import * as React49 from 'react';
import React49__default, { createContext, forwardRef, createElement, useContext, useState, useEffect, useImperativeHandle, useMemo, useLayoutEffect, useRef, useCallback, useDebugValue, createRef, memo, version } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Container, Row, Column, Link, Img, Button as Button$1, Section, Text as Text$1, Hr, Heading as Heading$1, Tailwind, Html, Head, Preview, Body } from '@react-email/components';
import * as ReactDOM6 from 'react-dom';
import ReactDOM6__default, { createPortal, flushSync } from 'react-dom';
import { useSyncExternalStore } from 'use-sync-external-store/shim/index.js';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector.js';
import { resolveVariables, createFormatter, useVariablesValues, VARIABLE_REGISTRY, VariablesDictionaryProvider, useUnavailableVariableIds } from '@babackapp/variables-registry';
import { useTranslation, initReactI18next } from 'react-i18next';
import { format, formatDate } from 'date-fns';
import { de as de$1, es as es$1, enUS, fr as fr$1 } from 'date-fns/locale';
import { TrackingStatus, getTrackingStatusTranslation } from '@babackapp/tracking-status-registry';
import { formatDate as formatDate$1 } from 'date-fns/format';
import i18next from 'i18next';
import { render as render$1 } from '@react-email/render';
import { resolveReturnVariables, createReturnFormatter, RETURN_VARIABLE_REGISTRY } from '@babackapp/return-variables-registry';

var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var BlockThemeContext = createContext(void 0);
function BlockThemeProvider({ theme, children }) {
  const values = useMemo(() => ({ theme }), [theme]);
  return /* @__PURE__ */ jsx(BlockThemeContext.Provider, { value: values, children });
}

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/shared/src/utils/mergeClasses.js
var mergeClasses = (...classes) => classes.filter((className, index2, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index2;
}).join(" ").trim();

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/shared/src/utils/toKebabCase.js
var toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/shared/src/utils/toCamelCase.js
var toCamelCase = (string) => string.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (match, p1, p2) => p2 ? p2.toUpperCase() : p1.toLowerCase()
);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/shared/src/utils/toPascalCase.js
var toPascalCase = (string) => {
  const camelCase = toCamelCase(string);
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/defaultAttributes.js
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/shared/src/utils/hasA11yProp.js
var hasA11yProp = (props) => {
  for (const prop in props) {
    if (prop.startsWith("aria-") || prop === "role" || prop === "title") {
      return true;
    }
  }
  return false;
};

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/Icon.js
var Icon = forwardRef(
  ({
    color = "currentColor",
    size: size4 = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => createElement(
    "svg",
    {
      ref,
      ...defaultAttributes,
      width: size4,
      height: size4,
      stroke: color,
      strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size4) : strokeWidth,
      className: mergeClasses("lucide", className),
      ...!children && !hasA11yProp(rest) && { "aria-hidden": "true" },
      ...rest
    },
    [
      ...iconNode.map(([tag, attrs]) => createElement(tag, attrs)),
      ...Array.isArray(children) ? children : [children]
    ]
  )
);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/createLucideIcon.js
var createLucideIcon = (iconName, iconNode) => {
  const Component = forwardRef(
    ({ className, ...props }, ref) => createElement(Icon, {
      ref,
      iconNode,
      className: mergeClasses(
        `lucide-${toKebabCase(toPascalCase(iconName))}`,
        `lucide-${iconName}`,
        className
      ),
      ...props
    })
  );
  Component.displayName = toPascalCase(iconName);
  return Component;
};

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/activity.js
var __iconNode = [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
];
var Activity = createLucideIcon("activity", __iconNode);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/align-center-vertical.js
var __iconNode2 = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
];
var AlignCenterVertical = createLucideIcon("align-center-vertical", __iconNode2);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/align-end-vertical.js
var __iconNode3 = [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
];
var AlignEndVertical = createLucideIcon("align-end-vertical", __iconNode3);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/align-start-vertical.js
var __iconNode4 = [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
];
var AlignStartVertical = createLucideIcon("align-start-vertical", __iconNode4);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/align-vertical-justify-center.js
var __iconNode5 = [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
];
var AlignVerticalJustifyCenter = createLucideIcon("align-vertical-justify-center", __iconNode5);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/align-vertical-justify-end.js
var __iconNode6 = [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
];
var AlignVerticalJustifyEnd = createLucideIcon("align-vertical-justify-end", __iconNode6);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/align-vertical-justify-start.js
var __iconNode7 = [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
];
var AlignVerticalJustifyStart = createLucideIcon("align-vertical-justify-start", __iconNode7);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/arrow-big-right.js
var __iconNode8 = [
  [
    "path",
    {
      d: "M11 9a1 1 0 0 0 1-1V5.061a1 1 0 0 1 1.811-.75l6.836 6.836a1.207 1.207 0 0 1 0 1.707l-6.836 6.835a1 1 0 0 1-1.811-.75V16a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z",
      key: "1232du"
    }
  ]
];
var ArrowBigRight = createLucideIcon("arrow-big-right", __iconNode8);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/bold.js
var __iconNode9 = [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
];
var Bold = createLucideIcon("bold", __iconNode9);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/building.js
var __iconNode10 = [
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3", key: "cabbwy" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
];
var Building = createLucideIcon("building", __iconNode10);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/calendar-clock.js
var __iconNode11 = [
  ["path", { d: "M16 14v2.2l1.6 1", key: "fo4ql5" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
];
var CalendarClock = createLucideIcon("calendar-clock", __iconNode11);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/calendar.js
var __iconNode12 = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
];
var Calendar = createLucideIcon("calendar", __iconNode12);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/check.js
var __iconNode13 = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]];
var Check = createLucideIcon("check", __iconNode13);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/chevron-down.js
var __iconNode14 = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]];
var ChevronDown = createLucideIcon("chevron-down", __iconNode14);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/circle-minus.js
var __iconNode15 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
];
var CircleMinus = createLucideIcon("circle-minus", __iconNode15);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/cloud-upload.js
var __iconNode16 = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
];
var CloudUpload = createLucideIcon("cloud-upload", __iconNode16);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/columns-2.js
var __iconNode17 = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
];
var Columns2 = createLucideIcon("columns-2", __iconNode17);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/download.js
var __iconNode18 = [
  ["path", { d: "M12 15V3", key: "m9g1x1" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
];
var Download = createLucideIcon("download", __iconNode18);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/eye-off.js
var __iconNode19 = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
];
var EyeOff = createLucideIcon("eye-off", __iconNode19);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/heading.js
var __iconNode20 = [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
];
var Heading = createLucideIcon("heading", __iconNode20);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/hourglass.js
var __iconNode21 = [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
];
var Hourglass = createLucideIcon("hourglass", __iconNode21);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/image.js
var __iconNode22 = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
];
var Image = createLucideIcon("image", __iconNode22);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/italic.js
var __iconNode23 = [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
];
var Italic = createLucideIcon("italic", __iconNode23);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/languages.js
var __iconNode24 = [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
];
var Languages = createLucideIcon("languages", __iconNode24);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/link-2.js
var __iconNode25 = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
];
var Link2 = createLucideIcon("link-2", __iconNode25);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/list-ordered.js
var __iconNode26 = [
  ["path", { d: "M11 5h10", key: "1cz7ny" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 19h10", key: "11t30w" }],
  ["path", { d: "M4 4h1v5", key: "10yrso" }],
  ["path", { d: "M4 9h2", key: "r1h2o0" }],
  ["path", { d: "M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02", key: "xtkcd5" }]
];
var ListOrdered = createLucideIcon("list-ordered", __iconNode26);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/loader.js
var __iconNode27 = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
];
var Loader = createLucideIcon("loader", __iconNode27);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/map-pin-house.js
var __iconNode28 = [
  [
    "path",
    {
      d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
      key: "1p1rcz"
    }
  ],
  [
    "path",
    {
      d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2",
      key: "mcbcs9"
    }
  ],
  ["path", { d: "M18 22v-3", key: "1t1ugv" }],
  ["circle", { cx: "10", cy: "10", r: "3", key: "1ns7v1" }]
];
var MapPinHouse = createLucideIcon("map-pin-house", __iconNode28);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/map-pin.js
var __iconNode29 = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
];
var MapPin = createLucideIcon("map-pin", __iconNode29);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/minus.js
var __iconNode30 = [["path", { d: "M5 12h14", key: "1ays0h" }]];
var Minus = createLucideIcon("minus", __iconNode30);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/mouse.js
var __iconNode31 = [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
];
var Mouse = createLucideIcon("mouse", __iconNode31);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/package.js
var __iconNode32 = [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
];
var Package = createLucideIcon("package", __iconNode32);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/palette.js
var __iconNode33 = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
];
var Palette = createLucideIcon("palette", __iconNode33);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/refresh-cw.js
var __iconNode34 = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
];
var RefreshCw = createLucideIcon("refresh-cw", __iconNode34);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/rotate-ccw.js
var __iconNode35 = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
];
var RotateCcw = createLucideIcon("rotate-ccw", __iconNode35);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/share-2.js
var __iconNode36 = [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
];
var Share2 = createLucideIcon("share-2", __iconNode36);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/shopping-bag.js
var __iconNode37 = [
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }],
  ["path", { d: "M3.103 6.034h17.794", key: "awc11p" }],
  [
    "path",
    {
      d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
      key: "o988cm"
    }
  ]
];
var ShoppingBag = createLucideIcon("shopping-bag", __iconNode37);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/smartphone.js
var __iconNode38 = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
];
var Smartphone = createLucideIcon("smartphone", __iconNode38);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/star.js
var __iconNode39 = [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
];
var Star = createLucideIcon("star", __iconNode39);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/text-align-start.js
var __iconNode40 = [
  ["path", { d: "M21 5H3", key: "1fi0y6" }],
  ["path", { d: "M15 12H3", key: "6jk70r" }],
  ["path", { d: "M17 19H3", key: "z6ezky" }]
];
var TextAlignStart = createLucideIcon("text-align-start", __iconNode40);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/text-wrap.js
var __iconNode41 = [
  ["path", { d: "m16 16-3 3 3 3", key: "117b85" }],
  ["path", { d: "M3 12h14.5a1 1 0 0 1 0 7H13", key: "18xa6z" }],
  ["path", { d: "M3 19h6", key: "1ygdsz" }],
  ["path", { d: "M3 5h18", key: "1u36vt" }]
];
var TextWrap = createLucideIcon("text-wrap", __iconNode41);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/ticket-percent.js
var __iconNode42 = [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
];
var TicketPercent = createLucideIcon("ticket-percent", __iconNode42);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/trash-2.js
var __iconNode43 = [
  ["path", { d: "M10 11v6", key: "nco0om" }],
  ["path", { d: "M14 11v6", key: "outv1u" }],
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
];
var Trash2 = createLucideIcon("trash-2", __iconNode43);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/triangle-alert.js
var __iconNode44 = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
];
var TriangleAlert = createLucideIcon("triangle-alert", __iconNode44);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/truck.js
var __iconNode45 = [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
];
var Truck = createLucideIcon("truck", __iconNode45);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/underline.js
var __iconNode46 = [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
];
var Underline = createLucideIcon("underline", __iconNode46);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/undo-2.js
var __iconNode47 = [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
];
var Undo2 = createLucideIcon("undo-2", __iconNode47);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/wallet-minimal.js
var __iconNode48 = [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
];
var WalletMinimal = createLucideIcon("wallet-minimal", __iconNode48);

// ../../node_modules/.pnpm/lucide-react@0.564.0_react@19.2.4/node_modules/lucide-react/dist/esm/icons/x.js
var __iconNode49 = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
];
var X = createLucideIcon("x", __iconNode49);

// ../editor-blocks-library/src/lib/register-block.tsx
function registerBlock({
  components,
  category,
  premium,
  hasDynamicContent,
  ...config
}) {
  return {
    config: {
      ...config,
      category,
      premium,
      hasDynamicContent
    },
    ...components,
    EmailComponent: components.email?.component,
    WebComponent: components.web?.component,
    EmailEditor: components.email?.editor.component,
    WebEditor: components.web?.editor.component,
    EmailConfigPanel: components.email?.configPanel?.component,
    WebConfigPanel: components.web?.configPanel?.component
  };
}
function EmailComponentWrapper({
  children
}) {
  return /* @__PURE__ */ jsx(Fragment, { children });
}

// ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function r(e) {
  var t2, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t2 = 0; t2 < o; t2++) e[t2] && (f = r(e[t2])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t2, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t2 = r(e)) && (n && (n += " "), n += t2);
  return n;
}

// ../../node_modules/.pnpm/tailwind-merge@3.5.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var concatArrays = (array1, array2) => {
  const combinedArray = new Array(array1.length + array2.length);
  for (let i = 0; i < array1.length; i++) {
    combinedArray[i] = array1[i];
  }
  for (let i = 0; i < array2.length; i++) {
    combinedArray[array1.length + i] = array2[i];
  }
  return combinedArray;
};
var createClassValidatorObject = (classGroupId, validator) => ({
  classGroupId,
  validator
});
var createClassPartObject = (nextPart = /* @__PURE__ */ new Map(), validators = null, classGroupId) => ({
  nextPart,
  validators,
  classGroupId
});
var CLASS_PART_SEPARATOR = "-";
var EMPTY_CONFLICTS = [];
var ARBITRARY_PROPERTY_PREFIX = "arbitrary..";
var createClassGroupUtils = (config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = (className) => {
    if (className.startsWith("[") && className.endsWith("]")) {
      return getGroupIdForArbitraryProperty(className);
    }
    const classParts = className.split(CLASS_PART_SEPARATOR);
    const startIndex = classParts[0] === "" && classParts.length > 1 ? 1 : 0;
    return getGroupRecursive(classParts, startIndex, classMap);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    if (hasPostfixModifier) {
      const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
      const baseConflicts = conflictingClassGroups[classGroupId];
      if (modifierConflicts) {
        if (baseConflicts) {
          return concatArrays(baseConflicts, modifierConflicts);
        }
        return modifierConflicts;
      }
      return baseConflicts || EMPTY_CONFLICTS;
    }
    return conflictingClassGroups[classGroupId] || EMPTY_CONFLICTS;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
var getGroupRecursive = (classParts, startIndex, classPartObject) => {
  const classPathsLength = classParts.length - startIndex;
  if (classPathsLength === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[startIndex];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  if (nextClassPartObject) {
    const result = getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
    if (result) return result;
  }
  const validators = classPartObject.validators;
  if (validators === null) {
    return void 0;
  }
  const classRest = startIndex === 0 ? classParts.join(CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join(CLASS_PART_SEPARATOR);
  const validatorsLength = validators.length;
  for (let i = 0; i < validatorsLength; i++) {
    const validatorObj = validators[i];
    if (validatorObj.validator(classRest)) {
      return validatorObj.classGroupId;
    }
  }
  return void 0;
};
var getGroupIdForArbitraryProperty = (className) => className.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const content = className.slice(1, -1);
  const colonIndex = content.indexOf(":");
  const property = content.slice(0, colonIndex);
  return property ? ARBITRARY_PROPERTY_PREFIX + property : void 0;
})();
var createClassMap = (config) => {
  const {
    theme,
    classGroups
  } = config;
  return processClassGroups(classGroups, theme);
};
var processClassGroups = (classGroups, theme) => {
  const classMap = createClassPartObject();
  for (const classGroupId in classGroups) {
    const group = classGroups[classGroupId];
    processClassesRecursively(group, classMap, classGroupId, theme);
  }
  return classMap;
};
var processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  const len = classGroup.length;
  for (let i = 0; i < len; i++) {
    const classDefinition = classGroup[i];
    processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
  }
};
var processClassDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  if (typeof classDefinition === "string") {
    processStringDefinition(classDefinition, classPartObject, classGroupId);
    return;
  }
  if (typeof classDefinition === "function") {
    processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
    return;
  }
  processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
var processStringDefinition = (classDefinition, classPartObject, classGroupId) => {
  const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
  classPartObjectToEdit.classGroupId = classGroupId;
};
var processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  if (isThemeGetter(classDefinition)) {
    processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
    return;
  }
  if (classPartObject.validators === null) {
    classPartObject.validators = [];
  }
  classPartObject.validators.push(createClassValidatorObject(classGroupId, classDefinition));
};
var processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  const entries = Object.entries(classDefinition);
  const len = entries.length;
  for (let i = 0; i < len; i++) {
    const [key, value] = entries[i];
    processClassesRecursively(value, getPart(classPartObject, key), classGroupId, theme);
  }
};
var getPart = (classPartObject, path) => {
  let current = classPartObject;
  const parts = path.split(CLASS_PART_SEPARATOR);
  const len = parts.length;
  for (let i = 0; i < len; i++) {
    const part = parts[i];
    let next = current.nextPart.get(part);
    if (!next) {
      next = createClassPartObject();
      current.nextPart.set(part, next);
    }
    current = next;
  }
  return current;
};
var isThemeGetter = (func) => "isThemeGetter" in func && func.isThemeGetter === true;
var createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ Object.create(null);
  let previousCache = /* @__PURE__ */ Object.create(null);
  const update = (key, value) => {
    cache[key] = value;
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ Object.create(null);
    }
  };
  return {
    get(key) {
      let value = cache[key];
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache[key]) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (key in cache) {
        cache[key] = value;
      } else {
        update(key, value);
      }
    }
  };
};
var IMPORTANT_MODIFIER = "!";
var MODIFIER_SEPARATOR = ":";
var EMPTY_MODIFIERS = [];
var createResultObject = (modifiers2, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal) => ({
  modifiers: modifiers2,
  hasImportantModifier,
  baseClassName,
  maybePostfixModifierPosition,
  isExternal
});
var createParseClassName = (config) => {
  const {
    prefix,
    experimentalParseClassName
  } = config;
  let parseClassName = (className) => {
    const modifiers2 = [];
    let bracketDepth = 0;
    let parenDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    const len = className.length;
    for (let index2 = 0; index2 < len; index2++) {
      const currentCharacter = className[index2];
      if (bracketDepth === 0 && parenDepth === 0) {
        if (currentCharacter === MODIFIER_SEPARATOR) {
          modifiers2.push(className.slice(modifierStart, index2));
          modifierStart = index2 + 1;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index2;
          continue;
        }
      }
      if (currentCharacter === "[") bracketDepth++;
      else if (currentCharacter === "]") bracketDepth--;
      else if (currentCharacter === "(") parenDepth++;
      else if (currentCharacter === ")") parenDepth--;
    }
    const baseClassNameWithImportantModifier = modifiers2.length === 0 ? className : className.slice(modifierStart);
    let baseClassName = baseClassNameWithImportantModifier;
    let hasImportantModifier = false;
    if (baseClassNameWithImportantModifier.endsWith(IMPORTANT_MODIFIER)) {
      baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
      hasImportantModifier = true;
    } else if (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER)
    ) {
      baseClassName = baseClassNameWithImportantModifier.slice(1);
      hasImportantModifier = true;
    }
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return createResultObject(modifiers2, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
  };
  if (prefix) {
    const fullPrefix = prefix + MODIFIER_SEPARATOR;
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : createResultObject(EMPTY_MODIFIERS, false, className, void 0, true);
  }
  if (experimentalParseClassName) {
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => experimentalParseClassName({
      className,
      parseClassName: parseClassNameOriginal
    });
  }
  return parseClassName;
};
var createSortModifiers = (config) => {
  const modifierWeights = /* @__PURE__ */ new Map();
  config.orderSensitiveModifiers.forEach((mod, index2) => {
    modifierWeights.set(mod, 1e6 + index2);
  });
  return (modifiers2) => {
    const result = [];
    let currentSegment = [];
    for (let i = 0; i < modifiers2.length; i++) {
      const modifier = modifiers2[i];
      const isArbitrary = modifier[0] === "[";
      const isOrderSensitive = modifierWeights.has(modifier);
      if (isArbitrary || isOrderSensitive) {
        if (currentSegment.length > 0) {
          currentSegment.sort();
          result.push(...currentSegment);
          currentSegment = [];
        }
        result.push(modifier);
      } else {
        currentSegment.push(modifier);
      }
    }
    if (currentSegment.length > 0) {
      currentSegment.sort();
      result.push(...currentSegment);
    }
    return result;
  };
};
var createConfigUtils = (config) => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  sortModifiers: createSortModifiers(config),
  ...createClassGroupUtils(config)
});
var SPLIT_CLASSES_REGEX = /\s+/;
var mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds,
    sortModifiers
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index2 = classNames.length - 1; index2 >= 0; index2 -= 1) {
    const originalClassName = classNames[index2];
    const {
      isExternal,
      modifiers: modifiers2,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    if (isExternal) {
      result = originalClassName + (result.length > 0 ? " " + result : result);
      continue;
    }
    let hasPostfixModifier = !!maybePostfixModifierPosition;
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = modifiers2.length === 0 ? "" : modifiers2.length === 1 ? modifiers2[0] : sortModifiers(modifiers2).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.indexOf(classId) > -1) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i = 0; i < conflictGroups.length; ++i) {
      const group = conflictGroups[i];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
var twJoin = (...classLists) => {
  let index2 = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index2 < classLists.length) {
    if (argument = classLists[index2++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
var toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
var createTailwindMerge = (createConfigFirst, ...createConfigRest) => {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall;
  const initTailwindMerge = (classList) => {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  };
  const tailwindMerge = (classList) => {
    const cachedResult2 = cacheGet(classList);
    if (cachedResult2) {
      return cachedResult2;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  };
  functionToCall = initTailwindMerge;
  return (...args) => functionToCall(twJoin(...args));
};
var fallbackThemeArr = [];
var fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || fallbackThemeArr;
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
var arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
var arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
var fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
var shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
var imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
var isFraction = (value) => fractionRegex.test(value);
var isNumber = (value) => !!value && !Number.isNaN(Number(value));
var isInteger = (value) => !!value && Number.isInteger(Number(value));
var isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
var isTshirtSize = (value) => tshirtUnitRegex.test(value);
var isAny = () => true;
var isLengthOnly = (value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
);
var isNever = () => false;
var isShadow = (value) => shadowRegex.test(value);
var isImage = (value) => imageRegex.test(value);
var isAnyNonArbitrary = (value) => !isArbitraryValue(value) && !isArbitraryVariable(value);
var isArbitrarySize = (value) => getIsArbitraryValue(value, isLabelSize, isNever);
var isArbitraryValue = (value) => arbitraryValueRegex.test(value);
var isArbitraryLength = (value) => getIsArbitraryValue(value, isLabelLength, isLengthOnly);
var isArbitraryNumber = (value) => getIsArbitraryValue(value, isLabelNumber, isNumber);
var isArbitraryWeight = (value) => getIsArbitraryValue(value, isLabelWeight, isAny);
var isArbitraryFamilyName = (value) => getIsArbitraryValue(value, isLabelFamilyName, isNever);
var isArbitraryPosition = (value) => getIsArbitraryValue(value, isLabelPosition, isNever);
var isArbitraryImage = (value) => getIsArbitraryValue(value, isLabelImage, isImage);
var isArbitraryShadow = (value) => getIsArbitraryValue(value, isLabelShadow, isShadow);
var isArbitraryVariable = (value) => arbitraryVariableRegex.test(value);
var isArbitraryVariableLength = (value) => getIsArbitraryVariable(value, isLabelLength);
var isArbitraryVariableFamilyName = (value) => getIsArbitraryVariable(value, isLabelFamilyName);
var isArbitraryVariablePosition = (value) => getIsArbitraryVariable(value, isLabelPosition);
var isArbitraryVariableSize = (value) => getIsArbitraryVariable(value, isLabelSize);
var isArbitraryVariableImage = (value) => getIsArbitraryVariable(value, isLabelImage);
var isArbitraryVariableShadow = (value) => getIsArbitraryVariable(value, isLabelShadow, true);
var isArbitraryVariableWeight = (value) => getIsArbitraryVariable(value, isLabelWeight, true);
var getIsArbitraryValue = (value, testLabel, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
var getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false) => {
  const result = arbitraryVariableRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return shouldMatchNoLabel;
  }
  return false;
};
var isLabelPosition = (label) => label === "position" || label === "percentage";
var isLabelImage = (label) => label === "image" || label === "url";
var isLabelSize = (label) => label === "length" || label === "size" || label === "bg-size";
var isLabelLength = (label) => label === "length";
var isLabelNumber = (label) => label === "number";
var isLabelFamilyName = (label) => label === "family-name";
var isLabelWeight = (label) => label === "number" || label === "weight";
var isLabelShadow = (label) => label === "shadow";
var getDefaultConfig = () => {
  const themeColor = fromTheme("color");
  const themeFont = fromTheme("font");
  const themeText = fromTheme("text");
  const themeFontWeight = fromTheme("font-weight");
  const themeTracking = fromTheme("tracking");
  const themeLeading = fromTheme("leading");
  const themeBreakpoint = fromTheme("breakpoint");
  const themeContainer = fromTheme("container");
  const themeSpacing = fromTheme("spacing");
  const themeRadius = fromTheme("radius");
  const themeShadow = fromTheme("shadow");
  const themeInsetShadow = fromTheme("inset-shadow");
  const themeTextShadow = fromTheme("text-shadow");
  const themeDropShadow = fromTheme("drop-shadow");
  const themeBlur = fromTheme("blur");
  const themePerspective = fromTheme("perspective");
  const themeAspect = fromTheme("aspect");
  const themeEase = fromTheme("ease");
  const themeAnimate = fromTheme("animate");
  const scaleBreak = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const scalePosition = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ];
  const scalePositionWithArbitrary = () => [...scalePosition(), isArbitraryVariable, isArbitraryValue];
  const scaleOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const scaleOverscroll = () => ["auto", "contain", "none"];
  const scaleUnambiguousSpacing = () => [isArbitraryVariable, isArbitraryValue, themeSpacing];
  const scaleInset = () => [isFraction, "full", "auto", ...scaleUnambiguousSpacing()];
  const scaleGridTemplateColsRows = () => [isInteger, "none", "subgrid", isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartAndEnd = () => ["auto", {
    span: ["full", isInteger, isArbitraryVariable, isArbitraryValue]
  }, isInteger, isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartOrEnd = () => [isInteger, "auto", isArbitraryVariable, isArbitraryValue];
  const scaleGridAutoColsRows = () => ["auto", "min", "max", "fr", isArbitraryVariable, isArbitraryValue];
  const scaleAlignPrimaryAxis = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"];
  const scaleAlignSecondaryAxis = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"];
  const scaleMargin = () => ["auto", ...scaleUnambiguousSpacing()];
  const scaleSizing = () => [isFraction, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleSizingInline = () => [isFraction, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleSizingBlock = () => [isFraction, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleColor = () => [themeColor, isArbitraryVariable, isArbitraryValue];
  const scaleBgPosition = () => [...scalePosition(), isArbitraryVariablePosition, isArbitraryPosition, {
    position: [isArbitraryVariable, isArbitraryValue]
  }];
  const scaleBgRepeat = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }];
  const scaleBgSize = () => ["auto", "cover", "contain", isArbitraryVariableSize, isArbitrarySize, {
    size: [isArbitraryVariable, isArbitraryValue]
  }];
  const scaleGradientStopPosition = () => [isPercent, isArbitraryVariableLength, isArbitraryLength];
  const scaleRadius = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    themeRadius,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleBorderWidth = () => ["", isNumber, isArbitraryVariableLength, isArbitraryLength];
  const scaleLineStyle = () => ["solid", "dashed", "dotted", "double"];
  const scaleBlendMode = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const scaleMaskImagePosition = () => [isNumber, isPercent, isArbitraryVariablePosition, isArbitraryPosition];
  const scaleBlur = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    themeBlur,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleRotate = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleScale = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleSkew = () => [isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleTranslate = () => [isFraction, "full", ...scaleUnambiguousSpacing()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [isTshirtSize],
      breakpoint: [isTshirtSize],
      color: [isAny],
      container: [isTshirtSize],
      "drop-shadow": [isTshirtSize],
      ease: ["in", "out", "in-out"],
      font: [isAnyNonArbitrary],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [isTshirtSize],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [isTshirtSize],
      shadow: [isTshirtSize],
      spacing: ["px", isNumber],
      text: [isTshirtSize],
      "text-shadow": [isTshirtSize],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", isFraction, isArbitraryValue, isArbitraryVariable, themeAspect]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isNumber, isArbitraryValue, isArbitraryVariable, themeContainer]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": scaleBreak()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": scaleBreak()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: scalePositionWithArbitrary()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: scaleOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": scaleOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": scaleOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: scaleOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": scaleOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": scaleOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: scaleInset()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": scaleInset()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": scaleInset()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": scaleInset(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: scaleInset()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": scaleInset(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: scaleInset()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": scaleInset()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": scaleInset()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: scaleInset()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: scaleInset()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: scaleInset()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: scaleInset()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [isInteger, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [isFraction, "full", "auto", themeContainer, ...scaleUnambiguousSpacing()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [isNumber, isFraction, "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [isInteger, "first", "last", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": scaleGridAutoColsRows()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": scaleGridAutoColsRows()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: scaleUnambiguousSpacing()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": scaleUnambiguousSpacing()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": scaleUnambiguousSpacing()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...scaleAlignPrimaryAxis(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...scaleAlignSecondaryAxis(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...scaleAlignPrimaryAxis()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": scaleAlignPrimaryAxis()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...scaleAlignSecondaryAxis(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: scaleUnambiguousSpacing()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: scaleMargin()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: scaleMargin()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: scaleMargin()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: scaleMargin()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: scaleMargin()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: scaleMargin()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: scaleMargin()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: scaleMargin()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: scaleMargin()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: scaleMargin()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: scaleMargin()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: scaleSizing()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...scaleSizingInline()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...scaleSizingInline()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...scaleSizingInline()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...scaleSizingBlock()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...scaleSizingBlock()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...scaleSizingBlock()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [themeContainer, "screen", ...scaleSizing()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          themeContainer,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...scaleSizing()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          themeContainer,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [themeBreakpoint]
          },
          ...scaleSizing()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...scaleSizing()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...scaleSizing()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...scaleSizing()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", themeText, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [themeFontWeight, isArbitraryVariableWeight, isArbitraryWeight]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", isPercent, isArbitraryValue]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isArbitraryVariableFamilyName, isArbitraryFamilyName, themeFont]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [isArbitraryValue]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [themeTracking, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [isNumber, "none", isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          themeLeading,
          ...scaleUnambiguousSpacing()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: scaleColor()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: scaleColor()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...scaleLineStyle(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [isNumber, "from-font", "auto", isArbitraryVariable, isArbitraryLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: scaleColor()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [isNumber, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: scaleUnambiguousSpacing()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: scaleBgPosition()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: scaleBgRepeat()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: scaleBgSize()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, isInteger, isArbitraryVariable, isArbitraryValue],
          radial: ["", isArbitraryVariable, isArbitraryValue],
          conic: [isInteger, isArbitraryVariable, isArbitraryValue]
        }, isArbitraryVariableImage, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: scaleColor()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: scaleColor()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: scaleColor()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: scaleColor()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: scaleRadius()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": scaleRadius()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": scaleRadius()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": scaleRadius()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": scaleRadius()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": scaleRadius()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": scaleRadius()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": scaleRadius()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": scaleRadius()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": scaleRadius()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": scaleRadius()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": scaleRadius()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": scaleRadius()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": scaleRadius()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": scaleRadius()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: scaleBorderWidth()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": scaleBorderWidth()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": scaleBorderWidth()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": scaleBorderWidth()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": scaleBorderWidth()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": scaleBorderWidth()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": scaleBorderWidth()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": scaleBorderWidth()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": scaleBorderWidth()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": scaleBorderWidth()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": scaleBorderWidth()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": scaleBorderWidth()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": scaleBorderWidth()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: scaleColor()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": scaleColor()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": scaleColor()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": scaleColor()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": scaleColor()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": scaleColor()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": scaleColor()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": scaleColor()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": scaleColor()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": scaleColor()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": scaleColor()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: scaleColor()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...scaleLineStyle(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", isNumber, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: scaleColor()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: scaleColor()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", themeInsetShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": scaleColor()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: scaleBorderWidth()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: scaleColor()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [isNumber, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": scaleColor()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": scaleBorderWidth()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": scaleColor()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", themeTextShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": scaleColor()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...scaleBlendMode(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": scaleBlendMode()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [isNumber]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": scaleMaskImagePosition()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": scaleMaskImagePosition()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": scaleColor()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": scaleColor()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": scaleMaskImagePosition()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": scaleMaskImagePosition()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": scaleColor()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": scaleColor()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": scaleMaskImagePosition()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": scaleMaskImagePosition()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": scaleColor()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": scaleColor()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": scaleMaskImagePosition()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": scaleMaskImagePosition()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": scaleColor()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": scaleColor()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": scaleMaskImagePosition()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": scaleMaskImagePosition()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": scaleColor()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": scaleColor()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": scaleMaskImagePosition()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": scaleMaskImagePosition()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": scaleColor()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": scaleColor()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": scaleMaskImagePosition()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": scaleMaskImagePosition()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": scaleColor()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": scaleColor()
      }],
      "mask-image-radial": [{
        "mask-radial": [isArbitraryVariable, isArbitraryValue]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": scaleMaskImagePosition()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": scaleMaskImagePosition()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": scaleColor()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": scaleColor()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": scalePosition()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [isNumber]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": scaleMaskImagePosition()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": scaleMaskImagePosition()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": scaleColor()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": scaleColor()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: scaleBgPosition()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: scaleBgRepeat()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: scaleBgSize()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: scaleBlur()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeDropShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": scaleColor()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": scaleBlur()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": scaleUnambiguousSpacing()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [isNumber, "initial", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", themeEase, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", themeAnimate, isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [themePerspective, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": scalePositionWithArbitrary()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: scaleRotate()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": scaleRotate()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": scaleRotate()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": scaleRotate()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: scaleScale()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": scaleScale()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": scaleScale()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": scaleScale()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: scaleSkew()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": scaleSkew()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": scaleSkew()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [isArbitraryVariable, isArbitraryValue, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: scalePositionWithArbitrary()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: scaleTranslate()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": scaleTranslate()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": scaleTranslate()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": scaleTranslate()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: scaleColor()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: scaleColor()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryVariable, isArbitraryValue]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...scaleColor()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isNumber, isArbitraryVariableLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...scaleColor()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
};
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);

// ../ui/src/lib/utils.ts
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// ../editor-blocks-library/src/hooks/use-emails-theme-radius.ts
var RADIUS_MAP = {
  none: {
    ["button" /* BUTTON */]: "rounded-none",
    ["card" /* CARD */]: "rounded-none",
    ["packageContentTable" /* PACKAGE_CONTENT_TABLE */]: "rounded-none",
    ["packageContentImage" /* PACKAGE_CONTENT_IMAGE */]: "rounded-none",
    ["bannerImage" /* BANNER_IMAGE */]: "rounded-none"
  },
  low: {
    ["button" /* BUTTON */]: "rounded-sm",
    ["card" /* CARD */]: "rounded-sm",
    ["packageContentTable" /* PACKAGE_CONTENT_TABLE */]: "rounded-sm",
    ["packageContentImage" /* PACKAGE_CONTENT_IMAGE */]: "rounded-xs",
    ["bannerImage" /* BANNER_IMAGE */]: "rounded-xs"
  },
  default: {
    ["button" /* BUTTON */]: "rounded-md",
    ["card" /* CARD */]: "rounded-lg",
    ["packageContentTable" /* PACKAGE_CONTENT_TABLE */]: "rounded-md",
    ["packageContentImage" /* PACKAGE_CONTENT_IMAGE */]: "rounded-sm",
    ["bannerImage" /* BANNER_IMAGE */]: "rounded-md"
  },
  high: {
    ["button" /* BUTTON */]: "rounded-xl",
    ["card" /* CARD */]: "rounded-xl",
    ["packageContentTable" /* PACKAGE_CONTENT_TABLE */]: "rounded-xl",
    ["packageContentImage" /* PACKAGE_CONTENT_IMAGE */]: "rounded-lg",
    ["bannerImage" /* BANNER_IMAGE */]: "rounded-xl"
  }
};
function getThemeRadius(theme, component) {
  const radiusLevel = theme?.radius ?? "default";
  const componentRadiusMap = RADIUS_MAP[radiusLevel];
  if (component) {
    return componentRadiusMap[component];
  }
  return componentRadiusMap;
}
function useEmailThemeRadius(theme, component) {
  if (component) {
    return getThemeRadius(theme, component);
  }
  return getThemeRadius(theme);
}
function BannerEmailRenderer(props) {
  const imageRadius = useEmailThemeRadius(props.theme, "bannerImage");
  const item = props.block.properties?.items?.[0];
  const itemHref = item?.href;
  const imageUrl = item?.imageId ? `https://baback-banner-images.s3.eu-west-3.amazonaws.com/${item.imageId}` : item?.imageUrl ?? "#";
  return /* @__PURE__ */ jsx(Container, { className: "w-full", children: /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { children: itemHref ? /* @__PURE__ */ jsx(Link, { href: itemHref, children: /* @__PURE__ */ jsx(
    Img,
    {
      src: imageUrl,
      alt: "Banner",
      className: cn(imageRadius, "h-auto w-full object-cover block mr-2")
    }
  ) }) : /* @__PURE__ */ jsx(
    Img,
    {
      src: imageUrl,
      alt: "Banner",
      className: cn(imageRadius, "h-auto w-full object-cover block mr-2")
    }
  ) }) }) });
}
var BlockPropsContext = React49__default.createContext({});
function useBlockPanelPropsContext() {
  const context = React49__default.useContext(BlockPropsContext);
  if (!context) {
    throw new Error(
      "useBlockPropsContext must be used within a BlockPropsContext.Provider"
    );
  }
  return context;
}
function PanelContainer({
  children,
  blockProps
}) {
  return /* @__PURE__ */ jsx(BlockPropsContext.Provider, { value: blockProps, children });
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    return ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => {
    let hasCleanup = false;
    const cleanups = refs.map((ref) => {
      const cleanup = setRef(ref, node);
      if (!hasCleanup && typeof cleanup == "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0; i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup == "function") {
            cleanup();
          } else {
            setRef(refs[i], null);
          }
        }
      };
    }
  };
}
function useComposedRefs(...refs) {
  return React49.useCallback(composeRefs(...refs), refs);
}
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
  const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
  const Slot22 = React49.forwardRef((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    const childrenArray = React49.Children.toArray(children);
    const slottable = childrenArray.find(isSlottable);
    if (slottable) {
      const newElement = slottable.props.children;
      const newChildren = childrenArray.map((child) => {
        if (child === slottable) {
          if (React49.Children.count(newElement) > 1) return React49.Children.only(null);
          return React49.isValidElement(newElement) ? newElement.props.children : null;
        } else {
          return child;
        }
      });
      return /* @__PURE__ */ jsx(SlotClone, { ...slotProps, ref: forwardedRef, children: React49.isValidElement(newElement) ? React49.cloneElement(newElement, void 0, newChildren) : null });
    }
    return /* @__PURE__ */ jsx(SlotClone, { ...slotProps, ref: forwardedRef, children });
  });
  Slot22.displayName = `${ownerName}.Slot`;
  return Slot22;
}
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
  const SlotClone = React49.forwardRef((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    if (React49.isValidElement(children)) {
      const childrenRef = getElementRef(children);
      const props2 = mergeProps(slotProps, children.props);
      if (children.type !== React49.Fragment) {
        props2.ref = forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef;
      }
      return React49.cloneElement(children, props2);
    }
    return React49.Children.count(children) > 1 ? React49.Children.only(null) : null;
  });
  SlotClone.displayName = `${ownerName}.SlotClone`;
  return SlotClone;
}
var SLOTTABLE_IDENTIFIER = /* @__PURE__ */ Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function createSlottable(ownerName) {
  const Slottable2 = ({ children }) => {
    return /* @__PURE__ */ jsx(Fragment, { children });
  };
  Slottable2.displayName = `${ownerName}.Slottable`;
  Slottable2.__radixId = SLOTTABLE_IDENTIFIER;
  return Slottable2;
}
function isSlottable(child) {
  return React49.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Slot5 = createSlot(`Primitive.${node}`);
  const Node4 = React49.forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot5 : node;
    if (typeof window !== "undefined") {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsx(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node4.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node4 };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target) ReactDOM6.flushSync(() => target.dispatchEvent(event));
}
var useLayoutEffect2 = globalThis?.document ? React49.useLayoutEffect : () => {
};
function useStateMachine(initialState, machine) {
  return React49.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}
var Presence = (props) => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : React49.Children.only(children);
  const ref = useComposedRefs(presence.ref, getElementRef2(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? React49.cloneElement(child, { ref }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
  const [node, setNode2] = React49.useState();
  const stylesRef = React49.useRef(null);
  const prevPresentRef = React49.useRef(present);
  const prevAnimationNameRef = React49.useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  React49.useEffect(() => {
    const currentAnimationName = getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  useLayoutEffect2(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        send("MOUNT");
      } else if (currentAnimationName === "none" || styles?.display === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect2(() => {
    if (node) {
      let timeoutId;
      const ownerWindow = node.ownerDocument.defaultView ?? window;
      const handleAnimationEnd = (event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
        if (event.target === node && isCurrentAnimation) {
          send("ANIMATION_END");
          if (!prevPresentRef.current) {
            const currentFillMode = node.style.animationFillMode;
            node.style.animationFillMode = "forwards";
            timeoutId = ownerWindow.setTimeout(() => {
              if (node.style.animationFillMode === "forwards") {
                node.style.animationFillMode = currentFillMode;
              }
            });
          }
        }
      };
      const handleAnimationStart = (event) => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node.addEventListener("animationstart", handleAnimationStart);
      node.addEventListener("animationcancel", handleAnimationEnd);
      node.addEventListener("animationend", handleAnimationEnd);
      return () => {
        ownerWindow.clearTimeout(timeoutId);
        node.removeEventListener("animationstart", handleAnimationStart);
        node.removeEventListener("animationcancel", handleAnimationEnd);
        node.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: React49.useCallback((node2) => {
      stylesRef.current = node2 ? getComputedStyle(node2) : null;
      setNode2(node2);
    }, [])
  };
}
function getAnimationName(styles) {
  return styles?.animationName || "none";
}
function getElementRef2(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
function createContext22(rootComponentName, defaultContext) {
  const Context = React49.createContext(defaultContext);
  const Provider2 = (props) => {
    const { children, ...context } = props;
    const value = React49.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  };
  Provider2.displayName = rootComponentName + "Provider";
  function useContext23(consumerName) {
    const context = React49.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  return [Provider2, useContext23];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext33(rootComponentName, defaultContext) {
    const BaseContext = React49.createContext(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider2 = (props) => {
      const { scope, children, ...context } = props;
      const Context = scope?.[scopeName]?.[index2] || BaseContext;
      const value = React49.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ jsx(Context.Provider, { value, children });
    };
    Provider2.displayName = rootComponentName + "Provider";
    function useContext23(consumerName, scope) {
      const Context = scope?.[scopeName]?.[index2] || BaseContext;
      const context = React49.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [Provider2, useContext23];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return React49.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = scope?.[scopeName] || scopeContexts;
      return React49.useMemo(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext33, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return React49.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
function useCallbackRef(callback) {
  const callbackRef = React49.useRef(callback);
  React49.useEffect(() => {
    callbackRef.current = callback;
  });
  return React49.useMemo(() => (...args) => callbackRef.current?.(...args), []);
}
var DirectionContext = React49.createContext(void 0);
function useDirection(localDir) {
  const globalDir = React49.useContext(DirectionContext);
  return localDir || globalDir || "ltr";
}

// ../../node_modules/.pnpm/@radix-ui+number@1.1.1/node_modules/@radix-ui/number/dist/index.mjs
function clamp(value, [min3, max3]) {
  return Math.min(max3, Math.max(min3, value));
}
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler?.(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler?.(event);
    }
  };
}
function useStateMachine2(initialState, machine) {
  return React49.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}
var SCROLL_AREA_NAME = "ScrollArea";
var [createScrollAreaContext] = createContextScope(SCROLL_AREA_NAME);
var [ScrollAreaProvider, useScrollAreaContext] = createScrollAreaContext(SCROLL_AREA_NAME);
var ScrollArea = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeScrollArea,
      type = "hover",
      dir,
      scrollHideDelay = 600,
      ...scrollAreaProps
    } = props;
    const [scrollArea, setScrollArea] = React49.useState(null);
    const [viewport2, setViewport] = React49.useState(null);
    const [content, setContent3] = React49.useState(null);
    const [scrollbarX, setScrollbarX] = React49.useState(null);
    const [scrollbarY, setScrollbarY] = React49.useState(null);
    const [cornerWidth, setCornerWidth] = React49.useState(0);
    const [cornerHeight, setCornerHeight] = React49.useState(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = React49.useState(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = React49.useState(false);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setScrollArea(node));
    const direction = useDirection(dir);
    return /* @__PURE__ */ jsx(
      ScrollAreaProvider,
      {
        scope: __scopeScrollArea,
        type,
        dir: direction,
        scrollHideDelay,
        scrollArea,
        viewport: viewport2,
        onViewportChange: setViewport,
        content,
        onContentChange: setContent3,
        scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight,
        children: /* @__PURE__ */ jsx(
          Primitive.div,
          {
            dir: direction,
            ...scrollAreaProps,
            ref: composedRefs,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              ["--radix-scroll-area-corner-width"]: cornerWidth + "px",
              ["--radix-scroll-area-corner-height"]: cornerHeight + "px",
              ...props.style
            }
          }
        )
      }
    );
  }
);
ScrollArea.displayName = SCROLL_AREA_NAME;
var VIEWPORT_NAME = "ScrollAreaViewport";
var ScrollAreaViewport = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeScrollArea, children, nonce, ...viewportProps } = props;
    const context = useScrollAreaContext(VIEWPORT_NAME, __scopeScrollArea);
    const ref = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref, context.onViewportChange);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
          },
          nonce
        }
      ),
      /* @__PURE__ */ jsx(
        Primitive.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...viewportProps,
          ref: composedRefs,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: context.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: context.scrollbarYEnabled ? "scroll" : "hidden",
            ...props.style
          },
          children: /* @__PURE__ */ jsx("div", { ref: context.onContentChange, style: { minWidth: "100%", display: "table" }, children })
        }
      )
    ] });
  }
);
ScrollAreaViewport.displayName = VIEWPORT_NAME;
var SCROLLBAR_NAME = "ScrollAreaScrollbar";
var ScrollAreaScrollbar = React49.forwardRef(
  (props, forwardedRef) => {
    const { forceMount, ...scrollbarProps } = props;
    const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange, onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === "horizontal";
    React49.useEffect(() => {
      isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
      return () => {
        isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
      };
    }, [isHorizontal, onScrollbarXEnabledChange, onScrollbarYEnabledChange]);
    return context.type === "hover" ? /* @__PURE__ */ jsx(ScrollAreaScrollbarHover, { ...scrollbarProps, ref: forwardedRef, forceMount }) : context.type === "scroll" ? /* @__PURE__ */ jsx(ScrollAreaScrollbarScroll, { ...scrollbarProps, ref: forwardedRef, forceMount }) : context.type === "auto" ? /* @__PURE__ */ jsx(ScrollAreaScrollbarAuto, { ...scrollbarProps, ref: forwardedRef, forceMount }) : context.type === "always" ? /* @__PURE__ */ jsx(ScrollAreaScrollbarVisible, { ...scrollbarProps, ref: forwardedRef }) : null;
  }
);
ScrollAreaScrollbar.displayName = SCROLLBAR_NAME;
var ScrollAreaScrollbarHover = React49.forwardRef((props, forwardedRef) => {
  const { forceMount, ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const [visible, setVisible] = React49.useState(false);
  React49.useEffect(() => {
    const scrollArea = context.scrollArea;
    let hideTimer = 0;
    if (scrollArea) {
      const handlePointerEnter = () => {
        window.clearTimeout(hideTimer);
        setVisible(true);
      };
      const handlePointerLeave = () => {
        hideTimer = window.setTimeout(() => setVisible(false), context.scrollHideDelay);
      };
      scrollArea.addEventListener("pointerenter", handlePointerEnter);
      scrollArea.addEventListener("pointerleave", handlePointerLeave);
      return () => {
        window.clearTimeout(hideTimer);
        scrollArea.removeEventListener("pointerenter", handlePointerEnter);
        scrollArea.removeEventListener("pointerleave", handlePointerLeave);
      };
    }
  }, [context.scrollArea, context.scrollHideDelay]);
  return /* @__PURE__ */ jsx(Presence, { present: forceMount || visible, children: /* @__PURE__ */ jsx(
    ScrollAreaScrollbarAuto,
    {
      "data-state": visible ? "visible" : "hidden",
      ...scrollbarProps,
      ref: forwardedRef
    }
  ) });
});
var ScrollAreaScrollbarScroll = React49.forwardRef((props, forwardedRef) => {
  const { forceMount, ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const isHorizontal = props.orientation === "horizontal";
  const debounceScrollEnd = useDebounceCallback(() => send("SCROLL_END"), 100);
  const [state, send] = useStateMachine2("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  React49.useEffect(() => {
    if (state === "idle") {
      const hideTimer = window.setTimeout(() => send("HIDE"), context.scrollHideDelay);
      return () => window.clearTimeout(hideTimer);
    }
  }, [state, context.scrollHideDelay, send]);
  React49.useEffect(() => {
    const viewport2 = context.viewport;
    const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
    if (viewport2) {
      let prevScrollPos = viewport2[scrollDirection];
      const handleScroll2 = () => {
        const scrollPos = viewport2[scrollDirection];
        const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
        if (hasScrollInDirectionChanged) {
          send("SCROLL");
          debounceScrollEnd();
        }
        prevScrollPos = scrollPos;
      };
      viewport2.addEventListener("scroll", handleScroll2);
      return () => viewport2.removeEventListener("scroll", handleScroll2);
    }
  }, [context.viewport, isHorizontal, send, debounceScrollEnd]);
  return /* @__PURE__ */ jsx(Presence, { present: forceMount || state !== "hidden", children: /* @__PURE__ */ jsx(
    ScrollAreaScrollbarVisible,
    {
      "data-state": state === "hidden" ? "hidden" : "visible",
      ...scrollbarProps,
      ref: forwardedRef,
      onPointerEnter: composeEventHandlers(props.onPointerEnter, () => send("POINTER_ENTER")),
      onPointerLeave: composeEventHandlers(props.onPointerLeave, () => send("POINTER_LEAVE"))
    }
  ) });
});
var ScrollAreaScrollbarAuto = React49.forwardRef((props, forwardedRef) => {
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const { forceMount, ...scrollbarProps } = props;
  const [visible, setVisible] = React49.useState(false);
  const isHorizontal = props.orientation === "horizontal";
  const handleResize = useDebounceCallback(() => {
    if (context.viewport) {
      const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
      const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
      setVisible(isHorizontal ? isOverflowX : isOverflowY);
    }
  }, 10);
  useResizeObserver(context.viewport, handleResize);
  useResizeObserver(context.content, handleResize);
  return /* @__PURE__ */ jsx(Presence, { present: forceMount || visible, children: /* @__PURE__ */ jsx(
    ScrollAreaScrollbarVisible,
    {
      "data-state": visible ? "visible" : "hidden",
      ...scrollbarProps,
      ref: forwardedRef
    }
  ) });
});
var ScrollAreaScrollbarVisible = React49.forwardRef((props, forwardedRef) => {
  const { orientation = "vertical", ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const thumbRef = React49.useRef(null);
  const pointerOffsetRef = React49.useRef(0);
  const [sizes, setSizes] = React49.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  });
  const thumbRatio = getThumbRatio(sizes.viewport, sizes.content);
  const commonProps = {
    ...scrollbarProps,
    sizes,
    onSizesChange: setSizes,
    hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
    onThumbChange: (thumb) => thumbRef.current = thumb,
    onThumbPointerUp: () => pointerOffsetRef.current = 0,
    onThumbPointerDown: (pointerPos) => pointerOffsetRef.current = pointerPos
  };
  function getScrollPosition(pointerPos, dir) {
    return getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
  }
  if (orientation === "horizontal") {
    return /* @__PURE__ */ jsx(
      ScrollAreaScrollbarX,
      {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: () => {
          if (context.viewport && thumbRef.current) {
            const scrollPos = context.viewport.scrollLeft;
            const offset5 = getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
            thumbRef.current.style.transform = `translate3d(${offset5}px, 0, 0)`;
          }
        },
        onWheelScroll: (scrollPos) => {
          if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos) => {
          if (context.viewport) {
            context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
          }
        }
      }
    );
  }
  if (orientation === "vertical") {
    return /* @__PURE__ */ jsx(
      ScrollAreaScrollbarY,
      {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: () => {
          if (context.viewport && thumbRef.current) {
            const scrollPos = context.viewport.scrollTop;
            const offset5 = getThumbOffsetFromScroll(scrollPos, sizes);
            thumbRef.current.style.transform = `translate3d(0, ${offset5}px, 0)`;
          }
        },
        onWheelScroll: (scrollPos) => {
          if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos) => {
          if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
      }
    );
  }
  return null;
});
var ScrollAreaScrollbarX = React49.forwardRef((props, forwardedRef) => {
  const { sizes, onSizesChange, ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const [computedStyle, setComputedStyle] = React49.useState();
  const ref = React49.useRef(null);
  const composeRefs2 = useComposedRefs(forwardedRef, ref, context.onScrollbarXChange);
  React49.useEffect(() => {
    if (ref.current) setComputedStyle(getComputedStyle(ref.current));
  }, [ref]);
  return /* @__PURE__ */ jsx(
    ScrollAreaScrollbarImpl,
    {
      "data-orientation": "horizontal",
      ...scrollbarProps,
      ref: composeRefs2,
      sizes,
      style: {
        bottom: 0,
        left: context.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: context.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        ["--radix-scroll-area-thumb-width"]: getThumbSize(sizes) + "px",
        ...props.style
      },
      onThumbPointerDown: (pointerPos) => props.onThumbPointerDown(pointerPos.x),
      onDragScroll: (pointerPos) => props.onDragScroll(pointerPos.x),
      onWheelScroll: (event, maxScrollPos) => {
        if (context.viewport) {
          const scrollPos = context.viewport.scrollLeft + event.deltaX;
          props.onWheelScroll(scrollPos);
          if (isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) {
            event.preventDefault();
          }
        }
      },
      onResize: () => {
        if (ref.current && context.viewport && computedStyle) {
          onSizesChange({
            content: context.viewport.scrollWidth,
            viewport: context.viewport.offsetWidth,
            scrollbar: {
              size: ref.current.clientWidth,
              paddingStart: toInt(computedStyle.paddingLeft),
              paddingEnd: toInt(computedStyle.paddingRight)
            }
          });
        }
      }
    }
  );
});
var ScrollAreaScrollbarY = React49.forwardRef((props, forwardedRef) => {
  const { sizes, onSizesChange, ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const [computedStyle, setComputedStyle] = React49.useState();
  const ref = React49.useRef(null);
  const composeRefs2 = useComposedRefs(forwardedRef, ref, context.onScrollbarYChange);
  React49.useEffect(() => {
    if (ref.current) setComputedStyle(getComputedStyle(ref.current));
  }, [ref]);
  return /* @__PURE__ */ jsx(
    ScrollAreaScrollbarImpl,
    {
      "data-orientation": "vertical",
      ...scrollbarProps,
      ref: composeRefs2,
      sizes,
      style: {
        top: 0,
        right: context.dir === "ltr" ? 0 : void 0,
        left: context.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        ["--radix-scroll-area-thumb-height"]: getThumbSize(sizes) + "px",
        ...props.style
      },
      onThumbPointerDown: (pointerPos) => props.onThumbPointerDown(pointerPos.y),
      onDragScroll: (pointerPos) => props.onDragScroll(pointerPos.y),
      onWheelScroll: (event, maxScrollPos) => {
        if (context.viewport) {
          const scrollPos = context.viewport.scrollTop + event.deltaY;
          props.onWheelScroll(scrollPos);
          if (isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) {
            event.preventDefault();
          }
        }
      },
      onResize: () => {
        if (ref.current && context.viewport && computedStyle) {
          onSizesChange({
            content: context.viewport.scrollHeight,
            viewport: context.viewport.offsetHeight,
            scrollbar: {
              size: ref.current.clientHeight,
              paddingStart: toInt(computedStyle.paddingTop),
              paddingEnd: toInt(computedStyle.paddingBottom)
            }
          });
        }
      }
    }
  );
});
var [ScrollbarProvider, useScrollbarContext] = createScrollAreaContext(SCROLLBAR_NAME);
var ScrollAreaScrollbarImpl = React49.forwardRef((props, forwardedRef) => {
  const {
    __scopeScrollArea,
    sizes,
    hasThumb,
    onThumbChange,
    onThumbPointerUp,
    onThumbPointerDown,
    onThumbPositionChange,
    onDragScroll,
    onWheelScroll,
    onResize,
    ...scrollbarProps
  } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, __scopeScrollArea);
  const [scrollbar, setScrollbar] = React49.useState(null);
  const composeRefs2 = useComposedRefs(forwardedRef, (node) => setScrollbar(node));
  const rectRef = React49.useRef(null);
  const prevWebkitUserSelectRef = React49.useRef("");
  const viewport2 = context.viewport;
  const maxScrollPos = sizes.content - sizes.viewport;
  const handleWheelScroll = useCallbackRef(onWheelScroll);
  const handleThumbPositionChange = useCallbackRef(onThumbPositionChange);
  const handleResize = useDebounceCallback(onResize, 10);
  function handleDragScroll(event) {
    if (rectRef.current) {
      const x = event.clientX - rectRef.current.left;
      const y = event.clientY - rectRef.current.top;
      onDragScroll({ x, y });
    }
  }
  React49.useEffect(() => {
    const handleWheel = (event) => {
      const element = event.target;
      const isScrollbarWheel = scrollbar?.contains(element);
      if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
    };
    document.addEventListener("wheel", handleWheel, { passive: false });
    return () => document.removeEventListener("wheel", handleWheel, { passive: false });
  }, [viewport2, scrollbar, maxScrollPos, handleWheelScroll]);
  React49.useEffect(handleThumbPositionChange, [sizes, handleThumbPositionChange]);
  useResizeObserver(scrollbar, handleResize);
  useResizeObserver(context.content, handleResize);
  return /* @__PURE__ */ jsx(
    ScrollbarProvider,
    {
      scope: __scopeScrollArea,
      scrollbar,
      hasThumb,
      onThumbChange: useCallbackRef(onThumbChange),
      onThumbPointerUp: useCallbackRef(onThumbPointerUp),
      onThumbPositionChange: handleThumbPositionChange,
      onThumbPointerDown: useCallbackRef(onThumbPointerDown),
      children: /* @__PURE__ */ jsx(
        Primitive.div,
        {
          ...scrollbarProps,
          ref: composeRefs2,
          style: { position: "absolute", ...scrollbarProps.style },
          onPointerDown: composeEventHandlers(props.onPointerDown, (event) => {
            const mainPointer = 0;
            if (event.button === mainPointer) {
              const element = event.target;
              element.setPointerCapture(event.pointerId);
              rectRef.current = scrollbar.getBoundingClientRect();
              prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
              document.body.style.webkitUserSelect = "none";
              if (context.viewport) context.viewport.style.scrollBehavior = "auto";
              handleDragScroll(event);
            }
          }),
          onPointerMove: composeEventHandlers(props.onPointerMove, handleDragScroll),
          onPointerUp: composeEventHandlers(props.onPointerUp, (event) => {
            const element = event.target;
            if (element.hasPointerCapture(event.pointerId)) {
              element.releasePointerCapture(event.pointerId);
            }
            document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
            if (context.viewport) context.viewport.style.scrollBehavior = "";
            rectRef.current = null;
          })
        }
      )
    }
  );
});
var THUMB_NAME = "ScrollAreaThumb";
var ScrollAreaThumb = React49.forwardRef(
  (props, forwardedRef) => {
    const { forceMount, ...thumbProps } = props;
    const scrollbarContext = useScrollbarContext(THUMB_NAME, props.__scopeScrollArea);
    return /* @__PURE__ */ jsx(Presence, { present: forceMount || scrollbarContext.hasThumb, children: /* @__PURE__ */ jsx(ScrollAreaThumbImpl, { ref: forwardedRef, ...thumbProps }) });
  }
);
var ScrollAreaThumbImpl = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeScrollArea, style: style2, ...thumbProps } = props;
    const scrollAreaContext = useScrollAreaContext(THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = useScrollbarContext(THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange } = scrollbarContext;
    const composedRef = useComposedRefs(
      forwardedRef,
      (node) => scrollbarContext.onThumbChange(node)
    );
    const removeUnlinkedScrollListenerRef = React49.useRef(void 0);
    const debounceScrollEnd = useDebounceCallback(() => {
      if (removeUnlinkedScrollListenerRef.current) {
        removeUnlinkedScrollListenerRef.current();
        removeUnlinkedScrollListenerRef.current = void 0;
      }
    }, 100);
    React49.useEffect(() => {
      const viewport2 = scrollAreaContext.viewport;
      if (viewport2) {
        const handleScroll2 = () => {
          debounceScrollEnd();
          if (!removeUnlinkedScrollListenerRef.current) {
            const listener = addUnlinkedScrollListener(viewport2, onThumbPositionChange);
            removeUnlinkedScrollListenerRef.current = listener;
            onThumbPositionChange();
          }
        };
        onThumbPositionChange();
        viewport2.addEventListener("scroll", handleScroll2);
        return () => viewport2.removeEventListener("scroll", handleScroll2);
      }
    }, [scrollAreaContext.viewport, debounceScrollEnd, onThumbPositionChange]);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden",
        ...thumbProps,
        ref: composedRef,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...style2
        },
        onPointerDownCapture: composeEventHandlers(props.onPointerDownCapture, (event) => {
          const thumb = event.target;
          const thumbRect = thumb.getBoundingClientRect();
          const x = event.clientX - thumbRect.left;
          const y = event.clientY - thumbRect.top;
          scrollbarContext.onThumbPointerDown({ x, y });
        }),
        onPointerUp: composeEventHandlers(props.onPointerUp, scrollbarContext.onThumbPointerUp)
      }
    );
  }
);
ScrollAreaThumb.displayName = THUMB_NAME;
var CORNER_NAME = "ScrollAreaCorner";
var ScrollAreaCorner = React49.forwardRef(
  (props, forwardedRef) => {
    const context = useScrollAreaContext(CORNER_NAME, props.__scopeScrollArea);
    const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
    const hasCorner = context.type !== "scroll" && hasBothScrollbarsVisible;
    return hasCorner ? /* @__PURE__ */ jsx(ScrollAreaCornerImpl, { ...props, ref: forwardedRef }) : null;
  }
);
ScrollAreaCorner.displayName = CORNER_NAME;
var ScrollAreaCornerImpl = React49.forwardRef((props, forwardedRef) => {
  const { __scopeScrollArea, ...cornerProps } = props;
  const context = useScrollAreaContext(CORNER_NAME, __scopeScrollArea);
  const [width, setWidth] = React49.useState(0);
  const [height, setHeight] = React49.useState(0);
  const hasSize = Boolean(width && height);
  useResizeObserver(context.scrollbarX, () => {
    const height2 = context.scrollbarX?.offsetHeight || 0;
    context.onCornerHeightChange(height2);
    setHeight(height2);
  });
  useResizeObserver(context.scrollbarY, () => {
    const width2 = context.scrollbarY?.offsetWidth || 0;
    context.onCornerWidthChange(width2);
    setWidth(width2);
  });
  return hasSize ? /* @__PURE__ */ jsx(
    Primitive.div,
    {
      ...cornerProps,
      ref: forwardedRef,
      style: {
        width,
        height,
        position: "absolute",
        right: context.dir === "ltr" ? 0 : void 0,
        left: context.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...props.style
      }
    }
  ) : null;
});
function toInt(value) {
  return value ? parseInt(value, 10) : 0;
}
function getThumbRatio(viewportSize, contentSize) {
  const ratio = viewportSize / contentSize;
  return isNaN(ratio) ? 0 : ratio;
}
function getThumbSize(sizes) {
  const ratio = getThumbRatio(sizes.viewport, sizes.content);
  const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
  const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
  return Math.max(thumbSize, 18);
}
function getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = "ltr") {
  const thumbSizePx = getThumbSize(sizes);
  const thumbCenter = thumbSizePx / 2;
  const offset5 = pointerOffset || thumbCenter;
  const thumbOffsetFromEnd = thumbSizePx - offset5;
  const minPointerPos = sizes.scrollbar.paddingStart + offset5;
  const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
  const maxScrollPos = sizes.content - sizes.viewport;
  const scrollRange = dir === "ltr" ? [0, maxScrollPos] : [maxScrollPos * -1, 0];
  const interpolate = linearScale([minPointerPos, maxPointerPos], scrollRange);
  return interpolate(pointerPos);
}
function getThumbOffsetFromScroll(scrollPos, sizes, dir = "ltr") {
  const thumbSizePx = getThumbSize(sizes);
  const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
  const scrollbar = sizes.scrollbar.size - scrollbarPadding;
  const maxScrollPos = sizes.content - sizes.viewport;
  const maxThumbPos = scrollbar - thumbSizePx;
  const scrollClampRange = dir === "ltr" ? [0, maxScrollPos] : [maxScrollPos * -1, 0];
  const scrollWithoutMomentum = clamp(scrollPos, scrollClampRange);
  const interpolate = linearScale([0, maxScrollPos], [0, maxThumbPos]);
  return interpolate(scrollWithoutMomentum);
}
function linearScale(input, output) {
  return (value) => {
    if (input[0] === input[1] || output[0] === output[1]) return output[0];
    const ratio = (output[1] - output[0]) / (input[1] - input[0]);
    return output[0] + ratio * (value - input[0]);
  };
}
function isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
  return scrollPos > 0 && scrollPos < maxScrollPos;
}
var addUnlinkedScrollListener = (node, handler = () => {
}) => {
  let prevPosition = { left: node.scrollLeft, top: node.scrollTop };
  let rAF = 0;
  (function loop() {
    const position = { left: node.scrollLeft, top: node.scrollTop };
    const isHorizontalScroll = prevPosition.left !== position.left;
    const isVerticalScroll = prevPosition.top !== position.top;
    if (isHorizontalScroll || isVerticalScroll) handler();
    prevPosition = position;
    rAF = window.requestAnimationFrame(loop);
  })();
  return () => window.cancelAnimationFrame(rAF);
};
function useDebounceCallback(callback, delay) {
  const handleCallback = useCallbackRef(callback);
  const debounceTimerRef = React49.useRef(0);
  React49.useEffect(() => () => window.clearTimeout(debounceTimerRef.current), []);
  return React49.useCallback(() => {
    window.clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = window.setTimeout(handleCallback, delay);
  }, [handleCallback, delay]);
}
function useResizeObserver(element, onResize) {
  const handleResize = useCallbackRef(onResize);
  useLayoutEffect2(() => {
    let rAF = 0;
    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(rAF);
        rAF = window.requestAnimationFrame(handleResize);
      });
      resizeObserver.observe(element);
      return () => {
        window.cancelAnimationFrame(rAF);
        resizeObserver.unobserve(element);
      };
    }
  }, [element, handleResize]);
}
var Root = ScrollArea;
var Viewport = ScrollAreaViewport;
var Corner = ScrollAreaCorner;
var ScrollArea2 = React49.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  Root,
  {
    ref,
    className: cn("relative overflow-hidden", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx(Viewport, { className: "h-full w-full rounded-[inherit]", children }),
      /* @__PURE__ */ jsx(ScrollBar, {}),
      /* @__PURE__ */ jsx(Corner, {})
    ]
  }
));
ScrollArea2.displayName = Root.displayName;
var ScrollBar = React49.forwardRef(({ className, orientation = "vertical", ...props }, ref) => /* @__PURE__ */ jsx(
  ScrollAreaScrollbar,
  {
    ref,
    orientation,
    className: cn(
      "flex touch-none select-none transition-colors",
      orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border" })
  }
));
ScrollBar.displayName = ScrollAreaScrollbar.displayName;
var REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var use = React49[" use ".trim().toString()];
function isPromiseLike(value) {
  return typeof value === "object" && value !== null && "then" in value;
}
function isLazyComponent(element) {
  return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === REACT_LAZY_TYPE && "_payload" in element && isPromiseLike(element._payload);
}
// @__NO_SIDE_EFFECTS__
function createSlot2(ownerName) {
  const SlotClone = /* @__PURE__ */ createSlotClone2(ownerName);
  const Slot22 = React49.forwardRef((props, forwardedRef) => {
    let { children, ...slotProps } = props;
    if (isLazyComponent(children) && typeof use === "function") {
      children = use(children._payload);
    }
    const childrenArray = React49.Children.toArray(children);
    const slottable = childrenArray.find(isSlottable2);
    if (slottable) {
      const newElement = slottable.props.children;
      const newChildren = childrenArray.map((child) => {
        if (child === slottable) {
          if (React49.Children.count(newElement) > 1) return React49.Children.only(null);
          return React49.isValidElement(newElement) ? newElement.props.children : null;
        } else {
          return child;
        }
      });
      return /* @__PURE__ */ jsx(SlotClone, { ...slotProps, ref: forwardedRef, children: React49.isValidElement(newElement) ? React49.cloneElement(newElement, void 0, newChildren) : null });
    }
    return /* @__PURE__ */ jsx(SlotClone, { ...slotProps, ref: forwardedRef, children });
  });
  Slot22.displayName = `${ownerName}.Slot`;
  return Slot22;
}
var Slot = /* @__PURE__ */ createSlot2("Slot");
// @__NO_SIDE_EFFECTS__
function createSlotClone2(ownerName) {
  const SlotClone = React49.forwardRef((props, forwardedRef) => {
    let { children, ...slotProps } = props;
    if (isLazyComponent(children) && typeof use === "function") {
      children = use(children._payload);
    }
    if (React49.isValidElement(children)) {
      const childrenRef = getElementRef3(children);
      const props2 = mergeProps2(slotProps, children.props);
      if (children.type !== React49.Fragment) {
        props2.ref = forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef;
      }
      return React49.cloneElement(children, props2);
    }
    return React49.Children.count(children) > 1 ? React49.Children.only(null) : null;
  });
  SlotClone.displayName = `${ownerName}.SlotClone`;
  return SlotClone;
}
var SLOTTABLE_IDENTIFIER2 = /* @__PURE__ */ Symbol("radix.slottable");
function isSlottable2(child) {
  return React49.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER2;
}
function mergeProps2(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef3(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var NODES2 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
];
var Primitive2 = NODES2.reduce((primitive, node) => {
  const Slot5 = createSlot2(`Primitive.${node}`);
  const Node4 = React49.forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot5 : node;
    if (typeof window !== "undefined") {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsx(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node4.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node4 };
}, {});
var NAME = "Separator";
var DEFAULT_ORIENTATION = "horizontal";
var ORIENTATIONS = ["horizontal", "vertical"];
var Separator = React49.forwardRef((props, forwardedRef) => {
  const { decorative, orientation: orientationProp = DEFAULT_ORIENTATION, ...domProps } = props;
  const orientation = isValidOrientation(orientationProp) ? orientationProp : DEFAULT_ORIENTATION;
  const ariaOrientation = orientation === "vertical" ? orientation : void 0;
  const semanticProps = decorative ? { role: "none" } : { "aria-orientation": ariaOrientation, role: "separator" };
  return /* @__PURE__ */ jsx(
    Primitive2.div,
    {
      "data-orientation": orientation,
      ...semanticProps,
      ...domProps,
      ref: forwardedRef
    }
  );
});
Separator.displayName = NAME;
function isValidOrientation(orientation) {
  return ORIENTATIONS.includes(orientation);
}
var Root2 = Separator;
var Separator2 = React49.forwardRef(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => /* @__PURE__ */ jsx(
    Root2,
    {
      ref,
      decorative,
      orientation,
      className: cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        className
      ),
      ...props
    }
  )
);
Separator2.displayName = Root2.displayName;
function createCollection(name) {
  const PROVIDER_NAME2 = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope4] = createContextScope(PROVIDER_NAME2);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(
    PROVIDER_NAME2,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  );
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = React49__default.useRef(null);
    const itemMap = React49__default.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ jsx(CollectionProviderImpl, { scope, itemMap, collectionRef: ref, children });
  };
  CollectionProvider.displayName = PROVIDER_NAME2;
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlotImpl = createSlot(COLLECTION_SLOT_NAME);
  const CollectionSlot = React49__default.forwardRef(
    (props, forwardedRef) => {
      const { scope, children } = props;
      const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
      const composedRefs = useComposedRefs(forwardedRef, context.collectionRef);
      return /* @__PURE__ */ jsx(CollectionSlotImpl, { ref: composedRefs, children });
    }
  );
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlotImpl = createSlot(ITEM_SLOT_NAME);
  const CollectionItemSlot = React49__default.forwardRef(
    (props, forwardedRef) => {
      const { scope, children, ...itemData } = props;
      const ref = React49__default.useRef(null);
      const composedRefs = useComposedRefs(forwardedRef, ref);
      const context = useCollectionContext(ITEM_SLOT_NAME, scope);
      React49__default.useEffect(() => {
        context.itemMap.set(ref, { ref, ...itemData });
        return () => void context.itemMap.delete(ref);
      });
      return /* @__PURE__ */ jsx(CollectionItemSlotImpl, { ...{ [ITEM_DATA_ATTR]: "" }, ref: composedRefs, children });
    }
  );
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection4(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = React49__default.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a, b) => orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
      );
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [
    { Provider: CollectionProvider, Slot: CollectionSlot, ItemSlot: CollectionItemSlot },
    useCollection4,
    createCollectionScope4
  ];
}
var useReactId = React49[" useId ".trim().toString()] || (() => void 0);
var count = 0;
function useId(deterministicId) {
  const [id, setId] = React49.useState(useReactId());
  useLayoutEffect2(() => {
    setId((reactId) => reactId ?? String(count++));
  }, [deterministicId]);
  return (id ? `radix-${id}` : "");
}
var useInsertionEffect = React49[" useInsertionEffect ".trim().toString()] || useLayoutEffect2;
function useControllableState({
  prop,
  defaultProp,
  onChange = () => {
  },
  caller
}) {
  const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value = isControlled ? prop : uncontrolledProp;
  {
    const isControlledRef = React49.useRef(prop !== void 0);
    React49.useEffect(() => {
      const wasControlled = isControlledRef.current;
      if (wasControlled !== isControlled) {
        const from2 = wasControlled ? "controlled" : "uncontrolled";
        const to = isControlled ? "controlled" : "uncontrolled";
        console.warn(
          `${caller} is changing from ${from2} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
        );
      }
      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }
  const setValue = React49.useCallback(
    (nextValue) => {
      if (isControlled) {
        const value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;
        if (value2 !== prop) {
          onChangeRef.current?.(value2);
        }
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, onChangeRef]
  );
  return [value, setValue];
}
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const [value, setValue] = React49.useState(defaultProp);
  const prevValueRef = React49.useRef(value);
  const onChangeRef = React49.useRef(onChange);
  useInsertionEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  React49.useEffect(() => {
    if (prevValueRef.current !== value) {
      onChangeRef.current?.(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef]);
  return [value, setValue, onChangeRef];
}
function isFunction(value) {
  return typeof value === "function";
}
var ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var GROUP_NAME = "RovingFocusGroup";
var [Collection, useCollection, createCollectionScope] = createCollection(GROUP_NAME);
var [createRovingFocusGroupContext, createRovingFocusGroupScope] = createContextScope(
  GROUP_NAME,
  [createCollectionScope]
);
var [RovingFocusProvider, useRovingFocusContext] = createRovingFocusGroupContext(GROUP_NAME);
var RovingFocusGroup = React49.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ jsx(Collection.Provider, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ jsx(Collection.Slot, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ jsx(RovingFocusGroupImpl, { ...props, ref: forwardedRef }) }) });
  }
);
RovingFocusGroup.displayName = GROUP_NAME;
var RovingFocusGroupImpl = React49.forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    orientation,
    loop = false,
    dir,
    currentTabStopId: currentTabStopIdProp,
    defaultCurrentTabStopId,
    onCurrentTabStopIdChange,
    onEntryFocus,
    preventScrollOnEntryFocus = false,
    ...groupProps
  } = props;
  const ref = React49.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const direction = useDirection(dir);
  const [currentTabStopId, setCurrentTabStopId] = useControllableState({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId ?? null,
    onChange: onCurrentTabStopIdChange,
    caller: GROUP_NAME
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = React49.useState(false);
  const handleEntryFocus = useCallbackRef(onEntryFocus);
  const getItems = useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = React49.useRef(false);
  const [focusableItemsCount, setFocusableItemsCount] = React49.useState(0);
  React49.useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener(ENTRY_FOCUS, handleEntryFocus);
      return () => node.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */ jsx(
    RovingFocusProvider,
    {
      scope: __scopeRovingFocusGroup,
      orientation,
      dir: direction,
      loop,
      currentTabStopId,
      onItemFocus: React49.useCallback(
        (tabStopId) => setCurrentTabStopId(tabStopId),
        [setCurrentTabStopId]
      ),
      onItemShiftTab: React49.useCallback(() => setIsTabbingBackOut(true), []),
      onFocusableItemAdd: React49.useCallback(
        () => setFocusableItemsCount((prevCount) => prevCount + 1),
        []
      ),
      onFocusableItemRemove: React49.useCallback(
        () => setFocusableItemsCount((prevCount) => prevCount - 1),
        []
      ),
      children: /* @__PURE__ */ jsx(
        Primitive.div,
        {
          tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
          "data-orientation": orientation,
          ...groupProps,
          ref: composedRefs,
          style: { outline: "none", ...props.style },
          onMouseDown: composeEventHandlers(props.onMouseDown, () => {
            isClickFocusRef.current = true;
          }),
          onFocus: composeEventHandlers(props.onFocus, (event) => {
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
              const entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS);
              event.currentTarget.dispatchEvent(entryFocusEvent);
              if (!entryFocusEvent.defaultPrevented) {
                const items = getItems().filter((item) => item.focusable);
                const activeItem = items.find((item) => item.active);
                const currentItem = items.find((item) => item.id === currentTabStopId);
                const candidateItems = [activeItem, currentItem, ...items].filter(
                  Boolean
                );
                const candidateNodes = candidateItems.map((item) => item.ref.current);
                focusFirst(candidateNodes, preventScrollOnEntryFocus);
              }
            }
            isClickFocusRef.current = false;
          }),
          onBlur: composeEventHandlers(props.onBlur, () => setIsTabbingBackOut(false))
        }
      )
    }
  );
});
var ITEM_NAME = "RovingFocusGroupItem";
var RovingFocusGroupItem = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeRovingFocusGroup,
      focusable = true,
      active = false,
      tabStopId,
      children,
      ...itemProps
    } = props;
    const autoId = useId();
    const id = tabStopId || autoId;
    const context = useRovingFocusContext(ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd, onFocusableItemRemove, currentTabStopId } = context;
    React49.useEffect(() => {
      if (focusable) {
        onFocusableItemAdd();
        return () => onFocusableItemRemove();
      }
    }, [focusable, onFocusableItemAdd, onFocusableItemRemove]);
    return /* @__PURE__ */ jsx(
      Collection.ItemSlot,
      {
        scope: __scopeRovingFocusGroup,
        id,
        focusable,
        active,
        children: /* @__PURE__ */ jsx(
          Primitive.span,
          {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: composeEventHandlers(props.onMouseDown, (event) => {
              if (!focusable) event.preventDefault();
              else context.onItemFocus(id);
            }),
            onFocus: composeEventHandlers(props.onFocus, () => context.onItemFocus(id)),
            onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
              if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
              }
              if (event.target !== event.currentTarget) return;
              const focusIntent = getFocusIntent(event, context.orientation, context.dir);
              if (focusIntent !== void 0) {
                if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                event.preventDefault();
                const items = getItems().filter((item) => item.focusable);
                let candidateNodes = items.map((item) => item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                  if (focusIntent === "prev") candidateNodes.reverse();
                  const currentIndex = candidateNodes.indexOf(event.currentTarget);
                  candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                setTimeout(() => focusFirst(candidateNodes));
              }
            }),
            children: typeof children === "function" ? children({ isCurrentTabStop, hasTabStop: currentTabStopId != null }) : children
          }
        )
      }
    );
  }
);
RovingFocusGroupItem.displayName = ITEM_NAME;
var MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
  const key = getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key)) return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key)) return void 0;
  return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst(candidates, preventScroll = false) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus({ preventScroll });
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function wrapArray(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
var Root3 = RovingFocusGroup;
var Item = RovingFocusGroupItem;
var TABS_NAME = "Tabs";
var [createTabsContext] = createContextScope(TABS_NAME, [
  createRovingFocusGroupScope
]);
var useRovingFocusGroupScope = createRovingFocusGroupScope();
var [TabsProvider, useTabsContext] = createTabsContext(TABS_NAME);
var Tabs = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeTabs,
      value: valueProp,
      onValueChange,
      defaultValue,
      orientation = "horizontal",
      dir,
      activationMode = "automatic",
      ...tabsProps
    } = props;
    const direction = useDirection(dir);
    const [value, setValue] = useControllableState({
      prop: valueProp,
      onChange: onValueChange,
      defaultProp: defaultValue ?? "",
      caller: TABS_NAME
    });
    return /* @__PURE__ */ jsx(
      TabsProvider,
      {
        scope: __scopeTabs,
        baseId: useId(),
        value,
        onValueChange: setValue,
        orientation,
        dir: direction,
        activationMode,
        children: /* @__PURE__ */ jsx(
          Primitive.div,
          {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
          }
        )
      }
    );
  }
);
Tabs.displayName = TABS_NAME;
var TAB_LIST_NAME = "TabsList";
var TabsList = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeTabs, loop = true, ...listProps } = props;
    const context = useTabsContext(TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ jsx(
      Root3,
      {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop,
        children: /* @__PURE__ */ jsx(
          Primitive.div,
          {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
          }
        )
      }
    );
  }
);
TabsList.displayName = TAB_LIST_NAME;
var TRIGGER_NAME = "TabsTrigger";
var TabsTrigger = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeTabs, value, disabled = false, ...triggerProps } = props;
    const context = useTabsContext(TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
    const triggerId = makeTriggerId(context.baseId, value);
    const contentId = makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ jsx(
      Item,
      {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ jsx(
          Primitive.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: composeEventHandlers(props.onMouseDown, (event) => {
              if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onValueChange(value);
              } else {
                event.preventDefault();
              }
            }),
            onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
              if ([" ", "Enter"].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: composeEventHandlers(props.onFocus, () => {
              const isAutomaticActivation = context.activationMode !== "manual";
              if (!isSelected && !disabled && isAutomaticActivation) {
                context.onValueChange(value);
              }
            })
          }
        )
      }
    );
  }
);
TabsTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "TabsContent";
var TabsContent = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeTabs, value, forceMount, children, ...contentProps } = props;
    const context = useTabsContext(CONTENT_NAME, __scopeTabs);
    const triggerId = makeTriggerId(context.baseId, value);
    const contentId = makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = React49.useRef(isSelected);
    React49.useEffect(() => {
      const rAF = requestAnimationFrame(() => isMountAnimationPreventedRef.current = false);
      return () => cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ jsx(Presence, { present: forceMount || isSelected, children: ({ present }) => /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-state": isSelected ? "active" : "inactive",
        "data-orientation": context.orientation,
        role: "tabpanel",
        "aria-labelledby": triggerId,
        hidden: !present,
        id: contentId,
        tabIndex: 0,
        ...contentProps,
        ref: forwardedRef,
        style: {
          ...props.style,
          animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
        },
        children: present && children
      }
    ) });
  }
);
TabsContent.displayName = CONTENT_NAME;
function makeTriggerId(baseId, value) {
  return `${baseId}-trigger-${value}`;
}
function makeContentId(baseId, value) {
  return `${baseId}-content-${value}`;
}
var Root22 = Tabs;
var List = TabsList;
var Trigger = TabsTrigger;
var Content = TabsContent;
var Tabs2 = Root22;
var TabsList2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  List,
  {
    ref,
    className: cn(
      "inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
      className
    ),
    ...props
  }
));
TabsList2.displayName = List.displayName;
var TabsTrigger2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Trigger,
  {
    ref,
    className: cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      className
    ),
    ...props
  }
));
TabsTrigger2.displayName = Trigger.displayName;
var TabsContent2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Content,
  {
    ref,
    className: cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    ),
    ...props
  }
));
TabsContent2.displayName = Content.displayName;
var FloatingPanel = (props) => /* @__PURE__ */ jsx(
  "div",
  {
    ...props,
    className: cn(
      "bg-card overflow-hidden rounded-md shadow border w-[300px]",
      props.className
    )
  }
);
var FloatingPanelContent = (props) => /* @__PURE__ */ jsx("div", { ...props, className: cn("p-2 flex flex-col gap-2", props.className) });
var FloatingPanelHeader = (props) => /* @__PURE__ */ jsx(
  "div",
  {
    ...props,
    className: cn(
      "p-2 bg-card font-medium text-xs flex items-center gap-2",
      props.className
    )
  }
);
var FloatingPanelSeparator = (props) => /* @__PURE__ */ jsx(Separator2, { ...props, className: cn("", props.className) });
function PanelContent({ title, children }) {
  return /* @__PURE__ */ jsx(FloatingPanelContent, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
    title && /* @__PURE__ */ jsx("div", { className: "items-center font-medium text-xs", children: title }),
    /* @__PURE__ */ jsx("div", { className: "flex w-full", children })
  ] }) });
}

// ../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
var falsyToString = (value) => typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
var cx = clsx;
var cva = (base2, config) => (props) => {
  var _config_compoundVariants;
  if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base2, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  const { variants, defaultVariants } = config;
  const getVariantClassNames = Object.keys(variants).map((variant) => {
    const variantProp = props === null || props === void 0 ? void 0 : props[variant];
    const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
    if (variantProp === null) return null;
    const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
    return variants[variant][variantKey];
  });
  const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
    let [key, value] = param;
    if (value === void 0) {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});
  const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param) => {
    let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
    return Object.entries(compoundVariantOptions).every((param2) => {
      let [key, value] = param2;
      return Array.isArray(value) ? value.includes({
        ...defaultVariants,
        ...propsWithoutUndefined
      }[key]) : {
        ...defaultVariants,
        ...propsWithoutUndefined
      }[key] === value;
    }) ? [
      ...acc,
      cvClass,
      cvClassName
    ] : acc;
  }, []);
  return cx(base2, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
};
var buttonVariants = cva(
  "cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 text-foreground",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/70",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        "destructive-outline": "border-destructive text-destructive",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
        "icon-xs": "size-6"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var Button = React49.forwardRef(
  ({ className, variant, size: size4, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx(
      Comp,
      {
        className: cn(buttonVariants({ variant, size: size4, className })),
        ref,
        ...props
      }
    );
  }
);
Button.displayName = "Button";

// ../../node_modules/.pnpm/orderedmap@2.1.1/node_modules/orderedmap/dist/index.js
function OrderedMap(content) {
  this.content = content;
}
OrderedMap.prototype = {
  constructor: OrderedMap,
  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found2 = this.find(key);
    return found2 == -1 ? void 0 : this.content[found2 + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this;
    var found2 = self.find(key), content = self.content.slice();
    if (found2 == -1) {
      content.push(newKey || key, value);
    } else {
      content[found2 + 1] = value;
      if (newKey) content[found2] = newKey;
    }
    return new OrderedMap(content);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found2 = this.find(key);
    if (found2 == -1) return this;
    var content = this.content.slice();
    content.splice(found2, 2);
    return new OrderedMap(content);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice();
    content.push(key, value);
    return new OrderedMap(content);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice();
    var found2 = without.find(place);
    content.splice(found2 == -1 ? content.length : found2, 0, key, value);
    return new OrderedMap(content);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map2) {
    map2 = OrderedMap.from(map2);
    if (!map2.size) return this;
    return new OrderedMap(map2.content.concat(this.subtract(map2).content));
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map2) {
    map2 = OrderedMap.from(map2);
    if (!map2.size) return this;
    return new OrderedMap(this.subtract(map2).content.concat(map2.content));
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map2) {
    var result = this;
    map2 = OrderedMap.from(map2);
    for (var i = 0; i < map2.content.length; i += 2)
      result = result.remove(map2.content[i]);
    return result;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var result = {};
    this.forEach(function(key, value) {
      result[key] = value;
    });
    return result;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value;
  var content = [];
  if (value) for (var prop in value) content.push(prop, value[prop]);
  return new OrderedMap(content);
};
var dist_default = OrderedMap;

// ../../node_modules/.pnpm/prosemirror-model@1.25.4/node_modules/prosemirror-model/dist/index.js
function findDiffStart(a, b, pos) {
  for (let i = 0; ; i++) {
    if (i == a.childCount || i == b.childCount)
      return a.childCount == b.childCount ? null : pos;
    let childA = a.child(i), childB = b.child(i);
    if (childA == childB) {
      pos += childA.nodeSize;
      continue;
    }
    if (!childA.sameMarkup(childB))
      return pos;
    if (childA.isText && childA.text != childB.text) {
      for (let j = 0; childA.text[j] == childB.text[j]; j++)
        pos++;
      return pos;
    }
    if (childA.content.size || childB.content.size) {
      let inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null)
        return inner;
    }
    pos += childA.nodeSize;
  }
}
function findDiffEnd(a, b, posA, posB) {
  for (let iA = a.childCount, iB = b.childCount; ; ) {
    if (iA == 0 || iB == 0)
      return iA == iB ? null : { a: posA, b: posB };
    let childA = a.child(--iA), childB = b.child(--iB), size4 = childA.nodeSize;
    if (childA == childB) {
      posA -= size4;
      posB -= size4;
      continue;
    }
    if (!childA.sameMarkup(childB))
      return { a: posA, b: posB };
    if (childA.isText && childA.text != childB.text) {
      let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++;
        posA--;
        posB--;
      }
      return { a: posA, b: posB };
    }
    if (childA.content.size || childB.content.size) {
      let inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner)
        return inner;
    }
    posA -= size4;
    posB -= size4;
  }
}
var Fragment6 = class _Fragment {
  /**
  @internal
  */
  constructor(content, size4) {
    this.content = content;
    this.size = size4 || 0;
    if (size4 == null)
      for (let i = 0; i < content.length; i++)
        this.size += content[i].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(from2, to, f, nodeStart = 0, parent) {
    for (let i = 0, pos = 0; pos < to; i++) {
      let child = this.content[i], end2 = pos + child.nodeSize;
      if (end2 > from2 && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
        let start2 = pos + 1;
        child.nodesBetween(Math.max(0, from2 - start2), Math.min(child.content.size, to - start2), f, nodeStart + start2);
      }
      pos = end2;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(f) {
    this.nodesBetween(0, this.size, f);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(from2, to, blockSeparator, leafText) {
    let text = "", first2 = true;
    this.nodesBetween(from2, to, (node, pos) => {
      let nodeText = node.isText ? node.text.slice(Math.max(from2, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
      if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
        if (first2)
          first2 = false;
        else
          text += blockSeparator;
      }
      text += nodeText;
    }, 0);
    return text;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(other) {
    if (!other.size)
      return this;
    if (!this.size)
      return other;
    let last = this.lastChild, first2 = other.firstChild, content = this.content.slice(), i = 0;
    if (last.isText && last.sameMarkup(first2)) {
      content[content.length - 1] = last.withText(last.text + first2.text);
      i = 1;
    }
    for (; i < other.content.length; i++)
      content.push(other.content[i]);
    return new _Fragment(content, this.size + other.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(from2, to = this.size) {
    if (from2 == 0 && to == this.size)
      return this;
    let result = [], size4 = 0;
    if (to > from2)
      for (let i = 0, pos = 0; pos < to; i++) {
        let child = this.content[i], end2 = pos + child.nodeSize;
        if (end2 > from2) {
          if (pos < from2 || end2 > to) {
            if (child.isText)
              child = child.cut(Math.max(0, from2 - pos), Math.min(child.text.length, to - pos));
            else
              child = child.cut(Math.max(0, from2 - pos - 1), Math.min(child.content.size, to - pos - 1));
          }
          result.push(child);
          size4 += child.nodeSize;
        }
        pos = end2;
      }
    return new _Fragment(result, size4);
  }
  /**
  @internal
  */
  cutByIndex(from2, to) {
    if (from2 == to)
      return _Fragment.empty;
    if (from2 == 0 && to == this.content.length)
      return this;
    return new _Fragment(this.content.slice(from2, to));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(index2, node) {
    let current = this.content[index2];
    if (current == node)
      return this;
    let copy2 = this.content.slice();
    let size4 = this.size + node.nodeSize - current.nodeSize;
    copy2[index2] = node;
    return new _Fragment(copy2, size4);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(node) {
    return new _Fragment([node].concat(this.content), this.size + node.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(node) {
    return new _Fragment(this.content.concat(node), this.size + node.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(other) {
    if (this.content.length != other.content.length)
      return false;
    for (let i = 0; i < this.content.length; i++)
      if (!this.content[i].eq(other.content[i]))
        return false;
    return true;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(index2) {
    let found2 = this.content[index2];
    if (!found2)
      throw new RangeError("Index " + index2 + " out of range for " + this);
    return found2;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(index2) {
    return this.content[index2] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(f) {
    for (let i = 0, p = 0; i < this.content.length; i++) {
      let child = this.content[i];
      f(child, p, i);
      p += child.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(other, pos = 0) {
    return findDiffStart(this, other, pos);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(other, pos = this.size, otherPos = other.size) {
    return findDiffEnd(this, other, pos, otherPos);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(pos) {
    if (pos == 0)
      return retIndex(0, pos);
    if (pos == this.size)
      return retIndex(this.content.length, pos);
    if (pos > this.size || pos < 0)
      throw new RangeError(`Position ${pos} outside of fragment (${this})`);
    for (let i = 0, curPos = 0; ; i++) {
      let cur = this.child(i), end2 = curPos + cur.nodeSize;
      if (end2 >= pos) {
        if (end2 == pos)
          return retIndex(i + 1, end2);
        return retIndex(i, curPos);
      }
      curPos = end2;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((n) => n.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(schema, value) {
    if (!value)
      return _Fragment.empty;
    if (!Array.isArray(value))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new _Fragment(value.map(schema.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(array) {
    if (!array.length)
      return _Fragment.empty;
    let joined, size4 = 0;
    for (let i = 0; i < array.length; i++) {
      let node = array[i];
      size4 += node.nodeSize;
      if (i && node.isText && array[i - 1].sameMarkup(node)) {
        if (!joined)
          joined = array.slice(0, i);
        joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
      } else if (joined) {
        joined.push(node);
      }
    }
    return new _Fragment(joined || array, size4);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(nodes) {
    if (!nodes)
      return _Fragment.empty;
    if (nodes instanceof _Fragment)
      return nodes;
    if (Array.isArray(nodes))
      return this.fromArray(nodes);
    if (nodes.attrs)
      return new _Fragment([nodes], nodes.nodeSize);
    throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
};
Fragment6.empty = new Fragment6([], 0);
var found = { index: 0, offset: 0 };
function retIndex(index2, offset5) {
  found.index = index2;
  found.offset = offset5;
  return found;
}
function compareDeep(a, b) {
  if (a === b)
    return true;
  if (!(a && typeof a == "object") || !(b && typeof b == "object"))
    return false;
  let array = Array.isArray(a);
  if (Array.isArray(b) != array)
    return false;
  if (array) {
    if (a.length != b.length)
      return false;
    for (let i = 0; i < a.length; i++)
      if (!compareDeep(a[i], b[i]))
        return false;
  } else {
    for (let p in a)
      if (!(p in b) || !compareDeep(a[p], b[p]))
        return false;
    for (let p in b)
      if (!(p in a))
        return false;
  }
  return true;
}
var Mark = class _Mark2 {
  /**
  @internal
  */
  constructor(type, attrs) {
    this.type = type;
    this.attrs = attrs;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(set) {
    let copy2, placed = false;
    for (let i = 0; i < set.length; i++) {
      let other = set[i];
      if (this.eq(other))
        return set;
      if (this.type.excludes(other.type)) {
        if (!copy2)
          copy2 = set.slice(0, i);
      } else if (other.type.excludes(this.type)) {
        return set;
      } else {
        if (!placed && other.type.rank > this.type.rank) {
          if (!copy2)
            copy2 = set.slice(0, i);
          copy2.push(this);
          placed = true;
        }
        if (copy2)
          copy2.push(other);
      }
    }
    if (!copy2)
      copy2 = set.slice();
    if (!placed)
      copy2.push(this);
    return copy2;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(set) {
    for (let i = 0; i < set.length; i++)
      if (this.eq(set[i]))
        return set.slice(0, i).concat(set.slice(i + 1));
    return set;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(set) {
    for (let i = 0; i < set.length; i++)
      if (this.eq(set[i]))
        return true;
    return false;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(other) {
    return this == other || this.type == other.type && compareDeep(this.attrs, other.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let obj = { type: this.type.name };
    for (let _ in this.attrs) {
      obj.attrs = this.attrs;
      break;
    }
    return obj;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(schema, json) {
    if (!json)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let type = schema.marks[json.type];
    if (!type)
      throw new RangeError(`There is no mark type ${json.type} in this schema`);
    let mark = type.create(json.attrs);
    type.checkAttrs(mark.attrs);
    return mark;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(a, b) {
    if (a == b)
      return true;
    if (a.length != b.length)
      return false;
    for (let i = 0; i < a.length; i++)
      if (!a[i].eq(b[i]))
        return false;
    return true;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(marks) {
    if (!marks || Array.isArray(marks) && marks.length == 0)
      return _Mark2.none;
    if (marks instanceof _Mark2)
      return [marks];
    let copy2 = marks.slice();
    copy2.sort((a, b) => a.type.rank - b.type.rank);
    return copy2;
  }
};
Mark.none = [];
var ReplaceError = class extends Error {
};
var Slice = class _Slice {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(content, openStart, openEnd) {
    this.content = content;
    this.openStart = openStart;
    this.openEnd = openEnd;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(pos, fragment) {
    let content = insertInto(this.content, pos + this.openStart, fragment);
    return content && new _Slice(content, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(from2, to) {
    return new _Slice(removeRange(this.content, from2 + this.openStart, to + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(other) {
    return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let json = { content: this.content.toJSON() };
    if (this.openStart > 0)
      json.openStart = this.openStart;
    if (this.openEnd > 0)
      json.openEnd = this.openEnd;
    return json;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(schema, json) {
    if (!json)
      return _Slice.empty;
    let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
    if (typeof openStart != "number" || typeof openEnd != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new _Slice(Fragment6.fromJSON(schema, json.content), openStart, openEnd);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(fragment, openIsolating = true) {
    let openStart = 0, openEnd = 0;
    for (let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)
      openStart++;
    for (let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)
      openEnd++;
    return new _Slice(fragment, openStart, openEnd);
  }
};
Slice.empty = new Slice(Fragment6.empty, 0, 0);
function removeRange(content, from2, to) {
  let { index: index2, offset: offset5 } = content.findIndex(from2), child = content.maybeChild(index2);
  let { index: indexTo, offset: offsetTo } = content.findIndex(to);
  if (offset5 == from2 || child.isText) {
    if (offsetTo != to && !content.child(indexTo).isText)
      throw new RangeError("Removing non-flat range");
    return content.cut(0, from2).append(content.cut(to));
  }
  if (index2 != indexTo)
    throw new RangeError("Removing non-flat range");
  return content.replaceChild(index2, child.copy(removeRange(child.content, from2 - offset5 - 1, to - offset5 - 1)));
}
function insertInto(content, dist, insert, parent) {
  let { index: index2, offset: offset5 } = content.findIndex(dist), child = content.maybeChild(index2);
  if (offset5 == dist || child.isText) {
    if (parent && !parent.canReplace(index2, index2, insert))
      return null;
    return content.cut(0, dist).append(insert).append(content.cut(dist));
  }
  let inner = insertInto(child.content, dist - offset5 - 1, insert, child);
  return inner && content.replaceChild(index2, child.copy(inner));
}
function replace($from, $to, slice2) {
  if (slice2.openStart > $from.depth)
    throw new ReplaceError("Inserted content deeper than insertion position");
  if ($from.depth - slice2.openStart != $to.depth - slice2.openEnd)
    throw new ReplaceError("Inconsistent open depths");
  return replaceOuter($from, $to, slice2, 0);
}
function replaceOuter($from, $to, slice2, depth) {
  let index2 = $from.index(depth), node = $from.node(depth);
  if (index2 == $to.index(depth) && depth < $from.depth - slice2.openStart) {
    let inner = replaceOuter($from, $to, slice2, depth + 1);
    return node.copy(node.content.replaceChild(index2, inner));
  } else if (!slice2.content.size) {
    return close(node, replaceTwoWay($from, $to, depth));
  } else if (!slice2.openStart && !slice2.openEnd && $from.depth == depth && $to.depth == depth) {
    let parent = $from.parent, content = parent.content;
    return close(parent, content.cut(0, $from.parentOffset).append(slice2.content).append(content.cut($to.parentOffset)));
  } else {
    let { start: start2, end: end2 } = prepareSliceForReplace(slice2, $from);
    return close(node, replaceThreeWay($from, start2, end2, $to, depth));
  }
}
function checkJoin(main4, sub) {
  if (!sub.type.compatibleContent(main4.type))
    throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main4.type.name);
}
function joinable($before, $after, depth) {
  let node = $before.node(depth);
  checkJoin(node, $after.node(depth));
  return node;
}
function addNode(child, target) {
  let last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
    target[last] = child.withText(target[last].text + child.text);
  else
    target.push(child);
}
function addRange($start, $end, depth, target) {
  let node = ($end || $start).node(depth);
  let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (let i = startIndex; i < endIndex; i++)
    addNode(node.child(i), target);
  if ($end && $end.depth == depth && $end.textOffset)
    addNode($end.nodeBefore, target);
}
function close(node, content) {
  node.type.checkContent(content);
  return node.copy(content);
}
function replaceThreeWay($from, $start, $end, $to, depth) {
  let openStart = $from.depth > depth && joinable($from, $start, depth + 1);
  let openEnd = $to.depth > depth && joinable($end, $to, depth + 1);
  let content = [];
  addRange(null, $from, depth, content);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
  } else {
    if (openStart)
      addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content);
    addRange($start, $end, depth, content);
    if (openEnd)
      addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment6(content);
}
function replaceTwoWay($from, $to, depth) {
  let content = [];
  addRange(null, $from, depth, content);
  if ($from.depth > depth) {
    let type = joinable($from, $to, depth + 1);
    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment6(content);
}
function prepareSliceForReplace(slice2, $along) {
  let extra = $along.depth - slice2.openStart, parent = $along.node(extra);
  let node = parent.copy(slice2.content);
  for (let i = extra - 1; i >= 0; i--)
    node = $along.node(i).copy(Fragment6.from(node));
  return {
    start: node.resolveNoCache(slice2.openStart + extra),
    end: node.resolveNoCache(node.content.size - slice2.openEnd - extra)
  };
}
var ResolvedPos = class _ResolvedPos {
  /**
  @internal
  */
  constructor(pos, path, parentOffset) {
    this.pos = pos;
    this.path = path;
    this.parentOffset = parentOffset;
    this.depth = path.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(val) {
    if (val == null)
      return this.depth;
    if (val < 0)
      return this.depth + val;
    return val;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(depth) {
    return this.path[this.resolveDepth(depth) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(depth) {
    return this.path[this.resolveDepth(depth) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(depth) {
    depth = this.resolveDepth(depth);
    return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(depth) {
    depth = this.resolveDepth(depth);
    return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(depth) {
    depth = this.resolveDepth(depth);
    return this.start(depth) + this.node(depth).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(depth) {
    depth = this.resolveDepth(depth);
    if (!depth)
      throw new RangeError("There is no position before the top-level node");
    return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(depth) {
    depth = this.resolveDepth(depth);
    if (!depth)
      throw new RangeError("There is no position after the top-level node");
    return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let parent = this.parent, index2 = this.index(this.depth);
    if (index2 == parent.childCount)
      return null;
    let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index2);
    return dOff ? parent.child(index2).cut(dOff) : child;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let index2 = this.index(this.depth);
    let dOff = this.pos - this.path[this.path.length - 1];
    if (dOff)
      return this.parent.child(index2).cut(0, dOff);
    return index2 == 0 ? null : this.parent.child(index2 - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(index2, depth) {
    depth = this.resolveDepth(depth);
    let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    for (let i = 0; i < index2; i++)
      pos += node.child(i).nodeSize;
    return pos;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let parent = this.parent, index2 = this.index();
    if (parent.content.size == 0)
      return Mark.none;
    if (this.textOffset)
      return parent.child(index2).marks;
    let main4 = parent.maybeChild(index2 - 1), other = parent.maybeChild(index2);
    if (!main4) {
      let tmp = main4;
      main4 = other;
      other = tmp;
    }
    let marks = main4.marks;
    for (var i = 0; i < marks.length; i++)
      if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
        marks = marks[i--].removeFromSet(marks);
    return marks;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross($end) {
    let after = this.parent.maybeChild(this.index());
    if (!after || !after.isInline)
      return null;
    let marks = after.marks, next = $end.parent.maybeChild($end.index());
    for (var i = 0; i < marks.length; i++)
      if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
        marks = marks[i--].removeFromSet(marks);
    return marks;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(pos) {
    for (let depth = this.depth; depth > 0; depth--)
      if (this.start(depth) <= pos && this.end(depth) >= pos)
        return depth;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(other = this, pred) {
    if (other.pos < this.pos)
      return other.blockRange(this);
    for (let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
      if (other.pos <= this.end(d) && (!pred || pred(this.node(d))))
        return new NodeRange(this, other, d);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(other) {
    return this.pos - this.parentOffset == other.pos - other.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(other) {
    return other.pos > this.pos ? other : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(other) {
    return other.pos < this.pos ? other : this;
  }
  /**
  @internal
  */
  toString() {
    let str = "";
    for (let i = 1; i <= this.depth; i++)
      str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
    return str + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(doc3, pos) {
    if (!(pos >= 0 && pos <= doc3.content.size))
      throw new RangeError("Position " + pos + " out of range");
    let path = [];
    let start2 = 0, parentOffset = pos;
    for (let node = doc3; ; ) {
      let { index: index2, offset: offset5 } = node.content.findIndex(parentOffset);
      let rem = parentOffset - offset5;
      path.push(node, index2, start2 + offset5);
      if (!rem)
        break;
      node = node.child(index2);
      if (node.isText)
        break;
      parentOffset = rem - 1;
      start2 += offset5 + 1;
    }
    return new _ResolvedPos(pos, path, parentOffset);
  }
  /**
  @internal
  */
  static resolveCached(doc3, pos) {
    let cache = resolveCache.get(doc3);
    if (cache) {
      for (let i = 0; i < cache.elts.length; i++) {
        let elt = cache.elts[i];
        if (elt.pos == pos)
          return elt;
      }
    } else {
      resolveCache.set(doc3, cache = new ResolveCache());
    }
    let result = cache.elts[cache.i] = _ResolvedPos.resolve(doc3, pos);
    cache.i = (cache.i + 1) % resolveCacheSize;
    return result;
  }
};
var ResolveCache = class {
  constructor() {
    this.elts = [];
    this.i = 0;
  }
};
var resolveCacheSize = 12;
var resolveCache = /* @__PURE__ */ new WeakMap();
var NodeRange = class {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor($from, $to, depth) {
    this.$from = $from;
    this.$to = $to;
    this.depth = depth;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
};
var emptyAttrs = /* @__PURE__ */ Object.create(null);
var Node2 = class _Node2 {
  /**
  @internal
  */
  constructor(type, attrs, content, marks = Mark.none) {
    this.type = type;
    this.attrs = attrs;
    this.marks = marks;
    this.content = content || Fragment6.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(index2) {
    return this.content.child(index2);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(index2) {
    return this.content.maybeChild(index2);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(f) {
    this.content.forEach(f);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(from2, to, f, startPos = 0) {
    this.content.nodesBetween(from2, to, f, startPos, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(f) {
    this.nodesBetween(0, this.content.size, f);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(from2, to, blockSeparator, leafText) {
    return this.content.textBetween(from2, to, blockSeparator, leafText);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(other) {
    return this == other || this.sameMarkup(other) && this.content.eq(other.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(other) {
    return this.hasMarkup(other.type, other.attrs, other.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(type, attrs, marks) {
    return this.type == type && compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) && Mark.sameSet(this.marks, marks || Mark.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(content = null) {
    if (content == this.content)
      return this;
    return new _Node2(this.type, this.attrs, content, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(marks) {
    return marks == this.marks ? this : new _Node2(this.type, this.attrs, this.content, marks);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(from2, to = this.content.size) {
    if (from2 == 0 && to == this.content.size)
      return this;
    return this.copy(this.content.cut(from2, to));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(from2, to = this.content.size, includeParents = false) {
    if (from2 == to)
      return Slice.empty;
    let $from = this.resolve(from2), $to = this.resolve(to);
    let depth = includeParents ? 0 : $from.sharedDepth(to);
    let start2 = $from.start(depth), node = $from.node(depth);
    let content = node.content.cut($from.pos - start2, $to.pos - start2);
    return new Slice(content, $from.depth - depth, $to.depth - depth);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(from2, to, slice2) {
    return replace(this.resolve(from2), this.resolve(to), slice2);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(pos) {
    for (let node = this; ; ) {
      let { index: index2, offset: offset5 } = node.content.findIndex(pos);
      node = node.maybeChild(index2);
      if (!node)
        return null;
      if (offset5 == pos || node.isText)
        return node;
      pos -= offset5 + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(pos) {
    let { index: index2, offset: offset5 } = this.content.findIndex(pos);
    return { node: this.content.maybeChild(index2), index: index2, offset: offset5 };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(pos) {
    if (pos == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: index2, offset: offset5 } = this.content.findIndex(pos);
    if (offset5 < pos)
      return { node: this.content.child(index2), index: index2, offset: offset5 };
    let node = this.content.child(index2 - 1);
    return { node, index: index2 - 1, offset: offset5 - node.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(pos) {
    return ResolvedPos.resolveCached(this, pos);
  }
  /**
  @internal
  */
  resolveNoCache(pos) {
    return ResolvedPos.resolve(this, pos);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(from2, to, type) {
    let found2 = false;
    if (to > from2)
      this.nodesBetween(from2, to, (node) => {
        if (type.isInSet(node.marks))
          found2 = true;
        return !found2;
      });
    return found2;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let name = this.type.name;
    if (this.content.size)
      name += "(" + this.content.toStringInner() + ")";
    return wrapMarks(this.marks, name);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(index2) {
    let match = this.type.contentMatch.matchFragment(this.content, 0, index2);
    if (!match)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return match;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(from2, to, replacement = Fragment6.empty, start2 = 0, end2 = replacement.childCount) {
    let one = this.contentMatchAt(from2).matchFragment(replacement, start2, end2);
    let two = one && one.matchFragment(this.content, to);
    if (!two || !two.validEnd)
      return false;
    for (let i = start2; i < end2; i++)
      if (!this.type.allowsMarks(replacement.child(i).marks))
        return false;
    return true;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(from2, to, type, marks) {
    if (marks && !this.type.allowsMarks(marks))
      return false;
    let start2 = this.contentMatchAt(from2).matchType(type);
    let end2 = start2 && start2.matchFragment(this.content, to);
    return end2 ? end2.validEnd : false;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(other) {
    if (other.content.size)
      return this.canReplace(this.childCount, this.childCount, other.content);
    else
      return this.type.compatibleContent(other.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content);
    this.type.checkAttrs(this.attrs);
    let copy2 = Mark.none;
    for (let i = 0; i < this.marks.length; i++) {
      let mark = this.marks[i];
      mark.type.checkAttrs(mark.attrs);
      copy2 = mark.addToSet(copy2);
    }
    if (!Mark.sameSet(copy2, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m) => m.type.name)}`);
    this.content.forEach((node) => node.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let obj = { type: this.type.name };
    for (let _ in this.attrs) {
      obj.attrs = this.attrs;
      break;
    }
    if (this.content.size)
      obj.content = this.content.toJSON();
    if (this.marks.length)
      obj.marks = this.marks.map((n) => n.toJSON());
    return obj;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(schema, json) {
    if (!json)
      throw new RangeError("Invalid input for Node.fromJSON");
    let marks = void 0;
    if (json.marks) {
      if (!Array.isArray(json.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      marks = json.marks.map(schema.markFromJSON);
    }
    if (json.type == "text") {
      if (typeof json.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return schema.text(json.text, marks);
    }
    let content = Fragment6.fromJSON(schema, json.content);
    let node = schema.nodeType(json.type).create(json.attrs, content, marks);
    node.type.checkAttrs(node.attrs);
    return node;
  }
};
Node2.prototype.text = void 0;
var TextNode = class _TextNode extends Node2 {
  /**
  @internal
  */
  constructor(type, attrs, content, marks) {
    super(type, attrs, null, marks);
    if (!content)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = content;
  }
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    return wrapMarks(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(from2, to) {
    return this.text.slice(from2, to);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(marks) {
    return marks == this.marks ? this : new _TextNode(this.type, this.attrs, this.text, marks);
  }
  withText(text) {
    if (text == this.text)
      return this;
    return new _TextNode(this.type, this.attrs, text, this.marks);
  }
  cut(from2 = 0, to = this.text.length) {
    if (from2 == 0 && to == this.text.length)
      return this;
    return this.withText(this.text.slice(from2, to));
  }
  eq(other) {
    return this.sameMarkup(other) && this.text == other.text;
  }
  toJSON() {
    let base2 = super.toJSON();
    base2.text = this.text;
    return base2;
  }
};
function wrapMarks(marks, str) {
  for (let i = marks.length - 1; i >= 0; i--)
    str = marks[i].type.name + "(" + str + ")";
  return str;
}
var ContentMatch = class _ContentMatch {
  /**
  @internal
  */
  constructor(validEnd) {
    this.validEnd = validEnd;
    this.next = [];
    this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(string, nodeTypes) {
    let stream = new TokenStream(string, nodeTypes);
    if (stream.next == null)
      return _ContentMatch.empty;
    let expr = parseExpr(stream);
    if (stream.next)
      stream.err("Unexpected trailing text");
    let match = dfa(nfa(expr));
    checkForDeadEnds(match, stream);
    return match;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(type) {
    for (let i = 0; i < this.next.length; i++)
      if (this.next[i].type == type)
        return this.next[i].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(frag, start2 = 0, end2 = frag.childCount) {
    let cur = this;
    for (let i = start2; cur && i < end2; i++)
      cur = cur.matchType(frag.child(i).type);
    return cur;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let i = 0; i < this.next.length; i++) {
      let { type } = this.next[i];
      if (!(type.isText || type.hasRequiredAttrs()))
        return type;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(other) {
    for (let i = 0; i < this.next.length; i++)
      for (let j = 0; j < other.next.length; j++)
        if (this.next[i].type == other.next[j].type)
          return true;
    return false;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(after, toEnd = false, startIndex = 0) {
    let seen = [this];
    function search(match, types) {
      let finished = match.matchFragment(after, startIndex);
      if (finished && (!toEnd || finished.validEnd))
        return Fragment6.from(types.map((tp) => tp.createAndFill()));
      for (let i = 0; i < match.next.length; i++) {
        let { type, next } = match.next[i];
        if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
          seen.push(next);
          let found2 = search(next, types.concat(type));
          if (found2)
            return found2;
        }
      }
      return null;
    }
    return search(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(target) {
    for (let i = 0; i < this.wrapCache.length; i += 2)
      if (this.wrapCache[i] == target)
        return this.wrapCache[i + 1];
    let computed = this.computeWrapping(target);
    this.wrapCache.push(target, computed);
    return computed;
  }
  /**
  @internal
  */
  computeWrapping(target) {
    let seen = /* @__PURE__ */ Object.create(null), active = [{ match: this, type: null, via: null }];
    while (active.length) {
      let current = active.shift(), match = current.match;
      if (match.matchType(target)) {
        let result = [];
        for (let obj = current; obj.type; obj = obj.via)
          result.push(obj.type);
        return result.reverse();
      }
      for (let i = 0; i < match.next.length; i++) {
        let { type, next } = match.next[i];
        if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
          active.push({ match: type.contentMatch, type, via: current });
          seen[type.name] = true;
        }
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(n) {
    if (n >= this.next.length)
      throw new RangeError(`There's no ${n}th edge in this content match`);
    return this.next[n];
  }
  /**
  @internal
  */
  toString() {
    let seen = [];
    function scan(m) {
      seen.push(m);
      for (let i = 0; i < m.next.length; i++)
        if (seen.indexOf(m.next[i].next) == -1)
          scan(m.next[i].next);
    }
    scan(this);
    return seen.map((m, i) => {
      let out = i + (m.validEnd ? "*" : " ") + " ";
      for (let i2 = 0; i2 < m.next.length; i2++)
        out += (i2 ? ", " : "") + m.next[i2].type.name + "->" + seen.indexOf(m.next[i2].next);
      return out;
    }).join("\n");
  }
};
ContentMatch.empty = new ContentMatch(true);
var TokenStream = class {
  constructor(string, nodeTypes) {
    this.string = string;
    this.nodeTypes = nodeTypes;
    this.inline = null;
    this.pos = 0;
    this.tokens = string.split(/\s*(?=\b|\W|$)/);
    if (this.tokens[this.tokens.length - 1] == "")
      this.tokens.pop();
    if (this.tokens[0] == "")
      this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(tok) {
    return this.next == tok && (this.pos++ || true);
  }
  err(str) {
    throw new SyntaxError(str + " (in content expression '" + this.string + "')");
  }
};
function parseExpr(stream) {
  let exprs = [];
  do {
    exprs.push(parseExprSeq(stream));
  } while (stream.eat("|"));
  return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
}
function parseExprSeq(stream) {
  let exprs = [];
  do {
    exprs.push(parseExprSubscript(stream));
  } while (stream.next && stream.next != ")" && stream.next != "|");
  return exprs.length == 1 ? exprs[0] : { type: "seq", exprs };
}
function parseExprSubscript(stream) {
  let expr = parseExprAtom(stream);
  for (; ; ) {
    if (stream.eat("+"))
      expr = { type: "plus", expr };
    else if (stream.eat("*"))
      expr = { type: "star", expr };
    else if (stream.eat("?"))
      expr = { type: "opt", expr };
    else if (stream.eat("{"))
      expr = parseExprRange(stream, expr);
    else
      break;
  }
  return expr;
}
function parseNum(stream) {
  if (/\D/.test(stream.next))
    stream.err("Expected number, got '" + stream.next + "'");
  let result = Number(stream.next);
  stream.pos++;
  return result;
}
function parseExprRange(stream, expr) {
  let min3 = parseNum(stream), max3 = min3;
  if (stream.eat(",")) {
    if (stream.next != "}")
      max3 = parseNum(stream);
    else
      max3 = -1;
  }
  if (!stream.eat("}"))
    stream.err("Unclosed braced range");
  return { type: "range", min: min3, max: max3, expr };
}
function resolveName(stream, name) {
  let types = stream.nodeTypes, type = types[name];
  if (type)
    return [type];
  let result = [];
  for (let typeName in types) {
    let type2 = types[typeName];
    if (type2.isInGroup(name))
      result.push(type2);
  }
  if (result.length == 0)
    stream.err("No node type or group '" + name + "' found");
  return result;
}
function parseExprAtom(stream) {
  if (stream.eat("(")) {
    let expr = parseExpr(stream);
    if (!stream.eat(")"))
      stream.err("Missing closing paren");
    return expr;
  } else if (!/\W/.test(stream.next)) {
    let exprs = resolveName(stream, stream.next).map((type) => {
      if (stream.inline == null)
        stream.inline = type.isInline;
      else if (stream.inline != type.isInline)
        stream.err("Mixing inline and block content");
      return { type: "name", value: type };
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}
function nfa(expr) {
  let nfa2 = [[]];
  connect(compile(expr, 0), node());
  return nfa2;
  function node() {
    return nfa2.push([]) - 1;
  }
  function edge(from2, to, term) {
    let edge2 = { term, to };
    nfa2[from2].push(edge2);
    return edge2;
  }
  function connect(edges, to) {
    edges.forEach((edge2) => edge2.to = to);
  }
  function compile(expr2, from2) {
    if (expr2.type == "choice") {
      return expr2.exprs.reduce((out, expr3) => out.concat(compile(expr3, from2)), []);
    } else if (expr2.type == "seq") {
      for (let i = 0; ; i++) {
        let next = compile(expr2.exprs[i], from2);
        if (i == expr2.exprs.length - 1)
          return next;
        connect(next, from2 = node());
      }
    } else if (expr2.type == "star") {
      let loop = node();
      edge(from2, loop);
      connect(compile(expr2.expr, loop), loop);
      return [edge(loop)];
    } else if (expr2.type == "plus") {
      let loop = node();
      connect(compile(expr2.expr, from2), loop);
      connect(compile(expr2.expr, loop), loop);
      return [edge(loop)];
    } else if (expr2.type == "opt") {
      return [edge(from2)].concat(compile(expr2.expr, from2));
    } else if (expr2.type == "range") {
      let cur = from2;
      for (let i = 0; i < expr2.min; i++) {
        let next = node();
        connect(compile(expr2.expr, cur), next);
        cur = next;
      }
      if (expr2.max == -1) {
        connect(compile(expr2.expr, cur), cur);
      } else {
        for (let i = expr2.min; i < expr2.max; i++) {
          let next = node();
          edge(cur, next);
          connect(compile(expr2.expr, cur), next);
          cur = next;
        }
      }
      return [edge(cur)];
    } else if (expr2.type == "name") {
      return [edge(from2, void 0, expr2.value)];
    } else {
      throw new Error("Unknown expr type");
    }
  }
}
function cmp(a, b) {
  return b - a;
}
function nullFrom(nfa2, node) {
  let result = [];
  scan(node);
  return result.sort(cmp);
  function scan(node2) {
    let edges = nfa2[node2];
    if (edges.length == 1 && !edges[0].term)
      return scan(edges[0].to);
    result.push(node2);
    for (let i = 0; i < edges.length; i++) {
      let { term, to } = edges[i];
      if (!term && result.indexOf(to) == -1)
        scan(to);
    }
  }
}
function dfa(nfa2) {
  let labeled = /* @__PURE__ */ Object.create(null);
  return explore(nullFrom(nfa2, 0));
  function explore(states) {
    let out = [];
    states.forEach((node) => {
      nfa2[node].forEach(({ term, to }) => {
        if (!term)
          return;
        let set;
        for (let i = 0; i < out.length; i++)
          if (out[i][0] == term)
            set = out[i][1];
        nullFrom(nfa2, to).forEach((node2) => {
          if (!set)
            out.push([term, set = []]);
          if (set.indexOf(node2) == -1)
            set.push(node2);
        });
      });
    });
    let state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa2.length - 1) > -1);
    for (let i = 0; i < out.length; i++) {
      let states2 = out[i][1].sort(cmp);
      state.next.push({ type: out[i][0], next: labeled[states2.join(",")] || explore(states2) });
    }
    return state;
  }
}
function checkForDeadEnds(match, stream) {
  for (let i = 0, work = [match]; i < work.length; i++) {
    let state = work[i], dead = !state.validEnd, nodes = [];
    for (let j = 0; j < state.next.length; j++) {
      let { type, next } = state.next[j];
      nodes.push(type.name);
      if (dead && !(type.isText || type.hasRequiredAttrs()))
        dead = false;
      if (work.indexOf(next) == -1)
        work.push(next);
    }
    if (dead)
      stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function defaultAttrs(attrs) {
  let defaults2 = /* @__PURE__ */ Object.create(null);
  for (let attrName in attrs) {
    let attr = attrs[attrName];
    if (!attr.hasDefault)
      return null;
    defaults2[attrName] = attr.default;
  }
  return defaults2;
}
function computeAttrs(attrs, value) {
  let built = /* @__PURE__ */ Object.create(null);
  for (let name in attrs) {
    let given = value && value[name];
    if (given === void 0) {
      let attr = attrs[name];
      if (attr.hasDefault)
        given = attr.default;
      else
        throw new RangeError("No value supplied for attribute " + name);
    }
    built[name] = given;
  }
  return built;
}
function checkAttrs(attrs, values, type, name) {
  for (let name2 in values)
    if (!(name2 in attrs))
      throw new RangeError(`Unsupported attribute ${name2} for ${type} of type ${name2}`);
  for (let name2 in attrs) {
    let attr = attrs[name2];
    if (attr.validate)
      attr.validate(values[name2]);
  }
}
function initAttrs(typeName, attrs) {
  let result = /* @__PURE__ */ Object.create(null);
  if (attrs)
    for (let name in attrs)
      result[name] = new Attribute(typeName, name, attrs[name]);
  return result;
}
var NodeType = class _NodeType {
  /**
  @internal
  */
  constructor(name, schema, spec) {
    this.name = name;
    this.schema = schema;
    this.spec = spec;
    this.markSet = null;
    this.groups = spec.group ? spec.group.split(" ") : [];
    this.attrs = initAttrs(name, spec.attrs);
    this.defaultAttrs = defaultAttrs(this.attrs);
    this.contentMatch = null;
    this.inlineContent = null;
    this.isBlock = !(spec.inline || name == "text");
    this.isText = name == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ContentMatch.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(group) {
    return this.groups.indexOf(group) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let n in this.attrs)
      if (this.attrs[n].isRequired)
        return true;
    return false;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(other) {
    return this == other || this.contentMatch.compatible(other.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(attrs) {
    if (!attrs && this.defaultAttrs)
      return this.defaultAttrs;
    else
      return computeAttrs(this.attrs, attrs);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(attrs = null, content, marks) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Node2(this, this.computeAttrs(attrs), Fragment6.from(content), Mark.setFrom(marks));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(attrs = null, content, marks) {
    content = Fragment6.from(content);
    this.checkContent(content);
    return new Node2(this, this.computeAttrs(attrs), content, Mark.setFrom(marks));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(attrs = null, content, marks) {
    attrs = this.computeAttrs(attrs);
    content = Fragment6.from(content);
    if (content.size) {
      let before = this.contentMatch.fillBefore(content);
      if (!before)
        return null;
      content = before.append(content);
    }
    let matched = this.contentMatch.matchFragment(content);
    let after = matched && matched.fillBefore(Fragment6.empty, true);
    if (!after)
      return null;
    return new Node2(this, attrs, content.append(after), Mark.setFrom(marks));
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(content) {
    let result = this.contentMatch.matchFragment(content);
    if (!result || !result.validEnd)
      return false;
    for (let i = 0; i < content.childCount; i++)
      if (!this.allowsMarks(content.child(i).marks))
        return false;
    return true;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(content) {
    if (!this.validContent(content))
      throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(attrs) {
    checkAttrs(this.attrs, attrs, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(markType) {
    return this.markSet == null || this.markSet.indexOf(markType) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(marks) {
    if (this.markSet == null)
      return true;
    for (let i = 0; i < marks.length; i++)
      if (!this.allowsMarkType(marks[i].type))
        return false;
    return true;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(marks) {
    if (this.markSet == null)
      return marks;
    let copy2;
    for (let i = 0; i < marks.length; i++) {
      if (!this.allowsMarkType(marks[i].type)) {
        if (!copy2)
          copy2 = marks.slice(0, i);
      } else if (copy2) {
        copy2.push(marks[i]);
      }
    }
    return !copy2 ? marks : copy2.length ? copy2 : Mark.none;
  }
  /**
  @internal
  */
  static compile(nodes, schema) {
    let result = /* @__PURE__ */ Object.create(null);
    nodes.forEach((name, spec) => result[name] = new _NodeType(name, schema, spec));
    let topType = schema.spec.topNode || "doc";
    if (!result[topType])
      throw new RangeError("Schema is missing its top node type ('" + topType + "')");
    if (!result.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let _ in result.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return result;
  }
};
function validateType(typeName, attrName, type) {
  let types = type.split("|");
  return (value) => {
    let name = value === null ? "null" : typeof value;
    if (types.indexOf(name) < 0)
      throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
  };
}
var Attribute = class {
  constructor(typeName, attrName, options) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
    this.default = options.default;
    this.validate = typeof options.validate == "string" ? validateType(typeName, attrName, options.validate) : options.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
};
var MarkType = class _MarkType {
  /**
  @internal
  */
  constructor(name, rank, schema, spec) {
    this.name = name;
    this.rank = rank;
    this.schema = schema;
    this.spec = spec;
    this.attrs = initAttrs(name, spec.attrs);
    this.excluded = null;
    let defaults2 = defaultAttrs(this.attrs);
    this.instance = defaults2 ? new Mark(this, defaults2) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(attrs = null) {
    if (!attrs && this.instance)
      return this.instance;
    return new Mark(this, computeAttrs(this.attrs, attrs));
  }
  /**
  @internal
  */
  static compile(marks, schema) {
    let result = /* @__PURE__ */ Object.create(null), rank = 0;
    marks.forEach((name, spec) => result[name] = new _MarkType(name, rank++, schema, spec));
    return result;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(set) {
    for (var i = 0; i < set.length; i++)
      if (set[i].type == this) {
        set = set.slice(0, i).concat(set.slice(i + 1));
        i--;
      }
    return set;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(set) {
    for (let i = 0; i < set.length; i++)
      if (set[i].type == this)
        return set[i];
  }
  /**
  @internal
  */
  checkAttrs(attrs) {
    checkAttrs(this.attrs, attrs, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(other) {
    return this.excluded.indexOf(other) > -1;
  }
};
var Schema = class {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(spec) {
    this.linebreakReplacement = null;
    this.cached = /* @__PURE__ */ Object.create(null);
    let instanceSpec = this.spec = {};
    for (let prop in spec)
      instanceSpec[prop] = spec[prop];
    instanceSpec.nodes = dist_default.from(spec.nodes), instanceSpec.marks = dist_default.from(spec.marks || {}), this.nodes = NodeType.compile(this.spec.nodes, this);
    this.marks = MarkType.compile(this.spec.marks, this);
    let contentExprCache = /* @__PURE__ */ Object.create(null);
    for (let prop in this.nodes) {
      if (prop in this.marks)
        throw new RangeError(prop + " can not be both a node and a mark");
      let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
      type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
      type.inlineContent = type.contentMatch.inlineContent;
      if (type.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!type.isInline || !type.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = type;
      }
      type.markSet = markExpr == "_" ? null : markExpr ? gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
    }
    for (let prop in this.marks) {
      let type = this.marks[prop], excl = type.spec.excludes;
      type.excluded = excl == null ? [type] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
    }
    this.nodeFromJSON = (json) => Node2.fromJSON(this, json);
    this.markFromJSON = (json) => Mark.fromJSON(this, json);
    this.topNodeType = this.nodes[this.spec.topNode || "doc"];
    this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(type, attrs = null, content, marks) {
    if (typeof type == "string")
      type = this.nodeType(type);
    else if (!(type instanceof NodeType))
      throw new RangeError("Invalid node type: " + type);
    else if (type.schema != this)
      throw new RangeError("Node type from different schema used (" + type.name + ")");
    return type.createChecked(attrs, content, marks);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(text, marks) {
    let type = this.nodes.text;
    return new TextNode(type, type.defaultAttrs, text, Mark.setFrom(marks));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(type, attrs) {
    if (typeof type == "string")
      type = this.marks[type];
    return type.create(attrs);
  }
  /**
  @internal
  */
  nodeType(name) {
    let found2 = this.nodes[name];
    if (!found2)
      throw new RangeError("Unknown node type: " + name);
    return found2;
  }
};
function gatherMarks(schema, marks) {
  let found2 = [];
  for (let i = 0; i < marks.length; i++) {
    let name = marks[i], mark = schema.marks[name], ok = mark;
    if (mark) {
      found2.push(mark);
    } else {
      for (let prop in schema.marks) {
        let mark2 = schema.marks[prop];
        if (name == "_" || mark2.spec.group && mark2.spec.group.split(" ").indexOf(name) > -1)
          found2.push(ok = mark2);
      }
    }
    if (!ok)
      throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
  }
  return found2;
}
function isTagRule(rule) {
  return rule.tag != null;
}
function isStyleRule(rule) {
  return rule.style != null;
}
var DOMParser = class _DOMParser {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(schema, rules) {
    this.schema = schema;
    this.rules = rules;
    this.tags = [];
    this.styles = [];
    let matchedStyles = this.matchedStyles = [];
    rules.forEach((rule) => {
      if (isTagRule(rule)) {
        this.tags.push(rule);
      } else if (isStyleRule(rule)) {
        let prop = /[^=]*/.exec(rule.style)[0];
        if (matchedStyles.indexOf(prop) < 0)
          matchedStyles.push(prop);
        this.styles.push(rule);
      }
    });
    this.normalizeLists = !this.tags.some((r2) => {
      if (!/^(ul|ol)\b/.test(r2.tag) || !r2.node)
        return false;
      let node = schema.nodes[r2.node];
      return node.contentMatch.matchType(node);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(dom, options = {}) {
    let context = new ParseContext(this, options, false);
    context.addAll(dom, Mark.none, options.from, options.to);
    return context.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(dom, options = {}) {
    let context = new ParseContext(this, options, true);
    context.addAll(dom, Mark.none, options.from, options.to);
    return Slice.maxOpen(context.finish());
  }
  /**
  @internal
  */
  matchTag(dom, context, after) {
    for (let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++) {
      let rule = this.tags[i];
      if (matches(dom, rule.tag) && (rule.namespace === void 0 || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
        if (rule.getAttrs) {
          let result = rule.getAttrs(dom);
          if (result === false)
            continue;
          rule.attrs = result || void 0;
        }
        return rule;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(prop, value, context, after) {
    for (let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++) {
      let rule = this.styles[i], style2 = rule.style;
      if (style2.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      style2.length > prop.length && (style2.charCodeAt(prop.length) != 61 || style2.slice(prop.length + 1) != value))
        continue;
      if (rule.getAttrs) {
        let result = rule.getAttrs(value);
        if (result === false)
          continue;
        rule.attrs = result || void 0;
      }
      return rule;
    }
  }
  /**
  @internal
  */
  static schemaRules(schema) {
    let result = [];
    function insert(rule) {
      let priority = rule.priority == null ? 50 : rule.priority, i = 0;
      for (; i < result.length; i++) {
        let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
        if (nextPriority < priority)
          break;
      }
      result.splice(i, 0, rule);
    }
    for (let name in schema.marks) {
      let rules = schema.marks[name].spec.parseDOM;
      if (rules)
        rules.forEach((rule) => {
          insert(rule = copy(rule));
          if (!(rule.mark || rule.ignore || rule.clearMark))
            rule.mark = name;
        });
    }
    for (let name in schema.nodes) {
      let rules = schema.nodes[name].spec.parseDOM;
      if (rules)
        rules.forEach((rule) => {
          insert(rule = copy(rule));
          if (!(rule.node || rule.ignore || rule.mark))
            rule.node = name;
        });
    }
    return result;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(schema) {
    return schema.cached.domParser || (schema.cached.domParser = new _DOMParser(schema, _DOMParser.schemaRules(schema)));
  }
};
var blockTags = {
  address: true,
  article: true,
  aside: true,
  blockquote: true,
  canvas: true,
  dd: true,
  div: true,
  dl: true,
  fieldset: true,
  figcaption: true,
  figure: true,
  footer: true,
  form: true,
  h1: true,
  h2: true,
  h3: true,
  h4: true,
  h5: true,
  h6: true,
  header: true,
  hgroup: true,
  hr: true,
  li: true,
  noscript: true,
  ol: true,
  output: true,
  p: true,
  pre: true,
  section: true,
  table: true,
  tfoot: true,
  ul: true
};
var ignoreTags = {
  head: true,
  noscript: true,
  object: true,
  script: true,
  style: true,
  title: true
};
var listTags = { ol: true, ul: true };
var OPT_PRESERVE_WS = 1;
var OPT_PRESERVE_WS_FULL = 2;
var OPT_OPEN_LEFT = 4;
function wsOptionsFor(type, preserveWhitespace, base2) {
  if (preserveWhitespace != null)
    return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0);
  return type && type.whitespace == "pre" ? OPT_PRESERVE_WS | OPT_PRESERVE_WS_FULL : base2 & ~OPT_OPEN_LEFT;
}
var NodeContext = class {
  constructor(type, attrs, marks, solid, match, options) {
    this.type = type;
    this.attrs = attrs;
    this.marks = marks;
    this.solid = solid;
    this.options = options;
    this.content = [];
    this.activeMarks = Mark.none;
    this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  }
  findWrapping(node) {
    if (!this.match) {
      if (!this.type)
        return [];
      let fill = this.type.contentMatch.fillBefore(Fragment6.from(node));
      if (fill) {
        this.match = this.type.contentMatch.matchFragment(fill);
      } else {
        let start2 = this.type.contentMatch, wrap2;
        if (wrap2 = start2.findWrapping(node.type)) {
          this.match = start2;
          return wrap2;
        } else {
          return null;
        }
      }
    }
    return this.match.findWrapping(node.type);
  }
  finish(openEnd) {
    if (!(this.options & OPT_PRESERVE_WS)) {
      let last = this.content[this.content.length - 1], m;
      if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
        let text = last;
        if (last.text.length == m[0].length)
          this.content.pop();
        else
          this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
      }
    }
    let content = Fragment6.from(this.content);
    if (!openEnd && this.match)
      content = content.append(this.match.fillBefore(Fragment6.empty, true));
    return this.type ? this.type.create(this.attrs, content, this.marks) : content;
  }
  inlineContext(node) {
    if (this.type)
      return this.type.inlineContent;
    if (this.content.length)
      return this.content[0].isInline;
    return node.parentNode && !blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
  }
};
var ParseContext = class {
  constructor(parser, options, isOpen) {
    this.parser = parser;
    this.options = options;
    this.isOpen = isOpen;
    this.open = 0;
    this.localPreserveWS = false;
    let topNode = options.topNode, topContext;
    let topOptions = wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? OPT_OPEN_LEFT : 0);
    if (topNode)
      topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
    else if (isOpen)
      topContext = new NodeContext(null, null, Mark.none, true, null, topOptions);
    else
      topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions);
    this.nodes = [topContext];
    this.find = options.findPositions;
    this.needsBlock = false;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(dom, marks) {
    if (dom.nodeType == 3)
      this.addTextNode(dom, marks);
    else if (dom.nodeType == 1)
      this.addElement(dom, marks);
  }
  addTextNode(dom, marks) {
    let value = dom.nodeValue;
    let top2 = this.top, preserveWS = top2.options & OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top2.options & OPT_PRESERVE_WS) > 0;
    let { schema } = this.parser;
    if (preserveWS === "full" || top2.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
      if (!preserveWS) {
        value = value.replace(/[ \t\r\n\u000c]+/g, " ");
        if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
          let nodeBefore = top2.content[top2.content.length - 1];
          let domNodeBefore = dom.previousSibling;
          if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text))
            value = value.slice(1);
        }
      } else if (preserveWS === "full") {
        value = value.replace(/\r\n?/g, "\n");
      } else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
        let lines = value.split(/\r?\n|\r/);
        for (let i = 0; i < lines.length; i++) {
          if (i)
            this.insertNode(schema.linebreakReplacement.create(), marks, true);
          if (lines[i])
            this.insertNode(schema.text(lines[i]), marks, !/\S/.test(lines[i]));
        }
        value = "";
      } else {
        value = value.replace(/\r?\n|\r/g, " ");
      }
      if (value)
        this.insertNode(schema.text(value), marks, !/\S/.test(value));
      this.findInText(dom);
    } else {
      this.findInside(dom);
    }
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(dom, marks, matchAfter) {
    let outerWS = this.localPreserveWS, top2 = this.top;
    if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace))
      this.localPreserveWS = true;
    let name = dom.nodeName.toLowerCase(), ruleID;
    if (listTags.hasOwnProperty(name) && this.parser.normalizeLists)
      normalizeList(dom);
    let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
    out: if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
      this.findInside(dom);
      this.ignoreFallback(dom, marks);
    } else if (!rule || rule.skip || rule.closeParent) {
      if (rule && rule.closeParent)
        this.open = Math.max(0, this.open - 1);
      else if (rule && rule.skip.nodeType)
        dom = rule.skip;
      let sync, oldNeedsBlock = this.needsBlock;
      if (blockTags.hasOwnProperty(name)) {
        if (top2.content.length && top2.content[0].isInline && this.open) {
          this.open--;
          top2 = this.top;
        }
        sync = true;
        if (!top2.type)
          this.needsBlock = true;
      } else if (!dom.firstChild) {
        this.leafFallback(dom, marks);
        break out;
      }
      let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
      if (innerMarks)
        this.addAll(dom, innerMarks);
      if (sync)
        this.sync(top2);
      this.needsBlock = oldNeedsBlock;
    } else {
      let innerMarks = this.readStyles(dom, marks);
      if (innerMarks)
        this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : void 0);
    }
    this.localPreserveWS = outerWS;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(dom, marks) {
    if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent)
      this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
  }
  // Called for ignored nodes
  ignoreFallback(dom, marks) {
    if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent))
      this.findPlace(this.parser.schema.text("-"), marks, true);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(dom, marks) {
    let styles = dom.style;
    if (styles && styles.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
        if (value)
          for (let after = void 0; ; ) {
            let rule = this.parser.matchStyle(name, value, this, after);
            if (!rule)
              break;
            if (rule.ignore)
              return null;
            if (rule.clearMark)
              marks = marks.filter((m) => !rule.clearMark(m));
            else
              marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
            if (rule.consuming === false)
              after = rule;
            else
              break;
          }
      }
    return marks;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(dom, rule, marks, continueAfter) {
    let sync, nodeType;
    if (rule.node) {
      nodeType = this.parser.schema.nodes[rule.node];
      if (!nodeType.isLeaf) {
        let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
        if (inner) {
          sync = true;
          marks = inner;
        }
      } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) {
        this.leafFallback(dom, marks);
      }
    } else {
      let markType = this.parser.schema.marks[rule.mark];
      marks = marks.concat(markType.create(rule.attrs));
    }
    let startIn = this.top;
    if (nodeType && nodeType.isLeaf) {
      this.findInside(dom);
    } else if (continueAfter) {
      this.addElement(dom, marks, continueAfter);
    } else if (rule.getContent) {
      this.findInside(dom);
      rule.getContent(dom, this.parser.schema).forEach((node) => this.insertNode(node, marks, false));
    } else {
      let contentDOM = dom;
      if (typeof rule.contentElement == "string")
        contentDOM = dom.querySelector(rule.contentElement);
      else if (typeof rule.contentElement == "function")
        contentDOM = rule.contentElement(dom);
      else if (rule.contentElement)
        contentDOM = rule.contentElement;
      this.findAround(dom, contentDOM, true);
      this.addAll(contentDOM, marks);
      this.findAround(dom, contentDOM, false);
    }
    if (sync && this.sync(startIn))
      this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(parent, marks, startIndex, endIndex) {
    let index2 = startIndex || 0;
    for (let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end2 = endIndex == null ? null : parent.childNodes[endIndex]; dom != end2; dom = dom.nextSibling, ++index2) {
      this.findAtPoint(parent, index2);
      this.addDOM(dom, marks);
    }
    this.findAtPoint(parent, index2);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(node, marks, cautious) {
    let route, sync;
    for (let depth = this.open, penalty = 0; depth >= 0; depth--) {
      let cx2 = this.nodes[depth];
      let found2 = cx2.findWrapping(node);
      if (found2 && (!route || route.length > found2.length + penalty)) {
        route = found2;
        sync = cx2;
        if (!found2.length)
          break;
      }
      if (cx2.solid) {
        if (cautious)
          break;
        penalty += 2;
      }
    }
    if (!route)
      return null;
    this.sync(sync);
    for (let i = 0; i < route.length; i++)
      marks = this.enterInner(route[i], null, marks, false);
    return marks;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(node, marks, cautious) {
    if (node.isInline && this.needsBlock && !this.top.type) {
      let block = this.textblockFromContext();
      if (block)
        marks = this.enterInner(block, null, marks);
    }
    let innerMarks = this.findPlace(node, marks, cautious);
    if (innerMarks) {
      this.closeExtra();
      let top2 = this.top;
      if (top2.match)
        top2.match = top2.match.matchType(node.type);
      let nodeMarks = Mark.none;
      for (let m of innerMarks.concat(node.marks))
        if (top2.type ? top2.type.allowsMarkType(m.type) : markMayApply(m.type, node.type))
          nodeMarks = m.addToSet(nodeMarks);
      top2.content.push(node.mark(nodeMarks));
      return true;
    }
    return false;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(type, attrs, marks, preserveWS) {
    let innerMarks = this.findPlace(type.create(attrs), marks, false);
    if (innerMarks)
      innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
    return innerMarks;
  }
  // Open a node of the given type
  enterInner(type, attrs, marks, solid = false, preserveWS) {
    this.closeExtra();
    let top2 = this.top;
    top2.match = top2.match && top2.match.matchType(type);
    let options = wsOptionsFor(type, preserveWS, top2.options);
    if (top2.options & OPT_OPEN_LEFT && top2.content.length == 0)
      options |= OPT_OPEN_LEFT;
    let applyMarks = Mark.none;
    marks = marks.filter((m) => {
      if (top2.type ? top2.type.allowsMarkType(m.type) : markMayApply(m.type, type)) {
        applyMarks = m.addToSet(applyMarks);
        return false;
      }
      return true;
    });
    this.nodes.push(new NodeContext(type, attrs, applyMarks, solid, null, options));
    this.open++;
    return marks;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(openEnd = false) {
    let i = this.nodes.length - 1;
    if (i > this.open) {
      for (; i > this.open; i--)
        this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    this.open = 0;
    this.closeExtra(this.isOpen);
    return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(to) {
    for (let i = this.open; i >= 0; i--) {
      if (this.nodes[i] == to) {
        this.open = i;
        return true;
      } else if (this.localPreserveWS) {
        this.nodes[i].options |= OPT_PRESERVE_WS;
      }
    }
    return false;
  }
  get currentPos() {
    this.closeExtra();
    let pos = 0;
    for (let i = this.open; i >= 0; i--) {
      let content = this.nodes[i].content;
      for (let j = content.length - 1; j >= 0; j--)
        pos += content[j].nodeSize;
      if (i)
        pos++;
    }
    return pos;
  }
  findAtPoint(parent, offset5) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++) {
        if (this.find[i].node == parent && this.find[i].offset == offset5)
          this.find[i].pos = this.currentPos;
      }
  }
  findInside(parent) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++) {
        if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node))
          this.find[i].pos = this.currentPos;
      }
  }
  findAround(parent, content, before) {
    if (parent != content && this.find)
      for (let i = 0; i < this.find.length; i++) {
        if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
          let pos = content.compareDocumentPosition(this.find[i].node);
          if (pos & (before ? 2 : 4))
            this.find[i].pos = this.currentPos;
        }
      }
  }
  findInText(textNode) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++) {
        if (this.find[i].node == textNode)
          this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
      }
  }
  // Determines whether the given context string matches this context.
  matchesContext(context) {
    if (context.indexOf("|") > -1)
      return context.split(/\s*\|\s*/).some(this.matchesContext, this);
    let parts = context.split("/");
    let option = this.options.context;
    let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
    let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
    let match = (i, depth) => {
      for (; i >= 0; i--) {
        let part = parts[i];
        if (part == "") {
          if (i == parts.length - 1 || i == 0)
            continue;
          for (; depth >= minDepth; depth--)
            if (match(i - 1, depth))
              return true;
          return false;
        } else {
          let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
          if (!next || next.name != part && !next.isInGroup(part))
            return false;
          depth--;
        }
      }
      return true;
    };
    return match(parts.length - 1, this.open);
  }
  textblockFromContext() {
    let $context = this.options.context;
    if ($context)
      for (let d = $context.depth; d >= 0; d--) {
        let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
        if (deflt && deflt.isTextblock && deflt.defaultAttrs)
          return deflt;
      }
    for (let name in this.parser.schema.nodes) {
      let type = this.parser.schema.nodes[name];
      if (type.isTextblock && type.defaultAttrs)
        return type;
    }
  }
};
function normalizeList(dom) {
  for (let child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name && listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name == "li") {
      prevItem = child;
    } else if (name) {
      prevItem = null;
    }
  }
}
function matches(dom, selector) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function copy(obj) {
  let copy2 = {};
  for (let prop in obj)
    copy2[prop] = obj[prop];
  return copy2;
}
function markMayApply(markType, nodeType) {
  let nodes = nodeType.schema.nodes;
  for (let name in nodes) {
    let parent = nodes[name];
    if (!parent.allowsMarkType(markType))
      continue;
    let seen = [], scan = (match) => {
      seen.push(match);
      for (let i = 0; i < match.edgeCount; i++) {
        let { type, next } = match.edge(i);
        if (type == nodeType)
          return true;
        if (seen.indexOf(next) < 0 && scan(next))
          return true;
      }
    };
    if (scan(parent.contentMatch))
      return true;
  }
}
var DOMSerializer = class _DOMSerializer {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(nodes, marks) {
    this.nodes = nodes;
    this.marks = marks;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(fragment, options = {}, target) {
    if (!target)
      target = doc(options).createDocumentFragment();
    let top2 = target, active = [];
    fragment.forEach((node) => {
      if (active.length || node.marks.length) {
        let keep = 0, rendered = 0;
        while (keep < active.length && rendered < node.marks.length) {
          let next = node.marks[rendered];
          if (!this.marks[next.type.name]) {
            rendered++;
            continue;
          }
          if (!next.eq(active[keep][0]) || next.type.spec.spanning === false)
            break;
          keep++;
          rendered++;
        }
        while (keep < active.length)
          top2 = active.pop()[1];
        while (rendered < node.marks.length) {
          let add = node.marks[rendered++];
          let markDOM = this.serializeMark(add, node.isInline, options);
          if (markDOM) {
            active.push([add, top2]);
            top2.appendChild(markDOM.dom);
            top2 = markDOM.contentDOM || markDOM.dom;
          }
        }
      }
      top2.appendChild(this.serializeNodeInner(node, options));
    });
    return target;
  }
  /**
  @internal
  */
  serializeNodeInner(node, options) {
    let { dom, contentDOM } = renderSpec(doc(options), this.nodes[node.type.name](node), null, node.attrs);
    if (contentDOM) {
      if (node.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(node.content, options, contentDOM);
    }
    return dom;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(node, options = {}) {
    let dom = this.serializeNodeInner(node, options);
    for (let i = node.marks.length - 1; i >= 0; i--) {
      let wrap2 = this.serializeMark(node.marks[i], node.isInline, options);
      if (wrap2) {
        (wrap2.contentDOM || wrap2.dom).appendChild(dom);
        dom = wrap2.dom;
      }
    }
    return dom;
  }
  /**
  @internal
  */
  serializeMark(mark, inline3, options = {}) {
    let toDOM = this.marks[mark.type.name];
    return toDOM && renderSpec(doc(options), toDOM(mark, inline3), null, mark.attrs);
  }
  static renderSpec(doc3, structure, xmlNS = null, blockArraysIn) {
    return renderSpec(doc3, structure, xmlNS, blockArraysIn);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(schema) {
    return schema.cached.domSerializer || (schema.cached.domSerializer = new _DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(schema) {
    let result = gatherToDOM(schema.nodes);
    if (!result.text)
      result.text = (node) => node.text;
    return result;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(schema) {
    return gatherToDOM(schema.marks);
  }
};
function gatherToDOM(obj) {
  let result = {};
  for (let name in obj) {
    let toDOM = obj[name].spec.toDOM;
    if (toDOM)
      result[name] = toDOM;
  }
  return result;
}
function doc(options) {
  return options.document || window.document;
}
var suspiciousAttributeCache = /* @__PURE__ */ new WeakMap();
function suspiciousAttributes(attrs) {
  let value = suspiciousAttributeCache.get(attrs);
  if (value === void 0)
    suspiciousAttributeCache.set(attrs, value = suspiciousAttributesInner(attrs));
  return value;
}
function suspiciousAttributesInner(attrs) {
  let result = null;
  function scan(value) {
    if (value && typeof value == "object") {
      if (Array.isArray(value)) {
        if (typeof value[0] == "string") {
          if (!result)
            result = [];
          result.push(value);
        } else {
          for (let i = 0; i < value.length; i++)
            scan(value[i]);
        }
      } else {
        for (let prop in value)
          scan(value[prop]);
      }
    }
  }
  scan(attrs);
  return result;
}
function renderSpec(doc3, structure, xmlNS, blockArraysIn) {
  if (typeof structure == "string")
    return { dom: doc3.createTextNode(structure) };
  if (structure.nodeType != null)
    return { dom: structure };
  if (structure.dom && structure.dom.nodeType != null)
    return structure;
  let tagName = structure[0], suspicious;
  if (typeof tagName != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (blockArraysIn && (suspicious = suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let space = tagName.indexOf(" ");
  if (space > 0) {
    xmlNS = tagName.slice(0, space);
    tagName = tagName.slice(space + 1);
  }
  let contentDOM;
  let dom = xmlNS ? doc3.createElementNS(xmlNS, tagName) : doc3.createElement(tagName);
  let attrs = structure[1], start2 = 1;
  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start2 = 2;
    for (let name in attrs)
      if (attrs[name] != null) {
        let space2 = name.indexOf(" ");
        if (space2 > 0)
          dom.setAttributeNS(name.slice(0, space2), name.slice(space2 + 1), attrs[name]);
        else if (name == "style" && dom.style)
          dom.style.cssText = attrs[name];
        else
          dom.setAttribute(name, attrs[name]);
      }
  }
  for (let i = start2; i < structure.length; i++) {
    let child = structure[i];
    if (child === 0) {
      if (i < structure.length - 1 || i > start2)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom, contentDOM: dom };
    } else {
      let { dom: inner, contentDOM: innerContent } = renderSpec(doc3, child, xmlNS, blockArraysIn);
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM)
          throw new RangeError("Multiple content holes");
        contentDOM = innerContent;
      }
    }
  }
  return { dom, contentDOM };
}

// ../../node_modules/.pnpm/prosemirror-transform@1.10.5/node_modules/prosemirror-transform/dist/index.js
var lower16 = 65535;
var factor16 = Math.pow(2, 16);
function makeRecover(index2, offset5) {
  return index2 + offset5 * factor16;
}
function recoverIndex(value) {
  return value & lower16;
}
function recoverOffset(value) {
  return (value - (value & lower16)) / factor16;
}
var DEL_BEFORE = 1;
var DEL_AFTER = 2;
var DEL_ACROSS = 4;
var DEL_SIDE = 8;
var MapResult = class {
  /**
  @internal
  */
  constructor(pos, delInfo, recover) {
    this.pos = pos;
    this.delInfo = delInfo;
    this.recover = recover;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & DEL_SIDE) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (DEL_BEFORE | DEL_ACROSS)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (DEL_AFTER | DEL_ACROSS)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & DEL_ACROSS) > 0;
  }
};
var StepMap = class _StepMap {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(ranges, inverted = false) {
    this.ranges = ranges;
    this.inverted = inverted;
    if (!ranges.length && _StepMap.empty)
      return _StepMap.empty;
  }
  /**
  @internal
  */
  recover(value) {
    let diff = 0, index2 = recoverIndex(value);
    if (!this.inverted)
      for (let i = 0; i < index2; i++)
        diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[index2 * 3] + diff + recoverOffset(value);
  }
  mapResult(pos, assoc = 1) {
    return this._map(pos, assoc, false);
  }
  map(pos, assoc = 1) {
    return this._map(pos, assoc, true);
  }
  /**
  @internal
  */
  _map(pos, assoc, simple) {
    let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let start2 = this.ranges[i] - (this.inverted ? diff : 0);
      if (start2 > pos)
        break;
      let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end2 = start2 + oldSize;
      if (pos <= end2) {
        let side = !oldSize ? assoc : pos == start2 ? -1 : pos == end2 ? 1 : assoc;
        let result = start2 + diff + (side < 0 ? 0 : newSize);
        if (simple)
          return result;
        let recover = pos == (assoc < 0 ? start2 : end2) ? null : makeRecover(i / 3, pos - start2);
        let del2 = pos == start2 ? DEL_AFTER : pos == end2 ? DEL_BEFORE : DEL_ACROSS;
        if (assoc < 0 ? pos != start2 : pos != end2)
          del2 |= DEL_SIDE;
        return new MapResult(result, del2, recover);
      }
      diff += newSize - oldSize;
    }
    return simple ? pos + diff : new MapResult(pos + diff, 0, null);
  }
  /**
  @internal
  */
  touches(pos, recover) {
    let diff = 0, index2 = recoverIndex(recover);
    let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let start2 = this.ranges[i] - (this.inverted ? diff : 0);
      if (start2 > pos)
        break;
      let oldSize = this.ranges[i + oldIndex], end2 = start2 + oldSize;
      if (pos <= end2 && i == index2 * 3)
        return true;
      diff += this.ranges[i + newIndex] - oldSize;
    }
    return false;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(f) {
    let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
    for (let i = 0, diff = 0; i < this.ranges.length; i += 3) {
      let start2 = this.ranges[i], oldStart = start2 - (this.inverted ? diff : 0), newStart = start2 + (this.inverted ? 0 : diff);
      let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
      f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
      diff += newSize - oldSize;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new _StepMap(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(n) {
    return n == 0 ? _StepMap.empty : new _StepMap(n < 0 ? [0, -n, 0] : [0, 0, n]);
  }
};
StepMap.empty = new StepMap([]);
var Mapping = class _Mapping {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(maps, mirror, from2 = 0, to = maps ? maps.length : 0) {
    this.mirror = mirror;
    this.from = from2;
    this.to = to;
    this._maps = maps || [];
    this.ownData = !(maps || mirror);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(from2 = 0, to = this.maps.length) {
    return new _Mapping(this._maps, this.mirror, from2, to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(map2, mirrors) {
    if (!this.ownData) {
      this._maps = this._maps.slice();
      this.mirror = this.mirror && this.mirror.slice();
      this.ownData = true;
    }
    this.to = this._maps.push(map2);
    if (mirrors != null)
      this.setMirror(this._maps.length - 1, mirrors);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(mapping) {
    for (let i = 0, startSize = this._maps.length; i < mapping._maps.length; i++) {
      let mirr = mapping.getMirror(i);
      this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(n) {
    if (this.mirror) {
      for (let i = 0; i < this.mirror.length; i++)
        if (this.mirror[i] == n)
          return this.mirror[i + (i % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(n, m) {
    if (!this.mirror)
      this.mirror = [];
    this.mirror.push(n, m);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(mapping) {
    for (let i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--) {
      let mirr = mapping.getMirror(i);
      this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let inverse = new _Mapping();
    inverse.appendMappingInverted(this);
    return inverse;
  }
  /**
  Map a position through this mapping.
  */
  map(pos, assoc = 1) {
    if (this.mirror)
      return this._map(pos, assoc, true);
    for (let i = this.from; i < this.to; i++)
      pos = this._maps[i].map(pos, assoc);
    return pos;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(pos, assoc = 1) {
    return this._map(pos, assoc, false);
  }
  /**
  @internal
  */
  _map(pos, assoc, simple) {
    let delInfo = 0;
    for (let i = this.from; i < this.to; i++) {
      let map2 = this._maps[i], result = map2.mapResult(pos, assoc);
      if (result.recover != null) {
        let corr = this.getMirror(i);
        if (corr != null && corr > i && corr < this.to) {
          i = corr;
          pos = this._maps[corr].recover(result.recover);
          continue;
        }
      }
      delInfo |= result.delInfo;
      pos = result.pos;
    }
    return simple ? pos : new MapResult(pos, delInfo, null);
  }
};
var stepsByID = /* @__PURE__ */ Object.create(null);
var Step = class {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return StepMap.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(other) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(schema, json) {
    if (!json || !json.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let type = stepsByID[json.stepType];
    if (!type)
      throw new RangeError(`No step type ${json.stepType} defined`);
    return type.fromJSON(schema, json);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(id, stepClass) {
    if (id in stepsByID)
      throw new RangeError("Duplicate use of step JSON ID " + id);
    stepsByID[id] = stepClass;
    stepClass.prototype.jsonID = id;
    return stepClass;
  }
};
var StepResult = class _StepResult {
  /**
  @internal
  */
  constructor(doc3, failed) {
    this.doc = doc3;
    this.failed = failed;
  }
  /**
  Create a successful step result.
  */
  static ok(doc3) {
    return new _StepResult(doc3, null);
  }
  /**
  Create a failed step result.
  */
  static fail(message) {
    return new _StepResult(null, message);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(doc3, from2, to, slice2) {
    try {
      return _StepResult.ok(doc3.replace(from2, to, slice2));
    } catch (e) {
      if (e instanceof ReplaceError)
        return _StepResult.fail(e.message);
      throw e;
    }
  }
};
function mapFragment(fragment, f, parent) {
  let mapped = [];
  for (let i = 0; i < fragment.childCount; i++) {
    let child = fragment.child(i);
    if (child.content.size)
      child = child.copy(mapFragment(child.content, f, child));
    if (child.isInline)
      child = f(child, parent, i);
    mapped.push(child);
  }
  return Fragment6.fromArray(mapped);
}
var AddMarkStep = class _AddMarkStep extends Step {
  /**
  Create a mark step.
  */
  constructor(from2, to, mark) {
    super();
    this.from = from2;
    this.to = to;
    this.mark = mark;
  }
  apply(doc3) {
    let oldSlice = doc3.slice(this.from, this.to), $from = doc3.resolve(this.from);
    let parent = $from.node($from.sharedDepth(this.to));
    let slice2 = new Slice(mapFragment(oldSlice.content, (node, parent2) => {
      if (!node.isAtom || !parent2.type.allowsMarkType(this.mark.type))
        return node;
      return node.mark(this.mark.addToSet(node.marks));
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc3, this.from, this.to, slice2);
  }
  invert() {
    return new RemoveMarkStep(this.from, this.to, this.mark);
  }
  map(mapping) {
    let from2 = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from2.deleted && to.deleted || from2.pos >= to.pos)
      return null;
    return new _AddMarkStep(from2.pos, to.pos, this.mark);
  }
  merge(other) {
    if (other instanceof _AddMarkStep && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from)
      return new _AddMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
    return null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new _AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
  }
};
Step.jsonID("addMark", AddMarkStep);
var RemoveMarkStep = class _RemoveMarkStep extends Step {
  /**
  Create a mark-removing step.
  */
  constructor(from2, to, mark) {
    super();
    this.from = from2;
    this.to = to;
    this.mark = mark;
  }
  apply(doc3) {
    let oldSlice = doc3.slice(this.from, this.to);
    let slice2 = new Slice(mapFragment(oldSlice.content, (node) => {
      return node.mark(this.mark.removeFromSet(node.marks));
    }, doc3), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc3, this.from, this.to, slice2);
  }
  invert() {
    return new AddMarkStep(this.from, this.to, this.mark);
  }
  map(mapping) {
    let from2 = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from2.deleted && to.deleted || from2.pos >= to.pos)
      return null;
    return new _RemoveMarkStep(from2.pos, to.pos, this.mark);
  }
  merge(other) {
    if (other instanceof _RemoveMarkStep && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from)
      return new _RemoveMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
    return null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new _RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
  }
};
Step.jsonID("removeMark", RemoveMarkStep);
var AddNodeMarkStep = class _AddNodeMarkStep extends Step {
  /**
  Create a node mark step.
  */
  constructor(pos, mark) {
    super();
    this.pos = pos;
    this.mark = mark;
  }
  apply(doc3) {
    let node = doc3.nodeAt(this.pos);
    if (!node)
      return StepResult.fail("No node at mark step's position");
    let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
    return StepResult.fromReplace(doc3, this.pos, this.pos + 1, new Slice(Fragment6.from(updated), 0, node.isLeaf ? 0 : 1));
  }
  invert(doc3) {
    let node = doc3.nodeAt(this.pos);
    if (node) {
      let newSet = this.mark.addToSet(node.marks);
      if (newSet.length == node.marks.length) {
        for (let i = 0; i < node.marks.length; i++)
          if (!node.marks[i].isInSet(newSet))
            return new _AddNodeMarkStep(this.pos, node.marks[i]);
        return new _AddNodeMarkStep(this.pos, this.mark);
      }
    }
    return new RemoveNodeMarkStep(this.pos, this.mark);
  }
  map(mapping) {
    let pos = mapping.mapResult(this.pos, 1);
    return pos.deletedAfter ? null : new _AddNodeMarkStep(pos.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new _AddNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
  }
};
Step.jsonID("addNodeMark", AddNodeMarkStep);
var RemoveNodeMarkStep = class _RemoveNodeMarkStep extends Step {
  /**
  Create a mark-removing step.
  */
  constructor(pos, mark) {
    super();
    this.pos = pos;
    this.mark = mark;
  }
  apply(doc3) {
    let node = doc3.nodeAt(this.pos);
    if (!node)
      return StepResult.fail("No node at mark step's position");
    let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
    return StepResult.fromReplace(doc3, this.pos, this.pos + 1, new Slice(Fragment6.from(updated), 0, node.isLeaf ? 0 : 1));
  }
  invert(doc3) {
    let node = doc3.nodeAt(this.pos);
    if (!node || !this.mark.isInSet(node.marks))
      return this;
    return new AddNodeMarkStep(this.pos, this.mark);
  }
  map(mapping) {
    let pos = mapping.mapResult(this.pos, 1);
    return pos.deletedAfter ? null : new _RemoveNodeMarkStep(pos.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new _RemoveNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
  }
};
Step.jsonID("removeNodeMark", RemoveNodeMarkStep);
var ReplaceStep = class _ReplaceStep extends Step {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(from2, to, slice2, structure = false) {
    super();
    this.from = from2;
    this.to = to;
    this.slice = slice2;
    this.structure = structure;
  }
  apply(doc3) {
    if (this.structure && contentBetween(doc3, this.from, this.to))
      return StepResult.fail("Structure replace would overwrite content");
    return StepResult.fromReplace(doc3, this.from, this.to, this.slice);
  }
  getMap() {
    return new StepMap([this.from, this.to - this.from, this.slice.size]);
  }
  invert(doc3) {
    return new _ReplaceStep(this.from, this.from + this.slice.size, doc3.slice(this.from, this.to));
  }
  map(mapping) {
    let from2 = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from2.deletedAcross && to.deletedAcross)
      return null;
    return new _ReplaceStep(from2.pos, Math.max(from2.pos, to.pos), this.slice, this.structure);
  }
  merge(other) {
    if (!(other instanceof _ReplaceStep) || other.structure || this.structure)
      return null;
    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      let slice2 = this.slice.size + other.slice.size == 0 ? Slice.empty : new Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new _ReplaceStep(this.from, this.to + (other.to - other.from), slice2, this.structure);
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      let slice2 = this.slice.size + other.slice.size == 0 ? Slice.empty : new Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new _ReplaceStep(other.from, this.to, slice2, this.structure);
    } else {
      return null;
    }
  }
  toJSON() {
    let json = { stepType: "replace", from: this.from, to: this.to };
    if (this.slice.size)
      json.slice = this.slice.toJSON();
    if (this.structure)
      json.structure = true;
    return json;
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new _ReplaceStep(json.from, json.to, Slice.fromJSON(schema, json.slice), !!json.structure);
  }
};
Step.jsonID("replace", ReplaceStep);
var ReplaceAroundStep = class _ReplaceAroundStep extends Step {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(from2, to, gapFrom, gapTo, slice2, insert, structure = false) {
    super();
    this.from = from2;
    this.to = to;
    this.gapFrom = gapFrom;
    this.gapTo = gapTo;
    this.slice = slice2;
    this.insert = insert;
    this.structure = structure;
  }
  apply(doc3) {
    if (this.structure && (contentBetween(doc3, this.from, this.gapFrom) || contentBetween(doc3, this.gapTo, this.to)))
      return StepResult.fail("Structure gap-replace would overwrite content");
    let gap = doc3.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      return StepResult.fail("Gap is not a flat range");
    let inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted)
      return StepResult.fail("Content does not fit in gap");
    return StepResult.fromReplace(doc3, this.from, this.to, inserted);
  }
  getMap() {
    return new StepMap([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(doc3) {
    let gap = this.gapTo - this.gapFrom;
    return new _ReplaceAroundStep(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc3.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(mapping) {
    let from2 = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    let gapFrom = this.from == this.gapFrom ? from2.pos : mapping.map(this.gapFrom, -1);
    let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
    if (from2.deletedAcross && to.deletedAcross || gapFrom < from2.pos || gapTo > to.pos)
      return null;
    return new _ReplaceAroundStep(from2.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let json = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    if (this.slice.size)
      json.slice = this.slice.toJSON();
    if (this.structure)
      json.structure = true;
    return json;
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new _ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo, Slice.fromJSON(schema, json.slice), json.insert, !!json.structure);
  }
};
Step.jsonID("replaceAround", ReplaceAroundStep);
function contentBetween(doc3, from2, to) {
  let $from = doc3.resolve(from2), dist = to - from2, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    let next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf)
        return true;
      next = next.firstChild;
      dist--;
    }
  }
  return false;
}
function addMark(tr2, from2, to, mark) {
  let removed = [], added = [];
  let removing, adding;
  tr2.doc.nodesBetween(from2, to, (node, pos, parent) => {
    if (!node.isInline)
      return;
    let marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      let start2 = Math.max(pos, from2), end2 = Math.min(pos + node.nodeSize, to);
      let newSet = mark.addToSet(marks);
      for (let i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start2 && removing.mark.eq(marks[i]))
            removing.to = end2;
          else
            removed.push(removing = new RemoveMarkStep(start2, end2, marks[i]));
        }
      }
      if (adding && adding.to == start2)
        adding.to = end2;
      else
        added.push(adding = new AddMarkStep(start2, end2, mark));
    }
  });
  removed.forEach((s) => tr2.step(s));
  added.forEach((s) => tr2.step(s));
}
function removeMark(tr2, from2, to, mark) {
  let matched = [], step = 0;
  tr2.doc.nodesBetween(from2, to, (node, pos) => {
    if (!node.isInline)
      return;
    step++;
    let toRemove = null;
    if (mark instanceof MarkType) {
      let set = node.marks, found2;
      while (found2 = mark.isInSet(set)) {
        (toRemove || (toRemove = [])).push(found2);
        set = found2.removeFromSet(set);
      }
    } else if (mark) {
      if (mark.isInSet(node.marks))
        toRemove = [mark];
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      let end2 = Math.min(pos + node.nodeSize, to);
      for (let i = 0; i < toRemove.length; i++) {
        let style2 = toRemove[i], found2;
        for (let j = 0; j < matched.length; j++) {
          let m = matched[j];
          if (m.step == step - 1 && style2.eq(matched[j].style))
            found2 = m;
        }
        if (found2) {
          found2.to = end2;
          found2.step = step;
        } else {
          matched.push({ style: style2, from: Math.max(pos, from2), to: end2, step });
        }
      }
    }
  });
  matched.forEach((m) => tr2.step(new RemoveMarkStep(m.from, m.to, m.style)));
}
function clearIncompatible(tr2, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
  let node = tr2.doc.nodeAt(pos);
  let replSteps = [], cur = pos + 1;
  for (let i = 0; i < node.childCount; i++) {
    let child = node.child(i), end2 = cur + child.nodeSize;
    let allowed = match.matchType(child.type);
    if (!allowed) {
      replSteps.push(new ReplaceStep(cur, end2, Slice.empty));
    } else {
      match = allowed;
      for (let j = 0; j < child.marks.length; j++)
        if (!parentType.allowsMarkType(child.marks[j].type))
          tr2.step(new RemoveMarkStep(cur, end2, child.marks[j]));
      if (clearNewlines && child.isText && parentType.whitespace != "pre") {
        let m, newline = /\r?\n|\r/g, slice2;
        while (m = newline.exec(child.text)) {
          if (!slice2)
            slice2 = new Slice(Fragment6.from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
          replSteps.push(new ReplaceStep(cur + m.index, cur + m.index + m[0].length, slice2));
        }
      }
    }
    cur = end2;
  }
  if (!match.validEnd) {
    let fill = match.fillBefore(Fragment6.empty, true);
    tr2.replace(cur, cur, new Slice(fill, 0, 0));
  }
  for (let i = replSteps.length - 1; i >= 0; i--)
    tr2.step(replSteps[i]);
}
function canCut(node, start2, end2) {
  return (start2 == 0 || node.canReplace(start2, node.childCount)) && (end2 == node.childCount || node.canReplace(0, end2));
}
function liftTarget(range) {
  let parent = range.parent;
  let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
  for (let depth = range.depth, contentBefore = 0, contentAfter = 0; ; --depth) {
    let node = range.$from.node(depth);
    let index2 = range.$from.index(depth) + contentBefore, endIndex = range.$to.indexAfter(depth) - contentAfter;
    if (depth < range.depth && node.canReplace(index2, endIndex, content))
      return depth;
    if (depth == 0 || node.type.spec.isolating || !canCut(node, index2, endIndex))
      break;
    if (index2)
      contentBefore = 1;
    if (endIndex < node.childCount)
      contentAfter = 1;
  }
  return null;
}
function lift(tr2, range, target) {
  let { $from, $to, depth } = range;
  let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  let start2 = gapStart, end2 = gapEnd;
  let before = Fragment6.empty, openStart = 0;
  for (let d = depth, splitting = false; d > target; d--)
    if (splitting || $from.index(d) > 0) {
      splitting = true;
      before = Fragment6.from($from.node(d).copy(before));
      openStart++;
    } else {
      start2--;
    }
  let after = Fragment6.empty, openEnd = 0;
  for (let d = depth, splitting = false; d > target; d--)
    if (splitting || $to.after(d + 1) < $to.end(d)) {
      splitting = true;
      after = Fragment6.from($to.node(d).copy(after));
      openEnd++;
    } else {
      end2++;
    }
  tr2.step(new ReplaceAroundStep(start2, end2, gapStart, gapEnd, new Slice(before.append(after), openStart, openEnd), before.size - openStart, true));
}
function findWrapping(range, nodeType, attrs = null, innerRange = range) {
  let around = findWrappingOutside(range, nodeType);
  let inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner)
    return null;
  return around.map(withAttrs).concat({ type: nodeType, attrs }).concat(inner.map(withAttrs));
}
function withAttrs(type) {
  return { type, attrs: null };
}
function findWrappingOutside(range, type) {
  let { parent, startIndex, endIndex } = range;
  let around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around)
    return null;
  let outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function findWrappingInside(range, type) {
  let { parent, startIndex, endIndex } = range;
  let inner = parent.child(startIndex);
  let inside = type.contentMatch.findWrapping(inner.type);
  if (!inside)
    return null;
  let lastType = inside.length ? inside[inside.length - 1] : type;
  let innerMatch = lastType.contentMatch;
  for (let i = startIndex; innerMatch && i < endIndex; i++)
    innerMatch = innerMatch.matchType(parent.child(i).type);
  if (!innerMatch || !innerMatch.validEnd)
    return null;
  return inside;
}
function wrap(tr2, range, wrappers) {
  let content = Fragment6.empty;
  for (let i = wrappers.length - 1; i >= 0; i--) {
    if (content.size) {
      let match = wrappers[i].type.contentMatch.matchFragment(content);
      if (!match || !match.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    content = Fragment6.from(wrappers[i].type.create(wrappers[i].attrs, content));
  }
  let start2 = range.start, end2 = range.end;
  tr2.step(new ReplaceAroundStep(start2, end2, start2, end2, new Slice(content, 0, 0), wrappers.length, true));
}
function setBlockType(tr2, from2, to, type, attrs) {
  if (!type.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let mapFrom = tr2.steps.length;
  tr2.doc.nodesBetween(from2, to, (node, pos) => {
    let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
    if (node.isTextblock && !node.hasMarkup(type, attrsHere) && canChangeType(tr2.doc, tr2.mapping.slice(mapFrom).map(pos), type)) {
      let convertNewlines = null;
      if (type.schema.linebreakReplacement) {
        let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
        if (pre && !supportLinebreak)
          convertNewlines = false;
        else if (!pre && supportLinebreak)
          convertNewlines = true;
      }
      if (convertNewlines === false)
        replaceLinebreaks(tr2, node, pos, mapFrom);
      clearIncompatible(tr2, tr2.mapping.slice(mapFrom).map(pos, 1), type, void 0, convertNewlines === null);
      let mapping = tr2.mapping.slice(mapFrom);
      let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
      tr2.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1, new Slice(Fragment6.from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
      if (convertNewlines === true)
        replaceNewlines(tr2, node, pos, mapFrom);
      return false;
    }
  });
}
function replaceNewlines(tr2, node, pos, mapFrom) {
  node.forEach((child, offset5) => {
    if (child.isText) {
      let m, newline = /\r?\n|\r/g;
      while (m = newline.exec(child.text)) {
        let start2 = tr2.mapping.slice(mapFrom).map(pos + 1 + offset5 + m.index);
        tr2.replaceWith(start2, start2 + 1, node.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function replaceLinebreaks(tr2, node, pos, mapFrom) {
  node.forEach((child, offset5) => {
    if (child.type == child.type.schema.linebreakReplacement) {
      let start2 = tr2.mapping.slice(mapFrom).map(pos + 1 + offset5);
      tr2.replaceWith(start2, start2 + 1, node.type.schema.text("\n"));
    }
  });
}
function canChangeType(doc3, pos, type) {
  let $pos = doc3.resolve(pos), index2 = $pos.index();
  return $pos.parent.canReplaceWith(index2, index2 + 1, type);
}
function setNodeMarkup(tr2, pos, type, attrs, marks) {
  let node = tr2.doc.nodeAt(pos);
  if (!node)
    throw new RangeError("No node at given position");
  if (!type)
    type = node.type;
  let newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf)
    return tr2.replaceWith(pos, pos + node.nodeSize, newNode);
  if (!type.validContent(node.content))
    throw new RangeError("Invalid content for node type " + type.name);
  tr2.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new Slice(Fragment6.from(newNode), 0, 0), 1, true));
}
function canSplit(doc3, pos, depth = 1, typesAfter) {
  let $pos = doc3.resolve(pos), base2 = $pos.depth - depth;
  let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
  if (base2 < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
    return false;
  for (let d = $pos.depth - 1, i = depth - 2; d > base2; d--, i--) {
    let node = $pos.node(d), index3 = $pos.index(d);
    if (node.type.spec.isolating)
      return false;
    let rest = node.content.cutByIndex(index3, node.childCount);
    let overrideChild = typesAfter && typesAfter[i + 1];
    if (overrideChild)
      rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
    let after = typesAfter && typesAfter[i] || node;
    if (!node.canReplace(index3 + 1, node.childCount) || !after.type.validContent(rest))
      return false;
  }
  let index2 = $pos.indexAfter(base2);
  let baseType = typesAfter && typesAfter[0];
  return $pos.node(base2).canReplaceWith(index2, index2, baseType ? baseType.type : $pos.node(base2 + 1).type);
}
function split(tr2, pos, depth = 1, typesAfter) {
  let $pos = tr2.doc.resolve(pos), before = Fragment6.empty, after = Fragment6.empty;
  for (let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = Fragment6.from($pos.node(d).copy(before));
    let typeAfter = typesAfter && typesAfter[i];
    after = Fragment6.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  tr2.step(new ReplaceStep(pos, pos, new Slice(before.append(after), depth, depth), true));
}
function canJoin(doc3, pos) {
  let $pos = doc3.resolve(pos), index2 = $pos.index();
  return joinable2($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index2, index2 + 1);
}
function canAppendWithSubstitutedLinebreaks(a, b) {
  if (!b.content.size)
    a.type.compatibleContent(b.type);
  let match = a.contentMatchAt(a.childCount);
  let { linebreakReplacement } = a.type.schema;
  for (let i = 0; i < b.childCount; i++) {
    let child = b.child(i);
    let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
    match = match.matchType(type);
    if (!match)
      return false;
    if (!a.type.allowsMarks(child.marks))
      return false;
  }
  return match.validEnd;
}
function joinable2(a, b) {
  return !!(a && b && !a.isLeaf && canAppendWithSubstitutedLinebreaks(a, b));
}
function joinPoint(doc3, pos, dir = -1) {
  let $pos = doc3.resolve(pos);
  for (let d = $pos.depth; ; d--) {
    let before, after, index2 = $pos.index(d);
    if (d == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d + 1);
      index2++;
      after = $pos.node(d).maybeChild(index2);
    } else {
      before = $pos.node(d).maybeChild(index2 - 1);
      after = $pos.node(d + 1);
    }
    if (before && !before.isTextblock && joinable2(before, after) && $pos.node(d).canReplace(index2, index2 + 1))
      return pos;
    if (d == 0)
      break;
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}
function join(tr2, pos, depth) {
  let convertNewlines = null;
  let { linebreakReplacement } = tr2.doc.type.schema;
  let $before = tr2.doc.resolve(pos - depth), beforeType = $before.node().type;
  if (linebreakReplacement && beforeType.inlineContent) {
    let pre = beforeType.whitespace == "pre";
    let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
    if (pre && !supportLinebreak)
      convertNewlines = false;
    else if (!pre && supportLinebreak)
      convertNewlines = true;
  }
  let mapFrom = tr2.steps.length;
  if (convertNewlines === false) {
    let $after = tr2.doc.resolve(pos + depth);
    replaceLinebreaks(tr2, $after.node(), $after.before(), mapFrom);
  }
  if (beforeType.inlineContent)
    clearIncompatible(tr2, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
  let mapping = tr2.mapping.slice(mapFrom), start2 = mapping.map(pos - depth);
  tr2.step(new ReplaceStep(start2, mapping.map(pos + depth, -1), Slice.empty, true));
  if (convertNewlines === true) {
    let $full = tr2.doc.resolve(start2);
    replaceNewlines(tr2, $full.node(), $full.before(), tr2.steps.length);
  }
  return tr2;
}
function insertPoint(doc3, pos, nodeType) {
  let $pos = doc3.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType))
    return pos;
  if ($pos.parentOffset == 0)
    for (let d = $pos.depth - 1; d >= 0; d--) {
      let index2 = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index2, index2, nodeType))
        return $pos.before(d + 1);
      if (index2 > 0)
        return null;
    }
  if ($pos.parentOffset == $pos.parent.content.size)
    for (let d = $pos.depth - 1; d >= 0; d--) {
      let index2 = $pos.indexAfter(d);
      if ($pos.node(d).canReplaceWith(index2, index2, nodeType))
        return $pos.after(d + 1);
      if (index2 < $pos.node(d).childCount)
        return null;
    }
  return null;
}
function dropPoint(doc3, pos, slice2) {
  let $pos = doc3.resolve(pos);
  if (!slice2.content.size)
    return pos;
  let content = slice2.content;
  for (let i = 0; i < slice2.openStart; i++)
    content = content.firstChild.content;
  for (let pass = 1; pass <= (slice2.openStart == 0 && slice2.size ? 2 : 1); pass++) {
    for (let d = $pos.depth; d >= 0; d--) {
      let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      let parent = $pos.node(d), fits = false;
      if (pass == 1) {
        fits = parent.canReplace(insertPos, insertPos, content);
      } else {
        let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
        fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
      }
      if (fits)
        return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
  }
  return null;
}
function replaceStep(doc3, from2, to = from2, slice2 = Slice.empty) {
  if (from2 == to && !slice2.size)
    return null;
  let $from = doc3.resolve(from2), $to = doc3.resolve(to);
  if (fitsTrivially($from, $to, slice2))
    return new ReplaceStep(from2, to, slice2);
  return new Fitter($from, $to, slice2).fit();
}
function fitsTrivially($from, $to, slice2) {
  return !slice2.openStart && !slice2.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice2.content);
}
var Fitter = class {
  constructor($from, $to, unplaced) {
    this.$from = $from;
    this.$to = $to;
    this.unplaced = unplaced;
    this.frontier = [];
    this.placed = Fragment6.empty;
    for (let i = 0; i <= $from.depth; i++) {
      let node = $from.node(i);
      this.frontier.push({
        type: node.type,
        match: node.contentMatchAt($from.indexAfter(i))
      });
    }
    for (let i = $from.depth; i > 0; i--)
      this.placed = Fragment6.from($from.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    while (this.unplaced.size) {
      let fit = this.findFittable();
      if (fit)
        this.placeNodes(fit);
      else
        this.openMore() || this.dropNode();
    }
    let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
    let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
    if (!$to)
      return null;
    let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
    while (openStart && openEnd && content.childCount == 1) {
      content = content.firstChild.content;
      openStart--;
      openEnd--;
    }
    let slice2 = new Slice(content, openStart, openEnd);
    if (moveInline > -1)
      return new ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice2, placedSize);
    if (slice2.size || $from.pos != this.$to.pos)
      return new ReplaceStep($from.pos, $to.pos, slice2);
    return null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let startDepth = this.unplaced.openStart;
    for (let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++) {
      let node = cur.firstChild;
      if (cur.childCount > 1)
        openEnd = 0;
      if (node.type.spec.isolating && openEnd <= d) {
        startDepth = d;
        break;
      }
      cur = node.content;
    }
    for (let pass = 1; pass <= 2; pass++) {
      for (let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
        let fragment, parent = null;
        if (sliceDepth) {
          parent = contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
          fragment = parent.content;
        } else {
          fragment = this.unplaced.content;
        }
        let first2 = fragment.firstChild;
        for (let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
          let { type, match } = this.frontier[frontierDepth], wrap2, inject = null;
          if (pass == 1 && (first2 ? match.matchType(first2.type) || (inject = match.fillBefore(Fragment6.from(first2), false)) : parent && type.compatibleContent(parent.type)))
            return { sliceDepth, frontierDepth, parent, inject };
          else if (pass == 2 && first2 && (wrap2 = match.findWrapping(first2.type)))
            return { sliceDepth, frontierDepth, parent, wrap: wrap2 };
          if (parent && match.matchType(parent.type))
            break;
        }
      }
    }
  }
  openMore() {
    let { content, openStart, openEnd } = this.unplaced;
    let inner = contentAt(content, openStart);
    if (!inner.childCount || inner.firstChild.isLeaf)
      return false;
    this.unplaced = new Slice(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
    return true;
  }
  dropNode() {
    let { content, openStart, openEnd } = this.unplaced;
    let inner = contentAt(content, openStart);
    if (inner.childCount <= 1 && openStart > 0) {
      let openAtEnd = content.size - openStart <= openStart + inner.size;
      this.unplaced = new Slice(dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
    } else {
      this.unplaced = new Slice(dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth, frontierDepth, parent, inject, wrap: wrap2 }) {
    while (this.depth > frontierDepth)
      this.closeFrontierNode();
    if (wrap2)
      for (let i = 0; i < wrap2.length; i++)
        this.openFrontierNode(wrap2[i]);
    let slice2 = this.unplaced, fragment = parent ? parent.content : slice2.content;
    let openStart = slice2.openStart - sliceDepth;
    let taken = 0, add = [];
    let { match, type } = this.frontier[frontierDepth];
    if (inject) {
      for (let i = 0; i < inject.childCount; i++)
        add.push(inject.child(i));
      match = match.matchFragment(inject);
    }
    let openEndCount = fragment.size + sliceDepth - (slice2.content.size - slice2.openEnd);
    while (taken < fragment.childCount) {
      let next = fragment.child(taken), matches2 = match.matchType(next.type);
      if (!matches2)
        break;
      taken++;
      if (taken > 1 || openStart == 0 || next.content.size) {
        match = matches2;
        add.push(closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
      }
    }
    let toEnd = taken == fragment.childCount;
    if (!toEnd)
      openEndCount = -1;
    this.placed = addToFragment(this.placed, frontierDepth, Fragment6.from(add));
    this.frontier[frontierDepth].match = match;
    if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1)
      this.closeFrontierNode();
    for (let i = 0, cur = fragment; i < openEndCount; i++) {
      let node = cur.lastChild;
      this.frontier.push({ type: node.type, match: node.contentMatchAt(node.childCount) });
      cur = node.content;
    }
    this.unplaced = !toEnd ? new Slice(dropFromFragment(slice2.content, sliceDepth, taken), slice2.openStart, slice2.openEnd) : sliceDepth == 0 ? Slice.empty : new Slice(dropFromFragment(slice2.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice2.openEnd : sliceDepth - 1);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let top2 = this.frontier[this.depth], level;
    if (!top2.type.isTextblock || !contentAfterFits(this.$to, this.$to.depth, top2.type, top2.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth)
      return -1;
    let { depth } = this.$to, after = this.$to.after(depth);
    while (depth > 1 && after == this.$to.end(--depth))
      ++after;
    return after;
  }
  findCloseLevel($to) {
    scan: for (let i = Math.min(this.depth, $to.depth); i >= 0; i--) {
      let { match, type } = this.frontier[i];
      let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
      let fit = contentAfterFits($to, i, type, match, dropInner);
      if (!fit)
        continue;
      for (let d = i - 1; d >= 0; d--) {
        let { match: match2, type: type2 } = this.frontier[d];
        let matches2 = contentAfterFits($to, d, type2, match2, true);
        if (!matches2 || matches2.childCount)
          continue scan;
      }
      return { depth: i, fit, move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to };
    }
  }
  close($to) {
    let close2 = this.findCloseLevel($to);
    if (!close2)
      return null;
    while (this.depth > close2.depth)
      this.closeFrontierNode();
    if (close2.fit.childCount)
      this.placed = addToFragment(this.placed, close2.depth, close2.fit);
    $to = close2.move;
    for (let d = close2.depth + 1; d <= $to.depth; d++) {
      let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
      this.openFrontierNode(node.type, node.attrs, add);
    }
    return $to;
  }
  openFrontierNode(type, attrs = null, content) {
    let top2 = this.frontier[this.depth];
    top2.match = top2.match.matchType(type);
    this.placed = addToFragment(this.placed, this.depth, Fragment6.from(type.create(attrs, content)));
    this.frontier.push({ type, match: type.contentMatch });
  }
  closeFrontierNode() {
    let open2 = this.frontier.pop();
    let add = open2.match.fillBefore(Fragment6.empty, true);
    if (add.childCount)
      this.placed = addToFragment(this.placed, this.frontier.length, add);
  }
};
function dropFromFragment(fragment, depth, count3) {
  if (depth == 0)
    return fragment.cutByIndex(count3, fragment.childCount);
  return fragment.replaceChild(0, fragment.firstChild.copy(dropFromFragment(fragment.firstChild.content, depth - 1, count3)));
}
function addToFragment(fragment, depth, content) {
  if (depth == 0)
    return fragment.append(content);
  return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy(addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function contentAt(fragment, depth) {
  for (let i = 0; i < depth; i++)
    fragment = fragment.firstChild.content;
  return fragment;
}
function closeNodeStart(node, openStart, openEnd) {
  if (openStart <= 0)
    return node;
  let frag = node.content;
  if (openStart > 1)
    frag = frag.replaceChild(0, closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
  if (openStart > 0) {
    frag = node.type.contentMatch.fillBefore(frag).append(frag);
    if (openEnd <= 0)
      frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore(Fragment6.empty, true));
  }
  return node.copy(frag);
}
function contentAfterFits($to, depth, type, match, open2) {
  let node = $to.node(depth), index2 = open2 ? $to.indexAfter(depth) : $to.index(depth);
  if (index2 == node.childCount && !type.compatibleContent(node.type))
    return null;
  let fit = match.fillBefore(node.content, true, index2);
  return fit && !invalidMarks(type, node.content, index2) ? fit : null;
}
function invalidMarks(type, fragment, start2) {
  for (let i = start2; i < fragment.childCount; i++)
    if (!type.allowsMarks(fragment.child(i).marks))
      return true;
  return false;
}
function definesContent(type) {
  return type.spec.defining || type.spec.definingForContent;
}
function replaceRange(tr2, from2, to, slice2) {
  if (!slice2.size)
    return tr2.deleteRange(from2, to);
  let $from = tr2.doc.resolve(from2), $to = tr2.doc.resolve(to);
  if (fitsTrivially($from, $to, slice2))
    return tr2.step(new ReplaceStep(from2, to, slice2));
  let targetDepths = coveredDepths($from, $to);
  if (targetDepths[targetDepths.length - 1] == 0)
    targetDepths.pop();
  let preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  for (let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    let spec = $from.node(d).type.spec;
    if (spec.defining || spec.definingAsContext || spec.isolating)
      break;
    if (targetDepths.indexOf(d) > -1)
      preferredTarget = d;
    else if ($from.before(d) == pos)
      targetDepths.splice(1, 0, -d);
  }
  let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
  let leftNodes = [], preferredDepth = slice2.openStart;
  for (let content = slice2.content, i = 0; ; i++) {
    let node = content.firstChild;
    leftNodes.push(node);
    if (i == slice2.openStart)
      break;
    content = node.content;
  }
  for (let d = preferredDepth - 1; d >= 0; d--) {
    let leftNode = leftNodes[d], def = definesContent(leftNode.type);
    if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1)))
      preferredDepth = d;
    else if (def || !leftNode.type.isTextblock)
      break;
  }
  for (let j = slice2.openStart; j >= 0; j--) {
    let openDepth = (j + preferredDepth + 1) % (slice2.openStart + 1);
    let insert = leftNodes[openDepth];
    if (!insert)
      continue;
    for (let i = 0; i < targetDepths.length; i++) {
      let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) {
        expand = false;
        targetDepth = -targetDepth;
      }
      let parent = $from.node(targetDepth - 1), index2 = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index2, index2, insert.type, insert.marks))
        return tr2.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new Slice(closeFragment(slice2.content, 0, slice2.openStart, openDepth), openDepth, slice2.openEnd));
    }
  }
  let startSteps = tr2.steps.length;
  for (let i = targetDepths.length - 1; i >= 0; i--) {
    tr2.replace(from2, to, slice2);
    if (tr2.steps.length > startSteps)
      break;
    let depth = targetDepths[i];
    if (depth < 0)
      continue;
    from2 = $from.before(depth);
    to = $to.after(depth);
  }
}
function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    let first2 = fragment.firstChild;
    fragment = fragment.replaceChild(0, first2.copy(closeFragment(first2.content, depth + 1, oldOpen, newOpen, first2)));
  }
  if (depth > newOpen) {
    let match = parent.contentMatchAt(0);
    let start2 = match.fillBefore(fragment).append(fragment);
    fragment = start2.append(match.matchFragment(start2).fillBefore(Fragment6.empty, true));
  }
  return fragment;
}
function replaceRangeWith(tr2, from2, to, node) {
  if (!node.isInline && from2 == to && tr2.doc.resolve(from2).parent.content.size) {
    let point = insertPoint(tr2.doc, from2, node.type);
    if (point != null)
      from2 = to = point;
  }
  tr2.replaceRange(from2, to, new Slice(Fragment6.from(node), 0, 0));
}
function deleteRange(tr2, from2, to) {
  let $from = tr2.doc.resolve(from2), $to = tr2.doc.resolve(to);
  let covered = coveredDepths($from, $to);
  for (let i = 0; i < covered.length; i++) {
    let depth = covered[i], last = i == covered.length - 1;
    if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd)
      return tr2.delete($from.start(depth), $to.end(depth));
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      return tr2.delete($from.before(depth), $to.after(depth));
  }
  for (let d = 1; d <= $from.depth && d <= $to.depth; d++) {
    if (from2 - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1)))
      return tr2.delete($from.before(d), to);
  }
  tr2.delete(from2, to);
}
function coveredDepths($from, $to) {
  let result = [], minDepth = Math.min($from.depth, $to.depth);
  for (let d = minDepth; d >= 0; d--) {
    let start2 = $from.start(d);
    if (start2 < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating)
      break;
    if (start2 == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start2 - 1)
      result.push(d);
  }
  return result;
}
var AttrStep = class _AttrStep extends Step {
  /**
  Construct an attribute step.
  */
  constructor(pos, attr, value) {
    super();
    this.pos = pos;
    this.attr = attr;
    this.value = value;
  }
  apply(doc3) {
    let node = doc3.nodeAt(this.pos);
    if (!node)
      return StepResult.fail("No node at attribute step's position");
    let attrs = /* @__PURE__ */ Object.create(null);
    for (let name in node.attrs)
      attrs[name] = node.attrs[name];
    attrs[this.attr] = this.value;
    let updated = node.type.create(attrs, null, node.marks);
    return StepResult.fromReplace(doc3, this.pos, this.pos + 1, new Slice(Fragment6.from(updated), 0, node.isLeaf ? 0 : 1));
  }
  getMap() {
    return StepMap.empty;
  }
  invert(doc3) {
    return new _AttrStep(this.pos, this.attr, doc3.nodeAt(this.pos).attrs[this.attr]);
  }
  map(mapping) {
    let pos = mapping.mapResult(this.pos, 1);
    return pos.deletedAfter ? null : new _AttrStep(pos.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(schema, json) {
    if (typeof json.pos != "number" || typeof json.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new _AttrStep(json.pos, json.attr, json.value);
  }
};
Step.jsonID("attr", AttrStep);
var DocAttrStep = class _DocAttrStep extends Step {
  /**
  Construct an attribute step.
  */
  constructor(attr, value) {
    super();
    this.attr = attr;
    this.value = value;
  }
  apply(doc3) {
    let attrs = /* @__PURE__ */ Object.create(null);
    for (let name in doc3.attrs)
      attrs[name] = doc3.attrs[name];
    attrs[this.attr] = this.value;
    let updated = doc3.type.create(attrs, doc3.content, doc3.marks);
    return StepResult.ok(updated);
  }
  getMap() {
    return StepMap.empty;
  }
  invert(doc3) {
    return new _DocAttrStep(this.attr, doc3.attrs[this.attr]);
  }
  map(mapping) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(schema, json) {
    if (typeof json.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new _DocAttrStep(json.attr, json.value);
  }
};
Step.jsonID("docAttr", DocAttrStep);
var TransformError = class extends Error {
};
TransformError = function TransformError2(message) {
  let err = Error.call(this, message);
  err.__proto__ = TransformError2.prototype;
  return err;
};
TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";
var Transform = class {
  /**
  Create a transform that starts with the given document.
  */
  constructor(doc3) {
    this.doc = doc3;
    this.steps = [];
    this.docs = [];
    this.mapping = new Mapping();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(step) {
    let result = this.maybeStep(step);
    if (result.failed)
      throw new TransformError(result.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(step) {
    let result = step.apply(this.doc);
    if (!result.failed)
      this.addStep(step, result.doc);
    return result;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(step, doc3) {
    this.docs.push(this.doc);
    this.steps.push(step);
    this.mapping.appendMap(step.getMap());
    this.doc = doc3;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(from2, to = from2, slice2 = Slice.empty) {
    let step = replaceStep(this.doc, from2, to, slice2);
    if (step)
      this.step(step);
    return this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(from2, to, content) {
    return this.replace(from2, to, new Slice(Fragment6.from(content), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(from2, to) {
    return this.replace(from2, to, Slice.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(pos, content) {
    return this.replaceWith(pos, pos, content);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(from2, to, slice2) {
    replaceRange(this, from2, to, slice2);
    return this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(from2, to, node) {
    replaceRangeWith(this, from2, to, node);
    return this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(from2, to) {
    deleteRange(this, from2, to);
    return this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(range, target) {
    lift(this, range, target);
    return this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(pos, depth = 1) {
    join(this, pos, depth);
    return this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(range, wrappers) {
    wrap(this, range, wrappers);
    return this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(from2, to = from2, type, attrs = null) {
    setBlockType(this, from2, to, type, attrs);
    return this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(pos, type, attrs = null, marks) {
    setNodeMarkup(this, pos, type, attrs, marks);
    return this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(pos, attr, value) {
    this.step(new AttrStep(pos, attr, value));
    return this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(attr, value) {
    this.step(new DocAttrStep(attr, value));
    return this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(pos, mark) {
    this.step(new AddNodeMarkStep(pos, mark));
    return this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(pos, mark) {
    let node = this.doc.nodeAt(pos);
    if (!node)
      throw new RangeError("No node at position " + pos);
    if (mark instanceof Mark) {
      if (mark.isInSet(node.marks))
        this.step(new RemoveNodeMarkStep(pos, mark));
    } else {
      let set = node.marks, found2, steps = [];
      while (found2 = mark.isInSet(set)) {
        steps.push(new RemoveNodeMarkStep(pos, found2));
        set = found2.removeFromSet(set);
      }
      for (let i = steps.length - 1; i >= 0; i--)
        this.step(steps[i]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(pos, depth = 1, typesAfter) {
    split(this, pos, depth, typesAfter);
    return this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(from2, to, mark) {
    addMark(this, from2, to, mark);
    return this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(from2, to, mark) {
    removeMark(this, from2, to, mark);
    return this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(pos, parentType, match) {
    clearIncompatible(this, pos, parentType, match);
    return this;
  }
};

// ../../node_modules/.pnpm/prosemirror-state@1.4.4/node_modules/prosemirror-state/dist/index.js
var classesById = /* @__PURE__ */ Object.create(null);
var Selection = class {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor($anchor, $head, ranges) {
    this.$anchor = $anchor;
    this.$head = $head;
    this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let ranges = this.ranges;
    for (let i = 0; i < ranges.length; i++)
      if (ranges[i].$from.pos != ranges[i].$to.pos)
        return false;
    return true;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, true);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(tr2, content = Slice.empty) {
    let lastNode = content.content.lastChild, lastParent = null;
    for (let i = 0; i < content.openEnd; i++) {
      lastParent = lastNode;
      lastNode = lastNode.lastChild;
    }
    let mapFrom = tr2.steps.length, ranges = this.ranges;
    for (let i = 0; i < ranges.length; i++) {
      let { $from, $to } = ranges[i], mapping = tr2.mapping.slice(mapFrom);
      tr2.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? Slice.empty : content);
      if (i == 0)
        selectionToInsertionEnd(tr2, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(tr2, node) {
    let mapFrom = tr2.steps.length, ranges = this.ranges;
    for (let i = 0; i < ranges.length; i++) {
      let { $from, $to } = ranges[i], mapping = tr2.mapping.slice(mapFrom);
      let from2 = mapping.map($from.pos), to = mapping.map($to.pos);
      if (i) {
        tr2.deleteRange(from2, to);
      } else {
        tr2.replaceRangeWith(from2, to, node);
        selectionToInsertionEnd(tr2, mapFrom, node.isInline ? -1 : 1);
      }
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom($pos, dir, textOnly = false) {
    let inner = $pos.parent.inlineContent ? new TextSelection($pos) : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
    if (inner)
      return inner;
    for (let depth = $pos.depth - 1; depth >= 0; depth--) {
      let found2 = dir < 0 ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
      if (found2)
        return found2;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near($pos, bias = 1) {
    return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(doc3) {
    return findSelectionIn(doc3, doc3, 0, 0, 1) || new AllSelection(doc3);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(doc3) {
    return findSelectionIn(doc3, doc3, doc3.content.size, doc3.childCount, -1) || new AllSelection(doc3);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(doc3, json) {
    if (!json || !json.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let cls = classesById[json.type];
    if (!cls)
      throw new RangeError(`No selection type ${json.type} defined`);
    return cls.fromJSON(doc3, json);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(id, selectionClass) {
    if (id in classesById)
      throw new RangeError("Duplicate use of selection JSON ID " + id);
    classesById[id] = selectionClass;
    selectionClass.prototype.jsonID = id;
    return selectionClass;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return TextSelection.between(this.$anchor, this.$head).getBookmark();
  }
};
Selection.prototype.visible = true;
var SelectionRange = class {
  /**
  Create a range.
  */
  constructor($from, $to) {
    this.$from = $from;
    this.$to = $to;
  }
};
var warnedAboutTextSelection = false;
function checkTextSelection($pos) {
  if (!warnedAboutTextSelection && !$pos.parent.inlineContent) {
    warnedAboutTextSelection = true;
    console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
  }
}
var TextSelection = class _TextSelection extends Selection {
  /**
  Construct a text selection between the given points.
  */
  constructor($anchor, $head = $anchor) {
    checkTextSelection($anchor);
    checkTextSelection($head);
    super($anchor, $head);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(doc3, mapping) {
    let $head = doc3.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent)
      return Selection.near($head);
    let $anchor = doc3.resolve(mapping.map(this.anchor));
    return new _TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head);
  }
  replace(tr2, content = Slice.empty) {
    super.replace(tr2, content);
    if (content == Slice.empty) {
      let marks = this.$from.marksAcross(this.$to);
      if (marks)
        tr2.ensureMarks(marks);
    }
  }
  eq(other) {
    return other instanceof _TextSelection && other.anchor == this.anchor && other.head == this.head;
  }
  getBookmark() {
    return new TextBookmark(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(doc3, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new _TextSelection(doc3.resolve(json.anchor), doc3.resolve(json.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(doc3, anchor, head = anchor) {
    let $anchor = doc3.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc3.resolve(head));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between($anchor, $head, bias) {
    let dPos = $anchor.pos - $head.pos;
    if (!bias || dPos)
      bias = dPos >= 0 ? 1 : -1;
    if (!$head.parent.inlineContent) {
      let found2 = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
      if (found2)
        $head = found2.$head;
      else
        return Selection.near($head, bias);
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
        if ($anchor.pos < $head.pos != dPos < 0)
          $anchor = $head;
      }
    }
    return new _TextSelection($anchor, $head);
  }
};
Selection.jsonID("text", TextSelection);
var TextBookmark = class _TextBookmark {
  constructor(anchor, head) {
    this.anchor = anchor;
    this.head = head;
  }
  map(mapping) {
    return new _TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
  }
  resolve(doc3) {
    return TextSelection.between(doc3.resolve(this.anchor), doc3.resolve(this.head));
  }
};
var NodeSelection = class _NodeSelection extends Selection {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor($pos) {
    let node = $pos.nodeAfter;
    let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
    super($pos, $end);
    this.node = node;
  }
  map(doc3, mapping) {
    let { deleted, pos } = mapping.mapResult(this.anchor);
    let $pos = doc3.resolve(pos);
    if (deleted)
      return Selection.near($pos);
    return new _NodeSelection($pos);
  }
  content() {
    return new Slice(Fragment6.from(this.node), 0, 0);
  }
  eq(other) {
    return other instanceof _NodeSelection && other.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new NodeBookmark(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(doc3, json) {
    if (typeof json.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new _NodeSelection(doc3.resolve(json.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(doc3, from2) {
    return new _NodeSelection(doc3.resolve(from2));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(node) {
    return !node.isText && node.type.spec.selectable !== false;
  }
};
NodeSelection.prototype.visible = false;
Selection.jsonID("node", NodeSelection);
var NodeBookmark = class _NodeBookmark {
  constructor(anchor) {
    this.anchor = anchor;
  }
  map(mapping) {
    let { deleted, pos } = mapping.mapResult(this.anchor);
    return deleted ? new TextBookmark(pos, pos) : new _NodeBookmark(pos);
  }
  resolve(doc3) {
    let $pos = doc3.resolve(this.anchor), node = $pos.nodeAfter;
    if (node && NodeSelection.isSelectable(node))
      return new NodeSelection($pos);
    return Selection.near($pos);
  }
};
var AllSelection = class _AllSelection extends Selection {
  /**
  Create an all-selection over the given document.
  */
  constructor(doc3) {
    super(doc3.resolve(0), doc3.resolve(doc3.content.size));
  }
  replace(tr2, content = Slice.empty) {
    if (content == Slice.empty) {
      tr2.delete(0, tr2.doc.content.size);
      let sel = Selection.atStart(tr2.doc);
      if (!sel.eq(tr2.selection))
        tr2.setSelection(sel);
    } else {
      super.replace(tr2, content);
    }
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(doc3) {
    return new _AllSelection(doc3);
  }
  map(doc3) {
    return new _AllSelection(doc3);
  }
  eq(other) {
    return other instanceof _AllSelection;
  }
  getBookmark() {
    return AllBookmark;
  }
};
Selection.jsonID("all", AllSelection);
var AllBookmark = {
  map() {
    return this;
  },
  resolve(doc3) {
    return new AllSelection(doc3);
  }
};
function findSelectionIn(doc3, node, pos, index2, dir, text = false) {
  if (node.inlineContent)
    return TextSelection.create(doc3, pos);
  for (let i = index2 - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
    let child = node.child(i);
    if (!child.isAtom) {
      let inner = findSelectionIn(doc3, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
      if (inner)
        return inner;
    } else if (!text && NodeSelection.isSelectable(child)) {
      return NodeSelection.create(doc3, pos - (dir < 0 ? child.nodeSize : 0));
    }
    pos += child.nodeSize * dir;
  }
  return null;
}
function selectionToInsertionEnd(tr2, startLen, bias) {
  let last = tr2.steps.length - 1;
  if (last < startLen)
    return;
  let step = tr2.steps[last];
  if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep))
    return;
  let map2 = tr2.mapping.maps[last], end2;
  map2.forEach((_from, _to, _newFrom, newTo) => {
    if (end2 == null)
      end2 = newTo;
  });
  tr2.setSelection(Selection.near(tr2.doc.resolve(end2), bias));
}
var UPDATED_SEL = 1;
var UPDATED_MARKS = 2;
var UPDATED_SCROLL = 4;
var Transaction = class extends Transform {
  /**
  @internal
  */
  constructor(state) {
    super(state.doc);
    this.curSelectionFor = 0;
    this.updated = 0;
    this.meta = /* @__PURE__ */ Object.create(null);
    this.time = Date.now();
    this.curSelection = state.selection;
    this.storedMarks = state.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(selection) {
    if (selection.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
    this.storedMarks = null;
    return this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & UPDATED_SEL) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(marks) {
    this.storedMarks = marks;
    this.updated |= UPDATED_MARKS;
    return this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(marks) {
    if (!Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
      this.setStoredMarks(marks);
    return this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(mark) {
    return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(mark) {
    return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & UPDATED_MARKS) > 0;
  }
  /**
  @internal
  */
  addStep(step, doc3) {
    super.addStep(step, doc3);
    this.updated = this.updated & ~UPDATED_MARKS;
    this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(time) {
    this.time = time;
    return this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(slice2) {
    this.selection.replace(this, slice2);
    return this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(node, inheritMarks = true) {
    let selection = this.selection;
    if (inheritMarks)
      node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || Mark.none));
    selection.replaceWith(this, node);
    return this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    this.selection.replace(this);
    return this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(text, from2, to) {
    let schema = this.doc.type.schema;
    if (from2 == null) {
      if (!text)
        return this.deleteSelection();
      return this.replaceSelectionWith(schema.text(text), true);
    } else {
      if (to == null)
        to = from2;
      if (!text)
        return this.deleteRange(from2, to);
      let marks = this.storedMarks;
      if (!marks) {
        let $from = this.doc.resolve(from2);
        marks = to == from2 ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
      }
      this.replaceRangeWith(from2, to, schema.text(text, marks));
      if (!this.selection.empty && this.selection.to == from2 + text.length)
        this.setSelection(Selection.near(this.selection.$to));
      return this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(key, value) {
    this.meta[typeof key == "string" ? key : key.key] = value;
    return this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(key) {
    return this.meta[typeof key == "string" ? key : key.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let _ in this.meta)
      return false;
    return true;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    this.updated |= UPDATED_SCROLL;
    return this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & UPDATED_SCROLL) > 0;
  }
};
function bind(f, self) {
  return !self || !f ? f : f.bind(self);
}
var FieldDesc = class {
  constructor(name, desc, self) {
    this.name = name;
    this.init = bind(desc.init, self);
    this.apply = bind(desc.apply, self);
  }
};
var baseFields = [
  new FieldDesc("doc", {
    init(config) {
      return config.doc || config.schema.topNodeType.createAndFill();
    },
    apply(tr2) {
      return tr2.doc;
    }
  }),
  new FieldDesc("selection", {
    init(config, instance) {
      return config.selection || Selection.atStart(instance.doc);
    },
    apply(tr2) {
      return tr2.selection;
    }
  }),
  new FieldDesc("storedMarks", {
    init(config) {
      return config.storedMarks || null;
    },
    apply(tr2, _marks, _old, state) {
      return state.selection.$cursor ? tr2.storedMarks : null;
    }
  }),
  new FieldDesc("scrollToSelection", {
    init() {
      return 0;
    },
    apply(tr2, prev) {
      return tr2.scrolledIntoView ? prev + 1 : prev;
    }
  })
];
var Configuration = class {
  constructor(schema, plugins) {
    this.schema = schema;
    this.plugins = [];
    this.pluginsByKey = /* @__PURE__ */ Object.create(null);
    this.fields = baseFields.slice();
    if (plugins)
      plugins.forEach((plugin) => {
        if (this.pluginsByKey[plugin.key])
          throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
        this.plugins.push(plugin);
        this.pluginsByKey[plugin.key] = plugin;
        if (plugin.spec.state)
          this.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin));
      });
  }
};
var EditorState = class _EditorState {
  /**
  @internal
  */
  constructor(config) {
    this.config = config;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(tr2) {
    return this.applyTransaction(tr2).state;
  }
  /**
  @internal
  */
  filterTransaction(tr2, ignore = -1) {
    for (let i = 0; i < this.config.plugins.length; i++)
      if (i != ignore) {
        let plugin = this.config.plugins[i];
        if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr2, this))
          return false;
      }
    return true;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(rootTr) {
    if (!this.filterTransaction(rootTr))
      return { state: this, transactions: [] };
    let trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
    for (; ; ) {
      let haveNew = false;
      for (let i = 0; i < this.config.plugins.length; i++) {
        let plugin = this.config.plugins[i];
        if (plugin.spec.appendTransaction) {
          let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
          let tr2 = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
          if (tr2 && newState.filterTransaction(tr2, i)) {
            tr2.setMeta("appendedTransaction", rootTr);
            if (!seen) {
              seen = [];
              for (let j = 0; j < this.config.plugins.length; j++)
                seen.push(j < i ? { state: newState, n: trs.length } : { state: this, n: 0 });
            }
            trs.push(tr2);
            newState = newState.applyInner(tr2);
            haveNew = true;
          }
          if (seen)
            seen[i] = { state: newState, n: trs.length };
        }
      }
      if (!haveNew)
        return { state: newState, transactions: trs };
    }
  }
  /**
  @internal
  */
  applyInner(tr2) {
    if (!tr2.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let newInstance = new _EditorState(this.config), fields = this.config.fields;
    for (let i = 0; i < fields.length; i++) {
      let field = fields[i];
      newInstance[field.name] = field.apply(tr2, this[field.name], this, newInstance);
    }
    return newInstance;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new Transaction(this);
  }
  /**
  Create a new state.
  */
  static create(config) {
    let $config = new Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
    let instance = new _EditorState($config);
    for (let i = 0; i < $config.fields.length; i++)
      instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
    return instance;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(config) {
    let $config = new Configuration(this.schema, config.plugins);
    let fields = $config.fields, instance = new _EditorState($config);
    for (let i = 0; i < fields.length; i++) {
      let name = fields[i].name;
      instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
    }
    return instance;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(pluginFields) {
    let result = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks)
      result.storedMarks = this.storedMarks.map((m) => m.toJSON());
    if (pluginFields && typeof pluginFields == "object")
      for (let prop in pluginFields) {
        if (prop == "doc" || prop == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let plugin = pluginFields[prop], state = plugin.spec.state;
        if (state && state.toJSON)
          result[prop] = state.toJSON.call(plugin, this[plugin.key]);
      }
    return result;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(config, json, pluginFields) {
    if (!json)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!config.schema)
      throw new RangeError("Required config field 'schema' missing");
    let $config = new Configuration(config.schema, config.plugins);
    let instance = new _EditorState($config);
    $config.fields.forEach((field) => {
      if (field.name == "doc") {
        instance.doc = Node2.fromJSON(config.schema, json.doc);
      } else if (field.name == "selection") {
        instance.selection = Selection.fromJSON(instance.doc, json.selection);
      } else if (field.name == "storedMarks") {
        if (json.storedMarks)
          instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
      } else {
        if (pluginFields)
          for (let prop in pluginFields) {
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
              instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
              return;
            }
          }
        instance[field.name] = field.init(config, instance);
      }
    });
    return instance;
  }
};
function bindProps(obj, self, target) {
  for (let prop in obj) {
    let val = obj[prop];
    if (val instanceof Function)
      val = val.bind(self);
    else if (prop == "handleDOMEvents")
      val = bindProps(val, self, {});
    target[prop] = val;
  }
  return target;
}
var Plugin = class {
  /**
  Create a plugin.
  */
  constructor(spec) {
    this.spec = spec;
    this.props = {};
    if (spec.props)
      bindProps(spec.props, this, this.props);
    this.key = spec.key ? spec.key.key : createKey("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(state) {
    return state[this.key];
  }
};
var keys = /* @__PURE__ */ Object.create(null);
function createKey(name) {
  if (name in keys)
    return name + "$" + ++keys[name];
  keys[name] = 0;
  return name + "$";
}
var PluginKey = class {
  /**
  Create a plugin key.
  */
  constructor(name = "key") {
    this.key = createKey(name);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(state) {
    return state.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(state) {
    return state[this.key];
  }
};

// ../../node_modules/.pnpm/prosemirror-commands@1.7.1/node_modules/prosemirror-commands/dist/index.js
var deleteSelection = (state, dispatch) => {
  if (state.selection.empty)
    return false;
  if (dispatch)
    dispatch(state.tr.deleteSelection().scrollIntoView());
  return true;
};
function atBlockStart(state, view) {
  let { $cursor } = state.selection;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0))
    return null;
  return $cursor;
}
var joinBackward = (state, dispatch, view) => {
  let $cursor = atBlockStart(state, view);
  if (!$cursor)
    return false;
  let $cut = findCutBefore($cursor);
  if (!$cut) {
    let range = $cursor.blockRange(), target = range && liftTarget(range);
    if (target == null)
      return false;
    if (dispatch)
      dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
  }
  let before = $cut.nodeBefore;
  if (deleteBarrier(state, $cut, dispatch, -1))
    return true;
  if ($cursor.parent.content.size == 0 && (textblockAt(before, "end") || NodeSelection.isSelectable(before))) {
    for (let depth = $cursor.depth; ; depth--) {
      let delStep = replaceStep(state.doc, $cursor.before(depth), $cursor.after(depth), Slice.empty);
      if (delStep && delStep.slice.size < delStep.to - delStep.from) {
        if (dispatch) {
          let tr2 = state.tr.step(delStep);
          tr2.setSelection(textblockAt(before, "end") ? Selection.findFrom(tr2.doc.resolve(tr2.mapping.map($cut.pos, -1)), -1) : NodeSelection.create(tr2.doc, $cut.pos - before.nodeSize));
          dispatch(tr2.scrollIntoView());
        }
        return true;
      }
      if (depth == 1 || $cursor.node(depth - 1).childCount > 1)
        break;
    }
  }
  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch)
      dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
    return true;
  }
  return false;
};
var joinTextblockBackward = (state, dispatch, view) => {
  let $cursor = atBlockStart(state, view);
  if (!$cursor)
    return false;
  let $cut = findCutBefore($cursor);
  return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
var joinTextblockForward = (state, dispatch, view) => {
  let $cursor = atBlockEnd(state, view);
  if (!$cursor)
    return false;
  let $cut = findCutAfter($cursor);
  return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
function joinTextblocksAround(state, $cut, dispatch) {
  let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
  for (; !beforeText.isTextblock; beforePos--) {
    if (beforeText.type.spec.isolating)
      return false;
    let child = beforeText.lastChild;
    if (!child)
      return false;
    beforeText = child;
  }
  let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
  for (; !afterText.isTextblock; afterPos++) {
    if (afterText.type.spec.isolating)
      return false;
    let child = afterText.firstChild;
    if (!child)
      return false;
    afterText = child;
  }
  let step = replaceStep(state.doc, beforePos, afterPos, Slice.empty);
  if (!step || step.from != beforePos || step instanceof ReplaceStep && step.slice.size >= afterPos - beforePos)
    return false;
  if (dispatch) {
    let tr2 = state.tr.step(step);
    tr2.setSelection(TextSelection.create(tr2.doc, beforePos));
    dispatch(tr2.scrollIntoView());
  }
  return true;
}
function textblockAt(node, side, only = false) {
  for (let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild) {
    if (scan.isTextblock)
      return true;
    if (only && scan.childCount != 1)
      return false;
  }
  return false;
}
var selectNodeBackward = (state, dispatch, view) => {
  let { $head, empty: empty2 } = state.selection, $cut = $head;
  if (!empty2)
    return false;
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0)
      return false;
    $cut = findCutBefore($head);
  }
  let node = $cut && $cut.nodeBefore;
  if (!node || !NodeSelection.isSelectable(node))
    return false;
  if (dispatch)
    dispatch(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
  return true;
};
function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating)
    for (let i = $pos.depth - 1; i >= 0; i--) {
      if ($pos.index(i) > 0)
        return $pos.doc.resolve($pos.before(i + 1));
      if ($pos.node(i).type.spec.isolating)
        break;
    }
  return null;
}
function atBlockEnd(state, view) {
  let { $cursor } = state.selection;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size))
    return null;
  return $cursor;
}
var joinForward = (state, dispatch, view) => {
  let $cursor = atBlockEnd(state, view);
  if (!$cursor)
    return false;
  let $cut = findCutAfter($cursor);
  if (!$cut)
    return false;
  let after = $cut.nodeAfter;
  if (deleteBarrier(state, $cut, dispatch, 1))
    return true;
  if ($cursor.parent.content.size == 0 && (textblockAt(after, "start") || NodeSelection.isSelectable(after))) {
    let delStep = replaceStep(state.doc, $cursor.before(), $cursor.after(), Slice.empty);
    if (delStep && delStep.slice.size < delStep.to - delStep.from) {
      if (dispatch) {
        let tr2 = state.tr.step(delStep);
        tr2.setSelection(textblockAt(after, "start") ? Selection.findFrom(tr2.doc.resolve(tr2.mapping.map($cut.pos)), 1) : NodeSelection.create(tr2.doc, tr2.mapping.map($cut.pos)));
        dispatch(tr2.scrollIntoView());
      }
      return true;
    }
  }
  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch)
      dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
    return true;
  }
  return false;
};
var selectNodeForward = (state, dispatch, view) => {
  let { $head, empty: empty2 } = state.selection, $cut = $head;
  if (!empty2)
    return false;
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size)
      return false;
    $cut = findCutAfter($head);
  }
  let node = $cut && $cut.nodeAfter;
  if (!node || !NodeSelection.isSelectable(node))
    return false;
  if (dispatch)
    dispatch(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos)).scrollIntoView());
  return true;
};
function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating)
    for (let i = $pos.depth - 1; i >= 0; i--) {
      let parent = $pos.node(i);
      if ($pos.index(i) + 1 < parent.childCount)
        return $pos.doc.resolve($pos.after(i + 1));
      if (parent.type.spec.isolating)
        break;
    }
  return null;
}
var joinUp = (state, dispatch) => {
  let sel = state.selection, nodeSel = sel instanceof NodeSelection, point;
  if (nodeSel) {
    if (sel.node.isTextblock || !canJoin(state.doc, sel.from))
      return false;
    point = sel.from;
  } else {
    point = joinPoint(state.doc, sel.from, -1);
    if (point == null)
      return false;
  }
  if (dispatch) {
    let tr2 = state.tr.join(point);
    if (nodeSel)
      tr2.setSelection(NodeSelection.create(tr2.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
    dispatch(tr2.scrollIntoView());
  }
  return true;
};
var joinDown = (state, dispatch) => {
  let sel = state.selection, point;
  if (sel instanceof NodeSelection) {
    if (sel.node.isTextblock || !canJoin(state.doc, sel.to))
      return false;
    point = sel.to;
  } else {
    point = joinPoint(state.doc, sel.to, 1);
    if (point == null)
      return false;
  }
  if (dispatch)
    dispatch(state.tr.join(point).scrollIntoView());
  return true;
};
var lift2 = (state, dispatch) => {
  let { $from, $to } = state.selection;
  let range = $from.blockRange($to), target = range && liftTarget(range);
  if (target == null)
    return false;
  if (dispatch)
    dispatch(state.tr.lift(range, target).scrollIntoView());
  return true;
};
var newlineInCode = (state, dispatch) => {
  let { $head, $anchor } = state.selection;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor))
    return false;
  if (dispatch)
    dispatch(state.tr.insertText("\n").scrollIntoView());
  return true;
};
function defaultBlockAt(match) {
  for (let i = 0; i < match.edgeCount; i++) {
    let { type } = match.edge(i);
    if (type.isTextblock && !type.hasRequiredAttrs())
      return type;
  }
  return null;
}
var exitCode = (state, dispatch) => {
  let { $head, $anchor } = state.selection;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor))
    return false;
  let above = $head.node(-1), after = $head.indexAfter(-1), type = defaultBlockAt(above.contentMatchAt(after));
  if (!type || !above.canReplaceWith(after, after, type))
    return false;
  if (dispatch) {
    let pos = $head.after(), tr2 = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr2.setSelection(Selection.near(tr2.doc.resolve(pos), 1));
    dispatch(tr2.scrollIntoView());
  }
  return true;
};
var createParagraphNear = (state, dispatch) => {
  let sel = state.selection, { $from, $to } = sel;
  if (sel instanceof AllSelection || $from.parent.inlineContent || $to.parent.inlineContent)
    return false;
  let type = defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
  if (!type || !type.isTextblock)
    return false;
  if (dispatch) {
    let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    let tr2 = state.tr.insert(side, type.createAndFill());
    tr2.setSelection(TextSelection.create(tr2.doc, side + 1));
    dispatch(tr2.scrollIntoView());
  }
  return true;
};
var liftEmptyBlock = (state, dispatch) => {
  let { $cursor } = state.selection;
  if (!$cursor || $cursor.parent.content.size)
    return false;
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    let before = $cursor.before();
    if (canSplit(state.doc, before)) {
      if (dispatch)
        dispatch(state.tr.split(before).scrollIntoView());
      return true;
    }
  }
  let range = $cursor.blockRange(), target = range && liftTarget(range);
  if (target == null)
    return false;
  if (dispatch)
    dispatch(state.tr.lift(range, target).scrollIntoView());
  return true;
};
function splitBlockAs(splitNode) {
  return (state, dispatch) => {
    let { $from, $to } = state.selection;
    if (state.selection instanceof NodeSelection && state.selection.node.isBlock) {
      if (!$from.parentOffset || !canSplit(state.doc, $from.pos))
        return false;
      if (dispatch)
        dispatch(state.tr.split($from.pos).scrollIntoView());
      return true;
    }
    if (!$from.depth)
      return false;
    let types = [];
    let splitDepth, deflt, atEnd = false, atStart = false;
    for (let d = $from.depth; ; d--) {
      let node = $from.node(d);
      if (node.isBlock) {
        atEnd = $from.end(d) == $from.pos + ($from.depth - d);
        atStart = $from.start(d) == $from.pos - ($from.depth - d);
        deflt = defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
        types.unshift((atEnd && deflt ? { type: deflt } : null));
        splitDepth = d;
        break;
      } else {
        if (d == 1)
          return false;
        types.unshift(null);
      }
    }
    let tr2 = state.tr;
    if (state.selection instanceof TextSelection || state.selection instanceof AllSelection)
      tr2.deleteSelection();
    let splitPos = tr2.mapping.map($from.pos);
    let can = canSplit(tr2.doc, splitPos, types.length, types);
    if (!can) {
      types[0] = deflt ? { type: deflt } : null;
      can = canSplit(tr2.doc, splitPos, types.length, types);
    }
    if (!can)
      return false;
    tr2.split(splitPos, types.length, types);
    if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
      let first2 = tr2.mapping.map($from.before(splitDepth)), $first = tr2.doc.resolve(first2);
      if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt))
        tr2.setNodeMarkup(tr2.mapping.map($from.before(splitDepth)), deflt);
    }
    if (dispatch)
      dispatch(tr2.scrollIntoView());
    return true;
  };
}
var splitBlock = splitBlockAs();
var selectParentNode = (state, dispatch) => {
  let { $from, to } = state.selection, pos;
  let same = $from.sharedDepth(to);
  if (same == 0)
    return false;
  pos = $from.before(same);
  if (dispatch)
    dispatch(state.tr.setSelection(NodeSelection.create(state.doc, pos)));
  return true;
};
function joinMaybeClear(state, $pos, dispatch) {
  let before = $pos.nodeBefore, after = $pos.nodeAfter, index2 = $pos.index();
  if (!before || !after || !before.type.compatibleContent(after.type))
    return false;
  if (!before.content.size && $pos.parent.canReplace(index2 - 1, index2)) {
    if (dispatch)
      dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
    return true;
  }
  if (!$pos.parent.canReplace(index2, index2 + 1) || !(after.isTextblock || canJoin(state.doc, $pos.pos)))
    return false;
  if (dispatch)
    dispatch(state.tr.join($pos.pos).scrollIntoView());
  return true;
}
function deleteBarrier(state, $cut, dispatch, dir) {
  let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
  let isolated = before.type.spec.isolating || after.type.spec.isolating;
  if (!isolated && joinMaybeClear(state, $cut, dispatch))
    return true;
  let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
  if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
    if (dispatch) {
      let end2 = $cut.pos + after.nodeSize, wrap2 = Fragment6.empty;
      for (let i = conn.length - 1; i >= 0; i--)
        wrap2 = Fragment6.from(conn[i].create(null, wrap2));
      wrap2 = Fragment6.from(before.copy(wrap2));
      let tr2 = state.tr.step(new ReplaceAroundStep($cut.pos - 1, end2, $cut.pos, end2, new Slice(wrap2, 1, 0), conn.length, true));
      let $joinAt = tr2.doc.resolve(end2 + 2 * conn.length);
      if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && canJoin(tr2.doc, $joinAt.pos))
        tr2.join($joinAt.pos);
      dispatch(tr2.scrollIntoView());
    }
    return true;
  }
  let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : Selection.findFrom($cut, 1);
  let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && liftTarget(range);
  if (target != null && target >= $cut.depth) {
    if (dispatch)
      dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
  }
  if (canDelAfter && textblockAt(after, "start", true) && textblockAt(before, "end")) {
    let at = before, wrap2 = [];
    for (; ; ) {
      wrap2.push(at);
      if (at.isTextblock)
        break;
      at = at.lastChild;
    }
    let afterText = after, afterDepth = 1;
    for (; !afterText.isTextblock; afterText = afterText.firstChild)
      afterDepth++;
    if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
      if (dispatch) {
        let end2 = Fragment6.empty;
        for (let i = wrap2.length - 1; i >= 0; i--)
          end2 = Fragment6.from(wrap2[i].copy(end2));
        let tr2 = state.tr.step(new ReplaceAroundStep($cut.pos - wrap2.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new Slice(end2, wrap2.length, 0), 0, true));
        dispatch(tr2.scrollIntoView());
      }
      return true;
    }
  }
  return false;
}
function selectTextblockSide(side) {
  return function(state, dispatch) {
    let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
    let depth = $pos.depth;
    while ($pos.node(depth).isInline) {
      if (!depth)
        return false;
      depth--;
    }
    if (!$pos.node(depth).isTextblock)
      return false;
    if (dispatch)
      dispatch(state.tr.setSelection(TextSelection.create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
    return true;
  };
}
var selectTextblockStart = selectTextblockSide(-1);
var selectTextblockEnd = selectTextblockSide(1);
function wrapIn(nodeType, attrs = null) {
  return function(state, dispatch) {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to), wrapping = range && findWrapping(range, nodeType, attrs);
    if (!wrapping)
      return false;
    if (dispatch)
      dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
    return true;
  };
}
function setBlockType2(nodeType, attrs = null) {
  return function(state, dispatch) {
    let applicable = false;
    for (let i = 0; i < state.selection.ranges.length && !applicable; i++) {
      let { $from: { pos: from2 }, $to: { pos: to } } = state.selection.ranges[i];
      state.doc.nodesBetween(from2, to, (node, pos) => {
        if (applicable)
          return false;
        if (!node.isTextblock || node.hasMarkup(nodeType, attrs))
          return;
        if (node.type == nodeType) {
          applicable = true;
        } else {
          let $pos = state.doc.resolve(pos), index2 = $pos.index();
          applicable = $pos.parent.canReplaceWith(index2, index2 + 1, nodeType);
        }
      });
    }
    if (!applicable)
      return false;
    if (dispatch) {
      let tr2 = state.tr;
      for (let i = 0; i < state.selection.ranges.length; i++) {
        let { $from: { pos: from2 }, $to: { pos: to } } = state.selection.ranges[i];
        tr2.setBlockType(from2, to, nodeType, attrs);
      }
      dispatch(tr2.scrollIntoView());
    }
    return true;
  };
}
function chainCommands(...commands) {
  return function(state, dispatch, view) {
    for (let i = 0; i < commands.length; i++)
      if (commands[i](state, dispatch, view))
        return true;
    return false;
  };
}
chainCommands(deleteSelection, joinBackward, selectNodeBackward);
chainCommands(deleteSelection, joinForward, selectNodeForward);
({
  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock)});
typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;

// ../../node_modules/.pnpm/prosemirror-schema-list@1.5.1/node_modules/prosemirror-schema-list/dist/index.js
function wrapInList(listType, attrs = null) {
  return function(state, dispatch) {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to);
    if (!range)
      return false;
    let tr2 = dispatch ? state.tr : null;
    if (!wrapRangeInList(tr2, range, listType, attrs))
      return false;
    if (dispatch)
      dispatch(tr2.scrollIntoView());
    return true;
  };
}
function wrapRangeInList(tr2, range, listType, attrs = null) {
  let doJoin = false, outerRange = range, doc3 = range.$from.doc;
  if (range.depth >= 2 && range.$from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
    if (range.$from.index(range.depth - 1) == 0)
      return false;
    let $insert = doc3.resolve(range.start - 2);
    outerRange = new NodeRange($insert, $insert, range.depth);
    if (range.endIndex < range.parent.childCount)
      range = new NodeRange(range.$from, doc3.resolve(range.$to.end(range.depth)), range.depth);
    doJoin = true;
  }
  let wrap2 = findWrapping(outerRange, listType, attrs, range);
  if (!wrap2)
    return false;
  if (tr2)
    doWrapInList(tr2, range, wrap2, doJoin, listType);
  return true;
}
function doWrapInList(tr2, range, wrappers, joinBefore, listType) {
  let content = Fragment6.empty;
  for (let i = wrappers.length - 1; i >= 0; i--)
    content = Fragment6.from(wrappers[i].type.create(wrappers[i].attrs, content));
  tr2.step(new ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new Slice(content, 0, 0), wrappers.length, true));
  let found2 = 0;
  for (let i = 0; i < wrappers.length; i++)
    if (wrappers[i].type == listType)
      found2 = i + 1;
  let splitDepth = wrappers.length - found2;
  let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
  for (let i = range.startIndex, e = range.endIndex, first2 = true; i < e; i++, first2 = false) {
    if (!first2 && canSplit(tr2.doc, splitPos, splitDepth)) {
      tr2.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent.child(i).nodeSize;
  }
  return tr2;
}
function liftListItem(itemType) {
  return function(state, dispatch) {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to, (node) => node.childCount > 0 && node.firstChild.type == itemType);
    if (!range)
      return false;
    if (!dispatch)
      return true;
    if ($from.node(range.depth - 1).type == itemType)
      return liftToOuterList(state, dispatch, itemType, range);
    else
      return liftOutOfList(state, dispatch, range);
  };
}
function liftToOuterList(state, dispatch, itemType, range) {
  let tr2 = state.tr, end2 = range.end, endOfList = range.$to.end(range.depth);
  if (end2 < endOfList) {
    tr2.step(new ReplaceAroundStep(end2 - 1, endOfList, end2, endOfList, new Slice(Fragment6.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new NodeRange(tr2.doc.resolve(range.$from.pos), tr2.doc.resolve(endOfList), range.depth);
  }
  const target = liftTarget(range);
  if (target == null)
    return false;
  tr2.lift(range, target);
  let $after = tr2.doc.resolve(tr2.mapping.map(end2, -1) - 1);
  if (canJoin(tr2.doc, $after.pos) && $after.nodeBefore.type == $after.nodeAfter.type)
    tr2.join($after.pos);
  dispatch(tr2.scrollIntoView());
  return true;
}
function liftOutOfList(state, dispatch, range) {
  let tr2 = state.tr, list = range.parent;
  for (let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    tr2.delete(pos - 1, pos + 1);
  }
  let $start = tr2.doc.resolve(range.start), item = $start.nodeAfter;
  if (tr2.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize)
    return false;
  let atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
  let parent = $start.node(-1), indexBefore = $start.index(-1);
  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? Fragment6.empty : Fragment6.from(list))))
    return false;
  let start2 = $start.pos, end2 = start2 + item.nodeSize;
  tr2.step(new ReplaceAroundStep(start2 - (atStart ? 1 : 0), end2 + (atEnd ? 1 : 0), start2 + 1, end2 - 1, new Slice((atStart ? Fragment6.empty : Fragment6.from(list.copy(Fragment6.empty))).append(atEnd ? Fragment6.empty : Fragment6.from(list.copy(Fragment6.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
  dispatch(tr2.scrollIntoView());
  return true;
}
function sinkListItem(itemType) {
  return function(state, dispatch) {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to, (node) => node.childCount > 0 && node.firstChild.type == itemType);
    if (!range)
      return false;
    let startIndex = range.startIndex;
    if (startIndex == 0)
      return false;
    let parent = range.parent, nodeBefore = parent.child(startIndex - 1);
    if (nodeBefore.type != itemType)
      return false;
    if (dispatch) {
      let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
      let inner = Fragment6.from(nestedBefore ? itemType.create() : null);
      let slice2 = new Slice(Fragment6.from(itemType.create(null, Fragment6.from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
      let before = range.start, after = range.end;
      dispatch(state.tr.step(new ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after, before, after, slice2, 1, true)).scrollIntoView());
    }
    return true;
  };
}

// ../../node_modules/.pnpm/prosemirror-view@1.41.4/node_modules/prosemirror-view/dist/index.js
var domIndex = function(node) {
  for (var index2 = 0; ; index2++) {
    node = node.previousSibling;
    if (!node)
      return index2;
  }
};
var parentNode = function(node) {
  let parent = node.assignedSlot || node.parentNode;
  return parent && parent.nodeType == 11 ? parent.host : parent;
};
var reusedRange = null;
var textRange = function(node, from2, to) {
  let range = reusedRange || (reusedRange = document.createRange());
  range.setEnd(node, to == null ? node.nodeValue.length : to);
  range.setStart(node, from2 || 0);
  return range;
};
var clearReusedRange = function() {
  reusedRange = null;
};
var isEquivalentPosition = function(node, off, targetNode, targetOff) {
  return targetNode && (scanFor(node, off, targetNode, targetOff, -1) || scanFor(node, off, targetNode, targetOff, 1));
};
var atomElements = /^(img|br|input|textarea|hr)$/i;
function scanFor(node, off, targetNode, targetOff, dir) {
  var _a;
  for (; ; ) {
    if (node == targetNode && off == targetOff)
      return true;
    if (off == (dir < 0 ? 0 : nodeSize(node))) {
      let parent = node.parentNode;
      if (!parent || parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) || node.contentEditable == "false")
        return false;
      off = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      let child = node.childNodes[off + (dir < 0 ? -1 : 0)];
      if (child.nodeType == 1 && child.contentEditable == "false") {
        if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection)
          off += dir;
        else
          return false;
      } else {
        node = child;
        off = dir < 0 ? nodeSize(node) : 0;
      }
    } else {
      return false;
    }
  }
}
function nodeSize(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function textNodeBefore$1(node, offset5) {
  for (; ; ) {
    if (node.nodeType == 3 && offset5)
      return node;
    if (node.nodeType == 1 && offset5 > 0) {
      if (node.contentEditable == "false")
        return null;
      node = node.childNodes[offset5 - 1];
      offset5 = nodeSize(node);
    } else if (node.parentNode && !hasBlockDesc(node)) {
      offset5 = domIndex(node);
      node = node.parentNode;
    } else {
      return null;
    }
  }
}
function textNodeAfter$1(node, offset5) {
  for (; ; ) {
    if (node.nodeType == 3 && offset5 < node.nodeValue.length)
      return node;
    if (node.nodeType == 1 && offset5 < node.childNodes.length) {
      if (node.contentEditable == "false")
        return null;
      node = node.childNodes[offset5];
      offset5 = 0;
    } else if (node.parentNode && !hasBlockDesc(node)) {
      offset5 = domIndex(node) + 1;
      node = node.parentNode;
    } else {
      return null;
    }
  }
}
function isOnEdge(node, offset5, parent) {
  for (let atStart = offset5 == 0, atEnd = offset5 == nodeSize(node); atStart || atEnd; ) {
    if (node == parent)
      return true;
    let index2 = domIndex(node);
    node = node.parentNode;
    if (!node)
      return false;
    atStart = atStart && index2 == 0;
    atEnd = atEnd && index2 == nodeSize(node);
  }
}
function hasBlockDesc(dom) {
  let desc;
  for (let cur = dom; cur; cur = cur.parentNode)
    if (desc = cur.pmViewDesc)
      break;
  return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
var selectionCollapsed = function(domSel) {
  return domSel.focusNode && isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function keyEvent(keyCode, key) {
  let event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key;
  return event;
}
function deepActiveElement(doc3) {
  let elt = doc3.activeElement;
  while (elt && elt.shadowRoot)
    elt = elt.shadowRoot.activeElement;
  return elt;
}
function caretFromPoint(doc3, x, y) {
  if (doc3.caretPositionFromPoint) {
    try {
      let pos = doc3.caretPositionFromPoint(x, y);
      if (pos)
        return { node: pos.offsetNode, offset: Math.min(nodeSize(pos.offsetNode), pos.offset) };
    } catch (_) {
    }
  }
  if (doc3.caretRangeFromPoint) {
    let range = doc3.caretRangeFromPoint(x, y);
    if (range)
      return { node: range.startContainer, offset: Math.min(nodeSize(range.startContainer), range.startOffset) };
  }
}
var nav = typeof navigator != "undefined" ? navigator : null;
var doc2 = typeof document != "undefined" ? document : null;
var agent = nav && nav.userAgent || "";
var ie_edge = /Edge\/(\d+)/.exec(agent);
var ie_upto10 = /MSIE \d/.exec(agent);
var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(agent);
var ie = !!(ie_upto10 || ie_11up || ie_edge);
var ie_version = ie_upto10 ? document.documentMode : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0;
var gecko = !ie && /gecko\/(\d+)/i.test(agent);
gecko && +(/Firefox\/(\d+)/.exec(agent) || [0, 0])[1];
var _chrome = !ie && /Chrome\/(\d+)/.exec(agent);
var chrome = !!_chrome;
var chrome_version = _chrome ? +_chrome[1] : 0;
var safari = !ie && !!nav && /Apple Computer/.test(nav.vendor);
var ios = safari && (/Mobile\/\w+/.test(agent) || !!nav && nav.maxTouchPoints > 2);
var mac2 = ios || (nav ? /Mac/.test(nav.platform) : false);
var windows = nav ? /Win/.test(nav.platform) : false;
var android = /Android \d/.test(agent);
var webkit = !!doc2 && "webkitFontSmoothing" in doc2.documentElement.style;
var webkit_version = webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function windowRect(doc3) {
  let vp = doc3.defaultView && doc3.defaultView.visualViewport;
  if (vp)
    return {
      left: 0,
      right: vp.width,
      top: 0,
      bottom: vp.height
    };
  return {
    left: 0,
    right: doc3.documentElement.clientWidth,
    top: 0,
    bottom: doc3.documentElement.clientHeight
  };
}
function getSide(value, side) {
  return typeof value == "number" ? value : value[side];
}
function clientRect(node) {
  let rect = node.getBoundingClientRect();
  let scaleX = rect.width / node.offsetWidth || 1;
  let scaleY = rect.height / node.offsetHeight || 1;
  return {
    left: rect.left,
    right: rect.left + node.clientWidth * scaleX,
    top: rect.top,
    bottom: rect.top + node.clientHeight * scaleY
  };
}
function scrollRectIntoView(view, rect, startDOM) {
  let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
  let doc3 = view.dom.ownerDocument;
  for (let parent = startDOM || view.dom; ; ) {
    if (!parent)
      break;
    if (parent.nodeType != 1) {
      parent = parentNode(parent);
      continue;
    }
    let elt = parent;
    let atTop = elt == doc3.body;
    let bounding = atTop ? windowRect(doc3) : clientRect(elt);
    let moveX = 0, moveY = 0;
    if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
      moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top"));
    else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
      moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom");
    if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
      moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left"));
    else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
      moveX = rect.right - bounding.right + getSide(scrollMargin, "right");
    if (moveX || moveY) {
      if (atTop) {
        doc3.defaultView.scrollBy(moveX, moveY);
      } else {
        let startX = elt.scrollLeft, startY = elt.scrollTop;
        if (moveY)
          elt.scrollTop += moveY;
        if (moveX)
          elt.scrollLeft += moveX;
        let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
        rect = { left: rect.left - dX, top: rect.top - dY, right: rect.right - dX, bottom: rect.bottom - dY };
      }
    }
    let pos = atTop ? "fixed" : getComputedStyle(parent).position;
    if (/^(fixed|sticky)$/.test(pos))
      break;
    parent = pos == "absolute" ? parent.offsetParent : parentNode(parent);
  }
}
function storeScrollPos(view) {
  let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
  let refDOM, refTop;
  for (let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5) {
    let dom = view.root.elementFromPoint(x, y);
    if (!dom || dom == view.dom || !view.dom.contains(dom))
      continue;
    let localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break;
    }
  }
  return { refDOM, refTop, stack: scrollStack(view.dom) };
}
function scrollStack(dom) {
  let stack = [], doc3 = dom.ownerDocument;
  for (let cur = dom; cur; cur = parentNode(cur)) {
    stack.push({ dom: cur, top: cur.scrollTop, left: cur.scrollLeft });
    if (dom == doc3)
      break;
  }
  return stack;
}
function resetScrollPos({ refDOM, refTop, stack }) {
  let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function restoreScrollStack(stack, dTop) {
  for (let i = 0; i < stack.length; i++) {
    let { dom, top: top2, left: left2 } = stack[i];
    if (dom.scrollTop != top2 + dTop)
      dom.scrollTop = top2 + dTop;
    if (dom.scrollLeft != left2)
      dom.scrollLeft = left2;
  }
}
var preventScrollSupported = null;
function focusPreventScroll(dom) {
  if (dom.setActive)
    return dom.setActive();
  if (preventScrollSupported)
    return dom.focus(preventScrollSupported);
  let stored = scrollStack(dom);
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = { preventScroll: true };
      return true;
    }
  } : void 0);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    restoreScrollStack(stored, 0);
  }
}
function findOffsetInNode(node, coords) {
  let closest, dxClosest = 2e8, coordsClosest, offset5 = 0;
  let rowBot = coords.top, rowTop = coords.top;
  let firstBelow, coordsBelow;
  for (let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
    let rects;
    if (child.nodeType == 1)
      rects = child.getClientRects();
    else if (child.nodeType == 3)
      rects = textRange(child).getClientRects();
    else
      continue;
    for (let i = 0; i < rects.length; i++) {
      let rect = rects[i];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest = child;
          dxClosest = dx;
          coordsClosest = dx && closest.nodeType == 3 ? {
            left: rect.right < coords.left ? rect.right : rect.left,
            top: coords.top
          } : coords;
          if (child.nodeType == 1 && dx)
            offset5 = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
          continue;
        }
      } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
        firstBelow = child;
        coordsBelow = { left: Math.max(rect.left, Math.min(rect.right, coords.left)), top: rect.top };
      }
      if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom))
        offset5 = childIndex + 1;
    }
  }
  if (!closest && firstBelow) {
    closest = firstBelow;
    coordsClosest = coordsBelow;
    dxClosest = 0;
  }
  if (closest && closest.nodeType == 3)
    return findOffsetInText(closest, coordsClosest);
  if (!closest || dxClosest && closest.nodeType == 1)
    return { node, offset: offset5 };
  return findOffsetInNode(closest, coordsClosest);
}
function findOffsetInText(node, coords) {
  let len = node.nodeValue.length;
  let range = document.createRange(), result;
  for (let i = 0; i < len; i++) {
    range.setEnd(node, i + 1);
    range.setStart(node, i);
    let rect = singleRect(range, 1);
    if (rect.top == rect.bottom)
      continue;
    if (inRect(coords, rect)) {
      result = { node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0) };
      break;
    }
  }
  range.detach();
  return result || { node, offset: 0 };
}
function inRect(coords, rect) {
  return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function targetKludge(dom, coords) {
  let parent = dom.parentNode;
  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
    return parent;
  return dom;
}
function posFromElement(view, elt, coords) {
  let { node, offset: offset5 } = findOffsetInNode(elt, coords), bias = -1;
  if (node.nodeType == 1 && !node.firstChild) {
    let rect = node.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node, offset5, bias);
}
function posFromCaret(view, node, offset5, coords) {
  let outsideBlock = -1;
  for (let cur = node, sawBlock = false; ; ) {
    if (cur == view.dom)
      break;
    let desc = view.docView.nearestDesc(cur, true), rect;
    if (!desc)
      return null;
    if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
      if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
        if (!sawBlock && rect.left > coords.left || rect.top > coords.top)
          outsideBlock = desc.posBefore;
        else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top)
          outsideBlock = desc.posAfter;
        sawBlock = true;
      }
      if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
        let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
        return before ? desc.posBefore : desc.posAfter;
      }
    }
    cur = desc.dom.parentNode;
  }
  return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset5, -1);
}
function elementFromPoint(element, coords, box) {
  let len = element.childNodes.length;
  if (len && box.top < box.bottom) {
    for (let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI; ; ) {
      let child = element.childNodes[i];
      if (child.nodeType == 1) {
        let rects = child.getClientRects();
        for (let j = 0; j < rects.length; j++) {
          let rect = rects[j];
          if (inRect(coords, rect))
            return elementFromPoint(child, coords, rect);
        }
      }
      if ((i = (i + 1) % len) == startI)
        break;
    }
  }
  return element;
}
function posAtCoords(view, coords) {
  let doc3 = view.dom.ownerDocument, node, offset5 = 0;
  let caret = caretFromPoint(doc3, coords.left, coords.top);
  if (caret)
    ({ node, offset: offset5 } = caret);
  let elt = (view.root.elementFromPoint ? view.root : doc3).elementFromPoint(coords.left, coords.top);
  let pos;
  if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
    let box = view.dom.getBoundingClientRect();
    if (!inRect(coords, box))
      return null;
    elt = elementFromPoint(view.dom, coords, box);
    if (!elt)
      return null;
  }
  if (safari) {
    for (let p = elt; node && p; p = parentNode(p))
      if (p.draggable)
        node = void 0;
  }
  elt = targetKludge(elt, coords);
  if (node) {
    if (gecko && node.nodeType == 1) {
      offset5 = Math.min(offset5, node.childNodes.length);
      if (offset5 < node.childNodes.length) {
        let next = node.childNodes[offset5], box;
        if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top)
          offset5++;
      }
    }
    let prev;
    if (webkit && offset5 && node.nodeType == 1 && (prev = node.childNodes[offset5 - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top)
      offset5--;
    if (node == view.dom && offset5 == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom)
      pos = view.state.doc.content.size;
    else if (offset5 == 0 || node.nodeType != 1 || node.childNodes[offset5 - 1].nodeName != "BR")
      pos = posFromCaret(view, node, offset5, coords);
  }
  if (pos == null)
    pos = posFromElement(view, elt, coords);
  let desc = view.docView.nearestDesc(elt, true);
  return { pos, inside: desc ? desc.posAtStart - desc.border : -1 };
}
function nonZero(rect) {
  return rect.top < rect.bottom || rect.left < rect.right;
}
function singleRect(target, bias) {
  let rects = target.getClientRects();
  if (rects.length) {
    let first2 = rects[bias < 0 ? 0 : rects.length - 1];
    if (nonZero(first2))
      return first2;
  }
  return Array.prototype.find.call(rects, nonZero) || target.getBoundingClientRect();
}
var BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function coordsAtPos(view, pos, side) {
  let { node, offset: offset5, atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
  let supportEmptyRange = webkit || gecko;
  if (node.nodeType == 3) {
    if (supportEmptyRange && (BIDI.test(node.nodeValue) || (side < 0 ? !offset5 : offset5 == node.nodeValue.length))) {
      let rect = singleRect(textRange(node, offset5, offset5), side);
      if (gecko && offset5 && /\s/.test(node.nodeValue[offset5 - 1]) && offset5 < node.nodeValue.length) {
        let rectBefore = singleRect(textRange(node, offset5 - 1, offset5 - 1), -1);
        if (rectBefore.top == rect.top) {
          let rectAfter = singleRect(textRange(node, offset5, offset5 + 1), -1);
          if (rectAfter.top != rect.top)
            return flattenV(rectAfter, rectAfter.left < rectBefore.left);
        }
      }
      return rect;
    } else {
      let from2 = offset5, to = offset5, takeSide = side < 0 ? 1 : -1;
      if (side < 0 && !offset5) {
        to++;
        takeSide = -1;
      } else if (side >= 0 && offset5 == node.nodeValue.length) {
        from2--;
        takeSide = 1;
      } else if (side < 0) {
        from2--;
      } else {
        to++;
      }
      return flattenV(singleRect(textRange(node, from2, to), takeSide), takeSide < 0);
    }
  }
  let $dom = view.state.doc.resolve(pos - (atom || 0));
  if (!$dom.parent.inlineContent) {
    if (atom == null && offset5 && (side < 0 || offset5 == nodeSize(node))) {
      let before = node.childNodes[offset5 - 1];
      if (before.nodeType == 1)
        return flattenH(before.getBoundingClientRect(), false);
    }
    if (atom == null && offset5 < nodeSize(node)) {
      let after = node.childNodes[offset5];
      if (after.nodeType == 1)
        return flattenH(after.getBoundingClientRect(), true);
    }
    return flattenH(node.getBoundingClientRect(), side >= 0);
  }
  if (atom == null && offset5 && (side < 0 || offset5 == nodeSize(node))) {
    let before = node.childNodes[offset5 - 1];
    let target = before.nodeType == 3 ? textRange(before, nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
    if (target)
      return flattenV(singleRect(target, 1), false);
  }
  if (atom == null && offset5 < nodeSize(node)) {
    let after = node.childNodes[offset5];
    while (after.pmViewDesc && after.pmViewDesc.ignoreForCoords)
      after = after.nextSibling;
    let target = !after ? null : after.nodeType == 3 ? textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
    if (target)
      return flattenV(singleRect(target, -1), true);
  }
  return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, -side), side >= 0);
}
function flattenV(rect, left2) {
  if (rect.width == 0)
    return rect;
  let x = left2 ? rect.left : rect.right;
  return { top: rect.top, bottom: rect.bottom, left: x, right: x };
}
function flattenH(rect, top2) {
  if (rect.height == 0)
    return rect;
  let y = top2 ? rect.top : rect.bottom;
  return { top: y, bottom: y, left: rect.left, right: rect.right };
}
function withFlushedState(view, state, f) {
  let viewState = view.state, active = view.root.activeElement;
  if (viewState != state)
    view.updateState(state);
  if (active != view.dom)
    view.focus();
  try {
    return f();
  } finally {
    if (viewState != state)
      view.updateState(viewState);
    if (active != view.dom && active)
      active.focus();
  }
}
function endOfTextblockVertical(view, state, dir) {
  let sel = state.selection;
  let $pos = dir == "up" ? sel.$from : sel.$to;
  return withFlushedState(view, state, () => {
    let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
    for (; ; ) {
      let nearest = view.docView.nearestDesc(dom, true);
      if (!nearest)
        break;
      if (nearest.node.isBlock) {
        dom = nearest.contentDOM || nearest.dom;
        break;
      }
      dom = nearest.dom.parentNode;
    }
    let coords = coordsAtPos(view, $pos.pos, 1);
    for (let child = dom.firstChild; child; child = child.nextSibling) {
      let boxes;
      if (child.nodeType == 1)
        boxes = child.getClientRects();
      else if (child.nodeType == 3)
        boxes = textRange(child, 0, child.nodeValue.length).getClientRects();
      else
        continue;
      for (let i = 0; i < boxes.length; i++) {
        let box = boxes[i];
        if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2))
          return false;
      }
    }
    return true;
  });
}
var maybeRTL = /[\u0590-\u08ac]/;
function endOfTextblockHorizontal(view, state, dir) {
  let { $head } = state.selection;
  if (!$head.parent.isTextblock)
    return false;
  let offset5 = $head.parentOffset, atStart = !offset5, atEnd = offset5 == $head.parent.content.size;
  let sel = view.domSelection();
  if (!sel)
    return $head.pos == $head.start() || $head.pos == $head.end();
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
    return dir == "left" || dir == "backward" ? atStart : atEnd;
  return withFlushedState(view, state, () => {
    let { focusNode: oldNode, focusOffset: oldOff, anchorNode, anchorOffset } = view.domSelectionRange();
    let oldBidiLevel = sel.caretBidiLevel;
    sel.modify("move", dir, "character");
    let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
    let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
    let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
    try {
      sel.collapse(anchorNode, anchorOffset);
      if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend)
        sel.extend(oldNode, oldOff);
    } catch (_) {
    }
    if (oldBidiLevel != null)
      sel.caretBidiLevel = oldBidiLevel;
    return result;
  });
}
var cachedState = null;
var cachedDir = null;
var cachedResult = false;
function endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir)
    return cachedResult;
  cachedState = state;
  cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down" ? endOfTextblockVertical(view, state, dir) : endOfTextblockHorizontal(view, state, dir);
}
var NOT_DIRTY = 0;
var CHILD_DIRTY = 1;
var CONTENT_DIRTY = 2;
var NODE_DIRTY = 3;
var ViewDesc = class {
  constructor(parent, children, dom, contentDOM) {
    this.parent = parent;
    this.children = children;
    this.dom = dom;
    this.contentDOM = contentDOM;
    this.dirty = NOT_DIRTY;
    dom.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(widget) {
    return false;
  }
  matchesMark(mark) {
    return false;
  }
  matchesNode(node, outerDeco, innerDeco) {
    return false;
  }
  matchesHack(nodeName) {
    return false;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(event) {
    return false;
  }
  // The size of the content represented by this desc.
  get size() {
    let size4 = 0;
    for (let i = 0; i < this.children.length; i++)
      size4 += this.children[i].size;
    return size4;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0;
    if (this.dom.pmViewDesc == this)
      this.dom.pmViewDesc = void 0;
    for (let i = 0; i < this.children.length; i++)
      this.children[i].destroy();
  }
  posBeforeChild(child) {
    for (let i = 0, pos = this.posAtStart; ; i++) {
      let cur = this.children[i];
      if (cur == child)
        return pos;
      pos += cur.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(dom, offset5, bias) {
    if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
      if (bias < 0) {
        let domBefore, desc;
        if (dom == this.contentDOM) {
          domBefore = dom.childNodes[offset5 - 1];
        } else {
          while (dom.parentNode != this.contentDOM)
            dom = dom.parentNode;
          domBefore = dom.previousSibling;
        }
        while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))
          domBefore = domBefore.previousSibling;
        return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
      } else {
        let domAfter, desc;
        if (dom == this.contentDOM) {
          domAfter = dom.childNodes[offset5];
        } else {
          while (dom.parentNode != this.contentDOM)
            dom = dom.parentNode;
          domAfter = dom.nextSibling;
        }
        while (domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))
          domAfter = domAfter.nextSibling;
        return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
      }
    }
    let atEnd;
    if (dom == this.dom && this.contentDOM) {
      atEnd = offset5 > domIndex(this.contentDOM);
    } else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
      atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
    } else if (this.dom.firstChild) {
      if (offset5 == 0)
        for (let search = dom; ; search = search.parentNode) {
          if (search == this.dom) {
            atEnd = false;
            break;
          }
          if (search.previousSibling)
            break;
        }
      if (atEnd == null && offset5 == dom.childNodes.length)
        for (let search = dom; ; search = search.parentNode) {
          if (search == this.dom) {
            atEnd = true;
            break;
          }
          if (search.nextSibling)
            break;
        }
    }
    return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(dom, onlyNodes = false) {
    for (let first2 = true, cur = dom; cur; cur = cur.parentNode) {
      let desc = this.getDesc(cur), nodeDOM;
      if (desc && (!onlyNodes || desc.node)) {
        if (first2 && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom))
          first2 = false;
        else
          return desc;
      }
    }
  }
  getDesc(dom) {
    let desc = dom.pmViewDesc;
    for (let cur = desc; cur; cur = cur.parent)
      if (cur == this)
        return desc;
  }
  posFromDOM(dom, offset5, bias) {
    for (let scan = dom; scan; scan = scan.parentNode) {
      let desc = this.getDesc(scan);
      if (desc)
        return desc.localPosFromDOM(dom, offset5, bias);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(pos) {
    for (let i = 0, offset5 = 0; i < this.children.length; i++) {
      let child = this.children[i], end2 = offset5 + child.size;
      if (offset5 == pos && end2 != offset5) {
        while (!child.border && child.children.length) {
          for (let i2 = 0; i2 < child.children.length; i2++) {
            let inner = child.children[i2];
            if (inner.size) {
              child = inner;
              break;
            }
          }
        }
        return child;
      }
      if (pos < end2)
        return child.descAt(pos - offset5 - child.border);
      offset5 = end2;
    }
  }
  domFromPos(pos, side) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: pos + 1 };
    let i = 0, offset5 = 0;
    for (let curPos = 0; i < this.children.length; i++) {
      let child = this.children[i], end2 = curPos + child.size;
      if (end2 > pos || child instanceof TrailingHackViewDesc) {
        offset5 = pos - curPos;
        break;
      }
      curPos = end2;
    }
    if (offset5)
      return this.children[i].domFromPos(offset5 - this.children[i].border, side);
    for (let prev; i && !(prev = this.children[i - 1]).size && prev instanceof WidgetViewDesc && prev.side >= 0; i--) {
    }
    if (side <= 0) {
      let prev, enter2 = true;
      for (; ; i--, enter2 = false) {
        prev = i ? this.children[i - 1] : null;
        if (!prev || prev.dom.parentNode == this.contentDOM)
          break;
      }
      if (prev && side && enter2 && !prev.border && !prev.domAtom)
        return prev.domFromPos(prev.size, side);
      return { node: this.contentDOM, offset: prev ? domIndex(prev.dom) + 1 : 0 };
    } else {
      let next, enter2 = true;
      for (; ; i++, enter2 = false) {
        next = i < this.children.length ? this.children[i] : null;
        if (!next || next.dom.parentNode == this.contentDOM)
          break;
      }
      if (next && enter2 && !next.border && !next.domAtom)
        return next.domFromPos(0, side);
      return { node: this.contentDOM, offset: next ? domIndex(next.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(from2, to, base2 = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: from2, to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let fromOffset = -1, toOffset = -1;
    for (let offset5 = base2, i = 0; ; i++) {
      let child = this.children[i], end2 = offset5 + child.size;
      if (fromOffset == -1 && from2 <= end2) {
        let childBase = offset5 + child.border;
        if (from2 >= childBase && to <= end2 - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM))
          return child.parseRange(from2, to, childBase);
        from2 = offset5;
        for (let j = i; j > 0; j--) {
          let prev = this.children[j - 1];
          if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
            fromOffset = domIndex(prev.dom) + 1;
            break;
          }
          from2 -= prev.size;
        }
        if (fromOffset == -1)
          fromOffset = 0;
      }
      if (fromOffset > -1 && (end2 > to || i == this.children.length - 1)) {
        to = end2;
        for (let j = i + 1; j < this.children.length; j++) {
          let next = this.children[j];
          if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
            toOffset = domIndex(next.dom);
            break;
          }
          to += next.size;
        }
        if (toOffset == -1)
          toOffset = this.contentDOM.childNodes.length;
        break;
      }
      offset5 = end2;
    }
    return { node: this.contentDOM, from: from2, to, fromOffset, toOffset };
  }
  emptyChildAt(side) {
    if (this.border || !this.contentDOM || !this.children.length)
      return false;
    let child = this.children[side < 0 ? 0 : this.children.length - 1];
    return child.size == 0 || child.emptyChildAt(side);
  }
  domAfterPos(pos) {
    let { node, offset: offset5 } = this.domFromPos(pos, 0);
    if (node.nodeType != 1 || offset5 == node.childNodes.length)
      throw new RangeError("No node after pos " + pos);
    return node.childNodes[offset5];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(anchor, head, view, force = false) {
    let from2 = Math.min(anchor, head), to = Math.max(anchor, head);
    for (let i = 0, offset5 = 0; i < this.children.length; i++) {
      let child = this.children[i], end2 = offset5 + child.size;
      if (from2 > offset5 && to < end2)
        return child.setSelection(anchor - offset5 - child.border, head - offset5 - child.border, view, force);
      offset5 = end2;
    }
    let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
    let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
    let domSel = view.root.getSelection();
    let selRange = view.domSelectionRange();
    let brKludge = false;
    if ((gecko || safari) && anchor == head) {
      let { node, offset: offset5 } = anchorDOM;
      if (node.nodeType == 3) {
        brKludge = !!(offset5 && node.nodeValue[offset5 - 1] == "\n");
        if (brKludge && offset5 == node.nodeValue.length) {
          for (let scan = node, after; scan; scan = scan.parentNode) {
            if (after = scan.nextSibling) {
              if (after.nodeName == "BR")
                anchorDOM = headDOM = { node: after.parentNode, offset: domIndex(after) + 1 };
              break;
            }
            let desc = scan.pmViewDesc;
            if (desc && desc.node && desc.node.isBlock)
              break;
          }
        }
      } else {
        let prev = node.childNodes[offset5 - 1];
        brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
      }
    }
    if (gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
      let after = selRange.focusNode.childNodes[selRange.focusOffset];
      if (after && after.contentEditable == "false")
        force = true;
    }
    if (!(force || brKludge && safari) && isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset))
      return;
    let domSelExtended = false;
    if ((domSel.extend || anchor == head) && !(brKludge && gecko)) {
      domSel.collapse(anchorDOM.node, anchorDOM.offset);
      try {
        if (anchor != head)
          domSel.extend(headDOM.node, headDOM.offset);
        domSelExtended = true;
      } catch (_) {
      }
    }
    if (!domSelExtended) {
      if (anchor > head) {
        let tmp = anchorDOM;
        anchorDOM = headDOM;
        headDOM = tmp;
      }
      let range = document.createRange();
      range.setEnd(headDOM.node, headDOM.offset);
      range.setStart(anchorDOM.node, anchorDOM.offset);
      domSel.removeAllRanges();
      domSel.addRange(range);
    }
  }
  ignoreMutation(mutation) {
    return !this.contentDOM && mutation.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(from2, to) {
    for (let offset5 = 0, i = 0; i < this.children.length; i++) {
      let child = this.children[i], end2 = offset5 + child.size;
      if (offset5 == end2 ? from2 <= end2 && to >= offset5 : from2 < end2 && to > offset5) {
        let startInside = offset5 + child.border, endInside = end2 - child.border;
        if (from2 >= startInside && to <= endInside) {
          this.dirty = from2 == offset5 || to == end2 ? CONTENT_DIRTY : CHILD_DIRTY;
          if (from2 == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM))
            child.dirty = NODE_DIRTY;
          else
            child.markDirty(from2 - startInside, to - startInside);
          return;
        } else {
          child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? CONTENT_DIRTY : NODE_DIRTY;
        }
      }
      offset5 = end2;
    }
    this.dirty = CONTENT_DIRTY;
  }
  markParentsDirty() {
    let level = 1;
    for (let node = this.parent; node; node = node.parent, level++) {
      let dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
      if (node.dirty < dirty)
        node.dirty = dirty;
    }
  }
  get domAtom() {
    return false;
  }
  get ignoreForCoords() {
    return false;
  }
  get ignoreForSelection() {
    return false;
  }
  isText(text) {
    return false;
  }
};
var WidgetViewDesc = class extends ViewDesc {
  constructor(parent, widget, view, pos) {
    let self, dom = widget.type.toDOM;
    if (typeof dom == "function")
      dom = dom(view, () => {
        if (!self)
          return pos;
        if (self.parent)
          return self.parent.posBeforeChild(self);
      });
    if (!widget.type.spec.raw) {
      if (dom.nodeType != 1) {
        let wrap2 = document.createElement("span");
        wrap2.appendChild(dom);
        dom = wrap2;
      }
      dom.contentEditable = "false";
      dom.classList.add("ProseMirror-widget");
    }
    super(parent, [], dom, null);
    this.widget = widget;
    this.widget = widget;
    self = this;
  }
  matchesWidget(widget) {
    return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: true };
  }
  stopEvent(event) {
    let stop = this.widget.spec.stopEvent;
    return stop ? stop(event) : false;
  }
  ignoreMutation(mutation) {
    return mutation.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom);
    super.destroy();
  }
  get domAtom() {
    return true;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
};
var CompositionViewDesc = class extends ViewDesc {
  constructor(parent, dom, textDOM, text) {
    super(parent, [], dom, null);
    this.textDOM = textDOM;
    this.text = text;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(dom, offset5) {
    if (dom != this.textDOM)
      return this.posAtStart + (offset5 ? this.size : 0);
    return this.posAtStart + offset5;
  }
  domFromPos(pos) {
    return { node: this.textDOM, offset: pos };
  }
  ignoreMutation(mut) {
    return mut.type === "characterData" && mut.target.nodeValue == mut.oldValue;
  }
};
var MarkViewDesc = class _MarkViewDesc extends ViewDesc {
  constructor(parent, mark, dom, contentDOM, spec) {
    super(parent, [], dom, contentDOM);
    this.mark = mark;
    this.spec = spec;
  }
  static create(parent, mark, inline3, view) {
    let custom = view.nodeViews[mark.type.name];
    let spec = custom && custom(mark, view, inline3);
    if (!spec || !spec.dom)
      spec = DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline3), null, mark.attrs);
    return new _MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
  }
  parseRule() {
    if (this.dirty & NODE_DIRTY || this.mark.type.spec.reparseInView)
      return null;
    return { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(mark) {
    return this.dirty != NODE_DIRTY && this.mark.eq(mark);
  }
  markDirty(from2, to) {
    super.markDirty(from2, to);
    if (this.dirty != NOT_DIRTY) {
      let parent = this.parent;
      while (!parent.node)
        parent = parent.parent;
      if (parent.dirty < this.dirty)
        parent.dirty = this.dirty;
      this.dirty = NOT_DIRTY;
    }
  }
  slice(from2, to, view) {
    let copy2 = _MarkViewDesc.create(this.parent, this.mark, true, view);
    let nodes = this.children, size4 = this.size;
    if (to < size4)
      nodes = replaceNodes(nodes, to, size4, view);
    if (from2 > 0)
      nodes = replaceNodes(nodes, 0, from2, view);
    for (let i = 0; i < nodes.length; i++)
      nodes[i].parent = copy2;
    copy2.children = nodes;
    return copy2;
  }
  ignoreMutation(mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
  }
  destroy() {
    if (this.spec.destroy)
      this.spec.destroy();
    super.destroy();
  }
};
var NodeViewDesc = class _NodeViewDesc extends ViewDesc {
  constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
    super(parent, [], dom, contentDOM);
    this.node = node;
    this.outerDeco = outerDeco;
    this.innerDeco = innerDeco;
    this.nodeDOM = nodeDOM;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(parent, node, outerDeco, innerDeco, view, pos) {
    let custom = view.nodeViews[node.type.name], descObj;
    let spec = custom && custom(node, view, () => {
      if (!descObj)
        return pos;
      if (descObj.parent)
        return descObj.parent.posBeforeChild(descObj);
    }, outerDeco, innerDeco);
    let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
    if (node.isText) {
      if (!dom)
        dom = document.createTextNode(node.text);
      else if (dom.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else if (!dom) {
      let spec2 = DOMSerializer.renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
      ({ dom, contentDOM } = spec2);
    }
    if (!contentDOM && !node.isText && dom.nodeName != "BR") {
      if (!dom.hasAttribute("contenteditable"))
        dom.contentEditable = "false";
      if (node.type.spec.draggable)
        dom.draggable = true;
    }
    let nodeDOM = dom;
    dom = applyOuterDeco(dom, outerDeco, node);
    if (spec)
      return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
    else if (node.isText)
      return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
    else
      return new _NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let rule = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre")
      rule.preserveWhitespace = "full";
    if (!this.contentDOM) {
      rule.getContent = () => this.node.content;
    } else if (!this.contentLost) {
      rule.contentElement = this.contentDOM;
    } else {
      for (let i = this.children.length - 1; i >= 0; i--) {
        let child = this.children[i];
        if (this.dom.contains(child.dom.parentNode)) {
          rule.contentElement = child.dom.parentNode;
          break;
        }
      }
      if (!rule.contentElement)
        rule.getContent = () => Fragment6.empty;
    }
    return rule;
  }
  matchesNode(node, outerDeco, innerDeco) {
    return this.dirty == NOT_DIRTY && node.eq(this.node) && sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(view, pos) {
    let inline3 = this.node.inlineContent, off = pos;
    let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
    let localComposition = composition && composition.pos > -1 ? composition : null;
    let compositionInChild = composition && composition.pos < 0;
    let updater = new ViewTreeUpdater(this, localComposition && localComposition.node, view);
    iterDeco(this.node, this.innerDeco, (widget, i, insideNode) => {
      if (widget.spec.marks)
        updater.syncToMarks(widget.spec.marks, inline3, view);
      else if (widget.type.side >= 0 && !insideNode)
        updater.syncToMarks(i == this.node.childCount ? Mark.none : this.node.child(i).marks, inline3, view);
      updater.placeWidget(widget, view, off);
    }, (child, outerDeco, innerDeco, i) => {
      updater.syncToMarks(child.marks, inline3, view);
      let compIndex;
      if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
      else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
      else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
      else {
        updater.addNode(child, outerDeco, innerDeco, view, off);
      }
      off += child.nodeSize;
    });
    updater.syncToMarks([], inline3, view);
    if (this.node.isTextblock)
      updater.addTextblockHacks();
    updater.destroyRest();
    if (updater.changed || this.dirty == CONTENT_DIRTY) {
      if (localComposition)
        this.protectLocalComposition(view, localComposition);
      renderDescs(this.contentDOM, this.children, view);
      if (ios)
        iosHacks(this.dom);
    }
  }
  localCompositionInfo(view, pos) {
    let { from: from2, to } = view.state.selection;
    if (!(view.state.selection instanceof TextSelection) || from2 < pos || to > pos + this.node.content.size)
      return null;
    let textNode = view.input.compositionNode;
    if (!textNode || !this.dom.contains(textNode.parentNode))
      return null;
    if (this.node.inlineContent) {
      let text = textNode.nodeValue;
      let textPos = findTextInFragment(this.node.content, text, from2 - pos, to - pos);
      return textPos < 0 ? null : { node: textNode, pos: textPos, text };
    } else {
      return { node: textNode, pos: -1, text: "" };
    }
  }
  protectLocalComposition(view, { node, pos, text }) {
    if (this.getDesc(node))
      return;
    let topNode = node;
    for (; ; topNode = topNode.parentNode) {
      if (topNode.parentNode == this.contentDOM)
        break;
      while (topNode.previousSibling)
        topNode.parentNode.removeChild(topNode.previousSibling);
      while (topNode.nextSibling)
        topNode.parentNode.removeChild(topNode.nextSibling);
      if (topNode.pmViewDesc)
        topNode.pmViewDesc = void 0;
    }
    let desc = new CompositionViewDesc(this, topNode, node, text);
    view.input.compositionNodes.push(desc);
    this.children = replaceNodes(this.children, pos, pos + text.length, view, desc);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY || !node.sameMarkup(this.node))
      return false;
    this.updateInner(node, outerDeco, innerDeco, view);
    return true;
  }
  updateInner(node, outerDeco, innerDeco, view) {
    this.updateOuterDeco(outerDeco);
    this.node = node;
    this.innerDeco = innerDeco;
    if (this.contentDOM)
      this.updateChildren(view, this.posAtStart);
    this.dirty = NOT_DIRTY;
  }
  updateOuterDeco(outerDeco) {
    if (sameOuterDeco(outerDeco, this.outerDeco))
      return;
    let needsWrap = this.nodeDOM.nodeType != 1;
    let oldDOM = this.dom;
    this.dom = patchOuterDeco(this.dom, this.nodeDOM, computeOuterDeco(this.outerDeco, this.node, needsWrap), computeOuterDeco(outerDeco, this.node, needsWrap));
    if (this.dom != oldDOM) {
      oldDOM.pmViewDesc = void 0;
      this.dom.pmViewDesc = this;
    }
    this.outerDeco = outerDeco;
  }
  // Mark this node as being the selected node.
  selectNode() {
    if (this.nodeDOM.nodeType == 1) {
      this.nodeDOM.classList.add("ProseMirror-selectednode");
      if (this.contentDOM || !this.node.type.spec.draggable)
        this.nodeDOM.draggable = true;
    }
  }
  // Remove selected node marking from this node.
  deselectNode() {
    if (this.nodeDOM.nodeType == 1) {
      this.nodeDOM.classList.remove("ProseMirror-selectednode");
      if (this.contentDOM || !this.node.type.spec.draggable)
        this.nodeDOM.removeAttribute("draggable");
    }
  }
  get domAtom() {
    return this.node.isAtom;
  }
};
function docViewDesc(doc3, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc3);
  let docView = new NodeViewDesc(void 0, doc3, outerDeco, innerDeco, dom, dom, dom, view, 0);
  if (docView.contentDOM)
    docView.updateChildren(view, 0);
  return docView;
}
var TextViewDesc = class _TextViewDesc extends NodeViewDesc {
  constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
    super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
  }
  parseRule() {
    let skip = this.nodeDOM.parentNode;
    while (skip && skip != this.dom && !skip.pmIsDeco)
      skip = skip.parentNode;
    return { skip: skip || true };
  }
  update(node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY || this.dirty != NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node))
      return false;
    this.updateOuterDeco(outerDeco);
    if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
      this.nodeDOM.nodeValue = node.text;
      if (view.trackWrites == this.nodeDOM)
        view.trackWrites = null;
    }
    this.node = node;
    this.dirty = NOT_DIRTY;
    return true;
  }
  inParent() {
    let parentDOM = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == parentDOM)
        return true;
    return false;
  }
  domFromPos(pos) {
    return { node: this.nodeDOM, offset: pos };
  }
  localPosFromDOM(dom, offset5, bias) {
    if (dom == this.nodeDOM)
      return this.posAtStart + Math.min(offset5, this.node.text.length);
    return super.localPosFromDOM(dom, offset5, bias);
  }
  ignoreMutation(mutation) {
    return mutation.type != "characterData" && mutation.type != "selection";
  }
  slice(from2, to, view) {
    let node = this.node.cut(from2, to), dom = document.createTextNode(node.text);
    return new _TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
  }
  markDirty(from2, to) {
    super.markDirty(from2, to);
    if (this.dom != this.nodeDOM && (from2 == 0 || to == this.nodeDOM.nodeValue.length))
      this.dirty = NODE_DIRTY;
  }
  get domAtom() {
    return false;
  }
  isText(text) {
    return this.node.text == text;
  }
};
var TrailingHackViewDesc = class extends ViewDesc {
  parseRule() {
    return { ignore: true };
  }
  matchesHack(nodeName) {
    return this.dirty == NOT_DIRTY && this.dom.nodeName == nodeName;
  }
  get domAtom() {
    return true;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
};
var CustomNodeViewDesc = class extends NodeViewDesc {
  constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
    super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
    this.spec = spec;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY)
      return false;
    if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
      let result = this.spec.update(node, outerDeco, innerDeco);
      if (result)
        this.updateInner(node, outerDeco, innerDeco, view);
      return result;
    } else if (!this.contentDOM && !node.isLeaf) {
      return false;
    } else {
      return super.update(node, outerDeco, innerDeco, view);
    }
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(anchor, head, view, force) {
    this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
  }
  destroy() {
    if (this.spec.destroy)
      this.spec.destroy();
    super.destroy();
  }
  stopEvent(event) {
    return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
  }
  ignoreMutation(mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
  }
};
function renderDescs(parentDOM, descs, view) {
  let dom = parentDOM.firstChild, written = false;
  for (let i = 0; i < descs.length; i++) {
    let desc = descs[i], childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) {
        dom = rm(dom);
        written = true;
      }
      dom = dom.nextSibling;
    } else {
      written = true;
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof MarkViewDesc) {
      let pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children, view);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) {
    dom = rm(dom);
    written = true;
  }
  if (written && view.trackWrites == parentDOM)
    view.trackWrites = null;
}
var OuterDecoLevel = function(nodeName) {
  if (nodeName)
    this.nodeName = nodeName;
};
OuterDecoLevel.prototype = /* @__PURE__ */ Object.create(null);
var noDeco = [new OuterDecoLevel()];
function computeOuterDeco(outerDeco, node, needsWrap) {
  if (outerDeco.length == 0)
    return noDeco;
  let top2 = needsWrap ? noDeco[0] : new OuterDecoLevel(), result = [top2];
  for (let i = 0; i < outerDeco.length; i++) {
    let attrs = outerDeco[i].type.attrs;
    if (!attrs)
      continue;
    if (attrs.nodeName)
      result.push(top2 = new OuterDecoLevel(attrs.nodeName));
    for (let name in attrs) {
      let val = attrs[name];
      if (val == null)
        continue;
      if (needsWrap && result.length == 1)
        result.push(top2 = new OuterDecoLevel(node.isInline ? "span" : "div"));
      if (name == "class")
        top2.class = (top2.class ? top2.class + " " : "") + val;
      else if (name == "style")
        top2.style = (top2.style ? top2.style + ";" : "") + val;
      else if (name != "nodeName")
        top2[name] = val;
    }
  }
  return result;
}
function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
  if (prevComputed == noDeco && curComputed == noDeco)
    return nodeDOM;
  let curDOM = nodeDOM;
  for (let i = 0; i < curComputed.length; i++) {
    let deco = curComputed[i], prev = prevComputed[i];
    if (i) {
      let parent;
      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) {
        curDOM = parent;
      } else {
        parent = document.createElement(deco.nodeName);
        parent.pmIsDeco = true;
        parent.appendChild(curDOM);
        prev = noDeco[0];
        curDOM = parent;
      }
    }
    patchAttributes(curDOM, prev || noDeco[0], deco);
  }
  return curDOM;
}
function patchAttributes(dom, prev, cur) {
  for (let name in prev)
    if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
      dom.removeAttribute(name);
  for (let name in cur)
    if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name])
      dom.setAttribute(name, cur[name]);
  if (prev.class != cur.class) {
    let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
    let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < prevList.length; i++)
      if (curList.indexOf(prevList[i]) == -1)
        dom.classList.remove(prevList[i]);
    for (let i = 0; i < curList.length; i++)
      if (prevList.indexOf(curList[i]) == -1)
        dom.classList.add(curList[i]);
    if (dom.classList.length == 0)
      dom.removeAttribute("class");
  }
  if (prev.style != cur.style) {
    if (prev.style) {
      let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
      while (m = prop.exec(prev.style))
        dom.style.removeProperty(m[1]);
    }
    if (cur.style)
      dom.style.cssText += cur.style;
  }
}
function applyOuterDeco(dom, deco, node) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1));
}
function sameOuterDeco(a, b) {
  if (a.length != b.length)
    return false;
  for (let i = 0; i < a.length; i++)
    if (!a[i].type.eq(b[i].type))
      return false;
  return true;
}
function rm(dom) {
  let next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next;
}
var ViewTreeUpdater = class {
  constructor(top2, lock, view) {
    this.lock = lock;
    this.view = view;
    this.index = 0;
    this.stack = [];
    this.changed = false;
    this.top = top2;
    this.preMatch = preMatch(top2.node.content, top2);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(start2, end2) {
    if (start2 == end2)
      return;
    for (let i = start2; i < end2; i++)
      this.top.children[i].destroy();
    this.top.children.splice(start2, end2 - start2);
    this.changed = true;
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(marks, inline3, view) {
    let keep = 0, depth = this.stack.length >> 1;
    let maxKeep = Math.min(depth, marks.length);
    while (keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)
      keep++;
    while (keep < depth) {
      this.destroyRest();
      this.top.dirty = NOT_DIRTY;
      this.index = this.stack.pop();
      this.top = this.stack.pop();
      depth--;
    }
    while (depth < marks.length) {
      this.stack.push(this.top, this.index + 1);
      let found2 = -1;
      for (let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
        let next = this.top.children[i];
        if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
          found2 = i;
          break;
        }
      }
      if (found2 > -1) {
        if (found2 > this.index) {
          this.changed = true;
          this.destroyBetween(this.index, found2);
        }
        this.top = this.top.children[this.index];
      } else {
        let markDesc = MarkViewDesc.create(this.top, marks[depth], inline3, view);
        this.top.children.splice(this.index, 0, markDesc);
        this.top = markDesc;
        this.changed = true;
      }
      this.index = 0;
      depth++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(node, outerDeco, innerDeco, index2) {
    let found2 = -1, targetDesc;
    if (index2 >= this.preMatch.index && (targetDesc = this.preMatch.matches[index2 - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) {
      found2 = this.top.children.indexOf(targetDesc, this.index);
    } else {
      for (let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++) {
        let child = this.top.children[i];
        if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
          found2 = i;
          break;
        }
      }
    }
    if (found2 < 0)
      return false;
    this.destroyBetween(this.index, found2);
    this.index++;
    return true;
  }
  updateNodeAt(node, outerDeco, innerDeco, index2, view) {
    let child = this.top.children[index2];
    if (child.dirty == NODE_DIRTY && child.dom == child.contentDOM)
      child.dirty = CONTENT_DIRTY;
    if (!child.update(node, outerDeco, innerDeco, view))
      return false;
    this.destroyBetween(this.index, index2);
    this.index++;
    return true;
  }
  findIndexWithChild(domNode) {
    for (; ; ) {
      let parent = domNode.parentNode;
      if (!parent)
        return -1;
      if (parent == this.top.contentDOM) {
        let desc = domNode.pmViewDesc;
        if (desc)
          for (let i = this.index; i < this.top.children.length; i++) {
            if (this.top.children[i] == desc)
              return i;
          }
        return -1;
      }
      domNode = parent;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(node, outerDeco, innerDeco, view, index2, pos) {
    for (let i = this.index; i < this.top.children.length; i++) {
      let next = this.top.children[i];
      if (next instanceof NodeViewDesc) {
        let preMatch2 = this.preMatch.matched.get(next);
        if (preMatch2 != null && preMatch2 != index2)
          return false;
        let nextDOM = next.dom, updated;
        let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
        if (!locked && next.update(node, outerDeco, innerDeco, view)) {
          this.destroyBetween(this.index, i);
          if (next.dom != nextDOM)
            this.changed = true;
          this.index++;
          return true;
        } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
          this.destroyBetween(this.index, i);
          this.top.children[this.index] = updated;
          if (updated.contentDOM) {
            updated.dirty = CONTENT_DIRTY;
            updated.updateChildren(view, pos + 1);
            updated.dirty = NOT_DIRTY;
          }
          this.changed = true;
          this.index++;
          return true;
        }
        break;
      }
    }
    return false;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
    if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco))
      return null;
    let wrapper = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
    if (wrapper.contentDOM) {
      wrapper.children = next.children;
      next.children = [];
      for (let ch of wrapper.children)
        ch.parent = wrapper;
    }
    next.destroy();
    return wrapper;
  }
  // Insert the node as a newly created node desc.
  addNode(node, outerDeco, innerDeco, view, pos) {
    let desc = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
    if (desc.contentDOM)
      desc.updateChildren(view, pos + 1);
    this.top.children.splice(this.index++, 0, desc);
    this.changed = true;
  }
  placeWidget(widget, view, pos) {
    let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) {
      this.index++;
    } else {
      let desc = new WidgetViewDesc(this.top, widget, view, pos);
      this.top.children.splice(this.index++, 0, desc);
      this.changed = true;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let lastChild = this.top.children[this.index - 1], parent = this.top;
    while (lastChild instanceof MarkViewDesc) {
      parent = lastChild;
      lastChild = parent.children[parent.children.length - 1];
    }
    if (!lastChild || // Empty textblock
    !(lastChild instanceof TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
      if ((safari || chrome) && lastChild && lastChild.dom.contentEditable == "false")
        this.addHackNode("IMG", parent);
      this.addHackNode("BR", this.top);
    }
  }
  addHackNode(nodeName, parent) {
    if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) {
      this.index++;
    } else {
      let dom = document.createElement(nodeName);
      if (nodeName == "IMG") {
        dom.className = "ProseMirror-separator";
        dom.alt = "";
      }
      if (nodeName == "BR")
        dom.className = "ProseMirror-trailingBreak";
      let hack = new TrailingHackViewDesc(this.top, [], dom, null);
      if (parent != this.top)
        parent.children.push(hack);
      else
        parent.children.splice(this.index++, 0, hack);
      this.changed = true;
    }
  }
  isLocked(node) {
    return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
  }
};
function preMatch(frag, parentDesc) {
  let curDesc = parentDesc, descI = curDesc.children.length;
  let fI = frag.childCount, matched = /* @__PURE__ */ new Map(), matches2 = [];
  outer: while (fI > 0) {
    let desc;
    for (; ; ) {
      if (descI) {
        let next = curDesc.children[descI - 1];
        if (next instanceof MarkViewDesc) {
          curDesc = next;
          descI = next.children.length;
        } else {
          desc = next;
          descI--;
          break;
        }
      } else if (curDesc == parentDesc) {
        break outer;
      } else {
        descI = curDesc.parent.children.indexOf(curDesc);
        curDesc = curDesc.parent;
      }
    }
    let node = desc.node;
    if (!node)
      continue;
    if (node != frag.child(fI - 1))
      break;
    --fI;
    matched.set(desc, fI);
    matches2.push(desc);
  }
  return { index: fI, matched, matches: matches2.reverse() };
}
function compareSide(a, b) {
  return a.type.side - b.type.side;
}
function iterDeco(parent, deco, onWidget, onNode) {
  let locals = deco.locals(parent), offset5 = 0;
  if (locals.length == 0) {
    for (let i = 0; i < parent.childCount; i++) {
      let child = parent.child(i);
      onNode(child, locals, deco.forChild(offset5, child), i);
      offset5 += child.nodeSize;
    }
    return;
  }
  let decoIndex = 0, active = [], restNode = null;
  for (let parentIndex = 0; ; ) {
    let widget, widgets;
    while (decoIndex < locals.length && locals[decoIndex].to == offset5) {
      let next = locals[decoIndex++];
      if (next.widget) {
        if (!widget)
          widget = next;
        else
          (widgets || (widgets = [widget])).push(next);
      }
    }
    if (widget) {
      if (widgets) {
        widgets.sort(compareSide);
        for (let i = 0; i < widgets.length; i++)
          onWidget(widgets[i], parentIndex, !!restNode);
      } else {
        onWidget(widget, parentIndex, !!restNode);
      }
    }
    let child, index2;
    if (restNode) {
      index2 = -1;
      child = restNode;
      restNode = null;
    } else if (parentIndex < parent.childCount) {
      index2 = parentIndex;
      child = parent.child(parentIndex++);
    } else {
      break;
    }
    for (let i = 0; i < active.length; i++)
      if (active[i].to <= offset5)
        active.splice(i--, 1);
    while (decoIndex < locals.length && locals[decoIndex].from <= offset5 && locals[decoIndex].to > offset5)
      active.push(locals[decoIndex++]);
    let end2 = offset5 + child.nodeSize;
    if (child.isText) {
      let cutAt = end2;
      if (decoIndex < locals.length && locals[decoIndex].from < cutAt)
        cutAt = locals[decoIndex].from;
      for (let i = 0; i < active.length; i++)
        if (active[i].to < cutAt)
          cutAt = active[i].to;
      if (cutAt < end2) {
        restNode = child.cut(cutAt - offset5);
        child = child.cut(0, cutAt - offset5);
        end2 = cutAt;
        index2 = -1;
      }
    } else {
      while (decoIndex < locals.length && locals[decoIndex].to < end2)
        decoIndex++;
    }
    let outerDeco = child.isInline && !child.isLeaf ? active.filter((d) => !d.inline) : active.slice();
    onNode(child, outerDeco, deco.forChild(offset5, child), index2);
    offset5 = end2;
  }
}
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    let oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}
function findTextInFragment(frag, text, from2, to) {
  for (let i = 0, pos = 0; i < frag.childCount && pos <= to; ) {
    let child = frag.child(i++), childStart = pos;
    pos += child.nodeSize;
    if (!child.isText)
      continue;
    let str = child.text;
    while (i < frag.childCount) {
      let next = frag.child(i++);
      pos += next.nodeSize;
      if (!next.isText)
        break;
      str += next.text;
    }
    if (pos >= from2) {
      if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text)
        return to - text.length;
      let found2 = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
      if (found2 >= 0 && found2 + text.length + childStart >= from2)
        return childStart + found2;
      if (from2 == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text)
        return to;
    }
  }
  return -1;
}
function replaceNodes(nodes, from2, to, view, replacement) {
  let result = [];
  for (let i = 0, off = 0; i < nodes.length; i++) {
    let child = nodes[i], start2 = off, end2 = off += child.size;
    if (start2 >= to || end2 <= from2) {
      result.push(child);
    } else {
      if (start2 < from2)
        result.push(child.slice(0, from2 - start2, view));
      if (replacement) {
        result.push(replacement);
        replacement = void 0;
      }
      if (end2 > to)
        result.push(child.slice(to - start2, child.size, view));
    }
  }
  return result;
}
function selectionFromDOM(view, origin = null) {
  let domSel = view.domSelectionRange(), doc3 = view.state.doc;
  if (!domSel.focusNode)
    return null;
  let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
  let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
  if (head < 0)
    return null;
  let $head = doc3.resolve(head), anchor, selection;
  if (selectionCollapsed(domSel)) {
    anchor = head;
    while (nearestDesc && !nearestDesc.node)
      nearestDesc = nearestDesc.parent;
    let nearestDescNode = nearestDesc.node;
    if (nearestDesc && nearestDescNode.isAtom && NodeSelection.isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
      let pos = nearestDesc.posBefore;
      selection = new NodeSelection(head == pos ? $head : doc3.resolve(pos));
    }
  } else {
    if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
      let min3 = head, max3 = head;
      for (let i = 0; i < domSel.rangeCount; i++) {
        let range = domSel.getRangeAt(i);
        min3 = Math.min(min3, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
        max3 = Math.max(max3, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
      }
      if (min3 < 0)
        return null;
      [anchor, head] = max3 == view.state.selection.anchor ? [max3, min3] : [min3, max3];
      $head = doc3.resolve(head);
    } else {
      anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
    }
    if (anchor < 0)
      return null;
  }
  let $anchor = doc3.resolve(anchor);
  if (!selection) {
    let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
    selection = selectionBetween(view, $anchor, $head, bias);
  }
  return selection;
}
function editorOwnsSelection(view) {
  return view.editable ? view.hasFocus() : hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function selectionToDOM(view, force = false) {
  let sel = view.state.selection;
  syncNodeSelection(view, sel);
  if (!editorOwnsSelection(view))
    return;
  if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && chrome) {
    let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
    if (domSel.anchorNode && curSel.anchorNode && isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
      view.input.mouseDown.delayedSelectionSync = true;
      view.domObserver.setCurSelection();
      return;
    }
  }
  view.domObserver.disconnectSelection();
  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    let { anchor, head } = sel, resetEditableFrom, resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof TextSelection)) {
      if (!sel.$from.parent.inlineContent)
        resetEditableFrom = temporarilyEditableNear(view, sel.from);
      if (!sel.empty && !sel.$from.parent.inlineContent)
        resetEditableTo = temporarilyEditableNear(view, sel.to);
    }
    view.docView.setSelection(anchor, head, view, force);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom)
        resetEditable(resetEditableFrom);
      if (resetEditableTo)
        resetEditable(resetEditableTo);
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document)
        removeClassOnSelectionChange(view);
    }
  }
  view.domObserver.setCurSelection();
  view.domObserver.connectSelection();
}
var brokenSelectBetweenUneditable = safari || chrome && chrome_version < 63;
function temporarilyEditableNear(view, pos) {
  let { node, offset: offset5 } = view.docView.domFromPos(pos, 0);
  let after = offset5 < node.childNodes.length ? node.childNodes[offset5] : null;
  let before = offset5 ? node.childNodes[offset5 - 1] : null;
  if (safari && after && after.contentEditable == "false")
    return setEditable(after);
  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
    if (after)
      return setEditable(after);
    else if (before)
      return setEditable(before);
  }
}
function setEditable(element) {
  element.contentEditable = "true";
  if (safari && element.draggable) {
    element.draggable = false;
    element.wasDraggable = true;
  }
  return element;
}
function resetEditable(element) {
  element.contentEditable = "false";
  if (element.wasDraggable) {
    element.draggable = true;
    element.wasDraggable = null;
  }
}
function removeClassOnSelectionChange(view) {
  let doc3 = view.dom.ownerDocument;
  doc3.removeEventListener("selectionchange", view.input.hideSelectionGuard);
  let domSel = view.domSelectionRange();
  let node = domSel.anchorNode, offset5 = domSel.anchorOffset;
  doc3.addEventListener("selectionchange", view.input.hideSelectionGuard = () => {
    if (domSel.anchorNode != node || domSel.anchorOffset != offset5) {
      doc3.removeEventListener("selectionchange", view.input.hideSelectionGuard);
      setTimeout(() => {
        if (!editorOwnsSelection(view) || view.state.selection.visible)
          view.dom.classList.remove("ProseMirror-hideselection");
      }, 20);
    }
  });
}
function selectCursorWrapper(view) {
  let domSel = view.domSelection();
  if (!domSel)
    return;
  let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
  if (img)
    domSel.collapse(node.parentNode, domIndex(node) + 1);
  else
    domSel.collapse(node, 0);
  if (!img && !view.state.selection.visible && ie && ie_version <= 11) {
    node.disabled = true;
    node.disabled = false;
  }
}
function syncNodeSelection(view, sel) {
  if (sel instanceof NodeSelection) {
    let desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc)
        desc.selectNode();
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    if (view.lastSelectedViewDesc.parent)
      view.lastSelectedViewDesc.deselectNode();
    view.lastSelectedViewDesc = void 0;
  }
}
function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", (f) => f(view, $anchor, $head)) || TextSelection.between($anchor, $head, bias);
}
function hasFocusAndSelection(view) {
  if (view.editable && !view.hasFocus())
    return false;
  return hasSelection(view);
}
function hasSelection(view) {
  let sel = view.domSelectionRange();
  if (!sel.anchorNode)
    return false;
  try {
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
  } catch (_) {
    return false;
  }
}
function anchorInRightPlace(view) {
  let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
  let domSel = view.domSelectionRange();
  return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function moveSelectionBlock(state, dir) {
  let { $anchor, $head } = state.selection;
  let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && Selection.findFrom($start, dir);
}
function apply(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true;
}
function selectHorizontally(view, dir, mods) {
  let sel = view.state.selection;
  if (sel instanceof TextSelection) {
    if (mods.indexOf("s") > -1) {
      let { $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
      if (!node || node.isText || !node.isLeaf)
        return false;
      let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
      return apply(view, new TextSelection(sel.$anchor, $newHead));
    } else if (!sel.empty) {
      return false;
    } else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
      let next = moveSelectionBlock(view.state, dir);
      if (next && next instanceof NodeSelection)
        return apply(view, next);
      return false;
    } else if (!(mac2 && mods.indexOf("m") > -1)) {
      let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
      if (!node || node.isText)
        return false;
      let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
      if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM))
        return false;
      if (NodeSelection.isSelectable(node)) {
        return apply(view, new NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
      } else if (webkit) {
        return apply(view, new TextSelection(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
      } else {
        return false;
      }
    }
  } else if (sel instanceof NodeSelection && sel.node.isInline) {
    return apply(view, new TextSelection(dir > 0 ? sel.$to : sel.$from));
  } else {
    let next = moveSelectionBlock(view.state, dir);
    if (next)
      return apply(view, next);
    return false;
  }
}
function nodeLen(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function isIgnorable(dom, dir) {
  let desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function skipIgnoredNodes(view, dir) {
  return dir < 0 ? skipIgnoredNodesBefore(view) : skipIgnoredNodesAfter(view);
}
function skipIgnoredNodesBefore(view) {
  let sel = view.domSelectionRange();
  let node = sel.focusNode, offset5 = sel.focusOffset;
  if (!node)
    return;
  let moveNode, moveOffset, force = false;
  if (gecko && node.nodeType == 1 && offset5 < nodeLen(node) && isIgnorable(node.childNodes[offset5], -1))
    force = true;
  for (; ; ) {
    if (offset5 > 0) {
      if (node.nodeType != 1) {
        break;
      } else {
        let before = node.childNodes[offset5 - 1];
        if (isIgnorable(before, -1)) {
          moveNode = node;
          moveOffset = --offset5;
        } else if (before.nodeType == 3) {
          node = before;
          offset5 = node.nodeValue.length;
        } else
          break;
      }
    } else if (isBlockNode(node)) {
      break;
    } else {
      let prev = node.previousSibling;
      while (prev && isIgnorable(prev, -1)) {
        moveNode = node.parentNode;
        moveOffset = domIndex(prev);
        prev = prev.previousSibling;
      }
      if (!prev) {
        node = node.parentNode;
        if (node == view.dom)
          break;
        offset5 = 0;
      } else {
        node = prev;
        offset5 = nodeLen(node);
      }
    }
  }
  if (force)
    setSelFocus(view, node, offset5);
  else if (moveNode)
    setSelFocus(view, moveNode, moveOffset);
}
function skipIgnoredNodesAfter(view) {
  let sel = view.domSelectionRange();
  let node = sel.focusNode, offset5 = sel.focusOffset;
  if (!node)
    return;
  let len = nodeLen(node);
  let moveNode, moveOffset;
  for (; ; ) {
    if (offset5 < len) {
      if (node.nodeType != 1)
        break;
      let after = node.childNodes[offset5];
      if (isIgnorable(after, 1)) {
        moveNode = node;
        moveOffset = ++offset5;
      } else
        break;
    } else if (isBlockNode(node)) {
      break;
    } else {
      let next = node.nextSibling;
      while (next && isIgnorable(next, 1)) {
        moveNode = next.parentNode;
        moveOffset = domIndex(next) + 1;
        next = next.nextSibling;
      }
      if (!next) {
        node = node.parentNode;
        if (node == view.dom)
          break;
        offset5 = len = 0;
      } else {
        node = next;
        offset5 = 0;
        len = nodeLen(node);
      }
    }
  }
  if (moveNode)
    setSelFocus(view, moveNode, moveOffset);
}
function isBlockNode(dom) {
  let desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock;
}
function textNodeAfter(node, offset5) {
  while (node && offset5 == node.childNodes.length && !hasBlockDesc(node)) {
    offset5 = domIndex(node) + 1;
    node = node.parentNode;
  }
  while (node && offset5 < node.childNodes.length) {
    let next = node.childNodes[offset5];
    if (next.nodeType == 3)
      return next;
    if (next.nodeType == 1 && next.contentEditable == "false")
      break;
    node = next;
    offset5 = 0;
  }
}
function textNodeBefore(node, offset5) {
  while (node && !offset5 && !hasBlockDesc(node)) {
    offset5 = domIndex(node);
    node = node.parentNode;
  }
  while (node && offset5) {
    let next = node.childNodes[offset5 - 1];
    if (next.nodeType == 3)
      return next;
    if (next.nodeType == 1 && next.contentEditable == "false")
      break;
    node = next;
    offset5 = node.childNodes.length;
  }
}
function setSelFocus(view, node, offset5) {
  if (node.nodeType != 3) {
    let before, after;
    if (after = textNodeAfter(node, offset5)) {
      node = after;
      offset5 = 0;
    } else if (before = textNodeBefore(node, offset5)) {
      node = before;
      offset5 = before.nodeValue.length;
    }
  }
  let sel = view.domSelection();
  if (!sel)
    return;
  if (selectionCollapsed(sel)) {
    let range = document.createRange();
    range.setEnd(node, offset5);
    range.setStart(node, offset5);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (sel.extend) {
    sel.extend(node, offset5);
  }
  view.domObserver.setCurSelection();
  let { state } = view;
  setTimeout(() => {
    if (view.state == state)
      selectionToDOM(view);
  }, 50);
}
function findDirection(view, pos) {
  let $pos = view.state.doc.resolve(pos);
  if (!(chrome || windows) && $pos.parent.inlineContent) {
    let coords = view.coordsAtPos(pos);
    if (pos > $pos.start()) {
      let before = view.coordsAtPos(pos - 1);
      let mid = (before.top + before.bottom) / 2;
      if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1)
        return before.left < coords.left ? "ltr" : "rtl";
    }
    if (pos < $pos.end()) {
      let after = view.coordsAtPos(pos + 1);
      let mid = (after.top + after.bottom) / 2;
      if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1)
        return after.left > coords.left ? "ltr" : "rtl";
    }
  }
  let computed = getComputedStyle(view.dom).direction;
  return computed == "rtl" ? "rtl" : "ltr";
}
function selectVertically(view, dir, mods) {
  let sel = view.state.selection;
  if (sel instanceof TextSelection && !sel.empty || mods.indexOf("s") > -1)
    return false;
  if (mac2 && mods.indexOf("m") > -1)
    return false;
  let { $from, $to } = sel;
  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    let next = moveSelectionBlock(view.state, dir);
    if (next && next instanceof NodeSelection)
      return apply(view, next);
  }
  if (!$from.parent.inlineContent) {
    let side = dir < 0 ? $from : $to;
    let beyond = sel instanceof AllSelection ? Selection.near(side, dir) : Selection.findFrom(side, dir);
    return beyond ? apply(view, beyond) : false;
  }
  return false;
}
function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof TextSelection))
    return true;
  let { $head, $anchor, empty: empty2 } = view.state.selection;
  if (!$head.sameParent($anchor))
    return true;
  if (!empty2)
    return false;
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward"))
    return true;
  let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    let tr2 = view.state.tr;
    if (dir < 0)
      tr2.delete($head.pos - nextNode.nodeSize, $head.pos);
    else
      tr2.delete($head.pos, $head.pos + nextNode.nodeSize);
    view.dispatch(tr2);
    return true;
  }
  return false;
}
function switchEditable(view, node, state) {
  view.domObserver.stop();
  node.contentEditable = state;
  view.domObserver.start();
}
function safariDownArrowBug(view) {
  if (!safari || view.state.selection.$head.parentOffset > 0)
    return false;
  let { focusNode, focusOffset } = view.domSelectionRange();
  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
    let child = focusNode.firstChild;
    switchEditable(view, child, "true");
    setTimeout(() => switchEditable(view, child, "false"), 20);
  }
  return false;
}
function getMods(event) {
  let result = "";
  if (event.ctrlKey)
    result += "c";
  if (event.metaKey)
    result += "m";
  if (event.altKey)
    result += "a";
  if (event.shiftKey)
    result += "s";
  return result;
}
function captureKeyDown(view, event) {
  let code = event.keyCode, mods = getMods(event);
  if (code == 8 || mac2 && code == 72 && mods == "c") {
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodes(view, -1);
  } else if (code == 46 && !event.shiftKey || mac2 && code == 68 && mods == "c") {
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodes(view, 1);
  } else if (code == 13 || code == 27) {
    return true;
  } else if (code == 37 || mac2 && code == 66 && mods == "c") {
    let dir = code == 37 ? findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
  } else if (code == 39 || mac2 && code == 70 && mods == "c") {
    let dir = code == 39 ? findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
  } else if (code == 38 || mac2 && code == 80 && mods == "c") {
    return selectVertically(view, -1, mods) || skipIgnoredNodes(view, -1);
  } else if (code == 40 || mac2 && code == 78 && mods == "c") {
    return safariDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodes(view, 1);
  } else if (mods == (mac2 ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) {
    return true;
  }
  return false;
}
function serializeForClipboard(view, slice2) {
  view.someProp("transformCopied", (f) => {
    slice2 = f(slice2, view);
  });
  let context = [], { content, openStart, openEnd } = slice2;
  while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    let node = content.firstChild;
    context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
    content = node.content;
  }
  let serializer = view.someProp("clipboardSerializer") || DOMSerializer.fromSchema(view.state.schema);
  let doc3 = detachedDoc(), wrap2 = doc3.createElement("div");
  wrap2.appendChild(serializer.serializeFragment(content, { document: doc3 }));
  let firstChild = wrap2.firstChild, needsWrap, wrappers = 0;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (let i = needsWrap.length - 1; i >= 0; i--) {
      let wrapper = doc3.createElement(needsWrap[i]);
      while (wrap2.firstChild)
        wrapper.appendChild(wrap2.firstChild);
      wrap2.appendChild(wrapper);
      wrappers++;
    }
    firstChild = wrap2.firstChild;
  }
  if (firstChild && firstChild.nodeType == 1)
    firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
  let text = view.someProp("clipboardTextSerializer", (f) => f(slice2, view)) || slice2.content.textBetween(0, slice2.content.size, "\n\n");
  return { dom: wrap2, text, slice: slice2 };
}
function parseFromClipboard(view, text, html, plainText, $context) {
  let inCode = $context.parent.type.spec.code;
  let dom, slice2;
  if (!html && !text)
    return null;
  let asText = !!text && (plainText || inCode || !html);
  if (asText) {
    view.someProp("transformPastedText", (f) => {
      text = f(text, inCode || plainText, view);
    });
    if (inCode) {
      slice2 = new Slice(Fragment6.from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0);
      view.someProp("transformPasted", (f) => {
        slice2 = f(slice2, view, true);
      });
      return slice2;
    }
    let parsed = view.someProp("clipboardTextParser", (f) => f(text, $context, plainText, view));
    if (parsed) {
      slice2 = parsed;
    } else {
      let marks = $context.marks();
      let { schema } = view.state, serializer = DOMSerializer.fromSchema(schema);
      dom = document.createElement("div");
      text.split(/(?:\r\n?|\n)+/).forEach((block) => {
        let p = dom.appendChild(document.createElement("p"));
        if (block)
          p.appendChild(serializer.serializeNode(schema.text(block, marks)));
      });
    }
  } else {
    view.someProp("transformPastedHTML", (f) => {
      html = f(html, view);
    });
    dom = readHTML(html);
    if (webkit)
      restoreReplacedSpaces(dom);
  }
  let contextNode = dom && dom.querySelector("[data-pm-slice]");
  let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
  if (sliceData && sliceData[3])
    for (let i = +sliceData[3]; i > 0; i--) {
      let child = dom.firstChild;
      while (child && child.nodeType != 1)
        child = child.nextSibling;
      if (!child)
        break;
      dom = child;
    }
  if (!slice2) {
    let parser = view.someProp("clipboardParser") || view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
    slice2 = parser.parseSlice(dom, {
      preserveWhitespace: !!(asText || sliceData),
      context: $context,
      ruleFromNode(dom2) {
        if (dom2.nodeName == "BR" && !dom2.nextSibling && dom2.parentNode && !inlineParents.test(dom2.parentNode.nodeName))
          return { ignore: true };
        return null;
      }
    });
  }
  if (sliceData) {
    slice2 = addContext(closeSlice(slice2, +sliceData[1], +sliceData[2]), sliceData[4]);
  } else {
    slice2 = Slice.maxOpen(normalizeSiblings(slice2.content, $context), true);
    if (slice2.openStart || slice2.openEnd) {
      let openStart = 0, openEnd = 0;
      for (let node = slice2.content.firstChild; openStart < slice2.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild) {
      }
      for (let node = slice2.content.lastChild; openEnd < slice2.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild) {
      }
      slice2 = closeSlice(slice2, openStart, openEnd);
    }
  }
  view.someProp("transformPasted", (f) => {
    slice2 = f(slice2, view, asText);
  });
  return slice2;
}
var inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2)
    return fragment;
  for (let d = $context.depth; d >= 0; d--) {
    let parent = $context.node(d);
    let match = parent.contentMatchAt($context.index(d));
    let lastWrap, result = [];
    fragment.forEach((node) => {
      if (!result)
        return;
      let wrap2 = match.findWrapping(node.type), inLast;
      if (!wrap2)
        return result = null;
      if (inLast = result.length && lastWrap.length && addToSibling(wrap2, lastWrap, node, result[result.length - 1], 0)) {
        result[result.length - 1] = inLast;
      } else {
        if (result.length)
          result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length);
        let wrapped = withWrappers(node, wrap2);
        result.push(wrapped);
        match = match.matchType(wrapped.type);
        lastWrap = wrap2;
      }
    });
    if (result)
      return Fragment6.from(result);
  }
  return fragment;
}
function withWrappers(node, wrap2, from2 = 0) {
  for (let i = wrap2.length - 1; i >= from2; i--)
    node = wrap2[i].create(null, Fragment6.from(node));
  return node;
}
function addToSibling(wrap2, lastWrap, node, sibling, depth) {
  if (depth < wrap2.length && depth < lastWrap.length && wrap2[depth] == lastWrap[depth]) {
    let inner = addToSibling(wrap2, lastWrap, node, sibling.lastChild, depth + 1);
    if (inner)
      return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
    let match = sibling.contentMatchAt(sibling.childCount);
    if (match.matchType(depth == wrap2.length - 1 ? node.type : wrap2[depth + 1]))
      return sibling.copy(sibling.content.append(Fragment6.from(withWrappers(node, wrap2, depth + 1))));
  }
}
function closeRight(node, depth) {
  if (depth == 0)
    return node;
  let fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
  let fill = node.contentMatchAt(node.childCount).fillBefore(Fragment6.empty, true);
  return node.copy(fragment.append(fill));
}
function closeRange(fragment, side, from2, to, depth, openEnd) {
  let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
  if (fragment.childCount > 1)
    openEnd = 0;
  if (depth < to - 1)
    inner = closeRange(inner, side, from2, to, depth + 1, openEnd);
  if (depth >= from2)
    inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore(Fragment6.empty, true));
  return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function closeSlice(slice2, openStart, openEnd) {
  if (openStart < slice2.openStart)
    slice2 = new Slice(closeRange(slice2.content, -1, openStart, slice2.openStart, 0, slice2.openEnd), openStart, slice2.openEnd);
  if (openEnd < slice2.openEnd)
    slice2 = new Slice(closeRange(slice2.content, 1, openEnd, slice2.openEnd, 0, 0), slice2.openStart, openEnd);
  return slice2;
}
var wrapMap = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
var _detachedDoc = null;
function detachedDoc() {
  return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"));
}
var _policy = null;
function maybeWrapTrusted(html) {
  let trustedTypes = window.trustedTypes;
  if (!trustedTypes)
    return html;
  if (!_policy)
    _policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", { createHTML: (s) => s });
  return _policy.createHTML(html);
}
function readHTML(html) {
  let metas = /^(\s*<meta [^>]*>)*/.exec(html);
  if (metas)
    html = html.slice(metas[0].length);
  let elt = detachedDoc().createElement("div");
  let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap2;
  if (wrap2 = firstTag && wrapMap[firstTag[1].toLowerCase()])
    html = wrap2.map((n) => "<" + n + ">").join("") + html + wrap2.map((n) => "</" + n + ">").reverse().join("");
  elt.innerHTML = maybeWrapTrusted(html);
  if (wrap2)
    for (let i = 0; i < wrap2.length; i++)
      elt = elt.querySelector(wrap2[i]) || elt;
  return elt;
}
function restoreReplacedSpaces(dom) {
  let nodes = dom.querySelectorAll(chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let i = 0; i < nodes.length; i++) {
    let node = nodes[i];
    if (node.childNodes.length == 1 && node.textContent == "\xA0" && node.parentNode)
      node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
  }
}
function addContext(slice2, context) {
  if (!slice2.size)
    return slice2;
  let schema = slice2.content.firstChild.type.schema, array;
  try {
    array = JSON.parse(context);
  } catch (e) {
    return slice2;
  }
  let { content, openStart, openEnd } = slice2;
  for (let i = array.length - 2; i >= 0; i -= 2) {
    let type = schema.nodes[array[i]];
    if (!type || type.hasRequiredAttrs())
      break;
    content = Fragment6.from(type.create(array[i + 1], content));
    openStart++;
    openEnd++;
  }
  return new Slice(content, openStart, openEnd);
}
var handlers = {};
var editHandlers = {};
var passiveHandlers = { touchstart: true, touchmove: true };
var InputState = class {
  constructor() {
    this.shiftKey = false;
    this.mouseDown = null;
    this.lastKeyCode = null;
    this.lastKeyCodeTime = 0;
    this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 };
    this.lastSelectionOrigin = null;
    this.lastSelectionTime = 0;
    this.lastIOSEnter = 0;
    this.lastIOSEnterFallbackTimeout = -1;
    this.lastFocus = 0;
    this.lastTouch = 0;
    this.lastChromeDelete = 0;
    this.composing = false;
    this.compositionNode = null;
    this.composingTimeout = -1;
    this.compositionNodes = [];
    this.compositionEndedAt = -2e8;
    this.compositionID = 1;
    this.compositionPendingChanges = 0;
    this.domChangeCount = 0;
    this.eventHandlers = /* @__PURE__ */ Object.create(null);
    this.hideSelectionGuard = null;
  }
};
function initInput(view) {
  for (let event in handlers) {
    let handler = handlers[event];
    view.dom.addEventListener(event, view.input.eventHandlers[event] = (event2) => {
      if (eventBelongsToView(view, event2) && !runCustomHandler(view, event2) && (view.editable || !(event2.type in editHandlers)))
        handler(view, event2);
    }, passiveHandlers[event] ? { passive: true } : void 0);
  }
  if (safari)
    view.dom.addEventListener("input", () => null);
  ensureListeners(view);
}
function setSelectionOrigin(view, origin) {
  view.input.lastSelectionOrigin = origin;
  view.input.lastSelectionTime = Date.now();
}
function destroyInput(view) {
  view.domObserver.stop();
  for (let type in view.input.eventHandlers)
    view.dom.removeEventListener(type, view.input.eventHandlers[type]);
  clearTimeout(view.input.composingTimeout);
  clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function ensureListeners(view) {
  view.someProp("handleDOMEvents", (currentHandlers) => {
    for (let type in currentHandlers)
      if (!view.input.eventHandlers[type])
        view.dom.addEventListener(type, view.input.eventHandlers[type] = (event) => runCustomHandler(view, event));
  });
}
function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", (handlers2) => {
    let handler = handlers2[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false;
  });
}
function eventBelongsToView(view, event) {
  if (!event.bubbles)
    return true;
  if (event.defaultPrevented)
    return false;
  for (let node = event.target; node != view.dom; node = node.parentNode)
    if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event))
      return false;
  return true;
}
function dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] && (view.editable || !(event.type in editHandlers)))
    handlers[event.type](view, event);
}
editHandlers.keydown = (view, _event) => {
  let event = _event;
  view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
  if (inOrNearComposition(view, event))
    return;
  view.input.lastKeyCode = event.keyCode;
  view.input.lastKeyCodeTime = Date.now();
  if (android && chrome && event.keyCode == 13)
    return;
  if (event.keyCode != 229)
    view.domObserver.forceFlush();
  if (ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
    let now = Date.now();
    view.input.lastIOSEnter = now;
    view.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
      if (view.input.lastIOSEnter == now) {
        view.someProp("handleKeyDown", (f) => f(view, keyEvent(13, "Enter")));
        view.input.lastIOSEnter = 0;
      }
    }, 200);
  } else if (view.someProp("handleKeyDown", (f) => f(view, event)) || captureKeyDown(view, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "key");
  }
};
editHandlers.keyup = (view, event) => {
  if (event.keyCode == 16)
    view.input.shiftKey = false;
};
editHandlers.keypress = (view, _event) => {
  let event = _event;
  if (inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || mac2 && event.metaKey)
    return;
  if (view.someProp("handleKeyPress", (f) => f(view, event))) {
    event.preventDefault();
    return;
  }
  let sel = view.state.selection;
  if (!(sel instanceof TextSelection) || !sel.$from.sameParent(sel.$to)) {
    let text = String.fromCharCode(event.charCode);
    let deflt = () => view.state.tr.insertText(text).scrollIntoView();
    if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f) => f(view, sel.$from.pos, sel.$to.pos, text, deflt)))
      view.dispatch(deflt());
    event.preventDefault();
  }
};
function eventCoords(event) {
  return { left: event.clientX, top: event.clientY };
}
function isNear(event, click) {
  let dx = click.x - event.clientX, dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100;
}
function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1)
    return false;
  let $pos = view.state.doc.resolve(inside);
  for (let i = $pos.depth + 1; i > 0; i--) {
    if (view.someProp(propName, (f) => i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false)))
      return true;
  }
  return false;
}
function updateSelection(view, selection, origin) {
  if (!view.focused)
    view.focus();
  if (view.state.selection.eq(selection))
    return;
  let tr2 = view.state.tr.setSelection(selection);
  tr2.setMeta("pointer", true);
  view.dispatch(tr2);
}
function selectClickedLeaf(view, inside) {
  if (inside == -1)
    return false;
  let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
  if (node && node.isAtom && NodeSelection.isSelectable(node)) {
    updateSelection(view, new NodeSelection($pos));
    return true;
  }
  return false;
}
function selectClickedNode(view, inside) {
  if (inside == -1)
    return false;
  let sel = view.state.selection, selectedNode, selectAt;
  if (sel instanceof NodeSelection)
    selectedNode = sel.node;
  let $pos = view.state.doc.resolve(inside);
  for (let i = $pos.depth + 1; i > 0; i--) {
    let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    if (NodeSelection.isSelectable(node)) {
      if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
        selectAt = $pos.before(sel.$from.depth);
      else
        selectAt = $pos.before(i);
      break;
    }
  }
  if (selectAt != null) {
    updateSelection(view, NodeSelection.create(view.state.doc, selectAt));
    return true;
  } else {
    return false;
  }
}
function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f) => f(view, pos, event)) || (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside));
}
function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f) => f(view, pos, event));
}
function handleTripleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f) => f(view, pos, event)) || defaultTripleClick(view, inside, event);
}
function defaultTripleClick(view, inside, event) {
  if (event.button != 0)
    return false;
  let doc3 = view.state.doc;
  if (inside == -1) {
    if (doc3.inlineContent) {
      updateSelection(view, TextSelection.create(doc3, 0, doc3.content.size));
      return true;
    }
    return false;
  }
  let $pos = doc3.resolve(inside);
  for (let i = $pos.depth + 1; i > 0; i--) {
    let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    let nodePos = $pos.before(i);
    if (node.inlineContent)
      updateSelection(view, TextSelection.create(doc3, nodePos + 1, nodePos + 1 + node.content.size));
    else if (NodeSelection.isSelectable(node))
      updateSelection(view, NodeSelection.create(doc3, nodePos));
    else
      continue;
    return true;
  }
}
function forceDOMFlush(view) {
  return endComposition(view);
}
var selectNodeModifier = mac2 ? "metaKey" : "ctrlKey";
handlers.mousedown = (view, _event) => {
  let event = _event;
  view.input.shiftKey = event.shiftKey;
  let flushed = forceDOMFlush(view);
  let now = Date.now(), type = "singleClick";
  if (now - view.input.lastClick.time < 500 && isNear(event, view.input.lastClick) && !event[selectNodeModifier] && view.input.lastClick.button == event.button) {
    if (view.input.lastClick.type == "singleClick")
      type = "doubleClick";
    else if (view.input.lastClick.type == "doubleClick")
      type = "tripleClick";
  }
  view.input.lastClick = { time: now, x: event.clientX, y: event.clientY, type, button: event.button };
  let pos = view.posAtCoords(eventCoords(event));
  if (!pos)
    return;
  if (type == "singleClick") {
    if (view.input.mouseDown)
      view.input.mouseDown.done();
    view.input.mouseDown = new MouseDown(view, pos, event, !!flushed);
  } else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "pointer");
  }
};
var MouseDown = class {
  constructor(view, pos, event, flushed) {
    this.view = view;
    this.pos = pos;
    this.event = event;
    this.flushed = flushed;
    this.delayedSelectionSync = false;
    this.mightDrag = null;
    this.startDoc = view.state.doc;
    this.selectNode = !!event[selectNodeModifier];
    this.allowDefault = event.shiftKey;
    let targetNode, targetPos;
    if (pos.inside > -1) {
      targetNode = view.state.doc.nodeAt(pos.inside);
      targetPos = pos.inside;
    } else {
      let $pos = view.state.doc.resolve(pos.pos);
      targetNode = $pos.parent;
      targetPos = $pos.depth ? $pos.before() : 0;
    }
    const target = flushed ? null : event.target;
    const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
    this.target = targetDesc && targetDesc.nodeDOM.nodeType == 1 ? targetDesc.nodeDOM : null;
    let { selection } = view.state;
    if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof NodeSelection && selection.from <= targetPos && selection.to > targetPos)
      this.mightDrag = {
        node: targetNode,
        pos: targetPos,
        addAttr: !!(this.target && !this.target.draggable),
        setUneditable: !!(this.target && gecko && !this.target.hasAttribute("contentEditable"))
      };
    if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
      this.view.domObserver.stop();
      if (this.mightDrag.addAttr)
        this.target.draggable = true;
      if (this.mightDrag.setUneditable)
        setTimeout(() => {
          if (this.view.input.mouseDown == this)
            this.target.setAttribute("contentEditable", "false");
        }, 20);
      this.view.domObserver.start();
    }
    view.root.addEventListener("mouseup", this.up = this.up.bind(this));
    view.root.addEventListener("mousemove", this.move = this.move.bind(this));
    setSelectionOrigin(view, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up);
    this.view.root.removeEventListener("mousemove", this.move);
    if (this.mightDrag && this.target) {
      this.view.domObserver.stop();
      if (this.mightDrag.addAttr)
        this.target.removeAttribute("draggable");
      if (this.mightDrag.setUneditable)
        this.target.removeAttribute("contentEditable");
      this.view.domObserver.start();
    }
    if (this.delayedSelectionSync)
      setTimeout(() => selectionToDOM(this.view));
    this.view.input.mouseDown = null;
  }
  up(event) {
    this.done();
    if (!this.view.dom.contains(event.target))
      return;
    let pos = this.pos;
    if (this.view.state.doc != this.startDoc)
      pos = this.view.posAtCoords(eventCoords(event));
    this.updateAllowDefault(event);
    if (this.allowDefault || !pos) {
      setSelectionOrigin(this.view, "pointer");
    } else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
      event.preventDefault();
    } else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
      updateSelection(this.view, Selection.near(this.view.state.doc.resolve(pos.pos)));
      event.preventDefault();
    } else {
      setSelectionOrigin(this.view, "pointer");
    }
  }
  move(event) {
    this.updateAllowDefault(event);
    setSelectionOrigin(this.view, "pointer");
    if (event.buttons == 0)
      this.done();
  }
  updateAllowDefault(event) {
    if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4))
      this.allowDefault = true;
  }
};
handlers.touchstart = (view) => {
  view.input.lastTouch = Date.now();
  forceDOMFlush(view);
  setSelectionOrigin(view, "pointer");
};
handlers.touchmove = (view) => {
  view.input.lastTouch = Date.now();
  setSelectionOrigin(view, "pointer");
};
handlers.contextmenu = (view) => forceDOMFlush(view);
function inOrNearComposition(view, event) {
  if (view.composing)
    return true;
  if (safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
    view.input.compositionEndedAt = -2e8;
    return true;
  }
  return false;
}
var timeoutComposition = android ? 5e3 : -1;
editHandlers.compositionstart = editHandlers.compositionupdate = (view) => {
  if (!view.composing) {
    view.domObserver.flush();
    let { state } = view, $pos = state.selection.$to;
    if (state.selection instanceof TextSelection && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m) => m.type.spec.inclusive === false) || chrome && windows && selectionBeforeUneditable(view))) {
      view.markCursor = view.state.storedMarks || $pos.marks();
      endComposition(view, true);
      view.markCursor = null;
    } else {
      endComposition(view, !state.selection.empty);
      if (gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
        let sel = view.domSelectionRange();
        for (let node = sel.focusNode, offset5 = sel.focusOffset; node && node.nodeType == 1 && offset5 != 0; ) {
          let before = offset5 < 0 ? node.lastChild : node.childNodes[offset5 - 1];
          if (!before)
            break;
          if (before.nodeType == 3) {
            let sel2 = view.domSelection();
            if (sel2)
              sel2.collapse(before, before.nodeValue.length);
            break;
          } else {
            node = before;
            offset5 = -1;
          }
        }
      }
    }
    view.input.composing = true;
  }
  scheduleComposeEnd(view, timeoutComposition);
};
function selectionBeforeUneditable(view) {
  let { focusNode, focusOffset } = view.domSelectionRange();
  if (!focusNode || focusNode.nodeType != 1 || focusOffset >= focusNode.childNodes.length)
    return false;
  let next = focusNode.childNodes[focusOffset];
  return next.nodeType == 1 && next.contentEditable == "false";
}
editHandlers.compositionend = (view, event) => {
  if (view.composing) {
    view.input.composing = false;
    view.input.compositionEndedAt = event.timeStamp;
    view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
    view.input.compositionNode = null;
    if (view.input.compositionPendingChanges)
      Promise.resolve().then(() => view.domObserver.flush());
    view.input.compositionID++;
    scheduleComposeEnd(view, 20);
  }
};
function scheduleComposeEnd(view, delay) {
  clearTimeout(view.input.composingTimeout);
  if (delay > -1)
    view.input.composingTimeout = setTimeout(() => endComposition(view), delay);
}
function clearComposition(view) {
  if (view.composing) {
    view.input.composing = false;
    view.input.compositionEndedAt = timestampFromCustomEvent();
  }
  while (view.input.compositionNodes.length > 0)
    view.input.compositionNodes.pop().markParentsDirty();
}
function findCompositionNode(view) {
  let sel = view.domSelectionRange();
  if (!sel.focusNode)
    return null;
  let textBefore = textNodeBefore$1(sel.focusNode, sel.focusOffset);
  let textAfter = textNodeAfter$1(sel.focusNode, sel.focusOffset);
  if (textBefore && textAfter && textBefore != textAfter) {
    let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
    if (textBefore == lastChanged || textAfter == lastChanged)
      return lastChanged;
    if (!descAfter || !descAfter.isText(textAfter.nodeValue)) {
      return textAfter;
    } else if (view.input.compositionNode == textAfter) {
      let descBefore = textBefore.pmViewDesc;
      if (!(!descBefore || !descBefore.isText(textBefore.nodeValue)))
        return textAfter;
    }
  }
  return textBefore || textAfter;
}
function timestampFromCustomEvent() {
  let event = document.createEvent("Event");
  event.initEvent("event", true, true);
  return event.timeStamp;
}
function endComposition(view, restarting = false) {
  if (android && view.domObserver.flushingSoon >= 0)
    return;
  view.domObserver.forceFlush();
  clearComposition(view);
  if (restarting || view.docView && view.docView.dirty) {
    let sel = selectionFromDOM(view), cur = view.state.selection;
    if (sel && !sel.eq(cur))
      view.dispatch(view.state.tr.setSelection(sel));
    else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent)
      view.dispatch(view.state.tr.deleteSelection());
    else
      view.updateState(view.state);
    return true;
  }
  return false;
}
function captureCopy(view, dom) {
  if (!view.dom.parentNode)
    return;
  let wrap2 = view.dom.parentNode.appendChild(document.createElement("div"));
  wrap2.appendChild(dom);
  wrap2.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let sel = getSelection(), range = document.createRange();
  range.selectNodeContents(dom);
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range);
  setTimeout(() => {
    if (wrap2.parentNode)
      wrap2.parentNode.removeChild(wrap2);
    view.focus();
  }, 50);
}
var brokenClipboardAPI = ie && ie_version < 15 || ios && webkit_version < 604;
handlers.copy = editHandlers.cut = (view, _event) => {
  let event = _event;
  let sel = view.state.selection, cut2 = event.type == "cut";
  if (sel.empty)
    return;
  let data = brokenClipboardAPI ? null : event.clipboardData;
  let slice2 = sel.content(), { dom, text } = serializeForClipboard(view, slice2);
  if (data) {
    event.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text);
  } else {
    captureCopy(view, dom);
  }
  if (cut2)
    view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function sliceSingleNode(slice2) {
  return slice2.openStart == 0 && slice2.openEnd == 0 && slice2.content.childCount == 1 ? slice2.content.firstChild : null;
}
function capturePaste(view, event) {
  if (!view.dom.parentNode)
    return;
  let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
  let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
  if (!plainText)
    target.contentEditable = "true";
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
  setTimeout(() => {
    view.focus();
    if (target.parentNode)
      target.parentNode.removeChild(target);
    if (plainText)
      doPaste(view, target.value, null, plain, event);
    else
      doPaste(view, target.textContent, target.innerHTML, plain, event);
  }, 50);
}
function doPaste(view, text, html, preferPlain, event) {
  let slice2 = parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
  if (view.someProp("handlePaste", (f) => f(view, event, slice2 || Slice.empty)))
    return true;
  if (!slice2)
    return false;
  let singleNode = sliceSingleNode(slice2);
  let tr2 = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice2);
  view.dispatch(tr2.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
  return true;
}
function getText(clipboardData) {
  let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
  if (text)
    return text;
  let uris = clipboardData.getData("text/uri-list");
  return uris ? uris.replace(/\r?\n/g, " ") : "";
}
editHandlers.paste = (view, _event) => {
  let event = _event;
  if (view.composing && !android)
    return;
  let data = brokenClipboardAPI ? null : event.clipboardData;
  let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
  if (data && doPaste(view, getText(data), data.getData("text/html"), plain, event))
    event.preventDefault();
  else
    capturePaste(view, event);
};
var Dragging = class {
  constructor(slice2, move, node) {
    this.slice = slice2;
    this.move = move;
    this.node = node;
  }
};
var dragCopyModifier = mac2 ? "altKey" : "ctrlKey";
function dragMoves(view, event) {
  let moves = view.someProp("dragCopies", (test) => !test(event));
  return moves != null ? moves : !event[dragCopyModifier];
}
handlers.dragstart = (view, _event) => {
  let event = _event;
  let mouseDown = view.input.mouseDown;
  if (mouseDown)
    mouseDown.done();
  if (!event.dataTransfer)
    return;
  let sel = view.state.selection;
  let pos = sel.empty ? null : view.posAtCoords(eventCoords(event));
  let node;
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof NodeSelection ? sel.to - 1 : sel.to)) ;
  else if (mouseDown && mouseDown.mightDrag) {
    node = NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos);
  } else if (event.target && event.target.nodeType == 1) {
    let desc = view.docView.nearestDesc(event.target, true);
    if (desc && desc.node.type.spec.draggable && desc != view.docView)
      node = NodeSelection.create(view.state.doc, desc.posBefore);
  }
  let draggedSlice = (node || view.state.selection).content();
  let { dom, text, slice: slice2 } = serializeForClipboard(view, draggedSlice);
  if (!event.dataTransfer.files.length || !chrome || chrome_version > 120)
    event.dataTransfer.clearData();
  event.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  event.dataTransfer.effectAllowed = "copyMove";
  if (!brokenClipboardAPI)
    event.dataTransfer.setData("text/plain", text);
  view.dragging = new Dragging(slice2, dragMoves(view, event), node);
};
handlers.dragend = (view) => {
  let dragging = view.dragging;
  window.setTimeout(() => {
    if (view.dragging == dragging)
      view.dragging = null;
  }, 50);
};
editHandlers.dragover = editHandlers.dragenter = (_, e) => e.preventDefault();
editHandlers.drop = (view, event) => {
  try {
    handleDrop(view, event, view.dragging);
  } finally {
    view.dragging = null;
  }
};
function handleDrop(view, event, dragging) {
  if (!event.dataTransfer)
    return;
  let eventPos = view.posAtCoords(eventCoords(event));
  if (!eventPos)
    return;
  let $mouse = view.state.doc.resolve(eventPos.pos);
  let slice2 = dragging && dragging.slice;
  if (slice2) {
    view.someProp("transformPasted", (f) => {
      slice2 = f(slice2, view, false);
    });
  } else {
    slice2 = parseFromClipboard(view, getText(event.dataTransfer), brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
  }
  let move = !!(dragging && dragMoves(view, event));
  if (view.someProp("handleDrop", (f) => f(view, event, slice2 || Slice.empty, move))) {
    event.preventDefault();
    return;
  }
  if (!slice2)
    return;
  event.preventDefault();
  let insertPos = slice2 ? dropPoint(view.state.doc, $mouse.pos, slice2) : $mouse.pos;
  if (insertPos == null)
    insertPos = $mouse.pos;
  let tr2 = view.state.tr;
  if (move) {
    let { node } = dragging;
    if (node)
      node.replace(tr2);
    else
      tr2.deleteSelection();
  }
  let pos = tr2.mapping.map(insertPos);
  let isNode2 = slice2.openStart == 0 && slice2.openEnd == 0 && slice2.content.childCount == 1;
  let beforeInsert = tr2.doc;
  if (isNode2)
    tr2.replaceRangeWith(pos, pos, slice2.content.firstChild);
  else
    tr2.replaceRange(pos, pos, slice2);
  if (tr2.doc.eq(beforeInsert))
    return;
  let $pos = tr2.doc.resolve(pos);
  if (isNode2 && NodeSelection.isSelectable(slice2.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice2.content.firstChild)) {
    tr2.setSelection(new NodeSelection($pos));
  } else {
    let end2 = tr2.mapping.map(insertPos);
    tr2.mapping.maps[tr2.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo) => end2 = newTo);
    tr2.setSelection(selectionBetween(view, $pos, tr2.doc.resolve(end2)));
  }
  view.focus();
  view.dispatch(tr2.setMeta("uiEvent", "drop"));
}
handlers.focus = (view) => {
  view.input.lastFocus = Date.now();
  if (!view.focused) {
    view.domObserver.stop();
    view.dom.classList.add("ProseMirror-focused");
    view.domObserver.start();
    view.focused = true;
    setTimeout(() => {
      if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange()))
        selectionToDOM(view);
    }, 20);
  }
};
handlers.blur = (view, _event) => {
  let event = _event;
  if (view.focused) {
    view.domObserver.stop();
    view.dom.classList.remove("ProseMirror-focused");
    view.domObserver.start();
    if (event.relatedTarget && view.dom.contains(event.relatedTarget))
      view.domObserver.currentSelection.clear();
    view.focused = false;
  }
};
handlers.beforeinput = (view, _event) => {
  let event = _event;
  if (chrome && android && event.inputType == "deleteContentBackward") {
    view.domObserver.flushSoon();
    let { domChangeCount } = view.input;
    setTimeout(() => {
      if (view.input.domChangeCount != domChangeCount)
        return;
      view.dom.blur();
      view.focus();
      if (view.someProp("handleKeyDown", (f) => f(view, keyEvent(8, "Backspace"))))
        return;
      let { $cursor } = view.state.selection;
      if ($cursor && $cursor.pos > 0)
        view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
    }, 50);
  }
};
for (let prop in editHandlers)
  handlers[prop] = editHandlers[prop];
function compareObjs(a, b) {
  if (a == b)
    return true;
  for (let p in a)
    if (a[p] !== b[p])
      return false;
  for (let p in b)
    if (!(p in a))
      return false;
  return true;
}
var WidgetType = class _WidgetType {
  constructor(toDOM, spec) {
    this.toDOM = toDOM;
    this.spec = spec || noSpec;
    this.side = this.spec.side || 0;
  }
  map(mapping, span, offset5, oldOffset) {
    let { pos, deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
    return deleted ? null : new Decoration(pos - offset5, pos - offset5, this);
  }
  valid() {
    return true;
  }
  eq(other) {
    return this == other || other instanceof _WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && compareObjs(this.spec, other.spec));
  }
  destroy(node) {
    if (this.spec.destroy)
      this.spec.destroy(node);
  }
};
var InlineType = class _InlineType {
  constructor(attrs, spec) {
    this.attrs = attrs;
    this.spec = spec || noSpec;
  }
  map(mapping, span, offset5, oldOffset) {
    let from2 = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset5;
    let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset5;
    return from2 >= to ? null : new Decoration(from2, to, this);
  }
  valid(_, span) {
    return span.from < span.to;
  }
  eq(other) {
    return this == other || other instanceof _InlineType && compareObjs(this.attrs, other.attrs) && compareObjs(this.spec, other.spec);
  }
  static is(span) {
    return span.type instanceof _InlineType;
  }
  destroy() {
  }
};
var NodeType2 = class _NodeType {
  constructor(attrs, spec) {
    this.attrs = attrs;
    this.spec = spec || noSpec;
  }
  map(mapping, span, offset5, oldOffset) {
    let from2 = mapping.mapResult(span.from + oldOffset, 1);
    if (from2.deleted)
      return null;
    let to = mapping.mapResult(span.to + oldOffset, -1);
    if (to.deleted || to.pos <= from2.pos)
      return null;
    return new Decoration(from2.pos - offset5, to.pos - offset5, this);
  }
  valid(node, span) {
    let { index: index2, offset: offset5 } = node.content.findIndex(span.from), child;
    return offset5 == span.from && !(child = node.child(index2)).isText && offset5 + child.nodeSize == span.to;
  }
  eq(other) {
    return this == other || other instanceof _NodeType && compareObjs(this.attrs, other.attrs) && compareObjs(this.spec, other.spec);
  }
  destroy() {
  }
};
var Decoration = class _Decoration {
  /**
  @internal
  */
  constructor(from2, to, type) {
    this.from = from2;
    this.to = to;
    this.type = type;
  }
  /**
  @internal
  */
  copy(from2, to) {
    return new _Decoration(from2, to, this.type);
  }
  /**
  @internal
  */
  eq(other, offset5 = 0) {
    return this.type.eq(other.type) && this.from + offset5 == other.from && this.to + offset5 == other.to;
  }
  /**
  @internal
  */
  map(mapping, offset5, oldOffset) {
    return this.type.map(mapping, this, offset5, oldOffset);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(pos, toDOM, spec) {
    return new _Decoration(pos, pos, new WidgetType(toDOM, spec));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(from2, to, attrs, spec) {
    return new _Decoration(from2, to, new InlineType(attrs, spec));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(from2, to, attrs, spec) {
    return new _Decoration(from2, to, new NodeType2(attrs, spec));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof InlineType;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof WidgetType;
  }
};
var none = [];
var noSpec = {};
var DecorationSet = class _DecorationSet {
  /**
  @internal
  */
  constructor(local, children) {
    this.local = local.length ? local : none;
    this.children = children.length ? children : none;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(doc3, decorations) {
    return decorations.length ? buildTree(decorations, doc3, 0, noSpec) : empty;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(start2, end2, predicate) {
    let result = [];
    this.findInner(start2 == null ? 0 : start2, end2 == null ? 1e9 : end2, result, 0, predicate);
    return result;
  }
  findInner(start2, end2, result, offset5, predicate) {
    for (let i = 0; i < this.local.length; i++) {
      let span = this.local[i];
      if (span.from <= end2 && span.to >= start2 && (!predicate || predicate(span.spec)))
        result.push(span.copy(span.from + offset5, span.to + offset5));
    }
    for (let i = 0; i < this.children.length; i += 3) {
      if (this.children[i] < end2 && this.children[i + 1] > start2) {
        let childOff = this.children[i] + 1;
        this.children[i + 2].findInner(start2 - childOff, end2 - childOff, result, offset5 + childOff, predicate);
      }
    }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(mapping, doc3, options) {
    if (this == empty || mapping.maps.length == 0)
      return this;
    return this.mapInner(mapping, doc3, 0, 0, options || noSpec);
  }
  /**
  @internal
  */
  mapInner(mapping, node, offset5, oldOffset, options) {
    let newLocal;
    for (let i = 0; i < this.local.length; i++) {
      let mapped = this.local[i].map(mapping, offset5, oldOffset);
      if (mapped && mapped.type.valid(node, mapped))
        (newLocal || (newLocal = [])).push(mapped);
      else if (options.onRemove)
        options.onRemove(this.local[i].spec);
    }
    if (this.children.length)
      return mapChildren(this.children, newLocal || [], mapping, node, offset5, oldOffset, options);
    else
      return newLocal ? new _DecorationSet(newLocal.sort(byPos), none) : empty;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(doc3, decorations) {
    if (!decorations.length)
      return this;
    if (this == empty)
      return _DecorationSet.create(doc3, decorations);
    return this.addInner(doc3, decorations, 0);
  }
  addInner(doc3, decorations, offset5) {
    let children, childIndex = 0;
    doc3.forEach((childNode, childOffset) => {
      let baseOffset = childOffset + offset5, found2;
      if (!(found2 = takeSpansForNode(decorations, childNode, baseOffset)))
        return;
      if (!children)
        children = this.children.slice();
      while (childIndex < children.length && children[childIndex] < childOffset)
        childIndex += 3;
      if (children[childIndex] == childOffset)
        children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found2, baseOffset + 1);
      else
        children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found2, childNode, baseOffset + 1, noSpec));
      childIndex += 3;
    });
    let local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset5);
    for (let i = 0; i < local.length; i++)
      if (!local[i].type.valid(doc3, local[i]))
        local.splice(i--, 1);
    return new _DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local, children || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(decorations) {
    if (decorations.length == 0 || this == empty)
      return this;
    return this.removeInner(decorations, 0);
  }
  removeInner(decorations, offset5) {
    let children = this.children, local = this.local;
    for (let i = 0; i < children.length; i += 3) {
      let found2;
      let from2 = children[i] + offset5, to = children[i + 1] + offset5;
      for (let j = 0, span; j < decorations.length; j++)
        if (span = decorations[j]) {
          if (span.from > from2 && span.to < to) {
            decorations[j] = null;
            (found2 || (found2 = [])).push(span);
          }
        }
      if (!found2)
        continue;
      if (children == this.children)
        children = this.children.slice();
      let removed = children[i + 2].removeInner(found2, from2 + 1);
      if (removed != empty) {
        children[i + 2] = removed;
      } else {
        children.splice(i, 3);
        i -= 3;
      }
    }
    if (local.length) {
      for (let i = 0, span; i < decorations.length; i++)
        if (span = decorations[i]) {
          for (let j = 0; j < local.length; j++)
            if (local[j].eq(span, offset5)) {
              if (local == this.local)
                local = this.local.slice();
              local.splice(j--, 1);
            }
        }
    }
    if (children == this.children && local == this.local)
      return this;
    return local.length || children.length ? new _DecorationSet(local, children) : empty;
  }
  forChild(offset5, node) {
    if (this == empty)
      return this;
    if (node.isLeaf)
      return _DecorationSet.empty;
    let child, local;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] >= offset5) {
        if (this.children[i] == offset5)
          child = this.children[i + 2];
        break;
      }
    let start2 = offset5 + 1, end2 = start2 + node.content.size;
    for (let i = 0; i < this.local.length; i++) {
      let dec = this.local[i];
      if (dec.from < end2 && dec.to > start2 && dec.type instanceof InlineType) {
        let from2 = Math.max(start2, dec.from) - start2, to = Math.min(end2, dec.to) - start2;
        if (from2 < to)
          (local || (local = [])).push(dec.copy(from2, to));
      }
    }
    if (local) {
      let localSet = new _DecorationSet(local.sort(byPos), none);
      return child ? new DecorationGroup([localSet, child]) : localSet;
    }
    return child || empty;
  }
  /**
  @internal
  */
  eq(other) {
    if (this == other)
      return true;
    if (!(other instanceof _DecorationSet) || this.local.length != other.local.length || this.children.length != other.children.length)
      return false;
    for (let i = 0; i < this.local.length; i++)
      if (!this.local[i].eq(other.local[i]))
        return false;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2]))
        return false;
    return true;
  }
  /**
  @internal
  */
  locals(node) {
    return removeOverlap(this.localsInner(node));
  }
  /**
  @internal
  */
  localsInner(node) {
    if (this == empty)
      return none;
    if (node.inlineContent || !this.local.some(InlineType.is))
      return this.local;
    let result = [];
    for (let i = 0; i < this.local.length; i++) {
      if (!(this.local[i].type instanceof InlineType))
        result.push(this.local[i]);
    }
    return result;
  }
  forEachSet(f) {
    f(this);
  }
};
DecorationSet.empty = new DecorationSet([], []);
DecorationSet.removeOverlap = removeOverlap;
var empty = DecorationSet.empty;
var DecorationGroup = class _DecorationGroup {
  constructor(members) {
    this.members = members;
  }
  map(mapping, doc3) {
    const mappedDecos = this.members.map((member) => member.map(mapping, doc3, noSpec));
    return _DecorationGroup.from(mappedDecos);
  }
  forChild(offset5, child) {
    if (child.isLeaf)
      return DecorationSet.empty;
    let found2 = [];
    for (let i = 0; i < this.members.length; i++) {
      let result = this.members[i].forChild(offset5, child);
      if (result == empty)
        continue;
      if (result instanceof _DecorationGroup)
        found2 = found2.concat(result.members);
      else
        found2.push(result);
    }
    return _DecorationGroup.from(found2);
  }
  eq(other) {
    if (!(other instanceof _DecorationGroup) || other.members.length != this.members.length)
      return false;
    for (let i = 0; i < this.members.length; i++)
      if (!this.members[i].eq(other.members[i]))
        return false;
    return true;
  }
  locals(node) {
    let result, sorted = true;
    for (let i = 0; i < this.members.length; i++) {
      let locals = this.members[i].localsInner(node);
      if (!locals.length)
        continue;
      if (!result) {
        result = locals;
      } else {
        if (sorted) {
          result = result.slice();
          sorted = false;
        }
        for (let j = 0; j < locals.length; j++)
          result.push(locals[j]);
      }
    }
    return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(members) {
    switch (members.length) {
      case 0:
        return empty;
      case 1:
        return members[0];
      default:
        return new _DecorationGroup(members.every((m) => m instanceof DecorationSet) ? members : members.reduce((r2, m) => r2.concat(m instanceof DecorationSet ? m : m.members), []));
    }
  }
  forEachSet(f) {
    for (let i = 0; i < this.members.length; i++)
      this.members[i].forEachSet(f);
  }
};
function mapChildren(oldChildren, newLocal, mapping, node, offset5, oldOffset, options) {
  let children = oldChildren.slice();
  for (let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++) {
    let moved = 0;
    mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd) => {
      let dSize = newEnd - newStart - (oldEnd - oldStart);
      for (let i2 = 0; i2 < children.length; i2 += 3) {
        let end2 = children[i2 + 1];
        if (end2 < 0 || oldStart > end2 + baseOffset - moved)
          continue;
        let start2 = children[i2] + baseOffset - moved;
        if (oldEnd >= start2) {
          children[i2 + 1] = oldStart <= start2 ? -2 : -1;
        } else if (oldStart >= baseOffset && dSize) {
          children[i2] += dSize;
          children[i2 + 1] += dSize;
        }
      }
      moved += dSize;
    });
    baseOffset = mapping.maps[i].map(baseOffset, -1);
  }
  let mustRebuild = false;
  for (let i = 0; i < children.length; i += 3)
    if (children[i + 1] < 0) {
      if (children[i + 1] == -2) {
        mustRebuild = true;
        children[i + 1] = -1;
        continue;
      }
      let from2 = mapping.map(oldChildren[i] + oldOffset), fromLocal = from2 - offset5;
      if (fromLocal < 0 || fromLocal >= node.content.size) {
        mustRebuild = true;
        continue;
      }
      let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset5;
      let { index: index2, offset: childOffset } = node.content.findIndex(fromLocal);
      let childNode = node.maybeChild(index2);
      if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
        let mapped = children[i + 2].mapInner(mapping, childNode, from2 + 1, oldChildren[i] + oldOffset + 1, options);
        if (mapped != empty) {
          children[i] = fromLocal;
          children[i + 1] = toLocal;
          children[i + 2] = mapped;
        } else {
          children[i + 1] = -2;
          mustRebuild = true;
        }
      } else {
        mustRebuild = true;
      }
    }
  if (mustRebuild) {
    let decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset5, oldOffset, options);
    let built = buildTree(decorations, node, 0, options);
    newLocal = built.local;
    for (let i = 0; i < children.length; i += 3)
      if (children[i + 1] < 0) {
        children.splice(i, 3);
        i -= 3;
      }
    for (let i = 0, j = 0; i < built.children.length; i += 3) {
      let from2 = built.children[i];
      while (j < children.length && children[j] < from2)
        j += 3;
      children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
    }
  }
  return new DecorationSet(newLocal.sort(byPos), children);
}
function moveSpans(spans, offset5) {
  if (!offset5 || !spans.length)
    return spans;
  let result = [];
  for (let i = 0; i < spans.length; i++) {
    let span = spans[i];
    result.push(new Decoration(span.from + offset5, span.to + offset5, span.type));
  }
  return result;
}
function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset5, oldOffset, options) {
  function gather(set, oldOffset2) {
    for (let i = 0; i < set.local.length; i++) {
      let mapped = set.local[i].map(mapping, offset5, oldOffset2);
      if (mapped)
        decorations.push(mapped);
      else if (options.onRemove)
        options.onRemove(set.local[i].spec);
    }
    for (let i = 0; i < set.children.length; i += 3)
      gather(set.children[i + 2], set.children[i] + oldOffset2 + 1);
  }
  for (let i = 0; i < children.length; i += 3)
    if (children[i + 1] == -1)
      gather(children[i + 2], oldChildren[i] + oldOffset + 1);
  return decorations;
}
function takeSpansForNode(spans, node, offset5) {
  if (node.isLeaf)
    return null;
  let end2 = offset5 + node.nodeSize, found2 = null;
  for (let i = 0, span; i < spans.length; i++) {
    if ((span = spans[i]) && span.from > offset5 && span.to < end2) {
      (found2 || (found2 = [])).push(span);
      spans[i] = null;
    }
  }
  return found2;
}
function withoutNulls(array) {
  let result = [];
  for (let i = 0; i < array.length; i++)
    if (array[i] != null)
      result.push(array[i]);
  return result;
}
function buildTree(spans, node, offset5, options) {
  let children = [], hasNulls = false;
  node.forEach((childNode, localStart) => {
    let found2 = takeSpansForNode(spans, childNode, localStart + offset5);
    if (found2) {
      hasNulls = true;
      let subtree = buildTree(found2, childNode, offset5 + localStart + 1, options);
      if (subtree != empty)
        children.push(localStart, localStart + childNode.nodeSize, subtree);
    }
  });
  let locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset5).sort(byPos);
  for (let i = 0; i < locals.length; i++)
    if (!locals[i].type.valid(node, locals[i])) {
      if (options.onRemove)
        options.onRemove(locals[i].spec);
      locals.splice(i--, 1);
    }
  return locals.length || children.length ? new DecorationSet(locals, children) : empty;
}
function byPos(a, b) {
  return a.from - b.from || a.to - b.to;
}
function removeOverlap(spans) {
  let working = spans;
  for (let i = 0; i < working.length - 1; i++) {
    let span = working[i];
    if (span.from != span.to)
      for (let j = i + 1; j < working.length; j++) {
        let next = working[j];
        if (next.from == span.from) {
          if (next.to != span.to) {
            if (working == spans)
              working = spans.slice();
            working[j] = next.copy(next.from, span.to);
            insertAhead(working, j + 1, next.copy(span.to, next.to));
          }
          continue;
        } else {
          if (next.from < span.to) {
            if (working == spans)
              working = spans.slice();
            working[i] = span.copy(span.from, next.from);
            insertAhead(working, j, span.copy(next.from, span.to));
          }
          break;
        }
      }
  }
  return working;
}
function insertAhead(array, i, deco) {
  while (i < array.length && byPos(deco, array[i]) > 0)
    i++;
  array.splice(i, 0, deco);
}
function viewDecorations(view) {
  let found2 = [];
  view.someProp("decorations", (f) => {
    let result = f(view.state);
    if (result && result != empty)
      found2.push(result);
  });
  if (view.cursorWrapper)
    found2.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco]));
  return DecorationGroup.from(found2);
}
var observeOptions = {
  childList: true,
  characterData: true,
  characterDataOldValue: true,
  attributes: true,
  attributeOldValue: true,
  subtree: true
};
var useCharData = ie && ie_version <= 11;
var SelectionState = class {
  constructor() {
    this.anchorNode = null;
    this.anchorOffset = 0;
    this.focusNode = null;
    this.focusOffset = 0;
  }
  set(sel) {
    this.anchorNode = sel.anchorNode;
    this.anchorOffset = sel.anchorOffset;
    this.focusNode = sel.focusNode;
    this.focusOffset = sel.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(sel) {
    return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
  }
};
var DOMObserver = class {
  constructor(view, handleDOMChange) {
    this.view = view;
    this.handleDOMChange = handleDOMChange;
    this.queue = [];
    this.flushingSoon = -1;
    this.observer = null;
    this.currentSelection = new SelectionState();
    this.onCharData = null;
    this.suppressingSelectionUpdates = false;
    this.lastChangedTextNode = null;
    this.observer = window.MutationObserver && new window.MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++)
        this.queue.push(mutations[i]);
      if (ie && ie_version <= 11 && mutations.some((m) => m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length))
        this.flushSoon();
      else
        this.flush();
    });
    if (useCharData) {
      this.onCharData = (e) => {
        this.queue.push({ target: e.target, type: "characterData", oldValue: e.prevValue });
        this.flushSoon();
      };
    }
    this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    if (this.flushingSoon < 0)
      this.flushingSoon = window.setTimeout(() => {
        this.flushingSoon = -1;
        this.flush();
      }, 20);
  }
  forceFlush() {
    if (this.flushingSoon > -1) {
      window.clearTimeout(this.flushingSoon);
      this.flushingSoon = -1;
      this.flush();
    }
  }
  start() {
    if (this.observer) {
      this.observer.takeRecords();
      this.observer.observe(this.view.dom, observeOptions);
    }
    if (this.onCharData)
      this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
    this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let take = this.observer.takeRecords();
      if (take.length) {
        for (let i = 0; i < take.length; i++)
          this.queue.push(take[i]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    if (this.onCharData)
      this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = true;
    setTimeout(() => this.suppressingSelectionUpdates = false, 50);
  }
  onSelectionChange() {
    if (!hasFocusAndSelection(this.view))
      return;
    if (this.suppressingSelectionUpdates)
      return selectionToDOM(this.view);
    if (ie && ie_version <= 11 && !this.view.state.selection.empty) {
      let sel = this.view.domSelectionRange();
      if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
        return this.flushSoon();
    }
    this.flush();
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(sel) {
    if (!sel.focusNode)
      return true;
    let ancestors = /* @__PURE__ */ new Set(), container;
    for (let scan = sel.focusNode; scan; scan = parentNode(scan))
      ancestors.add(scan);
    for (let scan = sel.anchorNode; scan; scan = parentNode(scan))
      if (ancestors.has(scan)) {
        container = scan;
        break;
      }
    let desc = container && this.view.docView.nearestDesc(container);
    if (desc && desc.ignoreMutation({
      type: "selection",
      target: container.nodeType == 3 ? container.parentNode : container
    })) {
      this.setCurSelection();
      return true;
    }
  }
  pendingRecords() {
    if (this.observer)
      for (let mut of this.observer.takeRecords())
        this.queue.push(mut);
    return this.queue;
  }
  flush() {
    let { view } = this;
    if (!view.docView || this.flushingSoon > -1)
      return;
    let mutations = this.pendingRecords();
    if (mutations.length)
      this.queue = [];
    let sel = view.domSelectionRange();
    let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
    let from2 = -1, to = -1, typeOver = false, added = [];
    if (view.editable) {
      for (let i = 0; i < mutations.length; i++) {
        let result = this.registerMutation(mutations[i], added);
        if (result) {
          from2 = from2 < 0 ? result.from : Math.min(result.from, from2);
          to = to < 0 ? result.to : Math.max(result.to, to);
          if (result.typeOver)
            typeOver = true;
        }
      }
    }
    if (gecko && added.length) {
      let brs = added.filter((n) => n.nodeName == "BR");
      if (brs.length == 2) {
        let [a, b] = brs;
        if (a.parentNode && a.parentNode.parentNode == b.parentNode)
          b.remove();
        else
          a.remove();
      } else {
        let { focusNode } = this.currentSelection;
        for (let br of brs) {
          let parent = br.parentNode;
          if (parent && parent.nodeName == "LI" && (!focusNode || blockParent(view, focusNode) != parent))
            br.remove();
        }
      }
    } else if ((chrome || safari) && added.some((n) => n.nodeName == "BR") && (view.input.lastKeyCode == 8 || view.input.lastKeyCode == 46)) {
      for (let node of added)
        if (node.nodeName == "BR" && node.parentNode) {
          let after = node.nextSibling;
          if (after && after.nodeType == 1 && after.contentEditable == "false")
            node.parentNode.removeChild(node);
        }
    }
    let readSel = null;
    if (from2 < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && selectionCollapsed(sel) && (readSel = selectionFromDOM(view)) && readSel.eq(Selection.near(view.state.doc.resolve(0), 1))) {
      view.input.lastFocus = 0;
      selectionToDOM(view);
      this.currentSelection.set(sel);
      view.scrollToSelection();
    } else if (from2 > -1 || newSel) {
      if (from2 > -1) {
        view.docView.markDirty(from2, to);
        checkCSS(view);
      }
      this.handleDOMChange(from2, to, typeOver, added);
      if (view.docView && view.docView.dirty)
        view.updateState(view.state);
      else if (!this.currentSelection.eq(sel))
        selectionToDOM(view);
      this.currentSelection.set(sel);
    }
  }
  registerMutation(mut, added) {
    if (added.indexOf(mut.target) > -1)
      return null;
    let desc = this.view.docView.nearestDesc(mut.target);
    if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style")))
      return null;
    if (!desc || desc.ignoreMutation(mut))
      return null;
    if (mut.type == "childList") {
      for (let i = 0; i < mut.addedNodes.length; i++) {
        let node = mut.addedNodes[i];
        added.push(node);
        if (node.nodeType == 3)
          this.lastChangedTextNode = node;
      }
      if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target))
        return { from: desc.posBefore, to: desc.posAfter };
      let prev = mut.previousSibling, next = mut.nextSibling;
      if (ie && ie_version <= 11 && mut.addedNodes.length) {
        for (let i = 0; i < mut.addedNodes.length; i++) {
          let { previousSibling, nextSibling } = mut.addedNodes[i];
          if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0)
            prev = previousSibling;
          if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0)
            next = nextSibling;
        }
      }
      let fromOffset = prev && prev.parentNode == mut.target ? domIndex(prev) + 1 : 0;
      let from2 = desc.localPosFromDOM(mut.target, fromOffset, -1);
      let toOffset = next && next.parentNode == mut.target ? domIndex(next) : mut.target.childNodes.length;
      let to = desc.localPosFromDOM(mut.target, toOffset, 1);
      return { from: from2, to };
    } else if (mut.type == "attributes") {
      return { from: desc.posAtStart - desc.border, to: desc.posAtEnd + desc.border };
    } else {
      this.lastChangedTextNode = mut.target;
      return {
        from: desc.posAtStart,
        to: desc.posAtEnd,
        // An event was generated for a text change that didn't change
        // any text. Mark the dom change to fall back to assuming the
        // selection was typed over with an identical value if it can't
        // find another change.
        typeOver: mut.target.nodeValue == mut.oldValue
      };
    }
  }
};
var cssChecked = /* @__PURE__ */ new WeakMap();
var cssCheckWarned = false;
function checkCSS(view) {
  if (cssChecked.has(view))
    return;
  cssChecked.set(view, null);
  if (["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
    view.requiresGeckoHackNode = gecko;
    if (cssCheckWarned)
      return;
    console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
    cssCheckWarned = true;
  }
}
function rangeToSelectionRange(view, range) {
  let anchorNode = range.startContainer, anchorOffset = range.startOffset;
  let focusNode = range.endContainer, focusOffset = range.endOffset;
  let currentAnchor = view.domAtPos(view.state.selection.anchor);
  if (isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset))
    [anchorNode, anchorOffset, focusNode, focusOffset] = [focusNode, focusOffset, anchorNode, anchorOffset];
  return { anchorNode, anchorOffset, focusNode, focusOffset };
}
function safariShadowSelectionRange(view, selection) {
  if (selection.getComposedRanges) {
    let range = selection.getComposedRanges(view.root)[0];
    if (range)
      return rangeToSelectionRange(view, range);
  }
  let found2;
  function read2(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    found2 = event.getTargetRanges()[0];
  }
  view.dom.addEventListener("beforeinput", read2, true);
  document.execCommand("indent");
  view.dom.removeEventListener("beforeinput", read2, true);
  return found2 ? rangeToSelectionRange(view, found2) : null;
}
function blockParent(view, node) {
  for (let p = node.parentNode; p && p != view.dom; p = p.parentNode) {
    let desc = view.docView.nearestDesc(p, true);
    if (desc && desc.node.isBlock)
      return p;
  }
  return null;
}
function parseBetween(view, from_, to_) {
  let { node: parent, fromOffset, toOffset, from: from2, to } = view.docView.parseRange(from_, to_);
  let domSel = view.domSelectionRange();
  let find2;
  let anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find2 = [{ node: anchor, offset: domSel.anchorOffset }];
    if (!selectionCollapsed(domSel))
      find2.push({ node: domSel.focusNode, offset: domSel.focusOffset });
  }
  if (chrome && view.input.lastKeyCode === 8) {
    for (let off = toOffset; off > fromOffset; off--) {
      let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
      if (node.nodeName == "BR" && !desc) {
        toOffset = off;
        break;
      }
      if (!desc || desc.size)
        break;
    }
  }
  let startDoc = view.state.doc;
  let parser = view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
  let $from = startDoc.resolve(from2);
  let sel = null, doc3 = parser.parse(parent, {
    topNode: $from.parent,
    topMatch: $from.parent.contentMatchAt($from.index()),
    topOpen: true,
    from: fromOffset,
    to: toOffset,
    preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
    findPositions: find2,
    ruleFromNode,
    context: $from
  });
  if (find2 && find2[0].pos != null) {
    let anchor2 = find2[0].pos, head = find2[1] && find2[1].pos;
    if (head == null)
      head = anchor2;
    sel = { anchor: anchor2 + from2, head: head + from2 };
  }
  return { doc: doc3, sel, from: from2, to };
}
function ruleFromNode(dom) {
  let desc = dom.pmViewDesc;
  if (desc) {
    return desc.parseRule();
  } else if (dom.nodeName == "BR" && dom.parentNode) {
    if (safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
      let skip = document.createElement("div");
      skip.appendChild(document.createElement("li"));
      return { skip };
    } else if (dom.parentNode.lastChild == dom || safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) {
      return { ignore: true };
    }
  } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
    return { ignore: true };
  }
  return null;
}
var isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function readDOMChange(view, from2, to, typeOver, addedNodes) {
  let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
  view.input.compositionPendingChanges = 0;
  if (from2 < 0) {
    let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
    let newSel = selectionFromDOM(view, origin);
    if (newSel && !view.state.selection.eq(newSel)) {
      if (chrome && android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f) => f(view, keyEvent(13, "Enter"))))
        return;
      let tr2 = view.state.tr.setSelection(newSel);
      if (origin == "pointer")
        tr2.setMeta("pointer", true);
      else if (origin == "key")
        tr2.scrollIntoView();
      if (compositionID)
        tr2.setMeta("composition", compositionID);
      view.dispatch(tr2);
    }
    return;
  }
  let $before = view.state.doc.resolve(from2);
  let shared = $before.sharedDepth(to);
  from2 = $before.before(shared + 1);
  to = view.state.doc.resolve(to).after(shared + 1);
  let sel = view.state.selection;
  let parse2 = parseBetween(view, from2, to);
  let doc3 = view.state.doc, compare = doc3.slice(parse2.from, parse2.to);
  let preferredPos, preferredSide;
  if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
    preferredPos = view.state.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = view.state.selection.from;
    preferredSide = "start";
  }
  view.input.lastKeyCode = null;
  let change = findDiff(compare.content, parse2.doc.content, parse2.from, preferredPos, preferredSide);
  if (change)
    view.input.domChangeCount++;
  if ((ios && view.input.lastIOSEnter > Date.now() - 225 || android) && addedNodes.some((n) => n.nodeType == 1 && !isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f) => f(view, keyEvent(13, "Enter")))) {
    view.input.lastIOSEnter = 0;
    return;
  }
  if (!change) {
    if (typeOver && sel instanceof TextSelection && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse2.sel && parse2.sel.anchor != parse2.sel.head)) {
      change = { start: sel.from, endA: sel.to, endB: sel.to };
    } else {
      if (parse2.sel) {
        let sel2 = resolveSelection(view, view.state.doc, parse2.sel);
        if (sel2 && !sel2.eq(view.state.selection)) {
          let tr2 = view.state.tr.setSelection(sel2);
          if (compositionID)
            tr2.setMeta("composition", compositionID);
          view.dispatch(tr2);
        }
      }
      return;
    }
  }
  if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof TextSelection) {
    if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse2.from) {
      change.start = view.state.selection.from;
    } else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse2.to) {
      change.endB += view.state.selection.to - change.endA;
      change.endA = view.state.selection.to;
    }
  }
  if (ie && ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse2.from && parse2.doc.textBetween(change.start - parse2.from - 1, change.start - parse2.from + 1) == " \xA0") {
    change.start--;
    change.endA--;
    change.endB--;
  }
  let $from = parse2.doc.resolveNoCache(change.start - parse2.from);
  let $to = parse2.doc.resolveNoCache(change.endB - parse2.from);
  let $fromA = doc3.resolve(change.start);
  let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
  if ((ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n) => n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse2.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && $from.pos < $to.pos && !/\S/.test(parse2.doc.textBetween($from.pos, $to.pos, "", ""))) && view.someProp("handleKeyDown", (f) => f(view, keyEvent(13, "Enter")))) {
    view.input.lastIOSEnter = 0;
    return;
  }
  if (view.state.selection.anchor > change.start && looksLikeBackspace(doc3, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f) => f(view, keyEvent(8, "Backspace")))) {
    if (android && chrome)
      view.domObserver.suppressSelectionUpdates();
    return;
  }
  if (chrome && change.endB == change.start)
    view.input.lastChromeDelete = Date.now();
  if (android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse2.sel && parse2.sel.anchor == parse2.sel.head && parse2.sel.head == change.endA) {
    change.endB -= 2;
    $to = parse2.doc.resolveNoCache(change.endB - parse2.from);
    setTimeout(() => {
      view.someProp("handleKeyDown", function(f) {
        return f(view, keyEvent(13, "Enter"));
      });
    }, 20);
  }
  let chFrom = change.start, chTo = change.endA;
  let mkTr = (base2) => {
    let tr2 = base2 || view.state.tr.replace(chFrom, chTo, parse2.doc.slice(change.start - parse2.from, change.endB - parse2.from));
    if (parse2.sel) {
      let sel2 = resolveSelection(view, tr2.doc, parse2.sel);
      if (sel2 && !(chrome && view.composing && sel2.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel2.head == chFrom || sel2.head == tr2.mapping.map(chTo) - 1) || ie && sel2.empty && sel2.head == chFrom))
        tr2.setSelection(sel2);
    }
    if (compositionID)
      tr2.setMeta("composition", compositionID);
    return tr2.scrollIntoView();
  };
  let markChange;
  if (inlineChange) {
    if ($from.pos == $to.pos) {
      if (ie && ie_version <= 11 && $from.parentOffset == 0) {
        view.domObserver.suppressSelectionUpdates();
        setTimeout(() => selectionToDOM(view), 20);
      }
      let tr2 = mkTr(view.state.tr.delete(chFrom, chTo));
      let marks = doc3.resolve(change.start).marksAcross(doc3.resolve(change.endA));
      if (marks)
        tr2.ensureMarks(marks);
      view.dispatch(tr2);
    } else if (
      // Adding or removing a mark
      change.endA == change.endB && (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))
    ) {
      let tr2 = mkTr(view.state.tr);
      if (markChange.type == "add")
        tr2.addMark(chFrom, chTo, markChange.mark);
      else
        tr2.removeMark(chFrom, chTo, markChange.mark);
      view.dispatch(tr2);
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      let deflt = () => mkTr(view.state.tr.insertText(text, chFrom, chTo));
      if (!view.someProp("handleTextInput", (f) => f(view, chFrom, chTo, text, deflt)))
        view.dispatch(deflt());
    } else {
      view.dispatch(mkTr());
    }
  } else {
    view.dispatch(mkTr());
  }
}
function resolveSelection(view, doc3, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc3.content.size)
    return null;
  return selectionBetween(view, doc3.resolve(parsedSel.anchor), doc3.resolve(parsedSel.head));
}
function isMarkChange(cur, prev) {
  let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
  let added = curMarks, removed = prevMarks, type, mark, update;
  for (let i = 0; i < prevMarks.length; i++)
    added = prevMarks[i].removeFromSet(added);
  for (let i = 0; i < curMarks.length; i++)
    removed = curMarks[i].removeFromSet(removed);
  if (added.length == 1 && removed.length == 0) {
    mark = added[0];
    type = "add";
    update = (node) => node.mark(mark.addToSet(node.marks));
  } else if (added.length == 0 && removed.length == 1) {
    mark = removed[0];
    type = "remove";
    update = (node) => node.mark(mark.removeFromSet(node.marks));
  } else {
    return null;
  }
  let updated = [];
  for (let i = 0; i < prev.childCount; i++)
    updated.push(update(prev.child(i)));
  if (Fragment6.from(updated).eq(cur))
    return { mark, type };
}
function looksLikeBackspace(old, start2, end2, $newStart, $newEnd) {
  if (
    // The content must have shrunk
    end2 - start2 <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    skipClosingAndOpening($newStart, true, false) < $newEnd.pos
  )
    return false;
  let $start = old.resolve(start2);
  if (!$newStart.parent.isTextblock) {
    let after = $start.nodeAfter;
    return after != null && end2 == start2 + after.nodeSize;
  }
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
    return false;
  let $next = old.resolve(skipClosingAndOpening($start, true, true));
  if (!$next.parent.isTextblock || $next.pos > end2 || skipClosingAndOpening($next, true, false) < end2)
    return false;
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  let depth = $pos.depth, end2 = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end2++;
    fromEnd = false;
  }
  if (mayOpen) {
    let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next && !next.isLeaf) {
      next = next.firstChild;
      end2++;
    }
  }
  return end2;
}
function findDiff(a, b, pos, preferredPos, preferredSide) {
  let start2 = a.findDiffStart(b, pos);
  if (start2 == null)
    return null;
  let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
  if (preferredSide == "end") {
    let adjust = Math.max(0, start2 - Math.min(endA, endB));
    preferredPos -= endA + adjust - start2;
  }
  if (endA < start2 && a.size < b.size) {
    let move = preferredPos <= start2 && preferredPos >= endA ? start2 - preferredPos : 0;
    start2 -= move;
    if (start2 && start2 < b.size && isSurrogatePair(b.textBetween(start2 - 1, start2 + 1)))
      start2 += move ? 1 : -1;
    endB = start2 + (endB - endA);
    endA = start2;
  } else if (endB < start2) {
    let move = preferredPos <= start2 && preferredPos >= endB ? start2 - preferredPos : 0;
    start2 -= move;
    if (start2 && start2 < a.size && isSurrogatePair(a.textBetween(start2 - 1, start2 + 1)))
      start2 += move ? 1 : -1;
    endA = start2 + (endA - endB);
    endB = start2;
  }
  return { start: start2, endA, endB };
}
function isSurrogatePair(str) {
  if (str.length != 2)
    return false;
  let a = str.charCodeAt(0), b = str.charCodeAt(1);
  return a >= 56320 && a <= 57343 && b >= 55296 && b <= 56319;
}
var EditorView = class {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(place, props) {
    this._root = null;
    this.focused = false;
    this.trackWrites = null;
    this.mounted = false;
    this.markCursor = null;
    this.cursorWrapper = null;
    this.lastSelectedViewDesc = void 0;
    this.input = new InputState();
    this.prevDirectPlugins = [];
    this.pluginViews = [];
    this.requiresGeckoHackNode = false;
    this.dragging = null;
    this._props = props;
    this.state = props.state;
    this.directPlugins = props.plugins || [];
    this.directPlugins.forEach(checkStateComponent);
    this.dispatch = this.dispatch.bind(this);
    this.dom = place && place.mount || document.createElement("div");
    if (place) {
      if (place.appendChild)
        place.appendChild(this.dom);
      else if (typeof place == "function")
        place(this.dom);
      else if (place.mount)
        this.mounted = true;
    }
    this.editable = getEditable(this);
    updateCursorWrapper(this);
    this.nodeViews = buildNodeViews(this);
    this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);
    this.domObserver = new DOMObserver(this, (from2, to, typeOver, added) => readDOMChange(this, from2, to, typeOver, added));
    this.domObserver.start();
    initInput(this);
    this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let prev = this._props;
      this._props = {};
      for (let name in prev)
        this._props[name] = prev[name];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(props) {
    if (props.handleDOMEvents != this._props.handleDOMEvents)
      ensureListeners(this);
    let prevProps = this._props;
    this._props = props;
    if (props.plugins) {
      props.plugins.forEach(checkStateComponent);
      this.directPlugins = props.plugins;
    }
    this.updateStateInner(props.state, prevProps);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(props) {
    let updated = {};
    for (let name in this._props)
      updated[name] = this._props[name];
    updated.state = this.state;
    for (let name in props)
      updated[name] = props[name];
    this.update(updated);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(state) {
    this.updateStateInner(state, this._props);
  }
  updateStateInner(state, prevProps) {
    var _a;
    let prev = this.state, redraw = false, updateSel = false;
    if (state.storedMarks && this.composing) {
      clearComposition(this);
      updateSel = true;
    }
    this.state = state;
    let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
    if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
      let nodeViews = buildNodeViews(this);
      if (changedNodeViews(nodeViews, this.nodeViews)) {
        this.nodeViews = nodeViews;
        redraw = true;
      }
    }
    if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) {
      ensureListeners(this);
    }
    this.editable = getEditable(this);
    updateCursorWrapper(this);
    let innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);
    let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
    let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
    if (updateDoc || !state.selection.eq(prev.selection))
      updateSel = true;
    let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);
    if (updateSel) {
      this.domObserver.stop();
      let forceSelUpdate = updateDoc && (ie || chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && selectionContextChanged(prev.selection, state.selection);
      if (updateDoc) {
        let chromeKludge = chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
        if (this.composing)
          this.input.compositionNode = findCompositionNode(this);
        if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
          this.docView.updateOuterDeco(outerDeco);
          this.docView.destroy();
          this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
        }
        if (chromeKludge && !this.trackWrites)
          forceSelUpdate = true;
      }
      if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && anchorInRightPlace(this))) {
        selectionToDOM(this, forceSelUpdate);
      } else {
        syncNodeSelection(this, state.selection);
        this.domObserver.setCurSelection();
      }
      this.domObserver.start();
    }
    this.updatePluginViews(prev);
    if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc))
      this.updateDraggedNode(this.dragging, prev);
    if (scroll == "reset") {
      this.dom.scrollTop = 0;
    } else if (scroll == "to selection") {
      this.scrollToSelection();
    } else if (oldScrollPos) {
      resetScrollPos(oldScrollPos);
    }
  }
  /**
  @internal
  */
  scrollToSelection() {
    let startDOM = this.domSelectionRange().focusNode;
    if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
    else if (this.someProp("handleScrollToSelection", (f) => f(this))) ;
    else if (this.state.selection instanceof NodeSelection) {
      let target = this.docView.domAfterPos(this.state.selection.from);
      if (target.nodeType == 1)
        scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
    } else {
      scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
  }
  destroyPluginViews() {
    let view;
    while (view = this.pluginViews.pop())
      if (view.destroy)
        view.destroy();
  }
  updatePluginViews(prevState) {
    if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins;
      this.destroyPluginViews();
      for (let i = 0; i < this.directPlugins.length; i++) {
        let plugin = this.directPlugins[i];
        if (plugin.spec.view)
          this.pluginViews.push(plugin.spec.view(this));
      }
      for (let i = 0; i < this.state.plugins.length; i++) {
        let plugin = this.state.plugins[i];
        if (plugin.spec.view)
          this.pluginViews.push(plugin.spec.view(this));
      }
    } else {
      for (let i = 0; i < this.pluginViews.length; i++) {
        let pluginView = this.pluginViews[i];
        if (pluginView.update)
          pluginView.update(this, prevState);
      }
    }
  }
  updateDraggedNode(dragging, prev) {
    let sel = dragging.node, found2 = -1;
    if (this.state.doc.nodeAt(sel.from) == sel.node) {
      found2 = sel.from;
    } else {
      let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
      let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
      if (moved == sel.node)
        found2 = movedPos;
    }
    this.dragging = new Dragging(dragging.slice, dragging.move, found2 < 0 ? void 0 : NodeSelection.create(this.state.doc, found2));
  }
  someProp(propName, f) {
    let prop = this._props && this._props[propName], value;
    if (prop != null && (value = f ? f(prop) : prop))
      return value;
    for (let i = 0; i < this.directPlugins.length; i++) {
      let prop2 = this.directPlugins[i].props[propName];
      if (prop2 != null && (value = f ? f(prop2) : prop2))
        return value;
    }
    let plugins = this.state.plugins;
    if (plugins)
      for (let i = 0; i < plugins.length; i++) {
        let prop2 = plugins[i].props[propName];
        if (prop2 != null && (value = f ? f(prop2) : prop2))
          return value;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (ie) {
      let node = this.root.activeElement;
      if (node == this.dom)
        return true;
      if (!node || !this.dom.contains(node))
        return false;
      while (node && this.dom != node && this.dom.contains(node)) {
        if (node.contentEditable == "false")
          return false;
        node = node.parentElement;
      }
      return true;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop();
    if (this.editable)
      focusPreventScroll(this.dom);
    selectionToDOM(this);
    this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let cached = this._root;
    if (cached == null)
      for (let search = this.dom.parentNode; search; search = search.parentNode) {
        if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
          if (!search.getSelection)
            Object.getPrototypeOf(search).getSelection = () => search.ownerDocument.getSelection();
          return this._root = search;
        }
      }
    return cached || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(coords) {
    return posAtCoords(this, coords);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(pos, side = 1) {
    return coordsAtPos(this, pos, side);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(pos, side = 0) {
    return this.docView.domFromPos(pos, side);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(pos) {
    let desc = this.docView.descAt(pos);
    return desc ? desc.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(node, offset5, bias = -1) {
    let pos = this.docView.posFromDOM(node, offset5, bias);
    if (pos == null)
      throw new RangeError("DOM position not inside the editor");
    return pos;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(dir, state) {
    return endOfTextblock(this, state || this.state, dir);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(html, event) {
    return doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(text, event) {
    return doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(slice2) {
    return serializeForClipboard(this, slice2);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    if (!this.docView)
      return;
    destroyInput(this);
    this.destroyPluginViews();
    if (this.mounted) {
      this.docView.update(this.state.doc, [], viewDecorations(this), this);
      this.dom.textContent = "";
    } else if (this.dom.parentNode) {
      this.dom.parentNode.removeChild(this.dom);
    }
    this.docView.destroy();
    this.docView = null;
    clearReusedRange();
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(event) {
    return dispatchEvent(this, event);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let sel = this.domSelection();
    if (!sel)
      return { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
    return safari && this.root.nodeType === 11 && deepActiveElement(this.dom.ownerDocument) == this.dom && safariShadowSelectionRange(this, sel) || sel;
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
};
EditorView.prototype.dispatch = function(tr2) {
  let dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction)
    dispatchTransaction.call(this, tr2);
  else
    this.updateState(this.state.apply(tr2));
};
function computeDocDeco(view) {
  let attrs = /* @__PURE__ */ Object.create(null);
  attrs.class = "ProseMirror";
  attrs.contenteditable = String(view.editable);
  view.someProp("attributes", (value) => {
    if (typeof value == "function")
      value = value(view.state);
    if (value)
      for (let attr in value) {
        if (attr == "class")
          attrs.class += " " + value[attr];
        else if (attr == "style")
          attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
        else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
          attrs[attr] = String(value[attr]);
      }
  });
  if (!attrs.translate)
    attrs.translate = "no";
  return [Decoration.node(0, view.state.doc.content.size, attrs)];
}
function updateCursorWrapper(view) {
  if (view.markCursor) {
    let dom = document.createElement("img");
    dom.className = "ProseMirror-separator";
    dom.setAttribute("mark-placeholder", "true");
    dom.setAttribute("alt", "");
    view.cursorWrapper = { dom, deco: Decoration.widget(view.state.selection.from, dom, { raw: true, marks: view.markCursor }) };
  } else {
    view.cursorWrapper = null;
  }
}
function getEditable(view) {
  return !view.someProp("editable", (value) => value(view.state) === false);
}
function selectionContextChanged(sel1, sel2) {
  let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
  return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function buildNodeViews(view) {
  let result = /* @__PURE__ */ Object.create(null);
  function add(obj) {
    for (let prop in obj)
      if (!Object.prototype.hasOwnProperty.call(result, prop))
        result[prop] = obj[prop];
  }
  view.someProp("nodeViews", add);
  view.someProp("markViews", add);
  return result;
}
function changedNodeViews(a, b) {
  let nA = 0, nB = 0;
  for (let prop in a) {
    if (a[prop] != b[prop])
      return true;
    nA++;
  }
  for (let _ in b)
    nB++;
  return nA != nB;
}
function checkStateComponent(plugin) {
  if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}

// ../../node_modules/.pnpm/w3c-keyname@2.2.8/node_modules/w3c-keyname/index.js
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
};
var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
};
var mac3 = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie2 = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i);
var i;
for (i = 1; i <= 24; i++) base[i + 111] = "F" + i;
var i;
for (i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32);
  shift[i] = String.fromCharCode(i);
}
var i;
for (code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code];
var code;
function keyName(event) {
  var ignoreKey = mac3 && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || ie2 && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
  var name = !ignoreKey && event.key || (event.shiftKey ? shift : base)[event.keyCode] || event.key || "Unidentified";
  if (name == "Esc") name = "Escape";
  if (name == "Del") name = "Delete";
  if (name == "Left") name = "ArrowLeft";
  if (name == "Up") name = "ArrowUp";
  if (name == "Right") name = "ArrowRight";
  if (name == "Down") name = "ArrowDown";
  return name;
}

// ../../node_modules/.pnpm/prosemirror-keymap@1.2.3/node_modules/prosemirror-keymap/dist/index.js
var mac4 = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
var windows2 = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function normalizeKeyName(name) {
  let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
  if (result == "Space")
    result = " ";
  let alt, ctrl, shift5, meta;
  for (let i = 0; i < parts.length - 1; i++) {
    let mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod))
      meta = true;
    else if (/^a(lt)?$/i.test(mod))
      alt = true;
    else if (/^(c|ctrl|control)$/i.test(mod))
      ctrl = true;
    else if (/^s(hift)?$/i.test(mod))
      shift5 = true;
    else if (/^mod$/i.test(mod)) {
      if (mac4)
        meta = true;
      else
        ctrl = true;
    } else
      throw new Error("Unrecognized modifier name: " + mod);
  }
  if (alt)
    result = "Alt-" + result;
  if (ctrl)
    result = "Ctrl-" + result;
  if (meta)
    result = "Meta-" + result;
  if (shift5)
    result = "Shift-" + result;
  return result;
}
function normalize(map2) {
  let copy2 = /* @__PURE__ */ Object.create(null);
  for (let prop in map2)
    copy2[normalizeKeyName(prop)] = map2[prop];
  return copy2;
}
function modifiers(name, event, shift5 = true) {
  if (event.altKey)
    name = "Alt-" + name;
  if (event.ctrlKey)
    name = "Ctrl-" + name;
  if (event.metaKey)
    name = "Meta-" + name;
  if (shift5 && event.shiftKey)
    name = "Shift-" + name;
  return name;
}
function keymap(bindings) {
  return new Plugin({ props: { handleKeyDown: keydownHandler(bindings) } });
}
function keydownHandler(bindings) {
  let map2 = normalize(bindings);
  return function(view, event) {
    let name = keyName(event), baseName, direct = map2[modifiers(name, event)];
    if (direct && direct(view.state, view.dispatch, view))
      return true;
    if (name.length == 1 && name != " ") {
      if (event.shiftKey) {
        let noShift = map2[modifiers(name, event, false)];
        if (noShift && noShift(view.state, view.dispatch, view))
          return true;
      }
      if ((event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(windows2 && event.ctrlKey && event.altKey) && (baseName = base[event.keyCode]) && baseName != name) {
        let fromCode = map2[modifiers(baseName, event)];
        if (fromCode && fromCode(view.state, view.dispatch, view))
          return true;
      }
    }
    return false;
  };
}

// ../../node_modules/.pnpm/@tiptap+core@3.20.0_@tiptap+pm@3.20.0/node_modules/@tiptap/core/dist/index.js
var __defProp2 = Object.defineProperty;
var __export2 = (target, all) => {
  for (var name in all)
    __defProp2(target, name, { get: all[name], enumerable: true });
};
function createChainableState(config) {
  const { state, transaction } = config;
  let { selection } = transaction;
  let { doc: doc3 } = transaction;
  let { storedMarks } = transaction;
  return {
    ...state,
    apply: state.apply.bind(state),
    applyTransaction: state.applyTransaction.bind(state),
    plugins: state.plugins,
    schema: state.schema,
    reconfigure: state.reconfigure.bind(state),
    toJSON: state.toJSON.bind(state),
    get storedMarks() {
      return storedMarks;
    },
    get selection() {
      return selection;
    },
    get doc() {
      return doc3;
    },
    get tr() {
      selection = transaction.selection;
      doc3 = transaction.doc;
      storedMarks = transaction.storedMarks;
      return transaction;
    }
  };
}
var CommandManager = class {
  constructor(props) {
    this.editor = props.editor;
    this.rawCommands = this.editor.extensionManager.commands;
    this.customState = props.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands, editor, state } = this;
    const { view } = editor;
    const { tr: tr2 } = state;
    const props = this.buildProps(tr2);
    return Object.fromEntries(
      Object.entries(rawCommands).map(([name, command2]) => {
        const method = (...args) => {
          const callback = command2(...args)(props);
          if (!tr2.getMeta("preventDispatch") && !this.hasCustomState) {
            view.dispatch(tr2);
          }
          return callback;
        };
        return [name, method];
      })
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(startTr, shouldDispatch = true) {
    const { rawCommands, editor, state } = this;
    const { view } = editor;
    const callbacks = [];
    const hasStartTransaction = !!startTr;
    const tr2 = startTr || state.tr;
    const run32 = () => {
      if (!hasStartTransaction && shouldDispatch && !tr2.getMeta("preventDispatch") && !this.hasCustomState) {
        view.dispatch(tr2);
      }
      return callbacks.every((callback) => callback === true);
    };
    const chain = {
      ...Object.fromEntries(
        Object.entries(rawCommands).map(([name, command2]) => {
          const chainedCommand = (...args) => {
            const props = this.buildProps(tr2, shouldDispatch);
            const callback = command2(...args)(props);
            callbacks.push(callback);
            return chain;
          };
          return [name, chainedCommand];
        })
      ),
      run: run32
    };
    return chain;
  }
  createCan(startTr) {
    const { rawCommands, state } = this;
    const dispatch = false;
    const tr2 = startTr || state.tr;
    const props = this.buildProps(tr2, dispatch);
    const formattedCommands = Object.fromEntries(
      Object.entries(rawCommands).map(([name, command2]) => {
        return [name, (...args) => command2(...args)({ ...props, dispatch: void 0 })];
      })
    );
    return {
      ...formattedCommands,
      chain: () => this.createChain(tr2, dispatch)
    };
  }
  buildProps(tr2, shouldDispatch = true) {
    const { rawCommands, editor, state } = this;
    const { view } = editor;
    const props = {
      tr: tr2,
      editor,
      view,
      state: createChainableState({
        state,
        transaction: tr2
      }),
      dispatch: shouldDispatch ? () => void 0 : void 0,
      chain: () => this.createChain(tr2, shouldDispatch),
      can: () => this.createCan(tr2),
      get commands() {
        return Object.fromEntries(
          Object.entries(rawCommands).map(([name, command2]) => {
            return [name, (...args) => command2(...args)(props)];
          })
        );
      }
    };
    return props;
  }
};
var commands_exports = {};
__export2(commands_exports, {
  blur: () => blur,
  clearContent: () => clearContent,
  clearNodes: () => clearNodes,
  command: () => command,
  createParagraphNear: () => createParagraphNear2,
  cut: () => cut,
  deleteCurrentNode: () => deleteCurrentNode,
  deleteNode: () => deleteNode,
  deleteRange: () => deleteRange2,
  deleteSelection: () => deleteSelection2,
  enter: () => enter,
  exitCode: () => exitCode2,
  extendMarkRange: () => extendMarkRange,
  first: () => first,
  focus: () => focus,
  forEach: () => forEach,
  insertContent: () => insertContent,
  insertContentAt: () => insertContentAt,
  joinBackward: () => joinBackward2,
  joinDown: () => joinDown2,
  joinForward: () => joinForward2,
  joinItemBackward: () => joinItemBackward,
  joinItemForward: () => joinItemForward,
  joinTextblockBackward: () => joinTextblockBackward2,
  joinTextblockForward: () => joinTextblockForward2,
  joinUp: () => joinUp2,
  keyboardShortcut: () => keyboardShortcut,
  lift: () => lift3,
  liftEmptyBlock: () => liftEmptyBlock2,
  liftListItem: () => liftListItem2,
  newlineInCode: () => newlineInCode2,
  resetAttributes: () => resetAttributes,
  scrollIntoView: () => scrollIntoView,
  selectAll: () => selectAll2,
  selectNodeBackward: () => selectNodeBackward2,
  selectNodeForward: () => selectNodeForward2,
  selectParentNode: () => selectParentNode2,
  selectTextblockEnd: () => selectTextblockEnd2,
  selectTextblockStart: () => selectTextblockStart2,
  setContent: () => setContent,
  setMark: () => setMark,
  setMeta: () => setMeta,
  setNode: () => setNode,
  setNodeSelection: () => setNodeSelection,
  setTextDirection: () => setTextDirection,
  setTextSelection: () => setTextSelection,
  sinkListItem: () => sinkListItem2,
  splitBlock: () => splitBlock2,
  splitListItem: () => splitListItem,
  toggleList: () => toggleList,
  toggleMark: () => toggleMark,
  toggleNode: () => toggleNode,
  toggleWrap: () => toggleWrap,
  undoInputRule: () => undoInputRule,
  unsetAllMarks: () => unsetAllMarks,
  unsetMark: () => unsetMark,
  unsetTextDirection: () => unsetTextDirection,
  updateAttributes: () => updateAttributes,
  wrapIn: () => wrapIn2,
  wrapInList: () => wrapInList2
});
var blur = () => ({ editor, view }) => {
  requestAnimationFrame(() => {
    var _a;
    if (!editor.isDestroyed) {
      view.dom.blur();
      (_a = window == null ? void 0 : window.getSelection()) == null ? void 0 : _a.removeAllRanges();
    }
  });
  return true;
};
var clearContent = (emitUpdate = true) => ({ commands }) => {
  return commands.setContent("", { emitUpdate });
};
var clearNodes = () => ({ state, tr: tr2, dispatch }) => {
  const { selection } = tr2;
  const { ranges } = selection;
  if (!dispatch) {
    return true;
  }
  ranges.forEach(({ $from, $to }) => {
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
      if (node.type.isText) {
        return;
      }
      const { doc: doc3, mapping } = tr2;
      const $mappedFrom = doc3.resolve(mapping.map(pos));
      const $mappedTo = doc3.resolve(mapping.map(pos + node.nodeSize));
      const nodeRange = $mappedFrom.blockRange($mappedTo);
      if (!nodeRange) {
        return;
      }
      const targetLiftDepth = liftTarget(nodeRange);
      if (node.type.isTextblock) {
        const { defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
        tr2.setNodeMarkup(nodeRange.start, defaultType);
      }
      if (targetLiftDepth || targetLiftDepth === 0) {
        tr2.lift(nodeRange, targetLiftDepth);
      }
    });
  });
  return true;
};
var command = (fn2) => (props) => {
  return fn2(props);
};
var createParagraphNear2 = () => ({ state, dispatch }) => {
  return createParagraphNear(state, dispatch);
};
var cut = (originRange, targetPos) => ({ editor, tr: tr2 }) => {
  const { state } = editor;
  const contentSlice = state.doc.slice(originRange.from, originRange.to);
  tr2.deleteRange(originRange.from, originRange.to);
  const newPos = tr2.mapping.map(targetPos);
  tr2.insert(newPos, contentSlice.content);
  tr2.setSelection(new TextSelection(tr2.doc.resolve(Math.max(newPos - 1, 0))));
  return true;
};
var deleteCurrentNode = () => ({ tr: tr2, dispatch }) => {
  const { selection } = tr2;
  const currentNode = selection.$anchor.node();
  if (currentNode.content.size > 0) {
    return false;
  }
  const $pos = tr2.selection.$anchor;
  for (let depth = $pos.depth; depth > 0; depth -= 1) {
    const node = $pos.node(depth);
    if (node.type === currentNode.type) {
      if (dispatch) {
        const from2 = $pos.before(depth);
        const to = $pos.after(depth);
        tr2.delete(from2, to).scrollIntoView();
      }
      return true;
    }
  }
  return false;
};
function getNodeType(nameOrType, schema) {
  if (typeof nameOrType === "string") {
    if (!schema.nodes[nameOrType]) {
      throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
    }
    return schema.nodes[nameOrType];
  }
  return nameOrType;
}
var deleteNode = (typeOrName) => ({ tr: tr2, state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  const $pos = tr2.selection.$anchor;
  for (let depth = $pos.depth; depth > 0; depth -= 1) {
    const node = $pos.node(depth);
    if (node.type === type) {
      if (dispatch) {
        const from2 = $pos.before(depth);
        const to = $pos.after(depth);
        tr2.delete(from2, to).scrollIntoView();
      }
      return true;
    }
  }
  return false;
};
var deleteRange2 = (range) => ({ tr: tr2, dispatch }) => {
  const { from: from2, to } = range;
  if (dispatch) {
    tr2.delete(from2, to);
  }
  return true;
};
var deleteSelection2 = () => ({ state, dispatch }) => {
  return deleteSelection(state, dispatch);
};
var enter = () => ({ commands }) => {
  return commands.keyboardShortcut("Enter");
};
var exitCode2 = () => ({ state, dispatch }) => {
  return exitCode(state, dispatch);
};
function isRegExp(value) {
  return Object.prototype.toString.call(value) === "[object RegExp]";
}
function objectIncludes(object1, object2, options = { strict: true }) {
  const keys3 = Object.keys(object2);
  if (!keys3.length) {
    return true;
  }
  return keys3.every((key) => {
    if (options.strict) {
      return object2[key] === object1[key];
    }
    if (isRegExp(object2[key])) {
      return object2[key].test(object1[key]);
    }
    return object2[key] === object1[key];
  });
}
function findMarkInSet(marks, type, attributes = {}) {
  return marks.find((item) => {
    return item.type === type && objectIncludes(
      // Only check equality for the attributes that are provided
      Object.fromEntries(Object.keys(attributes).map((k) => [k, item.attrs[k]])),
      attributes
    );
  });
}
function isMarkInSet(marks, type, attributes = {}) {
  return !!findMarkInSet(marks, type, attributes);
}
function getMarkRange($pos, type, attributes) {
  var _a;
  if (!$pos || !type) {
    return;
  }
  let start2 = $pos.parent.childAfter($pos.parentOffset);
  if (!start2.node || !start2.node.marks.some((mark2) => mark2.type === type)) {
    start2 = $pos.parent.childBefore($pos.parentOffset);
  }
  if (!start2.node || !start2.node.marks.some((mark2) => mark2.type === type)) {
    return;
  }
  attributes = attributes || ((_a = start2.node.marks[0]) == null ? void 0 : _a.attrs);
  const mark = findMarkInSet([...start2.node.marks], type, attributes);
  if (!mark) {
    return;
  }
  let startIndex = start2.index;
  let startPos = $pos.start() + start2.offset;
  let endIndex = startIndex + 1;
  let endPos = startPos + start2.node.nodeSize;
  while (startIndex > 0 && isMarkInSet([...$pos.parent.child(startIndex - 1).marks], type, attributes)) {
    startIndex -= 1;
    startPos -= $pos.parent.child(startIndex).nodeSize;
  }
  while (endIndex < $pos.parent.childCount && isMarkInSet([...$pos.parent.child(endIndex).marks], type, attributes)) {
    endPos += $pos.parent.child(endIndex).nodeSize;
    endIndex += 1;
  }
  return {
    from: startPos,
    to: endPos
  };
}
function getMarkType(nameOrType, schema) {
  if (typeof nameOrType === "string") {
    if (!schema.marks[nameOrType]) {
      throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
    }
    return schema.marks[nameOrType];
  }
  return nameOrType;
}
var extendMarkRange = (typeOrName, attributes = {}) => ({ tr: tr2, state, dispatch }) => {
  const type = getMarkType(typeOrName, state.schema);
  const { doc: doc3, selection } = tr2;
  const { $from, from: from2, to } = selection;
  if (dispatch) {
    const range = getMarkRange($from, type, attributes);
    if (range && range.from <= from2 && range.to >= to) {
      const newSelection = TextSelection.create(doc3, range.from, range.to);
      tr2.setSelection(newSelection);
    }
  }
  return true;
};
var first = (commands) => (props) => {
  const items = typeof commands === "function" ? commands(props) : commands;
  for (let i = 0; i < items.length; i += 1) {
    if (items[i](props)) {
      return true;
    }
  }
  return false;
};
function isTextSelection(value) {
  return value instanceof TextSelection;
}
function minMax(value = 0, min3 = 0, max3 = 0) {
  return Math.min(Math.max(value, min3), max3);
}
function resolveFocusPosition(doc3, position = null) {
  if (!position) {
    return null;
  }
  const selectionAtStart = Selection.atStart(doc3);
  const selectionAtEnd = Selection.atEnd(doc3);
  if (position === "start" || position === true) {
    return selectionAtStart;
  }
  if (position === "end") {
    return selectionAtEnd;
  }
  const minPos = selectionAtStart.from;
  const maxPos = selectionAtEnd.to;
  if (position === "all") {
    return TextSelection.create(doc3, minMax(0, minPos, maxPos), minMax(doc3.content.size, minPos, maxPos));
  }
  return TextSelection.create(doc3, minMax(position, minPos, maxPos), minMax(position, minPos, maxPos));
}
function isAndroid() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function isiOS() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function isSafari() {
  return typeof navigator !== "undefined" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : false;
}
var focus = (position = null, options = {}) => ({ editor, view, tr: tr2, dispatch }) => {
  options = {
    scrollIntoView: true,
    ...options
  };
  const delayedFocus = () => {
    if (isiOS() || isAndroid()) {
      view.dom.focus();
    }
    if (isSafari() && !isiOS() && !isAndroid()) {
      view.dom.focus({ preventScroll: true });
    }
    requestAnimationFrame(() => {
      if (!editor.isDestroyed) {
        view.focus();
        if (options == null ? void 0 : options.scrollIntoView) {
          editor.commands.scrollIntoView();
        }
      }
    });
  };
  try {
    if (view.hasFocus() && position === null || position === false) {
      return true;
    }
  } catch {
    return false;
  }
  if (dispatch && position === null && !isTextSelection(editor.state.selection)) {
    delayedFocus();
    return true;
  }
  const selection = resolveFocusPosition(tr2.doc, position) || editor.state.selection;
  const isSameSelection = editor.state.selection.eq(selection);
  if (dispatch) {
    if (!isSameSelection) {
      tr2.setSelection(selection);
    }
    if (isSameSelection && tr2.storedMarks) {
      tr2.setStoredMarks(tr2.storedMarks);
    }
    delayedFocus();
  }
  return true;
};
var forEach = (items, fn2) => (props) => {
  return items.every((item, index2) => fn2(item, { ...props, index: index2 }));
};
var insertContent = (value, options) => ({ tr: tr2, commands }) => {
  return commands.insertContentAt({ from: tr2.selection.from, to: tr2.selection.to }, value, options);
};
var removeWhitespaces = (node) => {
  const children = node.childNodes;
  for (let i = children.length - 1; i >= 0; i -= 1) {
    const child = children[i];
    if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) {
      node.removeChild(child);
    } else if (child.nodeType === 1) {
      removeWhitespaces(child);
    }
  }
  return node;
};
function elementFromString(value) {
  if (typeof window === "undefined") {
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  }
  const wrappedValue = `<body>${value}</body>`;
  const html = new window.DOMParser().parseFromString(wrappedValue, "text/html").body;
  return removeWhitespaces(html);
}
function createNodeFromContent(content, schema, options) {
  if (content instanceof Node2 || content instanceof Fragment6) {
    return content;
  }
  options = {
    slice: true,
    parseOptions: {},
    ...options
  };
  const isJSONContent = typeof content === "object" && content !== null;
  const isTextContent = typeof content === "string";
  if (isJSONContent) {
    try {
      const isArrayContent = Array.isArray(content) && content.length > 0;
      if (isArrayContent) {
        return Fragment6.fromArray(content.map((item) => schema.nodeFromJSON(item)));
      }
      const node = schema.nodeFromJSON(content);
      if (options.errorOnInvalidContent) {
        node.check();
      }
      return node;
    } catch (error) {
      if (options.errorOnInvalidContent) {
        throw new Error("[tiptap error]: Invalid JSON content", { cause: error });
      }
      console.warn("[tiptap warn]: Invalid content.", "Passed value:", content, "Error:", error);
      return createNodeFromContent("", schema, options);
    }
  }
  if (isTextContent) {
    if (options.errorOnInvalidContent) {
      let hasInvalidContent = false;
      let invalidContent = "";
      const contentCheckSchema = new Schema({
        topNode: schema.spec.topNode,
        marks: schema.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: schema.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (e) => {
                  hasInvalidContent = true;
                  invalidContent = typeof e === "string" ? e : e.outerHTML;
                  return null;
                }
              }
            ]
          }
        })
      });
      if (options.slice) {
        DOMParser.fromSchema(contentCheckSchema).parseSlice(elementFromString(content), options.parseOptions);
      } else {
        DOMParser.fromSchema(contentCheckSchema).parse(elementFromString(content), options.parseOptions);
      }
      if (options.errorOnInvalidContent && hasInvalidContent) {
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${invalidContent}`)
        });
      }
    }
    const parser = DOMParser.fromSchema(schema);
    if (options.slice) {
      return parser.parseSlice(elementFromString(content), options.parseOptions).content;
    }
    return parser.parse(elementFromString(content), options.parseOptions);
  }
  return createNodeFromContent("", schema, options);
}
function selectionToInsertionEnd2(tr2, startLen, bias) {
  const last = tr2.steps.length - 1;
  if (last < startLen) {
    return;
  }
  const step = tr2.steps[last];
  if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep)) {
    return;
  }
  const map2 = tr2.mapping.maps[last];
  let end2 = 0;
  map2.forEach((_from, _to, _newFrom, newTo) => {
    if (end2 === 0) {
      end2 = newTo;
    }
  });
  tr2.setSelection(Selection.near(tr2.doc.resolve(end2), bias));
}
var isFragment = (nodeOrFragment) => {
  return !("type" in nodeOrFragment);
};
var insertContentAt = (position, value, options) => ({ tr: tr2, dispatch, editor }) => {
  var _a;
  if (dispatch) {
    options = {
      parseOptions: editor.options.parseOptions,
      updateSelection: true,
      applyInputRules: false,
      applyPasteRules: false,
      ...options
    };
    let content;
    const emitContentError = (error) => {
      editor.emit("contentError", {
        editor,
        error,
        disableCollaboration: () => {
          if ("collaboration" in editor.storage && typeof editor.storage.collaboration === "object" && editor.storage.collaboration) {
            editor.storage.collaboration.isDisabled = true;
          }
        }
      });
    };
    const parseOptions = {
      preserveWhitespace: "full",
      ...options.parseOptions
    };
    if (!options.errorOnInvalidContent && !editor.options.enableContentCheck && editor.options.emitContentError) {
      try {
        createNodeFromContent(value, editor.schema, {
          parseOptions,
          errorOnInvalidContent: true
        });
      } catch (e) {
        emitContentError(e);
      }
    }
    try {
      content = createNodeFromContent(value, editor.schema, {
        parseOptions,
        errorOnInvalidContent: (_a = options.errorOnInvalidContent) != null ? _a : editor.options.enableContentCheck
      });
    } catch (e) {
      emitContentError(e);
      return false;
    }
    let { from: from2, to } = typeof position === "number" ? { from: position, to: position } : { from: position.from, to: position.to };
    let isOnlyTextContent = true;
    let isOnlyBlockContent = true;
    const nodes = isFragment(content) ? content : [content];
    nodes.forEach((node) => {
      node.check();
      isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
      isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
    });
    if (from2 === to && isOnlyBlockContent) {
      const { parent } = tr2.doc.resolve(from2);
      const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
      if (isEmptyTextBlock) {
        from2 -= 1;
        to += 1;
      }
    }
    let newContent;
    if (isOnlyTextContent) {
      if (Array.isArray(value)) {
        newContent = value.map((v) => v.text || "").join("");
      } else if (value instanceof Fragment6) {
        let text = "";
        value.forEach((node) => {
          if (node.text) {
            text += node.text;
          }
        });
        newContent = text;
      } else if (typeof value === "object" && !!value && !!value.text) {
        newContent = value.text;
      } else {
        newContent = value;
      }
      tr2.insertText(newContent, from2, to);
    } else {
      newContent = content;
      const $from = tr2.doc.resolve(from2);
      const $fromNode = $from.node();
      const fromSelectionAtStart = $from.parentOffset === 0;
      const isTextSelection2 = $fromNode.isText || $fromNode.isTextblock;
      const hasContent = $fromNode.content.size > 0;
      if (fromSelectionAtStart && isTextSelection2 && hasContent) {
        from2 = Math.max(0, from2 - 1);
      }
      tr2.replaceWith(from2, to, newContent);
    }
    if (options.updateSelection) {
      selectionToInsertionEnd2(tr2, tr2.steps.length - 1, -1);
    }
    if (options.applyInputRules) {
      tr2.setMeta("applyInputRules", { from: from2, text: newContent });
    }
    if (options.applyPasteRules) {
      tr2.setMeta("applyPasteRules", { from: from2, text: newContent });
    }
  }
  return true;
};
var joinUp2 = () => ({ state, dispatch }) => {
  return joinUp(state, dispatch);
};
var joinDown2 = () => ({ state, dispatch }) => {
  return joinDown(state, dispatch);
};
var joinBackward2 = () => ({ state, dispatch }) => {
  return joinBackward(state, dispatch);
};
var joinForward2 = () => ({ state, dispatch }) => {
  return joinForward(state, dispatch);
};
var joinItemBackward = () => ({ state, dispatch, tr: tr2 }) => {
  try {
    const point = joinPoint(state.doc, state.selection.$from.pos, -1);
    if (point === null || point === void 0) {
      return false;
    }
    tr2.join(point, 2);
    if (dispatch) {
      dispatch(tr2);
    }
    return true;
  } catch {
    return false;
  }
};
var joinItemForward = () => ({ state, dispatch, tr: tr2 }) => {
  try {
    const point = joinPoint(state.doc, state.selection.$from.pos, 1);
    if (point === null || point === void 0) {
      return false;
    }
    tr2.join(point, 2);
    if (dispatch) {
      dispatch(tr2);
    }
    return true;
  } catch {
    return false;
  }
};
var joinTextblockBackward2 = () => ({ state, dispatch }) => {
  return joinTextblockBackward(state, dispatch);
};
var joinTextblockForward2 = () => ({ state, dispatch }) => {
  return joinTextblockForward(state, dispatch);
};
function isMacOS() {
  return typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
}
function normalizeKeyName2(name) {
  const parts = name.split(/-(?!$)/);
  let result = parts[parts.length - 1];
  if (result === "Space") {
    result = " ";
  }
  let alt;
  let ctrl;
  let shift5;
  let meta;
  for (let i = 0; i < parts.length - 1; i += 1) {
    const mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) {
      meta = true;
    } else if (/^a(lt)?$/i.test(mod)) {
      alt = true;
    } else if (/^(c|ctrl|control)$/i.test(mod)) {
      ctrl = true;
    } else if (/^s(hift)?$/i.test(mod)) {
      shift5 = true;
    } else if (/^mod$/i.test(mod)) {
      if (isiOS() || isMacOS()) {
        meta = true;
      } else {
        ctrl = true;
      }
    } else {
      throw new Error(`Unrecognized modifier name: ${mod}`);
    }
  }
  if (alt) {
    result = `Alt-${result}`;
  }
  if (ctrl) {
    result = `Ctrl-${result}`;
  }
  if (meta) {
    result = `Meta-${result}`;
  }
  if (shift5) {
    result = `Shift-${result}`;
  }
  return result;
}
var keyboardShortcut = (name) => ({ editor, view, tr: tr2, dispatch }) => {
  const keys3 = normalizeKeyName2(name).split(/-(?!$)/);
  const key = keys3.find((item) => !["Alt", "Ctrl", "Meta", "Shift"].includes(item));
  const event = new KeyboardEvent("keydown", {
    key: key === "Space" ? " " : key,
    altKey: keys3.includes("Alt"),
    ctrlKey: keys3.includes("Ctrl"),
    metaKey: keys3.includes("Meta"),
    shiftKey: keys3.includes("Shift"),
    bubbles: true,
    cancelable: true
  });
  const capturedTransaction = editor.captureTransaction(() => {
    view.someProp("handleKeyDown", (f) => f(view, event));
  });
  capturedTransaction == null ? void 0 : capturedTransaction.steps.forEach((step) => {
    const newStep = step.map(tr2.mapping);
    if (newStep && dispatch) {
      tr2.maybeStep(newStep);
    }
  });
  return true;
};
function isNodeActive(state, typeOrName, attributes = {}) {
  const { from: from2, to, empty: empty2 } = state.selection;
  const type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
  const nodeRanges = [];
  state.doc.nodesBetween(from2, to, (node, pos) => {
    if (node.isText) {
      return;
    }
    const relativeFrom = Math.max(from2, pos);
    const relativeTo = Math.min(to, pos + node.nodeSize);
    nodeRanges.push({
      node,
      from: relativeFrom,
      to: relativeTo
    });
  });
  const selectionRange = to - from2;
  const matchedNodeRanges = nodeRanges.filter((nodeRange) => {
    if (!type) {
      return true;
    }
    return type.name === nodeRange.node.type.name;
  }).filter((nodeRange) => objectIncludes(nodeRange.node.attrs, attributes, { strict: false }));
  if (empty2) {
    return !!matchedNodeRanges.length;
  }
  const range = matchedNodeRanges.reduce((sum, nodeRange) => sum + nodeRange.to - nodeRange.from, 0);
  return range >= selectionRange;
}
var lift3 = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  const isActive2 = isNodeActive(state, type, attributes);
  if (!isActive2) {
    return false;
  }
  return lift2(state, dispatch);
};
var liftEmptyBlock2 = () => ({ state, dispatch }) => {
  return liftEmptyBlock(state, dispatch);
};
var liftListItem2 = (typeOrName) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  return liftListItem(type)(state, dispatch);
};
var newlineInCode2 = () => ({ state, dispatch }) => {
  return newlineInCode(state, dispatch);
};
function getSchemaTypeNameByName(name, schema) {
  if (schema.nodes[name]) {
    return "node";
  }
  if (schema.marks[name]) {
    return "mark";
  }
  return null;
}
function deleteProps(obj, propOrProps) {
  const props = typeof propOrProps === "string" ? [propOrProps] : propOrProps;
  return Object.keys(obj).reduce((newObj, prop) => {
    if (!props.includes(prop)) {
      newObj[prop] = obj[prop];
    }
    return newObj;
  }, {});
}
var resetAttributes = (typeOrName, attributes) => ({ tr: tr2, state, dispatch }) => {
  let nodeType = null;
  let markType = null;
  const schemaType = getSchemaTypeNameByName(
    typeof typeOrName === "string" ? typeOrName : typeOrName.name,
    state.schema
  );
  if (!schemaType) {
    return false;
  }
  if (schemaType === "node") {
    nodeType = getNodeType(typeOrName, state.schema);
  }
  if (schemaType === "mark") {
    markType = getMarkType(typeOrName, state.schema);
  }
  let canReset = false;
  tr2.selection.ranges.forEach((range) => {
    state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => {
      if (nodeType && nodeType === node.type) {
        canReset = true;
        if (dispatch) {
          tr2.setNodeMarkup(pos, void 0, deleteProps(node.attrs, attributes));
        }
      }
      if (markType && node.marks.length) {
        node.marks.forEach((mark) => {
          if (markType === mark.type) {
            canReset = true;
            if (dispatch) {
              tr2.addMark(pos, pos + node.nodeSize, markType.create(deleteProps(mark.attrs, attributes)));
            }
          }
        });
      }
    });
  });
  return canReset;
};
var scrollIntoView = () => ({ tr: tr2, dispatch }) => {
  if (dispatch) {
    tr2.scrollIntoView();
  }
  return true;
};
var selectAll2 = () => ({ tr: tr2, dispatch }) => {
  if (dispatch) {
    const selection = new AllSelection(tr2.doc);
    tr2.setSelection(selection);
  }
  return true;
};
var selectNodeBackward2 = () => ({ state, dispatch }) => {
  return selectNodeBackward(state, dispatch);
};
var selectNodeForward2 = () => ({ state, dispatch }) => {
  return selectNodeForward(state, dispatch);
};
var selectParentNode2 = () => ({ state, dispatch }) => {
  return selectParentNode(state, dispatch);
};
var selectTextblockEnd2 = () => ({ state, dispatch }) => {
  return selectTextblockEnd(state, dispatch);
};
var selectTextblockStart2 = () => ({ state, dispatch }) => {
  return selectTextblockStart(state, dispatch);
};
function createDocument(content, schema, parseOptions = {}, options = {}) {
  return createNodeFromContent(content, schema, {
    slice: false,
    parseOptions,
    errorOnInvalidContent: options.errorOnInvalidContent
  });
}
var setContent = (content, { errorOnInvalidContent, emitUpdate = true, parseOptions = {} } = {}) => ({ editor, tr: tr2, dispatch, commands }) => {
  const { doc: doc3 } = tr2;
  if (parseOptions.preserveWhitespace !== "full") {
    const document2 = createDocument(content, editor.schema, parseOptions, {
      errorOnInvalidContent: errorOnInvalidContent != null ? errorOnInvalidContent : editor.options.enableContentCheck
    });
    if (dispatch) {
      tr2.replaceWith(0, doc3.content.size, document2).setMeta("preventUpdate", !emitUpdate);
    }
    return true;
  }
  if (dispatch) {
    tr2.setMeta("preventUpdate", !emitUpdate);
  }
  return commands.insertContentAt({ from: 0, to: doc3.content.size }, content, {
    parseOptions,
    errorOnInvalidContent: errorOnInvalidContent != null ? errorOnInvalidContent : editor.options.enableContentCheck
  });
};
function getMarkAttributes(state, typeOrName) {
  const type = getMarkType(typeOrName, state.schema);
  const { from: from2, to, empty: empty2 } = state.selection;
  const marks = [];
  if (empty2) {
    if (state.storedMarks) {
      marks.push(...state.storedMarks);
    }
    marks.push(...state.selection.$head.marks());
  } else {
    state.doc.nodesBetween(from2, to, (node) => {
      marks.push(...node.marks);
    });
  }
  const mark = marks.find((markItem) => markItem.type.name === type.name);
  if (!mark) {
    return {};
  }
  return { ...mark.attrs };
}
function combineTransactionSteps(oldDoc, transactions) {
  const transform = new Transform(oldDoc);
  transactions.forEach((transaction) => {
    transaction.steps.forEach((step) => {
      transform.step(step);
    });
  });
  return transform;
}
function defaultBlockAt2(match) {
  for (let i = 0; i < match.edgeCount; i += 1) {
    const { type } = match.edge(i);
    if (type.isTextblock && !type.hasRequiredAttrs()) {
      return type;
    }
  }
  return null;
}
function findChildrenInRange(node, range, predicate) {
  const nodesWithPos = [];
  node.nodesBetween(range.from, range.to, (child, pos) => {
    if (predicate(child)) {
      nodesWithPos.push({
        node: child,
        pos
      });
    }
  });
  return nodesWithPos;
}
function findParentNodeClosestToPos($pos, predicate) {
  for (let i = $pos.depth; i > 0; i -= 1) {
    const node = $pos.node(i);
    if (predicate(node)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node
      };
    }
  }
}
function findParentNode(predicate) {
  return (selection) => findParentNodeClosestToPos(selection.$from, predicate);
}
function getExtensionField(extension, field, context) {
  if (extension.config[field] === void 0 && extension.parent) {
    return getExtensionField(extension.parent, field, context);
  }
  if (typeof extension.config[field] === "function") {
    const value = extension.config[field].bind({
      ...context,
      parent: extension.parent ? getExtensionField(extension.parent, field, context) : null
    });
    return value;
  }
  return extension.config[field];
}
function flattenExtensions(extensions) {
  return extensions.map((extension) => {
    const context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage
    };
    const addExtensions = getExtensionField(extension, "addExtensions", context);
    if (addExtensions) {
      return [extension, ...flattenExtensions(addExtensions())];
    }
    return extension;
  }).flat(10);
}
function getHTMLFromFragment(fragment, schema) {
  const documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment);
  const temporaryDocument = document.implementation.createHTMLDocument();
  const container = temporaryDocument.createElement("div");
  container.appendChild(documentFragment);
  return container.innerHTML;
}
function isFunction2(value) {
  return typeof value === "function";
}
function callOrReturn(value, context = void 0, ...props) {
  if (isFunction2(value)) {
    if (context) {
      return value.bind(context)(...props);
    }
    return value(...props);
  }
  return value;
}
function isEmptyObject(value = {}) {
  return Object.keys(value).length === 0 && value.constructor === Object;
}
function splitExtensions(extensions) {
  const baseExtensions = extensions.filter((extension) => extension.type === "extension");
  const nodeExtensions = extensions.filter((extension) => extension.type === "node");
  const markExtensions = extensions.filter((extension) => extension.type === "mark");
  return {
    baseExtensions,
    nodeExtensions,
    markExtensions
  };
}
function getAttributesFromExtensions(extensions) {
  const extensionAttributes = [];
  const { nodeExtensions, markExtensions } = splitExtensions(extensions);
  const nodeAndMarkExtensions = [...nodeExtensions, ...markExtensions];
  const defaultAttribute = {
    default: null,
    validate: void 0,
    rendered: true,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: true,
    isRequired: false
  };
  const nodeExtensionTypes = nodeExtensions.filter((ext) => ext.name !== "text").map((ext) => ext.name);
  const markExtensionTypes = markExtensions.map((ext) => ext.name);
  const allExtensionTypes = [...nodeExtensionTypes, ...markExtensionTypes];
  extensions.forEach((extension) => {
    const context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage,
      extensions: nodeAndMarkExtensions
    };
    const addGlobalAttributes = getExtensionField(
      extension,
      "addGlobalAttributes",
      context
    );
    if (!addGlobalAttributes) {
      return;
    }
    const globalAttributes = addGlobalAttributes();
    globalAttributes.forEach((globalAttribute) => {
      let resolvedTypes;
      if (Array.isArray(globalAttribute.types)) {
        resolvedTypes = globalAttribute.types;
      } else if (globalAttribute.types === "*") {
        resolvedTypes = allExtensionTypes;
      } else if (globalAttribute.types === "nodes") {
        resolvedTypes = nodeExtensionTypes;
      } else if (globalAttribute.types === "marks") {
        resolvedTypes = markExtensionTypes;
      } else {
        resolvedTypes = [];
      }
      resolvedTypes.forEach((type) => {
        Object.entries(globalAttribute.attributes).forEach(([name, attribute]) => {
          extensionAttributes.push({
            type,
            name,
            attribute: {
              ...defaultAttribute,
              ...attribute
            }
          });
        });
      });
    });
  });
  nodeAndMarkExtensions.forEach((extension) => {
    const context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage
    };
    const addAttributes = getExtensionField(
      extension,
      "addAttributes",
      context
    );
    if (!addAttributes) {
      return;
    }
    const attributes = addAttributes();
    Object.entries(attributes).forEach(([name, attribute]) => {
      const mergedAttr = {
        ...defaultAttribute,
        ...attribute
      };
      if (typeof (mergedAttr == null ? void 0 : mergedAttr.default) === "function") {
        mergedAttr.default = mergedAttr.default();
      }
      if ((mergedAttr == null ? void 0 : mergedAttr.isRequired) && (mergedAttr == null ? void 0 : mergedAttr.default) === void 0) {
        delete mergedAttr.default;
      }
      extensionAttributes.push({
        type: extension.name,
        name,
        attribute: mergedAttr
      });
    });
  });
  return extensionAttributes;
}
function mergeAttributes(...objects) {
  return objects.filter((item) => !!item).reduce((items, item) => {
    const mergedAttributes = { ...items };
    Object.entries(item).forEach(([key, value]) => {
      const exists = mergedAttributes[key];
      if (!exists) {
        mergedAttributes[key] = value;
        return;
      }
      if (key === "class") {
        const valueClasses = value ? String(value).split(" ") : [];
        const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(" ") : [];
        const insertClasses = valueClasses.filter((valueClass) => !existingClasses.includes(valueClass));
        mergedAttributes[key] = [...existingClasses, ...insertClasses].join(" ");
      } else if (key === "style") {
        const newStyles = value ? value.split(";").map((style2) => style2.trim()).filter(Boolean) : [];
        const existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(";").map((style2) => style2.trim()).filter(Boolean) : [];
        const styleMap = /* @__PURE__ */ new Map();
        existingStyles.forEach((style2) => {
          const [property, val] = style2.split(":").map((part) => part.trim());
          styleMap.set(property, val);
        });
        newStyles.forEach((style2) => {
          const [property, val] = style2.split(":").map((part) => part.trim());
          styleMap.set(property, val);
        });
        mergedAttributes[key] = Array.from(styleMap.entries()).map(([property, val]) => `${property}: ${val}`).join("; ");
      } else {
        mergedAttributes[key] = value;
      }
    });
    return mergedAttributes;
  }, {});
}
function getRenderedAttributes(nodeOrMark, extensionAttributes) {
  return extensionAttributes.filter((attribute) => attribute.type === nodeOrMark.type.name).filter((item) => item.attribute.rendered).map((item) => {
    if (!item.attribute.renderHTML) {
      return {
        [item.name]: nodeOrMark.attrs[item.name]
      };
    }
    return item.attribute.renderHTML(nodeOrMark.attrs) || {};
  }).reduce((attributes, attribute) => mergeAttributes(attributes, attribute), {});
}
function fromString(value) {
  if (typeof value !== "string") {
    return value;
  }
  if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) {
    return Number(value);
  }
  if (value === "true") {
    return true;
  }
  if (value === "false") {
    return false;
  }
  return value;
}
function injectExtensionAttributesToParseRule(parseRule, extensionAttributes) {
  if ("style" in parseRule) {
    return parseRule;
  }
  return {
    ...parseRule,
    getAttrs: (node) => {
      const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
      if (oldAttributes === false) {
        return false;
      }
      const newAttributes = extensionAttributes.reduce((items, item) => {
        const value = item.attribute.parseHTML ? item.attribute.parseHTML(node) : fromString(node.getAttribute(item.name));
        if (value === null || value === void 0) {
          return items;
        }
        return {
          ...items,
          [item.name]: value
        };
      }, {});
      return { ...oldAttributes, ...newAttributes };
    }
  };
}
function cleanUpSchemaItem(data) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(data).filter(([key, value]) => {
      if (key === "attrs" && isEmptyObject(value)) {
        return false;
      }
      return value !== null && value !== void 0;
    })
  );
}
function buildAttributeSpec(extensionAttribute) {
  var _a, _b;
  const spec = {};
  if (!((_a = extensionAttribute == null ? void 0 : extensionAttribute.attribute) == null ? void 0 : _a.isRequired) && "default" in ((extensionAttribute == null ? void 0 : extensionAttribute.attribute) || {})) {
    spec.default = extensionAttribute.attribute.default;
  }
  if (((_b = extensionAttribute == null ? void 0 : extensionAttribute.attribute) == null ? void 0 : _b.validate) !== void 0) {
    spec.validate = extensionAttribute.attribute.validate;
  }
  return [extensionAttribute.name, spec];
}
function getSchemaByResolvedExtensions(extensions, editor) {
  var _a;
  const allAttributes = getAttributesFromExtensions(extensions);
  const { nodeExtensions, markExtensions } = splitExtensions(extensions);
  const topNode = (_a = nodeExtensions.find((extension) => getExtensionField(extension, "topNode"))) == null ? void 0 : _a.name;
  const nodes = Object.fromEntries(
    nodeExtensions.map((extension) => {
      const extensionAttributes = allAttributes.filter((attribute) => attribute.type === extension.name);
      const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage,
        editor
      };
      const extraNodeFields = extensions.reduce((fields, e) => {
        const extendNodeSchema = getExtensionField(e, "extendNodeSchema", context);
        return {
          ...fields,
          ...extendNodeSchema ? extendNodeSchema(extension) : {}
        };
      }, {});
      const schema = cleanUpSchemaItem({
        ...extraNodeFields,
        content: callOrReturn(getExtensionField(extension, "content", context)),
        marks: callOrReturn(getExtensionField(extension, "marks", context)),
        group: callOrReturn(getExtensionField(extension, "group", context)),
        inline: callOrReturn(getExtensionField(extension, "inline", context)),
        atom: callOrReturn(getExtensionField(extension, "atom", context)),
        selectable: callOrReturn(getExtensionField(extension, "selectable", context)),
        draggable: callOrReturn(getExtensionField(extension, "draggable", context)),
        code: callOrReturn(getExtensionField(extension, "code", context)),
        whitespace: callOrReturn(getExtensionField(extension, "whitespace", context)),
        linebreakReplacement: callOrReturn(
          getExtensionField(extension, "linebreakReplacement", context)
        ),
        defining: callOrReturn(getExtensionField(extension, "defining", context)),
        isolating: callOrReturn(getExtensionField(extension, "isolating", context)),
        attrs: Object.fromEntries(extensionAttributes.map(buildAttributeSpec))
      });
      const parseHTML = callOrReturn(getExtensionField(extension, "parseHTML", context));
      if (parseHTML) {
        schema.parseDOM = parseHTML.map(
          (parseRule) => injectExtensionAttributesToParseRule(parseRule, extensionAttributes)
        );
      }
      const renderHTML = getExtensionField(extension, "renderHTML", context);
      if (renderHTML) {
        schema.toDOM = (node) => renderHTML({
          node,
          HTMLAttributes: getRenderedAttributes(node, extensionAttributes)
        });
      }
      const renderText = getExtensionField(extension, "renderText", context);
      if (renderText) {
        schema.toText = renderText;
      }
      return [extension.name, schema];
    })
  );
  const marks = Object.fromEntries(
    markExtensions.map((extension) => {
      const extensionAttributes = allAttributes.filter((attribute) => attribute.type === extension.name);
      const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage,
        editor
      };
      const extraMarkFields = extensions.reduce((fields, e) => {
        const extendMarkSchema = getExtensionField(e, "extendMarkSchema", context);
        return {
          ...fields,
          ...extendMarkSchema ? extendMarkSchema(extension) : {}
        };
      }, {});
      const schema = cleanUpSchemaItem({
        ...extraMarkFields,
        inclusive: callOrReturn(getExtensionField(extension, "inclusive", context)),
        excludes: callOrReturn(getExtensionField(extension, "excludes", context)),
        group: callOrReturn(getExtensionField(extension, "group", context)),
        spanning: callOrReturn(getExtensionField(extension, "spanning", context)),
        code: callOrReturn(getExtensionField(extension, "code", context)),
        attrs: Object.fromEntries(extensionAttributes.map(buildAttributeSpec))
      });
      const parseHTML = callOrReturn(getExtensionField(extension, "parseHTML", context));
      if (parseHTML) {
        schema.parseDOM = parseHTML.map(
          (parseRule) => injectExtensionAttributesToParseRule(parseRule, extensionAttributes)
        );
      }
      const renderHTML = getExtensionField(extension, "renderHTML", context);
      if (renderHTML) {
        schema.toDOM = (mark) => renderHTML({
          mark,
          HTMLAttributes: getRenderedAttributes(mark, extensionAttributes)
        });
      }
      return [extension.name, schema];
    })
  );
  return new Schema({
    topNode,
    nodes,
    marks
  });
}
function findDuplicates(items) {
  const filtered = items.filter((el, index2) => items.indexOf(el) !== index2);
  return Array.from(new Set(filtered));
}
function sortExtensions(extensions) {
  const defaultPriority = 100;
  return extensions.sort((a, b) => {
    const priorityA = getExtensionField(a, "priority") || defaultPriority;
    const priorityB = getExtensionField(b, "priority") || defaultPriority;
    if (priorityA > priorityB) {
      return -1;
    }
    if (priorityA < priorityB) {
      return 1;
    }
    return 0;
  });
}
function resolveExtensions(extensions) {
  const resolvedExtensions = sortExtensions(flattenExtensions(extensions));
  const duplicatedNames = findDuplicates(resolvedExtensions.map((extension) => extension.name));
  if (duplicatedNames.length) {
    console.warn(
      `[tiptap warn]: Duplicate extension names found: [${duplicatedNames.map((item) => `'${item}'`).join(", ")}]. This can lead to issues.`
    );
  }
  return resolvedExtensions;
}
function getTextBetween(startNode, range, options) {
  const { from: from2, to } = range;
  const { blockSeparator = "\n\n", textSerializers = {} } = options || {};
  let text = "";
  startNode.nodesBetween(from2, to, (node, pos, parent, index2) => {
    var _a;
    if (node.isBlock && pos > from2) {
      text += blockSeparator;
    }
    const textSerializer = textSerializers == null ? void 0 : textSerializers[node.type.name];
    if (textSerializer) {
      if (parent) {
        text += textSerializer({
          node,
          pos,
          parent,
          index: index2,
          range
        });
      }
      return false;
    }
    if (node.isText) {
      text += (_a = node == null ? void 0 : node.text) == null ? void 0 : _a.slice(Math.max(from2, pos) - pos, to - pos);
    }
  });
  return text;
}
function getText2(node, options) {
  const range = {
    from: 0,
    to: node.content.size
  };
  return getTextBetween(node, range, options);
}
function getTextSerializersFromSchema(schema) {
  return Object.fromEntries(
    Object.entries(schema.nodes).filter(([, node]) => node.spec.toText).map(([name, node]) => [name, node.spec.toText])
  );
}
function getNodeAttributes(state, typeOrName) {
  const type = getNodeType(typeOrName, state.schema);
  const { from: from2, to } = state.selection;
  const nodes = [];
  state.doc.nodesBetween(from2, to, (node2) => {
    nodes.push(node2);
  });
  const node = nodes.reverse().find((nodeItem) => nodeItem.type.name === type.name);
  if (!node) {
    return {};
  }
  return { ...node.attrs };
}
function getAttributes(state, typeOrName) {
  const schemaType = getSchemaTypeNameByName(
    typeof typeOrName === "string" ? typeOrName : typeOrName.name,
    state.schema
  );
  if (schemaType === "node") {
    return getNodeAttributes(state, typeOrName);
  }
  if (schemaType === "mark") {
    return getMarkAttributes(state, typeOrName);
  }
  return {};
}
function removeDuplicates(array, by = JSON.stringify) {
  const seen = {};
  return array.filter((item) => {
    const key = by(item);
    return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
  });
}
function simplifyChangedRanges(changes) {
  const uniqueChanges = removeDuplicates(changes);
  return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter((change, index2) => {
    const rest = uniqueChanges.filter((_, i) => i !== index2);
    return !rest.some((otherChange) => {
      return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
    });
  });
}
function getChangedRanges(transform) {
  const { mapping, steps } = transform;
  const changes = [];
  mapping.maps.forEach((stepMap, index2) => {
    const ranges = [];
    if (!stepMap.ranges.length) {
      const { from: from2, to } = steps[index2];
      if (from2 === void 0 || to === void 0) {
        return;
      }
      ranges.push({ from: from2, to });
    } else {
      stepMap.forEach((from2, to) => {
        ranges.push({ from: from2, to });
      });
    }
    ranges.forEach(({ from: from2, to }) => {
      const newStart = mapping.slice(index2).map(from2, -1);
      const newEnd = mapping.slice(index2).map(to);
      const oldStart = mapping.invert().map(newStart, -1);
      const oldEnd = mapping.invert().map(newEnd);
      changes.push({
        oldRange: {
          from: oldStart,
          to: oldEnd
        },
        newRange: {
          from: newStart,
          to: newEnd
        }
      });
    });
  });
  return simplifyChangedRanges(changes);
}
function getMarksBetween(from2, to, doc3) {
  const marks = [];
  if (from2 === to) {
    doc3.resolve(from2).marks().forEach((mark) => {
      const $pos = doc3.resolve(from2);
      const range = getMarkRange($pos, mark.type);
      if (!range) {
        return;
      }
      marks.push({
        mark,
        ...range
      });
    });
  } else {
    doc3.nodesBetween(from2, to, (node, pos) => {
      if (!node || (node == null ? void 0 : node.nodeSize) === void 0) {
        return;
      }
      marks.push(
        ...node.marks.map((mark) => ({
          from: pos,
          to: pos + node.nodeSize,
          mark
        }))
      );
    });
  }
  return marks;
}
function getSchemaTypeByName(name, schema) {
  return schema.nodes[name] || schema.marks[name] || null;
}
function getSplittedAttributes(extensionAttributes, typeName, attributes) {
  return Object.fromEntries(
    Object.entries(attributes).filter(([name]) => {
      const extensionAttribute = extensionAttributes.find((item) => {
        return item.type === typeName && item.name === name;
      });
      if (!extensionAttribute) {
        return false;
      }
      return extensionAttribute.attribute.keepOnSplit;
    })
  );
}
var getTextContentFromNodes = ($from, maxMatch = 500) => {
  let textBefore = "";
  const sliceEndPos = $from.parentOffset;
  $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index2) => {
    var _a, _b;
    const chunk = ((_b = (_a = node.type.spec).toText) == null ? void 0 : _b.call(_a, {
      node,
      pos,
      parent,
      index: index2
    })) || node.textContent || "%leaf%";
    textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
  });
  return textBefore;
};
function isMarkActive(state, typeOrName, attributes = {}) {
  const { empty: empty2, ranges } = state.selection;
  const type = typeOrName ? getMarkType(typeOrName, state.schema) : null;
  if (empty2) {
    return !!(state.storedMarks || state.selection.$from.marks()).filter((mark) => {
      if (!type) {
        return true;
      }
      return type.name === mark.type.name;
    }).find((mark) => objectIncludes(mark.attrs, attributes, { strict: false }));
  }
  let selectionRange = 0;
  const markRanges = [];
  ranges.forEach(({ $from, $to }) => {
    const from2 = $from.pos;
    const to = $to.pos;
    state.doc.nodesBetween(from2, to, (node, pos) => {
      if (type && node.inlineContent && !node.type.allowsMarkType(type)) {
        return false;
      }
      if (!node.isText && !node.marks.length) {
        return;
      }
      const relativeFrom = Math.max(from2, pos);
      const relativeTo = Math.min(to, pos + node.nodeSize);
      const range2 = relativeTo - relativeFrom;
      selectionRange += range2;
      markRanges.push(
        ...node.marks.map((mark) => ({
          mark,
          from: relativeFrom,
          to: relativeTo
        }))
      );
    });
  });
  if (selectionRange === 0) {
    return false;
  }
  const matchedRange = markRanges.filter((markRange) => {
    if (!type) {
      return true;
    }
    return type.name === markRange.mark.type.name;
  }).filter((markRange) => objectIncludes(markRange.mark.attrs, attributes, { strict: false })).reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
  const excludedRange = markRanges.filter((markRange) => {
    if (!type) {
      return true;
    }
    return markRange.mark.type !== type && markRange.mark.type.excludes(type);
  }).reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
  const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
  return range >= selectionRange;
}
function isActive(state, name, attributes = {}) {
  if (!name) {
    return isNodeActive(state, null, attributes) || isMarkActive(state, null, attributes);
  }
  const schemaType = getSchemaTypeNameByName(name, state.schema);
  if (schemaType === "node") {
    return isNodeActive(state, name, attributes);
  }
  if (schemaType === "mark") {
    return isMarkActive(state, name, attributes);
  }
  return false;
}
function isExtensionRulesEnabled(extension, enabled) {
  if (Array.isArray(enabled)) {
    return enabled.some((enabledExtension) => {
      const name = typeof enabledExtension === "string" ? enabledExtension : enabledExtension.name;
      return name === extension.name;
    });
  }
  return enabled;
}
function isList(name, extensions) {
  const { nodeExtensions } = splitExtensions(extensions);
  const extension = nodeExtensions.find((item) => item.name === name);
  if (!extension) {
    return false;
  }
  const context = {
    name: extension.name,
    options: extension.options,
    storage: extension.storage
  };
  const group = callOrReturn(getExtensionField(extension, "group", context));
  if (typeof group !== "string") {
    return false;
  }
  return group.split(" ").includes("list");
}
function isNodeEmpty(node, {
  checkChildren = true,
  ignoreWhitespace = false
} = {}) {
  var _a;
  if (ignoreWhitespace) {
    if (node.type.name === "hardBreak") {
      return true;
    }
    if (node.isText) {
      return /^\s*$/m.test((_a = node.text) != null ? _a : "");
    }
  }
  if (node.isText) {
    return !node.text;
  }
  if (node.isAtom || node.isLeaf) {
    return false;
  }
  if (node.content.childCount === 0) {
    return true;
  }
  if (checkChildren) {
    let isContentEmpty = true;
    node.content.forEach((childNode) => {
      if (isContentEmpty === false) {
        return;
      }
      if (!isNodeEmpty(childNode, { ignoreWhitespace, checkChildren })) {
        isContentEmpty = false;
      }
    });
    return isContentEmpty;
  }
  return false;
}
function isNodeSelection(value) {
  return value instanceof NodeSelection;
}
var MappablePosition = class _MappablePosition {
  constructor(position) {
    this.position = position;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(json) {
    return new _MappablePosition(json.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function getUpdatedPosition(position, transaction) {
  const mapResult = transaction.mapping.mapResult(position.position);
  return {
    position: new MappablePosition(mapResult.pos),
    mapResult
  };
}
function createMappablePosition(position) {
  return new MappablePosition(position);
}
function canSetMark(state, tr2, newMarkType) {
  var _a;
  const { selection } = tr2;
  let cursor = null;
  if (isTextSelection(selection)) {
    cursor = selection.$cursor;
  }
  if (cursor) {
    const currentMarks = (_a = state.storedMarks) != null ? _a : cursor.marks();
    const parentAllowsMarkType = cursor.parent.type.allowsMarkType(newMarkType);
    return parentAllowsMarkType && (!!newMarkType.isInSet(currentMarks) || !currentMarks.some((mark) => mark.type.excludes(newMarkType)));
  }
  const { ranges } = selection;
  return ranges.some(({ $from, $to }) => {
    let someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
    state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent) => {
      if (someNodeSupportsMark) {
        return false;
      }
      if (node.isInline) {
        const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
        const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some((otherMark) => otherMark.type.excludes(newMarkType));
        someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
      }
      return !someNodeSupportsMark;
    });
    return someNodeSupportsMark;
  });
}
var setMark = (typeOrName, attributes = {}) => ({ tr: tr2, state, dispatch }) => {
  const { selection } = tr2;
  const { empty: empty2, ranges } = selection;
  const type = getMarkType(typeOrName, state.schema);
  if (dispatch) {
    if (empty2) {
      const oldAttributes = getMarkAttributes(state, type);
      tr2.addStoredMark(
        type.create({
          ...oldAttributes,
          ...attributes
        })
      );
    } else {
      ranges.forEach((range) => {
        const from2 = range.$from.pos;
        const to = range.$to.pos;
        state.doc.nodesBetween(from2, to, (node, pos) => {
          const trimmedFrom = Math.max(pos, from2);
          const trimmedTo = Math.min(pos + node.nodeSize, to);
          const someHasMark = node.marks.find((mark) => mark.type === type);
          if (someHasMark) {
            node.marks.forEach((mark) => {
              if (type === mark.type) {
                tr2.addMark(
                  trimmedFrom,
                  trimmedTo,
                  type.create({
                    ...mark.attrs,
                    ...attributes
                  })
                );
              }
            });
          } else {
            tr2.addMark(trimmedFrom, trimmedTo, type.create(attributes));
          }
        });
      });
    }
  }
  return canSetMark(state, tr2, type);
};
var setMeta = (key, value) => ({ tr: tr2 }) => {
  tr2.setMeta(key, value);
  return true;
};
var setNode = (typeOrName, attributes = {}) => ({ state, dispatch, chain }) => {
  const type = getNodeType(typeOrName, state.schema);
  let attributesToCopy;
  if (state.selection.$anchor.sameParent(state.selection.$head)) {
    attributesToCopy = state.selection.$anchor.parent.attrs;
  }
  if (!type.isTextblock) {
    console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
    return false;
  }
  return chain().command(({ commands }) => {
    const canSetBlock = setBlockType2(type, { ...attributesToCopy, ...attributes })(state);
    if (canSetBlock) {
      return true;
    }
    return commands.clearNodes();
  }).command(({ state: updatedState }) => {
    return setBlockType2(type, { ...attributesToCopy, ...attributes })(updatedState, dispatch);
  }).run();
};
var setNodeSelection = (position) => ({ tr: tr2, dispatch }) => {
  if (dispatch) {
    const { doc: doc3 } = tr2;
    const from2 = minMax(position, 0, doc3.content.size);
    const selection = NodeSelection.create(doc3, from2);
    tr2.setSelection(selection);
  }
  return true;
};
var setTextDirection = (direction, position) => ({ tr: tr2, state, dispatch }) => {
  const { selection } = state;
  let from2;
  let to;
  if (typeof position === "number") {
    from2 = position;
    to = position;
  } else if (position && "from" in position && "to" in position) {
    from2 = position.from;
    to = position.to;
  } else {
    from2 = selection.from;
    to = selection.to;
  }
  if (dispatch) {
    tr2.doc.nodesBetween(from2, to, (node, pos) => {
      if (node.isText) {
        return;
      }
      tr2.setNodeMarkup(pos, void 0, {
        ...node.attrs,
        dir: direction
      });
    });
  }
  return true;
};
var setTextSelection = (position) => ({ tr: tr2, dispatch }) => {
  if (dispatch) {
    const { doc: doc3 } = tr2;
    const { from: from2, to } = typeof position === "number" ? { from: position, to: position } : position;
    const minPos = TextSelection.atStart(doc3).from;
    const maxPos = TextSelection.atEnd(doc3).to;
    const resolvedFrom = minMax(from2, minPos, maxPos);
    const resolvedEnd = minMax(to, minPos, maxPos);
    const selection = TextSelection.create(doc3, resolvedFrom, resolvedEnd);
    tr2.setSelection(selection);
  }
  return true;
};
var sinkListItem2 = (typeOrName) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  return sinkListItem(type)(state, dispatch);
};
function ensureMarks(state, splittableMarks) {
  const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
  if (marks) {
    const filteredMarks = marks.filter((mark) => splittableMarks == null ? void 0 : splittableMarks.includes(mark.type.name));
    state.tr.ensureMarks(filteredMarks);
  }
}
var splitBlock2 = ({ keepMarks = true } = {}) => ({ tr: tr2, state, dispatch, editor }) => {
  const { selection, doc: doc3 } = tr2;
  const { $from, $to } = selection;
  const extensionAttributes = editor.extensionManager.attributes;
  const newAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
  if (selection instanceof NodeSelection && selection.node.isBlock) {
    if (!$from.parentOffset || !canSplit(doc3, $from.pos)) {
      return false;
    }
    if (dispatch) {
      if (keepMarks) {
        ensureMarks(state, editor.extensionManager.splittableMarks);
      }
      tr2.split($from.pos).scrollIntoView();
    }
    return true;
  }
  if (!$from.parent.isBlock) {
    return false;
  }
  const atEnd = $to.parentOffset === $to.parent.content.size;
  const deflt = $from.depth === 0 ? void 0 : defaultBlockAt2($from.node(-1).contentMatchAt($from.indexAfter(-1)));
  let types = atEnd && deflt ? [
    {
      type: deflt,
      attrs: newAttributes
    }
  ] : void 0;
  let can = canSplit(tr2.doc, tr2.mapping.map($from.pos), 1, types);
  if (!types && !can && canSplit(tr2.doc, tr2.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : void 0)) {
    can = true;
    types = deflt ? [
      {
        type: deflt,
        attrs: newAttributes
      }
    ] : void 0;
  }
  if (dispatch) {
    if (can) {
      if (selection instanceof TextSelection) {
        tr2.deleteSelection();
      }
      tr2.split(tr2.mapping.map($from.pos), 1, types);
      if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
        const first2 = tr2.mapping.map($from.before());
        const $first = tr2.doc.resolve(first2);
        if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
          tr2.setNodeMarkup(tr2.mapping.map($from.before()), deflt);
        }
      }
    }
    if (keepMarks) {
      ensureMarks(state, editor.extensionManager.splittableMarks);
    }
    tr2.scrollIntoView();
  }
  return can;
};
var splitListItem = (typeOrName, overrideAttrs = {}) => ({ tr: tr2, state, dispatch, editor }) => {
  var _a;
  const type = getNodeType(typeOrName, state.schema);
  const { $from, $to } = state.selection;
  const node = state.selection.node;
  if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) {
    return false;
  }
  const grandParent = $from.node(-1);
  if (grandParent.type !== type) {
    return false;
  }
  const extensionAttributes = editor.extensionManager.attributes;
  if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
    if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) {
      return false;
    }
    if (dispatch) {
      let wrap2 = Fragment6.empty;
      const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
      for (let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1) {
        wrap2 = Fragment6.from($from.node(d).copy(wrap2));
      }
      const depthAfter = (
        // eslint-disable-next-line no-nested-ternary
        $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3
      );
      const newNextTypeAttributes2 = {
        ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
        ...overrideAttrs
      };
      const nextType2 = ((_a = type.contentMatch.defaultType) == null ? void 0 : _a.createAndFill(newNextTypeAttributes2)) || void 0;
      wrap2 = wrap2.append(Fragment6.from(type.createAndFill(null, nextType2) || void 0));
      const start2 = $from.before($from.depth - (depthBefore - 1));
      tr2.replace(start2, $from.after(-depthAfter), new Slice(wrap2, 4 - depthBefore, 0));
      let sel = -1;
      tr2.doc.nodesBetween(start2, tr2.doc.content.size, (n, pos) => {
        if (sel > -1) {
          return false;
        }
        if (n.isTextblock && n.content.size === 0) {
          sel = pos + 1;
        }
      });
      if (sel > -1) {
        tr2.setSelection(TextSelection.near(tr2.doc.resolve(sel)));
      }
      tr2.scrollIntoView();
    }
    return true;
  }
  const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
  const newTypeAttributes = {
    ...getSplittedAttributes(extensionAttributes, grandParent.type.name, grandParent.attrs),
    ...overrideAttrs
  };
  const newNextTypeAttributes = {
    ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
    ...overrideAttrs
  };
  tr2.delete($from.pos, $to.pos);
  const types = nextType ? [
    { type, attrs: newTypeAttributes },
    { type: nextType, attrs: newNextTypeAttributes }
  ] : [{ type, attrs: newTypeAttributes }];
  if (!canSplit(tr2.doc, $from.pos, 2)) {
    return false;
  }
  if (dispatch) {
    const { selection, storedMarks } = state;
    const { splittableMarks } = editor.extensionManager;
    const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
    tr2.split($from.pos, 2, types).scrollIntoView();
    if (!marks || !dispatch) {
      return true;
    }
    const filteredMarks = marks.filter((mark) => splittableMarks.includes(mark.type.name));
    tr2.ensureMarks(filteredMarks);
  }
  return true;
};
var joinListBackwards = (tr2, listType) => {
  const list = findParentNode((node) => node.type === listType)(tr2.selection);
  if (!list) {
    return true;
  }
  const before = tr2.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
  if (before === void 0) {
    return true;
  }
  const nodeBefore = tr2.doc.nodeAt(before);
  const canJoinBackwards = list.node.type === (nodeBefore == null ? void 0 : nodeBefore.type) && canJoin(tr2.doc, list.pos);
  if (!canJoinBackwards) {
    return true;
  }
  tr2.join(list.pos);
  return true;
};
var joinListForwards = (tr2, listType) => {
  const list = findParentNode((node) => node.type === listType)(tr2.selection);
  if (!list) {
    return true;
  }
  const after = tr2.doc.resolve(list.start).after(list.depth);
  if (after === void 0) {
    return true;
  }
  const nodeAfter = tr2.doc.nodeAt(after);
  const canJoinForwards = list.node.type === (nodeAfter == null ? void 0 : nodeAfter.type) && canJoin(tr2.doc, after);
  if (!canJoinForwards) {
    return true;
  }
  tr2.join(after);
  return true;
};
var toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {}) => ({ editor, tr: tr2, state, dispatch, chain, commands, can }) => {
  const { extensions, splittableMarks } = editor.extensionManager;
  const listType = getNodeType(listTypeOrName, state.schema);
  const itemType = getNodeType(itemTypeOrName, state.schema);
  const { selection, storedMarks } = state;
  const { $from, $to } = selection;
  const range = $from.blockRange($to);
  const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
  if (!range) {
    return false;
  }
  const parentList = findParentNode((node) => isList(node.type.name, extensions))(selection);
  if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
    if (parentList.node.type === listType) {
      return commands.liftListItem(itemType);
    }
    if (isList(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) {
      return chain().command(() => {
        tr2.setNodeMarkup(parentList.pos, listType);
        return true;
      }).command(() => joinListBackwards(tr2, listType)).command(() => joinListForwards(tr2, listType)).run();
    }
  }
  if (!keepMarks || !marks || !dispatch) {
    return chain().command(() => {
      const canWrapInList = can().wrapInList(listType, attributes);
      if (canWrapInList) {
        return true;
      }
      return commands.clearNodes();
    }).wrapInList(listType, attributes).command(() => joinListBackwards(tr2, listType)).command(() => joinListForwards(tr2, listType)).run();
  }
  return chain().command(() => {
    const canWrapInList = can().wrapInList(listType, attributes);
    const filteredMarks = marks.filter((mark) => splittableMarks.includes(mark.type.name));
    tr2.ensureMarks(filteredMarks);
    if (canWrapInList) {
      return true;
    }
    return commands.clearNodes();
  }).wrapInList(listType, attributes).command(() => joinListBackwards(tr2, listType)).command(() => joinListForwards(tr2, listType)).run();
};
var toggleMark = (typeOrName, attributes = {}, options = {}) => ({ state, commands }) => {
  const { extendEmptyMarkRange = false } = options;
  const type = getMarkType(typeOrName, state.schema);
  const isActive2 = isMarkActive(state, type, attributes);
  if (isActive2) {
    return commands.unsetMark(type, { extendEmptyMarkRange });
  }
  return commands.setMark(type, attributes);
};
var toggleNode = (typeOrName, toggleTypeOrName, attributes = {}) => ({ state, commands }) => {
  const type = getNodeType(typeOrName, state.schema);
  const toggleType = getNodeType(toggleTypeOrName, state.schema);
  const isActive2 = isNodeActive(state, type, attributes);
  let attributesToCopy;
  if (state.selection.$anchor.sameParent(state.selection.$head)) {
    attributesToCopy = state.selection.$anchor.parent.attrs;
  }
  if (isActive2) {
    return commands.setNode(toggleType, attributesToCopy);
  }
  return commands.setNode(type, { ...attributesToCopy, ...attributes });
};
var toggleWrap = (typeOrName, attributes = {}) => ({ state, commands }) => {
  const type = getNodeType(typeOrName, state.schema);
  const isActive2 = isNodeActive(state, type, attributes);
  if (isActive2) {
    return commands.lift(type);
  }
  return commands.wrapIn(type, attributes);
};
var undoInputRule = () => ({ state, dispatch }) => {
  const plugins = state.plugins;
  for (let i = 0; i < plugins.length; i += 1) {
    const plugin = plugins[i];
    let undoable;
    if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
      if (dispatch) {
        const tr2 = state.tr;
        const toUndo = undoable.transform;
        for (let j = toUndo.steps.length - 1; j >= 0; j -= 1) {
          tr2.step(toUndo.steps[j].invert(toUndo.docs[j]));
        }
        if (undoable.text) {
          const marks = tr2.doc.resolve(undoable.from).marks();
          tr2.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
        } else {
          tr2.delete(undoable.from, undoable.to);
        }
      }
      return true;
    }
  }
  return false;
};
var unsetAllMarks = () => ({ tr: tr2, dispatch }) => {
  const { selection } = tr2;
  const { empty: empty2, ranges } = selection;
  if (empty2) {
    return true;
  }
  if (dispatch) {
    ranges.forEach((range) => {
      tr2.removeMark(range.$from.pos, range.$to.pos);
    });
  }
  return true;
};
var unsetMark = (typeOrName, options = {}) => ({ tr: tr2, state, dispatch }) => {
  var _a;
  const { extendEmptyMarkRange = false } = options;
  const { selection } = tr2;
  const type = getMarkType(typeOrName, state.schema);
  const { $from, empty: empty2, ranges } = selection;
  if (!dispatch) {
    return true;
  }
  if (empty2 && extendEmptyMarkRange) {
    let { from: from2, to } = selection;
    const attrs = (_a = $from.marks().find((mark) => mark.type === type)) == null ? void 0 : _a.attrs;
    const range = getMarkRange($from, type, attrs);
    if (range) {
      from2 = range.from;
      to = range.to;
    }
    tr2.removeMark(from2, to, type);
  } else {
    ranges.forEach((range) => {
      tr2.removeMark(range.$from.pos, range.$to.pos, type);
    });
  }
  tr2.removeStoredMark(type);
  return true;
};
var unsetTextDirection = (position) => ({ tr: tr2, state, dispatch }) => {
  const { selection } = state;
  let from2;
  let to;
  if (typeof position === "number") {
    from2 = position;
    to = position;
  } else if (position && "from" in position && "to" in position) {
    from2 = position.from;
    to = position.to;
  } else {
    from2 = selection.from;
    to = selection.to;
  }
  if (dispatch) {
    tr2.doc.nodesBetween(from2, to, (node, pos) => {
      if (node.isText) {
        return;
      }
      const newAttrs = { ...node.attrs };
      delete newAttrs.dir;
      tr2.setNodeMarkup(pos, void 0, newAttrs);
    });
  }
  return true;
};
var updateAttributes = (typeOrName, attributes = {}) => ({ tr: tr2, state, dispatch }) => {
  let nodeType = null;
  let markType = null;
  const schemaType = getSchemaTypeNameByName(
    typeof typeOrName === "string" ? typeOrName : typeOrName.name,
    state.schema
  );
  if (!schemaType) {
    return false;
  }
  if (schemaType === "node") {
    nodeType = getNodeType(typeOrName, state.schema);
  }
  if (schemaType === "mark") {
    markType = getMarkType(typeOrName, state.schema);
  }
  let canUpdate = false;
  tr2.selection.ranges.forEach((range) => {
    const from2 = range.$from.pos;
    const to = range.$to.pos;
    let lastPos;
    let lastNode;
    let trimmedFrom;
    let trimmedTo;
    if (tr2.selection.empty) {
      state.doc.nodesBetween(from2, to, (node, pos) => {
        if (nodeType && nodeType === node.type) {
          canUpdate = true;
          trimmedFrom = Math.max(pos, from2);
          trimmedTo = Math.min(pos + node.nodeSize, to);
          lastPos = pos;
          lastNode = node;
        }
      });
    } else {
      state.doc.nodesBetween(from2, to, (node, pos) => {
        if (pos < from2 && nodeType && nodeType === node.type) {
          canUpdate = true;
          trimmedFrom = Math.max(pos, from2);
          trimmedTo = Math.min(pos + node.nodeSize, to);
          lastPos = pos;
          lastNode = node;
        }
        if (pos >= from2 && pos <= to) {
          if (nodeType && nodeType === node.type) {
            canUpdate = true;
            if (dispatch) {
              tr2.setNodeMarkup(pos, void 0, {
                ...node.attrs,
                ...attributes
              });
            }
          }
          if (markType && node.marks.length) {
            node.marks.forEach((mark) => {
              if (markType === mark.type) {
                canUpdate = true;
                if (dispatch) {
                  const trimmedFrom2 = Math.max(pos, from2);
                  const trimmedTo2 = Math.min(pos + node.nodeSize, to);
                  tr2.addMark(
                    trimmedFrom2,
                    trimmedTo2,
                    markType.create({
                      ...mark.attrs,
                      ...attributes
                    })
                  );
                }
              }
            });
          }
        }
      });
    }
    if (lastNode) {
      if (lastPos !== void 0 && dispatch) {
        tr2.setNodeMarkup(lastPos, void 0, {
          ...lastNode.attrs,
          ...attributes
        });
      }
      if (markType && lastNode.marks.length) {
        lastNode.marks.forEach((mark) => {
          if (markType === mark.type && dispatch) {
            tr2.addMark(
              trimmedFrom,
              trimmedTo,
              markType.create({
                ...mark.attrs,
                ...attributes
              })
            );
          }
        });
      }
    }
  });
  return canUpdate;
};
var wrapIn2 = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  return wrapIn(type, attributes)(state, dispatch);
};
var wrapInList2 = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  return wrapInList(type, attributes)(state, dispatch);
};
var EventEmitter = class {
  constructor() {
    this.callbacks = {};
  }
  on(event, fn2) {
    if (!this.callbacks[event]) {
      this.callbacks[event] = [];
    }
    this.callbacks[event].push(fn2);
    return this;
  }
  emit(event, ...args) {
    const callbacks = this.callbacks[event];
    if (callbacks) {
      callbacks.forEach((callback) => callback.apply(this, args));
    }
    return this;
  }
  off(event, fn2) {
    const callbacks = this.callbacks[event];
    if (callbacks) {
      if (fn2) {
        this.callbacks[event] = callbacks.filter((callback) => callback !== fn2);
      } else {
        delete this.callbacks[event];
      }
    }
    return this;
  }
  once(event, fn2) {
    const onceFn = (...args) => {
      this.off(event, onceFn);
      fn2.apply(this, args);
    };
    return this.on(event, onceFn);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
};
var InputRule = class {
  constructor(config) {
    var _a;
    this.find = config.find;
    this.handler = config.handler;
    this.undoable = (_a = config.undoable) != null ? _a : true;
  }
};
var inputRuleMatcherHandler = (text, find2) => {
  if (isRegExp(find2)) {
    return find2.exec(text);
  }
  const inputRuleMatch = find2(text);
  if (!inputRuleMatch) {
    return null;
  }
  const result = [inputRuleMatch.text];
  result.index = inputRuleMatch.index;
  result.input = text;
  result.data = inputRuleMatch.data;
  if (inputRuleMatch.replaceWith) {
    if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) {
      console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
    }
    result.push(inputRuleMatch.replaceWith);
  }
  return result;
};
function run(config) {
  var _a;
  const { editor, from: from2, to, text, rules, plugin } = config;
  const { view } = editor;
  if (view.composing) {
    return false;
  }
  const $from = view.state.doc.resolve(from2);
  if (
    // check for code node
    $from.parent.type.spec.code || // check for code mark
    !!((_a = $from.nodeBefore || $from.nodeAfter) == null ? void 0 : _a.marks.find((mark) => mark.type.spec.code))
  ) {
    return false;
  }
  let matched = false;
  const textBefore = getTextContentFromNodes($from) + text;
  rules.forEach((rule) => {
    if (matched) {
      return;
    }
    const match = inputRuleMatcherHandler(textBefore, rule.find);
    if (!match) {
      return;
    }
    const tr2 = view.state.tr;
    const state = createChainableState({
      state: view.state,
      transaction: tr2
    });
    const range = {
      from: from2 - (match[0].length - text.length),
      to
    };
    const { commands, chain, can } = new CommandManager({
      editor,
      state
    });
    const handler = rule.handler({
      state,
      range,
      match,
      commands,
      chain,
      can
    });
    if (handler === null || !tr2.steps.length) {
      return;
    }
    if (rule.undoable) {
      tr2.setMeta(plugin, {
        transform: tr2,
        from: from2,
        to,
        text
      });
    }
    view.dispatch(tr2);
    matched = true;
  });
  return matched;
}
function inputRulesPlugin(props) {
  const { editor, rules } = props;
  const plugin = new Plugin({
    state: {
      init() {
        return null;
      },
      apply(tr2, prev, state) {
        const stored = tr2.getMeta(plugin);
        if (stored) {
          return stored;
        }
        const simulatedInputMeta = tr2.getMeta("applyInputRules");
        const isSimulatedInput = !!simulatedInputMeta;
        if (isSimulatedInput) {
          setTimeout(() => {
            let { text } = simulatedInputMeta;
            if (typeof text === "string") {
              text = text;
            } else {
              text = getHTMLFromFragment(Fragment6.from(text), state.schema);
            }
            const { from: from2 } = simulatedInputMeta;
            const to = from2 + text.length;
            run({
              editor,
              from: from2,
              to,
              text,
              rules,
              plugin
            });
          });
        }
        return tr2.selectionSet || tr2.docChanged ? null : prev;
      }
    },
    props: {
      handleTextInput(view, from2, to, text) {
        return run({
          editor,
          from: from2,
          to,
          text,
          rules,
          plugin
        });
      },
      handleDOMEvents: {
        compositionend: (view) => {
          setTimeout(() => {
            const { $cursor } = view.state.selection;
            if ($cursor) {
              run({
                editor,
                from: $cursor.pos,
                to: $cursor.pos,
                text: "",
                rules,
                plugin
              });
            }
          });
          return false;
        }
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(view, event) {
        if (event.key !== "Enter") {
          return false;
        }
        const { $cursor } = view.state.selection;
        if ($cursor) {
          return run({
            editor,
            from: $cursor.pos,
            to: $cursor.pos,
            text: "\n",
            rules,
            plugin
          });
        }
        return false;
      }
    },
    // @ts-ignore
    isInputRules: true
  });
  return plugin;
}
function getType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}
function isPlainObject(value) {
  if (getType(value) !== "Object") {
    return false;
  }
  return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}
function mergeDeep(target, source) {
  const output = { ...target };
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isPlainObject(source[key]) && isPlainObject(target[key])) {
        output[key] = mergeDeep(target[key], source[key]);
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
var Extendable = class {
  constructor(config = {}) {
    this.type = "extendable";
    this.parent = null;
    this.child = null;
    this.name = "";
    this.config = {
      name: this.name
    };
    this.config = {
      ...this.config,
      ...config
    };
    this.name = this.config.name;
  }
  get options() {
    return {
      ...callOrReturn(
        getExtensionField(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...callOrReturn(
        getExtensionField(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(options = {}) {
    const extension = this.extend({
      ...this.config,
      addOptions: () => {
        return mergeDeep(this.options, options);
      }
    });
    extension.name = this.name;
    extension.parent = this.parent;
    return extension;
  }
  extend(extendedConfig = {}) {
    const extension = new this.constructor({ ...this.config, ...extendedConfig });
    extension.parent = this;
    this.child = extension;
    extension.name = "name" in extendedConfig ? extendedConfig.name : extension.parent.name;
    return extension;
  }
};
var Mark2 = class _Mark extends Extendable {
  constructor() {
    super(...arguments);
    this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(config = {}) {
    const resolvedConfig = typeof config === "function" ? config() : config;
    return new _Mark(resolvedConfig);
  }
  static handleExit({ editor, mark }) {
    const { tr: tr2 } = editor.state;
    const currentPos = editor.state.selection.$from;
    const isAtEnd = currentPos.pos === currentPos.end();
    if (isAtEnd) {
      const currentMarks = currentPos.marks();
      const isInMark = !!currentMarks.find((m) => (m == null ? void 0 : m.type.name) === mark.name);
      if (!isInMark) {
        return false;
      }
      const removeMark2 = currentMarks.find((m) => (m == null ? void 0 : m.type.name) === mark.name);
      if (removeMark2) {
        tr2.removeStoredMark(removeMark2);
      }
      tr2.insertText(" ", currentPos.pos);
      editor.view.dispatch(tr2);
      return true;
    }
    return false;
  }
  configure(options) {
    return super.configure(options);
  }
  extend(extendedConfig) {
    const resolvedConfig = typeof extendedConfig === "function" ? extendedConfig() : extendedConfig;
    return super.extend(resolvedConfig);
  }
};
function isNumber2(value) {
  return typeof value === "number";
}
var PasteRule = class {
  constructor(config) {
    this.find = config.find;
    this.handler = config.handler;
  }
};
var pasteRuleMatcherHandler = (text, find2, event) => {
  if (isRegExp(find2)) {
    return [...text.matchAll(find2)];
  }
  const matches2 = find2(text, event);
  if (!matches2) {
    return [];
  }
  return matches2.map((pasteRuleMatch) => {
    const result = [pasteRuleMatch.text];
    result.index = pasteRuleMatch.index;
    result.input = text;
    result.data = pasteRuleMatch.data;
    if (pasteRuleMatch.replaceWith) {
      if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) {
        console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
      }
      result.push(pasteRuleMatch.replaceWith);
    }
    return result;
  });
};
function run2(config) {
  const { editor, state, from: from2, to, rule, pasteEvent, dropEvent } = config;
  const { commands, chain, can } = new CommandManager({
    editor,
    state
  });
  const handlers2 = [];
  state.doc.nodesBetween(from2, to, (node, pos) => {
    var _a, _b, _c, _d, _e;
    if (((_b = (_a = node.type) == null ? void 0 : _a.spec) == null ? void 0 : _b.code) || !(node.isText || node.isTextblock || node.isInline)) {
      return;
    }
    const contentSize = (_e = (_d = (_c = node.content) == null ? void 0 : _c.size) != null ? _d : node.nodeSize) != null ? _e : 0;
    const resolvedFrom = Math.max(from2, pos);
    const resolvedTo = Math.min(to, pos + contentSize);
    if (resolvedFrom >= resolvedTo) {
      return;
    }
    const textToMatch = node.isText ? node.text || "" : node.textBetween(resolvedFrom - pos, resolvedTo - pos, void 0, "\uFFFC");
    const matches2 = pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
    matches2.forEach((match) => {
      if (match.index === void 0) {
        return;
      }
      const start2 = resolvedFrom + match.index + 1;
      const end2 = start2 + match[0].length;
      const range = {
        from: state.tr.mapping.map(start2),
        to: state.tr.mapping.map(end2)
      };
      const handler = rule.handler({
        state,
        range,
        match,
        commands,
        chain,
        can,
        pasteEvent,
        dropEvent
      });
      handlers2.push(handler);
    });
  });
  const success = handlers2.every((handler) => handler !== null);
  return success;
}
var tiptapDragFromOtherEditor = null;
var createClipboardPasteEvent = (text) => {
  var _a;
  const event = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  (_a = event.clipboardData) == null ? void 0 : _a.setData("text/html", text);
  return event;
};
function pasteRulesPlugin(props) {
  const { editor, rules } = props;
  let dragSourceElement = null;
  let isPastedFromProseMirror = false;
  let isDroppedFromProseMirror = false;
  let pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
  let dropEvent;
  try {
    dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
  } catch {
    dropEvent = null;
  }
  const processEvent = ({
    state,
    from: from2,
    to,
    rule,
    pasteEvt
  }) => {
    const tr2 = state.tr;
    const chainableState = createChainableState({
      state,
      transaction: tr2
    });
    const handler = run2({
      editor,
      state: chainableState,
      from: Math.max(from2 - 1, 0),
      to: to.b - 1,
      rule,
      pasteEvent: pasteEvt,
      dropEvent
    });
    if (!handler || !tr2.steps.length) {
      return;
    }
    try {
      dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
    } catch {
      dropEvent = null;
    }
    pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
    return tr2;
  };
  const plugins = rules.map((rule) => {
    return new Plugin({
      // we register a global drag handler to track the current drag source element
      view(view) {
        const handleDragstart = (event) => {
          var _a;
          dragSourceElement = ((_a = view.dom.parentElement) == null ? void 0 : _a.contains(event.target)) ? view.dom.parentElement : null;
          if (dragSourceElement) {
            tiptapDragFromOtherEditor = editor;
          }
        };
        const handleDragend = () => {
          if (tiptapDragFromOtherEditor) {
            tiptapDragFromOtherEditor = null;
          }
        };
        window.addEventListener("dragstart", handleDragstart);
        window.addEventListener("dragend", handleDragend);
        return {
          destroy() {
            window.removeEventListener("dragstart", handleDragstart);
            window.removeEventListener("dragend", handleDragend);
          }
        };
      },
      props: {
        handleDOMEvents: {
          drop: (view, event) => {
            isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
            dropEvent = event;
            if (!isDroppedFromProseMirror) {
              const dragFromOtherEditor = tiptapDragFromOtherEditor;
              if (dragFromOtherEditor == null ? void 0 : dragFromOtherEditor.isEditable) {
                setTimeout(() => {
                  const selection = dragFromOtherEditor.state.selection;
                  if (selection) {
                    dragFromOtherEditor.commands.deleteRange({ from: selection.from, to: selection.to });
                  }
                }, 10);
              }
            }
            return false;
          },
          paste: (_view, event) => {
            var _a;
            const html = (_a = event.clipboardData) == null ? void 0 : _a.getData("text/html");
            pasteEvent = event;
            isPastedFromProseMirror = !!(html == null ? void 0 : html.includes("data-pm-slice"));
            return false;
          }
        }
      },
      appendTransaction: (transactions, oldState, state) => {
        const transaction = transactions[0];
        const isPaste = transaction.getMeta("uiEvent") === "paste" && !isPastedFromProseMirror;
        const isDrop = transaction.getMeta("uiEvent") === "drop" && !isDroppedFromProseMirror;
        const simulatedPasteMeta = transaction.getMeta("applyPasteRules");
        const isSimulatedPaste = !!simulatedPasteMeta;
        if (!isPaste && !isDrop && !isSimulatedPaste) {
          return;
        }
        if (isSimulatedPaste) {
          let { text } = simulatedPasteMeta;
          if (typeof text === "string") {
            text = text;
          } else {
            text = getHTMLFromFragment(Fragment6.from(text), state.schema);
          }
          const { from: from22 } = simulatedPasteMeta;
          const to2 = from22 + text.length;
          const pasteEvt = createClipboardPasteEvent(text);
          return processEvent({
            rule,
            state,
            from: from22,
            to: { b: to2 },
            pasteEvt
          });
        }
        const from2 = oldState.doc.content.findDiffStart(state.doc.content);
        const to = oldState.doc.content.findDiffEnd(state.doc.content);
        if (!isNumber2(from2) || !to || from2 === to.b) {
          return;
        }
        return processEvent({
          rule,
          state,
          from: from2,
          to,
          pasteEvt: pasteEvent
        });
      }
    });
  });
  return plugins;
}
var ExtensionManager = class {
  constructor(extensions, editor) {
    this.splittableMarks = [];
    this.editor = editor;
    this.baseExtensions = extensions;
    this.extensions = resolveExtensions(extensions);
    this.schema = getSchemaByResolvedExtensions(this.extensions, editor);
    this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((commands, extension) => {
      const context = {
        name: extension.name,
        options: extension.options,
        storage: this.editor.extensionStorage[extension.name],
        editor: this.editor,
        type: getSchemaTypeByName(extension.name, this.schema)
      };
      const addCommands = getExtensionField(extension, "addCommands", context);
      if (!addCommands) {
        return commands;
      }
      return {
        ...commands,
        ...addCommands()
      };
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor } = this;
    const extensions = sortExtensions([...this.extensions].reverse());
    const allPlugins = extensions.flatMap((extension) => {
      const context = {
        name: extension.name,
        options: extension.options,
        storage: this.editor.extensionStorage[extension.name],
        editor,
        type: getSchemaTypeByName(extension.name, this.schema)
      };
      const plugins = [];
      const addKeyboardShortcuts = getExtensionField(
        extension,
        "addKeyboardShortcuts",
        context
      );
      let defaultBindings = {};
      if (extension.type === "mark" && getExtensionField(extension, "exitable", context)) {
        defaultBindings.ArrowRight = () => Mark2.handleExit({ editor, mark: extension });
      }
      if (addKeyboardShortcuts) {
        const bindings = Object.fromEntries(
          Object.entries(addKeyboardShortcuts()).map(([shortcut, method]) => {
            return [shortcut, () => method({ editor })];
          })
        );
        defaultBindings = { ...defaultBindings, ...bindings };
      }
      const keyMapPlugin = keymap(defaultBindings);
      plugins.push(keyMapPlugin);
      const addInputRules = getExtensionField(extension, "addInputRules", context);
      if (isExtensionRulesEnabled(extension, editor.options.enableInputRules) && addInputRules) {
        const rules = addInputRules();
        if (rules && rules.length) {
          const inputResult = inputRulesPlugin({
            editor,
            rules
          });
          const inputPlugins = Array.isArray(inputResult) ? inputResult : [inputResult];
          plugins.push(...inputPlugins);
        }
      }
      const addPasteRules = getExtensionField(extension, "addPasteRules", context);
      if (isExtensionRulesEnabled(extension, editor.options.enablePasteRules) && addPasteRules) {
        const rules = addPasteRules();
        if (rules && rules.length) {
          const pasteRules = pasteRulesPlugin({ editor, rules });
          plugins.push(...pasteRules);
        }
      }
      const addProseMirrorPlugins = getExtensionField(
        extension,
        "addProseMirrorPlugins",
        context
      );
      if (addProseMirrorPlugins) {
        const proseMirrorPlugins = addProseMirrorPlugins();
        plugins.push(...proseMirrorPlugins);
      }
      return plugins;
    });
    return allPlugins;
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return getAttributesFromExtensions(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor } = this;
    const { nodeExtensions } = splitExtensions(this.extensions);
    return Object.fromEntries(
      nodeExtensions.filter((extension) => !!getExtensionField(extension, "addNodeView")).map((extension) => {
        const extensionAttributes = this.attributes.filter((attribute) => attribute.type === extension.name);
        const context = {
          name: extension.name,
          options: extension.options,
          storage: this.editor.extensionStorage[extension.name],
          editor,
          type: getNodeType(extension.name, this.schema)
        };
        const addNodeView = getExtensionField(extension, "addNodeView", context);
        if (!addNodeView) {
          return [];
        }
        const nodeViewResult = addNodeView();
        if (!nodeViewResult) {
          return [];
        }
        const nodeview = (node, view, getPos, decorations, innerDecorations) => {
          const HTMLAttributes = getRenderedAttributes(node, extensionAttributes);
          return nodeViewResult({
            // pass-through
            node,
            view,
            getPos,
            decorations,
            innerDecorations,
            // tiptap-specific
            editor,
            extension,
            HTMLAttributes
          });
        };
        return [extension.name, nodeview];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(baseDispatch) {
    const { editor } = this;
    const extensions = sortExtensions([...this.extensions].reverse());
    return extensions.reduceRight((next, extension) => {
      const context = {
        name: extension.name,
        options: extension.options,
        storage: this.editor.extensionStorage[extension.name],
        editor,
        type: getSchemaTypeByName(extension.name, this.schema)
      };
      const dispatchTransaction = getExtensionField(
        extension,
        "dispatchTransaction",
        context
      );
      if (!dispatchTransaction) {
        return next;
      }
      return (transaction) => {
        dispatchTransaction.call(context, { transaction, next });
      };
    }, baseDispatch);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(baseTransform) {
    const { editor } = this;
    const extensions = sortExtensions([...this.extensions]);
    return extensions.reduce(
      (transform, extension) => {
        const context = {
          name: extension.name,
          options: extension.options,
          storage: this.editor.extensionStorage[extension.name],
          editor,
          type: getSchemaTypeByName(extension.name, this.schema)
        };
        const extensionTransform = getExtensionField(
          extension,
          "transformPastedHTML",
          context
        );
        if (!extensionTransform) {
          return transform;
        }
        return (html, view) => {
          const transformedHtml = transform(html, view);
          return extensionTransform.call(context, transformedHtml);
        };
      },
      baseTransform || ((html) => html)
    );
  }
  get markViews() {
    const { editor } = this;
    const { markExtensions } = splitExtensions(this.extensions);
    return Object.fromEntries(
      markExtensions.filter((extension) => !!getExtensionField(extension, "addMarkView")).map((extension) => {
        const extensionAttributes = this.attributes.filter((attribute) => attribute.type === extension.name);
        const context = {
          name: extension.name,
          options: extension.options,
          storage: this.editor.extensionStorage[extension.name],
          editor,
          type: getMarkType(extension.name, this.schema)
        };
        const addMarkView = getExtensionField(extension, "addMarkView", context);
        if (!addMarkView) {
          return [];
        }
        const markView = (mark, view, inline3) => {
          const HTMLAttributes = getRenderedAttributes(mark, extensionAttributes);
          return addMarkView()({
            // pass-through
            mark,
            view,
            inline: inline3,
            // tiptap-specific
            editor,
            extension,
            HTMLAttributes,
            updateAttributes: (attrs) => {
              updateMarkViewAttributes(mark, editor, attrs);
            }
          });
        };
        return [extension.name, markView];
      })
    );
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const extensions = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      extensions.map((extension) => [extension.name, extension.storage])
    );
    extensions.forEach((extension) => {
      var _a;
      const context = {
        name: extension.name,
        options: extension.options,
        storage: this.editor.extensionStorage[extension.name],
        editor: this.editor,
        type: getSchemaTypeByName(extension.name, this.schema)
      };
      if (extension.type === "mark") {
        const keepOnSplit = (_a = callOrReturn(getExtensionField(extension, "keepOnSplit", context))) != null ? _a : true;
        if (keepOnSplit) {
          this.splittableMarks.push(extension.name);
        }
      }
      const onBeforeCreate = getExtensionField(extension, "onBeforeCreate", context);
      const onCreate2 = getExtensionField(extension, "onCreate", context);
      const onUpdate = getExtensionField(extension, "onUpdate", context);
      const onSelectionUpdate = getExtensionField(
        extension,
        "onSelectionUpdate",
        context
      );
      const onTransaction = getExtensionField(extension, "onTransaction", context);
      const onFocus = getExtensionField(extension, "onFocus", context);
      const onBlur = getExtensionField(extension, "onBlur", context);
      const onDestroy2 = getExtensionField(extension, "onDestroy", context);
      if (onBeforeCreate) {
        this.editor.on("beforeCreate", onBeforeCreate);
      }
      if (onCreate2) {
        this.editor.on("create", onCreate2);
      }
      if (onUpdate) {
        this.editor.on("update", onUpdate);
      }
      if (onSelectionUpdate) {
        this.editor.on("selectionUpdate", onSelectionUpdate);
      }
      if (onTransaction) {
        this.editor.on("transaction", onTransaction);
      }
      if (onFocus) {
        this.editor.on("focus", onFocus);
      }
      if (onBlur) {
        this.editor.on("blur", onBlur);
      }
      if (onDestroy2) {
        this.editor.on("destroy", onDestroy2);
      }
    });
  }
};
ExtensionManager.resolve = resolveExtensions;
ExtensionManager.sort = sortExtensions;
ExtensionManager.flatten = flattenExtensions;
var extensions_exports = {};
__export2(extensions_exports, {
  ClipboardTextSerializer: () => ClipboardTextSerializer,
  Commands: () => Commands,
  Delete: () => Delete,
  Drop: () => Drop,
  Editable: () => Editable,
  FocusEvents: () => FocusEvents,
  Keymap: () => Keymap,
  Paste: () => Paste,
  Tabindex: () => Tabindex,
  TextDirection: () => TextDirection,
  focusEventsPluginKey: () => focusEventsPluginKey
});
var Extension = class _Extension extends Extendable {
  constructor() {
    super(...arguments);
    this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(config = {}) {
    const resolvedConfig = typeof config === "function" ? config() : config;
    return new _Extension(resolvedConfig);
  }
  configure(options) {
    return super.configure(options);
  }
  extend(extendedConfig) {
    const resolvedConfig = typeof extendedConfig === "function" ? extendedConfig() : extendedConfig;
    return super.extend(resolvedConfig);
  }
};
var ClipboardTextSerializer = Extension.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor } = this;
            const { state, schema } = editor;
            const { doc: doc3, selection } = state;
            const { ranges } = selection;
            const from2 = Math.min(...ranges.map((range2) => range2.$from.pos));
            const to = Math.max(...ranges.map((range2) => range2.$to.pos));
            const textSerializers = getTextSerializersFromSchema(schema);
            const range = { from: from2, to };
            return getTextBetween(doc3, range, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers
            });
          }
        }
      })
    ];
  }
});
var Commands = Extension.create({
  name: "commands",
  addCommands() {
    return {
      ...commands_exports
    };
  }
});
var Delete = Extension.create({
  name: "delete",
  onUpdate({ transaction, appendedTransactions }) {
    var _a, _b, _c;
    const callback = () => {
      var _a2, _b2, _c2, _d;
      if ((_d = (_c2 = (_b2 = (_a2 = this.editor.options.coreExtensionOptions) == null ? void 0 : _a2.delete) == null ? void 0 : _b2.filterTransaction) == null ? void 0 : _c2.call(_b2, transaction)) != null ? _d : transaction.getMeta("y-sync$")) {
        return;
      }
      const nextTransaction = combineTransactionSteps(transaction.before, [transaction, ...appendedTransactions]);
      const changes = getChangedRanges(nextTransaction);
      changes.forEach((change) => {
        if (nextTransaction.mapping.mapResult(change.oldRange.from).deletedAfter && nextTransaction.mapping.mapResult(change.oldRange.to).deletedBefore) {
          nextTransaction.before.nodesBetween(change.oldRange.from, change.oldRange.to, (node, from2) => {
            const to = from2 + node.nodeSize - 2;
            const isFullyWithinRange = change.oldRange.from <= from2 && to <= change.oldRange.to;
            this.editor.emit("delete", {
              type: "node",
              node,
              from: from2,
              to,
              newFrom: nextTransaction.mapping.map(from2),
              newTo: nextTransaction.mapping.map(to),
              deletedRange: change.oldRange,
              newRange: change.newRange,
              partial: !isFullyWithinRange,
              editor: this.editor,
              transaction,
              combinedTransform: nextTransaction
            });
          });
        }
      });
      const mapping = nextTransaction.mapping;
      nextTransaction.steps.forEach((step, index2) => {
        var _a3, _b3;
        if (step instanceof RemoveMarkStep) {
          const newStart = mapping.slice(index2).map(step.from, -1);
          const newEnd = mapping.slice(index2).map(step.to);
          const oldStart = mapping.invert().map(newStart, -1);
          const oldEnd = mapping.invert().map(newEnd);
          const foundBeforeMark = (_a3 = nextTransaction.doc.nodeAt(newStart - 1)) == null ? void 0 : _a3.marks.some((mark) => mark.eq(step.mark));
          const foundAfterMark = (_b3 = nextTransaction.doc.nodeAt(newEnd)) == null ? void 0 : _b3.marks.some((mark) => mark.eq(step.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: step.mark,
            from: step.from,
            to: step.to,
            deletedRange: {
              from: oldStart,
              to: oldEnd
            },
            newRange: {
              from: newStart,
              to: newEnd
            },
            partial: Boolean(foundAfterMark || foundBeforeMark),
            editor: this.editor,
            transaction,
            combinedTransform: nextTransaction
          });
        }
      });
    };
    if ((_c = (_b = (_a = this.editor.options.coreExtensionOptions) == null ? void 0 : _a.delete) == null ? void 0 : _b.async) != null ? _c : true) {
      setTimeout(callback, 0);
    } else {
      callback();
    }
  }
});
var Drop = Extension.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("tiptapDrop"),
        props: {
          handleDrop: (_, e, slice2, moved) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: slice2,
              moved
            });
          }
        }
      })
    ];
  }
});
var Editable = Extension.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
var focusEventsPluginKey = new PluginKey("focusEvents");
var FocusEvents = Extension.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor } = this;
    return [
      new Plugin({
        key: focusEventsPluginKey,
        props: {
          handleDOMEvents: {
            focus: (view, event) => {
              editor.isFocused = true;
              const transaction = editor.state.tr.setMeta("focus", { event }).setMeta("addToHistory", false);
              view.dispatch(transaction);
              return false;
            },
            blur: (view, event) => {
              editor.isFocused = false;
              const transaction = editor.state.tr.setMeta("blur", { event }).setMeta("addToHistory", false);
              view.dispatch(transaction);
              return false;
            }
          }
        }
      })
    ];
  }
});
var Keymap = Extension.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const handleBackspace = () => this.editor.commands.first(({ commands }) => [
      () => commands.undoInputRule(),
      // maybe convert first text block node to default node
      () => commands.command(({ tr: tr2 }) => {
        const { selection, doc: doc3 } = tr2;
        const { empty: empty2, $anchor } = selection;
        const { pos, parent } = $anchor;
        const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr2.doc.resolve(pos - 1) : $anchor;
        const parentIsIsolating = $parentPos.parent.type.spec.isolating;
        const parentPos = $anchor.pos - $anchor.parentOffset;
        const isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : Selection.atStart(doc3).from === pos;
        if (!empty2 || !parent.type.isTextblock || parent.textContent.length || !isAtStart || isAtStart && $anchor.parent.type.name === "paragraph") {
          return false;
        }
        return commands.clearNodes();
      }),
      () => commands.deleteSelection(),
      () => commands.joinBackward(),
      () => commands.selectNodeBackward()
    ]);
    const handleDelete = () => this.editor.commands.first(({ commands }) => [
      () => commands.deleteSelection(),
      () => commands.deleteCurrentNode(),
      () => commands.joinForward(),
      () => commands.selectNodeForward()
    ]);
    const handleEnter = () => this.editor.commands.first(({ commands }) => [
      () => commands.newlineInCode(),
      () => commands.createParagraphNear(),
      () => commands.liftEmptyBlock(),
      () => commands.splitBlock()
    ]);
    const baseKeymap = {
      Enter: handleEnter,
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: handleBackspace,
      "Mod-Backspace": handleBackspace,
      "Shift-Backspace": handleBackspace,
      Delete: handleDelete,
      "Mod-Delete": handleDelete,
      "Mod-a": () => this.editor.commands.selectAll()
    };
    const pcKeymap = {
      ...baseKeymap
    };
    const macKeymap = {
      ...baseKeymap,
      "Ctrl-h": handleBackspace,
      "Alt-Backspace": handleBackspace,
      "Ctrl-d": handleDelete,
      "Ctrl-Alt-Backspace": handleDelete,
      "Alt-Delete": handleDelete,
      "Alt-d": handleDelete,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    if (isiOS() || isMacOS()) {
      return macKeymap;
    }
    return pcKeymap;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Plugin({
        key: new PluginKey("clearDocument"),
        appendTransaction: (transactions, oldState, newState) => {
          if (transactions.some((tr22) => tr22.getMeta("composition"))) {
            return;
          }
          const docChanges = transactions.some((transaction) => transaction.docChanged) && !oldState.doc.eq(newState.doc);
          const ignoreTr = transactions.some((transaction) => transaction.getMeta("preventClearDocument"));
          if (!docChanges || ignoreTr) {
            return;
          }
          const { empty: empty2, from: from2, to } = oldState.selection;
          const allFrom = Selection.atStart(oldState.doc).from;
          const allEnd = Selection.atEnd(oldState.doc).to;
          const allWasSelected = from2 === allFrom && to === allEnd;
          if (empty2 || !allWasSelected) {
            return;
          }
          const isEmpty = isNodeEmpty(newState.doc);
          if (!isEmpty) {
            return;
          }
          const tr2 = newState.tr;
          const state = createChainableState({
            state: newState,
            transaction: tr2
          });
          const { commands } = new CommandManager({
            editor: this.editor,
            state
          });
          commands.clearNodes();
          if (!tr2.steps.length) {
            return;
          }
          return tr2;
        }
      })
    ];
  }
});
var Paste = Extension.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("tiptapPaste"),
        props: {
          handlePaste: (_view, e, slice2) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: slice2
            });
          }
        }
      })
    ];
  }
});
var Tabindex = Extension.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
var TextDirection = Extension.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction) {
      return [];
    }
    const { nodeExtensions } = splitExtensions(this.extensions);
    return [
      {
        types: nodeExtensions.filter((extension) => extension.name !== "text").map((extension) => extension.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (element) => {
              const dir = element.getAttribute("dir");
              if (dir && (dir === "ltr" || dir === "rtl" || dir === "auto")) {
                return dir;
              }
              return this.options.direction;
            },
            renderHTML: (attributes) => {
              if (!attributes.dir) {
                return {};
              }
              return {
                dir: attributes.dir
              };
            }
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("textDirection"),
        props: {
          attributes: () => {
            const direction = this.options.direction;
            if (!direction) {
              return {};
            }
            return {
              dir: direction
            };
          }
        }
      })
    ];
  }
});
var NodePos = class _NodePos {
  constructor(pos, editor, isBlock = false, node = null) {
    this.currentNode = null;
    this.actualDepth = null;
    this.isBlock = isBlock;
    this.resolvedPos = pos;
    this.editor = editor;
    this.currentNode = node;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var _a;
    return (_a = this.actualDepth) != null ? _a : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(content) {
    let from2 = this.from;
    let to = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can\u2019t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      from2 = this.from + 1;
      to = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: from2, to }, content);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    if (this.isBlock) {
      return this.pos;
    }
    return this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    if (this.isBlock) {
      return this.pos + this.size;
    }
    return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0) {
      return null;
    }
    const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
    const $pos = this.resolvedPos.doc.resolve(parentPos);
    return new _NodePos($pos, this.editor);
  }
  get before() {
    let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    if ($pos.depth !== this.depth) {
      $pos = this.resolvedPos.doc.resolve(this.from - 3);
    }
    return new _NodePos($pos, this.editor);
  }
  get after() {
    let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    if ($pos.depth !== this.depth) {
      $pos = this.resolvedPos.doc.resolve(this.to + 3);
    }
    return new _NodePos($pos, this.editor);
  }
  get children() {
    const children = [];
    this.node.content.forEach((node, offset5) => {
      const isBlock = node.isBlock && !node.isTextblock;
      const isNonTextAtom = node.isAtom && !node.isText;
      const isInline2 = node.isInline;
      const targetPos = this.pos + offset5 + (isNonTextAtom ? 0 : 1);
      if (targetPos < 0 || targetPos > this.resolvedPos.doc.nodeSize - 2) {
        return;
      }
      const $pos = this.resolvedPos.doc.resolve(targetPos);
      if (!isBlock && !isInline2 && $pos.depth <= this.depth) {
        return;
      }
      const childNodePos = new _NodePos($pos, this.editor, isBlock, isBlock || isInline2 ? node : null);
      if (isBlock) {
        childNodePos.actualDepth = this.depth + 1;
      }
      children.push(childNodePos);
    });
    return children;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const children = this.children;
    return children[children.length - 1] || null;
  }
  closest(selector, attributes = {}) {
    let node = null;
    let currentNode = this.parent;
    while (currentNode && !node) {
      if (currentNode.node.type.name === selector) {
        if (Object.keys(attributes).length > 0) {
          const nodeAttributes = currentNode.node.attrs;
          const attrKeys = Object.keys(attributes);
          for (let index2 = 0; index2 < attrKeys.length; index2 += 1) {
            const key = attrKeys[index2];
            if (nodeAttributes[key] !== attributes[key]) {
              break;
            }
          }
        } else {
          node = currentNode;
        }
      }
      currentNode = currentNode.parent;
    }
    return node;
  }
  querySelector(selector, attributes = {}) {
    return this.querySelectorAll(selector, attributes, true)[0] || null;
  }
  querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
    let nodes = [];
    if (!this.children || this.children.length === 0) {
      return nodes;
    }
    const attrKeys = Object.keys(attributes);
    this.children.forEach((childPos) => {
      if (firstItemOnly && nodes.length > 0) {
        return;
      }
      if (childPos.node.type.name === selector) {
        const doesAllAttributesMatch = attrKeys.every((key) => attributes[key] === childPos.node.attrs[key]);
        if (doesAllAttributesMatch) {
          nodes.push(childPos);
        }
      }
      if (firstItemOnly && nodes.length > 0) {
        return;
      }
      nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
    });
    return nodes;
  }
  setAttribute(attributes) {
    const { tr: tr2 } = this.editor.state;
    tr2.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...attributes
    });
    this.editor.view.dispatch(tr2);
  }
};
var style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function createStyleTag(style2, nonce, suffix) {
  const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${""}]`);
  if (tiptapStyleTag !== null) {
    return tiptapStyleTag;
  }
  const styleNode = document.createElement("style");
  if (nonce) {
    styleNode.setAttribute("nonce", nonce);
  }
  styleNode.setAttribute(`data-tiptap-style${""}`, "");
  styleNode.innerHTML = style2;
  document.getElementsByTagName("head")[0].appendChild(styleNode);
  return styleNode;
}
var Editor = class extends EventEmitter {
  constructor(options = {}) {
    super();
    this.css = null;
    this.className = "tiptap";
    this.editorView = null;
    this.isFocused = false;
    this.isInitialized = false;
    this.extensionStorage = {};
    this.instanceId = Math.random().toString(36).slice(2, 9);
    this.options = {
      element: typeof document !== "undefined" ? document.createElement("div") : null,
      content: "",
      injectCSS: true,
      injectNonce: void 0,
      extensions: [],
      autofocus: false,
      editable: true,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: true,
      enablePasteRules: true,
      enableCoreExtensions: true,
      enableContentCheck: false,
      emitContentError: false,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error }) => {
        throw error;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: true
    };
    this.isCapturingTransaction = false;
    this.capturedTransaction = null;
    this.utils = {
      getUpdatedPosition,
      createMappablePosition
    };
    this.setOptions(options);
    this.createExtensionManager();
    this.createCommandManager();
    this.createSchema();
    this.on("beforeCreate", this.options.onBeforeCreate);
    this.emit("beforeCreate", { editor: this });
    this.on("mount", this.options.onMount);
    this.on("unmount", this.options.onUnmount);
    this.on("contentError", this.options.onContentError);
    this.on("create", this.options.onCreate);
    this.on("update", this.options.onUpdate);
    this.on("selectionUpdate", this.options.onSelectionUpdate);
    this.on("transaction", this.options.onTransaction);
    this.on("focus", this.options.onFocus);
    this.on("blur", this.options.onBlur);
    this.on("destroy", this.options.onDestroy);
    this.on("drop", ({ event, slice: slice2, moved }) => this.options.onDrop(event, slice2, moved));
    this.on("paste", ({ event, slice: slice2 }) => this.options.onPaste(event, slice2));
    this.on("delete", this.options.onDelete);
    const initialDoc = this.createDoc();
    const selection = resolveFocusPosition(initialDoc, this.options.autofocus);
    this.editorState = EditorState.create({
      doc: initialDoc,
      schema: this.schema,
      selection: selection || void 0
    });
    if (this.options.element) {
      this.mount(this.options.element);
    }
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(el) {
    if (typeof document === "undefined") {
      throw new Error(
        `[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment.`
      );
    }
    this.createView(el);
    this.emit("mount", { editor: this });
    if (this.css && !document.head.contains(this.css)) {
      document.head.appendChild(this.css);
    }
    window.setTimeout(() => {
      if (this.isDestroyed) {
        return;
      }
      if (this.options.autofocus !== false && this.options.autofocus !== null) {
        this.commands.focus(this.options.autofocus);
      }
      this.emit("create", { editor: this });
      this.isInitialized = true;
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const dom = this.editorView.dom;
      if (dom == null ? void 0 : dom.editor) {
        delete dom.editor;
      }
      this.editorView.destroy();
    }
    this.editorView = null;
    this.isInitialized = false;
    if (this.css && !document.querySelectorAll(`.${this.className}`).length) {
      try {
        if (typeof this.css.remove === "function") {
          this.css.remove();
        } else if (this.css.parentNode) {
          this.css.parentNode.removeChild(this.css);
        }
      } catch (error) {
        console.warn("Failed to remove CSS element:", error);
      }
    }
    this.css = null;
    this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    if (this.options.injectCSS && typeof document !== "undefined") {
      this.css = createStyleTag(style, this.options.injectNonce);
    }
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(options = {}) {
    this.options = {
      ...this.options,
      ...options
    };
    if (!this.editorView || !this.state || this.isDestroyed) {
      return;
    }
    if (this.options.editorProps) {
      this.view.setProps(this.options.editorProps);
    }
    this.view.updateState(this.state);
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(editable, emitUpdate = true) {
    this.setOptions({ editable });
    if (emitUpdate) {
      this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
    }
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    if (this.editorView) {
      return this.editorView;
    }
    return new Proxy(
      {
        state: this.editorState,
        updateState: (state) => {
          this.editorState = state;
        },
        dispatch: (tr2) => {
          this.dispatchTransaction(tr2);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: false,
        dragging: null,
        editable: true,
        isDestroyed: false
      },
      {
        get: (obj, key) => {
          if (this.editorView) {
            return this.editorView[key];
          }
          if (key === "state") {
            return this.editorState;
          }
          if (key in obj) {
            return Reflect.get(obj, key);
          }
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${key}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    if (this.editorView) {
      this.editorState = this.view.state;
    }
    return this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(plugin, handlePlugins) {
    const plugins = isFunction2(handlePlugins) ? handlePlugins(plugin, [...this.state.plugins]) : [...this.state.plugins, plugin];
    const state = this.state.reconfigure({ plugins });
    this.view.updateState(state);
    return state;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(nameOrPluginKeyToRemove) {
    if (this.isDestroyed) {
      return void 0;
    }
    const prevPlugins = this.state.plugins;
    let plugins = prevPlugins;
    [].concat(nameOrPluginKeyToRemove).forEach((nameOrPluginKey) => {
      const name = typeof nameOrPluginKey === "string" ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
      plugins = plugins.filter((plugin) => !plugin.key.startsWith(name));
    });
    if (prevPlugins.length === plugins.length) {
      return void 0;
    }
    const state = this.state.reconfigure({
      plugins
    });
    this.view.updateState(state);
    return state;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var _a, _b;
    const coreExtensions = this.options.enableCoreExtensions ? [
      Editable,
      ClipboardTextSerializer.configure({
        blockSeparator: (_b = (_a = this.options.coreExtensionOptions) == null ? void 0 : _a.clipboardTextSerializer) == null ? void 0 : _b.blockSeparator
      }),
      Commands,
      FocusEvents,
      Keymap,
      Tabindex,
      Drop,
      Paste,
      Delete,
      TextDirection.configure({
        direction: this.options.textDirection
      })
    ].filter((ext) => {
      if (typeof this.options.enableCoreExtensions === "object") {
        return this.options.enableCoreExtensions[ext.name] !== false;
      }
      return true;
    }) : [];
    const allExtensions = [...coreExtensions, ...this.options.extensions].filter((extension) => {
      return ["extension", "node", "mark"].includes(extension == null ? void 0 : extension.type);
    });
    this.extensionManager = new ExtensionManager(allExtensions, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new CommandManager({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let doc3;
    try {
      doc3 = createDocument(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (e) {
      if (!(e instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(e.message)) {
        throw e;
      }
      this.emit("contentError", {
        editor: this,
        error: e,
        disableCollaboration: () => {
          if ("collaboration" in this.storage && typeof this.storage.collaboration === "object" && this.storage.collaboration) {
            this.storage.collaboration.isDisabled = true;
          }
          this.options.extensions = this.options.extensions.filter((extension) => extension.name !== "collaboration");
          this.createExtensionManager();
        }
      });
      doc3 = createDocument(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: false
      });
    }
    return doc3;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(element) {
    const { editorProps, enableExtensionDispatchTransaction } = this.options;
    const baseDispatch = editorProps.dispatchTransaction || this.dispatchTransaction.bind(this);
    const dispatch = enableExtensionDispatchTransaction ? this.extensionManager.dispatchTransaction(baseDispatch) : baseDispatch;
    const baseTransformPastedHTML = editorProps.transformPastedHTML;
    const transformPastedHTML = this.extensionManager.transformPastedHTML(baseTransformPastedHTML);
    this.editorView = new EditorView(element, {
      ...editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...editorProps == null ? void 0 : editorProps.attributes
      },
      dispatchTransaction: dispatch,
      transformPastedHTML,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const newState = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(newState);
    this.prependClass();
    this.injectCSS();
    const dom = this.view.dom;
    dom.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    if (this.view.isDestroyed) {
      return;
    }
    this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(fn2) {
    this.isCapturingTransaction = true;
    fn2();
    this.isCapturingTransaction = false;
    const tr2 = this.capturedTransaction;
    this.capturedTransaction = null;
    return tr2;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(transaction) {
    if (this.view.isDestroyed) {
      return;
    }
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = transaction;
        return;
      }
      transaction.steps.forEach((step) => {
        var _a;
        return (_a = this.capturedTransaction) == null ? void 0 : _a.step(step);
      });
      return;
    }
    const { state, transactions } = this.state.applyTransaction(transaction);
    const selectionHasChanged = !this.state.selection.eq(state.selection);
    const rootTrWasApplied = transactions.includes(transaction);
    const prevState = this.state;
    this.emit("beforeTransaction", {
      editor: this,
      transaction,
      nextState: state
    });
    if (!rootTrWasApplied) {
      return;
    }
    this.view.updateState(state);
    this.emit("transaction", {
      editor: this,
      transaction,
      appendedTransactions: transactions.slice(1)
    });
    if (selectionHasChanged) {
      this.emit("selectionUpdate", {
        editor: this,
        transaction
      });
    }
    const mostRecentFocusTr = transactions.findLast((tr2) => tr2.getMeta("focus") || tr2.getMeta("blur"));
    const focus22 = mostRecentFocusTr == null ? void 0 : mostRecentFocusTr.getMeta("focus");
    const blur2 = mostRecentFocusTr == null ? void 0 : mostRecentFocusTr.getMeta("blur");
    if (focus22) {
      this.emit("focus", {
        editor: this,
        event: focus22.event,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        transaction: mostRecentFocusTr
      });
    }
    if (blur2) {
      this.emit("blur", {
        editor: this,
        event: blur2.event,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        transaction: mostRecentFocusTr
      });
    }
    if (transaction.getMeta("preventUpdate") || !transactions.some((tr2) => tr2.docChanged) || prevState.doc.eq(state.doc)) {
      return;
    }
    this.emit("update", {
      editor: this,
      transaction,
      appendedTransactions: transactions.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(nameOrType) {
    return getAttributes(this.state, nameOrType);
  }
  isActive(nameOrAttributes, attributesOrUndefined) {
    const name = typeof nameOrAttributes === "string" ? nameOrAttributes : null;
    const attributes = typeof nameOrAttributes === "string" ? attributesOrUndefined : nameOrAttributes;
    return isActive(this.state, name, attributes);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return getHTMLFromFragment(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(options) {
    const { blockSeparator = "\n\n", textSerializers = {} } = options || {};
    return getText2(this.state.doc, {
      blockSeparator,
      textSerializers: {
        ...getTextSerializersFromSchema(this.schema),
        ...textSerializers
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return isNodeEmpty(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy");
    this.unmount();
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var _a, _b;
    return (_b = (_a = this.editorView) == null ? void 0 : _a.isDestroyed) != null ? _b : true;
  }
  $node(selector, attributes) {
    var _a;
    return ((_a = this.$doc) == null ? void 0 : _a.querySelector(selector, attributes)) || null;
  }
  $nodes(selector, attributes) {
    var _a;
    return ((_a = this.$doc) == null ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
  }
  $pos(pos) {
    const $pos = this.state.doc.resolve(pos);
    return new NodePos($pos, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function markInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: ({ state, range, match }) => {
      const attributes = callOrReturn(config.getAttributes, void 0, match);
      if (attributes === false || attributes === null) {
        return null;
      }
      const { tr: tr2 } = state;
      const captureGroup = match[match.length - 1];
      const fullMatch = match[0];
      if (captureGroup) {
        const startSpaces = fullMatch.search(/\S/);
        const textStart = range.from + fullMatch.indexOf(captureGroup);
        const textEnd = textStart + captureGroup.length;
        const excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter((item) => {
          const excluded = item.mark.type.excluded;
          return excluded.find((type) => type === config.type && type !== item.mark.type);
        }).filter((item) => item.to > textStart);
        if (excludedMarks.length) {
          return null;
        }
        if (textEnd < range.to) {
          tr2.delete(textEnd, range.to);
        }
        if (textStart > range.from) {
          tr2.delete(range.from + startSpaces, textStart);
        }
        const markEnd = range.from + startSpaces + captureGroup.length;
        tr2.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
        tr2.removeStoredMark(config.type);
      }
    },
    undoable: config.undoable
  });
}
function nodeInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: ({ state, range, match }) => {
      const attributes = callOrReturn(config.getAttributes, void 0, match) || {};
      const { tr: tr2 } = state;
      const start2 = range.from;
      let end2 = range.to;
      const newNode = config.type.create(attributes);
      if (match[1]) {
        const offset5 = match[0].lastIndexOf(match[1]);
        let matchStart = start2 + offset5;
        if (matchStart > end2) {
          matchStart = end2;
        } else {
          end2 = matchStart + match[1].length;
        }
        const lastChar = match[0][match[0].length - 1];
        tr2.insertText(lastChar, start2 + match[0].length - 1);
        tr2.replaceWith(matchStart, end2, newNode);
      } else if (match[0]) {
        const insertionStart = config.type.isInline ? start2 : start2 - 1;
        tr2.insert(insertionStart, config.type.create(attributes)).delete(tr2.mapping.map(start2), tr2.mapping.map(end2));
      }
      tr2.scrollIntoView();
    },
    undoable: config.undoable
  });
}
var isTouchEvent = (e) => {
  return "touches" in e;
};
var ResizableNodeView = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(options) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"];
    this.minSize = {
      height: 8,
      width: 8
    };
    this.preserveAspectRatio = false;
    this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    };
    this.initialWidth = 0;
    this.initialHeight = 0;
    this.aspectRatio = 1;
    this.isResizing = false;
    this.activeHandle = null;
    this.startX = 0;
    this.startY = 0;
    this.startWidth = 0;
    this.startHeight = 0;
    this.isShiftKeyPressed = false;
    this.lastEditableState = void 0;
    this.handleMap = /* @__PURE__ */ new Map();
    this.handleMouseMove = (event) => {
      if (!this.isResizing || !this.activeHandle) {
        return;
      }
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      this.handleResize(deltaX, deltaY);
    };
    this.handleTouchMove = (event) => {
      if (!this.isResizing || !this.activeHandle) {
        return;
      }
      const touch = event.touches[0];
      if (!touch) {
        return;
      }
      const deltaX = touch.clientX - this.startX;
      const deltaY = touch.clientY - this.startY;
      this.handleResize(deltaX, deltaY);
    };
    this.handleMouseUp = () => {
      if (!this.isResizing) {
        return;
      }
      const finalWidth = this.element.offsetWidth;
      const finalHeight = this.element.offsetHeight;
      this.onCommit(finalWidth, finalHeight);
      this.isResizing = false;
      this.activeHandle = null;
      this.container.dataset.resizeState = "false";
      if (this.classNames.resizing) {
        this.container.classList.remove(this.classNames.resizing);
      }
      document.removeEventListener("mousemove", this.handleMouseMove);
      document.removeEventListener("mouseup", this.handleMouseUp);
      document.removeEventListener("keydown", this.handleKeyDown);
      document.removeEventListener("keyup", this.handleKeyUp);
    };
    this.handleKeyDown = (event) => {
      if (event.key === "Shift") {
        this.isShiftKeyPressed = true;
      }
    };
    this.handleKeyUp = (event) => {
      if (event.key === "Shift") {
        this.isShiftKeyPressed = false;
      }
    };
    var _a, _b, _c, _d, _e, _f;
    this.node = options.node;
    this.editor = options.editor;
    this.element = options.element;
    this.contentElement = options.contentElement;
    this.getPos = options.getPos;
    this.onResize = options.onResize;
    this.onCommit = options.onCommit;
    this.onUpdate = options.onUpdate;
    if ((_a = options.options) == null ? void 0 : _a.min) {
      this.minSize = {
        ...this.minSize,
        ...options.options.min
      };
    }
    if ((_b = options.options) == null ? void 0 : _b.max) {
      this.maxSize = options.options.max;
    }
    if ((_c = options == null ? void 0 : options.options) == null ? void 0 : _c.directions) {
      this.directions = options.options.directions;
    }
    if ((_d = options.options) == null ? void 0 : _d.preserveAspectRatio) {
      this.preserveAspectRatio = options.options.preserveAspectRatio;
    }
    if ((_e = options.options) == null ? void 0 : _e.className) {
      this.classNames = {
        container: options.options.className.container || "",
        wrapper: options.options.className.wrapper || "",
        handle: options.options.className.handle || "",
        resizing: options.options.className.resizing || ""
      };
    }
    if ((_f = options.options) == null ? void 0 : _f.createCustomHandle) {
      this.createCustomHandle = options.options.createCustomHandle;
    }
    this.wrapper = this.createWrapper();
    this.container = this.createContainer();
    this.applyInitialSize();
    this.attachHandles();
    this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var _a;
    return (_a = this.contentElement) != null ? _a : null;
  }
  handleEditorUpdate() {
    const isEditable = this.editor.isEditable;
    if (isEditable === this.lastEditableState) {
      return;
    }
    this.lastEditableState = isEditable;
    if (!isEditable) {
      this.removeHandles();
    } else if (isEditable && this.handleMap.size === 0) {
      this.attachHandles();
    }
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(node, decorations, innerDecorations) {
    if (node.type !== this.node.type) {
      return false;
    }
    this.node = node;
    if (this.onUpdate) {
      return this.onUpdate(node, decorations, innerDecorations);
    }
    return true;
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    if (this.isResizing) {
      this.container.dataset.resizeState = "false";
      if (this.classNames.resizing) {
        this.container.classList.remove(this.classNames.resizing);
      }
      document.removeEventListener("mousemove", this.handleMouseMove);
      document.removeEventListener("mouseup", this.handleMouseUp);
      document.removeEventListener("keydown", this.handleKeyDown);
      document.removeEventListener("keyup", this.handleKeyUp);
      this.isResizing = false;
      this.activeHandle = null;
    }
    this.editor.off("update", this.handleEditorUpdate.bind(this));
    this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const element = document.createElement("div");
    element.dataset.resizeContainer = "";
    element.dataset.node = this.node.type.name;
    element.style.display = "flex";
    if (this.classNames.container) {
      element.className = this.classNames.container;
    }
    element.appendChild(this.wrapper);
    return element;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const element = document.createElement("div");
    element.style.position = "relative";
    element.style.display = "block";
    element.dataset.resizeWrapper = "";
    if (this.classNames.wrapper) {
      element.className = this.classNames.wrapper;
    }
    element.appendChild(this.element);
    return element;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(direction) {
    const handle = document.createElement("div");
    handle.dataset.resizeHandle = direction;
    handle.style.position = "absolute";
    if (this.classNames.handle) {
      handle.className = this.classNames.handle;
    }
    return handle;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(handle, direction) {
    const isTop = direction.includes("top");
    const isBottom = direction.includes("bottom");
    const isLeft = direction.includes("left");
    const isRight = direction.includes("right");
    if (isTop) {
      handle.style.top = "0";
    }
    if (isBottom) {
      handle.style.bottom = "0";
    }
    if (isLeft) {
      handle.style.left = "0";
    }
    if (isRight) {
      handle.style.right = "0";
    }
    if (direction === "top" || direction === "bottom") {
      handle.style.left = "0";
      handle.style.right = "0";
    }
    if (direction === "left" || direction === "right") {
      handle.style.top = "0";
      handle.style.bottom = "0";
    }
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((direction) => {
      let handle;
      if (this.createCustomHandle) {
        handle = this.createCustomHandle(direction);
      } else {
        handle = this.createHandle(direction);
      }
      if (!(handle instanceof HTMLElement)) {
        console.warn(
          `[ResizableNodeView] createCustomHandle("${direction}") did not return an HTMLElement. Falling back to default handle.`
        );
        handle = this.createHandle(direction);
      }
      if (!this.createCustomHandle) {
        this.positionHandle(handle, direction);
      }
      handle.addEventListener("mousedown", (event) => this.handleResizeStart(event, direction));
      handle.addEventListener("touchstart", (event) => this.handleResizeStart(event, direction));
      this.handleMap.set(direction, handle);
      this.wrapper.appendChild(handle);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((el) => el.remove());
    this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const width = this.node.attrs.width;
    const height = this.node.attrs.height;
    if (width) {
      this.element.style.width = `${width}px`;
      this.initialWidth = width;
    } else {
      this.initialWidth = this.element.offsetWidth;
    }
    if (height) {
      this.element.style.height = `${height}px`;
      this.initialHeight = height;
    } else {
      this.initialHeight = this.element.offsetHeight;
    }
    if (this.initialWidth > 0 && this.initialHeight > 0) {
      this.aspectRatio = this.initialWidth / this.initialHeight;
    }
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(event, direction) {
    event.preventDefault();
    event.stopPropagation();
    this.isResizing = true;
    this.activeHandle = direction;
    if (isTouchEvent(event)) {
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
    } else {
      this.startX = event.clientX;
      this.startY = event.clientY;
    }
    this.startWidth = this.element.offsetWidth;
    this.startHeight = this.element.offsetHeight;
    if (this.startWidth > 0 && this.startHeight > 0) {
      this.aspectRatio = this.startWidth / this.startHeight;
    }
    this.getPos();
    this.container.dataset.resizeState = "true";
    if (this.classNames.resizing) {
      this.container.classList.add(this.classNames.resizing);
    }
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("touchmove", this.handleTouchMove);
    document.addEventListener("mouseup", this.handleMouseUp);
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(deltaX, deltaY) {
    if (!this.activeHandle) {
      return;
    }
    const shouldPreserveAspectRatio = this.preserveAspectRatio || this.isShiftKeyPressed;
    const { width, height } = this.calculateNewDimensions(this.activeHandle, deltaX, deltaY);
    const constrained = this.applyConstraints(width, height, shouldPreserveAspectRatio);
    this.element.style.width = `${constrained.width}px`;
    this.element.style.height = `${constrained.height}px`;
    if (this.onResize) {
      this.onResize(constrained.width, constrained.height);
    }
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(direction, deltaX, deltaY) {
    let newWidth = this.startWidth;
    let newHeight = this.startHeight;
    const isRight = direction.includes("right");
    const isLeft = direction.includes("left");
    const isBottom = direction.includes("bottom");
    const isTop = direction.includes("top");
    if (isRight) {
      newWidth = this.startWidth + deltaX;
    } else if (isLeft) {
      newWidth = this.startWidth - deltaX;
    }
    if (isBottom) {
      newHeight = this.startHeight + deltaY;
    } else if (isTop) {
      newHeight = this.startHeight - deltaY;
    }
    if (direction === "right" || direction === "left") {
      newWidth = this.startWidth + (isRight ? deltaX : -deltaX);
    }
    if (direction === "top" || direction === "bottom") {
      newHeight = this.startHeight + (isBottom ? deltaY : -deltaY);
    }
    const shouldPreserveAspectRatio = this.preserveAspectRatio || this.isShiftKeyPressed;
    if (shouldPreserveAspectRatio) {
      return this.applyAspectRatio(newWidth, newHeight, direction);
    }
    return { width: newWidth, height: newHeight };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(width, height, preserveAspectRatio) {
    var _a, _b, _c, _d;
    if (!preserveAspectRatio) {
      let constrainedWidth2 = Math.max(this.minSize.width, width);
      let constrainedHeight2 = Math.max(this.minSize.height, height);
      if ((_a = this.maxSize) == null ? void 0 : _a.width) {
        constrainedWidth2 = Math.min(this.maxSize.width, constrainedWidth2);
      }
      if ((_b = this.maxSize) == null ? void 0 : _b.height) {
        constrainedHeight2 = Math.min(this.maxSize.height, constrainedHeight2);
      }
      return { width: constrainedWidth2, height: constrainedHeight2 };
    }
    let constrainedWidth = width;
    let constrainedHeight = height;
    if (constrainedWidth < this.minSize.width) {
      constrainedWidth = this.minSize.width;
      constrainedHeight = constrainedWidth / this.aspectRatio;
    }
    if (constrainedHeight < this.minSize.height) {
      constrainedHeight = this.minSize.height;
      constrainedWidth = constrainedHeight * this.aspectRatio;
    }
    if (((_c = this.maxSize) == null ? void 0 : _c.width) && constrainedWidth > this.maxSize.width) {
      constrainedWidth = this.maxSize.width;
      constrainedHeight = constrainedWidth / this.aspectRatio;
    }
    if (((_d = this.maxSize) == null ? void 0 : _d.height) && constrainedHeight > this.maxSize.height) {
      constrainedHeight = this.maxSize.height;
      constrainedWidth = constrainedHeight * this.aspectRatio;
    }
    return { width: constrainedWidth, height: constrainedHeight };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(width, height, direction) {
    const isHorizontal = direction === "left" || direction === "right";
    const isVertical = direction === "top" || direction === "bottom";
    if (isHorizontal) {
      return {
        width,
        height: width / this.aspectRatio
      };
    }
    if (isVertical) {
      return {
        width: height * this.aspectRatio,
        height
      };
    }
    return {
      width,
      height: width / this.aspectRatio
    };
  }
};
function escapeForRegEx(string) {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var markdown_exports = {};
__export2(markdown_exports, {
  createAtomBlockMarkdownSpec: () => createAtomBlockMarkdownSpec,
  createBlockMarkdownSpec: () => createBlockMarkdownSpec,
  createInlineMarkdownSpec: () => createInlineMarkdownSpec,
  parseAttributes: () => parseAttributes,
  parseIndentedBlocks: () => parseIndentedBlocks,
  renderNestedMarkdownContent: () => renderNestedMarkdownContent,
  serializeAttributes: () => serializeAttributes
});
function parseAttributes(attrString) {
  if (!(attrString == null ? void 0 : attrString.trim())) {
    return {};
  }
  const attributes = {};
  const quotedStrings = [];
  const tempString = attrString.replace(/["']([^"']*)["']/g, (match) => {
    quotedStrings.push(match);
    return `__QUOTED_${quotedStrings.length - 1}__`;
  });
  const classMatches = tempString.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (classMatches) {
    const classes = classMatches.map((match) => match.trim().slice(1));
    attributes.class = classes.join(" ");
  }
  const idMatch = tempString.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  if (idMatch) {
    attributes.id = idMatch[1];
  }
  const kvRegex = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  const kvMatches = Array.from(tempString.matchAll(kvRegex));
  kvMatches.forEach(([, key, quotedRef]) => {
    var _a;
    const quotedIndex = parseInt(((_a = quotedRef.match(/__QUOTED_(\d+)__/)) == null ? void 0 : _a[1]) || "0", 10);
    const quotedValue = quotedStrings[quotedIndex];
    if (quotedValue) {
      attributes[key] = quotedValue.slice(1, -1);
    }
  });
  const cleanString = tempString.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  if (cleanString) {
    const booleanAttrs = cleanString.split(/\s+/).filter(Boolean);
    booleanAttrs.forEach((attr) => {
      if (attr.match(/^[a-zA-Z][\w-]*$/)) {
        attributes[attr] = true;
      }
    });
  }
  return attributes;
}
function serializeAttributes(attributes) {
  if (!attributes || Object.keys(attributes).length === 0) {
    return "";
  }
  const parts = [];
  if (attributes.class) {
    const classes = String(attributes.class).split(/\s+/).filter(Boolean);
    classes.forEach((cls) => parts.push(`.${cls}`));
  }
  if (attributes.id) {
    parts.push(`#${attributes.id}`);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    if (key === "class" || key === "id") {
      return;
    }
    if (value === true) {
      parts.push(key);
    } else if (value !== false && value != null) {
      parts.push(`${key}="${String(value)}"`);
    }
  });
  return parts.join(" ");
}
function createAtomBlockMarkdownSpec(options) {
  const {
    nodeName,
    name: markdownName,
    parseAttributes: parseAttributes2 = parseAttributes,
    serializeAttributes: serializeAttributes2 = serializeAttributes,
    defaultAttributes: defaultAttributes2 = {},
    requiredAttributes = [],
    allowedAttributes
  } = options;
  const blockName = markdownName || nodeName;
  const filterAttributes = (attrs) => {
    if (!allowedAttributes) {
      return attrs;
    }
    const filtered = {};
    allowedAttributes.forEach((key) => {
      if (key in attrs) {
        filtered[key] = attrs[key];
      }
    });
    return filtered;
  };
  return {
    parseMarkdown: (token, h2) => {
      const attrs = { ...defaultAttributes2, ...token.attributes };
      return h2.createNode(nodeName, attrs, []);
    },
    markdownTokenizer: {
      name: nodeName,
      level: "block",
      start(src) {
        var _a;
        const regex = new RegExp(`^:::${blockName}(?:\\s|$)`, "m");
        const index2 = (_a = src.match(regex)) == null ? void 0 : _a.index;
        return index2 !== void 0 ? index2 : -1;
      },
      tokenize(src, _tokens, _lexer) {
        const regex = new RegExp(`^:::${blockName}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`);
        const match = src.match(regex);
        if (!match) {
          return void 0;
        }
        const attrString = match[1] || "";
        const attributes = parseAttributes2(attrString);
        const missingRequired = requiredAttributes.find((required) => !(required in attributes));
        if (missingRequired) {
          return void 0;
        }
        return {
          type: nodeName,
          raw: match[0],
          attributes
        };
      }
    },
    renderMarkdown: (node) => {
      const filteredAttrs = filterAttributes(node.attrs || {});
      const attrs = serializeAttributes2(filteredAttrs);
      const attrString = attrs ? ` {${attrs}}` : "";
      return `:::${blockName}${attrString} :::`;
    }
  };
}
function createBlockMarkdownSpec(options) {
  const {
    nodeName,
    name: markdownName,
    getContent,
    parseAttributes: parseAttributes2 = parseAttributes,
    serializeAttributes: serializeAttributes2 = serializeAttributes,
    defaultAttributes: defaultAttributes2 = {},
    content = "block",
    allowedAttributes
  } = options;
  const blockName = markdownName || nodeName;
  const filterAttributes = (attrs) => {
    if (!allowedAttributes) {
      return attrs;
    }
    const filtered = {};
    allowedAttributes.forEach((key) => {
      if (key in attrs) {
        filtered[key] = attrs[key];
      }
    });
    return filtered;
  };
  return {
    parseMarkdown: (token, h2) => {
      let nodeContent;
      if (getContent) {
        const contentResult = getContent(token);
        nodeContent = typeof contentResult === "string" ? [{ type: "text", text: contentResult }] : contentResult;
      } else if (content === "block") {
        nodeContent = h2.parseChildren(token.tokens || []);
      } else {
        nodeContent = h2.parseInline(token.tokens || []);
      }
      const attrs = { ...defaultAttributes2, ...token.attributes };
      return h2.createNode(nodeName, attrs, nodeContent);
    },
    markdownTokenizer: {
      name: nodeName,
      level: "block",
      start(src) {
        var _a;
        const regex = new RegExp(`^:::${blockName}`, "m");
        const index2 = (_a = src.match(regex)) == null ? void 0 : _a.index;
        return index2 !== void 0 ? index2 : -1;
      },
      tokenize(src, _tokens, lexer) {
        var _a;
        const openingRegex = new RegExp(`^:::${blockName}(?:\\s+\\{([^}]*)\\})?\\s*\\n`);
        const openingMatch = src.match(openingRegex);
        if (!openingMatch) {
          return void 0;
        }
        const [openingTag, attrString = ""] = openingMatch;
        const attributes = parseAttributes2(attrString);
        let level = 1;
        const position = openingTag.length;
        let matchedContent = "";
        const blockPattern = /^:::([\w-]*)(\s.*)?/gm;
        const remaining = src.slice(position);
        blockPattern.lastIndex = 0;
        for (; ; ) {
          const match = blockPattern.exec(remaining);
          if (match === null) {
            break;
          }
          const matchPos = match.index;
          const blockType = match[1];
          if ((_a = match[2]) == null ? void 0 : _a.endsWith(":::")) {
            continue;
          }
          if (blockType) {
            level += 1;
          } else {
            level -= 1;
            if (level === 0) {
              const rawContent = remaining.slice(0, matchPos);
              matchedContent = rawContent.trim();
              const fullMatch = src.slice(0, position + matchPos + match[0].length);
              let contentTokens = [];
              if (matchedContent) {
                if (content === "block") {
                  contentTokens = lexer.blockTokens(rawContent);
                  contentTokens.forEach((token) => {
                    if (token.text && (!token.tokens || token.tokens.length === 0)) {
                      token.tokens = lexer.inlineTokens(token.text);
                    }
                  });
                  while (contentTokens.length > 0) {
                    const lastToken = contentTokens[contentTokens.length - 1];
                    if (lastToken.type === "paragraph" && (!lastToken.text || lastToken.text.trim() === "")) {
                      contentTokens.pop();
                    } else {
                      break;
                    }
                  }
                } else {
                  contentTokens = lexer.inlineTokens(matchedContent);
                }
              }
              return {
                type: nodeName,
                raw: fullMatch,
                attributes,
                content: matchedContent,
                tokens: contentTokens
              };
            }
          }
        }
        return void 0;
      }
    },
    renderMarkdown: (node, h2) => {
      const filteredAttrs = filterAttributes(node.attrs || {});
      const attrs = serializeAttributes2(filteredAttrs);
      const attrString = attrs ? ` {${attrs}}` : "";
      const renderedContent = h2.renderChildren(node.content || [], "\n\n");
      return `:::${blockName}${attrString}

${renderedContent}

:::`;
    }
  };
}
function parseShortcodeAttributes(attrString) {
  if (!attrString.trim()) {
    return {};
  }
  const attributes = {};
  const regex = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let match = regex.exec(attrString);
  while (match !== null) {
    const [, key, doubleQuoted, singleQuoted] = match;
    attributes[key] = doubleQuoted || singleQuoted;
    match = regex.exec(attrString);
  }
  return attributes;
}
function serializeShortcodeAttributes(attrs) {
  return Object.entries(attrs).filter(([, value]) => value !== void 0 && value !== null).map(([key, value]) => `${key}="${value}"`).join(" ");
}
function createInlineMarkdownSpec(options) {
  const {
    nodeName,
    name: shortcodeName,
    getContent,
    parseAttributes: parseAttributes2 = parseShortcodeAttributes,
    serializeAttributes: serializeAttributes2 = serializeShortcodeAttributes,
    defaultAttributes: defaultAttributes2 = {},
    selfClosing = false,
    allowedAttributes
  } = options;
  const shortcode = shortcodeName || nodeName;
  const filterAttributes = (attrs) => {
    if (!allowedAttributes) {
      return attrs;
    }
    const filtered = {};
    allowedAttributes.forEach((attr) => {
      const attrName = typeof attr === "string" ? attr : attr.name;
      const skipIfDefault = typeof attr === "string" ? void 0 : attr.skipIfDefault;
      if (attrName in attrs) {
        const value = attrs[attrName];
        if (skipIfDefault !== void 0 && value === skipIfDefault) {
          return;
        }
        filtered[attrName] = value;
      }
    });
    return filtered;
  };
  const escapedShortcode = shortcode.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (token, h2) => {
      const attrs = { ...defaultAttributes2, ...token.attributes };
      if (selfClosing) {
        return h2.createNode(nodeName, attrs);
      }
      const content = getContent ? getContent(token) : token.content || "";
      if (content) {
        return h2.createNode(nodeName, attrs, [h2.createTextNode(content)]);
      }
      return h2.createNode(nodeName, attrs, []);
    },
    markdownTokenizer: {
      name: nodeName,
      level: "inline",
      start(src) {
        const startPattern = selfClosing ? new RegExp(`\\[${escapedShortcode}\\s*[^\\]]*\\]`) : new RegExp(`\\[${escapedShortcode}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${escapedShortcode}\\]`);
        const match = src.match(startPattern);
        const index2 = match == null ? void 0 : match.index;
        return index2 !== void 0 ? index2 : -1;
      },
      tokenize(src, _tokens, _lexer) {
        const tokenPattern = selfClosing ? new RegExp(`^\\[${escapedShortcode}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${escapedShortcode}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${escapedShortcode}\\]`);
        const match = src.match(tokenPattern);
        if (!match) {
          return void 0;
        }
        let content = "";
        let attrString = "";
        if (selfClosing) {
          const [, attrs] = match;
          attrString = attrs;
        } else {
          const [, attrs, contentMatch] = match;
          attrString = attrs;
          content = contentMatch || "";
        }
        const attributes = parseAttributes2(attrString.trim());
        return {
          type: nodeName,
          raw: match[0],
          content: content.trim(),
          attributes
        };
      }
    },
    renderMarkdown: (node) => {
      let content = "";
      if (getContent) {
        content = getContent(node);
      } else if (node.content && node.content.length > 0) {
        content = node.content.filter((child) => child.type === "text").map((child) => child.text).join("");
      }
      const filteredAttrs = filterAttributes(node.attrs || {});
      const attrs = serializeAttributes2(filteredAttrs);
      const attrString = attrs ? ` ${attrs}` : "";
      if (selfClosing) {
        return `[${shortcode}${attrString}]`;
      }
      return `[${shortcode}${attrString}]${content}[/${shortcode}]`;
    }
  };
}
function parseIndentedBlocks(src, config, lexer) {
  var _a, _b, _c, _d;
  const lines = src.split("\n");
  const items = [];
  let totalRaw = "";
  let i = 0;
  const baseIndentSize = config.baseIndentSize || 2;
  while (i < lines.length) {
    const currentLine = lines[i];
    const itemMatch = currentLine.match(config.itemPattern);
    if (!itemMatch) {
      if (items.length > 0) {
        break;
      } else if (currentLine.trim() === "") {
        i += 1;
        totalRaw = `${totalRaw}${currentLine}
`;
        continue;
      } else {
        return void 0;
      }
    }
    const itemData = config.extractItemData(itemMatch);
    const { indentLevel, mainContent } = itemData;
    totalRaw = `${totalRaw}${currentLine}
`;
    const itemContent = [mainContent];
    i += 1;
    while (i < lines.length) {
      const nextLine = lines[i];
      if (nextLine.trim() === "") {
        const nextNonEmptyIndex = lines.slice(i + 1).findIndex((l) => l.trim() !== "");
        if (nextNonEmptyIndex === -1) {
          break;
        }
        const nextNonEmpty = lines[i + 1 + nextNonEmptyIndex];
        const nextIndent2 = ((_b = (_a = nextNonEmpty.match(/^(\s*)/)) == null ? void 0 : _a[1]) == null ? void 0 : _b.length) || 0;
        if (nextIndent2 > indentLevel) {
          itemContent.push(nextLine);
          totalRaw = `${totalRaw}${nextLine}
`;
          i += 1;
          continue;
        } else {
          break;
        }
      }
      const nextIndent = ((_d = (_c = nextLine.match(/^(\s*)/)) == null ? void 0 : _c[1]) == null ? void 0 : _d.length) || 0;
      if (nextIndent > indentLevel) {
        itemContent.push(nextLine);
        totalRaw = `${totalRaw}${nextLine}
`;
        i += 1;
      } else {
        break;
      }
    }
    let nestedTokens;
    const nestedContent = itemContent.slice(1);
    if (nestedContent.length > 0) {
      const dedentedNested = nestedContent.map((nestedLine) => nestedLine.slice(indentLevel + baseIndentSize)).join("\n");
      if (dedentedNested.trim()) {
        if (config.customNestedParser) {
          nestedTokens = config.customNestedParser(dedentedNested);
        } else {
          nestedTokens = lexer.blockTokens(dedentedNested);
        }
      }
    }
    const token = config.createToken(itemData, nestedTokens);
    items.push(token);
  }
  if (items.length === 0) {
    return void 0;
  }
  return {
    items,
    raw: totalRaw
  };
}
function renderNestedMarkdownContent(node, h2, prefixOrGenerator, ctx) {
  if (!node || !Array.isArray(node.content)) {
    return "";
  }
  const prefix = typeof prefixOrGenerator === "function" ? prefixOrGenerator(ctx) : prefixOrGenerator;
  const [content, ...children] = node.content;
  const mainContent = h2.renderChildren([content]);
  const output = [`${prefix}${mainContent}`];
  if (children && children.length > 0) {
    children.forEach((child) => {
      const childContent = h2.renderChildren([child]);
      if (childContent) {
        const indentedChild = childContent.split("\n").map((line) => line ? h2.indent(line) : "").join("\n");
        output.push(indentedChild);
      }
    });
  }
  return output.join("\n");
}
function updateMarkViewAttributes(checkMark, editor, attrs = {}) {
  const { state } = editor;
  const { doc: doc3, tr: tr2 } = state;
  const thisMark = checkMark;
  doc3.descendants((node, pos) => {
    const from2 = tr2.mapping.map(pos);
    const to = tr2.mapping.map(pos) + node.nodeSize;
    let foundMark = null;
    node.marks.forEach((mark) => {
      if (mark !== thisMark) {
        return false;
      }
      foundMark = mark;
    });
    if (!foundMark) {
      return;
    }
    let needsUpdate = false;
    Object.keys(attrs).forEach((k) => {
      if (attrs[k] !== foundMark.attrs[k]) {
        needsUpdate = true;
      }
    });
    if (needsUpdate) {
      const updatedMark = checkMark.type.create({
        ...checkMark.attrs,
        ...attrs
      });
      tr2.removeMark(from2, to, checkMark.type);
      tr2.addMark(from2, to, updatedMark);
    }
  });
  if (tr2.docChanged) {
    editor.view.dispatch(tr2);
  }
}
var Node3 = class _Node extends Extendable {
  constructor() {
    super(...arguments);
    this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(config = {}) {
    const resolvedConfig = typeof config === "function" ? config() : config;
    return new _Node(resolvedConfig);
  }
  configure(options) {
    return super.configure(options);
  }
  extend(extendedConfig) {
    const resolvedConfig = typeof extendedConfig === "function" ? extendedConfig() : extendedConfig;
    return super.extend(resolvedConfig);
  }
};
var NodeView = class {
  constructor(component, props, options) {
    this.isDragging = false;
    this.component = component;
    this.editor = props.editor;
    this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...options
    };
    this.extension = props.extension;
    this.node = props.node;
    this.decorations = props.decorations;
    this.innerDecorations = props.innerDecorations;
    this.view = props.view;
    this.HTMLAttributes = props.HTMLAttributes;
    this.getPos = props.getPos;
    this.mount();
  }
  mount() {
    return;
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(event) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { view } = this.editor;
    const target = event.target;
    const dragHandle = target.nodeType === 3 ? (_a = target.parentElement) == null ? void 0 : _a.closest("[data-drag-handle]") : target.closest("[data-drag-handle]");
    if (!this.dom || ((_b = this.contentDOM) == null ? void 0 : _b.contains(target)) || !dragHandle) {
      return;
    }
    let x = 0;
    let y = 0;
    if (this.dom !== dragHandle) {
      const domBox = this.dom.getBoundingClientRect();
      const handleBox = dragHandle.getBoundingClientRect();
      const offsetX = (_d = event.offsetX) != null ? _d : (_c = event.nativeEvent) == null ? void 0 : _c.offsetX;
      const offsetY = (_f = event.offsetY) != null ? _f : (_e = event.nativeEvent) == null ? void 0 : _e.offsetY;
      x = handleBox.x - domBox.x + offsetX;
      y = handleBox.y - domBox.y + offsetY;
    }
    const clonedNode = this.dom.cloneNode(true);
    try {
      const domBox = this.dom.getBoundingClientRect();
      clonedNode.style.width = `${Math.round(domBox.width)}px`;
      clonedNode.style.height = `${Math.round(domBox.height)}px`;
      clonedNode.style.boxSizing = "border-box";
      clonedNode.style.pointerEvents = "none";
    } catch {
    }
    let dragImageWrapper = null;
    try {
      dragImageWrapper = document.createElement("div");
      dragImageWrapper.style.position = "absolute";
      dragImageWrapper.style.top = "-9999px";
      dragImageWrapper.style.left = "-9999px";
      dragImageWrapper.style.pointerEvents = "none";
      dragImageWrapper.appendChild(clonedNode);
      document.body.appendChild(dragImageWrapper);
      (_g = event.dataTransfer) == null ? void 0 : _g.setDragImage(clonedNode, x, y);
    } finally {
      if (dragImageWrapper) {
        setTimeout(() => {
          try {
            dragImageWrapper == null ? void 0 : dragImageWrapper.remove();
          } catch {
          }
        }, 0);
      }
    }
    const pos = this.getPos();
    if (typeof pos !== "number") {
      return;
    }
    const selection = NodeSelection.create(view.state.doc, pos);
    const transaction = view.state.tr.setSelection(selection);
    view.dispatch(transaction);
  }
  stopEvent(event) {
    var _a;
    if (!this.dom) {
      return false;
    }
    if (typeof this.options.stopEvent === "function") {
      return this.options.stopEvent({ event });
    }
    const target = event.target;
    const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) == null ? void 0 : _a.contains(target));
    if (!isInElement) {
      return false;
    }
    const isDragEvent = event.type.startsWith("drag");
    const isDropEvent = event.type === "drop";
    const isInput = ["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(target.tagName) || target.isContentEditable;
    if (isInput && !isDropEvent && !isDragEvent) {
      return true;
    }
    const { isEditable } = this.editor;
    const { isDragging } = this;
    const isDraggable = !!this.node.type.spec.draggable;
    const isSelectable = NodeSelection.isSelectable(this.node);
    const isCopyEvent = event.type === "copy";
    const isPasteEvent = event.type === "paste";
    const isCutEvent = event.type === "cut";
    const isClickEvent = event.type === "mousedown";
    if (!isDraggable && isSelectable && isDragEvent && event.target === this.dom) {
      event.preventDefault();
    }
    if (isDraggable && isDragEvent && !isDragging && event.target === this.dom) {
      event.preventDefault();
      return false;
    }
    if (isDraggable && isEditable && !isDragging && isClickEvent) {
      const dragHandle = target.closest("[data-drag-handle]");
      const isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));
      if (isValidDragHandle) {
        this.isDragging = true;
        document.addEventListener(
          "dragend",
          () => {
            this.isDragging = false;
          },
          { once: true }
        );
        document.addEventListener(
          "drop",
          () => {
            this.isDragging = false;
          },
          { once: true }
        );
        document.addEventListener(
          "mouseup",
          () => {
            this.isDragging = false;
          },
          { once: true }
        );
      }
    }
    if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) {
      return false;
    }
    return true;
  }
  /**
   * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
   * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
   * @return `true` if it can safely be ignored.
   */
  ignoreMutation(mutation) {
    if (!this.dom || !this.contentDOM) {
      return true;
    }
    if (typeof this.options.ignoreMutation === "function") {
      return this.options.ignoreMutation({ mutation });
    }
    if (this.node.isLeaf || this.node.isAtom) {
      return true;
    }
    if (mutation.type === "selection") {
      return false;
    }
    if (this.dom.contains(mutation.target) && mutation.type === "childList" && (isiOS() || isAndroid()) && this.editor.isFocused) {
      const changedNodes = [...Array.from(mutation.addedNodes), ...Array.from(mutation.removedNodes)];
      if (changedNodes.every((node) => node.isContentEditable)) {
        return false;
      }
    }
    if (this.contentDOM === mutation.target && mutation.type === "attributes") {
      return true;
    }
    if (this.contentDOM.contains(mutation.target)) {
      return false;
    }
    return true;
  }
  /**
   * Update the attributes of the prosemirror node.
   */
  updateAttributes(attributes) {
    this.editor.commands.command(({ tr: tr2 }) => {
      const pos = this.getPos();
      if (typeof pos !== "number") {
        return false;
      }
      tr2.setNodeMarkup(pos, void 0, {
        ...this.node.attrs,
        ...attributes
      });
      return true;
    });
  }
  /**
   * Delete the node.
   */
  deleteNode() {
    const from2 = this.getPos();
    if (typeof from2 !== "number") {
      return;
    }
    const to = from2 + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: from2, to });
  }
};
function markPasteRule(config) {
  return new PasteRule({
    find: config.find,
    handler: ({ state, range, match, pasteEvent }) => {
      const attributes = callOrReturn(config.getAttributes, void 0, match, pasteEvent);
      if (attributes === false || attributes === null) {
        return null;
      }
      const { tr: tr2 } = state;
      const captureGroup = match[match.length - 1];
      const fullMatch = match[0];
      let markEnd = range.to;
      if (captureGroup) {
        const startSpaces = fullMatch.search(/\S/);
        const textStart = range.from + fullMatch.indexOf(captureGroup);
        const textEnd = textStart + captureGroup.length;
        const excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter((item) => {
          const excluded = item.mark.type.excluded;
          return excluded.find((type) => type === config.type && type !== item.mark.type);
        }).filter((item) => item.to > textStart);
        if (excludedMarks.length) {
          return null;
        }
        if (textEnd < range.to) {
          tr2.delete(textEnd, range.to);
        }
        if (textStart > range.from) {
          tr2.delete(range.from + startSpaces, textStart);
        }
        markEnd = range.from + startSpaces + captureGroup.length;
        tr2.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
        tr2.removeStoredMark(config.type);
      }
    }
  });
}

// ../../node_modules/.pnpm/fast-equals@5.4.0/node_modules/fast-equals/dist/es/index.mjs
var { getOwnPropertyNames, getOwnPropertySymbols } = Object;
var { hasOwnProperty } = Object.prototype;
function combineComparators(comparatorA, comparatorB) {
  return function isEqual(a, b, state) {
    return comparatorA(a, b, state) && comparatorB(a, b, state);
  };
}
function createIsCircular(areItemsEqual) {
  return function isCircular(a, b, state) {
    if (!a || !b || typeof a !== "object" || typeof b !== "object") {
      return areItemsEqual(a, b, state);
    }
    const { cache } = state;
    const cachedA = cache.get(a);
    const cachedB = cache.get(b);
    if (cachedA && cachedB) {
      return cachedA === b && cachedB === a;
    }
    cache.set(a, b);
    cache.set(b, a);
    const result = areItemsEqual(a, b, state);
    cache.delete(a);
    cache.delete(b);
    return result;
  };
}
function getShortTag(value) {
  return value != null ? value[Symbol.toStringTag] : void 0;
}
function getStrictProperties(object) {
  return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
}
var hasOwn = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((object, property) => hasOwnProperty.call(object, property))
);
function sameValueZeroEqual(a, b) {
  return a === b || !a && !b && a !== a && b !== b;
}
var PREACT_VNODE = "__v";
var PREACT_OWNER = "__o";
var REACT_OWNER = "_owner";
var { getOwnPropertyDescriptor, keys: keys2 } = Object;
function areArrayBuffersEqual(a, b) {
  return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
}
function areArraysEqual(a, b, state) {
  let index2 = a.length;
  if (b.length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (!state.equals(a[index2], b[index2], index2, index2, a, b, state)) {
      return false;
    }
  }
  return true;
}
function areDataViewsEqual(a, b) {
  return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
}
function areDatesEqual(a, b) {
  return sameValueZeroEqual(a.getTime(), b.getTime());
}
function areErrorsEqual(a, b) {
  return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
}
function areFunctionsEqual(a, b) {
  return a === b;
}
function areMapsEqual(a, b, state) {
  const size4 = a.size;
  if (size4 !== b.size) {
    return false;
  }
  if (!size4) {
    return true;
  }
  const matchedIndices = new Array(size4);
  const aIterable = a.entries();
  let aResult;
  let bResult;
  let index2 = 0;
  while (aResult = aIterable.next()) {
    if (aResult.done) {
      break;
    }
    const bIterable = b.entries();
    let hasMatch = false;
    let matchIndex = 0;
    while (bResult = bIterable.next()) {
      if (bResult.done) {
        break;
      }
      if (matchedIndices[matchIndex]) {
        matchIndex++;
        continue;
      }
      const aEntry = aResult.value;
      const bEntry = bResult.value;
      if (state.equals(aEntry[0], bEntry[0], index2, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
        hasMatch = matchedIndices[matchIndex] = true;
        break;
      }
      matchIndex++;
    }
    if (!hasMatch) {
      return false;
    }
    index2++;
  }
  return true;
}
var areNumbersEqual = sameValueZeroEqual;
function areObjectsEqual(a, b, state) {
  const properties = keys2(a);
  let index2 = properties.length;
  if (keys2(b).length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (!isPropertyEqual(a, b, state, properties[index2])) {
      return false;
    }
  }
  return true;
}
function areObjectsEqualStrict(a, b, state) {
  const properties = getStrictProperties(a);
  let index2 = properties.length;
  if (getStrictProperties(b).length !== index2) {
    return false;
  }
  let property;
  let descriptorA;
  let descriptorB;
  while (index2-- > 0) {
    property = properties[index2];
    if (!isPropertyEqual(a, b, state, property)) {
      return false;
    }
    descriptorA = getOwnPropertyDescriptor(a, property);
    descriptorB = getOwnPropertyDescriptor(b, property);
    if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) {
      return false;
    }
  }
  return true;
}
function arePrimitiveWrappersEqual(a, b) {
  return sameValueZeroEqual(a.valueOf(), b.valueOf());
}
function areRegExpsEqual(a, b) {
  return a.source === b.source && a.flags === b.flags;
}
function areSetsEqual(a, b, state) {
  const size4 = a.size;
  if (size4 !== b.size) {
    return false;
  }
  if (!size4) {
    return true;
  }
  const matchedIndices = new Array(size4);
  const aIterable = a.values();
  let aResult;
  let bResult;
  while (aResult = aIterable.next()) {
    if (aResult.done) {
      break;
    }
    const bIterable = b.values();
    let hasMatch = false;
    let matchIndex = 0;
    while (bResult = bIterable.next()) {
      if (bResult.done) {
        break;
      }
      if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
        hasMatch = matchedIndices[matchIndex] = true;
        break;
      }
      matchIndex++;
    }
    if (!hasMatch) {
      return false;
    }
  }
  return true;
}
function areTypedArraysEqual(a, b) {
  let index2 = a.byteLength;
  if (b.byteLength !== index2 || a.byteOffset !== b.byteOffset) {
    return false;
  }
  while (index2-- > 0) {
    if (a[index2] !== b[index2]) {
      return false;
    }
  }
  return true;
}
function areUrlsEqual(a, b) {
  return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
}
function isPropertyEqual(a, b, state, property) {
  if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) {
    return true;
  }
  return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
}
var ARRAY_BUFFER_TAG = "[object ArrayBuffer]";
var ARGUMENTS_TAG = "[object Arguments]";
var BOOLEAN_TAG = "[object Boolean]";
var DATA_VIEW_TAG = "[object DataView]";
var DATE_TAG = "[object Date]";
var ERROR_TAG = "[object Error]";
var MAP_TAG = "[object Map]";
var NUMBER_TAG = "[object Number]";
var OBJECT_TAG = "[object Object]";
var REG_EXP_TAG = "[object RegExp]";
var SET_TAG = "[object Set]";
var STRING_TAG = "[object String]";
var TYPED_ARRAY_TAGS = {
  "[object Int8Array]": true,
  "[object Uint8Array]": true,
  "[object Uint8ClampedArray]": true,
  "[object Int16Array]": true,
  "[object Uint16Array]": true,
  "[object Int32Array]": true,
  "[object Uint32Array]": true,
  "[object Float16Array]": true,
  "[object Float32Array]": true,
  "[object Float64Array]": true,
  "[object BigInt64Array]": true,
  "[object BigUint64Array]": true
};
var URL_TAG = "[object URL]";
var toString = Object.prototype.toString;
function createEqualityComparator({ areArrayBuffersEqual: areArrayBuffersEqual2, areArraysEqual: areArraysEqual2, areDataViewsEqual: areDataViewsEqual2, areDatesEqual: areDatesEqual2, areErrorsEqual: areErrorsEqual2, areFunctionsEqual: areFunctionsEqual2, areMapsEqual: areMapsEqual2, areNumbersEqual: areNumbersEqual2, areObjectsEqual: areObjectsEqual2, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual2, areRegExpsEqual: areRegExpsEqual2, areSetsEqual: areSetsEqual2, areTypedArraysEqual: areTypedArraysEqual2, areUrlsEqual: areUrlsEqual2, unknownTagComparators }) {
  return function comparator(a, b, state) {
    if (a === b) {
      return true;
    }
    if (a == null || b == null) {
      return false;
    }
    const type = typeof a;
    if (type !== typeof b) {
      return false;
    }
    if (type !== "object") {
      if (type === "number") {
        return areNumbersEqual2(a, b, state);
      }
      if (type === "function") {
        return areFunctionsEqual2(a, b, state);
      }
      return false;
    }
    const constructor = a.constructor;
    if (constructor !== b.constructor) {
      return false;
    }
    if (constructor === Object) {
      return areObjectsEqual2(a, b, state);
    }
    if (Array.isArray(a)) {
      return areArraysEqual2(a, b, state);
    }
    if (constructor === Date) {
      return areDatesEqual2(a, b, state);
    }
    if (constructor === RegExp) {
      return areRegExpsEqual2(a, b, state);
    }
    if (constructor === Map) {
      return areMapsEqual2(a, b, state);
    }
    if (constructor === Set) {
      return areSetsEqual2(a, b, state);
    }
    const tag = toString.call(a);
    if (tag === DATE_TAG) {
      return areDatesEqual2(a, b, state);
    }
    if (tag === REG_EXP_TAG) {
      return areRegExpsEqual2(a, b, state);
    }
    if (tag === MAP_TAG) {
      return areMapsEqual2(a, b, state);
    }
    if (tag === SET_TAG) {
      return areSetsEqual2(a, b, state);
    }
    if (tag === OBJECT_TAG) {
      return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual2(a, b, state);
    }
    if (tag === URL_TAG) {
      return areUrlsEqual2(a, b, state);
    }
    if (tag === ERROR_TAG) {
      return areErrorsEqual2(a, b, state);
    }
    if (tag === ARGUMENTS_TAG) {
      return areObjectsEqual2(a, b, state);
    }
    if (TYPED_ARRAY_TAGS[tag]) {
      return areTypedArraysEqual2(a, b, state);
    }
    if (tag === ARRAY_BUFFER_TAG) {
      return areArrayBuffersEqual2(a, b, state);
    }
    if (tag === DATA_VIEW_TAG) {
      return areDataViewsEqual2(a, b, state);
    }
    if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) {
      return arePrimitiveWrappersEqual2(a, b, state);
    }
    if (unknownTagComparators) {
      let unknownTagComparator = unknownTagComparators[tag];
      if (!unknownTagComparator) {
        const shortTag = getShortTag(a);
        if (shortTag) {
          unknownTagComparator = unknownTagComparators[shortTag];
        }
      }
      if (unknownTagComparator) {
        return unknownTagComparator(a, b, state);
      }
    }
    return false;
  };
}
function createEqualityComparatorConfig({ circular, createCustomConfig, strict }) {
  let config = {
    areArrayBuffersEqual,
    areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
    areDataViewsEqual,
    areDatesEqual,
    areErrorsEqual,
    areFunctionsEqual,
    areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
    areNumbersEqual,
    areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
    arePrimitiveWrappersEqual,
    areRegExpsEqual,
    areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
    areTypedArraysEqual: strict ? combineComparators(areTypedArraysEqual, areObjectsEqualStrict) : areTypedArraysEqual,
    areUrlsEqual,
    unknownTagComparators: void 0
  };
  if (createCustomConfig) {
    config = Object.assign({}, config, createCustomConfig(config));
  }
  if (circular) {
    const areArraysEqual2 = createIsCircular(config.areArraysEqual);
    const areMapsEqual2 = createIsCircular(config.areMapsEqual);
    const areObjectsEqual2 = createIsCircular(config.areObjectsEqual);
    const areSetsEqual2 = createIsCircular(config.areSetsEqual);
    config = Object.assign({}, config, {
      areArraysEqual: areArraysEqual2,
      areMapsEqual: areMapsEqual2,
      areObjectsEqual: areObjectsEqual2,
      areSetsEqual: areSetsEqual2
    });
  }
  return config;
}
function createInternalEqualityComparator(compare) {
  return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
    return compare(a, b, state);
  };
}
function createIsEqual({ circular, comparator, createState, equals, strict }) {
  if (createState) {
    return function isEqual(a, b) {
      const { cache = circular ? /* @__PURE__ */ new WeakMap() : void 0, meta } = createState();
      return comparator(a, b, {
        cache,
        equals,
        meta,
        strict
      });
    };
  }
  if (circular) {
    return function isEqual(a, b) {
      return comparator(a, b, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals,
        meta: void 0,
        strict
      });
    };
  }
  const state = {
    cache: void 0,
    equals,
    meta: void 0,
    strict
  };
  return function isEqual(a, b) {
    return comparator(a, b, state);
  };
}
var deepEqual = createCustomEqual();
createCustomEqual({ strict: true });
createCustomEqual({ circular: true });
createCustomEqual({
  circular: true,
  strict: true
});
createCustomEqual({
  createInternalComparator: () => sameValueZeroEqual
});
createCustomEqual({
  strict: true,
  createInternalComparator: () => sameValueZeroEqual
});
createCustomEqual({
  circular: true,
  createInternalComparator: () => sameValueZeroEqual
});
createCustomEqual({
  circular: true,
  createInternalComparator: () => sameValueZeroEqual,
  strict: true
});
function createCustomEqual(options = {}) {
  const { circular = false, createInternalComparator: createCustomInternalComparator, createState, strict = false } = options;
  const config = createEqualityComparatorConfig(options);
  const comparator = createEqualityComparator(config);
  const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
  return createIsEqual({ circular, comparator, createState, equals, strict });
}
var mergeRefs = (...refs) => {
  return (node) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
};
var Portals = ({ contentComponent }) => {
  const renderers = useSyncExternalStore(
    contentComponent.subscribe,
    contentComponent.getSnapshot,
    contentComponent.getServerSnapshot
  );
  return /* @__PURE__ */ jsx(Fragment, { children: Object.values(renderers) });
};
function getInstance() {
  const subscribers = /* @__PURE__ */ new Set();
  let renderers = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(callback) {
      subscribers.add(callback);
      return () => {
        subscribers.delete(callback);
      };
    },
    getSnapshot() {
      return renderers;
    },
    getServerSnapshot() {
      return renderers;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(id, renderer) {
      renderers = {
        ...renderers,
        [id]: ReactDOM6__default.createPortal(renderer.reactElement, renderer.element, id)
      };
      subscribers.forEach((subscriber) => subscriber());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(id) {
      const nextRenderers = { ...renderers };
      delete nextRenderers[id];
      renderers = nextRenderers;
      subscribers.forEach((subscriber) => subscriber());
    }
  };
}
var PureEditorContent = class extends React49__default.Component {
  constructor(props) {
    var _a;
    super(props);
    this.editorContentRef = React49__default.createRef();
    this.initialized = false;
    this.state = {
      hasContentComponentInitialized: Boolean((_a = props.editor) == null ? void 0 : _a.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    var _a;
    const editor = this.props.editor;
    if (editor && !editor.isDestroyed && ((_a = editor.view.dom) == null ? void 0 : _a.parentNode)) {
      if (editor.contentComponent) {
        return;
      }
      const element = this.editorContentRef.current;
      element.append(...editor.view.dom.parentNode.childNodes);
      editor.setOptions({
        element
      });
      editor.contentComponent = getInstance();
      if (!this.state.hasContentComponentInitialized) {
        this.unsubscribeToContentComponent = editor.contentComponent.subscribe(() => {
          this.setState((prevState) => {
            if (!prevState.hasContentComponentInitialized) {
              return {
                hasContentComponentInitialized: true
              };
            }
            return prevState;
          });
          if (this.unsubscribeToContentComponent) {
            this.unsubscribeToContentComponent();
          }
        });
      }
      editor.createNodeViews();
      this.initialized = true;
    }
  }
  componentWillUnmount() {
    var _a;
    const editor = this.props.editor;
    if (!editor) {
      return;
    }
    this.initialized = false;
    if (!editor.isDestroyed) {
      editor.view.setProps({
        nodeViews: {}
      });
    }
    if (this.unsubscribeToContentComponent) {
      this.unsubscribeToContentComponent();
    }
    editor.contentComponent = null;
    try {
      if (!((_a = editor.view.dom) == null ? void 0 : _a.parentNode)) {
        return;
      }
      const newElement = document.createElement("div");
      newElement.append(...editor.view.dom.parentNode.childNodes);
      editor.setOptions({
        element: newElement
      });
    } catch {
    }
  }
  render() {
    const { editor, innerRef, ...rest } = this.props;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { ref: mergeRefs(innerRef, this.editorContentRef), ...rest }),
      (editor == null ? void 0 : editor.contentComponent) && /* @__PURE__ */ jsx(Portals, { contentComponent: editor.contentComponent })
    ] });
  }
};
var EditorContentWithKey = forwardRef(
  (props, ref) => {
    const key = React49__default.useMemo(() => {
      return Math.floor(Math.random() * 4294967295).toString();
    }, [props.editor]);
    return React49__default.createElement(PureEditorContent, {
      key,
      innerRef: ref,
      ...props
    });
  }
);
var EditorContent = React49__default.memo(EditorContentWithKey);
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
var EditorStateManager = class {
  constructor(initialEditor) {
    this.transactionNumber = 0;
    this.lastTransactionNumber = 0;
    this.subscribers = /* @__PURE__ */ new Set();
    this.editor = initialEditor;
    this.lastSnapshot = { editor: initialEditor, transactionNumber: 0 };
    this.getSnapshot = this.getSnapshot.bind(this);
    this.getServerSnapshot = this.getServerSnapshot.bind(this);
    this.watch = this.watch.bind(this);
    this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    if (this.transactionNumber === this.lastTransactionNumber) {
      return this.lastSnapshot;
    }
    this.lastTransactionNumber = this.transactionNumber;
    this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber };
    return this.lastSnapshot;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(callback) {
    this.subscribers.add(callback);
    return () => {
      this.subscribers.delete(callback);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(nextEditor) {
    this.editor = nextEditor;
    if (this.editor) {
      const fn2 = () => {
        this.transactionNumber += 1;
        this.subscribers.forEach((callback) => callback());
      };
      const currentEditor = this.editor;
      currentEditor.on("transaction", fn2);
      return () => {
        currentEditor.off("transaction", fn2);
      };
    }
    return void 0;
  }
};
function useEditorState(options) {
  var _a;
  const [editorStateManager] = useState(() => new EditorStateManager(options.editor));
  const selectedState = useSyncExternalStoreWithSelector(
    editorStateManager.subscribe,
    editorStateManager.getSnapshot,
    editorStateManager.getServerSnapshot,
    options.selector,
    (_a = options.equalityFn) != null ? _a : deepEqual
  );
  useIsomorphicLayoutEffect(() => {
    return editorStateManager.watch(options.editor);
  }, [options.editor, editorStateManager]);
  useDebugValue(selectedState);
  return selectedState;
}
var isDev = process.env.NODE_ENV !== "production";
var isSSR = typeof window === "undefined";
var isNext = isSSR || Boolean(typeof window !== "undefined" && window.next);
var EditorInstanceManager = class _EditorInstanceManager {
  constructor(options) {
    this.editor = null;
    this.subscriptions = /* @__PURE__ */ new Set();
    this.isComponentMounted = false;
    this.previousDeps = null;
    this.instanceId = "";
    this.options = options;
    this.subscriptions = /* @__PURE__ */ new Set();
    this.setEditor(this.getInitialEditor());
    this.scheduleDestroy();
    this.getEditor = this.getEditor.bind(this);
    this.getServerSnapshot = this.getServerSnapshot.bind(this);
    this.subscribe = this.subscribe.bind(this);
    this.refreshEditorInstance = this.refreshEditorInstance.bind(this);
    this.scheduleDestroy = this.scheduleDestroy.bind(this);
    this.onRender = this.onRender.bind(this);
    this.createEditor = this.createEditor.bind(this);
  }
  setEditor(editor) {
    this.editor = editor;
    this.instanceId = Math.random().toString(36).slice(2, 9);
    this.subscriptions.forEach((cb) => cb());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0) {
      if (isSSR || isNext) {
        if (isDev) {
          throw new Error(
            "Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."
          );
        }
        return null;
      }
      return this.createEditor();
    }
    if (this.options.current.immediatelyRender && isSSR && isDev) {
      throw new Error(
        "Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches."
      );
    }
    if (this.options.current.immediatelyRender) {
      return this.createEditor();
    }
    return null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const optionsToApply = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onBeforeCreate) == null ? void 0 : _b.call(_a, ...args);
      },
      onBlur: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onBlur) == null ? void 0 : _b.call(_a, ...args);
      },
      onCreate: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onCreate) == null ? void 0 : _b.call(_a, ...args);
      },
      onDestroy: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onDestroy) == null ? void 0 : _b.call(_a, ...args);
      },
      onFocus: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onFocus) == null ? void 0 : _b.call(_a, ...args);
      },
      onSelectionUpdate: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onSelectionUpdate) == null ? void 0 : _b.call(_a, ...args);
      },
      onTransaction: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onTransaction) == null ? void 0 : _b.call(_a, ...args);
      },
      onUpdate: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onUpdate) == null ? void 0 : _b.call(_a, ...args);
      },
      onContentError: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onContentError) == null ? void 0 : _b.call(_a, ...args);
      },
      onDrop: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onDrop) == null ? void 0 : _b.call(_a, ...args);
      },
      onPaste: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onPaste) == null ? void 0 : _b.call(_a, ...args);
      },
      onDelete: (...args) => {
        var _a, _b;
        return (_b = (_a = this.options.current).onDelete) == null ? void 0 : _b.call(_a, ...args);
      }
    };
    const editor = new Editor(optionsToApply);
    return editor;
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(onStoreChange) {
    this.subscriptions.add(onStoreChange);
    return () => {
      this.subscriptions.delete(onStoreChange);
    };
  }
  static compareOptions(a, b) {
    return Object.keys(a).every((key) => {
      if ([
        "onCreate",
        "onBeforeCreate",
        "onDestroy",
        "onUpdate",
        "onTransaction",
        "onFocus",
        "onBlur",
        "onSelectionUpdate",
        "onContentError",
        "onDrop",
        "onPaste"
      ].includes(key)) {
        return true;
      }
      if (key === "extensions" && a.extensions && b.extensions) {
        if (a.extensions.length !== b.extensions.length) {
          return false;
        }
        return a.extensions.every((extension, index2) => {
          var _a;
          if (extension !== ((_a = b.extensions) == null ? void 0 : _a[index2])) {
            return false;
          }
          return true;
        });
      }
      if (a[key] !== b[key]) {
        return false;
      }
      return true;
    });
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(deps) {
    return () => {
      this.isComponentMounted = true;
      clearTimeout(this.scheduledDestructionTimeout);
      if (this.editor && !this.editor.isDestroyed && deps.length === 0) {
        if (!_EditorInstanceManager.compareOptions(this.options.current, this.editor.options)) {
          this.editor.setOptions({
            ...this.options.current,
            editable: this.editor.isEditable
          });
        }
      } else {
        this.refreshEditorInstance(deps);
      }
      return () => {
        this.isComponentMounted = false;
        this.scheduleDestroy();
      };
    };
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(deps) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = deps;
        return;
      }
      const depsAreEqual = this.previousDeps.length === deps.length && this.previousDeps.every((dep, index2) => dep === deps[index2]);
      if (depsAreEqual) {
        return;
      }
    }
    if (this.editor && !this.editor.isDestroyed) {
      this.editor.destroy();
    }
    this.setEditor(this.createEditor());
    this.previousDeps = deps;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const currentInstanceId = this.instanceId;
    const currentEditor = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === currentInstanceId) {
        if (currentEditor) {
          currentEditor.setOptions(this.options.current);
        }
        return;
      }
      if (currentEditor && !currentEditor.isDestroyed) {
        currentEditor.destroy();
        if (this.instanceId === currentInstanceId) {
          this.setEditor(null);
        }
      }
    }, 1);
  }
};
function useEditor(options = {}, deps = []) {
  const mostRecentOptions = useRef(options);
  mostRecentOptions.current = options;
  const [instanceManager] = useState(() => new EditorInstanceManager(mostRecentOptions));
  const editor = useSyncExternalStore(
    instanceManager.subscribe,
    instanceManager.getEditor,
    instanceManager.getServerSnapshot
  );
  useDebugValue(editor);
  useEffect(instanceManager.onRender(deps));
  useEditorState({
    editor,
    selector: ({ transactionNumber }) => {
      if (options.shouldRerenderOnTransaction === false || options.shouldRerenderOnTransaction === void 0) {
        return null;
      }
      if (options.immediatelyRender && transactionNumber === 0) {
        return 0;
      }
      return transactionNumber + 1;
    }
  });
  return editor;
}
var EditorContext = createContext({
  editor: null
});
EditorContext.Consumer;
var ReactNodeViewContext = createContext({
  onDragStart: () => {
  },
  nodeViewContentChildren: void 0,
  nodeViewContentRef: () => {
  }
});
var useReactNodeView = () => useContext(ReactNodeViewContext);
var NodeViewWrapper = React49__default.forwardRef((props, ref) => {
  const { onDragStart } = useReactNodeView();
  const Tag = props.as || "div";
  return (
    // @ts-ignore
    /* @__PURE__ */ jsx(
      Tag,
      {
        ...props,
        ref,
        "data-node-view-wrapper": "",
        onDragStart,
        style: {
          whiteSpace: "normal",
          ...props.style
        }
      }
    )
  );
});
function isClassComponent(Component) {
  return !!(typeof Component === "function" && Component.prototype && Component.prototype.isReactComponent);
}
function isForwardRefComponent(Component) {
  return !!(typeof Component === "object" && Component.$$typeof && (Component.$$typeof.toString() === "Symbol(react.forward_ref)" || Component.$$typeof.description === "react.forward_ref"));
}
function isMemoComponent(Component) {
  return !!(typeof Component === "object" && Component.$$typeof && (Component.$$typeof.toString() === "Symbol(react.memo)" || Component.$$typeof.description === "react.memo"));
}
function canReceiveRef(Component) {
  if (isClassComponent(Component)) {
    return true;
  }
  if (isForwardRefComponent(Component)) {
    return true;
  }
  if (isMemoComponent(Component)) {
    const wrappedComponent = Component.type;
    if (wrappedComponent) {
      return isClassComponent(wrappedComponent) || isForwardRefComponent(wrappedComponent);
    }
  }
  return false;
}
function isReact19Plus() {
  try {
    if (version) {
      const majorVersion = parseInt(version.split(".")[0], 10);
      return majorVersion >= 19;
    }
  } catch {
  }
  return false;
}
var ReactRenderer = class {
  /**
   * Immediately creates element and renders the provided React component.
   */
  constructor(component, { editor, props = {}, as = "div", className = "" }) {
    this.ref = null;
    this.destroyed = false;
    this.id = Math.floor(Math.random() * 4294967295).toString();
    this.component = component;
    this.editor = editor;
    this.props = props;
    this.element = document.createElement(as);
    this.element.classList.add("react-renderer");
    if (className) {
      this.element.classList.add(...className.split(" "));
    }
    if (this.editor.isInitialized) {
      flushSync(() => {
        this.render();
      });
    } else {
      queueMicrotask(() => {
        if (this.destroyed) {
          return;
        }
        this.render();
      });
    }
  }
  /**
   * Render the React component.
   */
  render() {
    var _a;
    if (this.destroyed) {
      return;
    }
    const Component = this.component;
    const props = this.props;
    const editor = this.editor;
    const isReact19 = isReact19Plus();
    const componentCanReceiveRef = canReceiveRef(Component);
    const elementProps = { ...props };
    if (elementProps.ref && !(isReact19 || componentCanReceiveRef)) {
      delete elementProps.ref;
    }
    if (!elementProps.ref && (isReact19 || componentCanReceiveRef)) {
      elementProps.ref = (ref) => {
        this.ref = ref;
      };
    }
    this.reactElement = /* @__PURE__ */ jsx(Component, { ...elementProps });
    (_a = editor == null ? void 0 : editor.contentComponent) == null ? void 0 : _a.setRenderer(this.id, this);
  }
  /**
   * Re-renders the React component with new props.
   */
  updateProps(props = {}) {
    if (this.destroyed) {
      return;
    }
    this.props = {
      ...this.props,
      ...props
    };
    this.render();
  }
  /**
   * Destroy the React component.
   */
  destroy() {
    var _a;
    this.destroyed = true;
    const editor = this.editor;
    (_a = editor == null ? void 0 : editor.contentComponent) == null ? void 0 : _a.removeRenderer(this.id);
    try {
      if (this.element && this.element.parentNode) {
        this.element.parentNode.removeChild(this.element);
      }
    } catch {
    }
  }
  /**
   * Update the attributes of the element that holds the React component.
   */
  updateAttributes(attributes) {
    Object.keys(attributes).forEach((key) => {
      this.element.setAttribute(key, attributes[key]);
    });
  }
};
React49__default.createContext({
  markViewContentRef: () => {
  }
});
var ReactNodeView = class extends NodeView {
  constructor(component, props, options) {
    super(component, props, options);
    this.selectionRafId = null;
    this.cachedExtensionWithSyncedStorage = null;
    if (!this.node.isLeaf) {
      if (this.options.contentDOMElementTag) {
        this.contentDOMElement = document.createElement(this.options.contentDOMElementTag);
      } else {
        this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div");
      }
      this.contentDOMElement.dataset.nodeViewContentReact = "";
      this.contentDOMElement.dataset.nodeViewWrapper = "";
      this.contentDOMElement.style.whiteSpace = "inherit";
      const contentTarget = this.dom.querySelector("[data-node-view-content]");
      if (!contentTarget) {
        return;
      }
      contentTarget.appendChild(this.contentDOMElement);
    }
  }
  /**
   * Returns a proxy of the extension that redirects storage access to the editor's mutable storage.
   * This preserves the original prototype chain (instanceof checks, methods like configure/extend work).
   * Cached to avoid proxy creation on every update.
   */
  get extensionWithSyncedStorage() {
    if (!this.cachedExtensionWithSyncedStorage) {
      const editor = this.editor;
      const extension = this.extension;
      this.cachedExtensionWithSyncedStorage = new Proxy(extension, {
        get(target, prop, receiver) {
          var _a;
          if (prop === "storage") {
            return (_a = editor.storage[extension.name]) != null ? _a : {};
          }
          return Reflect.get(target, prop, receiver);
        }
      });
    }
    return this.cachedExtensionWithSyncedStorage;
  }
  /**
   * Setup the React component.
   * Called on initialization.
   */
  mount() {
    const props = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      innerDecorations: this.innerDecorations,
      view: this.view,
      selected: false,
      extension: this.extensionWithSyncedStorage,
      HTMLAttributes: this.HTMLAttributes,
      getPos: () => this.getPos(),
      updateAttributes: (attributes = {}) => this.updateAttributes(attributes),
      deleteNode: () => this.deleteNode(),
      ref: createRef()
    };
    if (!this.component.displayName) {
      const capitalizeFirstChar = (string) => {
        return string.charAt(0).toUpperCase() + string.substring(1);
      };
      this.component.displayName = capitalizeFirstChar(this.extension.name);
    }
    const onDragStart = this.onDragStart.bind(this);
    const nodeViewContentRef = (element) => {
      if (element && this.contentDOMElement && element.firstChild !== this.contentDOMElement) {
        if (element.hasAttribute("data-node-view-wrapper")) {
          element.removeAttribute("data-node-view-wrapper");
        }
        element.appendChild(this.contentDOMElement);
      }
    };
    const context = { onDragStart, nodeViewContentRef };
    const Component = this.component;
    const ReactNodeViewProvider = memo((componentProps) => {
      return /* @__PURE__ */ jsx(ReactNodeViewContext.Provider, { value: context, children: createElement(Component, componentProps) });
    });
    ReactNodeViewProvider.displayName = "ReactNodeView";
    let as = this.node.isInline ? "span" : "div";
    if (this.options.as) {
      as = this.options.as;
    }
    const { className = "" } = this.options;
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
    this.renderer = new ReactRenderer(ReactNodeViewProvider, {
      editor: this.editor,
      props,
      as,
      className: `node-${this.node.type.name} ${className}`.trim()
    });
    this.editor.on("selectionUpdate", this.handleSelectionUpdate);
    this.updateElementAttributes();
  }
  /**
   * Return the DOM element.
   * This is the element that will be used to display the node view.
   */
  get dom() {
    var _a;
    if (this.renderer.element.firstElementChild && !((_a = this.renderer.element.firstElementChild) == null ? void 0 : _a.hasAttribute("data-node-view-wrapper"))) {
      throw Error("Please use the NodeViewWrapper component for your node view.");
    }
    return this.renderer.element;
  }
  /**
   * Return the content DOM element.
   * This is the element that will be used to display the rich-text content of the node.
   */
  get contentDOM() {
    if (this.node.isLeaf) {
      return null;
    }
    return this.contentDOMElement;
  }
  /**
   * On editor selection update, check if the node is selected.
   * If it is, call `selectNode`, otherwise call `deselectNode`.
   */
  handleSelectionUpdate() {
    if (this.selectionRafId) {
      cancelAnimationFrame(this.selectionRafId);
      this.selectionRafId = null;
    }
    this.selectionRafId = requestAnimationFrame(() => {
      this.selectionRafId = null;
      const { from: from2, to } = this.editor.state.selection;
      const pos = this.getPos();
      if (typeof pos !== "number") {
        return;
      }
      if (from2 <= pos && to >= pos + this.node.nodeSize) {
        if (this.renderer.props.selected) {
          return;
        }
        this.selectNode();
      } else {
        if (!this.renderer.props.selected) {
          return;
        }
        this.deselectNode();
      }
    });
  }
  /**
   * On update, update the React component.
   * To prevent unnecessary updates, the `update` option can be used.
   */
  update(node, decorations, innerDecorations) {
    const rerenderComponent = (props) => {
      this.renderer.updateProps(props);
      if (typeof this.options.attrs === "function") {
        this.updateElementAttributes();
      }
    };
    if (node.type !== this.node.type) {
      return false;
    }
    if (typeof this.options.update === "function") {
      const oldNode = this.node;
      const oldDecorations = this.decorations;
      const oldInnerDecorations = this.innerDecorations;
      this.node = node;
      this.decorations = decorations;
      this.innerDecorations = innerDecorations;
      return this.options.update({
        oldNode,
        oldDecorations,
        newNode: node,
        newDecorations: decorations,
        oldInnerDecorations,
        innerDecorations,
        updateProps: () => rerenderComponent({ node, decorations, innerDecorations, extension: this.extensionWithSyncedStorage })
      });
    }
    if (node === this.node && this.decorations === decorations && this.innerDecorations === innerDecorations) {
      return true;
    }
    this.node = node;
    this.decorations = decorations;
    this.innerDecorations = innerDecorations;
    rerenderComponent({ node, decorations, innerDecorations, extension: this.extensionWithSyncedStorage });
    return true;
  }
  /**
   * Select the node.
   * Add the `selected` prop and the `ProseMirror-selectednode` class.
   */
  selectNode() {
    this.renderer.updateProps({
      selected: true
    });
    this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  /**
   * Deselect the node.
   * Remove the `selected` prop and the `ProseMirror-selectednode` class.
   */
  deselectNode() {
    this.renderer.updateProps({
      selected: false
    });
    this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  /**
   * Destroy the React component instance.
   */
  destroy() {
    this.renderer.destroy();
    this.editor.off("selectionUpdate", this.handleSelectionUpdate);
    this.contentDOMElement = null;
    if (this.selectionRafId) {
      cancelAnimationFrame(this.selectionRafId);
      this.selectionRafId = null;
    }
  }
  /**
   * Update the attributes of the top-level element that holds the React component.
   * Applying the attributes defined in the `attrs` option.
   */
  updateElementAttributes() {
    if (this.options.attrs) {
      let attrsObj = {};
      if (typeof this.options.attrs === "function") {
        const extensionAttributes = this.editor.extensionManager.attributes;
        const HTMLAttributes = getRenderedAttributes(this.node, extensionAttributes);
        attrsObj = this.options.attrs({ node: this.node, HTMLAttributes });
      } else {
        attrsObj = this.options.attrs;
      }
      this.renderer.updateAttributes(attrsObj);
    }
  }
};
function ReactNodeViewRenderer(component, options) {
  return (props) => {
    if (!props.editor.contentComponent) {
      return {};
    }
    return new ReactNodeView(component, props, options);
  };
}
var TiptapContext = createContext({
  get editor() {
    throw new Error("useTiptap must be used within a <Tiptap> provider");
  }
});
TiptapContext.displayName = "TiptapContext";
var useTiptap = () => useContext(TiptapContext);
function TiptapWrapper({ editor, instance, children }) {
  const resolvedEditor = editor != null ? editor : instance;
  if (!resolvedEditor) {
    throw new Error("Tiptap: An editor instance is required. Pass a non-null `editor` prop.");
  }
  const tiptapContextValue = useMemo(() => ({ editor: resolvedEditor }), [resolvedEditor]);
  const legacyContextValue = useMemo(() => ({ editor: resolvedEditor }), [resolvedEditor]);
  return /* @__PURE__ */ jsx(EditorContext.Provider, { value: legacyContextValue, children: /* @__PURE__ */ jsx(TiptapContext.Provider, { value: tiptapContextValue, children }) });
}
TiptapWrapper.displayName = "Tiptap";
function TiptapContent({ ...rest }) {
  const { editor } = useTiptap();
  return /* @__PURE__ */ jsx(EditorContent, { editor, ...rest });
}
TiptapContent.displayName = "Tiptap.Content";
Object.assign(TiptapWrapper, {
  /**
   * The Tiptap Content component that renders the EditorContent with the editor instance from the context.
   * @see TiptapContent
   */
  Content: TiptapContent
});

// ../../node_modules/.pnpm/@tiptap+extension-document@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-document/dist/index.js
var Document = Node3.create({
  name: "doc",
  topNode: true,
  content: "block+",
  renderMarkdown: (node, h2) => {
    if (!node.content) {
      return "";
    }
    return h2.renderChildren(node.content, "\n\n");
  }
});
var index_default = Document;

// ../../node_modules/.pnpm/@tiptap+suggestion@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0__@tiptap+pm@3.20.0/node_modules/@tiptap/suggestion/dist/index.js
function findSuggestionMatch(config) {
  var _a;
  const { char, allowSpaces: allowSpacesOption, allowToIncludeChar, allowedPrefixes, startOfLine, $position } = config;
  const allowSpaces = allowSpacesOption && !allowToIncludeChar;
  const escapedChar = escapeForRegEx(char);
  const suffix = new RegExp(`\\s${escapedChar}$`);
  const prefix = startOfLine ? "^" : "";
  const finalEscapedChar = allowToIncludeChar ? "" : escapedChar;
  const regexp = allowSpaces ? new RegExp(`${prefix}${escapedChar}.*?(?=\\s${finalEscapedChar}|$)`, "gm") : new RegExp(`${prefix}(?:^)?${escapedChar}[^\\s${finalEscapedChar}]*`, "gm");
  const text = ((_a = $position.nodeBefore) == null ? void 0 : _a.isText) && $position.nodeBefore.text;
  if (!text) {
    return null;
  }
  const textFrom = $position.pos - text.length;
  const match = Array.from(text.matchAll(regexp)).pop();
  if (!match || match.input === void 0 || match.index === void 0) {
    return null;
  }
  const matchPrefix = match.input.slice(Math.max(0, match.index - 1), match.index);
  const matchPrefixIsAllowed = new RegExp(`^[${allowedPrefixes == null ? void 0 : allowedPrefixes.join("")}\0]?$`).test(matchPrefix);
  if (allowedPrefixes !== null && !matchPrefixIsAllowed) {
    return null;
  }
  const from2 = textFrom + match.index;
  let to = from2 + match[0].length;
  if (allowSpaces && suffix.test(text.slice(to - 1, to + 1))) {
    match[0] += " ";
    to += 1;
  }
  if (from2 < $position.pos && to >= $position.pos) {
    return {
      range: {
        from: from2,
        to
      },
      query: match[0].slice(char.length),
      text: match[0]
    };
  }
  return null;
}
var SuggestionPluginKey = new PluginKey("suggestion");
function Suggestion({
  pluginKey = SuggestionPluginKey,
  editor,
  char = "@",
  allowSpaces = false,
  allowToIncludeChar = false,
  allowedPrefixes = [" "],
  startOfLine = false,
  decorationTag = "span",
  decorationClass = "suggestion",
  decorationContent = "",
  decorationEmptyClass = "is-empty",
  command: command2 = () => null,
  items = () => [],
  render: render22 = () => ({}),
  allow = () => true,
  findSuggestionMatch: findSuggestionMatch2 = findSuggestionMatch,
  shouldShow
}) {
  let props;
  const renderer = render22 == null ? void 0 : render22();
  const getAnchorClientRect = () => {
    const pos = editor.state.selection.$anchor.pos;
    const coords = editor.view.coordsAtPos(pos);
    const { top: top2, right: right2, bottom: bottom2, left: left2 } = coords;
    try {
      return new DOMRect(left2, top2, right2 - left2, bottom2 - top2);
    } catch {
      return null;
    }
  };
  const clientRectFor = (view, decorationNode) => {
    if (!decorationNode) {
      return getAnchorClientRect;
    }
    return () => {
      const state = pluginKey.getState(editor.state);
      const decorationId = state == null ? void 0 : state.decorationId;
      const currentDecorationNode = view.dom.querySelector(`[data-decoration-id="${decorationId}"]`);
      return (currentDecorationNode == null ? void 0 : currentDecorationNode.getBoundingClientRect()) || null;
    };
  };
  function dispatchExit(view, pluginKeyRef) {
    var _a;
    try {
      const state = pluginKey.getState(view.state);
      const decorationNode = (state == null ? void 0 : state.decorationId) ? view.dom.querySelector(`[data-decoration-id="${state.decorationId}"]`) : null;
      const exitProps = {
        // @ts-ignore editor is available in closure
        editor,
        range: (state == null ? void 0 : state.range) || { from: 0, to: 0 },
        query: (state == null ? void 0 : state.query) || null,
        text: (state == null ? void 0 : state.text) || null,
        items: [],
        command: (commandProps) => {
          return command2({ editor, range: (state == null ? void 0 : state.range) || { from: 0, to: 0 }, props: commandProps });
        },
        decorationNode,
        clientRect: clientRectFor(view, decorationNode)
      };
      (_a = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _a.call(renderer, exitProps);
    } catch {
    }
    const tr2 = view.state.tr.setMeta(pluginKeyRef, { exit: true });
    view.dispatch(tr2);
  }
  const plugin = new Plugin({
    key: pluginKey,
    view() {
      return {
        update: async (view, prevState) => {
          var _a, _b, _c, _d, _e, _f, _g;
          const prev = (_a = this.key) == null ? void 0 : _a.getState(prevState);
          const next = (_b = this.key) == null ? void 0 : _b.getState(view.state);
          const moved = prev.active && next.active && prev.range.from !== next.range.from;
          const started = !prev.active && next.active;
          const stopped = prev.active && !next.active;
          const changed = !started && !stopped && prev.query !== next.query;
          const handleStart = started || moved && changed;
          const handleChange = changed || moved;
          const handleExit = stopped || moved && changed;
          if (!handleStart && !handleChange && !handleExit) {
            return;
          }
          const state = handleExit && !handleStart ? prev : next;
          const decorationNode = view.dom.querySelector(`[data-decoration-id="${state.decorationId}"]`);
          props = {
            editor,
            range: state.range,
            query: state.query,
            text: state.text,
            items: [],
            command: (commandProps) => {
              return command2({
                editor,
                range: state.range,
                props: commandProps
              });
            },
            decorationNode,
            clientRect: clientRectFor(view, decorationNode)
          };
          if (handleStart) {
            (_c = renderer == null ? void 0 : renderer.onBeforeStart) == null ? void 0 : _c.call(renderer, props);
          }
          if (handleChange) {
            (_d = renderer == null ? void 0 : renderer.onBeforeUpdate) == null ? void 0 : _d.call(renderer, props);
          }
          if (handleChange || handleStart) {
            props.items = await items({
              editor,
              query: state.query
            });
          }
          if (handleExit) {
            (_e = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _e.call(renderer, props);
          }
          if (handleChange) {
            (_f = renderer == null ? void 0 : renderer.onUpdate) == null ? void 0 : _f.call(renderer, props);
          }
          if (handleStart) {
            (_g = renderer == null ? void 0 : renderer.onStart) == null ? void 0 : _g.call(renderer, props);
          }
        },
        destroy: () => {
          var _a;
          if (!props) {
            return;
          }
          (_a = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _a.call(renderer, props);
        }
      };
    },
    state: {
      // Initialize the plugin's internal state.
      init() {
        const state = {
          active: false,
          range: {
            from: 0,
            to: 0
          },
          query: null,
          text: null,
          composing: false
        };
        return state;
      },
      // Apply changes to the plugin state from a view transaction.
      apply(transaction, prev, _oldState, state) {
        const { isEditable } = editor;
        const { composing } = editor.view;
        const { selection } = transaction;
        const { empty: empty2, from: from2 } = selection;
        const next = { ...prev };
        const meta = transaction.getMeta(pluginKey);
        if (meta && meta.exit) {
          next.active = false;
          next.decorationId = null;
          next.range = { from: 0, to: 0 };
          next.query = null;
          next.text = null;
          return next;
        }
        next.composing = composing;
        if (isEditable && (empty2 || editor.view.composing)) {
          if ((from2 < prev.range.from || from2 > prev.range.to) && !composing && !prev.composing) {
            next.active = false;
          }
          const match = findSuggestionMatch2({
            char,
            allowSpaces,
            allowToIncludeChar,
            allowedPrefixes,
            startOfLine,
            $position: selection.$from
          });
          const decorationId = `id_${Math.floor(Math.random() * 4294967295)}`;
          if (match && allow({
            editor,
            state,
            range: match.range,
            isActive: prev.active
          }) && (!shouldShow || shouldShow({
            editor,
            range: match.range,
            query: match.query,
            text: match.text,
            transaction
          }))) {
            next.active = true;
            next.decorationId = prev.decorationId ? prev.decorationId : decorationId;
            next.range = match.range;
            next.query = match.query;
            next.text = match.text;
          } else {
            next.active = false;
          }
        } else {
          next.active = false;
        }
        if (!next.active) {
          next.decorationId = null;
          next.range = { from: 0, to: 0 };
          next.query = null;
          next.text = null;
        }
        return next;
      }
    },
    props: {
      // Call the keydown hook if suggestion is active.
      handleKeyDown(view, event) {
        var _a, _b, _c, _d;
        const { active, range } = plugin.getState(view.state);
        if (!active) {
          return false;
        }
        if (event.key === "Escape" || event.key === "Esc") {
          const state = plugin.getState(view.state);
          const cachedNode = (_a = props == null ? void 0 : props.decorationNode) != null ? _a : null;
          const decorationNode = cachedNode != null ? cachedNode : (state == null ? void 0 : state.decorationId) ? view.dom.querySelector(`[data-decoration-id="${state.decorationId}"]`) : null;
          const handledByKeyDown = ((_b = renderer == null ? void 0 : renderer.onKeyDown) == null ? void 0 : _b.call(renderer, { view, event, range: state.range })) || false;
          if (handledByKeyDown) {
            return true;
          }
          const exitProps = {
            editor,
            range: state.range,
            query: state.query,
            text: state.text,
            items: [],
            command: (commandProps) => {
              return command2({ editor, range: state.range, props: commandProps });
            },
            decorationNode,
            // If we have a cached decoration node, use it for the clientRect
            // to avoid another DOM lookup. If not, leave clientRect null and
            // let consumer decide if they want to query.
            clientRect: decorationNode ? () => {
              return decorationNode.getBoundingClientRect() || null;
            } : null
          };
          (_c = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _c.call(renderer, exitProps);
          dispatchExit(view, pluginKey);
          return true;
        }
        const handled = ((_d = renderer == null ? void 0 : renderer.onKeyDown) == null ? void 0 : _d.call(renderer, { view, event, range })) || false;
        return handled;
      },
      // Setup decorator on the currently active suggestion.
      decorations(state) {
        const { active, range, decorationId, query } = plugin.getState(state);
        if (!active) {
          return null;
        }
        const isEmpty = !(query == null ? void 0 : query.length);
        const classNames = [decorationClass];
        if (isEmpty) {
          classNames.push(decorationEmptyClass);
        }
        return DecorationSet.create(state.doc, [
          Decoration.inline(range.from, range.to, {
            nodeName: decorationTag,
            class: classNames.join(" "),
            "data-decoration-id": decorationId,
            "data-decoration-content": decorationContent
          })
        ]);
      }
    }
  });
  return plugin;
}

// ../../node_modules/.pnpm/@tiptap+extension-mention@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0__@tiptap+pm@3.20_dfe8326c6cb958c645cf43ebb012a56f/node_modules/@tiptap/extension-mention/dist/index.js
function getSuggestionOptions({
  editor: tiptapEditor,
  overrideSuggestionOptions,
  extensionName,
  char = "@"
}) {
  const pluginKey = new PluginKey();
  return {
    editor: tiptapEditor,
    char,
    pluginKey,
    command: ({ editor, range, props }) => {
      var _a, _b, _c;
      const nodeAfter = editor.view.state.selection.$to.nodeAfter;
      const overrideSpace = (_a = nodeAfter == null ? void 0 : nodeAfter.text) == null ? void 0 : _a.startsWith(" ");
      if (overrideSpace) {
        range.to += 1;
      }
      editor.chain().focus().insertContentAt(range, [
        {
          type: extensionName,
          attrs: { ...props, mentionSuggestionChar: char }
        },
        {
          type: "text",
          text: " "
        }
      ]).run();
      (_c = (_b = editor.view.dom.ownerDocument.defaultView) == null ? void 0 : _b.getSelection()) == null ? void 0 : _c.collapseToEnd();
    },
    allow: ({ state, range }) => {
      const $from = state.doc.resolve(range.from);
      const type = state.schema.nodes[extensionName];
      const allow = !!$from.parent.type.contentMatch.matchType(type);
      return allow;
    },
    ...overrideSuggestionOptions
  };
}
function getSuggestions(options) {
  return (options.options.suggestions.length ? options.options.suggestions : [options.options.suggestion]).map(
    (suggestion) => getSuggestionOptions({
      // @ts-ignore `editor` can be `undefined` when converting the document to HTML with the HTML utility
      editor: options.editor,
      overrideSuggestionOptions: suggestion,
      extensionName: options.name,
      char: suggestion.char
    })
  );
}
function getSuggestionFromChar(options, char) {
  const suggestions = getSuggestions(options);
  const suggestion = suggestions.find((s) => s.char === char);
  if (suggestion) {
    return suggestion;
  }
  if (suggestions.length) {
    return suggestions[0];
  }
  return null;
}
var Mention = Node3.create({
  name: "mention",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      renderText({ node, suggestion }) {
        var _a, _b;
        return `${(_a = suggestion == null ? void 0 : suggestion.char) != null ? _a : "@"}${(_b = node.attrs.label) != null ? _b : node.attrs.id}`;
      },
      deleteTriggerWithBackspace: false,
      renderHTML({ options, node, suggestion }) {
        var _a, _b;
        return [
          "span",
          mergeAttributes(this.HTMLAttributes, options.HTMLAttributes),
          `${(_a = suggestion == null ? void 0 : suggestion.char) != null ? _a : "@"}${(_b = node.attrs.label) != null ? _b : node.attrs.id}`
        ];
      },
      suggestions: [],
      suggestion: {}
    };
  },
  group: "inline",
  inline: true,
  selectable: false,
  atom: true,
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-id"),
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }
          return {
            "data-id": attributes.id
          };
        }
      },
      label: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-label"),
        renderHTML: (attributes) => {
          if (!attributes.label) {
            return {};
          }
          return {
            "data-label": attributes.label
          };
        }
      },
      // When there are multiple types of mentions, this attribute helps distinguish them
      mentionSuggestionChar: {
        default: "@",
        parseHTML: (element) => element.getAttribute("data-mention-suggestion-char"),
        renderHTML: (attributes) => {
          return {
            "data-mention-suggestion-char": attributes.mentionSuggestionChar
          };
        }
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML({ node, HTMLAttributes }) {
    const suggestion = getSuggestionFromChar(this, node.attrs.mentionSuggestionChar);
    if (this.options.renderLabel !== void 0) {
      console.warn("renderLabel is deprecated use renderText and renderHTML instead");
      return [
        "span",
        mergeAttributes({ "data-type": this.name }, this.options.HTMLAttributes, HTMLAttributes),
        this.options.renderLabel({
          options: this.options,
          node,
          suggestion
        })
      ];
    }
    const mergedOptions = { ...this.options };
    mergedOptions.HTMLAttributes = mergeAttributes(
      { "data-type": this.name },
      this.options.HTMLAttributes,
      HTMLAttributes
    );
    const html = this.options.renderHTML({
      options: mergedOptions,
      node,
      suggestion
    });
    if (typeof html === "string") {
      return ["span", mergeAttributes({ "data-type": this.name }, this.options.HTMLAttributes, HTMLAttributes), html];
    }
    return html;
  },
  ...createInlineMarkdownSpec({
    nodeName: "mention",
    name: "@",
    selfClosing: true,
    allowedAttributes: ["id", "label", { name: "mentionSuggestionChar", skipIfDefault: "@" }],
    parseAttributes: (attrString) => {
      const attrs = {};
      const regex = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
      let match = regex.exec(attrString);
      while (match !== null) {
        const [, key, doubleQuoted, singleQuoted] = match;
        const value = doubleQuoted != null ? doubleQuoted : singleQuoted;
        attrs[key === "char" ? "mentionSuggestionChar" : key] = value;
        match = regex.exec(attrString);
      }
      return attrs;
    },
    serializeAttributes: (attrs) => {
      return Object.entries(attrs).filter(([, value]) => value !== void 0 && value !== null).map(([key, value]) => {
        const serializedKey = key === "mentionSuggestionChar" ? "char" : key;
        return `${serializedKey}="${value}"`;
      }).join(" ");
    }
  }),
  renderText({ node }) {
    const args = {
      options: this.options,
      node,
      suggestion: getSuggestionFromChar(this, node.attrs.mentionSuggestionChar)
    };
    if (this.options.renderLabel !== void 0) {
      console.warn("renderLabel is deprecated use renderText and renderHTML instead");
      return this.options.renderLabel(args);
    }
    return this.options.renderText(args);
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({ tr: tr2, state }) => {
        let isMention = false;
        const { selection } = state;
        const { empty: empty2, anchor } = selection;
        if (!empty2) {
          return false;
        }
        let mentionNode = new Node2();
        let mentionPos = 0;
        state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
          if (node.type.name === this.name) {
            isMention = true;
            mentionNode = node;
            mentionPos = pos;
            return false;
          }
        });
        if (isMention) {
          tr2.insertText(
            this.options.deleteTriggerWithBackspace ? "" : mentionNode.attrs.mentionSuggestionChar,
            mentionPos,
            mentionPos + mentionNode.nodeSize
          );
        }
        return isMention;
      })
    };
  },
  addProseMirrorPlugins() {
    return getSuggestions(this).map(Suggestion);
  }
});
var index_default2 = Mention;

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/enums.js
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/applyStyles.js
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style2 = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style2);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style2 = styleProperties.reduce(function(style3, property) {
        style3[property] = "";
        return style3;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style2);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles_default = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect,
  requires: ["computeStyles"]
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getBasePlacement.js
function getBasePlacement(placement) {
  return placement.split("-")[0];
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/math.js
var max = Math.max;
var min = Math.min;
var round = Math.round;

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect2 = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect2.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect2.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect2.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect2.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect2.width / scaleX;
  var height = clientRect2.height / scaleY;
  return {
    width,
    height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x,
    y
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
function getLayoutRect(element) {
  var clientRect2 = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect2.width - width) <= 1) {
    width = clientRect2.width;
  }
  if (Math.abs(clientRect2.height - height) <= 1) {
    height = clientRect2.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/contains.js
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
function getComputedStyle2(element) {
  return getWindow(element).getComputedStyle(element);
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : (
    // $FlowFixMe[prop-missing]
    element.document
  )) || window.document).documentElement;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element)
  );
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle2(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle2(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle2(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle2(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle2(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/within.js
function within(min3, value, max3) {
  return max(min3, min(value, max3));
}
function withinMaxClamp(min3, value, max3) {
  var v = within(min3, value, max3);
  return v > max3 ? max3 : v;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys3) {
  return keys3.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/arrow.js
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min3 = paddingObject[minProp];
  var max3 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset5 = within(min3, center, max3);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset5, _state$modifiersData$.centerOffset = offset5 - center, _state$modifiersData$);
}
function effect2(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow_default = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect2,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split("-")[1];
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x, y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle2(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp]
      );
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp]
      );
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }, getWindow(popper2)) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles_default = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var passive = {
  passive: true
};
function effect3(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners_default = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect: effect3,
  data: {}
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash[matched];
  });
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var hash2 = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash2[matched];
  });
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle2(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle2(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)))
  );
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle2(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeOffsets.js
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/detectOverflow.js
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset5 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset5[axis] * multiply;
    });
  }
  return overflowOffsets;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements3 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements3.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements3;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/flip.js
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements3 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements3[0];
  for (var i = 0; i < placements3.length; i++) {
    var placement = placements3[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements3.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip_default = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/hide.js
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide_default = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/offset.js
function distanceAndSkiddingToXY(placement, rects, offset5) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset5 === "function" ? offset5(Object.assign({}, rects, {
    placement
  })) : offset5, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset5 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset5);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset_default = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    placement: state.placement
  });
}
var popperOffsets_default = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset5 = popperOffsets2[mainAxis];
    var min3 = offset5 + overflow[mainSide];
    var max3 = offset5 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset5 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset5 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min3, tetherMin) : min3, offset5, tether ? max(max3, tetherMax) : max3);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset5;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow_default = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/orderModifiers.js
function order(modifiers2) {
  var map2 = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers2.forEach(function(modifier) {
    map2.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map2.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers2.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers2) {
  var orderedModifiers = order(modifiers2);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers2) {
  var merged = modifiers2.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/createPopper.js
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref) {
        var name = _ref.name, _ref$options = _ref.options, options2 = _ref$options === void 0 ? {} : _ref$options, effect5 = _ref.effect;
        if (typeof effect5 === "function") {
          var cleanupFn = effect5({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/popper.js
var defaultModifiers = [eventListeners_default, popperOffsets_default, computeStyles_default, applyStyles_default, offset_default, flip_default, preventOverflow_default, arrow_default, hide_default];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});

// ../../node_modules/.pnpm/tippy.js@6.3.7/node_modules/tippy.js/dist/tippy.esm.js
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO2() {
  return document.body;
};
function hasOwnProperty2(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index2, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index2];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index2] : defaultValue : v;
  }
  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === "function" ? value.apply(void 0, args) : value;
}
function debounce2(fn2, ms) {
  if (ms === 0) {
    return fn2;
  }
  var timeout;
  return function(arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      fn2(arg);
    }, ms);
  };
}
function removeProperties(obj, keys3) {
  var clone = Object.assign({}, obj);
  keys3.forEach(function(key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function(item, index2) {
    return arr.indexOf(item) === index2;
  });
}
function getBasePlacement2(placement) {
  return placement.split("-")[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function(acc, key) {
    if (obj[key] !== void 0) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}
function div() {
  return document.createElement("div");
}
function isElement2(value) {
  return ["Element", "Fragment"].some(function(type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, "NodeList");
}
function isMouseEvent(value) {
  return isType(value, "MouseEvent");
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement2(value)) {
    return [value];
  }
  if (isNodeList(value)) {
    return arrayFrom(value);
  }
  if (Array.isArray(value)) {
    return value;
  }
  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function(el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function(el) {
    if (el) {
      el.setAttribute("data-state", state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;
  var _normalizeToArray = normalizeToArray(elementOrElements), element = _normalizeToArray[0];
  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX, clientY = event.clientY;
  return popperTreeData.every(function(_ref) {
    var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement2(popperState.placement);
    var offsetData = popperState.modifiersData.offset;
    if (!offsetData) {
      return true;
    }
    var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
    var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(event) {
    box[method](event, listener);
  });
}
function actualContains(parent, child) {
  var target = child;
  while (target) {
    var _target$getRootNode;
    if (parent.contains(target)) {
      return true;
    }
    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }
  return false;
}
var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }
  currentInput.isTouch = true;
  if (window.performance) {
    document.addEventListener("mousemove", onDocumentMouseMove);
  }
}
function onDocumentMouseMove() {
  var now = performance.now();
  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener("mousemove", onDocumentMouseMove);
  }
  lastMouseMoveTime = now;
}
function onWindowBlur() {
  var activeElement = document.activeElement;
  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;
    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener("touchstart", onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener("blur", onWindowBlur);
}
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var isIE11 = isBrowser ? (
  // @ts-ignore
  !!window.msCrypto
) : false;
function createMemoryLeakWarning(method) {
  var txt = method === "destroy" ? "n already-" : " ";
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\u{1F477}\u200D This is a development-only message. It will be removed in production.\n  ");
}
function getFormattedMessage(message) {
  return [
    getDevMessage(message),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var visitedMessages;
if (process.env.NODE_ENV !== "production") {
  resetVisitedMessages();
}
function resetVisitedMessages() {
  visitedMessages = /* @__PURE__ */ new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;
    visitedMessages.add(message);
    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;
    visitedMessages.add(message);
    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ["tippy() was passed", "`" + String(targets) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" "));
  errorWhen(didPassPlainObject, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: "fade",
  arrow: true,
  content: "",
  inertia: false,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {
  },
  onBeforeUpdate: function onBeforeUpdate() {
  },
  onCreate: function onCreate() {
  },
  onDestroy: function onDestroy() {
  },
  onHidden: function onHidden() {
  },
  onHide: function onHide() {
  },
  onMount: function onMount() {
  },
  onShow: function onShow() {
  },
  onShown: function onShown() {
  },
  onTrigger: function onTrigger() {
  },
  onUntrigger: function onUntrigger() {
  },
  onClickOutside: function onClickOutside() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: "mouseenter focus",
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps2(partialProps) {
  if (process.env.NODE_ENV !== "production") {
    validateProps(partialProps, []);
  }
  var keys3 = Object.keys(partialProps);
  keys3.forEach(function(key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps2 = plugins.reduce(function(acc, plugin) {
    var name = plugin.name, defaultValue = plugin.defaultValue;
    if (name) {
      var _name;
      acc[name] = passedProps[name] !== void 0 ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }
    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps2);
}
function getDataAttributeProps(reference2, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function(acc, key) {
    var valueAsString = (reference2.getAttribute("data-tippy-" + key) || "").trim();
    if (!valueAsString) {
      return acc;
    }
    if (key === "content") {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }
    return acc;
  }, {});
  return props;
}
function evaluateProps(reference2, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference2])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference2, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
    content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }
  if (plugins === void 0) {
    plugins = [];
  }
  var keys3 = Object.keys(partialProps);
  keys3.forEach(function(prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !hasOwnProperty2(nonPluginProps, prop);
    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function(plugin) {
        return plugin.name === prop;
      }).length === 0;
    }
    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", "\n\n", "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n", "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var innerHTML = function innerHTML2() {
  return "innerHTML";
};
function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}
function createArrowElement(value) {
  var arrow6 = div();
  if (value === true) {
    arrow6.className = ARROW_CLASS;
  } else {
    arrow6.className = SVG_ARROW_CLASS;
    if (isElement2(value)) {
      arrow6.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow6, value);
    }
  }
  return arrow6;
}
function setContent2(content, props) {
  if (isElement2(props.content)) {
    dangerouslySetInnerHTML(content, "");
    content.appendChild(props.content);
  } else if (typeof props.content !== "function") {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper2) {
  var box = popper2.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box,
    content: boxChildren.find(function(node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function(node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function(node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper2 = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute("data-state", "hidden");
  box.setAttribute("tabindex", "-1");
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute("data-state", "hidden");
  setContent2(content, instance.props);
  popper2.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);
  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper2), box2 = _getChildren.box, content2 = _getChildren.content, arrow6 = _getChildren.arrow;
    if (nextProps.theme) {
      box2.setAttribute("data-theme", nextProps.theme);
    } else {
      box2.removeAttribute("data-theme");
    }
    if (typeof nextProps.animation === "string") {
      box2.setAttribute("data-animation", nextProps.animation);
    } else {
      box2.removeAttribute("data-animation");
    }
    if (nextProps.inertia) {
      box2.setAttribute("data-inertia", "");
    } else {
      box2.removeAttribute("data-inertia");
    }
    box2.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
    if (nextProps.role) {
      box2.setAttribute("role", nextProps.role);
    } else {
      box2.removeAttribute("role");
    }
    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent2(content2, instance.props);
    }
    if (nextProps.arrow) {
      if (!arrow6) {
        box2.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box2.removeChild(arrow6);
        box2.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow6) {
      box2.removeChild(arrow6);
    }
  }
  return {
    popper: popper2,
    onUpdate
  };
}
render.$$tippy = true;
var idCounter = 1;
var mouseMoveListeners = [];
var mountedInstances = [];
function createTippy(reference2, passedProps) {
  var props = evaluateProps(reference2, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps))));
  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce2(onMouseMove, props.interactiveDebounce);
  var currentTarget;
  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id,
    reference: reference2,
    popper: div(),
    popperInstance,
    props,
    state,
    plugins,
    // methods
    clearDelayTimeouts,
    setProps,
    setContent: setContent3,
    show,
    hide: hide5,
    hideWithInteractivity,
    enable,
    disable,
    unmount,
    destroy
  };
  if (!props.render) {
    if (process.env.NODE_ENV !== "production") {
      errorWhen(true, "render() function has not been supplied.");
    }
    return instance;
  }
  var _props$render = props.render(instance), popper2 = _props$render.popper, onUpdate = _props$render.onUpdate;
  popper2.setAttribute("data-tippy-root", "");
  popper2.id = "tippy-" + instance.id;
  instance.popper = popper2;
  reference2._tippy = instance;
  popper2._tippy = instance;
  var pluginsHooks = plugins.map(function(plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference2.hasAttribute("aria-expanded");
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook("onCreate", [instance]);
  if (props.showOnCreate) {
    scheduleShow();
  }
  popper2.addEventListener("mouseenter", function() {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper2.addEventListener("mouseleave", function() {
    if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) {
      getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    }
  });
  return instance;
  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }
  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === "hold";
  }
  function getIsDefaultRenderFn() {
    var _instance$props$rende;
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }
  function getCurrentTarget() {
    return currentTarget || reference2;
  }
  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }
  function getDefaultTemplateChildren() {
    return getChildren(popper2);
  }
  function getDelay(isShow) {
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") {
      return 0;
    }
    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }
  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }
    popper2.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
    popper2.style.zIndex = "" + instance.props.zIndex;
  }
  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }
    pluginsHooks.forEach(function(pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });
    if (shouldInvokePropsHook) {
      var _instance$props;
      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }
  function handleAriaContentAttribute() {
    var aria = instance.props.aria;
    if (!aria.content) {
      return;
    }
    var attr = "aria-" + aria.content;
    var id2 = popper2.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function(node) {
      var currentValue = node.getAttribute(attr);
      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id2 : id2);
      } else {
        var nextValue = currentValue && currentValue.replace(id2, "").trim();
        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }
  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }
    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function(node) {
      if (instance.props.interactive) {
        node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
      } else {
        node.removeAttribute("aria-expanded");
      }
    });
  }
  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function(listener) {
      return listener !== debouncedOnMouseMove;
    });
  }
  function onDocumentPress(event) {
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === "mousedown") {
        return;
      }
    }
    var actualTarget = event.composedPath && event.composedPath()[0] || event.target;
    if (instance.props.interactive && actualContains(popper2, actualTarget)) {
      return;
    }
    if (normalizeToArray(instance.props.triggerTarget || reference2).some(function(el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }
      if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) {
        return;
      }
    } else {
      invokeHook("onClickOutside", [instance, event]);
    }
    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide();
      didHideDueToDocumentMouseDown = true;
      setTimeout(function() {
        didHideDueToDocumentMouseDown = false;
      });
      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }
  function onTouchMove() {
    didTouchMove = true;
  }
  function onTouchStart() {
    didTouchMove = false;
  }
  function addDocumentPress() {
    var doc3 = getDocument();
    doc3.addEventListener("mousedown", onDocumentPress, true);
    doc3.addEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
    doc3.addEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
    doc3.addEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
  }
  function removeDocumentPress() {
    var doc3 = getDocument();
    doc3.removeEventListener("mousedown", onDocumentPress, true);
    doc3.removeEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
    doc3.removeEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
    doc3.removeEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
  }
  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function() {
      if (!instance.state.isVisible && popper2.parentNode && popper2.parentNode.contains(popper2)) {
        callback();
      }
    });
  }
  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }
  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;
    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, "remove", listener);
        callback();
      }
    }
    if (duration === 0) {
      return callback();
    }
    updateTransitionEndListener(box, "remove", currentTransitionEndListener);
    updateTransitionEndListener(box, "add", listener);
    currentTransitionEndListener = listener;
  }
  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }
    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function(node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node,
        eventType,
        handler,
        options
      });
    });
  }
  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on("touchstart", onTrigger2, {
        passive: true
      });
      on("touchend", onMouseLeave, {
        passive: true
      });
    }
    splitBySpaces(instance.props.trigger).forEach(function(eventType) {
      if (eventType === "manual") {
        return;
      }
      on(eventType, onTrigger2);
      switch (eventType) {
        case "mouseenter":
          on("mouseleave", onMouseLeave);
          break;
        case "focus":
          on(isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
          break;
        case "focusin":
          on("focusout", onBlurOrFocusOut);
          break;
      }
    });
  }
  function removeListeners() {
    listeners.forEach(function(_ref) {
      var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }
  function onTrigger2(event) {
    var _lastTriggerEvent;
    var shouldScheduleClickHide = false;
    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }
    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();
    if (!instance.state.isVisible && isMouseEvent(event)) {
      mouseMoveListeners.forEach(function(listener) {
        return listener(event);
      });
    }
    if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }
    if (event.type === "click") {
      isVisibleFromClick = !shouldScheduleClickHide;
    }
    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }
  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper2.contains(target);
    if (event.type === "mousemove" && isCursorOverReferenceOrPopper) {
      return;
    }
    var popperTreeData = getNestedPopperTree().concat(popper2).map(function(popper3) {
      var _instance$popperInsta;
      var instance2 = popper3._tippy;
      var state2 = (_instance$popperInsta = instance2.popperInstance) == null ? void 0 : _instance$popperInsta.state;
      if (state2) {
        return {
          popperRect: popper3.getBoundingClientRect(),
          popperState: state2,
          props
        };
      }
      return null;
    }).filter(Boolean);
    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }
  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
    if (shouldBail) {
      return;
    }
    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }
    scheduleHide(event);
  }
  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) {
      return;
    }
    if (instance.props.interactive && event.relatedTarget && popper2.contains(event.relatedTarget)) {
      return;
    }
    scheduleHide(event);
  }
  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
  }
  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset5 = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
    var arrow6 = getIsDefaultRenderFn() ? getChildren(popper2).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference2;
    var tippyModifier = {
      name: "$$tippy",
      enabled: true,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function fn2(_ref2) {
        var state2 = _ref2.state;
        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(attr) {
            if (attr === "placement") {
              box.setAttribute("data-placement", state2.placement);
            } else {
              if (state2.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, "");
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state2.attributes.popper = {};
        }
      }
    };
    var modifiers2 = [{
      name: "offset",
      options: {
        offset: offset5
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];
    if (getIsDefaultRenderFn() && arrow6) {
      modifiers2.push({
        name: "arrow",
        options: {
          element: arrow6,
          padding: 3
        }
      });
    }
    modifiers2.push.apply(modifiers2, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = createPopper(computedReference, popper2, Object.assign({}, popperOptions, {
      placement,
      onFirstUpdate,
      modifiers: modifiers2
    }));
  }
  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }
  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode2;
    var node = getCurrentTarget();
    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") {
      parentNode2 = node.parentNode;
    } else {
      parentNode2 = invokeWithArgsOrReturn(appendTo, [node]);
    }
    if (!parentNode2.contains(popper2)) {
      parentNode2.appendChild(popper2);
    }
    instance.state.isMounted = true;
    createPopperInstance();
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper2, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", "\n\n", "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", "\n\n", "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", "\n\n", "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
    }
  }
  function getNestedPopperTree() {
    return arrayFrom(popper2.querySelectorAll("[data-tippy-root]"));
  }
  function scheduleShow(event) {
    instance.clearDelayTimeouts();
    if (event) {
      invokeHook("onTrigger", [instance, event]);
    }
    addDocumentPress();
    var delay = getDelay(true);
    var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
    if (currentInput.isTouch && touchValue === "hold" && touchDelay) {
      delay = touchDelay;
    }
    if (delay) {
      showTimeout = setTimeout(function() {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }
  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook("onUntrigger", [instance, event]);
    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    }
    if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }
    var delay = getDelay(false);
    if (delay) {
      hideTimeout = setTimeout(function() {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      scheduleHideAnimationFrame = requestAnimationFrame(function() {
        instance.hide();
      });
    }
  }
  function enable() {
    instance.state.isEnabled = true;
  }
  function disable() {
    instance.hide();
    instance.state.isEnabled = false;
  }
  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }
  function setProps(partialProps) {
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("setProps"));
    }
    if (instance.state.isDestroyed) {
      return;
    }
    invokeHook("onBeforeUpdate", [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference2, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();
    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce2(onMouseMove, nextProps.interactiveDebounce);
    }
    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
        node.removeAttribute("aria-expanded");
      });
    } else if (nextProps.triggerTarget) {
      reference2.removeAttribute("aria-expanded");
    }
    handleAriaExpandedAttribute();
    handleStyles();
    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }
    if (instance.popperInstance) {
      createPopperInstance();
      getNestedPopperTree().forEach(function(nestedPopper) {
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }
    invokeHook("onAfterUpdate", [instance, partialProps]);
  }
  function setContent3(content) {
    instance.setProps({
      content
    });
  }
  function show() {
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("show"));
    }
    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    }
    if (getCurrentTarget().hasAttribute("disabled")) {
      return;
    }
    invokeHook("onShow", [instance], false);
    if (instance.props.onShow(instance) === false) {
      return;
    }
    instance.state.isVisible = true;
    if (getIsDefaultRenderFn()) {
      popper2.style.visibility = "visible";
    }
    handleStyles();
    addDocumentPress();
    if (!instance.state.isMounted) {
      popper2.style.transition = "none";
    }
    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
      setTransitionDuration([box, content], 0);
    }
    onFirstUpdate = function onFirstUpdate2() {
      var _instance$popperInsta2;
      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }
      ignoreOnFirstUpdate = true;
      void popper2.offsetHeight;
      popper2.style.transition = instance.props.moveTransition;
      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], "visible");
      }
      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance);
      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook("onMount", [instance]);
      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function() {
          instance.state.isShown = true;
          invokeHook("onShown", [instance]);
        });
      }
    };
    mount();
  }
  function hide5() {
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("hide"));
    }
    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }
    invokeHook("onHide", [instance], false);
    if (instance.props.onHide(instance) === false) {
      return;
    }
    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;
    if (getIsDefaultRenderFn()) {
      popper2.style.visibility = "hidden";
    }
    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);
    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], "hidden");
      }
    }
    handleAriaContentAttribute();
    handleAriaExpandedAttribute();
    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }
  function hideWithInteractivity(event) {
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("hideWithInteractivity"));
    }
    getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }
  function unmount() {
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("unmount"));
    }
    if (instance.state.isVisible) {
      instance.hide();
    }
    if (!instance.state.isMounted) {
      return;
    }
    destroyPopperInstance();
    getNestedPopperTree().forEach(function(nestedPopper) {
      nestedPopper._tippy.unmount();
    });
    if (popper2.parentNode) {
      popper2.parentNode.removeChild(popper2);
    }
    mountedInstances = mountedInstances.filter(function(i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook("onHidden", [instance]);
  }
  function destroy() {
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("destroy"));
    }
    if (instance.state.isDestroyed) {
      return;
    }
    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference2._tippy;
    instance.state.isDestroyed = true;
    invokeHook("onDestroy", [instance]);
  }
}
function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }
  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  if (process.env.NODE_ENV !== "production") {
    validateTargets(targets);
    validateProps(optionalProps, plugins);
  }
  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins
  });
  var elements = getArrayOfElements(targets);
  if (process.env.NODE_ENV !== "production") {
    var isSingleContentElement = isElement2(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", "\n\n", "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", "\n\n", "1) content: element.innerHTML\n", "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var instances = elements.reduce(function(acc, reference2) {
    var instance = reference2 && createTippy(reference2, passedProps);
    if (instance) {
      acc.push(instance);
    }
    return acc;
  }, []);
  return isElement2(targets) ? instances[0] : instances;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
Object.assign({}, applyStyles_default, {
  effect: function effect4(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }
  }
});
tippy.setDefaultProps({
  render
});
var tippy_esm_default = tippy;
var MentionList = forwardRef(({ items, command: command2, unavailableVariableIds }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const unavailableIds = unavailableVariableIds ?? /* @__PURE__ */ new Set();
  const selectItem = (index2) => {
    const item = items[index2];
    if (item) command2(item);
  };
  useEffect(() => {
    setSelectedIndex(0);
  }, [items]);
  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === "ArrowUp") {
        event.preventDefault();
        setSelectedIndex((index2) => (index2 + items.length - 1) % items.length);
        return true;
      }
      if (event.key === "ArrowDown") {
        event.preventDefault();
        setSelectedIndex((index2) => (index2 + 1) % items.length);
        return true;
      }
      if (event.key === "Enter") {
        event.preventDefault();
        selectItem(selectedIndex);
        return true;
      }
      return false;
    }
  }));
  return /* @__PURE__ */ jsx("div", { className: "bg-background border border-border rounded-md shadow-md p-1 min-w-[220px]", children: items.length ? items.map((item, index2) => {
    const isUnavailable = unavailableIds.has(item.id);
    return /* @__PURE__ */ jsxs(
      "button",
      {
        onClick: () => selectItem(index2),
        onMouseDown: (e) => e.preventDefault(),
        type: "button",
        title: isUnavailable ? "This variable may not be available for the current trigger type" : void 0,
        className: `flex items-center gap-1.5 w-full text-left px-2 py-1.5 rounded text-xs ${isUnavailable ? "opacity-50" : ""} ${index2 === selectedIndex ? "bg-muted text-foreground" : "hover:bg-muted text-foreground"}`,
        children: [
          isUnavailable && /* @__PURE__ */ jsx(TriangleAlert, { className: "size-3 shrink-0 text-destructive" }),
          /* @__PURE__ */ jsxs("span", { children: [
            item.name,
            " (",
            item.id,
            ")"
          ] })
        ]
      },
      item.id
    );
  }) : /* @__PURE__ */ jsx("div", { className: "px-2 py-2 text-xs text-muted-foreground", children: "No results" }) });
});
MentionList.displayName = "MentionList";
function createVariablesMentionExtension(variables, unavailableVariableIds = /* @__PURE__ */ new Set()) {
  const suggestion = {
    char: "@",
    allowSpaces: false,
    startOfLine: false,
    // Allow triggering after any character (including letters/numbers)
    // Some Tiptap versions support `allowedPrefixes`; setting it to null allows any prefix.
    // Cast to any to avoid type friction across versions.
    ...{ allowedPrefixes: null },
    allow: () => true,
    command: ({ editor, range, props }) => {
      const { state } = editor;
      const marks = state.storedMarks || state.selection.$from.marks();
      const markTypes = marks.map((mark) => ({
        type: mark.type.name,
        attrs: mark.attrs
      }));
      const nodeAfter = state.selection.$to.nodeAfter;
      const overrideSpace = nodeAfter?.text?.startsWith(" ");
      if (overrideSpace) {
        range.to += 1;
      }
      editor.chain().focus().insertContentAt(range, [
        {
          type: "mention",
          attrs: { ...props, mentionSuggestionChar: "@" },
          marks: markTypes
        },
        {
          type: "text",
          text: " ",
          marks: markTypes
        }
      ]).run();
      editor.view.dom.ownerDocument.defaultView?.getSelection()?.collapseToEnd();
    },
    items: ({ query }) => {
      const q = query?.toLowerCase() ?? "";
      const list = variables.filter((item) => item.pickable !== false).filter(
        (item) => [item.name, item.id].some((v) => v.toLowerCase().includes(q))
      ).slice(0, 10);
      return list;
    },
    render: () => {
      let component = null;
      let popup = null;
      return {
        onStart: (props) => {
          try {
            document.body.dataset.mentionOpen = "true";
          } catch {
          }
          component = new ReactRenderer(MentionList, {
            props: {
              items: props.items,
              command: (item) => props.command({ id: item.id, label: item.name }),
              unavailableVariableIds
            },
            editor: props.editor
          });
          popup = tippy_esm_default("body", {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start"
          });
        },
        onUpdate(props) {
          component?.updateProps({
            items: props.items,
            command: (item) => props.command({ id: item.id, label: item.name }),
            unavailableVariableIds
          });
          popup?.[0]?.setProps({
            getReferenceClientRect: props.clientRect
          });
        },
        onKeyDown(props) {
          if (props.event.key === "Escape") {
            popup?.[0]?.hide();
            return true;
          }
          return component && component.ref ? component.ref.onKeyDown(props) : false;
        },
        onExit() {
          try {
            delete document.body.dataset.mentionOpen;
          } catch {
          }
          popup?.[0]?.destroy();
          popup = null;
          component?.destroy();
          component = null;
        }
      };
    }
  };
  const MentionWithNodeView = index_default2.extend({
    marks: "_",
    addStorage() {
      return { unavailableVariableIds };
    },
    addNodeView() {
      return ReactNodeViewRenderer(MentionNodeView);
    }
  });
  return MentionWithNodeView.configure({
    suggestion,
    renderText({
      node
    }) {
      const attrs = node.attrs;
      return `{{${attrs.id}}}`;
    },
    renderHTML({
      options,
      node
    }) {
      const attrs = node.attrs;
      const text = `${options.suggestion.char}${attrs.label ?? attrs.id}`;
      return [
        "span",
        { ...options.HTMLAttributes || {}, "data-type": "mention" },
        text
      ];
    },
    HTMLAttributes: {
      class: "mention",
      style: "background: rgba(0,0,0,0.05); padding: 0 2px; border-radius: 3px;"
    }
  });
}
var mention_extension_default = createVariablesMentionExtension;
function MentionNodeView(props) {
  const attrs = props.node.attrs;
  const label = attrs.label ?? attrs.id ?? "";
  const unavailableIds = props.extension.storage.unavailableVariableIds;
  const isUnavailable = attrs.id ? unavailableIds.has(attrs.id) : false;
  return /* @__PURE__ */ jsxs(
    NodeViewWrapper,
    {
      as: "span",
      className: `mention px-1 whitespace-nowrap text-xs rounded-sm ${isUnavailable ? "border-b border-b-destructive/50 bg-destructive/10 text-destructive" : "border-b border-b-primary/30 bg-primary/10 text-primary"}`,
      "data-type": "mention",
      "data-id": attrs.id ?? "",
      contentEditable: false,
      title: isUnavailable ? "This variable may not be available for the current trigger type" : void 0,
      children: [
        isUnavailable && /* @__PURE__ */ jsx(TriangleAlert, { className: "inline size-3 mr-0.5 align-text-bottom" }),
        "@",
        label
      ]
    }
  );
}
function parseMentionsFromText(text, variables) {
  const cleanedText = text.replace(/<p><\/p>$/g, "").replace(/<br\s*\/?>$/g, "");
  const regex = /\{\{([^}]+)\}\}/g;
  const nodes = [];
  let lastIndex = 0;
  let match;
  while ((match = regex.exec(cleanedText)) !== null) {
    if (match.index > lastIndex) {
      nodes.push({
        type: "text",
        text: cleanedText.slice(lastIndex, match.index)
      });
    }
    const variableId = match[1];
    const variable = variables.find((v) => v.id === variableId) || variables.find((v) => v.name === variableId);
    const id = variable?.id || variableId;
    const label = variable?.name || variableId;
    nodes.push({
      type: "mention",
      attrs: { id, label }
    });
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < cleanedText.length) {
    nodes.push({
      type: "text",
      text: cleanedText.slice(lastIndex)
    });
  }
  const paragraph = { type: "paragraph" };
  if (nodes.length > 0) {
    paragraph.content = nodes;
  } else if (cleanedText.length > 0) {
    paragraph.content = [{ type: "text", text: cleanedText }];
  }
  return {
    type: "doc",
    content: [paragraph]
  };
}

// ../../node_modules/.pnpm/@tiptap+extension-paragraph@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-paragraph/dist/index.js
var EMPTY_PARAGRAPH_MARKDOWN = "&nbsp;";
var NBSP_CHAR = "\xA0";
var Paragraph = Node3.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["p", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  parseMarkdown: (token, helpers) => {
    const tokens = token.tokens || [];
    if (tokens.length === 1 && tokens[0].type === "image") {
      return helpers.parseChildren([tokens[0]]);
    }
    const content = helpers.parseInline(tokens);
    if (content.length === 1 && content[0].type === "text" && (content[0].text === EMPTY_PARAGRAPH_MARKDOWN || content[0].text === NBSP_CHAR)) {
      return helpers.createNode("paragraph", void 0, []);
    }
    return helpers.createNode("paragraph", void 0, content);
  },
  renderMarkdown: (node, h2) => {
    if (!node) {
      return "";
    }
    const content = Array.isArray(node.content) ? node.content : [];
    if (content.length === 0) {
      return EMPTY_PARAGRAPH_MARKDOWN;
    }
    return h2.renderChildren(content);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands }) => {
        return commands.setNode(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
});
var index_default3 = Paragraph;

// ../../node_modules/.pnpm/@tiptap+extension-text@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-text/dist/index.js
var Text = Node3.create({
  name: "text",
  group: "inline",
  parseMarkdown: (token) => {
    return {
      type: "text",
      text: token.text || ""
    };
  },
  renderMarkdown: (node) => node.text || ""
});
var index_default4 = Text;
var DEFAULT_BANNER = {
  href: "",
  imageUrl: "https://via.assets.so/img.jpg?w=600&h=300&bg=e5e7eb&text=No+image&f=png",
  imageId: null,
  imageUploadKey: null
};
function EmailPanelImage() {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI } = blockProps;
  const block = blockProps.block;
  const item = block.properties?.items?.[0] ?? DEFAULT_BANNER;
  const unavailableVariableIds = useUnavailableVariableIds();
  const [imageUrl, setImageUrl] = useState(
    item.imageId ? `https://baback-banner-images.s3.eu-west-3.amazonaws.com/${item.imageId}` : item.imageUrl ?? DEFAULT_BANNER.imageUrl
  );
  useEffect(() => {
    if (item.imageId) {
      const s3Url = `https://baback-banner-images.s3.eu-west-3.amazonaws.com/${item.imageId}`;
      setImageUrl(s3Url);
    } else if (item.imageUrl) {
      setImageUrl(item.imageUrl);
    }
  }, [item.imageId, item.imageUrl]);
  const handleBannerSave = (values) => {
    const imageUploadKey = item.imageUploadKey ?? crypto.randomUUID();
    if (values.imageFile) {
      setImageUrl(URL.createObjectURL(values.imageFile));
    }
    if (values.removeImage) {
      setImageUrl(DEFAULT_BANNER.imageUrl);
      formAPI.registerImage(imageUploadKey, null);
      return formAPI.updateField(`${formAPI.blockPath}.properties`, {
        items: []
      });
    }
    formAPI.registerImage(imageUploadKey, values.imageFile);
    formAPI.updateField(`${formAPI.blockPath}.properties.items.0`, {
      href: values.href,
      // craftsman-ignore: TS003
      imageUrl: values.imageFile ? URL.createObjectURL(values.imageFile) : null,
      imageId: null,
      imageUploadKey
    });
  };
  const hrefEditor = useEditor({
    extensions: [
      index_default,
      mention_extension_default(blockProps.variables, unavailableVariableIds),
      index_default3,
      index_default4
    ],
    content: parseMentionsFromText(item.href ?? "", blockProps.variables),
    editorProps: {
      attributes: {
        class: "min-h-9 px-3 py-2 text-sm rounded-md border bg-background outline-none ring-0 focus:outline-none focus:ring-0",
        style: "white-space: pre-wrap;"
      }
    }
  });
  useEffect(() => {
    if (!hrefEditor) return;
    const doc3 = parseMentionsFromText(item.href ?? "", blockProps.variables);
    if (hrefEditor.getJSON && JSON.stringify(hrefEditor.getJSON()) !== JSON.stringify(doc3)) {
      hrefEditor.commands.setContent(doc3, { emitUpdate: false });
    }
  }, [hrefEditor, item.href, open, blockProps.variables]);
  const fileInputRef = useRef(null);
  const objectUrlRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(
    imageUrl && imageUrl !== DEFAULT_BANNER.imageUrl ? imageUrl : null
  );
  const [errorMessage, setErrorMessage] = useState(null);
  useEffect(
    () => () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    },
    []
  );
  const applyFile = useCallback((file) => {
    if (!file.type.startsWith("image/")) {
      setErrorMessage("Please choose an image file.");
      return;
    }
    setErrorMessage(null);
    if (objectUrlRef.current) {
      URL.revokeObjectURL(objectUrlRef.current);
    }
    const url = URL.createObjectURL(file);
    objectUrlRef.current = url;
    setPreviewUrl(url);
    handleBannerSave?.({
      href: item.href ?? "",
      imageFile: file,
      removeImage: false
    });
  }, []);
  const handleDrop2 = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      setIsDragging(false);
      const [file] = Array.from(event.dataTransfer.files ?? []);
      if (file) {
        applyFile(file);
      }
    },
    [applyFile]
  );
  const handleDragOver = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  }, []);
  const handleDragLeave = useCallback(() => {
    setIsDragging(false);
  }, []);
  const handleFileInputChange = useCallback(
    (event) => {
      const [file] = Array.from(event.target.files ?? []);
      if (file) {
        applyFile(file);
      }
      event.target.value = "";
    },
    [applyFile]
  );
  const handleChooseFile = useCallback(() => {
    fileInputRef.current?.click();
  }, []);
  const handleKeyDown2 = useCallback(
    (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleChooseFile();
      }
    },
    [handleChooseFile]
  );
  const handleRemoveImage = useCallback(() => {
    if (objectUrlRef.current) {
      URL.revokeObjectURL(objectUrlRef.current);
      objectUrlRef.current = null;
    }
    setPreviewUrl(null);
    setErrorMessage(null);
    handleBannerSave?.({
      href: "",
      imageFile: null,
      removeImage: true
    });
  }, []);
  return /* @__PURE__ */ jsx(PanelContent, { title: "Image", children: /* @__PURE__ */ jsxs("div", { className: "space-y-2 w-full", children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        role: "button",
        tabIndex: 0,
        onClick: handleChooseFile,
        onKeyDown: handleKeyDown2,
        onDrop: handleDrop2,
        onDragOver: handleDragOver,
        onDragLeave: handleDragLeave,
        className: cn(
          "group relative flex min-h-[8rem] w-full cursor-pointer flex-col items-center justify-center gap-3 rounded-md border border-dashed bg-muted/40 text-center text-sm text-muted-foreground transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
          isDragging && "border-primary bg-primary/5 text-primary",
          previewUrl && "border border-solid border-muted-foreground/25 bg-background p-2"
        ),
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "file",
              accept: "image/*",
              ref: fileInputRef,
              onChange: handleFileInputChange,
              className: "hidden"
            }
          ),
          previewUrl ? /* @__PURE__ */ jsxs("div", { className: "relative w-full", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: previewUrl,
                alt: "Selected banner preview",
                className: "h-40 w-full rounded-md object-cover"
              }
            ),
            /* @__PURE__ */ jsxs(
              Button,
              {
                variant: "secondary",
                size: "sm",
                onClick: (event) => {
                  event.stopPropagation();
                  handleRemoveImage();
                },
                className: "absolute right-3 top-3",
                children: [
                  /* @__PURE__ */ jsx(Trash2, { className: "mr-1 size-4" }),
                  "Remove"
                ]
              }
            )
          ] }) : /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center gap-2", children: [
            /* @__PURE__ */ jsx(CloudUpload, { className: "size-8" }),
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("p", { className: "font-medium", children: "Drop an image here" }),
              /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: "or click to select a file" })
            ] })
          ] })
        ]
      }
    ),
    errorMessage ? /* @__PURE__ */ jsx("p", { className: "text-sm text-destructive", children: errorMessage }) : null
  ] }) });
}
function BannerEditor({ formAPI, ...props }) {
  const { block, shop } = props;
  const item = block.properties?.items?.[0] ?? DEFAULT_BANNER;
  const imageUrl = item.imageId ? `https://baback-banner-images.s3.eu-west-3.amazonaws.com/${item.imageId}` : item.imageUrl ?? DEFAULT_BANNER.imageUrl;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(EmailComponentWrapper, { shop, children: /* @__PURE__ */ jsx(
    BannerEmailRenderer,
    {
      formAPI: {
        blockPath: "",
        updateField: () => {
        },
        getFieldValue: () => {
        },
        registerImage: () => {
        }
      },
      ...props,
      block: {
        ...props.block,
        properties: {
          items: [
            {
              ...item,
              imageId: null,
              imageUrl
            }
          ]
        }
      }
    }
  ) }) }) });
}
function PanelVariableInputContent({
  title,
  value,
  onChange,
  variables,
  id,
  placeholder,
  outputFormat = "text",
  triggerOnChange = false
}) {
  const unavailableVariableIds = useUnavailableVariableIds();
  const editor = useEditor({
    extensions: [
      index_default,
      createVariablesMentionExtension(variables, unavailableVariableIds),
      index_default3,
      index_default4
    ],
    content: outputFormat === "html" ? value : parseMentionsFromText(value ?? "", variables),
    editorProps: {
      attributes: {
        class: "min-h-9 px-3 py-2 text-sm rounded-md border bg-background outline-none ring-0 focus:outline-none focus:ring-0",
        style: "white-space: nowrap; overflow-x: auto;",
        ...placeholder && { placeholder }
      },
      handleKeyDown: (view, event) => {
        if (view && event.key === "Enter") {
          event.preventDefault();
          return true;
        }
        return false;
      }
    },
    onUpdate: triggerOnChange ? ({ editor: editor2 }) => {
      const content = outputFormat === "html" ? editor2.getHTML() : editor2.getText();
      onChange(content);
    } : void 0
  });
  useEffect(() => {
    if (!editor) return;
    const doc3 = outputFormat === "html" ? value : parseMentionsFromText(value ?? "", variables);
    if (editor.getJSON && JSON.stringify(editor.getJSON()) !== JSON.stringify(doc3)) {
      editor.commands.setContent(doc3, { emitUpdate: false });
    }
  }, [editor, value, variables, outputFormat]);
  const handleBlur = () => {
    if (!editor) return;
    const content = outputFormat === "html" ? editor.getHTML() : editor.getText();
    onChange(content);
  };
  return /* @__PURE__ */ jsx(PanelContent, { title, children: /* @__PURE__ */ jsx(
    EditorContent,
    {
      editor,
      id,
      className: "w-full",
      ...!triggerOnChange && { onBlur: handleBlur }
    }
  ) });
}
function EmailPanelUrl() {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI } = blockProps;
  const block = blockProps.block;
  const item = block.properties?.items?.[0];
  const handleSave = useCallback(
    (href) => {
      if (!item) return;
      formAPI.updateField(`${formAPI.blockPath}.properties.items.0`, {
        href,
        imageUrl: item.imageUrl,
        imageId: item.imageId,
        imageUploadKey: item.imageUploadKey
      });
    },
    [formAPI, item]
  );
  return /* @__PURE__ */ jsx(
    PanelVariableInputContent,
    {
      title: "Url",
      value: item?.href ?? "",
      onChange: handleSave,
      variables: blockProps.variables,
      id: "banner-href",
      triggerOnChange: true
    }
  );
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var _excluded$T = ["color"];
var CheckIcon = /* @__PURE__ */ forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$T);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$U = ["color"];
var CheckCircledIcon = /* @__PURE__ */ forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$U);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$W = ["color"];
var ChevronDownIcon = /* @__PURE__ */ forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$W);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$Y = ["color"];
var ChevronRightIcon = /* @__PURE__ */ forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$Y);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$Z = ["color"];
var ChevronUpIcon = /* @__PURE__ */ forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$Z);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$1r = ["color"];
var Cross2Icon = /* @__PURE__ */ forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$1r);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$1I = ["color"];
var DotFilledIcon = /* @__PURE__ */ forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$1I);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
    fill: color
  }));
});
var _excluded$4Q = ["color"];
var ValueNoneIcon = /* @__PURE__ */ forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$4Q);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
  const onEscapeKeyDown = useCallbackRef(onEscapeKeyDownProp);
  React49.useEffect(() => {
    const handleKeyDown2 = (event) => {
      if (event.key === "Escape") {
        onEscapeKeyDown(event);
      }
    };
    ownerDocument.addEventListener("keydown", handleKeyDown2, { capture: true });
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown2, { capture: true });
  }, [onEscapeKeyDown, ownerDocument]);
}
var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = React49.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
var DismissableLayer = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      disableOutsidePointerEvents = false,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss,
      ...layerProps
    } = props;
    const context = React49.useContext(DismissableLayerContext);
    const [node, setNode2] = React49.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = React49.useState({});
    const composedRefs = useComposedRefs(forwardedRef, (node2) => setNode2(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index2 = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = usePointerDownOutside((event) => {
      const target = event.target;
      const isPointerDownOnBranch = [...context.branches].some((branch) => branch.contains(target));
      if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
      onPointerDownOutside?.(event);
      onInteractOutside?.(event);
      if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = useFocusOutside((event) => {
      const target = event.target;
      const isFocusInBranch = [...context.branches].some((branch) => branch.contains(target));
      if (isFocusInBranch) return;
      onFocusOutside?.(event);
      onInteractOutside?.(event);
      if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    useEscapeKeydown((event) => {
      const isHighestLayer = index2 === context.layers.size - 1;
      if (!isHighestLayer) return;
      onEscapeKeyDown?.(event);
      if (!event.defaultPrevented && onDismiss) {
        event.preventDefault();
        onDismiss();
      }
    }, ownerDocument);
    React49.useEffect(() => {
      if (!node) return;
      if (disableOutsidePointerEvents) {
        if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
          originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
          ownerDocument.body.style.pointerEvents = "none";
        }
        context.layersWithOutsidePointerEventsDisabled.add(node);
      }
      context.layers.add(node);
      dispatchUpdate();
      return () => {
        if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) {
          ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
        }
      };
    }, [node, ownerDocument, disableOutsidePointerEvents, context]);
    React49.useEffect(() => {
      return () => {
        if (!node) return;
        context.layers.delete(node);
        context.layersWithOutsidePointerEventsDisabled.delete(node);
        dispatchUpdate();
      };
    }, [node, context]);
    React49.useEffect(() => {
      const handleUpdate = () => force({});
      document.addEventListener(CONTEXT_UPDATE, handleUpdate);
      return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        ...layerProps,
        ref: composedRefs,
        style: {
          pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
          ...props.style
        },
        onFocusCapture: composeEventHandlers(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: composeEventHandlers(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: composeEventHandlers(
          props.onPointerDownCapture,
          pointerDownOutside.onPointerDownCapture
        )
      }
    );
  }
);
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = React49.forwardRef((props, forwardedRef) => {
  const context = React49.useContext(DismissableLayerContext);
  const ref = React49.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  React49.useEffect(() => {
    const node = ref.current;
    if (node) {
      context.branches.add(node);
      return () => {
        context.branches.delete(node);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */ jsx(Primitive.div, { ...props, ref: composedRefs });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
  const handlePointerDownOutside = useCallbackRef(onPointerDownOutside);
  const isPointerInsideReactTreeRef = React49.useRef(false);
  const handleClickRef = React49.useRef(() => {
  });
  React49.useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          handleAndDispatchCustomEvent(
            POINTER_DOWN_OUTSIDE,
            handlePointerDownOutside,
            eventDetail,
            { discrete: true }
          );
        };
        const eventDetail = { originalEvent: event };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, { once: true });
        } else {
          handleAndDispatchPointerDownOutsideEvent2();
        }
      } else {
        ownerDocument.removeEventListener("click", handleClickRef.current);
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
  const handleFocusOutside = useCallbackRef(onFocusOutside);
  const isFocusInsideReactTreeRef = React49.useRef(false);
  React49.useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, { bubbles: false, cancelable: true, detail });
  if (handler) target.addEventListener(name, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
var count2 = 0;
function useFocusGuards() {
  React49.useEffect(() => {
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? createFocusGuard());
    document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? createFocusGuard());
    count2++;
    return () => {
      if (count2 === 1) {
        document.querySelectorAll("[data-radix-focus-guard]").forEach((node) => node.remove());
      }
      count2--;
    };
  }, []);
}
function createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.outline = "none";
  element.style.opacity = "0";
  element.style.position = "fixed";
  element.style.pointerEvents = "none";
  return element;
}
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS2 = { bubbles: false, cancelable: true };
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = React49.forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container, setContainer] = React49.useState(null);
  const onMountAutoFocus = useCallbackRef(onMountAutoFocusProp);
  const onUnmountAutoFocus = useCallbackRef(onUnmountAutoFocusProp);
  const lastFocusedElementRef = React49.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, (node) => setContainer(node));
  const focusScope = React49.useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  React49.useEffect(() => {
    if (trapped) {
      let handleFocusIn2 = function(event) {
        if (focusScope.paused || !container) return;
        const target = event.target;
        if (container.contains(target)) {
          lastFocusedElementRef.current = target;
        } else {
          focus2(lastFocusedElementRef.current, { select: true });
        }
      }, handleFocusOut2 = function(event) {
        if (focusScope.paused || !container) return;
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null) return;
        if (!container.contains(relatedTarget)) {
          focus2(lastFocusedElementRef.current, { select: true });
        }
      }, handleMutations2 = function(mutations) {
        const focusedElement = document.activeElement;
        if (focusedElement !== document.body) return;
        for (const mutation of mutations) {
          if (mutation.removedNodes.length > 0) focus2(container);
        }
      };
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      const mutationObserver = new MutationObserver(handleMutations2);
      if (container) mutationObserver.observe(container, { childList: true, subtree: true });
      return () => {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container, focusScope.paused]);
  React49.useEffect(() => {
    if (container) {
      focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS2);
        container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst2(removeLinks(getTabbableCandidates(container)), { select: true });
          if (document.activeElement === previouslyFocusedElement) {
            focus2(container);
          }
        }
      }
      return () => {
        container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS2);
          container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            focus2(previouslyFocusedElement ?? document.body, { select: true });
          }
          container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown2 = React49.useCallback(
    (event) => {
      if (!loop && !trapped) return;
      if (focusScope.paused) return;
      const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
      const focusedElement = document.activeElement;
      if (isTabKey && focusedElement) {
        const container2 = event.currentTarget;
        const [first2, last] = getTabbableEdges(container2);
        const hasTabbableElementsInside = first2 && last;
        if (!hasTabbableElementsInside) {
          if (focusedElement === container2) event.preventDefault();
        } else {
          if (!event.shiftKey && focusedElement === last) {
            event.preventDefault();
            if (loop) focus2(first2, { select: true });
          } else if (event.shiftKey && focusedElement === first2) {
            event.preventDefault();
            if (loop) focus2(last, { select: true });
          }
        }
      }
    },
    [loop, trapped, focusScope.paused]
  );
  return /* @__PURE__ */ jsx(Primitive.div, { tabIndex: -1, ...scopeProps, ref: composedRefs, onKeyDown: handleKeyDown2 });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst2(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    focus2(candidate, { select });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function getTabbableEdges(container) {
  const candidates = getTabbableCandidates(container);
  const first2 = findVisible(candidates, container);
  const last = findVisible(candidates.reverse(), container);
  return [first2, last];
}
function getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container) {
  for (const element of elements) {
    if (!isHidden(element, { upTo: container })) return element;
  }
}
function isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === "hidden") return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === "none") return true;
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function focus2(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({ preventScroll: true });
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select)
      element.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope?.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      stack = arrayRemove(stack, focusScope);
      stack[0]?.resume();
    }
  };
}
function arrayRemove(array, item) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) {
    updatedArray.splice(index2, 1);
  }
  return updatedArray;
}
function removeLinks(items) {
  return items.filter((item) => item.tagName !== "A");
}

// ../../node_modules/.pnpm/@floating-ui+utils@0.2.10/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var sides = ["top", "right", "bottom", "left"];
var min2 = Math.min;
var max2 = Math.max;
var round2 = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
  x: v,
  y: v
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
var oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp2(start2, value, end2) {
  return max2(start2, min2(value, end2));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide2(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
var yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(placement) {
  return yAxisSides.has(getSide2(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement2(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement2(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement2(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
var lrPlacement = ["left", "right"];
var rlPlacement = ["right", "left"];
var tbPlacement = ["top", "bottom"];
var btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide2(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement2(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect2(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

// ../../node_modules/.pnpm/@floating-ui+core@1.7.3/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference: reference2,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide2(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference2.x + reference2.width / 2 - floating.width / 2;
  const commonY = reference2.y + reference2.height / 2 - floating.height / 2;
  const commonAlign = reference2[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference2.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case "right":
      coords = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference2.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference2.x,
        y: reference2.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
var computePosition = async (reference2, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference: reference2,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn: fn2
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset: reset2
    } = await fn2({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference: reference2,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset2 && resetCount <= 50) {
      resetCount++;
      if (typeof reset2 === "object") {
        if (reset2.placement) {
          statefulPlacement = reset2.placement;
        }
        if (reset2.rects) {
          rects = reset2.rects === true ? await platform2.getElementRects({
            reference: reference2,
            floating,
            strategy
          }) : reset2.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow2(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect2(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect2(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
var arrow2 = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min2(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min2(paddingObject[maxProp], largestPossiblePadding);
    const min$1 = minPadding;
    const max3 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset5 = clamp2(min$1, center, max3);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset5 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max3 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset5,
        centerOffset: center - offset5 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
var flip2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide2(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide2(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement2(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements3 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow2(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements3[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d) => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets2(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped2(overflow) {
  return sides.some((side) => overflow[side] >= 0);
}
var hide2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "hide",
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = "referenceHidden",
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case "referenceHidden": {
          const overflow = await detectOverflow2(state, {
            ...detectOverflowOptions,
            elementContext: "reference"
          });
          const offsets = getSideOffsets2(overflow, rects.reference);
          return {
            data: {
              referenceHiddenOffsets: offsets,
              referenceHidden: isAnySideFullyClipped2(offsets)
            }
          };
        }
        case "escaped": {
          const overflow = await detectOverflow2(state, {
            ...detectOverflowOptions,
            altBoundary: true
          });
          const offsets = getSideOffsets2(overflow, rects.floating);
          return {
            data: {
              escapedOffsets: offsets,
              escaped: isAnySideFullyClipped2(offsets)
            }
          };
        }
        default: {
          return {};
        }
      }
    }
  };
};
var originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide2(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
var offset2 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
var shift2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow2(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide2(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min3 = mainAxisCoord + overflow[minSide];
        const max3 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp2(min3, mainAxisCoord, max3);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min3 = crossAxisCoord + overflow[minSide];
        const max3 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp2(min3, crossAxisCoord, max3);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
var limitShift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset5 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset5, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = originSides.has(getSide2(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
var size = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply: apply2 = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow2(state, detectOverflowOptions);
      const side = getSide2(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min2(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min2(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max2(overflow.left, 0);
        const xMax = max2(overflow.right, 0);
        const yMin = max2(overflow.top, 0);
        const yMax = max2(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max2(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max2(overflow.top, overflow.bottom));
        }
      }
      await apply2({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

// ../../node_modules/.pnpm/@floating-ui+utils@0.2.10/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName2(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow2(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement2(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow2(value).Node;
}
function isElement3(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow2(value).Element;
}
function isHTMLElement2(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow2(value).HTMLElement;
}
function isShadowRoot2(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow2(value).ShadowRoot;
}
var invalidOverflowDisplayValues = /* @__PURE__ */ new Set(["inline", "contents"]);
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle3(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
var tableElements = /* @__PURE__ */ new Set(["table", "td", "th"]);
function isTableElement2(element) {
  return tableElements.has(getNodeName2(element));
}
var topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element) {
  return topLayerSelectors.some((selector) => {
    try {
      return element.matches(selector);
    } catch (_e) {
      return false;
    }
  });
}
var transformProperties = ["transform", "translate", "scale", "rotate", "perspective"];
var willChangeValues = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
var containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(elementOrCss) {
  const webkit2 = isWebKit();
  const css = isElement3(elementOrCss) ? getComputedStyle3(elementOrCss) : elementOrCss;
  return transformProperties.some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit2 && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit2 && (css.filter ? css.filter !== "none" : false) || willChangeValues.some((value) => (css.willChange || "").includes(value)) || containValues.some((value) => (css.contain || "").includes(value));
}
function getContainingBlock2(element) {
  let currentNode = getParentNode2(element);
  while (isHTMLElement2(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode2(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
var lastTraversableNodeNames = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName2(node));
}
function getComputedStyle3(element) {
  return getWindow2(element).getComputedStyle(element);
}
function getNodeScroll2(element) {
  if (isElement3(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode2(node) {
  if (getNodeName2(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot2(node) && node.host || // Fallback.
    getDocumentElement2(node)
  );
  return isShadowRoot2(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode2 = getParentNode2(node);
  if (isLastTraversableNode(parentNode2)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement2(parentNode2) && isOverflowElement(parentNode2)) {
    return parentNode2;
  }
  return getNearestOverflowAncestor(parentNode2);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow2(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

// ../../node_modules/.pnpm/@floating-ui+dom@1.7.4/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
  const css = getComputedStyle3(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement2(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round2(width) !== offsetWidth || round2(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement3(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement2(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round2(rect.width) : rect.width) / width;
  let y = ($ ? round2(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow2(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow2(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect2(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect2 = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement3(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect2.left + visualOffsets.x) / scale.x;
  let y = (clientRect2.top + visualOffsets.y) / scale.y;
  let width = clientRect2.width / scale.x;
  let height = clientRect2.height / scale.y;
  if (domElement) {
    const win = getWindow2(domElement);
    const offsetWin = offsetParent && isElement3(offsetParent) ? getWindow2(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle3(currentIFrame);
      const left2 = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left2;
      y += top2;
      currentWin = getWindow2(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect2({
    width,
    height,
    x,
    y
  });
}
function getWindowScrollBarX2(element, rect) {
  const leftScroll = getNodeScroll2(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect2(getDocumentElement2(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX2(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement2(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement2(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName2(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll2(offsetParent);
    }
    if (isHTMLElement2(offsetParent)) {
      const offsetRect = getBoundingClientRect2(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect2(element) {
  const html = getDocumentElement2(element);
  const scroll = getNodeScroll2(element);
  const body = element.ownerDocument.body;
  const width = max2(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max2(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX2(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle3(body).direction === "rtl") {
    x += max2(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
var SCROLLBAR_MAX = 25;
function getViewportRect2(element, strategy) {
  const win = getWindow2(element);
  const html = getDocumentElement2(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX2(html);
  if (windowScrollbarX <= 0) {
    const doc3 = html.ownerDocument;
    const body = doc3.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc3.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x,
    y
  };
}
var absoluteOrFixed = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect2(element, strategy) {
  const clientRect2 = getBoundingClientRect2(element, true, strategy === "fixed");
  const top2 = clientRect2.top + element.clientTop;
  const left2 = clientRect2.left + element.clientLeft;
  const scale = isHTMLElement2(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left2 * scale.x;
  const y = top2 * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect2(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect2(getDocumentElement2(element));
  } else if (isElement3(clippingAncestor)) {
    rect = getInnerBoundingClientRect2(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect2(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode2 = getParentNode2(element);
  if (parentNode2 === stopNode || !isElement3(parentNode2) || isLastTraversableNode(parentNode2)) {
    return false;
  }
  return getComputedStyle3(parentNode2).position === "fixed" || hasFixedPositionAncestor(parentNode2, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult2 = cache.get(element);
  if (cachedResult2) {
    return cachedResult2;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement3(el) && getNodeName2(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle3(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode2(element) : element;
  while (isElement3(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle3(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode2(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect2(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max2(rect.top, accRect.top);
    accRect.right = min2(rect.right, accRect.right);
    accRect.bottom = min2(rect.bottom, accRect.bottom);
    accRect.left = max2(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement2(offsetParent);
  const documentElement = getDocumentElement2(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect2(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX2(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName2(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll2(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect2(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle3(element).position === "static";
}
function getTrueOffsetParent2(element, polyfill) {
  if (!isHTMLElement2(element) || getComputedStyle3(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement2(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent2(element, polyfill) {
  const win = getWindow2(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement2(element)) {
    let svgOffsetParent = getParentNode2(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement3(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode2(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent2(element, polyfill);
  while (offsetParent && isTableElement2(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent2(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock2(element) || win;
}
var getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent2;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle3(element).direction === "rtl";
}
var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement2,
  getClippingRect: getClippingRect2,
  getOffsetParent: getOffsetParent2,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement3,
  isRTL
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement2(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left: left2,
      top: top2,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top2);
    const insetRight = floor(root.clientWidth - (left2 + width));
    const insetBottom = floor(root.clientHeight - (top2 + height));
    const insetLeft = floor(left2);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max2(0, min2(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference2, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference2);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect2(reference2) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect2(reference2);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var offset3 = offset2;
var shift3 = shift2;
var flip3 = flip2;
var size2 = size;
var hide3 = hide2;
var arrow3 = arrow2;
var limitShift2 = limitShift;
var computePosition2 = (reference2, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference2, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var isClient = typeof document !== "undefined";
var noop = function noop2() {
};
var index = isClient ? useLayoutEffect : noop;
function deepEqual2(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys3;
  if (a && b && typeof a === "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual2(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys3 = Object.keys(a);
    length = keys3.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys3[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys3[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual2(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React49.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open: open2
  } = options;
  const [data, setData] = React49.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React49.useState(middleware);
  if (!deepEqual2(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React49.useState(null);
  const [_floating, _setFloating] = React49.useState(null);
  const setReference = React49.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React49.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React49.useRef(null);
  const floatingRef = React49.useRef(null);
  const dataRef = React49.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open2);
  const update = React49.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition2(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual2(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM6.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open2 === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open2]);
  const isMountedRef = React49.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React49.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React49.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React49.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React49.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
var arrow$1 = (options) => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === "function" ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow3({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow3({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};
var offset4 = (options, deps) => ({
  ...offset3(options),
  options: [options, deps]
});
var shift4 = (options, deps) => ({
  ...shift3(options),
  options: [options, deps]
});
var limitShift3 = (options, deps) => ({
  ...limitShift2(options),
  options: [options, deps]
});
var flip4 = (options, deps) => ({
  ...flip3(options),
  options: [options, deps]
});
var size3 = (options, deps) => ({
  ...size2(options),
  options: [options, deps]
});
var hide4 = (options, deps) => ({
  ...hide3(options),
  options: [options, deps]
});
var arrow4 = (options, deps) => ({
  ...arrow$1(options),
  options: [options, deps]
});
var NAME2 = "Arrow";
var Arrow = React49.forwardRef((props, forwardedRef) => {
  const { children, width = 10, height = 5, ...arrowProps } = props;
  return /* @__PURE__ */ jsx(
    Primitive.svg,
    {
      ...arrowProps,
      ref: forwardedRef,
      width,
      height,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: props.asChild ? children : /* @__PURE__ */ jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Arrow.displayName = NAME2;
var Root4 = Arrow;
function useSize(element) {
  const [size4, setSize] = React49.useState(void 0);
  useLayoutEffect2(() => {
    if (element) {
      setSize({ width: element.offsetWidth, height: element.offsetHeight });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({ width, height });
      });
      resizeObserver.observe(element, { box: "border-box" });
      return () => resizeObserver.unobserve(element);
    } else {
      setSize(void 0);
    }
  }, [element]);
  return size4;
}
var POPPER_NAME = "Popper";
var [createPopperContext, createPopperScope] = createContextScope(POPPER_NAME);
var [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
var Popper = (props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = React49.useState(null);
  return /* @__PURE__ */ jsx(PopperProvider, { scope: __scopePopper, anchor, onAnchorChange: setAnchor, children });
};
Popper.displayName = POPPER_NAME;
var ANCHOR_NAME = "PopperAnchor";
var PopperAnchor = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopper, virtualRef, ...anchorProps } = props;
    const context = usePopperContext(ANCHOR_NAME, __scopePopper);
    const ref = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const anchorRef = React49.useRef(null);
    React49.useEffect(() => {
      const previousAnchor = anchorRef.current;
      anchorRef.current = virtualRef?.current || ref.current;
      if (previousAnchor !== anchorRef.current) {
        context.onAnchorChange(anchorRef.current);
      }
    });
    return virtualRef ? null : /* @__PURE__ */ jsx(Primitive.div, { ...anchorProps, ref: composedRefs });
  }
);
PopperAnchor.displayName = ANCHOR_NAME;
var CONTENT_NAME2 = "PopperContent";
var [PopperContentProvider, useContentContext] = createPopperContext(CONTENT_NAME2);
var PopperContent = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopePopper,
      side = "bottom",
      sideOffset = 0,
      align = "center",
      alignOffset = 0,
      arrowPadding = 0,
      avoidCollisions = true,
      collisionBoundary = [],
      collisionPadding: collisionPaddingProp = 0,
      sticky = "partial",
      hideWhenDetached = false,
      updatePositionStrategy = "optimized",
      onPlaced,
      ...contentProps
    } = props;
    const context = usePopperContext(CONTENT_NAME2, __scopePopper);
    const [content, setContent3] = React49.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setContent3(node));
    const [arrow6, setArrow] = React49.useState(null);
    const arrowSize = useSize(arrow6);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : { top: 0, right: 0, bottom: 0, left: 0, ...collisionPaddingProp };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
      padding: collisionPadding,
      boundary: boundary.filter(isNotNull),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: hasExplicitBoundaries
    };
    const { refs, floatingStyles, placement, isPositioned, middlewareData } = useFloating({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: desiredPlacement,
      whileElementsMounted: (...args) => {
        const cleanup = autoUpdate(...args, {
          animationFrame: updatePositionStrategy === "always"
        });
        return cleanup;
      },
      elements: {
        reference: context.anchor
      },
      middleware: [
        offset4({ mainAxis: sideOffset + arrowHeight, alignmentAxis: alignOffset }),
        avoidCollisions && shift4({
          mainAxis: true,
          crossAxis: false,
          limiter: sticky === "partial" ? limitShift3() : void 0,
          ...detectOverflowOptions
        }),
        avoidCollisions && flip4({ ...detectOverflowOptions }),
        size3({
          ...detectOverflowOptions,
          apply: ({ elements, rects, availableWidth, availableHeight }) => {
            const { width: anchorWidth, height: anchorHeight } = rects.reference;
            const contentStyle = elements.floating.style;
            contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
            contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
            contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
            contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
          }
        }),
        arrow6 && arrow4({ element: arrow6, padding: arrowPadding }),
        transformOrigin({ arrowWidth, arrowHeight }),
        hideWhenDetached && hide4({ strategy: "referenceHidden", ...detectOverflowOptions })
      ]
    });
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const handlePlaced = useCallbackRef(onPlaced);
    useLayoutEffect2(() => {
      if (isPositioned) {
        handlePlaced?.();
      }
    }, [isPositioned, handlePlaced]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = React49.useState();
    useLayoutEffect2(() => {
      if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [content]);
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...floatingStyles,
          transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: contentZIndex,
          ["--radix-popper-transform-origin"]: [
            middlewareData.transformOrigin?.x,
            middlewareData.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...middlewareData.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: props.dir,
        children: /* @__PURE__ */ jsx(
          PopperContentProvider,
          {
            scope: __scopePopper,
            placedSide,
            onArrowChange: setArrow,
            arrowX,
            arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ jsx(
              Primitive.div,
              {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                  ...contentProps.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: !isPositioned ? "none" : void 0
                }
              }
            )
          }
        )
      }
    );
  }
);
PopperContent.displayName = CONTENT_NAME2;
var ARROW_NAME = "PopperArrow";
var OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
var PopperArrow = React49.forwardRef(function PopperArrow2(props, forwardedRef) {
  const { __scopePopper, ...arrowProps } = props;
  const contentContext = useContentContext(ARROW_NAME, __scopePopper);
  const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ jsx(
      "span",
      {
        ref: contentContext.onArrowChange,
        style: {
          position: "absolute",
          left: contentContext.arrowX,
          top: contentContext.arrowY,
          [baseSide]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[contentContext.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: `rotate(180deg)`,
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[contentContext.placedSide],
          visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ jsx(
          Root4,
          {
            ...arrowProps,
            ref: forwardedRef,
            style: {
              ...arrowProps.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
PopperArrow.displayName = ARROW_NAME;
function isNotNull(value) {
  return value !== null;
}
var transformOrigin = (options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const noArrowAlign = { start: "0%", center: "50%", end: "100%" }[placedAlign];
    const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
    const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
    let x = "";
    let y = "";
    if (placedSide === "bottom") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x = `${-arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x = `${rects.floating.width + arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return { data: { x, y } };
  }
});
function getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
var Root23 = Popper;
var Anchor = PopperAnchor;
var Content2 = PopperContent;
var Arrow2 = PopperArrow;
var PORTAL_NAME = "Portal";
var Portal = React49.forwardRef((props, forwardedRef) => {
  const { container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = React49.useState(false);
  useLayoutEffect2(() => setMounted(true), []);
  const container = containerProp || mounted && globalThis?.document?.body;
  return container ? ReactDOM6__default.createPortal(/* @__PURE__ */ jsx(Primitive.div, { ...portalProps, ref: forwardedRef }), container) : null;
});
Portal.displayName = PORTAL_NAME;
function usePrevious(value) {
  const ref = React49.useRef({ value, previous: value });
  return React49.useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [value]);
}
var VISUALLY_HIDDEN_STYLES = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
});
var NAME3 = "VisuallyHidden";
var VisuallyHidden = React49.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ jsx(
      Primitive.span,
      {
        ...props,
        ref: forwardedRef,
        style: { ...VISUALLY_HIDDEN_STYLES, ...props.style }
      }
    );
  }
);
VisuallyHidden.displayName = NAME3;
var Root5 = VisuallyHidden;

// ../../node_modules/.pnpm/aria-hidden@1.2.6/node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x) {
    return Boolean(x);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode2, markerName, controlAttribute) {
  var targets = correctTargets(parentNode2, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, "true");
          }
        } catch (e) {
          console.error("aria-hidden: cannot operate on ", node, e);
        }
      }
    });
  };
  deep(parentNode2);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode2, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live], script")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};

// ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t2[p[i]] = s[p[i]];
    }
  return t2;
}
function __spreadArray(to, from2, pack) {
  for (var i = 0, l = from2.length, ar; i < l; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
}

// ../../node_modules/.pnpm/react-remove-scroll-bar@2.3.8_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";

// ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.2.14_react@19.2.4/node_modules/use-callback-ref/dist/es2015/assignRef.js
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
function useCallbackRef2(initialValue, callback) {
  var ref = useState(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
var useIsomorphicLayoutEffect2 = typeof window !== "undefined" ? React49.useLayoutEffect : React49.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef2(null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect2(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}

// ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.2.14_react@19.2.4/node_modules/use-sidecar/dist/es2015/medium.js
function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults2, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults2;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x) {
          return cb(x);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}
var SideCar = function(_a) {
  var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React49.createElement(Target, __assign({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar;
}

// ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll/dist/es2015/medium.js
var effectCar = createSidecarMedium();

// ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll/dist/es2015/UI.js
var nothing = function() {
  return;
};
var RemoveScroll = React49.forwardRef(function(props, parentRef) {
  var ref = React49.useRef(null);
  var _a = React49.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container7 = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React49.createElement(
    React49.Fragment,
    null,
    enabled && React49.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noRelative, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode }),
    forwardProps ? React49.cloneElement(React49.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : React49.createElement(Container7, __assign({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function() {
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};

// ../../node_modules/.pnpm/react-style-singleton@2.2.3_@types+react@19.2.14_react@19.2.4/node_modules/react-style-singleton/dist/es2015/singleton.js
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function(style2) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style2);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function() {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};

// ../../node_modules/.pnpm/react-style-singleton@2.2.3_@types+react@19.2.14_react@19.2.4/node_modules/react-style-singleton/dist/es2015/hook.js
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles, isDynamic) {
    React49.useEffect(function() {
      sheet.add(styles);
      return function() {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};

// ../../node_modules/.pnpm/react-style-singleton@2.2.3_@types+react@19.2.14_react@19.2.4/node_modules/react-style-singleton/dist/es2015/component.js
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet = function(_a) {
    var styles = _a.styles, dynamic = _a.dynamic;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet;
};

// ../../node_modules/.pnpm/react-remove-scroll-bar@2.3.8_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function(x) {
  return parseInt(x || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs2 = window.getComputedStyle(document.body);
  var left2 = cs2[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top2 = cs2[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right2 = cs2[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse(left2), parse(top2), parse(right2)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};

// ../../node_modules/.pnpm/react-remove-scroll-bar@2.3.8_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll-bar/dist/es2015/component.js
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles = function(_a, allowRelative, gapMode, important) {
  var left2 = _a.left, top2 = _a.top, right2 = _a.right, gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left2, "px;\n    padding-top: ").concat(top2, "px;\n    padding-right: ").concat(right2, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
  var counter = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
  React49.useEffect(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a) {
  var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
  useLockAttribute();
  var gap = React49.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React49.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};

// ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var options;
var nonPassive = passiveSupported ? { passive: false } : false;

// ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function(node) {
  return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node, overflow) {
  if (!(node instanceof Element)) {
    return false;
  }
  var styles = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === "visible")
  );
};
var elementCouldBeVScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function(axis, node) {
  var ownerDocument = node.ownerDocument;
  var current = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
      if (scrollHeight > clientHeight) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    if (!target) {
      break;
    }
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    var parent_1 = target.parentNode;
    target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
  } while (
    // portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target)
  );
  if (isDeltaPositive && (Math.abs(availableScroll) < 1 || false)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (Math.abs(availableScrollTop) < 1 || false)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};

// ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll/dist/es2015/SideEffect.js
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x, y) {
  return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter2 = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React49.useRef([]);
  var touchStartRef = React49.useRef([0, 0]);
  var activeAxis = React49.useRef();
  var id = React49.useState(idCounter2++)[0];
  var Style2 = React49.useState(styleSingleton)[0];
  var lastProps = React49.useRef(props);
  React49.useEffect(function() {
    lastProps.current = props;
  }, [props]);
  React49.useEffect(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef)).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React49.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var selection = window.getSelection();
    var anchorNode = selection && selection.anchorNode;
    var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
    if (isTouchingSelection) {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY);
  }, []);
  var shouldPrevent = React49.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e) {
      return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React49.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should, shadowParent: getOutermostShadowParent(target) };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React49.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React49.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React49.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React49.useEffect(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return React49.createElement(
    React49.Fragment,
    null,
    inert ? React49.createElement(Style2, { styles: generateStyle(id) }) : null,
    removeScrollBar ? React49.createElement(RemoveScrollBar, { noRelative: props.noRelative, gapMode: props.gapMode }) : null
  );
}
function getOutermostShadowParent(node) {
  var shadowParent = null;
  while (node !== null) {
    if (node instanceof ShadowRoot) {
      shadowParent = node.host;
      node = node.host;
    }
    node = node.parentNode;
  }
  return shadowParent;
}

// ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll/dist/es2015/sidecar.js
var sidecar_default = exportSidecar(effectCar, RemoveScrollSideCar);

// ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.14_react@19.2.4/node_modules/react-remove-scroll/dist/es2015/Combination.js
var ReactRemoveScroll = React49.forwardRef(function(props, ref) {
  return React49.createElement(RemoveScroll, __assign({}, props, { ref, sideCar: sidecar_default }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var Combination_default = ReactRemoveScroll;
var OPEN_KEYS = [" ", "Enter", "ArrowUp", "ArrowDown"];
var SELECTION_KEYS = [" ", "Enter"];
var SELECT_NAME = "Select";
var [Collection2, useCollection2, createCollectionScope2] = createCollection(SELECT_NAME);
var [createSelectContext] = createContextScope(SELECT_NAME, [
  createCollectionScope2,
  createPopperScope
]);
var usePopperScope = createPopperScope();
var [SelectProvider, useSelectContext] = createSelectContext(SELECT_NAME);
var [SelectNativeOptionsProvider, useSelectNativeOptionsContext] = createSelectContext(SELECT_NAME);
var Select = (props) => {
  const {
    __scopeSelect,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    value: valueProp,
    defaultValue,
    onValueChange,
    dir,
    name,
    autoComplete,
    disabled,
    required,
    form
  } = props;
  const popperScope = usePopperScope(__scopeSelect);
  const [trigger, setTrigger] = React49.useState(null);
  const [valueNode, setValueNode] = React49.useState(null);
  const [valueNodeHasChildren, setValueNodeHasChildren] = React49.useState(false);
  const direction = useDirection(dir);
  const [open2, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: SELECT_NAME
  });
  const [value, setValue] = useControllableState({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange,
    caller: SELECT_NAME
  });
  const triggerPointerDownPosRef = React49.useRef(null);
  const isFormControl = trigger ? form || !!trigger.closest("form") : true;
  const [nativeOptionsSet, setNativeOptionsSet] = React49.useState(/* @__PURE__ */ new Set());
  const nativeSelectKey = Array.from(nativeOptionsSet).map((option) => option.props.value).join(";");
  return /* @__PURE__ */ jsx(Root23, { ...popperScope, children: /* @__PURE__ */ jsxs(
    SelectProvider,
    {
      required,
      scope: __scopeSelect,
      trigger,
      onTriggerChange: setTrigger,
      valueNode,
      onValueNodeChange: setValueNode,
      valueNodeHasChildren,
      onValueNodeHasChildrenChange: setValueNodeHasChildren,
      contentId: useId(),
      value,
      onValueChange: setValue,
      open: open2,
      onOpenChange: setOpen,
      dir: direction,
      triggerPointerDownPosRef,
      disabled,
      children: [
        /* @__PURE__ */ jsx(Collection2.Provider, { scope: __scopeSelect, children: /* @__PURE__ */ jsx(
          SelectNativeOptionsProvider,
          {
            scope: props.__scopeSelect,
            onNativeOptionAdd: React49.useCallback((option) => {
              setNativeOptionsSet((prev) => new Set(prev).add(option));
            }, []),
            onNativeOptionRemove: React49.useCallback((option) => {
              setNativeOptionsSet((prev) => {
                const optionsSet = new Set(prev);
                optionsSet.delete(option);
                return optionsSet;
              });
            }, []),
            children
          }
        ) }),
        isFormControl ? /* @__PURE__ */ jsxs(
          SelectBubbleInput,
          {
            "aria-hidden": true,
            required,
            tabIndex: -1,
            name,
            autoComplete,
            value,
            onChange: (event) => setValue(event.target.value),
            disabled,
            form,
            children: [
              value === void 0 ? /* @__PURE__ */ jsx("option", { value: "" }) : null,
              Array.from(nativeOptionsSet)
            ]
          },
          nativeSelectKey
        ) : null
      ]
    }
  ) });
};
Select.displayName = SELECT_NAME;
var TRIGGER_NAME2 = "SelectTrigger";
var SelectTrigger = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, disabled = false, ...triggerProps } = props;
    const popperScope = usePopperScope(__scopeSelect);
    const context = useSelectContext(TRIGGER_NAME2, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = useComposedRefs(forwardedRef, context.onTriggerChange);
    const getItems = useCollection2(__scopeSelect);
    const pointerTypeRef = React49.useRef("touch");
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = useTypeaheadSearch((search) => {
      const enabledItems = getItems().filter((item) => !item.disabled);
      const currentItem = enabledItems.find((item) => item.value === context.value);
      const nextItem = findNextItem(enabledItems, search, currentItem);
      if (nextItem !== void 0) {
        context.onValueChange(nextItem.value);
      }
    });
    const handleOpen = (pointerEvent) => {
      if (!isDisabled) {
        context.onOpenChange(true);
        resetTypeahead();
      }
      if (pointerEvent) {
        context.triggerPointerDownPosRef.current = {
          x: Math.round(pointerEvent.pageX),
          y: Math.round(pointerEvent.pageY)
        };
      }
    };
    return /* @__PURE__ */ jsx(Anchor, { asChild: true, ...popperScope, children: /* @__PURE__ */ jsx(
      Primitive.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": context.contentId,
        "aria-expanded": context.open,
        "aria-required": context.required,
        "aria-autocomplete": "none",
        dir: context.dir,
        "data-state": context.open ? "open" : "closed",
        disabled: isDisabled,
        "data-disabled": isDisabled ? "" : void 0,
        "data-placeholder": shouldShowPlaceholder(context.value) ? "" : void 0,
        ...triggerProps,
        ref: composedRefs,
        onClick: composeEventHandlers(triggerProps.onClick, (event) => {
          event.currentTarget.focus();
          if (pointerTypeRef.current !== "mouse") {
            handleOpen(event);
          }
        }),
        onPointerDown: composeEventHandlers(triggerProps.onPointerDown, (event) => {
          pointerTypeRef.current = event.pointerType;
          const target = event.target;
          if (target.hasPointerCapture(event.pointerId)) {
            target.releasePointerCapture(event.pointerId);
          }
          if (event.button === 0 && event.ctrlKey === false && event.pointerType === "mouse") {
            handleOpen(event);
            event.preventDefault();
          }
        }),
        onKeyDown: composeEventHandlers(triggerProps.onKeyDown, (event) => {
          const isTypingAhead = searchRef.current !== "";
          const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
          if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
          if (isTypingAhead && event.key === " ") return;
          if (OPEN_KEYS.includes(event.key)) {
            handleOpen();
            event.preventDefault();
          }
        })
      }
    ) });
  }
);
SelectTrigger.displayName = TRIGGER_NAME2;
var VALUE_NAME = "SelectValue";
var SelectValue = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, className, style: style2, children, placeholder = "", ...valueProps } = props;
    const context = useSelectContext(VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== void 0;
    const composedRefs = useComposedRefs(forwardedRef, context.onValueNodeChange);
    useLayoutEffect2(() => {
      onValueNodeHasChildrenChange(hasChildren);
    }, [onValueNodeHasChildrenChange, hasChildren]);
    return /* @__PURE__ */ jsx(
      Primitive.span,
      {
        ...valueProps,
        ref: composedRefs,
        style: { pointerEvents: "none" },
        children: shouldShowPlaceholder(context.value) ? /* @__PURE__ */ jsx(Fragment, { children: placeholder }) : children
      }
    );
  }
);
SelectValue.displayName = VALUE_NAME;
var ICON_NAME = "SelectIcon";
var SelectIcon = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, children, ...iconProps } = props;
    return /* @__PURE__ */ jsx(Primitive.span, { "aria-hidden": true, ...iconProps, ref: forwardedRef, children: children || "\u25BC" });
  }
);
SelectIcon.displayName = ICON_NAME;
var PORTAL_NAME2 = "SelectPortal";
var SelectPortal = (props) => {
  return /* @__PURE__ */ jsx(Portal, { asChild: true, ...props });
};
SelectPortal.displayName = PORTAL_NAME2;
var CONTENT_NAME3 = "SelectContent";
var SelectContent = React49.forwardRef(
  (props, forwardedRef) => {
    const context = useSelectContext(CONTENT_NAME3, props.__scopeSelect);
    const [fragment, setFragment] = React49.useState();
    useLayoutEffect2(() => {
      setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
      const frag = fragment;
      return frag ? ReactDOM6.createPortal(
        /* @__PURE__ */ jsx(SelectContentProvider, { scope: props.__scopeSelect, children: /* @__PURE__ */ jsx(Collection2.Slot, { scope: props.__scopeSelect, children: /* @__PURE__ */ jsx("div", { children: props.children }) }) }),
        frag
      ) : null;
    }
    return /* @__PURE__ */ jsx(SelectContentImpl, { ...props, ref: forwardedRef });
  }
);
SelectContent.displayName = CONTENT_NAME3;
var CONTENT_MARGIN = 10;
var [SelectContentProvider, useSelectContentContext] = createSelectContext(CONTENT_NAME3);
var CONTENT_IMPL_NAME = "SelectContentImpl";
var Slot2 = createSlot("SelectContent.RemoveScroll");
var SelectContentImpl = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeSelect,
      position = "item-aligned",
      onCloseAutoFocus,
      onEscapeKeyDown,
      onPointerDownOutside,
      //
      // PopperContent props
      side,
      sideOffset,
      align,
      alignOffset,
      arrowPadding,
      collisionBoundary,
      collisionPadding,
      sticky,
      hideWhenDetached,
      avoidCollisions,
      //
      ...contentProps
    } = props;
    const context = useSelectContext(CONTENT_NAME3, __scopeSelect);
    const [content, setContent3] = React49.useState(null);
    const [viewport2, setViewport] = React49.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setContent3(node));
    const [selectedItem, setSelectedItem] = React49.useState(null);
    const [selectedItemText, setSelectedItemText] = React49.useState(
      null
    );
    const getItems = useCollection2(__scopeSelect);
    const [isPositioned, setIsPositioned] = React49.useState(false);
    const firstValidItemFoundRef = React49.useRef(false);
    React49.useEffect(() => {
      if (content) return hideOthers(content);
    }, [content]);
    useFocusGuards();
    const focusFirst4 = React49.useCallback(
      (candidates) => {
        const [firstItem, ...restItems] = getItems().map((item) => item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates) {
          if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
          candidate?.scrollIntoView({ block: "nearest" });
          if (candidate === firstItem && viewport2) viewport2.scrollTop = 0;
          if (candidate === lastItem && viewport2) viewport2.scrollTop = viewport2.scrollHeight;
          candidate?.focus();
          if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
      },
      [getItems, viewport2]
    );
    const focusSelectedItem = React49.useCallback(
      () => focusFirst4([selectedItem, content]),
      [focusFirst4, selectedItem, content]
    );
    React49.useEffect(() => {
      if (isPositioned) {
        focusSelectedItem();
      }
    }, [isPositioned, focusSelectedItem]);
    const { onOpenChange, triggerPointerDownPosRef } = context;
    React49.useEffect(() => {
      if (content) {
        let pointerMoveDelta = { x: 0, y: 0 };
        const handlePointerMove = (event) => {
          pointerMoveDelta = {
            x: Math.abs(Math.round(event.pageX) - (triggerPointerDownPosRef.current?.x ?? 0)),
            y: Math.abs(Math.round(event.pageY) - (triggerPointerDownPosRef.current?.y ?? 0))
          };
        };
        const handlePointerUp = (event) => {
          if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) {
            event.preventDefault();
          } else {
            if (!content.contains(event.target)) {
              onOpenChange(false);
            }
          }
          document.removeEventListener("pointermove", handlePointerMove);
          triggerPointerDownPosRef.current = null;
        };
        if (triggerPointerDownPosRef.current !== null) {
          document.addEventListener("pointermove", handlePointerMove);
          document.addEventListener("pointerup", handlePointerUp, { capture: true, once: true });
        }
        return () => {
          document.removeEventListener("pointermove", handlePointerMove);
          document.removeEventListener("pointerup", handlePointerUp, { capture: true });
        };
      }
    }, [content, onOpenChange, triggerPointerDownPosRef]);
    React49.useEffect(() => {
      const close2 = () => onOpenChange(false);
      window.addEventListener("blur", close2);
      window.addEventListener("resize", close2);
      return () => {
        window.removeEventListener("blur", close2);
        window.removeEventListener("resize", close2);
      };
    }, [onOpenChange]);
    const [searchRef, handleTypeaheadSearch] = useTypeaheadSearch((search) => {
      const enabledItems = getItems().filter((item) => !item.disabled);
      const currentItem = enabledItems.find((item) => item.ref.current === document.activeElement);
      const nextItem = findNextItem(enabledItems, search, currentItem);
      if (nextItem) {
        setTimeout(() => nextItem.ref.current.focus());
      }
    });
    const itemRefCallback = React49.useCallback(
      (node, value, disabled) => {
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
          setSelectedItem(node);
          if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
      },
      [context.value]
    );
    const handleItemLeave = React49.useCallback(() => content?.focus(), [content]);
    const itemTextRefCallback = React49.useCallback(
      (node, value, disabled) => {
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
          setSelectedItemText(node);
        }
      },
      [context.value]
    );
    const SelectPosition = position === "popper" ? SelectPopperPosition : SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === SelectPopperPosition ? {
      side,
      sideOffset,
      align,
      alignOffset,
      arrowPadding,
      collisionBoundary,
      collisionPadding,
      sticky,
      hideWhenDetached,
      avoidCollisions
    } : {};
    return /* @__PURE__ */ jsx(
      SelectContentProvider,
      {
        scope: __scopeSelect,
        content,
        viewport: viewport2,
        onViewportChange: setViewport,
        itemRefCallback,
        selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback,
        focusSelectedItem,
        selectedItemText,
        position,
        isPositioned,
        searchRef,
        children: /* @__PURE__ */ jsx(Combination_default, { as: Slot2, allowPinchZoom: true, children: /* @__PURE__ */ jsx(
          FocusScope,
          {
            asChild: true,
            trapped: context.open,
            onMountAutoFocus: (event) => {
              event.preventDefault();
            },
            onUnmountAutoFocus: composeEventHandlers(onCloseAutoFocus, (event) => {
              context.trigger?.focus({ preventScroll: true });
              event.preventDefault();
            }),
            children: /* @__PURE__ */ jsx(
              DismissableLayer,
              {
                asChild: true,
                disableOutsidePointerEvents: true,
                onEscapeKeyDown,
                onPointerDownOutside,
                onFocusOutside: (event) => event.preventDefault(),
                onDismiss: () => context.onOpenChange(false),
                children: /* @__PURE__ */ jsx(
                  SelectPosition,
                  {
                    role: "listbox",
                    id: context.contentId,
                    "data-state": context.open ? "open" : "closed",
                    dir: context.dir,
                    onContextMenu: (event) => event.preventDefault(),
                    ...contentProps,
                    ...popperContentProps,
                    onPlaced: () => setIsPositioned(true),
                    ref: composedRefs,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...contentProps.style
                    },
                    onKeyDown: composeEventHandlers(contentProps.onKeyDown, (event) => {
                      const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                      if (event.key === "Tab") event.preventDefault();
                      if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                      if (["ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) {
                        const items = getItems().filter((item) => !item.disabled);
                        let candidateNodes = items.map((item) => item.ref.current);
                        if (["ArrowUp", "End"].includes(event.key)) {
                          candidateNodes = candidateNodes.slice().reverse();
                        }
                        if (["ArrowUp", "ArrowDown"].includes(event.key)) {
                          const currentElement = event.target;
                          const currentIndex = candidateNodes.indexOf(currentElement);
                          candidateNodes = candidateNodes.slice(currentIndex + 1);
                        }
                        setTimeout(() => focusFirst4(candidateNodes));
                        event.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
SelectContentImpl.displayName = CONTENT_IMPL_NAME;
var ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var SelectItemAlignedPosition = React49.forwardRef((props, forwardedRef) => {
  const { __scopeSelect, onPlaced, ...popperProps } = props;
  const context = useSelectContext(CONTENT_NAME3, __scopeSelect);
  const contentContext = useSelectContentContext(CONTENT_NAME3, __scopeSelect);
  const [contentWrapper, setContentWrapper] = React49.useState(null);
  const [content, setContent3] = React49.useState(null);
  const composedRefs = useComposedRefs(forwardedRef, (node) => setContent3(node));
  const getItems = useCollection2(__scopeSelect);
  const shouldExpandOnScrollRef = React49.useRef(false);
  const shouldRepositionRef = React49.useRef(true);
  const { viewport: viewport2, selectedItem, selectedItemText, focusSelectedItem } = contentContext;
  const position = React49.useCallback(() => {
    if (context.trigger && context.valueNode && contentWrapper && content && viewport2 && selectedItem && selectedItemText) {
      const triggerRect = context.trigger.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      const valueNodeRect = context.valueNode.getBoundingClientRect();
      const itemTextRect = selectedItemText.getBoundingClientRect();
      if (context.dir !== "rtl") {
        const itemTextOffset = itemTextRect.left - contentRect.left;
        const left2 = valueNodeRect.left - itemTextOffset;
        const leftDelta = triggerRect.left - left2;
        const minContentWidth = triggerRect.width + leftDelta;
        const contentWidth = Math.max(minContentWidth, contentRect.width);
        const rightEdge = window.innerWidth - CONTENT_MARGIN;
        const clampedLeft = clamp(left2, [
          CONTENT_MARGIN,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(CONTENT_MARGIN, rightEdge - contentWidth)
        ]);
        contentWrapper.style.minWidth = minContentWidth + "px";
        contentWrapper.style.left = clampedLeft + "px";
      } else {
        const itemTextOffset = contentRect.right - itemTextRect.right;
        const right2 = window.innerWidth - valueNodeRect.right - itemTextOffset;
        const rightDelta = window.innerWidth - triggerRect.right - right2;
        const minContentWidth = triggerRect.width + rightDelta;
        const contentWidth = Math.max(minContentWidth, contentRect.width);
        const leftEdge = window.innerWidth - CONTENT_MARGIN;
        const clampedRight = clamp(right2, [
          CONTENT_MARGIN,
          Math.max(CONTENT_MARGIN, leftEdge - contentWidth)
        ]);
        contentWrapper.style.minWidth = minContentWidth + "px";
        contentWrapper.style.right = clampedRight + "px";
      }
      const items = getItems();
      const availableHeight = window.innerHeight - CONTENT_MARGIN * 2;
      const itemsHeight = viewport2.scrollHeight;
      const contentStyles = window.getComputedStyle(content);
      const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
      const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
      const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
      const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
      const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
      const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
      const viewportStyles = window.getComputedStyle(viewport2);
      const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
      const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
      const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - CONTENT_MARGIN;
      const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
      const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
      const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
      const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
      const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
      const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
      if (willAlignWithoutTopOverflow) {
        const isLastItem = items.length > 0 && selectedItem === items[items.length - 1].ref.current;
        contentWrapper.style.bottom = "0px";
        const viewportOffsetBottom = content.clientHeight - viewport2.offsetTop - viewport2.offsetHeight;
        const clampedTriggerMiddleToBottomEdge = Math.max(
          triggerMiddleToBottomEdge,
          selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth
        );
        const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
        contentWrapper.style.height = height + "px";
      } else {
        const isFirstItem = items.length > 0 && selectedItem === items[0].ref.current;
        contentWrapper.style.top = "0px";
        const clampedTopEdgeToTriggerMiddle = Math.max(
          topEdgeToTriggerMiddle,
          contentBorderTopWidth + viewport2.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight
        );
        const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
        contentWrapper.style.height = height + "px";
        viewport2.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport2.offsetTop;
      }
      contentWrapper.style.margin = `${CONTENT_MARGIN}px 0`;
      contentWrapper.style.minHeight = minContentHeight + "px";
      contentWrapper.style.maxHeight = availableHeight + "px";
      onPlaced?.();
      requestAnimationFrame(() => shouldExpandOnScrollRef.current = true);
    }
  }, [
    getItems,
    context.trigger,
    context.valueNode,
    contentWrapper,
    content,
    viewport2,
    selectedItem,
    selectedItemText,
    context.dir,
    onPlaced
  ]);
  useLayoutEffect2(() => position(), [position]);
  const [contentZIndex, setContentZIndex] = React49.useState();
  useLayoutEffect2(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  const handleScrollButtonChange = React49.useCallback(
    (node) => {
      if (node && shouldRepositionRef.current === true) {
        position();
        focusSelectedItem?.();
        shouldRepositionRef.current = false;
      }
    },
    [position, focusSelectedItem]
  );
  return /* @__PURE__ */ jsx(
    SelectViewportProvider,
    {
      scope: __scopeSelect,
      contentWrapper,
      shouldExpandOnScrollRef,
      onScrollButtonChange: handleScrollButtonChange,
      children: /* @__PURE__ */ jsx(
        "div",
        {
          ref: setContentWrapper,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: contentZIndex
          },
          children: /* @__PURE__ */ jsx(
            Primitive.div,
            {
              ...popperProps,
              ref: composedRefs,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...popperProps.style
              }
            }
          )
        }
      )
    }
  );
});
SelectItemAlignedPosition.displayName = ITEM_ALIGNED_POSITION_NAME;
var POPPER_POSITION_NAME = "SelectPopperPosition";
var SelectPopperPosition = React49.forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    align = "start",
    collisionPadding = CONTENT_MARGIN,
    ...popperProps
  } = props;
  const popperScope = usePopperScope(__scopeSelect);
  return /* @__PURE__ */ jsx(
    Content2,
    {
      ...popperScope,
      ...popperProps,
      ref: forwardedRef,
      align,
      collisionPadding,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...popperProps.style,
        // re-namespace exposed content custom properties
        ...{
          "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-select-content-available-width": "var(--radix-popper-available-width)",
          "--radix-select-content-available-height": "var(--radix-popper-available-height)",
          "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    }
  );
});
SelectPopperPosition.displayName = POPPER_POSITION_NAME;
var [SelectViewportProvider, useSelectViewportContext] = createSelectContext(CONTENT_NAME3, {});
var VIEWPORT_NAME2 = "SelectViewport";
var SelectViewport = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, nonce, ...viewportProps } = props;
    const contentContext = useSelectContentContext(VIEWPORT_NAME2, __scopeSelect);
    const viewportContext = useSelectViewportContext(VIEWPORT_NAME2, __scopeSelect);
    const composedRefs = useComposedRefs(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = React49.useRef(0);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
          },
          nonce
        }
      ),
      /* @__PURE__ */ jsx(Collection2.Slot, { scope: __scopeSelect, children: /* @__PURE__ */ jsx(
        Primitive.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...viewportProps,
          ref: composedRefs,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...viewportProps.style
          },
          onScroll: composeEventHandlers(viewportProps.onScroll, (event) => {
            const viewport2 = event.currentTarget;
            const { contentWrapper, shouldExpandOnScrollRef } = viewportContext;
            if (shouldExpandOnScrollRef?.current && contentWrapper) {
              const scrolledBy = Math.abs(prevScrollTopRef.current - viewport2.scrollTop);
              if (scrolledBy > 0) {
                const availableHeight = window.innerHeight - CONTENT_MARGIN * 2;
                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                const cssHeight = parseFloat(contentWrapper.style.height);
                const prevHeight = Math.max(cssMinHeight, cssHeight);
                if (prevHeight < availableHeight) {
                  const nextHeight = prevHeight + scrolledBy;
                  const clampedNextHeight = Math.min(availableHeight, nextHeight);
                  const heightDiff = nextHeight - clampedNextHeight;
                  contentWrapper.style.height = clampedNextHeight + "px";
                  if (contentWrapper.style.bottom === "0px") {
                    viewport2.scrollTop = heightDiff > 0 ? heightDiff : 0;
                    contentWrapper.style.justifyContent = "flex-end";
                  }
                }
              }
            }
            prevScrollTopRef.current = viewport2.scrollTop;
          })
        }
      ) })
    ] });
  }
);
SelectViewport.displayName = VIEWPORT_NAME2;
var GROUP_NAME2 = "SelectGroup";
var [SelectGroupContextProvider, useSelectGroupContext] = createSelectContext(GROUP_NAME2);
var SelectGroup = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, ...groupProps } = props;
    const groupId = useId();
    return /* @__PURE__ */ jsx(SelectGroupContextProvider, { scope: __scopeSelect, id: groupId, children: /* @__PURE__ */ jsx(Primitive.div, { role: "group", "aria-labelledby": groupId, ...groupProps, ref: forwardedRef }) });
  }
);
SelectGroup.displayName = GROUP_NAME2;
var LABEL_NAME = "SelectLabel";
var SelectLabel = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, ...labelProps } = props;
    const groupContext = useSelectGroupContext(LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ jsx(Primitive.div, { id: groupContext.id, ...labelProps, ref: forwardedRef });
  }
);
SelectLabel.displayName = LABEL_NAME;
var ITEM_NAME2 = "SelectItem";
var [SelectItemContextProvider, useSelectItemContext] = createSelectContext(ITEM_NAME2);
var SelectItem = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeSelect,
      value,
      disabled = false,
      textValue: textValueProp,
      ...itemProps
    } = props;
    const context = useSelectContext(ITEM_NAME2, __scopeSelect);
    const contentContext = useSelectContentContext(ITEM_NAME2, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = React49.useState(textValueProp ?? "");
    const [isFocused, setIsFocused] = React49.useState(false);
    const composedRefs = useComposedRefs(
      forwardedRef,
      (node) => contentContext.itemRefCallback?.(node, value, disabled)
    );
    const textId = useId();
    const pointerTypeRef = React49.useRef("touch");
    const handleSelect = () => {
      if (!disabled) {
        context.onValueChange(value);
        context.onOpenChange(false);
      }
    };
    if (value === "") {
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    }
    return /* @__PURE__ */ jsx(
      SelectItemContextProvider,
      {
        scope: __scopeSelect,
        value,
        disabled,
        textId,
        isSelected,
        onItemTextChange: React49.useCallback((node) => {
          setTextValue((prevTextValue) => prevTextValue || (node?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ jsx(
          Collection2.ItemSlot,
          {
            scope: __scopeSelect,
            value,
            disabled,
            textValue,
            children: /* @__PURE__ */ jsx(
              Primitive.div,
              {
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1,
                ...itemProps,
                ref: composedRefs,
                onFocus: composeEventHandlers(itemProps.onFocus, () => setIsFocused(true)),
                onBlur: composeEventHandlers(itemProps.onBlur, () => setIsFocused(false)),
                onClick: composeEventHandlers(itemProps.onClick, () => {
                  if (pointerTypeRef.current !== "mouse") handleSelect();
                }),
                onPointerUp: composeEventHandlers(itemProps.onPointerUp, () => {
                  if (pointerTypeRef.current === "mouse") handleSelect();
                }),
                onPointerDown: composeEventHandlers(itemProps.onPointerDown, (event) => {
                  pointerTypeRef.current = event.pointerType;
                }),
                onPointerMove: composeEventHandlers(itemProps.onPointerMove, (event) => {
                  pointerTypeRef.current = event.pointerType;
                  if (disabled) {
                    contentContext.onItemLeave?.();
                  } else if (pointerTypeRef.current === "mouse") {
                    event.currentTarget.focus({ preventScroll: true });
                  }
                }),
                onPointerLeave: composeEventHandlers(itemProps.onPointerLeave, (event) => {
                  if (event.currentTarget === document.activeElement) {
                    contentContext.onItemLeave?.();
                  }
                }),
                onKeyDown: composeEventHandlers(itemProps.onKeyDown, (event) => {
                  const isTypingAhead = contentContext.searchRef?.current !== "";
                  if (isTypingAhead && event.key === " ") return;
                  if (SELECTION_KEYS.includes(event.key)) handleSelect();
                  if (event.key === " ") event.preventDefault();
                })
              }
            )
          }
        )
      }
    );
  }
);
SelectItem.displayName = ITEM_NAME2;
var ITEM_TEXT_NAME = "SelectItemText";
var SelectItemText = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, className, style: style2, ...itemTextProps } = props;
    const context = useSelectContext(ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = useSelectContentContext(ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = useSelectItemContext(ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = useSelectNativeOptionsContext(ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = React49.useState(null);
    const composedRefs = useComposedRefs(
      forwardedRef,
      (node) => setItemTextNode(node),
      itemContext.onItemTextChange,
      (node) => contentContext.itemTextRefCallback?.(node, itemContext.value, itemContext.disabled)
    );
    const textContent = itemTextNode?.textContent;
    const nativeOption = React49.useMemo(
      () => /* @__PURE__ */ jsx("option", { value: itemContext.value, disabled: itemContext.disabled, children: textContent }, itemContext.value),
      [itemContext.disabled, itemContext.value, textContent]
    );
    const { onNativeOptionAdd, onNativeOptionRemove } = nativeOptionsContext;
    useLayoutEffect2(() => {
      onNativeOptionAdd(nativeOption);
      return () => onNativeOptionRemove(nativeOption);
    }, [onNativeOptionAdd, onNativeOptionRemove, nativeOption]);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Primitive.span, { id: itemContext.textId, ...itemTextProps, ref: composedRefs }),
      itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? ReactDOM6.createPortal(itemTextProps.children, context.valueNode) : null
    ] });
  }
);
SelectItemText.displayName = ITEM_TEXT_NAME;
var ITEM_INDICATOR_NAME = "SelectItemIndicator";
var SelectItemIndicator = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = useSelectItemContext(ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ jsx(Primitive.span, { "aria-hidden": true, ...itemIndicatorProps, ref: forwardedRef }) : null;
  }
);
SelectItemIndicator.displayName = ITEM_INDICATOR_NAME;
var SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var SelectScrollUpButton = React49.forwardRef((props, forwardedRef) => {
  const contentContext = useSelectContentContext(SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
  const viewportContext = useSelectViewportContext(SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
  const [canScrollUp, setCanScrollUp] = React49.useState(false);
  const composedRefs = useComposedRefs(forwardedRef, viewportContext.onScrollButtonChange);
  useLayoutEffect2(() => {
    if (contentContext.viewport && contentContext.isPositioned) {
      let handleScroll22 = function() {
        const canScrollUp2 = viewport2.scrollTop > 0;
        setCanScrollUp(canScrollUp2);
      };
      const viewport2 = contentContext.viewport;
      handleScroll22();
      viewport2.addEventListener("scroll", handleScroll22);
      return () => viewport2.removeEventListener("scroll", handleScroll22);
    }
  }, [contentContext.viewport, contentContext.isPositioned]);
  return canScrollUp ? /* @__PURE__ */ jsx(
    SelectScrollButtonImpl,
    {
      ...props,
      ref: composedRefs,
      onAutoScroll: () => {
        const { viewport: viewport2, selectedItem } = contentContext;
        if (viewport2 && selectedItem) {
          viewport2.scrollTop = viewport2.scrollTop - selectedItem.offsetHeight;
        }
      }
    }
  ) : null;
});
SelectScrollUpButton.displayName = SCROLL_UP_BUTTON_NAME;
var SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var SelectScrollDownButton = React49.forwardRef((props, forwardedRef) => {
  const contentContext = useSelectContentContext(SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
  const viewportContext = useSelectViewportContext(SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
  const [canScrollDown, setCanScrollDown] = React49.useState(false);
  const composedRefs = useComposedRefs(forwardedRef, viewportContext.onScrollButtonChange);
  useLayoutEffect2(() => {
    if (contentContext.viewport && contentContext.isPositioned) {
      let handleScroll22 = function() {
        const maxScroll = viewport2.scrollHeight - viewport2.clientHeight;
        const canScrollDown2 = Math.ceil(viewport2.scrollTop) < maxScroll;
        setCanScrollDown(canScrollDown2);
      };
      const viewport2 = contentContext.viewport;
      handleScroll22();
      viewport2.addEventListener("scroll", handleScroll22);
      return () => viewport2.removeEventListener("scroll", handleScroll22);
    }
  }, [contentContext.viewport, contentContext.isPositioned]);
  return canScrollDown ? /* @__PURE__ */ jsx(
    SelectScrollButtonImpl,
    {
      ...props,
      ref: composedRefs,
      onAutoScroll: () => {
        const { viewport: viewport2, selectedItem } = contentContext;
        if (viewport2 && selectedItem) {
          viewport2.scrollTop = viewport2.scrollTop + selectedItem.offsetHeight;
        }
      }
    }
  ) : null;
});
SelectScrollDownButton.displayName = SCROLL_DOWN_BUTTON_NAME;
var SelectScrollButtonImpl = React49.forwardRef((props, forwardedRef) => {
  const { __scopeSelect, onAutoScroll, ...scrollIndicatorProps } = props;
  const contentContext = useSelectContentContext("SelectScrollButton", __scopeSelect);
  const autoScrollTimerRef = React49.useRef(null);
  const getItems = useCollection2(__scopeSelect);
  const clearAutoScrollTimer = React49.useCallback(() => {
    if (autoScrollTimerRef.current !== null) {
      window.clearInterval(autoScrollTimerRef.current);
      autoScrollTimerRef.current = null;
    }
  }, []);
  React49.useEffect(() => {
    return () => clearAutoScrollTimer();
  }, [clearAutoScrollTimer]);
  useLayoutEffect2(() => {
    const activeItem = getItems().find((item) => item.ref.current === document.activeElement);
    activeItem?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [getItems]);
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "aria-hidden": true,
      ...scrollIndicatorProps,
      ref: forwardedRef,
      style: { flexShrink: 0, ...scrollIndicatorProps.style },
      onPointerDown: composeEventHandlers(scrollIndicatorProps.onPointerDown, () => {
        if (autoScrollTimerRef.current === null) {
          autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }
      }),
      onPointerMove: composeEventHandlers(scrollIndicatorProps.onPointerMove, () => {
        contentContext.onItemLeave?.();
        if (autoScrollTimerRef.current === null) {
          autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }
      }),
      onPointerLeave: composeEventHandlers(scrollIndicatorProps.onPointerLeave, () => {
        clearAutoScrollTimer();
      })
    }
  );
});
var SEPARATOR_NAME = "SelectSeparator";
var SelectSeparator = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, ...separatorProps } = props;
    return /* @__PURE__ */ jsx(Primitive.div, { "aria-hidden": true, ...separatorProps, ref: forwardedRef });
  }
);
SelectSeparator.displayName = SEPARATOR_NAME;
var ARROW_NAME2 = "SelectArrow";
var SelectArrow = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, ...arrowProps } = props;
    const popperScope = usePopperScope(__scopeSelect);
    const context = useSelectContext(ARROW_NAME2, __scopeSelect);
    const contentContext = useSelectContentContext(ARROW_NAME2, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /* @__PURE__ */ jsx(Arrow2, { ...popperScope, ...arrowProps, ref: forwardedRef }) : null;
  }
);
SelectArrow.displayName = ARROW_NAME2;
var BUBBLE_INPUT_NAME = "SelectBubbleInput";
var SelectBubbleInput = React49.forwardRef(
  ({ __scopeSelect, value, ...props }, forwardedRef) => {
    const ref = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const prevValue = usePrevious(value);
    React49.useEffect(() => {
      const select = ref.current;
      if (!select) return;
      const selectProto = window.HTMLSelectElement.prototype;
      const descriptor = Object.getOwnPropertyDescriptor(
        selectProto,
        "value"
      );
      const setValue = descriptor.set;
      if (prevValue !== value && setValue) {
        const event = new Event("change", { bubbles: true });
        setValue.call(select, value);
        select.dispatchEvent(event);
      }
    }, [prevValue, value]);
    return /* @__PURE__ */ jsx(
      Primitive.select,
      {
        ...props,
        style: { ...VISUALLY_HIDDEN_STYLES, ...props.style },
        ref: composedRefs,
        defaultValue: value
      }
    );
  }
);
SelectBubbleInput.displayName = BUBBLE_INPUT_NAME;
function shouldShowPlaceholder(value) {
  return value === "" || value === void 0;
}
function useTypeaheadSearch(onSearchChange) {
  const handleSearchChange = useCallbackRef(onSearchChange);
  const searchRef = React49.useRef("");
  const timerRef = React49.useRef(0);
  const handleTypeaheadSearch = React49.useCallback(
    (key) => {
      const search = searchRef.current + key;
      handleSearchChange(search);
      (function updateSearch(value) {
        searchRef.current = value;
        window.clearTimeout(timerRef.current);
        if (value !== "") timerRef.current = window.setTimeout(() => updateSearch(""), 1e3);
      })(search);
    },
    [handleSearchChange]
  );
  const resetTypeahead = React49.useCallback(() => {
    searchRef.current = "";
    window.clearTimeout(timerRef.current);
  }, []);
  React49.useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);
  return [searchRef, handleTypeaheadSearch, resetTypeahead];
}
function findNextItem(items, search, currentItem) {
  const isRepeated = search.length > 1 && Array.from(search).every((char) => char === search[0]);
  const normalizedSearch = isRepeated ? search[0] : search;
  const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
  let wrappedItems = wrapArray2(items, Math.max(currentItemIndex, 0));
  const excludeCurrentItem = normalizedSearch.length === 1;
  if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v) => v !== currentItem);
  const nextItem = wrappedItems.find(
    (item) => item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase())
  );
  return nextItem !== currentItem ? nextItem : void 0;
}
function wrapArray2(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
var Root24 = Select;
var Trigger2 = SelectTrigger;
var Value = SelectValue;
var Icon2 = SelectIcon;
var Portal2 = SelectPortal;
var Content22 = SelectContent;
var Viewport2 = SelectViewport;
var Label = SelectLabel;
var Item2 = SelectItem;
var ItemText = SelectItemText;
var ItemIndicator = SelectItemIndicator;
var ScrollUpButton = SelectScrollUpButton;
var ScrollDownButton = SelectScrollDownButton;
var Separator3 = SelectSeparator;
var Select2 = Root24;
var SelectValue2 = Value;
var SelectTrigger2 = React49.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  Trigger2,
  {
    ref,
    className: cn(
      "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      className
    ),
    ...props,
    children: [
      children,
      /* @__PURE__ */ jsx(Icon2, { asChild: true, children: /* @__PURE__ */ jsx(ChevronDownIcon, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
SelectTrigger2.displayName = Trigger2.displayName;
var SelectScrollUpButton2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ScrollUpButton,
  {
    ref,
    className: cn(
      "flex cursor-default items-center justify-center py-1",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(ChevronUpIcon, { className: "h-4 w-4" })
  }
));
SelectScrollUpButton2.displayName = ScrollUpButton.displayName;
var SelectScrollDownButton2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ScrollDownButton,
  {
    ref,
    className: cn(
      "flex cursor-default items-center justify-center py-1",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(ChevronDownIcon, { className: "h-4 w-4" })
  }
));
SelectScrollDownButton2.displayName = ScrollDownButton.displayName;
var SelectContent2 = React49.forwardRef(
  ({ className, viewportClassName, children, position = "popper", ...props }, ref) => /* @__PURE__ */ jsx(Portal2, { children: /* @__PURE__ */ jsxs(
    Content22,
    {
      ref,
      className: cn(
        "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        className
      ),
      position,
      ...props,
      children: [
        /* @__PURE__ */ jsx(SelectScrollUpButton2, {}),
        /* @__PURE__ */ jsx(
          Viewport2,
          {
            className: cn(
              "p-1",
              position === "popper" && "h-[var(--radix-select-trigger-height)] w-full",
              position === "popper" && !viewportClassName && "min-w-[var(--radix-select-trigger-width)]",
              viewportClassName
            ),
            children
          }
        ),
        /* @__PURE__ */ jsx(SelectScrollDownButton2, {})
      ]
    }
  ) })
);
SelectContent2.displayName = Content22.displayName;
var SelectLabel2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Label,
  {
    ref,
    className: cn("px-2 py-1.5 text-sm font-semibold", className),
    ...props
  }
));
SelectLabel2.displayName = Label.displayName;
var SelectItem2 = React49.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  Item2,
  {
    ref,
    className: cn(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(ItemIndicator, { children: /* @__PURE__ */ jsx(CheckIcon, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ jsx(ItemText, { children })
    ]
  }
));
SelectItem2.displayName = Item2.displayName;
var SelectSeparator2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Separator3,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-muted", className),
    ...props
  }
));
SelectSeparator2.displayName = Separator3.displayName;
var inputVariant = cn(
  "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
  "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
  "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
);
function Input({ className, type, ...props }) {
  return /* @__PURE__ */ jsx(
    "input",
    {
      type,
      "data-slot": "input",
      className: cn(inputVariant, className),
      ...props
    }
  );
}
var AVAILABLE_LOCALES = {
  en: { value: "en", label: "Anglais", flag: "\u{1F1EC}\u{1F1E7}" },
  fr: { value: "fr", label: "Fran\xE7ais", flag: "\u{1F1EB}\u{1F1F7}" },
  es: { value: "es", label: "Espagnol", flag: "\u{1F1EA}\u{1F1F8}" },
  de: { value: "de", label: "Allemand", flag: "\u{1F1E9}\u{1F1EA}" },
  it: { value: "it", label: "Italien", flag: "\u{1F1EE}\u{1F1F9}" },
  nl: { value: "nl", label: "N\xE9erlandais", flag: "\u{1F1F3}\u{1F1F1}" },
  pt: { value: "pt", label: "Portugais", flag: "\u{1F1F5}\u{1F1F9}" },
  sv: { value: "sv", label: "Su\xE9dois", flag: "\u{1F1F8}\u{1F1EA}" },
  fi: { value: "fi", label: "Finnois", flag: "\u{1F1EB}\u{1F1EE}" },
  no: { value: "no", label: "Norv\xE9gien", flag: "\u{1F1F3}\u{1F1F4}" },
  da: { value: "da", label: "Danois", flag: "\u{1F1E9}\u{1F1F0}" },
  pl: { value: "pl", label: "Polonais", flag: "\u{1F1F5}\u{1F1F1}" },
  hu: { value: "hu", label: "Hongrois", flag: "\u{1F1ED}\u{1F1FA}" },
  cs: { value: "cs", label: "Tch\xE8que", flag: "\u{1F1E8}\u{1F1FF}" },
  sk: { value: "sk", label: "Slovaque", flag: "\u{1F1F8}\u{1F1F0}" },
  bg: { value: "bg", label: "Bulgare", flag: "\u{1F1E7}\u{1F1EC}" },
  zh: { value: "zh", label: "Chinois (Simplifi\xE9)", flag: "\u{1F1E8}\u{1F1F3}" },
  ja: { value: "ja", label: "Japonais", flag: "\u{1F1EF}\u{1F1F5}" }
};
function PanelTranslationState({
  mode,
  portal
}) {
  const blockProps = useBlockPanelPropsContext();
  if (!portal || blockProps.isWrapped) {
    return /* @__PURE__ */ jsxs("div", { className: "bg-background", children: [
      /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
      /* @__PURE__ */ jsx(PanelTranslationStateContent, { mode })
    ] });
  }
  if (!blockProps.containerRef?.current) return null;
  return createPortal(
    /* @__PURE__ */ jsx(FloatingPanel, { className: "mt-2 z-10 w-full", children: /* @__PURE__ */ jsx(PanelTranslationStateContent, { mode }) }),
    blockProps.containerRef.current
  );
}
function PanelTranslationStateContent({
  mode
}) {
  const blockProps = useBlockPanelPropsContext();
  const isTranslated = isBlockTranslated(blockProps.locale, blockProps.block);
  const availableLocales = blockProps.localeCodes ?? [];
  const { t: t2 } = useTranslation("editor-blocks-library");
  const localesState = useMemo(() => availableLocales.map(
    (locale) => ({
      locale,
      isTranslated: isBlockTranslated(locale, blockProps.block),
      label: AVAILABLE_LOCALES[locale]?.label || locale,
      flag: AVAILABLE_LOCALES[locale]?.flag
    })
  ), [availableLocales, blockProps.block, blockProps.locale, isTranslated, t2, blockProps.block?.content]);
  return /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx(FloatingPanelHeader, { children: /* @__PURE__ */ jsx("div", { className: "flex items-center justify-between w-full", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ jsx(Languages, { className: "h-4 w-4 mr-2 text-muted-foreground" }),
      t2("editorBlocksLibrary.translationState.title", "Translations")
    ] }) }) }),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelContent, { children: /* @__PURE__ */ jsxs("div", { children: [
      mode === "not-translatable" && /* @__PURE__ */ jsxs("div", { className: "text-sm text-muted-foreground flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(CheckCircledIcon, { className: "size-5 text-green-300" }),
        t2("editorBlocksLibrary.translationState.notTranslatable", "This block cannot be translated.")
      ] }),
      mode === "auto" && /* @__PURE__ */ jsxs("div", { className: "text-sm text-muted-foreground flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(CheckCircledIcon, { className: "size-5 text-green-300" }),
        t2(
          "editorBlocksLibrary.translationState.translationAuto",
          "This block will be automatically translated."
        )
      ] }),
      mode === "translatable" && isTranslated && /* @__PURE__ */ jsxs("div", { className: "text-sm text-muted-foreground flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(CheckCircledIcon, { className: "size-5 text-green-300" }),
        t2("editorBlocksLibrary.translationState.translated", "This block has been translated.")
      ] }),
      mode === "translatable" && !isTranslated && /* @__PURE__ */ jsxs("div", { className: "text-sm text-muted-foreground flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ValueNoneIcon, { className: "size-5 text-orange-300" }),
        t2(
          "editorBlocksLibrary.translationState.missingTranslation",
          "This block needs to be translated in the current language."
        )
      ] }),
      mode === "translatable" && /* @__PURE__ */ jsx("div", { className: "flex items-center justify-start w-full gap-1 flex-wrap", children: localesState.map((locale) => /* @__PURE__ */ jsxs("div", { className: "relative flex items-center justify-center w-8 h-7", children: [
        /* @__PURE__ */ jsx("div", { className: "text-lg", children: locale.flag }),
        /* @__PURE__ */ jsx("div", { className: "absolute bottom-0 right-0", children: locale.isTranslated ? /* @__PURE__ */ jsx(Check, { size: 14, className: "text-green-300" }) : /* @__PURE__ */ jsx(X, { size: 14, className: "text-destructive" }) })
      ] }, locale.locale)) })
    ] }) })
  ] });
}
function BannerEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(EmailPanelImage, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(EmailPanelUrl, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "not-translatable", portal: true })
  ] });
}
function BannerWeb(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(BannerEmailRenderer, { ...props }) });
}
function BannerWebEditor(props) {
  return /* @__PURE__ */ jsx(BannerWeb, { ...props });
}

// ../editor-blocks-library/src/blocks/banner/index.tsx
var banner_default = registerBlock({
  type: "banner",
  name: "editorBlocksLibrary.blocks.banner.title",
  description: "editorBlocksLibrary.blocks.banner.description",
  Icon: Image,
  category: "layout" /* LAYOUT */,
  premium: true,
  components: {
    email: {
      component: BannerEmailRenderer,
      editor: {
        component: BannerEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: BannerEmailPanelRenderer
      },
      compatibility: {
        rowBlock: {
          minSize: 4
        }
      }
    },
    web: {
      component: BannerWeb,
      editor: {
        component: BannerWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: BannerEmailPanelRenderer
      },
      compatibility: {
        rowBlock: {
          minSize: 3
        }
      }
    }
  }
});

// ../ui/src/lib/colors.ts
function clamp3(value, min3 = 0, max3 = 1) {
  return Math.min(Math.max(min3, value), max3);
}
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map((n) => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index2) => {
    return index2 < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3;
  }).join(", ")})` : "";
}
function decomposeColor(color) {
  if (typeof color === "object" && color.type) {
    return color;
  }
  if (typeof color !== "string") {
    throw new Error("Color must be a string or ColorObject");
  }
  if (color.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf("(");
  const type = color.substring(0, marker);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(type) === -1) {
    throw new Error(
      `MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`
    );
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === "color") {
    const valuesArray = values.split(" ");
    colorSpace = valuesArray.shift();
    if (valuesArray.length === 4 && valuesArray[3].charAt(0) === "/") {
      valuesArray[3] = valuesArray[3].slice(1);
    }
    values = valuesArray.join(",");
    if (["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(
      colorSpace
    ) === -1) {
      throw new Error(
        `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`
      );
    }
  }
  const parsedValues = values.split(",").map((value) => parseFloat(value));
  return { type, values: parsedValues, colorSpace };
}
function recomposeColor(color) {
  const { type, colorSpace } = color;
  let values = [...color.values];
  if (type.indexOf("rgb") !== -1) {
    values = values.map(
      (n, i) => i < 3 ? parseInt(String(n), 10) : n
    );
  } else if (type.indexOf("hsl") !== -1) {
    values = values.map((n, i) => {
      if (i === 1 || i === 2) return `${n}%`;
      return n;
    });
  }
  if (type.indexOf("color") !== -1) {
    values = `${colorSpace} ${values.join(" ")}`;
  } else {
    values = `${values.join(", ")}`;
  }
  return `${type}(${values})`;
}
function darken(color, coefficient) {
  const decomposed = decomposeColor(color);
  coefficient = clamp3(coefficient);
  if (decomposed.type.indexOf("hsl") !== -1) {
    decomposed.values[2] *= 1 - coefficient;
  } else if (decomposed.type.indexOf("rgb") !== -1 || decomposed.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      decomposed.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(decomposed);
}
function lighten(color, coefficient) {
  const decomposed = decomposeColor(color);
  coefficient = clamp3(coefficient);
  if (decomposed.type.indexOf("hsl") !== -1) {
    decomposed.values[2] += (100 - decomposed.values[2]) * coefficient;
  } else if (decomposed.type.indexOf("rgb") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      decomposed.values[i] += (255 - decomposed.values[i]) * coefficient;
    }
  } else if (decomposed.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      decomposed.values[i] += (1 - decomposed.values[i]) * coefficient;
    }
  }
  return recomposeColor(decomposed);
}
function hslToRgb(color) {
  const decomposed = decomposeColor(color);
  const { values } = decomposed;
  const h2 = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h2 / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = "rgb";
  const rgb = [
    Math.round(f(0) * 255),
    Math.round(f(8) * 255),
    Math.round(f(4) * 255)
  ];
  if (decomposed.type === "hsla") {
    type += "a";
    rgb.push(values[3]);
  }
  return recomposeColor({ type, values: rgb });
}
function getLuminance(color) {
  const decomposed = decomposeColor(color);
  let rgb = decomposed.type === "hsl" ? decomposeColor(hslToRgb(color)).values : decomposed.values;
  rgb = rgb.map((val) => {
    if (decomposed.type !== "color") {
      val /= 255;
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });
  return Number(
    (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)
  );
}
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function getContrastText(background, threshold = 3) {
  return getContrastRatio(background, "#fff") >= threshold ? "#fff" : "rgba(0, 0, 0, 0.87)";
}
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.1 ? darken(color, coefficient) : lighten(color, coefficient);
}
function calculateContrastColor(backgroundColor, coefficient = 0.1) {
  return emphasize(backgroundColor, coefficient);
}

// ../editor-blocks-library/src/blocks/button/shared-button-styling.ts
function getThemeButtonStyle({
  theme,
  variant,
  textColor
}) {
  const baseStyles = {
    fontWeight: 500,
    padding: "8px 16px",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap"
  };
  switch (variant) {
    case "primary":
      return {
        ...baseStyles,
        backgroundColor: theme.primaryColor || "#000000",
        color: theme.primaryTextColor || "#FFFFFF"
      };
    case "secondary":
      return {
        ...baseStyles,
        backgroundColor: theme.secondaryColor || "#000000",
        color: theme.secondaryTextColor || "#FFFFFF"
      };
    case "outline":
      return {
        ...baseStyles,
        backgroundColor: "transparent",
        color: textColor || theme.primaryTextColor || "#000000",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: textColor || theme.primaryTextColor || "#000000"
      };
    default:
      return {
        ...baseStyles,
        backgroundColor: textColor || theme.primaryTextColor || "#000000",
        color: getContrastText(
          textColor || theme.primaryTextColor || "#000000"
        )
      };
  }
}

// ../editor-blocks-library/src/hooks/use-theme-contextual-colors.ts
function sectionToParent(section) {
  if (section === "inside") return "card";
  return "background";
}
var DEFAULT_COLORS = {
  background: "#f0f0f0",
  card: "#ffffff",
  primary: "#000000",
  secondary: "#000000"
};
function useThemeContextualColors(theme, parent) {
  const bg2 = theme?.backgroundColor ?? DEFAULT_COLORS.background;
  const card = theme?.cardColor ?? DEFAULT_COLORS.card;
  const primary = theme?.primaryColor ?? DEFAULT_COLORS.primary;
  const secondary = theme?.secondaryColor ?? DEFAULT_COLORS.secondary;
  const colorsMap = {
    background: {
      bg: bg2,
      text: theme?.backgroundTextColor ?? getContrastText(bg2),
      contrast: calculateContrastColor(bg2)
    },
    card: {
      bg: card,
      text: theme?.cardTextColor ?? getContrastText(card),
      contrast: calculateContrastColor(card)
    },
    primary: {
      bg: primary,
      text: theme?.primaryTextColor ?? getContrastText(primary),
      contrast: calculateContrastColor(primary)
    },
    secondary: {
      bg: secondary,
      text: theme?.secondaryTextColor ?? getContrastText(secondary),
      contrast: calculateContrastColor(secondary)
    }
  };
  return colorsMap[parent];
}
var use_theme_contextual_colors_default = useThemeContextualColors;

// ../editor-blocks-library/src/utils/constants.ts
var DEFAULT_FONT = `-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif`;
function ButtonEmailRenderer({
  block,
  formatter,
  theme,
  locale,
  defaultLocale,
  section,
  isEditor
}) {
  const alignment = block.alignment || "center";
  const font = block.font ?? DEFAULT_FONT;
  const buttonRadius = useEmailThemeRadius(theme, "button");
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const buttonStyle = getThemeButtonStyle({
    variant: block.properties?.variant || "default",
    theme,
    textColor: colors.text
  });
  const contentHTML = block.content?.[locale]?.text || block.content?.[defaultLocale]?.text;
  const href = block.content?.[locale]?.href || block.content?.[defaultLocale]?.href;
  let formattedText = !!formatter && contentHTML ? formatter(contentHTML) : contentHTML;
  let formattedHref = !!formatter && href ? formatter(href) : href;
  formattedHref = formattedHref?.trim();
  if (!formattedText?.length) {
    if (isEditor) {
      formattedText = "Ajoutez un label";
    } else {
      return null;
    }
  }
  if (!isEditor && !formattedHref?.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
    Column,
    {
      className: cn({
        "text-left": alignment === "left",
        "text-center": alignment === "center",
        "text-right": alignment === "right"
      }),
      children: /* @__PURE__ */ jsx(
        Button$1,
        {
          href: formattedHref,
          className: cn("inline-block mx-1 no-underline", buttonRadius),
          style: { ...buttonStyle, fontFamily: font },
          children: /* @__PURE__ */ jsx(
            "span",
            {
              dangerouslySetInnerHTML: {
                __html: formattedText
              }
            }
          )
        }
      )
    }
  ) });
}
function ButtonEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx("div", { className: "[&_a]:pointer-events-none [&_a]:cursor-default", children: /* @__PURE__ */ jsx(ButtonEmailRenderer, { isEditor: true, ...props }) }) });
}
function PanelInlineContent({ title, children, largeTitle, Icon: Icon3 }) {
  return /* @__PURE__ */ jsx(FloatingPanelContent, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center justify-between gap-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "items-center font-medium text whitespace-nowrap", style: {
      fontSize: largeTitle ? "0.875rem" : "0.7rem"
    }, children: [
      Icon3 && /* @__PURE__ */ jsx(Icon3, { className: "inline mr-1", size: 14 }),
      title
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex w-full justify-end", children })
  ] }) });
}
var NAME4 = "Toggle";
var Toggle = React49.forwardRef((props, forwardedRef) => {
  const { pressed: pressedProp, defaultPressed, onPressedChange, ...buttonProps } = props;
  const [pressed, setPressed] = useControllableState({
    prop: pressedProp,
    onChange: onPressedChange,
    defaultProp: defaultPressed ?? false,
    caller: NAME4
  });
  return /* @__PURE__ */ jsx(
    Primitive.button,
    {
      type: "button",
      "aria-pressed": pressed,
      "data-state": pressed ? "on" : "off",
      "data-disabled": props.disabled ? "" : void 0,
      ...buttonProps,
      ref: forwardedRef,
      onClick: composeEventHandlers(props.onClick, () => {
        if (!props.disabled) {
          setPressed(!pressed);
        }
      })
    }
  );
});
Toggle.displayName = NAME4;
var TOGGLE_GROUP_NAME = "ToggleGroup";
var [createToggleGroupContext] = createContextScope(TOGGLE_GROUP_NAME, [
  createRovingFocusGroupScope
]);
var useRovingFocusGroupScope2 = createRovingFocusGroupScope();
var ToggleGroup = React49__default.forwardRef((props, forwardedRef) => {
  const { type, ...toggleGroupProps } = props;
  if (type === "single") {
    const singleProps = toggleGroupProps;
    return /* @__PURE__ */ jsx(ToggleGroupImplSingle, { ...singleProps, ref: forwardedRef });
  }
  if (type === "multiple") {
    const multipleProps = toggleGroupProps;
    return /* @__PURE__ */ jsx(ToggleGroupImplMultiple, { ...multipleProps, ref: forwardedRef });
  }
  throw new Error(`Missing prop \`type\` expected on \`${TOGGLE_GROUP_NAME}\``);
});
ToggleGroup.displayName = TOGGLE_GROUP_NAME;
var [ToggleGroupValueProvider, useToggleGroupValueContext] = createToggleGroupContext(TOGGLE_GROUP_NAME);
var ToggleGroupImplSingle = React49__default.forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    defaultValue,
    onValueChange = () => {
    },
    ...toggleGroupSingleProps
  } = props;
  const [value, setValue] = useControllableState({
    prop: valueProp,
    defaultProp: defaultValue ?? "",
    onChange: onValueChange,
    caller: TOGGLE_GROUP_NAME
  });
  return /* @__PURE__ */ jsx(
    ToggleGroupValueProvider,
    {
      scope: props.__scopeToggleGroup,
      type: "single",
      value: React49__default.useMemo(() => value ? [value] : [], [value]),
      onItemActivate: setValue,
      onItemDeactivate: React49__default.useCallback(() => setValue(""), [setValue]),
      children: /* @__PURE__ */ jsx(ToggleGroupImpl, { ...toggleGroupSingleProps, ref: forwardedRef })
    }
  );
});
var ToggleGroupImplMultiple = React49__default.forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    defaultValue,
    onValueChange = () => {
    },
    ...toggleGroupMultipleProps
  } = props;
  const [value, setValue] = useControllableState({
    prop: valueProp,
    defaultProp: defaultValue ?? [],
    onChange: onValueChange,
    caller: TOGGLE_GROUP_NAME
  });
  const handleButtonActivate = React49__default.useCallback(
    (itemValue) => setValue((prevValue = []) => [...prevValue, itemValue]),
    [setValue]
  );
  const handleButtonDeactivate = React49__default.useCallback(
    (itemValue) => setValue((prevValue = []) => prevValue.filter((value2) => value2 !== itemValue)),
    [setValue]
  );
  return /* @__PURE__ */ jsx(
    ToggleGroupValueProvider,
    {
      scope: props.__scopeToggleGroup,
      type: "multiple",
      value,
      onItemActivate: handleButtonActivate,
      onItemDeactivate: handleButtonDeactivate,
      children: /* @__PURE__ */ jsx(ToggleGroupImpl, { ...toggleGroupMultipleProps, ref: forwardedRef })
    }
  );
});
ToggleGroup.displayName = TOGGLE_GROUP_NAME;
var [ToggleGroupContext, useToggleGroupContext] = createToggleGroupContext(TOGGLE_GROUP_NAME);
var ToggleGroupImpl = React49__default.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeToggleGroup,
      disabled = false,
      rovingFocus = true,
      orientation,
      dir,
      loop = true,
      ...toggleGroupProps
    } = props;
    const rovingFocusGroupScope = useRovingFocusGroupScope2(__scopeToggleGroup);
    const direction = useDirection(dir);
    const commonProps = { role: "group", dir: direction, ...toggleGroupProps };
    return /* @__PURE__ */ jsx(ToggleGroupContext, { scope: __scopeToggleGroup, rovingFocus, disabled, children: rovingFocus ? /* @__PURE__ */ jsx(
      Root3,
      {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation,
        dir: direction,
        loop,
        children: /* @__PURE__ */ jsx(Primitive.div, { ...commonProps, ref: forwardedRef })
      }
    ) : /* @__PURE__ */ jsx(Primitive.div, { ...commonProps, ref: forwardedRef }) });
  }
);
var ITEM_NAME3 = "ToggleGroupItem";
var ToggleGroupItem = React49__default.forwardRef(
  (props, forwardedRef) => {
    const valueContext = useToggleGroupValueContext(ITEM_NAME3, props.__scopeToggleGroup);
    const context = useToggleGroupContext(ITEM_NAME3, props.__scopeToggleGroup);
    const rovingFocusGroupScope = useRovingFocusGroupScope2(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = { ...props, pressed, disabled };
    const ref = React49__default.useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ jsx(
      Item,
      {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: pressed,
        ref,
        children: /* @__PURE__ */ jsx(ToggleGroupItemImpl, { ...commonProps, ref: forwardedRef })
      }
    ) : /* @__PURE__ */ jsx(ToggleGroupItemImpl, { ...commonProps, ref: forwardedRef });
  }
);
ToggleGroupItem.displayName = ITEM_NAME3;
var ToggleGroupItemImpl = React49__default.forwardRef(
  (props, forwardedRef) => {
    const { __scopeToggleGroup, value, ...itemProps } = props;
    const valueContext = useToggleGroupValueContext(ITEM_NAME3, __scopeToggleGroup);
    const singleProps = { role: "radio", "aria-checked": props.pressed, "aria-pressed": void 0 };
    const typeProps = valueContext.type === "single" ? singleProps : void 0;
    return /* @__PURE__ */ jsx(
      Toggle,
      {
        ...typeProps,
        ...itemProps,
        ref: forwardedRef,
        onPressedChange: (pressed) => {
          if (pressed) {
            valueContext.onItemActivate(value);
          } else {
            valueContext.onItemDeactivate(value);
          }
        }
      }
    );
  }
);
var Root25 = ToggleGroup;
var Item22 = ToggleGroupItem;
var toggleVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-9 px-2 min-w-9",
        sm: "h-8 px-1.5 min-w-8",
        lg: "h-10 px-2.5 min-w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var ToggleGroupContext2 = React49.createContext({
  size: "default",
  variant: "default"
});
function ToggleGroup2({
  className,
  variant,
  size: size4,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    Root25,
    {
      "data-slot": "toggle-group",
      "data-variant": variant,
      "data-size": size4,
      className: cn(
        "group/toggle-group flex w-fit items-center rounded-md data-[variant=outline]:shadow-xs",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx(ToggleGroupContext2.Provider, { value: { variant, size: size4 }, children })
    }
  );
}
function ToggleGroupItem2({
  className,
  children,
  variant,
  size: size4,
  ...props
}) {
  const context = React49.useContext(ToggleGroupContext2);
  return /* @__PURE__ */ jsx(
    Item22,
    {
      "data-slot": "toggle-group-item",
      "data-variant": context.variant || variant,
      "data-size": context.size || size4,
      className: cn(
        toggleVariants({
          variant: context.variant || variant,
          size: context.size || size4
        }),
        "min-w-0 flex-1 shrink-0 rounded-none shadow-none first:rounded-l-md last:rounded-r-md focus:z-10 focus-visible:z-10 data-[variant=outline]:border-l-0 data-[variant=outline]:first:border-l",
        className
      ),
      ...props,
      children
    }
  );
}
function PanelBlockAlignment() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.alignment || "left";
  const handleUpdate = (alignment) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      alignment
    });
  };
  return /* @__PURE__ */ jsx(
    PanelInlineContent,
    {
      title: t2("editorBlocksLibrary.panel.alignment.title", "Alignment"),
      children: /* @__PURE__ */ jsxs(
        ToggleGroup2,
        {
          variant: "default",
          type: "single",
          className: "bg-background border shadow",
          value,
          onValueChange: (value2) => {
            if (value2 && (value2 === "left" || value2 === "center" || value2 === "right")) {
              handleUpdate(value2);
            }
          },
          children: [
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "left", "aria-label": "Toggle align left", children: /* @__PURE__ */ jsx(AlignStartVertical, { className: "h-4 w-4" }) }),
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "center", "aria-label": "Toggle align center", children: /* @__PURE__ */ jsx(AlignCenterVertical, { className: "h-4 w-4" }) }),
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "right", "aria-label": "Toggle align right", children: /* @__PURE__ */ jsx(AlignEndVertical, { className: "h-4 w-4" }) })
          ]
        }
      )
    }
  );
}
function EmailPanelLabel({ buttonKey } = {}) {
  const blockProps = useBlockPanelPropsContext();
  const { t: t2 } = useTranslation("editor-blocks-library");
  const { formAPI } = blockProps;
  const block = blockProps.block;
  const locale = blockProps.locale || blockProps?.defaultLocale;
  const content = block.content?.[locale];
  const currentText = buttonKey ? content?.[buttonKey]?.text : content?.text;
  const currentHref = buttonKey ? content?.[buttonKey]?.href : content?.href;
  const handleSave = useCallback(
    (text) => {
      if (buttonKey) {
        const doubleContent = content;
        formAPI.updateField(`${formAPI.blockPath}.content.${locale}`, {
          button0: doubleContent?.button0 || { text: "", href: "" },
          button1: doubleContent?.button1 || { text: "", href: "" },
          [buttonKey]: {
            text,
            href: currentHref || ""
          }
        });
      } else {
        formAPI.updateField(`${formAPI.blockPath}.content.${locale}`, {
          text,
          href: currentHref || ""
        });
      }
    },
    [formAPI, locale, buttonKey, currentHref, content]
  );
  const inputId = buttonKey ? `${buttonKey}-label` : "button-label";
  return /* @__PURE__ */ jsx(
    PanelVariableInputContent,
    {
      triggerOnChange: true,
      title: t2("editorBlocksLibrary.blocks.button.panel.label.title", "Label"),
      value: currentText ?? "",
      onChange: handleSave,
      variables: blockProps.variables,
      id: inputId,
      placeholder: t2(
        "editorBlocksLibrary.blocks.button.panel.label.description",
        "Enter the button text"
      ),
      outputFormat: "text"
    }
  );
}
function EmailPanelUrl2({ buttonKey } = {}) {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI } = blockProps;
  const block = blockProps.block;
  const { t: t2 } = useTranslation("editor-blocks-library");
  const locale = blockProps.locale || blockProps?.defaultLocale;
  const content = block.content?.[locale];
  const currentText = buttonKey ? content?.[buttonKey]?.text : content?.text;
  const currentHref = buttonKey ? content?.[buttonKey]?.href : content?.href;
  const handleSave = useCallback(
    (href) => {
      if (buttonKey) {
        const doubleContent = content;
        formAPI.updateField(`${formAPI.blockPath}.content.${locale}`, {
          button0: doubleContent?.button0 || { text: "", href: "" },
          button1: doubleContent?.button1 || { text: "", href: "" },
          [buttonKey]: {
            text: currentText || "",
            href
          }
        });
      } else {
        formAPI.updateField(`${formAPI.blockPath}.content.${locale}`, {
          text: currentText || "",
          href
        });
      }
    },
    [formAPI, locale, buttonKey, currentText, content]
  );
  const inputId = buttonKey ? `${buttonKey}-url` : "button-url";
  return /* @__PURE__ */ jsx(
    PanelVariableInputContent,
    {
      title: t2("editorBlocksLibrary.blocks.button.panel.url.title", "Link"),
      value: currentHref ?? "",
      onChange: handleSave,
      variables: blockProps.variables,
      id: inputId,
      placeholder: t2(
        "editorBlocksLibrary.blocks.button.panel.url.placeholder",
        "Enter the button URL"
      ),
      outputFormat: "text",
      triggerOnChange: true
    }
  );
}
var VARIANT_OPTIONS = [
  {
    value: "default",
    label: "editorBlocksLibrary.blocks.button.variant.default.title",
    description: "editorBlocksLibrary.blocks.button.variant.default.description"
  },
  {
    value: "primary",
    label: "editorBlocksLibrary.blocks.button.variant.primary.title",
    description: "editorBlocksLibrary.blocks.button.variant.primary.description"
  },
  {
    value: "secondary",
    label: "editorBlocksLibrary.blocks.button.variant.secondary.title",
    description: "editorBlocksLibrary.blocks.button.variant.secondary.description"
  },
  {
    value: "outline",
    label: "editorBlocksLibrary.blocks.button.variant.outline.title",
    description: "editorBlocksLibrary.blocks.button.variant.outline.description"
  }
];
function SettingsCard({ children, className }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "bg-muted/10 rounded-xl p-0 border border-border/50 flex flex-row overflow-hidden",
        className
      ),
      children
    }
  );
}
function EmailPanelStyle({ variantFieldName = "variant" } = {}) {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI, theme, section } = blockProps;
  const block = blockProps.block;
  const variant = block.properties?.[variantFieldName] ?? "default";
  const buttonRadius = useEmailThemeRadius(theme, "button");
  const { t: t2 } = useTranslation("editor-blocks-library");
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const handleVariantChange = useCallback((newVariant) => {
    formAPI.updateField(`${formAPI.blockPath}.properties.${variantFieldName}`, newVariant);
  }, [formAPI, variantFieldName]);
  const renderButtonPreview = (variantOption) => {
    const previewStyles = Object.assign(getThemeButtonStyle({
      theme,
      variant: variantOption,
      textColor: colors.text
    }), {
      fontSize: "0.6rem",
      padding: "3px 6px"
    });
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "p-3 h-full flex items-center justify-center shadow-[inset_6px_0_8px_-4px_rgba(0,0,0,0.1)]"
        ),
        style: { borderColor: colors.contrast, backgroundColor: colors.bg },
        children: /* @__PURE__ */ jsx("div", { style: previewStyles, className: cn(buttonRadius), children: "Aper\xE7u" })
      }
    );
  };
  return /* @__PURE__ */ jsx(PanelContent, { title: "Style", children: /* @__PURE__ */ jsx("div", { className: "grid grid-cols-1 gap-3 w-full", children: VARIANT_OPTIONS.map((option) => /* @__PURE__ */ jsx(
    SettingsCard,
    {
      className: "cursor-pointer",
      children: /* @__PURE__ */ jsxs("label", { className: "flex items-center space-x-3 cursor-pointer w-full", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-3 cursor-pointer w-full p-3", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "radio",
              name: variantFieldName,
              value: option.value,
              checked: variant === option.value,
              onChange: () => handleVariantChange(option.value),
              className: "sr-only"
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: cn(
                "w-4 h-4 rounded-full border-2 flex items-center justify-center",
                variant === option.value ? "border-primary bg-primary" : "border-muted-foreground"
              ),
              children: variant === option.value && /* @__PURE__ */ jsx("div", { className: "w-2 h-2 rounded-full bg-primary-foreground" })
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "flex-1", children: /* @__PURE__ */ jsx("div", { className: "font-medium text-xs", children: t2(option.label) }) })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "ml-auto h-full", children: renderButtonPreview(option.value) })
      ] })
    },
    option.value
  )) }) });
}
function PanelBlockFont() {
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.font || DEFAULT_FONT;
  const handleUpdate = (font) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      font
    });
  };
  return /* @__PURE__ */ jsx(PanelContent, { title: "Font", children: /* @__PURE__ */ jsx(
    Input,
    {
      value,
      className: "w-full text-sm h-8",
      onChange: (e) => handleUpdate(e.target.value)
    }
  ) });
}
function ButtonEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(EmailPanelLabel, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(EmailPanelUrl2, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(EmailPanelStyle, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelBlockFont, {}),
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "translatable", portal: true })
  ] });
}
function ButtonWeb({
  block,
  formatter,
  theme,
  locale,
  defaultLocale,
  section,
  isEditor,
  shop
}) {
  const contentHTML = block.content?.[locale]?.text || block.content?.[defaultLocale]?.text;
  const alignment = block.alignment || "center";
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const href = block.content?.[locale]?.href || block.content?.[defaultLocale]?.href;
  let formattedText = !!formatter && contentHTML ? formatter(contentHTML) : contentHTML;
  const formattedHref = !!formatter && href ? formatter(href) : href;
  if (!formattedText?.length) {
    if (isEditor) {
      formattedText = "Ajoutez un label";
    } else {
      return null;
    }
  }
  const buttonStyle = getThemeButtonStyle({
    variant: block.properties?.variant || "default",
    theme,
    textColor: colors.text
  });
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop, children: /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("flex", {
        "justify-center": alignment === "center",
        "justify-start": alignment === "left",
        "justify-end": alignment === "right"
      }),
      children: /* @__PURE__ */ jsx("a", { href: formattedHref, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ jsx(Button, { style: buttonStyle, children: /* @__PURE__ */ jsx(
        "span",
        {
          dangerouslySetInnerHTML: {
            __html: formattedText
          }
        }
      ) }) })
    }
  ) });
}
function ButtonWebEditor(props) {
  return /* @__PURE__ */ jsx(ButtonWeb, { isEditor: true, ...props });
}

// ../editor-blocks-library/src/blocks/button/index.tsx
var button_default = registerBlock({
  type: "button",
  name: "editorBlocksLibrary.blocks.button.title",
  description: "editorBlocksLibrary.blocks.button.description",
  Icon: Mouse,
  category: "essentials" /* ESSENTIALS */,
  isTranslated: (locale, block) => {
    const content = block.content;
    return !!content?.[locale]?.text?.length && !!content?.[locale]?.href?.length;
  },
  components: {
    email: {
      component: ButtonEmailRenderer,
      editor: {
        component: ButtonEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ButtonEmailPanelRenderer
      },
      compatibility: {
        rowBlock: true
      }
    },
    web: {
      component: ButtonWeb,
      editor: {
        component: ButtonWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ButtonEmailPanelRenderer
      },
      compatibility: {
        rowBlock: true
      }
    }
  }
});

// ../editor-blocks-library/src/lib/format-template.ts
function formatTemplate(html) {
  if (!html) return html;
  const mentionSpanRegex = /<span\b[^>]*data-type=["']mention["'][^>]*data-id=["']([^"']+)["'][^>]*>.*?<\/span>/g;
  return html.replace(mentionSpanRegex, (_, id) => `{{${id}}}`);
}
var format_template_default = formatTemplate;
function DynamicTextEmailRenderer({
  locale,
  block,
  formatter,
  theme,
  section,
  defaultLocale,
  isEditor = false,
  isPreview = false
}) {
  const content = block.content?.[locale]?.html || block.content?.[defaultLocale]?.html || "";
  const alignment = block.alignment;
  const font = block.font ?? DEFAULT_FONT;
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  let processedHtml = content.replace(/<p([^>]*)><\/p>/g, "<p$1>&nbsp;</p>");
  if (isEditor && processedHtml.trim() === "") {
    processedHtml = "<p>Cliquez pour ajouter du texte</p>";
  }
  if (isPreview && processedHtml.trim() === "") {
    processedHtml = "<p style='color: " + (colors.text ?? "#999") + "; opacity: 0.5; font-style: italic;'>Contenu dynamique</p>";
  }
  if (!isEditor && !isPreview && processedHtml.trim() === "") {
    return null;
  }
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(
    "div",
    {
      style: { color: colors.text, fontFamily: font },
      className: cn(
        "font-sans text-sm leading-tight text-primary m-0 p-0",
        {
          left: "text-left",
          center: "text-center",
          right: "text-right"
        }[alignment]
      ),
      dangerouslySetInnerHTML: {
        __html: formatter(format_template_default(processedHtml))
      }
    }
  ) }) });
}
function DynamicTextPlaceholder() {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3 rounded-md border border-dashed border-muted-foreground/30 bg-muted/50 px-4 py-3", children: [
    /* @__PURE__ */ jsx(RefreshCw, { className: "mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" }),
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("p", { className: "text-sm font-medium text-muted-foreground", children: "Contenu dynamique" }),
      /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground/70", children: "Ce texte sera personnalis\xE9 pour chaque workflow." })
    ] })
  ] });
}
function DynamicTextEditorRenderer(props) {
  if (props.editorMode === "workflowCustom") {
    return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(DynamicTextEmailRenderer, { isEditor: true, ...props }) });
  }
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(DynamicTextPlaceholder, {}) });
}

// ../../node_modules/.pnpm/@tiptap+core@3.20.0_@tiptap+pm@3.20.0/node_modules/@tiptap/core/dist/jsx-runtime/jsx-runtime.js
var h = (tag, attributes) => {
  if (tag === "slot") {
    return 0;
  }
  if (tag instanceof Function) {
    return tag(attributes);
  }
  const { children, ...rest } = attributes != null ? attributes : {};
  if (tag === "svg") {
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  }
  return [tag, rest, children];
};

// ../../node_modules/.pnpm/@tiptap+extension-bold@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-bold/dist/index.js
var starInputRegex = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
var starPasteRegex = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
var underscoreInputRegex = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
var underscorePasteRegex = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
var Bold2 = Mark2.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (node) => node.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (mark) => mark.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (value) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return /* @__PURE__ */ h("strong", { ...mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), children: /* @__PURE__ */ h("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (token, helpers) => {
    return helpers.applyMark("bold", helpers.parseInline(token.tokens || []));
  },
  renderMarkdown: (node, h2) => {
    return `**${h2.renderChildren(node)}**`;
  },
  addCommands() {
    return {
      setBold: () => ({ commands }) => {
        return commands.setMark(this.name);
      },
      toggleBold: () => ({ commands }) => {
        return commands.toggleMark(this.name);
      },
      unsetBold: () => ({ commands }) => {
        return commands.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      markInputRule({
        find: starInputRegex,
        type: this.type
      }),
      markInputRule({
        find: underscoreInputRegex,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: starPasteRegex,
        type: this.type
      }),
      markPasteRule({
        find: underscorePasteRegex,
        type: this.type
      })
    ];
  }
});
var index_default5 = Bold2;

// ../../node_modules/.pnpm/@tiptap+extension-text-style@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-text-style/dist/index.js
var MAX_FIND_CHILD_SPAN_DEPTH = 20;
var findChildSpans = (element, depth = 0) => {
  const childSpans = [];
  if (!element.children.length || depth > MAX_FIND_CHILD_SPAN_DEPTH) {
    return childSpans;
  }
  Array.from(element.children).forEach((child) => {
    if (child.tagName === "SPAN") {
      childSpans.push(child);
    } else if (child.children.length) {
      childSpans.push(...findChildSpans(child, depth + 1));
    }
  });
  return childSpans;
};
var mergeNestedSpanStyles = (element) => {
  if (!element.children.length) {
    return;
  }
  const childSpans = findChildSpans(element);
  if (!childSpans) {
    return;
  }
  childSpans.forEach((childSpan) => {
    var _a, _b;
    const childStyle = childSpan.getAttribute("style");
    const closestParentSpanStyleOfChild = (_b = (_a = childSpan.parentElement) == null ? void 0 : _a.closest("span")) == null ? void 0 : _b.getAttribute("style");
    childSpan.setAttribute("style", `${closestParentSpanStyleOfChild};${childStyle}`);
  });
};
var TextStyle = Mark2.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: true
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: false,
        getAttrs: (element) => {
          const hasStyles = element.hasAttribute("style");
          if (!hasStyles) {
            return false;
          }
          if (this.options.mergeNestedSpanStyles) {
            mergeNestedSpanStyles(element);
          }
          return {};
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (attributes) => ({ commands }) => {
        return commands.toggleMark(this.name, attributes);
      },
      removeEmptyTextStyle: () => ({ tr: tr2 }) => {
        const { selection } = tr2;
        tr2.doc.nodesBetween(selection.from, selection.to, (node, pos) => {
          if (node.isTextblock) {
            return true;
          }
          if (!node.marks.filter((mark) => mark.type === this.type).some((mark) => Object.values(mark.attrs).some((value) => !!value))) {
            tr2.removeMark(pos, pos + node.nodeSize, this.type);
          }
        });
        return true;
      }
    };
  }
});
var BackgroundColor = Extension.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (element) => {
              var _a;
              const styleAttr = element.getAttribute("style");
              if (styleAttr) {
                const decls = styleAttr.split(";").map((s) => s.trim()).filter(Boolean);
                for (let i = decls.length - 1; i >= 0; i -= 1) {
                  const parts = decls[i].split(":");
                  if (parts.length >= 2) {
                    const prop = parts[0].trim().toLowerCase();
                    const val = parts.slice(1).join(":").trim();
                    if (prop === "background-color") {
                      return val.replace(/['"]+/g, "");
                    }
                  }
                }
              }
              return (_a = element.style.backgroundColor) == null ? void 0 : _a.replace(/['"]+/g, "");
            },
            renderHTML: (attributes) => {
              if (!attributes.backgroundColor) {
                return {};
              }
              return {
                style: `background-color: ${attributes.backgroundColor}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (backgroundColor) => ({ chain }) => {
        return chain().setMark("textStyle", { backgroundColor }).run();
      },
      unsetBackgroundColor: () => ({ chain }) => {
        return chain().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
var Color = Extension.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (element) => {
              var _a;
              const styleAttr = element.getAttribute("style");
              if (styleAttr) {
                const decls = styleAttr.split(";").map((s) => s.trim()).filter(Boolean);
                for (let i = decls.length - 1; i >= 0; i -= 1) {
                  const parts = decls[i].split(":");
                  if (parts.length >= 2) {
                    const prop = parts[0].trim().toLowerCase();
                    const val = parts.slice(1).join(":").trim();
                    if (prop === "color") {
                      return val.replace(/['"]+/g, "");
                    }
                  }
                }
              }
              return (_a = element.style.color) == null ? void 0 : _a.replace(/['"]+/g, "");
            },
            renderHTML: (attributes) => {
              if (!attributes.color) {
                return {};
              }
              return {
                style: `color: ${attributes.color}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (color) => ({ chain }) => {
        return chain().setMark("textStyle", { color }).run();
      },
      unsetColor: () => ({ chain }) => {
        return chain().setMark("textStyle", { color: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
var FontFamily = Extension.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (element) => element.style.fontFamily,
            renderHTML: (attributes) => {
              if (!attributes.fontFamily) {
                return {};
              }
              return {
                style: `font-family: ${attributes.fontFamily}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (fontFamily) => ({ chain }) => {
        return chain().setMark("textStyle", { fontFamily }).run();
      },
      unsetFontFamily: () => ({ chain }) => {
        return chain().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
var FontSize = Extension.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) {
                return {};
              }
              return {
                style: `font-size: ${attributes.fontSize}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (fontSize) => ({ chain }) => {
        return chain().setMark("textStyle", { fontSize }).run();
      },
      unsetFontSize: () => ({ chain }) => {
        return chain().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
var LineHeight = Extension.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            parseHTML: (element) => element.style.lineHeight,
            renderHTML: (attributes) => {
              if (!attributes.lineHeight) {
                return {};
              }
              return {
                style: `line-height: ${attributes.lineHeight}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (lineHeight) => ({ chain }) => {
        return chain().setMark("textStyle", { lineHeight }).run();
      },
      unsetLineHeight: () => ({ chain }) => {
        return chain().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
Extension.create({
  name: "textStyleKit",
  addExtensions() {
    const extensions = [];
    if (this.options.backgroundColor !== false) {
      extensions.push(BackgroundColor.configure(this.options.backgroundColor));
    }
    if (this.options.color !== false) {
      extensions.push(Color.configure(this.options.color));
    }
    if (this.options.fontFamily !== false) {
      extensions.push(FontFamily.configure(this.options.fontFamily));
    }
    if (this.options.fontSize !== false) {
      extensions.push(FontSize.configure(this.options.fontSize));
    }
    if (this.options.lineHeight !== false) {
      extensions.push(LineHeight.configure(this.options.lineHeight));
    }
    if (this.options.textStyle !== false) {
      extensions.push(TextStyle.configure(this.options.textStyle));
    }
    return extensions;
  }
});

// ../../node_modules/.pnpm/@tiptap+extension-font-size@3.0.0-next.3_@tiptap+core@3.20.0_@tiptap+pm@3.20.0__@tiptap_bd026f8ea385e751d38e17199bf77ce3/node_modules/@tiptap/extension-font-size/dist/index.js
var FontSize2 = Extension.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) {
                return {};
              }
              return {
                style: `font-size: ${attributes.fontSize}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (fontSize) => ({ chain }) => {
        return chain().setMark("textStyle", { fontSize }).run();
      },
      unsetFontSize: () => ({ chain }) => {
        return chain().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
var src_default = FontSize2;

// ../../node_modules/.pnpm/@tiptap+extension-italic@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-italic/dist/index.js
var starInputRegex2 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
var starPasteRegex2 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
var underscoreInputRegex2 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
var underscorePasteRegex2 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
var Italic2 = Mark2.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (node) => node.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (mark) => mark.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["em", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands }) => {
        return commands.setMark(this.name);
      },
      toggleItalic: () => ({ commands }) => {
        return commands.toggleMark(this.name);
      },
      unsetItalic: () => ({ commands }) => {
        return commands.unsetMark(this.name);
      }
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (token, helpers) => {
    return helpers.applyMark("italic", helpers.parseInline(token.tokens || []));
  },
  renderMarkdown: (node, h2) => {
    return `*${h2.renderChildren(node)}*`;
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      markInputRule({
        find: starInputRegex2,
        type: this.type
      }),
      markInputRule({
        find: underscoreInputRegex2,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: starPasteRegex2,
        type: this.type
      }),
      markPasteRule({
        find: underscorePasteRegex2,
        type: this.type
      })
    ];
  }
});
var index_default6 = Italic2;

// ../../node_modules/.pnpm/linkifyjs@4.3.2/node_modules/linkifyjs/dist/linkify.mjs
var encodedTlds = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5m\xF6gensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2";
var encodedUtlds = "\u03B5\u03BB1\u03C52\u0431\u04331\u0435\u043B3\u0434\u0435\u0442\u04384\u0435\u044E2\u043A\u0430\u0442\u043E\u043B\u0438\u043A6\u043E\u043C3\u043C\u043A\u04342\u043E\u043D1\u0441\u043A\u0432\u04306\u043E\u043D\u043B\u0430\u0439\u043D5\u0440\u04333\u0440\u0443\u04412\u04442\u0441\u0430\u0439\u04423\u0440\u04313\u0443\u043A\u04403\u049B\u0430\u04373\u0570\u0561\u05753\u05D9\u05E9\u05E8\u05D0\u05DC5\u05E7\u05D5\u05DD3\u0627\u0628\u0648\u0638\u0628\u064A5\u0631\u0627\u0645\u0643\u06485\u0644\u0627\u0631\u062F\u06464\u0628\u062D\u0631\u064A\u06465\u062C\u0632\u0627\u0626\u06315\u0633\u0639\u0648\u062F\u064A\u06296\u0639\u0644\u064A\u0627\u06465\u0645\u063A\u0631\u06285\u0645\u0627\u0631\u0627\u062A5\u06CC\u0631\u0627\u06465\u0628\u0627\u0631\u062A2\u0632\u0627\u06314\u064A\u062A\u06433\u06BE\u0627\u0631\u062A5\u062A\u0648\u0646\u06334\u0633\u0648\u062F\u0627\u06463\u0631\u064A\u06295\u0634\u0628\u0643\u06294\u0639\u0631\u0627\u06422\u06282\u0645\u0627\u06464\u0641\u0644\u0633\u0637\u064A\u06466\u0642\u0637\u06313\u0643\u0627\u062B\u0648\u0644\u064A\u06436\u0648\u06453\u0645\u0635\u06312\u0644\u064A\u0633\u064A\u06275\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u06277\u0642\u06394\u0647\u0645\u0631\u0627\u06475\u067E\u0627\u06A9\u0633\u062A\u0627\u06467\u0680\u0627\u0631\u062A4\u0915\u0949\u092E3\u0928\u0947\u091F3\u092D\u093E\u0930\u09240\u092E\u094D3\u094B\u09245\u0938\u0902\u0917\u0920\u09285\u09AC\u09BE\u0982\u09B2\u09BE5\u09AD\u09BE\u09B0\u09A42\u09F0\u09A44\u0A2D\u0A3E\u0A30\u0A244\u0AAD\u0ABE\u0AB0\u0AA44\u0B2D\u0B3E\u0B30\u0B244\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE6\u0BB2\u0B99\u0BCD\u0B95\u0BC86\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD11\u0C2D\u0C3E\u0C30\u0C24\u0C4D5\u0CAD\u0CBE\u0CB0\u0CA44\u0D2D\u0D3E\u0D30\u0D24\u0D025\u0DBD\u0D82\u0D9A\u0DCF4\u0E04\u0E2D\u0E213\u0E44\u0E17\u0E223\u0EA5\u0EB2\u0EA73\u10D2\u10D42\u307F\u3093\u306A3\u30A2\u30DE\u30BE\u30F34\u30AF\u30E9\u30A6\u30C94\u30B0\u30FC\u30B0\u30EB4\u30B3\u30E02\u30B9\u30C8\u30A23\u30BB\u30FC\u30EB3\u30D5\u30A1\u30C3\u30B7\u30E7\u30F36\u30DD\u30A4\u30F3\u30C84\u4E16\u754C2\u4E2D\u4FE11\u56FD1\u570B1\u6587\u7F513\u4E9A\u9A6C\u900A3\u4F01\u4E1A2\u4F5B\u5C712\u4FE1\u606F2\u5065\u5EB72\u516B\u53662\u516C\u53F81\u76CA2\u53F0\u6E7E1\u70632\u5546\u57CE1\u5E971\u68072\u5609\u91CC0\u5927\u9152\u5E975\u5728\u7EBF2\u5927\u62FF2\u5929\u4E3B\u65593\u5A31\u4E502\u5BB6\u96FB2\u5E7F\u4E1C2\u5FAE\u535A2\u6148\u55842\u6211\u7231\u4F603\u624B\u673A2\u62DB\u80582\u653F\u52A11\u5E9C2\u65B0\u52A0\u57612\u95FB2\u65F6\u5C1A2\u66F8\u7C4D2\u673A\u67842\u6DE1\u9A6C\u95213\u6E38\u620F2\u6FB3\u95802\u70B9\u770B2\u79FB\u52A82\u7EC4\u7EC7\u673A\u67844\u7F51\u57401\u5E971\u7AD91\u7EDC2\u8054\u901A2\u8C37\u6B4C2\u8D2D\u72692\u901A\u8CA92\u96C6\u56E22\u96FB\u8A0A\u76C8\u79D14\u98DE\u5229\u6D663\u98DF\u54C12\u9910\u53852\u9999\u683C\u91CC\u62C93\u6E2F2\uB2F7\uB1371\uCEF42\uC0BC\uC1312\uD55C\uAD6D2";
var numeric = "numeric";
var ascii = "ascii";
var alpha = "alpha";
var asciinumeric = "asciinumeric";
var alphanumeric = "alphanumeric";
var domain = "domain";
var emoji = "emoji";
var scheme = "scheme";
var slashscheme = "slashscheme";
var whitespace = "whitespace";
function registerGroup(name, groups) {
  if (!(name in groups)) {
    groups[name] = [];
  }
  return groups[name];
}
function addToGroups(t2, flags, groups) {
  if (flags[numeric]) {
    flags[asciinumeric] = true;
    flags[alphanumeric] = true;
  }
  if (flags[ascii]) {
    flags[asciinumeric] = true;
    flags[alpha] = true;
  }
  if (flags[asciinumeric]) {
    flags[alphanumeric] = true;
  }
  if (flags[alpha]) {
    flags[alphanumeric] = true;
  }
  if (flags[alphanumeric]) {
    flags[domain] = true;
  }
  if (flags[emoji]) {
    flags[domain] = true;
  }
  for (const k in flags) {
    const group = registerGroup(k, groups);
    if (group.indexOf(t2) < 0) {
      group.push(t2);
    }
  }
}
function flagsForToken(t2, groups) {
  const result = {};
  for (const c in groups) {
    if (groups[c].indexOf(t2) >= 0) {
      result[c] = true;
    }
  }
  return result;
}
function State(token = null) {
  this.j = {};
  this.jr = [];
  this.jd = null;
  this.t = token;
}
State.groups = {};
State.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(input) {
    const state = this;
    const nextState = state.j[input];
    if (nextState) {
      return nextState;
    }
    for (let i = 0; i < state.jr.length; i++) {
      const regex = state.jr[i][0];
      const nextState2 = state.jr[i][1];
      if (nextState2 && regex.test(input)) {
        return nextState2;
      }
    }
    return state.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(input, exactOnly = false) {
    return exactOnly ? input in this.j : !!this.go(input);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(inputs, next, flags, groups) {
    for (let i = 0; i < inputs.length; i++) {
      this.tt(inputs[i], next, flags, groups);
    }
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(regexp, next, flags, groups) {
    groups = groups || State.groups;
    let nextState;
    if (next && next.j) {
      nextState = next;
    } else {
      nextState = new State(next);
      if (flags && groups) {
        addToGroups(next, flags, groups);
      }
    }
    this.jr.push([regexp, nextState]);
    return nextState;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(input, next, flags, groups) {
    let state = this;
    const len = input.length;
    if (!len) {
      return state;
    }
    for (let i = 0; i < len - 1; i++) {
      state = state.tt(input[i]);
    }
    return state.tt(input[len - 1], next, flags, groups);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(input, next, flags, groups) {
    groups = groups || State.groups;
    const state = this;
    if (next && next.j) {
      state.j[input] = next;
      return next;
    }
    const t2 = next;
    let nextState, templateState = state.go(input);
    if (templateState) {
      nextState = new State();
      Object.assign(nextState.j, templateState.j);
      nextState.jr.push.apply(nextState.jr, templateState.jr);
      nextState.jd = templateState.jd;
      nextState.t = templateState.t;
    } else {
      nextState = new State();
    }
    if (t2) {
      if (groups) {
        if (nextState.t && typeof nextState.t === "string") {
          const allFlags = Object.assign(flagsForToken(nextState.t, groups), flags);
          addToGroups(t2, allFlags, groups);
        } else if (flags) {
          addToGroups(t2, flags, groups);
        }
      }
      nextState.t = t2;
    }
    state.j[input] = nextState;
    return nextState;
  }
};
var ta = (state, input, next, flags, groups) => state.ta(input, next, flags, groups);
var tr = (state, regexp, next, flags, groups) => state.tr(regexp, next, flags, groups);
var ts = (state, input, next, flags, groups) => state.ts(input, next, flags, groups);
var tt = (state, input, next, flags, groups) => state.tt(input, next, flags, groups);
var WORD = "WORD";
var UWORD = "UWORD";
var ASCIINUMERICAL = "ASCIINUMERICAL";
var ALPHANUMERICAL = "ALPHANUMERICAL";
var LOCALHOST = "LOCALHOST";
var TLD = "TLD";
var UTLD = "UTLD";
var SCHEME = "SCHEME";
var SLASH_SCHEME = "SLASH_SCHEME";
var NUM = "NUM";
var WS = "WS";
var NL = "NL";
var OPENBRACE = "OPENBRACE";
var CLOSEBRACE = "CLOSEBRACE";
var OPENBRACKET = "OPENBRACKET";
var CLOSEBRACKET = "CLOSEBRACKET";
var OPENPAREN = "OPENPAREN";
var CLOSEPAREN = "CLOSEPAREN";
var OPENANGLEBRACKET = "OPENANGLEBRACKET";
var CLOSEANGLEBRACKET = "CLOSEANGLEBRACKET";
var FULLWIDTHLEFTPAREN = "FULLWIDTHLEFTPAREN";
var FULLWIDTHRIGHTPAREN = "FULLWIDTHRIGHTPAREN";
var LEFTCORNERBRACKET = "LEFTCORNERBRACKET";
var RIGHTCORNERBRACKET = "RIGHTCORNERBRACKET";
var LEFTWHITECORNERBRACKET = "LEFTWHITECORNERBRACKET";
var RIGHTWHITECORNERBRACKET = "RIGHTWHITECORNERBRACKET";
var FULLWIDTHLESSTHAN = "FULLWIDTHLESSTHAN";
var FULLWIDTHGREATERTHAN = "FULLWIDTHGREATERTHAN";
var AMPERSAND = "AMPERSAND";
var APOSTROPHE = "APOSTROPHE";
var ASTERISK = "ASTERISK";
var AT = "AT";
var BACKSLASH = "BACKSLASH";
var BACKTICK = "BACKTICK";
var CARET = "CARET";
var COLON = "COLON";
var COMMA = "COMMA";
var DOLLAR = "DOLLAR";
var DOT = "DOT";
var EQUALS = "EQUALS";
var EXCLAMATION = "EXCLAMATION";
var HYPHEN = "HYPHEN";
var PERCENT = "PERCENT";
var PIPE = "PIPE";
var PLUS = "PLUS";
var POUND = "POUND";
var QUERY = "QUERY";
var QUOTE = "QUOTE";
var FULLWIDTHMIDDLEDOT = "FULLWIDTHMIDDLEDOT";
var SEMI = "SEMI";
var SLASH = "SLASH";
var TILDE = "TILDE";
var UNDERSCORE = "UNDERSCORE";
var EMOJI$1 = "EMOJI";
var SYM = "SYM";
var tk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL,
  AMPERSAND,
  APOSTROPHE,
  ASCIINUMERICAL,
  ASTERISK,
  AT,
  BACKSLASH,
  BACKTICK,
  CARET,
  CLOSEANGLEBRACKET,
  CLOSEBRACE,
  CLOSEBRACKET,
  CLOSEPAREN,
  COLON,
  COMMA,
  DOLLAR,
  DOT,
  EMOJI: EMOJI$1,
  EQUALS,
  EXCLAMATION,
  FULLWIDTHGREATERTHAN,
  FULLWIDTHLEFTPAREN,
  FULLWIDTHLESSTHAN,
  FULLWIDTHMIDDLEDOT,
  FULLWIDTHRIGHTPAREN,
  HYPHEN,
  LEFTCORNERBRACKET,
  LEFTWHITECORNERBRACKET,
  LOCALHOST,
  NL,
  NUM,
  OPENANGLEBRACKET,
  OPENBRACE,
  OPENBRACKET,
  OPENPAREN,
  PERCENT,
  PIPE,
  PLUS,
  POUND,
  QUERY,
  QUOTE,
  RIGHTCORNERBRACKET,
  RIGHTWHITECORNERBRACKET,
  SCHEME,
  SEMI,
  SLASH,
  SLASH_SCHEME,
  SYM,
  TILDE,
  TLD,
  UNDERSCORE,
  UTLD,
  UWORD,
  WORD,
  WS
});
var ASCII_LETTER = /[a-z]/;
var LETTER = /\p{L}/u;
var EMOJI = /\p{Emoji}/u;
var DIGIT = /\d/;
var SPACE = /\s/;
var CR = "\r";
var LF = "\n";
var EMOJI_VARIATION = "\uFE0F";
var EMOJI_JOINER = "\u200D";
var OBJECT_REPLACEMENT = "\uFFFC";
var tlds = null;
var utlds = null;
function init$2(customSchemes = []) {
  const groups = {};
  State.groups = groups;
  const Start = new State();
  if (tlds == null) {
    tlds = decodeTlds(encodedTlds);
  }
  if (utlds == null) {
    utlds = decodeTlds(encodedUtlds);
  }
  tt(Start, "'", APOSTROPHE);
  tt(Start, "{", OPENBRACE);
  tt(Start, "}", CLOSEBRACE);
  tt(Start, "[", OPENBRACKET);
  tt(Start, "]", CLOSEBRACKET);
  tt(Start, "(", OPENPAREN);
  tt(Start, ")", CLOSEPAREN);
  tt(Start, "<", OPENANGLEBRACKET);
  tt(Start, ">", CLOSEANGLEBRACKET);
  tt(Start, "\uFF08", FULLWIDTHLEFTPAREN);
  tt(Start, "\uFF09", FULLWIDTHRIGHTPAREN);
  tt(Start, "\u300C", LEFTCORNERBRACKET);
  tt(Start, "\u300D", RIGHTCORNERBRACKET);
  tt(Start, "\u300E", LEFTWHITECORNERBRACKET);
  tt(Start, "\u300F", RIGHTWHITECORNERBRACKET);
  tt(Start, "\uFF1C", FULLWIDTHLESSTHAN);
  tt(Start, "\uFF1E", FULLWIDTHGREATERTHAN);
  tt(Start, "&", AMPERSAND);
  tt(Start, "*", ASTERISK);
  tt(Start, "@", AT);
  tt(Start, "`", BACKTICK);
  tt(Start, "^", CARET);
  tt(Start, ":", COLON);
  tt(Start, ",", COMMA);
  tt(Start, "$", DOLLAR);
  tt(Start, ".", DOT);
  tt(Start, "=", EQUALS);
  tt(Start, "!", EXCLAMATION);
  tt(Start, "-", HYPHEN);
  tt(Start, "%", PERCENT);
  tt(Start, "|", PIPE);
  tt(Start, "+", PLUS);
  tt(Start, "#", POUND);
  tt(Start, "?", QUERY);
  tt(Start, '"', QUOTE);
  tt(Start, "/", SLASH);
  tt(Start, ";", SEMI);
  tt(Start, "~", TILDE);
  tt(Start, "_", UNDERSCORE);
  tt(Start, "\\", BACKSLASH);
  tt(Start, "\u30FB", FULLWIDTHMIDDLEDOT);
  const Num = tr(Start, DIGIT, NUM, {
    [numeric]: true
  });
  tr(Num, DIGIT, Num);
  const Asciinumeric = tr(Num, ASCII_LETTER, ASCIINUMERICAL, {
    [asciinumeric]: true
  });
  const Alphanumeric = tr(Num, LETTER, ALPHANUMERICAL, {
    [alphanumeric]: true
  });
  const Word = tr(Start, ASCII_LETTER, WORD, {
    [ascii]: true
  });
  tr(Word, DIGIT, Asciinumeric);
  tr(Word, ASCII_LETTER, Word);
  tr(Asciinumeric, DIGIT, Asciinumeric);
  tr(Asciinumeric, ASCII_LETTER, Asciinumeric);
  const UWord = tr(Start, LETTER, UWORD, {
    [alpha]: true
  });
  tr(UWord, ASCII_LETTER);
  tr(UWord, DIGIT, Alphanumeric);
  tr(UWord, LETTER, UWord);
  tr(Alphanumeric, DIGIT, Alphanumeric);
  tr(Alphanumeric, ASCII_LETTER);
  tr(Alphanumeric, LETTER, Alphanumeric);
  const Nl2 = tt(Start, LF, NL, {
    [whitespace]: true
  });
  const Cr = tt(Start, CR, WS, {
    [whitespace]: true
  });
  const Ws = tr(Start, SPACE, WS, {
    [whitespace]: true
  });
  tt(Start, OBJECT_REPLACEMENT, Ws);
  tt(Cr, LF, Nl2);
  tt(Cr, OBJECT_REPLACEMENT, Ws);
  tr(Cr, SPACE, Ws);
  tt(Ws, CR);
  tt(Ws, LF);
  tr(Ws, SPACE, Ws);
  tt(Ws, OBJECT_REPLACEMENT, Ws);
  const Emoji = tr(Start, EMOJI, EMOJI$1, {
    [emoji]: true
  });
  tt(Emoji, "#");
  tr(Emoji, EMOJI, Emoji);
  tt(Emoji, EMOJI_VARIATION, Emoji);
  const EmojiJoiner = tt(Emoji, EMOJI_JOINER);
  tt(EmojiJoiner, "#");
  tr(EmojiJoiner, EMOJI, Emoji);
  const wordjr = [[ASCII_LETTER, Word], [DIGIT, Asciinumeric]];
  const uwordjr = [[ASCII_LETTER, null], [LETTER, UWord], [DIGIT, Alphanumeric]];
  for (let i = 0; i < tlds.length; i++) {
    fastts(Start, tlds[i], TLD, WORD, wordjr);
  }
  for (let i = 0; i < utlds.length; i++) {
    fastts(Start, utlds[i], UTLD, UWORD, uwordjr);
  }
  addToGroups(TLD, {
    tld: true,
    ascii: true
  }, groups);
  addToGroups(UTLD, {
    utld: true,
    alpha: true
  }, groups);
  fastts(Start, "file", SCHEME, WORD, wordjr);
  fastts(Start, "mailto", SCHEME, WORD, wordjr);
  fastts(Start, "http", SLASH_SCHEME, WORD, wordjr);
  fastts(Start, "https", SLASH_SCHEME, WORD, wordjr);
  fastts(Start, "ftp", SLASH_SCHEME, WORD, wordjr);
  fastts(Start, "ftps", SLASH_SCHEME, WORD, wordjr);
  addToGroups(SCHEME, {
    scheme: true,
    ascii: true
  }, groups);
  addToGroups(SLASH_SCHEME, {
    slashscheme: true,
    ascii: true
  }, groups);
  customSchemes = customSchemes.sort((a, b) => a[0] > b[0] ? 1 : -1);
  for (let i = 0; i < customSchemes.length; i++) {
    const sch = customSchemes[i][0];
    const optionalSlashSlash = customSchemes[i][1];
    const flags = optionalSlashSlash ? {
      [scheme]: true
    } : {
      [slashscheme]: true
    };
    if (sch.indexOf("-") >= 0) {
      flags[domain] = true;
    } else if (!ASCII_LETTER.test(sch)) {
      flags[numeric] = true;
    } else if (DIGIT.test(sch)) {
      flags[asciinumeric] = true;
    } else {
      flags[ascii] = true;
    }
    ts(Start, sch, sch, flags);
  }
  ts(Start, "localhost", LOCALHOST, {
    ascii: true
  });
  Start.jd = new State(SYM);
  return {
    start: Start,
    tokens: Object.assign({
      groups
    }, tk)
  };
}
function run$1(start2, str) {
  const iterable = stringToArray(str.replace(/[A-Z]/g, (c) => c.toLowerCase()));
  const charCount = iterable.length;
  const tokens = [];
  let cursor = 0;
  let charCursor = 0;
  while (charCursor < charCount) {
    let state = start2;
    let nextState = null;
    let tokenLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    let charsSinceAccepts = -1;
    while (charCursor < charCount && (nextState = state.go(iterable[charCursor]))) {
      state = nextState;
      if (state.accepts()) {
        sinceAccepts = 0;
        charsSinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts += iterable[charCursor].length;
        charsSinceAccepts++;
      }
      tokenLength += iterable[charCursor].length;
      cursor += iterable[charCursor].length;
      charCursor++;
    }
    cursor -= sinceAccepts;
    charCursor -= charsSinceAccepts;
    tokenLength -= sinceAccepts;
    tokens.push({
      t: latestAccepting.t,
      // token type/name
      v: str.slice(cursor - tokenLength, cursor),
      // string value
      s: cursor - tokenLength,
      // start index
      e: cursor
      // end index (excluding)
    });
  }
  return tokens;
}
function stringToArray(str) {
  const result = [];
  const len = str.length;
  let index2 = 0;
  while (index2 < len) {
    let first2 = str.charCodeAt(index2);
    let second;
    let char = first2 < 55296 || first2 > 56319 || index2 + 1 === len || (second = str.charCodeAt(index2 + 1)) < 56320 || second > 57343 ? str[index2] : str.slice(index2, index2 + 2);
    result.push(char);
    index2 += char.length;
  }
  return result;
}
function fastts(state, input, t2, defaultt, jr) {
  let next;
  const len = input.length;
  for (let i = 0; i < len - 1; i++) {
    const char = input[i];
    if (state.j[char]) {
      next = state.j[char];
    } else {
      next = new State(defaultt);
      next.jr = jr.slice();
      state.j[char] = next;
    }
    state = next;
  }
  next = new State(t2);
  next.jr = jr.slice();
  state.j[input[len - 1]] = next;
  return next;
}
function decodeTlds(encoded) {
  const words = [];
  const stack = [];
  let i = 0;
  let digits = "0123456789";
  while (i < encoded.length) {
    let popDigitCount = 0;
    while (digits.indexOf(encoded[i + popDigitCount]) >= 0) {
      popDigitCount++;
    }
    if (popDigitCount > 0) {
      words.push(stack.join(""));
      for (let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--) {
        stack.pop();
      }
      i += popDigitCount;
    } else {
      stack.push(encoded[i]);
      i++;
    }
  }
  return words;
}
var defaults = {
  defaultProtocol: "http",
  events: null,
  format: noop3,
  formatHref: noop3,
  nl2br: false,
  tagName: "a",
  target: null,
  rel: null,
  validate: true,
  truncate: Infinity,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Options(opts, defaultRender = null) {
  let o = Object.assign({}, defaults);
  if (opts) {
    o = Object.assign(o, opts instanceof Options ? opts.o : opts);
  }
  const ignoredTags = o.ignoreTags;
  const uppercaseIgnoredTags = [];
  for (let i = 0; i < ignoredTags.length; i++) {
    uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
  }
  this.o = o;
  if (defaultRender) {
    this.defaultRender = defaultRender;
  }
  this.ignoreTags = uppercaseIgnoredTags;
}
Options.prototype = {
  o: defaults,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(ir) {
    return ir;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(token) {
    return this.get("validate", token.toString(), token);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(key, operator, token) {
    const isCallable = operator != null;
    let option = this.o[key];
    if (!option) {
      return option;
    }
    if (typeof option === "object") {
      option = token.t in option ? option[token.t] : defaults[key];
      if (typeof option === "function" && isCallable) {
        option = option(operator, token);
      }
    } else if (typeof option === "function" && isCallable) {
      option = option(operator, token.t, token);
    }
    return option;
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(key, operator, token) {
    let obj = this.o[key];
    if (typeof obj === "function" && operator != null) {
      obj = obj(operator, token.t, token);
    }
    return obj;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(token) {
    const ir = token.render(this);
    const renderFn = this.get("render", null, token) || this.defaultRender;
    return renderFn(ir, token.t, token);
  }
};
function noop3(val) {
  return val;
}
function MultiToken(value, tokens) {
  this.t = "token";
  this.v = value;
  this.tk = tokens;
}
MultiToken.prototype = {
  isLink: false,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(scheme2) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(options) {
    const val = this.toString();
    const truncate = options.get("truncate", val, this);
    const formatted = options.get("format", val, this);
    return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + "\u2026" : formatted;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(options) {
    return options.get("formatHref", this.toHref(options.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(protocol = defaults.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(protocol),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(options) {
    return {
      type: this.t,
      value: this.toFormattedString(options),
      isLink: this.isLink,
      href: this.toFormattedHref(options),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(options) {
    return options.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(options) {
    const token = this;
    const href = this.toHref(options.get("defaultProtocol"));
    const formattedHref = options.get("formatHref", href, this);
    const tagName = options.get("tagName", href, token);
    const content = this.toFormattedString(options);
    const attributes = {};
    const className = options.get("className", href, token);
    const target = options.get("target", href, token);
    const rel = options.get("rel", href, token);
    const attrs = options.getObj("attributes", href, token);
    const eventListeners = options.getObj("events", href, token);
    attributes.href = formattedHref;
    if (className) {
      attributes.class = className;
    }
    if (target) {
      attributes.target = target;
    }
    if (rel) {
      attributes.rel = rel;
    }
    if (attrs) {
      Object.assign(attributes, attrs);
    }
    return {
      tagName,
      attributes,
      content,
      eventListeners
    };
  }
};
function createTokenClass(type, props) {
  class Token extends MultiToken {
    constructor(value, tokens) {
      super(value, tokens);
      this.t = type;
    }
  }
  for (const p in props) {
    Token.prototype[p] = props[p];
  }
  Token.t = type;
  return Token;
}
var Email = createTokenClass("email", {
  isLink: true,
  toHref() {
    return "mailto:" + this.toString();
  }
});
var Text2 = createTokenClass("text");
var Nl = createTokenClass("nl");
var Url = createTokenClass("url", {
  isLink: true,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(scheme2 = defaults.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${scheme2}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const tokens = this.tk;
    return tokens.length >= 2 && tokens[0].t !== LOCALHOST && tokens[1].t === COLON;
  }
});
var makeState = (arg) => new State(arg);
function init$1({
  groups
}) {
  const qsAccepting = groups.domain.concat([AMPERSAND, ASTERISK, AT, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, NUM, PERCENT, PIPE, PLUS, POUND, SLASH, SYM, TILDE, UNDERSCORE]);
  const qsNonAccepting = [APOSTROPHE, COLON, COMMA, DOT, EXCLAMATION, PERCENT, QUERY, QUOTE, SEMI, OPENANGLEBRACKET, CLOSEANGLEBRACKET, OPENBRACE, CLOSEBRACE, CLOSEBRACKET, OPENBRACKET, OPENPAREN, CLOSEPAREN, FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN, LEFTCORNERBRACKET, RIGHTCORNERBRACKET, LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET, FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN];
  const localpartAccepting = [AMPERSAND, APOSTROPHE, ASTERISK, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, OPENBRACE, CLOSEBRACE, PERCENT, PIPE, PLUS, POUND, QUERY, SLASH, SYM, TILDE, UNDERSCORE];
  const Start = makeState();
  const Localpart = tt(Start, TILDE);
  ta(Localpart, localpartAccepting, Localpart);
  ta(Localpart, groups.domain, Localpart);
  const Domain = makeState(), Scheme = makeState(), SlashScheme = makeState();
  ta(Start, groups.domain, Domain);
  ta(Start, groups.scheme, Scheme);
  ta(Start, groups.slashscheme, SlashScheme);
  ta(Domain, localpartAccepting, Localpart);
  ta(Domain, groups.domain, Domain);
  const LocalpartAt = tt(Domain, AT);
  tt(Localpart, AT, LocalpartAt);
  tt(Scheme, AT, LocalpartAt);
  tt(SlashScheme, AT, LocalpartAt);
  const LocalpartDot = tt(Localpart, DOT);
  ta(LocalpartDot, localpartAccepting, Localpart);
  ta(LocalpartDot, groups.domain, Localpart);
  const EmailDomain = makeState();
  ta(LocalpartAt, groups.domain, EmailDomain);
  ta(EmailDomain, groups.domain, EmailDomain);
  const EmailDomainDot = tt(EmailDomain, DOT);
  ta(EmailDomainDot, groups.domain, EmailDomain);
  const Email$1 = makeState(Email);
  ta(EmailDomainDot, groups.tld, Email$1);
  ta(EmailDomainDot, groups.utld, Email$1);
  tt(LocalpartAt, LOCALHOST, Email$1);
  const EmailDomainHyphen = tt(EmailDomain, HYPHEN);
  tt(EmailDomainHyphen, HYPHEN, EmailDomainHyphen);
  ta(EmailDomainHyphen, groups.domain, EmailDomain);
  ta(Email$1, groups.domain, EmailDomain);
  tt(Email$1, DOT, EmailDomainDot);
  tt(Email$1, HYPHEN, EmailDomainHyphen);
  const EmailColon = tt(Email$1, COLON);
  ta(EmailColon, groups.numeric, Email);
  const DomainHyphen = tt(Domain, HYPHEN);
  const DomainDot = tt(Domain, DOT);
  tt(DomainHyphen, HYPHEN, DomainHyphen);
  ta(DomainHyphen, groups.domain, Domain);
  ta(DomainDot, localpartAccepting, Localpart);
  ta(DomainDot, groups.domain, Domain);
  const DomainDotTld = makeState(Url);
  ta(DomainDot, groups.tld, DomainDotTld);
  ta(DomainDot, groups.utld, DomainDotTld);
  ta(DomainDotTld, groups.domain, Domain);
  ta(DomainDotTld, localpartAccepting, Localpart);
  tt(DomainDotTld, DOT, DomainDot);
  tt(DomainDotTld, HYPHEN, DomainHyphen);
  tt(DomainDotTld, AT, LocalpartAt);
  const DomainDotTldColon = tt(DomainDotTld, COLON);
  const DomainDotTldColonPort = makeState(Url);
  ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);
  const Url$1 = makeState(Url);
  const UrlNonaccept = makeState();
  ta(Url$1, qsAccepting, Url$1);
  ta(Url$1, qsNonAccepting, UrlNonaccept);
  ta(UrlNonaccept, qsAccepting, Url$1);
  ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);
  tt(DomainDotTld, SLASH, Url$1);
  tt(DomainDotTldColonPort, SLASH, Url$1);
  const SchemeColon = tt(Scheme, COLON);
  const SlashSchemeColon = tt(SlashScheme, COLON);
  const SlashSchemeColonSlash = tt(SlashSchemeColon, SLASH);
  const UriPrefix = tt(SlashSchemeColonSlash, SLASH);
  ta(Scheme, groups.domain, Domain);
  tt(Scheme, DOT, DomainDot);
  tt(Scheme, HYPHEN, DomainHyphen);
  ta(SlashScheme, groups.domain, Domain);
  tt(SlashScheme, DOT, DomainDot);
  tt(SlashScheme, HYPHEN, DomainHyphen);
  ta(SchemeColon, groups.domain, Url$1);
  tt(SchemeColon, SLASH, Url$1);
  tt(SchemeColon, QUERY, Url$1);
  ta(UriPrefix, groups.domain, Url$1);
  ta(UriPrefix, qsAccepting, Url$1);
  tt(UriPrefix, SLASH, Url$1);
  const bracketPairs = [
    [OPENBRACE, CLOSEBRACE],
    // {}
    [OPENBRACKET, CLOSEBRACKET],
    // []
    [OPENPAREN, CLOSEPAREN],
    // ()
    [OPENANGLEBRACKET, CLOSEANGLEBRACKET],
    // <>
    [FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN],
    // （）
    [LEFTCORNERBRACKET, RIGHTCORNERBRACKET],
    // 「」
    [LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET],
    // 『』
    [FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN]
    // ＜＞
  ];
  for (let i = 0; i < bracketPairs.length; i++) {
    const [OPEN, CLOSE] = bracketPairs[i];
    const UrlOpen = tt(Url$1, OPEN);
    tt(UrlNonaccept, OPEN, UrlOpen);
    tt(UrlOpen, CLOSE, Url$1);
    const UrlOpenQ = makeState(Url);
    ta(UrlOpen, qsAccepting, UrlOpenQ);
    const UrlOpenSyms = makeState();
    ta(UrlOpen, qsNonAccepting);
    ta(UrlOpenQ, qsAccepting, UrlOpenQ);
    ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
    ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
    ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);
    tt(UrlOpenQ, CLOSE, Url$1);
    tt(UrlOpenSyms, CLOSE, Url$1);
  }
  tt(Start, LOCALHOST, DomainDotTld);
  tt(Start, NL, Nl);
  return {
    start: Start,
    tokens: tk
  };
}
function run3(start2, input, tokens) {
  let len = tokens.length;
  let cursor = 0;
  let multis = [];
  let textTokens = [];
  while (cursor < len) {
    let state = start2;
    let secondState = null;
    let nextState = null;
    let multiLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    while (cursor < len && !(secondState = state.go(tokens[cursor].t))) {
      textTokens.push(tokens[cursor++]);
    }
    while (cursor < len && (nextState = secondState || state.go(tokens[cursor].t))) {
      secondState = null;
      state = nextState;
      if (state.accepts()) {
        sinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts++;
      }
      cursor++;
      multiLength++;
    }
    if (sinceAccepts < 0) {
      cursor -= multiLength;
      if (cursor < len) {
        textTokens.push(tokens[cursor]);
        cursor++;
      }
    } else {
      if (textTokens.length > 0) {
        multis.push(initMultiToken(Text2, input, textTokens));
        textTokens = [];
      }
      cursor -= sinceAccepts;
      multiLength -= sinceAccepts;
      const Multi = latestAccepting.t;
      const subtokens = tokens.slice(cursor - multiLength, cursor);
      multis.push(initMultiToken(Multi, input, subtokens));
    }
  }
  if (textTokens.length > 0) {
    multis.push(initMultiToken(Text2, input, textTokens));
  }
  return multis;
}
function initMultiToken(Multi, input, tokens) {
  const startIdx = tokens[0].s;
  const endIdx = tokens[tokens.length - 1].e;
  const value = input.slice(startIdx, endIdx);
  return new Multi(value, tokens);
}
var warn = typeof console !== "undefined" && console && console.warn || (() => {
});
var warnAdvice = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.";
var INIT = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: false
};
function reset() {
  State.groups = {};
  INIT.scanner = null;
  INIT.parser = null;
  INIT.tokenQueue = [];
  INIT.pluginQueue = [];
  INIT.customSchemes = [];
  INIT.initialized = false;
  return INIT;
}
function registerCustomProtocol(scheme2, optionalSlashSlash = false) {
  if (INIT.initialized) {
    warn(`linkifyjs: already initialized - will not register custom scheme "${scheme2}" ${warnAdvice}`);
  }
  if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme2)) {
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  }
  INIT.customSchemes.push([scheme2, optionalSlashSlash]);
}
function init() {
  INIT.scanner = init$2(INIT.customSchemes);
  for (let i = 0; i < INIT.tokenQueue.length; i++) {
    INIT.tokenQueue[i][1]({
      scanner: INIT.scanner
    });
  }
  INIT.parser = init$1(INIT.scanner.tokens);
  for (let i = 0; i < INIT.pluginQueue.length; i++) {
    INIT.pluginQueue[i][1]({
      scanner: INIT.scanner,
      parser: INIT.parser
    });
  }
  INIT.initialized = true;
  return INIT;
}
function tokenize(str) {
  if (!INIT.initialized) {
    init();
  }
  return run3(INIT.parser.start, str, run$1(INIT.scanner.start, str));
}
tokenize.scan = run$1;
function find(str, type = null, opts = null) {
  if (type && typeof type === "object") {
    if (opts) {
      throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
    }
    opts = type;
    type = null;
  }
  const options = new Options(opts);
  const tokens = tokenize(str);
  const filtered = [];
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.isLink && (!type || token.t === type) && options.check(token)) {
      filtered.push(token.toFormattedObject(options));
    }
  }
  return filtered;
}

// ../../node_modules/.pnpm/@tiptap+extension-link@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0__@tiptap+pm@3.20.0/node_modules/@tiptap/extension-link/dist/index.js
var UNICODE_WHITESPACE_PATTERN = "[\0- \xA0\u1680\u180E\u2000-\u2029\u205F\u3000]";
var UNICODE_WHITESPACE_REGEX = new RegExp(UNICODE_WHITESPACE_PATTERN);
var UNICODE_WHITESPACE_REGEX_END = new RegExp(`${UNICODE_WHITESPACE_PATTERN}$`);
var UNICODE_WHITESPACE_REGEX_GLOBAL = new RegExp(UNICODE_WHITESPACE_PATTERN, "g");
function isValidLinkStructure(tokens) {
  if (tokens.length === 1) {
    return tokens[0].isLink;
  }
  if (tokens.length === 3 && tokens[1].isLink) {
    return ["()", "[]"].includes(tokens[0].value + tokens[2].value);
  }
  return false;
}
function autolink(options) {
  return new Plugin({
    key: new PluginKey("autolink"),
    appendTransaction: (transactions, oldState, newState) => {
      const docChanges = transactions.some((transaction) => transaction.docChanged) && !oldState.doc.eq(newState.doc);
      const preventAutolink = transactions.some((transaction) => transaction.getMeta("preventAutolink"));
      if (!docChanges || preventAutolink) {
        return;
      }
      const { tr: tr2 } = newState;
      const transform = combineTransactionSteps(oldState.doc, [...transactions]);
      const changes = getChangedRanges(transform);
      changes.forEach(({ newRange }) => {
        const nodesInChangedRanges = findChildrenInRange(newState.doc, newRange, (node) => node.isTextblock);
        let textBlock;
        let textBeforeWhitespace;
        if (nodesInChangedRanges.length > 1) {
          textBlock = nodesInChangedRanges[0];
          textBeforeWhitespace = newState.doc.textBetween(
            textBlock.pos,
            textBlock.pos + textBlock.node.nodeSize,
            void 0,
            " "
          );
        } else if (nodesInChangedRanges.length) {
          const endText = newState.doc.textBetween(newRange.from, newRange.to, " ", " ");
          if (!UNICODE_WHITESPACE_REGEX_END.test(endText)) {
            return;
          }
          textBlock = nodesInChangedRanges[0];
          textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, void 0, " ");
        }
        if (textBlock && textBeforeWhitespace) {
          const wordsBeforeWhitespace = textBeforeWhitespace.split(UNICODE_WHITESPACE_REGEX).filter(Boolean);
          if (wordsBeforeWhitespace.length <= 0) {
            return false;
          }
          const lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
          const lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);
          if (!lastWordBeforeSpace) {
            return false;
          }
          const linksBeforeSpace = tokenize(lastWordBeforeSpace).map((t2) => t2.toObject(options.defaultProtocol));
          if (!isValidLinkStructure(linksBeforeSpace)) {
            return false;
          }
          linksBeforeSpace.filter((link) => link.isLink).map((link) => ({
            ...link,
            from: lastWordAndBlockOffset + link.start + 1,
            to: lastWordAndBlockOffset + link.end + 1
          })).filter((link) => {
            if (!newState.schema.marks.code) {
              return true;
            }
            return !newState.doc.rangeHasMark(link.from, link.to, newState.schema.marks.code);
          }).filter((link) => options.validate(link.value)).filter((link) => options.shouldAutoLink(link.value)).forEach((link) => {
            if (getMarksBetween(link.from, link.to, newState.doc).some((item) => item.mark.type === options.type)) {
              return;
            }
            tr2.addMark(
              link.from,
              link.to,
              options.type.create({
                href: link.href
              })
            );
          });
        }
      });
      if (!tr2.steps.length) {
        return;
      }
      return tr2;
    }
  });
}
function clickHandler(options) {
  return new Plugin({
    key: new PluginKey("handleClickLink"),
    props: {
      handleClick: (view, pos, event) => {
        var _a, _b;
        if (event.button !== 0) {
          return false;
        }
        if (!view.editable) {
          return false;
        }
        let link = null;
        if (event.target instanceof HTMLAnchorElement) {
          link = event.target;
        } else {
          const target = event.target;
          if (!target) {
            return false;
          }
          const root = options.editor.view.dom;
          link = target.closest("a");
          if (link && !root.contains(link)) {
            link = null;
          }
        }
        if (!link) {
          return false;
        }
        let handled = false;
        if (options.enableClickSelection) {
          const commandResult = options.editor.commands.extendMarkRange(options.type.name);
          handled = commandResult;
        }
        if (options.openOnClick) {
          const attrs = getAttributes(view.state, options.type.name);
          const href = (_a = link.href) != null ? _a : attrs.href;
          const target = (_b = link.target) != null ? _b : attrs.target;
          if (href) {
            window.open(href, target);
            handled = true;
          }
        }
        return handled;
      }
    }
  });
}
function pasteHandler(options) {
  return new Plugin({
    key: new PluginKey("handlePasteLink"),
    props: {
      handlePaste: (view, _event, slice2) => {
        const { shouldAutoLink } = options;
        const { state } = view;
        const { selection } = state;
        const { empty: empty2 } = selection;
        if (empty2) {
          return false;
        }
        let textContent = "";
        slice2.content.forEach((node) => {
          textContent += node.textContent;
        });
        const link = find(textContent, { defaultProtocol: options.defaultProtocol }).find(
          (item) => item.isLink && item.value === textContent
        );
        if (!textContent || !link || shouldAutoLink !== void 0 && !shouldAutoLink(link.value)) {
          return false;
        }
        return options.editor.commands.setMark(options.type, {
          href: link.href
        });
      }
    }
  });
}
function isAllowedUri(uri, protocols) {
  const allowedProtocols = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  if (protocols) {
    protocols.forEach((protocol) => {
      const nextProtocol = typeof protocol === "string" ? protocol : protocol.scheme;
      if (nextProtocol) {
        allowedProtocols.push(nextProtocol);
      }
    });
  }
  return !uri || uri.replace(UNICODE_WHITESPACE_REGEX_GLOBAL, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${allowedProtocols.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var Link3 = Mark2.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: false,
  exitable: true,
  onCreate() {
    if (this.options.validate && !this.options.shouldAutoLink) {
      this.options.shouldAutoLink = this.options.validate;
      console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.");
    }
    this.options.protocols.forEach((protocol) => {
      if (typeof protocol === "string") {
        registerCustomProtocol(protocol);
        return;
      }
      registerCustomProtocol(protocol.scheme, protocol.optionalSlashes);
    });
  },
  onDestroy() {
    reset();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: true,
      enableClickSelection: false,
      linkOnPaste: true,
      autolink: true,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (url, ctx) => !!isAllowedUri(url, ctx.protocols),
      validate: (url) => !!url,
      shouldAutoLink: (url) => {
        const hasProtocol = /^[a-z][a-z0-9+.-]*:\/\//i.test(url);
        const hasMaybeProtocol = /^[a-z][a-z0-9+.-]*:/i.test(url);
        if (hasProtocol || hasMaybeProtocol && !url.includes("@")) {
          return true;
        }
        const urlWithoutUserinfo = url.includes("@") ? url.split("@").pop() : url;
        const hostname = urlWithoutUserinfo.split(/[/?#:]/)[0];
        if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
          return false;
        }
        if (!/\./.test(hostname)) {
          return false;
        }
        return true;
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(element) {
          return element.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (dom) => {
          const href = dom.getAttribute("href");
          if (!href || !this.options.isAllowedUri(href, {
            defaultValidate: (url) => !!isAllowedUri(url, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          })) {
            return false;
          }
          return null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    if (!this.options.isAllowedUri(HTMLAttributes.href, {
      defaultValidate: (href) => !!isAllowedUri(href, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    })) {
      return ["a", mergeAttributes(this.options.HTMLAttributes, { ...HTMLAttributes, href: "" }), 0];
    }
    return ["a", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (token, helpers) => {
    return helpers.applyMark("link", helpers.parseInline(token.tokens || []), {
      href: token.href,
      title: token.title || null
    });
  },
  renderMarkdown: (node, h2) => {
    var _a, _b, _c, _d;
    const href = (_b = (_a = node.attrs) == null ? void 0 : _a.href) != null ? _b : "";
    const title = (_d = (_c = node.attrs) == null ? void 0 : _c.title) != null ? _d : "";
    const text = h2.renderChildren(node);
    return title ? `[${text}](${href} "${title}")` : `[${text}](${href})`;
  },
  addCommands() {
    return {
      setLink: (attributes) => ({ chain }) => {
        const { href } = attributes;
        if (!this.options.isAllowedUri(href, {
          defaultValidate: (url) => !!isAllowedUri(url, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        })) {
          return false;
        }
        return chain().setMark(this.name, attributes).setMeta("preventAutolink", true).run();
      },
      toggleLink: (attributes) => ({ chain }) => {
        const { href } = attributes || {};
        if (href && !this.options.isAllowedUri(href, {
          defaultValidate: (url) => !!isAllowedUri(url, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        })) {
          return false;
        }
        return chain().toggleMark(this.name, attributes, { extendEmptyMarkRange: true }).setMeta("preventAutolink", true).run();
      },
      unsetLink: () => ({ chain }) => {
        return chain().unsetMark(this.name, { extendEmptyMarkRange: true }).setMeta("preventAutolink", true).run();
      }
    };
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: (text) => {
          const foundLinks = [];
          if (text) {
            const { protocols, defaultProtocol } = this.options;
            const links = find(text).filter(
              (item) => item.isLink && this.options.isAllowedUri(item.value, {
                defaultValidate: (href) => !!isAllowedUri(href, protocols),
                protocols,
                defaultProtocol
              })
            );
            if (links.length) {
              links.forEach((link) => {
                if (!this.options.shouldAutoLink(link.value)) {
                  return;
                }
                foundLinks.push({
                  text: link.value,
                  data: {
                    href: link.href
                  },
                  index: link.start
                });
              });
            }
          }
          return foundLinks;
        },
        type: this.type,
        getAttributes: (match) => {
          var _a;
          return {
            href: (_a = match.data) == null ? void 0 : _a.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const plugins = [];
    const { protocols, defaultProtocol } = this.options;
    if (this.options.autolink) {
      plugins.push(
        autolink({
          type: this.type,
          defaultProtocol: this.options.defaultProtocol,
          validate: (url) => this.options.isAllowedUri(url, {
            defaultValidate: (href) => !!isAllowedUri(href, protocols),
            protocols,
            defaultProtocol
          }),
          shouldAutoLink: this.options.shouldAutoLink
        })
      );
    }
    plugins.push(
      clickHandler({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? true : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    );
    if (this.options.linkOnPaste) {
      plugins.push(
        pasteHandler({
          editor: this.editor,
          defaultProtocol: this.options.defaultProtocol,
          type: this.type,
          shouldAutoLink: this.options.shouldAutoLink
        })
      );
    }
    return plugins;
  }
});
var index_default7 = Link3;

// ../../node_modules/.pnpm/@tiptap+extension-underline@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-underline/dist/index.js
var Underline2 = Mark2.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: false,
        getAttrs: (style2) => style2.includes("underline") ? {} : false
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["u", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  parseMarkdown(token, helpers) {
    return helpers.applyMark(this.name || "underline", helpers.parseInline(token.tokens || []));
  },
  renderMarkdown(node, helpers) {
    return `++${helpers.renderChildren(node)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(src) {
      return src.indexOf("++");
    },
    tokenize(src, _tokens, lexer) {
      const rule = /^(\+\+)([\s\S]+?)(\+\+)/;
      const match = rule.exec(src);
      if (!match) {
        return void 0;
      }
      const innerContent = match[2].trim();
      return {
        type: "underline",
        raw: match[0],
        text: innerContent,
        tokens: lexer.inlineTokens(innerContent)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands }) => {
        return commands.setMark(this.name);
      },
      toggleUnderline: () => ({ commands }) => {
        return commands.toggleMark(this.name);
      },
      unsetUnderline: () => ({ commands }) => {
        return commands.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
var index_default8 = Underline2;

// ../../node_modules/.pnpm/@tiptap+extension-image@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-image/dist/index.js
var inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;
var Image2 = Node3.create({
  name: "image",
  addOptions() {
    return {
      inline: false,
      allowBase64: false,
      HTMLAttributes: {},
      resize: false
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: true,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },
  parseMarkdown: (token, helpers) => {
    return helpers.createNode("image", {
      src: token.href,
      title: token.title,
      alt: token.text
    });
  },
  renderMarkdown: (node) => {
    var _a, _b, _c, _d, _e, _f;
    const src = (_b = (_a = node.attrs) == null ? void 0 : _a.src) != null ? _b : "";
    const alt = (_d = (_c = node.attrs) == null ? void 0 : _c.alt) != null ? _d : "";
    const title = (_f = (_e = node.attrs) == null ? void 0 : _e.title) != null ? _f : "";
    return title ? `![${alt}](${src} "${title}")` : `![${alt}](${src})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document === "undefined") {
      return null;
    }
    const { directions, minWidth, minHeight, alwaysPreserveAspectRatio } = this.options.resize;
    return ({ node, getPos, HTMLAttributes, editor }) => {
      const el = document.createElement("img");
      Object.entries(HTMLAttributes).forEach(([key, value]) => {
        if (value != null) {
          switch (key) {
            case "width":
            case "height":
              break;
            default:
              el.setAttribute(key, value);
              break;
          }
        }
      });
      el.src = HTMLAttributes.src;
      const nodeView = new ResizableNodeView({
        element: el,
        editor,
        node,
        getPos,
        onResize: (width, height) => {
          el.style.width = `${width}px`;
          el.style.height = `${height}px`;
        },
        onCommit: (width, height) => {
          const pos = getPos();
          if (pos === void 0) {
            return;
          }
          this.editor.chain().setNodeSelection(pos).updateAttributes(this.name, {
            width,
            height
          }).run();
        },
        onUpdate: (updatedNode, _decorations, _innerDecorations) => {
          if (updatedNode.type !== node.type) {
            return false;
          }
          return true;
        },
        options: {
          directions,
          min: {
            width: minWidth,
            height: minHeight
          },
          preserveAspectRatio: alwaysPreserveAspectRatio === true
        }
      });
      const dom = nodeView.dom;
      dom.style.visibility = "hidden";
      dom.style.pointerEvents = "none";
      el.onload = () => {
        dom.style.visibility = "";
        dom.style.pointerEvents = "";
      };
      return nodeView;
    };
  },
  addCommands() {
    return {
      setImage: (options) => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: options
        });
      }
    };
  },
  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: (match) => {
          const [, , alt, src, title] = match;
          return { src, alt, title };
        }
      })
    ];
  }
});
var index_default9 = Image2;

// ../editor-blocks-library/src/lib/image-extension.ts
var ImageWithUploadKey = index_default9.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      uploadKey: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-upload-key"),
        renderHTML: (attributes) => {
          if (!attributes.uploadKey) {
            return {};
          }
          return { "data-upload-key": attributes.uploadKey };
        }
      },
      width: {
        default: null,
        parseHTML: (element) => {
          const styleWidth = element.style.width;
          if (styleWidth) {
            return styleWidth;
          }
          const attrWidth = element.getAttribute("width");
          return attrWidth ? `${attrWidth}px` : null;
        },
        renderHTML: (attributes) => {
          if (!attributes.width) {
            return {};
          }
          return { style: `width:${attributes.width}` };
        }
      }
    };
  }
});
var image_extension_default = ImageWithUploadKey;

// ../editor-blocks-library/src/blocks/paragraph/email-panel-content.tsx
function useParagraphEditor() {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI, locale, defaultLocale, section, theme } = blockProps;
  const block = blockProps.block;
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const unavailableVariableIds = useUnavailableVariableIds();
  const content = (block.content?.[locale] ?? block.content?.[defaultLocale])?.html ?? "";
  const updateTimeoutRef = useRef(null);
  const blockRef = useRef(block);
  const formAPIRef = useRef(formAPI);
  blockRef.current = block;
  formAPIRef.current = formAPI;
  const editor = useEditor({
    extensions: [
      index_default,
      mention_extension_default(
        blockProps.variables,
        unavailableVariableIds
      ),
      index_default3.configure({
        HTMLAttributes: {
          style: "font-size:16px;font-weight:normal;margin:0;padding:0;"
        }
      }),
      index_default4,
      index_default5,
      index_default6,
      index_default8,
      index_default7.configure({
        openOnClick: false,
        HTMLAttributes: {
          class: "underline text-foreground"
        }
      }),
      TextStyle,
      Color,
      src_default.configure({
        types: ["textStyle"]
      }),
      image_extension_default.configure({
        inline: false,
        HTMLAttributes: {
          // Responsive, and inline-block so the block's alignment control
          // (text-align on the wrapper) can left/center/right-align the image.
          // Width is set via the toolbar inputs (see `width` attribute).
          style: "max-width:100%;height:auto;display:inline-block;vertical-align:middle;"
        }
      })
    ],
    content: content || "",
    onUpdate: ({ editor: editor2 }) => {
      const newContent = editor2.getHTML();
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
      updateTimeoutRef.current = setTimeout(() => {
        const updatedBlock = {
          ...blockRef.current,
          content: {
            ...blockRef.current.content,
            [locale]: { html: newContent }
          }
        };
        formAPIRef.current.updateField(
          formAPIRef.current.blockPath,
          updatedBlock
        );
      }, 300);
    },
    editorProps: {
      attributes: {
        class: "min-h-[120px] max-h-[400px] overflow-auto px-3 py-2 text-sm rounded-md border bg-background outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:ring-1 focus-visible:ring-ring",
        style: `background-color: ${colors.bg}; color: ${colors.text}`
      }
    }
  });
  useEffect(() => {
    if (editor && content) {
      const currentContent = editor.getHTML();
      if (currentContent !== content) {
        editor.commands.setContent(content, {
          emitUpdate: false
        });
      }
    }
  }, [editor, content, locale]);
  useEffect(() => {
    return () => {
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
    };
  }, []);
  return editor;
}
var SELECTION_KEYS2 = ["Enter", " "];
var FIRST_KEYS = ["ArrowDown", "PageUp", "Home"];
var LAST_KEYS = ["ArrowUp", "PageDown", "End"];
var FIRST_LAST_KEYS = [...FIRST_KEYS, ...LAST_KEYS];
var SUB_OPEN_KEYS = {
  ltr: [...SELECTION_KEYS2, "ArrowRight"],
  rtl: [...SELECTION_KEYS2, "ArrowLeft"]
};
var SUB_CLOSE_KEYS = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
};
var MENU_NAME = "Menu";
var [Collection3, useCollection3, createCollectionScope3] = createCollection(MENU_NAME);
var [createMenuContext, createMenuScope] = createContextScope(MENU_NAME, [
  createCollectionScope3,
  createPopperScope,
  createRovingFocusGroupScope
]);
var usePopperScope2 = createPopperScope();
var useRovingFocusGroupScope3 = createRovingFocusGroupScope();
var [MenuProvider, useMenuContext] = createMenuContext(MENU_NAME);
var [MenuRootProvider, useMenuRootContext] = createMenuContext(MENU_NAME);
var Menu = (props) => {
  const { __scopeMenu, open: open2 = false, children, dir, onOpenChange, modal = true } = props;
  const popperScope = usePopperScope2(__scopeMenu);
  const [content, setContent3] = React49.useState(null);
  const isUsingKeyboardRef = React49.useRef(false);
  const handleOpenChange = useCallbackRef(onOpenChange);
  const direction = useDirection(dir);
  React49.useEffect(() => {
    const handleKeyDown2 = () => {
      isUsingKeyboardRef.current = true;
      document.addEventListener("pointerdown", handlePointer, { capture: true, once: true });
      document.addEventListener("pointermove", handlePointer, { capture: true, once: true });
    };
    const handlePointer = () => isUsingKeyboardRef.current = false;
    document.addEventListener("keydown", handleKeyDown2, { capture: true });
    return () => {
      document.removeEventListener("keydown", handleKeyDown2, { capture: true });
      document.removeEventListener("pointerdown", handlePointer, { capture: true });
      document.removeEventListener("pointermove", handlePointer, { capture: true });
    };
  }, []);
  return /* @__PURE__ */ jsx(Root23, { ...popperScope, children: /* @__PURE__ */ jsx(
    MenuProvider,
    {
      scope: __scopeMenu,
      open: open2,
      onOpenChange: handleOpenChange,
      content,
      onContentChange: setContent3,
      children: /* @__PURE__ */ jsx(
        MenuRootProvider,
        {
          scope: __scopeMenu,
          onClose: React49.useCallback(() => handleOpenChange(false), [handleOpenChange]),
          isUsingKeyboardRef,
          dir: direction,
          modal,
          children
        }
      )
    }
  ) });
};
Menu.displayName = MENU_NAME;
var ANCHOR_NAME2 = "MenuAnchor";
var MenuAnchor = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...anchorProps } = props;
    const popperScope = usePopperScope2(__scopeMenu);
    return /* @__PURE__ */ jsx(Anchor, { ...popperScope, ...anchorProps, ref: forwardedRef });
  }
);
MenuAnchor.displayName = ANCHOR_NAME2;
var PORTAL_NAME3 = "MenuPortal";
var [PortalProvider, usePortalContext] = createMenuContext(PORTAL_NAME3, {
  forceMount: void 0
});
var MenuPortal = (props) => {
  const { __scopeMenu, forceMount, children, container } = props;
  const context = useMenuContext(PORTAL_NAME3, __scopeMenu);
  return /* @__PURE__ */ jsx(PortalProvider, { scope: __scopeMenu, forceMount, children: /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(Portal, { asChild: true, container, children }) }) });
};
MenuPortal.displayName = PORTAL_NAME3;
var CONTENT_NAME4 = "MenuContent";
var [MenuContentProvider, useMenuContentContext] = createMenuContext(CONTENT_NAME4);
var MenuContent = React49.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(CONTENT_NAME4, props.__scopeMenu);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = useMenuContext(CONTENT_NAME4, props.__scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME4, props.__scopeMenu);
    return /* @__PURE__ */ jsx(Collection3.Provider, { scope: props.__scopeMenu, children: /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(Collection3.Slot, { scope: props.__scopeMenu, children: rootContext.modal ? /* @__PURE__ */ jsx(MenuRootContentModal, { ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ jsx(MenuRootContentNonModal, { ...contentProps, ref: forwardedRef }) }) }) });
  }
);
var MenuRootContentModal = React49.forwardRef(
  (props, forwardedRef) => {
    const context = useMenuContext(CONTENT_NAME4, props.__scopeMenu);
    const ref = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    React49.useEffect(() => {
      const content = ref.current;
      if (content) return hideOthers(content);
    }, []);
    return /* @__PURE__ */ jsx(
      MenuContentImpl,
      {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: composeEventHandlers(
          props.onFocusOutside,
          (event) => event.preventDefault(),
          { checkForDefaultPrevented: false }
        ),
        onDismiss: () => context.onOpenChange(false)
      }
    );
  }
);
var MenuRootContentNonModal = React49.forwardRef((props, forwardedRef) => {
  const context = useMenuContext(CONTENT_NAME4, props.__scopeMenu);
  return /* @__PURE__ */ jsx(
    MenuContentImpl,
    {
      ...props,
      ref: forwardedRef,
      trapFocus: false,
      disableOutsidePointerEvents: false,
      disableOutsideScroll: false,
      onDismiss: () => context.onOpenChange(false)
    }
  );
});
var Slot3 = createSlot("MenuContent.ScrollLock");
var MenuContentImpl = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeMenu,
      loop = false,
      trapFocus,
      onOpenAutoFocus,
      onCloseAutoFocus,
      disableOutsidePointerEvents,
      onEntryFocus,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss,
      disableOutsideScroll,
      ...contentProps
    } = props;
    const context = useMenuContext(CONTENT_NAME4, __scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME4, __scopeMenu);
    const popperScope = usePopperScope2(__scopeMenu);
    const rovingFocusGroupScope = useRovingFocusGroupScope3(__scopeMenu);
    const getItems = useCollection3(__scopeMenu);
    const [currentItemId, setCurrentItemId] = React49.useState(null);
    const contentRef = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, contentRef, context.onContentChange);
    const timerRef = React49.useRef(0);
    const searchRef = React49.useRef("");
    const pointerGraceTimerRef = React49.useRef(0);
    const pointerGraceIntentRef = React49.useRef(null);
    const pointerDirRef = React49.useRef("right");
    const lastPointerXRef = React49.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? Combination_default : React49.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? { as: Slot3, allowPinchZoom: true } : void 0;
    const handleTypeaheadSearch = (key) => {
      const search = searchRef.current + key;
      const items = getItems().filter((item) => !item.disabled);
      const currentItem = document.activeElement;
      const currentMatch = items.find((item) => item.ref.current === currentItem)?.textValue;
      const values = items.map((item) => item.textValue);
      const nextMatch = getNextMatch(values, search, currentMatch);
      const newItem = items.find((item) => item.textValue === nextMatch)?.ref.current;
      (function updateSearch(value) {
        searchRef.current = value;
        window.clearTimeout(timerRef.current);
        if (value !== "") timerRef.current = window.setTimeout(() => updateSearch(""), 1e3);
      })(search);
      if (newItem) {
        setTimeout(() => newItem.focus());
      }
    };
    React49.useEffect(() => {
      return () => window.clearTimeout(timerRef.current);
    }, []);
    useFocusGuards();
    const isPointerMovingToSubmenu = React49.useCallback((event) => {
      const isMovingTowards = pointerDirRef.current === pointerGraceIntentRef.current?.side;
      return isMovingTowards && isPointerInGraceArea(event, pointerGraceIntentRef.current?.area);
    }, []);
    return /* @__PURE__ */ jsx(
      MenuContentProvider,
      {
        scope: __scopeMenu,
        searchRef,
        onItemEnter: React49.useCallback(
          (event) => {
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
          },
          [isPointerMovingToSubmenu]
        ),
        onItemLeave: React49.useCallback(
          (event) => {
            if (isPointerMovingToSubmenu(event)) return;
            contentRef.current?.focus();
            setCurrentItemId(null);
          },
          [isPointerMovingToSubmenu]
        ),
        onTriggerLeave: React49.useCallback(
          (event) => {
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
          },
          [isPointerMovingToSubmenu]
        ),
        pointerGraceTimerRef,
        onPointerGraceIntentChange: React49.useCallback((intent) => {
          pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ jsx(ScrollLockWrapper, { ...scrollLockWrapperProps, children: /* @__PURE__ */ jsx(
          FocusScope,
          {
            asChild: true,
            trapped: trapFocus,
            onMountAutoFocus: composeEventHandlers(onOpenAutoFocus, (event) => {
              event.preventDefault();
              contentRef.current?.focus({ preventScroll: true });
            }),
            onUnmountAutoFocus: onCloseAutoFocus,
            children: /* @__PURE__ */ jsx(
              DismissableLayer,
              {
                asChild: true,
                disableOutsidePointerEvents,
                onEscapeKeyDown,
                onPointerDownOutside,
                onFocusOutside,
                onInteractOutside,
                onDismiss,
                children: /* @__PURE__ */ jsx(
                  Root3,
                  {
                    asChild: true,
                    ...rovingFocusGroupScope,
                    dir: rootContext.dir,
                    orientation: "vertical",
                    loop,
                    currentTabStopId: currentItemId,
                    onCurrentTabStopIdChange: setCurrentItemId,
                    onEntryFocus: composeEventHandlers(onEntryFocus, (event) => {
                      if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                    }),
                    preventScrollOnEntryFocus: true,
                    children: /* @__PURE__ */ jsx(
                      Content2,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": getOpenState(context.open),
                        "data-radix-menu-content": "",
                        dir: rootContext.dir,
                        ...popperScope,
                        ...contentProps,
                        ref: composedRefs,
                        style: { outline: "none", ...contentProps.style },
                        onKeyDown: composeEventHandlers(contentProps.onKeyDown, (event) => {
                          const target = event.target;
                          const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                          const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                          const isCharacterKey = event.key.length === 1;
                          if (isKeyDownInside) {
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                          }
                          const content = contentRef.current;
                          if (event.target !== content) return;
                          if (!FIRST_LAST_KEYS.includes(event.key)) return;
                          event.preventDefault();
                          const items = getItems().filter((item) => !item.disabled);
                          const candidateNodes = items.map((item) => item.ref.current);
                          if (LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                          focusFirst3(candidateNodes);
                        }),
                        onBlur: composeEventHandlers(props.onBlur, (event) => {
                          if (!event.currentTarget.contains(event.target)) {
                            window.clearTimeout(timerRef.current);
                            searchRef.current = "";
                          }
                        }),
                        onPointerMove: composeEventHandlers(
                          props.onPointerMove,
                          whenMouse((event) => {
                            const target = event.target;
                            const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                              const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                              pointerDirRef.current = newDir;
                              lastPointerXRef.current = event.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
MenuContent.displayName = CONTENT_NAME4;
var GROUP_NAME3 = "MenuGroup";
var MenuGroup = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ jsx(Primitive.div, { role: "group", ...groupProps, ref: forwardedRef });
  }
);
MenuGroup.displayName = GROUP_NAME3;
var LABEL_NAME2 = "MenuLabel";
var MenuLabel = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ jsx(Primitive.div, { ...labelProps, ref: forwardedRef });
  }
);
MenuLabel.displayName = LABEL_NAME2;
var ITEM_NAME4 = "MenuItem";
var ITEM_SELECT = "menu.itemSelect";
var MenuItem = React49.forwardRef(
  (props, forwardedRef) => {
    const { disabled = false, onSelect, ...itemProps } = props;
    const ref = React49.useRef(null);
    const rootContext = useMenuRootContext(ITEM_NAME4, props.__scopeMenu);
    const contentContext = useMenuContentContext(ITEM_NAME4, props.__scopeMenu);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const isPointerDownRef = React49.useRef(false);
    const handleSelect = () => {
      const menuItem = ref.current;
      if (!disabled && menuItem) {
        const itemSelectEvent = new CustomEvent(ITEM_SELECT, { bubbles: true, cancelable: true });
        menuItem.addEventListener(ITEM_SELECT, (event) => onSelect?.(event), { once: true });
        dispatchDiscreteCustomEvent(menuItem, itemSelectEvent);
        if (itemSelectEvent.defaultPrevented) {
          isPointerDownRef.current = false;
        } else {
          rootContext.onClose();
        }
      }
    };
    return /* @__PURE__ */ jsx(
      MenuItemImpl,
      {
        ...itemProps,
        ref: composedRefs,
        disabled,
        onClick: composeEventHandlers(props.onClick, handleSelect),
        onPointerDown: (event) => {
          props.onPointerDown?.(event);
          isPointerDownRef.current = true;
        },
        onPointerUp: composeEventHandlers(props.onPointerUp, (event) => {
          if (!isPointerDownRef.current) event.currentTarget?.click();
        }),
        onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
          const isTypingAhead = contentContext.searchRef.current !== "";
          if (disabled || isTypingAhead && event.key === " ") return;
          if (SELECTION_KEYS2.includes(event.key)) {
            event.currentTarget.click();
            event.preventDefault();
          }
        })
      }
    );
  }
);
MenuItem.displayName = ITEM_NAME4;
var MenuItemImpl = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, disabled = false, textValue, ...itemProps } = props;
    const contentContext = useMenuContentContext(ITEM_NAME4, __scopeMenu);
    const rovingFocusGroupScope = useRovingFocusGroupScope3(__scopeMenu);
    const ref = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const [isFocused, setIsFocused] = React49.useState(false);
    const [textContent, setTextContent] = React49.useState("");
    React49.useEffect(() => {
      const menuItem = ref.current;
      if (menuItem) {
        setTextContent((menuItem.textContent ?? "").trim());
      }
    }, [itemProps.children]);
    return /* @__PURE__ */ jsx(
      Collection3.ItemSlot,
      {
        scope: __scopeMenu,
        disabled,
        textValue: textValue ?? textContent,
        children: /* @__PURE__ */ jsx(Item, { asChild: true, ...rovingFocusGroupScope, focusable: !disabled, children: /* @__PURE__ */ jsx(
          Primitive.div,
          {
            role: "menuitem",
            "data-highlighted": isFocused ? "" : void 0,
            "aria-disabled": disabled || void 0,
            "data-disabled": disabled ? "" : void 0,
            ...itemProps,
            ref: composedRefs,
            onPointerMove: composeEventHandlers(
              props.onPointerMove,
              whenMouse((event) => {
                if (disabled) {
                  contentContext.onItemLeave(event);
                } else {
                  contentContext.onItemEnter(event);
                  if (!event.defaultPrevented) {
                    const item = event.currentTarget;
                    item.focus({ preventScroll: true });
                  }
                }
              })
            ),
            onPointerLeave: composeEventHandlers(
              props.onPointerLeave,
              whenMouse((event) => contentContext.onItemLeave(event))
            ),
            onFocus: composeEventHandlers(props.onFocus, () => setIsFocused(true)),
            onBlur: composeEventHandlers(props.onBlur, () => setIsFocused(false))
          }
        ) })
      }
    );
  }
);
var CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var MenuCheckboxItem = React49.forwardRef(
  (props, forwardedRef) => {
    const { checked = false, onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ jsx(ItemIndicatorProvider, { scope: props.__scopeMenu, checked, children: /* @__PURE__ */ jsx(
      MenuItem,
      {
        role: "menuitemcheckbox",
        "aria-checked": isIndeterminate(checked) ? "mixed" : checked,
        ...checkboxItemProps,
        ref: forwardedRef,
        "data-state": getCheckedState(checked),
        onSelect: composeEventHandlers(
          checkboxItemProps.onSelect,
          () => onCheckedChange?.(isIndeterminate(checked) ? true : !checked),
          { checkForDefaultPrevented: false }
        )
      }
    ) });
  }
);
MenuCheckboxItem.displayName = CHECKBOX_ITEM_NAME;
var RADIO_GROUP_NAME = "MenuRadioGroup";
var [RadioGroupProvider, useRadioGroupContext] = createMenuContext(
  RADIO_GROUP_NAME,
  { value: void 0, onValueChange: () => {
  } }
);
var MenuRadioGroup = React49.forwardRef(
  (props, forwardedRef) => {
    const { value, onValueChange, ...groupProps } = props;
    const handleValueChange = useCallbackRef(onValueChange);
    return /* @__PURE__ */ jsx(RadioGroupProvider, { scope: props.__scopeMenu, value, onValueChange: handleValueChange, children: /* @__PURE__ */ jsx(MenuGroup, { ...groupProps, ref: forwardedRef }) });
  }
);
MenuRadioGroup.displayName = RADIO_GROUP_NAME;
var RADIO_ITEM_NAME = "MenuRadioItem";
var MenuRadioItem = React49.forwardRef(
  (props, forwardedRef) => {
    const { value, ...radioItemProps } = props;
    const context = useRadioGroupContext(RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ jsx(ItemIndicatorProvider, { scope: props.__scopeMenu, checked, children: /* @__PURE__ */ jsx(
      MenuItem,
      {
        role: "menuitemradio",
        "aria-checked": checked,
        ...radioItemProps,
        ref: forwardedRef,
        "data-state": getCheckedState(checked),
        onSelect: composeEventHandlers(
          radioItemProps.onSelect,
          () => context.onValueChange?.(value),
          { checkForDefaultPrevented: false }
        )
      }
    ) });
  }
);
MenuRadioItem.displayName = RADIO_ITEM_NAME;
var ITEM_INDICATOR_NAME2 = "MenuItemIndicator";
var [ItemIndicatorProvider, useItemIndicatorContext] = createMenuContext(
  ITEM_INDICATOR_NAME2,
  { checked: false }
);
var MenuItemIndicator = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = useItemIndicatorContext(ITEM_INDICATOR_NAME2, __scopeMenu);
    return /* @__PURE__ */ jsx(
      Presence,
      {
        present: forceMount || isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ jsx(
          Primitive.span,
          {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": getCheckedState(indicatorContext.checked)
          }
        )
      }
    );
  }
);
MenuItemIndicator.displayName = ITEM_INDICATOR_NAME2;
var SEPARATOR_NAME2 = "MenuSeparator";
var MenuSeparator = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
      }
    );
  }
);
MenuSeparator.displayName = SEPARATOR_NAME2;
var ARROW_NAME3 = "MenuArrow";
var MenuArrow = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...arrowProps } = props;
    const popperScope = usePopperScope2(__scopeMenu);
    return /* @__PURE__ */ jsx(Arrow2, { ...popperScope, ...arrowProps, ref: forwardedRef });
  }
);
MenuArrow.displayName = ARROW_NAME3;
var SUB_NAME = "MenuSub";
var [MenuSubProvider, useMenuSubContext] = createMenuContext(SUB_NAME);
var SUB_TRIGGER_NAME = "MenuSubTrigger";
var MenuSubTrigger = React49.forwardRef(
  (props, forwardedRef) => {
    const context = useMenuContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = useMenuRootContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = useMenuSubContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = useMenuContentContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = React49.useRef(null);
    const { pointerGraceTimerRef, onPointerGraceIntentChange } = contentContext;
    const scope = { __scopeMenu: props.__scopeMenu };
    const clearOpenTimer = React49.useCallback(() => {
      if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
      openTimerRef.current = null;
    }, []);
    React49.useEffect(() => clearOpenTimer, [clearOpenTimer]);
    React49.useEffect(() => {
      const pointerGraceTimer = pointerGraceTimerRef.current;
      return () => {
        window.clearTimeout(pointerGraceTimer);
        onPointerGraceIntentChange(null);
      };
    }, [pointerGraceTimerRef, onPointerGraceIntentChange]);
    return /* @__PURE__ */ jsx(MenuAnchor, { asChild: true, ...scope, children: /* @__PURE__ */ jsx(
      MenuItemImpl,
      {
        id: subContext.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": subContext.contentId,
        "data-state": getOpenState(context.open),
        ...props,
        ref: composeRefs(forwardedRef, subContext.onTriggerChange),
        onClick: (event) => {
          props.onClick?.(event);
          if (props.disabled || event.defaultPrevented) return;
          event.currentTarget.focus();
          if (!context.open) context.onOpenChange(true);
        },
        onPointerMove: composeEventHandlers(
          props.onPointerMove,
          whenMouse((event) => {
            contentContext.onItemEnter(event);
            if (event.defaultPrevented) return;
            if (!props.disabled && !context.open && !openTimerRef.current) {
              contentContext.onPointerGraceIntentChange(null);
              openTimerRef.current = window.setTimeout(() => {
                context.onOpenChange(true);
                clearOpenTimer();
              }, 100);
            }
          })
        ),
        onPointerLeave: composeEventHandlers(
          props.onPointerLeave,
          whenMouse((event) => {
            clearOpenTimer();
            const contentRect = context.content?.getBoundingClientRect();
            if (contentRect) {
              const side = context.content?.dataset.side;
              const rightSide = side === "right";
              const bleed = rightSide ? -5 : 5;
              const contentNearEdge = contentRect[rightSide ? "left" : "right"];
              const contentFarEdge = contentRect[rightSide ? "right" : "left"];
              contentContext.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: event.clientX + bleed, y: event.clientY },
                  { x: contentNearEdge, y: contentRect.top },
                  { x: contentFarEdge, y: contentRect.top },
                  { x: contentFarEdge, y: contentRect.bottom },
                  { x: contentNearEdge, y: contentRect.bottom }
                ],
                side
              });
              window.clearTimeout(pointerGraceTimerRef.current);
              pointerGraceTimerRef.current = window.setTimeout(
                () => contentContext.onPointerGraceIntentChange(null),
                300
              );
            } else {
              contentContext.onTriggerLeave(event);
              if (event.defaultPrevented) return;
              contentContext.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
          const isTypingAhead = contentContext.searchRef.current !== "";
          if (props.disabled || isTypingAhead && event.key === " ") return;
          if (SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
            context.onOpenChange(true);
            context.content?.focus();
            event.preventDefault();
          }
        })
      }
    ) });
  }
);
MenuSubTrigger.displayName = SUB_TRIGGER_NAME;
var SUB_CONTENT_NAME = "MenuSubContent";
var MenuSubContent = React49.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(CONTENT_NAME4, props.__scopeMenu);
    const { forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = useMenuContext(CONTENT_NAME4, props.__scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME4, props.__scopeMenu);
    const subContext = useMenuSubContext(SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    return /* @__PURE__ */ jsx(Collection3.Provider, { scope: props.__scopeMenu, children: /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(Collection3.Slot, { scope: props.__scopeMenu, children: /* @__PURE__ */ jsx(
      MenuContentImpl,
      {
        id: subContext.contentId,
        "aria-labelledby": subContext.triggerId,
        ...subContentProps,
        ref: composedRefs,
        align: "start",
        side: rootContext.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        trapFocus: false,
        onOpenAutoFocus: (event) => {
          if (rootContext.isUsingKeyboardRef.current) ref.current?.focus();
          event.preventDefault();
        },
        onCloseAutoFocus: (event) => event.preventDefault(),
        onFocusOutside: composeEventHandlers(props.onFocusOutside, (event) => {
          if (event.target !== subContext.trigger) context.onOpenChange(false);
        }),
        onEscapeKeyDown: composeEventHandlers(props.onEscapeKeyDown, (event) => {
          rootContext.onClose();
          event.preventDefault();
        }),
        onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
          const isKeyDownInside = event.currentTarget.contains(event.target);
          const isCloseKey = SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
          if (isKeyDownInside && isCloseKey) {
            context.onOpenChange(false);
            subContext.trigger?.focus();
            event.preventDefault();
          }
        })
      }
    ) }) }) });
  }
);
MenuSubContent.displayName = SUB_CONTENT_NAME;
function getOpenState(open2) {
  return open2 ? "open" : "closed";
}
function isIndeterminate(checked) {
  return checked === "indeterminate";
}
function getCheckedState(checked) {
  return isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function focusFirst3(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function wrapArray3(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
function getNextMatch(values, search, currentMatch) {
  const isRepeated = search.length > 1 && Array.from(search).every((char) => char === search[0]);
  const normalizedSearch = isRepeated ? search[0] : search;
  const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
  let wrappedValues = wrapArray3(values, Math.max(currentMatchIndex, 0));
  const excludeCurrentMatch = normalizedSearch.length === 1;
  if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v) => v !== currentMatch);
  const nextMatch = wrappedValues.find(
    (value) => value.toLowerCase().startsWith(normalizedSearch.toLowerCase())
  );
  return nextMatch !== currentMatch ? nextMatch : void 0;
}
function isPointInPolygon(point, polygon) {
  const { x, y } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const ii = polygon[i];
    const jj = polygon[j];
    const xi = ii.x;
    const yi = ii.y;
    const xj = jj.x;
    const yj = jj.y;
    const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function isPointerInGraceArea(event, area) {
  if (!area) return false;
  const cursorPos = { x: event.clientX, y: event.clientY };
  return isPointInPolygon(cursorPos, area);
}
function whenMouse(handler) {
  return (event) => event.pointerType === "mouse" ? handler(event) : void 0;
}
var Root32 = Menu;
var Anchor2 = MenuAnchor;
var Portal3 = MenuPortal;
var Content23 = MenuContent;
var Group2 = MenuGroup;
var Label2 = MenuLabel;
var Item23 = MenuItem;
var CheckboxItem = MenuCheckboxItem;
var RadioGroup = MenuRadioGroup;
var RadioItem = MenuRadioItem;
var ItemIndicator2 = MenuItemIndicator;
var Separator4 = MenuSeparator;
var Arrow22 = MenuArrow;
var SubTrigger = MenuSubTrigger;
var SubContent = MenuSubContent;
var DROPDOWN_MENU_NAME = "DropdownMenu";
var [createDropdownMenuContext] = createContextScope(
  DROPDOWN_MENU_NAME,
  [createMenuScope]
);
var useMenuScope = createMenuScope();
var [DropdownMenuProvider, useDropdownMenuContext] = createDropdownMenuContext(DROPDOWN_MENU_NAME);
var DropdownMenu = (props) => {
  const {
    __scopeDropdownMenu,
    children,
    dir,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  const triggerRef = React49.useRef(null);
  const [open2, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: DROPDOWN_MENU_NAME
  });
  return /* @__PURE__ */ jsx(
    DropdownMenuProvider,
    {
      scope: __scopeDropdownMenu,
      triggerId: useId(),
      triggerRef,
      contentId: useId(),
      open: open2,
      onOpenChange: setOpen,
      onOpenToggle: React49.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
      modal,
      children: /* @__PURE__ */ jsx(Root32, { ...menuScope, open: open2, onOpenChange: setOpen, dir, modal, children })
    }
  );
};
DropdownMenu.displayName = DROPDOWN_MENU_NAME;
var TRIGGER_NAME3 = "DropdownMenuTrigger";
var DropdownMenuTrigger = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, disabled = false, ...triggerProps } = props;
    const context = useDropdownMenuContext(TRIGGER_NAME3, __scopeDropdownMenu);
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx(Anchor2, { asChild: true, ...menuScope, children: /* @__PURE__ */ jsx(
      Primitive.button,
      {
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": context.open ? "open" : "closed",
        "data-disabled": disabled ? "" : void 0,
        disabled,
        ...triggerProps,
        ref: composeRefs(forwardedRef, context.triggerRef),
        onPointerDown: composeEventHandlers(props.onPointerDown, (event) => {
          if (!disabled && event.button === 0 && event.ctrlKey === false) {
            context.onOpenToggle();
            if (!context.open) event.preventDefault();
          }
        }),
        onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
          if (disabled) return;
          if (["Enter", " "].includes(event.key)) context.onOpenToggle();
          if (event.key === "ArrowDown") context.onOpenChange(true);
          if (["Enter", " ", "ArrowDown"].includes(event.key)) event.preventDefault();
        })
      }
    ) });
  }
);
DropdownMenuTrigger.displayName = TRIGGER_NAME3;
var PORTAL_NAME4 = "DropdownMenuPortal";
var DropdownMenuPortal = (props) => {
  const { __scopeDropdownMenu, ...portalProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx(Portal3, { ...menuScope, ...portalProps });
};
DropdownMenuPortal.displayName = PORTAL_NAME4;
var CONTENT_NAME5 = "DropdownMenuContent";
var DropdownMenuContent = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...contentProps } = props;
    const context = useDropdownMenuContext(CONTENT_NAME5, __scopeDropdownMenu);
    const menuScope = useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = React49.useRef(false);
    return /* @__PURE__ */ jsx(
      Content23,
      {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: composeEventHandlers(props.onCloseAutoFocus, (event) => {
          if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
          hasInteractedOutsideRef.current = false;
          event.preventDefault();
        }),
        onInteractOutside: composeEventHandlers(props.onInteractOutside, (event) => {
          const originalEvent = event.detail.originalEvent;
          const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
          const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
          if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
          ...props.style,
          // re-namespace exposed content custom properties
          ...{
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      }
    );
  }
);
DropdownMenuContent.displayName = CONTENT_NAME5;
var GROUP_NAME4 = "DropdownMenuGroup";
var DropdownMenuGroup = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx(Group2, { ...menuScope, ...groupProps, ref: forwardedRef });
  }
);
DropdownMenuGroup.displayName = GROUP_NAME4;
var LABEL_NAME3 = "DropdownMenuLabel";
var DropdownMenuLabel = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx(Label2, { ...menuScope, ...labelProps, ref: forwardedRef });
  }
);
DropdownMenuLabel.displayName = LABEL_NAME3;
var ITEM_NAME5 = "DropdownMenuItem";
var DropdownMenuItem = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx(Item23, { ...menuScope, ...itemProps, ref: forwardedRef });
  }
);
DropdownMenuItem.displayName = ITEM_NAME5;
var CHECKBOX_ITEM_NAME2 = "DropdownMenuCheckboxItem";
var DropdownMenuCheckboxItem = React49.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...checkboxItemProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx(CheckboxItem, { ...menuScope, ...checkboxItemProps, ref: forwardedRef });
});
DropdownMenuCheckboxItem.displayName = CHECKBOX_ITEM_NAME2;
var RADIO_GROUP_NAME2 = "DropdownMenuRadioGroup";
var DropdownMenuRadioGroup = React49.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...radioGroupProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx(RadioGroup, { ...menuScope, ...radioGroupProps, ref: forwardedRef });
});
DropdownMenuRadioGroup.displayName = RADIO_GROUP_NAME2;
var RADIO_ITEM_NAME2 = "DropdownMenuRadioItem";
var DropdownMenuRadioItem = React49.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...radioItemProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx(RadioItem, { ...menuScope, ...radioItemProps, ref: forwardedRef });
});
DropdownMenuRadioItem.displayName = RADIO_ITEM_NAME2;
var INDICATOR_NAME = "DropdownMenuItemIndicator";
var DropdownMenuItemIndicator = React49.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...itemIndicatorProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx(ItemIndicator2, { ...menuScope, ...itemIndicatorProps, ref: forwardedRef });
});
DropdownMenuItemIndicator.displayName = INDICATOR_NAME;
var SEPARATOR_NAME3 = "DropdownMenuSeparator";
var DropdownMenuSeparator = React49.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...separatorProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx(Separator4, { ...menuScope, ...separatorProps, ref: forwardedRef });
});
DropdownMenuSeparator.displayName = SEPARATOR_NAME3;
var ARROW_NAME4 = "DropdownMenuArrow";
var DropdownMenuArrow = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx(Arrow22, { ...menuScope, ...arrowProps, ref: forwardedRef });
  }
);
DropdownMenuArrow.displayName = ARROW_NAME4;
var SUB_TRIGGER_NAME2 = "DropdownMenuSubTrigger";
var DropdownMenuSubTrigger = React49.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...subTriggerProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx(SubTrigger, { ...menuScope, ...subTriggerProps, ref: forwardedRef });
});
DropdownMenuSubTrigger.displayName = SUB_TRIGGER_NAME2;
var SUB_CONTENT_NAME2 = "DropdownMenuSubContent";
var DropdownMenuSubContent = React49.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...subContentProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx(
    SubContent,
    {
      ...menuScope,
      ...subContentProps,
      ref: forwardedRef,
      style: {
        ...props.style,
        // re-namespace exposed content custom properties
        ...{
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    }
  );
});
DropdownMenuSubContent.displayName = SUB_CONTENT_NAME2;
var Root26 = DropdownMenu;
var Trigger3 = DropdownMenuTrigger;
var Portal22 = DropdownMenuPortal;
var Content24 = DropdownMenuContent;
var Label22 = DropdownMenuLabel;
var Item24 = DropdownMenuItem;
var CheckboxItem2 = DropdownMenuCheckboxItem;
var RadioItem2 = DropdownMenuRadioItem;
var ItemIndicator22 = DropdownMenuItemIndicator;
var Separator22 = DropdownMenuSeparator;
var SubTrigger2 = DropdownMenuSubTrigger;
var SubContent2 = DropdownMenuSubContent;
var DropdownMenu2 = Root26;
var DropdownMenuTrigger2 = Trigger3;
var DropdownMenuSubTrigger2 = React49.forwardRef(({ className, inset, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  SubTrigger2,
  {
    ref,
    className: cn(
      "flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      inset && "pl-8",
      className
    ),
    ...props,
    children: [
      children,
      /* @__PURE__ */ jsx(ChevronRightIcon, { className: "ml-auto" })
    ]
  }
));
DropdownMenuSubTrigger2.displayName = SubTrigger2.displayName;
var DropdownMenuSubContent2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  SubContent2,
  {
    ref,
    className: cn(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
));
DropdownMenuSubContent2.displayName = SubContent2.displayName;
var DropdownMenuContent2 = React49.forwardRef(({ className, sideOffset = 4, container, ...props }, ref) => /* @__PURE__ */ jsx(Portal22, { container, children: /* @__PURE__ */ jsx(
  Content24,
  {
    ref,
    sideOffset,
    className: cn(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
) }));
DropdownMenuContent2.displayName = Content24.displayName;
var DropdownMenuItem2 = React49.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx(
  Item24,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0",
      inset && "pl-8",
      className
    ),
    ...props
  }
));
DropdownMenuItem2.displayName = Item24.displayName;
var DropdownMenuCheckboxItem2 = React49.forwardRef(({ className, children, checked, ...props }, ref) => /* @__PURE__ */ jsxs(
  CheckboxItem2,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    checked,
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(ItemIndicator22, { children: /* @__PURE__ */ jsx(CheckIcon, { className: "h-4 w-4" }) }) }),
      children
    ]
  }
));
DropdownMenuCheckboxItem2.displayName = CheckboxItem2.displayName;
var DropdownMenuRadioItem2 = React49.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  RadioItem2,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(ItemIndicator22, { children: /* @__PURE__ */ jsx(DotFilledIcon, { className: "size-4 fill-current" }) }) }),
      children
    ]
  }
));
DropdownMenuRadioItem2.displayName = RadioItem2.displayName;
var DropdownMenuLabel2 = React49.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx(
  Label22,
  {
    ref,
    className: cn(
      "px-2 py-1.5 text-sm font-semibold",
      inset && "pl-8",
      className
    ),
    ...props
  }
));
DropdownMenuLabel2.displayName = Label22.displayName;
var DropdownMenuSeparator2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Separator22,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-muted", className),
    ...props
  }
));
DropdownMenuSeparator2.displayName = Separator22.displayName;
var DIALOG_NAME = "Dialog";
var [createDialogContext] = createContextScope(DIALOG_NAME);
var [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME);
var Dialog = (props) => {
  const {
    __scopeDialog,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const triggerRef = React49.useRef(null);
  const contentRef = React49.useRef(null);
  const [open2, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: DIALOG_NAME
  });
  return /* @__PURE__ */ jsx(
    DialogProvider,
    {
      scope: __scopeDialog,
      triggerRef,
      contentRef,
      contentId: useId(),
      titleId: useId(),
      descriptionId: useId(),
      open: open2,
      onOpenChange: setOpen,
      onOpenToggle: React49.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
      modal,
      children
    }
  );
};
Dialog.displayName = DIALOG_NAME;
var TRIGGER_NAME4 = "DialogTrigger";
var DialogTrigger = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...triggerProps } = props;
    const context = useDialogContext(TRIGGER_NAME4, __scopeDialog);
    const composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ jsx(
      Primitive.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
      }
    );
  }
);
DialogTrigger.displayName = TRIGGER_NAME4;
var PORTAL_NAME5 = "DialogPortal";
var [PortalProvider2, usePortalContext2] = createDialogContext(PORTAL_NAME5, {
  forceMount: void 0
});
var DialogPortal = (props) => {
  const { __scopeDialog, forceMount, children, container } = props;
  const context = useDialogContext(PORTAL_NAME5, __scopeDialog);
  return /* @__PURE__ */ jsx(PortalProvider2, { scope: __scopeDialog, forceMount, children: React49.Children.map(children, (child) => /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(Portal, { asChild: true, container, children: child }) })) });
};
DialogPortal.displayName = PORTAL_NAME5;
var OVERLAY_NAME = "DialogOverlay";
var DialogOverlay = React49.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext2(OVERLAY_NAME, props.__scopeDialog);
    const { forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(DialogOverlayImpl, { ...overlayProps, ref: forwardedRef }) }) : null;
  }
);
DialogOverlay.displayName = OVERLAY_NAME;
var Slot4 = createSlot("DialogOverlay.RemoveScroll");
var DialogOverlayImpl = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, __scopeDialog);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ jsx(Combination_default, { as: Slot4, allowPinchZoom: true, shards: [context.contentRef], children: /* @__PURE__ */ jsx(
        Primitive.div,
        {
          "data-state": getState(context.open),
          ...overlayProps,
          ref: forwardedRef,
          style: { pointerEvents: "auto", ...overlayProps.style }
        }
      ) })
    );
  }
);
var CONTENT_NAME6 = "DialogContent";
var DialogContent = React49.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext2(CONTENT_NAME6, props.__scopeDialog);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = useDialogContext(CONTENT_NAME6, props.__scopeDialog);
    return /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: context.modal ? /* @__PURE__ */ jsx(DialogContentModal, { ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ jsx(DialogContentNonModal, { ...contentProps, ref: forwardedRef }) });
  }
);
DialogContent.displayName = CONTENT_NAME6;
var DialogContentModal = React49.forwardRef(
  (props, forwardedRef) => {
    const context = useDialogContext(CONTENT_NAME6, props.__scopeDialog);
    const contentRef = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, context.contentRef, contentRef);
    React49.useEffect(() => {
      const content = contentRef.current;
      if (content) return hideOthers(content);
    }, []);
    return /* @__PURE__ */ jsx(
      DialogContentImpl,
      {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: composeEventHandlers(props.onCloseAutoFocus, (event) => {
          event.preventDefault();
          context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: composeEventHandlers(props.onPointerDownOutside, (event) => {
          const originalEvent = event.detail.originalEvent;
          const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
          const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
          if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: composeEventHandlers(
          props.onFocusOutside,
          (event) => event.preventDefault()
        )
      }
    );
  }
);
var DialogContentNonModal = React49.forwardRef(
  (props, forwardedRef) => {
    const context = useDialogContext(CONTENT_NAME6, props.__scopeDialog);
    const hasInteractedOutsideRef = React49.useRef(false);
    const hasPointerDownOutsideRef = React49.useRef(false);
    return /* @__PURE__ */ jsx(
      DialogContentImpl,
      {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event) => {
          props.onCloseAutoFocus?.(event);
          if (!event.defaultPrevented) {
            if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
            event.preventDefault();
          }
          hasInteractedOutsideRef.current = false;
          hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event) => {
          props.onInteractOutside?.(event);
          if (!event.defaultPrevented) {
            hasInteractedOutsideRef.current = true;
            if (event.detail.originalEvent.type === "pointerdown") {
              hasPointerDownOutsideRef.current = true;
            }
          }
          const target = event.target;
          const targetIsTrigger = context.triggerRef.current?.contains(target);
          if (targetIsTrigger) event.preventDefault();
          if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) {
            event.preventDefault();
          }
        }
      }
    );
  }
);
var DialogContentImpl = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, trapFocus, onOpenAutoFocus, onCloseAutoFocus, ...contentProps } = props;
    const context = useDialogContext(CONTENT_NAME6, __scopeDialog);
    const contentRef = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, contentRef);
    useFocusGuards();
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        FocusScope,
        {
          asChild: true,
          loop: true,
          trapped: trapFocus,
          onMountAutoFocus: onOpenAutoFocus,
          onUnmountAutoFocus: onCloseAutoFocus,
          children: /* @__PURE__ */ jsx(
            DismissableLayer,
            {
              role: "dialog",
              id: context.contentId,
              "aria-describedby": context.descriptionId,
              "aria-labelledby": context.titleId,
              "data-state": getState(context.open),
              ...contentProps,
              ref: composedRefs,
              onDismiss: () => context.onOpenChange(false)
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(TitleWarning, { titleId: context.titleId }),
        /* @__PURE__ */ jsx(DescriptionWarning, { contentRef, descriptionId: context.descriptionId })
      ] })
    ] });
  }
);
var TITLE_NAME = "DialogTitle";
var DialogTitle = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...titleProps } = props;
    const context = useDialogContext(TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ jsx(Primitive.h2, { id: context.titleId, ...titleProps, ref: forwardedRef });
  }
);
DialogTitle.displayName = TITLE_NAME;
var DESCRIPTION_NAME = "DialogDescription";
var DialogDescription = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...descriptionProps } = props;
    const context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ jsx(Primitive.p, { id: context.descriptionId, ...descriptionProps, ref: forwardedRef });
  }
);
DialogDescription.displayName = DESCRIPTION_NAME;
var CLOSE_NAME = "DialogClose";
var DialogClose = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...closeProps } = props;
    const context = useDialogContext(CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ jsx(
      Primitive.button,
      {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: composeEventHandlers(props.onClick, () => context.onOpenChange(false))
      }
    );
  }
);
DialogClose.displayName = CLOSE_NAME;
function getState(open2) {
  return open2 ? "open" : "closed";
}
var TITLE_WARNING_NAME = "DialogTitleWarning";
var [WarningProvider, useWarningContext] = createContext22(TITLE_WARNING_NAME, {
  contentName: CONTENT_NAME6,
  titleName: TITLE_NAME,
  docsSlug: "dialog"
});
var TitleWarning = ({ titleId }) => {
  const titleWarningContext = useWarningContext(TITLE_WARNING_NAME);
  const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
  React49.useEffect(() => {
    if (titleId) {
      const hasTitle = document.getElementById(titleId);
      if (!hasTitle) console.error(MESSAGE);
    }
  }, [MESSAGE, titleId]);
  return null;
};
var DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var DescriptionWarning = ({ contentRef, descriptionId }) => {
  const descriptionWarningContext = useWarningContext(DESCRIPTION_WARNING_NAME);
  const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
  React49.useEffect(() => {
    const describedById = contentRef.current?.getAttribute("aria-describedby");
    if (descriptionId && describedById) {
      const hasDescription = document.getElementById(descriptionId);
      if (!hasDescription) console.warn(MESSAGE);
    }
  }, [MESSAGE, contentRef, descriptionId]);
  return null;
};
var Root6 = Dialog;
var Portal4 = DialogPortal;
var Overlay = DialogOverlay;
var Content3 = DialogContent;
var Title = DialogTitle;
var Description = DialogDescription;
var Close = DialogClose;
var Dialog2 = Root6;
var DialogPortal2 = Portal4;
var DialogOverlay2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Overlay,
  {
    ref,
    className: cn(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props
  }
));
DialogOverlay2.displayName = Overlay.displayName;
var DialogContent2 = React49.forwardRef(({ className, children, showOverlay = true, hideCloseButton = false, ...props }, ref) => /* @__PURE__ */ jsxs(DialogPortal2, { children: [
  showOverlay && /* @__PURE__ */ jsx(DialogOverlay2, {}),
  /* @__PURE__ */ jsxs(
    Content3,
    {
      ref,
      className: cn(
        "fixed max-h-[90vh] overflow-y-auto left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 sm:rounded-lg",
        className
      ),
      ...props,
      children: [
        children,
        !hideCloseButton && /* @__PURE__ */ jsxs(Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ jsx(Cross2Icon, { className: "h-4 w-4" }),
          /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
DialogContent2.displayName = Content3.displayName;
var DialogHeader = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      className
    ),
    ...props
  }
);
DialogHeader.displayName = "DialogHeader";
var DialogFooter = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      className
    ),
    ...props
  }
);
DialogFooter.displayName = "DialogFooter";
var DialogTitle2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Title,
  {
    ref,
    className: cn(
      "text-lg font-semibold leading-none tracking-tight",
      className
    ),
    ...props
  }
));
DialogTitle2.displayName = Title.displayName;
var DialogDescription2 = React49.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Description,
  {
    ref,
    className: cn("text-sm text-muted-foreground", className),
    ...props
  }
));
DialogDescription2.displayName = Description.displayName;
function LinkModal({
  open: open2,
  onOpenChange,
  currentHref = "",
  onSave,
  variables
}) {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const unavailableVariableIds = useUnavailableVariableIds();
  const editor = useEditor({
    extensions: [
      index_default,
      mention_extension_default(variables, unavailableVariableIds),
      index_default3,
      index_default4
    ],
    content: parseMentionsFromText(currentHref ?? "", variables),
    editorProps: {
      attributes: {
        class: "min-h-9 px-3 py-2 text-sm rounded-md border bg-background outline-none ring-0 focus:outline-none focus:ring-0",
        style: "white-space: pre-wrap;"
      }
    }
  });
  useEffect(() => {
    if (!editor) return;
    const doc3 = parseMentionsFromText(currentHref ?? "", variables);
    if (editor.getJSON && JSON.stringify(editor.getJSON()) !== JSON.stringify(doc3)) {
      editor.commands.setContent(doc3, { emitUpdate: false });
    }
  }, [editor, currentHref, open2, variables]);
  const handleSave = () => {
    const text = editor?.getText() ?? "";
    onSave(text.trim());
    onOpenChange(false);
  };
  const handleCancel = () => {
    if (editor) {
      editor.commands.setContent(
        parseMentionsFromText(currentHref ?? "", variables),
        {
          emitUpdate: false
        }
      );
    }
    onOpenChange(false);
  };
  return /* @__PURE__ */ jsx(Dialog2, { open: open2, onOpenChange, children: /* @__PURE__ */ jsxs(DialogContent2, { children: [
    /* @__PURE__ */ jsx(DialogHeader, { children: /* @__PURE__ */ jsx(DialogTitle2, { children: t2(
      "editorBlocksLibrary.blocks.paragraph.linkModal.title",
      "Add Link"
    ) }) }),
    /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx("label", { className: "text-sm font-medium", children: t2(
        "editorBlocksLibrary.blocks.paragraph.linkModal.urlLabel",
        "URL"
      ) }),
      /* @__PURE__ */ jsx(EditorContent, { editor })
    ] }),
    /* @__PURE__ */ jsxs(DialogFooter, { children: [
      /* @__PURE__ */ jsx(Button, { variant: "outline", onClick: handleCancel, children: t2(
        "editorBlocksLibrary.blocks.paragraph.linkModal.cancel",
        "Cancel"
      ) }),
      /* @__PURE__ */ jsx(Button, { onClick: handleSave, children: t2("editorBlocksLibrary.blocks.paragraph.linkModal.save", "Save") })
    ] })
  ] }) });
}
var ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png"];
var MAX_IMAGE_SIZE_BYTES = 1024 * 1024 * 2;
function parseImageWidth(raw) {
  const match = /^(\d+(?:\.\d+)?)(px|%)$/.exec(raw ?? "");
  if (match) {
    return { value: match[1], unit: match[2] };
  }
  return { value: "", unit: "px" };
}
function EmailPanelToolbar({ editor }) {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [imageError, setImageError] = useState(null);
  const containerRef = useRef(null);
  const colorInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const currentColor = editor?.getAttributes("textStyle")?.color || "#000000";
  const { variables, formAPI } = useBlockPanelPropsContext();
  const activeFormats = useMemo(() => {
    if (!editor) return [];
    const formats = [];
    if (editor.isActive("bold")) formats.push("bold");
    if (editor.isActive("italic")) formats.push("italic");
    if (editor.isActive("underline")) formats.push("underline");
    return formats;
  }, [
    editor?.isActive("bold"),
    editor?.isActive("italic"),
    editor?.isActive("underline")
  ]);
  const imageState = useEditorState({
    editor,
    selector: ({ editor: editor2 }) => ({
      isImageSelected: editor2?.isActive("image") ?? false,
      width: editor2?.getAttributes("image").width ?? ""
    })
  });
  if (!editor) {
    return null;
  }
  const getCurrentFontSize = () => {
    const fontSize = editor.getAttributes("textStyle")?.fontSize || "16px";
    return fontSize;
  };
  const handleFormatChange = (values) => {
    if (values.includes("bold") && !editor.isActive("bold")) {
      editor.chain().focus().toggleBold().run();
    } else if (!values.includes("bold") && editor.isActive("bold")) {
      editor.chain().focus().toggleBold().run();
    }
    if (values.includes("italic") && !editor.isActive("italic")) {
      editor.chain().focus().toggleItalic().run();
    } else if (!values.includes("italic") && editor.isActive("italic")) {
      editor.chain().focus().toggleItalic().run();
    }
    if (values.includes("underline") && !editor.isActive("underline")) {
      editor.chain().focus().toggleUnderline().run();
    } else if (!values.includes("underline") && editor.isActive("underline")) {
      editor.chain().focus().toggleUnderline().run();
    }
  };
  const handleFontSizeChange = (fontSize) => {
    editor.chain().focus().setFontSize(fontSize).run();
  };
  const getFontSizeLabel = () => {
    const fontSize = getCurrentFontSize();
    return fontSize;
  };
  const getCurrentLink = () => {
    if (!editor) return "";
    const attrs = editor.getAttributes("link");
    return attrs.href || "";
  };
  const handleLinkSave = (href) => {
    if (href) {
      editor.chain().focus().setLink({ href }).run();
    } else {
      editor.chain().focus().unsetLink().run();
    }
  };
  const handleLinkClick = () => {
    if (editor.isActive("link")) {
      editor.chain().focus().extendMarkRange("link").run();
    }
    setIsLinkModalOpen(true);
  };
  const handleClearColor = () => {
    if (editor) {
      editor.chain().focus().unsetColor().run();
    }
  };
  const handleImageButtonClick = () => {
    imageInputRef.current?.click();
  };
  const handleImageFileChange = (event) => {
    const [file] = Array.from(event.target.files ?? []);
    event.target.value = "";
    if (!file || !editor) return;
    if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
      setImageError(
        t2(
          "editorBlocksLibrary.blocks.paragraph.image.invalidType",
          "Only JPG and PNG images are allowed."
        )
      );
      return;
    }
    if (file.size > MAX_IMAGE_SIZE_BYTES) {
      setImageError(
        t2(
          "editorBlocksLibrary.blocks.paragraph.image.tooLarge",
          "Image must be under 2 MB."
        )
      );
      return;
    }
    setImageError(null);
    const uploadKey = crypto.randomUUID();
    formAPI.registerImage(uploadKey, file);
    const previewUrl = URL.createObjectURL(file);
    editor.chain().focus().insertContent({
      type: "image",
      attrs: { src: previewUrl, uploadKey }
    }).run();
  };
  const isImageSelected = imageState?.isImageSelected ?? false;
  const { value: imageWidthValue, unit: imageWidthUnit } = parseImageWidth(
    imageState?.width
  );
  const applyImageWidth = (value, unit) => {
    const trimmed = value.trim();
    editor.chain().updateAttributes("image", {
      width: trimmed ? `${trimmed}${unit}` : null
    }).run();
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "flex gap-1.5 items-center flex-wrap text-foreground",
      ref: containerRef,
      children: [
        /* @__PURE__ */ jsxs(DropdownMenu2, { children: [
          /* @__PURE__ */ jsx(DropdownMenuTrigger2, { asChild: true, children: /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "outline",
              size: "sm",
              className: "h-8 w-16 bg-background border shadow justify-between text-xs gap-0",
              children: [
                getFontSizeLabel(),
                /* @__PURE__ */ jsx(ChevronDown, { className: "h-3 w-3" })
              ]
            }
          ) }),
          /* @__PURE__ */ jsxs(
            DropdownMenuContent2,
            {
              side: "bottom",
              align: "start",
              className: "w-16 text-foreground",
              container: containerRef.current,
              children: [
                /* @__PURE__ */ jsx(DropdownMenuItem2, { onClick: () => handleFontSizeChange("12px"), children: "12px" }),
                /* @__PURE__ */ jsx(DropdownMenuItem2, { onClick: () => handleFontSizeChange("14px"), children: "14px" }),
                /* @__PURE__ */ jsx(DropdownMenuItem2, { onClick: () => handleFontSizeChange("16px"), children: "16px" }),
                /* @__PURE__ */ jsx(DropdownMenuItem2, { onClick: () => handleFontSizeChange("18px"), children: "18px" }),
                /* @__PURE__ */ jsx(DropdownMenuItem2, { onClick: () => handleFontSizeChange("20px"), children: "20px" }),
                /* @__PURE__ */ jsx(DropdownMenuItem2, { onClick: () => handleFontSizeChange("24px"), children: "24px" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(
          ToggleGroup2,
          {
            variant: "default",
            type: "multiple",
            value: activeFormats,
            onValueChange: handleFormatChange,
            className: "bg-background border shadow h-8",
            children: [
              /* @__PURE__ */ jsx(
                ToggleGroupItem2,
                {
                  value: "bold",
                  "aria-label": "Toggle bold",
                  className: "h-8 w-8 p-0",
                  children: /* @__PURE__ */ jsx(Bold, { className: "h-3.5 w-3.5" })
                }
              ),
              /* @__PURE__ */ jsx(
                ToggleGroupItem2,
                {
                  value: "italic",
                  "aria-label": "Toggle italic",
                  className: "h-8 w-8 p-0",
                  children: /* @__PURE__ */ jsx(Italic, { className: "h-3.5 w-3.5" })
                }
              ),
              /* @__PURE__ */ jsx(
                ToggleGroupItem2,
                {
                  value: "underline",
                  "aria-label": "Toggle underline",
                  className: "h-8 w-8 p-0",
                  children: /* @__PURE__ */ jsx(Underline, { className: "h-3.5 w-3.5" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            variant: "outline",
            className: "bg-background h-8 w-8 p-0",
            onClick: handleLinkClick,
            children: /* @__PURE__ */ jsx(Link2, { className: "h-3.5 w-3.5" })
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            variant: "outline",
            className: "bg-background h-8 w-8 p-0",
            onClick: handleImageButtonClick,
            title: t2(
              "editorBlocksLibrary.blocks.paragraph.image.insert",
              "Insert image"
            ),
            children: /* @__PURE__ */ jsx(Image, { className: "h-3.5 w-3.5" })
          }
        ),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: imageInputRef,
            type: "file",
            accept: ACCEPTED_IMAGE_TYPES.join(","),
            onChange: handleImageFileChange,
            className: "hidden"
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "flex bg-background border shadow rounded-md h-8", children: [
          /* @__PURE__ */ jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ jsx(
              "input",
              {
                ref: colorInputRef,
                type: "color",
                defaultValue: currentColor,
                onInput: (event) => {
                  if (editor) {
                    editor.chain().focus().setColor(event.currentTarget.value).run();
                  }
                },
                className: "absolute inset-0 w-full h-full opacity-0 cursor-pointer",
                title: "Choose text color"
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                size: "sm",
                variant: "ghost",
                className: "pointer-events-none rounded-r-none border-r h-8 w-8 p-0",
                children: /* @__PURE__ */ jsx(Palette, { className: "h-3.5 w-3.5" })
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            Button,
            {
              size: "sm",
              variant: "ghost",
              className: "rounded-l-none h-8 w-8 p-0",
              onClick: handleClearColor,
              title: "Clear text color",
              children: /* @__PURE__ */ jsx(RotateCcw, { className: "h-3.5 w-3.5" })
            }
          )
        ] }),
        isImageSelected ? /* @__PURE__ */ jsxs("div", { className: "flex h-8 items-center gap-1 rounded-md border bg-background px-2 shadow", children: [
          /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: t2("editorBlocksLibrary.blocks.paragraph.image.width", "Width") }),
          /* @__PURE__ */ jsx(
            Input,
            {
              type: "number",
              min: 1,
              value: imageWidthValue,
              placeholder: t2(
                "editorBlocksLibrary.blocks.paragraph.image.auto",
                "Auto"
              ),
              onChange: (event) => applyImageWidth(event.target.value, imageWidthUnit),
              className: "h-6 w-14 border-0 px-1 text-xs shadow-none focus-visible:ring-0"
            }
          ),
          /* @__PURE__ */ jsxs(
            ToggleGroup2,
            {
              type: "single",
              value: imageWidthUnit,
              onValueChange: (unit) => {
                if (unit && imageWidthValue) {
                  applyImageWidth(imageWidthValue, unit);
                }
              },
              className: "h-6",
              children: [
                /* @__PURE__ */ jsx(
                  ToggleGroupItem2,
                  {
                    value: "px",
                    "aria-label": "Width in pixels",
                    className: "h-6 w-7 p-0 text-xs",
                    children: "px"
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToggleGroupItem2,
                  {
                    value: "%",
                    "aria-label": "Width in percent",
                    className: "h-6 w-7 p-0 text-xs",
                    children: "%"
                  }
                )
              ]
            }
          )
        ] }) : null,
        /* @__PURE__ */ jsx(
          LinkModal,
          {
            variables,
            open: isLinkModalOpen,
            onOpenChange: setIsLinkModalOpen,
            currentHref: getCurrentLink(),
            onSave: handleLinkSave
          }
        ),
        imageError ? /* @__PURE__ */ jsx("p", { className: "w-full text-sm text-destructive", children: imageError }) : null
      ]
    }
  );
}
function DynamicTextPanelWorkflowContent() {
  const editor = useParagraphEditor();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(PanelContent, { title: "Contenu", children: /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx(EmailPanelToolbar, { editor }),
      /* @__PURE__ */ jsx(EditorContent, { editor })
    ] }) }),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelBlockFont, {}),
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "translatable", portal: true })
  ] });
}
function DynamicTextPanelTemplateContent() {
  return /* @__PURE__ */ jsx(PanelContent, { title: "Contenu dynamique", children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3 rounded-md bg-muted/50 p-3", children: [
    /* @__PURE__ */ jsx(RefreshCw, { className: "mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" }),
    /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Le contenu de ce bloc est d\xE9fini dans chaque workflow." })
  ] }) });
}
function DynamicTextEmailPanelRenderer(blockProps) {
  const isWorkflowMode = blockProps.editorMode === "workflowCustom";
  return /* @__PURE__ */ jsx(PanelContainer, { blockProps, children: isWorkflowMode ? /* @__PURE__ */ jsx(DynamicTextPanelWorkflowContent, {}) : /* @__PURE__ */ jsx(DynamicTextPanelTemplateContent, {}) });
}

// ../editor-blocks-library/src/blocks/dynamic-text/index.tsx
var dynamic_text_default = registerBlock({
  type: "dynamic-text",
  name: "editorBlocksLibrary.blocks.dynamicText.title",
  description: "editorBlocksLibrary.blocks.dynamicText.description",
  Icon: RefreshCw,
  category: "essentials" /* ESSENTIALS */,
  isTranslated: (locale, block) => {
    const content = block.content;
    return !!content && content?.[locale]?.html?.replace(/<[^>]+>/g, "").trim().length > 0;
  },
  components: {
    email: {
      component: DynamicTextEmailRenderer,
      editor: {
        component: DynamicTextEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: DynamicTextEmailPanelRenderer
      },
      compatibility: {
        rowBlock: true
      }
    }
  }
});

// ../editor-blocks-library/src/translations/bg.ts
var bg = {
  returnLineItems: {
    refund: "\u0412\u044A\u0437\u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435",
    exchange: "\u0417\u0430\u043C\u044F\u043D\u0430",
    newOrder: "\u041D\u043E\u0432\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430",
    discount: "\u041E\u0442\u0441\u0442\u044A\u043F\u043A\u0430"
  },
  returnStoreAddress: {
    mapButton: "\u0412\u0438\u0436 \u043D\u0430 \u043A\u0430\u0440\u0442\u0430\u0442\u0430"
  },
  downloadLabel: {
    label: "\u0418\u0437\u0442\u0435\u0433\u043B\u0438 \u0435\u0442\u0438\u043A\u0435\u0442\u0430 \u043C\u0438",
    bonDeRetour: "\u0418\u0437\u0442\u0435\u0433\u043B\u0438 \u0444\u043E\u0440\u043C\u0443\u043B\u044F\u0440\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435"
  },
  returnRequestDate: {
    label: "\u0417\u0430\u044F\u0432\u043A\u0430\u0442\u0430 \u0432\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u0435\u043D\u0430 \u043D\u0430 {{date}} \u0432 {{time}}"
  },
  actions: {
    continue: "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438"
  },
  "order-identification": {
    title: "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u0435\u0442\u0435 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u0441\u0438",
    description: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0434\u0435\u0442\u0430\u0439\u043B\u0438\u0442\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u0441\u0438, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430",
    fields: {
      "zip-code": {
        title: "\u041F\u043E\u0449\u0435\u043D\u0441\u043A\u0438 \u043A\u043E\u0434",
        description: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u043F\u043E\u0449\u0435\u043D\u0441\u043A\u0438 \u043A\u043E\u0434 \u0437\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
        required: "\u041F\u043E\u0449\u0435\u043D\u0441\u043A\u0438\u044F\u0442 \u043A\u043E\u0434 \u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u0435\u043D"
      },
      email: {
        title: "\u0418\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
        description: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441\u0430, \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D \u043F\u0440\u0438 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430",
        required: "\u0418\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441\u044A\u0442 \u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u0435\u043D"
      },
      both: {
        title: "\u041F\u043E\u0449\u0435\u043D\u0441\u043A\u0438 \u043A\u043E\u0434 \u0438\u043B\u0438 \u0438\u043C\u0435\u0439\u043B",
        description: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u043F\u043E\u0449\u0435\u043D\u0441\u043A\u0438 \u043A\u043E\u0434 \u0437\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u0438\u043B\u0438 \u0438\u043C\u0435\u0439\u043B\u0430, \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430",
        required: "\u041F\u043E\u0449\u0435\u043D\u0441\u043A\u0438\u044F\u0442 \u043A\u043E\u0434 \u0438\u043B\u0438 \u0438\u043C\u0435\u0439\u043B\u044A\u0442 \u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u0435\u043D"
      },
      "tracking-number": {
        title: "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430",
        description: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u0441\u0438",
        required: "\u041D\u043E\u043C\u0435\u0440\u044A\u0442 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u0435\u043D"
      }
    },
    errors: {
      "unknown-order": {
        title: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u0435\u043D \u043D\u043E\u043C\u0435\u0440 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430",
        description: "\u041D\u043E\u043C\u0435\u0440\u044A\u0442 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u043D\u0435 \u0431\u0435\u0448\u0435 \u043D\u0430\u043C\u0435\u0440\u0435\u043D, \u043C\u043E\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u0442\u0435 \u0433\u043E"
      },
      "search-error": {
        title: "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0442\u044A\u0440\u0441\u0435\u043D\u0435",
        description: "\u041D\u0435 \u0443\u0441\u043F\u044F\u0445\u043C\u0435 \u0434\u0430 \u043D\u0430\u043C\u0435\u0440\u0438\u043C \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430. \u041C\u043E\u043B\u044F, \u043E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043F\u043E-\u043A\u044A\u0441\u043D\u043E."
      }
    }
  },
  delivery: "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
  "parcel-history": "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043D\u0430 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430",
  "order-details": {
    title: "\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430",
    "tracking-number": "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435",
    "order-number": "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "\u041E\u0447\u0430\u043A\u0432\u0430\u043D\u0430 \u0434\u0430\u0442\u0430 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
      deliveredOn: "\u0414\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u043E \u043D\u0430",
      from: "\u043E\u0442",
      to: "\u0434\u043E"
    }
  },
  deliveryAddress: {
    title: "\u0410\u0434\u0440\u0435\u0441 \u0437\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430:",
    titlePickup: "\u0410\u0434\u0440\u0435\u0441 \u043D\u0430 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435:",
    orderDetails: {
      title: "\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430:",
      trackingNumber: "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435:",
      orderNumber: "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430:",
      orderDate: "\u0414\u0430\u0442\u0430 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430:"
    }
  },
  pickupPoint: {
    title: "\u041F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
    openingHours: "\u0420\u0430\u0431\u043E\u0442\u043D\u043E \u0432\u0440\u0435\u043C\u0435:",
    closed: "\u0417\u0430\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    directions: "\u0423\u043A\u0430\u0437\u0430\u043D\u0438\u044F",
    days: {
      monday: "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A:",
      tuesday: "\u0412\u0442\u043E\u0440\u043D\u0438\u043A:",
      wednesday: "\u0421\u0440\u044F\u0434\u0430:",
      thursday: "\u0427\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A:",
      friday: "\u041F\u0435\u0442\u044A\u043A:",
      saturday: "\u0421\u044A\u0431\u043E\u0442\u0430:",
      sunday: "\u041D\u0435\u0434\u0435\u043B\u044F:"
    }
  },
  wallet: {
    warningNotEnabled: "\u0422\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u0442\u0435 Wallet \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0442\u0435 \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u043C\u0430\u0433\u0430\u0437\u0438\u043D"
  },
  crossSell: {
    youMightAlsoLike: "\u041C\u043E\u0436\u0435 \u0434\u0430 \u0445\u0430\u0440\u0435\u0441\u0430\u0442\u0435 \u0438"
  },
  "rate-order": {
    "order-recap": {
      title: "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430",
      "tracking-label": "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435:",
      "order-label": "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430:"
    },
    form: {
      title: "\u041E\u0446\u0435\u043D\u0435\u0442\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
      "rating-label": "\u041E\u0446\u0435\u043D\u0435\u0442\u0435 \u043E\u043F\u0438\u0442\u0430 \u0441\u0438 \u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430",
      "comment-label": "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440 (\u043D\u0435\u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E)",
      "comment-placeholder": "\u0421\u043F\u043E\u0434\u0435\u043B\u0435\u0442\u0435 \u043E\u043F\u0438\u0442\u0430 \u0441\u0438 \u0441 \u043D\u0430\u0441\u2026",
      "submit-cta": "\u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043C\u043E\u044F\u0442\u0430 \u043E\u0446\u0435\u043D\u043A\u0430",
      "update-cta": "\u041E\u0431\u043D\u043E\u0432\u0438 \u043C\u043E\u044F\u0442\u0430 \u043E\u0446\u0435\u043D\u043A\u0430",
      "rating-required": "\u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043E\u0446\u0435\u043D\u043A\u0430."
    },
    "thank-you": {
      title: "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043E\u0431\u0440\u0430\u0442\u043D\u0430 \u0432\u0440\u044A\u0437\u043A\u0430!",
      description: "\u0412\u0430\u0448\u0430\u0442\u0430 \u043E\u0446\u0435\u043D\u043A\u0430 \u0431\u0435\u0448\u0435 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0430. \u0422\u044F \u0449\u0435 \u043D\u0438 \u043F\u043E\u043C\u043E\u0433\u043D\u0435 \u0434\u0430 \u043F\u043E\u0434\u043E\u0431\u0440\u0438\u043C \u043E\u043F\u0438\u0442\u0430 \u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438\u0442\u0435."
    },
    errors: {
      "invalid-token": {
        title: "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430 \u0438\u043B\u0438 \u0438\u0437\u0442\u0435\u043A\u043B\u0430 \u0432\u0440\u044A\u0437\u043A\u0430",
        description: "\u0422\u0430\u0437\u0438 \u0432\u0440\u044A\u0437\u043A\u0430 \u0432\u0435\u0447\u0435 \u043D\u0435 \u0435 \u0432\u0430\u043B\u0438\u0434\u043D\u0430. \u041C\u043E\u043B\u044F, \u043E\u0442\u0432\u043E\u0440\u0435\u0442\u0435 \u044F \u043E\u0442\u043D\u043E\u0432\u043E \u043E\u0442 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u044F \u0441\u0438 \u0438\u043C\u0435\u0439\u043B \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435."
      },
      submit: {
        title: "\u041D\u0435\u0449\u043E \u0441\u0435 \u043E\u0431\u044A\u0440\u043A\u0430",
        description: "\u041D\u0435 \u0443\u0441\u043F\u044F\u0445\u043C\u0435 \u0434\u0430 \u0437\u0430\u043F\u0430\u0437\u0438\u043C \u0432\u0430\u0448\u0430\u0442\u0430 \u043E\u0446\u0435\u043D\u043A\u0430. \u041C\u043E\u043B\u044F, \u043E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043F\u043E-\u043A\u044A\u0441\u043D\u043E."
      }
    }
  },
  shippingInstructions: {
    colissimo: "\u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043E\u0442\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u0435 \u0435\u0442\u0438\u043A\u0435\u0442\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0438 \u0434\u0430 \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438 \u0432 \u043D\u0430\u0439-\u0431\u043B\u0438\u0437\u043A\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u043D\u0430 Colissimo.",
    chronoShop2Shop: "\u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043E\u0442\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u0435 \u0435\u0442\u0438\u043A\u0435\u0442\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0438 \u0434\u0430 \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438 \u0432 \u043D\u0430\u0439-\u0431\u043B\u0438\u0437\u043A\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u043D\u0430 Chronopost.",
    ups: "\u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043E\u0442\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u0435 \u0435\u0442\u0438\u043A\u0435\u0442\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0438 \u0434\u0430 \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438 \u0432 \u043D\u0430\u0439-\u0431\u043B\u0438\u0437\u043A\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u043D\u0430 UPS.",
    customerCarrier: "\u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u043F\u0440\u0430\u0442\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0441 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447 \u043F\u043E \u0432\u0430\u0448 \u0438\u0437\u0431\u043E\u0440.",
    merchantCarrier: "\u0429\u0435 \u0432\u0438 \u0438\u0437\u043F\u0440\u0430\u0442\u0438\u043C \u0435\u0442\u0438\u043A\u0435\u0442 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u043F\u043E \u0438\u043C\u0435\u0439\u043B \u0432 \u0440\u0430\u043C\u043A\u0438\u0442\u0435 \u043D\u0430 1 \u0434\u043E 3 \u0440\u0430\u0431\u043E\u0442\u043D\u0438 \u0434\u043D\u0438.",
    returnToStore: "\u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438 \u0432 \u043D\u0430\u0439-\u0431\u043B\u0438\u0437\u043A\u0438\u044F \u043C\u0430\u0433\u0430\u0437\u0438\u043D.",
    malca: "\u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043E\u0442\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u0435 \u0435\u0442\u0438\u043A\u0435\u0442\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0438 \u0434\u0430 \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438 \u0432 \u043D\u0430\u0439-\u0431\u043B\u0438\u0437\u043A\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u043D\u0430 Malca.",
    tnt: "\u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043E\u0442\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u0435 \u0435\u0442\u0438\u043A\u0435\u0442\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0438 \u0434\u0430 \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438 \u0432 \u043D\u0430\u0439-\u0431\u043B\u0438\u0437\u043A\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u043D\u0430 TNT.",
    bonDeRetour: "\u0412\u0430\u0448\u0430\u0442\u0430 \u0431\u0435\u043B\u0435\u0436\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0435 \u0433\u043E\u0442\u043E\u0432\u0430. \u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u044F \u043E\u0442\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u0435 \u0438 \u0434\u0430 \u044F \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E.",
    unknownCarrier: "\u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0440\u0430\u0437\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u0435 \u0435\u0442\u0438\u043A\u0435\u0442\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0438 \u0434\u0430 \u0438\u0437\u043F\u0440\u0430\u0442\u0438\u0442\u0435 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430, \u043F\u043E\u0441\u043E\u0447\u0435\u043D \u043D\u0430 \u0435\u0442\u0438\u043A\u0435\u0442\u0430."
  },
  shippingInstructionsTitle: {
    shippingLabel: "\u0412\u0430\u0448\u0438\u044F\u0442 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0435\u043D \u0435\u0442\u0438\u043A\u0435\u0442 \u0435 \u0433\u043E\u0442\u043E\u0432",
    bonDeRetour: "\u0412\u0430\u0448\u0430\u0442\u0430 \u0431\u0435\u043B\u0435\u0436\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0435 \u0433\u043E\u0442\u043E\u0432\u0430"
  }
};

// ../editor-blocks-library/src/translations/cs.ts
var cs = {
  returnLineItems: {
    refund: "Vr\xE1cen\xED pen\u011Bz",
    exchange: "V\xFDm\u011Bna",
    newOrder: "Nov\xE1 objedn\xE1vka",
    discount: "Sleva"
  },
  returnStoreAddress: {
    mapButton: "Zobrazit na map\u011B"
  },
  downloadLabel: {
    label: "St\xE1hnout m\u016Fj \u0161t\xEDtek",
    bonDeRetour: "St\xE1hnout formul\xE1\u0159 pro vr\xE1cen\xED"
  },
  returnRequestDate: {
    label: "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED byla pod\xE1na {{date}} v {{time}}"
  },
  actions: {
    continue: "Pokra\u010Dovat"
  },
  "order-identification": {
    title: "Sledujte svou objedn\xE1vku",
    description: "Zadejte \xFAdaje o objedn\xE1vce pro sledov\xE1n\xED z\xE1silky",
    fields: {
      "zip-code": {
        title: "PS\u010C",
        description: "Zadejte va\u0161e doru\u010Dovac\xED PS\u010C",
        required: "PS\u010C je povinn\xE9"
      },
      email: {
        title: "E-mailov\xE1 adresa",
        description: "Zadejte e-mailovou adresu pou\u017Eitou p\u0159i objedn\xE1vce",
        required: "E-mailov\xE1 adresa je povinn\xE1"
      },
      both: {
        title: "PS\u010C nebo e-mail",
        description: "Zadejte sv\xE9 doru\u010Dovac\xED PS\u010C nebo e-mail pou\u017Eit\xFD pro objedn\xE1vku",
        required: "PS\u010C nebo e-mail je povinn\xFD"
      },
      "tracking-number": {
        title: "\u010C\xEDslo objedn\xE1vky",
        description: "Zadejte \u010D\xEDslo va\u0161\xED objedn\xE1vky",
        required: "\u010C\xEDslo objedn\xE1vky je povinn\xE9"
      }
    },
    errors: {
      "unknown-order": {
        title: "Nezn\xE1m\xE9 \u010D\xEDslo objedn\xE1vky",
        description: "\u010C\xEDslo objedn\xE1vky nebylo nalezeno, zkontrolujte ho pros\xEDm"
      },
      "search-error": {
        title: "Chyba vyhled\xE1v\xE1n\xED",
        description: "Nepoda\u0159ilo se n\xE1m naj\xEDt objedn\xE1vku. Zkuste to pros\xEDm pozd\u011Bji."
      }
    }
  },
  delivery: "Doru\u010Den\xED",
  "parcel-history": "Historie bal\xEDku",
  "order-details": {
    title: "Detaily objedn\xE1vky",
    "tracking-number": "Sledovac\xED \u010D\xEDslo",
    "order-number": "\u010C\xEDslo objedn\xE1vky"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Odhadovan\xE9 datum doru\u010Den\xED",
      deliveredOn: "Doru\u010Deno dne",
      from: "od",
      to: "do"
    }
  },
  deliveryAddress: {
    title: "Dodac\xED adresa:",
    titlePickup: "Adresa v\xFDdejn\xEDho m\xEDsta:",
    orderDetails: {
      title: "Detaily objedn\xE1vky:",
      trackingNumber: "Sledovac\xED \u010D\xEDslo:",
      orderNumber: "\u010C\xEDslo objedn\xE1vky:",
      orderDate: "Datum objedn\xE1vky:"
    }
  },
  pickupPoint: {
    title: "V\xFDdejn\xED m\xEDsto",
    openingHours: "Otev\xEDrac\xED doba:",
    closed: "Zav\u0159eno",
    directions: "Trasa",
    days: {
      monday: "Pond\u011Bl\xED:",
      tuesday: "\xDAter\xFD:",
      wednesday: "St\u0159eda:",
      thursday: "\u010Ctvrtek:",
      friday: "P\xE1tek:",
      saturday: "Sobota:",
      sunday: "Ned\u011Ble:"
    }
  },
  wallet: {
    warningNotEnabled: "Mus\xEDte povolit Wallet v nastaven\xED sv\xE9ho obchodu"
  },
  crossSell: {
    youMightAlsoLike: "Mohlo by se v\xE1m tak\xE9 l\xEDbit"
  },
  "rate-order": {
    "order-recap": {
      title: "Va\u0161e objedn\xE1vka",
      "tracking-label": "Sledovac\xED \u010D\xEDslo:",
      "order-label": "\u010C\xEDslo objedn\xE1vky:"
    },
    form: {
      title: "Ohodno\u0165te sv\xE9 doru\u010Den\xED",
      "rating-label": "Ohodno\u0165te z\xE1\u017Eitek z doru\u010Den\xED",
      "comment-label": "Koment\xE1\u0159 (nepovinn\xE9)",
      "comment-placeholder": "Pod\u011Blte se s n\xE1mi o sv\u016Fj z\xE1\u017Eitek\u2026",
      "submit-cta": "Odeslat hodnocen\xED",
      "update-cta": "Aktualizovat hodnocen\xED",
      "rating-required": "Vyberte pros\xEDm hodnocen\xED."
    },
    "thank-you": {
      title: "D\u011Bkujeme za va\u0161i zp\u011Btnou vazbu!",
      description: "Va\u0161e hodnocen\xED bylo ulo\u017Eeno. Pom\u016F\u017Ee n\xE1m vylep\u0161it z\xE1\u017Eitek z doru\u010Den\xED."
    },
    errors: {
      "invalid-token": {
        title: "Neplatn\xFD nebo vypr\u0161el\xFD odkaz",
        description: "Tento odkaz ji\u017E nen\xED platn\xFD. Otev\u0159ete ho pros\xEDm znovu z va\u0161eho posledn\xEDho sledovac\xEDho e-mailu."
      },
      submit: {
        title: "N\u011Bco se pokazilo",
        description: "Nepoda\u0159ilo se n\xE1m ulo\u017Eit va\u0161e hodnocen\xED. Zkuste to pros\xEDm pozd\u011Bji."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Nyn\xED si m\u016F\u017Eete vytisknout zp\u011Btn\xFD \u0161t\xEDtek a odevzdat bal\xED\u010Dek v nejbli\u017E\u0161\xEDm v\xFDdejn\xEDm m\xEDst\u011B Colissimo.",
    chronoShop2Shop: "Nyn\xED si m\u016F\u017Eete vytisknout zp\u011Btn\xFD \u0161t\xEDtek a odevzdat bal\xED\u010Dek v nejbli\u017E\u0161\xEDm v\xFDdejn\xEDm m\xEDst\u011B Chronopost.",
    ups: "Nyn\xED si m\u016F\u017Eete vytisknout zp\u011Btn\xFD \u0161t\xEDtek a odevzdat bal\xED\u010Dek v nejbli\u017E\u0161\xEDm v\xFDdejn\xEDm m\xEDst\u011B UPS.",
    customerCarrier: "Nyn\xED m\u016F\u017Eete poslat bal\xED\u010Dek k vr\xE1cen\xED dopravci dle va\u0161eho v\xFDb\u011Bru.",
    merchantCarrier: "Zas\xEDl\xE1me v\xE1m zp\u011Btn\xFD \u0161t\xEDtek e-mailem b\u011Bhem 1 a\u017E 3 pracovn\xEDch dn\u016F.",
    returnToStore: "Nyn\xED m\u016F\u017Eete odevzdat bal\xED\u010Dek v nejbli\u017E\u0161\xED prodejn\u011B.",
    malca: "Nyn\xED si m\u016F\u017Eete vytisknout zp\u011Btn\xFD \u0161t\xEDtek a odevzdat bal\xED\u010Dek v nejbli\u017E\u0161\xEDm v\xFDdejn\xEDm m\xEDst\u011B Malca.",
    tnt: "Nyn\xED si m\u016F\u017Eete vytisknout zp\u011Btn\xFD \u0161t\xEDtek a odevzdat bal\xED\u010Dek v nejbli\u017E\u0161\xEDm v\xFDdejn\xEDm m\xEDst\u011B TNT.",
    bonDeRetour: "V\xE1\u0161 p\u0159epravn\xED \u0161t\xEDtek je p\u0159ipraven. Nyn\xED si jej m\u016F\u017Eete vytisknout a pou\u017E\xEDt pro vr\xE1cen\xED.",
    unknownCarrier: "Nyn\xED si m\u016F\u017Eete vytisknout zp\xE1te\u010Dn\xED \u0161t\xEDtek a odeslat bal\xEDk dopravcem uveden\xFDm na \u0161t\xEDtku."
  },
  shippingInstructionsTitle: {
    shippingLabel: "V\xE1\u0161 p\u0159epravn\xED \u0161t\xEDtek je p\u0159ipraven",
    bonDeRetour: "V\xE1\u0161 formul\xE1\u0159 pro vr\xE1cen\xED je p\u0159ipraven"
  }
};

// ../editor-blocks-library/src/translations/da.ts
var da = {
  returnLineItems: {
    refund: "Refundering(er)",
    exchange: "Ombytning(er)",
    newOrder: "Ny ordre",
    discount: "Rabat(ter)"
  },
  returnStoreAddress: {
    mapButton: "Se p\xE5 kort"
  },
  downloadLabel: {
    label: "Download min etiket",
    bonDeRetour: "Download min returseddel"
  },
  returnRequestDate: {
    label: "Din returanmodning blev oprettet den {{date}} kl. {{time}}"
  },
  actions: {
    continue: "Forts\xE6t"
  },
  "order-identification": {
    title: "Spor din ordre",
    description: "Indtast dine ordreoplysninger for at spore din pakke",
    fields: {
      "zip-code": {
        title: "Postnummer",
        description: "Indtast dit leveringspostnummer",
        required: "Postnummer er p\xE5kr\xE6vet"
      },
      email: {
        title: "E-mailadresse",
        description: "Indtast den e-mailadresse, du brugte til din bestilling",
        required: "E-mailadresse er p\xE5kr\xE6vet"
      },
      both: {
        title: "Postnummer eller e-mail",
        description: "Indtast dit leveringspostnummer eller den e-mail, der blev brugt til din ordre",
        required: "Postnummer eller e-mail er p\xE5kr\xE6vet"
      },
      "tracking-number": {
        title: "Ordrenummer",
        description: "Indtast dit ordrenummer",
        required: "Ordrenummer er p\xE5kr\xE6vet"
      }
    },
    errors: {
      "unknown-order": {
        title: "Ukendt ordrenummer",
        description: "Ordrenummeret blev ikke fundet, kontroller det venligst"
      },
      "search-error": {
        title: "S\xF8gefejl",
        description: "Vi kunne ikke finde ordren. Pr\xF8v venligst igen senere."
      }
    }
  },
  delivery: "Levering",
  "parcel-history": "Pakkehistorik",
  "order-details": {
    title: "Ordredetaljer",
    "tracking-number": "Sporingsnummer",
    "order-number": "Ordrenummer"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Forventet leveringsdato",
      deliveredOn: "Leveret den",
      from: "fra",
      to: "til"
    }
  },
  deliveryAddress: {
    title: "Leveringsadresse:",
    titlePickup: "Adresse p\xE5 afhentningssted:",
    orderDetails: {
      title: "Ordredetaljer:",
      trackingNumber: "Sporingsnummer:",
      orderNumber: "Ordrenummer:",
      orderDate: "Ordredato:"
    }
  },
  pickupPoint: {
    title: "Afhentningssted",
    openingHours: "\xC5bningstider:",
    closed: "Lukket",
    directions: "Vejbeskrivelse",
    days: {
      monday: "Mandag:",
      tuesday: "Tirsdag:",
      wednesday: "Onsdag:",
      thursday: "Torsdag:",
      friday: "Fredag:",
      saturday: "L\xF8rdag:",
      sunday: "S\xF8ndag:"
    }
  },
  wallet: {
    warningNotEnabled: "Du skal aktivere Wallet i dine butiksindstillinger"
  },
  crossSell: {
    youMightAlsoLike: "Du vil m\xE5ske ogs\xE5 kunne lide"
  },
  "rate-order": {
    "order-recap": {
      title: "Din ordre",
      "tracking-label": "Sporingsnummer:",
      "order-label": "Ordrenummer:"
    },
    form: {
      title: "Bed\xF8m din levering",
      "rating-label": "Bed\xF8m din leveringsoplevelse",
      "comment-label": "Kommentar (valgfri)",
      "comment-placeholder": "Del din oplevelse med os\u2026",
      "submit-cta": "Indsend min anmeldelse",
      "update-cta": "Opdater min anmeldelse",
      "rating-required": "V\xE6lg venligst en bed\xF8mmelse."
    },
    "thank-you": {
      title: "Tak for din feedback!",
      description: "Din anmeldelse er blevet gemt. Den vil hj\xE6lpe os med at forbedre leveringsoplevelsen."
    },
    errors: {
      "invalid-token": {
        title: "Ugyldigt eller udl\xF8bet link",
        description: "Dette link er ikke l\xE6ngere gyldigt. \xC5bn det igen fra din seneste sporings-e-mail."
      },
      submit: {
        title: "Noget gik galt",
        description: "Vi kunne ikke gemme din anmeldelse. Pr\xF8v venligst igen senere."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Du kan nu printe din returlabel og aflevere din pakke p\xE5 det n\xE6rmeste Colissimo-udleveringssted.",
    chronoShop2Shop: "Du kan nu printe din returlabel og aflevere din pakke p\xE5 det n\xE6rmeste Chronopost-udleveringssted.",
    ups: "Du kan nu printe din returlabel og aflevere din pakke p\xE5 det n\xE6rmeste UPS-udleveringssted.",
    customerCarrier: "Du kan nu sende din returpakke med det fragtfirma, du \xF8nsker.",
    merchantCarrier: "Vi sender dig en returlabel pr. e-mail inden for 1 til 3 hverdage.",
    returnToStore: "Du kan nu aflevere din pakke i den n\xE6rmeste butik.",
    malca: "Du kan nu printe din returlabel og aflevere din pakke p\xE5 det n\xE6rmeste Malca-udleveringssted.",
    tnt: "Du kan nu printe din returlabel og aflevere din pakke p\xE5 det n\xE6rmeste TNT-udleveringssted.",
    bonDeRetour: "Din fragtlabel er klar. Du kan nu printe den og bruge den til din returnering.",
    unknownCarrier: "Du kan nu printe din returlabel og sende din pakke med det fragtfirma, der er angivet p\xE5 labelen."
  },
  shippingInstructionsTitle: {
    shippingLabel: "Din forsendelsesetiket er klar",
    bonDeRetour: "Din returseddel er klar"
  }
};

// ../editor-blocks-library/src/translations/de.ts
var de = {
  returnLineItems: {
    refund: "R\xFCckerstattung(en)",
    exchange: "Umtausch",
    newOrder: "Neue Bestellung",
    discount: "Rabatt(e)"
  },
  returnStoreAddress: {
    mapButton: "Auf Karte anzeigen"
  },
  returnRequestDate: {
    label: "Ihre R\xFCcksendeanfrage wurde am {{date}} um {{time}} Uhr gestellt"
  },
  actions: {
    continue: "Weiter"
  },
  "order-identification": {
    title: "Verfolgen Sie Ihre Bestellung",
    description: "Geben Sie Ihre Bestelldetails ein, um Ihr Paket zu verfolgen",
    fields: {
      "zip-code": {
        title: "Postleitzahl",
        description: "Geben Sie Ihre Lieferpostleitzahl ein",
        required: "Die Postleitzahl ist erforderlich"
      },
      email: {
        title: "E-Mail-Adresse",
        description: "Geben Sie die f\xFCr Ihre Bestellung verwendete E-Mail-Adresse ein",
        required: "E-Mail-Adresse ist erforderlich"
      },
      both: {
        title: "Postleitzahl oder E-Mail",
        description: "Geben Sie Ihre Liefer-Postleitzahl oder die f\xFCr Ihre Bestellung verwendete E-Mail ein",
        required: "Postleitzahl oder E-Mail ist erforderlich"
      },
      "tracking-number": {
        title: "Bestellnummer",
        description: "Geben Sie Ihre Bestellnummer ein",
        required: "Die Bestellnummer ist erforderlich"
      }
    },
    errors: {
      "unknown-order": {
        title: "Unbekannte Bestellnummer",
        description: "Die Bestellnummer wurde nicht gefunden, bitte \xFCberpr\xFCfen Sie sie"
      },
      "search-error": {
        title: "Suchfehler",
        description: "Wir konnten die Bestellung nicht finden. Bitte versuchen Sie es sp\xE4ter erneut."
      }
    }
  },
  delivery: "Lieferung",
  "parcel-history": "Paketverlauf",
  "order-details": {
    title: "Bestelldetails",
    "tracking-number": "Sendungsnummer",
    "order-number": "Bestellnummer"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Voraussichtliches Lieferdatum",
      deliveredOn: "Geliefert am",
      from: "vom",
      to: "bis"
    }
  },
  deliveryAddress: {
    title: "Lieferadresse:",
    titlePickup: "Adresse der Abholstelle:",
    orderDetails: {
      title: "Bestelldetails:",
      trackingNumber: "Sendungsnummer:",
      orderNumber: "Bestellnummer:",
      orderDate: "Bestelldatum:"
    }
  },
  pickupPoint: {
    title: "Abholstation",
    openingHours: "\xD6ffnungszeiten:",
    closed: "Geschlossen",
    directions: "Wegbeschreibung",
    days: {
      monday: "Montag:",
      tuesday: "Dienstag:",
      wednesday: "Mittwoch:",
      thursday: "Donnerstag:",
      friday: "Freitag:",
      saturday: "Samstag:",
      sunday: "Sonntag:"
    }
  },
  wallet: {
    warningNotEnabled: "Sie m\xFCssen Wallet in Ihren Shop-Einstellungen aktivieren"
  },
  crossSell: {
    youMightAlsoLike: "Das k\xF6nnte Ihnen auch gefallen"
  },
  "rate-order": {
    "order-recap": {
      title: "Ihre Bestellung",
      "tracking-label": "Sendungsnummer:",
      "order-label": "Bestellnummer:"
    },
    form: {
      title: "Bewerten Sie Ihre Lieferung",
      "rating-label": "Bewerten Sie Ihre Liefererfahrung",
      "comment-label": "Kommentar (optional)",
      "comment-placeholder": "Teilen Sie uns Ihre Erfahrung mit\u2026",
      "submit-cta": "Bewertung absenden",
      "update-cta": "Bewertung aktualisieren",
      "rating-required": "Bitte w\xE4hlen Sie eine Bewertung aus."
    },
    "thank-you": {
      title: "Vielen Dank f\xFCr Ihr Feedback!",
      description: "Ihre Bewertung wurde gespeichert. Sie hilft uns, die Liefererfahrung zu verbessern."
    },
    errors: {
      "invalid-token": {
        title: "Ung\xFCltiger oder abgelaufener Link",
        description: "Dieser Link ist nicht mehr g\xFCltig. Bitte \xF6ffnen Sie ihn erneut aus Ihrer letzten Tracking-E-Mail."
      },
      submit: {
        title: "Etwas ist schiefgelaufen",
        description: "Wir konnten Ihre Bewertung nicht speichern. Bitte versuchen Sie es sp\xE4ter erneut."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen Colissimo-Relaispunkt abgeben.",
    chronoShop2Shop: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen Chronopost-Relaispunkt abgeben.",
    ups: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen UPS-Relaispunkt abgeben.",
    customerCarrier: "Sie k\xF6nnen nun Ihr R\xFCcksendepaket an den Spediteur Ihrer Wahl senden.",
    merchantCarrier: "Wir senden Ihnen ein R\xFCcksendeetikett per E-Mail innerhalb von 1 bis 3 Werktagen.",
    returnToStore: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket im n\xE4chstgelegenen Gesch\xE4ft abgeben.",
    malca: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen Malca-Relaispunkt abgeben.",
    tnt: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen TNT-Relaispunkt abgeben.",
    bonDeRetour: "Ihr R\xFCcksendeschein ist bereit. Sie k\xF6nnen ihn jetzt ausdrucken und f\xFCr Ihre R\xFCcksendung verwenden.",
    unknownCarrier: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket mit dem auf dem Etikett angegebenen Transporteur versenden."
  },
  downloadLabel: {
    label: "Mein Etikett herunterladen",
    bonDeRetour: "Meinen R\xFCcksendeschein herunterladen"
  },
  shippingInstructionsTitle: {
    shippingLabel: "Ihr Versandetikett ist bereit",
    bonDeRetour: "Ihr R\xFCcksendeschein ist bereit"
  }
};

// ../editor-blocks-library/src/translations/en.ts
var en = {
  returnRequestDate: {
    label: "Your return request was made on {{date}} at {{time}}"
  },
  actions: {
    continue: "Continue"
  },
  "order-identification": {
    title: "Track your order",
    description: "Enter your order details to track your package",
    fields: {
      "zip-code": {
        title: "Zip code",
        description: "Enter your delivery zip code",
        required: "Zip code is required"
      },
      email: {
        title: "Email address",
        description: "Enter the email address used for your order",
        required: "Email address is required"
      },
      both: {
        title: "Postal code or email",
        description: "Enter your delivery postal code or the email used for your order",
        required: "Postal code or email is required"
      },
      "tracking-number": {
        title: "Order number",
        description: "Enter your order number",
        required: "Order number is required"
      }
    },
    errors: {
      "unknown-order": {
        title: "Unknown order number",
        description: "The order number was not found, please check it"
      },
      "order-not-shipped": {
        title: "Order in preparation",
        description: "Your order has not been shipped yet"
      },
      "search-error": {
        title: "Search error",
        description: "We could not find the order. Please try again later."
      }
    }
  },
  delivery: "Delivery",
  "parcel-history": "Parcel History",
  "order-details": {
    title: "Order Details",
    "tracking-number": "Tracking Number",
    "order-number": "Order Number"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Estimated Delivery Date",
      deliveredOn: "Delivered on",
      from: "from",
      to: "to"
    }
  },
  deliveryAddress: {
    title: "Delivery address:",
    titlePickup: "Pickup point address:",
    orderDetails: {
      title: "Order details:",
      trackingNumber: "Tracking number:",
      orderNumber: "Order number:",
      orderDate: "Order date:"
    }
  },
  pickupPoint: {
    title: "Pickup Point",
    openingHours: "Opening Hours:",
    closed: "Closed",
    directions: "Directions",
    days: {
      monday: "Monday:",
      tuesday: "Tuesday:",
      wednesday: "Wednesday:",
      thursday: "Thursday:",
      friday: "Friday:",
      saturday: "Saturday:",
      sunday: "Sunday:"
    }
  },
  wallet: {
    warningNotEnabled: "You must enable Wallet in your shop settings"
  },
  crossSell: {
    youMightAlsoLike: "You might also like"
  },
  "rate-order": {
    "order-recap": {
      title: "Your order",
      "tracking-label": "Tracking number:",
      "order-label": "Order number:"
    },
    form: {
      title: "Rate your delivery",
      "rating-label": "Rate your delivery experience",
      "comment-label": "Comment (optional)",
      "comment-placeholder": "Share your experience with us\u2026",
      "submit-cta": "Submit my review",
      "update-cta": "Update my review",
      "rating-required": "Please select a rating."
    },
    "thank-you": {
      title: "Thanks for your feedback!",
      description: "Your review has been saved. It will help us improve the delivery experience."
    },
    errors: {
      "invalid-token": {
        title: "Invalid or expired link",
        description: "This link is no longer valid. Please reopen it from your latest tracking email."
      },
      submit: {
        title: "Something went wrong",
        description: "We couldn't save your review. Please try again later."
      }
    }
  },
  returnLineItems: {
    refund: "Refund(s)",
    exchange: "Exchange(s)",
    newOrder: "New order",
    discount: "Discount(s)"
  },
  returnStoreAddress: {
    mapButton: "View on map"
  },
  shippingInstructions: {
    colissimo: "You can now print your return label and drop off your package at the nearest Colissimo relay point.",
    chronoShop2Shop: "You can now print your return label and drop off your package at the nearest Chronopost relay point.",
    ups: "You can now print your return label and drop off your package at the nearest UPS relay point.",
    customerCarrier: "You can now send your return package to the carrier of your choice.",
    merchantCarrier: "We will send you a return label by email within 1 to 3 business days.",
    returnToStore: "You can now print your return label and drop off your package at the nearest store.",
    malca: "You can now print your return label and drop off your package at the nearest Malca relay point.",
    tnt: "You can now print your return label and drop off your package at the nearest TNT relay point.",
    bonDeRetour: "Your return slip is ready. You can now print it and use it for your return.",
    unknownCarrier: "You can now print your return label and ship your package with the carrier indicated on the label."
  },
  downloadLabel: {
    label: "Download my label",
    bonDeRetour: "Download my return slip"
  },
  shippingInstructionsTitle: {
    shippingLabel: "Your shipping label is ready",
    bonDeRetour: "Your return slip is ready"
  }
};

// ../editor-blocks-library/src/translations/es.ts
var es = {
  returnLineItems: {
    refund: "Reembolso(s)",
    exchange: "Cambio(s)",
    newOrder: "Nuevo pedido",
    discount: "Descuento(s)"
  },
  returnStoreAddress: {
    mapButton: "Ver en el mapa"
  },
  returnRequestDate: {
    label: "Tu solicitud de devoluci\xF3n se realiz\xF3 el {{date}} a las {{time}}"
  },
  actions: {
    continue: "Continuar"
  },
  "order-identification": {
    title: "Sigue tu pedido",
    description: "Introduce los detalles de tu pedido para rastrear tu paquete",
    fields: {
      "zip-code": {
        title: "C\xF3digo postal",
        description: "Introduce tu c\xF3digo postal de entrega",
        required: "El c\xF3digo postal es obligatorio"
      },
      email: {
        title: "Direcci\xF3n de correo electr\xF3nico",
        description: "Ingrese el correo electr\xF3nico utilizado en su pedido",
        required: "La direcci\xF3n de correo electr\xF3nico es obligatoria"
      },
      both: {
        title: "C\xF3digo postal o correo electr\xF3nico",
        description: "Introduzca su c\xF3digo postal de entrega o el correo electr\xF3nico usado en su pedido",
        required: "El c\xF3digo postal o el correo electr\xF3nico es obligatorio"
      },
      "tracking-number": {
        title: "N\xFAmero de pedido",
        description: "Introduce tu n\xFAmero de pedido",
        required: "El n\xFAmero de pedido es obligatorio"
      }
    },
    errors: {
      "unknown-order": {
        title: "N\xFAmero de pedido desconocido",
        description: "No se encontr\xF3 el n\xFAmero de pedido, por favor verif\xEDcalo"
      },
      "search-error": {
        title: "Error de b\xFAsqueda",
        description: "No pudimos encontrar el pedido. Por favor, int\xE9ntalo m\xE1s tarde."
      }
    }
  },
  delivery: "Entrega",
  "parcel-history": "Historial del paquete",
  "order-details": {
    title: "Detalles del pedido",
    "tracking-number": "N\xFAmero de seguimiento",
    "order-number": "N\xFAmero de pedido"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Fecha estimada de entrega",
      deliveredOn: "Entregado el",
      from: "del",
      to: "al"
    }
  },
  deliveryAddress: {
    title: "Direcci\xF3n de entrega:",
    titlePickup: "Direcci\xF3n del punto de recogida:",
    orderDetails: {
      title: "Detalles del pedido:",
      trackingNumber: "N\xFAmero de seguimiento:",
      orderNumber: "N\xFAmero de pedido:",
      orderDate: "Fecha del pedido:"
    }
  },
  pickupPoint: {
    title: "Punto de recogida",
    openingHours: "Horario de apertura:",
    closed: "Cerrado",
    directions: "Direcciones",
    days: {
      monday: "Lunes:",
      tuesday: "Martes:",
      wednesday: "Mi\xE9rcoles:",
      thursday: "Jueves:",
      friday: "Viernes:",
      saturday: "S\xE1bado:",
      sunday: "Domingo:"
    }
  },
  wallet: {
    warningNotEnabled: "Debe activar Wallet en la configuraci\xF3n de su tienda"
  },
  crossSell: {
    youMightAlsoLike: "Tambi\xE9n te puede gustar"
  },
  "rate-order": {
    "order-recap": {
      title: "Tu pedido",
      "tracking-label": "N\xFAmero de seguimiento:",
      "order-label": "N\xFAmero de pedido:"
    },
    form: {
      title: "Califica tu entrega",
      "rating-label": "Califica tu experiencia de entrega",
      "comment-label": "Comentario (opcional)",
      "comment-placeholder": "Comparte tu experiencia con nosotros\u2026",
      "submit-cta": "Enviar mi valoraci\xF3n",
      "update-cta": "Actualizar mi valoraci\xF3n",
      "rating-required": "Por favor, selecciona una valoraci\xF3n."
    },
    "thank-you": {
      title: "\xA1Gracias por tu opini\xF3n!",
      description: "Tu valoraci\xF3n se ha guardado. Nos ayudar\xE1 a mejorar la experiencia de entrega."
    },
    errors: {
      "invalid-token": {
        title: "Enlace no v\xE1lido o caducado",
        description: "Este enlace ya no es v\xE1lido. \xC1brelo de nuevo desde tu \xFAltimo correo de seguimiento."
      },
      submit: {
        title: "Algo ha salido mal",
        description: "No pudimos guardar tu valoraci\xF3n. Por favor, int\xE9ntalo de nuevo m\xE1s tarde."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo Colissimo m\xE1s cercano.",
    chronoShop2Shop: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo Chronopost m\xE1s cercano.",
    ups: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo UPS m\xE1s cercano.",
    customerCarrier: "Ahora puede enviar su paquete de devoluci\xF3n al transportista de su elecci\xF3n.",
    merchantCarrier: "Nosotros le enviaremos una etiqueta de devoluci\xF3n por correo electr\xF3nico en los 1 a 3 d\xEDas h\xE1biles.",
    returnToStore: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en la tienda m\xE1s cercana.",
    malca: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo Malca m\xE1s cercano.",
    tnt: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo TNT m\xE1s cercano.",
    bonDeRetour: "Su albar\xE1n de devoluci\xF3n est\xE1 listo. Ahora puede imprimirlo y usarlo para su devoluci\xF3n.",
    unknownCarrier: "Ya puede imprimir su etiqueta de devoluci\xF3n y enviar su paquete con el transportista indicado en la etiqueta."
  },
  downloadLabel: {
    label: "Descargar mi etiqueta",
    bonDeRetour: "Descargar mi albar\xE1n de devoluci\xF3n"
  },
  shippingInstructionsTitle: {
    shippingLabel: "Su etiqueta de env\xEDo est\xE1 lista",
    bonDeRetour: "Su hoja de devoluci\xF3n est\xE1 lista"
  }
};

// ../editor-blocks-library/src/translations/fi.ts
var fi = {
  returnLineItems: {
    refund: "Hyvitys/hyvitykset",
    exchange: "Vaihto/vaihdot",
    newOrder: "Uusi tilaus",
    discount: "Alennus/alennukset"
  },
  returnStoreAddress: {
    mapButton: "N\xE4yt\xE4 kartalla"
  },
  downloadLabel: {
    label: "Lataa osoitetarrani",
    bonDeRetour: "Lataa palautuslomakkeeni"
  },
  returnRequestDate: {
    label: "Palautuspyynt\xF6si tehtiin {{date}} klo {{time}}"
  },
  actions: {
    continue: "Jatka"
  },
  "order-identification": {
    title: "Seuraa tilaustasi",
    description: "Sy\xF6t\xE4 tilaustietosi seurataksesi pakettiasi",
    fields: {
      "zip-code": {
        title: "Postinumero",
        description: "Sy\xF6t\xE4 toimituspostinumerosi",
        required: "Postinumero on pakollinen"
      },
      email: {
        title: "S\xE4hk\xF6postiosoite",
        description: "Sy\xF6t\xE4 tilauksessasi k\xE4ytt\xE4m\xE4si s\xE4hk\xF6postiosoite",
        required: "S\xE4hk\xF6postiosoite on pakollinen"
      },
      both: {
        title: "Postinumero tai s\xE4hk\xF6posti",
        description: "Anna toimituspostinumerosi tai tilauksessasi k\xE4ytetty s\xE4hk\xF6posti",
        required: "Postinumero tai s\xE4hk\xF6posti vaaditaan"
      },
      "tracking-number": {
        title: "Tilausnumero",
        description: "Sy\xF6t\xE4 tilausnumerosi",
        required: "Tilausnumero on pakollinen"
      }
    },
    errors: {
      "unknown-order": {
        title: "Tuntematon tilausnumero",
        description: "Tilausnumeroa ei l\xF6ytynyt, tarkista se"
      },
      "search-error": {
        title: "Hakuvirhe",
        description: "Tilausta ei l\xF6ytynyt. Yrit\xE4 my\xF6hemmin uudelleen."
      }
    }
  },
  delivery: "Toimitus",
  "parcel-history": "Paketin historia",
  "order-details": {
    title: "Tilauksen tiedot",
    "tracking-number": "Seurantanumero",
    "order-number": "Tilausnumero"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Arvioitu toimitusp\xE4iv\xE4",
      deliveredOn: "Toimitettu",
      from: "alkaen",
      to: "asti"
    }
  },
  deliveryAddress: {
    title: "Toimitusosoite:",
    titlePickup: "Noutopisteen osoite:",
    orderDetails: {
      title: "Tilauksen tiedot:",
      trackingNumber: "Seurantanumero:",
      orderNumber: "Tilausnumero:",
      orderDate: "Tilausp\xE4iv\xE4:"
    }
  },
  pickupPoint: {
    title: "Noutopiste",
    openingHours: "Aukioloajat:",
    closed: "Suljettu",
    directions: "Reittiohjeet",
    days: {
      monday: "Maanantai:",
      tuesday: "Tiistai:",
      wednesday: "Keskiviikko:",
      thursday: "Torstai:",
      friday: "Perjantai:",
      saturday: "Lauantai:",
      sunday: "Sunnuntai:"
    }
  },
  wallet: {
    warningNotEnabled: "Sinun t\xE4ytyy ottaa Wallet k\xE4ytt\xF6\xF6n kaupan asetuksissa"
  },
  crossSell: {
    youMightAlsoLike: "Saatat pit\xE4\xE4 my\xF6s"
  },
  "rate-order": {
    "order-recap": {
      title: "Tilauksesi",
      "tracking-label": "Seurantanumero:",
      "order-label": "Tilausnumero:"
    },
    form: {
      title: "Arvioi toimituksesi",
      "rating-label": "Arvioi toimituskokemuksesi",
      "comment-label": "Kommentti (valinnainen)",
      "comment-placeholder": "Kerro kokemuksestasi meille\u2026",
      "submit-cta": "L\xE4het\xE4 arviointi",
      "update-cta": "P\xE4ivit\xE4 arviointi",
      "rating-required": "Valitse arvosana."
    },
    "thank-you": {
      title: "Kiitos palautteestasi!",
      description: "Arviointisi on tallennettu. Se auttaa meit\xE4 parantamaan toimituskokemusta."
    },
    errors: {
      "invalid-token": {
        title: "Virheellinen tai vanhentunut linkki",
        description: "T\xE4m\xE4 linkki ei ole en\xE4\xE4 voimassa. Avaa se uudelleen viimeisimm\xE4st\xE4 seurantaviestist\xE4si."
      },
      submit: {
        title: "Jotain meni pieleen",
        description: "Emme voineet tallentaa arviointiasi. Yrit\xE4 my\xF6hemmin uudelleen."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Voit nyt tulostaa palautustarrasi ja j\xE4tt\xE4\xE4 pakettisi l\xE4himp\xE4\xE4n Colissimo-l\xE4hipisteeseen.",
    chronoShop2Shop: "Voit nyt tulostaa palautustarrasi ja j\xE4tt\xE4\xE4 pakettisi l\xE4himp\xE4\xE4n Chronopost-l\xE4hipisteeseen.",
    ups: "Voit nyt tulostaa palautustarrasi ja j\xE4tt\xE4\xE4 pakettisi l\xE4himp\xE4\xE4n UPS-l\xE4hipisteeseen.",
    customerCarrier: "Voit nyt l\xE4hett\xE4\xE4 palautuspakettisi valitsemallesi kuljetusyritykselle.",
    merchantCarrier: "L\xE4het\xE4mme sinulle palautustarran s\xE4hk\xF6postitse 1\u20133 arkip\xE4iv\xE4n kuluessa.",
    returnToStore: "Voit nyt j\xE4tt\xE4\xE4 pakettisi l\xE4himp\xE4\xE4n myym\xE4l\xE4\xE4n.",
    malca: "Voit nyt tulostaa palautustarrasi ja j\xE4tt\xE4\xE4 pakettisi l\xE4himp\xE4\xE4n Malca-l\xE4hipisteeseen.",
    tnt: "Voit nyt tulostaa palautustarrasi ja j\xE4tt\xE4\xE4 pakettisi l\xE4himp\xE4\xE4n TNT-l\xE4hipisteeseen.",
    bonDeRetour: "L\xE4hetyslappusi on valmis. Voit nyt tulostaa sen ja k\xE4ytt\xE4\xE4 palautuksessasi.",
    unknownCarrier: "Voit nyt tulostaa palautustarran ja l\xE4hett\xE4\xE4 pakettisi tarrassa mainitulla kuljetusyhti\xF6ll\xE4."
  },
  shippingInstructionsTitle: {
    shippingLabel: "Toimitustarrasi on valmis",
    bonDeRetour: "Palautuslomakkeesi on valmis"
  }
};

// ../editor-blocks-library/src/translations/fr.ts
var fr = {
  returnRequestDate: {
    label: "Votre demande de retour a \xE9t\xE9 faite le {{date}} \xE0 {{time}}"
  },
  actions: {
    continue: "Continuer"
  },
  "order-identification": {
    title: "Suivez votre commande",
    description: "Entrez les d\xE9tails de votre commande pour suivre votre colis",
    fields: {
      "zip-code": {
        title: "Code postal",
        description: "Entrez votre code postal de livraison",
        required: "Le code postal est obligatoire"
      },
      email: {
        title: "Adresse email",
        description: "Entrez l'adresse email utilis\xE9e pour votre commande",
        required: "L'adresse email est obligatoire"
      },
      both: {
        title: "Code postal ou email",
        description: "Entrez votre code postal de livraison ou l'email utilis\xE9 pour votre commande",
        required: "Le code postal ou l'email est obligatoire"
      },
      "tracking-number": {
        title: "Num\xE9ro de commande",
        description: "Entrez votre num\xE9ro de commande",
        required: "Le num\xE9ro de commande est obligatoire"
      }
    },
    errors: {
      "unknown-order": {
        title: "Num\xE9ro de commande inconnu",
        description: "Le num\xE9ro de commande n'a pas \xE9t\xE9 trouv\xE9, veuillez le v\xE9rifier"
      },
      "order-not-shipped": {
        title: "Commande en pr\xE9paration",
        description: "Votre commande n'est pas encore exp\xE9di\xE9e"
      },
      "search-error": {
        title: "Erreur lors de la recherche",
        description: "Nous n'avons pas pu trouver la commande. Veuillez r\xE9essayer plus tard."
      }
    }
  },
  delivery: "Livraison",
  "parcel-history": "Historique du colis",
  "order-details": {
    title: "D\xE9tails de la commande",
    "tracking-number": "Num\xE9ro de suivi",
    "order-number": "Num\xE9ro de commande"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Date de livraison estim\xE9e",
      deliveredOn: "Livr\xE9 le",
      from: "du",
      to: "au"
    }
  },
  deliveryAddress: {
    title: "Adresse de livraison\xA0:",
    titlePickup: "Adresse du point de retrait\xA0:",
    orderDetails: {
      title: "D\xE9tails de la commande\xA0:",
      trackingNumber: "Num\xE9ro de suivi\xA0:",
      orderNumber: "Num\xE9ro de commande\xA0:",
      orderDate: "Date de commande\xA0:"
    }
  },
  pickupPoint: {
    title: "Point relais",
    openingHours: "Horaires d'ouverture\xA0:",
    closed: "Ferm\xE9",
    directions: "Itin\xE9raire",
    days: {
      monday: "Lundi\xA0:",
      tuesday: "Mardi\xA0:",
      wednesday: "Mercredi\xA0:",
      thursday: "Jeudi\xA0:",
      friday: "Vendredi\xA0:",
      saturday: "Samedi\xA0:",
      sunday: "Dimanche\xA0:"
    }
  },
  wallet: {
    warningNotEnabled: "Vous devez activer le Wallet dans les param\xE8tres de votre boutique"
  },
  crossSell: {
    youMightAlsoLike: "Vous aimerez peut-\xEAtre aussi"
  },
  "rate-order": {
    "order-recap": {
      title: "Votre commande",
      "tracking-label": "Num\xE9ro de suivi :",
      "order-label": "Num\xE9ro de commande :"
    },
    form: {
      title: "\xC9valuez votre livraison",
      "rating-label": "Notez votre exp\xE9rience de livraison",
      "comment-label": "Commentaire (facultatif)",
      "comment-placeholder": "Partagez-nous votre exp\xE9rience\u2026",
      "submit-cta": "Envoyer mon \xE9valuation",
      "update-cta": "Mettre \xE0 jour mon \xE9valuation",
      "rating-required": "Veuillez s\xE9lectionner une note."
    },
    "thank-you": {
      title: "Merci pour votre retour !",
      description: "Votre \xE9valuation a bien \xE9t\xE9 prise en compte. Elle nous aidera \xE0 am\xE9liorer l'exp\xE9rience de livraison."
    },
    errors: {
      "invalid-token": {
        title: "Lien invalide ou expir\xE9",
        description: "Ce lien n'est plus valide. Ouvrez-le depuis votre dernier email de suivi."
      },
      submit: {
        title: "Une erreur est survenue",
        description: "Nous n'avons pas pu enregistrer votre \xE9valuation. Veuillez r\xE9essayer plus tard."
      }
    }
  },
  returnLineItems: {
    refund: "Remboursement(s)",
    exchange: "\xC9change(s)",
    newOrder: "Nouvelle commande",
    discount: "Remise(s)"
  },
  returnStoreAddress: {
    mapButton: "Voir sur la carte"
  },
  shippingInstructions: {
    colissimo: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais Colissimo le plus proche.",
    chronoShop2Shop: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais Chronopost le plus proche.",
    ups: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais UPS le plus proche.",
    customerCarrier: "Vous pouvez \xE0 pr\xE9sent envoyer votre colis de retour au transporteur de votre choix.",
    merchantCarrier: "Nous vous enverrons une \xE9tiquette de retour par email dans les 1 \xE0 3 jours ouvr\xE9s.",
    returnToStore: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le magasin le plus proche.",
    malca: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais Malca le plus proche.",
    tnt: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais TNT le plus proche.",
    bonDeRetour: "Votre bon de retour est pr\xEAt. Vous pouvez d\xE8s \xE0 pr\xE9sent l'imprimer et l'utiliser pour votre retour.",
    unknownCarrier: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et exp\xE9dier votre colis avec le transporteur indiqu\xE9 sur l'\xE9tiquette."
  },
  downloadLabel: {
    label: "T\xE9l\xE9charger mon \xE9tiquette",
    bonDeRetour: "T\xE9l\xE9charger mon bon de retour"
  },
  shippingInstructionsTitle: {
    shippingLabel: "Votre \xE9tiquette d'exp\xE9dition est pr\xEAte",
    bonDeRetour: "Votre bon de retour est pr\xEAt"
  }
};

// ../editor-blocks-library/src/translations/hu.ts
var hu = {
  returnLineItems: {
    refund: "Visszat\xE9r\xEDt\xE9s(ek)",
    exchange: "Csere/cser\xE9k",
    newOrder: "\xDAj rendel\xE9s",
    discount: "Kedvezm\xE9ny(ek)"
  },
  returnStoreAddress: {
    mapButton: "Megtekint\xE9s a t\xE9rk\xE9pen"
  },
  downloadLabel: {
    label: "C\xEDmke let\xF6lt\xE9se",
    bonDeRetour: "Visszak\xFCld\xE9si bizonylat let\xF6lt\xE9se"
  },
  returnRequestDate: {
    label: "A visszak\xFCld\xE9si k\xE9relm\xE9t {{date}} {{time}} id\u0151pontban adta le"
  },
  actions: {
    continue: "Folytat\xE1s"
  },
  "order-identification": {
    title: "K\xF6vesse nyomon rendel\xE9s\xE9t",
    description: "Adja meg a rendel\xE9si adatokat a csomag k\xF6vet\xE9s\xE9hez",
    fields: {
      "zip-code": {
        title: "Ir\xE1ny\xEDt\xF3sz\xE1m",
        description: "Adja meg a sz\xE1ll\xEDt\xE1si ir\xE1ny\xEDt\xF3sz\xE1mot",
        required: "Az ir\xE1ny\xEDt\xF3sz\xE1m megad\xE1sa k\xF6telez\u0151"
      },
      email: {
        title: "E-mail c\xEDm",
        description: "Adja meg a rendel\xE9shez haszn\xE1lt e-mail c\xEDm\xE9t",
        required: "Az e-mail c\xEDm megad\xE1sa k\xF6telez\u0151"
      },
      both: {
        title: "Ir\xE1ny\xEDt\xF3sz\xE1m vagy e-mail",
        description: "Adja meg a sz\xE1ll\xEDt\xE1si ir\xE1ny\xEDt\xF3sz\xE1m\xE1t vagy a rendel\xE9s\xE9hez haszn\xE1lt e-mailt",
        required: "Az ir\xE1ny\xEDt\xF3sz\xE1m vagy az e-mail megad\xE1sa k\xF6telez\u0151"
      },
      "tracking-number": {
        title: "Rendel\xE9ssz\xE1m",
        description: "Adja meg a rendel\xE9ssz\xE1m\xE1t",
        required: "A rendel\xE9ssz\xE1m megad\xE1sa k\xF6telez\u0151"
      }
    },
    errors: {
      "unknown-order": {
        title: "Ismeretlen rendel\xE9ssz\xE1m",
        description: "A rendel\xE9ssz\xE1m nem tal\xE1lhat\xF3, k\xE9rj\xFCk ellen\u0151rizze"
      },
      "search-error": {
        title: "Keres\xE9si hiba",
        description: "Nem siker\xFClt megtal\xE1lni a rendel\xE9st. K\xE9rj\xFCk, pr\xF3b\xE1lja k\xE9s\u0151bb."
      }
    }
  },
  delivery: "Sz\xE1ll\xEDt\xE1s",
  "parcel-history": "Csomag el\u0151zm\xE9nyek",
  "order-details": {
    title: "Rendel\xE9s r\xE9szletei",
    "tracking-number": "Nyomk\xF6vet\xE9si sz\xE1m",
    "order-number": "Rendel\xE9ssz\xE1m"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Becs\xFClt k\xE9zbes\xEDt\xE9si d\xE1tum",
      deliveredOn: "K\xE9zbes\xEDtve",
      from: "t\xF3l",
      to: "ig"
    }
  },
  deliveryAddress: {
    title: "Sz\xE1ll\xEDt\xE1si c\xEDm:",
    titlePickup: "\xC1tv\xE9teli pont c\xEDme:",
    orderDetails: {
      title: "Rendel\xE9s r\xE9szletei:",
      trackingNumber: "K\xF6vet\xE9si sz\xE1m:",
      orderNumber: "Rendel\xE9ssz\xE1m:",
      orderDate: "Rendel\xE9s d\xE1tuma:"
    }
  },
  pickupPoint: {
    title: "\xC1tv\xE9teli pont",
    openingHours: "Nyitvatart\xE1s:",
    closed: "Z\xE1rva",
    directions: "\xDAtvonal",
    days: {
      monday: "H\xE9tf\u0151:",
      tuesday: "Kedd:",
      wednesday: "Szerda:",
      thursday: "Cs\xFCt\xF6rt\xF6k:",
      friday: "P\xE9ntek:",
      saturday: "Szombat:",
      sunday: "Vas\xE1rnap:"
    }
  },
  wallet: {
    warningNotEnabled: "Enged\xE9lyeznie kell a Wallet-et a bolt be\xE1ll\xEDt\xE1saiban"
  },
  crossSell: {
    youMightAlsoLike: "Ezek is tetszhetnek"
  },
  "rate-order": {
    "order-recap": {
      title: "Az \xD6n rendel\xE9se",
      "tracking-label": "K\xF6vet\xE9si sz\xE1m:",
      "order-label": "Rendel\xE9ssz\xE1m:"
    },
    form: {
      title: "\xC9rt\xE9kelje a k\xE9zbes\xEDt\xE9st",
      "rating-label": "\xC9rt\xE9kelje a k\xE9zbes\xEDt\xE9si \xE9lm\xE9nyt",
      "comment-label": "Megjegyz\xE9s (nem k\xF6telez\u0151)",
      "comment-placeholder": "Ossza meg vel\xFCnk a tapasztalat\xE1t\u2026",
      "submit-cta": "\xC9rt\xE9kel\xE9s elk\xFCld\xE9se",
      "update-cta": "\xC9rt\xE9kel\xE9s friss\xEDt\xE9se",
      "rating-required": "K\xE9rj\xFCk, v\xE1lasszon egy \xE9rt\xE9kel\xE9st."
    },
    "thank-you": {
      title: "K\xF6sz\xF6nj\xFCk a visszajelz\xE9st!",
      description: "\xC9rt\xE9kel\xE9s\xE9t elmentett\xFCk. Seg\xEDteni fog a k\xE9zbes\xEDt\xE9si \xE9lm\xE9ny jav\xEDt\xE1s\xE1ban."
    },
    errors: {
      "invalid-token": {
        title: "\xC9rv\xE9nytelen vagy lej\xE1rt link",
        description: "Ez a link m\xE1r nem \xE9rv\xE9nyes. K\xE9rj\xFCk, nyissa meg \xFAjra a legut\xF3bbi k\xF6vet\xE9si e-mailj\xE9b\u0151l."
      },
      submit: {
        title: "Valami hiba t\xF6rt\xE9nt",
        description: "Nem tudtuk elmenteni az \xE9rt\xE9kel\xE9s\xE9t. K\xE9rj\xFCk, pr\xF3b\xE1lja k\xE9s\u0151bb \xFAjra."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Most kinyomtathatod a visszak\xFCld\xE9si c\xEDmk\xE9t, \xE9s leadhatod a csomagot a legk\xF6zelebbi Colissimo \xE1tvev\u0151ponton.",
    chronoShop2Shop: "Most kinyomtathatod a visszak\xFCld\xE9si c\xEDmk\xE9t, \xE9s leadhatod a csomagot a legk\xF6zelebbi Chronopost \xE1tvev\u0151ponton.",
    ups: "Most kinyomtathatod a visszak\xFCld\xE9si c\xEDmk\xE9t, \xE9s leadhatod a csomagot a legk\xF6zelebbi UPS \xE1tvev\u0151ponton.",
    customerCarrier: "Most elk\xFCldheted a visszak\xFCldend\u0151 csomagot az \xE1ltalad v\xE1lasztott fut\xE1rszolg\xE1lattal.",
    merchantCarrier: "1\u20133 munkanapon bel\xFCl e-mailben elk\xFCldj\xFCk a visszak\xFCld\xE9si c\xEDmk\xE9t.",
    returnToStore: "Most leadhatod a csomagot a legk\xF6zelebbi \xFCzletben.",
    malca: "Most kinyomtathatod a visszak\xFCld\xE9si c\xEDmk\xE9t, \xE9s leadhatod a csomagot a legk\xF6zelebbi Malca \xE1tvev\u0151ponton.",
    tnt: "Most kinyomtathatod a visszak\xFCld\xE9si c\xEDmk\xE9t, \xE9s leadhatod a csomagot a legk\xF6zelebbi TNT \xE1tvev\u0151ponton.",
    bonDeRetour: "A visszak\xFCld\xE9si bizonylatod elk\xE9sz\xFClt. Most kinyomtathatod \xE9s felhaszn\xE1lhatod a visszak\xFCld\xE9shez.",
    unknownCarrier: "Most m\xE1r kinyomtathatja a visszak\xFCld\xE9si c\xEDmk\xE9t, \xE9s feladhatja csomagj\xE1t a c\xEDmk\xE9n felt\xFCntetett fuvaroz\xF3val."
  },
  shippingInstructionsTitle: {
    shippingLabel: "A sz\xE1ll\xEDt\xE1si c\xEDmk\xE9d elk\xE9sz\xFClt",
    bonDeRetour: "A visszak\xFCld\xE9si bizonylatod elk\xE9sz\xFClt"
  }
};

// ../editor-blocks-library/src/translations/it.ts
var it = {
  returnLineItems: {
    refund: "Rimborso/i",
    exchange: "Cambio/i",
    newOrder: "Nuovo ordine",
    discount: "Sconto/i"
  },
  returnStoreAddress: {
    mapButton: "Vedi sulla mappa"
  },
  returnRequestDate: {
    label: "La tua richiesta di reso \xE8 stata effettuata il {{date}} alle {{time}}"
  },
  actions: {
    continue: "Continua"
  },
  "order-identification": {
    title: "Traccia il tuo ordine",
    description: "Inserisci i dettagli del tuo ordine per tracciare il tuo pacco",
    fields: {
      "zip-code": {
        title: "Codice postale",
        description: "Inserisci il tuo codice postale di consegna",
        required: "Il codice postale \xE8 obbligatorio"
      },
      email: {
        title: "Indirizzo email",
        description: "Inserisci l'indirizzo email utilizzato per il tuo ordine",
        required: "L'indirizzo email \xE8 obbligatorio"
      },
      both: {
        title: "Codice postale o email",
        description: "Inserisci il tuo codice postale di consegna o l'email utilizzata per il tuo ordine",
        required: "Il codice postale o l'email \xE8 obbligatorio"
      },
      "tracking-number": {
        title: "Numero d'ordine",
        description: "Inserisci il tuo numero d'ordine",
        required: "Il numero d'ordine \xE8 obbligatorio"
      }
    },
    errors: {
      "unknown-order": {
        title: "Numero d'ordine sconosciuto",
        description: "Il numero d'ordine non \xE8 stato trovato, si prega di verificarlo"
      },
      "search-error": {
        title: "Errore di ricerca",
        description: "Non siamo riusciti a trovare l'ordine. Riprova pi\xF9 tardi."
      }
    }
  },
  delivery: "Consegna",
  "parcel-history": "Cronologia del pacco",
  "order-details": {
    title: "Dettagli dell'ordine",
    "tracking-number": "Numero di tracciamento",
    "order-number": "Numero d'ordine"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Data di consegna stimata",
      deliveredOn: "Consegnato il",
      from: "dal",
      to: "al"
    }
  },
  deliveryAddress: {
    title: "Indirizzo di consegna:",
    titlePickup: "Indirizzo del punto di ritiro:",
    orderDetails: {
      title: "Dettagli dell'ordine:",
      trackingNumber: "Numero di tracciamento:",
      orderNumber: "Numero d'ordine:",
      orderDate: "Data dell'ordine:"
    }
  },
  pickupPoint: {
    title: "Punto di ritiro",
    openingHours: "Orari di apertura:",
    closed: "Chiuso",
    directions: "Indicazioni",
    days: {
      monday: "Luned\xEC:",
      tuesday: "Marted\xEC:",
      wednesday: "Mercoled\xEC:",
      thursday: "Gioved\xEC:",
      friday: "Venerd\xEC:",
      saturday: "Sabato:",
      sunday: "Domenica:"
    }
  },
  wallet: {
    warningNotEnabled: "\xC8 necessario abilitare Wallet nelle impostazioni del negozio"
  },
  crossSell: {
    youMightAlsoLike: "Potrebbe piacerti anche"
  },
  "rate-order": {
    "order-recap": {
      title: "Il tuo ordine",
      "tracking-label": "Numero di tracciamento:",
      "order-label": "Numero d'ordine:"
    },
    form: {
      title: "Valuta la tua consegna",
      "rating-label": "Valuta la tua esperienza di consegna",
      "comment-label": "Commento (facoltativo)",
      "comment-placeholder": "Condividi la tua esperienza con noi\u2026",
      "submit-cta": "Invia la mia valutazione",
      "update-cta": "Aggiorna la mia valutazione",
      "rating-required": "Seleziona una valutazione."
    },
    "thank-you": {
      title: "Grazie per il tuo feedback!",
      description: "La tua valutazione \xE8 stata salvata. Ci aiuter\xE0 a migliorare l'esperienza di consegna."
    },
    errors: {
      "invalid-token": {
        title: "Link non valido o scaduto",
        description: "Questo link non \xE8 pi\xF9 valido. Riaprilo dalla tua ultima email di tracciamento."
      },
      submit: {
        title: "Qualcosa \xE8 andato storto",
        description: "Non siamo riusciti a salvare la tua valutazione. Riprova pi\xF9 tardi."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Colissimo pi\xF9 vicino.",
    chronoShop2Shop: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Chronopost pi\xF9 vicino.",
    ups: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto UPS pi\xF9 vicino.",
    customerCarrier: "Puoi ora spedire il tuo pacco di reso con il corriere di tua scelta.",
    merchantCarrier: "Ti invieremo un'etichetta di reso via email entro 1\u20133 giorni lavorativi.",
    returnToStore: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel negozio pi\xF9 vicino.",
    malca: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Malca pi\xF9 vicino.",
    tnt: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto TNT pi\xF9 vicino.",
    bonDeRetour: "Il tuo modulo di reso \xE8 pronto. Puoi stamparlo ora e usarlo per il tuo reso.",
    unknownCarrier: "Ora puoi stampare la tua etichetta di reso e spedire il pacco con il corriere indicato sull'etichetta."
  },
  downloadLabel: {
    label: "Scarica la mia etichetta",
    bonDeRetour: "Scarica il mio modulo di reso"
  },
  shippingInstructionsTitle: {
    shippingLabel: "La tua etichetta di spedizione \xE8 pronta",
    bonDeRetour: "Il tuo modulo di reso \xE8 pronto"
  }
};

// ../editor-blocks-library/src/translations/nl.ts
var nl = {
  returnLineItems: {
    refund: "Terugbetaling(en)",
    exchange: "Ruil(en)",
    newOrder: "Nieuwe bestelling",
    discount: "Korting(en)"
  },
  returnStoreAddress: {
    mapButton: "Bekijk op kaart"
  },
  downloadLabel: {
    label: "Mijn label downloaden",
    bonDeRetour: "Mijn retourformulier downloaden"
  },
  returnRequestDate: {
    label: "Je retouraanvraag is gedaan op {{date}} om {{time}}"
  },
  actions: {
    continue: "Doorgaan"
  },
  "order-identification": {
    title: "Volg uw bestelling",
    description: "Voer uw bestelgegevens in om uw pakket te volgen",
    fields: {
      "zip-code": {
        title: "Postcode",
        description: "Voer uw bezorgpostcode in",
        required: "Postcode is verplicht"
      },
      email: {
        title: "E-mailadres",
        description: "Voer het e-mailadres in dat u voor uw bestelling heeft gebruikt",
        required: "E-mailadres is vereist"
      },
      both: {
        title: "Postcode of e-mail",
        description: "Voer uw bezorgpostcode in of het e-mailadres dat u voor uw bestelling heeft gebruikt",
        required: "Postcode of e-mail is vereist"
      },
      "tracking-number": {
        title: "Bestelnummer",
        description: "Voer uw bestelnummer in",
        required: "Bestelnummer is verplicht"
      }
    },
    errors: {
      "unknown-order": {
        title: "Onbekend bestelnummer",
        description: "Het bestelnummer is niet gevonden, controleer het"
      },
      "search-error": {
        title: "Zoekfout",
        description: "We konden de bestelling niet vinden. Probeer het later opnieuw."
      }
    }
  },
  delivery: "Levering",
  "parcel-history": "Pakketgeschiedenis",
  "order-details": {
    title: "Bestelgegevens",
    "tracking-number": "Trackingnummer",
    "order-number": "Bestelnummer"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Geschatte leverdatum",
      deliveredOn: "Afgeleverd op",
      from: "van",
      to: "tot"
    }
  },
  deliveryAddress: {
    title: "Bezorgadres:",
    titlePickup: "Adres van afhaalpunt:",
    orderDetails: {
      title: "Bestelgegevens:",
      trackingNumber: "Trackingnummer:",
      orderNumber: "Bestelnummer:",
      orderDate: "Besteldatum:"
    }
  },
  pickupPoint: {
    title: "Afhaalpunt",
    openingHours: "Openingstijden:",
    closed: "Gesloten",
    directions: "Routebeschrijving",
    days: {
      monday: "Maandag:",
      tuesday: "Dinsdag:",
      wednesday: "Woensdag:",
      thursday: "Donderdag:",
      friday: "Vrijdag:",
      saturday: "Zaterdag:",
      sunday: "Zondag:"
    }
  },
  wallet: {
    warningNotEnabled: "U moet Wallet inschakelen in uw winkelinstellingen"
  },
  crossSell: {
    youMightAlsoLike: "Misschien vind je dit ook leuk"
  },
  "rate-order": {
    "order-recap": {
      title: "Jouw bestelling",
      "tracking-label": "Trackingnummer:",
      "order-label": "Bestelnummer:"
    },
    form: {
      title: "Beoordeel je bezorging",
      "rating-label": "Beoordeel je bezorgervaring",
      "comment-label": "Opmerking (optioneel)",
      "comment-placeholder": "Deel je ervaring met ons\u2026",
      "submit-cta": "Mijn beoordeling verzenden",
      "update-cta": "Mijn beoordeling bijwerken",
      "rating-required": "Selecteer een beoordeling."
    },
    "thank-you": {
      title: "Bedankt voor je feedback!",
      description: "Je beoordeling is opgeslagen. Het helpt ons de bezorgervaring te verbeteren."
    },
    errors: {
      "invalid-token": {
        title: "Ongeldige of verlopen link",
        description: "Deze link is niet meer geldig. Open hem opnieuw vanuit je laatste trackingmail."
      },
      submit: {
        title: "Er is iets misgegaan",
        description: "We konden je beoordeling niet opslaan. Probeer het later opnieuw."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde Colissimo-afhaalpunt.",
    chronoShop2Shop: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde Chronopost-afhaalpunt.",
    ups: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde UPS-afhaalpunt.",
    customerCarrier: "Je kunt je retourpakket nu versturen met de vervoerder van je keuze.",
    merchantCarrier: "We sturen je binnen 1 tot 3 werkdagen een retourlabel per e-mail.",
    returnToStore: "Je kunt je pakket nu afgeven in de dichtstbijzijnde winkel.",
    malca: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde Malca-afhaalpunt.",
    tnt: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde TNT-afhaalpunt.",
    bonDeRetour: "Je retourbon is klaar. Je kunt deze nu afdrukken en gebruiken voor je retour.",
    unknownCarrier: "U kunt nu uw retourlabel afdrukken en uw pakket verzenden met de vervoerder die op het label staat vermeld."
  },
  shippingInstructionsTitle: {
    shippingLabel: "Je verzendlabel is klaar",
    bonDeRetour: "Je retourbon is klaar"
  }
};

// ../editor-blocks-library/src/translations/no.ts
var no = {
  returnLineItems: {
    refund: "Refusjon(er)",
    exchange: "Bytte(r)",
    newOrder: "Ny ordre",
    discount: "Rabatt(er)"
  },
  returnStoreAddress: {
    mapButton: "Vis p\xE5 kart"
  },
  downloadLabel: {
    label: "Last ned etiketten min",
    bonDeRetour: "Last ned returseddelen min"
  },
  returnRequestDate: {
    label: "Returforesp\xF8rselen din ble opprettet {{date}} kl. {{time}}"
  },
  actions: {
    continue: "Fortsett"
  },
  "order-identification": {
    title: "Spor bestillingen din",
    description: "Skriv inn bestillingsdetaljene for \xE5 spore pakken din",
    fields: {
      "zip-code": {
        title: "Postnummer",
        description: "Skriv inn leveringspostnummeret ditt",
        required: "Postnummer er p\xE5krevd"
      },
      email: {
        title: "E-postadresse",
        description: "Skriv inn e-postadressen du brukte til bestillingen",
        required: "E-postadresse er p\xE5krevd"
      },
      both: {
        title: "Postnummer eller e-post",
        description: "Skriv inn leveringspostnummeret ditt eller e-posten som ble brukt til bestillingen",
        required: "Postnummer eller e-post er p\xE5krevd"
      },
      "tracking-number": {
        title: "Ordrenummer",
        description: "Skriv inn ordrenummeret ditt",
        required: "Ordrenummer er p\xE5krevd"
      }
    },
    errors: {
      "unknown-order": {
        title: "Ukjent ordrenummer",
        description: "Ordrenummeret ble ikke funnet, vennligst sjekk det"
      },
      "search-error": {
        title: "S\xF8kefeil",
        description: "Vi kunne ikke finne bestillingen. Vennligst pr\xF8v igjen senere."
      }
    }
  },
  delivery: "Levering",
  "parcel-history": "Pakkehistorikk",
  "order-details": {
    title: "Ordredetaljer",
    "tracking-number": "Sporingsnummer",
    "order-number": "Ordrenummer"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Forventet leveringsdato",
      deliveredOn: "Levert den",
      from: "fra",
      to: "til"
    }
  },
  deliveryAddress: {
    title: "Leveringsadresse:",
    titlePickup: "Adresse til hentested:",
    orderDetails: {
      title: "Ordredetaljer:",
      trackingNumber: "Sporingsnummer:",
      orderNumber: "Ordrenummer:",
      orderDate: "Ordredato:"
    }
  },
  pickupPoint: {
    title: "Hentested",
    openingHours: "\xC5pningstider:",
    closed: "Stengt",
    directions: "Veibeskrivelse",
    days: {
      monday: "Mandag:",
      tuesday: "Tirsdag:",
      wednesday: "Onsdag:",
      thursday: "Torsdag:",
      friday: "Fredag:",
      saturday: "L\xF8rdag:",
      sunday: "S\xF8ndag:"
    }
  },
  wallet: {
    warningNotEnabled: "Du m\xE5 aktivere Wallet i butikkinnstillingene dine"
  },
  crossSell: {
    youMightAlsoLike: "Du vil kanskje ogs\xE5 like"
  },
  "rate-order": {
    "order-recap": {
      title: "Din bestilling",
      "tracking-label": "Sporingsnummer:",
      "order-label": "Ordrenummer:"
    },
    form: {
      title: "Vurder leveringen din",
      "rating-label": "Vurder leveringsopplevelsen din",
      "comment-label": "Kommentar (valgfritt)",
      "comment-placeholder": "Del opplevelsen din med oss\u2026",
      "submit-cta": "Send inn vurderingen min",
      "update-cta": "Oppdater vurderingen min",
      "rating-required": "Vennligst velg en vurdering."
    },
    "thank-you": {
      title: "Takk for tilbakemeldingen!",
      description: "Vurderingen din er lagret. Den vil hjelpe oss med \xE5 forbedre leveringsopplevelsen."
    },
    errors: {
      "invalid-token": {
        title: "Ugyldig eller utl\xF8pt lenke",
        description: "Denne lenken er ikke lenger gyldig. \xC5pne den p\xE5 nytt fra din siste sporings-e-post."
      },
      submit: {
        title: "Noe gikk galt",
        description: "Vi kunne ikke lagre vurderingen din. Vennligst pr\xF8v igjen senere."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Du kan n\xE5 skrive ut returetiketten din og levere pakken p\xE5 n\xE6rmeste Colissimo-innleveringssted.",
    chronoShop2Shop: "Du kan n\xE5 skrive ut returetiketten din og levere pakken p\xE5 n\xE6rmeste Chronopost-innleveringssted.",
    ups: "Du kan n\xE5 skrive ut returetiketten din og levere pakken p\xE5 n\xE6rmeste UPS-innleveringssted.",
    customerCarrier: "Du kan n\xE5 sende returpakken til transport\xF8ren du \xF8nsker.",
    merchantCarrier: "Vi sender deg en returetikett p\xE5 e-post innen 1 til 3 virkedager.",
    returnToStore: "Du kan n\xE5 levere pakken i n\xE6rmeste butikk.",
    malca: "Du kan n\xE5 skrive ut returetiketten din og levere pakken p\xE5 n\xE6rmeste Malca-innleveringssted.",
    tnt: "Du kan n\xE5 skrive ut returetiketten din og levere pakken p\xE5 n\xE6rmeste TNT-innleveringssted.",
    bonDeRetour: "Fraktetiketten din er klar. Du kan n\xE5 skrive den ut og bruke den til returen.",
    unknownCarrier: "Du kan n\xE5 skrive ut returetiketten din og sende pakken med transport\xF8ren som er angitt p\xE5 etiketten."
  },
  shippingInstructionsTitle: {
    shippingLabel: "Fraktetiketten din er klar",
    bonDeRetour: "Returseddelen din er klar"
  }
};

// ../editor-blocks-library/src/translations/pl.ts
var pl = {
  returnLineItems: {
    refund: "Zwrot(y)",
    exchange: "Wymiana/wymiany",
    newOrder: "Nowe zam\xF3wienie",
    discount: "Rabat(y)"
  },
  returnStoreAddress: {
    mapButton: "Zobacz na mapie"
  },
  downloadLabel: {
    label: "Pobierz etykiet\u0119",
    bonDeRetour: "Pobierz formularz zwrotu"
  },
  returnRequestDate: {
    label: "Twoje zg\u0142oszenie zwrotu zosta\u0142o z\u0142o\u017Cone {{date}} o {{time}}"
  },
  actions: {
    continue: "Kontynuuj"
  },
  "order-identification": {
    title: "\u015Aled\u017A swoje zam\xF3wienie",
    description: "Wprowad\u017A dane zam\xF3wienia, aby \u015Bledzi\u0107 paczk\u0119",
    fields: {
      "zip-code": {
        title: "Kod pocztowy",
        description: "Wprowad\u017A kod pocztowy dostawy",
        required: "Kod pocztowy jest wymagany"
      },
      email: {
        title: "Adres e-mail",
        description: "Wprowad\u017A adres e-mail u\u017Cyty podczas sk\u0142adania zam\xF3wienia",
        required: "Adres e-mail jest wymagany"
      },
      both: {
        title: "Kod pocztowy lub e-mail",
        description: "Wprowad\u017A sw\xF3j kod pocztowy dostawy lub adres e-mail u\u017Cyty do zam\xF3wienia",
        required: "Kod pocztowy lub e-mail jest wymagany"
      },
      "tracking-number": {
        title: "Numer zam\xF3wienia",
        description: "Wprowad\u017A numer zam\xF3wienia",
        required: "Numer zam\xF3wienia jest wymagany"
      }
    },
    errors: {
      "unknown-order": {
        title: "Nieznany numer zam\xF3wienia",
        description: "Nie znaleziono numeru zam\xF3wienia, sprawd\u017A go"
      },
      "search-error": {
        title: "B\u0142\u0105d wyszukiwania",
        description: "Nie uda\u0142o si\u0119 znale\u017A\u0107 zam\xF3wienia. Spr\xF3buj ponownie p\xF3\u017Aniej."
      }
    }
  },
  delivery: "Dostawa",
  "parcel-history": "Historia paczki",
  "order-details": {
    title: "Szczeg\xF3\u0142y zam\xF3wienia",
    "tracking-number": "Numer \u015Bledzenia",
    "order-number": "Numer zam\xF3wienia"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Szacowana data dostawy",
      deliveredOn: "Dostarczono",
      from: "od",
      to: "do"
    }
  },
  deliveryAddress: {
    title: "Adres dostawy:",
    titlePickup: "Adres punktu odbioru:",
    orderDetails: {
      title: "Szczeg\xF3\u0142y zam\xF3wienia:",
      trackingNumber: "Numer \u015Bledzenia:",
      orderNumber: "Numer zam\xF3wienia:",
      orderDate: "Data zam\xF3wienia:"
    }
  },
  pickupPoint: {
    title: "Punkt odbioru",
    openingHours: "Godziny otwarcia:",
    closed: "Zamkni\u0119te",
    directions: "Wskaz\xF3wki dojazdu",
    days: {
      monday: "Poniedzia\u0142ek:",
      tuesday: "Wtorek:",
      wednesday: "\u015Aroda:",
      thursday: "Czwartek:",
      friday: "Pi\u0105tek:",
      saturday: "Sobota:",
      sunday: "Niedziela:"
    }
  },
  wallet: {
    warningNotEnabled: "Musisz w\u0142\u0105czy\u0107 Wallet w ustawieniach sklepu"
  },
  crossSell: {
    youMightAlsoLike: "Mo\u017Ce ci si\u0119 te\u017C spodoba\u0107"
  },
  "rate-order": {
    "order-recap": {
      title: "Twoje zam\xF3wienie",
      "tracking-label": "Numer \u015Bledzenia:",
      "order-label": "Numer zam\xF3wienia:"
    },
    form: {
      title: "Oce\u0144 swoj\u0105 dostaw\u0119",
      "rating-label": "Oce\u0144 swoje do\u015Bwiadczenie z dostaw\u0105",
      "comment-label": "Komentarz (opcjonalnie)",
      "comment-placeholder": "Podziel si\u0119 z nami swoim do\u015Bwiadczeniem\u2026",
      "submit-cta": "Wy\u015Blij moj\u0105 ocen\u0119",
      "update-cta": "Zaktualizuj moj\u0105 ocen\u0119",
      "rating-required": "Prosz\u0119 wybra\u0107 ocen\u0119."
    },
    "thank-you": {
      title: "Dzi\u0119kujemy za opini\u0119!",
      description: "Twoja ocena zosta\u0142a zapisana. Pomo\u017Ce nam poprawi\u0107 do\u015Bwiadczenie z dostaw\u0105."
    },
    errors: {
      "invalid-token": {
        title: "Nieprawid\u0142owy lub wygas\u0142y link",
        description: "Ten link nie jest ju\u017C wa\u017Cny. Otw\xF3rz go ponownie z najnowszej wiadomo\u015Bci e-mail ze \u015Bledzeniem."
      },
      submit: {
        title: "Co\u015B posz\u0142o nie tak",
        description: "Nie uda\u0142o nam si\u0119 zapisa\u0107 Twojej oceny. Spr\xF3buj ponownie p\xF3\u017Aniej."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Mo\u017Cesz teraz wydrukowa\u0107 etykiet\u0119 zwrotn\u0105 i nada\u0107 paczk\u0119 w najbli\u017Cszym punkcie odbioru Colissimo.",
    chronoShop2Shop: "Mo\u017Cesz teraz wydrukowa\u0107 etykiet\u0119 zwrotn\u0105 i nada\u0107 paczk\u0119 w najbli\u017Cszym punkcie odbioru Chronopost.",
    ups: "Mo\u017Cesz teraz wydrukowa\u0107 etykiet\u0119 zwrotn\u0105 i nada\u0107 paczk\u0119 w najbli\u017Cszym punkcie odbioru UPS.",
    customerCarrier: "Mo\u017Cesz teraz nada\u0107 paczk\u0119 zwrotn\u0105 wybranemu przewo\u017Anikowi.",
    merchantCarrier: "Wy\u015Blemy Ci etykiet\u0119 zwrotn\u0105 e-mailem w ci\u0105gu 1 do 3 dni roboczych.",
    returnToStore: "Mo\u017Cesz teraz nada\u0107 paczk\u0119 w najbli\u017Cszym sklepie.",
    malca: "Mo\u017Cesz teraz wydrukowa\u0107 etykiet\u0119 zwrotn\u0105 i nada\u0107 paczk\u0119 w najbli\u017Cszym punkcie odbioru Malca.",
    tnt: "Mo\u017Cesz teraz wydrukowa\u0107 etykiet\u0119 zwrotn\u0105 i nada\u0107 paczk\u0119 w najbli\u017Cszym punkcie odbioru TNT.",
    bonDeRetour: "Twoja etykieta wysy\u0142kowa jest gotowa. Mo\u017Cesz j\u0105 teraz wydrukowa\u0107 i u\u017Cy\u0107 do zwrotu.",
    unknownCarrier: "Mo\u017Cesz teraz wydrukowa\u0107 etykiet\u0119 zwrotn\u0105 i nada\u0107 paczk\u0119 u przewo\u017Anika wskazanego na etykiecie."
  },
  shippingInstructionsTitle: {
    shippingLabel: "Twoja etykieta wysy\u0142kowa jest gotowa",
    bonDeRetour: "Tw\xF3j formularz zwrotu jest gotowy"
  }
};

// ../editor-blocks-library/src/translations/pt.ts
var pt = {
  returnLineItems: {
    refund: "Reembolso(s)",
    exchange: "Troca(s)",
    newOrder: "Novo pedido",
    discount: "Desconto(s)"
  },
  returnStoreAddress: {
    mapButton: "Ver no mapa"
  },
  downloadLabel: {
    label: "Transferir a minha etiqueta",
    bonDeRetour: "Transferir o meu comprovativo de devolu\xE7\xE3o"
  },
  returnRequestDate: {
    label: "O seu pedido de devolu\xE7\xE3o foi feito em {{date}} \xE0s {{time}}"
  },
  actions: {
    continue: "Continuar"
  },
  "order-identification": {
    title: "Acompanhe o seu pedido",
    description: "Insira os detalhes do seu pedido para rastrear a sua encomenda",
    fields: {
      "zip-code": {
        title: "C\xF3digo postal",
        description: "Insira o seu c\xF3digo postal de entrega",
        required: "O c\xF3digo postal \xE9 obrigat\xF3rio"
      },
      email: {
        title: "Endere\xE7o de e-mail",
        description: "Insira o endere\xE7o de e-mail utilizado no seu pedido",
        required: "O endere\xE7o de e-mail \xE9 obrigat\xF3rio"
      },
      both: {
        title: "C\xF3digo postal ou email",
        description: "Introduza o seu c\xF3digo postal de entrega ou o email usado na sua encomenda",
        required: "O c\xF3digo postal ou o email \xE9 obrigat\xF3rio"
      },
      "tracking-number": {
        title: "N\xFAmero do pedido",
        description: "Insira o n\xFAmero do seu pedido",
        required: "O n\xFAmero do pedido \xE9 obrigat\xF3rio"
      }
    },
    errors: {
      "unknown-order": {
        title: "N\xFAmero de pedido desconhecido",
        description: "O n\xFAmero do pedido n\xE3o foi encontrado, por favor verifique-o"
      },
      "search-error": {
        title: "Erro de pesquisa",
        description: "N\xE3o conseguimos encontrar o pedido. Por favor, tente novamente mais tarde."
      }
    }
  },
  delivery: "Entrega",
  "parcel-history": "Hist\xF3rico da encomenda",
  "order-details": {
    title: "Detalhes do pedido",
    "tracking-number": "N\xFAmero de rastreamento",
    "order-number": "N\xFAmero do pedido"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Data estimada de entrega",
      deliveredOn: "Entregue em",
      from: "de",
      to: "a"
    }
  },
  deliveryAddress: {
    title: "Endere\xE7o de entrega:",
    titlePickup: "Endere\xE7o do ponto de recolha:",
    orderDetails: {
      title: "Detalhes do pedido:",
      trackingNumber: "N\xFAmero de rastreamento:",
      orderNumber: "N\xFAmero do pedido:",
      orderDate: "Data do pedido:"
    }
  },
  pickupPoint: {
    title: "Ponto de recolha",
    openingHours: "Hor\xE1rio de funcionamento:",
    closed: "Fechado",
    directions: "Dire\xE7\xF5es",
    days: {
      monday: "Segunda-feira:",
      tuesday: "Ter\xE7a-feira:",
      wednesday: "Quarta-feira:",
      thursday: "Quinta-feira:",
      friday: "Sexta-feira:",
      saturday: "S\xE1bado:",
      sunday: "Domingo:"
    }
  },
  wallet: {
    warningNotEnabled: "Voc\xEA deve ativar a Wallet nas configura\xE7\xF5es da sua loja"
  },
  crossSell: {
    youMightAlsoLike: "Voc\xEA tamb\xE9m pode gostar"
  },
  "rate-order": {
    "order-recap": {
      title: "O seu pedido",
      "tracking-label": "N\xFAmero de rastreamento:",
      "order-label": "N\xFAmero do pedido:"
    },
    form: {
      title: "Avalie a sua entrega",
      "rating-label": "Avalie a sua experi\xEAncia de entrega",
      "comment-label": "Coment\xE1rio (opcional)",
      "comment-placeholder": "Partilhe connosco a sua experi\xEAncia\u2026",
      "submit-cta": "Enviar a minha avalia\xE7\xE3o",
      "update-cta": "Atualizar a minha avalia\xE7\xE3o",
      "rating-required": "Por favor, selecione uma avalia\xE7\xE3o."
    },
    "thank-you": {
      title: "Obrigado pelo seu feedback!",
      description: "A sua avalia\xE7\xE3o foi guardada. Vai ajudar-nos a melhorar a experi\xEAncia de entrega."
    },
    errors: {
      "invalid-token": {
        title: "Link inv\xE1lido ou expirado",
        description: "Este link j\xE1 n\xE3o \xE9 v\xE1lido. Por favor, abra-o novamente a partir do seu \xFAltimo email de rastreamento."
      },
      submit: {
        title: "Algo correu mal",
        description: "N\xE3o conseguimos guardar a sua avalia\xE7\xE3o. Por favor, tente novamente mais tarde."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Agora pode imprimir a sua etiqueta de devolu\xE7\xE3o e entregar o seu pacote no ponto de recolha Colissimo mais pr\xF3ximo.",
    chronoShop2Shop: "Agora pode imprimir a sua etiqueta de devolu\xE7\xE3o e entregar o seu pacote no ponto de recolha Chronopost mais pr\xF3ximo.",
    ups: "Agora pode imprimir a sua etiqueta de devolu\xE7\xE3o e entregar o seu pacote no ponto de recolha UPS mais pr\xF3ximo.",
    customerCarrier: "Agora pode enviar o seu pacote de devolu\xE7\xE3o pela transportadora da sua escolha.",
    merchantCarrier: "Iremos enviar-lhe uma etiqueta de devolu\xE7\xE3o por email no prazo de 1 a 3 dias \xFAteis.",
    returnToStore: "Agora pode entregar o seu pacote na loja mais pr\xF3xima.",
    malca: "Agora pode imprimir a sua etiqueta de devolu\xE7\xE3o e entregar o seu pacote no ponto de recolha Malca mais pr\xF3ximo.",
    tnt: "Agora pode imprimir a sua etiqueta de devolu\xE7\xE3o e entregar o seu pacote no ponto de recolha TNT mais pr\xF3ximo.",
    bonDeRetour: "O seu comprovativo de devolu\xE7\xE3o est\xE1 pronto. J\xE1 pode imprimi-lo e utiliz\xE1-lo para a sua devolu\xE7\xE3o.",
    unknownCarrier: "J\xE1 pode imprimir a sua etiqueta de devolu\xE7\xE3o e enviar a sua encomenda com a transportadora indicada na etiqueta."
  },
  shippingInstructionsTitle: {
    shippingLabel: "A sua etiqueta de envio est\xE1 pronta",
    bonDeRetour: "O seu comprovativo de devolu\xE7\xE3o est\xE1 pronto"
  }
};

// ../editor-blocks-library/src/translations/sk.ts
var sk = {
  returnLineItems: {
    refund: "Vr\xE1tenie pe\u0148az\xED",
    exchange: "V\xFDmena",
    newOrder: "Nov\xE1 objedn\xE1vka",
    discount: "Z\u013Eava"
  },
  returnStoreAddress: {
    mapButton: "Zobrazi\u0165 na mape"
  },
  downloadLabel: {
    label: "Stiahnu\u0165 m\xF4j \u0161t\xEDtok",
    bonDeRetour: "Stiahnu\u0165 formul\xE1r na vr\xE1tenie"
  },
  returnRequestDate: {
    label: "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie bola podan\xE1 {{date}} o {{time}}"
  },
  actions: {
    continue: "Pokra\u010Dova\u0165"
  },
  "order-identification": {
    title: "Sledujte svoju objedn\xE1vku",
    description: "Zadajte \xFAdaje o objedn\xE1vke pre sledovanie z\xE1sielky",
    fields: {
      "zip-code": {
        title: "PS\u010C",
        description: "Zadajte va\u0161e doru\u010Dovacie PS\u010C",
        required: "PS\u010C je povinn\xE9"
      },
      email: {
        title: "E-mailov\xE1 adresa",
        description: "Zadajte e-mailov\xFA adresu pou\u017Eit\xFA pri objedn\xE1vke",
        required: "E-mailov\xE1 adresa je povinn\xE1"
      },
      both: {
        title: "PS\u010C alebo e-mail",
        description: "Zadajte svoje doru\u010Dovacie PS\u010C alebo e-mail pou\u017Eit\xFD pri objedn\xE1vke",
        required: "PS\u010C alebo e-mail je povinn\xFD"
      },
      "tracking-number": {
        title: "\u010C\xEDslo objedn\xE1vky",
        description: "Zadajte \u010D\xEDslo va\u0161ej objedn\xE1vky",
        required: "\u010C\xEDslo objedn\xE1vky je povinn\xE9"
      }
    },
    errors: {
      "unknown-order": {
        title: "Nezn\xE1me \u010D\xEDslo objedn\xE1vky",
        description: "\u010C\xEDslo objedn\xE1vky nebolo n\xE1jden\xE9, skontrolujte ho pros\xEDm"
      },
      "search-error": {
        title: "Chyba vyh\u013Ead\xE1vania",
        description: "Nepodarilo sa n\xE1m n\xE1js\u0165 objedn\xE1vku. Sk\xFAste to pros\xEDm nesk\xF4r."
      }
    }
  },
  delivery: "Doru\u010Denie",
  "parcel-history": "Hist\xF3ria bal\xEDka",
  "order-details": {
    title: "Detaily objedn\xE1vky",
    "tracking-number": "Sledovacie \u010D\xEDslo",
    "order-number": "\u010C\xEDslo objedn\xE1vky"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Odhadovan\xFD d\xE1tum doru\u010Denia",
      deliveredOn: "Doru\u010Den\xE9 d\u0148a",
      from: "od",
      to: "do"
    }
  },
  deliveryAddress: {
    title: "Dodacia adresa:",
    titlePickup: "Adresa v\xFDdajn\xE9ho miesta:",
    orderDetails: {
      title: "Detaily objedn\xE1vky:",
      trackingNumber: "Sledovacie \u010D\xEDslo:",
      orderNumber: "\u010C\xEDslo objedn\xE1vky:",
      orderDate: "D\xE1tum objedn\xE1vky:"
    }
  },
  pickupPoint: {
    title: "V\xFDdajn\xE9 miesto",
    openingHours: "Otv\xE1racie hodiny:",
    closed: "Zatvoren\xE9",
    directions: "Trasa",
    days: {
      monday: "Pondelok:",
      tuesday: "Utorok:",
      wednesday: "Streda:",
      thursday: "\u0160tvrtok:",
      friday: "Piatok:",
      saturday: "Sobota:",
      sunday: "Nede\u013Ea:"
    }
  },
  wallet: {
    warningNotEnabled: "Mus\xEDte povoli\u0165 Wallet v nastaveniach svojho obchodu"
  },
  crossSell: {
    youMightAlsoLike: "Mohlo by sa v\xE1m tie\u017E p\xE1\u010Di\u0165"
  },
  "rate-order": {
    "order-recap": {
      title: "Va\u0161a objedn\xE1vka",
      "tracking-label": "Sledovacie \u010D\xEDslo:",
      "order-label": "\u010C\xEDslo objedn\xE1vky:"
    },
    form: {
      title: "Ohodno\u0165te svoje doru\u010Denie",
      "rating-label": "Ohodno\u0165te svoj z\xE1\u017Eitok z doru\u010Denia",
      "comment-label": "Koment\xE1r (nepovinn\xE9)",
      "comment-placeholder": "Pode\u013Ete sa s nami o svoj z\xE1\u017Eitok\u2026",
      "submit-cta": "Odosla\u0165 hodnotenie",
      "update-cta": "Aktualizova\u0165 hodnotenie",
      "rating-required": "Vyberte pros\xEDm hodnotenie."
    },
    "thank-you": {
      title: "\u010Eakujeme za va\u0161u sp\xE4tn\xFA v\xE4zbu!",
      description: "Va\u0161e hodnotenie bolo ulo\u017Een\xE9. Pom\xF4\u017Ee n\xE1m zlep\u0161i\u0165 z\xE1\u017Eitok z doru\u010Denia."
    },
    errors: {
      "invalid-token": {
        title: "Neplatn\xFD alebo vypr\u0161an\xFD odkaz",
        description: "Tento odkaz u\u017E nie je platn\xFD. Otvorte ho pros\xEDm znova z v\xE1\u0161ho posledn\xE9ho sledovacieho e-mailu."
      },
      submit: {
        title: "Nie\u010Do sa pokazilo",
        description: "Nepodarilo sa n\xE1m ulo\u017Ei\u0165 va\u0161e hodnotenie. Sk\xFAste to pros\xEDm nesk\xF4r."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Teraz si m\xF4\u017Eete vytla\u010Di\u0165 n\xE1vratov\xFD \u0161t\xEDtok a odovzda\u0165 bal\xEDk na najbli\u017E\u0161om v\xFDdajnom mieste Colissimo.",
    chronoShop2Shop: "Teraz si m\xF4\u017Eete vytla\u010Di\u0165 n\xE1vratov\xFD \u0161t\xEDtok a odovzda\u0165 bal\xEDk na najbli\u017E\u0161om v\xFDdajnom mieste Chronopost.",
    ups: "Teraz si m\xF4\u017Eete vytla\u010Di\u0165 n\xE1vratov\xFD \u0161t\xEDtok a odovzda\u0165 bal\xEDk na najbli\u017E\u0161om v\xFDdajnom mieste UPS.",
    customerCarrier: "Teraz m\xF4\u017Eete posla\u0165 bal\xEDk na vr\xE1tenie prepravcom pod\u013Ea v\xE1\u0161ho v\xFDberu.",
    merchantCarrier: "N\xE1vratov\xFD \u0161t\xEDtok v\xE1m po\u0161leme e-mailom do 1 a\u017E 3 pracovn\xFDch dn\xED.",
    returnToStore: "Teraz m\xF4\u017Eete odovzda\u0165 bal\xEDk v najbli\u017E\u0161ej predajni.",
    malca: "Teraz si m\xF4\u017Eete vytla\u010Di\u0165 n\xE1vratov\xFD \u0161t\xEDtok a odovzda\u0165 bal\xEDk na najbli\u017E\u0161om v\xFDdajnom mieste Malca.",
    tnt: "Teraz si m\xF4\u017Eete vytla\u010Di\u0165 n\xE1vratov\xFD \u0161t\xEDtok a odovzda\u0165 bal\xEDk na najbli\u017E\u0161om v\xFDdajnom mieste TNT.",
    bonDeRetour: "V\xE1\u0161 prepravn\xFD \u0161t\xEDtok je pripraven\xFD. Teraz si ho m\xF4\u017Eete vytla\u010Di\u0165 a pou\u017Ei\u0165 na vr\xE1tenie.",
    unknownCarrier: "Teraz si m\xF4\u017Eete vytla\u010Di\u0165 \u0161t\xEDtok na vr\xE1tenie a odosla\u0165 bal\xEDk prepravcom uveden\xFDm na \u0161t\xEDtku."
  },
  shippingInstructionsTitle: {
    shippingLabel: "V\xE1\u0161 prepravn\xFD \u0161t\xEDtok je pripraven\xFD",
    bonDeRetour: "V\xE1\u0161 formul\xE1r na vr\xE1tenie je pripraven\xFD"
  }
};

// ../editor-blocks-library/src/translations/sv.ts
var sv = {
  returnLineItems: {
    refund: "\xC5terbetalning(ar)",
    exchange: "Byte(n)",
    newOrder: "Ny order",
    discount: "Rabatt(er)"
  },
  returnStoreAddress: {
    mapButton: "Visa p\xE5 karta"
  },
  downloadLabel: {
    label: "Ladda ner min etikett",
    bonDeRetour: "Ladda ner min retursedel"
  },
  returnRequestDate: {
    label: "Din returbeg\xE4ran gjordes den {{date}} kl. {{time}}"
  },
  actions: {
    continue: "Forts\xE4tt"
  },
  "order-identification": {
    title: "Sp\xE5ra din best\xE4llning",
    description: "Ange dina best\xE4llningsuppgifter f\xF6r att sp\xE5ra ditt paket",
    fields: {
      "zip-code": {
        title: "Postnummer",
        description: "Ange ditt leveranspostnummer",
        required: "Postnummer \xE4r obligatoriskt"
      },
      email: {
        title: "E-postadress",
        description: "Ange den e-postadress du anv\xE4nde f\xF6r din best\xE4llning",
        required: "E-postadress kr\xE4vs"
      },
      both: {
        title: "Postnummer eller e-post",
        description: "Ange ditt leveranspostnummer eller den e-post som anv\xE4ndes f\xF6r din best\xE4llning",
        required: "Postnummer eller e-post kr\xE4vs"
      },
      "tracking-number": {
        title: "Best\xE4llningsnummer",
        description: "Ange ditt best\xE4llningsnummer",
        required: "Best\xE4llningsnummer \xE4r obligatoriskt"
      }
    },
    errors: {
      "unknown-order": {
        title: "Ok\xE4nt best\xE4llningsnummer",
        description: "Best\xE4llningsnumret hittades inte, v\xE4nligen kontrollera det"
      },
      "search-error": {
        title: "S\xF6kfel",
        description: "Vi kunde inte hitta best\xE4llningen. F\xF6rs\xF6k igen senare."
      }
    }
  },
  delivery: "Leverans",
  "parcel-history": "Pakethistorik",
  "order-details": {
    title: "Orderdetaljer",
    "tracking-number": "Sp\xE5rningsnummer",
    "order-number": "Ordernummer"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Ber\xE4knat leveransdatum",
      deliveredOn: "Levererad den",
      from: "fr\xE5n",
      to: "till"
    }
  },
  deliveryAddress: {
    title: "Leveransadress:",
    titlePickup: "Adress till upph\xE4mtningsst\xE4lle:",
    orderDetails: {
      title: "Best\xE4llningsdetaljer:",
      trackingNumber: "Sp\xE5rningsnummer:",
      orderNumber: "Best\xE4llningsnummer:",
      orderDate: "Best\xE4llningsdatum:"
    }
  },
  pickupPoint: {
    title: "Upph\xE4mtningsst\xE4lle",
    openingHours: "\xD6ppettider:",
    closed: "St\xE4ngt",
    directions: "V\xE4gbeskrivning",
    days: {
      monday: "M\xE5ndag:",
      tuesday: "Tisdag:",
      wednesday: "Onsdag:",
      thursday: "Torsdag:",
      friday: "Fredag:",
      saturday: "L\xF6rdag:",
      sunday: "S\xF6ndag:"
    }
  },
  wallet: {
    warningNotEnabled: "Du m\xE5ste aktivera Wallet i dina butiksinst\xE4llningar"
  },
  crossSell: {
    youMightAlsoLike: "Du kanske ocks\xE5 gillar"
  },
  "rate-order": {
    "order-recap": {
      title: "Din best\xE4llning",
      "tracking-label": "Sp\xE5rningsnummer:",
      "order-label": "Ordernummer:"
    },
    form: {
      title: "Betygs\xE4tt din leverans",
      "rating-label": "Betygs\xE4tt din leveransupplevelse",
      "comment-label": "Kommentar (valfritt)",
      "comment-placeholder": "Dela din upplevelse med oss\u2026",
      "submit-cta": "Skicka in mitt omd\xF6me",
      "update-cta": "Uppdatera mitt omd\xF6me",
      "rating-required": "V\xE4lj ett betyg."
    },
    "thank-you": {
      title: "Tack f\xF6r din feedback!",
      description: "Ditt omd\xF6me har sparats. Det hj\xE4lper oss att f\xF6rb\xE4ttra leveransupplevelsen."
    },
    errors: {
      "invalid-token": {
        title: "Ogiltig eller utg\xE5ngen l\xE4nk",
        description: "Den h\xE4r l\xE4nken \xE4r inte l\xE4ngre giltig. \xD6ppna den igen fr\xE5n ditt senaste sp\xE5rningsmejl."
      },
      submit: {
        title: "N\xE5got gick fel",
        description: "Vi kunde inte spara ditt omd\xF6me. F\xF6rs\xF6k igen senare."
      }
    }
  },
  shippingInstructions: {
    colissimo: "Du kan nu skriva ut din returetikett och l\xE4mna in ditt paket vid n\xE4rmaste Colissimo-ombud.",
    chronoShop2Shop: "Du kan nu skriva ut din returetikett och l\xE4mna in ditt paket vid n\xE4rmaste Chronopost-ombud.",
    ups: "Du kan nu skriva ut din returetikett och l\xE4mna in ditt paket vid n\xE4rmaste UPS-ombud.",
    customerCarrier: "Du kan nu skicka ditt returpaket med den transport\xF6r du sj\xE4lv v\xE4ljer.",
    merchantCarrier: "Vi skickar en returetikett till dig via e-post inom 1 till 3 arbetsdagar.",
    returnToStore: "Du kan nu l\xE4mna in ditt paket i n\xE4rmaste butik.",
    malca: "Du kan nu skriva ut din returetikett och l\xE4mna in ditt paket vid n\xE4rmaste Malca-ombud.",
    tnt: "Du kan nu skriva ut din returetikett och l\xE4mna in ditt paket vid n\xE4rmaste TNT-ombud.",
    bonDeRetour: "Din retursedel \xE4r klar. Du kan nu skriva ut den och anv\xE4nda den f\xF6r din retur.",
    unknownCarrier: "Du kan nu skriva ut din returetikett och skicka ditt paket med transport\xF6ren som anges p\xE5 etiketten."
  },
  shippingInstructionsTitle: {
    shippingLabel: "Din fraktetikett \xE4r klar",
    bonDeRetour: "Din returblankett \xE4r klar"
  }
};

// ../editor-blocks-library/src/translations/zh.ts
var zh = {
  returnLineItems: {
    refund: "\u9000\u6B3E",
    exchange: "\u6362\u8D27",
    newOrder: "\u65B0\u8BA2\u5355",
    discount: "\u6298\u6263"
  },
  returnStoreAddress: {
    mapButton: "\u5728\u5730\u56FE\u4E0A\u67E5\u770B"
  },
  returnRequestDate: {
    label: "\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u5DF2\u4E8E {{date}} {{time}} \u63D0\u4EA4"
  },
  actions: {
    continue: "\u7EE7\u7EED"
  },
  "order-identification": {
    title: "\u8FFD\u8E2A\u60A8\u7684\u8BA2\u5355",
    description: "\u8F93\u5165\u60A8\u7684\u8BA2\u5355\u8BE6\u60C5\u4EE5\u8FFD\u8E2A\u60A8\u7684\u5305\u88F9",
    fields: {
      "zip-code": {
        title: "\u90AE\u653F\u7F16\u7801",
        description: "\u8F93\u5165\u60A8\u7684\u9001\u8D27\u90AE\u653F\u7F16\u7801",
        required: "\u8BF7\u8F93\u5165\u90AE\u653F\u7F16\u7801"
      },
      email: {
        title: "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
        description: "\u8BF7\u8F93\u5165\u60A8\u4E0B\u5355\u65F6\u4F7F\u7528\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
        required: "\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u4E3A\u5FC5\u586B\u9879"
      },
      both: {
        title: "\u90AE\u653F\u7F16\u7801\u6216\u7535\u5B50\u90AE\u4EF6",
        description: "\u8F93\u5165\u60A8\u7684\u9001\u8D27\u90AE\u653F\u7F16\u7801\u6216\u4E0B\u5355\u65F6\u4F7F\u7528\u7684\u7535\u5B50\u90AE\u4EF6",
        required: "\u90AE\u653F\u7F16\u7801\u6216\u7535\u5B50\u90AE\u4EF6\u4E3A\u5FC5\u586B\u9879"
      },
      "tracking-number": {
        title: "\u8BA2\u5355\u53F7",
        description: "\u8F93\u5165\u60A8\u7684\u8BA2\u5355\u53F7",
        required: "\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7"
      }
    },
    errors: {
      "unknown-order": {
        title: "\u8BA2\u5355\u53F7\u672A\u77E5",
        description: "\u672A\u627E\u5230\u8BE5\u8BA2\u5355\u53F7\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u8BD5"
      },
      "order-not-shipped": {
        title: "\u8BA2\u5355\u51C6\u5907\u4E2D",
        description: "\u60A8\u7684\u8BA2\u5355\u5C1A\u672A\u53D1\u8D27"
      },
      "search-error": {
        title: "\u67E5\u8BE2\u51FA\u9519",
        description: "\u672A\u80FD\u67E5\u627E\u5230\u8BA2\u5355\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002"
      }
    }
  },
  delivery: "\u914D\u9001",
  "parcel-history": "\u5305\u88F9\u5386\u53F2",
  "order-details": {
    title: "\u8BA2\u5355\u8BE6\u60C5",
    "tracking-number": "\u8FFD\u8E2A\u53F7",
    "order-number": "\u8BA2\u5355\u53F7"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "\u9884\u8BA1\u9001\u8FBE\u65E5\u671F",
      deliveredOn: "\u9001\u8FBE\u65E5\u671F",
      from: "\u4ECE",
      to: "\u81F3"
    }
  },
  deliveryAddress: {
    title: "\u914D\u9001\u5730\u5740\uFF1A",
    titlePickup: "\u81EA\u63D0\u70B9\u5730\u5740\uFF1A",
    orderDetails: {
      title: "\u8BA2\u5355\u8BE6\u60C5\uFF1A",
      trackingNumber: "\u8FFD\u8E2A\u53F7\uFF1A",
      orderNumber: "\u8BA2\u5355\u53F7\uFF1A",
      orderDate: "\u4E0B\u5355\u65E5\u671F\uFF1A"
    }
  },
  pickupPoint: {
    title: "\u81EA\u63D0\u70B9",
    openingHours: "\u8425\u4E1A\u65F6\u95F4\uFF1A",
    closed: "\u5DF2\u5173\u95ED",
    directions: "\u8DEF\u7EBF",
    days: {
      monday: "\u661F\u671F\u4E00\uFF1A",
      tuesday: "\u661F\u671F\u4E8C\uFF1A",
      wednesday: "\u661F\u671F\u4E09\uFF1A",
      thursday: "\u661F\u671F\u56DB\uFF1A",
      friday: "\u661F\u671F\u4E94\uFF1A",
      saturday: "\u661F\u671F\u516D\uFF1A",
      sunday: "\u661F\u671F\u65E5\uFF1A"
    }
  },
  wallet: {
    warningNotEnabled: "\u60A8\u5FC5\u987B\u5728\u5E97\u94FA\u8BBE\u7F6E\u4E2D\u542F\u7528\u94B1\u5305\u529F\u80FD"
  },
  crossSell: {
    youMightAlsoLike: "\u60A8\u53EF\u80FD\u8FD8\u559C\u6B22"
  },
  "rate-order": {
    "order-recap": {
      title: "\u60A8\u7684\u8BA2\u5355",
      "tracking-label": "\u8FFD\u8E2A\u53F7\uFF1A",
      "order-label": "\u8BA2\u5355\u53F7\uFF1A"
    },
    form: {
      title: "\u8BC4\u4EF7\u60A8\u7684\u914D\u9001",
      "rating-label": "\u4E3A\u60A8\u7684\u914D\u9001\u4F53\u9A8C\u6253\u5206",
      "comment-label": "\u8BC4\u8BBA\uFF08\u53EF\u9009\uFF09",
      "comment-placeholder": "\u4E0E\u6211\u4EEC\u5206\u4EAB\u60A8\u7684\u4F53\u9A8C\u2026",
      "submit-cta": "\u63D0\u4EA4\u6211\u7684\u8BC4\u4EF7",
      "update-cta": "\u66F4\u65B0\u6211\u7684\u8BC4\u4EF7",
      "rating-required": "\u8BF7\u9009\u62E9\u4E00\u4E2A\u8BC4\u5206\u3002"
    },
    "thank-you": {
      title: "\u611F\u8C22\u60A8\u7684\u53CD\u9988\uFF01",
      description: "\u60A8\u7684\u8BC4\u4EF7\u5DF2\u4FDD\u5B58\u3002\u8FD9\u5C06\u5E2E\u52A9\u6211\u4EEC\u6539\u5584\u914D\u9001\u4F53\u9A8C\u3002"
    },
    errors: {
      "invalid-token": {
        title: "\u94FE\u63A5\u65E0\u6548\u6216\u5DF2\u8FC7\u671F",
        description: "\u6B64\u94FE\u63A5\u5DF2\u4E0D\u518D\u6709\u6548\u3002\u8BF7\u91CD\u65B0\u6253\u5F00\u6700\u65B0\u7684\u8FFD\u8E2A\u90AE\u4EF6\u3002"
      },
      submit: {
        title: "\u51FA\u9519\u4E86",
        description: "\u672A\u80FD\u4FDD\u5B58\u60A8\u7684\u8BC4\u4EF7\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002"
      }
    }
  },
  shippingInstructions: {
    colissimo: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684Colissimo\u4EE3\u6536\u70B9\u3002",
    chronoShop2Shop: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684Chronopost\u4EE3\u6536\u70B9\u3002",
    ups: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684UPS\u4EE3\u6536\u70B9\u3002",
    customerCarrier: "\u60A8\u73B0\u5728\u53EF\u4EE5\u5C06\u9000\u8D27\u5305\u88F9\u4EA4\u7ED9\u60A8\u9009\u62E9\u7684\u627F\u8FD0\u5546\u3002",
    merchantCarrier: "\u6211\u4EEC\u5C06\u57281\u81F33\u4E2A\u5DE5\u4F5C\u65E5\u5185\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5411\u60A8\u53D1\u9001\u9000\u8D27\u6807\u7B7E\u3002",
    returnToStore: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684\u95E8\u5E97\u3002",
    malca: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684Malca\u4EE3\u6536\u70B9\u3002",
    tnt: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684TNT\u4EE3\u6536\u70B9\u3002",
    bonDeRetour: "\u60A8\u7684\u9000\u8D27\u5355\u5DF2\u51C6\u5907\u597D\u3002\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u5E76\u7528\u4E8E\u9000\u8D27\u3002",
    unknownCarrier: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u901A\u8FC7\u6807\u7B7E\u4E0A\u6CE8\u660E\u7684\u627F\u8FD0\u5546\u5BC4\u51FA\u5305\u88F9\u3002"
  },
  downloadLabel: {
    label: "\u4E0B\u8F7D\u6211\u7684\u6807\u7B7E",
    bonDeRetour: "\u4E0B\u8F7D\u6211\u7684\u9000\u8D27\u5355"
  },
  shippingInstructionsTitle: {
    shippingLabel: "\u60A8\u7684\u8FD0\u9001\u6807\u7B7E\u5DF2\u51C6\u5907\u5C31\u7EEA",
    bonDeRetour: "\u60A8\u7684\u9000\u8D27\u5355\u5DF2\u51C6\u5907\u5C31\u7EEA"
  }
};

// ../editor-blocks-library/src/translations/ja.ts
var ja = {
  returnLineItems: {
    refund: "\u8FD4\u91D1",
    exchange: "\u4EA4\u63DB",
    newOrder: "\u65B0\u898F\u6CE8\u6587",
    discount: "\u5272\u5F15"
  },
  returnStoreAddress: {
    mapButton: "\u5730\u56F3\u3067\u898B\u308B"
  },
  returnRequestDate: {
    label: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u306F{{date}} {{time}}\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F"
  },
  actions: {
    continue: "\u7D9A\u3051\u308B"
  },
  "order-identification": {
    title: "\u6CE8\u6587\u3092\u8FFD\u8DE1\u3059\u308B",
    description: "\u6CE8\u6587\u306E\u8A73\u7D30\u3092\u5165\u529B\u3057\u3066\u8377\u7269\u3092\u8FFD\u8DE1\u3057\u3066\u304F\u3060\u3055\u3044",
    fields: {
      "zip-code": {
        title: "\u90F5\u4FBF\u756A\u53F7",
        description: "\u914D\u9054\u5148\u306E\u90F5\u4FBF\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        required: "\u90F5\u4FBF\u756A\u53F7\u306F\u5FC5\u9808\u3067\u3059"
      },
      email: {
        title: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        description: "\u3054\u6CE8\u6587\u6642\u306B\u4F7F\u7528\u3057\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        required: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u5FC5\u9808\u3067\u3059"
      },
      both: {
        title: "\u90F5\u4FBF\u756A\u53F7\u307E\u305F\u306F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        description: "\u914D\u9001\u5148\u306E\u90F5\u4FBF\u756A\u53F7\u307E\u305F\u306F\u3054\u6CE8\u6587\u306B\u4F7F\u7528\u3057\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        required: "\u90F5\u4FBF\u756A\u53F7\u307E\u305F\u306F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u5FC5\u9808\u3067\u3059"
      },
      "tracking-number": {
        title: "\u6CE8\u6587\u756A\u53F7",
        description: "\u6CE8\u6587\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        required: "\u6CE8\u6587\u756A\u53F7\u306F\u5FC5\u9808\u3067\u3059"
      }
    },
    errors: {
      "unknown-order": {
        title: "\u6CE8\u6587\u756A\u53F7\u304C\u4E0D\u660E\u3067\u3059",
        description: "\u6CE8\u6587\u756A\u53F7\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044"
      },
      "order-not-shipped": {
        title: "\u6CE8\u6587\u6E96\u5099\u4E2D",
        description: "\u3054\u6CE8\u6587\u306F\u307E\u3060\u767A\u9001\u3055\u308C\u3066\u3044\u307E\u305B\u3093"
      },
      "search-error": {
        title: "\u691C\u7D22\u30A8\u30E9\u30FC",
        description: "\u6CE8\u6587\u3092\u691C\u7D22\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u5F8C\u307B\u3069\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"
      }
    }
  },
  delivery: "\u914D\u9001",
  "parcel-history": "\u8377\u7269\u306E\u5C65\u6B74",
  "order-details": {
    title: "\u6CE8\u6587\u306E\u8A73\u7D30",
    "tracking-number": "\u8FFD\u8DE1\u756A\u53F7",
    "order-number": "\u6CE8\u6587\u756A\u53F7"
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "\u914D\u9054\u4E88\u5B9A\u65E5",
      deliveredOn: "\u914D\u9054\u65E5",
      from: "\u304B\u3089",
      to: "\u307E\u3067"
    }
  },
  deliveryAddress: {
    title: "\u914D\u9001\u5148\u4F4F\u6240\uFF1A",
    titlePickup: "\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306E\u4F4F\u6240\uFF1A",
    orderDetails: {
      title: "\u6CE8\u6587\u306E\u8A73\u7D30\uFF1A",
      trackingNumber: "\u8FFD\u8DE1\u756A\u53F7\uFF1A",
      orderNumber: "\u6CE8\u6587\u756A\u53F7\uFF1A",
      orderDate: "\u6CE8\u6587\u65E5\uFF1A"
    }
  },
  pickupPoint: {
    title: "\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8",
    openingHours: "\u55B6\u696D\u6642\u9593\uFF1A",
    closed: "\u9589\u5E97",
    directions: "\u9053\u9806",
    days: {
      monday: "\u6708\u66DC\u65E5\uFF1A",
      tuesday: "\u706B\u66DC\u65E5\uFF1A",
      wednesday: "\u6C34\u66DC\u65E5\uFF1A",
      thursday: "\u6728\u66DC\u65E5\uFF1A",
      friday: "\u91D1\u66DC\u65E5\uFF1A",
      saturday: "\u571F\u66DC\u65E5\uFF1A",
      sunday: "\u65E5\u66DC\u65E5\uFF1A"
    }
  },
  wallet: {
    warningNotEnabled: "\u5E97\u8217\u8A2D\u5B9A\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u6709\u52B9\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059"
  },
  crossSell: {
    youMightAlsoLike: "\u3053\u3061\u3089\u3082\u304A\u3059\u3059\u3081"
  },
  "rate-order": {
    "order-recap": {
      title: "\u3054\u6CE8\u6587",
      "tracking-label": "\u8FFD\u8DE1\u756A\u53F7\uFF1A",
      "order-label": "\u6CE8\u6587\u756A\u53F7\uFF1A"
    },
    form: {
      title: "\u914D\u9001\u3092\u8A55\u4FA1\u3059\u308B",
      "rating-label": "\u914D\u9001\u4F53\u9A13\u3092\u8A55\u4FA1\u3057\u3066\u304F\u3060\u3055\u3044",
      "comment-label": "\u30B3\u30E1\u30F3\u30C8\uFF08\u4EFB\u610F\uFF09",
      "comment-placeholder": "\u3054\u4F53\u9A13\u3092\u5171\u6709\u3057\u3066\u304F\u3060\u3055\u3044\u2026",
      "submit-cta": "\u30EC\u30D3\u30E5\u30FC\u3092\u9001\u4FE1",
      "update-cta": "\u30EC\u30D3\u30E5\u30FC\u3092\u66F4\u65B0",
      "rating-required": "\u8A55\u4FA1\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    },
    "thank-you": {
      title: "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01",
      description: "\u30EC\u30D3\u30E5\u30FC\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002\u914D\u9001\u4F53\u9A13\u306E\u6539\u5584\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002"
    },
    errors: {
      "invalid-token": {
        title: "\u30EA\u30F3\u30AF\u304C\u7121\u52B9\u307E\u305F\u306F\u671F\u9650\u5207\u308C\u3067\u3059",
        description: "\u3053\u306E\u30EA\u30F3\u30AF\u306F\u3082\u3046\u6709\u52B9\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u6700\u65B0\u306E\u8FFD\u8DE1\u30E1\u30FC\u30EB\u304B\u3089\u518D\u5EA6\u958B\u3044\u3066\u304F\u3060\u3055\u3044\u3002"
      },
      submit: {
        title: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
        description: "\u30EC\u30D3\u30E5\u30FC\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u5F8C\u307B\u3069\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"
      }
    }
  },
  shippingInstructions: {
    colissimo: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306EColissimo\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    chronoShop2Shop: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306EChronopost\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    ups: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306EUPS\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    customerCarrier: "\u304A\u597D\u307F\u306E\u914D\u9001\u696D\u8005\u306B\u8FD4\u54C1\u5546\u54C1\u3092\u304A\u6E21\u3057\u304F\u3060\u3055\u3044\u3002",
    merchantCarrier: "1\u301C3\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u30E1\u30FC\u30EB\u3067\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\u3002",
    returnToStore: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306E\u5E97\u8217\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    malca: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306EMalca\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    tnt: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306ETNT\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    bonDeRetour: "\u8FD4\u54C1\u4F1D\u7968\u306E\u6E96\u5099\u304C\u3067\u304D\u307E\u3057\u305F\u3002\u5370\u5237\u3057\u3066\u8FD4\u54C1\u306B\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002",
    unknownCarrier: "\u8FD4\u9001\u7528\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u30E9\u30D9\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u914D\u9001\u696D\u8005\u3067\u8377\u7269\u3092\u767A\u9001\u3067\u304D\u307E\u3059\u3002"
  },
  downloadLabel: {
    label: "\u30E9\u30D9\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    bonDeRetour: "\u8FD4\u54C1\u4F1D\u7968\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"
  },
  shippingInstructionsTitle: {
    shippingLabel: "\u914D\u9001\u30E9\u30D9\u30EB\u306E\u6E96\u5099\u304C\u3067\u304D\u307E\u3057\u305F",
    bonDeRetour: "\u8FD4\u54C1\u4F1D\u7968\u306E\u6E96\u5099\u304C\u3067\u304D\u307E\u3057\u305F"
  }
};

// ../editor-blocks-library/src/translations/index.ts
var translations = {
  bg,
  cs,
  da,
  de,
  en,
  es,
  fi,
  fr,
  hu,
  it,
  nl,
  no,
  pl,
  pt,
  sk,
  sv,
  zh,
  ja
};
function tLayout(locale, defaultLocale) {
  return (key, vars) => {
    const localeToUse = locale in translations ? locale : defaultLocale;
    const dict = translations[localeToUse] || translations.en;
    const keys3 = key.split(".");
    let value = dict;
    for (const k of keys3) {
      if (value && typeof value === "object" && k in value) {
        value = value[k];
      } else {
        return key;
      }
    }
    if (typeof value !== "string") {
      return key;
    }
    if (!vars) {
      return value;
    }
    return value.replace(/\{\{(\w+)\}\}/g, (_, varName) => {
      return varName in vars ? String(vars[varName]) : `{{${varName}}}`;
    });
  };
}
var grey = "#e5e7eb";
function PlaceholderItem() {
  return /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          width: "100%",
          aspectRatio: "16 / 9",
          backgroundColor: grey,
          borderRadius: "8px"
        }
      }
    ),
    /* @__PURE__ */ jsx("div", { style: { height: "12px", width: "70%", backgroundColor: grey, borderRadius: "4px" } }),
    /* @__PURE__ */ jsx("div", { style: { height: "12px", width: "40%", backgroundColor: grey, borderRadius: "4px" } })
  ] });
}
function CrossSellEditorRenderer({ block, shop, locale, defaultLocale, theme, section }) {
  const count3 = block?.properties?.count ?? 2;
  const t2 = tLayout(locale, defaultLocale);
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop, children: /* @__PURE__ */ jsxs(Section, { children: [
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { style: { padding: "4px 4px 8px" }, children: /* @__PURE__ */ jsx(Text$1, { className: "m-0 p-0 leading-[1.4] font-semibold", style: { color: colors.text }, children: t2("crossSell.youMightAlsoLike") }) }) }),
    count3 === 1 && /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { style: { width: "100%", padding: "4px" }, children: /* @__PURE__ */ jsx("div", { style: { maxWidth: "280px" }, children: /* @__PURE__ */ jsx(PlaceholderItem, {}) }) }) }),
    count3 === 2 && /* @__PURE__ */ jsx(Row, { children: [0, 1].map((i) => /* @__PURE__ */ jsx(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: /* @__PURE__ */ jsx(PlaceholderItem, {}) }, i)) }),
    count3 === 3 && /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsxs(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: [
        /* @__PURE__ */ jsx(PlaceholderItem, {}),
        /* @__PURE__ */ jsx("div", { style: { height: "8px" } }),
        /* @__PURE__ */ jsx(PlaceholderItem, {})
      ] }),
      /* @__PURE__ */ jsx(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px", height: "1px" }, children: /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", height: "100%", gap: "6px" }, children: [
        /* @__PURE__ */ jsx("div", { style: { flex: 1, backgroundColor: grey, borderRadius: "8px" } }),
        /* @__PURE__ */ jsx("div", { style: { height: "12px", width: "70%", backgroundColor: grey, borderRadius: "4px" } }),
        /* @__PURE__ */ jsx("div", { style: { height: "12px", width: "40%", backgroundColor: grey, borderRadius: "4px" } })
      ] }) })
    ] }),
    count3 === 4 && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Row, { children: [0, 1].map((i) => /* @__PURE__ */ jsx(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: /* @__PURE__ */ jsx(PlaceholderItem, {}) }, i)) }),
      /* @__PURE__ */ jsx(Row, { children: [0, 1].map((i) => /* @__PURE__ */ jsx(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: /* @__PURE__ */ jsx(PlaceholderItem, {}) }, i)) })
    ] })
  ] }) });
}
function PanelCrossCount() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const count3 = blockProps.block.properties?.count ?? 2;
  return /* @__PURE__ */ jsx(
    PanelInlineContent,
    {
      title: t2(
        "editorBlocksLibrary.blocks.cross-sell.panel.count.title",
        "Products"
      ),
      children: /* @__PURE__ */ jsx(
        ToggleGroup2,
        {
          variant: "default",
          type: "single",
          className: "bg-background border shadow",
          value: String(count3),
          onValueChange: (value) => {
            const num = parseInt(value, 10);
            if (num >= 1 && num <= 4) {
              blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
                ...blockProps.block,
                properties: { ...blockProps.block.properties, count: num }
              });
            }
          },
          children: [1, 2, 3, 4].map((n) => /* @__PURE__ */ jsx(ToggleGroupItem2, { value: String(n), "aria-label": `${n} products`, children: /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: n }) }, n))
        }
      )
    }
  );
}
function CrossSellEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(PanelCrossCount, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "not-translatable", portal: true })
  ] });
}
function ProductCard({
  product,
  imgSize,
  textColor
}) {
  return /* @__PURE__ */ jsxs(Link, { href: product.url, style: { textDecoration: "none" }, children: [
    product.imageUrl && /* @__PURE__ */ jsx(
      Img,
      {
        src: product.imageUrl,
        alt: product.title,
        width: imgSize,
        height: imgSize,
        style: {
          width: `${imgSize}px`,
          height: `${imgSize}px`,
          objectFit: "cover",
          borderRadius: "8px",
          display: "block",
          margin: "0 auto"
        }
      }
    ),
    /* @__PURE__ */ jsx(
      Text$1,
      {
        style: {
          margin: "6px 0 2px",
          fontSize: "12px",
          fontWeight: 600,
          color: textColor,
          textAlign: "center"
        },
        children: product.title
      }
    )
  ] });
}
function CrossSellEmailRenderer({
  block,
  parcel,
  theme,
  section,
  locale,
  defaultLocale
}) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const count3 = block?.properties?.count ?? 2;
  const t2 = tLayout(locale, defaultLocale);
  const recommendations = parcel?.crossSellRecommendations;
  if (!recommendations?.length) return null;
  const items = recommendations.slice(0, count3);
  const imgSize = count3 <= 2 ? 100 : 80;
  return /* @__PURE__ */ jsxs(Section, { children: [
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { style: { padding: "4px 4px 8px" }, children: /* @__PURE__ */ jsx(Text$1, { className: "m-0 p-0 leading-[1.4] font-semibold", style: { color: colors.text }, children: t2("crossSell.youMightAlsoLike") }) }) }),
    count3 === 1 && /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { style: { width: "100%", padding: "4px" }, children: /* @__PURE__ */ jsx(ProductCard, { product: items[0], imgSize, textColor: colors.text }) }) }),
    count3 === 2 && /* @__PURE__ */ jsx(Row, { children: items.map((product) => /* @__PURE__ */ jsx(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: /* @__PURE__ */ jsx(ProductCard, { product, imgSize, textColor: colors.text }) }, product.id)) }),
    count3 === 3 && /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsxs(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: [
        /* @__PURE__ */ jsx(ProductCard, { product: items[0], imgSize, textColor: colors.text }),
        /* @__PURE__ */ jsx("div", { style: { height: "8px" } }),
        /* @__PURE__ */ jsx(ProductCard, { product: items[1], imgSize, textColor: colors.text })
      ] }),
      /* @__PURE__ */ jsx(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: /* @__PURE__ */ jsx(ProductCard, { product: items[2], imgSize, textColor: colors.text }) })
    ] }),
    count3 === 4 && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Row, { children: items.slice(0, 2).map((product) => /* @__PURE__ */ jsx(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: /* @__PURE__ */ jsx(ProductCard, { product, imgSize, textColor: colors.text }) }, product.id)) }),
      /* @__PURE__ */ jsx(Row, { children: items.slice(2, 4).map((product) => /* @__PURE__ */ jsx(Column, { style: { width: "50%", verticalAlign: "top", padding: "4px" }, children: /* @__PURE__ */ jsx(ProductCard, { product, imgSize, textColor: colors.text }) }, product.id)) })
    ] })
  ] });
}
var grey2 = "#e5e7eb";
var radius8 = "8px";
var radius4 = "4px";
function TitleBar() {
  return /* @__PURE__ */ jsx("div", { style: { height: "12px", width: "70%", backgroundColor: grey2, borderRadius: radius4 } });
}
function PriceBar() {
  return /* @__PURE__ */ jsx("div", { style: { height: "12px", width: "40%", backgroundColor: grey2, borderRadius: radius4 } });
}
function PlaceholderItem2() {
  return /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
    /* @__PURE__ */ jsx("div", { style: { width: "100%", aspectRatio: "16 / 9", backgroundColor: grey2, borderRadius: radius8 } }),
    /* @__PURE__ */ jsx(TitleBar, {}),
    /* @__PURE__ */ jsx(PriceBar, {})
  ] });
}
function CrossSellWebEditor({ block, locale, defaultLocale, theme, section }) {
  const count3 = block?.properties?.count ?? 2;
  const t2 = tLayout(locale, defaultLocale);
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const title = /* @__PURE__ */ jsx("p", { style: { margin: "0 0 8px", padding: 0, lineHeight: 1.4, fontWeight: 600, color: colors.text }, children: t2("crossSell.youMightAlsoLike") });
  if (count3 === 1) {
    return /* @__PURE__ */ jsxs("div", { style: { padding: "4px" }, children: [
      title,
      /* @__PURE__ */ jsx("div", { style: { maxWidth: "280px" }, children: /* @__PURE__ */ jsx(PlaceholderItem2, {}) })
    ] });
  }
  if (count3 === 2) {
    return /* @__PURE__ */ jsxs("div", { style: { padding: "4px" }, children: [
      title,
      /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "8px" }, children: [
        /* @__PURE__ */ jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsx(PlaceholderItem2, {}) }),
        /* @__PURE__ */ jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsx(PlaceholderItem2, {}) })
      ] })
    ] });
  }
  if (count3 === 3) {
    return /* @__PURE__ */ jsxs("div", { style: { padding: "4px" }, children: [
      title,
      /* @__PURE__ */ jsxs("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }, children: [
        /* @__PURE__ */ jsx("div", { style: { gridColumn: 1, gridRow: 1 }, children: /* @__PURE__ */ jsx(PlaceholderItem2, {}) }),
        /* @__PURE__ */ jsx("div", { style: { gridColumn: 1, gridRow: 2 }, children: /* @__PURE__ */ jsx(PlaceholderItem2, {}) }),
        /* @__PURE__ */ jsxs("div", { style: { gridColumn: 2, gridRow: "1 / 3", display: "flex", flexDirection: "column", gap: "6px" }, children: [
          /* @__PURE__ */ jsx("div", { style: { flex: 1, backgroundColor: grey2, borderRadius: radius8 } }),
          /* @__PURE__ */ jsx(TitleBar, {}),
          /* @__PURE__ */ jsx(PriceBar, {})
        ] })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { style: { padding: "4px" }, children: [
    title,
    /* @__PURE__ */ jsx("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }, children: [0, 1, 2, 3].map((i) => /* @__PURE__ */ jsx(PlaceholderItem2, {}, i)) })
  ] });
}
function CrossSellWebRenderer(props) {
  const recommendations = props.parcel?.crossSellRecommendations;
  if (!recommendations?.length) return null;
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(CrossSellEmailRenderer, { ...props }) });
}

// ../editor-blocks-library/src/blocks/cross-sell/index.tsx
var cross_sell_default = registerBlock({
  type: "cross-sell",
  name: "editorBlocksLibrary.blocks.cross-sell.title",
  description: "editorBlocksLibrary.blocks.cross-sell.description",
  Icon: ShoppingBag,
  category: "tracking" /* TRACKING */,
  hasDynamicContent: true,
  components: {
    email: {
      component: CrossSellEmailRenderer,
      editor: {
        component: CrossSellEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: CrossSellEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    },
    web: {
      component: CrossSellWebRenderer,
      editor: {
        component: CrossSellWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: CrossSellEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
function DoubleButtonsEmailRenderer({
  block,
  formatter,
  theme,
  locale,
  defaultLocale,
  section,
  isEditor
}) {
  const alignment = block.alignment || "center";
  const font = block.font ?? DEFAULT_FONT;
  const buttonRadius = useEmailThemeRadius(theme, "button");
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const button0Content = block.content?.[locale]?.button0 || block.content?.[defaultLocale]?.button0;
  const button1Content = block.content?.[locale]?.button1 || block.content?.[defaultLocale]?.button1;
  const button0Style = getThemeButtonStyle({
    variant: block.properties?.button0Variant || "default",
    theme,
    textColor: colors.text
  });
  const button1Style = getThemeButtonStyle({
    variant: block.properties?.button1Variant || "outline",
    theme,
    textColor: colors.text
  });
  let formattedButton0Text = !!formatter && button0Content?.text ? formatter(button0Content?.text) : button0Content?.text;
  let formattedButton1Text = !!formatter && button1Content?.text ? formatter(button1Content?.text) : button1Content?.text;
  let formattedButton0Href = !!formatter && button0Content?.href ? formatter(button0Content?.href) : button0Content?.href;
  let formattedButton1Href = !!formatter && button1Content?.href ? formatter(button1Content?.href) : button1Content?.href;
  if (!formattedButton0Text?.length) {
    if (isEditor) {
      formattedButton0Text = "Ajoutez un label";
    } else {
      return null;
    }
  }
  if (!formattedButton1Text?.length) {
    if (isEditor) {
      formattedButton1Text = "Ajoutez un label";
    } else {
      return null;
    }
  }
  if (!formattedButton0Href?.length) {
    if (isEditor) {
      formattedButton0Href = "#";
    } else {
      return null;
    }
  }
  if (!formattedButton1Href?.length) {
    if (isEditor) {
      formattedButton1Href = "#";
    } else {
      return null;
    }
  }
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsxs(
    Column,
    {
      className: cn({
        "text-left": alignment === "left",
        "text-center": alignment === "center",
        "text-right": alignment === "right"
      }),
      children: [
        /* @__PURE__ */ jsx(
          Button$1,
          {
            href: formattedButton0Href,
            className: cn("inline-block mx-1 no-underline", buttonRadius),
            style: { ...button0Style, fontFamily: font },
            children: /* @__PURE__ */ jsx(
              "span",
              {
                dangerouslySetInnerHTML: {
                  __html: formattedButton0Text
                }
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          Button$1,
          {
            href: formattedButton1Href,
            className: cn("inline-block mx-1 no-underline ml-2", buttonRadius),
            style: { ...button1Style, fontFamily: font },
            children: /* @__PURE__ */ jsx(
              "span",
              {
                dangerouslySetInnerHTML: {
                  __html: formattedButton1Text
                }
              }
            )
          }
        )
      ]
    }
  ) });
}
function DoubleButtonsEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx("div", { className: "[&_a]:pointer-events-none [&_a]:cursor-default", children: /* @__PURE__ */ jsx(DoubleButtonsEmailRenderer, { isEditor: true, ...props }) }) });
}
function DoubleButtonsEmailPanelRenderer(blockProps) {
  const { t: t2 } = useTranslation("editor-blocks-library");
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsxs(Tabs2, { defaultValue: "button0", className: "w-full", children: [
      /* @__PURE__ */ jsx(FloatingPanelContent, { className: "pb-0", children: /* @__PURE__ */ jsxs(TabsList2, { className: "w-full flex", children: [
        /* @__PURE__ */ jsx(TabsTrigger2, { className: "flex-1", value: "button0", children: t2(
          "editorBlocksLibrary.blocks.double-buttons.panel.button1.title",
          "Button 1"
        ) }),
        /* @__PURE__ */ jsx(TabsTrigger2, { className: "flex-1", value: "button1", children: t2(
          "editorBlocksLibrary.blocks.double-buttons.panel.button2.title",
          "Button 2"
        ) })
      ] }) }),
      /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
      /* @__PURE__ */ jsxs(TabsContent2, { value: "button0", className: "flex flex-col gap-0 pt-0", children: [
        /* @__PURE__ */ jsx(EmailPanelLabel, { buttonKey: "button0" }),
        /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
        /* @__PURE__ */ jsx(EmailPanelUrl2, { buttonKey: "button0" }),
        /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
        /* @__PURE__ */ jsx(EmailPanelStyle, { variantFieldName: "button0Variant" })
      ] }),
      /* @__PURE__ */ jsxs(TabsContent2, { value: "button1", className: "flex flex-col gap-0 pt-0", children: [
        /* @__PURE__ */ jsx(EmailPanelLabel, { buttonKey: "button1" }),
        /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
        /* @__PURE__ */ jsx(EmailPanelUrl2, { buttonKey: "button1" }),
        /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
        /* @__PURE__ */ jsx(EmailPanelStyle, { variantFieldName: "button1Variant" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelBlockFont, {}),
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "translatable", portal: true })
  ] });
}
function DoubleButtonsWeb({
  block,
  formatter,
  theme,
  locale,
  defaultLocale,
  section,
  shop,
  isEditor
}) {
  const alignment = block.alignment || "center";
  const buttonRadius = useEmailThemeRadius(theme, "button");
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const button0Content = block.content?.[locale]?.button0 || block.content?.[defaultLocale]?.button0;
  const button1Content = block.content?.[locale]?.button1 || block.content?.[defaultLocale]?.button1;
  const button0Style = getThemeButtonStyle({
    variant: block.properties?.button0Variant || "default",
    theme,
    textColor: colors.text
  });
  const button1Style = getThemeButtonStyle({
    variant: block.properties?.button1Variant || "outline",
    theme,
    textColor: colors.text
  });
  let formattedButton0Text = !!formatter && button0Content?.text ? formatter(button0Content?.text) : button0Content?.text;
  let formattedButton1Text = !!formatter && button1Content?.text ? formatter(button1Content?.text) : button1Content?.text;
  const formattedButton0Href = !!formatter && button0Content?.href ? formatter(button0Content?.href) : button0Content?.href;
  const formattedButton1Href = !!formatter && button1Content?.href ? formatter(button1Content?.href) : button1Content?.href;
  if (!formattedButton0Text?.length) {
    if (isEditor) {
      formattedButton0Text = "Ajoutez un label";
    } else {
      return null;
    }
  }
  if (!formattedButton1Text?.length) {
    if (isEditor) {
      formattedButton1Text = "Ajoutez un label";
    } else {
      return null;
    }
  }
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn("flex gap-4", {
        "justify-center": alignment === "center",
        "justify-start": alignment === "left",
        "justify-end": alignment === "right"
      }),
      children: [
        /* @__PURE__ */ jsx("a", { href: formattedButton0Href, children: /* @__PURE__ */ jsx(Button, { style: button0Style, className: buttonRadius, children: formattedButton0Text }) }),
        /* @__PURE__ */ jsx("a", { href: formattedButton1Href, children: /* @__PURE__ */ jsx(Button, { style: button1Style, className: buttonRadius, children: formattedButton1Text }) })
      ]
    }
  ) });
}
function DoubleButtonsWebEditor(props) {
  return /* @__PURE__ */ jsx(DoubleButtonsWeb, { ...props, isEditor: true });
}

// ../editor-blocks-library/src/blocks/double-buttons/index.tsx
var double_buttons_default = registerBlock({
  type: "double-buttons",
  name: "editorBlocksLibrary.blocks.double-buttons.title",
  description: "editorBlocksLibrary.blocks.double-buttons.description",
  Icon: ArrowBigRight,
  category: "essentials" /* ESSENTIALS */,
  isTranslated: (locale, block) => {
    const content = block.content;
    return !!content?.[locale]?.button0?.text?.length && !!content?.[locale]?.button0?.href?.length && !!content?.[locale]?.button1?.text?.length && !!content?.[locale]?.button1?.href?.length;
  },
  components: {
    email: {
      component: DoubleButtonsEmailRenderer,
      editor: {
        component: DoubleButtonsEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: DoubleButtonsEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    },
    web: {
      component: DoubleButtonsWeb,
      editor: {
        component: DoubleButtonsWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: DoubleButtonsEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
function LogoEmailRenderer({ block, shop }) {
  const alignment = block.alignment || "center";
  const size4 = block.properties?.size || "medium";
  const heightPx = logoSizeMap[size4] || 18;
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
    Column,
    {
      className: cn({
        "text-left": alignment === "left",
        "text-center": alignment === "center",
        "text-right": alignment === "right"
      }),
      children: /* @__PURE__ */ jsx(
        Img,
        {
          src: shop.logoUrl ?? `https://baback-public-logos.s3.eu-north-1.amazonaws.com/${shop.logoId}`,
          alt: `${shop.name} Logo`,
          style: {
            height: `${heightPx}px`
          },
          height: heightPx,
          className: cn("block", `h-[${heightPx}px]`, {
            "mx-auto": alignment === "center",
            "ml-auto": alignment === "right",
            "mr-auto": alignment === "left"
          })
        }
      )
    }
  ) });
}
function LogoEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(LogoEmailRenderer, { ...props }) });
}
function PanelLogoSize() {
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.properties?.size || "medium";
  const handleUpdate = (size4) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        size: size4
      }
    });
  };
  return /* @__PURE__ */ jsx(PanelInlineContent, { title: "Taille", children: /* @__PURE__ */ jsxs(
    ToggleGroup2,
    {
      variant: "default",
      type: "single",
      className: "bg-background border shadow",
      value,
      onValueChange: (value2) => {
        if (value2 && (value2 === "small" || value2 === "medium" || value2 === "large")) {
          handleUpdate(value2);
        }
      },
      children: [
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "small", "aria-label": "Petite taille", children: /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: "Petit" }) }),
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "medium", "aria-label": "Taille moyenne", children: /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: "Moyen" }) }),
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "large", "aria-label": "Grande taille", children: /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: "Grand" }) })
      ]
    }
  ) });
}
function LogoEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(PanelLogoSize, {}),
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "not-translatable", portal: true })
  ] });
}
function LogoWeb(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(LogoEmailRenderer, { ...props }) });
}
function LogoWebEditor(props) {
  return /* @__PURE__ */ jsx(LogoWeb, { ...props });
}

// ../editor-blocks-library/src/blocks/logo/index.tsx
var logoSizeMap = {
  small: 24,
  medium: 60,
  large: 120
};
var logo_default = registerBlock({
  type: "logo",
  name: "editorBlocksLibrary.blocks.logo.title",
  description: "editorBlocksLibrary.blocks.logo.description",
  Icon: Building,
  category: "layout" /* LAYOUT */,
  components: {
    email: {
      component: LogoEmailRenderer,
      editor: {
        component: LogoEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: LogoEmailPanelRenderer
      },
      compatibility: {
        rowBlock: true
      }
    },
    web: {
      component: LogoWeb,
      editor: {
        component: LogoWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: LogoEmailPanelRenderer
      },
      compatibility: {
        rowBlock: true
      }
    }
  }
});
function AddressBlockEmail({
  theme,
  section,
  locale,
  defaultLocale
}) {
  const t2 = tLayout(locale, defaultLocale);
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const { getVariableValue } = useVariablesValues();
  return /* @__PURE__ */ jsx(Container, { children: /* @__PURE__ */ jsxs(Row, { style: { color: colors.text }, children: [
    /* @__PURE__ */ jsxs(
      Column,
      {
        style: { width: "50%", verticalAlign: "top", paddingRight: "12px" },
        children: [
          /* @__PURE__ */ jsx(
            Text$1,
            {
              style: {
                fontWeight: "bold",
                lineHeight: "1.3",
                marginBottom: "2px",
                marginTop: "0",
                fontSize: "12px"
              },
              children: getVariableValue("address.isPickupPoint") === true ? t2("deliveryAddress.titlePickup") : t2("deliveryAddress.title")
            }
          ),
          getVariableValue("address.isPickupPoint") !== true && /* @__PURE__ */ jsxs(Text$1, { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            getVariableValue("customer.firstName"),
            " ",
            getVariableValue("customer.lastName")
          ] }),
          /* @__PURE__ */ jsxs(Text$1, { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            getVariableValue("address.address1"),
            getVariableValue("address.address2") && `, ${getVariableValue("address.address2")}`
          ] }),
          /* @__PURE__ */ jsxs(Text$1, { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            getVariableValue("address.zip"),
            " ",
            getVariableValue("address.city"),
            ", ",
            getVariableValue("address.country")
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      Column,
      {
        style: { width: "50%", verticalAlign: "top", paddingLeft: "12px" },
        children: [
          /* @__PURE__ */ jsx(
            Text$1,
            {
              style: {
                fontWeight: "bold",
                lineHeight: "1.3",
                marginBottom: "2px",
                marginTop: "0",
                fontSize: "12px"
              },
              children: t2("deliveryAddress.orderDetails.title")
            }
          ),
          /* @__PURE__ */ jsxs(Text$1, { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            t2("deliveryAddress.orderDetails.trackingNumber"),
            " ",
            getVariableValue("parcel.trackingId") || "N/A"
          ] }),
          /* @__PURE__ */ jsxs(
            Text$1,
            {
              style: {
                margin: "0",
                lineHeight: "1.3",
                fontSize: "11px",
                textDecoration: "underline"
              },
              children: [
                t2("deliveryAddress.orderDetails.orderNumber"),
                " ",
                getVariableValue("parcel.orderNumber") || "N/A"
              ]
            }
          )
        ]
      }
    )
  ] }) });
}
function AddressBlockEditor(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(AddressBlockEmail, { ...props }) });
}
function AddressWeb({
  locale,
  defaultLocale,
  theme,
  section
}) {
  const t2 = tLayout(locale, defaultLocale);
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const { getVariableValue } = useVariablesValues();
  const isPickupPoint = getVariableValue("address.isPickupPoint") === true;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "flex gap-4 justify-around items-start",
      style: { marginBottom: "12px", color: colors.text },
      children: [
        /* @__PURE__ */ jsxs("div", { style: { display: "inline-block" }, children: [
          /* @__PURE__ */ jsx(
            "p",
            {
              style: {
                fontWeight: "bold",
                marginBottom: "2px",
                marginTop: "0",
                fontSize: "12px"
              },
              children: isPickupPoint ? t2("deliveryAddress.titlePickup") : t2("deliveryAddress.title")
            }
          ),
          !isPickupPoint && /* @__PURE__ */ jsxs("p", { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            getVariableValue("customer.firstName"),
            " ",
            getVariableValue("customer.lastName")
          ] }),
          /* @__PURE__ */ jsxs("p", { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            getVariableValue("address.address1"),
            " ",
            getVariableValue("address.address2") && `, ${getVariableValue("address.address2")}`
          ] }),
          /* @__PURE__ */ jsxs("p", { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            getVariableValue("address.zip"),
            " ",
            getVariableValue("address.city"),
            ",",
            " ",
            getVariableValue("address.country")
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { style: { display: "inline-block" }, children: [
          /* @__PURE__ */ jsx(
            "p",
            {
              style: {
                fontWeight: "bold",
                marginBottom: "2px",
                marginTop: "0",
                fontSize: "12px"
              },
              children: t2("deliveryAddress.orderDetails.title")
            }
          ),
          /* @__PURE__ */ jsxs("p", { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            t2("deliveryAddress.orderDetails.trackingNumber"),
            " ",
            getVariableValue("parcel.trackingId") || "N/A"
          ] }),
          /* @__PURE__ */ jsxs("p", { style: { margin: "0", lineHeight: "1.3", fontSize: "11px" }, children: [
            t2("deliveryAddress.orderDetails.orderNumber"),
            " ",
            getVariableValue("parcel.orderNumber") || "N/A"
          ] })
        ] })
      ]
    }
  );
}
function AddressWebEditor(props) {
  return /* @__PURE__ */ jsx(AddressWeb, { ...props });
}
function PanelNoSettings({}) {
  const { t: t2 } = useTranslation("editor-blocks-library");
  return /* @__PURE__ */ jsx("div", { className: "p-2 text-sm text-muted-foreground", children: t2("editorBlocksLibrary.panel.noSettings.title", "No settings available for this block.") });
}
function AddressEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(PanelNoSettings, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "auto", portal: true })
  ] });
}

// ../editor-blocks-library/src/blocks/address/index.tsx
var address_default = registerBlock({
  type: "delivery-address",
  name: "editorBlocksLibrary.blocks.delivery-address.title",
  description: "editorBlocksLibrary.blocks.delivery-address.description",
  Icon: MapPin,
  category: "tracking" /* TRACKING */,
  hasDynamicContent: true,
  components: {
    email: {
      component: AddressBlockEmail,
      editor: {
        component: AddressBlockEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: AddressEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    },
    web: {
      component: AddressWeb,
      editor: {
        component: AddressWebEditor
      },
      configPanel: {
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: {
          minSize: 6
        }
      }
    }
  }
});
var deliveredStatus = [
  "DELIVERED",
  "DELIVERED_TO_NEIGHBOUR",
  "COLLECTED_AT_PICKUP"
];
var arrivedStatus = [
  ...deliveredStatus,
  "AVAILABLE_FOR_PICKUP",
  "WAITING_AT_PICKUP_POINT",
  "WAITING_AT_PICKUP_POINT_SEVERE",
  "DISPATCHED_TO_OTHER_PICKUP_POINT"
];
var localesMap = {
  fr: fr$1,
  en: enUS,
  es: es$1,
  de: de$1
};
function getDateFnsLocale(customerLocale) {
  return localesMap[customerLocale] || enUS;
}
function findDeliveredEvent(parcel) {
  return parcel.events.find((event) => deliveredStatus.includes(event.status));
}
function findArrivedEvent(parcel) {
  return parcel.events.find((event) => arrivedStatus.includes(event.status));
}
function formatDeliveryDateWindow(minimumDate, maximumDate, customerLocale, translations2) {
  const dateFnsLocale = getDateFnsLocale(customerLocale);
  const min3 = format(minimumDate, "d MMM", { locale: dateFnsLocale });
  const max3 = format(maximumDate, "d MMM yyyy", { locale: dateFnsLocale });
  return `${translations2.from} ${min3} ${translations2.to} ${max3}`;
}
function EstimatedDeliveryDateEmailRenderer({
  block,
  parcel,
  theme,
  section,
  locale,
  defaultLocale
}) {
  const alignment = block?.alignment || "center";
  const wrap2 = block?.properties?.wrap ?? false;
  const t2 = tLayout(locale, defaultLocale);
  const dateWindow = parcel?.estimatedDeliveryDateWindow;
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  if (!dateWindow) return null;
  const { exactDeliveryDay, minimumDeliveryDate, maximumDeliveryDate } = dateWindow;
  const customerLocale = locale || parcel?.customerLocale || defaultLocale;
  const dateFnsLocale = getDateFnsLocale(customerLocale);
  const deliveredEvent = findDeliveredEvent(parcel);
  const alignmentClasses = {
    "text-left": alignment === "left",
    "text-center": alignment === "center",
    "text-right": alignment === "right"
  };
  if (deliveredEvent) {
    const deliveredDate = format(
      deliveredEvent?.createdAt || /* @__PURE__ */ new Date(),
      "d MMMM yyyy",
      { locale: dateFnsLocale }
    );
    return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
      Column,
      {
        className: cn("rounded-lg", `bg-[${colors.bg}]`, alignmentClasses),
        children: wrap2 ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Text$1,
            {
              className: cn("w-full font-medium m-0", alignmentClasses),
              style: { margin: 0, color: colors.text },
              children: t2("tracking.shared.deliveredOn")
            }
          ),
          /* @__PURE__ */ jsx(
            Text$1,
            {
              className: cn(
                "w-full text-md font-semibold m-0",
                alignmentClasses
              ),
              style: { margin: 0, color: colors.text },
              children: deliveredDate
            }
          )
        ] }) : /* @__PURE__ */ jsxs(
          Text$1,
          {
            className: cn("w-full font-medium m-0", alignmentClasses),
            style: { margin: 0, color: colors.text },
            children: [
              t2("tracking.shared.deliveredOn"),
              " ",
              deliveredDate
            ]
          }
        )
      }
    ) });
  }
  const arrivedEvent = findArrivedEvent(parcel);
  if (arrivedEvent) {
    return null;
  }
  let displayDate = "";
  if (exactDeliveryDay) {
    displayDate = format(exactDeliveryDay, "EEEE d MMMM yyyy", {
      locale: dateFnsLocale
    });
  } else if (minimumDeliveryDate && maximumDeliveryDate) {
    displayDate = formatDeliveryDateWindow(
      minimumDeliveryDate,
      maximumDeliveryDate,
      customerLocale,
      {
        from: t2("tracking.shared.from"),
        to: t2("tracking.shared.to")
      }
    );
  } else if (minimumDeliveryDate) {
    displayDate = format(minimumDeliveryDate, "EEEE d MMMM yyyy", {
      locale: dateFnsLocale
    });
  }
  if (!displayDate?.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
    Column,
    {
      className: cn("rounded-lg", `bg-[${colors.bg}]`, alignmentClasses),
      children: wrap2 ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Text$1,
          {
            className: cn("w-full font-medium m-0", alignmentClasses),
            style: { margin: 0, color: colors.text },
            children: t2("tracking.shared.estimatedDeliveryDate")
          }
        ),
        /* @__PURE__ */ jsx(
          Text$1,
          {
            className: cn(
              "w-full text-md font-semibold m-0",
              alignmentClasses
            ),
            style: { margin: 0, color: colors.text },
            children: displayDate
          }
        )
      ] }) : /* @__PURE__ */ jsxs(
        Text$1,
        {
          className: cn("w-full font-medium m-0", alignmentClasses),
          style: { margin: 0, color: colors.text },
          children: [
            t2("tracking.shared.estimatedDeliveryDate"),
            " ",
            /* @__PURE__ */ jsx("span", { className: "m-0 text-md font-semibold", children: displayDate })
          ]
        }
      )
    }
  ) });
}
function EstimatedDeliveryDateEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(EstimatedDeliveryDateEmailRenderer, { ...props }) });
}
function PanelEstimatedDeliveryDateWrap() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.properties?.wrap ? "on" : "off";
  const handleUpdate = (enabled) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        wrap: enabled
      }
    });
  };
  return /* @__PURE__ */ jsx(
    PanelInlineContent,
    {
      title: t2(
        "editorBlocksLibrary.blocks.estimated-delivery-date.panel.wrap.title",
        "Two lines"
      ),
      children: /* @__PURE__ */ jsxs(
        ToggleGroup2,
        {
          variant: "default",
          type: "single",
          className: "bg-background border shadow",
          value,
          onValueChange: (value2) => {
            if (value2 === "on" || value2 === "off") {
              handleUpdate(value2 === "on");
            }
          },
          children: [
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "on", "aria-label": "Wrap enabled", children: /* @__PURE__ */ jsx(TextWrap, { className: "h-4 w-4" }) }),
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "off", "aria-label": "No wrap", children: /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: t2(
              "editorBlocksLibrary.blocks.estimated-delivery-date.panel.wrap.off",
              "Off"
            ) }) })
          ]
        }
      )
    }
  );
}
function EstimatedDeliveryDateEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelEstimatedDeliveryDateWrap, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "not-translatable", portal: true })
  ] });
}

// ../ui/src/lib/date-window.ts
var hasEstimatedDeliveryDate = (dateWindow) => {
  return !!dateWindow?.exactDeliveryDay || !!(dateWindow?.minimumDeliveryDate && dateWindow?.maximumDeliveryDate);
};
var hasEstimatedDeliveryDateDayOnly = (dateWindow) => {
  return !!dateWindow?.exactDeliveryDay && (!dateWindow?.minimumDeliveryDate || !dateWindow?.maximumDeliveryDate);
};
var hasEstimatedDeliveryDateWindowOnSameDay = (dateWindow) => {
  const minimumDate = new Date(dateWindow?.minimumDeliveryDate ?? 0);
  const maximumDate = new Date(dateWindow?.maximumDeliveryDate ?? 0);
  return minimumDate.getFullYear() === maximumDate.getFullYear() && minimumDate.getMonth() === maximumDate.getMonth() && minimumDate.getDate() === maximumDate.getDate();
};
var hasIdenticalDeliveryTimes = (dateWindow) => {
  const minimumDate = new Date(dateWindow?.minimumDeliveryDate ?? 0);
  const maximumDate = new Date(dateWindow?.maximumDeliveryDate ?? 0);
  return minimumDate.getHours() === maximumDate.getHours() && minimumDate.getMinutes() === maximumDate.getMinutes();
};
var createEstimationDeliveryDateMock = () => {
  const today = /* @__PURE__ */ new Date();
  return {
    exactDeliveryDay: new Date(
      today.getTime() + 5 * 24 * 60 * 60 * 1e3
    ).getTime(),
    minimumDeliveryDate: new Date(
      today.getTime() + 3 * 24 * 60 * 60 * 1e3
    ).getTime(),
    maximumDeliveryDate: new Date(
      today.getTime() + 7 * 24 * 60 * 60 * 1e3
    ).getTime()
  };
};
function EstimatedDeliveryDateWebRenderer({
  parcel,
  locale,
  defaultLocale
}) {
  const t2 = tLayout(locale, defaultLocale);
  const dateWindow = parcel?.estimatedDeliveryDateWindow || createEstimationDeliveryDateMock();
  if (!dateWindow) {
    return null;
  }
  if (parcel) {
    const deliveredEvent = findDeliveredEvent(parcel);
    if (deliveredEvent) {
      const customerLocale = parcel.customerLocale || "en";
      const dateFnsLocale = getDateFnsLocale(customerLocale);
      const deliveredDate = format(deliveredEvent.createdAt, "d MMMM yyyy", {
        locale: dateFnsLocale
      });
      return /* @__PURE__ */ jsxs("p", { className: "text-center text-xs font-medium", children: [
        t2("tracking.shared.deliveredOn"),
        " ",
        deliveredDate
      ] });
    }
    const arrivedEvent = findArrivedEvent(parcel);
    if (arrivedEvent) {
      return null;
    }
  }
  const isDayOnly = hasEstimatedDeliveryDateDayOnly(dateWindow);
  if (isDayOnly && dateWindow.exactDeliveryDay) {
    const dateStr = formatDate(dateWindow.exactDeliveryDay, "dd/MM/yyyy");
    return /* @__PURE__ */ jsxs("p", { className: "text-center text-xs", children: [
      t2("tracking.shared.estimatedDeliveryDate"),
      "\xA0 ",
      dateStr
    ] });
  }
  const isSameDayWindow = hasEstimatedDeliveryDateWindowOnSameDay(dateWindow);
  if (isSameDayWindow && dateWindow.minimumDeliveryDate && dateWindow.maximumDeliveryDate) {
    const day = formatDate(dateWindow.minimumDeliveryDate, "dd/MM/yyyy");
    if (hasIdenticalDeliveryTimes(dateWindow)) {
      return /* @__PURE__ */ jsxs("p", { className: "text-center text-xs", children: [
        t2("tracking.shared.estimatedDeliveryDate"),
        "\xA0 ",
        day
      ] });
    }
    const minStr = formatDate(dateWindow.minimumDeliveryDate, "HH:mm");
    const maxStr = formatDate(dateWindow.maximumDeliveryDate, "HH:mm");
    return /* @__PURE__ */ jsxs("p", { className: "text-center text-xs", children: [
      t2("tracking.shared.estimatedDeliveryDate"),
      "\xA0",
      day,
      " ",
      minStr,
      " - ",
      maxStr
    ] });
  }
  if (dateWindow.minimumDeliveryDate && dateWindow.maximumDeliveryDate) {
    const minStr = formatDate(dateWindow.minimumDeliveryDate, "dd/MM/yyyy");
    const maxStr = formatDate(dateWindow.maximumDeliveryDate, "dd/MM/yyyy");
    return /* @__PURE__ */ jsxs("p", { className: "text-center text-xs", children: [
      t2("tracking.shared.estimatedDeliveryDate"),
      "\xA0",
      minStr,
      " - ",
      maxStr
    ] });
  }
  if (dateWindow.exactDeliveryDay) {
    const dateStr = formatDate(dateWindow.exactDeliveryDay, "dd/MM/yyyy");
    return /* @__PURE__ */ jsxs("p", { className: "text-center text-xs", children: [
      t2("tracking.shared.estimatedDeliveryDate"),
      "\xA0 ",
      dateStr
    ] });
  }
  return null;
}
function EstimatedDeliveryDateWebEditor(props) {
  return /* @__PURE__ */ jsx(EstimatedDeliveryDateWebRenderer, { ...props });
}

// ../editor-blocks-library/src/blocks/estimated-delivery-date/index.tsx
var estimated_delivery_date_default = registerBlock({
  type: "estimated-delivery-date",
  name: "editorBlocksLibrary.blocks.estimated-delivery-date.title",
  description: "editorBlocksLibrary.blocks.estimated-delivery-date.description",
  Icon: CalendarClock,
  category: "tracking" /* TRACKING */,
  hasDynamicContent: true,
  components: {
    email: {
      component: EstimatedDeliveryDateEmailRenderer,
      editor: {
        component: EstimatedDeliveryDateEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: EstimatedDeliveryDateEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    },
    web: {
      component: EstimatedDeliveryDateWebRenderer,
      editor: {
        component: EstimatedDeliveryDateWebEditor
      },
      configPanel: {
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
function getTranslatedName(defaultName, translations2, locale) {
  if (!translations2 || !locale) return defaultName;
  const translation = translations2.find(
    (t2) => {
      const tLocale = t2.locale?.split("-")[0];
      return t2.key === "title" && tLocale === locale && t2.value;
    }
  );
  return translation?.value || defaultName;
}
function LineItem({
  name,
  imageUrl,
  quantity,
  price,
  textColor,
  translations: translations2,
  customerLocale,
  hidePrices
}) {
  const imageRadius = "rounded-lg";
  const displayName = getTranslatedName(name, translations2, customerLocale);
  return /* @__PURE__ */ jsxs(Row, { className: "", children: [
    /* @__PURE__ */ jsx(Column, { className: "w-[64px] p-1", children: /* @__PURE__ */ jsx(
      Img,
      {
        src: imageUrl,
        width: 64,
        height: 64,
        alt: displayName,
        className: cn("w-[64px] h-[64px]", imageRadius, "object-cover")
      }
    ) }),
    /* @__PURE__ */ jsxs(Column, { className: "pl-2", children: [
      /* @__PURE__ */ jsxs(
        Text$1,
        {
          className: "m-0 p-0 leading-[1.4] font-semibold",
          style: { color: textColor },
          children: [
            displayName,
            " x ",
            quantity
          ]
        }
      ),
      !hidePrices && /* @__PURE__ */ jsxs(
        Text$1,
        {
          className: "m-0 p-0 leading-[1.4] opacity-60",
          style: { color: textColor },
          children: [
            price,
            "\u20AC"
          ]
        }
      )
    ] })
  ] });
}
function OrderRecapContainer({
  children,
  contrastColor,
  theme
}) {
  const radius = useEmailThemeRadius(theme, "packageContentTable");
  return /* @__PURE__ */ jsx(Section, { className: radius, children: /* @__PURE__ */ jsx(
    Row,
    {
      className: cn(radius, "border-1 border-solid"),
      style: { borderWidth: 1, borderColor: contrastColor },
      children: /* @__PURE__ */ jsx(Column, { children })
    }
  ) });
}
function PackageContentEmailRenderer({
  block,
  parcel,
  theme,
  section,
  locale
}) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  if (!parcel?.lineItems) {
    return null;
  }
  return /* @__PURE__ */ jsx(Section, { children: /* @__PURE__ */ jsx(OrderRecapContainer, { theme, contrastColor: colors.contrast, children: parcel.lineItems?.map((item, index2) => {
    const itemWithMetadata = item;
    const translations2 = itemWithMetadata.metadata?.translations;
    return /* @__PURE__ */ jsxs(React49__default.Fragment, { children: [
      /* @__PURE__ */ jsx(
        LineItem,
        {
          name: item.name,
          imageUrl: item.imageUrl,
          sku: item.sku,
          quantity: item.quantity,
          price: item.price,
          textColor: colors.text,
          translations: translations2,
          customerLocale: locale,
          hidePrices: block.properties?.hidePrices
        }
      ),
      index2 < parcel.lineItems.length - 1 && /* @__PURE__ */ jsx(
        Hr,
        {
          className: "border",
          style: { borderColor: colors.contrast }
        }
      )
    ] }, item.sku);
  }) }) });
}
function PackageContentEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(PackageContentEmailRenderer, { ...props }) });
}
function PackageContentWeb(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(PackageContentEmailRenderer, { ...props }) });
}
function PackageContentWebEditor(props) {
  return /* @__PURE__ */ jsx(PackageContentWeb, { ...props });
}
function EmailPanelHidePrices() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.properties?.hidePrices ? "on" : "off";
  const handleUpdate = (enabled) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        hidePrices: enabled
      }
    });
  };
  return /* @__PURE__ */ jsx(
    PanelInlineContent,
    {
      title: t2(
        "editorBlocksLibrary.blocks.package-content.panel.hidePrices.title",
        "Hide prices"
      ),
      children: /* @__PURE__ */ jsxs(
        ToggleGroup2,
        {
          variant: "default",
          type: "single",
          className: "bg-background border shadow",
          value,
          onValueChange: (value2) => {
            if (value2 === "on" || value2 === "off") {
              handleUpdate(value2 === "on");
            }
          },
          children: [
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "on", "aria-label": "Hide prices", children: /* @__PURE__ */ jsx(EyeOff, { className: "h-4 w-4" }) }),
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "off", "aria-label": "Show prices", children: /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: t2(
              "editorBlocksLibrary.blocks.package-content.panel.hidePrices.off",
              "Off"
            ) }) })
          ]
        }
      )
    }
  );
}
function PackageContentEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(EmailPanelHidePrices, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "auto", portal: true })
  ] });
}

// ../editor-blocks-library/src/blocks/package-content/index.tsx
var package_content_default = registerBlock({
  type: "package-content",
  name: "editorBlocksLibrary.blocks.package-content.title",
  description: "editorBlocksLibrary.blocks.package-content.description",
  Icon: Package,
  category: "tracking" /* TRACKING */,
  hasDynamicContent: true,
  components: {
    email: {
      component: PackageContentEmailRenderer,
      editor: {
        component: PackageContentEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: PackageContentEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    },
    web: {
      component: PackageContentWeb,
      editor: {
        component: PackageContentWebEditor
      },
      configPanel: {
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: {
          minSize: 6
        }
      }
    }
  }
});
function ParagraphEmailRenderer({
  locale,
  block,
  formatter,
  theme,
  section,
  defaultLocale,
  isEditor = false
}) {
  const content = block.content?.[locale]?.html || block.content?.[defaultLocale]?.html || "";
  const alignment = block.alignment;
  const font = block.font ?? DEFAULT_FONT;
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  let processedHtml = content.replace(/<p([^>]*)><\/p>/g, "<p$1>&nbsp;</p>");
  if (isEditor && processedHtml.trim() === "") {
    processedHtml = "<p>Cliquez pour ajouter du texte</p>";
  }
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(
    "div",
    {
      style: { color: colors.text, fontFamily: font },
      className: cn(
        "font-sans text-sm leading-tight m-0 p-0",
        {
          left: "text-left",
          center: "text-center",
          right: "text-right"
        }[alignment]
      ),
      dangerouslySetInnerHTML: {
        __html: formatter(format_template_default(processedHtml))
      }
    }
  ) }) });
}
function ParagraphEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ParagraphEmailRenderer, { isEditor: true, ...props }) });
}
function ParagraphPanelContent() {
  const editor = useParagraphEditor();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(PanelContent, { title: "Contenu", children: /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx(EmailPanelToolbar, { editor }),
      /* @__PURE__ */ jsx(EditorContent, { editor })
    ] }) }),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelBlockFont, {}),
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "translatable", portal: true })
  ] });
}
function ParagraphEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsx(PanelContainer, { blockProps, children: /* @__PURE__ */ jsx(ParagraphPanelContent, {}, blockProps.locale) });
}
function ParagraphWeb(props) {
  return /* @__PURE__ */ jsx(ParagraphEmailRenderer, { ...props });
}
function ParagraphWebEditor(props) {
  return /* @__PURE__ */ jsx(ParagraphWeb, { ...props, isEditor: true });
}

// ../editor-blocks-library/src/blocks/paragraph/index.tsx
var paragraph_default = registerBlock({
  type: "paragraph",
  name: "editorBlocksLibrary.blocks.paragraph.title",
  description: "editorBlocksLibrary.blocks.paragraph.description",
  Icon: TextAlignStart,
  category: "essentials" /* ESSENTIALS */,
  isTranslated: (locale, block) => {
    const content = block.content;
    const html = content?.[locale]?.html ?? "";
    const hasText = html.replace(/<[^>]+>/g, "").trim().length > 0;
    const hasImage = /<img\b/i.test(html);
    return !!content && (hasText || hasImage);
  },
  components: {
    email: {
      component: ParagraphEmailRenderer,
      editor: {
        component: ParagraphEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ParagraphEmailPanelRenderer
      },
      compatibility: {
        rowBlock: true
      }
    },
    web: {
      component: ParagraphWeb,
      editor: {
        component: ParagraphWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ParagraphEmailPanelRenderer
      },
      compatibility: {
        rowBlock: true
      }
    }
  }
});
function PickupPointBlockEmail({
  theme,
  section,
  isEditor,
  locale,
  defaultLocale
}) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const { getVariableValue } = useVariablesValues();
  const t2 = tLayout(locale, defaultLocale);
  const isPickupPoint = getVariableValue("address.isPickupPoint") === true;
  if (!isPickupPoint && !isEditor) {
    return null;
  }
  const name = getVariableValue("pickupPoint.name") || getVariableValue("address.name");
  const addressLine1 = getVariableValue("pickupPoint.addressLine1");
  if (!addressLine1?.length && !name?.length) {
    return null;
  }
  const openingHours = getVariableValue("pickupPoint.openingHours");
  const formatDayHours = (dayHours) => {
    if (!dayHours || dayHours.length === 0) return t2("pickupPoint.closed");
    return dayHours.map((h2) => `${h2.from} - ${h2.to}`).join(", ");
  };
  const daysOfWeek = [
    { key: "monday", label: t2("pickupPoint.days.monday") },
    { key: "tuesday", label: t2("pickupPoint.days.tuesday") },
    { key: "wednesday", label: t2("pickupPoint.days.wednesday") },
    { key: "thursday", label: t2("pickupPoint.days.thursday") },
    { key: "friday", label: t2("pickupPoint.days.friday") },
    { key: "saturday", label: t2("pickupPoint.days.saturday") },
    { key: "sunday", label: t2("pickupPoint.days.sunday") }
  ];
  return /* @__PURE__ */ jsx(Container, { children: /* @__PURE__ */ jsx(Row, { className: "mb-3", style: { color: colors.text }, children: /* @__PURE__ */ jsxs(Column, { style: { width: "100%", verticalAlign: "top" }, children: [
    /* @__PURE__ */ jsx(
      Text$1,
      {
        style: {
          fontWeight: "bold",
          marginBottom: "8px",
          marginTop: "0",
          fontSize: "14px"
        },
        children: t2("pickupPoint.title")
      }
    ),
    /* @__PURE__ */ jsx(
      Text$1,
      {
        style: {
          fontWeight: "bold",
          margin: "0",
          marginBottom: "4px",
          fontSize: "12px"
        },
        children: name
      }
    ),
    addressLine1 && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Text$1,
        {
          style: { margin: "0", lineHeight: "1.3", fontSize: "11px" },
          children: addressLine1
        }
      ),
      getVariableValue("pickupPoint.addressLine2") && /* @__PURE__ */ jsx(
        Text$1,
        {
          style: { margin: "0", lineHeight: "1.3", fontSize: "11px" },
          children: getVariableValue("pickupPoint.addressLine2")
        }
      ),
      /* @__PURE__ */ jsxs(
        Text$1,
        {
          style: {
            margin: "0",
            lineHeight: "1.3",
            fontSize: "11px",
            marginBottom: "8px"
          },
          children: [
            getVariableValue("pickupPoint.postalCode"),
            " ",
            getVariableValue("pickupPoint.city"),
            ",",
            " ",
            getVariableValue("pickupPoint.countryCode")
          ]
        }
      )
    ] }),
    !!openingHours && !!(openingHours.monday?.length || openingHours.tuesday?.length || openingHours.wednesday?.length || openingHours.thursday?.length || openingHours.friday?.length || openingHours.saturday?.length || openingHours.sunday?.length) && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Text$1,
        {
          style: {
            fontWeight: "bold",
            marginTop: "8px",
            marginBottom: "4px",
            fontSize: "12px"
          },
          children: t2("pickupPoint.openingHours")
        }
      ),
      daysOfWeek.map(({ key, label }) => {
        const hours = openingHours[key];
        return /* @__PURE__ */ jsxs(Row, { style: { marginBottom: "2px" }, children: [
          /* @__PURE__ */ jsx(Column, { style: { width: "40%" }, children: /* @__PURE__ */ jsx(
            Text$1,
            {
              style: {
                margin: "0",
                fontSize: "10px",
                lineHeight: "1.3"
              },
              children: label
            }
          ) }),
          /* @__PURE__ */ jsx(Column, { style: { width: "60%" }, children: /* @__PURE__ */ jsx(
            Text$1,
            {
              style: {
                margin: "0",
                fontSize: "10px",
                lineHeight: "1.3"
              },
              children: formatDayHours(hours)
            }
          ) })
        ] }, key);
      })
    ] }),
    getVariableValue("pickupPoint.addressLine1") && getVariableValue("pickupPoint.postalCode") && getVariableValue("pickupPoint.city") && getVariableValue("pickupPoint.countryCode") && /* @__PURE__ */ jsx(Text$1, { style: { marginTop: "8px", fontSize: "11px" }, children: /* @__PURE__ */ jsx(
      Link,
      {
        href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          `${getVariableValue("pickupPoint.addressLine1")}${getVariableValue("pickupPoint.addressLine2") ? ` ${getVariableValue("pickupPoint.addressLine2")}` : ""} ${getVariableValue("pickupPoint.postalCode")} ${getVariableValue(
            "pickupPoint.city"
          )} ${getVariableValue("pickupPoint.countryCode")}`
        )}`,
        style: {
          color: theme.primaryColor || "#000000",
          textDecoration: "underline"
        },
        children: t2("pickupPoint.directions")
      }
    ) })
  ] }) }) });
}
function PickupPointBlockEditor(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(PickupPointBlockEmail, { ...props, isEditor: true }) });
}
function PickupPointWeb(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(PickupPointBlockEmail, { ...props }) });
}
function PickupPointWebEditor(props) {
  return /* @__PURE__ */ jsx(PickupPointWeb, { ...props });
}
function PickupPointEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(PanelNoSettings, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "auto", portal: true })
  ] });
}

// ../editor-blocks-library/src/blocks/pickup-point/index.tsx
var pickup_point_default = registerBlock({
  type: "pickup-point",
  name: "editorBlocksLibrary.blocks.pickup-point.title",
  description: "editorBlocksLibrary.blocks.pickup-point.description",
  Icon: MapPinHouse,
  category: "tracking" /* TRACKING */,
  hasDynamicContent: true,
  components: {
    email: {
      component: PickupPointBlockEmail,
      editor: {
        component: PickupPointBlockEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: PickupPointEmailPanelRenderer
      }
    },
    web: {
      component: PickupPointWeb,
      editor: {
        component: PickupPointWebEditor
      },
      configPanel: {
        features: {
          delete: true
        }
      }
    }
  }
});
function EditorSubBlockRenderer({
  subBlock,
  blockProps
}) {
  const blockType = subBlock?.type;
  const BlockComponent = getEditorBlockConfig(blockType);
  if (!BlockComponent?.EmailEditor) return null;
  return /* @__PURE__ */ jsx(
    BlockComponent.EmailEditor,
    {
      ...blockProps,
      block: subBlock
    }
  );
}
function ButtonEmailRenderer2({ isEditor, ...blockProps }) {
  const subBlocks = blockProps.block.content?.children || [];
  const layout = blockProps.block.properties?.layout || "6-6";
  const layoutColsCount = layout.split("-").length;
  const verticalAlignment = blockProps.block.properties?.verticalAlignment || "top";
  const stackOnMobile = blockProps.block.properties?.stackOnMobile !== false;
  const verticalAlignValue = {
    top: "top",
    middle: "middle",
    bottom: "bottom"
  }[verticalAlignment];
  const getColumnWidth = (index2) => {
    switch (layout) {
      case "6-6":
        return "50%";
      case "4-4-4":
        return "33.333%";
      case "3-3-3-3":
        return "25%";
      case "8-4":
        return index2 === 0 ? "33.333%" : "66.666%";
      case "4-8":
        return index2 === 0 ? "66.666%" : "33.333%";
      default:
        return `${100 / layoutColsCount}%`;
    }
  };
  return /* @__PURE__ */ jsx(Row, { children: Array.from({ length: layoutColsCount }).map((_, index2) => {
    const subBlock = subBlocks[index2] || null;
    const columnWidth = getColumnWidth(index2);
    return /* @__PURE__ */ jsx(
      Column,
      {
        style: {
          width: columnWidth,
          padding: 0,
          margin: 0,
          verticalAlign: verticalAlignValue
        },
        className: cn(
          stackOnMobile && "stack-on-mobile",
          isEditor && "border border-dashed border-muted-foreground/30 min-h-[60px]"
        ),
        children: subBlock ? /* @__PURE__ */ jsx(EditorSubBlockRenderer, { subBlock, blockProps }) : isEditor ? /* @__PURE__ */ jsx("div", { className: "text-xs text-muted-foreground/50 select-none", children: "Vide" }) : null
      },
      subBlock?.id || `empty-col-${index2}`
    );
  }) });
}
function ButtonEditorRenderer2(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ButtonEmailRenderer2, { isEditor: true, ...props }) });
}
function EmailPanelLayout() {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI } = blockProps;
  const block = blockProps.block;
  const layout = block.properties?.layout ?? "6-6";
  const currentPreset = RowLayoutPresets[layout];
  const handleLayoutChange = useCallback((newLayout) => {
    const newCellSizes = newLayout.split("-").map((size4) => parseInt(size4, 10));
    const currentChildren = block.content?.children || [];
    const filteredChildren = currentChildren.map((child, index2) => {
      if (!child || index2 >= newCellSizes.length) {
        return null;
      }
      const cellSize = newCellSizes[index2];
      const blockConfig = getEditorBlockConfig(child.type);
      const compatibility = blockConfig?.email?.compatibility?.rowBlock;
      if (compatibility === true) {
        return child;
      }
      if (typeof compatibility === "object") {
        const minSize = compatibility.minSize || 1;
        return cellSize >= minSize ? child : null;
      }
      return null;
    });
    formAPI.updateField(`${formAPI.blockPath}.properties.layout`, newLayout);
    formAPI.updateField(`${formAPI.blockPath}.content.children`, filteredChildren);
  }, [formAPI, block.content?.children]);
  const CurrentPreviewComponent = currentPreset.Preview;
  return /* @__PURE__ */ jsx(PanelInlineContent, { title: "Disposition", children: /* @__PURE__ */ jsx("div", { className: "w-full", style: { maxWidth: 120 }, children: /* @__PURE__ */ jsxs(DropdownMenu2, { children: [
    /* @__PURE__ */ jsx(DropdownMenuTrigger2, { asChild: true, children: /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: "w-full p-2 bg-muted/10 rounded border border-border/50 hover:bg-muted/20 transition-colors cursor-pointer",
        children: /* @__PURE__ */ jsx(CurrentPreviewComponent, {})
      }
    ) }),
    /* @__PURE__ */ jsx(DropdownMenuContent2, { align: "start", className: "w-56", children: Object.values(RowLayoutPresets).map((preset) => {
      const PreviewComponent = preset.Preview;
      return /* @__PURE__ */ jsx(
        DropdownMenuItem2,
        {
          onClick: () => handleLayoutChange(preset.id),
          className: "cursor-pointer p-3",
          children: /* @__PURE__ */ jsx(PreviewComponent, {})
        },
        preset.id
      );
    }) })
  ] }) }) });
}
var [createTooltipContext] = createContextScope("Tooltip", [
  createPopperScope
]);
var usePopperScope3 = createPopperScope();
var PROVIDER_NAME = "TooltipProvider";
var TOOLTIP_OPEN = "tooltip.open";
var [TooltipProviderContextProvider, useTooltipProviderContext] = createTooltipContext(PROVIDER_NAME);
var TOOLTIP_NAME = "Tooltip";
var [TooltipContextProvider, useTooltipContext] = createTooltipContext(TOOLTIP_NAME);
var Tooltip = (props) => {
  const {
    __scopeTooltip,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    disableHoverableContent: disableHoverableContentProp,
    delayDuration: delayDurationProp
  } = props;
  const providerContext = useTooltipProviderContext(TOOLTIP_NAME, props.__scopeTooltip);
  const popperScope = usePopperScope3(__scopeTooltip);
  const [trigger, setTrigger] = React49.useState(null);
  const contentId = useId();
  const openTimerRef = React49.useRef(0);
  const disableHoverableContent = disableHoverableContentProp ?? providerContext.disableHoverableContent;
  const delayDuration = delayDurationProp ?? providerContext.delayDuration;
  const wasOpenDelayedRef = React49.useRef(false);
  const [open2, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: (open22) => {
      if (open22) {
        providerContext.onOpen();
        document.dispatchEvent(new CustomEvent(TOOLTIP_OPEN));
      } else {
        providerContext.onClose();
      }
      onOpenChange?.(open22);
    },
    caller: TOOLTIP_NAME
  });
  const stateAttribute = React49.useMemo(() => {
    return open2 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [open2]);
  const handleOpen = React49.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = 0;
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [setOpen]);
  const handleClose = React49.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = 0;
    setOpen(false);
  }, [setOpen]);
  const handleDelayedOpen = React49.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(() => {
      wasOpenDelayedRef.current = true;
      setOpen(true);
      openTimerRef.current = 0;
    }, delayDuration);
  }, [delayDuration, setOpen]);
  React49.useEffect(() => {
    return () => {
      if (openTimerRef.current) {
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
      }
    };
  }, []);
  return /* @__PURE__ */ jsx(Root23, { ...popperScope, children: /* @__PURE__ */ jsx(
    TooltipContextProvider,
    {
      scope: __scopeTooltip,
      contentId,
      open: open2,
      stateAttribute,
      trigger,
      onTriggerChange: setTrigger,
      onTriggerEnter: React49.useCallback(() => {
        if (providerContext.isOpenDelayedRef.current) handleDelayedOpen();
        else handleOpen();
      }, [providerContext.isOpenDelayedRef, handleDelayedOpen, handleOpen]),
      onTriggerLeave: React49.useCallback(() => {
        if (disableHoverableContent) {
          handleClose();
        } else {
          window.clearTimeout(openTimerRef.current);
          openTimerRef.current = 0;
        }
      }, [handleClose, disableHoverableContent]),
      onOpen: handleOpen,
      onClose: handleClose,
      disableHoverableContent,
      children
    }
  ) });
};
Tooltip.displayName = TOOLTIP_NAME;
var TRIGGER_NAME5 = "TooltipTrigger";
var TooltipTrigger = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeTooltip, ...triggerProps } = props;
    const context = useTooltipContext(TRIGGER_NAME5, __scopeTooltip);
    const providerContext = useTooltipProviderContext(TRIGGER_NAME5, __scopeTooltip);
    const popperScope = usePopperScope3(__scopeTooltip);
    const ref = React49.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = React49.useRef(false);
    const hasPointerMoveOpenedRef = React49.useRef(false);
    const handlePointerUp = React49.useCallback(() => isPointerDownRef.current = false, []);
    React49.useEffect(() => {
      return () => document.removeEventListener("pointerup", handlePointerUp);
    }, [handlePointerUp]);
    return /* @__PURE__ */ jsx(Anchor, { asChild: true, ...popperScope, children: /* @__PURE__ */ jsx(
      Primitive.button,
      {
        "aria-describedby": context.open ? context.contentId : void 0,
        "data-state": context.stateAttribute,
        ...triggerProps,
        ref: composedRefs,
        onPointerMove: composeEventHandlers(props.onPointerMove, (event) => {
          if (event.pointerType === "touch") return;
          if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
            context.onTriggerEnter();
            hasPointerMoveOpenedRef.current = true;
          }
        }),
        onPointerLeave: composeEventHandlers(props.onPointerLeave, () => {
          context.onTriggerLeave();
          hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: composeEventHandlers(props.onPointerDown, () => {
          if (context.open) {
            context.onClose();
          }
          isPointerDownRef.current = true;
          document.addEventListener("pointerup", handlePointerUp, { once: true });
        }),
        onFocus: composeEventHandlers(props.onFocus, () => {
          if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: composeEventHandlers(props.onBlur, context.onClose),
        onClick: composeEventHandlers(props.onClick, context.onClose)
      }
    ) });
  }
);
TooltipTrigger.displayName = TRIGGER_NAME5;
var PORTAL_NAME6 = "TooltipPortal";
var [PortalProvider3, usePortalContext3] = createTooltipContext(PORTAL_NAME6, {
  forceMount: void 0
});
var TooltipPortal = (props) => {
  const { __scopeTooltip, forceMount, children, container } = props;
  const context = useTooltipContext(PORTAL_NAME6, __scopeTooltip);
  return /* @__PURE__ */ jsx(PortalProvider3, { scope: __scopeTooltip, forceMount, children: /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(Portal, { asChild: true, container, children }) }) });
};
TooltipPortal.displayName = PORTAL_NAME6;
var CONTENT_NAME7 = "TooltipContent";
var TooltipContent = React49.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext3(CONTENT_NAME7, props.__scopeTooltip);
    const { forceMount = portalContext.forceMount, side = "top", ...contentProps } = props;
    const context = useTooltipContext(CONTENT_NAME7, props.__scopeTooltip);
    return /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: context.disableHoverableContent ? /* @__PURE__ */ jsx(TooltipContentImpl, { side, ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ jsx(TooltipContentHoverable, { side, ...contentProps, ref: forwardedRef }) });
  }
);
var TooltipContentHoverable = React49.forwardRef((props, forwardedRef) => {
  const context = useTooltipContext(CONTENT_NAME7, props.__scopeTooltip);
  const providerContext = useTooltipProviderContext(CONTENT_NAME7, props.__scopeTooltip);
  const ref = React49.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const [pointerGraceArea, setPointerGraceArea] = React49.useState(null);
  const { trigger, onClose } = context;
  const content = ref.current;
  const { onPointerInTransitChange } = providerContext;
  const handleRemoveGraceArea = React49.useCallback(() => {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [onPointerInTransitChange]);
  const handleCreateGraceArea = React49.useCallback(
    (event, hoverTarget) => {
      const currentTarget = event.currentTarget;
      const exitPoint = { x: event.clientX, y: event.clientY };
      const exitSide = getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
      const paddedExitPoints = getPaddedExitPoints(exitPoint, exitSide);
      const hoverTargetPoints = getPointsFromRect(hoverTarget.getBoundingClientRect());
      const graceArea = getHull([...paddedExitPoints, ...hoverTargetPoints]);
      setPointerGraceArea(graceArea);
      onPointerInTransitChange(true);
    },
    [onPointerInTransitChange]
  );
  React49.useEffect(() => {
    return () => handleRemoveGraceArea();
  }, [handleRemoveGraceArea]);
  React49.useEffect(() => {
    if (trigger && content) {
      const handleTriggerLeave = (event) => handleCreateGraceArea(event, content);
      const handleContentLeave = (event) => handleCreateGraceArea(event, trigger);
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return () => {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [trigger, content, handleCreateGraceArea, handleRemoveGraceArea]);
  React49.useEffect(() => {
    if (pointerGraceArea) {
      const handleTrackPointerGrace = (event) => {
        const target = event.target;
        const pointerPosition = { x: event.clientX, y: event.clientY };
        const hasEnteredTarget = trigger?.contains(target) || content?.contains(target);
        const isPointerOutsideGraceArea = !isPointInPolygon2(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) {
          handleRemoveGraceArea();
        } else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      };
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return () => document.removeEventListener("pointermove", handleTrackPointerGrace);
    }
  }, [trigger, content, pointerGraceArea, onClose, handleRemoveGraceArea]);
  return /* @__PURE__ */ jsx(TooltipContentImpl, { ...props, ref: composedRefs });
});
var [VisuallyHiddenContentContextProvider, useVisuallyHiddenContentContext] = createTooltipContext(TOOLTIP_NAME, { isInside: false });
var Slottable = createSlottable("TooltipContent");
var TooltipContentImpl = React49.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeTooltip,
      children,
      "aria-label": ariaLabel,
      onEscapeKeyDown,
      onPointerDownOutside,
      ...contentProps
    } = props;
    const context = useTooltipContext(CONTENT_NAME7, __scopeTooltip);
    const popperScope = usePopperScope3(__scopeTooltip);
    const { onClose } = context;
    React49.useEffect(() => {
      document.addEventListener(TOOLTIP_OPEN, onClose);
      return () => document.removeEventListener(TOOLTIP_OPEN, onClose);
    }, [onClose]);
    React49.useEffect(() => {
      if (context.trigger) {
        const handleScroll2 = (event) => {
          const target = event.target;
          if (target?.contains(context.trigger)) onClose();
        };
        window.addEventListener("scroll", handleScroll2, { capture: true });
        return () => window.removeEventListener("scroll", handleScroll2, { capture: true });
      }
    }, [context.trigger, onClose]);
    return /* @__PURE__ */ jsx(
      DismissableLayer,
      {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown,
        onPointerDownOutside,
        onFocusOutside: (event) => event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ jsxs(
          Content2,
          {
            "data-state": context.stateAttribute,
            ...popperScope,
            ...contentProps,
            ref: forwardedRef,
            style: {
              ...contentProps.style,
              // re-namespace exposed content custom properties
              ...{
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
              }
            },
            children: [
              /* @__PURE__ */ jsx(Slottable, { children }),
              /* @__PURE__ */ jsx(VisuallyHiddenContentContextProvider, { scope: __scopeTooltip, isInside: true, children: /* @__PURE__ */ jsx(Root5, { id: context.contentId, role: "tooltip", children: ariaLabel || children }) })
            ]
          }
        )
      }
    );
  }
);
TooltipContent.displayName = CONTENT_NAME7;
var ARROW_NAME5 = "TooltipArrow";
var TooltipArrow = React49.forwardRef(
  (props, forwardedRef) => {
    const { __scopeTooltip, ...arrowProps } = props;
    const popperScope = usePopperScope3(__scopeTooltip);
    const visuallyHiddenContentContext = useVisuallyHiddenContentContext(
      ARROW_NAME5,
      __scopeTooltip
    );
    return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ jsx(Arrow2, { ...popperScope, ...arrowProps, ref: forwardedRef });
  }
);
TooltipArrow.displayName = ARROW_NAME5;
function getExitSideFromRect(point, rect) {
  const top2 = Math.abs(rect.top - point.y);
  const bottom2 = Math.abs(rect.bottom - point.y);
  const right2 = Math.abs(rect.right - point.x);
  const left2 = Math.abs(rect.left - point.x);
  switch (Math.min(top2, bottom2, right2, left2)) {
    case left2:
      return "left";
    case right2:
      return "right";
    case top2:
      return "top";
    case bottom2:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
  const paddedExitPoints = [];
  switch (exitSide) {
    case "top":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y + padding },
        { x: exitPoint.x + padding, y: exitPoint.y + padding }
      );
      break;
    case "bottom":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y - padding },
        { x: exitPoint.x + padding, y: exitPoint.y - padding }
      );
      break;
    case "left":
      paddedExitPoints.push(
        { x: exitPoint.x + padding, y: exitPoint.y - padding },
        { x: exitPoint.x + padding, y: exitPoint.y + padding }
      );
      break;
    case "right":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y - padding },
        { x: exitPoint.x - padding, y: exitPoint.y + padding }
      );
      break;
  }
  return paddedExitPoints;
}
function getPointsFromRect(rect) {
  const { top: top2, right: right2, bottom: bottom2, left: left2 } = rect;
  return [
    { x: left2, y: top2 },
    { x: right2, y: top2 },
    { x: right2, y: bottom2 },
    { x: left2, y: bottom2 }
  ];
}
function isPointInPolygon2(point, polygon) {
  const { x, y } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const ii = polygon[i];
    const jj = polygon[j];
    const xi = ii.x;
    const yi = ii.y;
    const xj = jj.x;
    const yj = jj.y;
    const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function getHull(points) {
  const newPoints = points.slice();
  newPoints.sort((a, b) => {
    if (a.x < b.x) return -1;
    else if (a.x > b.x) return 1;
    else if (a.y < b.y) return -1;
    else if (a.y > b.y) return 1;
    else return 0;
  });
  return getHullPresorted(newPoints);
}
function getHullPresorted(points) {
  if (points.length <= 1) return points.slice();
  const upperHull = [];
  for (let i = 0; i < points.length; i++) {
    const p = points[i];
    while (upperHull.length >= 2) {
      const q = upperHull[upperHull.length - 1];
      const r2 = upperHull[upperHull.length - 2];
      if ((q.x - r2.x) * (p.y - r2.y) >= (q.y - r2.y) * (p.x - r2.x)) upperHull.pop();
      else break;
    }
    upperHull.push(p);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i = points.length - 1; i >= 0; i--) {
    const p = points[i];
    while (lowerHull.length >= 2) {
      const q = lowerHull[lowerHull.length - 1];
      const r2 = lowerHull[lowerHull.length - 2];
      if ((q.x - r2.x) * (p.y - r2.y) >= (q.y - r2.y) * (p.x - r2.x)) lowerHull.pop();
      else break;
    }
    lowerHull.push(p);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) {
    return upperHull;
  } else {
    return upperHull.concat(lowerHull);
  }
}
var Root33 = Tooltip;
var Trigger5 = TooltipTrigger;
var Portal5 = TooltipPortal;
var Content25 = TooltipContent;
var Tooltip2 = Root33;
var TooltipTrigger2 = Trigger5;
var TooltipContent2 = React49.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(Portal5, { children: /* @__PURE__ */ jsx(
  Content25,
  {
    ref,
    sideOffset,
    className: cn(
      "z-50 overflow-hidden bg-primary rounded-md px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
) }));
TooltipContent2.displayName = Content25.displayName;
function useLibraryCompatibleBlocks(platform2, cellSize) {
  const blocks = useMemo(() => {
    return Object.values(editorBlocksLibrary).filter((b) => !!b?.config?.Icon).filter((b) => {
      const compatibility = b?.[platform2]?.compatibility?.rowBlock;
      if (compatibility === true) return true;
      if (typeof compatibility === "object") {
        if (!cellSize) return true;
        return cellSize >= (compatibility.minSize || 1);
      }
      return false;
    });
  }, [editorBlocksLibrary, cellSize]);
  return blocks || [];
}
function EmailPanelSubBlocks() {
  const { block } = useBlockPanelPropsContext();
  const [selectedTab, setSelectedTab] = useState(0);
  const layoutId = block.properties?.layout || "6-6";
  const subBlock = block.content?.children?.[selectedTab] || null;
  useEffect(() => {
    {
      const layoutCellsCount = layoutId.split("-").length;
      if (selectedTab >= layoutCellsCount) {
        setSelectedTab(layoutCellsCount - 1);
      }
    }
  }, [layoutId]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      SubBlocksTabs,
      {
        selectedTab,
        setSelectedTab
      }
    ),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsxs("div", { className: "bg-muted/50", children: [
      /* @__PURE__ */ jsx(BlockSelector, { subBlock, blockIndex: selectedTab }),
      !!subBlock && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
        /* @__PURE__ */ jsx(SubBlockPanel, { block: subBlock, blockIndex: selectedTab })
      ] })
    ] })
  ] });
}
function SubBlockPanel({
  block,
  blockIndex
}) {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const blockType = block?.type;
  const blockConfig = getEditorBlockConfig(blockType);
  const formAPI = useSubBlockFormApi(blockIndex);
  if (!blockType || !blockConfig?.EmailConfigPanel) {
    return /* @__PURE__ */ jsx("div", { className: "p-2 text-sm text-muted-foreground", children: t2(
      "editorBlocksLibrary.blocks.row.panel.subBlocks.noSettings",
      "No settings available for this block."
    ) });
  }
  const EmailPanel = blockConfig.EmailConfigPanel;
  return /* @__PURE__ */ jsx(
    EmailPanel,
    {
      ...blockProps,
      block,
      index: blockIndex,
      formAPI,
      isWrapped: true
    }
  );
}
function BlockSelector({
  subBlock,
  blockIndex
}) {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const { formAPI, block } = useBlockPanelPropsContext();
  const layoutId = block.properties?.layout || "6-6";
  const currentCellSize = parseInt(layoutId.split("-")[blockIndex], 10);
  const blocks = useLibraryCompatibleBlocks("email", currentCellSize);
  const handleInsert = (blockType) => {
    const properties = {};
    const subBlocks = block.content?.children || [];
    subBlocks[blockIndex] = {
      id: crypto.randomUUID(),
      type: blockType,
      alignment: "center",
      properties
    };
    formAPI.updateField(`${formAPI.blockPath}.content`, {
      ...block.content,
      children: subBlocks
    });
  };
  const handleRemove = () => {
    const subBlocks = block.content?.children || [];
    subBlocks[blockIndex] = null;
    formAPI.updateField(`${formAPI.blockPath}.content`, {
      ...block.content,
      children: subBlocks
    });
  };
  if (!subBlock) {
    return /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-2 p-2", children: [
      /* @__PURE__ */ jsx("div", { className: "w-full text-xs text-muted-foreground", children: t2(
        "editorBlocksLibrary.blocks.row.panel.subBlocks.selectBlock",
        "Select a block"
      ) }),
      blocks.map((b) => {
        const Icon3 = b.config.Icon;
        return /* @__PURE__ */ jsxs(Tooltip2, { children: [
          /* @__PURE__ */ jsx(TooltipTrigger2, { children: /* @__PURE__ */ jsx(
            "div",
            {
              className: "flex items-center justify-center p-2 border border-dashed border-border rounded-md text-sm text-muted-foreground hover:bg-accent hover:text-accent-foreground cursor-pointer",
              onClick: () => handleInsert(b.config.type),
              children: /* @__PURE__ */ jsx(Icon3, { className: "inline h-4 w-4" })
            }
          ) }),
          /* @__PURE__ */ jsx(TooltipContent2, { children: t2(b?.config.name || "") })
        ] }, b?.config.type);
      })
    ] });
  }
  const blockConfig = getEditorBlockConfig(subBlock.type);
  return /* @__PURE__ */ jsx(
    PanelInlineContent,
    {
      largeTitle: true,
      title: t2(blockConfig?.config.name || ""),
      Icon: blockConfig?.config.Icon,
      children: /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          className: "h-6 w-6 p-0",
          onClick: handleRemove,
          children: /* @__PURE__ */ jsx(CircleMinus, { className: "h-3.5 w-3.5" })
        }
      )
    }
  );
}
function SubBlocksTabs({
  selectedTab,
  setSelectedTab
}) {
  const blockProps = useBlockPanelPropsContext();
  const layoutId = blockProps.block.properties?.layout || "6-6";
  const p = RowLayoutPresets[layoutId];
  const Preview4 = p.Preview;
  return /* @__PURE__ */ jsx(FloatingPanelContent, { className: "pb-0 pt-4 mb-2", children: /* @__PURE__ */ jsx(
    Preview4,
    {
      displayLabels: true,
      className: "h-6 cursor-pointer",
      selectedIndex: selectedTab,
      onSelect: setSelectedTab
    }
  ) });
}
function useSubBlockFormApi(index2) {
  const {
    formAPI,
    index: parentIndex,
    section
  } = useBlockPanelPropsContext();
  const blockPath = `content.${section}Blocks.${parentIndex}.content.children.${index2}`;
  return useMemo(
    () => ({
      blockPath,
      updateField: (path, value) => {
        formAPI.updateField(path, value);
      },
      getFieldValue: (path) => formAPI.getFieldValue(path),
      registerImage: (imageUploadKey, file) => {
        formAPI.registerImage(imageUploadKey, file);
      }
    }),
    [formAPI, blockPath]
  );
}
function PanelRowVerticalAlignment() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.properties?.verticalAlignment || "top";
  const handleUpdate = (verticalAlignment) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        verticalAlignment
      }
    });
  };
  return /* @__PURE__ */ jsx(PanelInlineContent, { title: t2("editorBlocksLibrary.blocks.row.panel.verticalAlignment.title", "Vertical alignment"), children: /* @__PURE__ */ jsxs(
    ToggleGroup2,
    {
      variant: "default",
      type: "single",
      className: "bg-background border shadow",
      value,
      onValueChange: (value2) => {
        if (value2 && (value2 === "top" || value2 === "middle" || value2 === "bottom")) {
          handleUpdate(value2);
        }
      },
      children: [
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "top", "aria-label": "Toggle align top", children: /* @__PURE__ */ jsx(AlignVerticalJustifyStart, { className: "h-4 w-4" }) }),
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "middle", "aria-label": "Toggle align middle", children: /* @__PURE__ */ jsx(AlignVerticalJustifyCenter, { className: "h-4 w-4" }) }),
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "bottom", "aria-label": "Toggle align bottom", children: /* @__PURE__ */ jsx(AlignVerticalJustifyEnd, { className: "h-4 w-4" }) })
      ]
    }
  ) });
}
function PanelRowStackOnMobile() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.properties?.stackOnMobile !== false ? "on" : "off";
  const handleUpdate = (enabled) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        stackOnMobile: enabled
      }
    });
  };
  return /* @__PURE__ */ jsx(PanelInlineContent, { title: t2("editorBlocksLibrary.blocks.row.panel.stackOnMobile.title", "Stack on mobile"), children: /* @__PURE__ */ jsxs(
    ToggleGroup2,
    {
      variant: "default",
      type: "single",
      className: "bg-background border shadow",
      value,
      onValueChange: (value2) => {
        if (value2 === "on" || value2 === "off") {
          handleUpdate(value2 === "on");
        }
      },
      children: [
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "on", "aria-label": "Stack on mobile", children: /* @__PURE__ */ jsx(Smartphone, { className: "h-4 w-4" }) }),
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "off", "aria-label": "No stacking", children: /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: t2("editorBlocksLibrary.blocks.row.panel.stackOnMobile.off", "Off") }) })
      ]
    }
  ) });
}
function ButtonEmailPanelRenderer2(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(EmailPanelLayout, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelRowVerticalAlignment, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelRowStackOnMobile, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(EmailPanelSubBlocks, {})
  ] });
}
function RowWeb(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ButtonEmailRenderer2, { ...props }) });
}
function RowWebEditor(props) {
  return /* @__PURE__ */ jsx(RowWeb, { ...props });
}
function Column14({ index: index2, size: size4, active = false, onClick, displayLabel }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "flex-1 rounded border transition-colors items-center flex p-1",
        onClick && "cursor-pointer"
      ),
      style: {
        maxWidth: size4 ? `${size4}%` : void 0,
        background: active ? "var(--primary)" : "var(--muted)"
      },
      onClick,
      children: displayLabel && /* @__PURE__ */ jsxs("div", { className: "text-[10px] text-center select-none", style: {
        color: active ? "#fff" : "var(--muted-foreground)"
      }, children: [
        "Bloc ",
        index2 + 1
      ] })
    }
  );
}
function LayoutContainer({ className, children }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "flex gap-1 w-full h-4",
        className
      ),
      children
    }
  );
}
function Layout66Preview({ className, selectedIndex, onSelect, displayLabels }) {
  const handleClick2 = (index2) => () => onSelect?.(index2);
  return /* @__PURE__ */ jsxs(LayoutContainer, { className, children: [
    /* @__PURE__ */ jsx(Column14, { index: 0, active: selectedIndex === 0, onClick: handleClick2(0), displayLabel: displayLabels }),
    /* @__PURE__ */ jsx(Column14, { index: 1, active: selectedIndex === 1, onClick: handleClick2(1), displayLabel: displayLabels })
  ] });
}
function Layout444Preview({ className, selectedIndex, onSelect, displayLabels }) {
  const handleClick2 = (index2) => () => onSelect?.(index2);
  return /* @__PURE__ */ jsxs(LayoutContainer, { className, children: [
    /* @__PURE__ */ jsx(Column14, { index: 0, active: selectedIndex === 0, onClick: handleClick2(0), displayLabel: displayLabels }),
    /* @__PURE__ */ jsx(Column14, { index: 1, active: selectedIndex === 1, onClick: handleClick2(1), displayLabel: displayLabels }),
    /* @__PURE__ */ jsx(Column14, { index: 2, active: selectedIndex === 2, onClick: handleClick2(2), displayLabel: displayLabels })
  ] });
}
function Layout3333Preview({ className, selectedIndex, onSelect, displayLabels }) {
  const handleClick2 = (index2) => () => onSelect?.(index2);
  return /* @__PURE__ */ jsxs(LayoutContainer, { className, children: [
    /* @__PURE__ */ jsx(Column14, { index: 0, active: selectedIndex === 0, onClick: handleClick2(0), displayLabel: displayLabels }),
    /* @__PURE__ */ jsx(Column14, { index: 1, active: selectedIndex === 1, onClick: handleClick2(1), displayLabel: displayLabels }),
    /* @__PURE__ */ jsx(Column14, { index: 2, active: selectedIndex === 2, onClick: handleClick2(2), displayLabel: displayLabels }),
    /* @__PURE__ */ jsx(Column14, { index: 3, active: selectedIndex === 3, onClick: handleClick2(3), displayLabel: displayLabels })
  ] });
}
function Layout84Preview({ className, selectedIndex, onSelect, displayLabels }) {
  const handleClick2 = (index2) => () => onSelect?.(index2);
  return /* @__PURE__ */ jsxs(LayoutContainer, { className, children: [
    /* @__PURE__ */ jsx(Column14, { index: 0, size: 30, active: selectedIndex === 0, onClick: handleClick2(0), displayLabel: displayLabels }),
    /* @__PURE__ */ jsx(Column14, { index: 1, active: selectedIndex === 1, onClick: handleClick2(1), displayLabel: displayLabels })
  ] });
}
function Layout48Preview({ className, selectedIndex, onSelect, displayLabels }) {
  const handleClick2 = (index2) => () => onSelect?.(index2);
  return /* @__PURE__ */ jsxs(LayoutContainer, { className, children: [
    /* @__PURE__ */ jsx(Column14, { index: 0, active: selectedIndex === 0, onClick: handleClick2(0), displayLabel: displayLabels }),
    /* @__PURE__ */ jsx(Column14, { index: 1, size: 30, active: selectedIndex === 1, onClick: handleClick2(1), displayLabel: displayLabels })
  ] });
}

// ../editor-blocks-library/src/blocks/row/index.tsx
var RowLayoutPresets = {
  "6-6": {
    id: "6-6",
    name: "2 colonnes \xE9gales",
    Preview: Layout66Preview
  },
  "4-4-4": {
    id: "4-4-4",
    name: "3 colonnes \xE9gales",
    Preview: Layout444Preview
  },
  "3-3-3-3": {
    id: "3-3-3-3",
    name: "4 colonnes \xE9gales",
    Preview: Layout3333Preview
  },
  "8-4": {
    id: "8-4",
    name: "2 colonnes (large/\xE9troit)",
    Preview: Layout84Preview
  },
  "4-8": {
    id: "4-8",
    name: "2 colonnes (\xE9troit/large)",
    Preview: Layout48Preview
  }
};
var row_default = registerBlock({
  type: "row",
  name: "editorBlocksLibrary.blocks.row.title",
  description: "editorBlocksLibrary.blocks.row.description",
  Icon: Columns2,
  category: "layout" /* LAYOUT */,
  isTranslated: (locale, block) => {
    const children = block.content?.children;
    if (!children?.length) {
      return true;
    }
    return children.every((child) => isBlockTranslated(locale, child));
  },
  components: {
    email: {
      component: ButtonEmailRenderer2,
      editor: {
        component: ButtonEditorRenderer2
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ButtonEmailPanelRenderer2
      },
      compatibility: {
        rowBlock: false
      }
    },
    web: {
      component: RowWeb,
      editor: {
        component: RowWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ButtonEmailPanelRenderer2
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
var STAR_COUNT = 5;
var STAR_SIZE = 32;
function RateOrderEmailRenderer({
  block,
  theme,
  isEditor
}) {
  const alignment = block.alignment || "center";
  const { getVariableValue } = useVariablesValues();
  const reviewUrl = getVariableValue("parcel.reviewUrl") ?? "";
  if (!reviewUrl && !isEditor) {
    return null;
  }
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
    Column,
    {
      className: cn({
        "text-left": alignment === "left",
        "text-center": alignment === "center",
        "text-right": alignment === "right"
      }),
      children: Array.from({ length: STAR_COUNT }, (_, index2) => {
        const rating = index2 + 1;
        const href = reviewUrl ? `${reviewUrl}${reviewUrl.includes("?") ? "&" : "?"}rating=${rating}` : "#";
        return /* @__PURE__ */ jsx(
          Link,
          {
            href,
            style: {
              display: "inline-block",
              margin: "0 4px",
              textDecoration: "none",
              lineHeight: 0
            },
            children: /* @__PURE__ */ jsx(StarIcon, { color: theme?.primaryColor ?? "#f5b301" })
          },
          rating
        );
      })
    }
  ) });
}
function StarIcon({ color }) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: STAR_SIZE,
      height: STAR_SIZE,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 2.5l2.9 6.55 7.1.69-5.33 4.88 1.52 6.98L12 18.27l-6.19 3.33 1.52-6.98L2 9.74l7.1-.69L12 2.5z",
          fill: color,
          stroke: color,
          strokeWidth: "1",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function RateOrderEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx("div", { className: "[&_a]:pointer-events-none [&_a]:cursor-default", children: /* @__PURE__ */ jsx(RateOrderEmailRenderer, { isEditor: true, ...props }) }) });
}
function RateOrderEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsx(PanelContainer, { blockProps, children: /* @__PURE__ */ jsx(PanelBlockAlignment, {}) });
}
var STAR_COUNT2 = 5;
var STAR_SIZE2 = 32;
function RateOrderWeb({
  block,
  theme,
  isEditor
}) {
  const alignment = block.alignment || "center";
  const { getVariableValue } = useVariablesValues();
  const reviewUrl = getVariableValue("parcel.reviewUrl") ?? "";
  if (!reviewUrl && !isEditor) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("flex items-center gap-2", {
        "justify-start": alignment === "left",
        "justify-center": alignment === "center",
        "justify-end": alignment === "right"
      }),
      children: Array.from({ length: STAR_COUNT2 }, (_, index2) => {
        const rating = index2 + 1;
        const href = reviewUrl ? `${reviewUrl}${reviewUrl.includes("?") ? "&" : "?"}rating=${rating}` : "#";
        return /* @__PURE__ */ jsx(
          "a",
          {
            href,
            className: cn(
              "inline-flex leading-none transition-opacity hover:opacity-80",
              isEditor && "pointer-events-none"
            ),
            "aria-label": `${rating} / ${STAR_COUNT2}`,
            children: /* @__PURE__ */ jsx(StarIcon2, { color: theme?.primaryColor ?? "#f5b301" })
          },
          rating
        );
      })
    }
  );
}
function StarIcon2({ color }) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: STAR_SIZE2,
      height: STAR_SIZE2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 2.5l2.9 6.55 7.1.69-5.33 4.88 1.52 6.98L12 18.27l-6.19 3.33 1.52-6.98L2 9.74l7.1-.69L12 2.5z",
          fill: color,
          stroke: color,
          strokeWidth: "1",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function RateOrderWebEditor(props) {
  return /* @__PURE__ */ jsx(RateOrderWeb, { isEditor: true, ...props });
}

// ../editor-blocks-library/src/blocks/rate-order/index.tsx
var rate_order_default = registerBlock({
  type: "rate-order",
  name: "editorBlocksLibrary.blocks.rate-order.title",
  description: "editorBlocksLibrary.blocks.rate-order.description",
  Icon: Star,
  category: "tracking" /* TRACKING */,
  components: {
    email: {
      component: RateOrderEmailRenderer,
      editor: {
        component: RateOrderEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: RateOrderEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    },
    web: {
      component: RateOrderWeb,
      editor: {
        component: RateOrderWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: RateOrderEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
function SeparatorEmailRenderer({ theme, section, block }) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const margin = mapSeparatorSpacingToPixels(block.properties?.spacing);
  const isInvisible = block.properties?.invisible;
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(Hr, { className: cn("w-full"), style: {
    borderColor: colors.contrast,
    marginTop: margin,
    marginBottom: margin,
    opacity: isInvisible ? 0 : 1
  } }) }) });
}
function SeparatorEditorRenderer(buttonProps) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: buttonProps.shop, children: /* @__PURE__ */ jsx(SeparatorEmailRenderer, { ...buttonProps }) });
}
function SeparatorWeb(buttonProps) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: buttonProps.shop, children: /* @__PURE__ */ jsx(SeparatorEmailRenderer, { ...buttonProps }) });
}
function SeparatorWebEditor(props) {
  return /* @__PURE__ */ jsx(SeparatorWeb, { ...props });
}
function EmailPanelVerticalSpacing() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.properties?.spacing || "default";
  const handleUpdate = (spacing) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        spacing
      }
    });
  };
  return /* @__PURE__ */ jsx(PanelInlineContent, { title: t2("editorBlocksLibrary.blocks.separator.panel.spacing.title", "Spacing"), children: /* @__PURE__ */ jsxs(
    ToggleGroup2,
    {
      variant: "default",
      type: "single",
      className: "bg-background border shadow",
      value,
      onValueChange: handleUpdate,
      children: [
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "small", "aria-label": "Toggle small spacing", className: "text-xs", children: t2("editorBlocksLibrary.blocks.separator.panel.spacing.small", "Petit") }),
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "default", "aria-label": "Toggle normal spacing", className: "text-xs", children: t2("editorBlocksLibrary.blocks.separator.panel.spacing.default", "Normal") }),
        /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "large", "aria-label": "Toggle large spacing", className: "text-xs", children: t2("editorBlocksLibrary.blocks.separator.panel.spacing.large", "Large") })
      ]
    }
  ) });
}
function EmailPanelInvisible() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.properties?.invisible ? "on" : "off";
  const handleUpdate = (enabled) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        invisible: enabled
      }
    });
  };
  return /* @__PURE__ */ jsx(
    PanelInlineContent,
    {
      title: t2(
        "editorBlocksLibrary.blocks.separator.panel.invisible.title",
        "Invisible"
      ),
      children: /* @__PURE__ */ jsxs(
        ToggleGroup2,
        {
          variant: "default",
          type: "single",
          className: "bg-background border shadow",
          value,
          onValueChange: (value2) => {
            if (value2 === "on" || value2 === "off") {
              handleUpdate(value2 === "on");
            }
          },
          children: [
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "on", "aria-label": "Invisible", children: /* @__PURE__ */ jsx(EyeOff, { className: "h-4 w-4" }) }),
            /* @__PURE__ */ jsx(ToggleGroupItem2, { value: "off", "aria-label": "Visible", children: /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: t2(
              "editorBlocksLibrary.blocks.separator.panel.invisible.off",
              "Off"
            ) }) })
          ]
        }
      )
    }
  );
}
function SeparatorEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(EmailPanelVerticalSpacing, {}),
    /* @__PURE__ */ jsx(EmailPanelInvisible, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "not-translatable", portal: true })
  ] });
}

// ../editor-blocks-library/src/blocks/separator/index.tsx
function mapSeparatorSpacingToPixels(spacing) {
  switch (spacing) {
    case "small":
      return 12;
    case "default":
      return 24;
    case "large":
      return 40;
    default:
      return 24;
  }
}
var separator_default = registerBlock({
  type: "separator",
  name: "editorBlocksLibrary.blocks.separator.title",
  description: "editorBlocksLibrary.blocks.separator.description",
  Icon: Minus,
  category: "layout" /* LAYOUT */,
  components: {
    email: {
      component: SeparatorEmailRenderer,
      editor: {
        component: SeparatorEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: SeparatorEmailPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    },
    web: {
      component: SeparatorWeb,
      editor: {
        component: SeparatorWebEditor
      },
      configPanel: {
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});

// ../ui/src/lib/social-icons.ts
var BASE_URL = "https://baback-public-logo.s3.eu-west-3.amazonaws.com/external/";
var getSocialIconGlyphUrl = (icon, color = "black") => {
  return `${BASE_URL}${icon}-glyph-${color}.png`;
};

// ../editor-blocks-library/src/blocks/social-networks/social-badge-style.ts
var DEFAULT_SURFACE = {
  background: "#f0f0f0",
  card: "#ffffff"
};
var DEFAULT_PRIMARY = "#000000";
var DEFAULT_SECONDARY = "#000000";
function safeContrast(color) {
  try {
    return getContrastText(color) === "#fff" ? "#fff" : "#000";
  } catch {
    return "#000";
  }
}
function surfaceColor(theme, section) {
  if (section === "inside") {
    return theme?.cardColor ?? DEFAULT_SURFACE.card;
  }
  return theme?.backgroundColor ?? DEFAULT_SURFACE.background;
}
function getSocialBadgeStyle(theme, section, variant, color) {
  let backgroundColor;
  if (color === "primary") {
    backgroundColor = theme?.primaryColor ?? DEFAULT_PRIMARY;
  } else if (color === "secondary") {
    backgroundColor = theme?.secondaryColor ?? DEFAULT_SECONDARY;
  } else {
    backgroundColor = safeContrast(surfaceColor(theme, section)) === "#fff" ? "#ffffff" : "#000000";
  }
  return {
    backgroundColor,
    glyphColor: safeContrast(backgroundColor) === "#fff" ? "white" : "black",
    borderRadiusClass: variant === "square" ? getThemeRadius(theme, "button" /* BUTTON */) : "rounded-full"
  };
}
function SocialNetworksEmailRenderer({
  block,
  shop,
  section = "inside",
  theme
}) {
  const alignment = block.alignment || "center";
  const variant = block.properties?.variant || "circle";
  const color = block.properties?.color || "default";
  const badge = getSocialBadgeStyle(theme, section, variant, color);
  const socialNetworks = useMemo(() => {
    return shop.externalLinks ? Object.entries(shop.externalLinks).filter(([_, link]) => link?.type === "SOCIAL_NETWORK" && link?.url).map(([platform2, link]) => ({
      platform: platform2,
      url: link.url,
      iconUrl: getSocialIconGlyphUrl(platform2, badge.glyphColor)
    })) : [];
  }, [shop.externalLinks, badge.glyphColor]);
  if (socialNetworks.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
    Column,
    {
      className: cn({
        "text-left": alignment === "left",
        "text-center": alignment === "center",
        "text-right": alignment === "right"
      }),
      children: socialNetworks.map(({ platform: platform2, url, iconUrl }) => /* @__PURE__ */ jsx(
        Link,
        {
          href: url,
          className: cn("mx-1", badge.borderRadiusClass),
          style: {
            display: "inline-block",
            textDecoration: "none",
            backgroundColor: badge.backgroundColor,
            padding: "5px",
            lineHeight: 0
          },
          children: /* @__PURE__ */ jsx(
            Img,
            {
              src: iconUrl,
              alt: platform2,
              width: 18,
              height: 18,
              style: {
                display: "block",
                width: "18px",
                height: "18px"
              }
            }
          )
        },
        platform2
      ))
    }
  ) });
}
function SocialNetworksEditorRenderer({
  ...props
}) {
  const { shop } = props;
  const socialNetworks = useMemo(() => {
    return shop.externalLinks ? Object.entries(shop.externalLinks).filter(
      ([_, link]) => link?.type === "SOCIAL_NETWORK" && link?.url
    ) : [];
  }, [shop.externalLinks]);
  if (socialNetworks.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: "w-full flex justify-center", children: /* @__PURE__ */ jsx("div", { className: "text-muted-foreground text-sm px-4 py-2 border border-dashed rounded", children: "Aucun r\xE9seau social configur\xE9" }) });
  }
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(SocialNetworksEmailRenderer, { ...props }) });
}
var PREVIEW_PLATFORM = "instagram";
var VARIANT_OPTIONS2 = ["circle", "square"];
var COLOR_OPTIONS = ["default", "primary", "secondary"];
function SettingsCard2({
  selected,
  onSelect,
  name,
  label,
  preview: preview10
}) {
  return /* @__PURE__ */ jsx("div", { className: "bg-muted/10 rounded-xl p-0 border border-border/50 flex flex-row overflow-hidden cursor-pointer", children: /* @__PURE__ */ jsxs("label", { className: "flex items-center space-x-3 cursor-pointer w-full", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-3 cursor-pointer w-full p-3", children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          type: "radio",
          name,
          checked: selected,
          onChange: onSelect,
          className: "sr-only"
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "w-4 h-4 rounded-full border-2 flex items-center justify-center",
            selected ? "border-primary bg-primary" : "border-muted-foreground"
          ),
          children: selected && /* @__PURE__ */ jsx("div", { className: "w-2 h-2 rounded-full bg-primary-foreground" })
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "flex-1 font-medium text-xs", children: label })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "ml-auto h-full flex items-center pr-3 shrink-0", children: preview10 })
  ] }) });
}
function IconBadgePreview({
  variant,
  color
}) {
  const { theme, section } = useBlockPanelPropsContext();
  const badge = getSocialBadgeStyle(theme, section, variant, color);
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn("shrink-0", badge.borderRadiusClass),
      style: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: badge.backgroundColor,
        padding: "5px",
        lineHeight: 0
      },
      children: /* @__PURE__ */ jsx(
        "img",
        {
          src: getSocialIconGlyphUrl(PREVIEW_PLATFORM, badge.glyphColor),
          alt: "",
          width: 16,
          height: 16,
          style: {
            display: "block",
            flexShrink: 0,
            width: "16px",
            height: "16px",
            maxWidth: "16px",
            objectFit: "contain"
          }
        }
      )
    }
  );
}
function SocialNetworksEmailPanelStyle() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const { formAPI } = blockProps;
  const block = blockProps.block;
  const variant = block.properties?.variant || "circle";
  const color = block.properties?.color || "default";
  const updateProperty = (key, value) => {
    formAPI.updateField(`${formAPI.blockPath}.properties.${key}`, value);
  };
  const variantLabel = {
    circle: t2("editorBlocksLibrary.blocks.social-networks.shape.circle", "Circle"),
    square: t2("editorBlocksLibrary.blocks.social-networks.shape.square", "Square")
  };
  const colorLabel = {
    default: t2("editorBlocksLibrary.blocks.button.variant.default.title", "Default"),
    primary: t2("editorBlocksLibrary.blocks.button.variant.primary.title", "Primary"),
    secondary: t2("editorBlocksLibrary.blocks.button.variant.secondary.title", "Secondary")
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      PanelContent,
      {
        title: t2("editorBlocksLibrary.blocks.social-networks.shape.title", "Shape"),
        children: /* @__PURE__ */ jsx("div", { className: "grid grid-cols-1 gap-3 w-full", children: VARIANT_OPTIONS2.map((option) => /* @__PURE__ */ jsx(
          SettingsCard2,
          {
            name: "social-variant",
            label: variantLabel[option],
            selected: variant === option,
            onSelect: () => updateProperty("variant", option),
            preview: /* @__PURE__ */ jsx(IconBadgePreview, { variant: option, color })
          },
          option
        )) })
      }
    ),
    /* @__PURE__ */ jsx(
      PanelContent,
      {
        title: t2("editorBlocksLibrary.blocks.social-networks.color.title", "Color"),
        children: /* @__PURE__ */ jsx("div", { className: "grid grid-cols-1 gap-3 w-full", children: COLOR_OPTIONS.map((option) => /* @__PURE__ */ jsx(
          SettingsCard2,
          {
            name: "social-color",
            label: colorLabel[option],
            selected: color === option,
            onSelect: () => updateProperty("color", option),
            preview: /* @__PURE__ */ jsx(IconBadgePreview, { variant, color: option })
          },
          option
        )) })
      }
    )
  ] });
}
function SocialNetworksEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(SocialNetworksEmailPanelStyle, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "not-translatable", portal: true })
  ] });
}
function SocialNetworksWeb({ ...props }) {
  const { shop } = props;
  const socialNetworks = useMemo(() => {
    return shop.externalLinks ? Object.entries(shop.externalLinks).filter(
      ([_, link]) => link?.type === "SOCIAL_NETWORK" && link?.url
    ) : [];
  }, [shop.externalLinks]);
  if (socialNetworks.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(SocialNetworksEmailRenderer, { ...props }) });
}
function SocialNetworksWebEditor(props) {
  return /* @__PURE__ */ jsx(SocialNetworksWeb, { ...props });
}

// ../editor-blocks-library/src/blocks/social-networks/index.tsx
var social_networks_default = registerBlock({
  type: "social-networks",
  name: "editorBlocksLibrary.blocks.social-networks.title",
  description: "editorBlocksLibrary.blocks.social-networks.description",
  Icon: Share2,
  category: "essentials" /* ESSENTIALS */,
  components: {
    email: {
      component: SocialNetworksEmailRenderer,
      editor: {
        component: SocialNetworksEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: SocialNetworksEmailPanelRenderer
      }
    },
    web: {
      component: SocialNetworksWeb,
      editor: {
        component: SocialNetworksWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: SocialNetworksEmailPanelRenderer
      }
    }
  }
});
function WalletEmailRenderer({
  block,
  locale,
  appleWalletURL,
  googleWalletURL,
  shop,
  isEditor
}) {
  const t2 = tLayout(locale, "en");
  const appleWalletImageUrl = `https://baback-wallet.s3.eu-west-3.amazonaws.com/apple-buttons/${getImageLocale(locale)}`;
  const googleWalletImageUrl = `https://baback-wallet.s3.eu-west-3.amazonaws.com/google-buttons/${getImageLocale(locale)}`;
  const alignment = block.alignment;
  const alignStyle = {
    left: "left",
    center: "center",
    right: "right"
  }[alignment];
  const isAppleWalletEnabled = isEditor ? shop.trackingPreferences.isAppleWalletEnabled : !!appleWalletURL?.length && !appleWalletURL.includes("undefined") && shop.trackingPreferences.isAppleWalletEnabled;
  const isGoogleWalletEnabled = isEditor ? shop.trackingPreferences.isGoogleWalletEnabled : !!googleWalletURL?.length && !googleWalletURL.includes("undefined") && shop.trackingPreferences.isGoogleWalletEnabled;
  if (!isAppleWalletEnabled && !isGoogleWalletEnabled) {
    if (isEditor) {
      return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { align: alignStyle, children: /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            backgroundColor: "#FEF3C7",
            border: "1px solid #FCD34D",
            borderRadius: "6px",
            padding: "12px 16px",
            margin: "8px 0"
          },
          children: /* @__PURE__ */ jsxs(
            Text$1,
            {
              style: {
                color: "#92400E",
                fontSize: "14px",
                lineHeight: "1.5",
                margin: "0"
              },
              children: [
                "\u26A0\uFE0F ",
                t2("wallet.warningNotEnabled")
              ]
            }
          )
        }
      ) }) });
    }
    return null;
  }
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Column, { align: alignStyle, children: /* @__PURE__ */ jsxs("div", { style: { display: "inline-block", textAlign: alignStyle }, children: [
    isAppleWalletEnabled && /* @__PURE__ */ jsx(
      Link,
      {
        href: appleWalletURL,
        style: {
          display: "inline-block",
          margin: "4px",
          verticalAlign: "middle"
        },
        children: /* @__PURE__ */ jsx(
          Img,
          {
            src: appleWalletImageUrl,
            alt: "Add to Apple Wallet",
            height: "40",
            style: { height: "40px", display: "block", maxWidth: "100%" }
          }
        )
      }
    ),
    isGoogleWalletEnabled && /* @__PURE__ */ jsx(
      Link,
      {
        href: googleWalletURL,
        style: {
          display: "inline-block",
          margin: "4px",
          verticalAlign: "middle"
        },
        children: /* @__PURE__ */ jsx(
          Img,
          {
            src: googleWalletImageUrl,
            alt: "Add to Google Wallet",
            height: "40",
            style: { height: "40px", display: "block", maxWidth: "100%" }
          }
        )
      }
    )
  ] }) }) });
}
function getImageLocale(locale) {
  return ["fr", "en", "es", "de"].includes(locale) ? locale : "en";
}
function WalletEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(WalletEmailRenderer, { ...props, isEditor: true }) });
}
function WalletEmailPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "auto", portal: true })
  ] });
}

// ../editor-blocks-library/src/blocks/wallet/web.tsx
function WalletWeb(props) {
  return null;
}
function WalletWebEditor(props) {
  return /* @__PURE__ */ jsx(WalletWeb, { ...props });
}

// ../editor-blocks-library/src/blocks/wallet/index.tsx
var wallet_default = registerBlock({
  type: "wallet",
  name: "editorBlocksLibrary.blocks.wallet.title",
  description: "editorBlocksLibrary.blocks.wallet.description",
  Icon: WalletMinimal,
  category: "tracking" /* TRACKING */,
  premium: true,
  components: {
    email: {
      component: WalletEmailRenderer,
      editor: {
        component: WalletEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: WalletEmailPanelRenderer
      }
    },
    web: {
      component: WalletWeb,
      editor: {
        component: WalletWebEditor
      },
      configPanel: {
        features: {
          delete: true
        },
        component: WalletEmailPanelRenderer
      }
    }
  }
});
function StepIndicator({ status }) {
  return /* @__PURE__ */ jsx("div", { className: "bg-muted w-full h-2 rounded-full overflow-hidden", children: /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "w-full h-full rounded-full",
        {
          completed: "bg-primary",
          active: "bg-primary w-1/2",
          pending: "bg-muted"
        }[status]
      )
    }
  ) });
}
function Step2({ title, status, stepNumber, theme, section }) {
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const iconSrc = {
    completed: CHECK_ICON_SRC,
    active: LOADER_ICON_SRC,
    pending: PENDING_ICON_SRC
  }[status];
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
    /* @__PURE__ */ jsx(StepIndicator, { status, stepNumber }),
    /* @__PURE__ */ jsxs(
      "span",
      {
        className: cn(
          "text-sm font-medium @sm:inline-flex gap-1 items-start hidden",
          colors.text,
          status === "completed" && "",
          status === "active" && "font-semibold",
          status === "pending" && "text-muted-foreground"
        ),
        children: [
          /* @__PURE__ */ jsx("span", { className: "flex-1 text-xs", children: title }),
          /* @__PURE__ */ jsx("img", { src: iconSrc, className: cn("size-3 mt-1") })
        ]
      }
    )
  ] });
}
var CHECK_ICON_SRC = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMyMGFjMjIiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaXJjbGUtY2hlY2stYmlnLWljb24gbHVjaWRlLWNpcmNsZS1jaGVjay1iaWciPjxwYXRoIGQ9Ik0yMS44MDEgMTBBMTAgMTAgMCAxIDEgMTcgMy4zMzUiLz48cGF0aCBkPSJtOSAxMSAzIDNMMjIgNCIvPjwvc3ZnPg==";
var PENDING_ICON_SRC = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM5ZTllOWUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaXJjbGUtaWNvbiBsdWNpZGUtY2lyY2xlIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIvPjwvc3ZnPg==";
var LOADER_ICON_SRC = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmMjg2MjEiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1sb2FkZXItY2lyY2xlLWljb24gbHVjaWRlLWxvYWRlci1jaXJjbGUiPjxwYXRoIGQ9Ik0yMSAxMmE5IDkgMCAxIDEtNi4yMTktOC41NiIvPjwvc3ZnPg==";
function Stepper({ steps, theme, section }) {
  const lastStepIndex = steps.reduce((lastIndex, step, index2) => {
    if (step.status === "active" || step.status === "completed") {
      return index2;
    }
    return lastIndex;
  }, 0);
  const currentStep = steps[lastStepIndex];
  return /* @__PURE__ */ jsxs("div", { className: "@container flex-1 flex flex-col w-full py-2 gap-4", children: [
    /* @__PURE__ */ jsx("div", { className: "flex w-full gap-4", children: steps.map((step, stepIndex) => /* @__PURE__ */ jsx(
      Step2,
      {
        section,
        theme,
        title: step.title,
        status: step.status,
        stepNumber: stepIndex + 1
      },
      step.title
    )) }),
    currentStep && /* @__PURE__ */ jsx("div", { className: "flex @sm:hidden", id: "guillaume", children: /* @__PURE__ */ jsxs("span", { className: "font-semibold inline-flex gap-1 items-center", children: [
      /* @__PURE__ */ jsx(
        "img",
        {
          src: currentStep.status === "completed" ? CHECK_ICON_SRC2 : currentStep.status === "active" ? LOADER_ICON_SRC2 : PENDING_ICON_SRC2,
          className: cn(
            "size-3",
            currentStep.status === "active" && "animate-spin"
          ),
          alt: ""
        }
      ),
      currentStep.title
    ] }) })
  ] });
}
var CHECK_ICON_SRC2 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMyMGFjMjIiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaXJjbGUtY2hlY2stYmlnLWljb24gbHVjaWRlLWNpcmNsZS1jaGVjay1iaWciPjxwYXRoIGQ9Ik0yMS44MDEgMTBBMTAgMTAgMCAxIDEgMTcgMy4zMzUiLz48cGF0aCBkPSJtOSAxMSAzIDNMMjIgNCIvPjwvc3ZnPg==";
var PENDING_ICON_SRC2 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM5ZTllOWUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaXJjbGUtaWNvbiBsdWNpZGUtY2lyY2xlIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIvPjwvc3ZnPg==";
var LOADER_ICON_SRC2 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmMjg2MjEiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1sb2FkZXItY2lyY2xlLWljb24gbHVjaWRlLWxvYWRlci1jaXJjbGUiPjxwYXRoIGQ9Ik0yMSAxMmE5IDkgMCAxIDEtNi4yMTktOC41NiIvPjwvc3ZnPg==";
function getStatusTitle(status, locale) {
  return getTrackingStatusTranslation(status, locale).title;
}
function useSteps({
  locale,
  parcel,
  filterStepId
}) {
  const allSteps = [
    {
      id: "pre-transit",
      name: getStatusTitle(TrackingStatus.PRE_TRANSIT, locale),
      matches: ["PRE_TRANSIT"],
      text: getStatusTitle(TrackingStatus.PRE_TRANSIT, locale)
    },
    {
      id: "in-transit",
      name: getStatusTitle(TrackingStatus.IN_TRANSIT, locale),
      matches: ["IN_TRANSIT", "REDIRECT_TO_PICKUP"],
      text: getStatusTitle(TrackingStatus.IN_TRANSIT, locale),
      texts: {
        IN_TRANSIT: getStatusTitle(TrackingStatus.IN_TRANSIT, locale),
        REDIRECT_TO_PICKUP: getStatusTitle(
          TrackingStatus.REDIRECT_TO_PICKUP,
          locale
        )
      }
    },
    {
      id: "available-for-pickup",
      name: getStatusTitle(TrackingStatus.AVAILABLE_FOR_PICKUP, locale),
      matches: [
        "AVAILABLE_FOR_PICKUP",
        "WAITING_AT_PICKUP_POINT",
        "WAITING_AT_PICKUP_POINT_SEVERE"
      ],
      text: getStatusTitle(TrackingStatus.AVAILABLE_FOR_PICKUP, locale)
    },
    {
      id: "delivered",
      name: getStatusTitle(TrackingStatus.DELIVERED, locale),
      texts: {
        DELIVERED: getStatusTitle(TrackingStatus.DELIVERED, locale),
        COLLECTED_AT_PICKUP: getStatusTitle(
          TrackingStatus.COLLECTED_AT_PICKUP,
          locale
        ),
        DELIVERED_TO_NEIGHBOUR: getStatusTitle(
          TrackingStatus.DELIVERED_TO_NEIGHBOUR,
          locale
        )
      },
      matches: ["DELIVERED", "COLLECTED_AT_PICKUP", "DELIVERED_TO_NEIGHBOUR"],
      text: getStatusTitle(TrackingStatus.DELIVERED, locale)
    }
  ];
  if (!parcel || !parcel.events) {
    return allSteps;
  }
  const eventStatuses = parcel.events.map((event) => event.status);
  const filteredSteps = allSteps.filter((step) => {
    if (step.id === "available-for-pickup") {
      return step.matches.some((match) => eventStatuses.includes(match));
    }
    return true;
  });
  if (filterStepId) {
    return filteredSteps.filter((step) => step.id === filterStepId);
  }
  return filteredSteps;
}
function StepperWeb({
  theme,
  section,
  parcel,
  locale,
  defaultLocale
}) {
  const localeToUse = locale || defaultLocale;
  const steps = useSteps({ locale: localeToUse, parcel }).map((step) => ({
    ...step
  }));
  if (!parcel) {
    return null;
  }
  const activeIndex = steps.reduceRight((acc, step, i) => {
    const event = parcel.events.find(
      (event2) => step.matches.includes(event2.status)
    );
    if (acc === -1 && event) {
      step.text = step.texts?.[event.status] ?? step.text;
      return i;
    }
    return acc;
  }, -1);
  if (activeIndex === -1) {
    return null;
  }
  const isDelivered = parcel.events.some(
    (event) => ["DELIVERED", "COLLECTED_AT_PICKUP", "DELIVERED_TO_NEIGHBOUR"].includes(
      event.status
    )
  );
  const stepperData = steps.map((step, index2) => ({
    title: step.text ?? step.name,
    status: index2 < activeIndex ? "completed" : index2 === activeIndex ? isDelivered && step.id === "delivered" ? "completed" : "active" : "pending"
  }));
  return /* @__PURE__ */ jsx(Stepper, { theme, section, steps: stepperData });
}
function StepperWebEditor(props) {
  return /* @__PURE__ */ jsx(StepperWeb, { ...props });
}

// ../editor-blocks-library/src/blocks/stepper/index.tsx
var stepper_default = registerBlock({
  type: "stepper",
  name: "editorBlocksLibrary.blocks.stepper.title",
  description: "editorBlocksLibrary.blocks.stepper.description",
  Icon: Hourglass,
  category: "tracking" /* TRACKING */,
  hasDynamicContent: true,
  components: {
    // email: {
    //   component: StepperEmail,
    //   editor: { component: StepperEmailEditor },
    // },
    web: {
      component: StepperWeb,
      editor: { component: StepperWebEditor }
    }
  }
});
function useReturnVariableValues() {
  const { variablesValues } = useVariablesValues();
  const values = variablesValues;
  const getReturnItems = () => {
    const items = values["return.items"];
    return Array.isArray(items) ? items : [];
  };
  const getReturnExchangeItems = () => {
    const items = values["return.exchangeItems"];
    return Array.isArray(items) ? items : [];
  };
  const getRefund = () => ({
    amount: typeof values["return.refundAmount"] === "number" ? values["return.refundAmount"] : null,
    currency: values["return.refundCurrency"] ?? ""
  });
  const getShippingInstructions = () => ({
    carrierCode: values["return.carrierCode"],
    hasLogisticLabel: values["return.hasLogisticLabel"]
  });
  const getRequestDate = () => ({
    createdAt: typeof values["return.createdAt"] === "number" ? values["return.createdAt"] : void 0,
    requestTimezone: values["return.requestTimezone"]
  });
  const getDiscountCode = () => ({
    discountCode: values["return.discountCode"]
  });
  const getLabelDownload = () => ({
    labelUrl: values["return.labelUrl"],
    hasLogisticLabel: values["return.hasLogisticLabel"]
  });
  const getReturnStore = () => {
    const store = values["return.store"];
    if (!store || typeof store !== "object") return null;
    return store;
  };
  return {
    getReturnItems,
    getReturnExchangeItems,
    getRefund,
    getShippingInstructions,
    getRequestDate,
    getDiscountCode,
    getLabelDownload,
    getReturnStore
  };
}
var SECTION_LABEL = {
  refund: { key: "returnLineItems.refund", fallback: "Refund" },
  exchange: { key: "returnLineItems.exchange", fallback: "Exchange" },
  newOrder: { key: "returnLineItems.newOrder", fallback: "New order" },
  discount: { key: "returnLineItems.discount", fallback: "Discount" }
};
function getSubtitle(item, currency, hidePrices) {
  switch (item.resolution) {
    case "refund": {
      if (hidePrices) return "";
      const price = item.paidPrice ?? item.price;
      return `${price} ${currency}`.trim();
    }
    case "exchange": {
      const original = item.variant?.title ?? "";
      const next = [
        item.newVariant?.option1,
        item.newVariant?.option2,
        item.newVariant?.option3
      ].filter(Boolean).join(" ");
      if (!original && !next) return "";
      return `${original} \u2192 ${next}`;
    }
    default:
      return "";
  }
}
function LineItem2({
  item,
  currency,
  textColor,
  hidePrices
}) {
  const name = item.name;
  const imageUrl = item.imageUrl ?? "#";
  const subtitle = getSubtitle(item, currency, hidePrices);
  return /* @__PURE__ */ jsxs(Row, { children: [
    /* @__PURE__ */ jsx(Column, { className: "w-[64px] p-1", children: /* @__PURE__ */ jsx(
      Img,
      {
        src: imageUrl,
        width: 64,
        height: 64,
        alt: name,
        className: cn("w-[64px] h-[64px] rounded-lg object-cover")
      }
    ) }),
    /* @__PURE__ */ jsxs(Column, { className: "pl-2", children: [
      /* @__PURE__ */ jsxs(
        Text$1,
        {
          className: "m-0 p-0 leading-[1.4] font-semibold",
          style: { color: textColor },
          children: [
            name,
            " x ",
            item.quantity
          ]
        }
      ),
      subtitle && /* @__PURE__ */ jsx(
        Text$1,
        {
          className: "m-0 p-0 leading-[1.4] opacity-60",
          style: { color: textColor },
          children: subtitle
        }
      )
    ] })
  ] });
}
function ItemsContainer({
  children,
  contrastColor,
  theme
}) {
  const radius = useEmailThemeRadius(theme, "packageContentTable");
  return /* @__PURE__ */ jsx(Section, { className: radius, children: /* @__PURE__ */ jsx(
    Row,
    {
      className: cn(radius, "border-1 border-solid"),
      style: { borderWidth: 1, borderColor: contrastColor },
      children: /* @__PURE__ */ jsx(Column, { children })
    }
  ) });
}
function ReturnLineItemsEmailRenderer({
  block,
  theme,
  section,
  locale,
  defaultLocale
}) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const { getReturnItems, getReturnExchangeItems, getRefund } = useReturnVariableValues();
  const t2 = tLayout(locale, defaultLocale);
  const items = getReturnItems();
  const exchangeItems = getReturnExchangeItems();
  const { currency } = getRefund();
  const hidePrices = block.properties?.hidePrices;
  if (!items.length && !exchangeItems.length) return null;
  const heading = (kind) => {
    const entry = SECTION_LABEL[kind];
    if (!entry) return kind;
    const label = t2(entry.key);
    return label === entry.key ? entry.fallback : label;
  };
  const groups = [
    {
      kind: "refund",
      items: items.filter((item) => item.resolution === "refund")
    },
    {
      kind: "exchange",
      // exchange-credit items are grouped with exchange (same section, same heading)
      items: items.filter(
        (item) => item.resolution === "exchange" || item.resolution === "exchange-credit"
      )
    },
    {
      kind: "newOrder",
      items: exchangeItems
    },
    {
      kind: "discount",
      items: items.filter((item) => item.resolution === "discount")
    }
  ];
  const displayGroups = groups.filter((group) => group.items.length > 0);
  return /* @__PURE__ */ jsx(Section, { children: displayGroups.map((group) => /* @__PURE__ */ jsxs(Section, { className: "mb-2", children: [
    /* @__PURE__ */ jsx(Heading$1, { as: "h5", className: "m-0 mb-2 text-xs font-bold text-secondary-foreground", children: heading(group.kind) }),
    /* @__PURE__ */ jsx(ItemsContainer, { theme, contrastColor: colors.contrast, children: group.items.map((item, index2) => /* @__PURE__ */ jsxs(React49__default.Fragment, { children: [
      /* @__PURE__ */ jsx(
        LineItem2,
        {
          item,
          currency,
          textColor: colors.text,
          hidePrices
        }
      ),
      index2 < group.items.length - 1 && /* @__PURE__ */ jsx(
        Hr,
        {
          className: "border",
          style: { borderColor: colors.contrast }
        }
      )
    ] }, `${group.kind}-${index2}`)) })
  ] }, group.kind)) });
}
function ReturnLineItemsEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ReturnLineItemsEmailRenderer, { ...props }) });
}

// ../editor-blocks-library/src/blocks/return-line-items/index.tsx
var return_line_items_default = registerBlock({
  type: "return-line-items",
  name: "editorBlocksLibrary.blocks.return-line-items.title",
  description: "editorBlocksLibrary.blocks.return-line-items.description",
  Icon: Undo2,
  category: "return" /* RETURN */,
  hasDynamicContent: true,
  components: {
    email: {
      component: ReturnLineItemsEmailRenderer,
      editor: {
        component: ReturnLineItemsEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
function ReturnStoreAddressEmailRenderer({
  theme,
  section,
  locale,
  defaultLocale
}) {
  const t2 = tLayout(locale, defaultLocale);
  const store = useReturnVariableValues().getReturnStore();
  const buttonRadius = useEmailThemeRadius(theme, "button");
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const buttonStyle = getThemeButtonStyle({ variant: "default", theme, textColor: colors.text });
  if (!store) return null;
  const mapLabel = (() => {
    const v = t2("returnStoreAddress.mapButton");
    return v === "returnStoreAddress.mapButton" ? "View on map" : v;
  })();
  return /* @__PURE__ */ jsx(Section, { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        borderRadius: "8px",
        padding: "12px 16px",
        backgroundColor: "#f9fafb",
        display: "inline-block",
        border: "1px solid #e5e7eb",
        minWidth: "220px",
        marginBottom: "8px",
        fontSize: "14px",
        lineHeight: "1.5"
      },
      children: [
        /* @__PURE__ */ jsxs("div", { className: "text-center", style: { fontWeight: "bold", fontSize: "16px", marginBottom: "4px" }, children: [
          "\u{1F4CD} ",
          store.name
        ] }),
        store.address1 && /* @__PURE__ */ jsx("div", { className: "text-center", children: store.address1 }),
        store.address2 && /* @__PURE__ */ jsx("div", { className: "text-center", children: store.address2 }),
        (store.zip || store.city) && /* @__PURE__ */ jsx("div", { className: "text-center", children: [store.zip, store.city].filter(Boolean).join(" ") }),
        store.country && /* @__PURE__ */ jsx("div", { className: "text-center", children: store.country }),
        store.mapUrl && /* @__PURE__ */ jsx("div", { style: { marginTop: "12px", textAlign: "center" }, children: /* @__PURE__ */ jsx(
          Button$1,
          {
            href: store.mapUrl,
            className: buttonRadius,
            style: buttonStyle,
            children: mapLabel
          }
        ) })
      ]
    }
  ) });
}
function ReturnStoreAddressEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ReturnStoreAddressEmailRenderer, { ...props }) });
}

// ../editor-blocks-library/src/blocks/return-store-address/index.tsx
var return_store_address_default = registerBlock({
  type: "return-store-address",
  name: "editorBlocksLibrary.blocks.return-store-address.title",
  description: "editorBlocksLibrary.blocks.return-store-address.description",
  Icon: MapPin,
  category: "return" /* RETURN */,
  hasDynamicContent: true,
  components: {
    email: {
      component: ReturnStoreAddressEmailRenderer,
      editor: {
        component: ReturnStoreAddressEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});

// ../editor-blocks-library/src/blocks/return-shipping-instructions/instructions.ts
var LABEL_KEY = (id) => `editorBlocksLibrary.blocks.return-shipping-instructions.panel.message.${id}`;
var INSTRUCTION_KEYS = [
  {
    id: "colissimo",
    tLayoutKey: "shippingInstructions.colissimo",
    fallback: "You can now print your return label and drop off your package at the nearest Colissimo relay point.",
    labelKey: LABEL_KEY("colissimo"),
    labelFallback: "Colissimo"
  },
  {
    id: "chronoShop2Shop",
    tLayoutKey: "shippingInstructions.chronoShop2Shop",
    fallback: "You can now print your return label and drop off your package at the nearest Chronopost relay point.",
    labelKey: LABEL_KEY("chronoShop2Shop"),
    labelFallback: "Chronopost / pickup point"
  },
  {
    id: "ups",
    tLayoutKey: "shippingInstructions.ups",
    fallback: "You can now print your return label and drop off your package at the nearest UPS relay point.",
    labelKey: LABEL_KEY("ups"),
    labelFallback: "UPS"
  },
  {
    id: "customerCarrier",
    tLayoutKey: "shippingInstructions.customerCarrier",
    fallback: "You can now send your return package to the carrier of your choice.",
    labelKey: LABEL_KEY("customerCarrier"),
    labelFallback: "Customer's carrier"
  },
  {
    id: "merchantCarrier",
    tLayoutKey: "shippingInstructions.merchantCarrier",
    fallback: "We will send you a return label by email within 1 to 3 business days.",
    labelKey: LABEL_KEY("merchantCarrier"),
    labelFallback: "Merchant's carrier"
  },
  {
    id: "returnToStore",
    tLayoutKey: "shippingInstructions.returnToStore",
    fallback: "You can now print your return label and drop off your package at the nearest store.",
    labelKey: LABEL_KEY("returnToStore"),
    labelFallback: "Return to store"
  },
  {
    id: "malca",
    tLayoutKey: "shippingInstructions.malca",
    fallback: "You can now print your return label and drop off your package at the nearest Malca relay point.",
    labelKey: LABEL_KEY("malca"),
    labelFallback: "Malca"
  },
  {
    id: "tnt",
    tLayoutKey: "shippingInstructions.tnt",
    fallback: "You can now print your return label and drop off your package at the nearest TNT relay point.",
    labelKey: LABEL_KEY("tnt"),
    labelFallback: "TNT"
  },
  {
    id: "bonDeRetour",
    tLayoutKey: "shippingInstructions.bonDeRetour",
    fallback: "Your return slip is ready. You can now print it and use it for your return.",
    labelKey: LABEL_KEY("bonDeRetour"),
    labelFallback: "Return slip"
  },
  {
    id: "unknownCarrier",
    tLayoutKey: "shippingInstructions.unknownCarrier",
    fallback: "You can now print your return label and ship your package with the carrier indicated on the label.",
    labelKey: LABEL_KEY("unknownCarrier"),
    labelFallback: "Other carriers"
  }
];
var INSTRUCTION_BY_ID = INSTRUCTION_KEYS.reduce(
  (acc, def) => {
    acc[def.id] = def;
    return acc;
  },
  {}
);
var CARRIER_TO_INSTRUCTION = {
  colissimo: "colissimo",
  "chrono-shop2shop": "chronoShop2Shop",
  crosslog: "chronoShop2Shop",
  ups: "ups",
  "ups-saver": "ups",
  "ups-standard": "ups",
  "ups-express": "ups",
  "fake-dpd": "ups",
  "customer-carrier": "customerCarrier",
  "merchant-carrier": "merchantCarrier",
  "return-to-store": "returnToStore",
  malca: "malca",
  tnt: "tnt"
};
var BON_DE_RETOUR_CONTENT_KEY = "bonDeRetour";
function preserveBlankLines(html) {
  return html.replace(/<p([^>]*)><\/p>/g, "<p$1>&nbsp;</p>");
}
function isEmptyHtml(html) {
  if (!html) return true;
  const stripped = html.replace(/<br\s*\/?>/gi, "").replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").trim();
  return stripped.length === 0;
}
function resolveInstructionKey(carrierCode, hasLogisticLabel) {
  if (hasLogisticLabel) return "bonDeRetour";
  return carrierCode && CARRIER_TO_INSTRUCTION[carrierCode] || "unknownCarrier";
}
function getOverrideContentKeys(carrierCode, hasLogisticLabel) {
  if (hasLogisticLabel) return [BON_DE_RETOUR_CONTENT_KEY];
  if (!carrierCode) return [];
  const legacy = CARRIER_TO_INSTRUCTION[carrierCode];
  return legacy && legacy !== carrierCode ? [carrierCode, legacy] : [carrierCode];
}
function resolveOverride(content, locale, defaultLocale, carrierCode, hasLogisticLabel) {
  if (!content) return void 0;
  for (const key of getOverrideContentKeys(carrierCode, hasLogisticLabel)) {
    const localeOverride = content[locale]?.[key];
    if (!isEmptyHtml(localeOverride)) return localeOverride ?? void 0;
    const defaultOverride = content[defaultLocale]?.[key];
    if (!isEmptyHtml(defaultOverride)) return defaultOverride ?? void 0;
  }
  return void 0;
}
function ReturnShippingInstructionsEmailRenderer({
  block,
  formatter,
  theme,
  section,
  locale,
  defaultLocale
}) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const t2 = tLayout(locale, defaultLocale);
  const { getShippingInstructions } = useReturnVariableValues();
  const { carrierCode, hasLogisticLabel } = getShippingInstructions();
  const activeKey = resolveInstructionKey(carrierCode, hasLogisticLabel);
  const definition = INSTRUCTION_BY_ID[activeKey];
  const override = resolveOverride(
    block.content,
    locale,
    defaultLocale,
    carrierCode,
    hasLogisticLabel
  );
  if (override) {
    const withBlankLines = preserveBlankLines(override);
    return /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "m-0 text-base leading-[1.5] text-center",
        style: { color: colors.text },
        dangerouslySetInnerHTML: {
          __html: formatter ? formatter(format_template_default(withBlankLines)) : format_template_default(withBlankLines)
        }
      }
    ) });
  }
  const translated = t2(definition.tLayoutKey);
  const text = translated === definition.tLayoutKey ? definition.fallback : translated;
  return /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(
    Text$1,
    {
      className: "m-0 text-base leading-[1.5] text-center",
      style: { color: colors.text },
      children: text
    }
  ) });
}
function ReturnShippingInstructionsEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ReturnShippingInstructionsEmailRenderer, { ...props }) });
}

// ../carriers-utils/dist/index.js
var WEEKDAYS = [1, 2, 3, 4, 5];
var WEEKDAYS_SAT = [1, 2, 3, 4, 5, 6];
var MONDIAL_DAYS = [2, 3, 4, 5, 6];
var CARRIER_REGISTRY = {
  colissimo: {
    name: "Colissimo",
    logo: "colissimo.png",
    match: (code) => code.includes("colissimo") || code === "la-poste" || code === "lapost" || code === "la-poste-colissimo" || code === "lapostcolissimo" || code === "lettre-suivie" || code === "lettre suivie" || code === "lettresuivie" || code === "delivengo",
    tracking: { provider: "native", trackingMoreCarrierCode: "colissimo" },
    trackingUrl: {
      url: "https://www.laposte.fr/outils/suivre-vos-envois?code={trackingId}",
      fallbackUrl: "https://www.laposte.fr/outils/suivre-vos-envois"
    },
    matchTrackingNumber: (tn) => /^[68]A\d{9}FR$/i.test(tn) || /^[C-R][A-Z]\d{9}FR$/i.test(tn),
    meta: {
      trackingMethod: "API officielle La Poste v2 (OAuth2) + fallback scraper SmartProxy v1",
      rateLimit: "~5 req/s (429 avec Retry-After)",
      notes: "Circuit breaker 5s sur 429. Token OAuth2 cached avec marge 1min."
    },
    credentials: {
      // Tracking utilise une clé OkApi centrale Baback + fallback scraper SmartProxy ;
      // les identifiants marchand ne servent qu'à la génération d'étiquettes.
      usedFor: ["shipment"],
      supportsCredentialCheck: true,
      fields: [
        { key: "accountId", label: "Account ID", type: "string", required: true },
        { key: "password", label: "Password", type: "string", required: true, sensitive: true },
        { key: "SLS", label: "Suivi Livraison Sign\xE9 (SLS)", type: "boolean", required: false }
      ]
    },
    supportsLabelGeneration: true,
    products: [
      { code: "colissimo", isPickupPoint: false, name: "Colissimo", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "DOM", international: "COLD" }, servedZones: ["FR_METRO", "EU", "OM1", "OM2", "MONDE"], zoneDelays: { EU: { promise: 4, padding: 2 }, OM1: { promise: 8, padding: 3 }, OM2: { promise: 10, padding: 4 }, MONDE: { promise: 7, padding: 2 } } },
      { code: "livraison-domicile", isPickupPoint: false, name: "Livraison \xE0 domicile", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "DOM", international: "COLD" }, servedZones: ["FR_METRO", "EU", "OM1", "OM2", "MONDE"], zoneDelays: { EU: { promise: 4, padding: 2 }, OM1: { promise: 8, padding: 3 }, OM2: { promise: 10, padding: 4 }, MONDE: { promise: 7, padding: 2 } } },
      { code: "point-retrait", isPickupPoint: true, name: "Point retrait", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "A2P" }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } },
      { code: "colissimo_domicile_signature_france", isPickupPoint: false, name: "Colissimo Domicile Signature - France", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "DOS" }, servedZones: ["FR_METRO"] },
      { code: "colissimo_domicile_sans_signature_france", isPickupPoint: false, name: "Colissimo Domicile Sans Signature - France", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "DOM" }, servedZones: ["FR_METRO"] },
      { code: "colissimo_point_retrait_france", isPickupPoint: true, name: "Colissimo Point Retrait - France", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "A2P" }, servedZones: ["FR_METRO"] },
      // MONDE recalé sur mesure (159 colis) : le produit est utilisé hors EU, où il met 5 à 9 jours.
      { code: "colissimo_domicile_signature_europe", isPickupPoint: false, name: "Colissimo Domicile Signature - Europe", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLI" }, servedZones: ["EU"], zoneDelays: { MONDE: { promise: 5, padding: 4 } } },
      { code: "colissimo_domicile_sans_signature_europe", isPickupPoint: false, name: "Colissimo Domicile Sans Signature - Europe", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLD" }, servedZones: ["EU"] },
      { code: "colissimo_point_retrait_europe", isPickupPoint: true, name: "Colissimo Point Retrait - Europe", defaultSmartDelivery: { defaultPromise: 7, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "A2P" }, servedZones: ["EU"] },
      { code: "colissimo_domicile_signature_outre_mer", isPickupPoint: false, name: "Colissimo Domicile Signature - Outre-Mer", defaultSmartDelivery: { defaultPromise: 7, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLI" }, servedZones: ["OM1", "OM2"], zoneDelays: { OM2: { promise: 10, padding: 4 } } },
      { code: "colissimo_domicile_sans_signature_outre_mer", isPickupPoint: false, name: "Colissimo Domicile Sans Signature - Outre-Mer", defaultSmartDelivery: { defaultPromise: 7, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLD" }, servedZones: ["OM1", "OM2"], zoneDelays: { OM2: { promise: 10, padding: 4 } } },
      { code: "colissimo_domicile_signature_monde", isPickupPoint: false, name: "Colissimo Domicile Signature - Monde", defaultSmartDelivery: { defaultPromise: 7, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLI" }, servedZones: ["MONDE"] },
      { code: "lettre-suivie", isPickupPoint: false, name: "Lettre Suivie", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO"], zoneDelays: { EU: { promise: 5, padding: 2 } } }
    ]
  },
  chronopost: {
    name: "Chronopost",
    logo: "chronopost.png",
    match: (code) => code.startsWith("chrono"),
    tracking: { provider: "native", trackingMoreCarrierCode: "chronopost" },
    trackingUrl: {
      url: "https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT={trackingId}",
      fallbackUrl: "https://www.chronopost.fr/tracking-no-cms/suivi-page"
    },
    matchTrackingNumber: (tn) => /^X[A-Z]\d{9}[A-Z]{2}$/i.test(tn),
    meta: {
      trackingMethod: "Web service SOAP public Chronopost (trackSkybillV2, non authentifi\xE9)"
    },
    credentials: {
      // Le suivi passe par un endpoint SOAP public anonyme ; les identifiants
      // marchand ne servent qu'à la génération d'étiquettes.
      usedFor: ["shipment"],
      supportsCredentialCheck: true,
      fields: [
        { key: "accountNumber", label: "Account Number", type: "string", required: true },
        { key: "password", label: "Password", type: "string", required: true, sensitive: true },
        { key: "subAccount", label: "Sub Account", type: "string", required: false }
      ]
    },
    supportsLabelGeneration: true,
    supportsPickupRequest: true,
    products: [
      { code: "chronopost-18", isPickupPoint: false, name: "Chronopost 18", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "18", international: "17" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      { code: "chronopost-13", isPickupPoint: false, name: "Chronopost 13", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "13", international: "17" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      { code: "relais", isPickupPoint: true, name: "Chrono Relais", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "44" }, servedZones: ["FR_METRO"], zoneDelays: { EU: { promise: 3, padding: 2 } } },
      { code: "shop2shop", isPickupPoint: true, name: "Shop2Shop", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "2R" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_lendemain_13h", isPickupPoint: false, name: "Lendemain avant 13h", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "13", international: "17" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_lendemain_18h", isPickupPoint: false, name: "Livraison le lendemain avant 18h", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "18", international: "17" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_jour_j", isPickupPoint: false, name: "Livraison le jour m\xEAme", defaultSmartDelivery: { defaultPromise: 0, defaultPadding: 0, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "SD" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_relais_france", isPickupPoint: true, name: "Livraison en relais France", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "44" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_rapide_eco", isPickupPoint: false, name: "Livraison rapide et \xE9conomique vers l'Europe", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "16", international: "16" }, servedZones: ["EU"] },
      { code: "chronopost_express_world", isPickupPoint: false, name: "Livraison Express Monde", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "17", international: "17" }, servedZones: ["EU", "MONDE"], zoneDelays: { MONDE: { promise: 4, padding: 2 } } },
      { code: "chronopost_relais_europe_outre_mer", isPickupPoint: true, name: "Livraison en relais Europe et Outre-Mer", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "49", international: "49" }, servedZones: ["EU", "OM1", "OM2"], zoneDelays: { OM2: { promise: 6, padding: 2 } } },
      { code: "chronopost_shop2shop", isPickupPoint: true, name: "Shop2Shop", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "2R" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_2shopdirect", isPickupPoint: true, name: "2Shop Direct", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "T2" }, servedZones: ["FR_METRO"], zoneDelays: { EU: { promise: 4, padding: 2 } } }
    ]
  },
  dhl: {
    name: "DHL",
    logo: "dhl.png",
    match: (code) => code === "dhl" || code.includes("dhl-express") || code.includes("dhlexpress") || code.includes("dhl-economy") || code.includes("dhleconomy") || code.includes("dhl-tax-free") || code.includes("dhltaxfree"),
    tracking: { provider: "native", trackingMoreCarrierCode: "dhl" },
    trackingUrl: {
      url: "https://www.dhl.com/{countryCode}/home/tracking.html?tracking-id={trackingId}",
      fallbackUrl: "https://www.dhl.com/fr-fr/home/tracking.html",
      supportsLocale: true,
      formatCountryCode: (countryCode, locale) => `${countryCode.toLowerCase()}-${locale}`
    },
    matchTrackingNumber: (tn) => /^JJD\d{10,}$/i.test(tn),
    meta: {
      trackingMethod: "API officielle DHL Tracking (API key)",
      notes: "Rate limit g\xE9r\xE9 par quota API key."
    },
    products: [
      { code: "dhl", isPickupPoint: false, name: "DHL", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3, padding: 1 } } },
      { code: "dhl-express", isPickupPoint: false, name: "DHL Express", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      { code: "dhl_express_worldwide", isPickupPoint: false, name: "DHL Express Worldwide", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU", "MONDE"], zoneDelays: { EU: { promise: 1, padding: 1 }, MONDE: { promise: 3, padding: 1 } } },
      { code: "dhl_express_domestic", isPickupPoint: false, name: "DHL Express Domestic", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO"] },
      { code: "dhl_economy_select", isPickupPoint: false, name: "DHL Economy Select", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU", "MONDE"], zoneDelays: { EU: { promise: 3, padding: 1 }, MONDE: { promise: 7, padding: 2 } } },
      { code: "dhl_euroconnect", isPickupPoint: false, name: "DHL Euroconnect", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "dhl_parcel_europe", isPickupPoint: false, name: "DHL Parcel Europe", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "dhl_parcel_connect", isPickupPoint: false, name: "DHL Parcel Connect", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "dhl_service_point", isPickupPoint: true, name: "DHL ServicePoint", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"] }
    ]
  },
  ups: {
    name: "UPS",
    logo: "ups.png",
    match: (code) => code === "ups" || code.includes("ups-standard") || code.includes("upsstandard") || code.includes("ups-saver") || code.includes("upssaver") || code.includes("ups-ground") || code.includes("upsground"),
    tracking: { provider: "native", trackingMoreCarrierCode: "ups" },
    trackingUrl: {
      url: "https://www.ups.com/track?loc={locale}&tracknum={trackingId}",
      fallbackUrl: "https://www.ups.com/track",
      supportsLocale: true,
      formatLocale: (locale) => `${locale}_${locale.toUpperCase()}`
    },
    matchTrackingNumber: (tn) => /^1Z[0-9A-Z]{16}$/i.test(tn),
    meta: {
      trackingMethod: "API officielle UPS Tracking (OAuth2)"
    },
    credentials: {
      usedFor: ["tracking", "shipment"],
      oauth: true,
      supportsCredentialCheck: true,
      fields: [
        { key: "accountNumber", label: "Account Number", type: "string", required: true }
      ]
    },
    supportsLabelGeneration: true,
    products: [
      // MONDE mesuré par destination : US n=198 méd. 3 p80 6, CA n=45 méd. 3, AU n=30 méd. 3.
      { code: "standard", isPickupPoint: false, name: "UPS Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3, padding: 3 } } },
      { code: "saver", isPickupPoint: false, name: "UPS Saver", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      // Même produit physique que `standard` ci-dessus (même nom) : valeurs alignées,
      // sinon deux marchands reçoivent des EDD écartées de 3 jours selon le code
      // posé à l'onboarding.
      { code: "ups_standard", isPickupPoint: false, name: "UPS Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "11" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3, padding: 3 } } },
      { code: "ups_express", isPickupPoint: false, name: "UPS Express", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "07" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3, padding: 2 } } },
      { code: "ups_express_saver", isPickupPoint: false, name: "UPS Express Saver", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "65" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      { code: "ups_access_point", isPickupPoint: true, name: "UPS Access Point", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU"] },
      { code: "ups_expedited", isPickupPoint: false, name: "UPS Expedited", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "08" }, servedZones: ["EU", "MONDE"], zoneDelays: { MONDE: { promise: 6, padding: 2 } } }
    ]
  },
  gls: {
    name: "GLS",
    logo: "gls.png",
    match: (code) => code === "gls",
    tracking: { provider: "native", trackingMoreCarrierCode: "gls" },
    trackingUrl: {
      url: "https://gls-group.com/GROUP/en/parcel-tracking?match={trackingId}",
      fallbackUrl: "https://gls-group.com/GROUP/en/parcel-tracking"
    },
    meta: {
      trackingMethod: "API publique non-authentifi\xE9e (gls-group.com)",
      notes: "Deux endpoints : rstt029 (overview) puis rstt028 (d\xE9tail si code postal disponible)."
    },
    products: [
      { code: "gls", isPickupPoint: false, name: "GLS Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3, padding: 2 } } },
      { code: "gls-point-relais", isPickupPoint: true, name: "GLS Point Relais", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } },
      { code: "gls_business_parcel", isPickupPoint: false, name: "GLS Business Parcel", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5, padding: 2 } } },
      { code: "gls_europlus", isPickupPoint: false, name: "GLS EuroPlus", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      // FR n=364 méd. 2 p80 3 ; ES n=64 méd. 3 p80 4 ; DE n=53 méd. 4 p80 4.
      { code: "gls_shop_delivery", isPickupPoint: true, name: "GLS Shop Delivery", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3, padding: 2 } } },
      { code: "gls_parcel_shop", isPickupPoint: true, name: "GLS ParcelShop", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } }
    ]
  },
  "mondial-relay": {
    name: "Mondial Relay",
    logo: "mondial-relay.png",
    match: (code) => code === "mondial-relay" || code === "mondialrelay",
    tracking: { provider: "native", trackingMoreCarrierCode: "mondialrelay" },
    trackingUrl: {
      url: "https://www.mondialrelay.fr/suivi-de-colis?NumeroExpedition={trackingId}&CodePostal={zipCode}",
      fallbackUrl: "https://www.mondialrelay.fr/suivi-de-colis",
      requiredFields: ["zipCode"]
    },
    meta: {
      trackingMethod: "API web mondialrelay.fr (via proxy SmartProxy)",
      notes: "Authentification par cookie obtenu via scraping. N\xE9cessite proxy r\xE9sidentiel FR."
    },
    credentials: {
      usedFor: ["tracking"],
      fields: [
        { key: "brand", label: "Enseigne (Brand)", type: "string", required: true },
        { key: "securityKey", label: "Security Key", type: "string", required: true, sensitive: true }
      ],
      supportsCredentialCheck: true
    },
    // Two known cart customAttribute conventions for MR pickup points:
    // - `Mondial_Relay_*` (Bellerose / Checkout Blocks integrations)
    // - `PickupPoint*` (Globe app / generic). Note: `PickupPointCourier` is
    //   misnamed by the Globe app — it actually carries an ISO country code
    //   (e.g. "FR", "BE"), not a carrier identifier.
    pickupPointCartAttributes: {
      id: ["Mondial_Relay_CODE", "PickupPointId"],
      zip: ["Mondial_Relay_ZIP_CODE", "PickupPointPostCode"],
      name: ["Mondial_Relay_NAME", "PickupPointName", "PickupPointPlace"],
      address1: ["Mondial_Relay_ADDRESS_1", "PickupPointAddress"],
      city: ["Mondial_Relay_CITY", "PickupPointCity"],
      country: ["Mondial_Relay_COUNTRY", "PickupPointCourier"]
    },
    // 98 % of Mondial Relay parcels are measured as pickup deliveries, so an
    // opaque label like `MREL_SE` must not default to home.
    defaultProductCode: "mondial-relay",
    products: [
      // Même produit physique que `mondial_relay_point_relais` (même nom) : EU aligné
      // sur la mesure (n=606, méd. 3).
      { code: "mondial-relay", isPickupPoint: true, name: "Mondial Relay Point Relais", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3 } } },
      { code: "mondial-relay-home", isPickupPoint: false, name: "Mondial Relay Domicile", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } },
      { code: "mondial_relay_point_relais", isPickupPoint: true, name: "Mondial Relay Point Relais", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3 } } },
      // Relais transfrontalier, bien plus rapide que le relais domestique : 93 % du
      // volume est Belgique. Mesuré sur 884 colis livrés (120 j) : EU n=611 méd. 1,5
      // P90 4,5 ; FR n=273 méd. 1,5 P90 4,5. Les deux zones donnent la même paire,
      // d'où l'absence de `zoneDelays`. Servi (avec le supplément de repli) 1 à 5 j,
      // contre 3 à 7 avant cette entrée, ce qui livrait 91 % des colis AVANT l'edd_min.
      { code: "mondial_relay_point_relais_international", isPickupPoint: true, name: "Mondial Relay Point Relais International", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 2, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"] },
      { code: "mondial_relay_domicile", isPickupPoint: false, name: "Mondial Relay Domicile", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } },
      { code: "mondial_relay_xl", isPickupPoint: false, name: "Mondial Relay XL", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 6 } } }
    ]
  },
  fedex: {
    name: "FedEx",
    logo: "fedex.png",
    match: (code) => code === "fedex",
    tracking: { provider: "native", trackingMoreCarrierCode: "fedex" },
    trackingUrl: {
      url: "https://www.fedex.com/fedextrack/?trknbr={trackingId}",
      fallbackUrl: "https://www.fedex.com/fedextrack/"
    },
    meta: {
      trackingMethod: "API officielle FedEx Track (OAuth2)"
    },
    credentials: {
      usedFor: ["tracking"],
      fields: [
        { key: "clientId", label: "Client ID", type: "string", required: true },
        { key: "clientSecret", label: "Client Secret", type: "string", required: true, sensitive: true },
        { key: "accountNumber", label: "Account Number", type: "string", required: true }
      ],
      supportsCredentialCheck: true
    },
    products: [
      { code: "fedex", isPickupPoint: false, name: "FedEx Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"] },
      { code: "fedex_international_priority", isPickupPoint: false, name: "FedEx International Priority", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU", "MONDE"] },
      { code: "fedex_international_economy", isPickupPoint: false, name: "FedEx International Economy", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU", "MONDE"] },
      { code: "fedex_ground", isPickupPoint: false, name: "FedEx Ground", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"] },
      { code: "fedex_express_saver", isPickupPoint: false, name: "FedEx Express Saver", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"] }
    ]
  },
  "global-e": {
    name: "Global-E",
    match: (code) => code === "global-e" || code === "globale",
    tracking: { provider: "native" },
    trackingUrl: {
      url: "https://www.global-e.com/Tracking/Tracking?orderid={trackingId}&CountryCode={countryCode}",
      fallbackUrl: "https://www.global-e.com/Tracking/Tracking",
      requiredFields: ["countryCode"],
      supportsLocale: true,
      formatCountryCode: (countryCode, locale) => `${countryCode.toLowerCase()}-${locale}`
    },
    meta: {
      trackingMethod: "API officielle Global-E (SDK client)",
      notes: "Utilise le package @global-e/client. Fallback vers TrackShip si configur\xE9."
    },
    credentials: {
      usedFor: ["tracking"],
      fields: [
        { key: "account", label: "Merchant GUID", type: "string", required: true }
      ],
      supportsCredentialCheck: true
    },
    // `ShipperName` from the Global-e API, stored as `carrierDisplayName`. This is
    // Global-e's whole vocabulary: 7 values over a year of production, 5 once the
    // "api" channel variant is normalized away. Unknown values are logged.
    sourceProductMap: {
      "dhl express worldwide": { carrier: "dhl", product: "dhl_express_worldwide" },
      // No exact code for the road offering: `dhl_euroconnect` (promise 3) matches
      // the measured 3-day median, `dhl_economy_select` (promise 5) does not.
      "dhl european road economy": { carrier: "dhl", product: "dhl_euroconnect" },
      "dhl european road": { carrier: "dhl", product: "dhl_euroconnect" },
      "fedex ficp worldwide": { carrier: "fedex", product: "fedex_international_priority" },
      "chronopost standard": { carrier: "chronopost", product: "chronopost-13" }
    },
    products: [
      { code: "global-e", isPickupPoint: false, name: "Global-E", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3 } }, servedZones: ["EU", "OM1", "OM2", "MONDE"] }
    ]
  },
  bpost: {
    name: "bpost",
    logo: "bpost.png",
    match: (code) => code === "bpost" || code === "bepost" || code === "be-post",
    tracking: { provider: "native", trackingMoreCarrierCode: "belgium-post" },
    trackingUrl: {
      url: "https://track.bpost.cloud/btr/web/#/search?itemCode={trackingId}",
      fallbackUrl: "https://track.bpost.cloud/btr/web/"
    },
    meta: {
      trackingMethod: "API publique non-authentifi\xE9e (track.bpost.cloud)"
    },
    products: [
      { code: "bpost", isPickupPoint: false, name: "bpost", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { FR_METRO: { promise: 3 }, MONDE: { promise: 8, padding: 2 } } },
      { code: "bpost-point-relais", isPickupPoint: true, name: "bpost Point Relais", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  custom: {
    name: "Custom",
    match: (code) => code === "custom",
    tracking: { provider: "manual" },
    trackingUrl: { url: null },
    meta: {
      trackingMethod: "Manuel (API emitParcelStatus ou back-office)"
    },
    products: []
  },
  dpd: {
    name: "DPD",
    match: (code) => code === "dpd" || code === "fake-dpd",
    tracking: { provider: "native", trackingMoreCarrierCode: "dpd" },
    trackingUrl: {
      url: "https://trace.dpd.fr/fr/trace/{trackingId}",
      fallbackUrl: "https://trace.dpd.fr/fr/trace"
    },
    credentials: {
      usedFor: ["tracking", "shipment"],
      // DPD only answers tracking/shipment API calls coming from whitelisted IPs.
      ipWhitelist: ["171.33.105.206", "171.33.92.211"],
      fields: [
        { key: "userid", label: "User ID", type: "string", required: true },
        { key: "password", label: "Password", type: "string", required: true, sensitive: true },
        { key: "customerCountryCode", label: "Customer Country Code", type: "string", required: true },
        { key: "customerCenterNumber", label: "Customer Center Number", type: "string", required: true },
        { key: "customerNumber", label: "Customer Number", type: "string", required: true }
      ],
      supportsCredentialCheck: true
    },
    products: [
      // EU : mesure instable selon la fenêtre (3+2 sur 120 j, 5+1 sur 90 j), on retient la plus large.
      { code: "dpd", isPickupPoint: false, name: "DPD Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3, padding: 2 } } },
      { code: "dpd-pickup", isPickupPoint: true, name: "DPD Pickup", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } }
    ]
  },
  "dpd-uk": {
    name: "DPD UK",
    match: (code) => code === "dpd-uk" || code === "dpducluk" || code === "dpd-ucl-uk",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "dpd-uk" },
    trackingUrl: {
      url: "https://www.dpd.co.uk/service/tracking?consignment={trackingId}",
      fallbackUrl: "https://www.dpd.co.uk/service/tracking"
    },
    products: [
      { code: "dpd-uk", isPickupPoint: false, name: "DPD UK", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "dpd-uk-pickup", isPickupPoint: true, name: "DPD UK Pickup", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  tnt: {
    name: "TNT",
    match: (code) => code === "tnt",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "tnt" },
    trackingUrl: {
      url: "https://www.tnt.com/express/{locale}/site/shipping-tools/tracking.html?searchType=con&cons={trackingId}",
      fallbackUrl: "https://www.tnt.com/express/fr_fr/site/shipping-tools/tracking.html",
      supportsLocale: true,
      formatLocale: (locale) => `${locale}_${locale}`
    },
    products: [
      { code: "tnt", isPickupPoint: false, name: "TNT", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"] }
    ]
  },
  canadapost: {
    name: "Canada Post",
    match: (code) => code === "canadapost" || code === "canada-post",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "canada-post" },
    trackingUrl: {
      url: "https://www.canadapost-postescanada.ca/track-reperage/{locale}#/details/{trackingId}",
      fallbackUrl: "https://www.canadapost-postescanada.ca/track-reperage/en",
      supportsLocale: true
    },
    products: [
      { code: "canadapost", isPickupPoint: false, name: "Canada Post", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["MONDE"] }
    ]
  },
  geodis: {
    name: "Geodis",
    logo: "geodis.png",
    match: (code) => code === "geodis",
    tracking: { provider: "native", trackingMoreCarrierCode: "geodis" },
    trackingUrl: {
      url: "https://espace-client.geodis.com/services/destinataires/#/en/suivi/{trackingId}"
    },
    meta: {
      trackingMethod: "API publique non-authentifi\xE9e (endpoint anonyme destinataire)",
      notes: "HMAC-SHA256 avec appKey hardcod\xE9e. Derri\xE8re Cloudflare Bot Management \u2014 risque 403 sur volume \xE9lev\xE9."
    },
    products: [
      { code: "geodis", isPickupPoint: false, name: "Geodis", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"] }
    ]
  },
  "colis-prive": {
    name: "Colis Priv\xE9",
    match: (code) => code === "colis-prive" || code === "colisprive",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "colis-prive" },
    trackingUrl: {
      url: "https://www.colisprive.com/moncolis/pages/detailColis.aspx?numColis={trackingId}&cp={zipCode}",
      fallbackUrl: "https://www.colisprive.com/moncolis/",
      requiredFields: ["zipCode"]
    },
    products: [
      { code: "colis-prive", isPickupPoint: false, name: "Colis Priv\xE9", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO"] }
    ]
  },
  seur: {
    name: "SEUR",
    match: (code) => code === "seur",
    tracking: { provider: "native", trackingMoreCarrierCode: "international-seur" },
    trackingUrl: {
      url: "https://www.seur.com/livetracking/?segOnlineIdentifier={trackingId}",
      fallbackUrl: "https://www.seur.com/livetracking/"
    },
    meta: {
      trackingMethod: "API officielle SEUR PIC (OAuth2 password grant)",
      notes: "Token obtenu via POST pic_token avec client_id/client_secret + username/password.",
      limitations: "Adresse du point relais non r\xE9cup\xE9rable. Sur une livraison redirig\xE9e en point relais (destinataire absent \u2192 codes LJ105/LI574\u2026), l'API PIC ne renvoie que le CP/ville de destination + les codes d'\xE9v\xE9nements, jamais l'adresse du point. Cette adresse n'existe que sur la page de suivi client (endpoint consultarEnvioLT, derri\xE8re Imperva Incapsula \u2192 non exploitable en server-to-server). Cons\xE9quence : l'email de mise \xE0 disposition ne peut afficher que l'adresse de destination d'origine, pas celle du point relais. Aucune solution tant que SEUR n'expose pas le pudo dans l'API PIC."
    },
    credentials: {
      usedFor: ["tracking"],
      fields: [
        { key: "clientId", label: "Client ID", type: "string", required: true },
        { key: "clientSecret", label: "Client Secret", type: "string", required: true, sensitive: true },
        { key: "username", label: "Username", type: "string", required: true },
        { key: "password", label: "Password", type: "string", required: true, sensitive: true },
        { key: "accountNumber", label: "Account Number", type: "string", required: true },
        { key: "businessUnit", label: "Business Unit", type: "string", required: true },
        { key: "idNumber", label: "ID Number (NIF)", type: "string", required: true }
      ],
      supportsCredentialCheck: true
    },
    products: [
      { code: "seur", isPickupPoint: false, name: "SEUR", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "seur_24", isPickupPoint: false, name: "SEUR 24", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "seur_pickup", isPickupPoint: true, name: "SEUR Pickup", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  hermes: {
    name: "Hermes",
    match: (code) => code === "hermes",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "hermes" },
    trackingUrl: {
      url: "https://www.myhermes.de/empfangen/sendungsverfolgung/sendungsinformation/#/{trackingId}",
      fallbackUrl: "https://www.myhermes.de/empfangen/sendungsverfolgung/"
    },
    products: [
      { code: "hermes", isPickupPoint: false, name: "Hermes", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "hermes-pickup", isPickupPoint: true, name: "Hermes ParcelShop", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  "hermes-de": {
    name: "Hermes Germany",
    match: (code) => code === "hermes-de" || code === "hermesde",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "hermes-de" },
    trackingUrl: {
      url: "https://www.myhermes.de/empfangen/sendungsverfolgung/sendungsinformation/#/{trackingId}",
      fallbackUrl: "https://www.myhermes.de/empfangen/sendungsverfolgung/"
    },
    products: [
      { code: "hermes-de", isPickupPoint: false, name: "Hermes Germany", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "hermes-de-pickup", isPickupPoint: true, name: "Hermes Germany PaketShop", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  "hermes-uk": {
    name: "Hermes UK (Evri)",
    match: (code) => code === "hermes-uk" || code === "hermesuk" || code === "evri",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "hermes-uk" },
    trackingUrl: {
      url: "https://www.evri.com/track-a-parcel/{trackingId}",
      fallbackUrl: "https://www.evri.com/track-a-parcel"
    },
    products: [
      { code: "hermes-uk", isPickupPoint: false, name: "Hermes UK (Evri)", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "hermes-uk-pickup", isPickupPoint: true, name: "Evri ParcelShop", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  "swiss-post": {
    name: "Swiss Post",
    logo: "swiss-post.png",
    match: (code) => code === "swiss-post" || code === "swisspost",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "swiss-post" },
    trackingUrl: {
      url: "https://service.post.ch/ekp-web/ui/entry/search/{trackingId}",
      fallbackUrl: "https://www.swisspost.ch/swisspost-tracking"
    },
    meta: {
      trackingMethod: "Via TrackingMore (API universelle)",
      notes: "Impl\xE9mentation API native (developer.post.ch OAuth2) \xE0 pr\xE9voir pour volume \xE9lev\xE9."
    },
    products: [
      { code: "swiss-post", isPickupPoint: false, name: "Swiss Post", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "swiss-post-pickup", isPickupPoint: true, name: "Swiss Post Pickup", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  postnl: {
    name: "PostNL",
    logo: "postnl.png",
    match: (code) => code === "postnl" || code === "post-nl" || code === "post_nl",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "postnl-3s" },
    trackingUrl: {
      url: "https://jouw.postnl.nl/track-and-trace/{trackingId}/{countryCode}/{zipCode}",
      fallbackUrl: "https://jouw.postnl.nl/track-and-trace/",
      requiredFields: ["zipCode", "countryCode"]
    },
    meta: {
      trackingMethod: "Via TrackingMore (API universelle)",
      notes: "Impl\xE9mentation API native (developer.postnl.nl \u2014 Shipping Status) possible plus tard avec credentials par shop (customercode + customernumber + API key via Mijn PostNL Zakelijk), m\xEAme mod\xE8le que UPS/FedEx."
    },
    products: [
      { code: "postnl", isPickupPoint: false, name: "PostNL", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "postnl-pickup", isPickupPoint: true, name: "PostNL Pakketpunt", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  sending: {
    name: "Sending",
    logo: "sending.png",
    match: (code) => code === "sending" || code === "sending-es",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "sending" },
    trackingUrl: {
      url: null,
      fallbackUrl: "https://www.sending.es/en/find-your-shipment/"
    },
    meta: {
      trackingMethod: "Via TrackingMore (API universelle)",
      notes: "Sending Transporte Urgente \u2014 transporteur espagnol (ES/PT/Andorre/Canaries/Bal\xE9ares). Pas de developer portal public ; API native en contrat B2B direct uniquement."
    },
    products: [
      { code: "sending", isPickupPoint: false, name: "Sending", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "sending-pickup", isPickupPoint: true, name: "Sending Pickup", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  // Carriers with tracking URL only (no tracking provider in our system)
  "australia-post": {
    name: "Australia Post",
    match: (code) => code === "australia-post" || code === "australiapost",
    tracking: { provider: "none" },
    trackingUrl: {
      url: "https://auspost.com.au/track/track-details?id={trackingId}",
      fallbackUrl: "https://auspost.com.au/track/"
    },
    products: []
  },
  // Carriers with no tracking URL
  "la-poste": {
    name: "La Poste",
    match: () => false,
    tracking: { provider: "none" },
    products: []
  },
  "customer-carrier": {
    name: "Customer Carrier",
    match: (code) => code === "customer-carrier",
    tracking: { provider: "none" },
    products: []
  },
  "merchant-carrier": {
    name: "Merchant Carrier",
    match: (code) => code === "merchant-carrier",
    tracking: { provider: "none" },
    products: []
  },
  logfret: {
    name: "LogFret",
    match: (code) => code === "logfret",
    tracking: { provider: "none" },
    products: []
  },
  crosslog: {
    name: "Crosslog",
    match: (code) => code === "crosslog",
    tracking: { provider: "none" },
    products: []
  },
  malca: {
    name: "Malca",
    match: (code) => code === "malca",
    tracking: { provider: "none" },
    products: []
  },
  envoidunet: {
    name: "EnvoiDunet",
    match: (code) => code === "envoidunet",
    tracking: { provider: "none" },
    products: []
  },
  bleckmann: {
    name: "Bleckmann",
    match: (code) => code === "bleckmann",
    tracking: { provider: "none" },
    products: []
  },
  sympl: {
    name: "Sympl",
    match: (code) => code === "sympl",
    tracking: { provider: "none" },
    products: []
  },
  "api-carrier": {
    name: "API Carrier",
    match: (code) => code === "api-carrier",
    tracking: { provider: "none" },
    products: []
  }
};
var registryEntries = Object.entries(CARRIER_REGISTRY);
function getDefinition(code) {
  return CARRIER_REGISTRY[code];
}
registryEntries.filter(([, def]) => def.tracking.provider !== "none").map(([code]) => code);
var VARIANT_NAMES = {
  "la-poste-colissimo": "Colissimo",
  "colissimo/colissimo-livraison-a-domicile-avec-signature": "Colissimo",
  colissimov2: "Colissimo",
  "chronopost-18": "Chronopost 18",
  "chrono-relais": "Chrono Relais",
  "chrono-shop2shop": "Chrono Shop2Shop",
  "fake-dpd": "Fake DPD",
  dpdUclUk: "DPD UCL UK",
  "dhl-express": "DHL Express",
  "dhl-economy-select": "DHL Economy Select",
  "dhl-tax-free": "DHL Tax Free",
  "ups-standard": "UPS Standard",
  "ups-saver": "UPS Saver",
  "ups-ground": "UPS Ground"
};
var CARRIERS_NAMES = {
  ...Object.fromEntries(registryEntries.map(([code, def]) => [code, def.name])),
  ...VARIANT_NAMES
};
function mapToCanonicalCarrierCode(carrierCode) {
  const code = carrierCode.toLowerCase();
  for (const [key, def] of registryEntries) {
    if (def.match(code)) {
      return key;
    }
  }
  return null;
}
function getCarrierLabel(code) {
  if (code in CARRIERS_NAMES) return CARRIERS_NAMES[code];
  const canonical = mapToCanonicalCarrierCode(code);
  if (canonical) return getDefinition(canonical).name;
  return code;
}
var NON_BRAND_CARRIER_CODES = /* @__PURE__ */ new Set([
  "custom",
  "customer-carrier",
  "merchant-carrier",
  "api-carrier"
]);
registryEntries.filter(([code]) => !NON_BRAND_CARRIER_CODES.has(code)).map(([, def]) => ({
  name: def.name,
  needle: `-${normalizeShippingLine(def.name)}-`
})).sort((a, b) => b.needle.length - a.needle.length);
function normalizeShippingLine(input) {
  return input.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
var FR_METRO_COUNTRIES = ["FR", "MC"];
var OM1_COUNTRIES = ["GP", "MQ", "GF", "RE", "YT", "BL", "MF", "PM"];
var OM2_COUNTRIES = ["NC", "PF", "WF", "TF"];
var EU_COUNTRIES = [
  // EU member states (FR is FR_METRO)
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  // EEA + Switzerland + UK + European microstates
  "IS",
  "LI",
  "NO",
  "CH",
  "GB",
  "AD",
  "SM",
  "VA",
  "GI"
];
({
  ...Object.fromEntries(FR_METRO_COUNTRIES.map((c) => [c, "FR_METRO"])),
  ...Object.fromEntries(OM1_COUNTRIES.map((c) => [c, "OM1"])),
  ...Object.fromEntries(OM2_COUNTRIES.map((c) => [c, "OM2"])),
  ...Object.fromEntries(EU_COUNTRIES.map((c) => [c, "EU"]))
});
(() => {
  const result = {};
  for (const [code, def] of Object.entries(CARRIER_REGISTRY)) {
    const creds = def.credentials;
    if (creds) {
      result[code] = {
        usedFor: creds.usedFor,
        fields: creds.fields,
        oauth: creds.oauth,
        ipWhitelist: creds.ipWhitelist,
        supportsCredentialCheck: creds.supportsCredentialCheck
      };
    }
  }
  return result;
})();

// ../editor-blocks-library/src/blocks/return-shipping-instructions/carrier-options.ts
var PSEUDO_CARRIER_INSTRUCTION_KEYS = [
  "customerCarrier",
  "merchantCarrier",
  "returnToStore"
];
function useCarrierMessageOptions() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const { variables } = useBlockPanelPropsContext();
  const carrierOptions = variables?.find((v) => v.id === "return.carrierCode")?.options ?? [];
  const options = carrierOptions.filter((o) => o.value !== BON_DE_RETOUR_CONTENT_KEY).map((o) => {
    const instructionKey = CARRIER_TO_INSTRUCTION[o.value];
    const isPseudoCarrier = instructionKey && PSEUDO_CARRIER_INSTRUCTION_KEYS.includes(instructionKey);
    const label = isPseudoCarrier ? t2(
      INSTRUCTION_BY_ID[instructionKey].labelKey,
      INSTRUCTION_BY_ID[instructionKey].labelFallback
    ) : getCarrierLabel(o.value);
    return { value: o.value, label };
  });
  options.push({
    value: BON_DE_RETOUR_CONTENT_KEY,
    label: t2(
      INSTRUCTION_BY_ID.bonDeRetour.labelKey,
      INSTRUCTION_BY_ID.bonDeRetour.labelFallback
    )
  });
  return options;
}

// ../../node_modules/.pnpm/prosemirror-dropcursor@1.8.2/node_modules/prosemirror-dropcursor/dist/index.js
function dropCursor(options = {}) {
  return new Plugin({
    view(editorView) {
      return new DropCursorView(editorView, options);
    }
  });
}
var DropCursorView = class {
  constructor(editorView, options) {
    var _a;
    this.editorView = editorView;
    this.cursorPos = null;
    this.element = null;
    this.timeout = -1;
    this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 1;
    this.color = options.color === false ? void 0 : options.color || "black";
    this.class = options.class;
    this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((name) => {
      let handler = (e) => {
        this[name](e);
      };
      editorView.dom.addEventListener(name, handler);
      return { name, handler };
    });
  }
  destroy() {
    this.handlers.forEach(({ name, handler }) => this.editorView.dom.removeEventListener(name, handler));
  }
  update(editorView, prevState) {
    if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
      if (this.cursorPos > editorView.state.doc.content.size)
        this.setCursor(null);
      else
        this.updateOverlay();
    }
  }
  setCursor(pos) {
    if (pos == this.cursorPos)
      return;
    this.cursorPos = pos;
    if (pos == null) {
      this.element.parentNode.removeChild(this.element);
      this.element = null;
    } else {
      this.updateOverlay();
    }
  }
  updateOverlay() {
    let $pos = this.editorView.state.doc.resolve(this.cursorPos);
    let isBlock = !$pos.parent.inlineContent, rect;
    let editorDOM = this.editorView.dom, editorRect = editorDOM.getBoundingClientRect();
    let scaleX = editorRect.width / editorDOM.offsetWidth, scaleY = editorRect.height / editorDOM.offsetHeight;
    if (isBlock) {
      let before = $pos.nodeBefore, after = $pos.nodeAfter;
      if (before || after) {
        let node = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
        if (node) {
          let nodeRect = node.getBoundingClientRect();
          let top2 = before ? nodeRect.bottom : nodeRect.top;
          if (before && after)
            top2 = (top2 + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
          let halfWidth = this.width / 2 * scaleY;
          rect = { left: nodeRect.left, right: nodeRect.right, top: top2 - halfWidth, bottom: top2 + halfWidth };
        }
      }
    }
    if (!rect) {
      let coords = this.editorView.coordsAtPos(this.cursorPos);
      let halfWidth = this.width / 2 * scaleX;
      rect = { left: coords.left - halfWidth, right: coords.left + halfWidth, top: coords.top, bottom: coords.bottom };
    }
    let parent = this.editorView.dom.offsetParent;
    if (!this.element) {
      this.element = parent.appendChild(document.createElement("div"));
      if (this.class)
        this.element.className = this.class;
      this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
      if (this.color) {
        this.element.style.backgroundColor = this.color;
      }
    }
    this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
    this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
    let parentLeft, parentTop;
    if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
      parentLeft = -pageXOffset;
      parentTop = -pageYOffset;
    } else {
      let rect2 = parent.getBoundingClientRect();
      let parentScaleX = rect2.width / parent.offsetWidth, parentScaleY = rect2.height / parent.offsetHeight;
      parentLeft = rect2.left - parent.scrollLeft * parentScaleX;
      parentTop = rect2.top - parent.scrollTop * parentScaleY;
    }
    this.element.style.left = (rect.left - parentLeft) / scaleX + "px";
    this.element.style.top = (rect.top - parentTop) / scaleY + "px";
    this.element.style.width = (rect.right - rect.left) / scaleX + "px";
    this.element.style.height = (rect.bottom - rect.top) / scaleY + "px";
  }
  scheduleRemoval(timeout) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.setCursor(null), timeout);
  }
  dragover(event) {
    if (!this.editorView.editable)
      return;
    let pos = this.editorView.posAtCoords({ left: event.clientX, top: event.clientY });
    let node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
    let disableDropCursor = node && node.type.spec.disableDropCursor;
    let disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
    if (pos && !disabled) {
      let target = pos.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let point = dropPoint(this.editorView.state.doc, target, this.editorView.dragging.slice);
        if (point != null)
          target = point;
      }
      this.setCursor(target);
      this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(event) {
    if (!this.editorView.dom.contains(event.relatedTarget))
      this.setCursor(null);
  }
};

// ../../node_modules/.pnpm/prosemirror-gapcursor@1.4.0/node_modules/prosemirror-gapcursor/dist/index.js
var GapCursor = class _GapCursor extends Selection {
  /**
  Create a gap cursor.
  */
  constructor($pos) {
    super($pos, $pos);
  }
  map(doc3, mapping) {
    let $pos = doc3.resolve(mapping.map(this.head));
    return _GapCursor.valid($pos) ? new _GapCursor($pos) : Selection.near($pos);
  }
  content() {
    return Slice.empty;
  }
  eq(other) {
    return other instanceof _GapCursor && other.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(doc3, json) {
    if (typeof json.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new _GapCursor(doc3.resolve(json.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new GapBookmark(this.anchor);
  }
  /**
  @internal
  */
  static valid($pos) {
    let parent = $pos.parent;
    if (parent.isTextblock || !closedBefore($pos) || !closedAfter($pos))
      return false;
    let override = parent.type.spec.allowGapCursor;
    if (override != null)
      return override;
    let deflt = parent.contentMatchAt($pos.index()).defaultType;
    return deflt && deflt.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom($pos, dir, mustMove = false) {
    search: for (; ; ) {
      if (!mustMove && _GapCursor.valid($pos))
        return $pos;
      let pos = $pos.pos, next = null;
      for (let d = $pos.depth; ; d--) {
        let parent = $pos.node(d);
        if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
          next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
          break;
        } else if (d == 0) {
          return null;
        }
        pos += dir;
        let $cur = $pos.doc.resolve(pos);
        if (_GapCursor.valid($cur))
          return $cur;
      }
      for (; ; ) {
        let inside = dir > 0 ? next.firstChild : next.lastChild;
        if (!inside) {
          if (next.isAtom && !next.isText && !NodeSelection.isSelectable(next)) {
            $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
            mustMove = false;
            continue search;
          }
          break;
        }
        next = inside;
        pos += dir;
        let $cur = $pos.doc.resolve(pos);
        if (_GapCursor.valid($cur))
          return $cur;
      }
      return null;
    }
  }
};
GapCursor.prototype.visible = false;
GapCursor.findFrom = GapCursor.findGapCursorFrom;
Selection.jsonID("gapcursor", GapCursor);
var GapBookmark = class _GapBookmark {
  constructor(pos) {
    this.pos = pos;
  }
  map(mapping) {
    return new _GapBookmark(mapping.map(this.pos));
  }
  resolve(doc3) {
    let $pos = doc3.resolve(this.pos);
    return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos);
  }
};
function needsGap(type) {
  return type.isAtom || type.spec.isolating || type.spec.createGapCursor;
}
function closedBefore($pos) {
  for (let d = $pos.depth; d >= 0; d--) {
    let index2 = $pos.index(d), parent = $pos.node(d);
    if (index2 == 0) {
      if (parent.type.spec.isolating)
        return true;
      continue;
    }
    for (let before = parent.child(index2 - 1); ; before = before.lastChild) {
      if (before.childCount == 0 && !before.inlineContent || needsGap(before.type))
        return true;
      if (before.inlineContent)
        return false;
    }
  }
  return true;
}
function closedAfter($pos) {
  for (let d = $pos.depth; d >= 0; d--) {
    let index2 = $pos.indexAfter(d), parent = $pos.node(d);
    if (index2 == parent.childCount) {
      if (parent.type.spec.isolating)
        return true;
      continue;
    }
    for (let after = parent.child(index2); ; after = after.firstChild) {
      if (after.childCount == 0 && !after.inlineContent || needsGap(after.type))
        return true;
      if (after.inlineContent)
        return false;
    }
  }
  return true;
}
function gapCursor() {
  return new Plugin({
    props: {
      decorations: drawGapCursor,
      createSelectionBetween(_view, $anchor, $head) {
        return $anchor.pos == $head.pos && GapCursor.valid($head) ? new GapCursor($head) : null;
      },
      handleClick,
      handleKeyDown,
      handleDOMEvents: { beforeinput }
    }
  });
}
var handleKeyDown = keydownHandler({
  "ArrowLeft": arrow5("horiz", -1),
  "ArrowRight": arrow5("horiz", 1),
  "ArrowUp": arrow5("vert", -1),
  "ArrowDown": arrow5("vert", 1)
});
function arrow5(axis, dir) {
  const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
  return function(state, dispatch, view) {
    let sel = state.selection;
    let $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
    if (sel instanceof TextSelection) {
      if (!view.endOfTextblock(dirStr) || $start.depth == 0)
        return false;
      mustMove = false;
      $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
    }
    let $found = GapCursor.findGapCursorFrom($start, dir, mustMove);
    if (!$found)
      return false;
    if (dispatch)
      dispatch(state.tr.setSelection(new GapCursor($found)));
    return true;
  };
}
function handleClick(view, pos, event) {
  if (!view || !view.editable)
    return false;
  let $pos = view.state.doc.resolve(pos);
  if (!GapCursor.valid($pos))
    return false;
  let clickPos = view.posAtCoords({ left: event.clientX, top: event.clientY });
  if (clickPos && clickPos.inside > -1 && NodeSelection.isSelectable(view.state.doc.nodeAt(clickPos.inside)))
    return false;
  view.dispatch(view.state.tr.setSelection(new GapCursor($pos)));
  return true;
}
function beforeinput(view, event) {
  if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof GapCursor))
    return false;
  let { $from } = view.state.selection;
  let insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
  if (!insert)
    return false;
  let frag = Fragment6.empty;
  for (let i = insert.length - 1; i >= 0; i--)
    frag = Fragment6.from(insert[i].createAndFill(null, frag));
  let tr2 = view.state.tr.replace($from.pos, $from.pos, new Slice(frag, 0, 0));
  tr2.setSelection(TextSelection.near(tr2.doc.resolve($from.pos + 1)));
  view.dispatch(tr2);
  return false;
}
function drawGapCursor(state) {
  if (!(state.selection instanceof GapCursor))
    return null;
  let node = document.createElement("div");
  node.className = "ProseMirror-gapcursor";
  return DecorationSet.create(state.doc, [Decoration.widget(state.selection.head, node, { key: "gapcursor" })]);
}

// ../../node_modules/.pnpm/rope-sequence@1.3.4/node_modules/rope-sequence/dist/index.js
var GOOD_LEAF_SIZE = 200;
var RopeSequence = function RopeSequence2() {
};
RopeSequence.prototype.append = function append(other) {
  if (!other.length) {
    return this;
  }
  other = RopeSequence.from(other);
  return !this.length && other || other.length < GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
RopeSequence.prototype.prepend = function prepend(other) {
  if (!other.length) {
    return this;
  }
  return RopeSequence.from(other).append(this);
};
RopeSequence.prototype.appendInner = function appendInner(other) {
  return new Append(this, other);
};
RopeSequence.prototype.slice = function slice(from2, to) {
  if (from2 === void 0) from2 = 0;
  if (to === void 0) to = this.length;
  if (from2 >= to) {
    return RopeSequence.empty;
  }
  return this.sliceInner(Math.max(0, from2), Math.min(this.length, to));
};
RopeSequence.prototype.get = function get(i) {
  if (i < 0 || i >= this.length) {
    return void 0;
  }
  return this.getInner(i);
};
RopeSequence.prototype.forEach = function forEach2(f, from2, to) {
  if (from2 === void 0) from2 = 0;
  if (to === void 0) to = this.length;
  if (from2 <= to) {
    this.forEachInner(f, from2, to, 0);
  } else {
    this.forEachInvertedInner(f, from2, to, 0);
  }
};
RopeSequence.prototype.map = function map(f, from2, to) {
  if (from2 === void 0) from2 = 0;
  if (to === void 0) to = this.length;
  var result = [];
  this.forEach(function(elt, i) {
    return result.push(f(elt, i));
  }, from2, to);
  return result;
};
RopeSequence.from = function from(values) {
  if (values instanceof RopeSequence) {
    return values;
  }
  return values && values.length ? new Leaf(values) : RopeSequence.empty;
};
var Leaf = /* @__PURE__ */ (function(RopeSequence3) {
  function Leaf2(values) {
    RopeSequence3.call(this);
    this.values = values;
  }
  if (RopeSequence3) Leaf2.__proto__ = RopeSequence3;
  Leaf2.prototype = Object.create(RopeSequence3 && RopeSequence3.prototype);
  Leaf2.prototype.constructor = Leaf2;
  var prototypeAccessors = { length: { configurable: true }, depth: { configurable: true } };
  Leaf2.prototype.flatten = function flatten() {
    return this.values;
  };
  Leaf2.prototype.sliceInner = function sliceInner(from2, to) {
    if (from2 == 0 && to == this.length) {
      return this;
    }
    return new Leaf2(this.values.slice(from2, to));
  };
  Leaf2.prototype.getInner = function getInner(i) {
    return this.values[i];
  };
  Leaf2.prototype.forEachInner = function forEachInner(f, from2, to, start2) {
    for (var i = from2; i < to; i++) {
      if (f(this.values[i], start2 + i) === false) {
        return false;
      }
    }
  };
  Leaf2.prototype.forEachInvertedInner = function forEachInvertedInner(f, from2, to, start2) {
    for (var i = from2 - 1; i >= to; i--) {
      if (f(this.values[i], start2 + i) === false) {
        return false;
      }
    }
  };
  Leaf2.prototype.leafAppend = function leafAppend(other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE) {
      return new Leaf2(this.values.concat(other.flatten()));
    }
  };
  Leaf2.prototype.leafPrepend = function leafPrepend(other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE) {
      return new Leaf2(other.flatten().concat(this.values));
    }
  };
  prototypeAccessors.length.get = function() {
    return this.values.length;
  };
  prototypeAccessors.depth.get = function() {
    return 0;
  };
  Object.defineProperties(Leaf2.prototype, prototypeAccessors);
  return Leaf2;
})(RopeSequence);
RopeSequence.empty = new Leaf([]);
var Append = /* @__PURE__ */ (function(RopeSequence3) {
  function Append2(left2, right2) {
    RopeSequence3.call(this);
    this.left = left2;
    this.right = right2;
    this.length = left2.length + right2.length;
    this.depth = Math.max(left2.depth, right2.depth) + 1;
  }
  if (RopeSequence3) Append2.__proto__ = RopeSequence3;
  Append2.prototype = Object.create(RopeSequence3 && RopeSequence3.prototype);
  Append2.prototype.constructor = Append2;
  Append2.prototype.flatten = function flatten() {
    return this.left.flatten().concat(this.right.flatten());
  };
  Append2.prototype.getInner = function getInner(i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
  };
  Append2.prototype.forEachInner = function forEachInner(f, from2, to, start2) {
    var leftLen = this.left.length;
    if (from2 < leftLen && this.left.forEachInner(f, from2, Math.min(to, leftLen), start2) === false) {
      return false;
    }
    if (to > leftLen && this.right.forEachInner(f, Math.max(from2 - leftLen, 0), Math.min(this.length, to) - leftLen, start2 + leftLen) === false) {
      return false;
    }
  };
  Append2.prototype.forEachInvertedInner = function forEachInvertedInner(f, from2, to, start2) {
    var leftLen = this.left.length;
    if (from2 > leftLen && this.right.forEachInvertedInner(f, from2 - leftLen, Math.max(to, leftLen) - leftLen, start2 + leftLen) === false) {
      return false;
    }
    if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from2, leftLen), to, start2) === false) {
      return false;
    }
  };
  Append2.prototype.sliceInner = function sliceInner(from2, to) {
    if (from2 == 0 && to == this.length) {
      return this;
    }
    var leftLen = this.left.length;
    if (to <= leftLen) {
      return this.left.slice(from2, to);
    }
    if (from2 >= leftLen) {
      return this.right.slice(from2 - leftLen, to - leftLen);
    }
    return this.left.slice(from2, leftLen).append(this.right.slice(0, to - leftLen));
  };
  Append2.prototype.leafAppend = function leafAppend(other) {
    var inner = this.right.leafAppend(other);
    if (inner) {
      return new Append2(this.left, inner);
    }
  };
  Append2.prototype.leafPrepend = function leafPrepend(other) {
    var inner = this.left.leafPrepend(other);
    if (inner) {
      return new Append2(inner, this.right);
    }
  };
  Append2.prototype.appendInner = function appendInner2(other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) {
      return new Append2(this.left, new Append2(this.right, other));
    }
    return new Append2(this, other);
  };
  return Append2;
})(RopeSequence);
var dist_default2 = RopeSequence;

// ../../node_modules/.pnpm/prosemirror-history@1.5.0/node_modules/prosemirror-history/dist/index.js
var max_empty_items = 500;
var Branch = class _Branch {
  constructor(items, eventCount) {
    this.items = items;
    this.eventCount = eventCount;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(state, preserveItems) {
    if (this.eventCount == 0)
      return null;
    let end2 = this.items.length;
    for (; ; end2--) {
      let next = this.items.get(end2 - 1);
      if (next.selection) {
        --end2;
        break;
      }
    }
    let remap, mapFrom;
    if (preserveItems) {
      remap = this.remapping(end2, this.items.length);
      mapFrom = remap.maps.length;
    }
    let transform = state.tr;
    let selection, remaining;
    let addAfter = [], addBefore = [];
    this.items.forEach((item, i) => {
      if (!item.step) {
        if (!remap) {
          remap = this.remapping(end2, i + 1);
          mapFrom = remap.maps.length;
        }
        mapFrom--;
        addBefore.push(item);
        return;
      }
      if (remap) {
        addBefore.push(new Item3(item.map));
        let step = item.step.map(remap.slice(mapFrom)), map2;
        if (step && transform.maybeStep(step).doc) {
          map2 = transform.mapping.maps[transform.mapping.maps.length - 1];
          addAfter.push(new Item3(map2, void 0, void 0, addAfter.length + addBefore.length));
        }
        mapFrom--;
        if (map2)
          remap.appendMap(map2, mapFrom);
      } else {
        transform.maybeStep(item.step);
      }
      if (item.selection) {
        selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
        remaining = new _Branch(this.items.slice(0, end2).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
        return false;
      }
    }, this.items.length, 0);
    return { remaining, transform, selection };
  }
  // Create a new branch with the given transform added.
  addTransform(transform, selection, histOptions, preserveItems) {
    let newItems = [], eventCount = this.eventCount;
    let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
    for (let i = 0; i < transform.steps.length; i++) {
      let step = transform.steps[i].invert(transform.docs[i]);
      let item = new Item3(transform.mapping.maps[i], step, selection), merged;
      if (merged = lastItem && lastItem.merge(item)) {
        item = merged;
        if (i)
          newItems.pop();
        else
          oldItems = oldItems.slice(0, oldItems.length - 1);
      }
      newItems.push(item);
      if (selection) {
        eventCount++;
        selection = void 0;
      }
      if (!preserveItems)
        lastItem = item;
    }
    let overflow = eventCount - histOptions.depth;
    if (overflow > DEPTH_OVERFLOW) {
      oldItems = cutOffEvents(oldItems, overflow);
      eventCount -= overflow;
    }
    return new _Branch(oldItems.append(newItems), eventCount);
  }
  remapping(from2, to) {
    let maps = new Mapping();
    this.items.forEach((item, i) => {
      let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from2 ? maps.maps.length - item.mirrorOffset : void 0;
      maps.appendMap(item.map, mirrorPos);
    }, from2, to);
    return maps;
  }
  addMaps(array) {
    if (this.eventCount == 0)
      return this;
    return new _Branch(this.items.append(array.map((map2) => new Item3(map2))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(rebasedTransform, rebasedCount) {
    if (!this.eventCount)
      return this;
    let rebasedItems = [], start2 = Math.max(0, this.items.length - rebasedCount);
    let mapping = rebasedTransform.mapping;
    let newUntil = rebasedTransform.steps.length;
    let eventCount = this.eventCount;
    this.items.forEach((item) => {
      if (item.selection)
        eventCount--;
    }, start2);
    let iRebased = rebasedCount;
    this.items.forEach((item) => {
      let pos = mapping.getMirror(--iRebased);
      if (pos == null)
        return;
      newUntil = Math.min(newUntil, pos);
      let map2 = mapping.maps[pos];
      if (item.step) {
        let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
        let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
        if (selection)
          eventCount++;
        rebasedItems.push(new Item3(map2, step, selection));
      } else {
        rebasedItems.push(new Item3(map2));
      }
    }, start2);
    let newMaps = [];
    for (let i = rebasedCount; i < newUntil; i++)
      newMaps.push(new Item3(mapping.maps[i]));
    let items = this.items.slice(0, start2).append(newMaps).append(rebasedItems);
    let branch = new _Branch(items, eventCount);
    if (branch.emptyItemCount() > max_empty_items)
      branch = branch.compress(this.items.length - rebasedItems.length);
    return branch;
  }
  emptyItemCount() {
    let count3 = 0;
    this.items.forEach((item) => {
      if (!item.step)
        count3++;
    });
    return count3;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(upto = this.items.length) {
    let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
    let items = [], events = 0;
    this.items.forEach((item, i) => {
      if (i >= upto) {
        items.push(item);
        if (item.selection)
          events++;
      } else if (item.step) {
        let step = item.step.map(remap.slice(mapFrom)), map2 = step && step.getMap();
        mapFrom--;
        if (map2)
          remap.appendMap(map2, mapFrom);
        if (step) {
          let selection = item.selection && item.selection.map(remap.slice(mapFrom));
          if (selection)
            events++;
          let newItem = new Item3(map2.invert(), step, selection), merged, last = items.length - 1;
          if (merged = items.length && items[last].merge(newItem))
            items[last] = merged;
          else
            items.push(newItem);
        }
      } else if (item.map) {
        mapFrom--;
      }
    }, this.items.length, 0);
    return new _Branch(dist_default2.from(items.reverse()), events);
  }
};
Branch.empty = new Branch(dist_default2.empty, 0);
function cutOffEvents(items, n) {
  let cutPoint;
  items.forEach((item, i) => {
    if (item.selection && n-- == 0) {
      cutPoint = i;
      return false;
    }
  });
  return items.slice(cutPoint);
}
var Item3 = class _Item {
  constructor(map2, step, selection, mirrorOffset) {
    this.map = map2;
    this.step = step;
    this.selection = selection;
    this.mirrorOffset = mirrorOffset;
  }
  merge(other) {
    if (this.step && other.step && !other.selection) {
      let step = other.step.merge(this.step);
      if (step)
        return new _Item(step.getMap().invert(), step, this.selection);
    }
  }
};
var HistoryState = class {
  constructor(done, undone, prevRanges, prevTime, prevComposition) {
    this.done = done;
    this.undone = undone;
    this.prevRanges = prevRanges;
    this.prevTime = prevTime;
    this.prevComposition = prevComposition;
  }
};
var DEPTH_OVERFLOW = 20;
function applyTransaction(history2, state, tr2, options) {
  let historyTr = tr2.getMeta(historyKey), rebased;
  if (historyTr)
    return historyTr.historyState;
  if (tr2.getMeta(closeHistoryKey))
    history2 = new HistoryState(history2.done, history2.undone, null, 0, -1);
  let appended = tr2.getMeta("appendedTransaction");
  if (tr2.steps.length == 0) {
    return history2;
  } else if (appended && appended.getMeta(historyKey)) {
    if (appended.getMeta(historyKey).redo)
      return new HistoryState(history2.done.addTransform(tr2, void 0, options, mustPreserveItems(state)), history2.undone, rangesFor(tr2.mapping.maps), history2.prevTime, history2.prevComposition);
    else
      return new HistoryState(history2.done, history2.undone.addTransform(tr2, void 0, options, mustPreserveItems(state)), null, history2.prevTime, history2.prevComposition);
  } else if (tr2.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
    let composition = tr2.getMeta("composition");
    let newGroup = history2.prevTime == 0 || !appended && history2.prevComposition != composition && (history2.prevTime < (tr2.time || 0) - options.newGroupDelay || !isAdjacentTo(tr2, history2.prevRanges));
    let prevRanges = appended ? mapRanges(history2.prevRanges, tr2.mapping) : rangesFor(tr2.mapping.maps);
    return new HistoryState(history2.done.addTransform(tr2, newGroup ? state.selection.getBookmark() : void 0, options, mustPreserveItems(state)), Branch.empty, prevRanges, tr2.time, composition == null ? history2.prevComposition : composition);
  } else if (rebased = tr2.getMeta("rebased")) {
    return new HistoryState(history2.done.rebased(tr2, rebased), history2.undone.rebased(tr2, rebased), mapRanges(history2.prevRanges, tr2.mapping), history2.prevTime, history2.prevComposition);
  } else {
    return new HistoryState(history2.done.addMaps(tr2.mapping.maps), history2.undone.addMaps(tr2.mapping.maps), mapRanges(history2.prevRanges, tr2.mapping), history2.prevTime, history2.prevComposition);
  }
}
function isAdjacentTo(transform, prevRanges) {
  if (!prevRanges)
    return false;
  if (!transform.docChanged)
    return true;
  let adjacent = false;
  transform.mapping.maps[0].forEach((start2, end2) => {
    for (let i = 0; i < prevRanges.length; i += 2)
      if (start2 <= prevRanges[i + 1] && end2 >= prevRanges[i])
        adjacent = true;
  });
  return adjacent;
}
function rangesFor(maps) {
  let result = [];
  for (let i = maps.length - 1; i >= 0 && result.length == 0; i--)
    maps[i].forEach((_from, _to, from2, to) => result.push(from2, to));
  return result;
}
function mapRanges(ranges, mapping) {
  if (!ranges)
    return null;
  let result = [];
  for (let i = 0; i < ranges.length; i += 2) {
    let from2 = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
    if (from2 <= to)
      result.push(from2, to);
  }
  return result;
}
function histTransaction(history2, state, redo2) {
  let preserveItems = mustPreserveItems(state);
  let histOptions = historyKey.get(state).spec.config;
  let pop = (redo2 ? history2.undone : history2.done).popEvent(state, preserveItems);
  if (!pop)
    return null;
  let selection = pop.selection.resolve(pop.transform.doc);
  let added = (redo2 ? history2.done : history2.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
  let newHist = new HistoryState(redo2 ? added : pop.remaining, redo2 ? pop.remaining : added, null, 0, -1);
  return pop.transform.setSelection(selection).setMeta(historyKey, { redo: redo2, historyState: newHist });
}
var cachedPreserveItems = false;
var cachedPreserveItemsPlugins = null;
function mustPreserveItems(state) {
  let plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (let i = 0; i < plugins.length; i++)
      if (plugins[i].spec.historyPreserveItems) {
        cachedPreserveItems = true;
        break;
      }
  }
  return cachedPreserveItems;
}
var historyKey = new PluginKey("history");
var closeHistoryKey = new PluginKey("closeHistory");
function history(config = {}) {
  config = {
    depth: config.depth || 100,
    newGroupDelay: config.newGroupDelay || 500
  };
  return new Plugin({
    key: historyKey,
    state: {
      init() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0, -1);
      },
      apply(tr2, hist, state) {
        return applyTransaction(hist, state, tr2, config);
      }
    },
    config,
    props: {
      handleDOMEvents: {
        beforeinput(view, e) {
          let inputType = e.inputType;
          let command2 = inputType == "historyUndo" ? undo : inputType == "historyRedo" ? redo : null;
          if (!command2 || !view.editable)
            return false;
          e.preventDefault();
          return command2(view.state, view.dispatch);
        }
      }
    }
  });
}
function buildCommand(redo2, scroll) {
  return (state, dispatch) => {
    let hist = historyKey.getState(state);
    if (!hist || (redo2 ? hist.undone : hist.done).eventCount == 0)
      return false;
    if (dispatch) {
      let tr2 = histTransaction(hist, state, redo2);
      if (tr2)
        dispatch(scroll ? tr2.scrollIntoView() : tr2);
    }
    return true;
  };
}
var undo = buildCommand(false, true);
var redo = buildCommand(true, true);

// ../../node_modules/.pnpm/@tiptap+extensions@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0__@tiptap+pm@3.20.0/node_modules/@tiptap/extensions/dist/index.js
Extension.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (text) => text.length,
      wordCounter: (text) => text.split(" ").filter((word) => word !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (options) => {
      const node = (options == null ? void 0 : options.node) || this.editor.state.doc;
      const mode = (options == null ? void 0 : options.mode) || this.options.mode;
      if (mode === "textSize") {
        const text = node.textBetween(0, node.content.size, void 0, " ");
        return this.options.textCounter(text);
      }
      return node.nodeSize;
    };
    this.storage.words = (options) => {
      const node = (options == null ? void 0 : options.node) || this.editor.state.doc;
      const text = node.textBetween(0, node.content.size, " ", " ");
      return this.options.wordCounter(text);
    };
  },
  addProseMirrorPlugins() {
    let initialEvaluationDone = false;
    return [
      new Plugin({
        key: new PluginKey("characterCount"),
        appendTransaction: (transactions, oldState, newState) => {
          if (initialEvaluationDone) {
            return;
          }
          const limit = this.options.limit;
          if (limit === null || limit === void 0 || limit === 0) {
            initialEvaluationDone = true;
            return;
          }
          const initialContentSize = this.storage.characters({ node: newState.doc });
          if (initialContentSize > limit) {
            const over = initialContentSize - limit;
            const from2 = 0;
            const to = over;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${limit} characters. Content was automatically trimmed.`
            );
            const tr2 = newState.tr.deleteRange(from2, to);
            initialEvaluationDone = true;
            return tr2;
          }
          initialEvaluationDone = true;
        },
        filterTransaction: (transaction, state) => {
          const limit = this.options.limit;
          if (!transaction.docChanged || limit === 0 || limit === null || limit === void 0) {
            return true;
          }
          const oldSize = this.storage.characters({ node: state.doc });
          const newSize = this.storage.characters({ node: transaction.doc });
          if (newSize <= limit) {
            return true;
          }
          if (oldSize > limit && newSize > limit && newSize <= oldSize) {
            return true;
          }
          if (oldSize > limit && newSize > limit && newSize > oldSize) {
            return false;
          }
          const isPaste = transaction.getMeta("paste");
          if (!isPaste) {
            return false;
          }
          const pos = transaction.selection.$head.pos;
          const over = newSize - limit;
          const from2 = pos - over;
          const to = pos;
          transaction.deleteRange(from2, to);
          const updatedSize = this.storage.characters({ node: transaction.doc });
          if (updatedSize > limit) {
            return false;
          }
          return true;
        }
      })
    ];
  }
});
Extension.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [dropCursor(this.options)];
  }
});
Extension.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("focus"),
        props: {
          decorations: ({ doc: doc3, selection }) => {
            const { isEditable, isFocused } = this.editor;
            const { anchor } = selection;
            const decorations = [];
            if (!isEditable || !isFocused) {
              return DecorationSet.create(doc3, []);
            }
            let maxLevels = 0;
            if (this.options.mode === "deepest") {
              doc3.descendants((node, pos) => {
                if (node.isText) {
                  return;
                }
                const isCurrent = anchor >= pos && anchor <= pos + node.nodeSize - 1;
                if (!isCurrent) {
                  return false;
                }
                maxLevels += 1;
              });
            }
            let currentLevel = 0;
            doc3.descendants((node, pos) => {
              if (node.isText) {
                return false;
              }
              const isCurrent = anchor >= pos && anchor <= pos + node.nodeSize - 1;
              if (!isCurrent) {
                return false;
              }
              currentLevel += 1;
              const outOfScope = this.options.mode === "deepest" && maxLevels - currentLevel > 0 || this.options.mode === "shallowest" && currentLevel > 1;
              if (outOfScope) {
                return this.options.mode === "deepest";
              }
              decorations.push(
                Decoration.node(pos, pos + node.nodeSize, {
                  class: this.options.className
                })
              );
            });
            return DecorationSet.create(doc3, decorations);
          }
        }
      })
    ];
  }
});
Extension.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [gapCursor()];
  },
  extendNodeSchema(extension) {
    var _a;
    const context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage
    };
    return {
      allowGapCursor: (_a = callOrReturn(getExtensionField(extension, "allowGapCursor", context))) != null ? _a : null
    };
  }
});
var DEFAULT_DATA_ATTRIBUTE = "placeholder";
function preparePlaceholderAttribute(attr) {
  return attr.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
var Placeholder = Extension.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: DEFAULT_DATA_ATTRIBUTE,
      placeholder: "Write something \u2026",
      showOnlyWhenEditable: true,
      showOnlyCurrent: true,
      includeChildren: false
    };
  },
  addProseMirrorPlugins() {
    const dataAttribute = this.options.dataAttribute ? `data-${preparePlaceholderAttribute(this.options.dataAttribute)}` : `data-${DEFAULT_DATA_ATTRIBUTE}`;
    return [
      new Plugin({
        key: new PluginKey("placeholder"),
        props: {
          decorations: ({ doc: doc3, selection }) => {
            const active = this.editor.isEditable || !this.options.showOnlyWhenEditable;
            const { anchor } = selection;
            const decorations = [];
            if (!active) {
              return null;
            }
            const isEmptyDoc = this.editor.isEmpty;
            doc3.descendants((node, pos) => {
              const hasAnchor = anchor >= pos && anchor <= pos + node.nodeSize;
              const isEmpty = !node.isLeaf && isNodeEmpty(node);
              if ((hasAnchor || !this.options.showOnlyCurrent) && isEmpty) {
                const classes = [this.options.emptyNodeClass];
                if (isEmptyDoc) {
                  classes.push(this.options.emptyEditorClass);
                }
                const decoration = Decoration.node(pos, pos + node.nodeSize, {
                  class: classes.join(" "),
                  [dataAttribute]: typeof this.options.placeholder === "function" ? this.options.placeholder({
                    editor: this.editor,
                    node,
                    pos,
                    hasAnchor
                  }) : this.options.placeholder
                });
                decorations.push(decoration);
              }
              return this.options.includeChildren;
            });
            return DecorationSet.create(doc3, decorations);
          }
        }
      })
    ];
  }
});
Extension.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor, options } = this;
    return [
      new Plugin({
        key: new PluginKey("selection"),
        props: {
          decorations(state) {
            if (state.selection.empty || editor.isFocused || !editor.isEditable || isNodeSelection(state.selection) || editor.view.dragging) {
              return null;
            }
            return DecorationSet.create(state.doc, [
              Decoration.inline(state.selection.from, state.selection.to, {
                class: options.className
              })
            ]);
          }
        }
      })
    ];
  }
});
function nodeEqualsType({ types, node }) {
  return node && Array.isArray(types) && types.includes(node.type) || (node == null ? void 0 : node.type) === types;
}
Extension.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var _a;
    const plugin = new PluginKey(this.name);
    const defaultNode = this.options.node || ((_a = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : _a.name) || "paragraph";
    const disabledNodes = Object.entries(this.editor.schema.nodes).map(([, value]) => value).filter((node) => (this.options.notAfter || []).concat(defaultNode).includes(node.name));
    return [
      new Plugin({
        key: plugin,
        appendTransaction: (_, __, state) => {
          const { doc: doc3, tr: tr2, schema } = state;
          const shouldInsertNodeAtEnd = plugin.getState(state);
          const endPosition = doc3.content.size;
          const type = schema.nodes[defaultNode];
          if (!shouldInsertNodeAtEnd) {
            return;
          }
          return tr2.insert(endPosition, type.create());
        },
        state: {
          init: (_, state) => {
            const lastNode = state.tr.doc.lastChild;
            return !nodeEqualsType({ node: lastNode, types: disabledNodes });
          },
          apply: (tr2, value) => {
            if (!tr2.docChanged) {
              return value;
            }
            if (tr2.getMeta("__uniqueIDTransaction")) {
              return value;
            }
            const lastNode = tr2.doc.lastChild;
            return !nodeEqualsType({ node: lastNode, types: disabledNodes });
          }
        }
      })
    ];
  }
});
Extension.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state, dispatch }) => {
        return undo(state, dispatch);
      },
      redo: () => ({ state, dispatch }) => {
        return redo(state, dispatch);
      }
    };
  },
  addProseMirrorPlugins() {
    return [history(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-\u044F": () => this.editor.commands.undo(),
      "Shift-Mod-\u044F": () => this.editor.commands.redo()
    };
  }
});

// ../../node_modules/.pnpm/@tiptap+extension-placeholder@3.26.1_@tiptap+extensions@3.20.0_@tiptap+core@3.20.0_@tiptap+pm@3.20.0__@tiptap+pm@3.20.0_/node_modules/@tiptap/extension-placeholder/dist/index.js
var index_default10 = Placeholder;
function useInstructionEditor(contentKey) {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI, locale, defaultLocale, section, theme } = blockProps;
  const block = blockProps.block;
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const unavailableVariableIds = useUnavailableVariableIds();
  const content = block.content?.[locale]?.[contentKey] ?? "";
  const t2 = tLayout(locale, defaultLocale);
  const def = INSTRUCTION_BY_ID[resolveInstructionKey(
    contentKey,
    contentKey === BON_DE_RETOUR_CONTENT_KEY
  )];
  const translated = t2(def.tLayoutKey);
  const placeholder = translated === def.tLayoutKey ? def.fallback : translated;
  const updateTimeoutRef = useRef(null);
  const blockRef = useRef(block);
  const formAPIRef = useRef(formAPI);
  blockRef.current = block;
  formAPIRef.current = formAPI;
  const editor = useEditor({
    extensions: [
      index_default,
      mention_extension_default(
        blockProps.variables,
        unavailableVariableIds
      ),
      index_default3.configure({
        HTMLAttributes: {
          style: "font-size:16px;font-weight:normal;margin:0;padding:0;"
        }
      }),
      index_default4,
      index_default5,
      index_default6,
      index_default8,
      index_default7.configure({
        openOnClick: false,
        HTMLAttributes: {
          class: "underline text-foreground"
        }
      }),
      TextStyle,
      Color,
      src_default.configure({
        types: ["textStyle"]
      }),
      index_default10.configure({ placeholder })
    ],
    content: content || "",
    onUpdate: ({ editor: editor2 }) => {
      const raw = editor2.getHTML();
      const newContent = isEmptyHtml(raw) ? "" : raw;
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
      updateTimeoutRef.current = setTimeout(() => {
        const current = blockRef.current;
        const updatedBlock = {
          ...current,
          content: {
            ...current.content,
            [locale]: {
              ...current.content?.[locale],
              [contentKey]: newContent
            }
          }
        };
        formAPIRef.current.updateField(
          formAPIRef.current.blockPath,
          updatedBlock
        );
      }, 300);
    },
    editorProps: {
      attributes: {
        class: "min-h-[120px] max-h-[400px] overflow-auto px-3 py-2 text-sm rounded-md border bg-background outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:ring-1 focus-visible:ring-ring",
        style: `background-color: ${colors.bg}; color: ${colors.text}`
      }
    }
  });
  useEffect(() => {
    if (editor && content) {
      const currentContent = editor.getHTML();
      if (currentContent !== content) {
        editor.commands.setContent(content, {
          emitUpdate: false
        });
      }
    }
  }, [editor, content, locale, contentKey]);
  useEffect(() => {
    return () => {
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
    };
  }, []);
  return editor;
}
function InstructionEditor({ contentKey }) {
  const editor = useInstructionEditor(contentKey);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx(EmailPanelToolbar, { editor }),
    /* @__PURE__ */ jsx(EditorContent, { editor })
  ] });
}
function ReturnShippingInstructionsPanelContent() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const { locale } = useBlockPanelPropsContext();
  const options = useCarrierMessageOptions();
  const [selectedKey, setSelectedKey] = useState(
    () => options[0]?.value ?? BON_DE_RETOUR_CONTENT_KEY
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      PanelContent,
      {
        title: t2(
          "editorBlocksLibrary.blocks.return-shipping-instructions.panel.message.title",
          "Message to customize"
        ),
        children: /* @__PURE__ */ jsxs(Select2, { value: selectedKey, onValueChange: setSelectedKey, children: [
          /* @__PURE__ */ jsx(SelectTrigger2, { className: "w-full h-8 text-sm bg-background", children: /* @__PURE__ */ jsx(SelectValue2, {}) }),
          /* @__PURE__ */ jsx(SelectContent2, { children: options.map((option) => /* @__PURE__ */ jsx(SelectItem2, { value: option.value, children: option.label }, option.value)) })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      PanelContent,
      {
        title: t2(
          "editorBlocksLibrary.blocks.return-shipping-instructions.panel.content.title",
          "Custom text"
        ),
        children: /* @__PURE__ */ jsx(
          InstructionEditor,
          {
            contentKey: selectedKey
          },
          `${locale}:${selectedKey}`
        )
      }
    ),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "translatable", portal: true })
  ] });
}
function ReturnShippingInstructionsPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsx(PanelContainer, { blockProps, children: /* @__PURE__ */ jsx(ReturnShippingInstructionsPanelContent, {}) });
}

// ../editor-blocks-library/src/blocks/return-shipping-instructions/index.tsx
var return_shipping_instructions_default = registerBlock({
  type: "return-shipping-instructions",
  name: "editorBlocksLibrary.blocks.return-shipping-instructions.title",
  description: "editorBlocksLibrary.blocks.return-shipping-instructions.description",
  Icon: Truck,
  category: "return" /* RETURN */,
  hasDynamicContent: true,
  // The built-in defaults cover every locale, so the block is never "untranslated".
  isTranslated: () => true,
  components: {
    email: {
      component: ReturnShippingInstructionsEmailRenderer,
      editor: {
        component: ReturnShippingInstructionsEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ReturnShippingInstructionsPanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
var FALLBACK = {
  label: "Download my label",
  bonDeRetour: "Download my return slip"
};
function ReturnDownloadLabelEmailRenderer({
  block,
  formatter,
  theme,
  locale,
  defaultLocale,
  section,
  isEditor
}) {
  const alignment = block.alignment || "center";
  const font = block.font ?? DEFAULT_FONT;
  const buttonRadius = useEmailThemeRadius(theme, "button");
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const t2 = tLayout(locale, defaultLocale);
  const { getLabelDownload } = useReturnVariableValues();
  const { labelUrl, hasLogisticLabel } = getLabelDownload();
  const buttonStyle = getThemeButtonStyle({
    variant: block.properties?.variant || "default",
    theme,
    textColor: colors.text
  });
  const autoLabel = (key, fallback) => {
    const value = t2(key);
    return value === key ? fallback : value;
  };
  const override = hasLogisticLabel ? block.content?.[locale]?.bonDeRetour || block.content?.[defaultLocale]?.bonDeRetour : block.content?.[locale]?.label || block.content?.[defaultLocale]?.label;
  const defaultText = hasLogisticLabel ? autoLabel("downloadLabel.bonDeRetour", FALLBACK.bonDeRetour) : autoLabel("downloadLabel.label", FALLBACK.label);
  const text = override && override.length ? formatter ? formatter(override) : override : defaultText;
  if (!labelUrl && !isEditor) return null;
  const href = labelUrl ?? "#";
  return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
    Column,
    {
      className: cn({
        "text-left": alignment === "left",
        "text-center": alignment === "center",
        "text-right": alignment === "right"
      }),
      children: /* @__PURE__ */ jsx(
        Button$1,
        {
          href,
          className: cn("inline-block mx-1 no-underline", buttonRadius),
          style: { ...buttonStyle, fontFamily: font },
          children: /* @__PURE__ */ jsx("span", { dangerouslySetInnerHTML: { __html: text } })
        }
      )
    }
  ) });
}
function ReturnDownloadLabelEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx("div", { className: "[&_a]:pointer-events-none [&_a]:cursor-default", children: /* @__PURE__ */ jsx(ReturnDownloadLabelEmailRenderer, { isEditor: true, ...props }) }) });
}
function ReturnDownloadLabelPanelLabel({
  field,
  titleKey,
  titleFallback,
  placeholderFallback
}) {
  const blockProps = useBlockPanelPropsContext();
  const { t: t2 } = useTranslation("editor-blocks-library");
  const { formAPI } = blockProps;
  const block = blockProps.block;
  const locale = blockProps.locale || blockProps?.defaultLocale;
  const content = block.content?.[locale];
  const currentText = content?.[field];
  const handleSave = useCallback(
    (text) => {
      formAPI.updateField(`${formAPI.blockPath}.content.${locale}`, {
        ...content,
        [field]: text
      });
    },
    [formAPI, locale, field, content]
  );
  return /* @__PURE__ */ jsx(
    PanelVariableInputContent,
    {
      triggerOnChange: true,
      title: t2(titleKey, titleFallback),
      value: currentText ?? "",
      onChange: handleSave,
      variables: blockProps.variables,
      id: `return-download-label-${field}`,
      placeholder: placeholderFallback,
      outputFormat: "text"
    }
  );
}
function ReturnDownloadLabelPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(
      ReturnDownloadLabelPanelLabel,
      {
        field: "label",
        titleKey: "editorBlocksLibrary.blocks.return-download-label.panel.label.title",
        titleFallback: "Label (shipping label)",
        placeholderFallback: "Download my label"
      }
    ),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(
      ReturnDownloadLabelPanelLabel,
      {
        field: "bonDeRetour",
        titleKey: "editorBlocksLibrary.blocks.return-download-label.panel.bonDeRetour.title",
        titleFallback: "Label (return slip)",
        placeholderFallback: "Download my return slip"
      }
    ),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(EmailPanelStyle, {}),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelBlockFont, {}),
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "translatable", portal: true })
  ] });
}

// ../editor-blocks-library/src/blocks/return-download-label/index.tsx
var return_download_label_default = registerBlock({
  type: "return-download-label",
  name: "editorBlocksLibrary.blocks.return-download-label.title",
  description: "editorBlocksLibrary.blocks.return-download-label.description",
  Icon: Download,
  category: "return" /* RETURN */,
  hasDynamicContent: true,
  // The auto labels cover every locale, so the block is never "untranslated".
  isTranslated: () => true,
  components: {
    email: {
      component: ReturnDownloadLabelEmailRenderer,
      editor: {
        component: ReturnDownloadLabelEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ReturnDownloadLabelPanelRenderer
      },
      compatibility: {
        rowBlock: true
      }
    }
  }
});
function ReturnRequestDateEmailRenderer({
  theme,
  section,
  locale,
  defaultLocale
}) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const t2 = tLayout(locale, defaultLocale);
  const { createdAt, requestTimezone } = useReturnVariableValues().getRequestDate();
  if (!createdAt || !requestTimezone) return null;
  const dateLocale = locale || defaultLocale;
  const date = new Date(createdAt);
  const requestDate = new Intl.DateTimeFormat(dateLocale, {
    dateStyle: "long",
    timeZone: requestTimezone
  }).format(date);
  const requestTime = new Intl.DateTimeFormat(dateLocale, {
    timeStyle: "short",
    timeZone: requestTimezone
  }).format(date);
  return /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(
    Text$1,
    {
      className: "m-0 text-base leading-[1.5] text-center",
      style: { color: colors.text },
      children: t2("returnRequestDate.label", {
        date: requestDate,
        time: requestTime
      })
    }
  ) });
}
function ReturnRequestDateEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ReturnRequestDateEmailRenderer, { ...props }) });
}

// ../editor-blocks-library/src/blocks/return-request-date/index.tsx
var return_request_date_default = registerBlock({
  type: "return-request-date",
  name: "editorBlocksLibrary.blocks.return-request-date.title",
  description: "editorBlocksLibrary.blocks.return-request-date.description",
  Icon: CalendarClock,
  category: "return" /* RETURN */,
  hasDynamicContent: true,
  components: {
    email: {
      component: ReturnRequestDateEmailRenderer,
      editor: {
        component: ReturnRequestDateEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});

// ../editor-blocks-library/src/blocks/return-shipping-instructions-title/title-defaults.ts
var TITLE_FONT_SIZE_PX = 18;
function getTitleDefault(key) {
  if (key === "bonDeRetour") {
    return {
      tLayoutKey: "shippingInstructionsTitle.bonDeRetour",
      fallback: "Your return slip is ready"
    };
  }
  return {
    tLayoutKey: "shippingInstructionsTitle.shippingLabel",
    fallback: "Your shipping label is ready"
  };
}
var TITLE_STYLE = {
  fontWeight: "bold",
  fontSize: `${TITLE_FONT_SIZE_PX}px`
};
function ReturnShippingInstructionsTitleEmailRenderer({
  block,
  formatter,
  theme,
  section,
  locale,
  defaultLocale
}) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const t2 = tLayout(locale, defaultLocale);
  const { getShippingInstructions } = useReturnVariableValues();
  const { carrierCode, hasLogisticLabel } = getShippingInstructions();
  const activeKey = resolveInstructionKey(carrierCode, hasLogisticLabel);
  const override = resolveOverride(
    block.content,
    locale,
    defaultLocale,
    carrierCode,
    hasLogisticLabel
  );
  if (override) {
    const withBlankLines = preserveBlankLines(override);
    return /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "m-0 text-center",
        style: { color: colors.text },
        dangerouslySetInnerHTML: {
          __html: formatter ? formatter(format_template_default(withBlankLines)) : format_template_default(withBlankLines)
        }
      }
    ) });
  }
  const def = getTitleDefault(activeKey);
  const translated = t2(def.tLayoutKey);
  const text = translated === def.tLayoutKey ? def.fallback : translated;
  return /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(
    Text$1,
    {
      className: "m-0 text-center",
      style: { color: colors.text, ...TITLE_STYLE },
      children: text
    }
  ) });
}
function ReturnShippingInstructionsTitleEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ReturnShippingInstructionsTitleEmailRenderer, { ...props }) });
}
function useTitleEditor(contentKey) {
  const blockProps = useBlockPanelPropsContext();
  const { formAPI, locale, defaultLocale, section, theme } = blockProps;
  const block = blockProps.block;
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const unavailableVariableIds = useUnavailableVariableIds();
  const content = block.content?.[locale]?.[contentKey] ?? "";
  const t2 = tLayout(locale, defaultLocale);
  const def = getTitleDefault(
    resolveInstructionKey(contentKey, contentKey === BON_DE_RETOUR_CONTENT_KEY)
  );
  const translated = t2(def.tLayoutKey);
  const placeholder = translated === def.tLayoutKey ? def.fallback : translated;
  const updateTimeoutRef = useRef(null);
  const blockRef = useRef(block);
  const formAPIRef = useRef(formAPI);
  blockRef.current = block;
  formAPIRef.current = formAPI;
  const editor = useEditor({
    extensions: [
      index_default,
      mention_extension_default(
        blockProps.variables,
        unavailableVariableIds
      ),
      index_default3.configure({
        HTMLAttributes: {
          // Default size matches the rendered title (TITLE_FONT_SIZE_PX) but
          // weight is left "normal" so the Bold toolbar button actually toggles
          // `<strong>` — baking in `font-weight:bold` here would make the text
          // permanently bold and the toggle a no-op.
          style: `font-size:${TITLE_FONT_SIZE_PX}px;font-weight:normal;margin:0;padding:0;`
        }
      }),
      index_default4,
      index_default5,
      index_default6,
      index_default8,
      index_default7.configure({
        openOnClick: false,
        HTMLAttributes: {
          class: "underline text-foreground"
        }
      }),
      TextStyle,
      Color,
      src_default.configure({
        types: ["textStyle"]
      }),
      index_default10.configure({ placeholder })
    ],
    content: content || "",
    onUpdate: ({ editor: editor2 }) => {
      const raw = editor2.getHTML();
      const newContent = isEmptyHtml(raw) ? "" : raw;
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
      updateTimeoutRef.current = setTimeout(() => {
        const current = blockRef.current;
        const updatedBlock = {
          ...current,
          content: {
            ...current.content,
            [locale]: {
              ...current.content?.[locale],
              [contentKey]: newContent
            }
          }
        };
        formAPIRef.current.updateField(
          formAPIRef.current.blockPath,
          updatedBlock
        );
      }, 300);
    },
    editorProps: {
      attributes: {
        class: "min-h-[120px] max-h-[400px] overflow-auto px-3 py-2 text-sm rounded-md border bg-background outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:ring-1 focus-visible:ring-ring",
        style: `background-color: ${colors.bg}; color: ${colors.text}`
      }
    }
  });
  useEffect(() => {
    if (editor && content) {
      const currentContent = editor.getHTML();
      if (currentContent !== content) {
        editor.commands.setContent(content, {
          emitUpdate: false
        });
      }
    }
  }, [editor, content, locale, contentKey]);
  useEffect(() => {
    return () => {
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
    };
  }, []);
  return editor;
}
function TitleEditor({ contentKey }) {
  const editor = useTitleEditor(contentKey);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx(EmailPanelToolbar, { editor }),
    /* @__PURE__ */ jsx(EditorContent, { editor })
  ] });
}
function ReturnShippingInstructionsTitlePanelContent() {
  const { t: t2 } = useTranslation("editor-blocks-library");
  const { locale } = useBlockPanelPropsContext();
  const options = useCarrierMessageOptions();
  const [selectedKey, setSelectedKey] = useState(
    () => options[0]?.value ?? BON_DE_RETOUR_CONTENT_KEY
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      PanelContent,
      {
        title: t2(
          "editorBlocksLibrary.blocks.return-shipping-instructions-title.panel.message.title",
          "Title to customize"
        ),
        children: /* @__PURE__ */ jsxs(Select2, { value: selectedKey, onValueChange: setSelectedKey, children: [
          /* @__PURE__ */ jsx(SelectTrigger2, { className: "w-full h-8 text-sm bg-background", children: /* @__PURE__ */ jsx(SelectValue2, {}) }),
          /* @__PURE__ */ jsx(SelectContent2, { children: options.map((option) => /* @__PURE__ */ jsx(SelectItem2, { value: option.value, children: option.label }, option.value)) })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      PanelContent,
      {
        title: t2(
          "editorBlocksLibrary.blocks.return-shipping-instructions-title.panel.content.title",
          "Custom title"
        ),
        children: /* @__PURE__ */ jsx(TitleEditor, { contentKey: selectedKey }, `${locale}:${selectedKey}`)
      }
    ),
    /* @__PURE__ */ jsx(FloatingPanelSeparator, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "translatable", portal: true })
  ] });
}
function ReturnShippingInstructionsTitlePanelRenderer(blockProps) {
  return /* @__PURE__ */ jsx(PanelContainer, { blockProps, children: /* @__PURE__ */ jsx(ReturnShippingInstructionsTitlePanelContent, {}) });
}

// ../editor-blocks-library/src/blocks/return-shipping-instructions-title/index.tsx
var return_shipping_instructions_title_default = registerBlock({
  type: "return-shipping-instructions-title",
  name: "editorBlocksLibrary.blocks.return-shipping-instructions-title.title",
  description: "editorBlocksLibrary.blocks.return-shipping-instructions-title.description",
  Icon: Heading,
  category: "return" /* RETURN */,
  hasDynamicContent: true,
  // The built-in defaults cover every locale, so the block is never "untranslated".
  isTranslated: () => true,
  components: {
    email: {
      component: ReturnShippingInstructionsTitleEmailRenderer,
      editor: {
        component: ReturnShippingInstructionsTitleEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        },
        component: ReturnShippingInstructionsTitlePanelRenderer
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
function ReturnDiscountCodeEmailRenderer({
  theme,
  section
}) {
  const colors = use_theme_contextual_colors_default(theme, sectionToParent(section));
  const { discountCode } = useReturnVariableValues().getDiscountCode();
  if (!discountCode) return null;
  return /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(
    Section,
    {
      className: "mx-auto rounded-md",
      style: { backgroundColor: "rgba(0,0,0,.05)", maxWidth: "280px" },
      children: /* @__PURE__ */ jsx(
        Text$1,
        {
          className: "m-0 py-2 text-center font-bold",
          style: {
            color: colors.text,
            fontSize: "18px",
            letterSpacing: "2px",
            lineHeight: "40px"
          },
          children: discountCode
        }
      )
    }
  ) });
}
function ReturnDiscountCodeEditorRenderer(props) {
  return /* @__PURE__ */ jsx(EmailComponentWrapper, { shop: props.shop, children: /* @__PURE__ */ jsx(ReturnDiscountCodeEmailRenderer, { ...props }) });
}

// ../editor-blocks-library/src/blocks/return-discount-code/index.tsx
var return_discount_code_default = registerBlock({
  type: "return-discount-code",
  name: "editorBlocksLibrary.blocks.return-discount-code.title",
  description: "editorBlocksLibrary.blocks.return-discount-code.description",
  Icon: TicketPercent,
  category: "return" /* RETURN */,
  hasDynamicContent: true,
  components: {
    email: {
      component: ReturnDiscountCodeEmailRenderer,
      editor: {
        component: ReturnDiscountCodeEditorRenderer
      },
      configPanel: {
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: false
      }
    }
  }
});
function History({ className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ...props, className: cn("", className) });
}
function HistoryBorder() {
  return /* @__PURE__ */ jsx("div", { className: "w-1 bg-secondary top-8 bottom-0 absolute left-3.5" });
}
function HistoryEvent({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...props,
      className: cn("flex gap-4 relative items-start pb-4", className)
    }
  );
}
function HistoryEventDate({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      ...props,
      className: cn(
        "italic text-muted-foreground text-xs font-semibold",
        className
      )
    }
  );
}
function HistoryEventTitle({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      ...props,
      className: cn("inline-flex items-center gap-1 [&_svg]:size-4", className)
    }
  );
}
function HistoryEventTextualContent({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "p",
    {
      ...props,
      className: cn("text-xs text-muted-foreground max-w-full", className)
    }
  );
}
function HistoryEventContent({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...props,
      className: cn(
        "flex flex-col gap-1 text-sm font-medium mt-1.5",
        className
      )
    }
  );
}
function HistoryEventIcon({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...props,
      className: cn(
        "rounded-full flex items-center border justify-center size-8 bg-secondary",
        className
      )
    }
  );
}
function TrackingHistoryWeb(props) {
  const { parcel, locale, defaultLocale } = props;
  const t2 = tLayout(locale, defaultLocale);
  if (!parcel || !parcel.events || !Array.isArray(parcel.events)) return null;
  const events = [...parcel.events].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  return /* @__PURE__ */ jsxs("div", { className: "mt-6", children: [
    /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground font-medium", children: t2("parcel-history") }),
    /* @__PURE__ */ jsx(History, { className: "mt-4", children: events.map((event, index2) => /* @__PURE__ */ jsxs(HistoryEvent, { children: [
      index2 !== events.length - 1 && /* @__PURE__ */ jsx(HistoryBorder, {}),
      /* @__PURE__ */ jsx(
        HistoryEventIcon,
        {
          className: index2 === 0 ? "bg-primary border-primary text-primary-foreground" : "",
          children: /* @__PURE__ */ jsx(Calendar, { className: "size-4" })
        }
      ),
      /* @__PURE__ */ jsxs(HistoryEventContent, { children: [
        /* @__PURE__ */ jsxs(HistoryEventTitle, { children: [
          /* @__PURE__ */ jsx(TrackingStatus2, { locale, status: event.status }),
          " ",
          index2 === 0 && /* @__PURE__ */ jsx(Loader, {})
        ] }),
        /* @__PURE__ */ jsx(HistoryEventDate, { children: formatDate$1(event.createdAt, "dd MMM yyyy") }),
        /* @__PURE__ */ jsx(HistoryEventTextualContent, { children: /* @__PURE__ */ jsx(
          TrackingStatusDescription,
          {
            status: event.status,
            locale
          }
        ) })
      ] })
    ] }, event.createdAt)) })
  ] });
}
function TrackingStatus2({ locale, status }) {
  return getTrackingStatusTranslation(status, locale).title;
}
function TrackingStatusDescription({
  status,
  locale
}) {
  return getTrackingStatusTranslation(status, locale).description;
}
function LastStatusWeb(props) {
  const { parcel, locale } = props;
  if (!parcel || !parcel.events || !Array.isArray(parcel.events) || parcel.events.length === 0) {
    return null;
  }
  const lastEvent = [...parcel.events].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
  if (!lastEvent) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: "text-center flex flex-col", children: [
    /* @__PURE__ */ jsx("span", { className: "font-bold text-xl", children: /* @__PURE__ */ jsx(TrackingStatus2, { status: lastEvent.status, locale }) }),
    /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: /* @__PURE__ */ jsx(
      TrackingStatusDescription,
      {
        status: lastEvent.status,
        locale
      }
    ) })
  ] });
}
function LastStatusWebEditor(props) {
  return /* @__PURE__ */ jsx(LastStatusWeb, { ...props });
}
function LastStatusPanelRenderer(blockProps) {
  return /* @__PURE__ */ jsxs(PanelContainer, { blockProps, children: [
    /* @__PURE__ */ jsx(PanelBlockAlignment, {}),
    /* @__PURE__ */ jsx(PanelTranslationState, { mode: "auto", portal: true })
  ] });
}

// ../editor-blocks-library/src/blocks/last-status/index.tsx
var last_status_default = registerBlock({
  type: "last-status",
  name: "editorBlocksLibrary.blocks.last-status.title",
  description: "editorBlocksLibrary.blocks.last-status.description",
  Icon: Activity,
  category: "tracking" /* TRACKING */,
  components: {
    web: {
      component: LastStatusWeb,
      editor: { component: LastStatusWebEditor },
      configPanel: {
        component: LastStatusPanelRenderer,
        features: {
          delete: true
        }
      },
      compatibility: {
        rowBlock: {
          minSize: 2
        }
      }
    }
  }
});
function TrackingHistoryWebEditor(props) {
  return /* @__PURE__ */ jsx(TrackingHistoryWeb, { ...props });
}

// ../editor-blocks-library/src/blocks/tracking-history/index.tsx
var tracking_history_default = registerBlock({
  type: "tracking-history",
  name: "editorBlocksLibrary.blocks.tracking-history.title",
  description: "editorBlocksLibrary.blocks.tracking-history.description",
  Icon: ListOrdered,
  category: "tracking" /* TRACKING */,
  hasDynamicContent: true,
  components: {
    // email: {
    //   component: TrackingHistoryEmail,
    //   editor: { component: TrackingHistoryEmailEditor },
    // },
    web: {
      component: TrackingHistoryWeb,
      editor: { component: TrackingHistoryWebEditor }
    }
  }
});

// ../editor-blocks-library/src/blocks/index.ts
var editorBlocksLibrary = {
  wallet: wallet_default,
  paragraph: paragraph_default,
  logo: logo_default,
  "social-networks": social_networks_default,
  "package-content": package_content_default,
  button: button_default,
  "cross-sell": cross_sell_default,
  "double-buttons": double_buttons_default,
  separator: separator_default,
  "delivery-address": address_default,
  banner: banner_default,
  row: row_default,
  "pickup-point": pickup_point_default,
  "estimated-delivery-date": estimated_delivery_date_default,
  // "stepper": null,
  stepper: stepper_default,
  "tracking-history": tracking_history_default,
  "last-status": last_status_default,
  "dynamic-text": dynamic_text_default,
  "rate-order": rate_order_default,
  "return-line-items": return_line_items_default,
  "return-store-address": return_store_address_default,
  "return-shipping-instructions": return_shipping_instructions_default,
  "return-download-label": return_download_label_default,
  "return-request-date": return_request_date_default,
  "return-shipping-instructions-title": return_shipping_instructions_title_default,
  "return-discount-code": return_discount_code_default
  // "carrier": null,
};
var getEditorBlockConfig = (type) => {
  return editorBlocksLibrary[type];
};
function isBlockTranslated(locale, block) {
  if (!block?.content) return true;
  const blockConfig = getEditorBlockConfig(block.type);
  if (blockConfig?.config?.isTranslated) {
    return blockConfig.config.isTranslated(locale, block);
  }
  if (block.content[locale]?.html?.length) {
    return (
      //@ts-expect-error type not predictable here
      block.content[locale]?.html?.replace(/<[^>]+>/g, "").trim().length > 0
    );
  }
  if (block.content[locale]?.text?.length) {
    return true;
  }
  if (!!block.content[locale]?.length) return true;
  return false;
}

// ../blocks-editor/src/constants/editor-constants.ts
var EditorContentMaxWidth = 480;
function EmailMainContainer({
  children,
  viewport: viewport2 = "desktop",
  backgroundColor = "#f0f0f0",
  preview: preview10,
  tailwindConfig,
  isEmailRenderer = false,
  isEditor = false,
  isWeb = false,
  editorClassName,
  editorStyle,
  contentMaxWidth
}) {
  const resolvedMaxWidth = contentMaxWidth ?? EditorContentMaxWidth;
  if (isEmailRenderer) {
    return /* @__PURE__ */ jsx(Tailwind, { config: tailwindConfig, children: /* @__PURE__ */ jsxs(Html, { lang: "en", dir: "ltr", style: { colorScheme: "light only" }, children: [
      /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("style", { children: `
                :root {
                  color-scheme: light only;
                  supported-color-schemes: light;
                }
                body {
                  color-scheme: light only;
                  supported-color-schemes: light;
                }
                @media only screen and (max-width: 600px) {
                  .stack-on-mobile {
                    width: 100% !important;
                    max-width: 100% !important;
                    display: block !important;
                    min-height: 0 !important;
                  }
                  .email-card-padding {
                    padding: 16px !important;
                  }
                }
              ` }) }),
      preview10 && /* @__PURE__ */ jsx(Preview, { children: preview10 }),
      /* @__PURE__ */ jsx(Body, { style: { ...main2, colorScheme: "light only" }, className: "bg-background", children: /* @__PURE__ */ jsxs(
        Container,
        {
          className: "max-w-full",
          style: {
            maxWidth: resolvedMaxWidth,
            width: "100%",
            paddingLeft: 16,
            paddingRight: 16,
            margin: "auto"
            // Ensure the container is centered
          },
          children: [
            /* @__PURE__ */ jsx(Section, { className: "h-8" }),
            children,
            /* @__PURE__ */ jsx(Section, { className: "h-8" })
          ]
        }
      ) })
    ] }) });
  }
  if (isEditor) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("style", { children: `
            /* Apply stacking on actual mobile screens */
            @media only screen and (max-width: 600px) {
              .stack-on-mobile {
                width: 100% !important;
                max-width: 100% !important;
                display: block !important;
              }
            }

            /* Apply stacking when viewport is set to mobile in editor */
            ${viewport2 === "mobile" ? `
              .stack-on-mobile {
                width: 100% !important;
                max-width: 100% !important;
                display: block !important;
                min-height: 0 !important;
              }
            ` : ""}
          ` }),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "group/editor w-full border flex-1 flex items-center justify-center flex-col rounded-xl",
            editorClassName
          ),
          style: {
            backgroundColor,
            ...editorStyle
          },
          children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: "mx-auto flex flex-col justify-center items-center",
              style: {
                paddingLeft: 16,
                paddingRight: 16,
                maxWidth: resolvedMaxWidth,
                width: "100%",
                minHeight: "50vh"
              },
              children: [
                /* @__PURE__ */ jsx("div", { className: "h-8" }),
                children,
                /* @__PURE__ */ jsx("div", { className: "h-8" })
              ]
            }
          )
        }
      )
    ] });
  }
  if (isWeb) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "w-full min-h-screen flex flex-col",
        style: { backgroundColor },
        children
      }
    );
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
}
var main2 = {
  fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif'
};

// ../blocks-editor/src/utils/theme-radius.ts
var RADIUS_MAP2 = {
  none: {
    ["button" /* BUTTON */]: "rounded-none",
    ["card" /* CARD */]: "rounded-none",
    ["packageContentTable" /* PACKAGE_CONTENT_TABLE */]: "rounded-none",
    ["packageContentImage" /* PACKAGE_CONTENT_IMAGE */]: "rounded-none",
    ["bannerImage" /* BANNER_IMAGE */]: "rounded-none"
  },
  low: {
    ["button" /* BUTTON */]: "rounded-sm",
    ["card" /* CARD */]: "rounded-sm",
    ["packageContentTable" /* PACKAGE_CONTENT_TABLE */]: "rounded-sm",
    ["packageContentImage" /* PACKAGE_CONTENT_IMAGE */]: "rounded-xs",
    ["bannerImage" /* BANNER_IMAGE */]: "rounded-xs"
  },
  default: {
    ["button" /* BUTTON */]: "rounded-md",
    ["card" /* CARD */]: "rounded-lg",
    ["packageContentTable" /* PACKAGE_CONTENT_TABLE */]: "rounded-md",
    ["packageContentImage" /* PACKAGE_CONTENT_IMAGE */]: "rounded-sm",
    ["bannerImage" /* BANNER_IMAGE */]: "rounded-md"
  },
  high: {
    ["button" /* BUTTON */]: "rounded-xl",
    ["card" /* CARD */]: "rounded-xl",
    ["packageContentTable" /* PACKAGE_CONTENT_TABLE */]: "rounded-xl",
    ["packageContentImage" /* PACKAGE_CONTENT_IMAGE */]: "rounded-lg",
    ["bannerImage" /* BANNER_IMAGE */]: "rounded-xl"
  }
};
function getThemeRadius2(theme, component) {
  const radiusLevel = theme?.radius ?? "default";
  const componentRadiusMap = RADIUS_MAP2[radiusLevel];
  {
    return componentRadiusMap[component];
  }
}
function EmailCardContainer({
  children,
  theme,
  cardColor = "#ffffff",
  cardTextColor,
  isEmailRenderer = false,
  isEditor = false,
  isWeb = false,
  editorClassName,
  contentMaxWidth
}) {
  const cardRadius = getThemeRadius2(theme, "card");
  const commonClasses = cn("bg-card px-8 py-8 w-full mt-4 mb-1", cardRadius);
  const emailPaddingStyle = {
    padding: "32px"
    // Desktop fallback
  };
  const commonStyle = {
    backgroundColor: cardColor || void 0,
    color: cardTextColor || void 0
  };
  if (isEmailRenderer) {
    return /* @__PURE__ */ jsx(
      Container,
      {
        className: cn(
          "email-card-padding bg-card w-full mt-4 mb-4",
          cardRadius
        ),
        style: {
          ...commonStyle,
          ...emailPaddingStyle,
          ...contentMaxWidth ? { maxWidth: contentMaxWidth } : {}
        },
        children
      }
    );
  }
  if (isEditor) {
    return /* @__PURE__ */ jsx("div", { className: cn("w-full @container", editorClassName), children: /* @__PURE__ */ jsx(
      "div",
      {
        className: cn("bg-card p-4 @md:p-8 w-full mt-4 mb-4", cardRadius),
        style: commonStyle || void 0,
        children
      }
    ) });
  }
  if (isWeb) {
    return /* @__PURE__ */ jsx("div", { className: cn("w-full @container"), children: /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(commonClasses, "drop-shadow-md"),
        style: commonStyle || void 0,
        children
      }
    ) });
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
}
function EmailBlocksWrapper({
  children,
  isEmailRenderer = false,
  isEditor = false
}) {
  const childrenArray = Array.isArray(children) ? children : [children];
  if (isEmailRenderer) {
    return /* @__PURE__ */ jsx(Fragment, { children: childrenArray.map((child, index2) => {
      if (index2 < childrenArray.length - 1) {
        return /* @__PURE__ */ jsxs("div", { children: [
          child,
          /* @__PURE__ */ jsx(Section, { style: { height: "16px" } })
        ] }, index2);
      }
      return /* @__PURE__ */ jsx("div", { children: child }, index2);
    }) });
  }
  if (isEditor) {
    return /* @__PURE__ */ jsx(Fragment, { children: childrenArray.map((child, index2) => {
      if (index2 < childrenArray.length - 1) {
        return /* @__PURE__ */ jsxs("div", { children: [
          child,
          /* @__PURE__ */ jsx("div", { style: { height: "16px" } })
        ] }, index2);
      }
      return /* @__PURE__ */ jsx("div", { children: child }, index2);
    }) });
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
}
function BlocksEmailRenderer({
  data,
  parcel,
  shop,
  googleWalletURL,
  appleWalletURL,
  walletEnabled,
  locale,
  status,
  preview: preview10,
  carrier,
  order: order2,
  viewport: viewport2 = "desktop",
  pickupPoint,
  links,
  trackingUrl,
  reviewUrl
}) {
  const currentLocale = getLocale(locale);
  const variableContext = {
    trackingUrl,
    reviewUrl,
    parcel,
    shop,
    carrierCode: parcel.carrierCode,
    status,
    pickupPoint,
    appleWalletURL,
    googleWalletURL,
    links
  };
  const variablesValues = resolveVariables(variableContext);
  const formatter = createFormatter(variablesValues);
  const theme = shop.trackingPreferences?.emailsTheme;
  const backgroundColor = theme?.backgroundColor || "#f0f0f0";
  const cardColor = theme?.cardColor || "#ffffff";
  const cardTextColor = theme?.cardTextColor;
  const tailwindConfig = {
    theme: {
      extend: {
        colors: {
          primary: shop.preferences.customisation["primary-400"] ?? shop.preferences.customisation["primary_400"] ?? "#000000",
          secondary: "#f1f5f9",
          "secondary-foreground": "#323232",
          border: "#e2e8f0",
          background: backgroundColor ?? "#ffffff",
          card: cardColor ?? "#ffffff"
        }
      }
    }
  };
  const blockProps = {
    defaultLocale: shop?.trackingPreferences?.notificationsDefaultLocale || "en",
    parcel,
    shop,
    googleWalletURL,
    appleWalletURL,
    walletEnabled,
    status,
    preview: preview10,
    carrier,
    order: order2};
  const beforeBlocks = data.beforeBlocks.map(
    (block, index2) => renderBlock("before", block, currentLocale, index2, formatter, blockProps)
  );
  const insideBlocks = data.insideBlocks.map(
    (block, index2) => renderBlock("inside", block, currentLocale, index2, formatter, blockProps)
  );
  const afterBlocks = data.afterBlocks.map(
    (block, index2) => renderBlock("after", block, currentLocale, index2, formatter, blockProps)
  );
  const variablesWithValues = Object.values(VARIABLE_REGISTRY).map(
    (definition) => ({
      ...definition,
      exampleValue: variablesValues[definition.id] ?? ""
      // Use resolved values
    })
  );
  return /* @__PURE__ */ jsx(VariablesDictionaryProvider, { variablesDefinition: variablesWithValues, children: /* @__PURE__ */ jsx(BlockThemeProvider, { theme: theme ?? null, children: /* @__PURE__ */ jsxs(
    EmailMainContainer,
    {
      viewport: viewport2,
      backgroundColor,
      preview: preview10,
      tailwindConfig,
      isEmailRenderer: true,
      children: [
        /* @__PURE__ */ jsx(EmailBlocksWrapper, { isEmailRenderer: true, children: beforeBlocks }),
        /* @__PURE__ */ jsx(
          EmailCardContainer,
          {
            theme,
            cardColor,
            cardTextColor,
            isEmailRenderer: true,
            children: /* @__PURE__ */ jsx(EmailBlocksWrapper, { isEmailRenderer: true, children: insideBlocks })
          }
        ),
        /* @__PURE__ */ jsx(EmailBlocksWrapper, { isEmailRenderer: true, children: afterBlocks })
      ]
    }
  ) }) });
}
var defaultProps2 = {
  parcel: {
    id: "1234567890",
    trackingId: "1234567890",
    orderId: "1234567890",
    orderNumber: "1001",
    carrierCode: "FEDEX",
    customerEmail: "customer@example.com",
    shopId: "shop123",
    events: [
      {
        status: "PRE_TRANSIT",
        createdAt: Date.now(),
        notifications: []
      },
      {
        status: "DELIVERED",
        createdAt: Date.now() + 864e5,
        // 24 hours later
        notifications: []
      }
    ],
    lineItems: [
      {
        quantity: 1,
        name: "Bermuda coton-lin terracotta",
        price: 89,
        imageUrl: "https://cdn.shopify.com/s/files/1/0852/1646/1130/files/LEPANTALON_FP_SHOPIFY_BERMUDA_COTONLIN_TERRACOTA_2.jpg?v=1744370384",
        sku: "LPBCL-2-#53902"
      },
      {
        quantity: 1,
        name: "Pantalon flanelle pied de puce gris",
        price: 149,
        imageUrl: "https://cdn.shopify.com/s/files/1/0852/1646/1130/files/LEPANTALON_FP_SHOPIFY_PANTALON_FLANELLE_CLASSIQUE_PIEDDEPUCEGRIS_1.jpg?v=1740578843",
        sku: "LPFR-8-#14457"
      },
      {
        quantity: 1,
        name: "Pantalon \xE0 pinces flanelle marron",
        price: 149,
        imageUrl: "https://cdn.shopify.com/s/files/1/0852/1646/1130/files/LEPANTALON_FP_SHOPIFY_PANTALON_PINCES_FLANELLES_MARRON_1.jpg?v=1740580850",
        sku: "LPFP-2-#29348"
      },
      {
        quantity: 1,
        name: "Pantalon \xE0 pinces l\xE9ger brun",
        price: 149,
        imageUrl: "https://cdn.shopify.com/s/files/1/0852/1646/1130/files/LEPANTALON_FP_SHOPIFY_PANTALON_LAINELINSOIE_BRUN_3.jpg?v=1742372837",
        sku: "LPP-11-#42657"
      },
      {
        quantity: 1,
        name: "Pantalon \xE0 pinces l\xE9ger vert",
        price: 149,
        imageUrl: "https://cdn.shopify.com/s/files/1/0852/1646/1130/files/LEPANTALON_FP_SHOPIFY_PANTALON_LAINE_LIN_SOIE_VERT_1_1.jpg?v=1741959191",
        sku: "LPP-10-#42555"
      }
    ],
    destination: {
      firstName: "Guillaume",
      lastName: "Badi",
      address1: "Puerta del Sol, 1",
      address2: "Piso 1A",
      city: "Madrid",
      zip: "28001",
      province: "Madrid",
      provinceCode: "CM",
      country: "Espa\xF1a",
      countryCode: "ES",
      phone: "+1234567890",
      company: "ACME Corp",
      name: "John Doe"
    }
  },
  shop: {
    name: "Soeur",
    logoId: "7707b12b-4a75-45de-820e-dc933102e462.png",
    logoUrl: "https://baback-public-logo.s3.eu-west-3.amazonaws.com/7707b12b-4a75-45de-820e-dc933102e462.png",
    preferences: {
      contactLink: "https://www.baback.co/contact",
      customisation: {
        "primary-400": "#ff0000"
      }
    },
    externalLinks: {
      instagram: {
        url: "https://url.com",
        name: "Instagram",
        type: "SOCIAL_NETWORK"
      },
      facebook: {
        url: "https://url.com",
        name: "Facebook",
        type: "SOCIAL_NETWORK"
      },
      x: null,
      linkedin: {
        url: "https://url.com",
        name: "LinkedIn",
        type: "SOCIAL_NETWORK"
      }
    },
    trackingPreferences: {
      emailsTheme: {
        backgroundColor: "#f5f5f5",
        backgroundTextColor: "rgba(0, 0, 0, 0.87)",
        cardColor: "#131313",
        cardTextColor: "rgba(255,255,255,0.87)",
        primaryColor: "#000000",
        primaryTextColor: "#fff",
        secondaryColor: "#cccccc",
        secondaryTextColor: "rgba(0, 0, 0, 0.87)",
        radius: "none"
      }
    }
  },
  carrier: {
    name: "UPS"
  },
  order: {
    firstName: "Guillaume"
  },
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true,
  data: {
    beforeBlocks: [
      {
        id: "998d4a38-9455-4219-b9d1-54d39841d56f",
        type: "paragraph",
        alignment: "center",
        content: {
          fr: {
            html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>VOTRE COLIS A BESOIN DE VOUS</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">N'oubliez pas <span><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span>. <span><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span></span> est en attente d'informations de votre part afin de pouvoir livrer votre colis <span><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span>. Vous pouvez les joindre \xE0 partir de votre page de suivi accessible ci-dessous.</p>`
          }
        }
      }
    ],
    insideBlocks: [
      {
        id: "ed0293ea-4ea5-4196-8d4b-19639369ef75",
        type: "logo",
        alignment: "center",
        content: null
      },
      {
        id: "998d4a38-9455-4219-b9d1-54d39841d56f",
        type: "paragraph",
        alignment: "center",
        content: {
          fr: {
            html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>VOTRE COLIS A BESOIN DE VOUS</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">N'oubliez pas <span><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span>. <span><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span></span> est en attente d'informations de votre part afin de pouvoir livrer votre colis <span><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span>. Vous pouvez les joindre \xE0 partir de votre page de suivi accessible ci-dessous.</p>`
          }
        }
      },
      {
        id: "c628fa0b-57cd-4f23-b10a-75cf3d17ab8a",
        type: "button",
        alignment: "center",
        properties: {
          variant: "outline"
        },
        content: {
          fr: {
            text: "Suivre mon colis",
            href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
          }
        }
      },
      {
        type: "separator",
        id: "",
        alignment: "center"
      },
      {
        id: "ec6a97ac-fc83-4310-a4fb-900e14c76150",
        type: "delivery-address",
        alignment: "center",
        content: null
      },
      {
        id: "8f007cc5-0d95-4732-9b00-34cb29a51362",
        type: "wallet",
        alignment: "center",
        content: null
      },
      {
        type: "social-networks",
        alignment: "center",
        id: "efb49f0a-39b8-43a0-8af0-cac2124d9b77",
        content: null
      }
    ],
    afterBlocks: [
      {
        type: "social-networks",
        alignment: "center",
        id: "efb49f0a-39b8-43a0-8af0-cac2124d9b77",
        content: null
      }
    ],
    defaultLocale: "en"
  }
};
BlocksEmailRenderer.PreviewProps = defaultProps2;
var getLocale = (locale) => {
  return locale?.split("-")[0]?.toLowerCase() ?? "fr";
};
function renderBlock(section, block, currentLocale, index2, formatter, props) {
  const blockType = block.type;
  const Component = getEditorBlockConfig(blockType)?.email?.component;
  if (Component) {
    return /* @__PURE__ */ jsx(
      Component,
      {
        index: index2,
        block,
        shop: props.shop,
        formatter,
        section,
        parcel: props.parcel,
        googleWalletURL: props.googleWalletURL,
        appleWalletURL: props.appleWalletURL,
        walletEnabled: props.walletEnabled,
        locale: currentLocale,
        defaultLocale: props.defaultLocale,
        status: props.status,
        preview: props.preview,
        carrier: props.carrier,
        order: props.order,
        pickupPoint: props.pickupPoint,
        theme: props.shop?.trackingPreferences?.emailsTheme,
        formAPI: {
          blockPath: "",
          updateField: () => {
          },
          getFieldValue: () => void 0
        }
      },
      block.id
    );
  }
  return null;
}

// ../translations/emails/fr.json
var fr_default = {
  returnRequestDate: {
    label: "Votre demande de retour a \xE9t\xE9 faite le {{date}} \xE0 {{time}}"
  },
  shippingStatusUpdated: {
    preview: "Votre retour est en route",
    heading: "Votre retour est en route !",
    confirmation: "Merci d'avoir renvoy\xE9 votre colis de retour, ce dernier \xE0 \xE9t\xE9 pris en charge par le transporteur.",
    track: "Vous pouvez suivre le retour de votre colis en cliquant sur le lien ci-dessous :",
    trackCTA: "Suivre mon retour",
    ending: "D\xE8s que nous aurons r\xE9ceptionn\xE9 votre colis, nous vous enverrons un email de confirmation. Comptez jusqu'\xE0 14 jours apr\xE8s reception de votre colis par notre \xE9quipe logistique pour recevoir votre remboursement."
  },
  returnRequestCreated: {
    preview: "Votre demande de retour",
    heading: "Votre demande de retour",
    description: "Nous avons bien re\xE7u votre demande de retour. Vous pouvez d\xE8s \xE0 pr\xE9sent t\xE9l\xE9charger votre \xE9tiquette d'exp\xE9dition et suivre votre retour.",
    findDropPointCTA: "Trouver un point relais",
    downloadLabelCTA: "T\xE9l\xE9charger mon \xE9tiquette",
    trackCTA: "Suivre mon retour"
  },
  returnRequestWithoutApproval: {
    preview: "Votre demande de retour",
    heading: "Votre demande de retour",
    description: "Nous avons bien pris en compte votre demande. Nous allons la valider dans les plus brefs d\xE9lais. Une fois valid\xE9e, nous vous indiquerons comment faire votre retour.",
    trackCTA: "Suivre mon retour"
  },
  returnRequestReturnToStore: {
    preview: "Votre demande de retour",
    heading: "Votre demande de retour",
    description: "Nous avons bien pris en compte votre demande. Vous pouvez d\xE8s \xE0 pr\xE9sent vous rendre \xE0 la boutique d\xE9poser votre retour.",
    trackCTA: "Suivre mon retour",
    mapLabel: "Voir la carte"
  },
  returnRequestWithoutLabel: {
    preview: "Votre demande de retour",
    heading: "Votre demande de retour",
    description: "Nous avons bien re\xE7u votre demande de retour. Nous vous enverrons un email avec les instructions de retour tr\xE8s prochainement.",
    trackCTA: "Suivre mon retour"
  },
  shippingLabelCreated: {
    preview: "Votre \xE9tiquette d'exp\xE9dition est pr\xEAte",
    heading: "Votre \xE9tiquette d'exp\xE9dition est pr\xEAte",
    description: "Votre \xE9tiquette d'exp\xE9dition est pr\xEAte. Vous pouvez d\xE8s \xE0 pr\xE9sent l'imprimer et l'utiliser pour votre retour.",
    conform: "Veuillez vous assurer que votre colis est correctement emball\xE9 et que l'\xE9tiquette d'exp\xE9dition est bien visible.",
    findDropPointCTA: "Trouver un point relais",
    downloadLabelCTA: "T\xE9l\xE9charger mon \xE9tiquette",
    trackCTA: "Suivre mon retour",
    takeAccount: "Imprimez votre \xE9tiquette retour et d\xE9posez votre colis retour dans le point de collecte {{carrier}} de votre choix",
    colissimo: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais Colissimo le plus proche.",
    "chrono-shop2shop": "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais Chronopost le plus proche",
    "customer-carrier": "Vous pouvez \xE0 pr\xE9sent envoyer votre colis de retour au transporteur de votre choix.",
    "merchant-carrier": "Nous vous enverrons une \xE9tiquette de retour par email dans les 1 \xE0 3 jours ouvr\xE9s.",
    returnToStore: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le magasin le plus proche.",
    malca: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais Malca le plus proche.",
    tnt: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais TNT le plus proche.",
    ups: "Vous pouvez \xE0 pr\xE9sent imprimer votre \xE9tiquette de retour et d\xE9poser votre colis dans le relais UPS le plus proche.",
    getLabelCTA: "T\xE9l\xE9charger mon \xE9tiquette de retour",
    doNotReply: "Ceci est un email automatique, merci de ne pas y r\xE9pondre.",
    contactUs: "Pour nous contacter :",
    previewBonDeRetour: "Votre bon de retour est pr\xEAt",
    headingBonDeRetour: "Votre bon de retour est pr\xEAt",
    descriptionBonDeRetour: "Votre bon de retour est pr\xEAt. Vous pouvez d\xE8s \xE0 pr\xE9sent l'imprimer et l'utiliser pour votre retour.",
    downloadBonDeRetourCTA: "T\xE9l\xE9charger mon bon de retour"
  },
  depositReminder: {
    preview: "Pensez \xE0 d\xE9poser votre colis retour",
    heading: "Pensez \xE0 d\xE9poser votre colis retour",
    description: "Vous avez g\xE9n\xE9r\xE9 votre \xE9tiquette de retour mais nous n'avons pas encore re\xE7u votre colis. Pensez \xE0 le d\xE9poser rapidement pour que nous puissions traiter votre demande.",
    downloadLabelCTA: "T\xE9l\xE9charger mon \xE9tiquette",
    trackCTA: "Suivre mon retour",
    descriptionBonDeRetour: "Vous avez g\xE9n\xE9r\xE9 votre bon de retour mais nous n'avons pas encore re\xE7u votre colis. Pensez \xE0 le d\xE9poser rapidement pour que nous puissions traiter votre demande.",
    downloadBonDeRetourCTA: "T\xE9l\xE9charger mon bon de retour"
  },
  returnRequestWithoutPhysicalReturn: {
    preview: "Votre demande a \xE9t\xE9 prise en compte",
    heading: "Votre demande a \xE9t\xE9 prise en compte",
    description: "Nous avons bien re\xE7u votre demande de retour. Vous serez inform\xE9(e) d\xE8s que celle-ci sera trait\xE9e.",
    trackCTA: "Suivre ma demande"
  },
  invite: {
    preview: "Rejoindre Baback",
    heading: "Rejoindre Baback",
    joinTeam: "Vous avez \xE9t\xE9 invit\xE9 \xE0 rejoindre l'entreprise {{shopName}} sur Baback",
    joinCTA: "Rejoindre {{shopName}}",
    noAccount: "Si vous n'avez pas de compte Baback, vous pouvez en cr\xE9er un en cliquant sur le bouton ci-dessus.",
    signature: "Bonne journ\xE9e"
  },
  discountCodeCreated: {
    preview: "Votre avoir pour la commande {{orderNumber}}",
    heading: "Votre avoir pour la commande {{orderNumber}}",
    giftMessageValidUntil: "Suite au traitement de votre retour sur la commande {{orderNumber}}, voici votre avoir de {{amount}}\u20AC, utilisable jusqu'au {{validUntil}}.",
    giftMessageNoValidity: "Suite au traitement de votre retour sur la commande {{orderNumber}}, voici votre avoir de {{amount}}\u20AC.",
    giftSecondaryMessage: "Vous pouvez l'utiliser sur toute la boutique.",
    ending: "Bonne journ\xE9e"
  },
  storeCreditCreated: {
    heading: "Votre avoir pour la commande {{orderName}}",
    preview: "{{shopName}} - Votre avoir pour la commande {{orderName}}",
    giftMessage: "Suite au traitement de votre retour sur la commande {{orderName}}, un avoir de {{amount}}{{currency}} a \xE9t\xE9 ajout\xE9 \xE0 votre compte.",
    giftMessageValidUntil: "Suite au traitement de votre retour sur la commande {{orderName}}, un avoir de {{amount}}{{currency}} a \xE9t\xE9 ajout\xE9 \xE0 votre compte, valable jusqu'au {{validUntil}}.",
    giftSecondaryMessage: "Il sera automatiquement appliqu\xE9 lors du passage en caisse.",
    ending: "Bonne journ\xE9e"
  },
  returnRequestAccepted: {
    previewMessage: "Votre demande de retour",
    headingMessage: "Votre demande de retour a bien \xE9t\xE9 trait\xE9e !",
    confirmationMessage: "Nous avons re\xE7u votre retour. Si vous avez demand\xE9 un remboursement, il sera visible sur le compte bancaire utilis\xE9 lors de la commande sous 2 \xE0 5 jours.",
    trackingCTAMessage: "Revoir mon retour",
    endingMessage: "Si vous avez la moindre requ\xEAte, n'h\xE9sitez pas \xE0 contacter notre service client."
  },
  returnRequestRejected: {
    preview: "Votre demande de retour",
    heading: "Votre demande de retour a \xE9t\xE9 refus\xE9e",
    description: "Nous avons bien trait\xE9 votre demande de retour. Malheureusement, les articles ci-dessous n'ont pas pu \xEAtre accept\xE9s.",
    rejectedItemsTitle: "Articles refus\xE9s",
    trackCTA: "Voir ma demande"
  },
  exportSuccess: {
    subject: "Demandes de retour export\xE9es",
    text: "Votre export de demandes de retour a \xE9t\xE9 g\xE9n\xE9r\xE9 avec succ\xE8s et disponible en pi\xE8ce jointe."
  },
  exportFailure: {
    subject: "\xC9chec de l'exportation des demandes de retour",
    text: "Nous avons rencontr\xE9 une erreur lors du traitement de votre exportation de demandes de retour. Merci de contacter le support Baback"
  },
  lineItems: {
    summary: {
      title: "D\xE9tails de votre retour"
    },
    sections: {
      refund: {
        title: "Remboursement(s)"
      },
      exchange: {
        title: "\xC9change(s)"
      },
      discount: {
        title: "Avoir(s)"
      },
      exchangeCredit: {
        title: "Nouvelle commande"
      }
    }
  },
  tracking: {
    shared: {
      endDepositDate: "Colis disponible jusqu'au :",
      estimatedDeliveryDate: "Date de livraison estim\xE9e :",
      estimatedDeliveryDateWindow: "le {{day}} entre {{minimum}} et {{maximum}}.",
      estimatedDeliveryDatesWindow: "entre le {{minimum}} et le {{maximum}}.",
      between: "Entre",
      and: "et",
      from: "Entre le",
      to: "et le"
    },
    preTransit: {
      preview: "Nous avons bien re\xE7u votre commande",
      email: {
        title: "Votre commande est en cours de traitement",
        description: "Nous avons bien re\xE7u votre commande et nous la pr\xE9parons pour l'exp\xE9dition. Vous recevrez un email de confirmation d'exp\xE9dition d\xE8s que votre commande sera en route.",
        cta: "Suivre ma commande",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    },
    inTransit: {
      preview: "Votre commande est en cours d\u2019acheminement.",
      email: {
        title: "Votre commande est en cours d\u2019acheminement.",
        description: "Votre commande a \xE9t\xE9 exp\xE9di\xE9e et est actuellement en transit. Vous pouvez suivre son acheminement en temps r\xE9el.",
        cta: "Suivre ma commande",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    },
    availableForPickup: {
      preview: "Votre colis est disponible en point de retrait",
      email: {
        title: "Votre colis est disponible en point de retrait",
        description: "Votre colis est arriv\xE9 au point de retrait et vous pouvez d\xE9sormais le r\xE9cup\xE9rer.",
        cta: "R\xE9cup\xE9rer mon colis",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    },
    deliveredToNeighbour: {
      preview: "Votre colis a \xE9t\xE9 remis \xE0 un voisin",
      email: {
        title: "Votre colis a \xE9t\xE9 remis \xE0 un voisin",
        description: "Votre colis a \xE9t\xE9 livr\xE9 \xE0 un voisin en votre absence.",
        cta: "Voir les d\xE9tails de la livraison",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    },
    waitingAtPickupPointSevere: {
      preview: "Votre colis attend d'\xEAtre r\xE9cup\xE9r\xE9 (rappel)",
      email: {
        title: "Votre colis attend d'\xEAtre r\xE9cup\xE9r\xE9",
        description: "Votre colis est toujours disponible au point de retrait. Merci de le r\xE9cup\xE9rer rapidement.",
        cta: "R\xE9cup\xE9rer mon colis",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    },
    waitingInformationFromAddress: {
      preview: "Information requise pour votre livraison",
      email: {
        title: "Information requise pour votre livraison",
        description: "Nous avons besoin d'informations suppl\xE9mentaires concernant votre adresse de livraison pour finaliser votre commande. Merci de mettre \xE0 jour vos informations rapidement.",
        cta: "Mettre \xE0 jour mes informations",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    },
    delivered: {
      preview: "Votre colis a \xE9t\xE9 livr\xE9",
      email: {
        title: "Votre colis a \xE9t\xE9 livr\xE9",
        description: "Votre colis a bien \xE9t\xE9 livr\xE9 \xE0 l'adresse indiqu\xE9e.",
        ifNotDelivered: "Si vous n'avez pas re\xE7u votre colis, veuillez contacter le ",
        ifNotDeliveredLink: "support client"
      }
    },
    returnedToSender: {
      preview: "Votre colis a \xE9t\xE9 retourn\xE9 \xE0 l'exp\xE9diteur",
      email: {
        title: "Votre colis a \xE9t\xE9 retourn\xE9 \xE0 l'exp\xE9diteur",
        description: "Votre colis n'a pas pu \xEAtre livr\xE9 et a \xE9t\xE9 retourn\xE9 \xE0 l'exp\xE9diteur.",
        cta: "Contacter le support",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    },
    exception: {
      preview: "Votre colis a rencontr\xE9 une difficult\xE9 durant son acheminement",
      email: {
        title: "Votre colis a rencontr\xE9 une difficult\xE9 durant son acheminement",
        description: "Votre transporteur a relay\xE9 la difficult\xE9 suivante:",
        cta: "Contacter le support",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    },
    orderNotFulfilled: {
      preview: "Votre commande n'a pas encore \xE9t\xE9 trait\xE9e",
      email: {
        title: "Votre commande n'a pas encore \xE9t\xE9 trait\xE9e",
        description: "Nous avons bien re\xE7u votre commande, mais elle n'a pas encore \xE9t\xE9 trait\xE9e par le marchand. Vous recevrez une notification d\xE8s qu'elle sera prise en charge.",
        cta: "Suivre ma commande",
        deliveryDetails: {
          title: "D\xE9tails de livraison",
          packageContent: {
            label: "Contenu du colis"
          }
        }
      }
    }
  },
  deliveryDetails: {
    title: "D\xE9tails de livraison"
  },
  packageContent: {
    label: "Contenu du colis"
  },
  deliveryAddress: {
    title: "Adresse de livraison",
    titlePickup: "Adresse du point de retrait",
    orderDetails: {
      title: "D\xE9tails de la commande",
      trackingNumber: "Num\xE9ro de suivi",
      orderNumber: "Num\xE9ro de commande",
      orderDate: "Date de commande"
    }
  },
  pickupPoint: {
    title: "Point de retrait",
    closed: "Ferm\xE9",
    openingHours: "Horaires d'ouverture",
    website: "Site web",
    directions: "Itin\xE9raire",
    days: {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche"
    }
  },
  blockedReturnsDigest: {
    subject: "R\xE9capitulatif des retours bloquants",
    heading: "Retours n\xE9cessitant votre attention",
    noAlerts: "Aucun retour bloquant sur la p\xE9riode",
    normalCount: "{{count}} retour(s) trait\xE9(s) normalement sur la p\xE9riode",
    andMore: "et {{count}} de plus...",
    viewReturn: "Voir le retour",
    types: {
      label_failed: "\xC9tiquette",
      refund_failed: "Remboursement",
      treatment_failed: "Traitement",
      logistics_rejected: "Rejet logistique",
      exchange_failed: "\xC9change",
      integration_failed: "Int\xE9gration",
      stale_return: "En attente",
      received_not_refunded: "Non rembours\xE9",
      out_of_stock: "Rupture de stock"
    },
    open: "Voir",
    header: {
      type: "Type",
      order: "Commande",
      email: "Email",
      error: "Erreur"
    },
    pendingActions: {
      heading: "Retours en attente d'action",
      toBeValidated: "retour(s) en attente de validation",
      toBeTreated: "retour(s) en attente de traitement"
    },
    blockingReturns: {
      heading: "Retours bloqu\xE9s"
    }
  }
};

// ../translations/emails/en.json
var en_default = {
  returnRequestDate: {
    label: "Your return request was made on {{date}} at {{time}}"
  },
  shippingStatusUpdated: {
    preview: "Your return is on its way",
    heading: "Your return is on its way !",
    confirmation: "Thank you for sending back your return package, it has been picked up by the carrier.",
    track: "You can track your return package by clicking on the link below:",
    trackCTA: "Track my return",
    ending: "As soon as we have received your package, we will send you a confirmation email. Allow up to 14 days after receiving your package by our logistics team to receive your refund."
  },
  shippingLabelCreated: {
    preview: "Your return label has been created.",
    heading: "Your return label",
    takeAccount: "Print your return label and drop off your return package at the {{carrier}} collection point of your choice.",
    colissimo: "You can now print your return label and drop off your package at the nearest Colissimo relay point.",
    "chrono-shop2shop": "You can now print your return label and drop off your package at the nearest Chronopost relay point.",
    "customer-carrier": "You can now send your return package to the carrier of your choice.",
    "merchant-carrier": "We will send you a return label by email within 1 to 3 business days.",
    returnToStore: "You can now print your return label and drop off your package at the nearest store.",
    malca: "You can now print your return label and drop off your package at the nearest Malca relay point.",
    tnt: "You can now print your return label and drop off your package at the nearest TNT relay point.",
    ups: "You can now print your return label and drop off your package at the nearest UPS relay point.",
    getLabelCTA: "Download my return label",
    findRelayPoint: "You can find the nearest relay point via this link, and then track your return with the carrier.",
    findRelayPointCTA: "Find a relay point",
    trackCTA: "Track my return",
    conform: "Upon receipt, we will check your return and proceed with the appropriate processing.",
    description: "Your shipping label is ready. You can now print it and use it for your return.",
    findDropPointCTA: "Find a drop-off point",
    downloadLabelCTA: "Download my label",
    doNotReply: "This is an automated email, please do not reply.",
    contactUs: "To contact us:",
    previewBonDeRetour: "Your return slip is ready",
    headingBonDeRetour: "Your return slip is ready",
    descriptionBonDeRetour: "Your return slip is ready. You can now print it and use it for your return.",
    downloadBonDeRetourCTA: "Download my return slip"
  },
  depositReminder: {
    preview: "Don't forget to drop off your return package",
    heading: "Don't forget to drop off your return package",
    description: "You have generated your return label but we haven't received your package yet. Please drop it off soon so we can process your request.",
    downloadLabelCTA: "Download my label",
    trackCTA: "Track my return",
    descriptionBonDeRetour: "You have generated your return slip but we haven't received your package yet. Please drop it off soon so we can process your request.",
    downloadBonDeRetourCTA: "Download my return slip"
  },
  returnRequestWithoutPhysicalReturn: {
    preview: "Your request has been received",
    heading: "Your request has been received",
    description: "We have received your return request. You will be notified once it has been processed.",
    trackCTA: "Track my request"
  },
  invite: {
    preview: "Join Baback",
    heading: "Join Baback",
    joinTeam: "You have been invited to join the company {{shopName}} on Baback",
    joinCTA: "Join {{shopName}}",
    noAccount: "If you don't have a Baback account, you can create one by clicking on the button above.",
    signature: "Have a nice day"
  },
  discountCodeCreated: {
    preview: "Your credit for order {{orderNumber}}",
    heading: "Your credit for order {{orderNumber}}",
    giftMessageValidUntil: "Following the processing of your return for order {{orderNumber}}, here is your credit of {{amount}}\u20AC, valid until {{validUntil}}.",
    giftMessageNoValidity: "Following the processing of your return for order {{orderNumber}}, here is your credit of {{amount}}\u20AC.",
    giftSecondaryMessage: "You can use it throughout the store.",
    ending: "Have a nice day"
  },
  storeCreditCreated: {
    heading: "Your store credit for order {{orderName}}",
    preview: "{{shopName}} - Your store credit for order {{orderName}}",
    giftMessage: "Following your return on order {{orderName}}, a store credit of {{amount}}{{currency}} has been added to your account.",
    giftMessageValidUntil: "Following your return on order {{orderName}}, a store credit of {{amount}}{{currency}} has been added to your account, valid until {{validUntil}}.",
    giftSecondaryMessage: "It will be automatically applied at checkout.",
    ending: "Have a great day"
  },
  returnRequestAccepted: {
    previewMessage: "Your return request",
    headingMessage: "Your return request",
    confirmationMessage: "We have processed your return. If you have requested a refund, it will be visible in the bank account used when ordering within 2 to 5 days.",
    trackingCTAMessage: "View my return request",
    endingMessage: "If you have any queries, do not hesitate to contact our customer service."
  },
  returnRequestRejected: {
    preview: "Your return request",
    heading: "Your return request has been declined",
    description: "We have processed your return request. Unfortunately, the items listed below could not be accepted.",
    rejectedItemsTitle: "Declined items",
    trackCTA: "View my request"
  },
  exportSuccess: {
    subject: "Exported Return Requests",
    text: "Your return request export has been successfully generated and is available as an attachment."
  },
  exportFailure: {
    subject: "Return Requests Export Failed",
    text: "We encountered an error while processing your return requests export. Please contact Baback support."
  },
  lineItems: {
    summary: {
      title: "Details of your return"
    },
    sections: {
      refund: {
        title: "Refund(s)"
      },
      exchange: {
        title: "Exchange(s)"
      },
      discount: {
        title: "Credit(s)"
      },
      exchangeCredit: {
        title: "New order"
      }
    }
  },
  tracking: {
    shared: {
      endDepositDate: "Parcel available until:",
      estimatedDeliveryDate: "Estimated delivery date:",
      estimatedDeliveryDateWindow: "on {{day}} between {{minimum}} and {{maximum}}.",
      estimatedDeliveryDatesWindow: "between {{minimum}} and {{maximum}}.",
      between: "Between",
      and: "and",
      from: "From",
      to: "to"
    },
    preTransit: {
      preview: "We have received your order",
      email: {
        title: "Your order is being processed",
        description: "We have received your order and are preparing it for shipment. You will receive a shipping confirmation email as soon as your order is on its way.",
        cta: "Track my order",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package contents"
          }
        }
      }
    },
    inTransit: {
      preview: "Your order is in transit",
      email: {
        title: "Your order is in transit",
        description: "Your order has been shipped and is on its way. You can track its progress in real time.",
        cta: "Track my order",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package contents"
          }
        }
      }
    },
    availableForPickup: {
      preview: "Your package is available for pickup",
      email: {
        title: "Your package is available for pickup",
        description: "Your package has arrived at the pickup point and you can now collect it.",
        cta: "Collect my package",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package contents"
          }
        }
      }
    },
    deliveredToNeighbour: {
      preview: "Your package was delivered to a neighbour",
      email: {
        title: "Your package was delivered to a neighbour",
        description: "Your package was delivered to a neighbour in your absence.",
        cta: "View delivery details",
        ifNotDelivered: "If you have not received your package, please contact our ",
        ifNotDeliveredLink: "customer service",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package contents"
          }
        }
      }
    },
    waitingAtPickupPointSevere: {
      preview: "Your package is waiting to be collected (reminder)",
      email: {
        title: "Your package is waiting to be collected",
        description: "Your package is still available at the pickup point. Please collect it as soon as possible.",
        cta: "Collect my package",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package contents"
          }
        }
      }
    },
    waitingInformationFromAddress: {
      preview: "Information required for your delivery",
      email: {
        title: "Information required for your delivery",
        description: "We need additional information about your delivery address to complete your order. Please update your information as soon as possible.",
        cta: "Update my information",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package contents"
          }
        }
      }
    },
    delivered: {
      preview: "Your package has been delivered",
      email: {
        title: "Your package has been delivered",
        description: "Your package has been delivered to the specified address."
      }
    },
    returnedToSender: {
      preview: "Your package was returned to sender",
      email: {
        title: "Your package was returned to sender",
        description: "Your package could not be delivered and was returned to the sender.",
        cta: "Contact support",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package contents"
          }
        }
      }
    },
    exception: {
      preview: "Your parcel encountered an issue during delivery",
      email: {
        title: "Your parcel encountered an issue during delivery",
        description: "Your carrier reported the following issue:",
        cta: "Contact support",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package contents"
          }
        }
      }
    },
    orderNotFulfilled: {
      preview: "Your order has not been processed yet",
      email: {
        title: "Your order has not been processed yet",
        description: "We have received your order, but it has not been processed by the merchant yet. You will receive a notification as soon as it is handled.",
        cta: "Track my order",
        deliveryDetails: {
          title: "Delivery details",
          packageContent: {
            label: "Package content"
          }
        }
      }
    }
  },
  returnRequestCreated: {
    preview: "Your return request",
    heading: "Your return request",
    description: "We have received your return request. You can now download your shipping label and track your return.",
    findDropPointCTA: "Find a drop-off point",
    downloadLabelCTA: "Download my label",
    trackCTA: "Track my return"
  },
  returnRequestWithoutApproval: {
    preview: "Your return request",
    heading: "Your return request",
    description: "We have received your return request. We will validate it as soon as possible. Once validated, we will let you know how to proceed with your return.",
    trackCTA: "Track my return"
  },
  returnRequestReturnToStore: {
    preview: "Your return request",
    heading: "Your return request",
    description: "We have received your return request. You can now go to the store to drop off your return.",
    trackCTA: "Track my return",
    mapLabel: "View map"
  },
  returnRequestWithoutLabel: {
    preview: "Your return request",
    heading: "Your return request",
    description: "We have received your return request. We will send you an email with return instructions very soon.",
    trackCTA: "Track my return"
  },
  deliveryDetails: {
    title: "Delivery Details"
  },
  packageContent: {
    label: "Package Content"
  },
  deliveryAddress: {
    title: "Delivery address",
    titlePickup: "Pickup point address",
    orderDetails: {
      title: "Order details",
      trackingNumber: "Tracking number",
      orderNumber: "Order number",
      orderDate: "Order date"
    }
  },
  pickupPoint: {
    title: "Pickup Point",
    closed: "Closed",
    openingHours: "Opening Hours",
    website: "Website",
    directions: "Directions",
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    }
  },
  blockedReturnsDigest: {
    subject: "Blocked returns summary",
    heading: "Returns requiring your attention",
    noAlerts: "No blocked returns in this period",
    normalCount: "{{count}} return(s) processed normally in this period",
    andMore: "and {{count}} more...",
    viewReturn: "View return",
    types: {
      label_failed: "Label",
      refund_failed: "Refund",
      treatment_failed: "Treatment",
      logistics_rejected: "Logistics rejected",
      exchange_failed: "Exchange",
      integration_failed: "Integration",
      stale_return: "Stale",
      received_not_refunded: "Not refunded",
      out_of_stock: "Out of stock"
    },
    open: "Open",
    header: {
      type: "Type",
      order: "Order",
      email: "Email",
      error: "Error"
    },
    pendingActions: {
      heading: "Returns awaiting action",
      toBeValidated: "return(s) awaiting validation",
      toBeTreated: "return(s) awaiting treatment"
    },
    blockingReturns: {
      heading: "Blocked returns"
    }
  }
};

// ../translations/emails/es.json
var es_default = {
  returnRequestDate: {
    label: "Tu solicitud de devoluci\xF3n se realiz\xF3 el {{date}} a las {{time}}"
  },
  shippingStatusUpdated: {
    preview: "Su devoluci\xF3n est\xE1 en camino",
    heading: "\xA1Su devoluci\xF3n est\xE1 en camino!",
    confirmation: "Gracias por devolver su paquete de devoluci\xF3n, este ha sido recogido por el transportista.",
    track: "Puede seguir el retorno de su paquete haciendo clic en el siguiente enlace:",
    trackCTA: "Seguir mi devoluci\xF3n",
    ending: "Una vez que hayamos recibido su paquete, le enviaremos un correo electr\xF3nico de confirmaci\xF3n. Espere hasta 14 d\xEDas despu\xE9s de recibir su paquete por parte de nuestro equipo log\xEDstico para recibir su reembolso."
  },
  shippingLabelCreated: {
    heading: "Su etiqueta de devoluci\xF3n",
    takeAccount: "Imprima su etiqueta de devoluci\xF3n y deposite su paquete de devoluci\xF3n en el punto de recogida {{carrier}} de su elecci\xF3n.",
    colissimo: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo Colissimo m\xE1s cercano.",
    "chrono-shop2shop": "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo Chronopost m\xE1s cercano.",
    "customer-carrier": "Ahora puede enviar su paquete de devoluci\xF3n al transportista de su elecci\xF3n.",
    "merchant-carrier": "Nosotros le enviaremos una etiqueta de devoluci\xF3n por correo electr\xF3nico en los 1 a 3 d\xEDas h\xE1biles.",
    returnToStore: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en la tienda m\xE1s cercana.",
    malca: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo Malca m\xE1s cercano.",
    tnt: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo TNT m\xE1s cercano.",
    ups: "Ahora puede imprimir su etiqueta de devoluci\xF3n y dejar su paquete en el punto de relevo UPS m\xE1s cercano.",
    getLabelCTA: "Descargar mi etiqueta de devoluci\xF3n",
    findRelayPoint: "Puede encontrar el punto de relevo m\xE1s cercano a trav\xE9s de este enlace y luego seguir su devoluci\xF3n con el transportista.",
    findRelayPointCTA: "Encontrar un punto de relevo",
    trackCTA: "Seguir mi devoluci\xF3n",
    onReception: "Al recibir su devoluci\xF3n, la verificaremos y procederemos con el procesamiento adecuado.",
    conform: "Si su devoluci\xF3n es conforme, procesaremos su reembolso al recibirla.",
    preview: "Su etiqueta de env\xEDo est\xE1 lista",
    description: "Su etiqueta de env\xEDo est\xE1 lista. Ahora puede imprimirla y usarla para su devoluci\xF3n.",
    findDropPointCTA: "Encontrar un punto de entrega",
    downloadLabelCTA: "Descargar mi etiqueta",
    doNotReply: "Este es un correo electr\xF3nico autom\xE1tico, por favor no responda.",
    contactUs: "Para contactarnos:",
    previewBonDeRetour: "Su albar\xE1n de devoluci\xF3n est\xE1 listo",
    headingBonDeRetour: "Su albar\xE1n de devoluci\xF3n est\xE1 listo",
    descriptionBonDeRetour: "Su albar\xE1n de devoluci\xF3n est\xE1 listo. Ahora puede imprimirlo y usarlo para su devoluci\xF3n.",
    downloadBonDeRetourCTA: "Descargar mi albar\xE1n de devoluci\xF3n"
  },
  depositReminder: {
    preview: "No olvide depositar su paquete de devoluci\xF3n",
    heading: "No olvide depositar su paquete de devoluci\xF3n",
    description: "Ha generado su etiqueta de devoluci\xF3n pero a\xFAn no hemos recibido su paquete. Por favor, depos\xEDtelo pronto para que podamos procesar su solicitud.",
    downloadLabelCTA: "Descargar mi etiqueta",
    trackCTA: "Seguir mi devoluci\xF3n",
    descriptionBonDeRetour: "Ha generado su albar\xE1n de devoluci\xF3n pero a\xFAn no hemos recibido su paquete. Por favor, depos\xEDtelo pronto para que podamos procesar su solicitud.",
    downloadBonDeRetourCTA: "Descargar mi albar\xE1n de devoluci\xF3n"
  },
  returnRequestWithoutPhysicalReturn: {
    preview: "Su solicitud ha sido recibida",
    heading: "Su solicitud ha sido recibida",
    description: "Hemos recibido su solicitud de devoluci\xF3n. Le informaremos en cuanto sea procesada.",
    trackCTA: "Seguir mi solicitud"
  },
  invite: {
    preview: "\xDAnete a Baback",
    heading: "\xDAnete a Baback",
    joinTeam: "Has sido invitado a unirte a la empresa {{shopName}} en Baback",
    joinCTA: "\xDAnete a {{shopName}}",
    noAccount: "Si no tienes una cuenta de Baback, puedes crear una haciendo clic en el bot\xF3n de arriba.",
    signature: "Que tengas un buen d\xEDa"
  },
  discountCodeCreated: {
    preview: "Su cr\xE9dito para el pedido {{orderNumber}}",
    heading: "Su cr\xE9dito para el pedido {{orderNumber}}",
    giftMessageValidUntil: "Tras el procesamiento de su devoluci\xF3n para el pedido {{orderNumber}}, aqu\xED tiene su cr\xE9dito de {{amount}}\u20AC, v\xE1lido hasta {{validUntil}}.",
    giftMessageNoValidity: "Tras el procesamiento de su devoluci\xF3n para el pedido {{orderNumber}}, aqu\xED tiene su cr\xE9dito de {{amount}}\u20AC.",
    giftSecondaryMessage: "Puede usarlo en toda la tienda.",
    ending: "Que tenga un buen d\xEDa"
  },
  storeCreditCreated: {
    heading: "Su cr\xE9dito en tienda para el pedido {{orderName}}",
    preview: "{{shopName}} - Su cr\xE9dito en tienda para el pedido {{orderName}}",
    giftMessage: "Tras su devoluci\xF3n del pedido {{orderName}}, se ha a\xF1adido un cr\xE9dito de {{amount}}{{currency}} a su cuenta.",
    giftMessageValidUntil: "Tras su devoluci\xF3n del pedido {{orderName}}, se ha a\xF1adido un cr\xE9dito de {{amount}}{{currency}} a su cuenta, v\xE1lido hasta el {{validUntil}}.",
    giftSecondaryMessage: "Se aplicar\xE1 autom\xE1ticamente en el pago.",
    ending: "Que tenga un buen d\xEDa"
  },
  returnRequestAccepted: {
    previewMessage: "Su solicitud de devoluci\xF3n",
    headingMessage: "Su solicitud de devoluci\xF3n",
    confirmationMessage: "Hemos procesado tu devoluci\xF3n. Si ha solicitado un reembolso, ser\xE1 visible en la cuenta bancaria utilizada al realizar el pedido en un plazo de 2 a 5 d\xEDas.",
    trackingCTAMessage: "Ver mi solicitud de devoluci\xF3n",
    endingMessage: "Si tienes alguna consulta, no dudes en ponerte en contacto con nuestro servicio de atenci\xF3n al cliente."
  },
  returnRequestRejected: {
    preview: "Su solicitud de devoluci\xF3n",
    heading: "Su solicitud de devoluci\xF3n ha sido rechazada",
    description: "Hemos procesado su solicitud de devoluci\xF3n. Lamentablemente, los art\xEDculos listados a continuaci\xF3n no pudieron ser aceptados.",
    rejectedItemsTitle: "Art\xEDculos rechazados",
    trackCTA: "Ver mi solicitud"
  },
  exportSuccess: {
    subject: "Solicitudes de devoluci\xF3n exportadas",
    text: "La exportaci\xF3n de su solicitud de devoluci\xF3n se gener\xF3 correctamente y est\xE1 disponible como archivo adjunto."
  },
  exportFailure: {
    subject: "Fallo en la exportaci\xF3n de solicitudes de devoluci\xF3n",
    text: "Se ha producido un error al procesar su exportaci\xF3n de solicitudes de devoluci\xF3n. Por favor, p\xF3ngase en contacto con el soporte de Baback."
  },
  lineItems: {
    summary: {
      title: "Detalles de su devoluci\xF3n"
    },
    sections: {
      refund: {
        title: "Reembolso(s)"
      },
      exchange: {
        title: "Intercambio(s)"
      },
      discount: {
        title: "Cr\xE9dito(s)"
      },
      exchangeCredit: {
        title: "Nuevo pedido"
      }
    }
  },
  tracking: {
    shared: {
      endDepositDate: "Paquete disponible hasta:",
      estimatedDeliveryDate: "Fecha estimada de entrega:",
      estimatedDeliveryDateWindow: "el {{day}} entre las {{minimum}} y las {{maximum}}.",
      estimatedDeliveryDatesWindow: "entre el {{minimum}} y el {{maximum}}.",
      between: "Entre",
      and: "y",
      from: "Del",
      to: "al"
    },
    preTransit: {
      preview: "Hemos recibido su pedido",
      email: {
        title: "Su pedido est\xE1 siendo procesado",
        description: "Hemos recibido su pedido y lo estamos preparando para el env\xEDo. Recibir\xE1 un correo electr\xF3nico de confirmaci\xF3n de env\xEDo tan pronto como su pedido est\xE9 en camino.",
        cta: "Seguir mi pedido",
        deliveryDetails: {
          title: "Detalles de entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    },
    inTransit: {
      preview: "Su pedido est\xE1 en camino",
      email: {
        title: "Su pedido est\xE1 en camino",
        description: "Su pedido ha sido enviado y est\xE1 en camino. Puede seguir su progreso en tiempo real.",
        cta: "Seguir mi pedido",
        deliveryDetails: {
          title: "Detalles de entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    },
    availableForPickup: {
      preview: "Su paquete est\xE1 disponible para recoger",
      email: {
        title: "Su paquete est\xE1 disponible para recoger",
        description: "Su paquete ha llegado al punto de recogida y ahora puede recogerlo.",
        cta: "Recoger mi paquete",
        deliveryDetails: {
          title: "Detalles de entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    },
    deliveredToNeighbour: {
      preview: "Su paquete fue entregado a un vecino",
      email: {
        title: "Su paquete fue entregado a un vecino",
        description: "Su paquete fue entregado a un vecino en su ausencia.",
        cta: "Ver detalles de la entrega",
        ifNotDelivered: "Si no ha recibido su paquete, por favor, contacte con nuestro ",
        ifNotDeliveredLink: "servicio de atenci\xF3n al cliente",
        deliveryDetails: {
          title: "Detalles de entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    },
    waitingAtPickupPointSevere: {
      preview: "Su paquete espera ser recogido (recordatorio)",
      email: {
        title: "Su paquete espera ser recogido",
        description: "Su paquete sigue disponible en el punto de recogida. Por favor, rec\xF3jalo lo antes posible.",
        cta: "Recoger mi paquete",
        deliveryDetails: {
          title: "Detalles de entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    },
    waitingInformationFromAddress: {
      preview: "Informaci\xF3n requerida para su entrega",
      email: {
        title: "Informaci\xF3n requerida para su entrega",
        description: "Necesitamos informaci\xF3n adicional sobre su direcci\xF3n de entrega para completar su pedido. Por favor, actualice su informaci\xF3n lo antes posible.",
        cta: "Actualizar mi informaci\xF3n",
        deliveryDetails: {
          title: "Detalles de entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    },
    delivered: {
      preview: "Su paquete ha sido entregado",
      email: {
        title: "Su paquete ha sido entregado",
        description: "Su paquete ha sido entregado en la direcci\xF3n indicada."
      }
    },
    returnedToSender: {
      preview: "Su paquete fue devuelto al remitente",
      email: {
        title: "Su paquete fue devuelto al remitente",
        description: "Su paquete no pudo ser entregado y fue devuelto al remitente.",
        cta: "Contactar con soporte",
        deliveryDetails: {
          title: "Detalles de entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    },
    exception: {
      preview: "Su paquete ha tenido un problema durante el env\xEDo",
      email: {
        title: "Su paquete ha tenido un problema durante el env\xEDo",
        description: "Su transportista ha informado del siguiente problema:",
        cta: "Contactar con soporte",
        deliveryDetails: {
          title: "Detalles de la entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    },
    orderNotFulfilled: {
      preview: "Su pedido a\xFAn no ha sido procesado",
      email: {
        title: "Su pedido a\xFAn no ha sido procesado",
        description: "Hemos recibido su pedido, pero a\xFAn no ha sido procesado por el comerciante. Recibir\xE1 una notificaci\xF3n tan pronto como sea atendido.",
        cta: "Seguir mi pedido",
        deliveryDetails: {
          title: "Detalles de entrega",
          packageContent: {
            label: "Contenido del paquete"
          }
        }
      }
    }
  },
  returnRequestCreated: {
    preview: "Su solicitud de devoluci\xF3n",
    heading: "Su solicitud de devoluci\xF3n",
    description: "Hemos recibido su solicitud de devoluci\xF3n. Ahora puede descargar su etiqueta de env\xEDo y seguir su devoluci\xF3n.",
    findDropPointCTA: "Encontrar un punto de entrega",
    downloadLabelCTA: "Descargar mi etiqueta",
    trackCTA: "Seguir mi devoluci\xF3n"
  },
  returnRequestWithoutApproval: {
    preview: "Su solicitud de devoluci\xF3n",
    heading: "Su solicitud de devoluci\xF3n",
    description: "Hemos recibido su solicitud de devoluci\xF3n. La validaremos lo antes posible. Una vez validada, le indicaremos c\xF3mo proceder con su devoluci\xF3n.",
    trackCTA: "Seguir mi devoluci\xF3n"
  },
  returnRequestReturnToStore: {
    preview: "Su solicitud de devoluci\xF3n",
    heading: "Su solicitud de devoluci\xF3n",
    description: "Hemos recibido su solicitud de devoluci\xF3n. Ahora puede ir a la tienda para dejar su devoluci\xF3n.",
    trackCTA: "Seguir mi devoluci\xF3n",
    mapLabel: "Ver mapa"
  },
  returnRequestWithoutLabel: {
    preview: "Su solicitud de devoluci\xF3n",
    heading: "Su solicitud de devoluci\xF3n",
    description: "Hemos recibido su solicitud de devoluci\xF3n. Le enviaremos un correo electr\xF3nico con las instrucciones de devoluci\xF3n muy pronto.",
    trackCTA: "Seguir mi devoluci\xF3n"
  },
  deliveryDetails: {
    title: "Detalles de entrega"
  },
  packageContent: {
    label: "Contenido del paquete"
  },
  deliveryAddress: {
    title: "Direcci\xF3n de entrega",
    titlePickup: "Direcci\xF3n del punto de recogida",
    orderDetails: {
      title: "Detalles del pedido",
      trackingNumber: "N\xFAmero de seguimiento",
      orderNumber: "N\xFAmero de pedido",
      orderDate: "Fecha del pedido"
    }
  },
  pickupPoint: {
    title: "Punto de recogida",
    closed: "Cerrado",
    openingHours: "Horario de apertura",
    website: "Sitio web",
    directions: "Direcciones",
    days: {
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Mi\xE9rcoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "S\xE1bado",
      sunday: "Domingo"
    }
  },
  blockedReturnsDigest: {
    subject: "Resumen de devoluciones bloqueadas",
    heading: "Devoluciones que requieren su atenci\xF3n",
    noAlerts: "Sin devoluciones bloqueadas en este per\xEDodo",
    normalCount: "{{count}} devoluci\xF3n(es) procesada(s) normalmente en este per\xEDodo",
    andMore: "y {{count}} m\xE1s...",
    viewReturn: "Ver devoluci\xF3n",
    types: {
      label_failed: "Etiqueta",
      refund_failed: "Reembolso",
      treatment_failed: "Tratamiento",
      logistics_rejected: "Log\xEDstica rechazada",
      exchange_failed: "Intercambio",
      integration_failed: "Integraci\xF3n",
      stale_return: "Pendiente",
      received_not_refunded: "No reembolsado",
      out_of_stock: "Sin stock"
    },
    open: "Abrir",
    header: {
      type: "Tipo",
      order: "Pedido",
      email: "Correo",
      error: "Error"
    },
    pendingActions: {
      heading: "Devoluciones pendientes de acci\xF3n",
      toBeValidated: "devoluci\xF3n(es) pendiente(s) de validaci\xF3n",
      toBeTreated: "devoluci\xF3n(es) pendiente(s) de tratamiento"
    },
    blockingReturns: {
      heading: "Devoluciones bloqueadas"
    }
  }
};

// ../translations/emails/de.json
var de_default = {
  returnRequestDate: {
    label: "Ihre R\xFCcksendeanfrage wurde am {{date}} um {{time}} Uhr gestellt"
  },
  shippingStatusUpdated: {
    preview: "Ihre R\xFCcksendung ist unterwegs",
    heading: "Ihre R\xFCcksendung ist unterwegs!",
    confirmation: "Vielen Dank, dass Sie Ihr R\xFCcksendepaket zur\xFCckgeschickt haben, es wurde vom Transportunternehmen abgeholt.",
    track: "Sie k\xF6nnen Ihr R\xFCcksendepaket verfolgen, indem Sie auf den folgenden Link klicken:",
    trackCTA: "Meine R\xFCcksendung verfolgen",
    ending: "Sobald wir Ihr Paket erhalten haben, senden wir Ihnen eine Best\xE4tigungs-E-Mail. Bitte erlauben Sie bis zu 14 Tage nach Erhalt Ihres Pakets durch unser Logistikteam, um Ihre R\xFCckerstattung zu erhalten."
  },
  shippingLabelCreated: {
    preview: "Ihr Versandetikett ist bereit",
    heading: "Ihr Versandetikett ist bereit",
    description: "Ihr Versandetikett ist bereit. Sie k\xF6nnen es jetzt ausdrucken und f\xFCr Ihre R\xFCcksendung verwenden.",
    conform: "Bitte stellen Sie sicher, dass Ihr Paket ordnungsgem\xE4\xDF verpackt ist und das Versandetikett gut sichtbar ist.",
    findDropPointCTA: "Abgabestelle finden",
    downloadLabelCTA: "Mein Etikett herunterladen",
    trackCTA: "R\xFCcksendung verfolgen",
    takeAccount: "Drucken Sie Ihr R\xFCcksendeetikett aus und geben Sie Ihr R\xFCcksendepaket im {{carrier}}-Abholpunkt Ihrer Wahl ab.",
    colissimo: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen Colissimo-Relaispunkt abgeben.",
    "chrono-shop2shop": "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen Chronopost-Relaispunkt abgeben.",
    "customer-carrier": "Sie k\xF6nnen nun Ihr R\xFCcksendepaket an den Spediteur Ihrer Wahl senden.",
    "merchant-carrier": "Wir senden Ihnen ein R\xFCcksendeetikett per E-Mail innerhalb von 1 bis 3 Werktagen.",
    returnToStore: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket im n\xE4chstgelegenen Gesch\xE4ft abgeben.",
    malca: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen Malca-Relaispunkt abgeben.",
    tnt: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen TNT-Relaispunkt abgeben.",
    ups: "Sie k\xF6nnen jetzt Ihr R\xFCcksendeetikett ausdrucken und Ihr Paket beim n\xE4chstgelegenen UPS-Relaispunkt abgeben.",
    getLabelCTA: "Mein R\xFCcksendeetikett herunterladen",
    findRelayPoint: "Sie k\xF6nnen den n\xE4chstgelegenen Relaispunkt \xFCber diesen Link finden und dann Ihre R\xFCcksendung beim Spediteur verfolgen.",
    findRelayPointCTA: "Einen Relaispunkt finden",
    doNotReply: "Dies ist eine automatische E-Mail, bitte antworten Sie nicht darauf.",
    contactUs: "Um uns zu kontaktieren:",
    previewBonDeRetour: "Ihr R\xFCcksendeschein ist bereit",
    headingBonDeRetour: "Ihr R\xFCcksendeschein ist bereit",
    descriptionBonDeRetour: "Ihr R\xFCcksendeschein ist bereit. Sie k\xF6nnen ihn jetzt ausdrucken und f\xFCr Ihre R\xFCcksendung verwenden.",
    downloadBonDeRetourCTA: "Meinen R\xFCcksendeschein herunterladen"
  },
  depositReminder: {
    preview: "Vergessen Sie nicht, Ihr R\xFCcksendepaket abzugeben",
    heading: "Vergessen Sie nicht, Ihr R\xFCcksendepaket abzugeben",
    description: "Sie haben Ihr R\xFCcksendeetikett erstellt, aber wir haben Ihr Paket noch nicht erhalten. Bitte geben Sie es bald ab, damit wir Ihre Anfrage bearbeiten k\xF6nnen.",
    downloadLabelCTA: "Mein Etikett herunterladen",
    trackCTA: "R\xFCcksendung verfolgen",
    descriptionBonDeRetour: "Sie haben Ihren R\xFCcksendeschein erstellt, aber wir haben Ihr Paket noch nicht erhalten. Bitte geben Sie es bald ab, damit wir Ihre Anfrage bearbeiten k\xF6nnen.",
    downloadBonDeRetourCTA: "Meinen R\xFCcksendeschein herunterladen"
  },
  returnRequestWithoutPhysicalReturn: {
    preview: "Ihre Anfrage wurde best\xE4tigt",
    heading: "Ihre Anfrage wurde best\xE4tigt",
    description: "Wir haben Ihre R\xFCcksendeanfrage erhalten. Sie werden benachrichtigt, sobald sie bearbeitet wurde.",
    trackCTA: "Meine Anfrage verfolgen"
  },
  invite: {
    preview: "Treten Sie Baback bei",
    heading: "Treten Sie Baback bei",
    joinTeam: "Sie wurden eingeladen, dem Unternehmen {{shopName}} auf Baback beizutreten",
    joinCTA: "Treten Sie {{shopName}} bei",
    noAccount: "Wenn Sie kein Baback-Konto haben, k\xF6nnen Sie eines erstellen, indem Sie auf die Schaltfl\xE4che oben klicken.",
    signature: "Einen sch\xF6nen Tag"
  },
  discountCodeCreated: {
    preview: "Ihr Guthaben f\xFCr die Bestellung {{orderNumber}}",
    heading: "Ihr Guthaben f\xFCr die Bestellung {{orderNumber}}",
    giftMessageValidUntil: "Nach der Bearbeitung Ihrer R\xFCcksendung f\xFCr die Bestellung {{orderNumber}} erhalten Sie hiermit Ihr Guthaben von {{amount}}\u20AC, g\xFCltig bis {{validUntil}}.",
    giftMessageNoValidity: "Nach der Bearbeitung Ihrer R\xFCcksendung f\xFCr die Bestellung {{orderNumber}} erhalten Sie hiermit Ihr Guthaben von {{amount}}\u20AC.",
    giftSecondaryMessage: "Sie k\xF6nnen es im gesamten Shop verwenden.",
    ending: "Sch\xF6nen Tag noch"
  },
  storeCreditCreated: {
    heading: "Ihr Guthaben f\xFCr die Bestellung {{orderName}}",
    preview: "{{shopName}} - Ihr Guthaben f\xFCr die Bestellung {{orderName}}",
    giftMessage: "Nach Ihrer R\xFCcksendung zur Bestellung {{orderName}} wurde ein Guthaben von {{amount}}{{currency}} Ihrem Konto gutgeschrieben.",
    giftMessageValidUntil: "Nach Ihrer R\xFCcksendung zur Bestellung {{orderName}} wurde ein Guthaben von {{amount}}{{currency}} Ihrem Konto gutgeschrieben, g\xFCltig bis {{validUntil}}.",
    giftSecondaryMessage: "Es wird automatisch an der Kasse angewendet.",
    ending: "Sch\xF6nen Tag noch"
  },
  returnRequestAccepted: {
    previewMessage: "Ihr R\xFCckgabewunsch",
    headingMessage: "Ihr R\xFCckgabewunsch",
    confirmationMessage: "Wir haben Ihre R\xFCcksendung bearbeitet. Wenn Sie eine R\xFCckerstattung beantragt haben, wird diese innerhalb von 2 bis 5 Tagen auf dem bei der Bestellung verwendeten Bankkonto angezeigt.",
    trackingCTAMessage: "Sehen Sie sich meine R\xFCckgabeanfrage an",
    endingMessage: "Wenn Sie Fragen haben, z\xF6gern Sie nicht, unseren Kundenservice zu kontaktieren."
  },
  returnRequestRejected: {
    preview: "Ihre R\xFCcksendeanfrage",
    heading: "Ihre R\xFCcksendeanfrage wurde abgelehnt",
    description: "Wir haben Ihre R\xFCcksendeanfrage bearbeitet. Leider konnten die unten aufgef\xFChrten Artikel nicht akzeptiert werden.",
    rejectedItemsTitle: "Abgelehnte Artikel",
    trackCTA: "Meine Anfrage ansehen"
  },
  exportSuccess: {
    subject: "Exportierte R\xFCcksendungen",
    text: "Ihr R\xFCckgabeanforderungsexport wurde erfolgreich generiert und ist als Anhang verf\xFCgbar."
  },
  exportFailure: {
    subject: "Export der R\xFCcksendungen fehlgeschlagen",
    text: "Beim Verarbeiten Ihres R\xFCcksendungsexports ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Baback-Support."
  },
  lineItems: {
    summary: {
      title: "Details Ihrer R\xFCcksendung"
    },
    sections: {
      refund: {
        title: "R\xFCckerstattung(en)"
      },
      exchange: {
        title: "Austausch"
      },
      discount: {
        title: "Guthaben"
      },
      exchangeCredit: {
        title: "Neue Bestellung"
      }
    }
  },
  tracking: {
    shared: {
      endDepositDate: "Paket verf\xFCgbar bis:",
      estimatedDeliveryDate: "Voraussichtliches Lieferdatum:",
      estimatedDeliveryDateWindow: "am {{day}} zwischen {{minimum}} und {{maximum}} Uhr.",
      estimatedDeliveryDatesWindow: "zwischen dem {{minimum}} und dem {{maximum}}.",
      between: "Zwischen",
      and: "und",
      from: "Vom",
      to: "bis zum"
    },
    preTransit: {
      preview: "Wir haben Ihre Bestellung erhalten",
      email: {
        title: "Ihre Bestellung wird bearbeitet",
        description: "Wir haben Ihre Bestellung erhalten und bereiten sie f\xFCr den Versand vor. Sie erhalten eine Versandbest\xE4tigung per E-Mail, sobald Ihre Bestellung unterwegs ist.",
        cta: "Meine Bestellung verfolgen",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    },
    inTransit: {
      preview: "Ihre Bestellung ist unterwegs",
      email: {
        title: "Ihre Bestellung ist unterwegs",
        description: "Ihre Bestellung wurde versandt und ist unterwegs. Sie k\xF6nnen den Versand in Echtzeit verfolgen.",
        cta: "Meine Bestellung verfolgen",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    },
    availableForPickup: {
      preview: "Ihr Paket ist zur Abholung bereit",
      email: {
        title: "Ihr Paket ist zur Abholung bereit",
        description: "Ihr Paket ist am Abholpunkt angekommen und Sie k\xF6nnen es jetzt abholen.",
        cta: "Mein Paket abholen",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    },
    deliveredToNeighbour: {
      preview: "Ihr Paket wurde einem Nachbarn \xFCbergeben",
      email: {
        title: "Ihr Paket wurde einem Nachbarn \xFCbergeben",
        description: "Ihr Paket wurde in Ihrer Abwesenheit einem Nachbarn zugestellt.",
        cta: "Lieferdetails anzeigen",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    },
    waitingAtPickupPointSevere: {
      preview: "Ihr Paket wartet auf Abholung (Erinnerung)",
      email: {
        title: "Ihr Paket wartet auf Abholung",
        description: "Ihr Paket ist weiterhin am Abholpunkt verf\xFCgbar. Bitte holen Sie es schnellstm\xF6glich ab.",
        cta: "Mein Paket abholen",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    },
    waitingInformationFromAddress: {
      preview: "Informationen f\xFCr Ihre Lieferung erforderlich",
      email: {
        title: "Informationen f\xFCr Ihre Lieferung erforderlich",
        description: "Wir ben\xF6tigen zus\xE4tzliche Informationen zu Ihrer Lieferadresse, um Ihre Bestellung abzuschlie\xDFen. Bitte aktualisieren Sie Ihre Informationen so schnell wie m\xF6glich.",
        cta: "Meine Informationen aktualisieren",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    },
    delivered: {
      preview: "Ihr Paket wurde geliefert",
      email: {
        title: "Ihr Paket wurde geliefert",
        description: "Ihr Paket wurde an die angegebene Adresse geliefert.",
        ifNotDelivered: "Wenn Sie Ihr Paket nicht erhalten haben, kontaktieren Sie bitte unseren ",
        ifNotDeliveredLink: "Kundenservice"
      }
    },
    returnedToSender: {
      preview: "Ihr Paket wurde an den Absender zur\xFCckgesendet",
      email: {
        title: "Ihr Paket wurde an den Absender zur\xFCckgesendet",
        description: "Ihr Paket konnte nicht zugestellt werden und wurde an den Absender zur\xFCckgesendet.",
        cta: "Support kontaktieren",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    },
    exception: {
      preview: "Ihr Paket ist w\xE4hrend der Zustellung auf ein Problem gesto\xDFen",
      email: {
        title: "Ihr Paket ist w\xE4hrend der Zustellung auf ein Problem gesto\xDFen",
        description: "Ihr Versanddienstleister hat folgendes Problem gemeldet:",
        cta: "Support kontaktieren",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    },
    orderNotFulfilled: {
      preview: "Ihre Bestellung wurde noch nicht bearbeitet",
      email: {
        title: "Ihre Bestellung wurde noch nicht bearbeitet",
        description: "Wir haben Ihre Bestellung erhalten, aber sie wurde vom H\xE4ndler noch nicht bearbeitet. Sie erhalten eine Benachrichtigung, sobald sie bearbeitet wird.",
        cta: "Meine Bestellung verfolgen",
        deliveryDetails: {
          title: "Lieferdetails",
          packageContent: {
            label: "Paketinhalt"
          }
        }
      }
    }
  },
  returnRequestCreated: {
    preview: "Ihre R\xFCcksendeanfrage",
    heading: "Ihre R\xFCcksendeanfrage",
    description: "Wir haben Ihre R\xFCcksendeanfrage erhalten. Sie k\xF6nnen jetzt Ihr Versandetikett herunterladen und Ihre R\xFCcksendung verfolgen.",
    findDropPointCTA: "Abgabestelle finden",
    downloadLabelCTA: "Mein Etikett herunterladen",
    trackCTA: "R\xFCcksendung verfolgen"
  },
  returnRequestWithoutApproval: {
    preview: "Ihre R\xFCcksendeanfrage",
    heading: "Ihre R\xFCcksendeanfrage",
    description: "Wir haben Ihre R\xFCcksendeanfrage erhalten. Wir werden sie so schnell wie m\xF6glich validieren. Sobald sie validiert ist, werden wir Ihnen mitteilen, wie Sie mit Ihrer R\xFCcksendung fortfahren k\xF6nnen.",
    trackCTA: "R\xFCcksendung verfolgen"
  },
  returnRequestReturnToStore: {
    preview: "Ihre R\xFCcksendeanfrage",
    heading: "Ihre R\xFCcksendeanfrage",
    description: "Wir haben Ihre R\xFCcksendeanfrage erhalten. Sie k\xF6nnen jetzt in den Laden gehen, um Ihre R\xFCcksendung abzugeben.",
    trackCTA: "R\xFCcksendung verfolgen",
    mapLabel: "Karte anzeigen"
  },
  returnRequestWithoutLabel: {
    preview: "Ihre R\xFCcksendeanfrage",
    heading: "Ihre R\xFCcksendeanfrage",
    description: "Wir haben Ihre R\xFCcksendeanfrage erhalten. Wir werden Ihnen in K\xFCrze eine E-Mail mit R\xFCcksendeanweisungen senden.",
    trackCTA: "R\xFCcksendung verfolgen"
  },
  deliveryDetails: {
    title: "Lieferdetails"
  },
  packageContent: {
    label: "Paketinhalt"
  },
  deliveryAddress: {
    title: "Lieferadresse",
    titlePickup: "Adresse der Abholstelle",
    orderDetails: {
      title: "Bestelldetails",
      trackingNumber: "Sendungsnummer",
      orderNumber: "Bestellnummer",
      orderDate: "Bestelldatum"
    }
  },
  pickupPoint: {
    title: "Abholpunkt",
    closed: "Geschlossen",
    openingHours: "\xD6ffnungszeiten",
    website: "Website",
    directions: "Wegbeschreibung",
    days: {
      monday: "Montag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
      thursday: "Donnerstag",
      friday: "Freitag",
      saturday: "Samstag",
      sunday: "Sonntag"
    }
  },
  blockedReturnsDigest: {
    subject: "Zusammenfassung blockierter Retouren",
    heading: "Retouren, die Ihre Aufmerksamkeit erfordern",
    noAlerts: "Keine blockierten Retouren in diesem Zeitraum",
    normalCount: "{{count}} Retoure(n) in diesem Zeitraum normal bearbeitet",
    andMore: "und {{count}} weitere...",
    viewReturn: "Retoure ansehen",
    types: {
      label_failed: "Etikett",
      refund_failed: "Erstattung",
      treatment_failed: "Bearbeitung",
      logistics_rejected: "Logistik abgelehnt",
      exchange_failed: "Umtausch",
      integration_failed: "Integration",
      stale_return: "Ausstehend",
      received_not_refunded: "Nicht erstattet",
      out_of_stock: "Nicht auf Lager"
    },
    open: "\xD6ffnen",
    header: {
      type: "Typ",
      order: "Bestellung",
      email: "E-Mail",
      error: "Fehler"
    },
    pendingActions: {
      heading: "R\xFCcksendungen, die auf eine Aktion warten",
      toBeValidated: "R\xFCcksendung(en) ausstehende Validierung",
      toBeTreated: "R\xFCcksendung(en) ausstehende Bearbeitung"
    },
    blockingReturns: {
      heading: "Blockierte R\xFCcksendungen"
    }
  }
};

// ../translations/emails/it.json
var it_default = {
  returnRequestDate: {
    label: "La tua richiesta di reso \xE8 stata effettuata il {{date}} alle {{time}}"
  },
  shippingStatusUpdated: {
    preview: "Il tuo reso \xE8 in arrivo",
    heading: "Il tuo reso \xE8 in arrivo!",
    confirmation: "Grazie per aver rispedito il tuo pacco di reso, che \xE8 stato preso in carico dal corriere.",
    track: "Puoi seguire il percorso del tuo reso cliccando sul link qui sotto:",
    trackCTA: "Segui il mio reso",
    ending: "Non appena avremo ricevuto il tuo pacco, ti invieremo un'email di conferma. Contare fino a 14 giorni dalla ricezione del pacco da parte del nostro team logistico per ricevere il rimborso."
  },
  returnRequestCreated: {
    preview: "La tua richiesta di reso",
    heading: "La tua richiesta di reso",
    description: "Abbiamo ricevuto la tua richiesta di reso. Puoi ora scaricare l'etichetta di spedizione e monitorare il tuo reso.",
    findDropPointCTA: "Trova un punto di ritiro",
    downloadLabelCTA: "Scarica la mia etichetta",
    trackCTA: "Segui il mio reso"
  },
  returnRequestWithoutApproval: {
    preview: "La tua richiesta di reso",
    heading: "La tua richiesta di reso",
    description: "La tua richiesta \xE8 stata presa in carico. La valuteremo al pi\xF9 presto. Una volta approvata, ti indicheremo come procedere al reso.",
    trackCTA: "Segui il mio reso"
  },
  returnRequestReturnToStore: {
    preview: "La tua richiesta di reso",
    heading: "La tua richiesta di reso",
    description: "La tua richiesta \xE8 stata presa in carico. Puoi ora recarti in negozio per depositare il tuo reso.",
    trackCTA: "Segui il mio reso",
    mapLabel: "Vedi la mappa"
  },
  returnRequestWithoutLabel: {
    preview: "La tua richiesta di reso",
    heading: "La tua richiesta di reso",
    description: "Abbiamo ricevuto la tua richiesta di reso. Ti invieremo presto un'email con le istruzioni per il reso.",
    trackCTA: "Segui il mio reso"
  },
  shippingLabelCreated: {
    preview: "La tua etichetta di spedizione \xE8 pronta",
    heading: "La tua etichetta di spedizione \xE8 pronta",
    description: "La tua etichetta di spedizione \xE8 pronta. Puoi stamparla ora e usarla per il tuo reso.",
    conform: "Assicurati che il pacco sia correttamente imballato e che l'etichetta di spedizione sia ben visibile.",
    findDropPointCTA: "Trova un punto di ritiro",
    downloadLabelCTA: "Scarica la mia etichetta",
    trackCTA: "Segui il mio reso",
    takeAccount: "Stampa la tua etichetta di reso e deposita il pacco presso il punto di raccolta {{carrier}} che preferisci",
    colissimo: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Colissimo pi\xF9 vicino.",
    "chrono-shop2shop": "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Chronopost pi\xF9 vicino.",
    "customer-carrier": "Puoi ora spedire il tuo pacco di reso con il corriere di tua scelta.",
    "merchant-carrier": "Ti invieremo un'etichetta di reso via email entro 1\u20133 giorni lavorativi.",
    returnToStore: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel negozio pi\xF9 vicino.",
    malca: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Malca pi\xF9 vicino.",
    tnt: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto TNT pi\xF9 vicino.",
    ups: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto UPS pi\xF9 vicino.",
    getLabelCTA: "Scarica la mia etichetta di reso",
    doNotReply: "Questa \xE8 un'email automatica, si prega di non rispondere.",
    contactUs: "Per contattarci:",
    previewBonDeRetour: "Il tuo modulo di reso \xE8 pronto",
    headingBonDeRetour: "Il tuo modulo di reso \xE8 pronto",
    descriptionBonDeRetour: "Il tuo modulo di reso \xE8 pronto. Puoi stamparlo ora e usarlo per il tuo reso.",
    downloadBonDeRetourCTA: "Scarica il mio modulo di reso"
  },
  depositReminder: {
    preview: "Non dimenticare di depositare il tuo pacco di reso",
    heading: "Non dimenticare di depositare il tuo pacco di reso",
    description: "Hai generato la tua etichetta di reso ma non abbiamo ancora ricevuto il tuo pacco. Ti preghiamo di depositarlo al pi\xF9 presto affinch\xE9 possiamo elaborare la tua richiesta.",
    downloadLabelCTA: "Scarica la mia etichetta",
    trackCTA: "Segui il mio reso",
    descriptionBonDeRetour: "Hai generato il tuo modulo di reso ma non abbiamo ancora ricevuto il tuo pacco. Ti preghiamo di depositarlo al pi\xF9 presto affinch\xE9 possiamo elaborare la tua richiesta.",
    downloadBonDeRetourCTA: "Scarica il mio modulo di reso"
  },
  returnRequestWithoutPhysicalReturn: {
    preview: "La tua richiesta \xE8 stata presa in carico",
    heading: "La tua richiesta \xE8 stata presa in carico",
    description: "Abbiamo ricevuto la tua richiesta di reso. Verrai informato/a non appena sar\xE0 elaborata.",
    trackCTA: "Segui la mia richiesta"
  },
  invite: {
    preview: "Unisciti a Baback",
    heading: "Unisciti a Baback",
    joinTeam: "Sei stato invitato a unirti all'azienda {{shopName}} su Baback",
    joinCTA: "Unisciti a {{shopName}}",
    noAccount: "Se non hai un account Baback, puoi crearne uno cliccando sul pulsante qui sopra.",
    signature: "Buona giornata"
  },
  discountCodeCreated: {
    preview: "Il tuo buono per l'ordine {{orderNumber}}",
    heading: "Il tuo buono per l'ordine {{orderNumber}}",
    giftMessageValidUntil: "A seguito del trattamento del reso dell'ordine {{orderNumber}}, ecco il tuo buono di {{amount}}\u20AC, valido fino al {{validUntil}}.",
    giftMessageNoValidity: "A seguito del trattamento del reso dell'ordine {{orderNumber}}, ecco il tuo buono di {{amount}}\u20AC.",
    giftSecondaryMessage: "Puoi utilizzarlo su tutto il negozio.",
    ending: "Buona giornata"
  },
  returnRequestAccepted: {
    previewMessage: "La tua richiesta di reso",
    headingMessage: "La tua richiesta di reso \xE8 stata elaborata!",
    confirmationMessage: "Abbiamo ricevuto il tuo reso. Se hai richiesto un rimborso, sar\xE0 visibile sul metodo di pagamento utilizzato entro 2\u20135 giorni.",
    trackingCTAMessage: "Rivedi il mio reso",
    endingMessage: "Per qualsiasi richiesta, non esitare a contattare il nostro servizio clienti."
  },
  returnRequestRejected: {
    preview: "La sua richiesta di reso",
    heading: "La sua richiesta di reso \xE8 stata rifiutata",
    description: "Abbiamo elaborato la sua richiesta di reso. Purtroppo, gli articoli elencati di seguito non hanno potuto essere accettati.",
    rejectedItemsTitle: "Articoli rifiutati",
    trackCTA: "Visualizza la mia richiesta"
  },
  exportSuccess: {
    subject: "Richieste di reso esportate",
    text: "La tua esportazione delle richieste di reso \xE8 stata generata con successo e si trova in allegato."
  },
  exportFailure: {
    subject: "Errore nell'esportazione delle richieste di reso",
    text: "Si \xE8 verificato un errore durante l'elaborazione dell'esportazione delle richieste di reso. Contatta il supporto Baback."
  },
  lineItems: {
    summary: {
      title: "Dettagli del tuo reso"
    },
    sections: {
      refund: {
        title: "Rimborso(i)"
      },
      exchange: {
        title: "Cambio(i)"
      },
      discount: {
        title: "Buono(i)"
      },
      exchangeCredit: {
        title: "Nuovo ordine"
      }
    }
  },
  tracking: {
    shared: {
      endDepositDate: "Pacco disponibile fino al:",
      estimatedDeliveryDate: "Data di consegna stimata:",
      estimatedDeliveryDateWindow: "il {{day}} tra {{minimum}} e {{maximum}}.",
      estimatedDeliveryDatesWindow: "tra il {{minimum}} e il {{maximum}}.",
      between: "Tra",
      and: "e",
      from: "Tra il",
      to: "e il"
    },
    preTransit: {
      preview: "Abbiamo ricevuto il tuo ordine",
      email: {
        title: "Il tuo ordine \xE8 in preparazione",
        description: "Abbiamo ricevuto il tuo ordine e lo stiamo preparando per la spedizione. Riceverai un'email di conferma non appena sar\xE0 spedito.",
        cta: "Segui il mio ordine",
        deliveryDetails: {
          title: "Dettagli di consegna",
          packageContent: {
            label: "Contenuto del pacco"
          }
        }
      }
    },
    inTransit: {
      preview: "Il tuo ordine \xE8 in transito.",
      email: {
        title: "Il tuo ordine \xE8 in transito.",
        description: "Il tuo ordine \xE8 stato spedito ed \xE8 attualmente in viaggio. Puoi seguirne il percorso in tempo reale.",
        cta: "Segui il mio ordine",
        deliveryDetails: {
          title: "Dettagli di consegna",
          packageContent: {
            label: "Contenuto del pacco"
          }
        }
      }
    },
    availableForPickup: {
      preview: "Il tuo pacco \xE8 disponibile al punto di ritiro",
      email: {
        title: "Il tuo pacco \xE8 disponibile al punto di ritiro",
        description: "Il tuo pacco \xE8 arrivato al punto di ritiro ed \xE8 pronto per essere ritirato.",
        cta: "Ritira il mio pacco",
        deliveryDetails: {
          title: "Dettagli di consegna",
          packageContent: {
            label: "Contenuto del pacco"
          }
        }
      }
    },
    deliveredToNeighbour: {
      preview: "Il tuo pacco \xE8 stato consegnato a un vicino",
      email: {
        title: "Il tuo pacco \xE8 stato consegnato a un vicino",
        description: "Il tuo pacco \xE8 stato consegnato a un vicino in tua assenza.",
        cta: "Vedi i dettagli di consegna",
        deliveryDetails: {
          title: "Dettagli di consegna",
          packageContent: {
            label: "Contenuto del pacco"
          }
        }
      }
    },
    waitingAtPickupPointSevere: {
      preview: "Il tuo pacco ti aspetta ancora (promemoria)",
      email: {
        title: "Il tuo pacco ti aspetta al punto di ritiro",
        description: "Il tuo pacco \xE8 ancora disponibile al punto di ritiro. Ti invitiamo a ritirarlo rapidamente.",
        cta: "Ritira il mio pacco",
        deliveryDetails: {
          title: "Dettagli di consegna",
          packageContent: {
            label: "Contenuto del pacco"
          }
        }
      }
    },
    waitingInformationFromAddress: {
      preview: "\xC8 necessaria un'informazione per la consegna",
      email: {
        title: "Serve un'informazione per la tua consegna",
        description: "Abbiamo bisogno di informazioni aggiuntive sul tuo indirizzo di consegna per finalizzare il tuo ordine. Ti preghiamo di aggiornare i tuoi dati.",
        cta: "Aggiorna le mie informazioni",
        deliveryDetails: {
          title: "Dettagli di consegna",
          packageContent: {
            label: "Contenuto del pacco"
          }
        }
      }
    },
    delivered: {
      preview: "Il tuo pacco \xE8 stato consegnato",
      email: {
        title: "Il tuo pacco \xE8 stato consegnato",
        description: "Il tuo pacco \xE8 stato consegnato all'indirizzo indicato.",
        ifNotDelivered: "Se non hai ricevuto il tuo pacco, contatta il ",
        ifNotDeliveredLink: "servizio clienti"
      }
    },
    returnedToSender: {
      preview: "Il tuo pacco \xE8 stato rispedito al mittente",
      email: {
        title: "Il tuo pacco \xE8 stato rispedito al mittente",
        description: "Il tuo pacco non \xE8 stato consegnato ed \xE8 stato rispedito al mittente.",
        cta: "Contatta il supporto",
        deliveryDetails: {
          title: "Dettagli di consegna",
          packageContent: {
            label: "Contenuto del pacco"
          }
        }
      }
    },
    exception: {
      preview: "Il tuo pacco ha incontrato un problema durante il trasporto",
      email: {
        title: "Il tuo pacco ha incontrato un problema durante il trasporto",
        description: "Il corriere ha segnalato il seguente problema:",
        cta: "Contatta il supporto",
        deliveryDetails: {
          title: "Dettagli di consegna",
          packageContent: {
            label: "Contenuto del pacco"
          }
        }
      }
    }
  },
  deliveryDetails: {
    title: "Dettagli di consegna"
  },
  packageContent: {
    label: "Contenuto del pacco"
  },
  deliveryAddress: {
    title: "Indirizzo di consegna",
    titlePickup: "Indirizzo del punto di ritiro",
    orderDetails: {
      title: "Dettagli dell'ordine",
      trackingNumber: "Numero di tracciamento",
      orderNumber: "Numero d'ordine",
      orderDate: "Data dell'ordine"
    }
  },
  pickupPoint: {
    title: "Punto di ritiro",
    closed: "Chiuso",
    openingHours: "Orari di apertura",
    website: "Sito web",
    directions: "Indicazioni",
    days: {
      monday: "Luned\xEC",
      tuesday: "Marted\xEC",
      wednesday: "Mercoled\xEC",
      thursday: "Gioved\xEC",
      friday: "Venerd\xEC",
      saturday: "Sabato",
      sunday: "Domenica"
    }
  },
  blockedReturnsDigest: {
    subject: "Riepilogo resi bloccati",
    heading: "Resi che richiedono la tua attenzione",
    noAlerts: "Nessun reso bloccato in questo periodo",
    normalCount: "{{count}} reso/i elaborato/i normalmente in questo periodo",
    andMore: "e altri {{count}}...",
    viewReturn: "Vedi reso",
    types: {
      label_failed: "Etichetta",
      refund_failed: "Rimborso",
      treatment_failed: "Elaborazione",
      logistics_rejected: "Logistica rifiutata",
      exchange_failed: "Scambio",
      integration_failed: "Integrazione",
      stale_return: "In sospeso",
      received_not_refunded: "Non rimborsato",
      out_of_stock: "Esaurito"
    },
    open: "Apri",
    header: {
      type: "Tipo",
      order: "Ordine",
      email: "Email",
      error: "Errore"
    },
    pendingActions: {
      heading: "Resi in attesa di azione",
      toBeValidated: "reso/i in attesa di validazione",
      toBeTreated: "reso/i in attesa di trattamento"
    },
    blockingReturns: {
      heading: "Resi bloccati"
    }
  }
};

// ../translations/emails/zh.json
var zh_default = {
  returnRequestDate: {
    label: "\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u5DF2\u4E8E {{date}} {{time}} \u63D0\u4EA4"
  },
  shippingStatusUpdated: {
    preview: "\u60A8\u7684\u9000\u8D27\u6B63\u5728\u9014\u4E2D",
    heading: "\u60A8\u7684\u9000\u8D27\u6B63\u5728\u9014\u4E2D\uFF01",
    confirmation: "\u611F\u8C22\u60A8\u5BC4\u56DE\u9000\u8D27\u5305\u88F9\uFF0C\u627F\u8FD0\u5546\u5DF2\u53D6\u4EF6\u3002",
    track: "\u60A8\u53EF\u4EE5\u70B9\u51FB\u4E0B\u65B9\u94FE\u63A5\u8FFD\u8E2A\u60A8\u7684\u9000\u8D27\u5305\u88F9\uFF1A",
    trackCTA: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
    ending: "\u4E00\u65E6\u6211\u4EEC\u6536\u5230\u60A8\u7684\u5305\u88F9\uFF0C\u6211\u4EEC\u4F1A\u5411\u60A8\u53D1\u9001\u786E\u8BA4\u90AE\u4EF6\u3002\u8BF7\u5728\u6211\u4EEC\u7684\u7269\u6D41\u56E2\u961F\u6536\u5230\u60A8\u7684\u5305\u88F9\u540E\u6700\u591A\u7B49\u5F8514\u5929\uFF0C\u4EE5\u6536\u5230\u9000\u6B3E\u3002"
  },
  shippingLabelCreated: {
    preview: "\u60A8\u7684\u9000\u8D27\u6807\u7B7E\u5DF2\u521B\u5EFA\u3002",
    heading: "\u60A8\u7684\u9000\u8D27\u6807\u7B7E",
    takeAccount: "\u6253\u5370\u60A8\u7684\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u9000\u8D27\u5305\u88F9\u9001\u81F3\u60A8\u9009\u62E9\u7684{{carrier}}\u53D6\u4EF6\u70B9\u3002",
    colissimo: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684Colissimo\u4EE3\u6536\u70B9\u3002",
    "chrono-shop2shop": "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684Chronopost\u4EE3\u6536\u70B9\u3002",
    "customer-carrier": "\u60A8\u73B0\u5728\u53EF\u4EE5\u5C06\u9000\u8D27\u5305\u88F9\u4EA4\u7ED9\u60A8\u9009\u62E9\u7684\u627F\u8FD0\u5546\u3002",
    "merchant-carrier": "\u6211\u4EEC\u5C06\u57281\u81F33\u4E2A\u5DE5\u4F5C\u65E5\u5185\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5411\u60A8\u53D1\u9001\u9000\u8D27\u6807\u7B7E\u3002",
    returnToStore: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684\u95E8\u5E97\u3002",
    malca: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684Malca\u4EE3\u6536\u70B9\u3002",
    tnt: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684TNT\u4EE3\u6536\u70B9\u3002",
    ups: "\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u9000\u8D27\u6807\u7B7E\uFF0C\u5E76\u5C06\u5305\u88F9\u9001\u81F3\u6700\u8FD1\u7684UPS\u4EE3\u6536\u70B9\u3002",
    getLabelCTA: "\u4E0B\u8F7D\u6211\u7684\u9000\u8D27\u6807\u7B7E",
    findRelayPoint: "\u60A8\u53EF\u4EE5\u901A\u8FC7\u6B64\u94FE\u63A5\u627E\u5230\u6700\u8FD1\u7684\u4EE3\u6536\u70B9\uFF0C\u7136\u540E\u4F7F\u7528\u627F\u8FD0\u5546\u8FFD\u8E2A\u60A8\u7684\u9000\u8D27\u3002",
    findRelayPointCTA: "\u67E5\u627E\u4EE3\u6536\u70B9",
    trackCTA: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
    conform: "\u6536\u5230\u540E\uFF0C\u6211\u4EEC\u5C06\u68C0\u67E5\u60A8\u7684\u9000\u8D27\u5E76\u8FDB\u884C\u76F8\u5E94\u5904\u7406\u3002",
    description: "\u60A8\u7684\u8FD0\u5355\u6807\u7B7E\u5DF2\u51C6\u5907\u597D\u3002\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u5E76\u7528\u4E8E\u9000\u8D27\u3002",
    findDropPointCTA: "\u67E5\u627E\u6295\u9012\u70B9",
    downloadLabelCTA: "\u4E0B\u8F7D\u6211\u7684\u6807\u7B7E",
    doNotReply: "\u8FD9\u662F\u4E00\u5C01\u81EA\u52A8\u90AE\u4EF6\uFF0C\u8BF7\u52FF\u56DE\u590D\u3002",
    contactUs: "\u8054\u7CFB\u6211\u4EEC\uFF1A",
    previewBonDeRetour: "\u60A8\u7684\u9000\u8D27\u5355\u5DF2\u51C6\u5907\u597D",
    headingBonDeRetour: "\u60A8\u7684\u9000\u8D27\u5355\u5DF2\u51C6\u5907\u597D",
    descriptionBonDeRetour: "\u60A8\u7684\u9000\u8D27\u5355\u5DF2\u51C6\u5907\u597D\u3002\u60A8\u73B0\u5728\u53EF\u4EE5\u6253\u5370\u5E76\u7528\u4E8E\u9000\u8D27\u3002",
    downloadBonDeRetourCTA: "\u4E0B\u8F7D\u6211\u7684\u9000\u8D27\u5355"
  },
  depositReminder: {
    preview: "\u8BF7\u52FF\u5FD8\u8BB0\u6295\u9012\u60A8\u7684\u9000\u8D27\u5305\u88F9",
    heading: "\u8BF7\u52FF\u5FD8\u8BB0\u6295\u9012\u60A8\u7684\u9000\u8D27\u5305\u88F9",
    description: "\u60A8\u5DF2\u751F\u6210\u9000\u8D27\u6807\u7B7E\uFF0C\u4F46\u6211\u4EEC\u5C1A\u672A\u6536\u5230\u60A8\u7684\u5305\u88F9\u3002\u8BF7\u5C3D\u5FEB\u6295\u9012\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u5904\u7406\u60A8\u7684\u8BF7\u6C42\u3002",
    downloadLabelCTA: "\u4E0B\u8F7D\u6211\u7684\u6807\u7B7E",
    trackCTA: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
    descriptionBonDeRetour: "\u60A8\u5DF2\u751F\u6210\u9000\u8D27\u5355\uFF0C\u4F46\u6211\u4EEC\u5C1A\u672A\u6536\u5230\u60A8\u7684\u5305\u88F9\u3002\u8BF7\u5C3D\u5FEB\u6295\u9012\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u5904\u7406\u60A8\u7684\u8BF7\u6C42\u3002",
    downloadBonDeRetourCTA: "\u4E0B\u8F7D\u6211\u7684\u9000\u8D27\u5355"
  },
  returnRequestWithoutPhysicalReturn: {
    preview: "\u60A8\u7684\u7533\u8BF7\u5DF2\u6536\u5230",
    heading: "\u60A8\u7684\u7533\u8BF7\u5DF2\u6536\u5230",
    description: "\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u3002\u5904\u7406\u5B8C\u6BD5\u540E\u4F1A\u901A\u77E5\u60A8\u3002",
    trackCTA: "\u67E5\u770B\u6211\u7684\u7533\u8BF7"
  },
  invite: {
    preview: "\u52A0\u5165Baback",
    heading: "\u52A0\u5165Baback",
    joinTeam: "\u60A8\u5DF2\u88AB\u9080\u8BF7\u52A0\u5165{{shopName}}\u5728Baback\u4E0A\u7684\u516C\u53F8",
    joinCTA: "\u52A0\u5165{{shopName}}",
    noAccount: "\u5982\u679C\u60A8\u6CA1\u6709Baback\u8D26\u6237\uFF0C\u53EF\u4EE5\u70B9\u51FB\u4E0A\u65B9\u6309\u94AE\u521B\u5EFA\u4E00\u4E2A\u3002",
    signature: "\u795D\u60A8\u6109\u5FEB"
  },
  discountCodeCreated: {
    preview: "\u60A8\u5728\u8BA2\u5355{{orderNumber}}\u7684\u8D2D\u7269\u4F59\u989D",
    heading: "\u60A8\u5728\u8BA2\u5355{{orderNumber}}\u7684\u8D2D\u7269\u4F59\u989D",
    giftMessageValidUntil: "\u5728\u5904\u7406\u5B8C\u8BA2\u5355{{orderNumber}}\u7684\u9000\u8D27\u540E\uFF0C\u4EE5\u4E0B\u662F\u60A8\u83B7\u5F97\u7684{{amount}}\u20AC\u4F59\u989D\uFF0C\u6709\u6548\u671F\u81F3{{validUntil}}\u3002",
    giftMessageNoValidity: "\u5728\u5904\u7406\u5B8C\u8BA2\u5355{{orderNumber}}\u7684\u9000\u8D27\u540E\uFF0C\u4EE5\u4E0B\u662F\u60A8\u83B7\u5F97\u7684{{amount}}\u20AC\u4F59\u989D\u3002",
    giftSecondaryMessage: "\u60A8\u53EF\u4EE5\u5728\u6574\u4E2A\u5546\u5E97\u4F7F\u7528\u8BE5\u4F59\u989D\u3002",
    ending: "\u795D\u60A8\u6109\u5FEB"
  },
  storeCreditCreated: {
    heading: "\u60A8\u5728\u8BA2\u5355{{orderName}}\u7684\u5546\u5E97\u4F59\u989D",
    preview: "{{shopName}} - \u60A8\u5728\u8BA2\u5355{{orderName}}\u7684\u5546\u5E97\u4F59\u989D",
    giftMessage: "\u7531\u4E8E\u60A8\u5728\u8BA2\u5355{{orderName}}\u7684\u9000\u8D27\uFF0C{{amount}}{{currency}}\u7684\u5546\u5E97\u4F59\u989D\u5DF2\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u4E2D\u3002",
    giftMessageValidUntil: "\u7531\u4E8E\u60A8\u5728\u8BA2\u5355{{orderName}}\u7684\u9000\u8D27\uFF0C{{amount}}{{currency}}\u7684\u5546\u5E97\u4F59\u989D\u5DF2\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u4E2D\uFF0C\u6709\u6548\u671F\u81F3{{validUntil}}\u3002",
    giftSecondaryMessage: "\u7ED3\u8D26\u65F6\u5C06\u81EA\u52A8\u5E94\u7528\u3002",
    ending: "\u795D\u60A8\u6109\u5FEB"
  },
  returnRequestAccepted: {
    previewMessage: "\u60A8\u7684\u9000\u8D27\u7533\u8BF7",
    headingMessage: "\u60A8\u7684\u9000\u8D27\u7533\u8BF7",
    confirmationMessage: "\u6211\u4EEC\u5DF2\u5904\u7406\u60A8\u7684\u9000\u8D27\u3002\u5982\u679C\u60A8\u7533\u8BF7\u4E86\u9000\u6B3E\uFF0C\u6B3E\u9879\u5C06\u57282\u81F35\u5929\u5185\u663E\u793A\u5728\u60A8\u4E0B\u5355\u65F6\u4F7F\u7528\u7684\u94F6\u884C\u8D26\u6237\u4E2D\u3002",
    trackingCTAMessage: "\u67E5\u770B\u6211\u7684\u9000\u8D27\u7533\u8BF7",
    endingMessage: "\u5982\u6709\u4EFB\u4F55\u95EE\u9898\uFF0C\u8BF7\u968F\u65F6\u8054\u7CFB\u6211\u4EEC\u7684\u5BA2\u670D\u3002"
  },
  returnRequestRejected: {
    preview: "\u60A8\u7684\u9000\u8D27\u7533\u8BF7",
    heading: "\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u5DF2\u88AB\u62D2\u7EDD",
    description: "\u6211\u4EEC\u5DF2\u5904\u7406\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u3002\u5F88\u9057\u61BE\uFF0C\u4EE5\u4E0B\u5546\u54C1\u65E0\u6CD5\u88AB\u63A5\u53D7\u3002",
    rejectedItemsTitle: "\u88AB\u62D2\u7EDD\u7684\u5546\u54C1",
    trackCTA: "\u67E5\u770B\u6211\u7684\u7533\u8BF7"
  },
  exportSuccess: {
    subject: "\u5DF2\u5BFC\u51FA\u7684\u9000\u8D27\u7533\u8BF7",
    text: "\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u5BFC\u51FA\u5DF2\u6210\u529F\u751F\u6210\uFF0C\u5E76\u4F5C\u4E3A\u9644\u4EF6\u63D0\u4F9B\u3002"
  },
  exportFailure: {
    subject: "\u9000\u8D27\u7533\u8BF7\u5BFC\u51FA\u5931\u8D25",
    text: "\u5728\u5904\u7406\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u5BFC\u51FA\u65F6\u9047\u5230\u9519\u8BEF\u3002\u8BF7\u8054\u7CFBBaback\u652F\u6301\u3002"
  },
  lineItems: {
    summary: {
      title: "\u60A8\u7684\u9000\u8D27\u8BE6\u60C5"
    },
    sections: {
      refund: {
        title: "\u9000\u6B3E"
      },
      exchange: {
        title: "\u6362\u8D27"
      },
      discount: {
        title: "\u4F59\u989D\u62B5\u6263"
      },
      exchangeCredit: {
        title: "\u65B0\u8BA2\u5355"
      }
    }
  },
  tracking: {
    shared: {
      endDepositDate: "\u5305\u88F9\u53EF\u7528\u81F3\uFF1A",
      estimatedDeliveryDate: "\u9884\u8BA1\u9001\u8FBE\u65E5\u671F\uFF1A",
      estimatedDeliveryDateWindow: "{{day}}\uFF0C{{minimum}}\u81F3{{maximum}}\u4E4B\u95F4\u3002",
      estimatedDeliveryDatesWindow: "{{minimum}}\u81F3{{maximum}}\u4E4B\u95F4\u3002",
      between: "\u4ECB\u4E8E",
      and: "\u548C",
      from: "\u4ECE",
      to: "\u81F3"
    },
    preTransit: {
      preview: "\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u8BA2\u5355",
      email: {
        title: "\u60A8\u7684\u8BA2\u5355\u6B63\u5728\u5904\u7406\u4E2D",
        description: "\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u8BA2\u5355\uFF0C\u6B63\u5728\u51C6\u5907\u53D1\u8D27\u3002\u4E00\u65E6\u8BA2\u5355\u53D1\u51FA\uFF0C\u60A8\u5C06\u6536\u5230\u53D1\u8D27\u786E\u8BA4\u90AE\u4EF6\u3002",
        cta: "\u8FFD\u8E2A\u6211\u7684\u8BA2\u5355",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    },
    inTransit: {
      preview: "\u60A8\u7684\u8BA2\u5355\u6B63\u5728\u8FD0\u9001\u4E2D",
      email: {
        title: "\u60A8\u7684\u8BA2\u5355\u6B63\u5728\u8FD0\u9001\u4E2D",
        description: "\u60A8\u7684\u8BA2\u5355\u5DF2\u53D1\u8D27\uFF0C\u6B63\u5728\u8FD0\u9001\u9014\u4E2D\u3002\u60A8\u53EF\u4EE5\u5B9E\u65F6\u8FFD\u8E2A\u8FD0\u8F93\u8FDB\u5EA6\u3002",
        cta: "\u8FFD\u8E2A\u6211\u7684\u8BA2\u5355",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    },
    availableForPickup: {
      preview: "\u60A8\u7684\u5305\u88F9\u53EF\u4F9B\u53D6\u4EF6",
      email: {
        title: "\u60A8\u7684\u5305\u88F9\u53EF\u4F9B\u53D6\u4EF6",
        description: "\u60A8\u7684\u5305\u88F9\u5DF2\u5230\u8FBE\u53D6\u4EF6\u70B9\uFF0C\u73B0\u5728\u53EF\u4EE5\u9886\u53D6\u3002",
        cta: "\u9886\u53D6\u6211\u7684\u5305\u88F9",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    },
    deliveredToNeighbour: {
      preview: "\u60A8\u7684\u5305\u88F9\u5DF2\u9001\u8FBE\u90BB\u5C45",
      email: {
        title: "\u60A8\u7684\u5305\u88F9\u5DF2\u9001\u8FBE\u90BB\u5C45",
        description: "\u60A8\u4E0D\u5728\u65F6\uFF0C\u60A8\u7684\u5305\u88F9\u5DF2\u9001\u8FBE\u90BB\u5C45\u3002",
        cta: "\u67E5\u770B\u914D\u9001\u8BE6\u60C5",
        ifNotDelivered: "\u5982\u679C\u60A8\u5C1A\u672A\u6536\u5230\u5305\u88F9\uFF0C\u8BF7\u8054\u7CFB\u6211\u4EEC\u7684",
        ifNotDeliveredLink: "\u5BA2\u670D",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    },
    waitingAtPickupPointSevere: {
      preview: "\u60A8\u7684\u5305\u88F9\u6B63\u7B49\u5F85\u9886\u53D6\uFF08\u63D0\u9192\uFF09",
      email: {
        title: "\u60A8\u7684\u5305\u88F9\u6B63\u7B49\u5F85\u9886\u53D6",
        description: "\u60A8\u7684\u5305\u88F9\u4ECD\u5728\u53D6\u4EF6\u70B9\uFF0C\u8BF7\u5C3D\u5FEB\u9886\u53D6\u3002",
        cta: "\u9886\u53D6\u6211\u7684\u5305\u88F9",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    },
    waitingInformationFromAddress: {
      preview: "\u914D\u9001\u9700\u8981\u8865\u5145\u4FE1\u606F",
      email: {
        title: "\u914D\u9001\u9700\u8981\u8865\u5145\u4FE1\u606F",
        description: "\u6211\u4EEC\u9700\u8981\u60A8\u7684\u914D\u9001\u5730\u5740\u7684\u8865\u5145\u4FE1\u606F\u4EE5\u5B8C\u6210\u8BA2\u5355\u3002\u8BF7\u5C3D\u5FEB\u66F4\u65B0\u60A8\u7684\u4FE1\u606F\u3002",
        cta: "\u66F4\u65B0\u6211\u7684\u4FE1\u606F",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    },
    delivered: {
      preview: "\u60A8\u7684\u5305\u88F9\u5DF2\u9001\u8FBE",
      email: {
        title: "\u60A8\u7684\u5305\u88F9\u5DF2\u9001\u8FBE",
        description: "\u60A8\u7684\u5305\u88F9\u5DF2\u9001\u8FBE\u81F3\u6307\u5B9A\u5730\u5740\u3002"
      }
    },
    returnedToSender: {
      preview: "\u60A8\u7684\u5305\u88F9\u5DF2\u9000\u56DE\u5BC4\u4EF6\u4EBA",
      email: {
        title: "\u60A8\u7684\u5305\u88F9\u5DF2\u9000\u56DE\u5BC4\u4EF6\u4EBA",
        description: "\u60A8\u7684\u5305\u88F9\u672A\u80FD\u9001\u8FBE\u5E76\u5DF2\u9000\u56DE\u5BC4\u4EF6\u4EBA\u3002",
        cta: "\u8054\u7CFB\u5BA2\u670D",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    },
    exception: {
      preview: "\u60A8\u7684\u5305\u88F9\u5728\u914D\u9001\u8FC7\u7A0B\u4E2D\u9047\u5230\u95EE\u9898",
      email: {
        title: "\u60A8\u7684\u5305\u88F9\u5728\u914D\u9001\u8FC7\u7A0B\u4E2D\u9047\u5230\u95EE\u9898",
        description: "\u60A8\u7684\u627F\u8FD0\u5546\u62A5\u544A\u4E86\u4EE5\u4E0B\u95EE\u9898\uFF1A",
        cta: "\u8054\u7CFB\u5BA2\u670D",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    },
    orderNotFulfilled: {
      preview: "\u60A8\u7684\u8BA2\u5355\u5C1A\u672A\u5904\u7406",
      email: {
        title: "\u60A8\u7684\u8BA2\u5355\u5C1A\u672A\u5904\u7406",
        description: "\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u8BA2\u5355\uFF0C\u4F46\u5546\u5BB6\u5C1A\u672A\u5904\u7406\u3002\u5904\u7406\u5B8C\u6210\u540E\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8\u3002",
        cta: "\u8FFD\u8E2A\u6211\u7684\u8BA2\u5355",
        deliveryDetails: {
          title: "\u914D\u9001\u8BE6\u60C5",
          packageContent: {
            label: "\u5305\u88F9\u5185\u5BB9"
          }
        }
      }
    }
  },
  returnRequestCreated: {
    preview: "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42",
    heading: "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42",
    description: "\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u60A8\u73B0\u5728\u53EF\u4EE5\u4E0B\u8F7D\u8FD0\u5355\u5E76\u8DDF\u8E2A\u9000\u8D27\u8FDB\u5EA6\u3002",
    findDropPointCTA: "\u67E5\u627E\u6295\u9012\u70B9",
    downloadLabelCTA: "\u4E0B\u8F7D\u6211\u7684\u8FD0\u5355",
    trackCTA: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27"
  },
  returnRequestWithoutApproval: {
    preview: "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42",
    heading: "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42",
    description: "\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u8FDB\u884C\u5BA1\u6838\u3002\u5BA1\u6838\u901A\u8FC7\u540E\uFF0C\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8\u5982\u4F55\u7EE7\u7EED\u9000\u8D27\u6D41\u7A0B\u3002",
    trackCTA: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27"
  },
  returnRequestReturnToStore: {
    preview: "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42",
    heading: "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42",
    description: "\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u60A8\u73B0\u5728\u53EF\u4EE5\u524D\u5F80\u95E8\u5E97\u6295\u9012\u9000\u8D27\u5305\u88F9\u3002",
    trackCTA: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
    mapLabel: "\u67E5\u770B\u5730\u56FE"
  },
  returnRequestWithoutLabel: {
    preview: "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42",
    heading: "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42",
    description: "\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u6211\u4EEC\u5C06\u5F88\u5FEB\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5411\u60A8\u53D1\u9001\u9000\u8D27\u8BF4\u660E\u3002",
    trackCTA: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27"
  },
  deliveryDetails: {
    title: "\u914D\u9001\u8BE6\u60C5"
  },
  packageContent: {
    label: "\u5305\u88F9\u5185\u5BB9"
  },
  deliveryAddress: {
    title: "\u914D\u9001\u5730\u5740",
    titlePickup: "\u53D6\u4EF6\u70B9\u5730\u5740",
    orderDetails: {
      title: "\u8BA2\u5355\u8BE6\u60C5",
      trackingNumber: "\u8FFD\u8E2A\u53F7",
      orderNumber: "\u8BA2\u5355\u53F7",
      orderDate: "\u8BA2\u5355\u65E5\u671F"
    }
  },
  pickupPoint: {
    title: "\u53D6\u4EF6\u70B9",
    closed: "\u5DF2\u5173\u95ED",
    openingHours: "\u8425\u4E1A\u65F6\u95F4",
    website: "\u7F51\u7AD9",
    directions: "\u8DEF\u7EBF",
    days: {
      monday: "\u661F\u671F\u4E00",
      tuesday: "\u661F\u671F\u4E8C",
      wednesday: "\u661F\u671F\u4E09",
      thursday: "\u661F\u671F\u56DB",
      friday: "\u661F\u671F\u4E94",
      saturday: "\u661F\u671F\u516D",
      sunday: "\u661F\u671F\u65E5"
    }
  },
  blockedReturnsDigest: {
    subject: "\u53D7\u963B\u9000\u8D27\u6458\u8981",
    heading: "\u9700\u8981\u60A8\u5173\u6CE8\u7684\u9000\u8D27",
    noAlerts: "\u6B64\u671F\u95F4\u6CA1\u6709\u53D7\u963B\u9000\u8D27",
    normalCount: "\u6B64\u671F\u95F4\u6709{{count}}\u4E2A\u9000\u8D27\u5DF2\u6B63\u5E38\u5904\u7406",
    andMore: "\u4EE5\u53CA{{count}}\u4E2A\u66F4\u591A...",
    viewReturn: "\u67E5\u770B\u9000\u8D27",
    types: {
      label_failed: "\u6807\u7B7E",
      refund_failed: "\u9000\u6B3E",
      treatment_failed: "\u5904\u7406",
      logistics_rejected: "\u7269\u6D41\u62D2\u7EDD",
      exchange_failed: "\u6362\u8D27",
      integration_failed: "\u96C6\u6210",
      stale_return: "\u6EDE\u7559",
      received_not_refunded: "\u672A\u9000\u6B3E",
      out_of_stock: "\u7F3A\u8D27"
    },
    open: "\u6253\u5F00",
    header: {
      type: "\u7C7B\u578B",
      order: "\u8BA2\u5355",
      email: "\u90AE\u7BB1",
      error: "\u9519\u8BEF"
    }
  }
};

// ../translations/emails/ja.json
var ja_default = {
  returnRequestDate: {
    label: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u306F{{date}} {{time}}\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F"
  },
  shippingStatusUpdated: {
    preview: "\u8FD4\u54C1\u5546\u54C1\u304C\u914D\u9001\u4E2D\u3067\u3059",
    heading: "\u8FD4\u54C1\u5546\u54C1\u304C\u914D\u9001\u4E2D\u3067\u3059\uFF01",
    confirmation: "\u8FD4\u54C1\u5546\u54C1\u3092\u3054\u8FD4\u9001\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u914D\u9001\u696D\u8005\u304C\u96C6\u8377\u3044\u305F\u3057\u307E\u3057\u305F\u3002",
    track: "\u4EE5\u4E0B\u306E\u30EA\u30F3\u30AF\u304B\u3089\u8FD4\u54C1\u5546\u54C1\u306E\u914D\u9001\u72B6\u6CC1\u3092\u8FFD\u8DE1\u3067\u304D\u307E\u3059\uFF1A",
    trackCTA: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
    ending: "\u5546\u54C1\u304C\u5C4A\u304D\u6B21\u7B2C\u3001\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\u3002\u7269\u6D41\u30C1\u30FC\u30E0\u304C\u5546\u54C1\u3092\u53D7\u3051\u53D6\u3063\u3066\u304B\u3089\u8FD4\u91D1\u307E\u3067\u306B\u6700\u592714\u65E5\u9593\u304B\u304B\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002"
  },
  shippingLabelCreated: {
    preview: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u3002",
    heading: "\u8FD4\u54C1\u30E9\u30D9\u30EB",
    takeAccount: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u304A\u8FD1\u304F\u306E{{carrier}}\u96C6\u8377\u30DD\u30A4\u30F3\u30C8\u306B\u8FD4\u54C1\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    colissimo: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306EColissimo\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    "chrono-shop2shop": "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306EChronopost\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    "customer-carrier": "\u304A\u597D\u307F\u306E\u914D\u9001\u696D\u8005\u306B\u8FD4\u54C1\u5546\u54C1\u3092\u304A\u6E21\u3057\u304F\u3060\u3055\u3044\u3002",
    "merchant-carrier": "1\u301C3\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u30E1\u30FC\u30EB\u3067\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\u3002",
    returnToStore: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306E\u5E97\u8217\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    malca: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306EMalca\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    tnt: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306ETNT\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    ups: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u5370\u5237\u3057\u3001\u6700\u5BC4\u308A\u306EUPS\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u306B\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    getLabelCTA: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    findRelayPoint: "\u3053\u3061\u3089\u306E\u30EA\u30F3\u30AF\u304B\u3089\u6700\u5BC4\u308A\u306E\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u3092\u898B\u3064\u3051\u3001\u914D\u9001\u696D\u8005\u3067\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3067\u304D\u307E\u3059\u3002",
    findRelayPointCTA: "\u4E2D\u7D99\u30DD\u30A4\u30F3\u30C8\u3092\u63A2\u3059",
    trackCTA: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
    conform: "\u5546\u54C1\u5230\u7740\u5F8C\u3001\u8FD4\u54C1\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u9069\u5207\u306B\u51E6\u7406\u3044\u305F\u3057\u307E\u3059\u3002",
    description: "\u914D\u9001\u30E9\u30D9\u30EB\u306E\u6E96\u5099\u304C\u3067\u304D\u307E\u3057\u305F\u3002\u5370\u5237\u3057\u3066\u8FD4\u54C1\u306B\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002",
    findDropPointCTA: "\u6295\u51FD\u30DD\u30A4\u30F3\u30C8\u3092\u63A2\u3059",
    downloadLabelCTA: "\u30E9\u30D9\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    doNotReply: "\u3053\u306E\u30E1\u30FC\u30EB\u306F\u81EA\u52D5\u9001\u4FE1\u3067\u3059\u3002\u8FD4\u4FE1\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
    contactUs: "\u304A\u554F\u3044\u5408\u308F\u305B\uFF1A",
    previewBonDeRetour: "\u8FD4\u54C1\u4F1D\u7968\u306E\u6E96\u5099\u304C\u3067\u304D\u307E\u3057\u305F",
    headingBonDeRetour: "\u8FD4\u54C1\u4F1D\u7968\u306E\u6E96\u5099\u304C\u3067\u304D\u307E\u3057\u305F",
    descriptionBonDeRetour: "\u8FD4\u54C1\u4F1D\u7968\u306E\u6E96\u5099\u304C\u3067\u304D\u307E\u3057\u305F\u3002\u5370\u5237\u3057\u3066\u8FD4\u54C1\u306B\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002",
    downloadBonDeRetourCTA: "\u8FD4\u54C1\u4F1D\u7968\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"
  },
  depositReminder: {
    preview: "\u8FD4\u54C1\u5546\u54C1\u306E\u6295\u51FD\u3092\u304A\u5FD8\u308C\u306A\u304F",
    heading: "\u8FD4\u54C1\u5546\u54C1\u306E\u6295\u51FD\u3092\u304A\u5FD8\u308C\u306A\u304F",
    description: "\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u751F\u6210\u3055\u308C\u307E\u3057\u305F\u304C\u3001\u307E\u3060\u5546\u54C1\u304C\u5C4A\u3044\u3066\u304A\u308A\u307E\u305B\u3093\u3002\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u51E6\u7406\u3059\u308B\u305F\u3081\u3001\u304A\u65E9\u3081\u306B\u6295\u51FD\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    downloadLabelCTA: "\u30E9\u30D9\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    trackCTA: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
    descriptionBonDeRetour: "\u8FD4\u54C1\u4F1D\u7968\u3092\u751F\u6210\u3055\u308C\u307E\u3057\u305F\u304C\u3001\u307E\u3060\u5546\u54C1\u304C\u5C4A\u3044\u3066\u304A\u308A\u307E\u305B\u3093\u3002\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u51E6\u7406\u3059\u308B\u305F\u3081\u3001\u304A\u65E9\u3081\u306B\u6295\u51FD\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    downloadBonDeRetourCTA: "\u8FD4\u54C1\u4F1D\u7968\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"
  },
  returnRequestWithoutPhysicalReturn: {
    preview: "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F",
    heading: "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F",
    description: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u51E6\u7406\u304C\u5B8C\u4E86\u6B21\u7B2C\u3054\u9023\u7D61\u3044\u305F\u3057\u307E\u3059\u3002",
    trackCTA: "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u78BA\u8A8D\u3059\u308B"
  },
  invite: {
    preview: "Baback\u306B\u53C2\u52A0",
    heading: "Baback\u306B\u53C2\u52A0",
    joinTeam: "Baback\u3067{{shopName}}\u3078\u306E\u53C2\u52A0\u304C\u62DB\u5F85\u3055\u308C\u307E\u3057\u305F",
    joinCTA: "{{shopName}}\u306B\u53C2\u52A0\u3059\u308B",
    noAccount: "Baback\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u5834\u5408\u306F\u3001\u4E0A\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002",
    signature: "\u826F\u3044\u4E00\u65E5\u3092\u304A\u904E\u3054\u3057\u304F\u3060\u3055\u3044"
  },
  discountCodeCreated: {
    preview: "\u6CE8\u6587{{orderNumber}}\u306E\u30AF\u30EC\u30B8\u30C3\u30C8",
    heading: "\u6CE8\u6587{{orderNumber}}\u306E\u30AF\u30EC\u30B8\u30C3\u30C8",
    giftMessageValidUntil: "\u6CE8\u6587{{orderNumber}}\u306E\u8FD4\u54C1\u51E6\u7406\u306B\u4F34\u3044\u3001{{amount}}\u20AC\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u3092\u304A\u9001\u308A\u3057\u307E\u3059\u3002\u6709\u52B9\u671F\u9650\uFF1A{{validUntil}}\u3002",
    giftMessageNoValidity: "\u6CE8\u6587{{orderNumber}}\u306E\u8FD4\u54C1\u51E6\u7406\u306B\u4F34\u3044\u3001{{amount}}\u20AC\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u3092\u304A\u9001\u308A\u3057\u307E\u3059\u3002",
    giftSecondaryMessage: "\u30B9\u30C8\u30A2\u5168\u4F53\u3067\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002",
    ending: "\u826F\u3044\u4E00\u65E5\u3092\u304A\u904E\u3054\u3057\u304F\u3060\u3055\u3044"
  },
  storeCreditCreated: {
    heading: "\u6CE8\u6587{{orderName}}\u306E\u30B9\u30C8\u30A2\u30AF\u30EC\u30B8\u30C3\u30C8",
    preview: "{{shopName}} - \u6CE8\u6587{{orderName}}\u306E\u30B9\u30C8\u30A2\u30AF\u30EC\u30B8\u30C3\u30C8",
    giftMessage: "\u6CE8\u6587{{orderName}}\u306E\u8FD4\u54C1\u306B\u4F34\u3044\u3001{{amount}}{{currency}}\u306E\u30B9\u30C8\u30A2\u30AF\u30EC\u30B8\u30C3\u30C8\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002",
    giftMessageValidUntil: "\u6CE8\u6587{{orderName}}\u306E\u8FD4\u54C1\u306B\u4F34\u3044\u3001{{amount}}{{currency}}\u306E\u30B9\u30C8\u30A2\u30AF\u30EC\u30B8\u30C3\u30C8\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002\u6709\u52B9\u671F\u9650\uFF1A{{validUntil}}\u3002",
    giftSecondaryMessage: "\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u6642\u306B\u81EA\u52D5\u7684\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002",
    ending: "\u826F\u3044\u4E00\u65E5\u3092\u304A\u904E\u3054\u3057\u304F\u3060\u3055\u3044"
  },
  returnRequestAccepted: {
    previewMessage: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    headingMessage: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    confirmationMessage: "\u8FD4\u54C1\u51E6\u7406\u304C\u5B8C\u4E86\u3044\u305F\u3057\u307E\u3057\u305F\u3002\u8FD4\u91D1\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3055\u308C\u305F\u5834\u5408\u30012\u301C5\u65E5\u4EE5\u5185\u306B\u3054\u6CE8\u6587\u6642\u306B\u3054\u5229\u7528\u306E\u9280\u884C\u53E3\u5EA7\u306B\u53CD\u6620\u3055\u308C\u307E\u3059\u3002",
    trackingCTAMessage: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u78BA\u8A8D\u3059\u308B",
    endingMessage: "\u3054\u4E0D\u660E\u306A\u70B9\u304C\u3054\u3056\u3044\u307E\u3057\u305F\u3089\u3001\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30FC\u30D3\u30B9\u307E\u3067\u304A\u6C17\u8EFD\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"
  },
  returnRequestRejected: {
    preview: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    heading: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5374\u4E0B\u3055\u308C\u307E\u3057\u305F",
    description: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u51E6\u7406\u3044\u305F\u3057\u307E\u3057\u305F\u3002\u6B8B\u5FF5\u306A\u304C\u3089\u3001\u4EE5\u4E0B\u306E\u5546\u54C1\u306F\u304A\u53D7\u3051\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    rejectedItemsTitle: "\u5374\u4E0B\u3055\u308C\u305F\u5546\u54C1",
    trackCTA: "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u78BA\u8A8D\u3059\u308B"
  },
  exportSuccess: {
    subject: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
    text: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u304C\u6B63\u5E38\u306B\u751F\u6210\u3055\u308C\u3001\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u3068\u3057\u3066\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002"
  },
  exportFailure: {
    subject: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u5931\u6557",
    text: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u51E6\u7406\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002Baback\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"
  },
  lineItems: {
    summary: {
      title: "\u8FD4\u54C1\u306E\u8A73\u7D30"
    },
    sections: {
      refund: {
        title: "\u8FD4\u91D1"
      },
      exchange: {
        title: "\u4EA4\u63DB"
      },
      discount: {
        title: "\u30AF\u30EC\u30B8\u30C3\u30C8"
      },
      exchangeCredit: {
        title: "\u65B0\u898F\u6CE8\u6587"
      }
    }
  },
  tracking: {
    shared: {
      endDepositDate: "\u8377\u7269\u306E\u53D7\u53D6\u671F\u9650\uFF1A",
      estimatedDeliveryDate: "\u914D\u9054\u4E88\u5B9A\u65E5\uFF1A",
      estimatedDeliveryDateWindow: "{{day}}\u3001{{minimum}}\u304B\u3089{{maximum}}\u306E\u9593\u3002",
      estimatedDeliveryDatesWindow: "{{minimum}}\u304B\u3089{{maximum}}\u306E\u9593\u3002",
      between: "\u9593",
      and: "\u3068",
      from: "\u304B\u3089",
      to: "\u307E\u3067"
    },
    preTransit: {
      preview: "\u3054\u6CE8\u6587\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F",
      email: {
        title: "\u3054\u6CE8\u6587\u306F\u51E6\u7406\u4E2D\u3067\u3059",
        description: "\u3054\u6CE8\u6587\u3092\u53D7\u3051\u4ED8\u3051\u3001\u767A\u9001\u6E96\u5099\u3092\u9032\u3081\u3066\u304A\u308A\u307E\u3059\u3002\u767A\u9001\u5B8C\u4E86\u6B21\u7B2C\u3001\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\u3002",
        cta: "\u6CE8\u6587\u3092\u8FFD\u8DE1\u3059\u308B",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    },
    inTransit: {
      preview: "\u3054\u6CE8\u6587\u306F\u914D\u9001\u4E2D\u3067\u3059",
      email: {
        title: "\u3054\u6CE8\u6587\u306F\u914D\u9001\u4E2D\u3067\u3059",
        description: "\u3054\u6CE8\u6587\u306F\u767A\u9001\u6E08\u307F\u3067\u914D\u9001\u4E2D\u3067\u3059\u3002\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u914D\u9001\u72B6\u6CC1\u3092\u8FFD\u8DE1\u3067\u304D\u307E\u3059\u3002",
        cta: "\u6CE8\u6587\u3092\u8FFD\u8DE1\u3059\u308B",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    },
    availableForPickup: {
      preview: "\u8377\u7269\u306E\u53D7\u3051\u53D6\u308A\u304C\u53EF\u80FD\u3067\u3059",
      email: {
        title: "\u8377\u7269\u306E\u53D7\u3051\u53D6\u308A\u304C\u53EF\u80FD\u3067\u3059",
        description: "\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u5C4A\u304D\u307E\u3057\u305F\u3002\u304A\u53D7\u3051\u53D6\u308A\u3044\u305F\u3060\u3051\u307E\u3059\u3002",
        cta: "\u8377\u7269\u3092\u53D7\u3051\u53D6\u308B",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    },
    deliveredToNeighbour: {
      preview: "\u8377\u7269\u304C\u304A\u96A3\u306B\u5C4A\u3051\u3089\u308C\u307E\u3057\u305F",
      email: {
        title: "\u8377\u7269\u304C\u304A\u96A3\u306B\u5C4A\u3051\u3089\u308C\u307E\u3057\u305F",
        description: "\u3054\u4E0D\u5728\u306E\u305F\u3081\u3001\u8377\u7269\u304C\u304A\u96A3\u306B\u5C4A\u3051\u3089\u308C\u307E\u3057\u305F\u3002",
        cta: "\u914D\u9001\u306E\u8A73\u7D30\u3092\u898B\u308B",
        ifNotDelivered: "\u8377\u7269\u3092\u53D7\u3051\u53D6\u3063\u3066\u3044\u306A\u3044\u5834\u5408\u306F\u3001",
        ifNotDeliveredLink: "\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30FC\u30D3\u30B9",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    },
    waitingAtPickupPointSevere: {
      preview: "\u8377\u7269\u306E\u53D7\u3051\u53D6\u308A\u3092\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059\uFF08\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\uFF09",
      email: {
        title: "\u8377\u7269\u306E\u53D7\u3051\u53D6\u308A\u3092\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059",
        description: "\u8377\u7269\u306F\u307E\u3060\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u3054\u3056\u3044\u307E\u3059\u3002\u304A\u65E9\u3081\u306B\u304A\u53D7\u3051\u53D6\u308A\u304F\u3060\u3055\u3044\u3002",
        cta: "\u8377\u7269\u3092\u53D7\u3051\u53D6\u308B",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    },
    waitingInformationFromAddress: {
      preview: "\u914D\u9001\u306B\u95A2\u3059\u308B\u60C5\u5831\u304C\u5FC5\u8981\u3067\u3059",
      email: {
        title: "\u914D\u9001\u306B\u95A2\u3059\u308B\u60C5\u5831\u304C\u5FC5\u8981\u3067\u3059",
        description: "\u3054\u6CE8\u6587\u306E\u914D\u9001\u3092\u5B8C\u4E86\u3059\u308B\u305F\u3081\u306B\u3001\u914D\u9001\u5148\u4F4F\u6240\u306E\u8FFD\u52A0\u60C5\u5831\u304C\u5FC5\u8981\u3067\u3059\u3002\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u60C5\u5831\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        cta: "\u60C5\u5831\u3092\u66F4\u65B0\u3059\u308B",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    },
    delivered: {
      preview: "\u8377\u7269\u304C\u5C4A\u304D\u307E\u3057\u305F",
      email: {
        title: "\u8377\u7269\u304C\u5C4A\u304D\u307E\u3057\u305F",
        description: "\u8377\u7269\u304C\u6307\u5B9A\u306E\u4F4F\u6240\u306B\u5C4A\u3051\u3089\u308C\u307E\u3057\u305F\u3002"
      }
    },
    returnedToSender: {
      preview: "\u8377\u7269\u304C\u5DEE\u51FA\u4EBA\u306B\u8FD4\u9001\u3055\u308C\u307E\u3057\u305F",
      email: {
        title: "\u8377\u7269\u304C\u5DEE\u51FA\u4EBA\u306B\u8FD4\u9001\u3055\u308C\u307E\u3057\u305F",
        description: "\u8377\u7269\u3092\u304A\u5C4A\u3051\u3067\u304D\u306A\u304B\u3063\u305F\u305F\u3081\u3001\u5DEE\u51FA\u4EBA\u306B\u8FD4\u9001\u3055\u308C\u307E\u3057\u305F\u3002",
        cta: "\u30B5\u30DD\u30FC\u30C8\u306B\u9023\u7D61\u3059\u308B",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    },
    exception: {
      preview: "\u8377\u7269\u306E\u914D\u9001\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
      email: {
        title: "\u8377\u7269\u306E\u914D\u9001\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
        description: "\u914D\u9001\u696D\u8005\u304B\u3089\u4EE5\u4E0B\u306E\u554F\u984C\u304C\u5831\u544A\u3055\u308C\u307E\u3057\u305F\uFF1A",
        cta: "\u30B5\u30DD\u30FC\u30C8\u306B\u9023\u7D61\u3059\u308B",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    },
    orderNotFulfilled: {
      preview: "\u3054\u6CE8\u6587\u306F\u307E\u3060\u51E6\u7406\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
      email: {
        title: "\u3054\u6CE8\u6587\u306F\u307E\u3060\u51E6\u7406\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
        description: "\u3054\u6CE8\u6587\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u304C\u3001\u8CA9\u58F2\u8005\u306B\u3088\u308B\u51E6\u7406\u304C\u307E\u3060\u5B8C\u4E86\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u51E6\u7406\u5B8C\u4E86\u6B21\u7B2C\u3054\u9023\u7D61\u3044\u305F\u3057\u307E\u3059\u3002",
        cta: "\u6CE8\u6587\u3092\u8FFD\u8DE1\u3059\u308B",
        deliveryDetails: {
          title: "\u914D\u9001\u306E\u8A73\u7D30",
          packageContent: {
            label: "\u8377\u7269\u306E\u5185\u5BB9"
          }
        }
      }
    }
  },
  returnRequestCreated: {
    preview: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    heading: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    description: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u914D\u9001\u30E9\u30D9\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3001\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3067\u304D\u307E\u3059\u3002",
    findDropPointCTA: "\u6295\u51FD\u30DD\u30A4\u30F3\u30C8\u3092\u63A2\u3059",
    downloadLabelCTA: "\u30E9\u30D9\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    trackCTA: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B"
  },
  returnRequestWithoutApproval: {
    preview: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    heading: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    description: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u78BA\u8A8D\u3044\u305F\u3057\u307E\u3059\u3002\u627F\u8A8D\u5F8C\u3001\u8FD4\u54C1\u306E\u624B\u7D9A\u304D\u65B9\u6CD5\u3092\u3054\u9023\u7D61\u3044\u305F\u3057\u307E\u3059\u3002",
    trackCTA: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B"
  },
  returnRequestReturnToStore: {
    preview: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    heading: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    description: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u5E97\u8217\u306B\u8FD4\u54C1\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002",
    trackCTA: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
    mapLabel: "\u5730\u56F3\u3092\u898B\u308B"
  },
  returnRequestWithoutLabel: {
    preview: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    heading: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
    description: "\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u8FD4\u54C1\u65B9\u6CD5\u306E\u3054\u6848\u5185\u3092\u307E\u3082\u306A\u304F\u30E1\u30FC\u30EB\u3067\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\u3002",
    trackCTA: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B"
  },
  deliveryDetails: {
    title: "\u914D\u9001\u306E\u8A73\u7D30"
  },
  packageContent: {
    label: "\u8377\u7269\u306E\u5185\u5BB9"
  },
  deliveryAddress: {
    title: "\u914D\u9001\u5148\u4F4F\u6240",
    titlePickup: "\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306E\u4F4F\u6240",
    orderDetails: {
      title: "\u6CE8\u6587\u306E\u8A73\u7D30",
      trackingNumber: "\u8FFD\u8DE1\u756A\u53F7",
      orderNumber: "\u6CE8\u6587\u756A\u53F7",
      orderDate: "\u6CE8\u6587\u65E5"
    }
  },
  pickupPoint: {
    title: "\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8",
    closed: "\u9589\u5E97",
    openingHours: "\u55B6\u696D\u6642\u9593",
    website: "\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8",
    directions: "\u9053\u9806",
    days: {
      monday: "\u6708\u66DC\u65E5",
      tuesday: "\u706B\u66DC\u65E5",
      wednesday: "\u6C34\u66DC\u65E5",
      thursday: "\u6728\u66DC\u65E5",
      friday: "\u91D1\u66DC\u65E5",
      saturday: "\u571F\u66DC\u65E5",
      sunday: "\u65E5\u66DC\u65E5"
    }
  },
  blockedReturnsDigest: {
    subject: "\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u305F\u8FD4\u54C1\u306E\u6982\u8981",
    heading: "\u5BFE\u5FDC\u304C\u5FC5\u8981\u306A\u8FD4\u54C1",
    noAlerts: "\u3053\u306E\u671F\u9593\u306B\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u305F\u8FD4\u54C1\u306F\u3042\u308A\u307E\u305B\u3093",
    normalCount: "\u3053\u306E\u671F\u9593\u306B{{count}}\u4EF6\u306E\u8FD4\u54C1\u304C\u6B63\u5E38\u306B\u51E6\u7406\u3055\u308C\u307E\u3057\u305F",
    andMore: "\u4ED6{{count}}\u4EF6...",
    viewReturn: "\u8FD4\u54C1\u3092\u78BA\u8A8D\u3059\u308B",
    types: {
      label_failed: "\u30E9\u30D9\u30EB",
      refund_failed: "\u8FD4\u91D1",
      treatment_failed: "\u51E6\u7406",
      logistics_rejected: "\u7269\u6D41\u62D2\u5426",
      exchange_failed: "\u4EA4\u63DB",
      integration_failed: "\u9023\u643A",
      stale_return: "\u505C\u6EDE",
      received_not_refunded: "\u672A\u8FD4\u91D1",
      out_of_stock: "\u5728\u5EAB\u5207\u308C"
    },
    open: "\u958B\u304F",
    header: {
      type: "\u7A2E\u985E",
      order: "\u6CE8\u6587",
      email: "\u30E1\u30FC\u30EB",
      error: "\u30A8\u30E9\u30FC"
    }
  }
};

// ../translations/src/init-emails.ts
async function createEmailsTranslationInstance(locale = "fr") {
  const instance = i18next.createInstance();
  await instance.use(initReactI18next).init({
    debug: false,
    fallbackLng: "en",
    lng: locale,
    interpolation: { escapeValue: false },
    resources: {
      fr: { translation: fr_default },
      en: { translation: en_default },
      de: { translation: de_default },
      es: { translation: es_default },
      it: { translation: it_default },
      zh: { translation: zh_default },
      ja: { translation: ja_default }
    }
  });
  return instance;
}
var localeInstances = /* @__PURE__ */ new Map();
var ensureTranslationsReady = async (locale = "fr") => {
  if (!localeInstances.has(locale)) {
    const instance = await createEmailsTranslationInstance(locale);
    localeInstances.set(locale, instance);
  }
};
var t = (key, locale = "fr", options) => {
  try {
    let instance = localeInstances.get(locale);
    if (!instance) {
      instance = i18next.createInstance();
      instance.use(initReactI18next).init({
        debug: false,
        fallbackLng: "en",
        lng: locale,
        interpolation: { escapeValue: false },
        resources: {
          fr: { translation: fr_default },
          en: { translation: en_default },
          de: { translation: de_default },
          es: { translation: es_default },
          it: { translation: it_default },
          zh: { translation: zh_default },
          ja: { translation: ja_default }
        }
      });
      localeInstances.set(locale, instance);
    }
    return instance.t(key, options);
  } catch (error) {
    console.warn(
      `Translation failed for key "${key}" with locale "${locale}":`,
      error
    );
    return key;
  }
};

// src/lib/utils/images.ts
var DEFAULT_PLACEHOLDER_DATA_URI = "https://placehold.co/1x1/d0d0d0/d0d0d0/png";
async function isImageReachable(url, timeoutMs) {
  if (!/^https?:\/\//i.test(url)) return true;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, { method: "HEAD", signal: controller.signal });
    if (res.ok) return true;
    if (res.status === 405 || res.status === 400) {
      const getRes = await fetch(url, {
        method: "GET",
        headers: { Range: "bytes=0-0" },
        signal: controller.signal
      });
      return getRes.ok;
    }
    return false;
  } catch {
    return false;
  } finally {
    clearTimeout(timeout);
  }
}
async function formatBlocksTemplateImages({
  template,
  parcel,
  shop
}) {
  const placeholder = DEFAULT_PLACEHOLDER_DATA_URI;
  const urls = /* @__PURE__ */ new Set();
  for (const li of parcel.lineItems ?? []) {
    if (li.imageUrl) urls.add(li.imageUrl);
  }
  const urlList = Array.from(urls);
  const checks = await Promise.allSettled(
    urlList.map((u) => isImageReachable(u, 3500))
  );
  const bad = /* @__PURE__ */ new Set();
  checks.forEach((res, i) => {
    const u = urlList[i];
    if (!(res.status === "fulfilled" && res.value)) bad.add(u);
  });
  const newParcel = {
    ...parcel,
    lineItems: (parcel.lineItems ?? []).map((li) => ({
      ...li,
      imageUrl: li.imageUrl && bad.has(li.imageUrl) ? placeholder : li.imageUrl
    }))
  };
  return { template, parcel: newParcel, shop };
}
function generatePreviewFromText(text) {
  try {
    const cleanedText = text.replace(/\s+/g, " ").trim();
    if (!cleanedText || cleanedText.length < 10) {
      return "";
    }
    const maxLength = 150;
    if (cleanedText.length <= maxLength) {
      return cleanedText;
    }
    const truncated = cleanedText.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(" ");
    if (lastSpaceIndex > maxLength * 0.8) {
      return truncated.substring(0, lastSpaceIndex) + "...";
    }
    return truncated + "...";
  } catch (error) {
    return "";
  }
}
async function blocksEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const { template, parcel, shop } = await formatBlocksTemplateImages({
    template: props.data,
    parcel: props.parcel,
    shop: props.shop,
    status: props.status
  });
  const variableContext = {
    trackingUrl: props.trackingUrl,
    reviewUrl: props.reviewUrl,
    parcel: props.parcel,
    shop: props.shop,
    carrierCode: props.parcel.carrierCode,
    status: props.status,
    pickupPoint: props.pickupPoint ?? props.parcel.pickupPoint ?? void 0,
    appleWalletURL: props.appleWalletURL,
    googleWalletURL: props.googleWalletURL,
    links: props.links
  };
  const variablesValues = resolveVariables(variableContext);
  const formatter = createFormatter(variablesValues);
  const defaultLocale = shop.trackingPreferences?.notificationsDefaultLocale || "en";
  const fallbackPreviewString = typeof props.preview === "string" ? props.preview : formatter(props.preview[locale] || props.preview[defaultLocale]);
  const subject = formatter(
    props.subject[locale] || props.subject[defaultLocale]
  );
  const text = await render$1(
    /* @__PURE__ */ jsx(
      BlocksEmailRenderer,
      {
        ...props,
        data: template,
        parcel,
        shop,
        locale,
        preview: "",
        carrier: props.carrier,
        order: props.order,
        defaultLocale,
        pickupPoint: props.pickupPoint ?? props.parcel.pickupPoint ?? void 0
      }
    ),
    { plainText: true }
  );
  const generatedPreview = generatePreviewFromText(text);
  const previewString = generatedPreview || fallbackPreviewString;
  const html = await render$1(
    /* @__PURE__ */ jsx(
      BlocksEmailRenderer,
      {
        ...props,
        data: template,
        parcel,
        shop,
        locale,
        defaultLocale,
        preview: previewString,
        carrier: props.carrier,
        order: props.order,
        pickupPoint: props.pickupPoint ?? props.parcel.pickupPoint ?? void 0
      }
    )
  );
  return { subject, html, text, preview: previewString };
}
var getLocale2 = (locale) => {
  return locale?.split("-")[0]?.toLowerCase() ?? "fr";
};
function BlocksReturnEmailRenderer({
  data,
  shop,
  return: returnData,
  customer,
  preview: preview10,
  locale,
  defaultLocale,
  viewport: viewport2 = "desktop"
}) {
  const currentLocale = getLocale2(locale);
  const resolvedDefaultLocale = getLocale2(
    defaultLocale ?? shop.preferences?.languages?.[0] ?? "en"
  );
  const context = {
    shop,
    return: returnData,
    customer
  };
  const variablesValues = resolveReturnVariables(context);
  const formatter = createReturnFormatter(variablesValues);
  const theme = shop.trackingPreferences?.emailsTheme;
  const backgroundColor = theme?.backgroundColor || "#f0f0f0";
  const cardColor = theme?.cardColor || "#ffffff";
  const cardTextColor = theme?.cardTextColor;
  const tailwindConfig = {
    theme: {
      extend: {
        colors: {
          primary: shop.preferences.customisation["primary-400"] ?? shop.preferences.customisation["primary_400"] ?? "#000000",
          secondary: "#f1f5f9",
          "secondary-foreground": "#323232",
          border: "#e2e8f0",
          background: backgroundColor ?? "#ffffff",
          card: cardColor ?? "#ffffff"
        }
      }
    }
  };
  const renderSection = (section, blocks) => blocks.map(
    (block, index2) => renderBlock2(
      section,
      block,
      currentLocale,
      index2,
      formatter,
      resolvedDefaultLocale,
      shop,
      theme
    )
  );
  const variablesWithValues = Object.values(RETURN_VARIABLE_REGISTRY).map(
    (definition) => ({
      ...definition,
      exampleValue: variablesValues[definition.id] ?? definition.exampleValue
    })
  );
  return /* @__PURE__ */ jsx(VariablesDictionaryProvider, { variablesDefinition: variablesWithValues, children: /* @__PURE__ */ jsx(BlockThemeProvider, { theme: theme ?? null, children: /* @__PURE__ */ jsxs(
    EmailMainContainer,
    {
      viewport: viewport2,
      backgroundColor,
      preview: preview10,
      tailwindConfig,
      isEmailRenderer: true,
      contentMaxWidth: 680,
      children: [
        /* @__PURE__ */ jsx(EmailBlocksWrapper, { isEmailRenderer: true, children: renderSection("before", data.beforeBlocks) }),
        /* @__PURE__ */ jsx(
          EmailCardContainer,
          {
            theme,
            cardColor,
            cardTextColor,
            isEmailRenderer: true,
            contentMaxWidth: 680,
            children: /* @__PURE__ */ jsx(EmailBlocksWrapper, { isEmailRenderer: true, children: renderSection("inside", data.insideBlocks) })
          }
        ),
        /* @__PURE__ */ jsx(EmailBlocksWrapper, { isEmailRenderer: true, children: renderSection("after", data.afterBlocks) })
      ]
    }
  ) }) });
}
function renderBlock2(section, block, currentLocale, index2, formatter, defaultLocale, shop, theme) {
  const Component = getEditorBlockConfig(block.type)?.email?.component;
  if (!Component) return null;
  return /* @__PURE__ */ jsx(
    Component,
    {
      index: index2,
      block,
      shop,
      formatter,
      section,
      locale: currentLocale,
      defaultLocale,
      theme,
      variables: [],
      formAPI: {
        blockPath: "",
        updateField: () => {
        },
        getFieldValue: () => void 0,
        registerImage: () => {
        }
      }
    },
    block.id
  );
}
function generatePreviewFromText2(text) {
  try {
    const cleanedText = text.replace(/\s+/g, " ").trim();
    if (!cleanedText || cleanedText.length < 10) {
      return "";
    }
    const maxLength = 150;
    if (cleanedText.length <= maxLength) {
      return cleanedText;
    }
    const truncated = cleanedText.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(" ");
    if (lastSpaceIndex > maxLength * 0.8) {
      return truncated.substring(0, lastSpaceIndex) + "...";
    }
    return truncated + "...";
  } catch {
    return "";
  }
}
var getLocale3 = (locale) => {
  return locale?.split("-")[0]?.toLowerCase() ?? "fr";
};
async function blocksReturnEmail(props) {
  const locale = getLocale3(props.locale);
  await ensureTranslationsReady(locale);
  const context = {
    shop: props.shop,
    return: props.return,
    customer: props.customer
  };
  const variablesValues = resolveReturnVariables(context);
  const formatter = createReturnFormatter(variablesValues);
  const defaultLocale = props.shop.trackingPreferences?.notificationsDefaultLocale || "en";
  const fallbackPreviewString = typeof props.preview === "string" ? props.preview : formatter(props.preview[locale] || props.preview[defaultLocale]);
  const subject = formatter(
    props.subject[locale] || props.subject[defaultLocale]
  );
  const text = await render$1(
    /* @__PURE__ */ jsx(
      BlocksReturnEmailRenderer,
      {
        data: props.data,
        shop: props.shop,
        return: props.return,
        customer: props.customer,
        locale,
        defaultLocale,
        preview: ""
      }
    ),
    { plainText: true }
  );
  const generatedPreview = generatePreviewFromText2(text);
  const previewString = fallbackPreviewString || generatedPreview;
  const html = await render$1(
    /* @__PURE__ */ jsx(
      BlocksReturnEmailRenderer,
      {
        data: props.data,
        shop: props.shop,
        return: props.return,
        customer: props.customer,
        locale,
        defaultLocale,
        preview: previewString
      }
    )
  );
  return { subject, html, text, preview: previewString };
}

// src/lib/return/index.ts
var return_exports = {};
__export(return_exports, {
  blockedReturnsDigestEmail: () => blockedReturnsDigestEmail,
  defaultReturnEmailTemplates: () => defaultReturnEmailTemplates,
  depositReminderEmail: () => depositReminderEmail,
  getDefaultReturnTemplate: () => getDefaultReturnTemplate,
  returnRequestAcceptedEmail: () => returnRequestAcceptedEmail,
  returnRequestCreateWithoutApprovalEmail: () => returnRequestCreateWithoutApprovalEmail,
  returnRequestCreatedReturnToStoreEmail: () => returnRequestCreatedReturnToStoreEmail,
  returnRequestCreatedWithoutLabelEmail: () => returnRequestCreatedWithoutLabelEmail,
  returnRequestCreatedWithoutPhysicalReturnEmail: () => returnRequestCreatedWithoutPhysicalReturnEmail,
  returnRequestLabelCreatedEmail: () => returnRequestLabelCreatedEmail,
  returnRequestRejectedEmail: () => returnRequestRejectedEmail,
  returnStoreCreditCreatedDefaultTemplate: () => returnStoreCreditCreatedDefaultTemplate
});
function BrandHeader({ shop }) {
  if (!shop.logoId) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Section, { className: "pt-6 px-8 margin-b-8", children: /* @__PURE__ */ jsx(
      Img,
      {
        width: 80,
        className: "mx-auto",
        src: `https://baback-public-logo.s3.eu-west-3.amazonaws.com/${shop.logoId}`,
        alt: "Logo"
      }
    ) }),
    /* @__PURE__ */ jsx(Hr, { className: "my-[16px] border-t-2 border-gray-300" })
  ] });
}
function EmailCard({ children }) {
  return /* @__PURE__ */ jsx(Container, { className: "bg-card pb-8 mb-1 w-[680px] max-w-full mt-16 shadow-md rounded-xl", children });
}
function EmailContainer({
  children,
  preview: preview10
}) {
  return /* @__PURE__ */ jsx(
    Tailwind,
    {
      config: {
        theme: {
          extend: {
            colors: {
              background: "#f0f0f0",
              secondary: "#F3F4F0",
              "secondary-foreground": "#323232",
              primary: "#000",
              "primary-foreground": "#ffffff",
              card: "#ffffff",
              border: "#efefef"
            }
          }
        }
      },
      children: /* @__PURE__ */ jsxs(Html, { children: [
        /* @__PURE__ */ jsx(Preview, { children: preview10 ?? "" }),
        /* @__PURE__ */ jsxs(Body, { className: "bg-background", style: main3, children: [
          /* @__PURE__ */ jsx(Section, { className: "h-8" }),
          children,
          /* @__PURE__ */ jsx(Section, { className: "h-8" })
        ] })
      ] })
    }
  );
}
var main3 = {
  fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif'
};
function LineItem3({
  name,
  imageUrl,
  subtitle,
  quantity
}) {
  return /* @__PURE__ */ jsxs(Row, { className: "p-2", children: [
    /* @__PURE__ */ jsx(Column, { className: "w-[64px]", children: /* @__PURE__ */ jsx(
      Img,
      {
        src: imageUrl,
        width: "64",
        height: "64",
        alt: name,
        className: "rounded-lg object-cover"
      }
    ) }),
    /* @__PURE__ */ jsxs(Column, { className: "pl-2", children: [
      /* @__PURE__ */ jsxs(Text$1, { className: "m-0 p-0 leading-[1.4] font-semibold", children: [
        name,
        " x ",
        quantity
      ] }),
      /* @__PURE__ */ jsx(Text$1, { className: "m-0 p-0 leading-[1.4]", children: subtitle })
    ] })
  ] });
}
function ReturnRequestLineItemsList({
  lineItems,
  currency
}) {
  return /* @__PURE__ */ jsx(Section, { className: "rounded-lg px-4", children: /* @__PURE__ */ jsx(Row, { className: "rounded-lg", style: { border: "1px solid #e6e6e6" }, children: /* @__PURE__ */ jsx(Column, { children: lineItems.map((item, index2) => /* @__PURE__ */ jsxs(React49__default.Fragment, { children: [
    /* @__PURE__ */ jsx(ReturnLineItem, { lineItem: item, currency }),
    index2 < lineItems.length - 1 && /* @__PURE__ */ jsx(Hr, {})
  ] }, index2)) }) }) });
}
function ReturnLineItem({ lineItem, currency }) {
  let subtitle = "";
  switch (lineItem.resolution) {
    case "exchange-credit":
    case "exchange":
      subtitle = getExchangeSubtitle(lineItem);
      break;
    case "refund":
      subtitle = getRefundSubtitle(lineItem, currency);
      break;
    default:
      subtitle = "";
      break;
  }
  return /* @__PURE__ */ jsx(
    LineItem3,
    {
      name: lineItem.title ?? "-",
      imageUrl: lineItem.image ?? "#",
      subtitle,
      quantity: lineItem.quantity
    }
  );
}
function getExchangeSubtitle(lineItem) {
  if (lineItem.resolution === "exchange-credit") {
    return "";
  }
  const original = lineItem.variant.title;
  const newVariant = lineItem.new_variant;
  if (!newVariant) {
    return "";
  }
  const newVariantContent = [
    newVariant.option1,
    newVariant.option2,
    newVariant.option3
  ].filter(Boolean).join(" ");
  return `${original} \u2192 ${newVariantContent}`;
}
function getRefundSubtitle(lineItem, currency) {
  return `${lineItem.paidPrice || lineItem.price} ${currency}`;
}
function SingleButtonSection({ label, href }) {
  return /* @__PURE__ */ jsx(Section, { className: "text-center pt-4 pb-8 mr-1", children: /* @__PURE__ */ jsx(
    Button$1,
    {
      className: "w-full inline px-4 py-2 rounded-md text-sm bg-primary font-semibold text-primary-foreground",
      href,
      children: label
    }
  ) });
}
function TextualSectionContainer({
  children,
  align = "center"
}) {
  return /* @__PURE__ */ jsx(Section, { className: `px-8 pt-2 text-${align}`, children });
}
function TextualSectionTitle(props) {
  return /* @__PURE__ */ jsx(
    Heading$1,
    {
      as: "h3",
      ...props,
      className: "text-lg m-0 mb-4 " + props.className
    }
  );
}
function TextualSectionContent(props) {
  return /* @__PURE__ */ jsx(
    Text$1,
    {
      ...props,
      className: "text-[16px] m-0 mt-1 mb-4 leading-[22px] text-gray-500" + props.className,
      children: props.children
    }
  );
}
function ReturnRequestAcceptedEmail({
  shop,
  orderName,
  lineItems,
  exchangeCreditLineItems,
  customerCurrency,
  cta,
  locale
}) {
  const loc = locale || "fr";
  const refundArticles = lineItems.filter(
    (item) => item.resolution === "refund"
  );
  const exchangeArticles = lineItems.filter(
    (item) => item.resolution && ["exchange", "exchange-credit"].includes(item.resolution)
  );
  const discountArticles = lineItems.filter(
    (item) => item.resolution === "discount"
  );
  return /* @__PURE__ */ jsx(
    EmailContainer,
    {
      preview: t("returnRequestAccepted.previewMessage", loc, {
        orderName
      }),
      children: /* @__PURE__ */ jsxs(EmailCard, { children: [
        /* @__PURE__ */ jsx(BrandHeader, { shop }),
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("returnRequestAccepted.headingMessage", loc) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: t("returnRequestAccepted.confirmationMessage", loc) })
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("returnRequestAccepted.trackingCTAMessage", loc),
            href: cta.href
          }
        ),
        /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
        /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(TextualSectionTitle, { className: "text-lg", children: t("lineItems.summary.title", loc) }) }),
        exchangeArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.exchange.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: exchangeArticles,
              currency: customerCurrency
            }
          )
        ] }),
        refundArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.refund.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: refundArticles,
              currency: customerCurrency
            }
          )
        ] }),
        discountArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.discount.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: discountArticles,
              currency: customerCurrency
            }
          )
        ] }),
        exchangeCreditLineItems.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.exchangeCredit.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: exchangeCreditLineItems,
              currency: customerCurrency
            }
          )
        ] })
      ] })
    }
  );
}
ReturnRequestAcceptedEmail.PreviewProps = {
  shop: {
    name: "Vanessa Wu",
    logoUrl: "https://prod-img-baback-1.s3.eu-west-3.amazonaws.com/09f6cd8a-94ab-4f34-99a3-f7cf8f058594.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA27FKOAILUYLEQDNT%2F20250424%2Feu-west-3%2Fs3%2Faws4_request&X-Amz-Date=20250424T160333Z&X-Amz-Expires=900&X-Amz-Signature=4d0c4b2c848d23e3f1ff92eb00d287f0f2c3348c01bf39a669fda11103dbd1ca&X-Amz-SignedHeaders=host"
  },
  orderName: "#0001",
  customerCurrency: "\u20AC",
  cta: {
    href: "/returns/123"
  },
  lineItems: [
    {
      title: "Baskets \xE9clair Ingrid blanc et noir z\xE9br\xE9 \xE0 scratchs",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/products/BK2445NR_01.jpg?v=1686221236",
      quantity: 1,
      resolution: "exchange",
      variant: {
        title: "L"
      },
      new_variant: {
        option1: "XL"
      }
    }
  ],
  exchangeCreditLineItems: [
    {
      title: "Sac \xE0 main Bethany beige et noir",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/files/MA0132BG-M_01.jpg?v=1738772468",
      quantity: 1
    }
  ]
};
async function returnRequestAcceptedEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(ReturnRequestAcceptedEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(ReturnRequestAcceptedEmail, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
function MultiButtonSection({
  buttons,
  direction = "vertical"
}) {
  if (direction === "vertical") {
    return /* @__PURE__ */ jsx(Section, { className: "text-center pt-4 pb-4", children: /* @__PURE__ */ jsx(
      "table",
      {
        width: "100%",
        border: 0,
        cellPadding: 0,
        cellSpacing: 0,
        role: "presentation",
        children: /* @__PURE__ */ jsx("tbody", { children: buttons.map((button, index2) => /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { align: "center", style: { paddingBottom: "16px" }, children: /* @__PURE__ */ jsx(
          Button$1,
          {
            className: `w-full inline px-4 py-2 rounded-md text-sm ${button.secondary ? "bg-secondary text-secondary-foreground" : "bg-primary text-primary-foreground"} font-semibold `,
            href: button.href,
            children: button.label
          }
        ) }) }, index2)) })
      }
    ) });
  }
  return /* @__PURE__ */ jsx(Section, { className: "text-center pt-4 pb-8", children: /* @__PURE__ */ jsx(
    "table",
    {
      width: "100%",
      border: 0,
      cellPadding: 0,
      cellSpacing: 0,
      role: "presentation",
      children: /* @__PURE__ */ jsx("tbody", { children: /* @__PURE__ */ jsx("tr", { children: buttons.map((button, index2) => /* @__PURE__ */ jsx("td", { align: "center", style: { padding: "0 8px" }, children: /* @__PURE__ */ jsx(
        Button$1,
        {
          className: "inline px-4 py-2 rounded-md text-sm bg-primary font-semibold text-primary-foreground",
          href: button.href,
          children: button.label
        }
      ) }, index2)) }) })
    }
  ) });
}
function ReturnRequestDate({
  requestDate,
  requestTime,
  locale
}) {
  if (!requestDate || !requestTime) return null;
  return /* @__PURE__ */ jsx(TextualSectionContent, { children: t("returnRequestDate.label", locale, {
    date: requestDate,
    time: requestTime
  }) });
}
function DoNotReplyFooter({
  locale,
  contactLink
}) {
  const isMailto = contactLink.startsWith("mailto:");
  const href = isMailto ? contactLink : contactLink;
  const label = isMailto ? contactLink.replace("mailto:", "") : contactLink;
  return /* @__PURE__ */ jsxs(Section, { className: "px-8 pt-2 text-center", children: [
    /* @__PURE__ */ jsxs(Text$1, { className: "text-[13px] m-0 mt-4 leading-[18px] text-gray-500", children: [
      t("shippingLabelCreated.contactUs", locale),
      " ",
      /* @__PURE__ */ jsx(Link, { href, className: "text-gray-500 underline", children: label })
    ] }),
    /* @__PURE__ */ jsx(Text$1, { className: "text-[12px] m-0 mt-1 leading-[16px] text-gray-400 italic", children: t("shippingLabelCreated.doNotReply", locale) })
  ] });
}
function ReturnRequestLabelCreatedEmail({
  shop,
  orderName,
  lineItems,
  exchangeCreditLineItems,
  customerCurrency,
  carrierCode,
  hasLogisticLabel,
  actions,
  requestDate,
  requestTime,
  locale
}) {
  const loc = locale || "fr";
  const upsMessage = t("shippingLabelCreated.ups", loc);
  const descriptionsMap = {
    colissimo: t("shippingLabelCreated.colissimo", loc),
    "chrono-shop2shop": t("shippingLabelCreated.chrono-shop2shop", loc),
    crosslog: t("shippingLabelCreated.chrono-shop2shop", loc),
    "ups-saver": upsMessage,
    "ups-standard": upsMessage,
    "ups-express": upsMessage,
    "fake-dpd": upsMessage,
    "customer-carrier": t("shippingLabelCreated.customer-carrier", loc),
    "merchant-carrier": t("shippingLabelCreated.merchant-carrier", loc),
    "return-to-store": t("shippingLabelCreated.returnToStore", loc),
    malca: t("shippingLabelCreated.malca", loc),
    tnt: t("shippingLabelCreated.tnt", loc)
  };
  const description = hasLogisticLabel ? t("shippingLabelCreated.descriptionBonDeRetour", loc) : carrierCode in descriptionsMap ? descriptionsMap[carrierCode] : t("shippingLabelCreated.customer-carrier", loc);
  const refundArticles = lineItems.filter(
    (item) => item.resolution === "refund"
  );
  const exchangeArticles = lineItems.filter(
    (item) => item.resolution && ["exchange", "exchange-credit"].includes(item.resolution)
  );
  const discountArticles = lineItems.filter(
    (item) => item.resolution === "discount"
  );
  return /* @__PURE__ */ jsx(
    EmailContainer,
    {
      preview: t(
        hasLogisticLabel ? "shippingLabelCreated.previewBonDeRetour" : "shippingLabelCreated.preview",
        loc,
        { orderName }
      ),
      children: /* @__PURE__ */ jsxs(EmailCard, { children: [
        /* @__PURE__ */ jsx(BrandHeader, { shop }),
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t(
            hasLogisticLabel ? "shippingLabelCreated.headingBonDeRetour" : "shippingLabelCreated.heading",
            loc
          ) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: description }),
          /* @__PURE__ */ jsx(
            ReturnRequestDate,
            {
              requestDate,
              requestTime,
              locale: loc
            }
          )
        ] }),
        actions.downloadLabelHref && actions.downloadLabelHref !== "" && /* @__PURE__ */ jsx(
          MultiButtonSection,
          {
            buttons: [
              {
                label: t(
                  hasLogisticLabel ? "shippingLabelCreated.downloadBonDeRetourCTA" : "shippingLabelCreated.downloadLabelCTA",
                  loc
                ),
                href: actions.downloadLabelHref
              },
              ...actions.findDropPointHref ? [
                {
                  label: t("shippingLabelCreated.findDropPointCTA", loc),
                  href: actions.findDropPointHref,
                  secondary: true
                }
              ] : []
            ],
            direction: "vertical"
          }
        ),
        /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
        /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(TextualSectionTitle, { className: "text-lg", children: t("lineItems.summary.title", loc) }) }),
        exchangeArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.exchange.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: exchangeArticles,
              currency: customerCurrency
            }
          )
        ] }),
        exchangeCreditLineItems.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.exchangeCredit.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: exchangeCreditLineItems,
              currency: customerCurrency
            }
          )
        ] }),
        refundArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.refund.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: refundArticles,
              currency: customerCurrency
            }
          )
        ] }),
        discountArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.discount.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: discountArticles,
              currency: customerCurrency
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("shippingLabelCreated.trackCTA", loc),
            href: actions.trackReturnHref
          }
        ),
        /* @__PURE__ */ jsx(
          DoNotReplyFooter,
          {
            locale: loc,
            contactLink: shop.preferences.contactLink
          }
        )
      ] })
    }
  );
}
ReturnRequestLabelCreatedEmail.PreviewProps = {
  shop: {
    name: "Vanessa Wu",
    logoUrl: "https://es.soeur.fr/cdn/shop/files/soeur.svg?v=1705681689&width=180",
    preferences: {
      contactLink: "mailto:contact@vanessawu.com"
    }
  },
  orderName: "#0001",
  customerCurrency: "\u20AC",
  actions: {
    findDropPointHref: "/drop-points/find",
    downloadLabelHref: "/returns/label/download",
    trackReturnHref: "/returns/123"
  },
  carrierCode: "ups-express",
  requestDate: "16 juin 2026",
  requestTime: "14:30",
  lineItems: [
    {
      title: "Baskets \xE9clair Ingrid blanc et noir z\xE9br\xE9 \xE0 scratchs",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/products/BK2445NR_01.jpg?v=1686221236",
      quantity: 1,
      resolution: "exchange-credit",
      variant: {
        title: "L"
      }
    }
  ],
  exchangeCreditLineItems: [
    {
      title: "Sac \xE0 main Bethany beige et noir",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/files/MA0132BG-M_01.jpg?v=1738772468",
      quantity: 1
    }
  ]
};
async function returnRequestLabelCreatedEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(ReturnRequestLabelCreatedEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(ReturnRequestLabelCreatedEmail, { ...props, locale }), { plainText: true })
  ]);
  return {
    html,
    text
  };
}
function ReturnRequestCreatedWithoutApprovalEmail({
  shop,
  orderName,
  lineItems,
  exchangeCreditLineItems,
  customerCurrency,
  trackReturnHref,
  requestDate,
  requestTime,
  locale
}) {
  const loc = locale || "fr";
  const refundArticles = lineItems.filter(
    (item) => item.resolution === "refund"
  );
  const exchangeArticles = lineItems.filter(
    (item) => item.resolution && ["exchange", "exchange-credit"].includes(item.resolution)
  );
  const discountArticles = lineItems.filter(
    (item) => item.resolution === "discount"
  );
  return /* @__PURE__ */ jsx(EmailContainer, { preview: t("returnRequestWithoutApproval.preview", loc, { orderName }), children: /* @__PURE__ */ jsxs(EmailCard, { children: [
    /* @__PURE__ */ jsx(BrandHeader, { shop }),
    /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
      /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("returnRequestWithoutApproval.heading", loc) }),
      /* @__PURE__ */ jsx(TextualSectionContent, { children: t("returnRequestWithoutApproval.description", loc) }),
      /* @__PURE__ */ jsx(
        ReturnRequestDate,
        {
          requestDate,
          requestTime,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
    /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(TextualSectionTitle, { className: "text-lg", children: t("lineItems.summary.title", loc) }) }),
    exchangeArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.exchange.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: exchangeArticles,
          currency: customerCurrency
        }
      )
    ] }),
    exchangeCreditLineItems.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.exchangeCredit.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: exchangeCreditLineItems,
          currency: customerCurrency
        }
      )
    ] }),
    refundArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.refund.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: refundArticles,
          currency: customerCurrency
        }
      )
    ] }),
    discountArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.discount.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: discountArticles,
          currency: customerCurrency
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      SingleButtonSection,
      {
        label: t("returnRequestWithoutApproval.trackCTA", loc),
        href: trackReturnHref
      }
    ),
    /* @__PURE__ */ jsx(
      DoNotReplyFooter,
      {
        locale: loc,
        contactLink: shop.preferences.contactLink
      }
    )
  ] }) });
}
ReturnRequestCreatedWithoutApprovalEmail.PreviewProps = {
  shop: {
    name: "Vanessa Wu",
    logoUrl: "https://es.soeur.fr/cdn/shop/files/soeur.svg?v=1705681689&width=180",
    preferences: {
      contactLink: "mailto:contact@vanessawu.com"
    }
  },
  orderName: "#0001",
  customerCurrency: "\u20AC",
  trackReturnHref: "/returns/123",
  requestDate: "16 juin 2026",
  requestTime: "14:30",
  lineItems: [
    {
      title: "Baskets \xE9clair Ingrid blanc et noir z\xE9br\xE9 \xE0 scratchs",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/products/BK2445NR_01.jpg?v=1686221236",
      quantity: 1,
      resolution: "exchange-credit",
      variant: {
        title: "L"
      }
    }
  ],
  exchangeCreditLineItems: [
    {
      title: "Sac \xE0 main Bethany beige et noir",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/files/MA0132BG-M_01.jpg?v=1738772468",
      quantity: 1
    }
  ]
};
async function returnRequestCreateWithoutApprovalEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(ReturnRequestCreatedWithoutApprovalEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(ReturnRequestCreatedWithoutApprovalEmail, { ...props, locale }), {
      plainText: true
    })
  ]);
  return {
    html,
    text
  };
}
function EmailAddress({
  name,
  address,
  showMapButton = true
}) {
  const mapUrl = `https://www.google.com/maps/place/${encodeURI(address.address1) + " " + address.zip + " " + address.city}`;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        borderRadius: "8px",
        padding: "12px 16px",
        backgroundColor: "#f9fafb",
        display: "inline-block",
        border: "1px solid #e5e7eb",
        minWidth: "220px",
        marginBottom: "8px",
        fontSize: "14px",
        lineHeight: "1.5"
      },
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "4px"
            },
            children: [
              "\u{1F4CD} ",
              name
            ]
          }
        ),
        /* @__PURE__ */ jsx("div", { children: address.address1 }),
        address.address2 && /* @__PURE__ */ jsx("div", { children: address.address2 }),
        /* @__PURE__ */ jsxs("div", { children: [
          address.zip,
          " ",
          address.city
        ] }),
        /* @__PURE__ */ jsx("div", { children: address.country }),
        showMapButton && mapUrl && /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              marginTop: "12px",
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsx(
              Button$1,
              {
                className: "w-full inline px-4 py-2 rounded-md text-sm bg-primary font-semibold text-primary-foreground",
                href: mapUrl,
                children: t("returnRequestReturnToStore.mapLabel")
              }
            )
          }
        )
      ]
    }
  );
}
function ReturnRequestCreatedReturnToStoreEmail({
  shop,
  orderName,
  lineItems,
  exchangeCreditLineItems,
  customerCurrency,
  store,
  trackReturnHref,
  requestDate,
  requestTime,
  locale
}) {
  const loc = locale || "fr";
  const refundArticles = lineItems.filter(
    (item) => item.resolution === "refund"
  );
  const exchangeArticles = lineItems.filter(
    (item) => item.resolution && ["exchange", "exchange-credit"].includes(item.resolution)
  );
  const discountArticles = lineItems.filter(
    (item) => item.resolution === "discount"
  );
  return /* @__PURE__ */ jsx(EmailContainer, { preview: t("returnRequestReturnToStore.preview", loc, { orderName }), children: /* @__PURE__ */ jsxs(EmailCard, { children: [
    /* @__PURE__ */ jsx(BrandHeader, { shop }),
    /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
      /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("returnRequestReturnToStore.heading", loc) }),
      /* @__PURE__ */ jsx(TextualSectionContent, { children: t("returnRequestReturnToStore.description", loc) }),
      /* @__PURE__ */ jsx(
        ReturnRequestDate,
        {
          requestDate,
          requestTime,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(TextualSectionContainer, { children: /* @__PURE__ */ jsx(EmailAddress, { name: store.name, address: store.address }) }),
    /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
    /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(TextualSectionTitle, { className: "text-lg", children: t("lineItems.summary.title", loc) }) }),
    exchangeArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.exchange.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: exchangeArticles,
          currency: customerCurrency
        }
      )
    ] }),
    exchangeCreditLineItems.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.exchangeCredit.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: exchangeCreditLineItems,
          currency: customerCurrency
        }
      )
    ] }),
    refundArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.refund.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: refundArticles,
          currency: customerCurrency
        }
      )
    ] }),
    discountArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.discount.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: discountArticles,
          currency: customerCurrency
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      SingleButtonSection,
      {
        label: t("returnRequestReturnToStore.trackCTA", loc),
        href: trackReturnHref
      }
    )
  ] }) });
}
ReturnRequestCreatedReturnToStoreEmail.PreviewProps = {
  shop: {
    name: "Vanessa Wu",
    logoUrl: "https://es.soeur.fr/cdn/shop/files/soeur.svg?v=1705681689&width=180"
  },
  orderName: "#0001",
  customerCurrency: "\u20AC",
  store: {
    name: "Boutique de bb",
    address: {
      address1: "123 Rue de la Paix",
      address2: "1er \xE9tage",
      city: "Paris",
      zip: "75000",
      country: "France"
    },
    urlMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.188343964958!2d2.3522219156740197!3d48.85661400789314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e145c7faf6b%3A0x50acf5597f6a8760!2sEspace%20Saint-Germain!5e0!3m2!1sfr!2sfr!4v1718308800000!5m2!1sfr!2sfr"
  },
  trackReturnHref: "/returns/123",
  requestDate: "16 juin 2026",
  requestTime: "14:30",
  lineItems: [
    {
      title: "Baskets \xE9clair Ingrid blanc et noir z\xE9br\xE9 \xE0 scratchs",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/products/BK2445NR_01.jpg?v=1686221236",
      quantity: 1,
      resolution: "exchange-credit",
      variant: {
        title: "L"
      }
    }
  ],
  exchangeCreditLineItems: [
    {
      title: "Sac \xE0 main Bethany beige et noir",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/files/MA0132BG-M_01.jpg?v=1738772468",
      quantity: 1
    }
  ]
};
async function returnRequestCreatedReturnToStoreEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(ReturnRequestCreatedReturnToStoreEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(ReturnRequestCreatedReturnToStoreEmail, { ...props, locale }), {
      plainText: true
    })
  ]);
  return {
    html,
    text
  };
}
function ReturnRequestCreatedWithoutLabelEmail({
  shop,
  orderName,
  lineItems,
  exchangeCreditLineItems,
  customerCurrency,
  trackReturnHref,
  requestDate,
  requestTime,
  locale
}) {
  const loc = locale || "fr";
  const refundArticles = lineItems.filter(
    (item) => item.resolution === "refund"
  );
  const exchangeArticles = lineItems.filter(
    (item) => item.resolution && ["exchange", "exchange-credit"].includes(item.resolution)
  );
  const discountArticles = lineItems.filter(
    (item) => item.resolution === "discount"
  );
  return /* @__PURE__ */ jsx(EmailContainer, { preview: t("returnRequestWithoutLabel.preview", loc, { orderName }), children: /* @__PURE__ */ jsxs(EmailCard, { children: [
    /* @__PURE__ */ jsx(BrandHeader, { shop }),
    /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
      /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("returnRequestWithoutLabel.heading", loc) }),
      /* @__PURE__ */ jsx(TextualSectionContent, { children: t("returnRequestWithoutLabel.description", loc) }),
      /* @__PURE__ */ jsx(
        ReturnRequestDate,
        {
          requestDate,
          requestTime,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
    /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(TextualSectionTitle, { className: "text-lg", children: t("lineItems.summary.title", loc) }) }),
    exchangeArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.exchange.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: exchangeArticles,
          currency: customerCurrency
        }
      )
    ] }),
    exchangeCreditLineItems.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.exchangeCredit.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: exchangeCreditLineItems,
          currency: customerCurrency
        }
      )
    ] }),
    refundArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.refund.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: refundArticles,
          currency: customerCurrency
        }
      )
    ] }),
    discountArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.discount.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: discountArticles,
          currency: customerCurrency
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      SingleButtonSection,
      {
        label: t("returnRequestWithoutLabel.trackCTA", loc),
        href: trackReturnHref
      }
    )
  ] }) });
}
ReturnRequestCreatedWithoutLabelEmail.PreviewProps = {
  shop: {
    name: "Vanessa Wu",
    logoUrl: "https://es.soeur.fr/cdn/shop/files/soeur.svg?v=1705681689&width=180"
  },
  orderName: "#0001",
  customerCurrency: "\u20AC",
  trackReturnHref: "/returns/123",
  requestDate: "16 juin 2026",
  requestTime: "14:30",
  lineItems: [
    {
      title: "Baskets \xE9clair Ingrid blanc et noir z\xE9br\xE9 \xE0 scratchs",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/products/BK2445NR_01.jpg?v=1686221236",
      quantity: 1,
      resolution: "exchange-credit",
      variant: {
        title: "L"
      }
    }
  ],
  exchangeCreditLineItems: [
    {
      title: "Sac \xE0 main Bethany beige et noir",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/files/MA0132BG-M_01.jpg?v=1738772468",
      quantity: 1
    }
  ]
};
async function returnRequestCreatedWithoutLabelEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(ReturnRequestCreatedWithoutLabelEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(ReturnRequestCreatedWithoutLabelEmail, { ...props, locale }), {
      plainText: true
    })
  ]);
  return {
    html,
    text
  };
}
function ReturnRequestCreatedWithoutPhysicalReturnEmail({
  shop,
  lineItems,
  exchangeCreditLineItems,
  customerCurrency,
  trackReturnHref,
  requestDate,
  requestTime,
  locale
}) {
  const loc = locale || "fr";
  const refundArticles = lineItems.filter(
    (item) => item.resolution === "refund"
  );
  const exchangeArticles = lineItems.filter(
    (item) => item.resolution && ["exchange", "exchange-credit"].includes(item.resolution)
  );
  const discountArticles = lineItems.filter(
    (item) => item.resolution === "discount"
  );
  return /* @__PURE__ */ jsx(
    EmailContainer,
    {
      preview: t("returnRequestWithoutPhysicalReturn.preview", loc),
      children: /* @__PURE__ */ jsxs(EmailCard, { children: [
        /* @__PURE__ */ jsx(BrandHeader, { shop }),
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("returnRequestWithoutPhysicalReturn.heading", loc) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: t("returnRequestWithoutPhysicalReturn.description", loc) }),
          /* @__PURE__ */ jsx(
            ReturnRequestDate,
            {
              requestDate,
              requestTime,
              locale: loc
            }
          )
        ] }),
        /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
        /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(TextualSectionTitle, { className: "text-lg", children: t("lineItems.summary.title", loc) }) }),
        exchangeArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.exchange.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: exchangeArticles,
              currency: customerCurrency
            }
          )
        ] }),
        exchangeCreditLineItems.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.exchangeCredit.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: exchangeCreditLineItems,
              currency: customerCurrency
            }
          )
        ] }),
        refundArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.refund.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: refundArticles,
              currency: customerCurrency
            }
          )
        ] }),
        discountArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
          /* @__PURE__ */ jsx(
            Heading$1,
            {
              as: "h5",
              className: "px-4 m-0 mb-2 text-secondary-foreground",
              children: t("lineItems.sections.discount.title", loc)
            }
          ),
          /* @__PURE__ */ jsx(
            ReturnRequestLineItemsList,
            {
              lineItems: discountArticles,
              currency: customerCurrency
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("returnRequestWithoutPhysicalReturn.trackCTA", loc),
            href: trackReturnHref
          }
        )
      ] })
    }
  );
}
ReturnRequestCreatedWithoutPhysicalReturnEmail.PreviewProps = {
  shop: {
    name: "Vanessa Wu",
    logoUrl: "https://es.soeur.fr/cdn/shop/files/soeur.svg?v=1705681689&width=180"
  },
  customerCurrency: "\u20AC",
  trackReturnHref: "/returns/123",
  requestDate: "16 juin 2026",
  requestTime: "14:30",
  lineItems: [
    {
      title: "Baskets \xE9clair Ingrid blanc et noir z\xE9br\xE9 \xE0 scratchs",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/products/BK2445NR_01.jpg?v=1686221236",
      quantity: 1,
      resolution: "exchange-credit",
      variant: {
        title: "L"
      }
    }
  ],
  exchangeCreditLineItems: [
    {
      title: "Sac \xE0 main Bethany beige et noir",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/files/MA0132BG-M_01.jpg?v=1738772468",
      quantity: 1
    }
  ]
};
async function returnRequestCreatedWithoutPhysicalReturnEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(
      /* @__PURE__ */ jsx(
        ReturnRequestCreatedWithoutPhysicalReturnEmail,
        {
          ...props,
          locale
        }
      )
    ),
    render$1(
      /* @__PURE__ */ jsx(
        ReturnRequestCreatedWithoutPhysicalReturnEmail,
        {
          ...props,
          locale
        }
      ),
      {
        plainText: true
      }
    )
  ]);
  return {
    html,
    text
  };
}
function DepositReminderEmail({
  shop,
  lineItems,
  exchangeCreditLineItems,
  customerCurrency,
  hasLogisticLabel,
  actions,
  locale
}) {
  const loc = locale || "fr";
  const refundArticles = lineItems.filter(
    (item) => item.resolution === "refund"
  );
  const exchangeArticles = lineItems.filter(
    (item) => item.resolution && ["exchange", "exchange-credit"].includes(item.resolution)
  );
  const discountArticles = lineItems.filter(
    (item) => item.resolution === "discount"
  );
  return /* @__PURE__ */ jsx(EmailContainer, { preview: t("depositReminder.preview", loc), children: /* @__PURE__ */ jsxs(EmailCard, { children: [
    /* @__PURE__ */ jsx(BrandHeader, { shop }),
    /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
      /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("depositReminder.heading", loc) }),
      /* @__PURE__ */ jsx(TextualSectionContent, { children: t(
        hasLogisticLabel ? "depositReminder.descriptionBonDeRetour" : "depositReminder.description",
        loc
      ) })
    ] }),
    actions.downloadLabelHref && actions.downloadLabelHref !== "" && /* @__PURE__ */ jsx(
      SingleButtonSection,
      {
        label: t(
          hasLogisticLabel ? "depositReminder.downloadBonDeRetourCTA" : "depositReminder.downloadLabelCTA",
          loc
        ),
        href: actions.downloadLabelHref
      }
    ),
    /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
    /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(TextualSectionTitle, { className: "text-lg", children: t("lineItems.summary.title", loc) }) }),
    exchangeArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.exchange.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: exchangeArticles,
          currency: customerCurrency
        }
      )
    ] }),
    exchangeCreditLineItems.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.exchangeCredit.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: exchangeCreditLineItems,
          currency: customerCurrency
        }
      )
    ] }),
    refundArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.refund.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: refundArticles,
          currency: customerCurrency
        }
      )
    ] }),
    discountArticles.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "my-4", children: [
      /* @__PURE__ */ jsx(
        Heading$1,
        {
          as: "h5",
          className: "px-4 m-0 mb-2 text-secondary-foreground",
          children: t("lineItems.sections.discount.title", loc)
        }
      ),
      /* @__PURE__ */ jsx(
        ReturnRequestLineItemsList,
        {
          lineItems: discountArticles,
          currency: customerCurrency
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      SingleButtonSection,
      {
        label: t("depositReminder.trackCTA", loc),
        href: actions.trackReturnHref
      }
    ),
    /* @__PURE__ */ jsx(
      DoNotReplyFooter,
      {
        locale: loc,
        contactLink: shop.preferences.contactLink
      }
    )
  ] }) });
}
DepositReminderEmail.PreviewProps = {
  shop: {
    name: "Vanessa Wu",
    logoUrl: "https://es.soeur.fr/cdn/shop/files/soeur.svg?v=1705681689&width=180",
    preferences: {
      contactLink: "mailto:contact@vanessawu.com"
    }
  },
  customerCurrency: "\u20AC",
  actions: {
    downloadLabelHref: "/returns/label/download",
    trackReturnHref: "/returns/123"
  },
  lineItems: [
    {
      title: "Baskets \xE9clair Ingrid blanc et noir z\xE9br\xE9 \xE0 scratchs",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/products/BK2445NR_01.jpg?v=1686221236",
      quantity: 1,
      resolution: "refund",
      variant: {
        title: "L"
      }
    }
  ],
  exchangeCreditLineItems: []
};
async function depositReminderEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(DepositReminderEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(DepositReminderEmail, { ...props, locale }), { plainText: true })
  ]);
  return {
    html,
    text
  };
}
function ReturnRequestRejectedEmail({
  shop,
  orderName,
  lineItems,
  customerCurrency,
  trackReturnHref,
  locale
}) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsx(EmailContainer, { preview: t("returnRequestRejected.preview", loc, { orderName }), children: /* @__PURE__ */ jsxs(EmailCard, { children: [
    /* @__PURE__ */ jsx(BrandHeader, { shop }),
    /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
      /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("returnRequestRejected.heading", loc) }),
      /* @__PURE__ */ jsx(TextualSectionContent, { children: t("returnRequestRejected.description", loc) })
    ] }),
    /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
    /* @__PURE__ */ jsx(Section, { className: "px-4", children: /* @__PURE__ */ jsx(TextualSectionTitle, { className: "text-lg", children: t("returnRequestRejected.rejectedItemsTitle", loc) }) }),
    lineItems.length > 0 && /* @__PURE__ */ jsx(Section, { className: "my-4", children: /* @__PURE__ */ jsx(
      ReturnRequestLineItemsList,
      {
        lineItems,
        currency: customerCurrency
      }
    ) }),
    /* @__PURE__ */ jsx(
      SingleButtonSection,
      {
        label: t("returnRequestRejected.trackCTA", loc),
        href: trackReturnHref
      }
    ),
    /* @__PURE__ */ jsx(
      DoNotReplyFooter,
      {
        locale: loc,
        contactLink: shop.preferences.contactLink
      }
    )
  ] }) });
}
ReturnRequestRejectedEmail.PreviewProps = {
  shop: {
    name: "Vanessa Wu",
    logoUrl: "https://es.soeur.fr/cdn/shop/files/soeur.svg?v=1705681689&width=180",
    preferences: {
      contactLink: "mailto:contact@vanessawu.com"
    }
  },
  orderName: "#0001",
  customerCurrency: "\u20AC",
  trackReturnHref: "/returns/123",
  lineItems: [
    {
      title: "Baskets \xE9clair Ingrid blanc et noir z\xE9br\xE9 \xE0 scratchs",
      price: "80,00",
      image: "https://cdn.shopify.com/s/files/1/0556/7778/0065/products/BK2445NR_01.jpg?v=1686221236",
      quantity: 1,
      resolution: "refund",
      variant: {
        title: "L"
      }
    }
  ]
};
async function returnRequestRejectedEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(ReturnRequestRejectedEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(ReturnRequestRejectedEmail, { ...props, locale }), {
      plainText: true
    })
  ]);
  return { html, text };
}
var MAX_ALERTS = 45;
var TYPE_STYLES = {
  label_failed: { bg: "#fef2f2", dot: "#ef4444", text: "#991b1b" },
  refund_failed: { bg: "#fff7ed", dot: "#f97316", text: "#9a3412" },
  treatment_failed: { bg: "#fefce8", dot: "#eab308", text: "#854d0e" },
  logistics_rejected: { bg: "#f5f3ff", dot: "#8b5cf6", text: "#5b21b6" },
  exchange_failed: { bg: "#eff6ff", dot: "#3b82f6", text: "#1e40af" },
  integration_failed: { bg: "#f1f5f9", dot: "#94a3b8", text: "#475569" },
  stale_return: { bg: "#fdf4ff", dot: "#d946ef", text: "#86198f" },
  received_not_refunded: { bg: "#ecfdf5", dot: "#10b981", text: "#065f46" },
  out_of_stock: { bg: "#fef3c7", dot: "#f59e0b", text: "#92400e" }
};
var DEFAULT_STYLE = { bg: "#f1f5f9", dot: "#94a3b8", text: "#475569" };
function BlockedReturnsDigestEmail({
  // craftsman-ignore: TS002
  shopName,
  alerts,
  normalCount,
  pendingCounts,
  frontendUrl,
  shopId,
  locale
}) {
  const loc = locale || "fr";
  const displayAlerts = alerts.slice(0, MAX_ALERTS);
  const remaining = alerts.length - displayAlerts.length;
  const hasPendingActions = pendingCounts && (pendingCounts.toBeValidated > 0 || pendingCounts.toBeTreated > 0);
  return /* @__PURE__ */ jsx(EmailContainer, { preview: t("blockedReturnsDigest.subject", loc), children: /* @__PURE__ */ jsxs(EmailCard, { children: [
    /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
      /* @__PURE__ */ jsxs(TextualSectionTitle, { className: "py-4", children: [
        shopName,
        " - ",
        t("blockedReturnsDigest.heading", loc)
      ] }),
      alerts.length === 0 && !hasPendingActions && /* @__PURE__ */ jsx(TextualSectionContent, { children: t("blockedReturnsDigest.noAlerts", loc) })
    ] }),
    hasPendingActions && /* @__PURE__ */ jsxs(Section, { className: "px-8 mb-4", children: [
      /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(Column, { style: { verticalAlign: "middle", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #e2e8f0" }, children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "11px", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", textAlign: "left" }, children: t("blockedReturnsDigest.pendingActions.heading", loc) }) }),
        /* @__PURE__ */ jsx(Column, { style: { width: "28px", borderBottom: "1px solid #e2e8f0" } })
      ] }),
      pendingCounts.toBeValidated > 0 && /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(Column, { style: { verticalAlign: "middle", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #f1f5f9" }, children: /* @__PURE__ */ jsx(
          Link,
          {
            href: `${frontendUrl}/shops/${shopId}/returns`,
            style: { textDecoration: "none" },
            children: /* @__PURE__ */ jsxs(
              "span",
              {
                style: {
                  display: "inline-block",
                  backgroundColor: "#fef3c7",
                  color: "#92400e",
                  fontSize: "11px",
                  fontWeight: 500,
                  padding: "2px 8px 2px 6px",
                  borderRadius: "9999px",
                  lineHeight: "18px",
                  whiteSpace: "nowrap"
                },
                children: [
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "#f59e0b",
                        marginRight: "5px",
                        verticalAlign: "middle"
                      }
                    }
                  ),
                  pendingCounts.toBeValidated,
                  " ",
                  t("blockedReturnsDigest.pendingActions.toBeValidated", loc)
                ]
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx(Column, { style: { width: "28px", verticalAlign: "middle", textAlign: "right", borderBottom: "1px solid #f1f5f9" }, children: /* @__PURE__ */ jsx(
          Link,
          {
            href: `${frontendUrl}/shops/${shopId}/returns`,
            style: { textDecoration: "none" },
            children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "14px", color: "#3b82f6", lineHeight: "14px" }, children: "\u2197" })
          }
        ) })
      ] }),
      pendingCounts.toBeTreated > 0 && /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(Column, { style: { verticalAlign: "middle", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #f1f5f9" }, children: /* @__PURE__ */ jsx(
          Link,
          {
            href: `${frontendUrl}/shops/${shopId}/returns`,
            style: { textDecoration: "none" },
            children: /* @__PURE__ */ jsxs(
              "span",
              {
                style: {
                  display: "inline-block",
                  backgroundColor: "#dbeafe",
                  color: "#1e40af",
                  fontSize: "11px",
                  fontWeight: 500,
                  padding: "2px 8px 2px 6px",
                  borderRadius: "9999px",
                  lineHeight: "18px",
                  whiteSpace: "nowrap"
                },
                children: [
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "#3b82f6",
                        marginRight: "5px",
                        verticalAlign: "middle"
                      }
                    }
                  ),
                  pendingCounts.toBeTreated,
                  " ",
                  t("blockedReturnsDigest.pendingActions.toBeTreated", loc)
                ]
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx(Column, { style: { width: "28px", verticalAlign: "middle", textAlign: "right", borderBottom: "1px solid #f1f5f9" }, children: /* @__PURE__ */ jsx(
          Link,
          {
            href: `${frontendUrl}/shops/${shopId}/returns`,
            style: { textDecoration: "none" },
            children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "14px", color: "#3b82f6", lineHeight: "14px" }, children: "\u2197" })
          }
        ) })
      ] })
    ] }),
    hasPendingActions && alerts.length > 0 && /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
    alerts.length > 0 && /* @__PURE__ */ jsxs(Section, { className: "px-8 mb-4", children: [
      /* @__PURE__ */ jsx(Text$1, { style: { margin: "0 0 8px 0", fontSize: "11px", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", textAlign: "left" }, children: t("blockedReturnsDigest.blockingReturns.heading", loc) }),
      /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(Column, { style: { width: "140px", verticalAlign: "middle", paddingRight: "10px", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #e2e8f0" }, children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "11px", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", textAlign: "left" }, children: t("blockedReturnsDigest.header.type", loc) }) }),
        /* @__PURE__ */ jsx(Column, { style: { width: "100px", verticalAlign: "middle", paddingRight: "10px", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #e2e8f0" }, children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "11px", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", textAlign: "left" }, children: t("blockedReturnsDigest.header.order", loc) }) }),
        /* @__PURE__ */ jsx(Column, { style: { width: "180px", verticalAlign: "middle", paddingRight: "10px", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #e2e8f0" }, children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "11px", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", textAlign: "left" }, children: t("blockedReturnsDigest.header.email", loc) }) }),
        /* @__PURE__ */ jsx(Column, { style: { width: "28px", borderBottom: "1px solid #e2e8f0" } })
      ] }),
      displayAlerts.map((alert, idx) => {
        const style2 = TYPE_STYLES[alert.type.toLowerCase()] || DEFAULT_STYLE;
        const typeKey = `blockedReturnsDigest.types.${alert.type.toLowerCase()}`;
        return /* @__PURE__ */ jsxs(Row, { children: [
          /* @__PURE__ */ jsx(Column, { style: { width: "140px", verticalAlign: "middle", paddingRight: "10px", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #f1f5f9" }, children: /* @__PURE__ */ jsxs(
            "span",
            {
              style: {
                display: "inline-block",
                backgroundColor: style2.bg,
                color: style2.text,
                fontSize: "11px",
                fontWeight: 500,
                padding: "2px 8px 2px 6px",
                borderRadius: "9999px",
                lineHeight: "18px",
                whiteSpace: "nowrap"
              },
              children: [
                /* @__PURE__ */ jsx(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: style2.dot,
                      marginRight: "5px",
                      verticalAlign: "middle"
                    }
                  }
                ),
                t(typeKey, loc)
              ]
            }
          ) }),
          /* @__PURE__ */ jsx(Column, { style: { width: "80px", verticalAlign: "middle", paddingRight: "10px", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #f1f5f9", whiteSpace: "nowrap" }, children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "13px", color: "#374151", fontWeight: 600 }, children: alert.orderName }) }),
          /* @__PURE__ */ jsx(Column, { style: { width: "180px", verticalAlign: "middle", paddingRight: "10px", paddingTop: "6px", paddingBottom: "6px", borderBottom: "1px solid #f1f5f9" }, children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "13px", color: "#6b7280" }, children: alert.customerEmail || "" }) }),
          /* @__PURE__ */ jsx(Column, { style: { width: "28px", verticalAlign: "middle", textAlign: "right", borderBottom: "1px solid #f1f5f9" }, children: /* @__PURE__ */ jsx(
            Link,
            {
              href: `${frontendUrl}/shops/${shopId}/returns/${alert.returnRequestId}`,
              style: { textDecoration: "none" },
              title: t("blockedReturnsDigest.open", loc),
              children: /* @__PURE__ */ jsx(Text$1, { style: { margin: 0, fontSize: "14px", color: "#3b82f6", lineHeight: "14px" }, children: "\u2197" })
            }
          ) })
        ] }, `${alert.returnRequestId}-${idx}`);
      }),
      remaining > 0 && /* @__PURE__ */ jsx(Text$1, { className: "text-sm m-0 text-gray-400 italic", children: t("blockedReturnsDigest.andMore", loc, {
        count: remaining
      }) })
    ] }),
    normalCount > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Hr, { className: "my-4" }),
      /* @__PURE__ */ jsx(TextualSectionContainer, { children: /* @__PURE__ */ jsx(TextualSectionContent, { children: t("blockedReturnsDigest.normalCount", loc, {
        count: normalCount
      }) }) })
    ] })
  ] }) });
}
BlockedReturnsDigestEmail.PreviewProps = {
  shopName: "Demo Shop",
  shopLogoUrl: "",
  alerts: [
    {
      returnRequestId: "rr-1",
      orderName: "#1001",
      customerEmail: "john@example.com",
      type: "label_failed"
    },
    {
      returnRequestId: "rr-2",
      orderName: "#1002",
      customerEmail: "jane@example.com",
      type: "label_failed"
    },
    {
      returnRequestId: "rr-3",
      orderName: "#1003",
      customerEmail: "bob@example.com",
      type: "refund_failed"
    },
    {
      returnRequestId: "rr-4",
      orderName: "#1004",
      customerEmail: "alice@example.com",
      type: "treatment_failed"
    },
    {
      returnRequestId: "rr-5",
      orderName: "#1005",
      customerEmail: "charlie@example.com",
      type: "logistics_rejected"
    },
    {
      returnRequestId: "rr-6",
      orderName: "#1006",
      customerEmail: "diana@example.com",
      type: "exchange_failed"
    }
  ],
  normalCount: 42,
  pendingCounts: { toBeValidated: 7, toBeTreated: 12 },
  frontendUrl: "https://app.baback.co",
  shopId: "shop-1",
  locale: "fr"
};
async function blockedReturnsDigestEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(BlockedReturnsDigestEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(BlockedReturnsDigestEmail, { ...props, locale }), {
      plainText: true
    })
  ]);
  return { html, text };
}

// src/templates/return/created-without-approval.ts
var returnCreatedWithoutApprovalEmailTemplateSubject = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returneringsanmodning for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Din returforesp\xF8rsel for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea dumneavoastr\u0103 de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnCreatedWithoutApprovalEmailTemplatePreview = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returneringsanmodning for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Din returforesp\xF8rsel for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea dumneavoastr\u0103 de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnCreatedWithoutApprovalEmailTemplate = {
  beforeBlocks: [],
  insideBlocks: [
    {
      id: "08ac1f57-c554-4313-aa9a-992d2e43ab17",
      type: "logo",
      alignment: "center",
      font: null,
      properties: {
        size: "medium"
      },
      content: null
    },
    {
      id: "18f8f0de-6d0a-4cd8-8ac7-117038362178",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      type: "paragraph",
      alignment: "center",
      properties: {},
      id: "96b6f321-cc2e-4669-83b7-1aa35f682d1d",
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Votre demande de retour</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161e \u017E\xE1dost o vr\xE1cen\xED</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returforesp\xF8rgsel</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ihre R\xFCcksendeanfrage</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Your return request</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Su solicitud de devoluci\xF3n</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuspyynt\xF6si</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas piepras\u012Bjums</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Returforesp\xF8rselen din</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Twoje zg\u0142oszenie zwrotu</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>O seu pedido de devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Sua solicita\xE7\xE3o de devolu\xE7\xE3o</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Cererea ta de retur</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returf\xF6rfr\xE5gan</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u7533\u8ACB</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>La tua richiesta di reso</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Je retouraanvraag</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9si k\xE9r\xE9se</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161a \u017Eiados\u0165 o vr\xE1tenie</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435</strong></p>'
        }
      }
    },
    {
      id: "47b13d67-caab-4b5b-b091-f994567de2d2",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Nous avons bien pris en compte votre demande. Nous allons la valider dans les plus brefs d\xE9lais. Une fois valid\xE9e, nous vous indiquerons comment faire votre retour.</span></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Obdr\u017Eeli jsme va\u0161i \u017E\xE1dost o vr\xE1cen\xED. Ov\u011B\u0159\xEDme ji co nejd\u0159\xEDve. Jakmile bude ov\u011B\u0159ena, d\xE1me v\xE1m v\u011Bd\u011Bt, jak postupovat d\xE1l.</span></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Vi har modtaget din returneringsanmodning. Vi validerer den hurtigst muligt. N\xE5r den er valideret, giver vi dig besked om, hvordan du skal forts\xE6tte med din returnering.</span></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Wir haben Ihre R\xFCcksendeanfrage erhalten. Wir werden sie so schnell wie m\xF6glich validieren. Sobald sie validiert ist, werden wir Ihnen mitteilen, wie Sie mit Ihrer R\xFCcksendung fortfahren k\xF6nnen.</span></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u039B\u03AC\u03B2\u03B1\u03BC\u03B5 \u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2. \u0398\u03B1 \u03C4\u03BF \u03B5\u03B3\u03BA\u03C1\u03AF\u03BD\u03BF\u03C5\u03BC\u03B5 \u03C4\u03BF \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03CC\u03C4\u03B5\u03C1\u03BF \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC. \u039C\u03CC\u03BB\u03B9\u03C2 \u03B5\u03B3\u03BA\u03C1\u03B9\u03B8\u03B5\u03AF, \u03B8\u03B1 \u03C3\u03B1\u03C2 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03C0\u03CE\u03C2 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C7\u03C9\u03C1\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03B1\u03C2.</span></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">We have received your return request. We will validate it as soon as possible. Once validated, we will let you know how to proceed with your return.</span></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Hemos recibido su solicitud de devoluci\xF3n. La validaremos lo antes posible. Una vez validada, le indicaremos c\xF3mo proceder con su devoluci\xF3n.</span></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Olemme vastaanottaneet palautuspyynt\xF6si. Vahvistamme sen mahdollisimman pian. Kun se on vahvistettu, ilmoitamme sinulle, miten jatkaa palautuksen kanssa.</span></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u78BA\u8A8D\u3044\u305F\u3057\u307E\u3059\u3002\u627F\u8A8D\u5F8C\u3001\u8FD4\u54C1\u306E\u624B\u7D9A\u304D\u65B9\u6CD5\u3092\u3054\u9023\u7D61\u3044\u305F\u3057\u307E\u3059\u3002</span></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">M\u0113s esam sa\u0146\u0113mu\u0161i j\u016Bsu atgrie\u0161anas piepras\u012Bjumu. M\u0113s to apstiprin\u0101sim p\u0113c iesp\u0113jas dr\u012Bz\u0101k. Kad tas b\u016Bs apstiprin\u0101ts, m\u0113s jums pazi\u0146osim, k\u0101 turpin\u0101t atgrie\u0161anu.</span></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Vi har mottatt din returforesp\xF8rsel. Vi vil validere den s\xE5 snart som mulig. N\xE5r den er validert, vil vi gi deg beskjed om hvordan du g\xE5r videre med returen.</span></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Otrzymali\u015Bmy Twoje zg\u0142oszenie zwrotu. Zweryfikujemy je jak najszybciej. Po zatwierdzeniu poinformujemy Ci\u0119, jak post\u0119powa\u0107 dalej.</span></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Recebemos o seu pedido de devolu\xE7\xE3o. Vamos valid\xE1-lo o mais rapidamente poss\xEDvel. Assim que estiver validado, inform\xE1-lo-emos sobre como proceder \xE0 devolu\xE7\xE3o.</span></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Recebemos sua solicita\xE7\xE3o de devolu\xE7\xE3o. Vamos valid\xE1-la o mais r\xE1pido poss\xEDvel. Assim que for validada, informaremos como prosseguir com sua devolu\xE7\xE3o.</span></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Am primit cererea dumneavoastr\u0103 de retur. O vom valida c\xE2t mai cur\xE2nd posibil. Dup\u0103 validare, v\u0103 vom anun\u021Ba cum s\u0103 proceda\u021Bi cu returul.</span></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Vi har tagit emot din returf\xF6rfr\xE5gan. Vi kommer att validera den s\xE5 snart som m\xF6jligt. N\xE4r den \xE4r validerad meddelar vi dig hur du ska g\xE5 vidare med din retur.</span></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u8FDB\u884C\u5BA1\u6838\u3002\u5BA1\u6838\u901A\u8FC7\u540E\uFF0C\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8\u5982\u4F55\u7EE7\u7EED\u9000\u8D27\u6D41\u7A0B\u3002</span></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u6211\u5011\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8CA8\u7533\u8ACB\u3002\u6211\u5011\u5C07\u76E1\u5FEB\u9A57\u8B49\uFF0C\u4E00\u65E6\u9A57\u8B49\u5B8C\u6210\uFF0C\u6211\u5011\u6703\u901A\u77E5\u60A8\u5982\u4F55\u7E7C\u7E8C\u9000\u8CA8\u6D41\u7A0B\u3002</span></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u8FDB\u884C\u5BA1\u6838\u3002\u5BA1\u6838\u901A\u8FC7\u540E\uFF0C\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8\u5982\u4F55\u7EE7\u7EED\u9000\u8D27\u6D41\u7A0B\u3002</span></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Abbiamo preso in carico la tua richiesta. La convalideremo al pi\xF9 presto. Una volta convalidata, ti indicheremo come effettuare il reso.</span></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">We hebben je aanvraag goed ontvangen. We valideren deze zo snel mogelijk. Zodra deze is gevalideerd, leggen we uit hoe je je retour kunt doen.</span></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">K\xE9r\xE9s\xE9t r\xF6gz\xEDtett\xFCk. A lehet\u0151 leghamarabb j\xF3v\xE1hagyjuk. A j\xF3v\xE1hagy\xE1s ut\xE1n t\xE1j\xE9koztatjuk a visszak\xFCld\xE9s m\xF3dj\xE1r\xF3l.</span></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Va\u0161u \u017Eiados\u0165 sme zaevidovali. \u010Co najsk\xF4r ju potvrd\xEDme. Po potvrden\xED v\xE1m ozn\xE1mime, ako vr\xE1ti\u0165 tovar.</span></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u041F\u0440\u0438\u0435\u0445\u043C\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430. \u0429\u0435 \u044F \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0438\u043C \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0441\u043A\u043E\u0440\u043E. \u0421\u043B\u0435\u0434 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0449\u0435 \u0432\u0438 \u043E\u0431\u044F\u0441\u043D\u0438\u043C \u043A\u0430\u043A \u0434\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u0438\u0442\u0435 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E.</span></p>'
        }
      }
    },
    {
      id: "0aa4d734-e088-42dd-91e2-62877ed1e78f",
      type: "return-request-date",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "63015317-e314-4f79-b4b3-4d0db79b31a6",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "c85e5a84-c889-4944-86a5-dc2b4bc38c41",
      type: "paragraph",
      alignment: "left",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>D\xE9tails de votre retour</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti o va\u0161em vr\xE1cen\xED</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din returnering</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details Ihrer R\xFCcksendung</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details of your return</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalles de su devoluci\xF3n</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuksesi tiedot</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u306E\u8A73\u7D30</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas deta\u013Cas</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om returen din</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Szczeg\xF3\u0142y Twojego zwrotu</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalii despre returul dvs.</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din retur</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u8A73\u60C5</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dettagli del tuo reso</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details van je retour</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9s r\xE9szletei</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti v\xE1\u0161ho vr\xE1tenia</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0432\u0438</strong></p>'
        }
      }
    },
    {
      id: "5a7d67b9-c231-4ac0-bffc-e0e869589d01",
      type: "return-line-items",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "e8cc9b0b-98e0-4145-a006-9d8ee54cce9d",
      type: "button",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          text: "Suivre mon retour",
          href: "{{return.trackingUrl}}"
        },
        cs: {
          text: "Sledovat m\xE9 vr\xE1cen\xED",
          href: "{{return.trackingUrl}}"
        },
        da: {
          text: "Spor min returnering",
          href: "{{return.trackingUrl}}"
        },
        de: {
          text: "R\xFCcksendung verfolgen",
          href: "{{return.trackingUrl}}"
        },
        el: {
          text: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03CD\u03B8\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03BF\u03C5",
          href: "{{return.trackingUrl}}"
        },
        en: {
          text: "Track my return",
          href: "{{return.trackingUrl}}"
        },
        es: {
          text: "Seguir mi devoluci\xF3n",
          href: "{{return.trackingUrl}}"
        },
        fi: {
          text: "Seuraa palautustani",
          href: "{{return.trackingUrl}}"
        },
        ja: {
          text: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
          href: "{{return.trackingUrl}}"
        },
        lv: {
          text: "Izsekot manu atgrie\u0161anu",
          href: "{{return.trackingUrl}}"
        },
        no: {
          text: "Spor returen min",
          href: "{{return.trackingUrl}}"
        },
        pl: {
          text: "\u015Aled\u017A m\xF3j zwrot",
          href: "{{return.trackingUrl}}"
        },
        pt: {
          text: "Acompanhar a minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        "pt-br": {
          text: "Rastrear minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        ro: {
          text: "Urm\u0103re\u0219te returul meu",
          href: "{{return.trackingUrl}}"
        },
        sv: {
          text: "Sp\xE5ra min retur",
          href: "{{return.trackingUrl}}"
        },
        "zh-cn": {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        "zh-tw": {
          text: "\u8FFD\u8E64\u6211\u7684\u9000\u8CA8",
          href: "{{return.trackingUrl}}"
        },
        zh: {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        it: {
          text: "Segui il mio reso",
          href: "{{return.trackingUrl}}"
        },
        nl: {
          text: "Mijn retour volgen",
          href: "{{return.trackingUrl}}"
        },
        hu: {
          text: "Visszak\xFCld\xE9sem k\xF6vet\xE9se",
          href: "{{return.trackingUrl}}"
        },
        sk: {
          text: "Sledova\u0165 moje vr\xE1tenie",
          href: "{{return.trackingUrl}}"
        },
        bg: {
          text: "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043C\u0438",
          href: "{{return.trackingUrl}}"
        }
      }
    }
  ],
  afterBlocks: [],
  defaultLocale: null
};

// src/templates/return/created-without-label.ts
var returnCreatedWithoutLabelEmailTemplateSubject = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returneringsanmodning for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Din returforesp\xF8rsel for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea dumneavoastr\u0103 de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnCreatedWithoutLabelEmailTemplatePreview = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returneringsanmodning for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Din returforesp\xF8rsel for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea dumneavoastr\u0103 de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnCreatedWithoutLabelEmailTemplate = {
  beforeBlocks: [],
  insideBlocks: [
    {
      id: "08ac1f57-c554-4313-aa9a-992d2e43ab17",
      type: "logo",
      alignment: "center",
      font: null,
      properties: {
        size: "medium"
      },
      content: null
    },
    {
      id: "18f8f0de-6d0a-4cd8-8ac7-117038362178",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "3d887de1-e95c-4e0d-82ae-ff6404cdd22f",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Votre demande de retour</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161e \u017E\xE1dost o vr\xE1cen\xED</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returforesp\xF8rgsel</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ihre R\xFCcksendeanfrage</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Your return request</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Su solicitud de devoluci\xF3n</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuspyynt\xF6si</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas piepras\u012Bjums</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Returforesp\xF8rselen din</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Twoje zg\u0142oszenie zwrotu</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>O seu pedido de devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Sua solicita\xE7\xE3o de devolu\xE7\xE3o</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Cererea ta de retur</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returf\xF6rfr\xE5gan</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u7533\u8ACB</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>La tua richiesta di reso</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Je retouraanvraag</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9si k\xE9r\xE9se</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161a \u017Eiados\u0165 o vr\xE1tenie</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435</strong></p>'
        }
      }
    },
    {
      id: "47b13d67-caab-4b5b-b091-f994567de2d2",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Nous avons bien re\xE7u votre demande de retour. Nous vous enverrons un email avec les instructions de retour tr\xE8s prochainement.</span></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Obdr\u017Eeli jsme va\u0161i \u017E\xE1dost o vr\xE1cen\xED. Brzy v\xE1m po\u0161leme e-mail s pokyny k vr\xE1cen\xED.</span></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Vi har modtaget din returneringsanmodning. Vi sender dig en e-mail med returneringsinstruktioner meget snart.</span></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Wir haben Ihre R\xFCcksendeanfrage erhalten. Wir werden Ihnen in K\xFCrze eine E-Mail mit R\xFCcksendeanweisungen senden.</span></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u039B\u03AC\u03B2\u03B1\u03BC\u03B5 \u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2. \u0398\u03B1 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B5\u03AF\u03BB\u03BF\u03C5\u03BC\u03B5 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1 \u03AD\u03BD\u03B1 email \u03BC\u03B5 \u03BF\u03B4\u03B7\u03B3\u03AF\u03B5\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2.</span></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">We have received your return request. We will send you an email with return instructions very soon.</span></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Hemos recibido su solicitud de devoluci\xF3n. Le enviaremos un correo electr\xF3nico con las instrucciones de devoluci\xF3n muy pronto.</span></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Olemme vastaanottaneet palautuspyynt\xF6si. L\xE4het\xE4mme sinulle pian s\xE4hk\xF6postin, jossa on palautusohjeet.</span></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u8FD4\u54C1\u65B9\u6CD5\u306E\u3054\u6848\u5185\u3092\u307E\u3082\u306A\u304F\u30E1\u30FC\u30EB\u3067\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\u3002</span></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">M\u0113s esam sa\u0146\u0113mu\u0161i j\u016Bsu atgrie\u0161anas piepras\u012Bjumu. \u013Boti dr\u012Bz nos\u016Bt\u012Bsim jums e-pastu ar atgrie\u0161anas instrukcij\u0101m.</span></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Vi har mottatt din returforesp\xF8rsel. Vi vil sende deg en e-post med returinstruksjoner veldig snart.</span></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Otrzymali\u015Bmy Twoje zg\u0142oszenie zwrotu. Wkr\xF3tce wy\u015Blemy Ci e-mail z instrukcjami dotycz\u0105cymi zwrotu.</span></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Recebemos o seu pedido de devolu\xE7\xE3o. Iremos enviar-lhe um email com instru\xE7\xF5es de devolu\xE7\xE3o muito em breve.</span></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Recebemos sua solicita\xE7\xE3o de devolu\xE7\xE3o. Em breve enviaremos um e-mail com as instru\xE7\xF5es de devolu\xE7\xE3o.</span></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Am primit cererea dumneavoastr\u0103 de retur. V\u0103 vom trimite \xEEn cur\xE2nd un e-mail cu instruc\u021Biunile de retur.</span></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Vi har tagit emot din returf\xF6rfr\xE5gan. Vi skickar snart ett e-postmeddelande med returinstruktioner.</span></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u6211\u4EEC\u5C06\u5F88\u5FEB\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5411\u60A8\u53D1\u9001\u9000\u8D27\u8BF4\u660E\u3002</span></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u5011\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8CA8\u7533\u8ACB\u3002\u6211\u5011\u5C07\u5F88\u5FEB\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u5411\u60A8\u767C\u9001\u9000\u8CA8\u6307\u793A\u3002</span></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u6211\u4EEC\u5C06\u5F88\u5FEB\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5411\u60A8\u53D1\u9001\u9000\u8D27\u8BF4\u660E\u3002</span></p>'
        },
        it: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Abbiamo ricevuto la tua richiesta di reso. Ti invieremo a breve un'email con le istruzioni per il reso.</span></p>`
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">We hebben je retouraanvraag ontvangen. We sturen je binnenkort een e-mail met de retourinstructies.</span></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Megkaptuk a visszak\xFCld\xE9si k\xE9r\xE9s\xE9t. Hamarosan e-mailt k\xFCld\xFCnk a visszak\xFCld\xE9si \xFAtmutat\xF3val.</span></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Prijali sme va\u0161u \u017Eiados\u0165 o vr\xE1tenie. \u010Coskoro v\xE1m po\u0161leme e-mail s pokynmi na vr\xE1tenie.</span></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u041F\u043E\u043B\u0443\u0447\u0438\u0445\u043C\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435. \u0421\u043A\u043E\u0440\u043E \u0449\u0435 \u0432\u0438 \u0438\u0437\u043F\u0440\u0430\u0442\u0438\u043C \u0438\u043C\u0435\u0439\u043B \u0441 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435.</span></p>'
        }
      }
    },
    {
      id: "61c1a93e-38a8-4c2a-bd2b-730160c2c177",
      type: "return-request-date",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "63015317-e314-4f79-b4b3-4d0db79b31a6",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "c85e5a84-c889-4944-86a5-dc2b4bc38c41",
      type: "paragraph",
      alignment: "left",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>D\xE9tails de votre retour</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti o va\u0161em vr\xE1cen\xED</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din returnering</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details Ihrer R\xFCcksendung</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details of your return</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalles de su devoluci\xF3n</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuksesi tiedot</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u306E\u8A73\u7D30</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas deta\u013Cas</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om returen din</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Szczeg\xF3\u0142y Twojego zwrotu</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalii despre returul dvs.</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din retur</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u8A73\u60C5</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dettagli del tuo reso</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details van je retour</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9s r\xE9szletei</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti v\xE1\u0161ho vr\xE1tenia</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0432\u0438</strong></p>'
        }
      }
    },
    {
      id: "5a7d67b9-c231-4ac0-bffc-e0e869589d01",
      type: "return-line-items",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "e8cc9b0b-98e0-4145-a006-9d8ee54cce9d",
      type: "button",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          text: "Suivre mon retour",
          href: "{{return.trackingUrl}}"
        },
        cs: {
          text: "Sledovat m\xE9 vr\xE1cen\xED",
          href: "{{return.trackingUrl}}"
        },
        da: {
          text: "Spor min returnering",
          href: "{{return.trackingUrl}}"
        },
        de: {
          text: "R\xFCcksendung verfolgen",
          href: "{{return.trackingUrl}}"
        },
        el: {
          text: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03CD\u03B8\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03BF\u03C5",
          href: "{{return.trackingUrl}}"
        },
        en: {
          text: "Track my return",
          href: "{{return.trackingUrl}}"
        },
        es: {
          text: "Seguir mi devoluci\xF3n",
          href: "{{return.trackingUrl}}"
        },
        fi: {
          text: "Seuraa palautustani",
          href: "{{return.trackingUrl}}"
        },
        ja: {
          text: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
          href: "{{return.trackingUrl}}"
        },
        lv: {
          text: "Izsekot manu atgrie\u0161anu",
          href: "{{return.trackingUrl}}"
        },
        no: {
          text: "Spor returen min",
          href: "{{return.trackingUrl}}"
        },
        pl: {
          text: "\u015Aled\u017A m\xF3j zwrot",
          href: "{{return.trackingUrl}}"
        },
        pt: {
          text: "Acompanhar a minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        "pt-br": {
          text: "Rastrear minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        ro: {
          text: "Urm\u0103re\u0219te returul meu",
          href: "{{return.trackingUrl}}"
        },
        sv: {
          text: "Sp\xE5ra min retur",
          href: "{{return.trackingUrl}}"
        },
        "zh-cn": {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        "zh-tw": {
          text: "\u8FFD\u8E64\u6211\u7684\u9000\u8CA8",
          href: "{{return.trackingUrl}}"
        },
        zh: {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        it: {
          text: "Segui il mio reso",
          href: "{{return.trackingUrl}}"
        },
        nl: {
          text: "Mijn retour volgen",
          href: "{{return.trackingUrl}}"
        },
        hu: {
          text: "Visszak\xFCld\xE9sem k\xF6vet\xE9se",
          href: "{{return.trackingUrl}}"
        },
        sk: {
          text: "Sledova\u0165 moje vr\xE1tenie",
          href: "{{return.trackingUrl}}"
        },
        bg: {
          text: "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043C\u0438",
          href: "{{return.trackingUrl}}"
        }
      }
    }
  ],
  afterBlocks: [],
  defaultLocale: null
};

// src/templates/return/created-without-physical-return.ts
var returnCreatedWithoutPhysicalReturnEmailTemplateSubject = {
  "cs": "Va\u0161e \u017E\xE1dost byla p\u0159ijata",
  "da": "Din anmodning er modtaget",
  "de": "Ihre Anfrage wurde erhalten",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03AC \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BB\u03B7\u03C6\u03B8\u03B5\u03AF",
  "en": "Your request has been received",
  "es": "Su solicitud ha sido recibida",
  "fi": "Pyynt\xF6si on vastaanotettu",
  "fr": "Votre demande a \xE9t\xE9 prise en compte",
  "ja": "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F",
  "lv": "J\u016Bsu piepras\u012Bjums ir sa\u0146emts",
  "no": "Foresp\xF8rselen din er mottatt",
  "pl": "Twoje zg\u0142oszenie zosta\u0142o przyj\u0119te",
  "pt": "O seu pedido foi recebido",
  "pt-br": "Sua solicita\xE7\xE3o foi recebida",
  "ro": "Cererea dumneavoastr\u0103 a fost primit\u0103",
  "sv": "D\xE1t g\xE1ldu lea vuostta\u017Eettiin",
  "zh-cn": "\u60A8\u7684\u7533\u8BF7\u5DF2\u6536\u5230",
  "zh-tw": "\u60A8\u7684\u7533\u8ACB\u5DF2\u6536\u5230",
  "zh": "\u60A8\u7684\u7533\u8BF7\u5DF2\u6536\u5230",
  "it": "La tua richiesta \xE8 stata presa in carico",
  "nl": "Je aanvraag is in behandeling genomen",
  "hu": "K\xE9r\xE9s\xE9t r\xF6gz\xEDtett\xFCk",
  "sk": "Va\u0161a \u017Eiados\u0165 bola zaevidovan\xE1",
  "bg": "\u0417\u0430\u044F\u0432\u043A\u0430\u0442\u0430 \u0432\u0438 \u0431\u0435\u0448\u0435 \u043F\u0440\u0438\u0435\u0442\u0430"
};
var returnCreatedWithoutPhysicalReturnEmailTemplatePreview = {
  "cs": "Va\u0161e \u017E\xE1dost byla p\u0159ijata",
  "da": "Din anmodning er modtaget",
  "de": "Ihre Anfrage wurde erhalten",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03AC \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BB\u03B7\u03C6\u03B8\u03B5\u03AF",
  "en": "Your request has been received",
  "es": "Su solicitud ha sido recibida",
  "fi": "Pyynt\xF6si on vastaanotettu",
  "fr": "Votre demande a \xE9t\xE9 prise en compte",
  "ja": "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F",
  "lv": "J\u016Bsu piepras\u012Bjums ir sa\u0146emts",
  "no": "Foresp\xF8rselen din er mottatt",
  "pl": "Twoje zg\u0142oszenie zosta\u0142o przyj\u0119te",
  "pt": "O seu pedido foi recebido",
  "pt-br": "Sua solicita\xE7\xE3o foi recebida",
  "ro": "Cererea dumneavoastr\u0103 a fost primit\u0103",
  "sv": "D\xE1t g\xE1ldu lea vuostta\u017Eettiin",
  "zh-cn": "\u60A8\u7684\u7533\u8BF7\u5DF2\u6536\u5230",
  "zh-tw": "\u60A8\u7684\u7533\u8ACB\u5DF2\u6536\u5230",
  "zh": "\u60A8\u7684\u7533\u8BF7\u5DF2\u6536\u5230",
  "it": "La tua richiesta \xE8 stata presa in carico",
  "nl": "Je aanvraag is in behandeling genomen",
  "hu": "K\xE9r\xE9s\xE9t r\xF6gz\xEDtett\xFCk",
  "sk": "Va\u0161a \u017Eiados\u0165 bola zaevidovan\xE1",
  "bg": "\u0417\u0430\u044F\u0432\u043A\u0430\u0442\u0430 \u0432\u0438 \u0431\u0435\u0448\u0435 \u043F\u0440\u0438\u0435\u0442\u0430"
};
var returnCreatedWithoutPhysicalReturnEmailTemplate = {
  beforeBlocks: [],
  insideBlocks: [
    {
      id: "97d264e1-444c-4ce3-af16-68db92b3da6c",
      type: "logo",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      type: "separator",
      alignment: "center",
      properties: {},
      id: "7a8e07e9-83c8-4ffb-b4b8-8d1388ac1b64"
    },
    {
      id: "ec8e7765-be11-4833-b560-beec79d58fdf",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Votre demande a \xE9t\xE9 prise en compte</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161e \u017E\xE1dost byla p\u0159ijata</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din anmodning er modtaget</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ihre Anfrage wurde erhalten</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03AC \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BB\u03B7\u03C6\u03B8\u03B5\u03AF</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Your request has been received</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Su solicitud ha sido recibida</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Pyynt\xF6si on vastaanotettu</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu piepras\u012Bjums ir sa\u0146emts</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Foresp\xF8rselen din er mottatt</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Twoje zg\u0142oszenie zosta\u0142o przyj\u0119te</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>O seu pedido foi recebido</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Sua solicita\xE7\xE3o foi recebida</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Cererea dumneavoastr\u0103 a fost primit\u0103</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>D\xE1t g\xE1ldu lea vuostta\u017Eettiin</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u7533\u8BF7\u5DF2\u6536\u5230</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u7533\u8ACB\u5DF2\u6536\u5230</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u7533\u8BF7\u5DF2\u6536\u5230</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>La tua richiesta \xE8 stata presa in carico</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Je aanvraag is in behandeling genomen</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>K\xE9r\xE9s\xE9t r\xF6gz\xEDtett\xFCk</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161a \u017Eiados\u0165 bola zaevidovan\xE1</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0417\u0430\u044F\u0432\u043A\u0430\u0442\u0430 \u0432\u0438 \u0431\u0435\u0448\u0435 \u043F\u0440\u0438\u0435\u0442\u0430</strong></p>'
        }
      }
    },
    {
      id: "0a71332a-b1cd-4638-807a-247c825d2b45",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Nous avons bien re\xE7u votre demande de retour. Vous serez inform\xE9(e) d\xE8s que celle-ci sera trait\xE9e.</span></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Obdr\u017Eeli jsme va\u0161i \u017E\xE1dost o vr\xE1cen\xED. Budete informov\xE1ni, jakmile bude zpracov\xE1na.</span></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Vi har modtaget din returforesp\xF8rgsel. Du vil blive informeret, s\xE5 snart den er behandlet.</span></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Wir haben Ihre R\xFCcksendeanfrage erhalten. Sie werden benachrichtigt, sobald diese bearbeitet wurde.</span></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u039B\u03AC\u03B2\u03B1\u03BC\u03B5 \u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03AC \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE. \u0398\u03B1 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF\u03C4\u03B5 \u03BC\u03CC\u03BB\u03B9\u03C2 \u03B1\u03C5\u03C4\u03CC \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03B5\u03AF.</span></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">We have received your return request. You will be notified as soon as it has been processed.</span></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Hemos recibido su solicitud de devoluci\xF3n. Le informaremos tan pronto como sea procesada.</span></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Olemme vastaanottaneet palautuspyynt\xF6si. Ilmoitamme sinulle, kun se on k\xE4sitelty.</span></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u51E6\u7406\u304C\u5B8C\u4E86\u6B21\u7B2C\u3054\u9023\u7D61\u3044\u305F\u3057\u307E\u3059\u3002</span></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">M\u0113s esam sa\u0146\u0113mu\u0161i j\u016Bsu atgrie\u0161anas piepras\u012Bjumu. J\u016Bs tiksiet inform\u0113ts, tikl\u012Bdz tas tiks apstr\u0101d\u0101ts.</span></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Vi har mottatt returforsp\xF8rselen din. Du vil bli varslet s\xE5 snart den er behandlet.</span></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Otrzymali\u015Bmy Twoje zg\u0142oszenie zwrotu. Poinformujemy Ci\u0119, gdy zostanie przetworzone.</span></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Recebemos o seu pedido de devolu\xE7\xE3o. Ser\xE1 notificado assim que for processado.</span></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Recebemos sua solicita\xE7\xE3o de devolu\xE7\xE3o. Voc\xEA ser\xE1 notificado assim que ela for processada.</span></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Am primit cererea dumneavoastr\u0103 de retur. Ve\u021Bi fi informat(\u0103) imediat ce aceasta va fi procesat\u0103.</span></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Mii leat vuostta\u017Eettan du m\xE1hccanguimmi g\xE1ldu. Don oa\u010D\u010Dut die\u0111\xE1hus go dat lea geargan.</span></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u3002\u4E00\u65E6\u5904\u7406\u5B8C\u6BD5\uFF0C\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8\u3002</span></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u5011\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8CA8\u7533\u8ACB\u3002\u4E00\u65E6\u8655\u7406\u5B8C\u7562\uFF0C\u6211\u5011\u6703\u901A\u77E5\u60A8\u3002</span></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u3002\u4E00\u65E6\u5904\u7406\u5B8C\u6BD5\uFF0C\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8\u3002</span></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Abbiamo ricevuto la tua richiesta di reso. Sarai informato non appena verr\xE0 elaborata.</span></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">We hebben je retouraanvraag ontvangen. Je wordt op de hoogte gebracht zodra deze is verwerkt.</span></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Megkaptuk a visszak\xFCld\xE9si k\xE9r\xE9s\xE9t. \xC9rtes\xEDtj\xFCk, amint feldolgoztuk.</span></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Prijali sme va\u0161u \u017Eiados\u0165 o vr\xE1tenie. Budeme v\xE1s informova\u0165, hne\u010F ako ju spracujeme.</span></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u041F\u043E\u043B\u0443\u0447\u0438\u0445\u043C\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435. \u0429\u0435 \u0431\u044A\u0434\u0435\u0442\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u0435\u043D\u0438 \u0432\u0435\u0434\u043D\u0430\u0433\u0430 \u0449\u043E\u043C \u0431\u044A\u0434\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0435\u043D\u0430.</span></p>'
        }
      }
    },
    {
      id: "3d4793f9-1c8d-4274-b022-98040117afbe",
      type: "return-request-date",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "cc804ce9-364a-476f-bbe0-8558d89d3978",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "ret-approved-summary-title",
      type: "paragraph",
      alignment: "left",
      font: null,
      properties: null,
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>D\xE9tails de votre retour</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details of your return</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti o va\u0161em vr\xE1cen\xED</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din returnering</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details Ihrer R\xFCcksendung</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalles de su devoluci\xF3n</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuksesi tiedot</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u306E\u8A73\u7D30</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas deta\u013Cas</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om returen din</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Szczeg\xF3\u0142y Twojego zwrotu</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalii despre returul dvs.</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din retur</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u8A73\u60C5</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dettagli del tuo reso</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details van je retour</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9s r\xE9szletei</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti v\xE1\u0161ho vr\xE1tenia</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0432\u0438</strong></p>'
        }
      }
    },
    {
      id: "0da83aa3-c3a0-4c8c-9f1b-5bb6a4fd8791",
      type: "return-line-items",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "94ebb720-29c1-4cd0-9c13-88c267def101",
      type: "button",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          text: "Suivre mon retour",
          href: "{{return.trackingUrl}}"
        },
        cs: {
          text: "Sledovat m\xE9 vr\xE1cen\xED",
          href: "{{return.trackingUrl}}"
        },
        da: {
          text: "Spor min returnering",
          href: "{{return.trackingUrl}}"
        },
        de: {
          text: "R\xFCcksendung verfolgen",
          href: "{{return.trackingUrl}}"
        },
        el: {
          text: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03CD\u03B8\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03BF\u03C5",
          href: "{{return.trackingUrl}}"
        },
        en: {
          text: "Track my return",
          href: "{{return.trackingUrl}}"
        },
        es: {
          text: "Seguir mi devoluci\xF3n",
          href: "{{return.trackingUrl}}"
        },
        fi: {
          text: "Seuraa palautustani",
          href: "{{return.trackingUrl}}"
        },
        ja: {
          text: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
          href: "{{return.trackingUrl}}"
        },
        lv: {
          text: "Izsekot manu atgrie\u0161anu",
          href: "{{return.trackingUrl}}"
        },
        no: {
          text: "Spor returen min",
          href: "{{return.trackingUrl}}"
        },
        pl: {
          text: "\u015Aled\u017A m\xF3j zwrot",
          href: "{{return.trackingUrl}}"
        },
        pt: {
          text: "Acompanhar a minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        "pt-br": {
          text: "Rastrear minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        ro: {
          text: "Urm\u0103re\u0219te returul meu",
          href: "{{return.trackingUrl}}"
        },
        sv: {
          text: "Sp\xE5ra min retur",
          href: "{{return.trackingUrl}}"
        },
        "zh-cn": {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        "zh-tw": {
          text: "\u8FFD\u8E64\u6211\u7684\u9000\u8CA8",
          href: "{{return.trackingUrl}}"
        },
        zh: {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        it: {
          text: "Segui il mio reso",
          href: "{{return.trackingUrl}}"
        },
        nl: {
          text: "Mijn retour volgen",
          href: "{{return.trackingUrl}}"
        },
        hu: {
          text: "Visszak\xFCld\xE9sem k\xF6vet\xE9se",
          href: "{{return.trackingUrl}}"
        },
        sk: {
          text: "Sledova\u0165 moje vr\xE1tenie",
          href: "{{return.trackingUrl}}"
        },
        bg: {
          text: "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043C\u0438",
          href: "{{return.trackingUrl}}"
        }
      }
    }
  ],
  afterBlocks: [],
  defaultLocale: null
};

// src/templates/return/created-return-to-store.ts
var returnCreatedReturnToStoreEmailTemplateSubject = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returneringsanmodning for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Din returforesp\xF8rsel for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea dumneavoastr\u0103 de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnCreatedReturnToStoreEmailTemplatePreview = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returneringsanmodning for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Din returforesp\xF8rsel for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea dumneavoastr\u0103 de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u8BF7\u6C42 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnCreatedReturnToStoreEmailTemplate = {
  beforeBlocks: [],
  insideBlocks: [
    {
      id: "ca305efd-9988-4e24-b390-ec72d782236b",
      type: "logo",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "33dcabc9-e1a1-42c4-a247-9369f0090073",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "c4959c96-2c53-4d4f-b7fc-bcbf9d2297ca",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Votre demande de retour</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161e \u017E\xE1dost o vr\xE1cen\xED</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returforesp\xF8rgsel</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ihre R\xFCcksendeanfrage</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Your return request</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Su solicitud de devoluci\xF3n</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuspyynt\xF6si</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas piepras\u012Bjums</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Returforesp\xF8rselen din</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Twoje zg\u0142oszenie zwrotu</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>O seu pedido de devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Sua solicita\xE7\xE3o de devolu\xE7\xE3o</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Cererea ta de retur</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returf\xF6rfr\xE5gan</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u7533\u8ACB</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>La tua richiesta di reso</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Je retouraanvraag</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9si k\xE9r\xE9se</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161a \u017Eiados\u0165 o vr\xE1tenie</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435</strong></p>'
        }
      }
    },
    {
      id: "15bb884c-919a-4f05-a72b-11852331fd0d",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Nous avons bien pris en compte votre demande. Vous pouvez d\xE8s \xE0 pr\xE9sent vous rendre \xE0 la boutique d\xE9poser votre retour.</span></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Obdr\u017Eeli jsme va\u0161i \u017E\xE1dost o vr\xE1cen\xED. Nyn\xED m\u016F\u017Eete zaj\xEDt do obchodu a odevzdat sv\xE9 vr\xE1cen\xED.</span></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Vi har modtaget din returneringsanmodning. Du kan nu g\xE5 til butikken for at aflevere din returnering.</span></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Wir haben Ihre R\xFCcksendeanfrage erhalten. Sie k\xF6nnen jetzt in den Laden gehen, um Ihre R\xFCcksendung abzugeben.</span></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u039B\u03AC\u03B2\u03B1\u03BC\u03B5 \u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C4\u03CE\u03C1\u03B1 \u03BD\u03B1 \u03C0\u03AC\u03C4\u03B5 \u03C3\u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B4\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03B1\u03C2.</span></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">We have received your return request. You can now go to the store to drop off your return.</span></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Hemos recibido su solicitud de devoluci\xF3n. Ahora puede ir a la tienda para dejar su devoluci\xF3n.</span></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Olemme vastaanottaneet palautuspyynt\xF6si. Voit nyt vied\xE4 palautuksesi myym\xE4l\xE4\xE4n.</span></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F\u3002\u5E97\u8217\u306B\u8FD4\u54C1\u5546\u54C1\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u3044\u3002</span></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">M\u0113s esam sa\u0146\u0113mu\u0161i j\u016Bsu atgrie\u0161anas piepras\u012Bjumu. Tagad varat doties uz veikalu, lai nodotu savu atgrie\u0161anu.</span></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Vi har mottatt din returforesp\xF8rsel. Du kan n\xE5 g\xE5 til butikken for \xE5 levere returen din.</span></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Otrzymali\u015Bmy Twoje zg\u0142oszenie zwrotu. Teraz mo\u017Cesz uda\u0107 si\u0119 do sklepu, aby nada\u0107 sw\xF3j zwrot.</span></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Recebemos o seu pedido de devolu\xE7\xE3o. J\xE1 pode dirigir-se \xE0 loja para entregar a sua devolu\xE7\xE3o.</span></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Recebemos sua solicita\xE7\xE3o de devolu\xE7\xE3o. Agora voc\xEA pode ir at\xE9 a loja para entregar sua devolu\xE7\xE3o.</span></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Am primit cererea dumneavoastr\u0103 de retur. Acum pute\u021Bi merge la magazin pentru a preda returul.</span></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Vi har tagit emot din returf\xF6rfr\xE5gan. Du kan nu g\xE5 till butiken f\xF6r att l\xE4mna in din retur.</span></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u60A8\u73B0\u5728\u53EF\u4EE5\u524D\u5F80\u95E8\u5E97\u6295\u9012\u9000\u8D27\u5305\u88F9\u3002</span></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u6211\u5011\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8CA8\u7533\u8ACB\u3002\u60A8\u73FE\u5728\u53EF\u4EE5\u524D\u5F80\u9580\u5E02\u6295\u905E\u60A8\u7684\u9000\u8CA8\u3002</span></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u6211\u4EEC\u5DF2\u6536\u5230\u60A8\u7684\u9000\u8D27\u8BF7\u6C42\u3002\u60A8\u73B0\u5728\u53EF\u4EE5\u524D\u5F80\u95E8\u5E97\u6295\u9012\u9000\u8D27\u5305\u88F9\u3002</span></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Abbiamo preso in carico la tua richiesta. Puoi gi\xE0 recarti in negozio per consegnare il tuo reso.</span></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">We hebben je aanvraag goed ontvangen. Je kunt nu al naar de winkel gaan om je retour af te geven.</span></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">K\xE9r\xE9s\xE9t r\xF6gz\xEDtett\xFCk. Mostant\xF3l felkeresheti az \xFCzletet, hogy leadja a visszak\xFCld\xF6tt term\xE9ket.</span></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">Va\u0161u \u017Eiados\u0165 sme zaevidovali. Teraz m\xF4\u017Eete pr\xEDs\u0165 do predajne odovzda\u0165 svoje vr\xE1tenie.</span></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(34, 34, 34); font-size: 16px;">\u041F\u0440\u0438\u0435\u0445\u043C\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430. \u0412\u0435\u0447\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043E\u0442\u0438\u0434\u0435\u0442\u0435 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0435\u0434\u0430\u0434\u0435\u0442\u0435 \u0432\u044A\u0440\u043D\u0430\u0442\u0430\u0442\u0430 \u0441\u0442\u043E\u043A\u0430.</span></p>'
        }
      }
    },
    {
      id: "bae6243b-01ac-492b-acfc-0ccedd007a73",
      type: "return-request-date",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "1bf242f6-eb32-414b-8d2a-d4d52427e0c1",
      type: "return-store-address",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "3027d047-5628-408c-ad1a-9f8a821ad296",
      type: "paragraph",
      alignment: "left",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>D\xE9tails de votre retour</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti o va\u0161em vr\xE1cen\xED</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din returnering</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details Ihrer R\xFCcksendung</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details of your return</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalles de su devoluci\xF3n</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuksesi tiedot</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u306E\u8A73\u7D30</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas deta\u013Cas</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om returen din</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Szczeg\xF3\u0142y Twojego zwrotu</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalii despre returul dvs.</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din retur</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u8A73\u60C5</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dettagli del tuo reso</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details van je retour</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9s r\xE9szletei</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti v\xE1\u0161ho vr\xE1tenia</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0432\u0438</strong></p>'
        }
      }
    },
    {
      id: "f7aeb83c-e4e5-4f3d-875a-b7e3f2996e9f",
      type: "return-line-items",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "94ebb720-29c1-4cd0-9c13-88c267def101",
      type: "button",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          text: "Suivre mon retour",
          href: "{{return.trackingUrl}}"
        },
        cs: {
          text: "Sledovat m\xE9 vr\xE1cen\xED",
          href: "{{return.trackingUrl}}"
        },
        da: {
          text: "Spor min returnering",
          href: "{{return.trackingUrl}}"
        },
        de: {
          text: "R\xFCcksendung verfolgen",
          href: "{{return.trackingUrl}}"
        },
        el: {
          text: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03CD\u03B8\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03BF\u03C5",
          href: "{{return.trackingUrl}}"
        },
        en: {
          text: "Track my return",
          href: "{{return.trackingUrl}}"
        },
        es: {
          text: "Seguir mi devoluci\xF3n",
          href: "{{return.trackingUrl}}"
        },
        fi: {
          text: "Seuraa palautustani",
          href: "{{return.trackingUrl}}"
        },
        ja: {
          text: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
          href: "{{return.trackingUrl}}"
        },
        lv: {
          text: "Izsekot manu atgrie\u0161anu",
          href: "{{return.trackingUrl}}"
        },
        no: {
          text: "Spor returen min",
          href: "{{return.trackingUrl}}"
        },
        pl: {
          text: "\u015Aled\u017A m\xF3j zwrot",
          href: "{{return.trackingUrl}}"
        },
        pt: {
          text: "Acompanhar a minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        "pt-br": {
          text: "Rastrear minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        ro: {
          text: "Urm\u0103re\u0219te returul meu",
          href: "{{return.trackingUrl}}"
        },
        sv: {
          text: "Sp\xE5ra min retur",
          href: "{{return.trackingUrl}}"
        },
        "zh-cn": {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        "zh-tw": {
          text: "\u8FFD\u8E64\u6211\u7684\u9000\u8CA8",
          href: "{{return.trackingUrl}}"
        },
        zh: {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        it: {
          text: "Segui il mio reso",
          href: "{{return.trackingUrl}}"
        },
        nl: {
          text: "Mijn retour volgen",
          href: "{{return.trackingUrl}}"
        },
        hu: {
          text: "Visszak\xFCld\xE9sem k\xF6vet\xE9se",
          href: "{{return.trackingUrl}}"
        },
        sk: {
          text: "Sledova\u0165 moje vr\xE1tenie",
          href: "{{return.trackingUrl}}"
        },
        bg: {
          text: "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043C\u0438",
          href: "{{return.trackingUrl}}"
        }
      }
    }
  ],
  afterBlocks: [],
  defaultLocale: null
};

// src/templates/return/label-created.ts
var returnLabelCreatedEmailTemplateSubject = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returforesp\xF8rgsel for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Returforesp\xF8rselen din for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea ta de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnLabelCreatedEmailTemplatePreview = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returforesp\xF8rgsel for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Returforesp\xF8rselen din for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea ta de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnLabelCreatedEmailTemplate = {
  beforeBlocks: [],
  insideBlocks: [
    {
      id: "950a8527-95c7-418c-a80a-a3645e1cd28f",
      type: "logo",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "0d8757f6-57c1-452d-942e-5c3052932574",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "a1f4c2e7-3b9d-4e8a-b6c1-7d2e9f0a1b2c",
      type: "return-shipping-instructions-title",
      alignment: "center",
      font: null,
      properties: {},
      content: {}
    },
    {
      id: "019bedfe-bf00-4a15-a799-3f7aac36e7c9",
      type: "return-shipping-instructions",
      alignment: "center",
      font: null,
      properties: {},
      content: {}
    },
    {
      id: "7b1b43ca-e6ca-40d7-bfd8-2dbbd56063af",
      type: "return-request-date",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "d5577786-0b53-4a2a-8b14-305634122818",
      type: "return-download-label",
      alignment: "center",
      font: null,
      properties: {
        variant: "default"
      },
      content: {
        fr: {
          label: ""
        }
      }
    },
    {
      id: "ad1fcd13-76e9-44d2-9042-04a95961123c",
      type: "button",
      alignment: "center",
      font: null,
      properties: {
        variant: "outline"
      },
      content: {
        fr: {
          text: "Trouver mon point relais",
          href: "{{return.dropPointFinderUrl}}"
        },
        cs: {
          text: "Naj\xEDt podac\xED m\xEDsto",
          href: "{{return.dropPointFinderUrl}}"
        },
        da: {
          text: "Find et afleveringssted",
          href: "{{return.dropPointFinderUrl}}"
        },
        de: {
          text: "Abgabestelle finden",
          href: "{{return.dropPointFinderUrl}}"
        },
        el: {
          text: "\u0392\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C3\u03B7\u03BC\u03B5\u03AF\u03BF \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
          href: "{{return.dropPointFinderUrl}}"
        },
        en: {
          text: "Find a drop-off point",
          href: "{{return.dropPointFinderUrl}}"
        },
        es: {
          text: "Encontrar un punto de entrega",
          href: "{{return.dropPointFinderUrl}}"
        },
        fi: {
          text: "Etsi j\xE4tt\xF6piste",
          href: "{{return.dropPointFinderUrl}}"
        },
        ja: {
          text: "\u6295\u51FD\u30DD\u30A4\u30F3\u30C8\u3092\u63A2\u3059",
          href: "{{return.dropPointFinderUrl}}"
        },
        lv: {
          text: "Atrast nodo\u0161anas punktu",
          href: "{{return.dropPointFinderUrl}}"
        },
        no: {
          text: "Finn et innleveringssted",
          href: "{{return.dropPointFinderUrl}}"
        },
        pl: {
          text: "Znajd\u017A punkt nadania",
          href: "{{return.dropPointFinderUrl}}"
        },
        pt: {
          text: "Encontrar um ponto de entrega",
          href: "{{return.dropPointFinderUrl}}"
        },
        "pt-br": {
          text: "Encontrar um ponto de entrega",
          href: "{{return.dropPointFinderUrl}}"
        },
        ro: {
          text: "G\u0103se\u0219te un punct de predare",
          href: "{{return.dropPointFinderUrl}}"
        },
        sv: {
          text: "Hitta en inl\xE4mningspunkt",
          href: "{{return.dropPointFinderUrl}}"
        },
        "zh-cn": {
          text: "\u67E5\u627E\u6295\u9012\u70B9",
          href: "{{return.dropPointFinderUrl}}"
        },
        "zh-tw": {
          text: "\u5C0B\u627E\u4EA4\u4EF6\u5730\u9EDE",
          href: "{{return.dropPointFinderUrl}}"
        },
        zh: {
          text: "\u67E5\u627E\u6295\u9012\u70B9",
          href: "{{return.dropPointFinderUrl}}"
        },
        it: {
          text: "Trova il mio punto di ritiro",
          href: "{{return.dropPointFinderUrl}}"
        },
        nl: {
          text: "Mijn afhaalpunt vinden",
          href: "{{return.dropPointFinderUrl}}"
        },
        hu: {
          text: "\xC1tv\xE9teli pont keres\xE9se",
          href: "{{return.dropPointFinderUrl}}"
        },
        sk: {
          text: "N\xE1js\u0165 v\xFDdajn\xE9 miesto",
          href: "{{return.dropPointFinderUrl}}"
        },
        bg: {
          text: "\u041D\u0430\u043C\u0435\u0440\u0435\u0442\u0435 \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435",
          href: "{{return.dropPointFinderUrl}}"
        }
      }
    },
    {
      id: "8c5b9307-e723-4c0a-81a1-4027a51be6aa",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "5465fc80-081b-4c2d-bc98-3f26b19a5a58",
      type: "paragraph",
      alignment: "left",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>D\xE9tails de votre retour</strong></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti o va\u0161em vr\xE1cen\xED</strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din returnering</strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details Ihrer R\xFCcksendung</strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details of your return</strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalles de su devoluci\xF3n</strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuksesi tiedot</strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u306E\u8A73\u7D30</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas deta\u013Cas</strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om returen din</strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Szczeg\xF3\u0142y Twojego zwrotu</strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalii despre returul dvs.</strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din retur</strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u8A73\u60C5</strong></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        it: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dettagli del tuo reso</strong></p>'
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details van je retour</strong></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9s r\xE9szletei</strong></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti v\xE1\u0161ho vr\xE1tenia</strong></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0432\u0438</strong></p>'
        }
      }
    },
    {
      id: "0da83aa3-c3a0-4c8c-9f1b-5bb6a4fd8791",
      type: "return-line-items",
      alignment: "center",
      font: null,
      properties: {},
      content: null
    },
    {
      id: "94ebb720-29c1-4cd0-9c13-88c267def101",
      type: "button",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          text: "Suivre mon retour",
          href: "{{return.trackingUrl}}"
        },
        cs: {
          text: "Sledovat m\xE9 vr\xE1cen\xED",
          href: "{{return.trackingUrl}}"
        },
        da: {
          text: "Spor min returnering",
          href: "{{return.trackingUrl}}"
        },
        de: {
          text: "R\xFCcksendung verfolgen",
          href: "{{return.trackingUrl}}"
        },
        el: {
          text: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03CD\u03B8\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03BF\u03C5",
          href: "{{return.trackingUrl}}"
        },
        en: {
          text: "Track my return",
          href: "{{return.trackingUrl}}"
        },
        es: {
          text: "Seguir mi devoluci\xF3n",
          href: "{{return.trackingUrl}}"
        },
        fi: {
          text: "Seuraa palautustani",
          href: "{{return.trackingUrl}}"
        },
        ja: {
          text: "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
          href: "{{return.trackingUrl}}"
        },
        lv: {
          text: "Izsekot manu atgrie\u0161anu",
          href: "{{return.trackingUrl}}"
        },
        no: {
          text: "Spor returen min",
          href: "{{return.trackingUrl}}"
        },
        pl: {
          text: "\u015Aled\u017A m\xF3j zwrot",
          href: "{{return.trackingUrl}}"
        },
        pt: {
          text: "Acompanhar a minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        "pt-br": {
          text: "Rastrear minha devolu\xE7\xE3o",
          href: "{{return.trackingUrl}}"
        },
        ro: {
          text: "Urm\u0103re\u0219te returul meu",
          href: "{{return.trackingUrl}}"
        },
        sv: {
          text: "Sp\xE5ra min retur",
          href: "{{return.trackingUrl}}"
        },
        "zh-cn": {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        "zh-tw": {
          text: "\u8FFD\u8E64\u6211\u7684\u9000\u8CA8",
          href: "{{return.trackingUrl}}"
        },
        zh: {
          text: "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          href: "{{return.trackingUrl}}"
        },
        it: {
          text: "Segui il mio reso",
          href: "{{return.trackingUrl}}"
        },
        nl: {
          text: "Mijn retour volgen",
          href: "{{return.trackingUrl}}"
        },
        hu: {
          text: "Visszak\xFCld\xE9sem k\xF6vet\xE9se",
          href: "{{return.trackingUrl}}"
        },
        sk: {
          text: "Sledova\u0165 moje vr\xE1tenie",
          href: "{{return.trackingUrl}}"
        },
        bg: {
          text: "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043C\u0438",
          href: "{{return.trackingUrl}}"
        }
      }
    },
    {
      id: "c29392cf-5637-484d-83a1-b0574500af52",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: {},
      content: {
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Pour nous contacter : </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Ceci est un email automatique, merci de ne pas y r\xE9pondre.</em></span></p>'
        },
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontaktujte n\xE1s: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Toto je automatick\xFD e-mail, pros\xEDm neodpov\xEDdejte na n\u011Bj.</em></span></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">S\xE5dan kontakter du os: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dette er en automatisk e-mail, svar venligst ikke p\xE5 den.</em></span></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">So erreichen Sie uns: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dies ist eine automatische E-Mail, bitte antworten Sie nicht darauf.</em></span></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0391\u03C5\u03C4\u03CC \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1 \u03B1\u03C5\u03C4\u03BF\u03BC\u03B1\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF email, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03BC\u03B7\u03BD \u03B1\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5.</em></span></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">To contact us: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>This is an automated email, please do not reply.</em></span></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para contactarnos: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este es un correo autom\xE1tico, por favor no responda.</em></span></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Ota meihin yhteytt\xE4: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>T\xE4m\xE4 on automaattinen s\xE4hk\xF6posti, \xE4l\xE4 vastaa siihen.</em></span></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u304A\u554F\u3044\u5408\u308F\u305B: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u3053\u308C\u306F\u81EA\u52D5\u9001\u4FE1\u30E1\u30FC\u30EB\u3067\u3059\u3002\u8FD4\u4FE1\u306F\u3054\u9060\u616E\u304F\u3060\u3055\u3044\u3002</em></span></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Sazinieties ar mums: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0160is ir autom\u0101tisks e-pasts, l\u016Bdzu, neatbildiet uz to.</em></span></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontakt oss: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dette er en automatisk e-post, vennligst ikke svar.</em></span></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Aby si\u0119 z nami skontaktowa\u0107: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>To jest automatyczna wiadomo\u015B\u0107, prosimy na ni\u0105 nie odpowiada\u0107.</em></span></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para nos contactar: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este \xE9 um email autom\xE1tico, por favor n\xE3o responda.</em></span></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para entrar em contato: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este \xE9 um e-mail autom\xE1tico, por favor n\xE3o responda.</em></span></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Pentru a ne contacta: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Acesta este un email automat, v\u0103 rug\u0103m s\u0103 nu r\u0103spunde\u021Bi.</em></span></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontakta oss: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Detta \xE4r ett automatiskt e-postmeddelande, v\xE4nligen svara inte.</em></span></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u8054\u7CFB\u6211\u4EEC: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u8FD9\u662F\u4E00\u5C01\u81EA\u52A8\u53D1\u9001\u7684\u90AE\u4EF6\uFF0C\u8BF7\u52FF\u56DE\u590D\u3002</em></span></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u806F\u7D61\u6211\u5011: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u9019\u662F\u4E00\u5C01\u81EA\u52D5\u767C\u9001\u7684\u90F5\u4EF6\uFF0C\u8ACB\u52FF\u56DE\u8986\u3002</em></span></p>'
        },
        zh: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u8054\u7CFB\u6211\u4EEC: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u8FD9\u662F\u4E00\u5C01\u81EA\u52A8\u53D1\u9001\u7684\u90AE\u4EF6\uFF0C\u8BF7\u52FF\u56DE\u590D\u3002</em></span></p>'
        },
        it: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Per contattarci: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Questa \xE8 un'email automatica, ti preghiamo di non rispondere.</em></span></p>`
        },
        nl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Contact opnemen: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dit is een automatische e-mail, gelieve niet te antwoorden.</em></span></p>'
        },
        hu: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kapcsolatfelv\xE9tel: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Ez egy automatikus e-mail, k\xE9rj\xFCk, ne v\xE1laszoljon r\xE1.</em></span></p>'
        },
        sk: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontaktujte n\xE1s: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Toto je automatick\xFD e-mail, pros\xEDm neodpovedajte na\u0148.</em></span></p>'
        },
        bg: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u0417\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0441 \u043D\u0430\u0441: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0422\u043E\u0432\u0430 \u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u043D \u0438\u043C\u0435\u0439\u043B, \u043C\u043E\u043B\u044F \u043D\u0435 \u043E\u0442\u0433\u043E\u0432\u0430\u0440\u044F\u0439\u0442\u0435.</em></span></p>'
        }
      }
    }
  ],
  afterBlocks: [],
  defaultLocale: null
};

// src/templates/return/deposit-reminder.ts
var returnDepositReminderEmailTemplateSubject = {
  "cs": "Nezapome\u0148te odevzdat sv\u016Fj vratkov\xFD bal\xEDk",
  "da": "Husk at aflevere din returpakke",
  "de": "Vergessen Sie nicht, Ihr R\xFCcksendepaket abzugeben",
  "el": "\u039C\u03B7\u03BD \u03BE\u03B5\u03C7\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B4\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03B4\u03AD\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2",
  "en": "Don't forget to drop off your return package",
  "es": "No olvide depositar su paquete de devoluci\xF3n",
  "fi": "Muista j\xE4tt\xE4\xE4 palautuspakettisi",
  "fr": "Pensez \xE0 d\xE9poser votre colis retour",
  "ja": "\u8FD4\u54C1\u5546\u54C1\u306E\u6295\u51FD\u3092\u304A\u5FD8\u308C\u306A\u304F",
  "lv": "Neaizmirstiet nodot savu atgrie\u0161anas s\u016Bt\u012Bjumu",
  "no": "Husk \xE5 levere returpakken din",
  "pl": "Pami\u0119taj, aby nada\u0107 paczk\u0119 zwrotn\u0105",
  "pt": "N\xE3o se esque\xE7a de entregar a sua encomenda de devolu\xE7\xE3o",
  "pt-br": "N\xE3o se esque\xE7a de postar seu pacote de devolu\xE7\xE3o",
  "ro": "Nu uita\u021Bi s\u0103 depune\u021Bi coletul de retur",
  "sv": "Gl\xF6m inte att l\xE4mna in ditt returpaket",
  "zh-cn": "\u8BF7\u52FF\u5FD8\u8BB0\u6295\u9012\u60A8\u7684\u9000\u8D27\u5305\u88F9",
  "zh-tw": "\u8ACB\u52FF\u5FD8\u8A18\u6295\u905E\u60A8\u7684\u9000\u8CA8\u5305\u88F9",
  "zh": "\u8BF7\u52FF\u5FD8\u8BB0\u6295\u9012\u60A8\u7684\u9000\u8D27\u5305\u88F9",
  "it": "Pensa a depositare il tuo pacco di reso",
  "nl": "Denk eraan je retourpakket af te geven",
  "hu": "Ne feledje feladni a visszak\xFCld\xE9si csomagj\xE1t",
  "sk": "Nezabudnite odovzda\u0165 svoj vratn\xFD bal\xEDk",
  "bg": "\u041D\u0435 \u0437\u0430\u0431\u0440\u0430\u0432\u044F\u0439\u0442\u0435 \u0434\u0430 \u043F\u0440\u0435\u0434\u0430\u0434\u0435\u0442\u0435 \u0432\u044A\u0440\u043D\u0430\u0442\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430"
};
var returnDepositReminderEmailTemplatePreview = {
  "cs": "Nezapome\u0148te odevzdat sv\u016Fj vratkov\xFD bal\xEDk",
  "da": "Husk at aflevere din returpakke",
  "de": "Vergessen Sie nicht, Ihr R\xFCcksendepaket abzugeben",
  "el": "\u039C\u03B7\u03BD \u03BE\u03B5\u03C7\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B4\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03B4\u03AD\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2",
  "en": "Don't forget to drop off your return package",
  "es": "No olvide depositar su paquete de devoluci\xF3n",
  "fi": "Muista j\xE4tt\xE4\xE4 palautuspakettisi",
  "fr": "Pensez \xE0 d\xE9poser votre colis retour",
  "ja": "\u8FD4\u54C1\u5546\u54C1\u306E\u6295\u51FD\u3092\u304A\u5FD8\u308C\u306A\u304F",
  "lv": "Neaizmirstiet nodot savu atgrie\u0161anas s\u016Bt\u012Bjumu",
  "no": "Husk \xE5 levere returpakken din",
  "pl": "Pami\u0119taj, aby nada\u0107 paczk\u0119 zwrotn\u0105",
  "pt": "N\xE3o se esque\xE7a de entregar a sua encomenda de devolu\xE7\xE3o",
  "pt-br": "N\xE3o se esque\xE7a de postar seu pacote de devolu\xE7\xE3o",
  "ro": "Nu uita\u021Bi s\u0103 depune\u021Bi coletul de retur",
  "sv": "Gl\xF6m inte att l\xE4mna in ditt returpaket",
  "zh-cn": "\u8BF7\u52FF\u5FD8\u8BB0\u6295\u9012\u60A8\u7684\u9000\u8D27\u5305\u88F9",
  "zh-tw": "\u8ACB\u52FF\u5FD8\u8A18\u6295\u905E\u60A8\u7684\u9000\u8CA8\u5305\u88F9",
  "zh": "\u8BF7\u52FF\u5FD8\u8BB0\u6295\u9012\u60A8\u7684\u9000\u8D27\u5305\u88F9",
  "it": "Pensa a depositare il tuo pacco di reso",
  "nl": "Denk eraan je retourpakket af te geven",
  "hu": "Ne feledje feladni a visszak\xFCld\xE9si csomagj\xE1t",
  "sk": "Nezabudnite odovzda\u0165 svoj vratn\xFD bal\xEDk",
  "bg": "\u041D\u0435 \u0437\u0430\u0431\u0440\u0430\u0432\u044F\u0439\u0442\u0435 \u0434\u0430 \u043F\u0440\u0435\u0434\u0430\u0434\u0435\u0442\u0435 \u0432\u044A\u0440\u043D\u0430\u0442\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430"
};
var returnDepositReminderEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "ca305efd-9988-4e24-b390-ec72d782236b",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "33dcabc9-e1a1-42c4-a247-9369f0090073",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "c4959c96-2c53-4d4f-b7fc-bcbf9d2297ca",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Pensez \xE0 d\xE9poser votre colis retour</strong></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Vergessen Sie nicht, Ihr R\xFCcksendepaket abzugeben</strong></p>'
        },
        "en": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Don't forget to drop off your return package</strong></p>`
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>No olvide depositar su paquete de devoluci\xF3n</strong></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u5546\u54C1\u306E\u6295\u51FD\u3092\u304A\u5FD8\u308C\u306A\u304F</strong></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8BF7\u52FF\u5FD8\u8BB0\u6295\u9012\u60A8\u7684\u9000\u8D27\u5305\u88F9</strong></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Nezapome\u0148te odevzdat sv\u016Fj vratkov\xFD bal\xEDk</strong></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Husk at aflevere din returpakke</strong></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u039C\u03B7\u03BD \u03BE\u03B5\u03C7\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B4\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03B4\u03AD\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Muista j\xE4tt\xE4\xE4 palautuspakettisi</strong></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Neaizmirstiet nodot savu atgrie\u0161anas s\u016Bt\u012Bjumu</strong></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Husk \xE5 levere returpakken din</strong></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Pami\u0119taj, aby nada\u0107 paczk\u0119 zwrotn\u0105</strong></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>N\xE3o se esque\xE7a de entregar a sua encomenda de devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>N\xE3o se esque\xE7a de postar seu pacote de devolu\xE7\xE3o</strong></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Nu uita\u021Bi s\u0103 depune\u021Bi coletul de retur</strong></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Gl\xF6m inte att l\xE4mna in ditt returpaket</strong></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8ACB\u52FF\u5FD8\u8A18\u6295\u905E\u60A8\u7684\u9000\u8CA8\u5305\u88F9</strong></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8BF7\u52FF\u5FD8\u8BB0\u6295\u9012\u60A8\u7684\u9000\u8D27\u5305\u88F9</strong></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Pensa a depositare il tuo pacco di reso</strong></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Denk eraan je retourpakket af te geven</strong></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ne feledje feladni a visszak\xFCld\xE9si csomagj\xE1t</strong></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Nezabudnite odovzda\u0165 svoj vratn\xFD bal\xEDk</strong></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u041D\u0435 \u0437\u0430\u0431\u0440\u0430\u0432\u044F\u0439\u0442\u0435 \u0434\u0430 \u043F\u0440\u0435\u0434\u0430\u0434\u0435\u0442\u0435 \u0432\u044A\u0440\u043D\u0430\u0442\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430</strong></p>'
        }
      }
    },
    {
      "id": "15bb884c-919a-4f05-a72b-11852331fd0d",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Vous avez g\xE9n\xE9r\xE9 votre \xE9tiquette de retour mais nous n'avons pas encore re\xE7u votre colis. Pensez \xE0 le d\xE9poser rapidement pour que nous puissions traiter votre demande.</p>`
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Vytvo\u0159ili jste vratkov\xFD \u0161t\xEDtek, ale va\u0161i z\xE1silku jsme zat\xEDm neobdr\u017Eeli. Odevzdejte ji co nejd\u0159\xEDve, abychom mohli zpracovat va\u0161i \u017E\xE1dost.</p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Du har genereret din returlabel, men vi har endnu ikke modtaget din pakke. Aflever den snart, s\xE5 vi kan behandle din anmodning.</p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Sie haben Ihr R\xFCcksendeetikett erstellt, aber wir haben Ihr Paket noch nicht erhalten. Bitte geben Sie es bald ab, damit wir Ihre Anfrage bearbeiten k\xF6nnen.</p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B1\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2, \u03B1\u03BB\u03BB\u03AC \u03B4\u03B5\u03BD \u03AD\u03C7\u03BF\u03C5\u03BC\u03B5 \u03BB\u03AC\u03B2\u03B5\u03B9 \u03B1\u03BA\u03CC\u03BC\u03B7 \u03C4\u03BF \u03B4\u03AD\u03BC\u03B1 \u03C3\u03B1\u03C2. \u03A0\u03B1\u03C1\u03B1\u03B4\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1 \u03CE\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03AC \u03C3\u03B1\u03C2.</p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">You have generated your return label but we have not received your package yet. Please drop it off soon so we can process your request.</p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Ha generado su etiqueta de devoluci\xF3n, pero a\xFAn no hemos recibido su paquete. Depos\xEDtelo pronto para que podamos procesar su solicitud.</p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Olet luonut palautustarran, mutta emme ole viel\xE4 vastaanottaneet pakettiasi. J\xE4t\xE4 se pian, jotta voimme k\xE4sitell\xE4 pyynt\xF6si.</p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u8FD4\u54C1\u30E9\u30D9\u30EB\u3092\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u304C\u3001\u307E\u3060\u304A\u8377\u7269\u304C\u5C4A\u3044\u3066\u3044\u307E\u305B\u3093\u3002\u304A\u65E9\u3081\u306B\u304A\u9810\u3051\u3044\u305F\u3060\u304D\u3001\u304A\u624B\u7D9A\u304D\u3092\u9032\u3081\u3089\u308C\u308B\u3088\u3046\u3054\u5354\u529B\u304F\u3060\u3055\u3044\u3002</p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">J\u016Bs izveidoj\u0101t atgrie\u0161anas uzl\u012Bmi, bet m\u0113s v\u0113l neesam sa\u0146\u0113mu\u0161i j\u016Bsu s\u016Bt\u012Bjumu. L\u016Bdzu, nododiet to dr\u012Bzum\u0101, lai m\u0113s var\u0113tu apstr\u0101d\u0101t j\u016Bsu piepras\u012Bjumu.</p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Du har generert returetiketten din, men vi har ikke mottatt pakken din enn\xE5. Lever den snart s\xE5 vi kan behandle foresp\xF8rselen din.</p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Wygenerowa\u0142e\u015B etykiet\u0119 zwrotn\u0105, ale nie otrzymali\u015Bmy jeszcze Twojej paczki. Nadaj j\u0105 wkr\xF3tce, aby\u015Bmy mogli przetworzy\u0107 Twoje zg\u0142oszenie.</p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Gerou a sua etiqueta de devolu\xE7\xE3o, mas ainda n\xE3o recebemos a sua encomenda. Deposite-a em breve para que possamos processar o seu pedido.</p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Voc\xEA gerou sua etiqueta de devolu\xE7\xE3o, mas ainda n\xE3o recebemos seu pacote. Poste-o em breve para que possamos processar sua solicita\xE7\xE3o.</p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">A\u021Bi generat eticheta de retur, dar \xEEnc\u0103 nu am primit coletul. V\u0103 rug\u0103m s\u0103 \xEEl depune\u021Bi \xEEn cur\xE2nd pentru a putea procesa cererea.</p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Du har skapat din returetikett, men vi har inte tagit emot ditt paket \xE4nnu. L\xE4mna in det snart s\xE5 att vi kan behandla din beg\xE4ran.</p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u60A8\u5DF2\u751F\u6210\u9000\u8D27\u6807\u7B7E\uFF0C\u4F46\u6211\u4EEC\u5C1A\u672A\u6536\u5230\u60A8\u7684\u5305\u88F9\u3002\u8BF7\u5C3D\u5FEB\u6295\u9012\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u5904\u7406\u60A8\u7684\u8BF7\u6C42\u3002</p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u60A8\u5DF2\u7522\u751F\u9000\u8CA8\u6A19\u7C64\uFF0C\u4F46\u6211\u5011\u5C1A\u672A\u6536\u5230\u60A8\u7684\u5305\u88F9\u3002\u8ACB\u76E1\u5FEB\u6295\u905E\uFF0C\u4EE5\u4FBF\u6211\u5011\u8655\u7406\u60A8\u7684\u8ACB\u6C42\u3002</p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u60A8\u5DF2\u751F\u6210\u9000\u8D27\u6807\u7B7E\uFF0C\u4F46\u6211\u4EEC\u5C1A\u672A\u6536\u5230\u60A8\u7684\u5305\u88F9\u3002\u8BF7\u5C3D\u5FEB\u6295\u9012\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u5904\u7406\u60A8\u7684\u8BF7\u6C42\u3002</p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Hai generato la tua etichetta di reso ma non abbiamo ancora ricevuto il tuo pacco. Ricordati di consegnarlo presto cos\xEC possiamo elaborare la tua richiesta.</p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Je hebt je retourlabel aangemaakt, maar we hebben je pakket nog niet ontvangen. Geef het snel af zodat we je aanvraag kunnen verwerken.</p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">L\xE9trehozta a visszak\xFCld\xE9si c\xEDmk\xE9t, de a csomagj\xE1t m\xE9g nem kaptuk meg. K\xE9rj\xFCk, adja le miel\u0151bb, hogy feldolgozhassuk a k\xE9r\xE9s\xE9t.</p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Vytvorili ste si vratn\xFA etiketu, ale va\u0161u z\xE1sielku sme zatia\u013E nedostali. Odovzdajte ju \u010Do najsk\xF4r, aby sme mohli spracova\u0165 va\u0161u \u017Eiados\u0165.</p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u0421\u044A\u0437\u0434\u0430\u0434\u043E\u0445\u0442\u0435 \u0435\u0442\u0438\u043A\u0435\u0442\u0430 \u0441\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435, \u043D\u043E \u0432\u0441\u0435 \u043E\u0449\u0435 \u043D\u0435 \u0441\u043C\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0432\u0438. \u041C\u043E\u043B\u044F, \u043F\u0440\u0435\u0434\u0430\u0439\u0442\u0435 \u044F \u0441\u043A\u043E\u0440\u043E, \u0437\u0430 \u0434\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0438\u043C \u0437\u0430\u044F\u0432\u043A\u0430\u0442\u0430 \u0432\u0438.</p>'
        }
      }
    },
    {
      "id": "9a4a8aa8-8504-40c2-a36d-01bf10bc8cdf",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "type": "return-download-label",
      "alignment": "center",
      "properties": {},
      "id": "c6cb4c92-c742-4f64-9df3-a6573be61219"
    },
    {
      "id": "3027d047-5628-408c-ad1a-9f8a821ad296",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>D\xE9tails de votre retour</strong></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti o va\u0161em vr\xE1cen\xED</strong></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din returnering</strong></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details Ihrer R\xFCcksendung</strong></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details of your return</strong></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalles de su devoluci\xF3n</strong></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuksesi tiedot</strong></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u306E\u8A73\u7D30</strong></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas deta\u013Cas</strong></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om returen din</strong></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Szczeg\xF3\u0142y Twojego zwrotu</strong></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalii despre returul dvs.</strong></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din retur</strong></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u8A73\u60C5</strong></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dettagli del tuo reso</strong></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details van je retour</strong></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9s r\xE9szletei</strong></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti v\xE1\u0161ho vr\xE1tenia</strong></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0432\u0438</strong></p>'
        }
      }
    },
    {
      "id": "f7aeb83c-e4e5-4f3d-875a-b7e3f2996e9f",
      "type": "return-line-items",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "94ebb720-29c1-4cd0-9c13-88c267def101",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "text": "Suivre mon retour",
          "href": "{{return.trackingUrl}}"
        },
        "cs": {
          "text": "Sledovat m\xE9 vr\xE1cen\xED",
          "href": "{{return.trackingUrl}}"
        },
        "da": {
          "text": "Spor min returnering",
          "href": "{{return.trackingUrl}}"
        },
        "de": {
          "text": "R\xFCcksendung verfolgen",
          "href": "{{return.trackingUrl}}"
        },
        "el": {
          "text": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03CD\u03B8\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03BF\u03C5",
          "href": "{{return.trackingUrl}}"
        },
        "en": {
          "text": "Track my return",
          "href": "{{return.trackingUrl}}"
        },
        "es": {
          "text": "Seguir mi devoluci\xF3n",
          "href": "{{return.trackingUrl}}"
        },
        "fi": {
          "text": "Seuraa palautustani",
          "href": "{{return.trackingUrl}}"
        },
        "ja": {
          "text": "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "{{return.trackingUrl}}"
        },
        "lv": {
          "text": "Izsekot manu atgrie\u0161anu",
          "href": "{{return.trackingUrl}}"
        },
        "no": {
          "text": "Spor returen min",
          "href": "{{return.trackingUrl}}"
        },
        "pl": {
          "text": "\u015Aled\u017A m\xF3j zwrot",
          "href": "{{return.trackingUrl}}"
        },
        "pt": {
          "text": "Acompanhar a minha devolu\xE7\xE3o",
          "href": "{{return.trackingUrl}}"
        },
        "pt-br": {
          "text": "Rastrear minha devolu\xE7\xE3o",
          "href": "{{return.trackingUrl}}"
        },
        "ro": {
          "text": "Urm\u0103re\u0219te returul meu",
          "href": "{{return.trackingUrl}}"
        },
        "sv": {
          "text": "Sp\xE5ra min retur",
          "href": "{{return.trackingUrl}}"
        },
        "zh-cn": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          "href": "{{return.trackingUrl}}"
        },
        "zh-tw": {
          "text": "\u8FFD\u8E64\u6211\u7684\u9000\u8CA8",
          "href": "{{return.trackingUrl}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          "href": "{{return.trackingUrl}}"
        },
        "it": {
          "text": "Segui il mio reso",
          "href": "{{return.trackingUrl}}"
        },
        "nl": {
          "text": "Mijn retour volgen",
          "href": "{{return.trackingUrl}}"
        },
        "hu": {
          "text": "Visszak\xFCld\xE9sem k\xF6vet\xE9se",
          "href": "{{return.trackingUrl}}"
        },
        "sk": {
          "text": "Sledova\u0165 moje vr\xE1tenie",
          "href": "{{return.trackingUrl}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043C\u0438",
          "href": "{{return.trackingUrl}}"
        }
      }
    },
    {
      "id": "c29392cf-5637-484d-83a1-b0574500af52",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Pour nous contacter : </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Ceci est un email automatique, merci de ne pas y r\xE9pondre.</em></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontaktujte n\xE1s: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Toto je automatick\xFD e-mail, pros\xEDm neodpov\xEDdejte na n\u011Bj.</em></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">S\xE5dan kontakter du os: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dette er en automatisk e-mail, svar venligst ikke p\xE5 den.</em></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">So erreichen Sie uns: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dies ist eine automatische E-Mail, bitte antworten Sie nicht darauf.</em></span></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0391\u03C5\u03C4\u03CC \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1 \u03B1\u03C5\u03C4\u03BF\u03BC\u03B1\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF email, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03BC\u03B7\u03BD \u03B1\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5.</em></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">To contact us: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>This is an automated email, please do not reply.</em></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para contactarnos: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este es un correo autom\xE1tico, por favor no responda.</em></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Ota meihin yhteytt\xE4: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>T\xE4m\xE4 on automaattinen s\xE4hk\xF6posti, \xE4l\xE4 vastaa siihen.</em></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u304A\u554F\u3044\u5408\u308F\u305B: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u3053\u308C\u306F\u81EA\u52D5\u9001\u4FE1\u30E1\u30FC\u30EB\u3067\u3059\u3002\u8FD4\u4FE1\u306F\u3054\u9060\u616E\u304F\u3060\u3055\u3044\u3002</em></span></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Sazinieties ar mums: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0160is ir autom\u0101tisks e-pasts, l\u016Bdzu, neatbildiet uz to.</em></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontakt oss: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dette er en automatisk e-post, vennligst ikke svar.</em></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Aby si\u0119 z nami skontaktowa\u0107: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>To jest automatyczna wiadomo\u015B\u0107, prosimy na ni\u0105 nie odpowiada\u0107.</em></span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para nos contactar: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este \xE9 um email autom\xE1tico, por favor n\xE3o responda.</em></span></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para entrar em contato: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este \xE9 um e-mail autom\xE1tico, por favor n\xE3o responda.</em></span></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Pentru a ne contacta: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Acesta este un email automat, v\u0103 rug\u0103m s\u0103 nu r\u0103spunde\u021Bi.</em></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontakta oss: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Detta \xE4r ett automatiskt e-postmeddelande, v\xE4nligen svara inte.</em></span></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u8054\u7CFB\u6211\u4EEC: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u8FD9\u662F\u4E00\u5C01\u81EA\u52A8\u53D1\u9001\u7684\u90AE\u4EF6\uFF0C\u8BF7\u52FF\u56DE\u590D\u3002</em></span></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u806F\u7D61\u6211\u5011: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u9019\u662F\u4E00\u5C01\u81EA\u52D5\u767C\u9001\u7684\u90F5\u4EF6\uFF0C\u8ACB\u52FF\u56DE\u8986\u3002</em></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u8054\u7CFB\u6211\u4EEC: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u8FD9\u662F\u4E00\u5C01\u81EA\u52A8\u53D1\u9001\u7684\u90AE\u4EF6\uFF0C\u8BF7\u52FF\u56DE\u590D\u3002</em></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Per contattarci: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Questa \xE8 un'email automatica, ti preghiamo di non rispondere.</em></span></p>`
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Contact opnemen: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dit is een automatische e-mail, gelieve niet te antwoorden.</em></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kapcsolatfelv\xE9tel: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Ez egy automatikus e-mail, k\xE9rj\xFCk, ne v\xE1laszoljon r\xE1.</em></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontaktujte n\xE1s: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Toto je automatick\xFD e-mail, pros\xEDm neodpovedajte na\u0148.</em></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u0417\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0441 \u043D\u0430\u0441: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0422\u043E\u0432\u0430 \u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u043D \u0438\u043C\u0435\u0439\u043B, \u043C\u043E\u043B\u044F \u043D\u0435 \u043E\u0442\u0433\u043E\u0432\u0430\u0440\u044F\u0439\u0442\u0435.</em></span></p>'
        }
      }
    }
  ],
  "afterBlocks": [],
  "defaultLocale": null
};

// src/templates/return/rejected.ts
var returnRejectedEmailTemplateSubject = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returforesp\xF8rgsel for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Returforesp\xF8rselen din for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea ta de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnRejectedEmailTemplatePreview = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returforesp\xF8rgsel for ordre {{return.orderName}}",
  "de": "Ihre R\xFCcksendeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Returforesp\xF8rselen din for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea ta de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnRejectedEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "ret-approved-logo",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {
        "size": "medium"
      },
      "content": null
    },
    {
      "id": "ret-approved-sep-1",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ret-approved-heading",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Votre demande de retour a \xE9t\xE9 rejet\xE9e</strong></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Your return request has been rejected</strong></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161e \u017E\xE1dost o vr\xE1cen\xED byla zam\xEDtnuta</strong></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returanmodning er blevet afvist</strong></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ihre R\xFCcksendeanfrage wurde abgelehnt</strong></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B1\u03C0\u03BF\u03C1\u03C1\u03AF\u03C6\u03B8\u03B7\u03BA\u03B5</strong></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Su solicitud de devoluci\xF3n ha sido rechazada</strong></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuspyynt\xF6si on hyl\xE4tty</strong></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5374\u4E0B\u3055\u308C\u307E\u3057\u305F</strong></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas piepras\u012Bjums ir noraid\u012Bts</strong></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Returforesp\xF8rselen din er avsl\xE5tt</strong></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Twoje zg\u0142oszenie zwrotu zosta\u0142o odrzucone</strong></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>O seu pedido de devolu\xE7\xE3o foi rejeitado</strong></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Sua solicita\xE7\xE3o de devolu\xE7\xE3o foi rejeitada</strong></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Cererea ta de retur a fost respins\u0103</strong></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returf\xF6rfr\xE5gan har avvisats</strong></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u5DF2\u88AB\u62D2\u7EDD</strong></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u7533\u8ACB\u5DF2\u88AB\u62D2\u7D55</strong></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u5DF2\u88AB\u62D2\u7EDD</strong></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>La tua richiesta di reso \xE8 stata rifiutata</strong></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Je retouraanvraag is afgewezen</strong></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9si k\xE9r\xE9s\xE9t elutas\xEDtottuk</strong></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161a \u017Eiados\u0165 o vr\xE1tenie bola zamietnut\xE1</strong></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0431\u0435\u0448\u0435 \u043E\u0442\u0445\u0432\u044A\u0440\u043B\u0435\u043D\u0430</strong></p>'
        }
      }
    },
    {
      "id": "ret-approved-body",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Nous avons bien trait\xE9 votre demande de retour. Malheureusement, les articles ci-dessous ont \xE9t\xE9 rejet\xE9s.</span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">We have processed your return request. Unfortunately, the items listed below have been rejected.</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Zpracovali jsme va\u0161i \u017E\xE1dost o vr\xE1cen\xED. Bohu\u017Eel n\xED\u017Ee uveden\xE9 polo\u017Eky byly zam\xEDtnuty.</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Vi har behandlet din returanmodning. Desv\xE6rre er varerne nedenfor blevet afvist.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Wir haben Ihre R\xFCcksendeanfrage bearbeitet. Leider wurden die unten aufgef\xFChrten Artikel abgelehnt.</span></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03AE\u03BA\u03B1\u03BC\u03B5 \u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2. \u0394\u03C5\u03C3\u03C4\u03C5\u03C7\u03CE\u03C2, \u03C4\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03B5\u03AF\u03B4\u03B7 \u03B1\u03C0\u03BF\u03C1\u03C1\u03AF\u03C6\u03B8\u03B7\u03BA\u03B1\u03BD.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Hemos procesado su solicitud de devoluci\xF3n. Lamentablemente, los art\xEDculos listados a continuaci\xF3n han sido rechazados.</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Olemme k\xE4sitelleet palautuspyynt\xF6si. Valitettavasti alla olevat tuotteet on hyl\xE4tty.</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u51E6\u7406\u3044\u305F\u3057\u307E\u3057\u305F\u3002\u6B8B\u5FF5\u306A\u304C\u3089\u3001\u4EE5\u4E0B\u306E\u5546\u54C1\u306F\u5374\u4E0B\u3055\u308C\u307E\u3057\u305F\u3002</span></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">M\u0113s esam apstr\u0101d\u0101ju\u0161i j\u016Bsu atgrie\u0161anas piepras\u012Bjumu. Diem\u017E\u0113l zem\u0101k uzskait\u012Btie priek\u0161meti tika noraid\u012Bti.</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Vi har behandlet returforesp\xF8rselen din. Dessverre er varene nedenfor avsl\xE5tt.</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Rozpatrzyli\u015Bmy Twoje zg\u0142oszenie zwrotu. Niestety, poni\u017Csze artyku\u0142y zosta\u0142y odrzucone.</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Process\xE1mos o seu pedido de devolu\xE7\xE3o. Infelizmente, os artigos listados abaixo foram rejeitados.</span></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Processamos sua solicita\xE7\xE3o de devolu\xE7\xE3o. Infelizmente, os itens listados abaixo foram rejeitados.</span></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Am procesat cererea ta de retur. Din p\u0103cate, articolele de mai jos au fost respinse.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Vi har behandlat din returf\xF6rfr\xE5gan. Tyv\xE4rr har artiklarna nedan avvisats.</span></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u4EEC\u5DF2\u5904\u7406\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u3002\u5F88\u9057\u61BE\uFF0C\u4EE5\u4E0B\u5546\u54C1\u5DF2\u88AB\u62D2\u7EDD\u3002</span></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u5011\u5DF2\u8655\u7406\u60A8\u7684\u9000\u8CA8\u7533\u8ACB\u3002\u5F88\u907A\u61BE\uFF0C\u4EE5\u4E0B\u5546\u54C1\u5DF2\u88AB\u62D2\u7D55\u3002</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u6211\u4EEC\u5DF2\u5904\u7406\u60A8\u7684\u9000\u8D27\u7533\u8BF7\u3002\u5F88\u9057\u61BE\uFF0C\u4EE5\u4E0B\u5546\u54C1\u5DF2\u88AB\u62D2\u7EDD\u3002</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Abbiamo elaborato la tua richiesta di reso. Purtroppo, gli articoli qui sotto sono stati rifiutati.</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">We hebben je retouraanvraag verwerkt. Helaas zijn de onderstaande artikelen afgewezen.</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Feldolgoztuk a visszak\xFCld\xE9si k\xE9r\xE9s\xE9t. Sajnos az al\xE1bbi term\xE9keket elutas\xEDtottuk.</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">Spracovali sme va\u0161u \u017Eiados\u0165 o vr\xE1tenie. \u017Dia\u013E, ni\u017E\u0161ie uveden\xE9 polo\u017Eky boli zamietnut\xE9.</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 16px;">\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u0438\u0445\u043C\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435. \u0417\u0430 \u0441\u044A\u0436\u0430\u043B\u0435\u043D\u0438\u0435 \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u0438\u0442\u0435 \u043F\u043E-\u0434\u043E\u043B\u0443 \u0431\u044F\u0445\u0430 \u043E\u0442\u0445\u0432\u044A\u0440\u043B\u0435\u043D\u0438.</span></p>'
        }
      }
    },
    {
      "id": "ret-approved-sep-2",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "default"
      },
      "content": null
    },
    {
      "id": "ret-approved-summary-title",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": null,
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Articles rejet\xE9s</strong></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Rejected items</strong></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Zam\xEDtnut\xE9 polo\u017Eky</strong></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Afviste varer</strong></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Abgelehnte Artikel</strong></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0391\u03C0\u03BF\u03C1\u03C1\u03B9\u03C6\u03B8\u03AD\u03BD\u03C4\u03B1 \u03B5\u03AF\u03B4\u03B7</strong></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Art\xEDculos rechazados</strong></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Hyl\xE4tyt tuotteet</strong></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u5374\u4E0B\u3055\u308C\u305F\u5546\u54C1</strong></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Noraid\u012Btie priek\u0161meti</strong></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Avsl\xE5tte varer</strong></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Odrzucone artyku\u0142y</strong></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Artigos rejeitados</strong></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Itens rejeitados</strong></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Articole respinse</strong></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Avvisade artiklar</strong></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u88AB\u62D2\u7EDD\u7684\u5546\u54C1</strong></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u88AB\u62D2\u7D55\u7684\u5546\u54C1</strong></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u88AB\u62D2\u7EDD\u7684\u5546\u54C1</strong></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Articoli rifiutati</strong></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Afgewezen artikelen</strong></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Elutas\xEDtott term\xE9kek</strong></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Zamietnut\xE9 polo\u017Eky</strong></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u0435\u043D\u0438 \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u0438</strong></p>'
        }
      }
    },
    {
      "id": "ret-approved-items",
      "type": "return-line-items",
      "alignment": "left",
      "font": null,
      "properties": {
        "hidePrices": false
      },
      "content": null
    },
    {
      "id": "ret-approved-cta",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "default"
      },
      "content": {
        "fr": {
          "text": "Suivre mon retour",
          "href": "{{return.trackingUrl}}"
        },
        "en": {
          "text": "Track my return",
          "href": "{{return.trackingUrl}}"
        },
        "cs": {
          "text": "Sledovat m\xE9 vr\xE1cen\xED",
          "href": "{{return.trackingUrl}}"
        },
        "da": {
          "text": "Spor min returnering",
          "href": "{{return.trackingUrl}}"
        },
        "de": {
          "text": "R\xFCcksendung verfolgen",
          "href": "{{return.trackingUrl}}"
        },
        "el": {
          "text": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03CD\u03B8\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03BF\u03C5",
          "href": "{{return.trackingUrl}}"
        },
        "es": {
          "text": "Seguir mi devoluci\xF3n",
          "href": "{{return.trackingUrl}}"
        },
        "fi": {
          "text": "Seuraa palautustani",
          "href": "{{return.trackingUrl}}"
        },
        "ja": {
          "text": "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "{{return.trackingUrl}}"
        },
        "lv": {
          "text": "Izsekot manu atgrie\u0161anu",
          "href": "{{return.trackingUrl}}"
        },
        "no": {
          "text": "Spor returen min",
          "href": "{{return.trackingUrl}}"
        },
        "pl": {
          "text": "\u015Aled\u017A m\xF3j zwrot",
          "href": "{{return.trackingUrl}}"
        },
        "pt": {
          "text": "Acompanhar a minha devolu\xE7\xE3o",
          "href": "{{return.trackingUrl}}"
        },
        "pt-br": {
          "text": "Rastrear minha devolu\xE7\xE3o",
          "href": "{{return.trackingUrl}}"
        },
        "ro": {
          "text": "Urm\u0103re\u0219te returul meu",
          "href": "{{return.trackingUrl}}"
        },
        "sv": {
          "text": "Sp\xE5ra min retur",
          "href": "{{return.trackingUrl}}"
        },
        "zh-cn": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          "href": "{{return.trackingUrl}}"
        },
        "zh-tw": {
          "text": "\u8FFD\u8E64\u6211\u7684\u9000\u8CA8",
          "href": "{{return.trackingUrl}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          "href": "{{return.trackingUrl}}"
        },
        "it": {
          "text": "Segui il mio reso",
          "href": "{{return.trackingUrl}}"
        },
        "nl": {
          "text": "Mijn retour volgen",
          "href": "{{return.trackingUrl}}"
        },
        "hu": {
          "text": "Visszak\xFCld\xE9sem k\xF6vet\xE9se",
          "href": "{{return.trackingUrl}}"
        },
        "sk": {
          "text": "Sledova\u0165 moje vr\xE1tenie",
          "href": "{{return.trackingUrl}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043C\u0438",
          "href": "{{return.trackingUrl}}"
        }
      }
    },
    {
      "id": "c29392cf-5637-484d-83a1-b0574500af52",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Pour nous contacter : </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Ceci est un email automatique, merci de ne pas y r\xE9pondre.</em></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontaktujte n\xE1s: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Toto je automatick\xFD e-mail, pros\xEDm neodpov\xEDdejte na n\u011Bj.</em></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">S\xE5dan kontakter du os: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dette er en automatisk e-mail, svar venligst ikke p\xE5 den.</em></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">So erreichen Sie uns: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dies ist eine automatische E-Mail, bitte antworten Sie nicht darauf.</em></span></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0391\u03C5\u03C4\u03CC \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1 \u03B1\u03C5\u03C4\u03BF\u03BC\u03B1\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF email, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03BC\u03B7\u03BD \u03B1\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5.</em></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">To contact us: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>This is an automated email, please do not reply.</em></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para contactarnos: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este es un correo autom\xE1tico, por favor no responda.</em></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Ota meihin yhteytt\xE4: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>T\xE4m\xE4 on automaattinen s\xE4hk\xF6posti, \xE4l\xE4 vastaa siihen.</em></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u304A\u554F\u3044\u5408\u308F\u305B: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u3053\u308C\u306F\u81EA\u52D5\u9001\u4FE1\u30E1\u30FC\u30EB\u3067\u3059\u3002\u8FD4\u4FE1\u306F\u3054\u9060\u616E\u304F\u3060\u3055\u3044\u3002</em></span></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Sazinieties ar mums: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0160is ir autom\u0101tisks e-pasts, l\u016Bdzu, neatbildiet uz to.</em></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontakt oss: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dette er en automatisk e-post, vennligst ikke svar.</em></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Aby si\u0119 z nami skontaktowa\u0107: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>To jest automatyczna wiadomo\u015B\u0107, prosimy na ni\u0105 nie odpowiada\u0107.</em></span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para nos contactar: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este \xE9 um email autom\xE1tico, por favor n\xE3o responda.</em></span></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Para entrar em contato: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Este \xE9 um e-mail autom\xE1tico, por favor n\xE3o responda.</em></span></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Pentru a ne contacta: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Acesta este un email automat, v\u0103 rug\u0103m s\u0103 nu r\u0103spunde\u021Bi.</em></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontakta oss: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Detta \xE4r ett automatiskt e-postmeddelande, v\xE4nligen svara inte.</em></span></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u8054\u7CFB\u6211\u4EEC: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u8FD9\u662F\u4E00\u5C01\u81EA\u52A8\u53D1\u9001\u7684\u90AE\u4EF6\uFF0C\u8BF7\u52FF\u56DE\u590D\u3002</em></span></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u806F\u7D61\u6211\u5011: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u9019\u662F\u4E00\u5C01\u81EA\u52D5\u767C\u9001\u7684\u90F5\u4EF6\uFF0C\u8ACB\u52FF\u56DE\u8986\u3002</em></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u8054\u7CFB\u6211\u4EEC: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u8FD9\u662F\u4E00\u5C01\u81EA\u52A8\u53D1\u9001\u7684\u90AE\u4EF6\uFF0C\u8BF7\u52FF\u56DE\u590D\u3002</em></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Per contattarci: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Questa \xE8 un'email automatica, ti preghiamo di non rispondere.</em></span></p>`
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Contact opnemen: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Dit is een automatische e-mail, gelieve niet te antwoorden.</em></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kapcsolatfelv\xE9tel: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Ez egy automatikus e-mail, k\xE9rj\xFCk, ne v\xE1laszoljon r\xE1.</em></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">Kontaktujte n\xE1s: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>Toto je automatick\xFD e-mail, pros\xEDm neodpovedajte na\u0148.</em></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(107, 114, 128); font-size: 12px;">\u0417\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0441 \u043D\u0430\u0441: </span><a target="_blank" rel="noopener noreferrer nofollow" class="underline text-foreground" href="{{shop.contactLink}}"><span style="color: rgb(107, 114, 128); font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.contactLink" data-label="Lien de contact du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Lien de contact du shop</span></span></a></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(156, 163, 175); font-size: 12px;"><em>\u0422\u043E\u0432\u0430 \u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u043D \u0438\u043C\u0435\u0439\u043B, \u043C\u043E\u043B\u044F \u043D\u0435 \u043E\u0442\u0433\u043E\u0432\u0430\u0440\u044F\u0439\u0442\u0435.</em></span></p>'
        }
      }
    }
  ],
  "afterBlocks": [],
  "defaultLocale": "fr"
};

// src/templates/return/approved.ts
var returnApprovedEmailTemplateSubject = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returforesp\xF8rgsel for ordre {{return.orderName}}",
  "de": "Ihre R\xFCckgabeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Returforesp\xF8rselen din for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea ta de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnApprovedEmailTemplatePreview = {
  "cs": "Va\u0161e \u017E\xE1dost o vr\xE1cen\xED objedn\xE1vky {{return.orderName}}",
  "da": "Din returforesp\xF8rgsel for ordre {{return.orderName}}",
  "de": "Ihre R\xFCckgabeanfrage f\xFCr Bestellung {{return.orderName}}",
  "el": "\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your return request for order {{return.orderName}}",
  "es": "Su solicitud de devoluci\xF3n del pedido {{return.orderName}}",
  "fi": "Palautuspyynt\xF6si tilaukselle {{return.orderName}}",
  "fr": "Votre demande de retour pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8",
  "lv": "J\u016Bsu atgrie\u0161anas piepras\u012Bjums pas\u016Bt\u012Bjumam {{return.orderName}}",
  "no": "Returforesp\xF8rselen din for ordre {{return.orderName}}",
  "pl": "Twoje zg\u0142oszenie zwrotu zam\xF3wienia {{return.orderName}}",
  "pt": "O seu pedido de devolu\xE7\xE3o {{return.orderName}}",
  "pt-br": "Sua solicita\xE7\xE3o de devolu\xE7\xE3o do pedido {{return.orderName}}",
  "ro": "Cererea ta de retur pentru comanda {{return.orderName}}",
  "sv": "Din returf\xF6rfr\xE5gan f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "zh-tw": "\u60A8\u7684\u9000\u8CA8\u7533\u8ACB {{return.orderName}}",
  "zh": "\u60A8\u7684\u9000\u8D27\u7533\u8BF7 {{return.orderName}}",
  "it": "La tua richiesta di reso per l'ordine {{return.orderName}}",
  "nl": "Je retouraanvraag voor bestelling {{return.orderName}}",
  "hu": "Visszak\xFCld\xE9si k\xE9r\xE9se a(z) {{return.orderName}} rendel\xE9shez",
  "sk": "Va\u0161a \u017Eiados\u0165 o vr\xE1tenie objedn\xE1vky {{return.orderName}}",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0437\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{return.orderName}}"
};
var returnApprovedEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "ret-approved-logo",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {
        "size": "medium"
      },
      "content": null
    },
    {
      "id": "ret-approved-sep-1",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ret-approved-heading",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Votre demande de retour a bien \xE9t\xE9 trait\xE9e !</strong></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Your return request</strong></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161e \u017E\xE1dost o vr\xE1cen\xED</strong></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returforesp\xF8rgsel</strong></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ihr R\xFCckgabewunsch</strong></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Su solicitud de devoluci\xF3n</strong></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuspyynt\xF6si</strong></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8</strong></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas piepras\u012Bjums</strong></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Returforesp\xF8rselen din</strong></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Twoje zg\u0142oszenie zwrotu</strong></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>O seu pedido de devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Sua solicita\xE7\xE3o de devolu\xE7\xE3o</strong></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Cererea ta de retur</strong></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din returf\xF6rfr\xE5gan</strong></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7</strong></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u7533\u8ACB</strong></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u7533\u8BF7</strong></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>La tua richiesta di reso \xE8 stata elaborata!</strong></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Je retouraanvraag is verwerkt!</strong></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9si k\xE9r\xE9s\xE9t feldolgoztuk!</strong></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Va\u0161a \u017Eiados\u0165 o vr\xE1tenie bola spracovan\xE1!</strong></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0412\u0430\u0448\u0430\u0442\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0431\u0435\u0448\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0435\u043D\u0430!</strong></p>'
        }
      }
    },
    {
      "id": "ret-approved-body",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Nous avons re\xE7u votre retour. Si vous avez demand\xE9 un remboursement, il sera visible sur le compte bancaire utilis\xE9 lors de la commande sous 2 \xE0 5 jours.</span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">We have processed your return. If you have requested a refund, it will be visible in the bank account used when ordering within 2 to 5 days.</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Va\u0161i vr\xE1cenou z\xE1silku jsme zpracovali. Pokud jste po\u017E\xE1dali o vr\xE1cen\xED pen\u011Bz, \u010D\xE1stka bude viditeln\xE1 na bankovn\xEDm \xFA\u010Dtu pou\u017Eit\xFDm p\u0159i objedn\xE1vce b\u011Bhem 2 a\u017E 5 dn\u016F.</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Vi har behandlet din returnering. Hvis du har anmodet om en tilbagebetaling, vil den v\xE6re synlig p\xE5 den bankkonto, der blev brugt ved bestilling, inden for 2 til 5 dage.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Wir haben Ihre R\xFCcksendung bearbeitet. Wenn Sie eine R\xFCckerstattung beantragt haben, wird diese innerhalb von 2 bis 5 Tagen auf dem bei der Bestellung verwendeten Bankkonto angezeigt.</span></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03AE\u03BA\u03B1\u03BC\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03B1\u03C2. \u0391\u03BD \u03B6\u03B7\u03C4\u03AE\u03C3\u03B1\u03C4\u03B5 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C7\u03C1\u03B7\u03BC\u03AC\u03C4\u03C9\u03BD, \u03B8\u03B1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03C3\u03C4\u03B5\u03AF \u03C3\u03C4\u03BF\u03BD \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C0\u03BF\u03C5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B1\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03BC\u03AD\u03C3\u03B1 \u03C3\u03B5 2 \u03AD\u03C9\u03C2 5 \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Hemos procesado tu devoluci\xF3n. Si ha solicitado un reembolso, ser\xE1 visible en la cuenta bancaria utilizada al realizar el pedido en un plazo de 2 a 5 d\xEDas.</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Olemme k\xE4sitelleet palautuksesi. Jos olet pyyt\xE4nyt hyvityst\xE4, se n\xE4kyy tilauksessa k\xE4ytt\xE4m\xE4ll\xE4si pankkitilill\xE4 2\u20135 p\xE4iv\xE4n kuluessa.</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u8FD4\u54C1\u51E6\u7406\u304C\u5B8C\u4E86\u3044\u305F\u3057\u307E\u3057\u305F\u3002\u8FD4\u91D1\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3055\u308C\u305F\u5834\u5408\u30012\u301C5\u65E5\u4EE5\u5185\u306B\u3054\u6CE8\u6587\u6642\u306B\u3054\u5229\u7528\u306E\u9280\u884C\u53E3\u5EA7\u306B\u53CD\u6620\u3055\u308C\u307E\u3059\u3002</span></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">M\u0113s esam apstr\u0101d\u0101ju\u0161i j\u016Bsu atgrie\u0161anu. Ja esat piepras\u012Bjis atmaksu, t\u0101 b\u016Bs redzama bankas kont\u0101, kas tika izmantots pas\u016Bt\u012Bjuma veik\u0161anai, 2 l\u012Bdz 5 dienu laik\u0101.</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Vi har behandlet returen din. Hvis du har bedt om refusjon, vil den v\xE6re synlig p\xE5 bankkontoen som ble brukt ved bestillingen innen 2 til 5 dager.</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Przetworzyli\u015Bmy Tw\xF3j zwrot. Je\u015Bli poprosi\u0142e\u015B o zwrot pieni\u0119dzy, b\u0119dzie on widoczny na rachunku bankowym u\u017Cytym przy zam\xF3wieniu w ci\u0105gu 2 do 5 dni.</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Process\xE1mos a sua devolu\xE7\xE3o. Se tiver solicitado um reembolso, este ficar\xE1 vis\xEDvel na conta banc\xE1ria usada no momento da encomenda no prazo de 2 a 5 dias.</span></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Processamos sua devolu\xE7\xE3o. Se voc\xEA solicitou um reembolso, ele ficar\xE1 vis\xEDvel na conta banc\xE1ria usada na compra em at\xE9 2 a 5 dias.</span></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Am procesat returul dvs. Dac\u0103 a\u021Bi solicitat o rambursare, aceasta va fi vizibil\u0103 \xEEn contul bancar folosit la comand\u0103 \xEEn 2 p\xE2n\u0103 la 5 zile.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Vi har behandlat din retur. Om du har beg\xE4rt en \xE5terbetalning kommer den att synas p\xE5 det bankkonto som anv\xE4ndes vid best\xE4llningen inom 2 till 5 dagar.</span></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u6211\u4EEC\u5DF2\u5904\u7406\u60A8\u7684\u9000\u8D27\u3002\u5982\u679C\u60A8\u7533\u8BF7\u4E86\u9000\u6B3E\uFF0C\u6B3E\u9879\u5C06\u5728 2 \u81F3 5 \u5929\u5185\u663E\u793A\u5728\u60A8\u4E0B\u5355\u65F6\u4F7F\u7528\u7684\u94F6\u884C\u8D26\u6237\u4E2D\u3002</span></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u6211\u5011\u5DF2\u8655\u7406\u60A8\u7684\u9000\u8CA8\u3002\u5982\u679C\u60A8\u7533\u8ACB\u4E86\u9000\u6B3E\uFF0C\u5C07\u6703\u5728 2 \u81F3 5 \u5929\u5167\u986F\u793A\u65BC\u4E0B\u55AE\u6642\u6240\u4F7F\u7528\u7684\u9280\u884C\u5E33\u6236\u4E2D\u3002</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u6211\u4EEC\u5DF2\u5904\u7406\u60A8\u7684\u9000\u8D27\u3002\u5982\u679C\u60A8\u7533\u8BF7\u4E86\u9000\u6B3E\uFF0C\u6B3E\u9879\u5C06\u5728 2 \u81F3 5 \u5929\u5185\u663E\u793A\u5728\u60A8\u4E0B\u5355\u65F6\u4F7F\u7528\u7684\u94F6\u884C\u8D26\u6237\u4E2D\u3002</span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Abbiamo ricevuto il tuo reso. Se hai richiesto un rimborso, sar\xE0 visibile sul conto bancario utilizzato per l'ordine entro 2-5 giorni.</span></p>`
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">We hebben je retour ontvangen. Als je een terugbetaling hebt aangevraagd, is deze binnen 2 tot 5 dagen zichtbaar op de bankrekening die voor de bestelling is gebruikt.</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Megkaptuk a visszak\xFCld\xF6tt term\xE9ket. Ha visszat\xE9r\xEDt\xE9st k\xE9rt, az 2-5 napon bel\xFCl megjelenik a rendel\xE9shez haszn\xE1lt banksz\xE1ml\xE1n.</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Prijali sme va\u0161e vr\xE1tenie. Ak ste po\u017Eiadali o vr\xE1tenie pe\u0148az\xED, zobraz\xED sa na bankovom \xFA\u010Dte pou\u017Eitom pri objedn\xE1vke do 2 a\u017E 5 dn\xED.</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u041F\u043E\u043B\u0443\u0447\u0438\u0445\u043C\u0435 \u0432\u044A\u0440\u043D\u0430\u0442\u0430\u0442\u0430 \u0441\u0442\u043E\u043A\u0430. \u0410\u043A\u043E \u0441\u0442\u0435 \u043F\u043E\u0438\u0441\u043A\u0430\u043B\u0438 \u0432\u044A\u0437\u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435, \u0442\u043E \u0449\u0435 \u0431\u044A\u0434\u0435 \u0432\u0438\u0434\u0438\u043C\u043E \u043F\u043E \u0431\u0430\u043D\u043A\u043E\u0432\u0430\u0442\u0430 \u0441\u043C\u0435\u0442\u043A\u0430, \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0430 \u043F\u0440\u0438 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430, \u0432 \u0440\u0430\u043C\u043A\u0438\u0442\u0435 \u043D\u0430 2 \u0434\u043E 5 \u0434\u043D\u0438.</span></p>'
        }
      }
    },
    {
      "id": "ret-approved-cta",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "default"
      },
      "content": {
        "fr": {
          "text": "Suivre mon retour",
          "href": "{{return.trackingUrl}}"
        },
        "en": {
          "text": "Track my return",
          "href": "{{return.trackingUrl}}"
        },
        "cs": {
          "text": "Sledovat m\xE9 vr\xE1cen\xED",
          "href": "{{return.trackingUrl}}"
        },
        "da": {
          "text": "Spor min returnering",
          "href": "{{return.trackingUrl}}"
        },
        "de": {
          "text": "R\xFCcksendung verfolgen",
          "href": "{{return.trackingUrl}}"
        },
        "el": {
          "text": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03CD\u03B8\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03BF\u03C5",
          "href": "{{return.trackingUrl}}"
        },
        "es": {
          "text": "Seguir mi devoluci\xF3n",
          "href": "{{return.trackingUrl}}"
        },
        "fi": {
          "text": "Seuraa palautustani",
          "href": "{{return.trackingUrl}}"
        },
        "ja": {
          "text": "\u8FD4\u54C1\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "{{return.trackingUrl}}"
        },
        "lv": {
          "text": "Izsekot manu atgrie\u0161anu",
          "href": "{{return.trackingUrl}}"
        },
        "no": {
          "text": "Spor returen min",
          "href": "{{return.trackingUrl}}"
        },
        "pl": {
          "text": "\u015Aled\u017A m\xF3j zwrot",
          "href": "{{return.trackingUrl}}"
        },
        "pt": {
          "text": "Acompanhar a minha devolu\xE7\xE3o",
          "href": "{{return.trackingUrl}}"
        },
        "pt-br": {
          "text": "Rastrear minha devolu\xE7\xE3o",
          "href": "{{return.trackingUrl}}"
        },
        "ro": {
          "text": "Urm\u0103re\u0219te returul meu",
          "href": "{{return.trackingUrl}}"
        },
        "sv": {
          "text": "Sp\xE5ra min retur",
          "href": "{{return.trackingUrl}}"
        },
        "zh-cn": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          "href": "{{return.trackingUrl}}"
        },
        "zh-tw": {
          "text": "\u8FFD\u8E64\u6211\u7684\u9000\u8CA8",
          "href": "{{return.trackingUrl}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u9000\u8D27",
          "href": "{{return.trackingUrl}}"
        },
        "it": {
          "text": "Segui il mio reso",
          "href": "{{return.trackingUrl}}"
        },
        "nl": {
          "text": "Mijn retour volgen",
          "href": "{{return.trackingUrl}}"
        },
        "hu": {
          "text": "Visszak\xFCld\xE9sem k\xF6vet\xE9se",
          "href": "{{return.trackingUrl}}"
        },
        "sk": {
          "text": "Sledova\u0165 moje vr\xE1tenie",
          "href": "{{return.trackingUrl}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043C\u0438",
          "href": "{{return.trackingUrl}}"
        }
      }
    },
    {
      "id": "ret-approved-sep-2",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "default"
      },
      "content": null
    },
    {
      "id": "ret-approved-summary-title",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": null,
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>D\xE9tails de votre retour</strong></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details of your return</strong></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti o va\u0161em vr\xE1cen\xED</strong></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din returnering</strong></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details Ihrer R\xFCcksendung</strong></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2</strong></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalles de su devoluci\xF3n</strong></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Palautuksesi tiedot</strong></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u8FD4\u54C1\u306E\u8A73\u7D30</strong></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu atgrie\u0161anas deta\u013Cas</strong></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om returen din</strong></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Szczeg\xF3\u0142y Twojego zwrotu</strong></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalhes da sua devolu\xE7\xE3o</strong></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detalii despre returul dvs.</strong></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Detaljer om din retur</strong></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8CA8\u8A73\u60C5</strong></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u7684\u9000\u8D27\u8BE6\u60C5</strong></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dettagli del tuo reso</strong></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Details van je retour</strong></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Visszak\xFCld\xE9s r\xE9szletei</strong></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Podrobnosti v\xE1\u0161ho vr\xE1tenia</strong></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0432\u0438</strong></p>'
        }
      }
    },
    {
      "id": "ret-approved-items",
      "type": "return-line-items",
      "alignment": "left",
      "font": null,
      "properties": {
        "hidePrices": false
      },
      "content": null
    }
  ],
  "afterBlocks": [],
  "defaultLocale": "fr"
};

// src/templates/return/discount-created.ts
var returnDiscountCreatedEmailTemplateSubject = {
  "cs": "V\xE1\u0161 kredit za objedn\xE1vku {{return.orderName}}",
  "da": "Dit tilgodehavende for ordre {{return.orderName}}",
  "de": "Ihr Guthaben f\xFCr die Bestellung {{return.orderName}}",
  "el": "\u0397 \u03C0\u03AF\u03C3\u03C4\u03C9\u03C3\u03B7 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your credit for order {{return.orderName}}",
  "es": "Su cr\xE9dito para el pedido {{return.orderName}}",
  "fi": "Hyvityksesi tilauksesta {{return.orderName}}",
  "fr": "Votre avoir pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u30AF\u30EC\u30B8\u30C3\u30C8",
  "lv": "J\u016Bsu kred\u012Bts par pas\u016Bt\u012Bjumu {{return.orderName}}",
  "no": "Din kreditt for bestilling {{return.orderName}}",
  "pl": "Tw\xF3j kredyt za zam\xF3wienie {{return.orderName}}",
  "pt": "O seu cr\xE9dito para a encomenda {{return.orderName}}",
  "pt-br": "Seu cr\xE9dito para o pedido {{return.orderName}}",
  "ro": "Creditul t\u0103u pentru comanda {{return.orderName}}",
  "sv": "Ditt tillgodohavande f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u5728\u8BA2\u5355 {{return.orderName}} \u7684\u8D2D\u7269\u4F59\u989D",
  "zh-tw": "\u60A8\u5728\u8A02\u55AE {{return.orderName}} \u7684\u8CFC\u7269\u91D1"
};
var returnDiscountCreatedEmailTemplatePreview = returnDiscountCreatedEmailTemplateSubject;
var returnDiscountCreatedEmailTemplate = {
  beforeBlocks: [],
  insideBlocks: [
    {
      id: "ret-discount-logo",
      type: "logo",
      alignment: "center",
      font: null,
      properties: {
        size: "medium"
      },
      content: null
    },
    {
      id: "ret-discount-sep-1",
      type: "separator",
      alignment: "center",
      font: null,
      properties: {
        spacing: "small"
      },
      content: null
    },
    {
      id: "ret-discount-heading",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: null,
      content: {
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>V\xE1\u0161 kredit za objedn\xE1vku <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dit tilgodehavende for ordre <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ihr Guthaben f\xFCr die Bestellung <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0397 \u03C0\u03AF\u03C3\u03C4\u03C9\u03C3\u03B7 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Your credit for order <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Su cr\xE9dito para el pedido <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Hyvityksesi tilauksesta <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Votre avoir pour la commande <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u6CE8\u6587<span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>\u306E\u30AF\u30EC\u30B8\u30C3\u30C8</strong></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu kred\u012Bts par pas\u016Bt\u012Bjumu <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din kreditt for bestilling <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Tw\xF3j kredyt za zam\xF3wienie <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>O seu cr\xE9dito para a encomenda <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Seu cr\xE9dito para o pedido <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Creditul t\u0103u pentru comanda <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ditt tillgodohavande f\xF6r order <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u5728\u8BA2\u5355 <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \u7684\u8D2D\u7269\u4F59\u989D</strong></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u5728\u8A02\u55AE <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \u7684\u8CFC\u7269\u91D1</strong></p>'
        }
      }
    },
    {
      id: "ret-discount-message",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: null,
      content: {
        cs: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Po zpracov\xE1n\xED va\u0161eho vr\xE1cen\xED za objedn\xE1vku <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> v\xE1m s pot\u011B\u0161en\xEDm oznamujeme, \u017Ee byl vystaven kredit ve v\xFD\u0161i <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. Je platn\xFD do <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Chcete-li jej vyu\u017E\xEDt, zadejte pros\xEDm tento k\xF3d do p\u0159\xEDslu\u0161n\xE9ho pole p\u0159i dokon\u010Den\xED objedn\xE1vky:</span></p>`
        },
        da: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Efter behandlingen af din returnering for ordre <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> er vi glade for at kunne oplyse, at der er udstedt et tilgodehavende p\xE5 <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. Det er gyldigt indtil <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. For at bruge det skal du indtaste denne kode i det dertil beregnede felt, n\xE5r du gennemf\xF8rer din ordre:</span></p>`
        },
        de: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Nach der Bearbeitung Ihrer R\xFCcksendung f\xFCr die Bestellung <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> freuen wir uns, Ihnen mitteilen zu k\xF6nnen, dass ein Guthaben von <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> ausgestellt wurde. Es ist g\xFCltig bis <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Um es einzul\xF6sen, geben Sie diesen Code bitte beim Abschluss Ihrer Bestellung in das daf\xFCr vorgesehene Feld ein:</span></p>`
        },
        el: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u039C\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, \u03BC\u03B5 \u03C7\u03B1\u03C1\u03AC \u03C3\u03B1\u03C2 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03BD\u03BF\u03C5\u03BC\u03B5 \u03CC\u03C4\u03B9 \u03AD\u03C7\u03B5\u03B9 \u03B5\u03BA\u03B4\u03BF\u03B8\u03B5\u03AF \u03C0\u03AF\u03C3\u03C4\u03C9\u03C3\u03B7 <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. \u0399\u03C3\u03C7\u03CD\u03B5\u03B9 \u03AD\u03C9\u03C2 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. \u0393\u03B9\u03B1 \u03BD\u03B1 \u03C4\u03B7 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5, \u03B5\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03C4\u03BF \u03B1\u03BD\u03C4\u03AF\u03C3\u03C4\u03BF\u03B9\u03C7\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2:</span></p>`
        },
        en: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Following the processing of your return for order <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, we are pleased to inform you that a credit of <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> has been issued. It is valid until <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. To use it, please enter this code in the field provided for this purpose when finalizing your order:</span></p>`
        },
        es: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Tras el procesamiento de su devoluci\xF3n del pedido <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, nos complace informarle de que se ha emitido un cr\xE9dito de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. Es v\xE1lido hasta el <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Para utilizarlo, introduzca este c\xF3digo en el campo previsto a tal efecto al finalizar su pedido:</span></p>`
        },
        fi: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Palautuksesi k\xE4sittelyn j\xE4lkeen tilauksesta <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> ilmoitamme mielell\xE4mme, ett\xE4 sinulle on my\xF6nnetty <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> hyvitys. Se on voimassa <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span> asti. K\xE4ytt\xE4\xE4ksesi sen sy\xF6t\xE4 t\xE4m\xE4 koodi sille varattuun kentt\xE4\xE4n tilausta viimeistelless\xE4si:</span></p>`
        },
        fr: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Suite au traitement de votre retour concernant la commande <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, nous avons le plaisir de vous informer qu\u2019un avoir de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> a \xE9t\xE9 \xE9mis. Il est valable jusqu'au <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Pour l\u2019utiliser, veuillez indiquer ce code dans le champ pr\xE9vu \xE0 cet effet au moment de valider votre commande:</span></p>`
        },
        ja: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u6CE8\u6587<span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>\u306E\u8FD4\u54C1\u51E6\u7406\u306B\u4F34\u3044\u3001<span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u3092\u767A\u884C\u3044\u305F\u3057\u307E\u3057\u305F\u3053\u3068\u3092\u304A\u77E5\u3089\u305B\u3044\u305F\u3057\u307E\u3059\u3002\u6709\u52B9\u671F\u9650\u306F<span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>\u3067\u3059\u3002\u3054\u5229\u7528\u306E\u969B\u306F\u3001\u3054\u6CE8\u6587\u3092\u78BA\u5B9A\u3059\u308B\u969B\u306B\u6240\u5B9A\u306E\u6B04\u306B\u3053\u306E\u30B3\u30FC\u30C9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\uFF1A</span></p>`
        },
        lv: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">P\u0113c j\u016Bsu atgrie\u0161anas apstr\u0101des par pas\u016Bt\u012Bjumu <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> ar prieku j\u016Bs inform\u0113jam, ka ir izsniegts kred\u012Bts <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> apm\u0113r\u0101. Tas ir der\u012Bgs l\u012Bdz <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Lai to izmantotu, l\u016Bdzu, ievadiet \u0161o kodu tam paredz\u0113taj\u0101 lauk\u0101, noform\u0113jot pas\u016Bt\u012Bjumu:</span></p>`
        },
        no: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Etter at vi har behandlet returen din for bestilling <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, er vi glade for \xE5 kunne informere deg om at det er utstedt en kreditt p\xE5 <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. Den er gyldig til <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. For \xE5 bruke den, vennligst oppgi denne koden i det tilh\xF8rende feltet n\xE5r du fullf\xF8rer bestillingen din:</span></p>`
        },
        pl: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Po przetworzeniu zwrotu dla zam\xF3wienia <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> z przyjemno\u015Bci\u0105 informujemy, \u017Ce zosta\u0142 wystawiony kredyt w wysoko\u015Bci <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. Jest wa\u017Cny do <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Aby go wykorzysta\u0107, wpisz ten kod w odpowiednim polu podczas finalizacji zam\xF3wienia:</span></p>`
        },
        pt: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Na sequ\xEAncia do processamento da sua devolu\xE7\xE3o da encomenda <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, temos o prazer de o informar de que foi emitido um cr\xE9dito de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. \xC9 v\xE1lido at\xE9 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Para o utilizar, indique este c\xF3digo no campo previsto para o efeito ao finalizar a sua encomenda:</span></p>`
        },
        "pt-br": {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ap\xF3s o processamento da sua devolu\xE7\xE3o do pedido <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, temos o prazer de informar que foi emitido um cr\xE9dito de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. \xC9 v\xE1lido at\xE9 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Para utiliz\xE1-lo, insira este c\xF3digo no campo indicado ao finalizar o seu pedido:</span></p>`
        },
        ro: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\xCEn urma proces\u0103rii returului pentru comanda <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, avem pl\u0103cerea s\u0103 te inform\u0103m c\u0103 a fost emis un credit de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>. Este valabil p\xE2n\u0103 la <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. Pentru a-l utiliza, te rug\u0103m s\u0103 introduci acest cod \xEEn c\xE2mpul prev\u0103zut \xEEn acest scop la finalizarea comenzii:</span></p>`
        },
        sv: {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Efter att vi har behandlat din retur f\xF6r order <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \xE4r vi glada att kunna meddela att ett tillgodohavande p\xE5 <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> har utf\xE4rdats. Det \xE4r giltigt till <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>. F\xF6r att anv\xE4nda det, ange den h\xE4r koden i avsett f\xE4lt n\xE4r du slutf\xF6r din best\xE4llning:</span></p>`
        },
        "zh-cn": {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u5728\u5904\u7406\u5B8C\u8BA2\u5355 <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \u7684\u9000\u8D27\u540E\uFF0C\u6211\u4EEC\u5F88\u9AD8\u5174\u5730\u901A\u77E5\u60A8\uFF0C\u5DF2\u4E3A\u60A8\u53D1\u653E <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> \u7684\u4F59\u989D\u3002\u6709\u6548\u671F\u81F3 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>\u3002\u4F7F\u7528\u65F6\uFF0C\u8BF7\u5728\u7ED3\u7B97\u8BA2\u5355\u65F6\u5C06\u6B64\u4EE3\u7801\u8F93\u5165\u5230\u76F8\u5E94\u7684\u5B57\u6BB5\u4E2D\uFF1A</span></p>`
        },
        "zh-tw": {
          html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u5728\u8655\u7406\u60A8\u8A02\u55AE <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \u7684\u9000\u8CA8\u5F8C\uFF0C\u6211\u5011\u5F88\u9AD8\u8208\u901A\u77E5\u60A8\uFF0C\u5DF2\u70BA\u60A8\u767C\u653E <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> \u7684\u8CFC\u7269\u91D1\u3002\u6709\u6548\u671F\u9650\u81F3 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>\u3002\u4F7F\u7528\u6642\uFF0C\u8ACB\u65BC\u7D50\u5E33\u6642\u5C07\u6B64\u4EE3\u78BC\u8F38\u5165\u81F3\u5C0D\u61C9\u7684\u6B04\u4F4D\uFF1A</span></p>`
        }
      }
    },
    {
      id: "ret-discount-code",
      type: "return-discount-code",
      alignment: "center",
      font: null,
      properties: null,
      content: null
    },
    {
      id: "ret-discount-secondary",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: null,
      content: {
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Tento k\xF3d je platn\xFD v\xFDhradn\u011B online a lze jej pou\u017E\xEDt v cel\xE9m obchod\u011B.</span></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Denne kode er udelukkende gyldig online og kan bruges i hele butikken.</span></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Dieser Code ist ausschlie\xDFlich online g\xFCltig und kann im gesamten Shop verwendet werden.</span></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B9\u03C3\u03C7\u03CD\u03B5\u03B9 \u03B1\u03C0\u03BF\u03BA\u03BB\u03B5\u03B9\u03C3\u03C4\u03B9\u03BA\u03AC \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03C4\u03C5\u03B1\u03BA\u03AC \u03BA\u03B1\u03B9 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF \u03C3\u03B5 \u03CC\u03BB\u03BF \u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1.</span></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">This code is exclusively valid online and can be used throughout the store.</span></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Este c\xF3digo solo es v\xE1lido en l\xEDnea y puede utilizarse en toda la tienda.</span></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">T\xE4m\xE4 koodi on voimassa ainoastaan verkossa ja sit\xE4 voi k\xE4ytt\xE4\xE4 koko kaupassa.</span></p>'
        },
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ce code est exclusivement valable en ligne et est utilisable sur toute la boutique.</span></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u3053\u306E\u30B3\u30FC\u30C9\u306F\u30AA\u30F3\u30E9\u30A4\u30F3\u9650\u5B9A\u3067\u6709\u52B9\u3067\u3001\u30B9\u30C8\u30A2\u5168\u4F53\u3067\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002</span></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u0160is kods ir der\u012Bgs tikai tie\u0161saist\u0113, un to var izmantot vis\u0101 veikal\u0101.</span></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Denne koden er kun gyldig p\xE5 nett og kan brukes i hele butikken.</span></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ten kod jest wa\u017Cny wy\u0142\u0105cznie online i mo\u017Cna go wykorzysta\u0107 w ca\u0142ym sklepie.</span></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Este c\xF3digo \xE9 v\xE1lido exclusivamente online e pode ser utilizado em toda a loja.</span></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Este c\xF3digo \xE9 v\xE1lido exclusivamente online e pode ser usado em toda a loja.</span></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Acest cod este valabil exclusiv online \u0219i poate fi utilizat \xEEn \xEEntregul magazin.</span></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Den h\xE4r koden \xE4r endast giltig online och kan anv\xE4ndas i hela butiken.</span></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u6B64\u4EE3\u7801\u4EC5\u5728\u7EBF\u4E0A\u6709\u6548\uFF0C\u53EF\u5728\u6574\u4E2A\u5546\u5E97\u4F7F\u7528\u3002</span></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u6B64\u4EE3\u78BC\u50C5\u9650\u7DDA\u4E0A\u6709\u6548\uFF0C\u53EF\u65BC\u5168\u5E97\u4F7F\u7528\u3002</span></p>'
        }
      }
    },
    {
      id: "ret-discount-ending",
      type: "paragraph",
      alignment: "center",
      font: null,
      properties: null,
      content: {
        cs: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">P\u0159ejeme hezk\xFD den</span></p>'
        },
        da: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Hav en god dag</span></p>'
        },
        de: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Sch\xF6nen Tag noch</span></p>'
        },
        el: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u039A\u03B1\u03BB\u03AE \u03C3\u03B1\u03C2 \u03BC\u03AD\u03C1\u03B1</span></p>'
        },
        en: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Have a nice day</span></p>'
        },
        es: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Que tenga un buen d\xEDa</span></p>'
        },
        fi: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Mukavaa p\xE4iv\xE4njatkoa</span></p>'
        },
        fr: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Bonne journ\xE9e</span></p>'
        },
        ja: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u826F\u3044\u4E00\u65E5\u3092\u304A\u904E\u3054\u3057\u304F\u3060\u3055\u3044</span></p>'
        },
        lv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Lai jums jauka diena</span></p>'
        },
        no: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ha en fin dag</span></p>'
        },
        pl: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Mi\u0142ego dnia</span></p>'
        },
        pt: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Tenha um bom dia</span></p>'
        },
        "pt-br": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Tenha um bom dia</span></p>'
        },
        ro: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">O zi frumoas\u0103</span></p>'
        },
        sv: {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ha en bra dag</span></p>'
        },
        "zh-cn": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u795D\u60A8\u6109\u5FEB</span></p>'
        },
        "zh-tw": {
          html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u795D\u60A8\u6709\u7F8E\u597D\u7684\u4E00\u5929</span></p>'
        }
      }
    }
  ],
  afterBlocks: [],
  defaultLocale: "en"
};

// src/templates/return/store-credit-created.ts
var returnStoreCreditCreatedEmailTemplateSubject = {
  "cs": "V\xE1\u0161 kredit za objedn\xE1vku {{return.orderName}}",
  "da": "Dit tilgodehavende for ordre {{return.orderName}}",
  "de": "Ihr Guthaben f\xFCr die Bestellung {{return.orderName}}",
  "el": "\u0397 \u03C0\u03AF\u03C3\u03C4\u03C9\u03C3\u03AE \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 {{return.orderName}}",
  "en": "Your store credit for order {{return.orderName}}",
  "es": "Su cr\xE9dito en tienda para el pedido {{return.orderName}}",
  "fi": "Hyvityksesi tilauksesta {{return.orderName}}",
  "fr": "Votre avoir pour la commande {{return.orderName}}",
  "ja": "\u6CE8\u6587{{return.orderName}}\u306E\u30B9\u30C8\u30A2\u30AF\u30EC\u30B8\u30C3\u30C8",
  "lv": "J\u016Bsu kred\u012Bts par pas\u016Bt\u012Bjumu {{return.orderName}}",
  "no": "Din kreditt for bestilling {{return.orderName}}",
  "pl": "Tw\xF3j kredyt za zam\xF3wienie {{return.orderName}}",
  "pt": "O seu cr\xE9dito para a encomenda {{return.orderName}}",
  "pt-br": "Seu cr\xE9dito para o pedido {{return.orderName}}",
  "ro": "Creditul t\u0103u pentru comanda {{return.orderName}}",
  "sv": "Ditt tillgodohavande f\xF6r order {{return.orderName}}",
  "zh-cn": "\u60A8\u5728\u8BA2\u5355 {{return.orderName}} \u7684\u5546\u5E97\u4F59\u989D",
  "zh-tw": "\u60A8\u5728\u8A02\u55AE {{return.orderName}} \u7684\u8CFC\u7269\u91D1"
};
var returnStoreCreditCreatedEmailTemplatePreview = returnStoreCreditCreatedEmailTemplateSubject;
var returnStoreCreditCreatedEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "ret-store-credit-logo",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {
        "size": "medium"
      },
      "content": null
    },
    {
      "id": "ret-store-credit-sep-1",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ret-store-credit-heading",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": {
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>V\xE1\u0161 kredit za objedn\xE1vku <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Dit tilgodehavende for ordre <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ihr Guthaben f\xFCr die Bestellung <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u0397 \u03C0\u03AF\u03C3\u03C4\u03C9\u03C3\u03AE \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Your store credit for order <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Su cr\xE9dito en tienda para el pedido <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Hyvityksesi tilauksesta <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Votre avoir pour la commande <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u6CE8\u6587<span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>\u306E\u30B9\u30C8\u30A2\u30AF\u30EC\u30B8\u30C3\u30C8</strong></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>J\u016Bsu kred\u012Bts par pas\u016Bt\u012Bjumu <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Din kreditt for bestilling <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Tw\xF3j kredyt za zam\xF3wienie <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>O seu cr\xE9dito para a encomenda <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Seu cr\xE9dito para o pedido <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Creditul t\u0103u pentru comanda <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>Ditt tillgodohavande f\xF6r order <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span></strong></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u5728\u8BA2\u5355 <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \u7684\u5546\u5E97\u4F59\u989D</strong></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><strong>\u60A8\u5728\u8A02\u55AE <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \u7684\u8CFC\u7269\u91D1</strong></p>'
        }
      }
    },
    {
      "id": "ret-store-credit-message",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": {
        "cs": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Po zpracov\xE1n\xED va\u0161eho vr\xE1cen\xED za objedn\xE1vku <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> byl na v\xE1\u0161 \xFA\u010Det p\u0159id\xE1n kredit ve v\xFD\u0161i <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>, platn\xFD do <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "da": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Efter behandlingen af din returnering for ordre <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> er der tilf\xF8jet et tilgodehavende p\xE5 <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> til din konto, gyldigt indtil <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "de": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Nach Ihrer R\xFCcksendung zur Bestellung <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> wurde ein Guthaben von <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> Ihrem Konto gutgeschrieben, g\xFCltig bis <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "el": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u039C\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2 \u03C0\u03AF\u03C3\u03C4\u03C9\u03C3\u03B7 <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>, \u03BC\u03B5 \u03B9\u03C3\u03C7\u03CD \u03AD\u03C9\u03C2 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "en": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Following your return on order <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, a store credit of <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> has been added to your account, valid until <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "es": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Tras su devoluci\xF3n del pedido <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, se ha a\xF1adido un cr\xE9dito de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> a su cuenta, v\xE1lido hasta el <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "fi": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Palautuksesi k\xE4sittelyn j\xE4lkeen tilauksesta <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> tilillesi on lis\xE4tty <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> hyvitys, joka on voimassa <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span> asti.</span></p>`
        },
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Suite au traitement de votre retour sur la commande <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, un avoir de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> a \xE9t\xE9 ajout\xE9 \xE0 votre compte, valable jusqu'au <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "ja": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u6CE8\u6587<span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>\u306E\u8FD4\u54C1\u306B\u4F34\u3044\u3001<span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>\u306E\u30B9\u30C8\u30A2\u30AF\u30EC\u30B8\u30C3\u30C8\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002\u6709\u52B9\u671F\u9650\uFF1A<span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>\u3002</span></p>`
        },
        "lv": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">P\u0113c j\u016Bsu atgrie\u0161anas apstr\u0101des par pas\u016Bt\u012Bjumu <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> j\u016Bsu kontam ir pievienots kred\u012Bts <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> apm\u0113r\u0101, der\u012Bgs l\u012Bdz <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "no": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Etter at vi har behandlet returen din for bestilling <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, er det lagt til en kreditt p\xE5 <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> p\xE5 kontoen din, gyldig til <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "pl": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Po przetworzeniu zwrotu dla zam\xF3wienia <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> do Twojego konta dodano kredyt w wysoko\u015Bci <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>, wa\u017Cny do <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "pt": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Na sequ\xEAncia do processamento da sua devolu\xE7\xE3o da encomenda <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, foi adicionado \xE0 sua conta um cr\xE9dito de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>, v\xE1lido at\xE9 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "pt-br": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ap\xF3s o processamento da sua devolu\xE7\xE3o do pedido <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, um cr\xE9dito de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> foi adicionado \xE0 sua conta, v\xE1lido at\xE9 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "ro": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\xCEn urma proces\u0103rii returului pentru comanda <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span>, \xEEn contul t\u0103u a fost ad\u0103ugat un credit de <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span>, valabil p\xE2n\u0103 la <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "sv": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Efter att vi har behandlat din retur f\xF6r order <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> har ett tillgodohavande p\xE5 <span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> lagts till p\xE5 ditt konto, giltigt till <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>.</span></p>`
        },
        "zh-cn": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u7531\u4E8E\u60A8\u5728\u8BA2\u5355 <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \u7684\u9000\u8D27\uFF0C<span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> \u7684\u5546\u5E97\u4F59\u989D\u5DF2\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u4E2D\uFF0C\u6709\u6548\u671F\u81F3 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>\u3002</span></p>`
        },
        "zh-tw": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u5728\u8655\u7406\u60A8\u8A02\u55AE <span data-type="mention" class="mention" data-id="return.orderName" data-label="Num\xE9ro de commande" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de commande</span> \u7684\u9000\u8CA8\u5F8C\uFF0C<span data-type="mention" class="mention" data-id="return.discountValue" data-label="Montant de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Montant de l'avoir</span> <span data-type="mention" class="mention" data-id="return.discountCurrency" data-label="Devise de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Devise de l'avoir</span> \u7684\u8CFC\u7269\u91D1\u5DF2\u52A0\u5165\u60A8\u7684\u5E33\u6236\uFF0C\u6709\u6548\u671F\u9650\u81F3 <span data-type="mention" class="mention" data-id="return.discountValidUntil" data-label="Date de validit\xE9 de l'avoir" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Date de validit\xE9 de l'avoir</span>\u3002</span></p>`
        }
      }
    },
    {
      "id": "ret-store-credit-secondary",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": {
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Bude automaticky uplatn\u011Bn p\u0159i placen\xED.</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Det vil automatisk blive anvendt ved kassen.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Es wird automatisch an der Kasse angewendet.</span></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u0398\u03B1 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03C3\u03C4\u03B5\u03AF \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AC\u03C2.</span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">It will be automatically applied at checkout.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Se aplicar\xE1 autom\xE1ticamente en el pago.</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Se otetaan automaattisesti k\xE4ytt\xF6\xF6n kassalla.</span></p>'
        },
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Il sera automatiquement appliqu\xE9 lors du passage en caisse.</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u6642\u306B\u81EA\u52D5\u7684\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002</span></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Tas tiks autom\u0101tiski piem\u0113rots, noform\u0113jot pas\u016Bt\u012Bjumu.</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Den blir automatisk brukt i kassen.</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Zostanie automatycznie zastosowany podczas finalizacji zam\xF3wienia.</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ser\xE1 aplicado automaticamente no momento do pagamento.</span></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ele ser\xE1 aplicado automaticamente na finaliza\xE7\xE3o da compra.</span></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Va fi aplicat automat la finalizarea comenzii.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Det till\xE4mpas automatiskt i kassan.</span></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u7ED3\u8D26\u65F6\u5C06\u81EA\u52A8\u5E94\u7528\u3002</span></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u7D50\u5E33\u6642\u5C07\u81EA\u52D5\u5957\u7528\u3002</span></p>'
        }
      }
    },
    {
      "id": "ret-store-credit-ending",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": {
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">P\u0159ejeme hezk\xFD den</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Hav en god dag</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Sch\xF6nen Tag noch</span></p>'
        },
        "el": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u039A\u03B1\u03BB\u03AE \u03C3\u03B1\u03C2 \u03BC\u03AD\u03C1\u03B1</span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Have a great day</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Que tenga un buen d\xEDa</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Mukavaa p\xE4iv\xE4njatkoa</span></p>'
        },
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Bonne journ\xE9e</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u826F\u3044\u4E00\u65E5\u3092\u304A\u904E\u3054\u3057\u304F\u3060\u3055\u3044</span></p>'
        },
        "lv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Lai jums jauka diena</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ha en fin dag</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Mi\u0142ego dnia</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Tenha um bom dia</span></p>'
        },
        "pt-br": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Tenha um bom dia</span></p>'
        },
        "ro": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">O zi frumoas\u0103</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">Ha en bra dag</span></p>'
        },
        "zh-cn": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u795D\u60A8\u6109\u5FEB</span></p>'
        },
        "zh-tw": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0);">\u795D\u60A8\u6709\u7F8E\u597D\u7684\u4E00\u5929</span></p>'
        }
      }
    }
  ],
  "afterBlocks": [],
  "defaultLocale": "en"
};

// src/templates/default-return-templates.ts
var defaultReturnTemplates = {
  returnCreatedWithoutApproval: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnCreatedWithoutApproval",
    id: "00000000-0000-4000-8000-000000000001",
    title: "Retour cr\xE9\xE9 (en attente de validation)",
    subject: returnCreatedWithoutApprovalEmailTemplateSubject,
    preview: returnCreatedWithoutApprovalEmailTemplatePreview,
    content: returnCreatedWithoutApprovalEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  },
  returnCreatedWithoutLabel: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnCreatedWithoutLabel",
    id: "00000000-0000-4000-8000-000000000002",
    title: "Retour cr\xE9\xE9 (sans \xE9tiquette)",
    subject: returnCreatedWithoutLabelEmailTemplateSubject,
    preview: returnCreatedWithoutLabelEmailTemplatePreview,
    content: returnCreatedWithoutLabelEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  },
  returnCreatedWithoutPhysicalReturn: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnCreatedWithoutPhysicalReturn",
    id: "00000000-0000-4000-8000-000000000003",
    title: "Retour sans renvoi physique",
    subject: returnCreatedWithoutPhysicalReturnEmailTemplateSubject,
    preview: returnCreatedWithoutPhysicalReturnEmailTemplatePreview,
    content: returnCreatedWithoutPhysicalReturnEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  },
  returnCreatedReturnToStore: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnCreatedReturnToStore",
    id: "00000000-0000-4000-8000-000000000004",
    title: "Retour en boutique",
    subject: returnCreatedReturnToStoreEmailTemplateSubject,
    preview: returnCreatedReturnToStoreEmailTemplatePreview,
    content: returnCreatedReturnToStoreEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  },
  returnLabelCreated: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnLabelCreated",
    id: "00000000-0000-4000-8000-000000000005",
    title: "\xC9tiquette de retour cr\xE9\xE9e",
    subject: returnLabelCreatedEmailTemplateSubject,
    preview: returnLabelCreatedEmailTemplatePreview,
    content: returnLabelCreatedEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  },
  returnDepositReminder: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnDepositReminder",
    id: "00000000-0000-4000-8000-000000000006",
    title: "Rappel de d\xE9p\xF4t",
    subject: returnDepositReminderEmailTemplateSubject,
    preview: returnDepositReminderEmailTemplatePreview,
    content: returnDepositReminderEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  },
  returnRejected: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnRejected",
    id: "00000000-0000-4000-8000-000000000007",
    title: "Retour rejet\xE9",
    subject: returnRejectedEmailTemplateSubject,
    preview: returnRejectedEmailTemplatePreview,
    content: returnRejectedEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  },
  returnApproved: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnApproved",
    id: "00000000-0000-4000-8000-000000000008",
    title: "Retour trait\xE9",
    subject: returnApprovedEmailTemplateSubject,
    preview: returnApprovedEmailTemplatePreview,
    content: returnApprovedEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  },
  returnDiscountCreated: {
    type: "email",
    domain: "return",
    category: "return",
    isProtected: true,
    emailDefaultTemplateType: "returnDiscountCreated",
    id: "00000000-0000-4000-8000-000000000009",
    title: "Avoir / code de r\xE9duction cr\xE9\xE9",
    subject: returnDiscountCreatedEmailTemplateSubject,
    preview: returnDiscountCreatedEmailTemplatePreview,
    content: returnDiscountCreatedEmailTemplate,
    createdAt: "2026-06-12T00:00:00.000Z",
    updatedAt: "2026-06-12T00:00:00.000Z"
  }
};
var returnStoreCreditCreatedDefaultTemplate = {
  type: "email",
  domain: "return",
  category: "return",
  isProtected: true,
  emailDefaultTemplateType: "returnDiscountCreated",
  id: "00000000-0000-4000-8000-00000000000a",
  title: "Avoir / cr\xE9dit boutique cr\xE9\xE9",
  subject: returnStoreCreditCreatedEmailTemplateSubject,
  preview: returnStoreCreditCreatedEmailTemplatePreview,
  content: returnStoreCreditCreatedEmailTemplate,
  createdAt: "2026-06-12T00:00:00.000Z",
  updatedAt: "2026-06-12T00:00:00.000Z"
};
var default_return_templates_default = defaultReturnTemplates;

// src/lib/return/get-default-template.ts
var defaultReturnEmailTemplates = default_return_templates_default;
var getDefaultReturnTemplate = (type, opts) => type === "returnDiscountCreated" && opts?.giftCard === "storeCredit" ? returnStoreCreditCreatedDefaultTemplate : defaultReturnEmailTemplates[type];

// src/lib/tracking/index.ts
var tracking_exports = {};
__export(tracking_exports, {
  TRACKING_V2_CATEGORIES: () => TRACKING_V2_CATEGORIES,
  defaultEmailTemplates: () => defaultEmailTemplates,
  deliveredEmail: () => deliveredEmail,
  deliveredToNeighbourEmail: () => deliveredToNeighbourEmail,
  getDefaultTemplate: () => getDefaultTemplate,
  inTransitEmail: () => inTransitEmail,
  parcelExceptionEmail: () => parcelExceptionEmail,
  parcelReturnedToSenderEmail: () => parcelReturnedToSenderEmail,
  preTransitEmail: () => preTransitEmail,
  trackingV2Designs: () => trackingV2Designs,
  trackingV2StatusContent: () => trackingV2StatusContent,
  waitingAtPickupPointEmail: () => waitingAtPickupPointEmail,
  waitingAtPickupPointSevereEmail: () => waitingAtPickupPointSevereEmail,
  waitingInformationFromAddressEmail: () => waitingInformationFromAddressEmail
});
function LineItem4({ name, imageUrl, sku, quantity, price }) {
  return /* @__PURE__ */ jsxs(Row, { className: "p-2", children: [
    /* @__PURE__ */ jsx(Column, { className: "w-[64px]", children: /* @__PURE__ */ jsx(
      Img,
      {
        src: imageUrl,
        width: "64",
        height: "64",
        alt: name,
        className: "rounded-lg object-cover"
      }
    ) }),
    /* @__PURE__ */ jsxs(Column, { className: "pl-2", children: [
      /* @__PURE__ */ jsxs(Text$1, { className: "m-0 p-0 leading-[1.4] font-semibold", children: [
        name,
        " x ",
        quantity
      ] }),
      /* @__PURE__ */ jsxs(Text$1, { className: "m-0 p-0 leading-[1.4]", children: [
        price,
        "\u20AC"
      ] })
    ] })
  ] });
}
function OrderRecapContainer2({ children }) {
  return /* @__PURE__ */ jsx(Section, { className: "rounded-lg px-4", children: /* @__PURE__ */ jsx(Row, { className: "rounded-lg", style: { border: "1px solid #e6e6e6" }, children: /* @__PURE__ */ jsx(Column, { children }) }) });
}
function PackageContent({ parcel, locale }) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Heading$1, { as: "h5", className: "px-4 m-0 mb-2 text-secondary-foreground", children: [
      t("packageContent.label", loc),
      " ",
      parcel.orderNumber
    ] }),
    /* @__PURE__ */ jsx(OrderRecapContainer2, { children: parcel.lineItems.map((item, index2) => /* @__PURE__ */ jsxs(React49__default.Fragment, { children: [
      /* @__PURE__ */ jsx(
        LineItem4,
        {
          name: item.name,
          imageUrl: item.imageUrl,
          sku: item.sku,
          quantity: item.quantity,
          price: item.price
        }
      ),
      index2 < parcel.lineItems.length - 1 && /* @__PURE__ */ jsx(Hr, {})
    ] }, item.sku)) })
  ] });
}
function DeliveryDetails({ parcel, locale }) {
  const loc = locale || "fr";
  const { destination } = parcel;
  return /* @__PURE__ */ jsxs(Section, { children: [
    /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
      /* @__PURE__ */ jsx(TextualSectionTitle, { className: "", children: t("deliveryDetails.title", loc) }),
      /* @__PURE__ */ jsx(
        EmailAddress,
        {
          name: `${destination.firstName} ${destination.lastName}`,
          address: {
            address1: destination.address1,
            address2: destination.address2,
            city: destination.city,
            zip: destination.zip,
            country: destination.country
          },
          showMapButton: false
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Hr, { className: "my-10" }),
    /* @__PURE__ */ jsx(PackageContent, { parcel, locale })
  ] });
}

// src/components/footer.tsx
function Footer() {
  return null;
}
function WalletSection({
  googleWalletURL,
  appleWalletURL,
  locale
}) {
  return /* @__PURE__ */ jsx(Section, { className: "px-8 pb-2 text-center pt-8", children: /* @__PURE__ */ jsxs("div", { className: "flex justify-center items-center gap-4 mb-2", children: [
    /* @__PURE__ */ jsx(Link, { href: appleWalletURL, target: "_blank", children: /* @__PURE__ */ jsx(
      Img,
      {
        src: `https://baback-wallet.s3.eu-west-3.amazonaws.com/apple-buttons/${locale}`,
        alt: "Apple Wallet",
        height: 40
      }
    ) }),
    /* @__PURE__ */ jsx(Link, { href: googleWalletURL, target: "_blank", children: /* @__PURE__ */ jsx(
      Img,
      {
        src: `https://baback-wallet.s3.eu-west-3.amazonaws.com/google-buttons/${locale}`,
        alt: "Google Wallet",
        height: 40
      }
    ) })
  ] }) });
}

// src/preview/preview-parcel.ts
var previewParcel = {
  id: "1234567890",
  trackingId: "1234567890",
  orderId: "1234567890",
  orderNumber: "1001",
  carrierCode: "FEDEX",
  customerEmail: "customer@example.com",
  customerLocale: "en",
  shopId: "shop123",
  createdAt: Date.now(),
  events: [
    {
      status: "PRE_TRANSIT",
      createdAt: Date.now(),
      label: "Pre-transit",
      notifications: []
    },
    {
      status: "PARCEL_NOT_SHIPPED",
      createdAt: Date.now(),
      label: "Parcel not shipped",
      notifications: []
    },
    {
      status: "DELIVERED",
      createdAt: Date.now() + 864e5,
      // 24 hours later
      label: "Delivered",
      notifications: []
    }
  ],
  lineItems: [
    {
      name: "Test Product",
      imageUrl: "https://cdn.shopify.com/s/files/1/0557/2211/5151/files/pexels-cottonbro-studio-9834872.jpg?v=1709650972",
      sku: "1234567890",
      quantity: 1,
      price: 100
    }
  ],
  destination: {
    firstName: "John",
    lastName: "Doe",
    address1: "123 Main St",
    address2: "Apt 4B",
    city: "New York",
    zip: "10001",
    province: "New York",
    provinceCode: "NY",
    country: "United States",
    countryCode: "US",
    phone: "+1234567890",
    company: "ACME Corp",
    name: "John Doe"
  }
};

// src/preview/preview-shop.ts
var previewShop = {
  name: "Vanessa Wu",
  logoUrl: "https://es.soeur.fr/cdn/shop/files/soeur.svg?v=1705681689&width=180",
  preferences: {
    contactLink: "https://www.baback.co/contact"
  },
  trackingPreferences: {
    emailsTheme: {
      cardColor: "#fff",
      backgroundColor: "#f0f0f0",
      radius: "default"
    }
  }
};
function ParcelEstimatedDateWindowText({
  parcel,
  locale
}) {
  const dateWindow = parcel.estimatedDeliveryDateWindow;
  if (!hasEstimatedDeliveryDate(dateWindow)) {
    return null;
  }
  if (hasEstimatedDeliveryDateDayOnly(dateWindow)) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      t("tracking.shared.estimatedDeliveryDate", locale),
      "\xA0",
      /* @__PURE__ */ jsx(Text$1, { children: formatDate(
        new Date(dateWindow?.exactDeliveryDay ?? 0),
        "dd/MM/yyyy"
      ) })
    ] });
  }
  if (hasEstimatedDeliveryDateWindowOnSameDay(dateWindow)) {
    if (hasIdenticalDeliveryTimes(dateWindow)) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        t("tracking.shared.estimatedDeliveryDate", locale),
        "\xA0",
        /* @__PURE__ */ jsx(Text$1, { children: formatDate(
          new Date(dateWindow?.minimumDeliveryDate ?? 0),
          "dd/MM/yyyy"
        ) })
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      t("tracking.shared.estimatedDeliveryDate", locale),
      "\xA0",
      /* @__PURE__ */ jsx(Text$1, { children: t("tracking.shared.estimatedDeliveryDateWindow", locale, {
        day: formatDate(
          new Date(dateWindow?.minimumDeliveryDate ?? 0),
          "dd/MM/yyyy"
        ),
        minimum: formatDate(
          new Date(dateWindow?.minimumDeliveryDate ?? 0),
          "hh:mm"
        ),
        maximum: formatDate(
          new Date(dateWindow?.maximumDeliveryDate ?? 0),
          "hh:mm"
        )
      }) })
    ] });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    t("tracking.shared.estimatedDeliveryDate", locale),
    "\xA0",
    /* @__PURE__ */ jsx(Text$1, { children: t("tracking.shared.estimatedDeliveryDatesWindow", locale, {
      minimum: formatDate(
        new Date(dateWindow?.minimumDeliveryDate ?? 0),
        "dd/MM/yyyy"
      ),
      maximum: formatDate(
        new Date(dateWindow?.maximumDeliveryDate ?? 0),
        "dd/MM/yyyy"
      )
    }) })
  ] });
}
function PreTransitEmail({
  parcel,
  shop,
  locale,
  googleWalletURL,
  appleWalletURL,
  walletEnabled
}) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
        /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.preTransit.email.title", loc) }),
        /* @__PURE__ */ jsx(TextualSectionContent, { children: t("tracking.preTransit.email.description", loc) }),
        hasEstimatedDeliveryDate(parcel.estimatedDeliveryDateWindow) && /* @__PURE__ */ jsx(TextualSectionContent, { children: /* @__PURE__ */ jsx(ParcelEstimatedDateWindowText, { parcel, locale: loc }) })
      ] }),
      /* @__PURE__ */ jsx(
        SingleButtonSection,
        {
          label: t("tracking.preTransit.email.cta", loc),
          href: `https://track.baback.co/tracking/${parcel.trackingId}`
        }
      ),
      /* @__PURE__ */ jsx(Hr, { className: "my-lg border-gray-300" }),
      /* @__PURE__ */ jsx(DeliveryDetails, { parcel }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview = {
  parcel: previewParcel,
  shop: previewShop,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
PreTransitEmail.PreviewProps = preview;
function ParcelEndDepositDateText({
  parcel,
  locale
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    t("tracking.shared.endDepositDate", locale),
    "\xA0",
    /* @__PURE__ */ jsx(Text$1, { children: formatDate(new Date(parcel?.endDepositDate ?? 0), "dd/MM/yyyy") })
  ] });
}
function WaitingAtPickupPointEmail({
  parcel,
  shop,
  locale,
  googleWalletURL,
  appleWalletURL,
  walletEnabled
}) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(Section, { className: "my-8", children: [
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.availableForPickup.email.title", loc) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: t("tracking.availableForPickup.email.description", loc) }),
          parcel.endDepositDate && /* @__PURE__ */ jsx(TextualSectionContent, { children: /* @__PURE__ */ jsx(ParcelEndDepositDateText, { parcel, locale: loc }) })
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("tracking.availableForPickup.email.cta", loc),
            href: `https://track.baback.co/tracking/${parcel.trackingId}`
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Hr, { className: "my-lg border-gray-300" }),
      /* @__PURE__ */ jsx(DeliveryDetails, { parcel, locale }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview2 = {
  parcel: previewParcel,
  shop: previewShop,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
WaitingAtPickupPointEmail.PreviewProps = preview2;
function ParcelDeliveredToNeighbour({
  parcel,
  shop,
  locale,
  googleWalletURL,
  appleWalletURL,
  walletEnabled
}) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(Section, { className: "my-8", children: [
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.deliveredToNeighbour.email.title", loc) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: t("tracking.deliveredToNeighbour.email.description", loc) })
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("tracking.deliveredToNeighbour.email.cta", loc),
            href: `https://track.baback.co/tracking/${parcel.trackingId}`
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Hr, { className: "my-lg border-gray-300" }),
      /* @__PURE__ */ jsx(DeliveryDetails, { parcel, locale }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview3 = {
  parcel: previewParcel,
  shop: previewShop,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
ParcelDeliveredToNeighbour.PreviewProps = preview3;
function DeliveredEmail({ shop, parcel, locale, googleWalletURL, appleWalletURL, walletEnabled }) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
        /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.delivered.email.title", loc) }),
        /* @__PURE__ */ jsx(TextualSectionContent, { children: t("tracking.delivered.email.description", loc) }),
        /* @__PURE__ */ jsxs(TextualSectionContent, { children: [
          t("tracking.delivered.email.ifNotDelivered"),
          /* @__PURE__ */ jsx(Link, { href: shop.preferences.contactLink, children: t("tracking.delivered.email.ifNotDeliveredLink") })
        ] })
      ] }),
      /* @__PURE__ */ jsx(Hr, { className: "py-4 border-gray-300" }),
      /* @__PURE__ */ jsx(PackageContent, { parcel, locale }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview4 = {
  shop: previewShop,
  parcel: previewParcel,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
DeliveredEmail.PreviewProps = preview4;
function InTransitEmail({
  parcel,
  shop,
  locale,
  googleWalletURL,
  appleWalletURL,
  walletEnabled
}) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(Section, { className: "my-8", children: [
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.inTransit.email.title", loc) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: t("tracking.inTransit.email.description", loc) }),
          hasEstimatedDeliveryDate(parcel.estimatedDeliveryDateWindow) && /* @__PURE__ */ jsx(TextualSectionContent, { children: /* @__PURE__ */ jsx(ParcelEstimatedDateWindowText, { parcel, locale: loc }) })
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("tracking.inTransit.email.cta", loc),
            href: `https://track.baback.co/tracking/${parcel.trackingId}`
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Hr, { className: "my-lg border-gray-300" }),
      /* @__PURE__ */ jsx(DeliveryDetails, { parcel, locale }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview5 = {
  parcel: previewParcel,
  shop: previewShop,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
InTransitEmail.PreviewProps = preview5;
async function deliveredEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(DeliveredEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(DeliveredEmail, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
async function deliveredToNeighbourEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(ParcelDeliveredToNeighbour, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(ParcelDeliveredToNeighbour, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
async function inTransitEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(InTransitEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(InTransitEmail, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
function ParcelException({
  parcel,
  shop,
  locale,
  googleWalletURL,
  appleWalletURL,
  walletEnabled
}) {
  const loc = locale || "fr";
  const exceptionLabel = parcel.events.sort((a, b) => b.createdAt - a.createdAt).find((event) => event.status === "EXCEPTION")?.label;
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(Section, { className: "my-8", children: [
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.exception.email.title", loc) }),
          /* @__PURE__ */ jsxs(TextualSectionContent, { children: [
            t("tracking.exception.email.description", loc),
            " ",
            exceptionLabel
          ] })
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("tracking.exception.email.cta", loc),
            href: shop.preferences.contactLink
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Hr, { className: "my-lg border-gray-300" }),
      /* @__PURE__ */ jsx(DeliveryDetails, { parcel, locale }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview6 = {
  parcel: previewParcel,
  shop: previewShop,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
ParcelException.PreviewProps = preview6;
async function parcelExceptionEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(ParcelException, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(ParcelException, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
function ReturnedToSenderEmail({
  parcel,
  shop,
  locale,
  googleWalletURL,
  appleWalletURL,
  walletEnabled
}) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(Section, { className: "my-8", children: [
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.returnedToSender.email.title", loc) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: t("tracking.returnedToSender.email.description", loc) })
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("tracking.returnedToSender.email.cta", loc),
            href: shop.preferences.contactLink
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Hr, { className: "my-lg border-gray-300" }),
      /* @__PURE__ */ jsx(DeliveryDetails, { parcel, locale }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview7 = {
  parcel: previewParcel,
  shop: previewShop,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
ReturnedToSenderEmail.PreviewProps = preview7;
var returned_to_sender_default = ReturnedToSenderEmail;
async function parcelReturnedToSenderEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(returned_to_sender_default, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(returned_to_sender_default, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
async function preTransitEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(PreTransitEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(PreTransitEmail, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
async function waitingAtPickupPointEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(WaitingAtPickupPointEmail, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(WaitingAtPickupPointEmail, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
function WaitingAtPickupPointSevereEmail({
  parcel,
  shop,
  locale,
  googleWalletURL,
  appleWalletURL,
  walletEnabled
}) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(Section, { className: "my-8", children: [
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.waitingAtPickupPointSevere.email.title", loc) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: t("tracking.waitingAtPickupPointSevere.email.description", loc) }),
          parcel.endDepositDate && /* @__PURE__ */ jsx(TextualSectionContent, { children: /* @__PURE__ */ jsx(ParcelEndDepositDateText, { parcel, locale: loc }) })
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("tracking.waitingAtPickupPointSevere.email.cta", loc),
            href: `https://track.baback.co/tracking/${parcel.trackingId}`
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Hr, { className: "my-lg border-gray-300" }),
      /* @__PURE__ */ jsx(DeliveryDetails, { parcel, locale }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview8 = {
  parcel: previewParcel,
  shop: previewShop,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
WaitingAtPickupPointSevereEmail.PreviewProps = preview8;
var waiting_at_pickup_point_severe_default = WaitingAtPickupPointSevereEmail;
async function waitingAtPickupPointSevereEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(waiting_at_pickup_point_severe_default, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(waiting_at_pickup_point_severe_default, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}
function WaitingInformationFromAddressEmail({
  parcel,
  shop,
  locale,
  googleWalletURL,
  appleWalletURL,
  walletEnabled
}) {
  const loc = locale || "fr";
  return /* @__PURE__ */ jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxs(EmailCard, { children: [
      /* @__PURE__ */ jsx(BrandHeader, { shop }),
      /* @__PURE__ */ jsxs(Section, { className: "my-8", children: [
        /* @__PURE__ */ jsxs(TextualSectionContainer, { children: [
          /* @__PURE__ */ jsx(TextualSectionTitle, { children: t("tracking.waitingInformationFromAddress.email.title", loc) }),
          /* @__PURE__ */ jsx(TextualSectionContent, { children: t("tracking.waitingInformationFromAddress.email.description", loc) })
        ] }),
        /* @__PURE__ */ jsx(
          SingleButtonSection,
          {
            label: t("tracking.waitingInformationFromAddress.email.cta", loc),
            href: `https://track.baback.co/tracking/${parcel.trackingId}`
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Hr, { className: "my-lg border-gray-300" }),
      /* @__PURE__ */ jsx(DeliveryDetails, { parcel, locale }),
      walletEnabled && /* @__PURE__ */ jsx(
        WalletSection,
        {
          googleWalletURL,
          appleWalletURL,
          locale: loc
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Footer, {})
  ] });
}
var preview9 = {
  parcel: previewParcel,
  shop: previewShop,
  googleWalletURL: "https://example.com/google-wallet",
  appleWalletURL: "https://example.com/apple-wallet",
  walletEnabled: true
};
WaitingInformationFromAddressEmail.PreviewProps = preview9;
var waiting_information_from_address_default = WaitingInformationFromAddressEmail;
async function waitingInformationFromAddressEmail(props) {
  const locale = props.locale || "fr";
  await ensureTranslationsReady(locale);
  const [html, text] = await Promise.all([
    render$1(/* @__PURE__ */ jsx(waiting_information_from_address_default, { ...props, locale })),
    render$1(/* @__PURE__ */ jsx(waiting_information_from_address_default, { ...props, locale }), { plainText: true })
  ]);
  return { html, text };
}

// src/templates/tracking/pre-transit.ts
var preTransitEmailTemplateSubject = {
  "fr": "Votre commande {{shop.name}} : l\u2019\xE9tiquette est g\xE9n\xE9r\xE9e et le suivi d\xE9marre.",
  "en": "The order is at the departure warehouse",
  "es": "El pedido est\xE1 en el almac\xE9n de salida",
  "it": "L'ordine \xE8 nel magazzino di partenza",
  "de": "Die Bestellung befindet sich im Ausgangslager",
  "nl": "De bestelling is in het vertrekmagazijn",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "O pedido est\xE1 no armaz\xE9m de partida",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "\u8BA2\u5355\u5DF2\u5728\u53D1\u8D27\u4ED3\u5E93\u5F85\u53D1",
  "ja": "\u3054\u6CE8\u6587\u306F\u51FA\u8377\u5009\u5EAB\u306B\u3066\u6E96\u5099\u4E2D\u3067\u3059"
};
var preTransitEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE EST PR\xCATE POUR L'EXP\xC9DITION</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est pr\xEAte ! </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Elle sera bient\xF4t prise en charge par le transporteur.&nbsp;</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER IS READY FOR SHIPPING</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is ready!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">It will soon be handled by the carrier.&nbsp;</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO EST\xC1 LISTO PARA EL ENV\xCDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 listo!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pronto ser\xE1 gestionado por el transportista.&nbsp;</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE \xC8 PRONTO PER LA SPEDIZIONE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 pronto!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Sar\xE0 presto gestito dal corriere.&nbsp;</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG IST VERSANDBEREIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ist bereit!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Es wird bald vom Spediteur bearbeitet.&nbsp;</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW BESTELLING IS KLAAR VOOR VERZENDING</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, uw bestelling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is klaar!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Het zal binnenkort door de vervoerder worden afgehandeld.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO EST\xC1 PRONTO PARA ENVIO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 pronto!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Em breve ser\xE1 tratado pelo transportador.&nbsp;</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u51C6\u5907\u597D\u53D1\u8D27</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u5DF2\u51C6\u5907\u597D\uFF01</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u627F\u8FD0\u5546\u5C06\u5F88\u5FEB\u5904\u7406\u3002&nbsp;</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306F\u767A\u9001\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306E\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\uFF01</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u307E\u3082\u306A\u304F\u914D\u9001\u696D\u8005\u304C\u5BFE\u5FDC\u3044\u305F\u3057\u307E\u3059\u3002&nbsp;</span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/parcel-not-shipped.ts
var parcelNotShippedEmailTemplateSubject = {
  "fr": "{{shop.name}} vous informe : aucun mouvement de votre commande d\xE9tect\xE9 pour l\u2019instant, nous suivons la situation de pr\xE8s.",
  "en": "{{shop.name}} informs you: no movement of your order detected for now, we are closely monitoring the situation.",
  "es": "{{shop.name}} le informa: no se ha detectado movimiento de su pedido por el momento, seguimos la situaci\xF3n de cerca.",
  "it": "{{shop.name}} ti informa: nessun movimento del tuo ordine rilevato per ora, stiamo monitorando la situazione da vicino.",
  "de": "{{shop.name}} informiert Sie: Keine Bewegung Ihrer Bestellung festgestellt, wir verfolgen die Situation genau.",
  "nl": "{{shop.name}} informeert u: geen beweging van uw bestelling gedetecteerd, we volgen de situatie op de voet.",
  "pl": "{{shop.name}} informuje: nie wykryto ruchu twojego zam\xF3wienia, uwa\u017Cnie \u015Bledzimy sytuacj\u0119.",
  "da": "{{shop.name}} informerer dig: ingen bev\xE6gelse af din ordre opdaget for nu, vi overv\xE5ger situationen n\xF8je.",
  "pt": "{{shop.name}} informa: nenhum movimento do seu pedido detectado por enquanto, estamos monitorando a situa\xE7\xE3o de perto.",
  "sv": "{{shop.name}} informerar dig: ingen r\xF6relse av din best\xE4llning uppt\xE4ckt f\xF6r tillf\xE4llet, vi \xF6vervakar situationen noga.",
  "fi": "{{shop.name}} ilmoittaa: tilaustasi ei ole havaittu liikkuvan t\xE4ll\xE4 hetkell\xE4, seuraamme tilannetta tarkasti.",
  "no": "{{shop.name}} informerer deg: ingen bevegelse av bestillingen din oppdaget for \xF8yeblikket, vi f\xF8lger situasjonen n\xF8ye.",
  "bg": "{{shop.name}} \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430: \u043D\u0435 \u0435 \u0437\u0430\u0441\u0435\u0447\u0435\u043D\u043E \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430, \u0441\u043B\u0435\u0434\u0438\u043C \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044F\u0442\u0430 \u043E\u0442\u0431\u043B\u0438\u0437\u043E.",
  "cs": "{{shop.name}} v\xE1s informuje: nebyl zji\u0161t\u011Bn \u017E\xE1dn\xFD pohyb va\u0161\xED objedn\xE1vky, situaci pe\u010Dliv\u011B sledujeme.",
  "hu": "{{shop.name}} t\xE1j\xE9koztat: a rendel\xE9sed mozg\xE1s\xE1t nem \xE9szlelt\xFCk, szorosan figyelj\xFCk a helyzetet.",
  "sk": "{{shop.name}} v\xE1s informuje: zatia\u013E nebol zisten\xFD \u017Eiadny pohyb va\u0161ej objedn\xE1vky, situ\xE1ciu pozorne sledujeme.",
  "zh": "{{shop.name}} \u901A\u77E5\u60A8\uFF1A\u6682\u672A\u68C0\u6D4B\u5230\u60A8\u7684\u8BA2\u5355\u6709\u7269\u6D41\u52A8\u6001\uFF0C\u6211\u4EEC\u6B63\u5728\u5BC6\u5207\u5173\u6CE8\u3002",
  "ja": "{{shop.name}} \u3088\u308A\u304A\u77E5\u3089\u305B\uFF1A\u73FE\u5728\u3054\u6CE8\u6587\u306E\u914D\u9001\u72B6\u6CC1\u306B\u52D5\u304D\u304C\u78BA\u8A8D\u3055\u308C\u3066\u304A\u308A\u307E\u305B\u3093\u3002\u72B6\u6CC1\u3092\u6CE8\u610F\u6DF1\u304F\u76E3\u8996\u3057\u3066\u304A\u308A\u307E\u3059\u3002"
};
var parcelNotShippedEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ENCORE UN PEU DE PATIENCE...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est finalis\xE9e et pr\xEAte \xE0 \xEAtre exp\xE9di\xE9e.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous sommes dans l'attente de </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> </span><span style="font-size: 12px;">pour entamer sa mise en livraison.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A LITTLE MORE PATIENCE...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is finalized and ready to be shipped.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are waiting for </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> </span><span style="font-size: 12px;">to start its delivery.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UN POCO M\xC1S DE PACIENCIA...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 finalizado y listo para ser enviado.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Estamos esperando a </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nombre del transportista" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nombre del transportista</span> </span><span style="font-size: 12px;">para iniciar su entrega.</span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ANCORA UN PO' DI PAZIENZA...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 finalizzato e pronto per essere spedito.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stiamo aspettando </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nome del corriere" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nome del corriere</span> </span><span style="font-size: 12px;">per iniziare la consegna.</span></p>`
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>NOCH EIN WENIG GEDULD...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ist abgeschlossen und bereit zum Versand.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir warten auf </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Name des Spediteurs" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Name des Spediteurs</span> </span><span style="font-size: 12px;">um mit der Lieferung zu beginnen.</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>NOG EVEN GEDULD...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, uw bestelling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is afgerond en klaar om te worden verzonden.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We wachten op </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Naam van de vervoerder" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Naam van de vervoerder</span> </span><span style="font-size: 12px;">om met de levering te beginnen.</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JESZCZE TROCH\u0118 CIERPLIWO\u015ACI...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, twoje zam\xF3wienie <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> jest gotowe do wysy\u0142ki.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Czekamy na </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nazwa przewo\u017Anika" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nazwa przewo\u017Anika</span> </span><span style="font-size: 12px;">aby rozpocz\u0105\u0107 dostaw\u0119.</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>LIDT MERE T\xC5LMODIGHED...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din ordre <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er f\xE6rdiggjort og klar til at blive sendt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi venter p\xE5 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Transport\xF8rens navn" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Transport\xF8rens navn</span> </span><span style="font-size: 12px;">for at starte leveringen.</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UM POUCO MAIS DE PACI\xCANCIA...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 finalizado e pronto para ser enviado.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Estamos aguardando </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nome do transportador" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nome do transportador</span> </span><span style="font-size: 12px;">para iniciar a entrega.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>LITE MER T\xC5LAMOD...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din best\xE4llning <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE4r f\xE4rdigst\xE4lld och redo att skickas.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi v\xE4ntar p\xE5 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Transport\xF6rens namn" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Transport\xF6rens namn</span> </span><span style="font-size: 12px;">f\xF6r att p\xE5b\xF6rja leveransen.</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VIEL\xC4 V\xC4H\xC4N K\xC4RSIV\xC4LLISYYTT\xC4...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, tilauksesi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> on valmis ja l\xE4hetett\xE4viss\xE4.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Odotamme </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Kuljettajan nimi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Kuljettajan nimi</span> </span><span style="font-size: 12px;">aloittamaan toimituksen.</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>LITT MER T\xC5LMODIGHET...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din bestilling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er ferdigstilt og klar til \xE5 sendes.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi venter p\xE5 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Transport\xF8rens navn" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Transport\xF8rens navn</span> </span><span style="font-size: 12px;">for \xE5 starte leveringen.</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u041E\u0429\u0415 \u041C\u0410\u041B\u041A\u041E \u0422\u042A\u0420\u041F\u0415\u041D\u0418\u0415...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u0435 \u0433\u043E\u0442\u043E\u0432\u0430 \u0437\u0430 \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u041E\u0447\u0430\u043A\u0432\u0430\u043C\u0435 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="\u0418\u043C\u0435 \u043D\u0430 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@\u0418\u043C\u0435 \u043D\u0430 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430</span> </span><span style="font-size: 12px;">\u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE\u0160T\u011A TROCHU TRP\u011ALIVOSTI...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161e objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je p\u0159ipravena k odesl\xE1n\xED.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u010Cek\xE1me na </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="N\xE1zev dopravce" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@N\xE1zev dopravce</span> </span><span style="font-size: 12px;">aby zah\xE1jil doru\u010Dov\xE1n\xED.</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>M\xC9G EGY KIS T\xDCRELEM...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a rendel\xE9se <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> k\xE9szen \xE1ll a sz\xE1ll\xEDt\xE1sra.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">V\xE1runk a </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Sz\xE1ll\xEDt\xF3 neve" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sz\xE1ll\xEDt\xF3 neve</span> </span><span style="font-size: 12px;">hogy megkezdje a sz\xE1ll\xEDt\xE1st.</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>E\u0160TE TROCHU TRPEZLIVOSTI...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161a objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je pripraven\xE1 na odoslanie.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u010Cak\xE1me na </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="N\xE1zov dopravcu" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@N\xE1zov dopravcu</span> </span><span style="font-size: 12px;">aby za\u010Dal doru\u010Dovanie.</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8BF7\u518D\u8010\u5FC3\u7B49\u5F85...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u5DF2\u5B8C\u6210\u5E76\u51C6\u5907\u53D1\u8D27\u3002</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u6211\u4EEC\u6B63\u5728\u7B49\u5F85 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> </span><span style="font-size: 12px;">\u5F00\u59CB\u914D\u9001\u3002</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3082\u3046\u5C11\u3057\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306E\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u767A\u9001\u53EF\u80FD\u3067\u3059\u3002</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u73FE\u5728\u304A\u5F85\u3061\u3057\u3066\u3044\u308B\u306E\u306F </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> </span><span style="font-size: 12px;">\u304C\u914D\u9001\u3092\u958B\u59CB\u3059\u308B\u306E\u3092\u5F85\u3063\u3066\u3044\u307E\u3059\u3002</span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Content of your order</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhalt Ihrer Bestellung</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido de su pedido</u></strong></span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto del tuo ordine</u></strong></span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do seu pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van uw bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inneh\xE5ll i din best\xE4llning</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaustesi sis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Innholdet i bestillingen din</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Indholdet af din ordre</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 twojego zam\xF3wienia</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9sed tartalma</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161ej objedn\xE1vky</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161\xED objedn\xE1vky</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u60A8\u7684\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/in-transit.ts
var inTransitEmailTemplateSubject = {
  "fr": "Bonne nouvelle : votre colis {{shop.name}} est d\xE9sormais en cours d'acheminement. ",
  "en": "Good news: your {{shop.name}} package is now in transit.",
  "es": "Buenas noticias: su paquete {{shop.name}} est\xE1 en tr\xE1nsito.",
  "it": "Buone notizie: il tuo pacco {{shop.name}} \xE8 ora in transito.",
  "de": "Gute Nachrichten: Ihr {{shop.name}} Paket ist jetzt unterwegs.",
  "nl": "Goed nieuws: je {{shop.name}} pakket is nu onderweg.",
  "pl": "Dobre wie\u015Bci: Twoja paczka {{shop.name}} jest ju\u017C w drodze.",
  "da": "Gode nyheder: din {{shop.name}} pakke er nu p\xE5 vej.",
  "pt": "Boas not\xEDcias: seu pacote {{shop.name}} est\xE1 em tr\xE2nsito.",
  "sv": "Goda nyheter: ditt {{shop.name}} paket \xE4r nu p\xE5 v\xE4g.",
  "fi": "Hyvi\xE4 uutisia: {{shop.name}}-pakettisi on nyt matkalla.",
  "no": "Gode nyheter: {{shop.name}}-pakken din er n\xE5 p\xE5 vei.",
  "bg": "\u0414\u043E\u0431\u0440\u0438 \u043D\u043E\u0432\u0438\u043D\u0438: \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0435\u0447\u0435 \u0435 \u0432 \u0442\u0440\u0430\u043D\u0437\u0438\u0442.",
  "cs": "Dobr\xE9 zpr\xE1vy: v\xE1\u0161 bal\xED\u010Dek {{shop.name}} je nyn\xED na cest\u011B.",
  "hu": "J\xF3 h\xEDr: a(z) {{shop.name}} csomagod most m\xE1r \xFAton van.",
  "sk": "Dobr\xE9 spr\xE1vy: v\xE1\u0161 bal\xEDk {{shop.name}} je teraz na ceste.",
  "zh": "\u597D\u6D88\u606F\uFF1A\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5DF2\u53D1\u51FA\uFF0C\u6B63\u5728\u8FD0\u8F93\u4E2D\u3002",
  "ja": "{{shop.name}} \u306E\u8377\u7269\u304C\u767A\u9001\u3055\u308C\u307E\u3057\u305F\u3002\u73FE\u5728\u914D\u9001\u4E2D\u3067\u3059\u3002"
};
var inTransitEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST EN COURS D'ACHEMINEMENT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est d\xE9sormais dans les mains du transporteur <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous vous tiendrons inform\xE9(e) de son acheminement.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS IN TRANSIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is now in the hands of the carrier <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We will keep you informed of its progress.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE EST\xC1 EN TR\xC1NSITO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 ahora en manos del transportista <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Le mantendremos informado de su progreso.</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 IN TRANSITO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 ora nelle mani del corriere <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Ti terremo informato sui suoi progressi.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHR PAKET IST UNTERWEGS</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ist jetzt in den H\xE4nden des Spediteurs <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir werden Sie \xFCber den Fortschritt informieren.</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET IS ONDERWEG</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, je bestelling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is nu in handen van de vervoerder <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We houden je op de hoogte van de voortgang.</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST W DRODZE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Twoje zam\xF3wienie <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> jest teraz w r\u0119kach przewo\u017Anika <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">B\u0119dziemy Ci\u0119 informowa\u0107 o jego post\u0119pach.</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER P\xC5 VEJ</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din ordre <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er nu i h\xE6nderne p\xE5 transport\xF8ren <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi vil holde dig informeret om dens fremskridt.</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 EM TR\xC2NSITO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 agora nas m\xE3os do transportador <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Iremos mant\xEA-lo informado sobre o progresso.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET \xC4R P\xC5 V\xC4G</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din best\xE4llning <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE4r nu i h\xE4nderna p\xE5 transport\xF6ren <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi kommer att h\xE5lla dig informerad om dess framsteg.</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON MATKALLA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, tilauksesi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> on nyt kuljettajan k\xE4siss\xE4 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4.</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER P\xC5 VEI</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, bestillingen din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er n\xE5 i hendene p\xE5 transport\xF8ren <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi vil holde deg informert om fremdriften.</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u0412 \u0422\u0420\u0410\u041D\u0417\u0418\u0422</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u0432\u0435\u0447\u0435 \u0435 \u0432 \u0440\u044A\u0446\u0435\u0442\u0435 \u043D\u0430 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u043C\u0443.</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCD\u010CEK JE NA CEST\u011A</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161e objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je nyn\xED v rukou dopravce <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Budeme v\xE1s informovat o jeho postupu.</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGOD \xDATON VAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a rendel\xE9sed <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> most a sz\xE1ll\xEDt\xF3 kez\xE9ben van <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l.</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE NA CESTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161a objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je teraz v ruk\xE1ch dopravcu <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Budeme v\xE1s informova\u0165 o jeho priebehu.</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u6B63\u5728\u8FD0\u8F93\u4E2D</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u73B0\u5728\u7531\u627F\u8FD0\u5546\u5904\u7406 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u6211\u4EEC\u5C06\u968F\u65F6\u901A\u77E5\u60A8\u8FDB\u5C55\u3002</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306F\u914D\u9001\u4E2D\u3067\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306F\u914D\u9001\u696D\u8005\u304C\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u3059 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u9032\u6357\u3092\u968F\u6642\u304A\u77E5\u3089\u305B\u3044\u305F\u3057\u307E\u3059\u3002</span></p>'
        }
      }
    },
    {
      "id": "32a8f947-3013-4309-9d90-13953a4e2534",
      "type": "estimated-delivery-date",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "12818071-aad6-41c5-be86-968fdb3d31db",
      "type": "button",
      "alignment": "center",
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contents of your order</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido de su pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhalt Ihrer Bestellung</u></strong></span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto del tuo ordine</u></strong></span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do seu pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van uw bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inneh\xE5ll i din best\xE4llning</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilauksesi sis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Innholdet i bestillingen din</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Indholdet af din ordre</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9sed tartalma</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161ej objedn\xE1vky</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161\xED objedn\xE1vky</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u60A8\u7684\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/customs-clearance-start.ts
var customsClearanceStartEmailTemplateSubject = {
  "fr": "{{carrier.name}} signale une difficult\xE9 douani\xE8re ; {{shop.name}} suit le dossier et vous accompagnera jusqu\u2019\xE0 r\xE9solution.",
  "en": "{{carrier.name}} reports a customs issue; {{shop.name}} is monitoring the case and will assist you until resolution.",
  "es": "{{carrier.name}} informa de un problema aduanero; {{shop.name}} est\xE1 monitoreando el caso y le asistir\xE1 hasta la resoluci\xF3n.",
  "it": "{{carrier.name}} segnala un problema doganale; {{shop.name}} sta monitorando il caso e ti assister\xE0 fino alla risoluzione.",
  "de": "{{carrier.name}} meldet ein Zollproblem; {{shop.name}} \xFCberwacht den Fall und wird Sie bis zur L\xF6sung unterst\xFCtzen.",
  "nl": "{{carrier.name}} meldt een douaneprobleem; {{shop.name}} volgt de zaak en zal u bijstaan tot de oplossing.",
  "pl": "{{carrier.name}} zg\u0142asza problem celny; {{shop.name}} monitoruje spraw\u0119 i b\u0119dzie Ci\u0119 wspiera\u0107 a\u017C do rozwi\u0105zania.",
  "da": "{{carrier.name}} rapporterer et toldproblem; {{shop.name}} overv\xE5ger sagen og vil hj\xE6lpe dig indtil l\xF8sningen.",
  "pt": "{{carrier.name}} relata um problema aduaneiro; {{shop.name}} est\xE1 monitorando o caso e ir\xE1 assisti-lo at\xE9 a resolu\xE7\xE3o.",
  "sv": "{{carrier.name}} rapporterar ett tullproblem; {{shop.name}} \xF6vervakar \xE4rendet och kommer att hj\xE4lpa dig tills det \xE4r l\xF6st.",
  "fi": "{{carrier.name}} ilmoittaa tulliongelmasta; {{shop.name}} seuraa tapausta ja auttaa sinua ratkaisuun asti.",
  "no": "{{carrier.name}} rapporterer et tollproblem; {{shop.name}} overv\xE5ker saken og vil hjelpe deg til den er l\xF8st.",
  "bg": "{{carrier.name}} \u0441\u044A\u043E\u0431\u0449\u0430\u0432\u0430 \u0437\u0430 \u043C\u0438\u0442\u043D\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C; {{shop.name}} \u0441\u043B\u0435\u0434\u0438 \u0441\u043B\u0443\u0447\u0430\u044F \u0438 \u0449\u0435 \u0432\u0438 \u043F\u043E\u043C\u043E\u0433\u043D\u0435 \u0434\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u043C\u0443.",
  "cs": "{{carrier.name}} hl\xE1s\xED celn\xED probl\xE9m; {{shop.name}} sleduje p\u0159\xEDpad a bude v\xE1s podporovat a\u017E do vy\u0159e\u0161en\xED.",
  "hu": "{{carrier.name}} v\xE1m jelent egy v\xE1mprobl\xE9m\xE1t; {{shop.name}} figyelemmel k\xEDs\xE9ri az \xFCgyet, \xE9s seg\xEDt a megold\xE1sig.",
  "sk": "{{carrier.name}} hl\xE1si coln\xFD probl\xE9m; {{shop.name}} sleduje pr\xEDpad a bude v\xE1s podporova\u0165 a\u017E do vyrie\u0161enia.",
  "zh": "{{carrier.name}} \u62A5\u544A\u4E86\u6D77\u5173\u95EE\u9898\uFF1B{{shop.name}} \u6B63\u5728\u8DDF\u8FDB\u6B64\u6848\u4EF6\uFF0C\u5C06\u534F\u52A9\u60A8\u76F4\u81F3\u89E3\u51B3\u3002",
  "ja": "{{carrier.name}} \u3088\u308A\u901A\u95A2\u306B\u95A2\u3059\u308B\u554F\u984C\u304C\u5831\u544A\u3055\u308C\u307E\u3057\u305F\u3002{{shop.name}} \u304C\u89E3\u6C7A\u307E\u3067\u30B5\u30DD\u30FC\u30C8\u3044\u305F\u3057\u307E\u3059\u3002"
};
var customsClearanceStartEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST RETARD\xC9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nous informe que votre commande </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est actuellement retenue en douane.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cette proc\xE9dure est al\xE9atoire et retarde n\xE9cessairement l'acheminement de votre commande.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Nous vous tiendrons inform\xE9 de son \xE9volution et vous remercions pour votre patience.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS DELAYED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that your order </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is currently held at customs.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">This procedure is random and necessarily delays the delivery of your order.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">We will keep you informed of its progress and thank you for your patience.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE EST\xC1 RETRASADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos informa que su pedido </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 actualmente retenido en aduanas.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Este procedimiento es aleatorio y necesariamente retrasa la entrega de su pedido.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Le mantendremos informado de su progreso y le agradecemos su paciencia.</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 IN RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ci informa che il tuo ordine </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE8 attualmente trattenuto in dogana.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Questa procedura \xE8 casuale e ritarda necessariamente la consegna del tuo ordine.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Ti terremo informato sui suoi progressi e ti ringraziamo per la tua pazienza.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DEIN PAKET IST VERZ\xD6GERT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informiert uns, dass Ihre Bestellung </span><span style="color: rgb(0, 0, 0); font-size: 12px;">derzeit beim Zoll festgehalten wird.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dieses Verfahren ist zuf\xE4llig und verz\xF6gert notwendigerweise die Lieferung Ihrer Bestellung.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Wir werden Sie \xFCber den Fortschritt informieren und danken Ihnen f\xFCr Ihre Geduld.</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET IS VERTRAAGD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informeert ons dat uw bestelling </span><span style="color: rgb(0, 0, 0); font-size: 12px;">momenteel bij de douane wordt vastgehouden.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Deze procedure is willekeurig en vertraagt noodzakelijkerwijs de levering van uw bestelling.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">We zullen u op de hoogte houden van de voortgang en danken u voor uw geduld.</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST OP\xD3\u0179NIONA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informuje nas, \u017Ce Twoje zam\xF3wienie </span><span style="color: rgb(0, 0, 0); font-size: 12px;">jest obecnie zatrzymane w urz\u0119dzie celnym.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Ta procedura jest losowa i koniecznie op\xF3\u017Ania dostaw\u0119 Twojego zam\xF3wienia.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">B\u0119dziemy Ci\u0119 informowa\u0107 o jego post\u0119pach i dzi\u0119kujemy za cierpliwo\u015B\u0107.</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerer os om, at din ordre </span><span style="color: rgb(0, 0, 0); font-size: 12px;">i \xF8jeblikket holdes i tolden.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Denne procedure er tilf\xE6ldig og forsinker n\xF8dvendigvis leveringen af din ordre.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vi vil holde dig informeret om dens fremskridt og takker for din t\xE5lmodighed.</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 ATRASADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos informa que o seu pedido </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 atualmente retido na alf\xE2ndega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Este procedimento \xE9 aleat\xF3rio e atrasa necessariamente a entrega do seu pedido.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Manteremos voc\xEA informado sobre o progresso e agradecemos pela sua paci\xEAncia.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET \xC4R F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerar oss om att din best\xE4llning </span><span style="color: rgb(0, 0, 0); font-size: 12px;">f\xF6r n\xE4rvarande h\xE5lls i tullen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Denna procedur \xE4r slumpm\xE4ssig och f\xF6rsenar n\xF6dv\xE4ndigtvis leveransen av din best\xE4llning.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vi kommer att h\xE5lla dig informerad om dess framsteg och tackar f\xF6r ditt t\xE5lamod.</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON VIIV\xC4STYNYT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ilmoittaa, ett\xE4 tilauksesi </span><span style="color: rgb(0, 0, 0); font-size: 12px;">on t\xE4ll\xE4 hetkell\xE4 tullissa.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">T\xE4m\xE4 menettely on satunnainen ja viiv\xE4stytt\xE4\xE4 v\xE4ist\xE4m\xE4tt\xE4 tilauksesi toimitusta.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja kiit\xE4mme k\xE4rsiv\xE4llisyydest\xE4si.</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerer oss om at bestillingen din </span><span style="color: rgb(0, 0, 0); font-size: 12px;">for tiden holdes i tollen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Denne prosedyren er tilfeldig og forsinker n\xF8dvendigvis leveringen av bestillingen din.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vi vil holde deg informert om fremdriften og takker for din t\xE5lmodighet.</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u0417\u0410\u0411\u0410\u0412\u0415\u041D\u0410</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> \u043D\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430, \u0447\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0432 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0435 \u0437\u0430\u0434\u044A\u0440\u0436\u0430\u043D\u0430 \u043D\u0430 \u043C\u0438\u0442\u043D\u0438\u0446\u0430\u0442\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0422\u0430\u0437\u0438 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430 \u0435 \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u0430 \u0438 \u043D\u0435\u0438\u0437\u0431\u0435\u0436\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0435\u0439\u043D\u0438\u044F \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A \u0438 \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u0432\u0430\u0448\u0435\u0442\u043E \u0442\u044A\u0440\u043F\u0435\u043D\u0438\u0435.</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ZPO\u017DD\u011AN\xDD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informuje, \u017Ee va\u0161e objedn\xE1vka </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je moment\xE1ln\u011B zadr\u017Eena na celnici.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tento postup je n\xE1hodn\xFD a nutn\u011B zpo\u017E\u010Fuje doru\u010Den\xED va\u0161\xED objedn\xE1vky.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Budeme v\xE1s informovat o jeho postupu a d\u011Bkujeme za va\u0161i trp\u011Blivost.</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA K\xC9S\xC9SBEN VAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> t\xE1j\xE9koztatott minket, hogy rendel\xE9se </span><span style="color: rgb(0, 0, 0); font-size: 12px;">jelenleg v\xE1mkezel\xE9s alatt \xE1ll.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Ez az elj\xE1r\xE1s v\xE9letlenszer\u0171, \xE9s sz\xFCks\xE9gszer\u0171en k\xE9slelteti a rendel\xE9s k\xE9zbes\xEDt\xE9s\xE9t.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l, \xE9s k\xF6sz\xF6nj\xFCk t\xFCrelm\xE9t.</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ONESKOREN\xDD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informuje, \u017Ee va\u0161a objedn\xE1vka </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je moment\xE1lne zadr\u017Ean\xE1 na colnici.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tento postup je n\xE1hodn\xFD a nevyhnutne oneskoruje doru\u010Denie va\u0161ej objedn\xE1vky.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Budeme v\xE1s informova\u0165 o jeho priebehu a \u010Fakujeme za va\u0161u trpezlivos\u0165.</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u5DF2\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that \u60A8\u7684\u8BA2\u5355 </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is currently held at customs.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">This procedure is random and necessarily delays the delivery of \u60A8\u7684\u8BA2\u5355.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">We will keep you informed of its progress and thank you for your patience.</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306E\u914D\u9054\u304C\u9045\u308C\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that \u3054\u6CE8\u6587 </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is currently held at customs.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">This procedure is random and necessarily delays the delivery of \u3054\u6CE8\u6587.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">We will keep you informed of its progress and thank you for your patience.</span></p>'
        }
      }
    },
    {
      "id": "12818071-aad6-41c5-be86-968fdb3d31db",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Rastrear mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Verfolge mein Paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xED\u010Dek",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u0435\u0442\u0435 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contents of your order</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido de su pedido</u></strong></span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto del tuo ordine</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhalt Ihrer Bestellung</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van uw bestelling</u></strong></span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do seu pedido</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inneh\xE5ll i din best\xE4llning</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilauksesi sis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Innholdet i bestillingen din</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Indholdet af din ordre</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9sed tartalma</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161ej objedn\xE1vky</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161\xED objedn\xE1vky</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u60A8\u7684\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/customs-clearance-complete.ts
var customsClearanceCompleteEmailTemplateSubject = {
  "fr": "La proc\xE9dure douani\xE8re est termin\xE9e ; {{carrier.name}} reprend l\u2019acheminement de votre colis.",
  "en": "The customs check for your {{shop.name}} package is complete.",
  "es": "El control aduanero de su paquete {{shop.name}} est\xE1 completo.",
  "it": "Il controllo doganale del tuo pacco {{shop.name}} \xE8 terminato.",
  "de": "Die Zollkontrolle f\xFCr Ihr {{shop.name}} Paket ist abgeschlossen.",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "A verifica\xE7\xE3o aduaneira do seu pacote {{shop.name}} est\xE1 conclu\xEDda.",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5DF2\u5B8C\u6210\u6D77\u5173\u68C0\u67E5\u3002",
  "ja": "{{shop.name}} \u306E\u8377\u7269\u306E\u901A\u95A2\u624B\u7D9A\u304D\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"
};
var customsClearanceCompleteEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE A REPRIS SON ACHEMINEMENT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, les douanes nous informent avoir termin\xE9 le contr\xF4le de votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Nom du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du shop</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Le colis a repris son acheminement et sera bient\xF4t mis en livraison. </span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER HAS RESUMED ITS JOURNEY</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, customs have informed us that they have completed the check of your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package has resumed its journey and will soon be delivered. </span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO HA REANUDADO SU CAMINO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, las aduanas nos han informado que han completado el control de su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">El paquete ha reanudado su camino y pronto ser\xE1 entregado. </span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE HA RIPRESO IL SUO VIAGGIO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, le dogane ci hanno informato di aver completato il controllo del tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Il pacco ha ripreso il suo viaggio e sar\xE0 presto consegnato. </span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG HAT IHRE REISE WIEDERAUFGENOMMEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, der Zoll hat uns mitgeteilt, dass die Kontrolle Ihrer Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> abgeschlossen ist</span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Das Paket hat seine Reise wieder aufgenommen und wird bald geliefert. </span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO RETOMOU O SEU CAMINHO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, as alf\xE2ndegas informaram-nos que conclu\xEDram a verifica\xE7\xE3o do seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">O pacote retomou o seu caminho e ser\xE1 brevemente entregue. </span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u6062\u590D\u8FD0\u8F93</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, customs have informed us that they have completed the check of \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package has resumed its journey and will soon be delivered. </span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306F\u914D\u9001\u3092\u518D\u958B\u3057\u307E\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, customs have informed us that they have completed the check of \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package has resumed its journey and will soon be delivered. </span></p>'
        }
      }
    },
    {
      "id": "12818071-aad6-41c5-be86-968fdb3d31db",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Rastrear mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear o meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/delayed-package.ts
var delayedPackageEmailTemplateSubject = {
  "fr": "Un retard mod\xE9r\xE9 est identifi\xE9 par {{carrier.name}} ; nous assurons le suivi pr\xE9cis de votre commande {{shop.name}} ",
  "en": "A moderate delay is identified by {{carrier.name}}; we are closely monitoring your {{shop.name}} order.",
  "es": "Se ha identificado un retraso moderado por {{carrier.name}}; estamos monitoreando de cerca su pedido de {{shop.name}}.",
  "it": "Un ritardo moderato \xE8 stato identificato da {{carrier.name}}; stiamo monitorando attentamente il tuo ordine {{shop.name}}.",
  "de": "Ein moderater Verzug wird von {{carrier.name}} festgestellt; wir \xFCberwachen Ihre {{shop.name}} Bestellung genau.",
  "nl": "Een matige vertraging is ge\xEFdentificeerd door {{carrier.name}}; we volgen uw {{shop.name}} bestelling nauwlettend.",
  "pl": "Umiarkowane op\xF3\u017Anienie zosta\u0142o zidentyfikowane przez {{carrier.name}}; dok\u0142adnie monitorujemy Twoje zam\xF3wienie {{shop.name}}.",
  "da": "En moderat forsinkelse er identificeret af {{carrier.name}}; vi overv\xE5ger din {{shop.name}} ordre n\xF8je.",
  "pt": "Um atraso moderado foi identificado por {{carrier.name}}; estamos monitorando de perto seu pedido {{shop.name}}.",
  "sv": "En m\xE5ttlig f\xF6rsening har identifierats av {{carrier.name}}; vi \xF6vervakar din {{shop.name}} best\xE4llning noggrant.",
  "fi": "Kohtalainen viive on tunnistettu {{carrier.name}}; seuraamme tarkasti {{shop.name}} tilaustasi.",
  "no": "En moderat forsinkelse er identifisert av {{carrier.name}}; vi overv\xE5ker din {{shop.name}} bestilling n\xF8ye.",
  "bg": "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0435\u043D\u043E \u0435 \u0443\u043C\u0435\u0440\u0435\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435 \u043E\u0442 {{carrier.name}}; \u0432\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u043D\u043E \u0441\u043B\u0435\u0434\u0438\u043C \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{shop.name}}.",
  "cs": "M\xEDrn\xE9 zpo\u017Ed\u011Bn\xED bylo identifikov\xE1no {{carrier.name}}; pe\u010Dliv\u011B sledujeme va\u0161i objedn\xE1vku {{shop.name}}.",
  "hu": "M\xE9rs\xE9kelt k\xE9s\xE9st azonos\xEDtott a {{carrier.name}}; szorosan figyelemmel k\xEDs\xE9rj\xFCk a {{shop.name}} rendel\xE9s\xE9t.",
  "sk": "Mierne oneskorenie bolo identifikovan\xE9 {{carrier.name}}; pozorne sledujeme va\u0161u objedn\xE1vku {{shop.name}}.",
  "zh": "{{carrier.name}} \u53D1\u73B0\u8F7B\u5FAE\u5EF6\u8FDF\uFF0C\u6211\u4EEC\u6B63\u5728\u5BC6\u5207\u8DDF\u8E2A\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u3002",
  "ja": "{{carrier.name}} \u306B\u3088\u308A\u82E5\u5E72\u306E\u9045\u5EF6\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002{{shop.name}} \u306E\u3054\u6CE8\u6587\u3092\u6CE8\u610F\u6DF1\u304F\u8FFD\u8DE1\u3057\u3066\u3044\u307E\u3059\u3002"
};
var delayedPackageEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS POURRAIT \xCATRE RETARD\xC9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nous informe d'un \xE9v\xE8nement impliquant votre colis et pouvant entra\xEEner un retard dans son acheminement.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous faisons le n\xE9cessaire pour qu'il vous soit livr\xE9 d\xE8s que possible.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE MAY BE DELAYED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> has informed us of an event involving your package that may cause a delay in its delivery.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are doing everything necessary to ensure it is delivered to you as soon as possible.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE PODR\xCDA RETRASARSE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos ha informado de un evento que involucra su paquete y que podr\xEDa causar un retraso en su entrega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Estamos haciendo todo lo necesario para que le sea entregado lo antes posible.</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO POTREBBE ESSERE IN RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ci ha informato di un evento che coinvolge il tuo pacco e che potrebbe causare un ritardo nella consegna.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stiamo facendo tutto il necessario affinch\xE9 ti venga consegnato il prima possibile.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHR PAKET K\xD6NNTE SICH VERZ\xD6GERN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> hat uns \xFCber ein Ereignis informiert, das Ihr Paket betrifft und zu einer Verz\xF6gerung bei der Lieferung f\xFChren k\xF6nnte.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir tun alles Notwendige, um sicherzustellen, dass es Ihnen so schnell wie m\xF6glich geliefert wird.</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET KAN VERTRAAGD ZIJN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> heeft ons ge\xEFnformeerd over een gebeurtenis met uw pakket die mogelijk vertraging kan veroorzaken.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We doen er alles aan om ervoor te zorgen dat het zo snel mogelijk bij u wordt afgeleverd.</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA MO\u017BE SI\u0118 OP\xD3\u0179NI\u0106</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> poinformowa\u0142 nas o zdarzeniu dotycz\u0105cym Twojej paczki, kt\xF3re mo\u017Ce spowodowa\u0107 op\xF3\u017Anienie w jej dostarczeniu.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Robimy wszystko, co konieczne, aby zapewni\u0107, \u017Ce zostanie dostarczona do Ciebie jak najszybciej.</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE KAN BLIVE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> har informeret os om en h\xE6ndelse, der involverer din pakke, og som kan for\xE5rsage en forsinkelse i leveringen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi g\xF8r alt n\xF8dvendigt for at sikre, at den bliver leveret til dig s\xE5 hurtigt som muligt.</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE PODE ATRASAR-SE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informou-nos de um evento que envolve o seu pacote e que pode causar um atraso na entrega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Estamos a fazer tudo o que \xE9 necess\xE1rio para que lhe seja entregue o mais rapidamente poss\xEDvel.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET KAN F\xD6RSENAS</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> har informerat oss om en h\xE4ndelse som involverar ditt paket och som kan orsaka en f\xF6rsening i leveransen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi g\xF6r allt som kr\xE4vs f\xF6r att s\xE4kerst\xE4lla att det levereras till dig s\xE5 snart som m\xF6jligt.</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI SAATTAA VIIV\xC4STY\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> on ilmoittanut meille tapahtumasta, joka koskee pakettiasi ja saattaa aiheuttaa viiv\xE4styst\xE4 sen toimituksessa.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Teemme kaiken tarvittavan varmistaaksemme, ett\xE4 se toimitetaan sinulle mahdollisimman pian.</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN KAN BLI FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> har informert oss om en hendelse som involverer pakken din og som kan f\xF8re til en forsinkelse i leveringen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi gj\xF8r alt n\xF8dvendig for \xE5 sikre at den blir levert til deg s\xE5 snart som mulig.</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u041C\u041E\u0416\u0415 \u0414\u0410 \u0421\u0415 \u0417\u0410\u0411\u0410\u0412\u0418</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> \u043D\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430 \u0437\u0430 \u0441\u044A\u0431\u0438\u0442\u0438\u0435, \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u043E \u0441 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430, \u043A\u043E\u0435\u0442\u043E \u043C\u043E\u0436\u0435 \u0434\u0430 \u0434\u043E\u0432\u0435\u0434\u0435 \u0434\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u041F\u0440\u0430\u0432\u0438\u043C \u0432\u0441\u0438\u0447\u043A\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E, \u0437\u0430 \u0434\u0430 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0430\u043C\u0435, \u0447\u0435 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0441\u043A\u043E\u0440\u043E.</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK M\u016E\u017DE B\xDDT ZPO\u017DD\u011AN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informoval o ud\xE1losti t\xFDkaj\xEDc\xED se va\u0161eho bal\xEDku, kter\xE1 m\u016F\u017Ee zp\u016Fsobit zpo\u017Ed\u011Bn\xED jeho doru\u010Den\xED.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">D\u011Bl\xE1me v\u0161e pot\u0159ebn\xE9, abychom zajistili, \u017Ee v\xE1m bude doru\u010Den co nejd\u0159\xEDve.</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGJA K\xC9SLEKEDHET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> t\xE1j\xE9koztatott minket egy esem\xE9nyr\u0151l, amely a csomagj\xE1t \xE9rinti, \xE9s k\xE9s\xE9st okozhat a k\xE9zbes\xEDt\xE9sben.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Mindent megtesz\xFCnk annak \xE9rdek\xE9ben, hogy a lehet\u0151 leghamarabb k\xE9zbes\xEDts\xFCk \xD6nnek.</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160 BAL\xCDK M\xD4\u017DE BY\u0164 ONESKOREN\xDD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informoval o udalosti t\xFDkaj\xFAcej sa v\xE1\u0161ho bal\xEDka, ktor\xE1 m\xF4\u017Ee sp\xF4sobi\u0165 oneskorenie jeho doru\u010Denia.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Rob\xEDme v\u0161etko potrebn\xE9, aby sme zabezpe\u010Dili, \u017Ee v\xE1m bude doru\u010Den\xFD \u010Do najsk\xF4r.</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u53EF\u80FD\u4F1A\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> has informed us of an event involving \u60A8\u7684\u5305\u88F9 that may cause a delay in its delivery.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are doing everything necessary to ensure it is delivered to you as soon as possible.</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306E\u914D\u9054\u304C\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> has informed us of an event involving \u8377\u7269 that may cause a delay in its delivery.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are doing everything necessary to ensure it is delivered to you as soon as possible.</span></p>'
        }
      }
    },
    {
      "id": "12818071-aad6-41c5-be86-968fdb3d31db",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Rastrear mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear o meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xED\u010Dek",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u0435\u0442\u0435 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/delayed-package-severe.ts
var delayedPackageSevereEmailTemplateSubject = {
  "fr": "Un retard important est signal\xE9 par {{carrier.name}} ; nous restons pleinement mobilis\xE9s jusqu\u2019\xE0 la livraison de votre commande {{shop.name}} .",
  "en": "A significant delay is reported by {{carrier.name}}; we remain fully committed until your {{shop.name}} order is delivered.",
  "es": "Se informa de un retraso significativo por {{carrier.name}}; seguimos plenamente comprometidos hasta que se entregue su pedido de {{shop.name}}.",
  "it": "Un ritardo significativo \xE8 segnalato da {{carrier.name}}; rimaniamo pienamente impegnati fino alla consegna del tuo ordine {{shop.name}}.",
  "de": "Eine erhebliche Verz\xF6gerung wird von {{carrier.name}} gemeldet; wir bleiben voll engagiert, bis Ihre {{shop.name}} Bestellung geliefert wird.",
  "nl": "Een aanzienlijke vertraging wordt gemeld door {{carrier.name}}; we blijven volledig toegewijd totdat uw {{shop.name}} bestelling is geleverd.",
  "pl": "Znaczne op\xF3\u017Anienie jest zg\u0142aszane przez {{carrier.name}}; pozostajemy w pe\u0142ni zaanga\u017Cowani, dop\xF3ki Twoje zam\xF3wienie {{shop.name}} nie zostanie dostarczone.",
  "da": "En betydelig forsinkelse er rapporteret af {{carrier.name}}; vi forbliver fuldt engagerede, indtil din {{shop.name}} ordre er leveret.",
  "pt": "Um atraso significativo \xE9 relatado por {{carrier.name}}; permanecemos totalmente comprometidos at\xE9 que seu pedido {{shop.name}} seja entregue.",
  "sv": "En betydande f\xF6rsening rapporteras av {{carrier.name}}; vi f\xF6rblir fullt engagerade tills din {{shop.name}} best\xE4llning \xE4r levererad.",
  "fi": "Merkitt\xE4v\xE4 viive on ilmoitettu {{carrier.name}}; pysymme t\xE4ysin sitoutuneina, kunnes {{shop.name}} tilauksesi on toimitettu.",
  "no": "En betydelig forsinkelse er rapportert av {{carrier.name}}; vi forblir fullt engasjert til din {{shop.name}} bestilling er levert.",
  "bg": "\u0417\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435 \u0435 \u0434\u043E\u043A\u043B\u0430\u0434\u0432\u0430\u043D\u043E \u043E\u0442 {{carrier.name}}; \u043E\u0441\u0442\u0430\u0432\u0430\u043C\u0435 \u043D\u0430\u043F\u044A\u043B\u043D\u043E \u0430\u043D\u0433\u0430\u0436\u0438\u0440\u0430\u043D\u0438, \u0434\u043E\u043A\u0430\u0442\u043E \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{shop.name}} \u043D\u0435 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430.",
  "cs": "V\xFDznamn\xE9 zpo\u017Ed\u011Bn\xED je hl\xE1\u0161eno {{carrier.name}}; z\u016Fst\xE1v\xE1me pln\u011B odhodl\xE1ni, dokud nebude va\u0161e objedn\xE1vka {{shop.name}} doru\u010Dena.",
  "hu": "Jelent\u0151s k\xE9s\xE9st jelentett a {{carrier.name}}; teljes m\xE9rt\xE9kben elk\xF6telezettek maradunk, am\xEDg a {{shop.name}} rendel\xE9sedet k\xE9zbes\xEDtik.",
  "sk": "V\xFDznamn\xE9 oneskorenie je hl\xE1sen\xE9 {{carrier.name}}; zost\xE1vame plne odhodlan\xED, k\xFDm nebude va\u0161a objedn\xE1vka {{shop.name}} doru\u010Den\xE1.",
  "zh": "{{carrier.name}} \u62A5\u544A\u4E86\u4E25\u91CD\u5EF6\u8FDF\uFF0C\u6211\u4EEC\u5C06\u5168\u529B\u8DDF\u8FDB\u76F4\u81F3\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u9001\u8FBE\u3002",
  "ja": "{{carrier.name}} \u306B\u3088\u308A\u5927\u5E45\u306A\u9045\u5EF6\u304C\u5831\u544A\u3055\u308C\u307E\u3057\u305F\u3002{{shop.name}} \u306E\u3054\u6CE8\u6587\u304C\u5C4A\u304F\u307E\u3067\u5168\u529B\u3067\u5BFE\u5FDC\u3044\u305F\u3057\u307E\u3059\u3002"
};
var delayedPackageSevereEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST RETARD\xC9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nous informe que votre commande rencontre une difficult\xE9 dans son acheminement.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous en sommes d\xE9sol\xE9s.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous avons pris contact avec eux pour qu'il vous soit livr\xE9 d\xE8s que possible.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS DELAYED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that your order is experiencing a delivery issue.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are sorry for this.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We have contacted them to ensure it is delivered to you as soon as possible.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE EST\xC1 RETRASADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos informa que su pedido est\xE1 experimentando un problema de entrega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Lo sentimos mucho.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nos hemos puesto en contacto con ellos para asegurarnos de que se le entregue lo antes posible.</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 IN RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ci informa che il tuo ordine sta riscontrando un problema di consegna.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Ci dispiace.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Li abbiamo contattati per garantire che ti venga consegnato il prima possibile.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHR PAKET IST VERZ\xD6GERT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informiert uns, dass Ihre Bestellung ein Lieferproblem hat.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Es tut uns leid.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir haben sie kontaktiert, um sicherzustellen, dass es Ihnen so schnell wie m\xF6glich geliefert wird.</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW PAKKET IS VERTRAAGD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informeert ons dat uw bestelling een leveringsprobleem ondervindt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Het spijt ons.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We hebben contact met hen opgenomen om ervoor te zorgen dat het zo snel mogelijk bij u wordt afgeleverd.</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST OP\xD3\u0179NIONA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informuje nas, \u017Ce Twoje zam\xF3wienie ma problem z dostaw\u0105.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Przepraszamy za to.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Skontaktowali\u015Bmy si\u0119 z nimi, aby upewni\u0107 si\u0119, \u017Ce zostanie dostarczone do Ciebie tak szybko, jak to mo\u017Cliwe.</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerer os om, at din ordre oplever et leveringsproblem.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi beklager dette.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi har kontaktet dem for at sikre, at det bliver leveret til dig s\xE5 hurtigt som muligt.</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 ATRASADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos informa que o seu pedido est\xE1 a ter um problema de entrega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Lamentamos muito.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Entr\xE1mos em contacto com eles para garantir que seja entregue o mais rapidamente poss\xEDvel.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET \xC4R F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerar oss om att din best\xE4llning har ett leveransproblem.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi beklagar detta.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi har kontaktat dem f\xF6r att s\xE4kerst\xE4lla att det levereras till dig s\xE5 snart som m\xF6jligt.</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON MY\xD6H\xC4SS\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ilmoittaa, ett\xE4 tilauksesi toimituksessa on ongelma.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pahoittelemme t\xE4t\xE4.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Olemme ottaneet heihin yhteytt\xE4 varmistaaksemme, ett\xE4 se toimitetaan sinulle mahdollisimman pian.</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerer oss om at bestillingen din har et leveringsproblem.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi beklager dette.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi har kontaktet dem for \xE5 sikre at det blir levert til deg s\xE5 snart som mulig.</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u0417\u0410\u0411\u0410\u0412\u0415\u041D\u0410</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> \u043D\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430, \u0447\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 \u0438\u043C\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C \u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u0421\u044A\u0436\u0430\u043B\u044F\u0432\u0430\u043C\u0435 \u0437\u0430 \u0442\u043E\u0432\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u0421\u0432\u044A\u0440\u0437\u0430\u0445\u043C\u0435 \u0441\u0435 \u0441 \u0442\u044F\u0445, \u0437\u0430 \u0434\u0430 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0430\u043C\u0435, \u0447\u0435 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0441\u043A\u043E\u0440\u043E.</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160E Z\xC1SILKA JE ZPO\u017DD\u011AN\xC1</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informoval, \u017Ee va\u0161e objedn\xE1vka m\xE1 probl\xE9m s doru\u010Den\xEDm.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Omlouv\xE1me se za to.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Kontaktovali jsme je, abychom zajistili, \u017Ee bude doru\u010Dena co nejd\u0159\xEDve.</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGJA K\xC9S\xC9SBEN VAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> t\xE1j\xE9koztatott minket, hogy a rendel\xE9se k\xE9zbes\xEDt\xE9si probl\xE9m\xE1val k\xFCzd.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Eln\xE9z\xE9st k\xE9r\xFCnk ez\xE9rt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Felvett\xFCk vel\xFCk a kapcsolatot, hogy biztos\xEDtsuk, hogy a lehet\u0151 leghamarabb k\xE9zbes\xEDts\xE9k \xD6nnek.</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160 BAL\xCDK JE ONESKOREN\xDD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informoval, \u017Ee va\u0161a objedn\xE1vka m\xE1 probl\xE9m s doru\u010Den\xEDm.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Ospravedl\u0148ujeme sa za to.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Kontaktovali sme ich, aby sme zabezpe\u010Dili, \u017Ee bude doru\u010Den\xE1 \u010Do najsk\xF4r.</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u5DF2\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that \u60A8\u7684\u8BA2\u5355 is experiencing a delivery issue.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are sorry for this.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We have contacted them to ensure it is delivered to you as soon as possible.</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306E\u914D\u9054\u304C\u9045\u308C\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that \u3054\u6CE8\u6587 is experiencing a delivery issue.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are sorry for this.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We have contacted them to ensure it is delivered to you as soon as possible.</span></p>'
        }
      }
    },
    {
      "id": "12818071-aad6-41c5-be86-968fdb3d31db",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Rastrear mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear o meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagomat",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xED\u010Dek",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u0435\u0442\u0435 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido de su pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/waiting-information-from-address.ts
var waitingInformationFromAddressEmailTemplateSubject = {
  "fr": "{{carrier.name}} n\xE9cessite des informations compl\xE9mentaires pour finaliser la livraison. ",
  "en": "Your {{shop.name}} package is still being prepared.",
  "es": "Su paquete {{shop.name}} todav\xEDa est\xE1 en preparaci\xF3n.",
  "it": "Il tuo pacco {{shop.name}} \xE8 ancora in fase di preparazione.",
  "de": "Dein {{shop.name}} Paket wird noch vorbereitet.",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "O seu pacote {{shop.name}} ainda est\xE1 a ser preparado.",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "\u60A8\u7684 {{shop.name}} \u5305\u88F9\u4ECD\u5728\u51C6\u5907\u4E2D\u3002",
  "ja": "{{shop.name}} \u306E\u8377\u7269\u306F\u307E\u3060\u6E96\u5099\u4E2D\u3067\u3059\u3002"
};
var waitingInformationFromAddressEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong>BESOIN D'INFORMATIONS SUPPLEMENTAIRES POUR VOTRE LIVRAISON</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Code transporteur</span> nous informe qu'il a besoin d'informations compl\xE9mentaires pour vous livrer votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Nom du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du shop</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Code transporteur</span> va revenir vers vous rapidement pour les compl\xE9ter.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS STILL BEING PREPARED AND MAY EXPERIENCE A SLIGHT DELAY</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, your </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> package is still being prepared. We will keep you updated on its progress and delivery.&nbsp;</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE TODAV\xCDA EST\xC1 EN PREPARACI\xD3N Y PODR\xCDA SUFRIR UN LIGERO RETRASO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, su paquete </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> todav\xEDa est\xE1 en preparaci\xF3n. Le mantendremos informado sobre su progreso y entrega.&nbsp;</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 ANCORA IN PREPARAZIONE E POTREBBE SUBIRE UN LEGGERO RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, il tuo pacco </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \xE8 ancora in preparazione. Ti terremo informato sui suoi progressi e sulla consegna.&nbsp;</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DEIN PAKET WIRD NOCH VORBEREITET UND K\xD6NNTE SICH LEICHT VERZ\xD6GERN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, dein </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> Paket wird noch vorbereitet. Wir halten dich \xFCber den Fortschritt und die Lieferung auf dem Laufenden.&nbsp;</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE AINDA EST\xC1 A SER PREPARADO E PODE SOFRER UM LIGEIRO ATRASO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, o seu pacote </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> ainda est\xE1 a ser preparado. Iremos mant\xEA-lo informado sobre o progresso e a entrega.&nbsp;</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u4ECD\u5728\u51C6\u5907\u4E2D\uFF0C\u53EF\u80FD\u4F1A\u6709\u4E9B\u8BB8\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, your </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> package is still being prepared. \u6211\u4EEC\u5C06\u968F\u65F6\u544A\u77E5\u60A8\u8FDB\u5C55\u548C\u9001\u8FBE\u60C5\u51B5\u3002&nbsp;</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306F\u307E\u3060\u6E96\u5099\u4E2D\u3067\u3001\u82E5\u5E72\u9045\u5EF6\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, your </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> package is still being prepared. \u9032\u6357\u3068\u914D\u9001\u306B\u3064\u3044\u3066\u968F\u6642\u304A\u77E5\u3089\u305B\u3044\u305F\u3057\u307E\u3059\u3002&nbsp;</span></p>'
        }
      }
    },
    {
      "id": "12818071-aad6-41c5-be86-968fdb3d31db",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/out-for-delivery.ts
var outForDeliveryEmailTemplateSubject = {
  "fr": "Votre colis {{shop.name}} entrera en livraison aujourd\u2019hui et arrive tr\xE8s bient\xF4t.",
  "en": "Your order is on its way",
  "es": "Su pedido est\xE1 en camino",
  "it": "Il tuo ordine \xE8 in arrivo",
  "de": "Ihre Bestellung ist unterwegs",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "O seu pedido est\xE1 a caminho",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "\u60A8\u7684\u8BA2\u5355\u6B63\u5728\u6D3E\u9001\u4E2D",
  "ja": "\u3054\u6CE8\u6587\u306E\u8377\u7269\u304C\u914D\u9054\u4E2D\u3067\u3059"
};
var outForDeliveryEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE ARRIVE AUJOURD'HUI !</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est dans les mains du livreur de <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong>La date de livraison est planifi\xE9e ce jour.</strong></span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER ARRIVES TODAY!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is in the hands of the delivery person from </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The delivery date is scheduled for today. </span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\xA1SU PEDIDO LLEGA HOY!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 en manos del repartidor de </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nombre del transportista" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nombre del transportista</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">La fecha de entrega est\xE1 programada para hoy. </span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE ARRIVA OGGI!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 nelle mani del corriere di </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nome del corriere" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nome del corriere</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">La data di consegna \xE8 prevista per oggi. </span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG KOMMT HEUTE AN!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ist in den H\xE4nden des Lieferanten von </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Name des Lieferanten" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Name des Lieferanten</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Das Lieferdatum ist f\xFCr heute geplant. </span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO CHEGA HOJE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 nas m\xE3os do entregador de </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nome do transportador" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nome do transportador</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">A data de entrega est\xE1 agendada para hoje. </span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u4ECA\u5929\u9001\u8FBE\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u6B63\u7531\u914D\u9001\u5458\u5904\u7406\uFF0C\u627F\u8FD0\u5546\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u9001\u8FBE\u65E5\u671F\u5B9A\u5728\u4ECA\u5929\u3002 </span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306F\u672C\u65E5\u304A\u5C4A\u3051\u3057\u307E\u3059\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306F\u914D\u9001\u696D\u8005\u306E\u62C5\u5F53\u8005\u304C\u304A\u9810\u304B\u308A\u3057\u3066\u3044\u307E\u3059\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u914D\u9054\u65E5\u306F\u672C\u65E5\u306B\u4E88\u5B9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002 </span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "a3aaaf52-59fe-4eb1-b29d-ae5e14e77755",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/delivery-attempted.ts
var deliveryAttemptedEmailTemplateSubject = {
  "fr": "La tentative de livraison par {{carrier.name}} n\u2019a pas pu aboutir ; une nouvelle remise est d\xE9j\xE0 programm\xE9e.",
  "en": "Your order could not be delivered by {{carrier.name}}",
  "es": "Su pedido no pudo ser entregado por {{carrier.name}}",
  "it": "Il tuo ordine non \xE8 stato consegnato da {{carrier.name}}",
  "de": "Ihre Bestellung konnte nicht von {{carrier.name}} geliefert werden",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "O seu pedido n\xE3o p\xF4de ser entregue por {{carrier.name}}",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "{{carrier.name}} \u672A\u80FD\u6210\u529F\u914D\u9001\u60A8\u7684\u8BA2\u5355",
  "ja": "{{carrier.name}} \u306B\u3088\u308B\u3054\u6CE8\u6587\u306E\u914D\u9054\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F"
};
var deliveryAttemptedEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE N'A PAS PU \xCATRE LIVR\xC9E</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n'a pas pu \xEAtre livr\xE9e par <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ce jour.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Soyez rassur\xE9(e), des instructions arrivent afin de vous permettre d'organiser la relivraison de votre colis rapidement.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER COULD NOT BE DELIVERED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> could not be delivered by </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> today. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Rest assured, instructions are on the way to help you arrange the redelivery of your package. </span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO NO PUDO SER ENTREGADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> no pudo ser entregado por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoy. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">No se preocupe, las instrucciones est\xE1n en camino para ayudarle a organizar la reentrega de su paquete. </span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE NON HA POTUTO ESSERE CONSEGNATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> non ha potuto essere consegnato da </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> oggi. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stai tranquillo, le istruzioni stanno arrivando per aiutarti a organizzare la riconsegna del tuo pacco. </span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG KONNTE NICHT GELIEFERT WERDEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> konnte nicht von </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> heute geliefert werden. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Seien Sie versichert, Anweisungen sind unterwegs, um Ihnen bei der Organisation der erneuten Lieferung Ihres Pakets zu helfen. </span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO N\xC3O P\xD4DE SER ENTREGUE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n\xE3o p\xF4de ser entregue por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoje. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Fique tranquilo, as instru\xE7\xF5es est\xE3o a caminho para ajud\xE1-lo a organizar a reentrega do seu pacote. </span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u672A\u80FD\u9001\u8FBE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u672A\u80FD\u9001\u8FBE\uFF0C\u627F\u8FD0\u5546\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u4ECA\u5929\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u8BF7\u653E\u5FC3\uFF0C\u5173\u4E8E\u91CD\u65B0\u914D\u9001\u7684\u8BF4\u660E\u5373\u5C06\u53D1\u9001\u7ED9\u60A8\uFF1A \u60A8\u7684\u5305\u88F9. </span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u3092\u304A\u5C4A\u3051\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306B\u3088\u308B\u914D\u9001\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u672C\u65E5\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u5B89\u5FC3\u304F\u3060\u3055\u3044\u3002\u518D\u914D\u9054\u306E\u624B\u914D\u65B9\u6CD5\u306B\u3064\u3044\u3066\u6848\u5185\u3092\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\uFF1A \u8377\u7269. </span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "a3aaaf52-59fe-4eb1-b29d-ae5e14e77755",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Rastrear mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear o meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagomat",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xED\u010Dek",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u0435\u0442\u0435 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/redirect-to-pickup.ts
var redirectToPickupEmailTemplateSubject = {
  "fr": "N'ayant pas pu vous \xEAtre livr\xE9 directement, votre colis {{shop.name}} vous attend d\xE9sormais en point de retrait.",
  "en": "Your order could not be delivered by {{carrier.name}}",
  "es": "Su pedido no pudo ser entregado por {{carrier.name}}",
  "it": "Il tuo ordine non \xE8 stato consegnato da {{carrier.name}}",
  "de": "Ihre Bestellung konnte nicht von {{carrier.name}} geliefert werden",
  "nl": "Uw {{shop.name}} pakket kon niet worden bezorgd en is doorgestuurd naar een afhaalpunt.",
  "pl": "Twoja paczka {{shop.name}} nie mog\u0142a zosta\u0107 dostarczona i zosta\u0142a przekierowana do punktu odbioru.",
  "da": "Din {{shop.name}} pakke kunne ikke leveres og er blevet omdirigeret til et afhentningssted.",
  "pt": "O seu pedido n\xE3o p\xF4de ser entregue por {{carrier.name}}",
  "sv": "Ditt {{shop.name}}-paket kunde inte levereras och har omdirigerats till ett utl\xE4mningsst\xE4lle.",
  "fi": "{{shop.name}}-pakettiasi ei voitu toimittaa ja se on ohjattu noutopisteeseen.",
  "no": "{{shop.name}}-pakken din kunne ikke leveres og er omdirigert til et hentested.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u043D\u0435 \u043C\u043E\u0436\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u0438 \u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0430 \u043A\u044A\u043C \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} nemohl b\xFDt doru\u010Den a byl p\u0159esm\u011Brov\xE1n na v\xFDdejn\xED m\xEDsto.",
  "hu": "A {{shop.name}} csomagod nem volt k\xE9zbes\xEDthet\u0151, ez\xE9rt egy \xE1tv\xE9teli pontra ir\xE1ny\xEDtottuk.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} nemohol by\u0165 doru\u010Den\xFD a bol presmerovan\xFD na v\xFDdajn\xE9 miesto.",
  "zh": "{{carrier.name}} \u672A\u80FD\u6210\u529F\u914D\u9001\u60A8\u7684\u8BA2\u5355",
  "ja": "{{carrier.name}} \u306B\u3088\u308B\u3054\u6CE8\u6587\u306E\u914D\u9054\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F"
};
var redirectToPickupEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE N'A PAS PU \xCATRE LIVR\xC9E CHEZ VOUS.</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nous informe que votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n'a pas pu \xEAtre livr\xE9e chez vous.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vous serez inform\xE9(e) rapidement de sa mise \xE0 disposition dans un point de retrait \xE0 proximit\xE9 de votre domicile par <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER COULD NOT BE DELIVERED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> could not be delivered by </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> today. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Rest assured, instructions are on the way to help you arrange the redelivery of your package. </span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO NO PUDO SER ENTREGADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> no pudo ser entregado por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoy. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">No se preocupe, las instrucciones est\xE1n en camino para ayudarle a organizar la reentrega de su paquete. </span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE NON HA POTUTO ESSERE CONSEGNATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> non ha potuto essere consegnato da </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> oggi. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stai tranquillo, le istruzioni stanno arrivando per aiutarti a organizzare la riconsegna del tuo pacco. </span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG KONNTE NICHT GELIEFERT WERDEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> konnte nicht von </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> heute geliefert werden. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Seien Sie versichert, Anweisungen sind unterwegs, um Ihnen bei der Organisation der erneuten Lieferung Ihres Pakets zu helfen. </span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW PAKKET KON NIET WORDEN BEZORGD EN IS DOORGESTUURD NAAR EEN AFHAALPUNT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, uw bestelling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> kon niet worden bezorgd door </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Uw pakket is doorgestuurd naar een afhaalpunt. U wordt op de hoogte gesteld zodra het beschikbaar is voor afhaling. </span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA NIE MOG\u0141A ZOSTA\u0106 DOSTARCZONA I ZOSTA\u0141A PRZEKIEROWANA DO PUNKTU ODBIORU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Twoje zam\xF3wienie <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> nie mog\u0142o zosta\u0107 dostarczone przez </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Twoja paczka zosta\u0142a przekierowana do punktu odbioru. Powiadomimy Ci\u0119, gdy b\u0119dzie gotowa do odbioru. </span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE KUNNE IKKE LEVERES OG ER OMDIRIGERET TIL ET AFHENTNINGSSTED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din ordre <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> kunne ikke leveres af </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Din pakke er blevet omdirigeret til et afhentningssted. Du f\xE5r besked, s\xE5 snart den er klar til afhentning. </span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO N\xC3O P\xD4DE SER ENTREGUE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n\xE3o p\xF4de ser entregue por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoje. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Fique tranquilo, as instru\xE7\xF5es est\xE3o a caminho para ajud\xE1-lo a organizar a reentrega do seu pacote. </span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET KUNDE INTE LEVERERAS OCH HAR OMDIRIGERATS TILL ETT UTL\xC4MNINGSST\xC4LLE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din best\xE4llning <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> kunde inte levereras av </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Ditt paket har omdirigerats till ett utl\xE4mningsst\xE4lle. Du meddelas s\xE5 snart det \xE4r tillg\xE4ngligt f\xF6r avh\xE4mtning. </span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTIASI EI VOITU TOIMITTAA JA SE ON OHJATTU NOUTOPISTEESEEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, tilaustasi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ei voitu toimittaa kuljetusyhti\xF6n <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> toimesta. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pakettisi on ohjattu noutopisteeseen. Saat ilmoituksen, kun se on noudettavissa. </span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN KUNNE IKKE LEVERES OG ER OMDIRIGERT TIL ET HENTESTED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din bestilling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> kunne ikke leveres av </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pakken din er omdirigert til et hentested. Du vil bli varslet s\xE5 snart den er klar for henting. </span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u041D\u0415 \u041C\u041E\u0416\u0410 \u0414\u0410 \u0411\u042A\u0414\u0415 \u0414\u041E\u0421\u0422\u0410\u0412\u0415\u041D\u0410 \u0418 \u0415 \u041F\u0420\u0415\u041D\u0410\u0421\u041E\u0427\u0415\u041D\u0410 \u041A\u042A\u041C \u041F\u0423\u041D\u041A\u0422 \u0417\u0410 \u041F\u041E\u041B\u0423\u0427\u0410\u0412\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u043D\u0435 \u043C\u043E\u0436\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u043E\u0442 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 \u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0430 \u043A\u044A\u043C \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435. \u0429\u0435 \u0431\u044A\u0434\u0435\u0442\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u0435\u043D\u0438 \u0432\u0435\u0434\u043D\u0430\u0433\u0430 \u0449\u043E\u043C \u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435. </span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK NEMOHL B\xDDT DORU\u010CEN A BYL P\u0158ESM\u011AROV\xC1N NA V\xDDDEJN\xCD M\xCDSTO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161e objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> nemohla b\xFDt doru\u010Dena p\u0159epravcem </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">V\xE1\u0161 bal\xEDk byl p\u0159esm\u011Brov\xE1n na v\xFDdejn\xED m\xEDsto. Budete informov\xE1ni, jakmile bude p\u0159ipraven k vyzvednut\xED. </span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJ\xC1T NEM SIKER\xDCLT K\xC9ZBES\xCDTENI \xC9S EGY \xC1TV\xC9TELI PONTRA IR\xC1NY\xCDTOTTUK</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a(z) <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> rendel\xE9s\xE9t nem tudta k\xE9zbes\xEDteni a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Csomagj\xE1t egy \xE1tv\xE9teli pontra ir\xE1ny\xEDtottuk. \xC9rtes\xEDtj\xFCk, amint \xE1tvehet\u0151 lesz. </span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK NEMOHOL BY\u0164 DORU\u010CEN\xDD A BOL PRESMEROVAN\xDD NA V\xDDDAJN\xC9 MIESTO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161a objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> nemohla by\u0165 doru\u010Den\xE1 prepravcom </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">V\xE1\u0161 bal\xEDk bol presmerovan\xFD na v\xFDdajn\xE9 miesto. Budete informovan\xED, akon\xE1hle bude pripraven\xFD na vyzdvihnutie. </span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u672A\u80FD\u9001\u8FBE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u672A\u80FD\u9001\u8FBE\uFF0C\u627F\u8FD0\u5546\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u4ECA\u5929\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u8BF7\u653E\u5FC3\uFF0C\u5173\u4E8E\u91CD\u65B0\u914D\u9001\u7684\u8BF4\u660E\u5373\u5C06\u53D1\u9001\u7ED9\u60A8\uFF1A \u60A8\u7684\u5305\u88F9. </span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u3092\u304A\u5C4A\u3051\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306B\u3088\u308B\u914D\u9001\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u672C\u65E5\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u5B89\u5FC3\u304F\u3060\u3055\u3044\u3002\u518D\u914D\u9054\u306E\u624B\u914D\u65B9\u6CD5\u306B\u3064\u3044\u3066\u6848\u5185\u3092\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\uFF1A \u8377\u7269. </span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "a3aaaf52-59fe-4eb1-b29d-ae5e14e77755",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/available-for-pickup.ts
var availableForPickupEmailTemplateSubject = {
  "fr": "Votre colis {{shop.name}} est disponible au point de retrait et pr\xEAt \xE0 \xEAtre r\xE9cup\xE9r\xE9.",
  "en": "Your {{shop.name}} package is available at the pickup point and ready to be collected.",
  "es": "Su paquete {{shop.name}} est\xE1 disponible en el punto de recogida y listo para ser recogido.",
  "it": "Il tuo pacco {{shop.name}} \xE8 disponibile al punto di ritiro e pronto per essere ritirato.",
  "de": "Dein {{shop.name}} Paket ist am Abholpunkt verf\xFCgbar und bereit zur Abholung.",
  "nl": "Je {{shop.name}} pakket is beschikbaar bij het afhaalpunt en klaar om opgehaald te worden.",
  "pl": "Twoja paczka {{shop.name}} jest dost\u0119pna w punkcie odbioru i gotowa do odbioru.",
  "da": "Din {{shop.name}} pakke er tilg\xE6ngelig p\xE5 afhentningsstedet og klar til at blive afhentet.",
  "pt": "O seu pacote {{shop.name}} est\xE1 dispon\xEDvel no ponto de retirada e pronto para ser recolhido.",
  "sv": "Ditt {{shop.name}}-paket \xE4r tillg\xE4ngligt vid upph\xE4mtningsst\xE4llet och redo att h\xE4mtas.",
  "fi": "{{shop.name}}-pakettisi on noudettavissa noutopisteest\xE4 ja valmis noudettavaksi.",
  "no": "{{shop.name}}-pakken din er tilgjengelig p\xE5 hentepunktet og klar til \xE5 bli hentet.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0438 \u0433\u043E\u0442\u043E\u0432\u0430 \u0437\u0430 \u0432\u0437\u0435\u043C\u0430\u043D\u0435.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} je k dispozici na v\xFDdejn\xEDm m\xEDst\u011B a p\u0159ipraven k vyzvednut\xED.",
  "hu": "A {{shop.name}} csomagod el\xE9rhet\u0151 az \xE1tv\xE9teli ponton \xE9s k\xE9szen \xE1ll az \xE1tv\xE9telre.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je k dispoz\xEDcii na v\xFDdajnom mieste a pripraven\xFD na vyzdvihnutie.",
  "zh": "\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5DF2\u5230\u8FBE\u81EA\u63D0\u70B9\uFF0C\u53EF\u4EE5\u9886\u53D6\u3002",
  "ja": "{{shop.name}} \u306E\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u5C4A\u304D\u307E\u3057\u305F\u3002\u304A\u53D7\u3051\u53D6\u308A\u3044\u305F\u3060\u3051\u307E\u3059\u3002"
};
var availableEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST DISPONIBLE AU POINT DE RETRAIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est disponible au point de retrait.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE9sentez votre num\xE9ro de colis</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">et votre pi\xE8ce d\u2019identit\xE9 pour le r\xE9cup\xE9rer.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Retrouvez votre point de retrait via le bouton \xAB Suivre mon colis \xBB.&nbsp;</span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS AVAILABLE AT THE PICKUP POINT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your package <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is available at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Present your parcel number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to collect it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "Track my package" button.&nbsp;</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE EST\xC1 DISPONIBLE EN EL PUNTO DE RECOGIDA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 disponible en el punto de recogida.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Presente su n\xFAmero de paquete</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">y su identificaci\xF3n para recogerlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encuentre su punto de recogida a trav\xE9s del bot\xF3n "Seguir mi paquete".&nbsp;</span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 DISPONIBILE AL PUNTO DI RITIRO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE8 disponibile al punto di ritiro.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Presenta il tuo numero di pacco</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e il tuo documento d'identit\xE0 per ritirarlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Trova il tuo punto di ritiro tramite il pulsante "Traccia il mio pacco".&nbsp;</span></p>`
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DEIN PAKET IST AM ABHOLPUNKT VERF\xDCGBAR</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, dein Paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ist am Abholpunkt verf\xFCgbar.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE4sentiere deine Paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">und deinen Ausweis, um es abzuholen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finde deinen Abholpunkt \xFCber den Button "Mein Paket verfolgen".&nbsp;</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET IS BESCHIKBAAR BIJ HET AFHAALPUNT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, je pakket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is beschikbaar bij het afhaalpunt.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Toon je pakketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">en je ID om het op te halen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vind je afhaalpunt via de knop "Mijn pakket volgen".&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST DOST\u0118PNA W PUNKCIE ODBIORU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, twoja paczka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">jest dost\u0119pna w punkcie odbioru.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Przedstaw sw\xF3j numer paczki</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">i dow\xF3d to\u017Csamo\u015Bci, aby go odebra\u0107.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Znajd\u017A sw\xF3j punkt odbioru za pomoc\u0105 przycisku "\u015Aled\u017A moj\u0105 paczk\u0119".&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER TILG\xC6NGELIG P\xC5 AFHENTNINGSSTEDET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din pakke <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">er tilg\xE6ngelig p\xE5 afhentningsstedet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE6senter dit pakkenummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for at hente den.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find dit afhentningssted via knappen "Spor min pakke".&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 DISPON\xCDVEL NO PONTO DE RETIRADA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 dispon\xEDvel no ponto de retirada.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Apresente o seu n\xFAmero de pacote</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e o seu documento de identidade para o recolher.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encontre o seu ponto de retirada atrav\xE9s do bot\xE3o "Rastrear meu pacote".&nbsp;</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET \xC4R TILLG\xC4NGLIGT VID UPPH\xC4MTNINGSST\xC4LLET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, ditt paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE4r tillg\xE4ngligt vid upph\xE4mtningsst\xE4llet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Visa ditt paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">och din ID f\xF6r att h\xE4mta det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hitta ditt upph\xE4mtningsst\xE4lle via knappen "Sp\xE5ra mitt paket".&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON SAATAVILLA NOUTOPISTEESS\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakettisi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">on saatavilla noutopisteess\xE4.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Esit\xE4 pakettinumerosi</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ja henkil\xF6llisyystodistuksesi noutaaksesi sen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">L\xF6yd\xE4 noutopisteesi "Seuraa pakettiani"-painikkeen kautta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER TILGJENGELIG P\xC5 HENTEPUNKTET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakken din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">er tilgjengelig p\xE5 hentepunktet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vis pakkenummeret ditt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og ID-en din for \xE5 hente den.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finn hentepunktet ditt via knappen "Spor pakken min".&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u041D\u0410\u041B\u0418\u0427\u041D\u0410 \u0412 \u041F\u0423\u041D\u041A\u0422\u0410 \u0417\u0410 \u041F\u041E\u041B\u0423\u0427\u0410\u0412\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0430 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0438 \u0432\u0430\u0448\u0430\u0442\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430, \u0437\u0430 \u0434\u0430 \u0433\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041D\u0430\u043C\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0447\u0440\u0435\u0437 \u0431\u0443\u0442\u043E\u043D\u0430 "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430".&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE K DISPOZICI NA V\xDDDEJN\xCDM M\xCDST\u011A</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xEDk <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je k dispozici na v\xFDdejn\xEDm m\xEDst\u011B.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">P\u0159edlo\u017Ete \u010D\xEDslo bal\xEDku</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a sv\u016Fj pr\u016Fkaz toto\u017Enosti k vyzvednut\xED.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Najd\u011Bte sv\xE9 v\xFDdejn\xED m\xEDsto pomoc\xED tla\u010D\xEDtka "Sledovat m\u016Fj bal\xEDk".&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGJA EL\xC9RHET\u0150 AZ \xC1TV\xC9TELI PONTON</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a csomagja <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">el\xE9rhet\u0151 az \xE1tv\xE9teli ponton.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Mutassa be a csomagsz\xE1m\xE1t</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE9s azonos\xEDt\xF3j\xE1t az \xE1tv\xE9telhez.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Keresse meg az \xE1tv\xE9teli pontj\xE1t a "Csomagom k\xF6vet\xE9se" gomb seg\xEDts\xE9g\xE9vel.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE K DISPOZ\xCDCII NA V\xDDDAJNOM MIESTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xEDk <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je k dispoz\xEDcii na v\xFDdajnom mieste.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Predlo\u017Ete \u010D\xEDslo bal\xEDka</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a svoj preukaz toto\u017Enosti na vyzdvihnutie.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">N\xE1jdite svoje v\xFDdajn\xE9 miesto pomocou tla\u010Didla "Sledova\u0165 m\xF4j bal\xEDk".&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u5DF2\u53EF\u5728\u81EA\u63D0\u70B9\u53D6\u4EF6</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u5305\u88F9 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is available at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Present your parcel number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to collect it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9" button.&nbsp;</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u3067\u53D7\u53D6\u53EF\u80FD\u3067\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u8377\u7269 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is available at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Present your parcel number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to collect it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B" button.&nbsp;</span></p>'
        }
      }
    },
    {
      "id": "daeb1b52-974d-41ce-819e-866a2f764e0b",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "f857a79f-9d1f-41d5-93a7-195526133797",
      "type": "pickup-point",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "94d5477c-51df-4fd5-a232-c75c00887be3",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/waiting-at-pickup-point.ts
var waitingAtPickupEmailTemplateSubject = {
  "fr": "Rappel : votre colis {{shop.name}} est en point de retrait depuis plusieurs jours.",
  "en": "Reminder: your {{shop.name}} package has been at the pickup point for several days.",
  "es": "Recordatorio: su paquete {{shop.name}} ha estado en el punto de recogida durante varios d\xEDas.",
  "it": "Promemoria: il tuo pacco {{shop.name}} \xE8 al punto di ritiro da diversi giorni.",
  "de": "Erinnerung: Ihr {{shop.name}} Paket befindet sich seit mehreren Tagen am Abholpunkt.",
  "nl": "Herinnering: je {{shop.name}} pakket ligt al enkele dagen op het afhaalpunt.",
  "pl": "Przypomnienie: Twoja paczka {{shop.name}} jest w punkcie odbioru od kilku dni.",
  "da": "P\xE5mindelse: din {{shop.name}} pakke har v\xE6ret p\xE5 afhentningsstedet i flere dage.",
  "pt": "Lembrete: seu pacote {{shop.name}} est\xE1 no ponto de retirada h\xE1 v\xE1rios dias.",
  "sv": "P\xE5minnelse: ditt {{shop.name}} paket har varit vid upph\xE4mtningsplatsen i flera dagar.",
  "fi": "Muistutus: {{shop.name}}-pakettisi on ollut noutopisteess\xE4 useita p\xE4ivi\xE4.",
  "no": "P\xE5minnelse: din {{shop.name}}-pakke har v\xE6rt p\xE5 hentepunktet i flere dager.",
  "bg": "\u041D\u0430\u043F\u043E\u043C\u043D\u044F\u043D\u0435: \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0435 \u043D\u0430 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u043E\u0442 \u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0434\u043D\u0438.",
  "cs": "P\u0159ipom\xEDnka: v\xE1\u0161 bal\xED\u010Dek {{shop.name}} je ji\u017E n\u011Bkolik dn\xED na v\xFDdejn\xEDm m\xEDst\u011B.",
  "hu": "Eml\xE9keztet\u0151: a(z) {{shop.name}} csomagod m\xE1r t\xF6bb napja az \xE1tv\xE9teli ponton van.",
  "sk": "Pripomienka: v\xE1\u0161 bal\xEDk {{shop.name}} je u\u017E nieko\u013Eko dn\xED na odbernom mieste.",
  "zh": "\u63D0\u9192\uFF1A\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5DF2\u5728\u81EA\u63D0\u70B9\u5B58\u653E\u591A\u65E5\u3002",
  "ja": "\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\uFF1A{{shop.name}} \u306E\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u5C4A\u3044\u3066\u304B\u3089\u6570\u65E5\u304C\u7D4C\u904E\u3057\u3066\u3044\u307E\u3059\u3002"
};
var waitingAtPickupEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS VOUS ATTEND AU POINT DE RETRAIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est encore disponible quelques jours au point de retrait.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE9sentez-vous <u>rapidement</u> avec votre num\xE9ro de colis</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">et votre pi\xE8ce d\u2019identit\xE9 pour le r\xE9cup\xE9rer.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Retrouvez votre point de retrait via le bouton \xAB Suivre mon colis \xBB.&nbsp;</span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS WAITING FOR YOU AT THE PICKUP POINT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your package <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is still available for a few days at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>quickly</u> with your package number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "Track my package" button.&nbsp;</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE LE ESPERA EN EL PUNTO DE RECOGIDA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 disponible por unos d\xEDas m\xE1s en el punto de recogida.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pres\xE9ntese <u>r\xE1pidamente</u> con su n\xFAmero de paquete</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">y su identificaci\xF3n para recogerlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encuentre su punto de recogida a trav\xE9s del bot\xF3n "Seguir mi paquete".&nbsp;</span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO TI ASPETTA AL PUNTO DI RITIRO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE8 ancora disponibile per alcuni giorni al punto di ritiro.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Presentati <u>rapidamente</u> con il tuo numero di pacco</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e il tuo documento d'identit\xE0 per ritirarlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Trova il tuo punto di ritiro tramite il pulsante "Traccia il mio pacco".&nbsp;</span></p>`
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DEIN PAKET WARTET AM ABHOLPUNKT AUF DICH</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, dein Paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ist noch einige Tage am Abholpunkt verf\xFCgbar.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Bitte erscheine <u>schnell</u> mit deiner Paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">und deinem Ausweis, um es abzuholen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finde deinen Abholpunkt \xFCber den Button "Mein Paket verfolgen".&nbsp;</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WACHT OP JE BIJ HET AFHAALPUNT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, je pakket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is nog enkele dagen beschikbaar bij het afhaalpunt.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Meld je <u>snel</u> met je pakketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">en je ID om het op te halen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vind je afhaalpunt via de knop "Mijn pakket volgen".&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA CZEKA NA CIEBIE W PUNKCIE ODBIORU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, twoja paczka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">jest nadal dost\u0119pna przez kilka dni w punkcie odbioru.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Prosz\u0119 zg\u0142o\u015B si\u0119 <u>szybko</u> z numerem paczki</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">i dowodem to\u017Csamo\u015Bci, aby j\u0105 odebra\u0107.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Znajd\u017A sw\xF3j punkt odbioru za pomoc\u0105 przycisku "\u015Aled\u017A moj\u0105 paczk\u0119".&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE VENTER P\xC5 DIG VED AFHENTNINGSPUNKTET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din pakke <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">er stadig tilg\xE6ngelig i et par dage ved afhentningspunktet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE6senter dig <u>hurtigt</u> med dit pakkenummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for at hente det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find dit afhentningspunkt via knappen "Spor min pakke".&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 \xC0 SUA ESPERA NO PONTO DE RETIRADA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ainda est\xE1 dispon\xEDvel por alguns dias no ponto de retirada.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Apresente-se <u>rapidamente</u> com o seu n\xFAmero de pacote</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e a sua identifica\xE7\xE3o para o recolher.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encontre o seu ponto de retirada atrav\xE9s do bot\xE3o "Rastrear meu pacote".&nbsp;</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET V\xC4NTAR P\xC5 DIG VID UPPH\xC4MTNINGSPUNKTEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, ditt paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE4r fortfarande tillg\xE4ngligt i n\xE5gra dagar vid upph\xE4mtningspunkten.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE4nligen presentera dig <u>snabbt</u> med ditt paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">och din ID f\xF6r att h\xE4mta det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hitta din upph\xE4mtningspunkt via knappen "Sp\xE5ra mitt paket".&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ODOTTAA SINUA NOUTOPISTEESS\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakettisi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">on edelleen saatavilla muutaman p\xE4iv\xE4n ajan noutopisteess\xE4.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Esit\xE4 itsesi <u>nopeasti</u> pakettinumerosi kanssa</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ja henkil\xF6todistuksesi saadaksesi sen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">L\xF6yd\xE4 noutopisteesi "Seuraa pakettiani"-painikkeen kautta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN VENTER P\xC5 DEG VED HENTEPUNKTET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakken din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">er fortsatt tilgjengelig i noen dager ved hentepunktet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vennligst presenter deg <u>raskt</u> med pakkenummeret ditt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for \xE5 hente den.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finn hentepunktet ditt via knappen "Spor pakken min".&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0418 \u041E\u0427\u0410\u041A\u0412\u0410 \u041D\u0410 \u041C\u042F\u0421\u0422\u041E\u0422\u041E \u0417\u0410 \u041F\u041E\u041B\u0423\u0427\u0410\u0412\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0435 \u0432\u0441\u0435 \u043E\u0449\u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0437\u0430 \u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0434\u043D\u0438 \u043D\u0430 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041C\u043E\u043B\u044F, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u0441\u0435 <u>\u0431\u044A\u0440\u0437\u043E</u> \u0441 \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0430 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0438 \u0432\u0430\u0448\u0430\u0442\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430, \u0437\u0430 \u0434\u0430 \u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041D\u0430\u043C\u0435\u0440\u0435\u0442\u0435 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0441\u0438 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0447\u0440\u0435\u0437 \u0431\u0443\u0442\u043E\u043D\u0430 "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430".&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK NA V\xC1S \u010CEK\xC1 NA V\xDDDEJN\xCDM M\xCDST\u011A</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xED\u010Dek <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je st\xE1le k dispozici n\u011Bkolik dn\xED na v\xFDdejn\xEDm m\xEDst\u011B.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pros\xEDm, dostavte se <u>rychle</u> s \u010D\xEDslem bal\xEDku</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a va\u0161\xEDm dokladem toto\u017Enosti, abyste jej vyzvedli.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Najd\u011Bte sv\xE9 v\xFDdejn\xED m\xEDsto pomoc\xED tla\u010D\xEDtka "Sledovat m\u016Fj bal\xEDk".&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGJA V\xC1RJA \xD6NT AZ \xC1TV\xC9TELI PONTON</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a csomagja <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">m\xE9g n\xE9h\xE1ny napig el\xE9rhet\u0151 az \xE1tv\xE9teli ponton.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE9rj\xFCk, jelentkezzen <u>gyorsan</u> a csomagsz\xE1m\xE1val</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE9s azonos\xEDt\xF3j\xE1val, hogy \xE1tvegye.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Keresse meg az \xE1tv\xE9teli pontj\xE1t a "Csomagom k\xF6vet\xE9se" gomb seg\xEDts\xE9g\xE9vel.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK V\xC1S \u010CAK\xC1 NA ODBERNOM MIESTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xEDk <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je e\u0161te nieko\u013Eko dn\xED dostupn\xFD na odbernom mieste.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pros\xEDm, dostavte sa <u>r\xFDchlo</u> s \u010D\xEDslom bal\xEDka</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a va\u0161\xEDm dokladom toto\u017Enosti, aby ste ho vyzdvihli.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">N\xE1jdite svoje odbern\xE9 miesto pomocou tla\u010Didla "Sledova\u0165 m\xF4j bal\xEDk".&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u6B63\u5728\u81EA\u63D0\u70B9\u7B49\u60A8</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u5305\u88F9 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is still available for a few days at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>quickly</u> with \u60A8\u7684\u5305\u88F9 number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9" button.&nbsp;</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u3067\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u8377\u7269 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is still available for a few days at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>quickly</u> with \u8377\u7269 number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B" button.&nbsp;</span></p>'
        }
      }
    },
    {
      "id": "daeb1b52-974d-41ce-819e-866a2f764e0b",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "f857a79f-9d1f-41d5-93a7-195526133797",
      "type": "pickup-point",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "94d5477c-51df-4fd5-a232-c75c00887be3",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido de su pedido</u></strong></span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto del tuo ordine</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhalt Ihrer Bestellung</u></strong></span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do seu pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van uw bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inneh\xE5ll i din best\xE4llning</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaustesi sis\xE4lt\xF6</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Indhold af din ordre</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Innhold i bestillingen din</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161ej objedn\xE1vky</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161\xED objedn\xE1vky</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/waiting-at-pickup-point-severe.ts
var waitingAtPickupSevereEmailTemplateSubject = {
  "fr": "Dernier rappel : la p\xE9riode de disponibilit\xE9 en point de retrait indiqu\xE9e par {{carrier.name}} touche bient\xF4t \xE0 sa fin.",
  "en": "Last reminder: the availability period at the pickup point indicated by {{carrier.name}} is coming to an end soon.",
  "es": "\xDAltimo recordatorio: el per\xEDodo de disponibilidad en el punto de recogida indicado por {{carrier.name}} est\xE1 llegando a su fin.",
  "it": "Ultimo promemoria: il periodo di disponibilit\xE0 presso il punto di ritiro indicato da {{carrier.name}} sta per terminare.",
  "de": "Letzte Erinnerung: Die Verf\xFCgbarkeitsdauer am Abholpunkt, angegeben von {{carrier.name}}, endet bald.",
  "nl": "Laatste herinnering: de beschikbaarheidsperiode bij het afhaalpunt aangegeven door {{carrier.name}} loopt binnenkort af.",
  "pl": "Ostatnie przypomnienie: okres dost\u0119pno\u015Bci w punkcie odbioru wskazanym przez {{carrier.name}} dobiega ko\u0144ca.",
  "da": "Sidste p\xE5mindelse: tilg\xE6ngelighedsperioden ved afhentningsstedet angivet af {{carrier.name}} n\xE6rmer sig sin afslutning.",
  "pt": "\xDAltimo lembrete: o per\xEDodo de disponibilidade no ponto de recolha indicado por {{carrier.name}} est\xE1 a chegar ao fim.",
  "sv": "Sista p\xE5minnelsen: tillg\xE4nglighetsperioden vid upph\xE4mtningsplatsen angiven av {{carrier.name}} n\xE4rmar sig sitt slut.",
  "fi": "Viimeinen muistutus: {{carrier.name}}-ilmoittama noutopisteen saatavuusaika on p\xE4\xE4ttym\xE4ss\xE4.",
  "no": "Siste p\xE5minnelse: tilgjengelighetsperioden ved hentepunktet angitt av {{carrier.name}} n\xE6rmer seg slutten.",
  "bg": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u043D\u0430\u043F\u043E\u043C\u043D\u044F\u043D\u0435: \u043F\u0435\u0440\u0438\u043E\u0434\u044A\u0442 \u043D\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0441\u0442 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435, \u043F\u043E\u0441\u043E\u0447\u0435\u043D \u043E\u0442 {{carrier.name}}, \u0441\u043A\u043E\u0440\u043E \u0449\u0435 \u043F\u0440\u0438\u043A\u043B\u044E\u0447\u0438.",
  "cs": "Posledn\xED p\u0159ipom\xEDnka: obdob\xED dostupnosti na v\xFDdejn\xEDm m\xEDst\u011B uveden\xE9m {{carrier.name}} se bl\xED\u017E\xED ke konci.",
  "hu": "Utols\xF3 eml\xE9keztet\u0151: a {{carrier.name}} \xE1ltal megadott \xE1tv\xE9teli pont el\xE9rhet\u0151s\xE9gi id\u0151szaka hamarosan v\xE9get \xE9r.",
  "sk": "Posledn\xE1 pripomienka: obdobie dostupnosti na odbernom mieste uvedenom {{carrier.name}} sa bl\xED\u017Ei ku koncu.",
  "zh": "\u6700\u540E\u63D0\u9192\uFF1A{{carrier.name}} \u6307\u5B9A\u7684\u81EA\u63D0\u70B9\u4FDD\u7BA1\u671F\u9650\u5373\u5C06\u5C4A\u6EE1\u3002",
  "ja": "\u6700\u7D42\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\uFF1A{{carrier.name}} \u306E\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u3067\u306E\u4FDD\u7BA1\u671F\u9650\u304C\u9593\u3082\u306A\u304F\u7D42\u4E86\u3057\u307E\u3059\u3002"
};
var waitingAtPickupSevereEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATTENTION, VOTRE COLIS DOIT \xCATRE R\xC9CUP\xC9R\xC9 D\xC8S QUE POSSIBLE AU POINT DE RETRAIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est toujours au point de retrait et ne sera bient\xF4t plus disponible.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE9sentez-vous <u>d\xE8s que possible</u> avec votre num\xE9ro de colis</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">et votre pi\xE8ce d\u2019identit\xE9 pour le r\xE9cup\xE9rer.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Retrouvez votre point de retrait via le bouton \xAB Suivre mon colis \xBB.&nbsp;</span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATTENTION, YOUR PACKAGE MUST BE PICKED UP AS SOON AS POSSIBLE AT THE PICKUP POINT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your package <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is still at the pickup point and will soon no longer be available.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>as soon as possible</u> with your package number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Tracking number" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Tracking number</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "Track my package" button.&nbsp;</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATENCI\xD3N, SU PAQUETE DEBE SER RECOGIDO LO ANTES POSIBLE EN EL PUNTO DE RECOGIDA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> todav\xEDa est\xE1 en el punto de recogida y pronto ya no estar\xE1 disponible.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pres\xE9ntese <u>lo antes posible</u> con su n\xFAmero de paquete</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="N\xFAmero de seguimiento" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@N\xFAmero de seguimiento</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">y su identificaci\xF3n para recuperarlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encuentre su punto de recogida a trav\xE9s del bot\xF3n "Seguir mi paquete".&nbsp;</span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATTENZIONE, IL TUO PACCO DEVE ESSERE RITIRATO IL PRIMA POSSIBILE AL PUNTO DI RITIRO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 ancora al punto di ritiro e presto non sar\xE0 pi\xF9 disponibile.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Presentati <u>il prima possibile</u> con il tuo numero di pacco</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Numero di tracciamento" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Numero di tracciamento</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e il tuo documento d'identit\xE0 per ritirarlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Trova il tuo punto di ritiro tramite il pulsante "Traccia il mio pacco".&nbsp;</span></p>`
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ACHTUNG, IHR PAKET MUSS SO SCHNELL WIE M\xD6GLICH AM ABHOLPUNKT ABGEHOLT WERDEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihr Paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> befindet sich noch am Abholpunkt und wird bald nicht mehr verf\xFCgbar sein.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Bitte erscheinen Sie <u>so schnell wie m\xF6glich</u> mit Ihrer Paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sendungsnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sendungsnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">und Ihrem Ausweis, um es abzuholen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finden Sie Ihren Abholpunkt \xFCber den Button "Mein Paket verfolgen".&nbsp;</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>LET OP, JE PAKKET MOET ZO SNEL MOGELIJK BIJ HET AFHAALPUNT WORDEN OPGEHAALD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, je pakket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is nog steeds bij het afhaalpunt en zal binnenkort niet meer beschikbaar zijn.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Meld je <u>zo snel mogelijk</u> met je pakketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Volgnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Volgnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">en je ID om het op te halen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vind je afhaalpunt via de knop "Mijn pakket volgen".&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UWAGA, TWOJA PACZKA MUSI ZOSTA\u0106 ODEBRANA JAK NAJSZYBCIEJ W PUNKCIE ODBIORU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, twoja paczka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> nadal znajduje si\u0119 w punkcie odbioru i wkr\xF3tce nie b\u0119dzie ju\u017C dost\u0119pna.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Prosz\u0119 zg\u0142osi\u0107 si\u0119 <u>jak najszybciej</u> z numerem paczki</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Numer \u015Bledzenia" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Numer \u015Bledzenia</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">i dowodem to\u017Csamo\u015Bci, aby j\u0105 odebra\u0107.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Znajd\u017A sw\xF3j punkt odbioru za pomoc\u0105 przycisku "\u015Aled\u017A moj\u0105 paczk\u0119".&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>OPM\xC6RKSOMHED, DIN PAKKE SKAL HENTES S\xC5 SNART SOM MULIGT VED AFHENTNINGSSTEDET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din pakke <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er stadig ved afhentningsstedet og vil snart ikke l\xE6ngere v\xE6re tilg\xE6ngelig.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Venligst pr\xE6senter dig <u>s\xE5 snart som muligt</u> med dit pakkenummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sporingsnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sporingsnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for at hente det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find dit afhentningssted via knappen "Spor min pakke".&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATEN\xC7\xC3O, O SEU PACOTE DEVE SER RECOLHIDO O MAIS R\xC1PIDO POSS\xCDVEL NO PONTO DE RECOLHA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ainda est\xE1 no ponto de recolha e em breve n\xE3o estar\xE1 mais dispon\xEDvel.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Apresente-se <u>o mais r\xE1pido poss\xEDvel</u> com o seu n\xFAmero de pacote</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="N\xFAmero de rastreamento" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@N\xFAmero de rastreamento</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e o seu documento de identidade para o recolher.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encontre o seu ponto de recolha atrav\xE9s do bot\xE3o "Rastrear o meu pacote".&nbsp;</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VARNING, DITT PAKET M\xC5STE H\xC4MTAS S\xC5 SNART SOM M\xD6JLIGT VID UPPH\xC4MTNINGSPLATSEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, ditt paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE4r fortfarande vid upph\xE4mtningsplatsen och kommer snart inte l\xE4ngre vara tillg\xE4ngligt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE4nligen presentera dig <u>s\xE5 snart som m\xF6jligt</u> med ditt paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sp\xE5rningsnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sp\xE5rningsnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">och din ID f\xF6r att h\xE4mta det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hitta din upph\xE4mtningsplats via knappen "Sp\xE5ra mitt paket".&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>HUOMIO, PAKETTISI ON NOUDETTAVA MAHDOLLISIMMAN PIAN NOUTOPISTEEST\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakettisi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> on edelleen noutopisteess\xE4 ja pian se ei en\xE4\xE4 ole saatavilla.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Esit\xE4 itsesi <u>mahdollisimman pian</u> pakettinumerosi kanssa</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Seurantanumero" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Seurantanumero</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ja henkil\xF6todistuksesi saadaksesi sen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">L\xF6yd\xE4 noutopisteesi "Seuraa pakettiani" -painikkeen kautta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>OBS, PAKKEN DIN M\xC5 HENTES S\xC5 SNART SOM MULIG P\xC5 HENTEPUNKTET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakken din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er fortsatt p\xE5 hentepunktet og vil snart ikke lenger v\xE6re tilgjengelig.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vennligst presenter deg <u>s\xE5 snart som mulig</u> med pakkenummeret ditt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sporingsnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sporingsnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for \xE5 hente den.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finn hentepunktet ditt via knappen "Spor pakken min".&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u041D\u0418\u041C\u0410\u041D\u0418\u0415, \u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0422\u0420\u042F\u0411\u0412\u0410 \u0414\u0410 \u0411\u042A\u0414\u0415 \u0412\u0417\u0415\u0422\u0410 \u0412\u042A\u0417\u041C\u041E\u0416\u041D\u041E \u041D\u0410\u0419-\u0421\u041A\u041E\u0420\u041E \u041E\u0422 \u041F\u0423\u041D\u041A\u0422\u0410 \u0417\u0410 \u041F\u041E\u041B\u0423\u0427\u0410\u0412\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0435 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0438 \u0441\u043A\u043E\u0440\u043E \u043D\u044F\u043C\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041C\u043E\u043B\u044F, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u0441\u0435 <u>\u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0441\u043A\u043E\u0440\u043E</u> \u0441 \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="\u041D\u043E\u043C\u0435\u0440 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@\u041D\u043E\u043C\u0435\u0440 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0438 \u0432\u0430\u0448\u0430\u0442\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430, \u0437\u0430 \u0434\u0430 \u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041D\u0430\u043C\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0447\u0440\u0435\u0437 \u0431\u0443\u0442\u043E\u043D\u0430 "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430".&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>POZOR, V\xC1\u0160 BAL\xCDK MUS\xCD B\xDDT CO NEJD\u0158\xCDVE VYZVEDNUT NA V\xDDDEJN\xCDM M\xCDST\u011A</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xED\u010Dek <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je st\xE1le na v\xFDdejn\xEDm m\xEDst\u011B a brzy ji\u017E nebude k dispozici.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pros\xEDm, dostavte se <u>co nejd\u0159\xEDve</u> s \u010D\xEDslem va\u0161eho bal\xED\u010Dku</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sledovac\xED \u010D\xEDslo" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sledovac\xED \u010D\xEDslo</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a va\u0161\xEDm pr\u016Fkazem toto\u017Enosti, abyste jej vyzvedli.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Najd\u011Bte sv\xE9 v\xFDdejn\xED m\xEDsto pomoc\xED tla\u010D\xEDtka "Sledovat m\u016Fj bal\xED\u010Dek".&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>FIGYELEM, A CSOMAGOT A LEHET\u0150 LEGHAMARABB FEL KELL VENNI AZ \xC1TV\xC9TELI PONTON</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a(z) <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> csomagja m\xE9g mindig az \xE1tv\xE9teli ponton van, \xE9s hamarosan m\xE1r nem lesz el\xE9rhet\u0151.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE9rj\xFCk, jelenjen meg <u>a lehet\u0151 leghamarabb</u> a csomagsz\xE1m\xE1val</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Nyomk\xF6vet\xE9si sz\xE1m" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nyomk\xF6vet\xE9si sz\xE1m</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE9s azonos\xEDt\xF3j\xE1val, hogy \xE1tvegye.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Keresse meg az \xE1tv\xE9teli pontj\xE1t a "Csomagom nyomon k\xF6vet\xE9se" gomb seg\xEDts\xE9g\xE9vel.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>POZOR, V\xC1\u0160 BAL\xCDK MUS\xCD BY\u0164 \u010CO NAJSK\xD4R VYZDVIHNUT\xDD NA ODBERNOM MIESTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xEDk <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je st\xE1le na odbernom mieste a \u010Doskoro u\u017E nebude k dispoz\xEDcii.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pros\xEDm, dostavte sa <u>\u010Do najsk\xF4r</u> s \u010D\xEDslom v\xE1\u0161ho bal\xEDka</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sledovacie \u010D\xEDslo" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sledovacie \u010D\xEDslo</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a va\u0161\xEDm preukazom toto\u017Enosti, aby ste ho vyzdvihli.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">N\xE1jdite svoje odbern\xE9 miesto pomocou tla\u010Didla "Sledova\u0165 m\xF4j bal\xEDk".&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u6CE8\u610F\uFF0C\u60A8\u7684\u5305\u88F9\u5FC5\u987B\u5C3D\u5FEB\u5728\u81EA\u63D0\u70B9\u9886\u53D6</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u5305\u88F9 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is still at the pickup point and will soon no longer be available.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>as soon as possible</u> with \u60A8\u7684\u5305\u88F9 number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Tracking number" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Tracking number</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9" button.&nbsp;</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u610F\uFF1A\u8377\u7269\u306F\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u3067\u53D7\u3051\u53D6\u3063\u3066\u304F\u3060\u3055\u3044</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u8377\u7269 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is still at the pickup point and will soon no longer be available.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>as soon as possible</u> with \u8377\u7269 number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Tracking number" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Tracking number</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B" button.&nbsp;</span></p>'
        }
      }
    },
    {
      "id": "daeb1b52-974d-41ce-819e-866a2f764e0b",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "f857a79f-9d1f-41d5-93a7-195526133797",
      "type": "pickup-point",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "94d5477c-51df-4fd5-a232-c75c00887be3",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contents of your order</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido de su pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhalt Ihrer Bestellung</u></strong></span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto del tuo ordine</u></strong></span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do seu pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van uw bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inneh\xE5ll i din best\xE4llning</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161\xED objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161ej objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9sed tartalma</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 twojego zam\xF3wienia</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Indhold af din ordre</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Innholdet i bestillingen din</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilauksesi sis\xE4lt\xF6</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u60A8\u7684\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/delivered.ts
var deliveredEmailTemplateSubject = {
  "fr": "Livraison r\xE9ussie : votre commande {{shop.name}} vous a \xE9t\xE9 livr\xE9e.",
  "en": "Your {{shop.name}} order has been delivered.",
  "es": "Su pedido {{shop.name}} ha sido entregado.",
  "it": "Il tuo ordine {{shop.name}} \xE8 stato consegnato.",
  "de": "Ihre {{shop.name}} Bestellung wurde geliefert.",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "O seu pedido {{shop.name}} foi entregue.",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u5DF2\u9001\u8FBE\u3002",
  "ja": "{{shop.name}} \u306E\u3054\u6CE8\u6587\u304C\u914D\u9054\u3055\u308C\u307E\u3057\u305F\u3002"
};
var deliveredEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE A ETE LIVR\xC9E !</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> a \xE9t\xE9 livr\xE9e avec succ\xE8s. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous esp\xE9rons qu'elle r\xE9pond \xE0 vos attentes et sommes \xE0 votre disposition le cas \xE9ch\xE9ant. </span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER HAS BEEN DELIVERED!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been successfully delivered. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We hope it meets your expectations and are at your disposal if needed. </span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\xA1SU PEDIDO HA SIDO ENTREGADO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ha sido entregado con \xE9xito. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que cumpla con sus expectativas y estamos a su disposici\xF3n si es necesario. </span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE \xC8 STATO CONSEGNATO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 stato consegnato con successo. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Speriamo che soddisfi le tue aspettative e siamo a tua disposizione se necessario. </span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG WURDE GELIEFERT!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> wurde erfolgreich geliefert. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir hoffen, dass es Ihren Erwartungen entspricht und stehen Ihnen bei Bedarf zur Verf\xFCgung. </span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO FOI ENTREGUE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> foi entregue com sucesso. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que atenda \xE0s suas expectativas e estamos \xE0 sua disposi\xE7\xE3o, se necess\xE1rio. </span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u9001\u8FBE\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been successfully delivered. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u5E0C\u671B\u7B26\u5408\u60A8\u7684\u671F\u671B\uFF0C\u5982\u6709\u9700\u8981\uFF0C\u6211\u4EEC\u968F\u65F6\u4E3A\u60A8\u670D\u52A1\u3002 </span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u304C\u914D\u9054\u3055\u308C\u307E\u3057\u305F\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been successfully delivered. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u671F\u5F85\u306B\u6CBF\u3048\u308C\u3070\u5E78\u3044\u3067\u3059\u3002\u5FC5\u8981\u3067\u3042\u308C\u3070\u3044\u3064\u3067\u3082\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002 </span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "a9a6e8d3-0b7b-4c7b-9f3c-5f8e1c9e7abd",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "c5a0e2f1-7b3d-4e8a-9c6f-2d1b8e3a5c7f",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\xC9valuez votre livraison</p>' },
        "en": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Rate your delivery</p>' },
        "es": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Califica tu entrega</p>' },
        "de": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Bewerten Sie Ihre Lieferung</p>' },
        "it": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Valuta la consegna</p>' },
        "pt": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Avalie sua entrega</p>' },
        "nl": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Beoordeel je bezorging</p>' },
        "sv": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Betygs\xE4tt din leverans</p>' },
        "fi": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Arvioi toimituksesi</p>' },
        "no": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Vurder leveringen din</p>' },
        "da": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Bed\xF8m din levering</p>' },
        "pl": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Oce\u0144 swoj\u0105 dostaw\u0119</p>' },
        "cs": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Ohodno\u0165te sv\xE9 doru\u010Den\xED</p>' },
        "sk": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Ohodno\u0165te svoje doru\u010Denie</p>' },
        "hu": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\xC9rt\xE9kelje a k\xE9zbes\xEDt\xE9st</p>' },
        "bg": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u041E\u0446\u0435\u043D\u0435\u0442\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430</p>' },
        "zh": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u8BC4\u4EF7\u60A8\u7684\u914D\u9001</p>' },
        "ja": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u914D\u9001\u3092\u8A55\u4FA1\u3059\u308B</p>' }
      }
    },
    {
      "id": "16d2dad6-5f60-4c22-b59a-0c3b0f5e1a4c",
      "type": "rate-order",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/dispatched-to-other-pickup-point.ts
var dispatchedToOtherPickupPointEmailTemplateSubject = {
  "fr": "Votre colis {{shop.name}} a \xE9t\xE9 redirig\xE9 vers un autre point de retrait par {{carrier.name}}.",
  "en": "Your {{shop.name}} package will be delivered to a different pickup point.",
  "es": "Su paquete {{shop.name}} ser\xE1 entregado en un punto de recogida diferente.",
  "it": "Il tuo pacco {{shop.name}} sar\xE0 consegnato a un punto di ritiro diverso.",
  "de": "Ihr {{shop.name}} Paket wird an einen anderen Abholpunkt geliefert.",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "O seu pacote {{shop.name}} ser\xE1 entregue em um ponto de retirada diferente.",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5C06\u88AB\u6D3E\u9001\u81F3\u53E6\u4E00\u4E2A\u81EA\u63D0\u70B9\u3002",
  "ja": "{{shop.name}} \u306E\u8377\u7269\u306F\u5225\u306E\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u5C4A\u3051\u3089\u308C\u307E\u3059\u3002"
};
var dispatchedToOtherPickupPointEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST ACHEMIN\xC9 VERS UN AUTRE POINT DE RETRAIT QUE CELUI S\xC9LECTIONN\xC9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a \xE9t\xE9 achemin\xE9 vers un autre point de retrait que celui initialement s\xE9lectionn\xE9.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Les informations \xE0 jour vous seront communiqu\xE9es tr\xE8s prochainement.</span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS BEING SENT TO A DIFFERENT PICKUP POINT THAN SELECTED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your package <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">has been sent to a different pickup point than initially selected.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Updated information will be communicated to you shortly.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE SE EST\xC1 ENVIANDO A UN PUNTO DE RECOGIDA DIFERENTE AL SELECCIONADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ha sido enviado a un punto de recogida diferente al seleccionado inicialmente.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">La informaci\xF3n actualizada se le comunicar\xE1 en breve.</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 STATO INVIATO A UN PUNTO DI RITIRO DIVERSO DA QUELLO SELEZIONATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE8 stato inviato a un punto di ritiro diverso da quello selezionato inizialmente.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Le informazioni aggiornate ti saranno comunicate a breve.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHR PAKET WIRD AN EINEN ANDEREN ABHOLPUNKT GESENDET ALS AUSGEW\xC4HLT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihr Paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">wurde an einen anderen Abholpunkt gesendet als urspr\xFCnglich ausgew\xE4hlt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Aktualisierte Informationen werden Ihnen in K\xFCrze mitgeteilt.</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 A SER ENVIADO PARA UM PONTO DE RETIRADA DIFERENTE DO SELECIONADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">foi enviado para um ponto de retirada diferente do inicialmente selecionado.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">As informa\xE7\xF5es atualizadas ser\xE3o comunicadas em breve.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u5DF2\u88AB\u53D1\u9001\u81F3\u4E0E\u6240\u9009\u4E0D\u540C\u7684\u81EA\u63D0\u70B9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u5305\u88F9 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">has been sent to a different pickup point than initially selected.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Updated information will be communicated to you shortly.</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306F\u9078\u629E\u3055\u308C\u305F\u5834\u6240\u3068\u306F\u7570\u306A\u308B\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u9001\u3089\u308C\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u8377\u7269 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">has been sent to a different pickup point than initially selected.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Updated information will be communicated to you shortly.</span></p>'
        }
      }
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/collected-at-pickup.ts
var collectedAtPickupEmailTemplateSubject = {
  "fr": "Confirmation de retrait : votre colis {{shop.name}} a bien \xE9t\xE9 r\xE9cup\xE9r\xE9.",
  "en": "You have picked up your {{shop.name}} package",
  "es": "Ha recogido su paquete {{shop.name}}",
  "it": "Hai ritirato il tuo pacco {{shop.name}}",
  "de": "Sie haben Ihr {{shop.name}} Paket abgeholt",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "Voc\xEA retirou seu pacote {{shop.name}}",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "\u60A8\u5DF2\u9886\u53D6 {{shop.name}} \u5305\u88F9",
  "ja": "{{shop.name}} \u306E\u8377\u7269\u3092\u304A\u53D7\u3051\u53D6\u308A\u3044\u305F\u3060\u304D\u307E\u3057\u305F"
};
var collectedAtPickupEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOUS AVEZ VOTRE COMMANDE !</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, vous avez retir\xE9 votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous esp\xE9rons qu'elle r\xE9pond \xE0 vos attentes et sommes \xE0 votre disposition le cas \xE9ch\xE9ant.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOU HAVE YOUR ORDER!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you have picked up your <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> package.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We hope it meets your expectations and are at your disposal if needed.</span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\xA1TIENE SU PEDIDO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, ha recogido su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que cumpla con sus expectativas y estamos a su disposici\xF3n si es necesario.</span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>HAI IL TUO ORDINE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, hai ritirato il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Speriamo che soddisfi le tue aspettative e siamo a tua disposizione se necessario.</span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SIE HABEN IHRE BESTELLUNG!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Sie haben Ihr <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> Paket abgeholt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir hoffen, dass es Ihren Erwartungen entspricht und stehen Ihnen bei Bedarf zur Verf\xFCgung.</span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOC\xCA TEM SEU PEDIDO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, voc\xEA retirou seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que atenda \xE0s suas expectativas e estamos \xE0 sua disposi\xE7\xE3o, se necess\xE1rio.</span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u5DF2\u6536\u5230\u8BA2\u5355\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you have picked up your <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> package.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u5E0C\u671B\u7B26\u5408\u60A8\u7684\u671F\u671B\uFF0C\u5982\u6709\u9700\u8981\uFF0C\u6211\u4EEC\u968F\u65F6\u4E3A\u60A8\u670D\u52A1\u3002</span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u3092\u304A\u53D7\u3051\u53D6\u308A\u3044\u305F\u3060\u304D\u307E\u3057\u305F\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you have picked up your <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> package.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u671F\u5F85\u306B\u6CBF\u3048\u308C\u3070\u5E78\u3044\u3067\u3059\u3002\u5FC5\u8981\u3067\u3042\u308C\u3070\u3044\u3064\u3067\u3082\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002</span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "b8f1d6e2-3a5c-4e1b-9d4c-0e7a2f8e9cd4",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "d9e3b1a6-8c4f-4d2e-a5b7-1f6c3a9e0d5b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\xC9valuez votre livraison</p>' },
        "en": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Rate your delivery</p>' },
        "es": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Califica tu entrega</p>' },
        "de": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Bewerten Sie Ihre Lieferung</p>' },
        "it": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Valuta la consegna</p>' },
        "pt": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Avalie sua entrega</p>' },
        "nl": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Beoordeel je bezorging</p>' },
        "sv": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Betygs\xE4tt din leverans</p>' },
        "fi": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Arvioi toimituksesi</p>' },
        "no": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Vurder leveringen din</p>' },
        "da": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Bed\xF8m din levering</p>' },
        "pl": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Oce\u0144 swoj\u0105 dostaw\u0119</p>' },
        "cs": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Ohodno\u0165te sv\xE9 doru\u010Den\xED</p>' },
        "sk": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Ohodno\u0165te svoje doru\u010Denie</p>' },
        "hu": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\xC9rt\xE9kelje a k\xE9zbes\xEDt\xE9st</p>' },
        "bg": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u041E\u0446\u0435\u043D\u0435\u0442\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430</p>' },
        "zh": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u8BC4\u4EF7\u60A8\u7684\u914D\u9001</p>' },
        "ja": { "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u914D\u9001\u3092\u8A55\u4FA1\u3059\u308B</p>' }
      }
    },
    {
      "id": "2e7c9d4a-1f0b-4a3e-8c6d-5b9e0f1a2b7d",
      "type": "rate-order",
      "alignment": "center",
      "font": null,
      "properties": null,
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/delivered-to-neighbour.ts
var deliveredToNeighbourEmailTemplateSubject = {
  "fr": "Votre colis {{shop.name}} a \xE9t\xE9 remis en toute s\xE9curit\xE9 \xE0 un tiers autoris\xE9.",
  "en": "Your {{shop.name}} order has been delivered to a third party.",
  "es": "Su pedido de {{shop.name}} ha sido entregado a un tercero.",
  "it": "Il tuo ordine {{shop.name}} \xE8 stato consegnato a una terza parte.",
  "de": "Ihre {{shop.name}} Bestellung wurde an eine dritte Partei geliefert.",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "O seu pedido {{shop.name}} foi entregue a um terceiro.",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u5DF2\u4EA4\u4ED8\u7ED9\u7B2C\u4E09\u65B9\u4EE3\u6536\u3002",
  "ja": "{{shop.name}} \u306E\u3054\u6CE8\u6587\u306F\u7B2C\u4E09\u8005\u306B\u304A\u5C4A\u3051\u3057\u307E\u3057\u305F\u3002"
};
var deliveredToNeighbourEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE A ETE LIVR\xC9E</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> a \xE9t\xE9 r\xE9ceptionn\xE9e par la personne d\xE9sign\xE9e par vos soins. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous esp\xE9rons qu'elle r\xE9pondra \xE0 vos attentes et restons disponibles le cas \xE9ch\xE9ant. </span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER HAS BEEN DELIVERED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been received by the person designated by you. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We hope it meets your expectations and remain available if needed. </span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO HA SIDO ENTREGADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ha sido recibido por la persona designada por usted. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que cumpla con sus expectativas y estamos disponibles si es necesario. </span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE \xC8 STATO CONSEGNATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 stato ricevuto dalla persona da te designata. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Speriamo che soddisfi le tue aspettative e rimaniamo a disposizione se necessario. </span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG WURDE GELIEFERT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> wurde von der von Ihnen benannten Person entgegengenommen. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir hoffen, dass es Ihren Erwartungen entspricht und stehen Ihnen bei Bedarf zur Verf\xFCgung. </span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO FOI ENTREGUE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> foi recebido pela pessoa designada por voc\xEA. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que atenda \xE0s suas expectativas e estamos dispon\xEDveis se necess\xE1rio. </span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u9001\u8FBE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been received by the person designated by you. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u5E0C\u671B\u7B26\u5408\u60A8\u7684\u671F\u671B\uFF0C\u5982\u6709\u9700\u8981\uFF0C\u6211\u4EEC\u968F\u65F6\u4E3A\u60A8\u670D\u52A1\u3002 </span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u304C\u914D\u9054\u3055\u308C\u307E\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been received by the person designated by you. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u671F\u5F85\u306B\u6CBF\u3048\u308C\u3070\u5E78\u3044\u3067\u3059\u3002\u5FC5\u8981\u3067\u3042\u308C\u3070\u3044\u3064\u3067\u3082\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002 </span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/returned-to-sender.ts
var returnedToSenderEmailTemplateSubject = {
  "fr": "Votre colis n\u2019a pas pu \xEAtre livr\xE9 et / ou r\xE9cup\xE9r\xE9 et retourne d\xE9sormais chez {{shop.name}}.",
  "en": "Your {{shop.name}} order is being returned to sender.",
  "es": "Su pedido de {{shop.name}} est\xE1 siendo devuelto al remitente.",
  "it": "Il tuo ordine {{shop.name}} viene restituito al mittente.",
  "de": "Ihre {{shop.name}}-Bestellung wird an den Absender zur\xFCckgesendet.",
  "nl": "Uw {{shop.name}}-bestelling wordt teruggestuurd naar de afzender.",
  "pl": "Twoje zam\xF3wienie {{shop.name}} jest zwracane do nadawcy.",
  "da": "Din {{shop.name}}-ordre returneres til afsenderen.",
  "pt": "O seu pedido {{shop.name}} est\xE1 a ser devolvido ao remetente.",
  "sv": "Din {{shop.name}}-best\xE4llning returneras till avs\xE4ndaren.",
  "fi": "Tilauksesi {{shop.name}} palautetaan l\xE4hett\xE4j\xE4lle.",
  "no": "Din {{shop.name}}-bestilling returneres til avsenderen.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "Va\u0161e objedn\xE1vka {{shop.name}} se vrac\xED odes\xEDlateli.",
  "hu": "A(z) {{shop.name}} rendel\xE9se visszak\xFCld\xE9sre ker\xFCl a felad\xF3nak.",
  "sk": "Va\u0161a objedn\xE1vka {{shop.name}} sa vracia odosielate\u013Eovi.",
  "zh": "\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u6B63\u5728\u9000\u56DE\u53D1\u4EF6\u4EBA\u3002",
  "ja": "{{shop.name}} \u306E\u3054\u6CE8\u6587\u306F\u767A\u9001\u5143\u306B\u8FD4\u9001\u4E2D\u3067\u3059\u3002"
};
var returnedToSenderEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE REPART CHEZ L'EXP\xC9DITEUR</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, vous n'avez pas pu prendre possession de votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> et nous le regrettons.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Le colis fait le chemin inverse et sera bient\xF4t dans les mains de nos \xE9quipes.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER IS BEING RETURNED TO THE SENDER</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you were unable to receive your {{shop.name}} order and we regret this. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package is on its way back and will soon be in the hands of our team. </span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO EST\xC1 SIENDO DEVUELTO AL REMITENTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, no pudo recibir su pedido de {{shop.name}} y lo lamentamos. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">El paquete est\xE1 de regreso y pronto estar\xE1 en manos de nuestro equipo. </span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE VIENE RESTITUITO AL MITTENTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, non sei riuscito a ricevere il tuo ordine {{shop.name}} e ce ne dispiace. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Il pacco \xE8 in viaggio di ritorno e presto sar\xE0 nelle mani del nostro team. </span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG WIRD AN DEN ABSENDER ZUR\xDCCKGESENDET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Sie konnten Ihre {{shop.name}}-Bestellung nicht entgegennehmen und wir bedauern dies. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Das Paket ist auf dem R\xFCckweg und wird bald in den H\xE4nden unseres Teams sein. </span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW BESTELLING WORDT TERUGGESTUURD NAAR DE AFZENDER</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, u kon uw {{shop.name}}-bestelling niet ontvangen en dat betreuren wij. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Het pakket is onderweg terug en zal binnenkort in handen zijn van ons team. </span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJE ZAM\xD3WIENIE JEST ZWRACANE DO NADAWCY</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, nie uda\u0142o Ci si\u0119 odebra\u0107 zam\xF3wienia {{shop.name}} i jest nam przykro. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Paczka jest w drodze powrotnej i wkr\xF3tce b\u0119dzie w r\u0119kach naszego zespo\u0142u. </span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN BESTILLING RETURNERES TIL AFSENDEREN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, du kunne ikke modtage din {{shop.name}}-bestilling, og vi beklager dette. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pakken er p\xE5 vej tilbage og vil snart v\xE6re i h\xE6nderne p\xE5 vores team. </span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO EST\xC1 A SER DEVOLVIDO AO REMETENTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, n\xE3o conseguiu receber o seu pedido {{shop.name}} e lamentamos isso. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">O pacote est\xE1 a caminho de volta e em breve estar\xE1 nas m\xE3os da nossa equipa. </span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN BEST\xC4LLNING RETURNERAS TILL AVS\xC4NDAREN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, du kunde inte ta emot din {{shop.name}}-best\xE4llning och vi beklagar detta. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Paketet \xE4r p\xE5 v\xE4g tillbaka och kommer snart att vara i v\xE5rt teams h\xE4nder. </span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TILAUKSESI PALAUTETAAN L\xC4HETT\xC4J\xC4LLE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, et voinut vastaanottaa {{shop.name}}-tilaustasi ja pahoittelemme t\xE4t\xE4. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Paketti on matkalla takaisin ja on pian tiimimme k\xE4siss\xE4. </span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN BESTILLING RETURNERES TIL AVSENDEREN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, du kunne ikke motta din {{shop.name}}-bestilling, og vi beklager dette. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pakken er p\xE5 vei tilbake og vil snart v\xE6re i hendene p\xE5 v\xE5rt team. </span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160E OBJEDN\xC1VKA SE VRAC\xCD ODES\xCDLATELI</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, nepoda\u0159ilo se v\xE1m p\u0159evz\xEDt objedn\xE1vku {{shop.name}} a je n\xE1m to l\xEDto. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Bal\xED\u010Dek je na cest\u011B zp\u011Bt a brzy bude v rukou na\u0161eho t\xFDmu. </span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>RENDEL\xC9SE VISSZAK\xDCLD\xC9SRE KER\xDCL A FELAD\xD3NAK</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, nem tudta \xE1tvenni a(z) {{shop.name}} rendel\xE9s\xE9t, \xE9s ezt sajn\xE1ljuk. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">A csomag vissza\xFAton van, \xE9s hamarosan a csapatunk kez\xE9ben lesz. </span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160A OBJEDN\xC1VKA SA VRACIA ODOSIELATE\u013DOVI</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, nepodarilo sa v\xE1m prevzia\u0165 objedn\xE1vku {{shop.name}} a je n\xE1m to \u013E\xFAto. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Bal\xEDk je na ceste sp\xE4\u0165 a \u010Doskoro bude v ruk\xE1ch n\xE1\u0161ho t\xEDmu. </span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u6B63\u5728\u9000\u56DE\u53D1\u4EF6\u4EBA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you were unable to receive your {{shop.name}} order and we regret this. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package is on its way back and will soon be in the hands of our team. </span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306F\u767A\u9001\u5143\u306B\u8FD4\u9001\u3055\u308C\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you were unable to receive your {{shop.name}} order and we regret this. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package is on its way back and will soon be in the hands of our team. </span></p>'
        }
      }
    },
    {
      "id": "afd116e3-9945-4326-9df3-1fe66087a76d",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      }
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      }
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contents of your order</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido de su pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhalt Ihrer Bestellung</u></strong></span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto del tuo ordine</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van uw bestelling</u></strong></span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do seu pedido</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inneh\xE5ll i din best\xE4llning</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilauksesi sis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Innholdet i bestillingen din</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Indholdet af din ordre</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9sed tartalma</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161ej objedn\xE1vky</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161\xED objedn\xE1vky</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u60A8\u7684\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/exception.ts
var exceptionEmailTemplateSubject = {
  "fr": "Un incident d\u2019acheminement a \xE9t\xE9 signal\xE9 par {{carrier.name}} ; {{shop.name}} engage imm\xE9diatement les actions n\xE9cessaires.",
  "en": "Your order could not be delivered by {{carrier.name}}",
  "es": "Su pedido no pudo ser entregado por {{carrier.name}}",
  "it": "Il tuo ordine non \xE8 stato consegnato da {{carrier.name}}",
  "de": "Ihre Bestellung konnte nicht von {{carrier.name}} geliefert werden",
  "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
  "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
  "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
  "pt": "O seu pedido n\xE3o p\xF4de ser entregue por {{carrier.name}}",
  "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
  "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
  "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
  "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
  "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
  "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
  "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
  "zh": "{{carrier.name}} \u672A\u80FD\u6210\u529F\u914D\u9001\u60A8\u7684\u8BA2\u5355",
  "ja": "{{carrier.name}} \u306B\u3088\u308B\u3054\u6CE8\u6587\u306E\u914D\u9054\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F"
};
var exceptionEmailTemplate = {
  "beforeBlocks": [],
  "insideBlocks": [
    {
      "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
      "type": "logo",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "dbd98b6f-59d1-494b-9632-e91cafef967b",
      "type": "paragraph",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UN INCIDENT D'ACHEMINEMENT EMPECHE VOTRE LIVRAISON.</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Cher(e) <span data-type="mention" class="mention" data-id="order.firstName" data-label="Firstname" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Firstname</span>, Nous avons \xE9t\xE9 inform\xE9s d\u2019une difficult\xE9 d\u2019acheminement concernant votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Nom du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du shop</span>, ind\xE9pendante de notre volont\xE9 comme de celle de <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Notre \xE9quipe a imm\xE9diatement pris contact avec le transporteur pour comprendre la situation et r\xE9soudre le probl\xE8me dans les meilleurs d\xE9lais.</span></p>`
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER COULD NOT BE DELIVERED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> could not be delivered by </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> today. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Rest assured, instructions are on the way to help you arrange the redelivery of your package. </span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO NO PUDO SER ENTREGADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> no pudo ser entregado por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoy. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">No se preocupe, las instrucciones est\xE1n en camino para ayudarle a organizar la reentrega de su paquete. </span></p>'
        },
        "it": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE NON HA POTUTO ESSERE CONSEGNATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> non ha potuto essere consegnato da </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> oggi. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stai tranquillo, le istruzioni stanno arrivando per aiutarti a organizzare la riconsegna del tuo pacco. </span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG KONNTE NICHT GELIEFERT WERDEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> konnte nicht von </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> heute geliefert werden. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Seien Sie versichert, Anweisungen sind unterwegs, um Ihnen bei der Organisation der erneuten Lieferung Ihres Pakets zu helfen. </span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO N\xC3O P\xD4DE SER ENTREGUE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n\xE3o p\xF4de ser entregue por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoje. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Fique tranquilo, as instru\xE7\xF5es est\xE3o a caminho para ajud\xE1-lo a organizar a reentrega do seu pacote. </span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u672A\u80FD\u9001\u8FBE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u672A\u80FD\u9001\u8FBE\uFF0C\u627F\u8FD0\u5546\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u4ECA\u5929\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u8BF7\u653E\u5FC3\uFF0C\u5173\u4E8E\u91CD\u65B0\u914D\u9001\u7684\u8BF4\u660E\u5373\u5C06\u53D1\u9001\u7ED9\u60A8\uFF1A \u60A8\u7684\u5305\u88F9. </span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u3092\u304A\u5C4A\u3051\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306B\u3088\u308B\u914D\u9001\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u672C\u65E5\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u5B89\u5FC3\u304F\u3060\u3055\u3044\u3002\u518D\u914D\u9054\u306E\u624B\u914D\u65B9\u6CD5\u306B\u3064\u3044\u3066\u6848\u5185\u3092\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\uFF1A \u8377\u7269. </span></p>'
        }
      }
    },
    {
      "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
      "type": "delivery-address",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
      "type": "separator",
      "alignment": "center",
      "font": null,
      "properties": {
        "spacing": "small"
      },
      "content": null
    },
    {
      "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
      "type": "paragraph",
      "alignment": "left",
      "font": null,
      "properties": {},
      "content": {
        "fr": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
        },
        "en": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
        },
        "es": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
        },
        "de": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
        },
        "it": {
          "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
        },
        "pt": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
        },
        "nl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
        },
        "sv": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
        },
        "fi": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
        },
        "no": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
        },
        "da": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
        },
        "pl": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
        },
        "cs": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "sk": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
        },
        "hu": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
        },
        "bg": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
        },
        "zh": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
        },
        "ja": {
          "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
        }
      }
    },
    {
      "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
      "type": "package-content",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "a3aaaf52-59fe-4eb1-b29d-ae5e14e77755",
      "type": "button",
      "alignment": "center",
      "font": null,
      "properties": {
        "variant": "outline"
      },
      "content": {
        "fr": {
          "text": "Suivre mon colis",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "en": {
          "text": "Track my package",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "es": {
          "text": "Seguir mi paquete",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "de": {
          "text": "Mein Paket verfolgen",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "it": {
          "text": "Traccia il mio pacco",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pt": {
          "text": "Rastrear meu pacote",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "nl": {
          "text": "Volg mijn pakket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sv": {
          "text": "Sp\xE5ra mitt paket",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "fi": {
          "text": "Seuraa pakettiani",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "no": {
          "text": "Spor pakken min",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "da": {
          "text": "Spor min pakke",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "pl": {
          "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "cs": {
          "text": "Sledovat m\u016Fj bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "sk": {
          "text": "Sledova\u0165 m\xF4j bal\xEDk",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "hu": {
          "text": "K\xF6vesd a csomagom",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "bg": {
          "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "zh": {
          "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        },
        "ja": {
          "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
          "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
        }
      }
    }
  ],
  "afterBlocks": [
    {
      "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
      "type": "wallet",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    },
    {
      "id": "ff47b487-ca85-40b6-a852-3fe952989749",
      "type": "social-networks",
      "alignment": "center",
      "font": null,
      "properties": {},
      "content": null
    }
  ],
  "defaultLocale": "fr"
};

// src/templates/tracking/order-not-fulfilled.ts
var orderNotFulfilledEmailTemplateSubject = {
  fr: "Commande non exp\xE9di\xE9e (#{{parcel.orderNumber}})",
  en: "Order Not Fulfilled (#{{parcel.orderNumber}})",
  de: "Bestellung nicht erf\xFCllt (#{{parcel.orderNumber}})",
  es: "Pedido no cumplido (#{{parcel.orderNumber}})",
  it: "Ordine non evaso (#{{parcel.orderNumber}})",
  nl: "Bestelling niet verzonden (#{{parcel.orderNumber}})",
  zh: "\u8BA2\u5355\u672A\u53D1\u8D27 (#{{parcel.orderNumber}})",
  ja: "\u6CE8\u6587\u672A\u51FA\u8377 (#{{parcel.orderNumber}})"
};
var orderNotFulfilledEmailTemplate = {
  beforeBlocks: [],
  insideBlocks: [
    {
      type: "logo",
      alignment: "center",
      properties: {},
      id: "1c4c576c-1db9-433c-9722-b8052c02e474"
    },
    {
      id: "f824b8ff-ec03-4da9-99c9-ec1ca4994f91",
      type: "separator",
      alignment: "center",
      properties: {},
      content: null
    },
    {
      id: "1",
      type: "paragraph",
      alignment: "center",
      properties: null,
      content: {
        en: {
          html: "<p style='font-size: 18px; font-weight: bold; margin: 0px; padding: 0px; color: #d97706;'>\u26A0\uFE0F Order Not Fulfilled - Merchant Alert</p><p style='font-size: 16px; font-weight: normal; margin: 10px 0px; padding: 0px;'>Order <strong>{{parcel.orderNumber}}</strong> has not been shipped yet.</p><p style='font-size: 14px; color: #666; margin: 5px 0px;'>Please check your orders and take action if needed.</p>"
        },
        fr: {
          html: "<p style='font-size: 18px; font-weight: bold; margin: 0px; padding: 0px; color: #d97706;'>\u26A0\uFE0F Commande non exp\xE9di\xE9e - Alerte Marchand</p><p style='font-size: 16px; font-weight: normal; margin: 10px 0px; padding: 0px;'>La commande <strong>{{parcel.orderNumber}}</strong> n'a pas encore \xE9t\xE9 exp\xE9di\xE9e.</p><p style='font-size: 14px; color: #666; margin: 5px 0px;'>Veuillez v\xE9rifier vos commandes et prendre les mesures n\xE9cessaires.</p>"
        },
        es: {
          html: "<p style='font-size: 18px; font-weight: bold; margin: 0px; padding: 0px; color: #d97706;'>\u26A0\uFE0F Pedido no cumplido - Alerta de Comerciante</p><p style='font-size: 16px; font-weight: normal; margin: 10px 0px; padding: 0px;'>El pedido <strong>{{parcel.orderNumber}}</strong> a\xFAn no ha sido enviado.</p><p style='font-size: 14px; color: #666; margin: 5px 0px;'>Por favor, revise sus pedidos y tome medidas si es necesario.</p>"
        },
        de: {
          html: "<p style='font-size: 18px; font-weight: bold; margin: 0px; padding: 0px; color: #d97706;'>\u26A0\uFE0F Bestellung nicht erf\xFCllt - H\xE4ndler-Alarm</p><p style='font-size: 16px; font-weight: normal; margin: 10px 0px; padding: 0px;'>Bestellung <strong>{{parcel.orderNumber}}</strong> wurde noch nicht versendet.</p><p style='font-size: 14px; color: #666; margin: 5px 0px;'>Bitte \xFCberpr\xFCfen Sie Ihre Bestellungen und ergreifen Sie bei Bedarf Ma\xDFnahmen.</p>"
        },
        it: {
          html: "<p style='font-size: 18px; font-weight: bold; margin: 0px; padding: 0px; color: #d97706;'>\u26A0\uFE0F Ordine non evaso - Avviso Commerciante</p><p style='font-size: 16px; font-weight: normal; margin: 10px 0px; padding: 0px;'>L'ordine <strong>{{parcel.orderNumber}}</strong> non \xE8 ancora stato spedito.</p><p style='font-size: 14px; color: #666; margin: 5px 0px;'>Si prega di controllare gli ordini e prendere provvedimenti se necessario.</p>"
        },
        nl: {
          html: "<p style='font-size: 18px; font-weight: bold; margin: 0px; padding: 0px; color: #d97706;'>\u26A0\uFE0F Bestelling niet verzonden - Handelaar Waarschuwing</p><p style='font-size: 16px; font-weight: normal; margin: 10px 0px; padding: 0px;'>Bestelling <strong>{{parcel.orderNumber}}</strong> is nog niet verzonden.</p><p style='font-size: 14px; color: #666; margin: 5px 0px;'>Controleer uw bestellingen en neem actie indien nodig.</p>"
        },
        zh: {
          html: "<p style='font-size: 18px; font-weight: bold; margin: 0px; padding: 0px; color: #d97706;'>\u26A0\uFE0F \u8BA2\u5355\u672A\u53D1\u8D27 - \u5546\u5BB6\u63D0\u9192</p><p style='font-size: 16px; font-weight: normal; margin: 10px 0px; padding: 0px;'>\u8BA2\u5355 <strong>{{parcel.orderNumber}}</strong> \u5C1A\u672A\u53D1\u8D27\u3002</p><p style='font-size: 14px; color: #666; margin: 5px 0px;'>\u8BF7\u68C0\u67E5\u60A8\u7684\u8BA2\u5355\u5E76\u6839\u636E\u9700\u8981\u91C7\u53D6\u884C\u52A8\u3002</p>"
        },
        ja: {
          html: "<p style='font-size: 18px; font-weight: bold; margin: 0px; padding: 0px; color: #d97706;'>\u26A0\uFE0F \u6CE8\u6587\u672A\u51FA\u8377 - \u8CA9\u58F2\u8005\u30A2\u30E9\u30FC\u30C8</p><p style='font-size: 16px; font-weight: normal; margin: 10px 0px; padding: 0px;'>\u6CE8\u6587 <strong>{{parcel.orderNumber}}</strong> \u306F\u307E\u3060\u767A\u9001\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002</p><p style='font-size: 14px; color: #666; margin: 5px 0px;'>\u3054\u6CE8\u6587\u3092\u78BA\u8A8D\u3057\u3001\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u5BFE\u5FDC\u3057\u3066\u304F\u3060\u3055\u3044\u3002</p>"
        }
      }
    },
    {
      type: "button",
      alignment: "center",
      properties: {},
      id: "f54e6d5a-03a7-4b95-8558-e51226463897",
      content: {
        fr: {
          text: "Voir la commande",
          href: "{{shop.preferences.backofficeUrl}}/orders"
        },
        en: {
          text: "View Order",
          href: "{{shop.preferences.backofficeUrl}}/orders"
        },
        es: {
          text: "Ver pedido",
          href: "{{shop.preferences.backofficeUrl}}/orders"
        },
        de: {
          text: "Bestellung ansehen",
          href: "{{shop.preferences.backofficeUrl}}/orders"
        },
        it: {
          text: "Visualizza ordine",
          href: "{{shop.preferences.backofficeUrl}}/orders"
        },
        nl: {
          text: "Bekijk bestelling",
          href: "{{shop.preferences.backofficeUrl}}/orders"
        },
        zh: {
          text: "\u67E5\u770B\u8BA2\u5355",
          href: "{{shop.preferences.backofficeUrl}}/orders"
        },
        ja: {
          text: "\u6CE8\u6587\u3092\u78BA\u8A8D\u3059\u308B",
          href: "{{shop.preferences.backofficeUrl}}/orders"
        }
      }
    },
    {
      type: "separator",
      alignment: "center",
      properties: {},
      id: "11dc9c0c-8045-4794-8188-12c0d3986509"
    },
    {
      type: "package-content",
      alignment: "center",
      properties: {},
      id: "3cc2433f-c221-4716-85cf-23dd7583cd87"
    }
  ],
  afterBlocks: [],
  defaultLocale: "en"
};

// src/templates/default-templates.ts
var defaultTemplates = {
  NONE: {
    type: "NONE",
    category: "expedition",
    id: "1938fde5-12c00-28s8-7df5-59f36defjha",
    title: "Pr\xEAt pour exp\xE9dition",
    subject: {
      fr: "Votre commande {{shop.name}} est pr\xEAte, elle sera bient\xF4t prise en charge par le transporteur.",
      en: "Your {{shop.name}} order is ready, it will soon be taken care of by the carrier.",
      es: "Su pedido {{shop.name}} est\xE1 listo, pronto ser\xE1 atendido por el transportista.",
      it: "Il tuo ordine {{shop.name}} \xE8 pronto, sar\xE0 presto preso in carico dal corriere.",
      de: "Ihre {{shop.name}} Bestellung ist bereit, sie wird bald vom Spediteur \xFCbernommen.",
      nl: "Uw {{shop.name}} bestelling is klaar, deze wordt binnenkort door de vervoerder afgehandeld.",
      pl: "Twoje zam\xF3wienie {{shop.name}} jest gotowe, wkr\xF3tce zostanie odebrane przez przewo\u017Anika.",
      da: "Din {{shop.name}} ordre er klar, den vil snart blive h\xE5ndteret af transport\xF8ren.",
      pt: "A sua encomenda {{shop.name}} est\xE1 pronta, ser\xE1 em breve entregue \xE0 transportadora.",
      sv: "Din {{shop.name}} best\xE4llning \xE4r klar, den kommer snart att tas om hand av transport\xF6ren.",
      fi: "{{shop.name}} -tilauksesi on valmis, kuljettaja hoitaa sen pian.",
      no: "{{shop.name}}-bestillingen din er klar, den vil snart bli tatt h\xE5nd om av transport\xF8ren.",
      bg: "\u0412\u0430\u0448\u0430\u0442\u0430 {{shop.name}} \u043F\u043E\u0440\u044A\u0447\u043A\u0430 \u0435 \u0433\u043E\u0442\u043E\u0432\u0430, \u0441\u043A\u043E\u0440\u043E \u0449\u0435 \u0431\u044A\u0434\u0435 \u043F\u043E\u0435\u0442\u0430 \u043E\u0442 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430.",
      cs: "Va\u0161e {{shop.name}} objedn\xE1vka je p\u0159ipravena, brzy se ji ujme p\u0159epravce.",
      hu: "Az \xD6n {{shop.name}} rendel\xE9se elk\xE9sz\xFClt, hamarosan a sz\xE1ll\xEDtm\xE1nyoz\xF3 veszi \xE1t.",
      sk: "Va\u0161a {{shop.name}} objedn\xE1vka je pripraven\xE1, \u010Doskoro sa o \u0148u postar\xE1 prepravca.",
      zh: "\u60A8\u7684{{shop.name}}\u8BA2\u5355\u5DF2\u51C6\u5907\u5C31\u7EEA\uFF0C\u5373\u5C06\u7531\u627F\u8FD0\u5546\u5904\u7406\u3002",
      ja: "{{shop.name}}\u306E\u3054\u6CE8\u6587\u306E\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u307E\u3082\u306A\u304F\u914D\u9001\u696D\u8005\u304C\u5BFE\u5FDC\u3044\u305F\u3057\u307E\u3059\u3002"
    },
    preview: {
      fr: "Votre commande {{shop.name}} est pr\xEAte, elle sera bient\xF4t prise en charge par le transporteur.",
      en: "Your {{shop.name}} order is ready, it will soon be taken care of by the carrier.",
      es: "Su pedido {{shop.name}} est\xE1 listo, pronto ser\xE1 atendido por el transportista.",
      it: "Il tuo ordine {{shop.name}} \xE8 pronto, sar\xE0 presto preso in carico dal corriere.",
      de: "Ihre {{shop.name}} Bestellung ist bereit, sie wird bald vom Spediteur \xFCbernommen.",
      nl: "Uw {{shop.name}} bestelling is klaar, deze wordt binnenkort door de vervoerder afgehandeld.",
      pl: "Twoje zam\xF3wienie {{shop.name}} jest gotowe, wkr\xF3tce zostanie odebrane przez przewo\u017Anika.",
      da: "Din {{shop.name}} ordre er klar, den vil snart blive h\xE5ndteret af transport\xF8ren.",
      pt: "A sua encomenda {{shop.name}} est\xE1 pronta, ser\xE1 em breve entregue \xE0 transportadora.",
      sv: "Din {{shop.name}} best\xE4llning \xE4r klar, den kommer snart att tas om hand av transport\xF6ren.",
      fi: "{{shop.name}} -tilauksesi on valmis, kuljettaja hoitaa sen pian.",
      no: "{{shop.name}}-bestillingen din er klar, den vil snart bli tatt h\xE5nd om av transport\xF8ren.",
      bg: "\u0412\u0430\u0448\u0430\u0442\u0430 {{shop.name}} \u043F\u043E\u0440\u044A\u0447\u043A\u0430 \u0435 \u0433\u043E\u0442\u043E\u0432\u0430, \u0441\u043A\u043E\u0440\u043E \u0449\u0435 \u0431\u044A\u0434\u0435 \u043F\u043E\u0435\u0442\u0430 \u043E\u0442 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430.",
      cs: "Va\u0161e {{shop.name}} objedn\xE1vka je p\u0159ipravena, brzy se ji ujme p\u0159epravce.",
      hu: "Az \xD6n {{shop.name}} rendel\xE9se elk\xE9sz\xFClt, hamarosan a sz\xE1ll\xEDtm\xE1nyoz\xF3 veszi \xE1t.",
      sk: "Va\u0161a {{shop.name}} objedn\xE1vka je pripraven\xE1, \u010Doskoro sa o \u0148u postar\xE1 prepravca.",
      zh: "\u60A8\u7684{{shop.name}}\u8BA2\u5355\u5DF2\u51C6\u5907\u5C31\u7EEA\uFF0C\u5373\u5C06\u7531\u627F\u8FD0\u5546\u5904\u7406\u3002",
      ja: "{{shop.name}}\u306E\u3054\u6CE8\u6587\u306E\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u307E\u3082\u306A\u304F\u914D\u9001\u696D\u8005\u304C\u5BFE\u5FDC\u3044\u305F\u3057\u307E\u3059\u3002"
    },
    content: {
      beforeBlocks: [],
      insideBlocks: [
        {
          id: "7c868707-ee74-4cea-a7da-ac4879188cfe",
          type: "logo",
          alignment: "center",
          properties: {},
          content: null
        },
        {
          id: "dbd98b6f-59d1-494b-9632-e91cafef967b",
          type: "paragraph",
          alignment: "center",
          properties: {},
          content: {
            fr: {
              html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE EST PR\xCATE POUR L'EXP\xC9DITION</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, votre commande </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> est pr\xEAte et sera bient\xF4t prise en charge par le transporteur.&nbsp;</span></p>`
            },
            en: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER IS READY FOR SHIPPING</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, your </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> order is ready and will soon be taken care of by the carrier.&nbsp;</span></p>'
            },
            es: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO EST\xC1 LISTO PARA EL ENV\xCDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, su pedido </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> est\xE1 listo y pronto ser\xE1 atendido por el transportista.&nbsp;</span></p>'
            },
            it: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE \xC8 PRONTO PER LA SPEDIZIONE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, il tuo ordine </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \xE8 pronto e sar\xE0 presto preso in carico dal corriere.&nbsp;</span></p>'
            },
            de: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG IST VERSANDBEREIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Ihre </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> Bestellung ist bereit und wird bald vom Spediteur \xFCbernommen.&nbsp;</span></p>'
            },
            nl: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW BESTELLING IS KLAAR VOOR VERZENDING</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, uw </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> bestelling is klaar en wordt binnenkort door de vervoerder afgehandeld.&nbsp;</span></p>'
            },
            pl: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJE ZAM\xD3WIENIE JEST GOTOWE DO WYSY\u0141KI</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoje zam\xF3wienie </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest gotowe i wkr\xF3tce zostanie odebrane przez przewo\u017Anika.&nbsp;</span></p>'
            },
            da: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN ORDRE ER KLAR TIL AFSENDELSE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> ordre er klar og vil snart blive h\xE5ndteret af transport\xF8ren.&nbsp;</span></p>'
            },
            pt: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A SUA ENCOMENDA EST\xC1 PRONTA PARA ENVIO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a sua encomenda </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> est\xE1 pronta e ser\xE1 em breve entregue \xE0 transportadora.&nbsp;</span></p>'
            },
            sv: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN BEST\xC4LLNING \xC4R KLAR F\xD6R LEVERANS</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> best\xE4llning \xE4r klar och kommer snart att tas om hand av transport\xF6ren.&nbsp;</span></p>'
            },
            fi: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TILAUKSESI ON VALMIS L\xC4HETETT\xC4V\xC4KSI</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> -tilauksesi on valmis ja kuljettaja hoitaa sen pian.&nbsp;</span></p>'
            },
            no: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>BESTILLINGEN DIN ER KLAR FOR SENDING</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>-bestillingen din er klar og vil snart bli tatt h\xE5nd om av transport\xF8ren.&nbsp;</span></p>'
            },
            bg: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u041E\u0420\u042A\u0427\u041A\u0410 \u0415 \u0413\u041E\u0422\u041E\u0412\u0410 \u0417\u0410 \u0418\u0417\u041F\u0420\u0410\u0429\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u043F\u043E\u0440\u044A\u0447\u043A\u0430 \u0435 \u0433\u043E\u0442\u043E\u0432\u0430 \u0438 \u0441\u043A\u043E\u0440\u043E \u0449\u0435 \u0431\u044A\u0434\u0435 \u043F\u043E\u0435\u0442\u0430 \u043E\u0442 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430.&nbsp;</span></p>'
            },
            cs: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160E OBJEDN\xC1VKA JE P\u0158IPRAVENA K ODESL\xC1N\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, va\u0161e </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> objedn\xE1vka je p\u0159ipravena a brzy se ji ujme p\u0159epravce.&nbsp;</span></p>'
            },
            hu: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>RENDEL\xC9SE K\xC9SZ A SZ\xC1LL\xCDT\xC1SRA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, az \xD6n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> rendel\xE9se elk\xE9sz\xFClt \xE9s hamarosan a sz\xE1ll\xEDtm\xE1nyoz\xF3 veszi \xE1t.&nbsp;</span></p>'
            },
            sk: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160A OBJEDN\xC1VKA JE PRIPRAVEN\xC1 NA ODOSLANIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, va\u0161a </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> objedn\xE1vka je pripraven\xE1 a \u010Doskoro sa o \u0148u postar\xE1 prepravca.&nbsp;</span></p>'
            },
            zh: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u51C6\u5907\u597D\u53D1\u8D27</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">\uFF0C\u60A8\u7684 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u8BA2\u5355\u5DF2\u51C6\u5907\u5C31\u7EEA\uFF0C\u5373\u5C06\u7531\u627F\u8FD0\u5546\u5904\u7406\u3002&nbsp;</span></p>'
            },
            ja: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306E\u767A\u9001\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;"></span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;"> \u69D8\u3001</span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u306E\u3054\u6CE8\u6587\u306E\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u307E\u3082\u306A\u304F\u914D\u9001\u696D\u8005\u304C\u5BFE\u5FDC\u3044\u305F\u3057\u307E\u3059\u3002&nbsp;</span></p>'
            }
          }
        },
        {
          id: "c628fa0b-57cd-4f23-b10a-75cf3d17ab8a",
          type: "button",
          alignment: "center",
          properties: {
            variant: "outline"
          },
          content: {
            fr: {
              text: "Suivre mon colis",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            en: {
              text: "Track my package",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            es: {
              text: "Seguir mi paquete",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            it: {
              text: "Segui il mio pacco",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            de: {
              text: "Mein Paket verfolgen",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            nl: {
              text: "Mijn pakket volgen",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            pl: {
              text: "\u015Aled\u017A moj\u0105 paczk\u0119",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            da: {
              text: "Spor min pakke",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            pt: {
              text: "Acompanhar a minha encomenda",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            sv: {
              text: "Sp\xE5ra mitt paket",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            fi: {
              text: "Seuraa pakettiani",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            no: {
              text: "Spor pakken min",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            bg: {
              text: "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u0438 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u043C\u0438",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            cs: {
              text: "Sledovat m\u016Fj bal\xEDk",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            hu: {
              text: "K\xF6vesd a csomagomat",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            sk: {
              text: "Sledova\u0165 m\xF4j bal\xEDk",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            zh: {
              text: "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            ja: {
              text: "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            }
          }
        },
        {
          id: "ec6a97ac-fc83-4310-a4fb-900e14c76150",
          type: "delivery-address",
          alignment: "center",
          properties: {},
          content: null
        },
        {
          type: "package-content",
          alignment: "center",
          properties: {},
          id: "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
          content: null
        }
      ],
      afterBlocks: [
        {
          id: "ff47b487-ca85-40b6-a852-3fe952989749",
          type: "social-networks",
          alignment: "center",
          properties: {},
          content: null
        }
      ],
      defaultLocale: "fr"
    },
    createdAt: "2025-10-03T17:08:49.049Z",
    updatedAt: "2025-10-21T10:04:24.949Z"
  },
  PRE_TRANSIT: {
    type: "PRE_TRANSIT",
    category: "expedition",
    id: "1938fde5-12c00-28s8-7df5-59f36defjha",
    title: "1 \xC9tiquette g\xE9n\xE9r\xE9e, aucun tracking",
    subject: preTransitEmailTemplateSubject,
    preview: preTransitEmailTemplateSubject,
    content: preTransitEmailTemplate,
    createdAt: "2025-10-03T17:08:49.049Z",
    updatedAt: "2025-10-21T10:04:24.949Z"
  },
  PARCEL_NOT_SHIPPED: {
    type: "PARCEL_NOT_SHIPPED",
    category: "expedition",
    id: "9773fde5-9c89-40fd-89f5-59f36defeedc",
    title: "1.2 Absence de tracking prolong\xE9e",
    subject: parcelNotShippedEmailTemplateSubject,
    preview: parcelNotShippedEmailTemplateSubject,
    content: parcelNotShippedEmailTemplate,
    createdAt: "2025-10-03T17:08:49.049Z",
    updatedAt: "2025-10-21T10:04:24.949Z"
  },
  CUSTOMS_CLEARANCE_START: {
    type: "CUSTOMS_CLEARANCE_START",
    category: "transit",
    id: "cb089179-0d93-4a47-9a32-97cd92422aaa",
    title: "2.2 Incident douanier d\xE9clar\xE9",
    subject: customsClearanceStartEmailTemplateSubject,
    preview: customsClearanceStartEmailTemplateSubject,
    content: customsClearanceStartEmailTemplate,
    createdAt: "2025-10-03T17:22:39.773Z",
    updatedAt: "2025-10-21T10:00:00.711Z"
  },
  CARRIER_DELAYED_PACKAGE: {
    type: "CARRIER_DELAYED_PACKAGE",
    category: "exception",
    id: "003f8ba8-09f4-496d-a4cf-ba3b359d899f",
    title: "Colis retard\xE9",
    subject: {
      fr: "Votre colis {{shop.name}} pourrait avoir un petit retard.",
      en: "Your {{shop.name}} package might be slightly delayed",
      es: "Tu paquete de {{shop.name}} podr\xEDa tener un poco de retraso",
      it: "Il tuo pacco {{shop.name}} potrebbe essere un po' in ritardo",
      de: "Ihr {{ shop.name }} Paket ist noch unterwegs.",
      nl: "Je {{shop.name}} pakket kan een beetje vertraagd zijn",
      pl: "Dostawa Twojej przesy\u0142ki {{shop.name}} nieco si\u0119 op\xF3\u017Ani",
      da: "Din {{shop.name}} pakke kan potentielt blive en smule forsinket",
      pt: "O seu pacote {{shop.name}} poder\xE1 estar ligeiramente atrasado",
      sv: "Ditt paket fr\xE5n {{shop.name}} kan vara n\xE5got f\xF6rsenat!",
      fi: "{{shop.name}} -pakettisi saattaa my\xF6h\xE4sty\xE4 hieman",
      no: "{{shop.name}}-pakken din kan v\xE6re litt forsinket!",
      bg: "\u0412\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u0435 {{shop.name}} \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 \u043C\u0430\u043B\u043A\u043E \u0434\u0430 \u0441\u0435 \u0437\u0430\u0431\u0430\u0432\u0438",
      cs: "V\xE1\u0161 bal\xEDk {{shop.name}} m\u016F\u017Ee m\xEDt m\xEDrn\xE9 zpo\u017Ed\u011Bn\xED",
      hu: "El\u0151fordulhat, hogy az \xD6n {{shop.name}} csomagja kicsit k\xE9sik",
      sk: "V\xE1\u0161 {{shop.name}} bal\xEDk sa m\xF4\u017Ee mierne oneskori\u0165",
      zh: "\u60A8\u7684{{shop.name}}\u5305\u88F9\u53EF\u80FD\u4F1A\u7A0D\u6709\u5EF6\u8FDF",
      ja: "{{shop.name}}\u306E\u8377\u7269\u304C\u5C11\u3057\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059"
    },
    preview: {
      fr: "Votre colis {{shop.name}} pourrait avoir un petit retard.",
      en: "Your {{shop.name}} package might be slightly delayed",
      es: "Tu paquete de {{shop.name}} podr\xEDa tener un poco de retraso",
      it: "Il tuo pacco {{shop.name}} potrebbe essere un po' in ritardo",
      de: "Ihr {{ shop.name }} Paket ist noch unterwegs.",
      nl: "Je {{shop.name}} pakket kan een beetje vertraagd zijn",
      pl: "Dostawa Twojej przesy\u0142ki {{shop.name}} nieco si\u0119 op\xF3\u017Ani",
      da: "Din {{shop.name}} pakke kan potentielt blive en smule forsinket",
      pt: "O seu pacote {{shop.name}} poder\xE1 estar ligeiramente atrasado",
      sv: "Ditt paket fr\xE5n {{shop.name}} kan vara n\xE5got f\xF6rsenat!",
      fi: "{{shop.name}} -pakettisi saattaa my\xF6h\xE4sty\xE4 hieman",
      no: "{{shop.name}}-pakken din kan v\xE6re litt forsinket!",
      bg: "\u0412\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u0435 {{shop.name}} \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 \u043C\u0430\u043B\u043A\u043E \u0434\u0430 \u0441\u0435 \u0437\u0430\u0431\u0430\u0432\u0438",
      cs: "V\xE1\u0161 bal\xEDk {{shop.name}} m\u016F\u017Ee m\xEDt m\xEDrn\xE9 zpo\u017Ed\u011Bn\xED",
      hu: "El\u0151fordulhat, hogy az \xD6n {{shop.name}} csomagja kicsit k\xE9sik",
      sk: "V\xE1\u0161 {{shop.name}} bal\xEDk sa m\xF4\u017Ee mierne oneskori\u0165",
      zh: "\u60A8\u7684{{shop.name}}\u5305\u88F9\u53EF\u80FD\u4F1A\u7A0D\u6709\u5EF6\u8FDF",
      ja: "{{shop.name}}\u306E\u8377\u7269\u304C\u5C11\u3057\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059"
    },
    content: {
      beforeBlocks: [],
      insideBlocks: [
        {
          id: "7c868707-ee74-4cea-a7da-ac4879188cfe",
          type: "logo",
          alignment: "center",
          properties: {},
          content: null
        },
        {
          id: "dbd98b6f-59d1-494b-9632-e91cafef967b",
          type: "paragraph",
          alignment: "center",
          properties: {},
          content: {
            fr: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS POURRAIT AVOIR UN PETIT RETARD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span></span><span style="font-size: 12px;"> nous informe que votre colis </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">pourrait subir un l\xE9ger retard.&nbsp;Votre commande est toujours en route et vous sera livr\xE9e tr\xE8s prochainement.</span></p>'
            },
            en: {
              html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>YOUR PACKAGE IS ON ITS WAY!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Your package is on its way but could be a bit delayed due to <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. You'll have your order very soon. </p>`
            },
            es: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>PUEDE QUE TU PAQUETE TENGA UN PEQUE\xD1O RETRASO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> nos ha informado que es posible que tu paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> lleve un poco de retraso. \xA1Pero no te preocupes <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span> ! A\xFAn est\xE1 en camino y te llegar\xE1 muy pronto.</p>'
            },
            it: {
              html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>IL TUO ORDINE POTREBBE ESSERE UN PO' IN RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> ci ha indicato che il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> potrebbe essere in ritardo. Non ti preoccupare <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>! L'ordine \xE8 ancora in transito ma verr\xE0 consegnato a breve.</p>`
            },
            de: {
              html: `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>Ihr <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> Paket ist noch unterwegs.</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hat uns \xFCber ein Problem bei der Zustellung Ihres <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> Pakets informiert. Es wird mit etwas  Versp\xE4tung bei Ihnen eintreffen. Sie erhalten weitere Informationen zu der Zustellung, indem Sie auf 'Meine Lieferung verfolgen' klicken.</p>`
            },
            nl: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>JE PAKKET IS ONDERWEG!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Je pakket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is onderweg, maar kan een beetje vertraagd zijn. Geen zorgen, het zal zo snel mogelijk bezorgd worden!</p>'
            },
            pl: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>TWOJA PACZKA JEST JU\u017B W DRODZE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Twoja przesy\u0142ka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> jest w drodze, ale dostawa realizowana przez <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> mo\u017Ce si\u0119 nieco op\xF3\u017Ani\u0107. Nie martw si\u0119, <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>! Przesy\u0142ka dotrze do Ciebie ju\u017C nied\u0142ugo!</p>'
            },
            da: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>DIN PAKKE ER P\xC5 VEJ!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> pakke er p\xE5 vej til dig - den kan potentielt v\xE6re en smule forsinket af <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Bare rolig <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>! Du vil have din pakke i h\xE6nde meget snart!</p>'
            },
            pt: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>O SEU PACOTE EST\xC1 A CAMINHO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">O seu pacote est\xE1 a caminho, mas pode sofrer um ligeiro atraso devido \xE0 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Ter\xE1 a sua encomenda em breve. </p>'
            },
            sv: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>DITT PAKET \xC4R P\xC5 V\xC4G!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Ditt paket \xE4r p\xE5 v\xE4g men kan vara lite f\xF6rsenat p\xE5 grund av <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Du f\xE5r din best\xE4llning mycket snart. </p>'
            },
            fi: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>PAKETTISI ON MATKALLA!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Pakettisi on matkalla luoksesi, mutta se voi olla hieman my\xF6h\xE4ss\xE4 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> -kuriirista johtuvista syist\xE4. Saat tilauspakettisi pian. </p>'
            },
            no: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>PAKKEN DIN ER P\xC5 VEI!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Pakken din er p\xE5 vei, men kan v\xE6re litt forsinket p\xE5 grunn av <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Du f\xE5r bestillingen din snart. </p>'
            },
            bg: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u041D\u0410 \u041F\u042A\u0422!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 \u0435 \u043D\u0430 \u043F\u044A\u0442, \u043D\u043E \u0435 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043B\u0435\u043A\u043E \u0434\u0430 \u0441\u0435 \u0437\u0430\u0431\u0430\u0432\u0438 \u043F\u043E\u0440\u0430\u0434\u0438 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. \u0429\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u0441\u0438 \u0441\u044A\u0432\u0441\u0435\u043C \u0441\u043A\u043E\u0440\u043E. </p>'
            },
            cs: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>BAL\xCDK JE NA CEST\u011A!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Bal\xEDk je na cest\u011B, ale m\u016F\u017Ee se trochu zpozdit z d\u016Fvodu: <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Objedn\xE1vku obdr\u017E\xEDte u\u017E brzy. </p>'
            },
            hu: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>A CSOMAGJA M\xC1R \xDATON VAN!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Az \xD6n csomagja \xFAton van, de a(z) <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> t\xE9ved\xE9se miatt egy kicsit k\xE9shet. Hamarosan megkapja a rendel\xE9s\xE9t. </p>'
            },
            sk: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>V\xC1\u0160 BAL\xCDK JE NA CESTE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">V\xE1\u0161 bal\xEDk je na ceste, ale m\xF4\u017Ee sa trochu oneskori\u0165 kv\xF4li <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Objedn\xE1vku dostanete u\u017E \u010Doskoro. </p>'
            },
            zh: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>\u60A8\u7684\u5305\u88F9\u53EF\u80FD\u4F1A\u7A0D\u6709\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u60A8\u7684\u5305\u88F9\u6B63\u5728\u8FD0\u9001\u4E2D\uFF0C\u4F46\u7531\u4E8E <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u7684\u539F\u56E0\u53EF\u80FD\u4F1A\u7A0D\u6709\u5EF6\u8FDF\u3002\u60A8\u5F88\u5FEB\u5C31\u4F1A\u6536\u5230\u60A8\u7684\u8BA2\u5355\u3002</p>'
            },
            ja: {
              html: '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>\u8377\u7269\u304C\u5C11\u3057\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u8377\u7269\u306F\u914D\u9001\u4E2D\u3067\u3059\u304C\u3001<span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u306E\u90FD\u5408\u306B\u3088\u308A\u5C11\u3057\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u307E\u3082\u306A\u304F\u304A\u5C4A\u3051\u3044\u305F\u3057\u307E\u3059\u3002</p>'
            }
          }
        },
        {
          id: "c628fa0b-57cd-4f23-b10a-75cf3d17ab8a",
          type: "button",
          alignment: "center",
          properties: {
            variant: "outline"
          },
          content: {
            fr: {
              text: "Suivre mon colis",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            en: {
              text: "Track my package",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            es: {
              text: "Seguir mi paquete",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            it: {
              text: "Segui il mio pacco",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            de: {
              text: "Mein Paket verfolgen",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            nl: {
              text: "Mijn pakket volgen",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            pl: {
              text: "\u015Aled\u017A moj\u0105 paczk\u0119",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            da: {
              text: "Spor min pakke",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            pt: {
              text: "Acompanhar a minha encomenda",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            sv: {
              text: "Sp\xE5ra mitt paket",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            fi: {
              text: "Seuraa pakettiani",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            no: {
              text: "Spor pakken min",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            bg: {
              text: "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u0438 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u043C\u0438",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            cs: {
              text: "Sledovat m\u016Fj bal\xEDk",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            hu: {
              text: "K\xF6vesd a csomagomat",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            sk: {
              text: "Sledova\u0165 m\xF4j bal\xEDk",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            zh: {
              text: "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            },
            ja: {
              text: "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
              href: "https://track.baback.co/tracking/{{parcel.trackingId}}"
            }
          }
        },
        {
          id: "ec6a97ac-fc83-4310-a4fb-900e14c76150",
          type: "delivery-address",
          alignment: "center",
          properties: {},
          content: null
        },
        {
          type: "package-content",
          alignment: "center",
          properties: {},
          id: "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
          content: null
        }
      ],
      afterBlocks: [
        {
          id: "ff47b487-ca85-40b6-a852-3fe952989749",
          type: "social-networks",
          alignment: "center",
          properties: {},
          content: null
        }
      ],
      defaultLocale: "en"
    },
    createdAt: "2025-10-03T17:24:51.372Z",
    updatedAt: "2025-10-21T09:57:08.170Z"
  },
  DELAYED_PACKAGE: {
    type: "DELAYED_PACKAGE",
    category: "transit",
    id: "003f8ba8-09f4-496d-a4cf-ba3b359d899f",
    title: "2.4 Retard mod\xE9r\xE9 d\xE9tect\xE9",
    subject: delayedPackageEmailTemplateSubject,
    preview: delayedPackageEmailTemplateSubject,
    content: delayedPackageEmailTemplate,
    createdAt: "2025-10-03T17:24:51.372Z",
    updatedAt: "2025-10-21T09:57:08.170Z"
  },
  DELAYED_PACKAGE_SEVERE: {
    type: "DELAYED_PACKAGE_SEVERE",
    category: "transit",
    id: "439c6c6d-ba60-44d5-b753-7d45bad16722",
    title: "2.5 Retard important d\xE9tect\xE9",
    subject: delayedPackageSevereEmailTemplateSubject,
    preview: delayedPackageSevereEmailTemplateSubject,
    content: delayedPackageSevereEmailTemplate,
    createdAt: "2025-10-03T17:27:43.514Z",
    updatedAt: "2025-10-21T10:01:27.944Z"
  },
  COLLECTED_AT_PICKUP: {
    type: "COLLECTED_AT_PICKUP",
    category: "delivery",
    id: "4fbf82a8-34ba-4439-81ce-e2496247ebf1",
    title: "3.9 Colis r\xE9cup\xE9r\xE9 par le client",
    subject: collectedAtPickupEmailTemplateSubject,
    preview: collectedAtPickupEmailTemplateSubject,
    content: collectedAtPickupEmailTemplate,
    createdAt: "2025-10-03T17:31:10.661Z",
    updatedAt: "2025-10-21T09:57:45.020Z"
  },
  OUT_FOR_DELIVERY: {
    type: "OUT_FOR_DELIVERY",
    category: "delivery",
    id: "97b441c6-3447-4cb0-bdfd-0dc8922a30af",
    title: "3.1 Livraison pr\xE9vue aujourd\u2019hui",
    subject: outForDeliveryEmailTemplateSubject,
    preview: outForDeliveryEmailTemplateSubject,
    content: outForDeliveryEmailTemplate,
    createdAt: "2025-10-03T17:09:42.080Z",
    updatedAt: "2025-10-21T10:05:39.024Z"
  },
  CUSTOMS_CLEARANCE_COMPLETE: {
    type: "CUSTOMS_CLEARANCE_COMPLETE",
    category: "transit",
    id: "e7f5ad8a-ae19-4d03-9237-c93494a5daa6",
    title: "2.3 Proc\xE9dure douani\xE8re termin\xE9e",
    subject: customsClearanceCompleteEmailTemplateSubject,
    preview: customsClearanceCompleteEmailTemplateSubject,
    content: customsClearanceCompleteEmailTemplate,
    createdAt: "2025-10-03T17:23:02.237Z",
    updatedAt: "2025-10-21T09:59:43.580Z"
  },
  AVAILABLE_FOR_PICKUP: {
    type: "AVAILABLE_FOR_PICKUP",
    category: "delivery",
    id: "1fc78cdd-fd41-4af8-847e-f5191b682054",
    title: "3.4 Colis disponible en point de retrait",
    subject: availableForPickupEmailTemplateSubject,
    preview: availableForPickupEmailTemplateSubject,
    content: availableEmailTemplate,
    createdAt: "2025-10-03T17:29:55.604Z",
    updatedAt: "2025-10-21T09:59:30.425Z"
  },
  REDIRECT_TO_PICKUP: {
    type: "REDIRECT_TO_PICKUP",
    category: "delivery",
    id: "1fc78cdd-fd41-4af8-847e-f5191b682054",
    title: "3.3 Colis d\xE9pos\xE9 en point de retrait",
    subject: redirectToPickupEmailTemplateSubject,
    preview: redirectToPickupEmailTemplateSubject,
    content: redirectToPickupEmailTemplate,
    createdAt: "2025-10-03T17:29:55.604Z",
    updatedAt: "2025-10-21T09:59:30.425Z"
  },
  DELIVERED: {
    type: "DELIVERED",
    category: "delivery",
    id: "45253563-6091-40ef-851a-b5955c1813f6",
    title: "3.7 Colis livr\xE9 au destinataire",
    subject: deliveredEmailTemplateSubject,
    preview: deliveredEmailTemplateSubject,
    content: deliveredEmailTemplate,
    createdAt: "2025-10-03T17:14:36.052Z",
    updatedAt: "2025-10-21T10:03:09.998Z"
  },
  DELIVERED_TO_NEIGHBOUR: {
    type: "DELIVERED_TO_NEIGHBOUR",
    category: "delivery",
    id: "7b16cf6b-51a1-4010-b832-e3d966e0b597",
    title: "3.9.1 Colis remis \xE0 un tiers autoris\xE9",
    subject: deliveredToNeighbourEmailTemplateSubject,
    preview: deliveredToNeighbourEmailTemplateSubject,
    content: deliveredToNeighbourEmailTemplate,
    createdAt: "2025-10-03T17:16:11.820Z",
    updatedAt: "2025-10-21T10:03:26.709Z"
  },
  WAITING_AT_PICKUP_POINT: {
    type: "WAITING_AT_PICKUP_POINT",
    category: "delivery",
    id: "31e517e3-49be-45ad-afa1-db857fe02052",
    title: "3.5 Colis en point de retrait depuis plusieurs jours",
    subject: waitingAtPickupEmailTemplateSubject,
    preview: waitingAtPickupEmailTemplateSubject,
    content: waitingAtPickupEmailTemplate,
    createdAt: "2025-10-03T17:21:12.900Z",
    updatedAt: "2025-10-21T10:09:46.709Z"
  },
  IN_TRANSIT: {
    type: "IN_TRANSIT",
    category: "transit",
    id: "52c7b794-4a97-4830-906e-c5cd316b1a95",
    title: "2.1 Colis pris en charge par le transporteur",
    subject: inTransitEmailTemplateSubject,
    preview: inTransitEmailTemplateSubject,
    content: inTransitEmailTemplate,
    createdAt: "2025-10-03T17:08:49.049Z",
    updatedAt: "2025-10-21T10:04:24.949Z"
  },
  EXCEPTION: {
    type: "EXCEPTION",
    category: "exception",
    id: "958aabd9-07ea-46c2-881c-5a96ae397d99",
    title: "4.1 Incident d\u2019acheminement compromettant la livraison",
    subject: exceptionEmailTemplateSubject,
    preview: exceptionEmailTemplateSubject,
    content: exceptionEmailTemplate,
    createdAt: "2025-10-03T17:23:57.721Z",
    updatedAt: "2025-10-21T10:04:04.056Z"
  },
  DELIVERY_ATTEMPTED: {
    type: "DELIVERY_ATTEMPTED",
    category: "delivery",
    id: "958aabd9-07ea-46c2-881c-5a96ae397d99",
    title: "3.2 Premi\xE8re tentative de livraison \xE9chou\xE9e",
    subject: deliveryAttemptedEmailTemplateSubject,
    preview: deliveryAttemptedEmailTemplateSubject,
    content: deliveryAttemptedEmailTemplate,
    createdAt: "2025-10-03T17:23:57.721Z",
    updatedAt: "2025-10-21T10:04:04.056Z"
  },
  DISPATCHED_TO_OTHER_PICKUP_POINT: {
    type: "DISPATCHED_TO_OTHER_PICKUP_POINT",
    category: "delivery",
    id: "3ba43fb5-add1-4ebd-9b82-1b47302695f8",
    title: "3.8 Colis livr\xE9 dans un autre point de retrait",
    subject: dispatchedToOtherPickupPointEmailTemplateSubject,
    preview: dispatchedToOtherPickupPointEmailTemplateSubject,
    content: dispatchedToOtherPickupPointEmailTemplate,
    createdAt: "2025-10-03T17:26:18.188Z",
    updatedAt: "2025-10-21T10:03:49.956Z"
  },
  RETURNED_TO_SENDER: {
    type: "RETURNED_TO_SENDER",
    category: "exception",
    id: "1b1fb0f5-7826-4e98-bdeb-c874c15c0163",
    title: "4 Colis retourn\xE9 \xE0 l\u2019exp\xE9diteur",
    subject: returnedToSenderEmailTemplateSubject,
    preview: returnedToSenderEmailTemplateSubject,
    content: returnedToSenderEmailTemplate,
    createdAt: "2025-10-03T17:17:26.552Z",
    updatedAt: "2025-10-21T10:06:39.363Z"
  },
  WAITING_AT_PICKUP_POINT_SEVERE: {
    type: "WAITING_AT_PICKUP_POINT_SEVERE",
    category: "delivery",
    id: "ed88ea6d-e4da-40e7-9312-f01409c4f97e",
    title: "3.6 Colis en point de retrait en fin de disponibilit\xE9",
    subject: waitingAtPickupSevereEmailTemplateSubject,
    preview: waitingAtPickupSevereEmailTemplateSubject,
    content: waitingAtPickupSevereEmailTemplate,
    createdAt: "2025-10-03T17:21:33.681Z",
    updatedAt: "2025-10-21T09:22:17.619Z"
  },
  WAITING_INFORMATION_FROM_ADDRESS: {
    type: "WAITING_INFORMATION_FROM_ADDRESS",
    category: "delivery",
    id: "ed88ea6d-e4da-40e7-9312-f01409c4f4e6",
    title: "3 Informations compl\xE9mentaires requises",
    preview: waitingInformationFromAddressEmailTemplateSubject,
    subject: waitingInformationFromAddressEmailTemplateSubject,
    content: waitingInformationFromAddressEmailTemplate,
    createdAt: "2025-10-03T17:23:57.721Z",
    updatedAt: "2025-10-21T10:04:04.056Z"
  },
  ORDER_NOT_FULFILLED: {
    type: "ORDER_NOT_FULFILLED",
    id: "order-not-fulfilled-default-template",
    title: "Order Not Fulfilled",
    subject: orderNotFulfilledEmailTemplateSubject,
    preview: orderNotFulfilledEmailTemplateSubject,
    content: orderNotFulfilledEmailTemplate,
    createdAt: "2025-11-25T15:00:00.000Z",
    updatedAt: "2025-11-25T15:00:00.000Z"
  }
};
var default_templates_default = defaultTemplates;

// src/lib/tracking/get-default-template.ts
var defaultEmailTemplates = default_templates_default;
var getDefaultTemplate = (status) => {
  return defaultEmailTemplates[status];
};

// src/templates/tracking-v2/types.ts
var TRACKING_V2_CATEGORIES = [
  "general",
  "incident",
  "delivery"
];

// src/templates/tracking-v2/designs.ts
var trackingV2Designs = {
  "general": {
    "beforeBlocks": [],
    "insideBlocks": [
      {
        "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
        "type": "logo",
        "alignment": "center",
        "properties": {},
        "content": null
      },
      {
        "id": "a1b2c3d4-0001-4a00-8000-000000000001",
        "type": "dynamic-text",
        "alignment": "center",
        "properties": {},
        "content": {}
      },
      {
        "id": "32a8f947-3013-4309-9d90-13953a4e2534",
        "type": "estimated-delivery-date",
        "alignment": "center",
        "properties": {},
        "content": null
      },
      {
        "id": "12818071-aad6-41c5-be86-968fdb3d31db",
        "type": "button",
        "alignment": "center",
        "properties": {
          "variant": "outline"
        },
        "content": {
          "fr": {
            "text": "Suivre mon colis",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "en": {
            "text": "Track my package",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "es": {
            "text": "Seguir mi paquete",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "de": {
            "text": "Mein Paket verfolgen",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "it": {
            "text": "Traccia il mio pacco",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "pt": {
            "text": "Rastrear meu pacote",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "nl": {
            "text": "Volg mijn pakket",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "sv": {
            "text": "Sp\xE5ra mitt paket",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "fi": {
            "text": "Seuraa pakettiani",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "no": {
            "text": "Spor pakken min",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "da": {
            "text": "Spor min pakke",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "pl": {
            "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "cs": {
            "text": "Sledovat m\u016Fj bal\xEDk",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "sk": {
            "text": "Sledova\u0165 m\xF4j bal\xEDk",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "hu": {
            "text": "K\xF6vesd a csomagom",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "bg": {
            "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "zh": {
            "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "ja": {
            "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          }
        }
      },
      {
        "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
        "type": "separator",
        "alignment": "center",
        "properties": {
          "spacing": "small"
        },
        "content": null
      },
      {
        "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
        "type": "delivery-address",
        "alignment": "center",
        "properties": {},
        "content": null
      },
      {
        "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
        "type": "separator",
        "alignment": "center",
        "properties": {
          "spacing": "small"
        },
        "content": null
      },
      {
        "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
        "type": "paragraph",
        "alignment": "left",
        "properties": {},
        "content": {
          "fr": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
          },
          "en": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contents of your order</u></strong></span></p>'
          },
          "es": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido de su pedido</u></strong></span></p>'
          },
          "de": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhalt Ihrer Bestellung</u></strong></span></p>'
          },
          "it": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto del tuo ordine</u></strong></span></p>'
          },
          "pt": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do seu pedido</u></strong></span></p>'
          },
          "nl": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van uw bestelling</u></strong></span></p>'
          },
          "sv": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inneh\xE5ll i din best\xE4llning</u></strong></span></p>'
          },
          "fi": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilauksesi sis\xE4lt\xF6</u></strong></span></p>'
          },
          "no": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Innholdet i bestillingen din</u></strong></span></p>'
          },
          "da": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Indholdet af din ordre</u></strong></span></p>'
          },
          "pl": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
          },
          "hu": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9sed tartalma</u></strong></span></p>'
          },
          "sk": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161ej objedn\xE1vky</u></strong></span></p>'
          },
          "cs": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah va\u0161\xED objedn\xE1vky</u></strong></span></p>'
          },
          "bg": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430</u></strong></span></p>'
          },
          "zh": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u60A8\u7684\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
          },
          "ja": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
          }
        }
      },
      {
        "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
        "type": "package-content",
        "alignment": "center",
        "properties": {},
        "content": null
      }
    ],
    "afterBlocks": [
      {
        "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
        "type": "wallet",
        "alignment": "center",
        "properties": {},
        "content": null
      },
      {
        "id": "ff47b487-ca85-40b6-a852-3fe952989749",
        "type": "social-networks",
        "alignment": "center",
        "properties": {},
        "content": null
      }
    ]
  },
  "incident": {
    "beforeBlocks": [],
    "insideBlocks": [
      {
        "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
        "type": "logo",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      },
      {
        "id": "a1b2c3d4-0002-4a00-8000-000000000002",
        "type": "dynamic-text",
        "alignment": "center",
        "properties": {},
        "content": {}
      },
      {
        "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
        "type": "separator",
        "alignment": "center",
        "font": null,
        "properties": {
          "spacing": "small"
        },
        "content": null
      },
      {
        "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
        "type": "delivery-address",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      },
      {
        "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
        "type": "separator",
        "alignment": "center",
        "font": null,
        "properties": {
          "spacing": "small"
        },
        "content": null
      },
      {
        "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
        "type": "paragraph",
        "alignment": "left",
        "font": null,
        "properties": {},
        "content": {
          "fr": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
          },
          "en": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
          },
          "es": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
          },
          "de": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
          },
          "it": {
            "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
          },
          "pt": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
          },
          "nl": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
          },
          "sv": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
          },
          "fi": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
          },
          "no": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
          },
          "da": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
          },
          "pl": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
          },
          "cs": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
          },
          "sk": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
          },
          "hu": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
          },
          "bg": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
          },
          "zh": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
          },
          "ja": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
          }
        }
      },
      {
        "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
        "type": "package-content",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      },
      {
        "id": "a3aaaf52-59fe-4eb1-b29d-ae5e14e77755",
        "type": "button",
        "alignment": "center",
        "font": null,
        "properties": {
          "variant": "outline"
        },
        "content": {
          "fr": {
            "text": "Suivre mon colis",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "en": {
            "text": "Track my package",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "es": {
            "text": "Seguir mi paquete",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "de": {
            "text": "Mein Paket verfolgen",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "it": {
            "text": "Traccia il mio pacco",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "pt": {
            "text": "Rastrear meu pacote",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "nl": {
            "text": "Volg mijn pakket",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "sv": {
            "text": "Sp\xE5ra mitt paket",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "fi": {
            "text": "Seuraa pakettiani",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "no": {
            "text": "Spor pakken min",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "da": {
            "text": "Spor min pakke",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "pl": {
            "text": "\u015Aled\u017A moj\u0105 paczk\u0119",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "cs": {
            "text": "Sledovat m\u016Fj bal\xEDk",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "sk": {
            "text": "Sledova\u0165 m\xF4j bal\xEDk",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "hu": {
            "text": "K\xF6vesd a csomagom",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "bg": {
            "text": "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "zh": {
            "text": "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          },
          "ja": {
            "text": "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B",
            "href": "https://track.baback.co/tracking/{{parcel.trackingId}}"
          }
        }
      }
    ],
    "afterBlocks": [
      {
        "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
        "type": "wallet",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      },
      {
        "id": "ff47b487-ca85-40b6-a852-3fe952989749",
        "type": "social-networks",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      }
    ]
  },
  "delivery": {
    "beforeBlocks": [],
    "insideBlocks": [
      {
        "id": "7c868707-ee74-4cea-a7da-ac4879188cfe",
        "type": "logo",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      },
      {
        "id": "a1b2c3d4-0003-4a00-8000-000000000003",
        "type": "dynamic-text",
        "alignment": "center",
        "properties": {},
        "content": {}
      },
      {
        "id": "7311505a-9473-49c0-86c8-84e9d2acb005",
        "type": "separator",
        "alignment": "center",
        "font": null,
        "properties": {
          "spacing": "small"
        },
        "content": null
      },
      {
        "id": "ec6a97ac-fc83-4310-a4fb-900e14c76150",
        "type": "delivery-address",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      },
      {
        "id": "4d8ee488-a9f7-4e4e-b178-d88aa6d16192",
        "type": "separator",
        "alignment": "center",
        "font": null,
        "properties": {
          "spacing": "small"
        },
        "content": null
      },
      {
        "id": "eefab7df-61d1-4be8-a549-5dafcc24b7a0",
        "type": "paragraph",
        "alignment": "left",
        "font": null,
        "properties": {},
        "content": {
          "fr": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenu de votre commande</u></strong></span></p>'
          },
          "en": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Order Contents</u></strong></span></p>'
          },
          "es": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenido del pedido</u></strong></span></p>'
          },
          "de": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestellinhalt</u></strong></span></p>'
          },
          "it": {
            "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Contenuto dell'ordine</u></strong></span></p>`
          },
          "pt": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Conte\xFAdo do pedido</u></strong></span></p>'
          },
          "nl": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Inhoud van de bestelling</u></strong></span></p>'
          },
          "sv": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Best\xE4llningsinneh\xE5ll</u></strong></span></p>'
          },
          "fi": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Tilaussis\xE4lt\xF6</u></strong></span></p>'
          },
          "no": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Bestillingsinnhold</u></strong></span></p>'
          },
          "da": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Ordreindhold</u></strong></span></p>'
          },
          "pl": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Zawarto\u015B\u0107 zam\xF3wienia</u></strong></span></p>'
          },
          "cs": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
          },
          "sk": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Obsah objedn\xE1vky</u></strong></span></p>'
          },
          "hu": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>Rendel\xE9s tartalma</u></strong></span></p>'
          },
          "bg": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430</u></strong></span></p>'
          },
          "zh": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u8BA2\u5355\u5185\u5BB9</u></strong></span></p>'
          },
          "ja": {
            "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong><u>\u3054\u6CE8\u6587\u306E\u5185\u5BB9</u></strong></span></p>'
          }
        }
      },
      {
        "id": "7ab95221-79b3-4c7b-b90a-a8ab55c239a6",
        "type": "package-content",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      },
      {
        "id": "a9a6e8d3-0b7b-4c7b-9f3c-5f8e1c9e7abd",
        "type": "separator",
        "alignment": "center",
        "font": null,
        "properties": {
          "spacing": "small"
        },
        "content": null
      },
      {
        "id": "c5a0e2f1-7b3d-4e8a-9c6f-2d1b8e3a5c7f",
        "type": "paragraph",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": {
          "fr": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\xC9valuez votre livraison</p>'
          },
          "en": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Rate your delivery</p>'
          },
          "es": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Califica tu entrega</p>'
          },
          "de": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Bewerten Sie Ihre Lieferung</p>'
          },
          "it": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Valuta la consegna</p>'
          },
          "pt": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Avalie sua entrega</p>'
          },
          "nl": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Beoordeel je bezorging</p>'
          },
          "sv": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Betygs\xE4tt din leverans</p>'
          },
          "fi": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Arvioi toimituksesi</p>'
          },
          "no": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Vurder leveringen din</p>'
          },
          "da": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Bed\xF8m din levering</p>'
          },
          "pl": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Oce\u0144 swoj\u0105 dostaw\u0119</p>'
          },
          "cs": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Ohodno\u0165te sv\xE9 doru\u010Den\xED</p>'
          },
          "sk": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">Ohodno\u0165te svoje doru\u010Denie</p>'
          },
          "hu": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\xC9rt\xE9kelje a k\xE9zbes\xEDt\xE9st</p>'
          },
          "bg": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u041E\u0446\u0435\u043D\u0435\u0442\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430</p>'
          },
          "zh": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u8BC4\u4EF7\u60A8\u7684\u914D\u9001</p>'
          },
          "ja": {
            "html": '<p style="font-size: 14px; font-weight: 600; margin: 0px; padding: 0px;">\u914D\u9001\u3092\u8A55\u4FA1\u3059\u308B</p>'
          }
        }
      },
      {
        "id": "16d2dad6-5f60-4c22-b59a-0c3b0f5e1a4c",
        "type": "rate-order",
        "alignment": "center",
        "font": null,
        "properties": null,
        "content": null
      }
    ],
    "afterBlocks": [
      {
        "id": "25fe0aff-48fa-431e-9f35-32f30358b3fc",
        "type": "wallet",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      },
      {
        "id": "ff47b487-ca85-40b6-a852-3fe952989749",
        "type": "social-networks",
        "alignment": "center",
        "font": null,
        "properties": {},
        "content": null
      }
    ]
  }
};

// src/templates/tracking-v2/status-content.ts
var trackingV2StatusContent = {
  "PRE_TRANSIT": {
    "category": "general",
    "subject": {
      "fr": "Votre commande {{shop.name}} : l\u2019\xE9tiquette est g\xE9n\xE9r\xE9e et le suivi d\xE9marre.",
      "en": "The order is at the departure warehouse",
      "es": "El pedido est\xE1 en el almac\xE9n de salida",
      "it": "L'ordine \xE8 nel magazzino di partenza",
      "de": "Die Bestellung befindet sich im Ausgangslager",
      "nl": "De bestelling is in het vertrekmagazijn",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "O pedido est\xE1 no armaz\xE9m de partida",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "\u8BA2\u5355\u5DF2\u5728\u53D1\u8D27\u4ED3\u5E93\u5F85\u53D1",
      "ja": "\u3054\u6CE8\u6587\u306F\u51FA\u8377\u5009\u5EAB\u306B\u3066\u6E96\u5099\u4E2D\u3067\u3059"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE EST PR\xCATE POUR L'EXP\xC9DITION</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est pr\xEAte ! </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Elle sera bient\xF4t prise en charge par le transporteur.&nbsp;</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER IS READY FOR SHIPPING</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is ready!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">It will soon be handled by the carrier.&nbsp;</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO EST\xC1 LISTO PARA EL ENV\xCDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 listo!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pronto ser\xE1 gestionado por el transportista.&nbsp;</span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE \xC8 PRONTO PER LA SPEDIZIONE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 pronto!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Sar\xE0 presto gestito dal corriere.&nbsp;</span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG IST VERSANDBEREIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ist bereit!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Es wird bald vom Spediteur bearbeitet.&nbsp;</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW BESTELLING IS KLAAR VOOR VERZENDING</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, uw bestelling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is klaar!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Het zal binnenkort door de vervoerder worden afgehandeld.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO EST\xC1 PRONTO PARA ENVIO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 pronto!</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Em breve ser\xE1 tratado pelo transportador.&nbsp;</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u51C6\u5907\u597D\u53D1\u8D27</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u5DF2\u51C6\u5907\u597D\uFF01</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u627F\u8FD0\u5546\u5C06\u5F88\u5FEB\u5904\u7406\u3002&nbsp;</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306F\u767A\u9001\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306E\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\uFF01</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u307E\u3082\u306A\u304F\u914D\u9001\u696D\u8005\u304C\u5BFE\u5FDC\u3044\u305F\u3057\u307E\u3059\u3002&nbsp;</span></p>'
      }
    }
  },
  "IN_TRANSIT": {
    "category": "general",
    "subject": {
      "fr": "Bonne nouvelle : votre colis {{shop.name}} est d\xE9sormais en cours d'acheminement. ",
      "en": "Good news: your {{shop.name}} package is now in transit.",
      "es": "Buenas noticias: su paquete {{shop.name}} est\xE1 en tr\xE1nsito.",
      "it": "Buone notizie: il tuo pacco {{shop.name}} \xE8 ora in transito.",
      "de": "Gute Nachrichten: Ihr {{shop.name}} Paket ist jetzt unterwegs.",
      "nl": "Goed nieuws: je {{shop.name}} pakket is nu onderweg.",
      "pl": "Dobre wie\u015Bci: Twoja paczka {{shop.name}} jest ju\u017C w drodze.",
      "da": "Gode nyheder: din {{shop.name}} pakke er nu p\xE5 vej.",
      "pt": "Boas not\xEDcias: seu pacote {{shop.name}} est\xE1 em tr\xE2nsito.",
      "sv": "Goda nyheter: ditt {{shop.name}} paket \xE4r nu p\xE5 v\xE4g.",
      "fi": "Hyvi\xE4 uutisia: {{shop.name}}-pakettisi on nyt matkalla.",
      "no": "Gode nyheter: {{shop.name}}-pakken din er n\xE5 p\xE5 vei.",
      "bg": "\u0414\u043E\u0431\u0440\u0438 \u043D\u043E\u0432\u0438\u043D\u0438: \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0435\u0447\u0435 \u0435 \u0432 \u0442\u0440\u0430\u043D\u0437\u0438\u0442.",
      "cs": "Dobr\xE9 zpr\xE1vy: v\xE1\u0161 bal\xED\u010Dek {{shop.name}} je nyn\xED na cest\u011B.",
      "hu": "J\xF3 h\xEDr: a(z) {{shop.name}} csomagod most m\xE1r \xFAton van.",
      "sk": "Dobr\xE9 spr\xE1vy: v\xE1\u0161 bal\xEDk {{shop.name}} je teraz na ceste.",
      "zh": "\u597D\u6D88\u606F\uFF1A\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5DF2\u53D1\u51FA\uFF0C\u6B63\u5728\u8FD0\u8F93\u4E2D\u3002",
      "ja": "{{shop.name}} \u306E\u8377\u7269\u304C\u767A\u9001\u3055\u308C\u307E\u3057\u305F\u3002\u73FE\u5728\u914D\u9001\u4E2D\u3067\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST EN COURS D'ACHEMINEMENT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est d\xE9sormais dans les mains du transporteur <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous vous tiendrons inform\xE9(e) de son acheminement.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS IN TRANSIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is now in the hands of the carrier <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We will keep you informed of its progress.</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE EST\xC1 EN TR\xC1NSITO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 ahora en manos del transportista <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Le mantendremos informado de su progreso.</span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 IN TRANSITO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 ora nelle mani del corriere <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Ti terremo informato sui suoi progressi.</span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHR PAKET IST UNTERWEGS</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ist jetzt in den H\xE4nden des Spediteurs <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir werden Sie \xFCber den Fortschritt informieren.</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET IS ONDERWEG</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, je bestelling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is nu in handen van de vervoerder <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We houden je op de hoogte van de voortgang.</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST W DRODZE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Twoje zam\xF3wienie <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> jest teraz w r\u0119kach przewo\u017Anika <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">B\u0119dziemy Ci\u0119 informowa\u0107 o jego post\u0119pach.</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER P\xC5 VEJ</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din ordre <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er nu i h\xE6nderne p\xE5 transport\xF8ren <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi vil holde dig informeret om dens fremskridt.</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 EM TR\xC2NSITO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 agora nas m\xE3os do transportador <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Iremos mant\xEA-lo informado sobre o progresso.</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET \xC4R P\xC5 V\xC4G</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din best\xE4llning <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE4r nu i h\xE4nderna p\xE5 transport\xF6ren <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi kommer att h\xE5lla dig informerad om dess framsteg.</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON MATKALLA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, tilauksesi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> on nyt kuljettajan k\xE4siss\xE4 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4.</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER P\xC5 VEI</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, bestillingen din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er n\xE5 i hendene p\xE5 transport\xF8ren <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi vil holde deg informert om fremdriften.</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u0412 \u0422\u0420\u0410\u041D\u0417\u0418\u0422</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u0432\u0435\u0447\u0435 \u0435 \u0432 \u0440\u044A\u0446\u0435\u0442\u0435 \u043D\u0430 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u043C\u0443.</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCD\u010CEK JE NA CEST\u011A</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161e objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je nyn\xED v rukou dopravce <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Budeme v\xE1s informovat o jeho postupu.</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGOD \xDATON VAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a rendel\xE9sed <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> most a sz\xE1ll\xEDt\xF3 kez\xE9ben van <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l.</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE NA CESTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161a objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je teraz v ruk\xE1ch dopravcu <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Budeme v\xE1s informova\u0165 o jeho priebehu.</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u6B63\u5728\u8FD0\u8F93\u4E2D</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u73B0\u5728\u7531\u627F\u8FD0\u5546\u5904\u7406 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u6211\u4EEC\u5C06\u968F\u65F6\u901A\u77E5\u60A8\u8FDB\u5C55\u3002</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306F\u914D\u9001\u4E2D\u3067\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306F\u914D\u9001\u696D\u8005\u304C\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u3059 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u9032\u6357\u3092\u968F\u6642\u304A\u77E5\u3089\u305B\u3044\u305F\u3057\u307E\u3059\u3002</span></p>'
      }
    }
  },
  "OUT_FOR_DELIVERY": {
    "category": "general",
    "subject": {
      "fr": "Votre colis {{shop.name}} entrera en livraison aujourd\u2019hui et arrive tr\xE8s bient\xF4t.",
      "en": "Your order is on its way",
      "es": "Su pedido est\xE1 en camino",
      "it": "Il tuo ordine \xE8 in arrivo",
      "de": "Ihre Bestellung ist unterwegs",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "O seu pedido est\xE1 a caminho",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "\u60A8\u7684\u8BA2\u5355\u6B63\u5728\u6D3E\u9001\u4E2D",
      "ja": "\u3054\u6CE8\u6587\u306E\u8377\u7269\u304C\u914D\u9054\u4E2D\u3067\u3059"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE ARRIVE AUJOURD'HUI !</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est dans les mains du livreur de <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong>La date de livraison est planifi\xE9e ce jour.</strong></span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER ARRIVES TODAY!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is in the hands of the delivery person from </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The delivery date is scheduled for today. </span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\xA1SU PEDIDO LLEGA HOY!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 en manos del repartidor de </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nombre del transportista" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nombre del transportista</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">La fecha de entrega est\xE1 programada para hoy. </span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE ARRIVA OGGI!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 nelle mani del corriere di </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nome del corriere" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nome del corriere</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">La data di consegna \xE8 prevista per oggi. </span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG KOMMT HEUTE AN!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ist in den H\xE4nden des Lieferanten von </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Name des Lieferanten" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Name des Lieferanten</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Das Lieferdatum ist f\xFCr heute geplant. </span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO CHEGA HOJE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 nas m\xE3os do entregador de </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nome do transportador" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nome do transportador</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">A data de entrega est\xE1 agendada para hoje. </span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u4ECA\u5929\u9001\u8FBE\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u6B63\u7531\u914D\u9001\u5458\u5904\u7406\uFF0C\u627F\u8FD0\u5546\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u9001\u8FBE\u65E5\u671F\u5B9A\u5728\u4ECA\u5929\u3002 </span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306F\u672C\u65E5\u304A\u5C4A\u3051\u3057\u307E\u3059\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306F\u914D\u9001\u696D\u8005\u306E\u62C5\u5F53\u8005\u304C\u304A\u9810\u304B\u308A\u3057\u3066\u3044\u307E\u3059\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u914D\u9054\u65E5\u306F\u672C\u65E5\u306B\u4E88\u5B9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002 </span></p>'
      }
    }
  },
  "AVAILABLE_FOR_PICKUP": {
    "category": "general",
    "subject": {
      "fr": "Votre colis {{shop.name}} est disponible au point de retrait et pr\xEAt \xE0 \xEAtre r\xE9cup\xE9r\xE9.",
      "en": "Your {{shop.name}} package is available at the pickup point and ready to be collected.",
      "es": "Su paquete {{shop.name}} est\xE1 disponible en el punto de recogida y listo para ser recogido.",
      "it": "Il tuo pacco {{shop.name}} \xE8 disponibile al punto di ritiro e pronto per essere ritirato.",
      "de": "Dein {{shop.name}} Paket ist am Abholpunkt verf\xFCgbar und bereit zur Abholung.",
      "nl": "Je {{shop.name}} pakket is beschikbaar bij het afhaalpunt en klaar om opgehaald te worden.",
      "pl": "Twoja paczka {{shop.name}} jest dost\u0119pna w punkcie odbioru i gotowa do odbioru.",
      "da": "Din {{shop.name}} pakke er tilg\xE6ngelig p\xE5 afhentningsstedet og klar til at blive afhentet.",
      "pt": "O seu pacote {{shop.name}} est\xE1 dispon\xEDvel no ponto de retirada e pronto para ser recolhido.",
      "sv": "Ditt {{shop.name}}-paket \xE4r tillg\xE4ngligt vid upph\xE4mtningsst\xE4llet och redo att h\xE4mtas.",
      "fi": "{{shop.name}}-pakettisi on noudettavissa noutopisteest\xE4 ja valmis noudettavaksi.",
      "no": "{{shop.name}}-pakken din er tilgjengelig p\xE5 hentepunktet og klar til \xE5 bli hentet.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0438 \u0433\u043E\u0442\u043E\u0432\u0430 \u0437\u0430 \u0432\u0437\u0435\u043C\u0430\u043D\u0435.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} je k dispozici na v\xFDdejn\xEDm m\xEDst\u011B a p\u0159ipraven k vyzvednut\xED.",
      "hu": "A {{shop.name}} csomagod el\xE9rhet\u0151 az \xE1tv\xE9teli ponton \xE9s k\xE9szen \xE1ll az \xE1tv\xE9telre.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je k dispoz\xEDcii na v\xFDdajnom mieste a pripraven\xFD na vyzdvihnutie.",
      "zh": "\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5DF2\u5230\u8FBE\u81EA\u63D0\u70B9\uFF0C\u53EF\u4EE5\u9886\u53D6\u3002",
      "ja": "{{shop.name}} \u306E\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u5C4A\u304D\u307E\u3057\u305F\u3002\u304A\u53D7\u3051\u53D6\u308A\u3044\u305F\u3060\u3051\u307E\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST DISPONIBLE AU POINT DE RETRAIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est disponible au point de retrait.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE9sentez votre num\xE9ro de colis</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">et votre pi\xE8ce d\u2019identit\xE9 pour le r\xE9cup\xE9rer.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Retrouvez votre point de retrait via le bouton \xAB Suivre mon colis \xBB.&nbsp;</span></p>'
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS AVAILABLE AT THE PICKUP POINT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your package <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is available at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Present your parcel number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to collect it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "Track my package" button.&nbsp;</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE EST\xC1 DISPONIBLE EN EL PUNTO DE RECOGIDA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 disponible en el punto de recogida.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Presente su n\xFAmero de paquete</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">y su identificaci\xF3n para recogerlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encuentre su punto de recogida a trav\xE9s del bot\xF3n "Seguir mi paquete".&nbsp;</span></p>'
      },
      "it": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 DISPONIBILE AL PUNTO DI RITIRO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE8 disponibile al punto di ritiro.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Presenta il tuo numero di pacco</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e il tuo documento d'identit\xE0 per ritirarlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Trova il tuo punto di ritiro tramite il pulsante "Traccia il mio pacco".&nbsp;</span></p>`
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DEIN PAKET IST AM ABHOLPUNKT VERF\xDCGBAR</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, dein Paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ist am Abholpunkt verf\xFCgbar.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE4sentiere deine Paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">und deinen Ausweis, um es abzuholen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finde deinen Abholpunkt \xFCber den Button "Mein Paket verfolgen".&nbsp;</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET IS BESCHIKBAAR BIJ HET AFHAALPUNT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, je pakket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is beschikbaar bij het afhaalpunt.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Toon je pakketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">en je ID om het op te halen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vind je afhaalpunt via de knop "Mijn pakket volgen".&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST DOST\u0118PNA W PUNKCIE ODBIORU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, twoja paczka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">jest dost\u0119pna w punkcie odbioru.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Przedstaw sw\xF3j numer paczki</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">i dow\xF3d to\u017Csamo\u015Bci, aby go odebra\u0107.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Znajd\u017A sw\xF3j punkt odbioru za pomoc\u0105 przycisku "\u015Aled\u017A moj\u0105 paczk\u0119".&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER TILG\xC6NGELIG P\xC5 AFHENTNINGSSTEDET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din pakke <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">er tilg\xE6ngelig p\xE5 afhentningsstedet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE6senter dit pakkenummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for at hente den.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find dit afhentningssted via knappen "Spor min pakke".&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 DISPON\xCDVEL NO PONTO DE RETIRADA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 dispon\xEDvel no ponto de retirada.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Apresente o seu n\xFAmero de pacote</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e o seu documento de identidade para o recolher.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encontre o seu ponto de retirada atrav\xE9s do bot\xE3o "Rastrear meu pacote".&nbsp;</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET \xC4R TILLG\xC4NGLIGT VID UPPH\xC4MTNINGSST\xC4LLET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, ditt paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE4r tillg\xE4ngligt vid upph\xE4mtningsst\xE4llet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Visa ditt paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">och din ID f\xF6r att h\xE4mta det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hitta ditt upph\xE4mtningsst\xE4lle via knappen "Sp\xE5ra mitt paket".&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON SAATAVILLA NOUTOPISTEESS\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakettisi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">on saatavilla noutopisteess\xE4.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Esit\xE4 pakettinumerosi</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ja henkil\xF6llisyystodistuksesi noutaaksesi sen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">L\xF6yd\xE4 noutopisteesi "Seuraa pakettiani"-painikkeen kautta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER TILGJENGELIG P\xC5 HENTEPUNKTET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakken din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">er tilgjengelig p\xE5 hentepunktet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vis pakkenummeret ditt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og ID-en din for \xE5 hente den.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finn hentepunktet ditt via knappen "Spor pakken min".&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u041D\u0410\u041B\u0418\u0427\u041D\u0410 \u0412 \u041F\u0423\u041D\u041A\u0422\u0410 \u0417\u0410 \u041F\u041E\u041B\u0423\u0427\u0410\u0412\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0430 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0438 \u0432\u0430\u0448\u0430\u0442\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430, \u0437\u0430 \u0434\u0430 \u0433\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041D\u0430\u043C\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0447\u0440\u0435\u0437 \u0431\u0443\u0442\u043E\u043D\u0430 "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430".&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE K DISPOZICI NA V\xDDDEJN\xCDM M\xCDST\u011A</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xEDk <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je k dispozici na v\xFDdejn\xEDm m\xEDst\u011B.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">P\u0159edlo\u017Ete \u010D\xEDslo bal\xEDku</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a sv\u016Fj pr\u016Fkaz toto\u017Enosti k vyzvednut\xED.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Najd\u011Bte sv\xE9 v\xFDdejn\xED m\xEDsto pomoc\xED tla\u010D\xEDtka "Sledovat m\u016Fj bal\xEDk".&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGJA EL\xC9RHET\u0150 AZ \xC1TV\xC9TELI PONTON</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a csomagja <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">el\xE9rhet\u0151 az \xE1tv\xE9teli ponton.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Mutassa be a csomagsz\xE1m\xE1t</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE9s azonos\xEDt\xF3j\xE1t az \xE1tv\xE9telhez.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Keresse meg az \xE1tv\xE9teli pontj\xE1t a "Csomagom k\xF6vet\xE9se" gomb seg\xEDts\xE9g\xE9vel.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE K DISPOZ\xCDCII NA V\xDDDAJNOM MIESTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xEDk <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je k dispoz\xEDcii na v\xFDdajnom mieste.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Predlo\u017Ete \u010D\xEDslo bal\xEDka</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a svoj preukaz toto\u017Enosti na vyzdvihnutie.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">N\xE1jdite svoje v\xFDdajn\xE9 miesto pomocou tla\u010Didla "Sledova\u0165 m\xF4j bal\xEDk".&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u5DF2\u53EF\u5728\u81EA\u63D0\u70B9\u53D6\u4EF6</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u5305\u88F9 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is available at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Present your parcel number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to collect it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9" button.&nbsp;</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u3067\u53D7\u53D6\u53EF\u80FD\u3067\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u8377\u7269 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is available at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Present your parcel number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to collect it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B" button.&nbsp;</span></p>'
      }
    }
  },
  "CUSTOMS_CLEARANCE_COMPLETE": {
    "category": "general",
    "subject": {
      "fr": "La proc\xE9dure douani\xE8re est termin\xE9e ; {{carrier.name}} reprend l\u2019acheminement de votre colis.",
      "en": "The customs check for your {{shop.name}} package is complete.",
      "es": "El control aduanero de su paquete {{shop.name}} est\xE1 completo.",
      "it": "Il controllo doganale del tuo pacco {{shop.name}} \xE8 terminato.",
      "de": "Die Zollkontrolle f\xFCr Ihr {{shop.name}} Paket ist abgeschlossen.",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "A verifica\xE7\xE3o aduaneira do seu pacote {{shop.name}} est\xE1 conclu\xEDda.",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5DF2\u5B8C\u6210\u6D77\u5173\u68C0\u67E5\u3002",
      "ja": "{{shop.name}} \u306E\u8377\u7269\u306E\u901A\u95A2\u624B\u7D9A\u304D\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"
    },
    "content": {
      "fr": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE A REPRIS SON ACHEMINEMENT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, les douanes nous informent avoir termin\xE9 le contr\xF4le de votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Nom du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du shop</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Le colis a repris son acheminement et sera bient\xF4t mis en livraison. </span></p>'
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER HAS RESUMED ITS JOURNEY</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, customs have informed us that they have completed the check of your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package has resumed its journey and will soon be delivered. </span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO HA REANUDADO SU CAMINO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, las aduanas nos han informado que han completado el control de su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">El paquete ha reanudado su camino y pronto ser\xE1 entregado. </span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE HA RIPRESO IL SUO VIAGGIO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, le dogane ci hanno informato di aver completato il controllo del tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Il pacco ha ripreso il suo viaggio e sar\xE0 presto consegnato. </span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG HAT IHRE REISE WIEDERAUFGENOMMEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, der Zoll hat uns mitgeteilt, dass die Kontrolle Ihrer Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> abgeschlossen ist</span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Das Paket hat seine Reise wieder aufgenommen und wird bald geliefert. </span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO RETOMOU O SEU CAMINHO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, as alf\xE2ndegas informaram-nos que conclu\xEDram a verifica\xE7\xE3o do seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">O pacote retomou o seu caminho e ser\xE1 brevemente entregue. </span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u6062\u590D\u8FD0\u8F93</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, customs have informed us that they have completed the check of \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package has resumed its journey and will soon be delivered. </span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306F\u914D\u9001\u3092\u518D\u958B\u3057\u307E\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, customs have informed us that they have completed the check of \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;">.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package has resumed its journey and will soon be delivered. </span></p>'
      }
    }
  },
  "DELIVERED": {
    "category": "delivery",
    "subject": {
      "fr": "Livraison r\xE9ussie : votre commande {{shop.name}} vous a \xE9t\xE9 livr\xE9e.",
      "en": "Your {{shop.name}} order has been delivered.",
      "es": "Su pedido {{shop.name}} ha sido entregado.",
      "it": "Il tuo ordine {{shop.name}} \xE8 stato consegnato.",
      "de": "Ihre {{shop.name}} Bestellung wurde geliefert.",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "O seu pedido {{shop.name}} foi entregue.",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u5DF2\u9001\u8FBE\u3002",
      "ja": "{{shop.name}} \u306E\u3054\u6CE8\u6587\u304C\u914D\u9054\u3055\u308C\u307E\u3057\u305F\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE A ETE LIVR\xC9E !</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> a \xE9t\xE9 livr\xE9e avec succ\xE8s. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous esp\xE9rons qu'elle r\xE9pond \xE0 vos attentes et sommes \xE0 votre disposition le cas \xE9ch\xE9ant. </span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER HAS BEEN DELIVERED!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been successfully delivered. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We hope it meets your expectations and are at your disposal if needed. </span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\xA1SU PEDIDO HA SIDO ENTREGADO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ha sido entregado con \xE9xito. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que cumpla con sus expectativas y estamos a su disposici\xF3n si es necesario. </span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE \xC8 STATO CONSEGNATO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 stato consegnato con successo. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Speriamo che soddisfi le tue aspettative e siamo a tua disposizione se necessario. </span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG WURDE GELIEFERT!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> wurde erfolgreich geliefert. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir hoffen, dass es Ihren Erwartungen entspricht und stehen Ihnen bei Bedarf zur Verf\xFCgung. </span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO FOI ENTREGUE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> foi entregue com sucesso. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que atenda \xE0s suas expectativas e estamos \xE0 sua disposi\xE7\xE3o, se necess\xE1rio. </span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u9001\u8FBE\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been successfully delivered. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u5E0C\u671B\u7B26\u5408\u60A8\u7684\u671F\u671B\uFF0C\u5982\u6709\u9700\u8981\uFF0C\u6211\u4EEC\u968F\u65F6\u4E3A\u60A8\u670D\u52A1\u3002 </span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u304C\u914D\u9054\u3055\u308C\u307E\u3057\u305F\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been successfully delivered. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u671F\u5F85\u306B\u6CBF\u3048\u308C\u3070\u5E78\u3044\u3067\u3059\u3002\u5FC5\u8981\u3067\u3042\u308C\u3070\u3044\u3064\u3067\u3082\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002 </span></p>'
      }
    }
  },
  "DELIVERED_TO_NEIGHBOUR": {
    "category": "delivery",
    "subject": {
      "fr": "Votre colis {{shop.name}} a \xE9t\xE9 remis en toute s\xE9curit\xE9 \xE0 un tiers autoris\xE9.",
      "en": "Your {{shop.name}} order has been delivered to a third party.",
      "es": "Su pedido de {{shop.name}} ha sido entregado a un tercero.",
      "it": "Il tuo ordine {{shop.name}} \xE8 stato consegnato a una terza parte.",
      "de": "Ihre {{shop.name}} Bestellung wurde an eine dritte Partei geliefert.",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "O seu pedido {{shop.name}} foi entregue a um terceiro.",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u5DF2\u4EA4\u4ED8\u7ED9\u7B2C\u4E09\u65B9\u4EE3\u6536\u3002",
      "ja": "{{shop.name}} \u306E\u3054\u6CE8\u6587\u306F\u7B2C\u4E09\u8005\u306B\u304A\u5C4A\u3051\u3057\u307E\u3057\u305F\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE A ETE LIVR\xC9E</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> a \xE9t\xE9 r\xE9ceptionn\xE9e par la personne d\xE9sign\xE9e par vos soins. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous esp\xE9rons qu'elle r\xE9pondra \xE0 vos attentes et restons disponibles le cas \xE9ch\xE9ant. </span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER HAS BEEN DELIVERED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been received by the person designated by you. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We hope it meets your expectations and remain available if needed. </span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO HA SIDO ENTREGADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ha sido recibido por la persona designada por usted. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que cumpla con sus expectativas y estamos disponibles si es necesario. </span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE \xC8 STATO CONSEGNATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 stato ricevuto dalla persona da te designata. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Speriamo che soddisfi le tue aspettative e rimaniamo a disposizione se necessario. </span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG WURDE GELIEFERT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> wurde von der von Ihnen benannten Person entgegengenommen. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir hoffen, dass es Ihren Erwartungen entspricht und stehen Ihnen bei Bedarf zur Verf\xFCgung. </span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO FOI ENTREGUE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> foi recebido pela pessoa designada por voc\xEA. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que atenda \xE0s suas expectativas e estamos dispon\xEDveis se necess\xE1rio. </span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u5DF2\u9001\u8FBE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been received by the person designated by you. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u5E0C\u671B\u7B26\u5408\u60A8\u7684\u671F\u671B\uFF0C\u5982\u6709\u9700\u8981\uFF0C\u6211\u4EEC\u968F\u65F6\u4E3A\u60A8\u670D\u52A1\u3002 </span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u304C\u914D\u9054\u3055\u308C\u307E\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> has been received by the person designated by you. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u671F\u5F85\u306B\u6CBF\u3048\u308C\u3070\u5E78\u3044\u3067\u3059\u3002\u5FC5\u8981\u3067\u3042\u308C\u3070\u3044\u3064\u3067\u3082\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002 </span></p>'
      }
    }
  },
  "COLLECTED_AT_PICKUP": {
    "category": "delivery",
    "subject": {
      "fr": "Confirmation de retrait : votre colis {{shop.name}} a bien \xE9t\xE9 r\xE9cup\xE9r\xE9.",
      "en": "You have picked up your {{shop.name}} package",
      "es": "Ha recogido su paquete {{shop.name}}",
      "it": "Hai ritirato il tuo pacco {{shop.name}}",
      "de": "Sie haben Ihr {{shop.name}} Paket abgeholt",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "Voc\xEA retirou seu pacote {{shop.name}}",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "\u60A8\u5DF2\u9886\u53D6 {{shop.name}} \u5305\u88F9",
      "ja": "{{shop.name}} \u306E\u8377\u7269\u3092\u304A\u53D7\u3051\u53D6\u308A\u3044\u305F\u3060\u304D\u307E\u3057\u305F"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOUS AVEZ VOTRE COMMANDE !</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, vous avez retir\xE9 votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous esp\xE9rons qu'elle r\xE9pond \xE0 vos attentes et sommes \xE0 votre disposition le cas \xE9ch\xE9ant.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOU HAVE YOUR ORDER!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you have picked up your <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> package.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We hope it meets your expectations and are at your disposal if needed.</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\xA1TIENE SU PEDIDO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, ha recogido su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que cumpla con sus expectativas y estamos a su disposici\xF3n si es necesario.</span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>HAI IL TUO ORDINE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, hai ritirato il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Speriamo che soddisfi le tue aspettative e siamo a tua disposizione se necessario.</span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SIE HABEN IHRE BESTELLUNG!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Sie haben Ihr <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> Paket abgeholt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir hoffen, dass es Ihren Erwartungen entspricht und stehen Ihnen bei Bedarf zur Verf\xFCgung.</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOC\xCA TEM SEU PEDIDO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, voc\xEA retirou seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Esperamos que atenda \xE0s suas expectativas e estamos \xE0 sua disposi\xE7\xE3o, se necess\xE1rio.</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u5DF2\u6536\u5230\u8BA2\u5355\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you have picked up your <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> package.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u5E0C\u671B\u7B26\u5408\u60A8\u7684\u671F\u671B\uFF0C\u5982\u6709\u9700\u8981\uFF0C\u6211\u4EEC\u968F\u65F6\u4E3A\u60A8\u670D\u52A1\u3002</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u3092\u304A\u53D7\u3051\u53D6\u308A\u3044\u305F\u3060\u304D\u307E\u3057\u305F\uFF01</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you have picked up your <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> package.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u671F\u5F85\u306B\u6CBF\u3048\u308C\u3070\u5E78\u3044\u3067\u3059\u3002\u5FC5\u8981\u3067\u3042\u308C\u3070\u3044\u3064\u3067\u3082\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002</span></p>'
      }
    }
  },
  "EXCEPTION": {
    "category": "incident",
    "subject": {
      "fr": "Un incident d\u2019acheminement a \xE9t\xE9 signal\xE9 par {{carrier.name}} ; {{shop.name}} engage imm\xE9diatement les actions n\xE9cessaires.",
      "en": "Your order could not be delivered by {{carrier.name}}",
      "es": "Su pedido no pudo ser entregado por {{carrier.name}}",
      "it": "Il tuo ordine non \xE8 stato consegnato da {{carrier.name}}",
      "de": "Ihre Bestellung konnte nicht von {{carrier.name}} geliefert werden",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "O seu pedido n\xE3o p\xF4de ser entregue por {{carrier.name}}",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "{{carrier.name}} \u672A\u80FD\u6210\u529F\u914D\u9001\u60A8\u7684\u8BA2\u5355",
      "ja": "{{carrier.name}} \u306B\u3088\u308B\u3054\u6CE8\u6587\u306E\u914D\u9054\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UN INCIDENT D'ACHEMINEMENT EMPECHE VOTRE LIVRAISON.</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Cher(e) <span data-type="mention" class="mention" data-id="order.firstName" data-label="Firstname" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Firstname</span>, Nous avons \xE9t\xE9 inform\xE9s d\u2019une difficult\xE9 d\u2019acheminement concernant votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Nom du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du shop</span>, ind\xE9pendante de notre volont\xE9 comme de celle de <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Notre \xE9quipe a imm\xE9diatement pris contact avec le transporteur pour comprendre la situation et r\xE9soudre le probl\xE8me dans les meilleurs d\xE9lais.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER COULD NOT BE DELIVERED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> could not be delivered by </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> today. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Rest assured, instructions are on the way to help you arrange the redelivery of your package. </span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO NO PUDO SER ENTREGADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> no pudo ser entregado por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoy. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">No se preocupe, las instrucciones est\xE1n en camino para ayudarle a organizar la reentrega de su paquete. </span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE NON HA POTUTO ESSERE CONSEGNATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> non ha potuto essere consegnato da </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> oggi. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stai tranquillo, le istruzioni stanno arrivando per aiutarti a organizzare la riconsegna del tuo pacco. </span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG KONNTE NICHT GELIEFERT WERDEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> konnte nicht von </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> heute geliefert werden. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Seien Sie versichert, Anweisungen sind unterwegs, um Ihnen bei der Organisation der erneuten Lieferung Ihres Pakets zu helfen. </span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO N\xC3O P\xD4DE SER ENTREGUE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n\xE3o p\xF4de ser entregue por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoje. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Fique tranquilo, as instru\xE7\xF5es est\xE3o a caminho para ajud\xE1-lo a organizar a reentrega do seu pacote. </span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u672A\u80FD\u9001\u8FBE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u672A\u80FD\u9001\u8FBE\uFF0C\u627F\u8FD0\u5546\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u4ECA\u5929\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u8BF7\u653E\u5FC3\uFF0C\u5173\u4E8E\u91CD\u65B0\u914D\u9001\u7684\u8BF4\u660E\u5373\u5C06\u53D1\u9001\u7ED9\u60A8\uFF1A \u60A8\u7684\u5305\u88F9. </span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u3092\u304A\u5C4A\u3051\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306B\u3088\u308B\u914D\u9001\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u672C\u65E5\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u5B89\u5FC3\u304F\u3060\u3055\u3044\u3002\u518D\u914D\u9054\u306E\u624B\u914D\u65B9\u6CD5\u306B\u3064\u3044\u3066\u6848\u5185\u3092\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\uFF1A \u8377\u7269. </span></p>'
      }
    }
  },
  "PARCEL_NOT_SHIPPED": {
    "category": "incident",
    "subject": {
      "fr": "{{shop.name}} vous informe : aucun mouvement de votre commande d\xE9tect\xE9 pour l\u2019instant, nous suivons la situation de pr\xE8s.",
      "en": "{{shop.name}} informs you: no movement of your order detected for now, we are closely monitoring the situation.",
      "es": "{{shop.name}} le informa: no se ha detectado movimiento de su pedido por el momento, seguimos la situaci\xF3n de cerca.",
      "it": "{{shop.name}} ti informa: nessun movimento del tuo ordine rilevato per ora, stiamo monitorando la situazione da vicino.",
      "de": "{{shop.name}} informiert Sie: Keine Bewegung Ihrer Bestellung festgestellt, wir verfolgen die Situation genau.",
      "nl": "{{shop.name}} informeert u: geen beweging van uw bestelling gedetecteerd, we volgen de situatie op de voet.",
      "pl": "{{shop.name}} informuje: nie wykryto ruchu twojego zam\xF3wienia, uwa\u017Cnie \u015Bledzimy sytuacj\u0119.",
      "da": "{{shop.name}} informerer dig: ingen bev\xE6gelse af din ordre opdaget for nu, vi overv\xE5ger situationen n\xF8je.",
      "pt": "{{shop.name}} informa: nenhum movimento do seu pedido detectado por enquanto, estamos monitorando a situa\xE7\xE3o de perto.",
      "sv": "{{shop.name}} informerar dig: ingen r\xF6relse av din best\xE4llning uppt\xE4ckt f\xF6r tillf\xE4llet, vi \xF6vervakar situationen noga.",
      "fi": "{{shop.name}} ilmoittaa: tilaustasi ei ole havaittu liikkuvan t\xE4ll\xE4 hetkell\xE4, seuraamme tilannetta tarkasti.",
      "no": "{{shop.name}} informerer deg: ingen bevegelse av bestillingen din oppdaget for \xF8yeblikket, vi f\xF8lger situasjonen n\xF8ye.",
      "bg": "{{shop.name}} \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430: \u043D\u0435 \u0435 \u0437\u0430\u0441\u0435\u0447\u0435\u043D\u043E \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430, \u0441\u043B\u0435\u0434\u0438\u043C \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044F\u0442\u0430 \u043E\u0442\u0431\u043B\u0438\u0437\u043E.",
      "cs": "{{shop.name}} v\xE1s informuje: nebyl zji\u0161t\u011Bn \u017E\xE1dn\xFD pohyb va\u0161\xED objedn\xE1vky, situaci pe\u010Dliv\u011B sledujeme.",
      "hu": "{{shop.name}} t\xE1j\xE9koztat: a rendel\xE9sed mozg\xE1s\xE1t nem \xE9szlelt\xFCk, szorosan figyelj\xFCk a helyzetet.",
      "sk": "{{shop.name}} v\xE1s informuje: zatia\u013E nebol zisten\xFD \u017Eiadny pohyb va\u0161ej objedn\xE1vky, situ\xE1ciu pozorne sledujeme.",
      "zh": "{{shop.name}} \u901A\u77E5\u60A8\uFF1A\u6682\u672A\u68C0\u6D4B\u5230\u60A8\u7684\u8BA2\u5355\u6709\u7269\u6D41\u52A8\u6001\uFF0C\u6211\u4EEC\u6B63\u5728\u5BC6\u5207\u5173\u6CE8\u3002",
      "ja": "{{shop.name}} \u3088\u308A\u304A\u77E5\u3089\u305B\uFF1A\u73FE\u5728\u3054\u6CE8\u6587\u306E\u914D\u9001\u72B6\u6CC1\u306B\u52D5\u304D\u304C\u78BA\u8A8D\u3055\u308C\u3066\u304A\u308A\u307E\u305B\u3093\u3002\u72B6\u6CC1\u3092\u6CE8\u610F\u6DF1\u304F\u76E3\u8996\u3057\u3066\u304A\u308A\u307E\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ENCORE UN PEU DE PATIENCE...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est finalis\xE9e et pr\xEAte \xE0 \xEAtre exp\xE9di\xE9e.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous sommes dans l'attente de </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> </span><span style="font-size: 12px;">pour entamer sa mise en livraison.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A LITTLE MORE PATIENCE...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is finalized and ready to be shipped.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are waiting for </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> </span><span style="font-size: 12px;">to start its delivery.</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UN POCO M\xC1S DE PACIENCIA...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 finalizado y listo para ser enviado.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Estamos esperando a </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nombre del transportista" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nombre del transportista</span> </span><span style="font-size: 12px;">para iniciar su entrega.</span></p>'
      },
      "it": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ANCORA UN PO' DI PAZIENZA...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 finalizzato e pronto per essere spedito.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stiamo aspettando </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nome del corriere" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nome del corriere</span> </span><span style="font-size: 12px;">per iniziare la consegna.</span></p>`
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>NOCH EIN WENIG GEDULD...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ist abgeschlossen und bereit zum Versand.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir warten auf </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Name des Spediteurs" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Name des Spediteurs</span> </span><span style="font-size: 12px;">um mit der Lieferung zu beginnen.</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>NOG EVEN GEDULD...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, uw bestelling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is afgerond en klaar om te worden verzonden.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We wachten op </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Naam van de vervoerder" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Naam van de vervoerder</span> </span><span style="font-size: 12px;">om met de levering te beginnen.</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JESZCZE TROCH\u0118 CIERPLIWO\u015ACI...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, twoje zam\xF3wienie <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> jest gotowe do wysy\u0142ki.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Czekamy na </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nazwa przewo\u017Anika" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nazwa przewo\u017Anika</span> </span><span style="font-size: 12px;">aby rozpocz\u0105\u0107 dostaw\u0119.</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>LIDT MERE T\xC5LMODIGHED...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din ordre <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er f\xE6rdiggjort og klar til at blive sendt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi venter p\xE5 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Transport\xF8rens navn" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Transport\xF8rens navn</span> </span><span style="font-size: 12px;">for at starte leveringen.</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UM POUCO MAIS DE PACI\xCANCIA...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est\xE1 finalizado e pronto para ser enviado.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Estamos aguardando </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nome do transportador" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nome do transportador</span> </span><span style="font-size: 12px;">para iniciar a entrega.</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>LITE MER T\xC5LAMOD...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din best\xE4llning <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE4r f\xE4rdigst\xE4lld och redo att skickas.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi v\xE4ntar p\xE5 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Transport\xF6rens namn" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Transport\xF6rens namn</span> </span><span style="font-size: 12px;">f\xF6r att p\xE5b\xF6rja leveransen.</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VIEL\xC4 V\xC4H\xC4N K\xC4RSIV\xC4LLISYYTT\xC4...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, tilauksesi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> on valmis ja l\xE4hetett\xE4viss\xE4.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Odotamme </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Kuljettajan nimi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Kuljettajan nimi</span> </span><span style="font-size: 12px;">aloittamaan toimituksen.</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>LITT MER T\xC5LMODIGHET...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din bestilling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er ferdigstilt og klar til \xE5 sendes.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi venter p\xE5 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Transport\xF8rens navn" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Transport\xF8rens navn</span> </span><span style="font-size: 12px;">for \xE5 starte leveringen.</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u041E\u0429\u0415 \u041C\u0410\u041B\u041A\u041E \u0422\u042A\u0420\u041F\u0415\u041D\u0418\u0415...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u0435 \u0433\u043E\u0442\u043E\u0432\u0430 \u0437\u0430 \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u041E\u0447\u0430\u043A\u0432\u0430\u043C\u0435 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="\u0418\u043C\u0435 \u043D\u0430 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@\u0418\u043C\u0435 \u043D\u0430 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430</span> </span><span style="font-size: 12px;">\u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE\u0160T\u011A TROCHU TRP\u011ALIVOSTI...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161e objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je p\u0159ipravena k odesl\xE1n\xED.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u010Cek\xE1me na </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="N\xE1zev dopravce" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@N\xE1zev dopravce</span> </span><span style="font-size: 12px;">aby zah\xE1jil doru\u010Dov\xE1n\xED.</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>M\xC9G EGY KIS T\xDCRELEM...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a rendel\xE9se <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> k\xE9szen \xE1ll a sz\xE1ll\xEDt\xE1sra.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">V\xE1runk a </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Sz\xE1ll\xEDt\xF3 neve" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sz\xE1ll\xEDt\xF3 neve</span> </span><span style="font-size: 12px;">hogy megkezdje a sz\xE1ll\xEDt\xE1st.</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>E\u0160TE TROCHU TRPEZLIVOSTI...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161a objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je pripraven\xE1 na odoslanie.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u010Cak\xE1me na </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="N\xE1zov dopravcu" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@N\xE1zov dopravcu</span> </span><span style="font-size: 12px;">aby za\u010Dal doru\u010Dovanie.</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8BF7\u518D\u8010\u5FC3\u7B49\u5F85...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u5DF2\u5B8C\u6210\u5E76\u51C6\u5907\u53D1\u8D27\u3002</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u6211\u4EEC\u6B63\u5728\u7B49\u5F85 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> </span><span style="font-size: 12px;">\u5F00\u59CB\u914D\u9001\u3002</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3082\u3046\u5C11\u3057\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306E\u6E96\u5099\u304C\u5B8C\u4E86\u3057\u767A\u9001\u53EF\u80FD\u3067\u3059\u3002</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u73FE\u5728\u304A\u5F85\u3061\u3057\u3066\u3044\u308B\u306E\u306F </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> </span><span style="font-size: 12px;">\u304C\u914D\u9001\u3092\u958B\u59CB\u3059\u308B\u306E\u3092\u5F85\u3063\u3066\u3044\u307E\u3059\u3002</span></p>'
      }
    }
  },
  "DELAYED_PACKAGE": {
    "category": "incident",
    "subject": {
      "fr": "Un retard mod\xE9r\xE9 est identifi\xE9 par {{carrier.name}} ; nous assurons le suivi pr\xE9cis de votre commande {{shop.name}} ",
      "en": "A moderate delay is identified by {{carrier.name}}; we are closely monitoring your {{shop.name}} order.",
      "es": "Se ha identificado un retraso moderado por {{carrier.name}}; estamos monitoreando de cerca su pedido de {{shop.name}}.",
      "it": "Un ritardo moderato \xE8 stato identificato da {{carrier.name}}; stiamo monitorando attentamente il tuo ordine {{shop.name}}.",
      "de": "Ein moderater Verzug wird von {{carrier.name}} festgestellt; wir \xFCberwachen Ihre {{shop.name}} Bestellung genau.",
      "nl": "Een matige vertraging is ge\xEFdentificeerd door {{carrier.name}}; we volgen uw {{shop.name}} bestelling nauwlettend.",
      "pl": "Umiarkowane op\xF3\u017Anienie zosta\u0142o zidentyfikowane przez {{carrier.name}}; dok\u0142adnie monitorujemy Twoje zam\xF3wienie {{shop.name}}.",
      "da": "En moderat forsinkelse er identificeret af {{carrier.name}}; vi overv\xE5ger din {{shop.name}} ordre n\xF8je.",
      "pt": "Um atraso moderado foi identificado por {{carrier.name}}; estamos monitorando de perto seu pedido {{shop.name}}.",
      "sv": "En m\xE5ttlig f\xF6rsening har identifierats av {{carrier.name}}; vi \xF6vervakar din {{shop.name}} best\xE4llning noggrant.",
      "fi": "Kohtalainen viive on tunnistettu {{carrier.name}}; seuraamme tarkasti {{shop.name}} tilaustasi.",
      "no": "En moderat forsinkelse er identifisert av {{carrier.name}}; vi overv\xE5ker din {{shop.name}} bestilling n\xF8ye.",
      "bg": "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0435\u043D\u043E \u0435 \u0443\u043C\u0435\u0440\u0435\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435 \u043E\u0442 {{carrier.name}}; \u0432\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u043D\u043E \u0441\u043B\u0435\u0434\u0438\u043C \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{shop.name}}.",
      "cs": "M\xEDrn\xE9 zpo\u017Ed\u011Bn\xED bylo identifikov\xE1no {{carrier.name}}; pe\u010Dliv\u011B sledujeme va\u0161i objedn\xE1vku {{shop.name}}.",
      "hu": "M\xE9rs\xE9kelt k\xE9s\xE9st azonos\xEDtott a {{carrier.name}}; szorosan figyelemmel k\xEDs\xE9rj\xFCk a {{shop.name}} rendel\xE9s\xE9t.",
      "sk": "Mierne oneskorenie bolo identifikovan\xE9 {{carrier.name}}; pozorne sledujeme va\u0161u objedn\xE1vku {{shop.name}}.",
      "zh": "{{carrier.name}} \u53D1\u73B0\u8F7B\u5FAE\u5EF6\u8FDF\uFF0C\u6211\u4EEC\u6B63\u5728\u5BC6\u5207\u8DDF\u8E2A\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u3002",
      "ja": "{{carrier.name}} \u306B\u3088\u308A\u82E5\u5E72\u306E\u9045\u5EF6\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002{{shop.name}} \u306E\u3054\u6CE8\u6587\u3092\u6CE8\u610F\u6DF1\u304F\u8FFD\u8DE1\u3057\u3066\u3044\u307E\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS POURRAIT \xCATRE RETARD\xC9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nous informe d'un \xE9v\xE8nement impliquant votre colis et pouvant entra\xEEner un retard dans son acheminement.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous faisons le n\xE9cessaire pour qu'il vous soit livr\xE9 d\xE8s que possible.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE MAY BE DELAYED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> has informed us of an event involving your package that may cause a delay in its delivery.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are doing everything necessary to ensure it is delivered to you as soon as possible.</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE PODR\xCDA RETRASARSE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos ha informado de un evento que involucra su paquete y que podr\xEDa causar un retraso en su entrega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Estamos haciendo todo lo necesario para que le sea entregado lo antes posible.</span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO POTREBBE ESSERE IN RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ci ha informato di un evento che coinvolge il tuo pacco e che potrebbe causare un ritardo nella consegna.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stiamo facendo tutto il necessario affinch\xE9 ti venga consegnato il prima possibile.</span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHR PAKET K\xD6NNTE SICH VERZ\xD6GERN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> hat uns \xFCber ein Ereignis informiert, das Ihr Paket betrifft und zu einer Verz\xF6gerung bei der Lieferung f\xFChren k\xF6nnte.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir tun alles Notwendige, um sicherzustellen, dass es Ihnen so schnell wie m\xF6glich geliefert wird.</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET KAN VERTRAAGD ZIJN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> heeft ons ge\xEFnformeerd over een gebeurtenis met uw pakket die mogelijk vertraging kan veroorzaken.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We doen er alles aan om ervoor te zorgen dat het zo snel mogelijk bij u wordt afgeleverd.</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA MO\u017BE SI\u0118 OP\xD3\u0179NI\u0106</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> poinformowa\u0142 nas o zdarzeniu dotycz\u0105cym Twojej paczki, kt\xF3re mo\u017Ce spowodowa\u0107 op\xF3\u017Anienie w jej dostarczeniu.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Robimy wszystko, co konieczne, aby zapewni\u0107, \u017Ce zostanie dostarczona do Ciebie jak najszybciej.</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE KAN BLIVE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> har informeret os om en h\xE6ndelse, der involverer din pakke, og som kan for\xE5rsage en forsinkelse i leveringen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi g\xF8r alt n\xF8dvendigt for at sikre, at den bliver leveret til dig s\xE5 hurtigt som muligt.</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE PODE ATRASAR-SE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informou-nos de um evento que envolve o seu pacote e que pode causar um atraso na entrega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Estamos a fazer tudo o que \xE9 necess\xE1rio para que lhe seja entregue o mais rapidamente poss\xEDvel.</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET KAN F\xD6RSENAS</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> har informerat oss om en h\xE4ndelse som involverar ditt paket och som kan orsaka en f\xF6rsening i leveransen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi g\xF6r allt som kr\xE4vs f\xF6r att s\xE4kerst\xE4lla att det levereras till dig s\xE5 snart som m\xF6jligt.</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI SAATTAA VIIV\xC4STY\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> on ilmoittanut meille tapahtumasta, joka koskee pakettiasi ja saattaa aiheuttaa viiv\xE4styst\xE4 sen toimituksessa.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Teemme kaiken tarvittavan varmistaaksemme, ett\xE4 se toimitetaan sinulle mahdollisimman pian.</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN KAN BLI FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> har informert oss om en hendelse som involverer pakken din og som kan f\xF8re til en forsinkelse i leveringen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi gj\xF8r alt n\xF8dvendig for \xE5 sikre at den blir levert til deg s\xE5 snart som mulig.</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u041C\u041E\u0416\u0415 \u0414\u0410 \u0421\u0415 \u0417\u0410\u0411\u0410\u0412\u0418</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> \u043D\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430 \u0437\u0430 \u0441\u044A\u0431\u0438\u0442\u0438\u0435, \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u043E \u0441 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430, \u043A\u043E\u0435\u0442\u043E \u043C\u043E\u0436\u0435 \u0434\u0430 \u0434\u043E\u0432\u0435\u0434\u0435 \u0434\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u041F\u0440\u0430\u0432\u0438\u043C \u0432\u0441\u0438\u0447\u043A\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E, \u0437\u0430 \u0434\u0430 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0430\u043C\u0435, \u0447\u0435 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0441\u043A\u043E\u0440\u043E.</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK M\u016E\u017DE B\xDDT ZPO\u017DD\u011AN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informoval o ud\xE1losti t\xFDkaj\xEDc\xED se va\u0161eho bal\xEDku, kter\xE1 m\u016F\u017Ee zp\u016Fsobit zpo\u017Ed\u011Bn\xED jeho doru\u010Den\xED.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">D\u011Bl\xE1me v\u0161e pot\u0159ebn\xE9, abychom zajistili, \u017Ee v\xE1m bude doru\u010Den co nejd\u0159\xEDve.</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGJA K\xC9SLEKEDHET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> t\xE1j\xE9koztatott minket egy esem\xE9nyr\u0151l, amely a csomagj\xE1t \xE9rinti, \xE9s k\xE9s\xE9st okozhat a k\xE9zbes\xEDt\xE9sben.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Mindent megtesz\xFCnk annak \xE9rdek\xE9ben, hogy a lehet\u0151 leghamarabb k\xE9zbes\xEDts\xFCk \xD6nnek.</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160 BAL\xCDK M\xD4\u017DE BY\u0164 ONESKOREN\xDD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informoval o udalosti t\xFDkaj\xFAcej sa v\xE1\u0161ho bal\xEDka, ktor\xE1 m\xF4\u017Ee sp\xF4sobi\u0165 oneskorenie jeho doru\u010Denia.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Rob\xEDme v\u0161etko potrebn\xE9, aby sme zabezpe\u010Dili, \u017Ee v\xE1m bude doru\u010Den\xFD \u010Do najsk\xF4r.</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u53EF\u80FD\u4F1A\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> has informed us of an event involving \u60A8\u7684\u5305\u88F9 that may cause a delay in its delivery.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are doing everything necessary to ensure it is delivered to you as soon as possible.</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306E\u914D\u9054\u304C\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> has informed us of an event involving \u8377\u7269 that may cause a delay in its delivery.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are doing everything necessary to ensure it is delivered to you as soon as possible.</span></p>'
      }
    }
  },
  "DELAYED_PACKAGE_SEVERE": {
    "category": "incident",
    "subject": {
      "fr": "Un retard important est signal\xE9 par {{carrier.name}} ; nous restons pleinement mobilis\xE9s jusqu\u2019\xE0 la livraison de votre commande {{shop.name}} .",
      "en": "A significant delay is reported by {{carrier.name}}; we remain fully committed until your {{shop.name}} order is delivered.",
      "es": "Se informa de un retraso significativo por {{carrier.name}}; seguimos plenamente comprometidos hasta que se entregue su pedido de {{shop.name}}.",
      "it": "Un ritardo significativo \xE8 segnalato da {{carrier.name}}; rimaniamo pienamente impegnati fino alla consegna del tuo ordine {{shop.name}}.",
      "de": "Eine erhebliche Verz\xF6gerung wird von {{carrier.name}} gemeldet; wir bleiben voll engagiert, bis Ihre {{shop.name}} Bestellung geliefert wird.",
      "nl": "Een aanzienlijke vertraging wordt gemeld door {{carrier.name}}; we blijven volledig toegewijd totdat uw {{shop.name}} bestelling is geleverd.",
      "pl": "Znaczne op\xF3\u017Anienie jest zg\u0142aszane przez {{carrier.name}}; pozostajemy w pe\u0142ni zaanga\u017Cowani, dop\xF3ki Twoje zam\xF3wienie {{shop.name}} nie zostanie dostarczone.",
      "da": "En betydelig forsinkelse er rapporteret af {{carrier.name}}; vi forbliver fuldt engagerede, indtil din {{shop.name}} ordre er leveret.",
      "pt": "Um atraso significativo \xE9 relatado por {{carrier.name}}; permanecemos totalmente comprometidos at\xE9 que seu pedido {{shop.name}} seja entregue.",
      "sv": "En betydande f\xF6rsening rapporteras av {{carrier.name}}; vi f\xF6rblir fullt engagerade tills din {{shop.name}} best\xE4llning \xE4r levererad.",
      "fi": "Merkitt\xE4v\xE4 viive on ilmoitettu {{carrier.name}}; pysymme t\xE4ysin sitoutuneina, kunnes {{shop.name}} tilauksesi on toimitettu.",
      "no": "En betydelig forsinkelse er rapportert av {{carrier.name}}; vi forblir fullt engasjert til din {{shop.name}} bestilling er levert.",
      "bg": "\u0417\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435 \u0435 \u0434\u043E\u043A\u043B\u0430\u0434\u0432\u0430\u043D\u043E \u043E\u0442 {{carrier.name}}; \u043E\u0441\u0442\u0430\u0432\u0430\u043C\u0435 \u043D\u0430\u043F\u044A\u043B\u043D\u043E \u0430\u043D\u0433\u0430\u0436\u0438\u0440\u0430\u043D\u0438, \u0434\u043E\u043A\u0430\u0442\u043E \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 {{shop.name}} \u043D\u0435 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430.",
      "cs": "V\xFDznamn\xE9 zpo\u017Ed\u011Bn\xED je hl\xE1\u0161eno {{carrier.name}}; z\u016Fst\xE1v\xE1me pln\u011B odhodl\xE1ni, dokud nebude va\u0161e objedn\xE1vka {{shop.name}} doru\u010Dena.",
      "hu": "Jelent\u0151s k\xE9s\xE9st jelentett a {{carrier.name}}; teljes m\xE9rt\xE9kben elk\xF6telezettek maradunk, am\xEDg a {{shop.name}} rendel\xE9sedet k\xE9zbes\xEDtik.",
      "sk": "V\xFDznamn\xE9 oneskorenie je hl\xE1sen\xE9 {{carrier.name}}; zost\xE1vame plne odhodlan\xED, k\xFDm nebude va\u0161a objedn\xE1vka {{shop.name}} doru\u010Den\xE1.",
      "zh": "{{carrier.name}} \u62A5\u544A\u4E86\u4E25\u91CD\u5EF6\u8FDF\uFF0C\u6211\u4EEC\u5C06\u5168\u529B\u8DDF\u8FDB\u76F4\u81F3\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u9001\u8FBE\u3002",
      "ja": "{{carrier.name}} \u306B\u3088\u308A\u5927\u5E45\u306A\u9045\u5EF6\u304C\u5831\u544A\u3055\u308C\u307E\u3057\u305F\u3002{{shop.name}} \u306E\u3054\u6CE8\u6587\u304C\u5C4A\u304F\u307E\u3067\u5168\u529B\u3067\u5BFE\u5FDC\u3044\u305F\u3057\u307E\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST RETARD\xC9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nous informe que votre commande rencontre une difficult\xE9 dans son acheminement.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous en sommes d\xE9sol\xE9s.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nous avons pris contact avec eux pour qu'il vous soit livr\xE9 d\xE8s que possible.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS DELAYED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that your order is experiencing a delivery issue.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are sorry for this.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We have contacted them to ensure it is delivered to you as soon as possible.</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE EST\xC1 RETRASADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos informa que su pedido est\xE1 experimentando un problema de entrega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Lo sentimos mucho.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Nos hemos puesto en contacto con ellos para asegurarnos de que se le entregue lo antes posible.</span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 IN RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ci informa che il tuo ordine sta riscontrando un problema di consegna.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Ci dispiace.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Li abbiamo contattati per garantire che ti venga consegnato il prima possibile.</span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHR PAKET IST VERZ\xD6GERT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informiert uns, dass Ihre Bestellung ein Lieferproblem hat.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Es tut uns leid.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Wir haben sie kontaktiert, um sicherzustellen, dass es Ihnen so schnell wie m\xF6glich geliefert wird.</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW PAKKET IS VERTRAAGD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informeert ons dat uw bestelling een leveringsprobleem ondervindt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Het spijt ons.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We hebben contact met hen opgenomen om ervoor te zorgen dat het zo snel mogelijk bij u wordt afgeleverd.</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST OP\xD3\u0179NIONA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informuje nas, \u017Ce Twoje zam\xF3wienie ma problem z dostaw\u0105.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Przepraszamy za to.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Skontaktowali\u015Bmy si\u0119 z nimi, aby upewni\u0107 si\u0119, \u017Ce zostanie dostarczone do Ciebie tak szybko, jak to mo\u017Cliwe.</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerer os om, at din ordre oplever et leveringsproblem.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi beklager dette.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi har kontaktet dem for at sikre, at det bliver leveret til dig s\xE5 hurtigt som muligt.</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 ATRASADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos informa que o seu pedido est\xE1 a ter um problema de entrega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Lamentamos muito.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Entr\xE1mos em contacto com eles para garantir que seja entregue o mais rapidamente poss\xEDvel.</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET \xC4R F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerar oss om att din best\xE4llning har ett leveransproblem.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi beklagar detta.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi har kontaktat dem f\xF6r att s\xE4kerst\xE4lla att det levereras till dig s\xE5 snart som m\xF6jligt.</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON MY\xD6H\xC4SS\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ilmoittaa, ett\xE4 tilauksesi toimituksessa on ongelma.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pahoittelemme t\xE4t\xE4.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Olemme ottaneet heihin yhteytt\xE4 varmistaaksemme, ett\xE4 se toimitetaan sinulle mahdollisimman pian.</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerer oss om at bestillingen din har et leveringsproblem.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi beklager dette.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vi har kontaktet dem for \xE5 sikre at det blir levert til deg s\xE5 snart som mulig.</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u0417\u0410\u0411\u0410\u0412\u0415\u041D\u0410</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> \u043D\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430, \u0447\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 \u0438\u043C\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C \u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u0421\u044A\u0436\u0430\u043B\u044F\u0432\u0430\u043C\u0435 \u0437\u0430 \u0442\u043E\u0432\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u0421\u0432\u044A\u0440\u0437\u0430\u0445\u043C\u0435 \u0441\u0435 \u0441 \u0442\u044F\u0445, \u0437\u0430 \u0434\u0430 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0430\u043C\u0435, \u0447\u0435 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0441\u043A\u043E\u0440\u043E.</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160E Z\xC1SILKA JE ZPO\u017DD\u011AN\xC1</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informoval, \u017Ee va\u0161e objedn\xE1vka m\xE1 probl\xE9m s doru\u010Den\xEDm.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Omlouv\xE1me se za to.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Kontaktovali jsme je, abychom zajistili, \u017Ee bude doru\u010Dena co nejd\u0159\xEDve.</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGJA K\xC9S\xC9SBEN VAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> t\xE1j\xE9koztatott minket, hogy a rendel\xE9se k\xE9zbes\xEDt\xE9si probl\xE9m\xE1val k\xFCzd.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Eln\xE9z\xE9st k\xE9r\xFCnk ez\xE9rt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Felvett\xFCk vel\xFCk a kapcsolatot, hogy biztos\xEDtsuk, hogy a lehet\u0151 leghamarabb k\xE9zbes\xEDts\xE9k \xD6nnek.</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160 BAL\xCDK JE ONESKOREN\xDD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informoval, \u017Ee va\u0161a objedn\xE1vka m\xE1 probl\xE9m s doru\u010Den\xEDm.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Ospravedl\u0148ujeme sa za to.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Kontaktovali sme ich, aby sme zabezpe\u010Dili, \u017Ee bude doru\u010Den\xE1 \u010Do najsk\xF4r.</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u5DF2\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that \u60A8\u7684\u8BA2\u5355 is experiencing a delivery issue.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are sorry for this.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We have contacted them to ensure it is delivered to you as soon as possible.</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306E\u914D\u9054\u304C\u9045\u308C\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that \u3054\u6CE8\u6587 is experiencing a delivery issue.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We are sorry for this.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">We have contacted them to ensure it is delivered to you as soon as possible.</span></p>'
      }
    }
  },
  "CARRIER_DELAYED_PACKAGE": {
    "category": "incident",
    "subject": {
      "fr": "Votre colis {{shop.name}} pourrait avoir un petit retard.",
      "en": "Your {{shop.name}} package might be slightly delayed",
      "es": "Tu paquete de {{shop.name}} podr\xEDa tener un poco de retraso",
      "it": "Il tuo pacco {{shop.name}} potrebbe essere un po' in ritardo",
      "de": "Ihr {{ shop.name }} Paket ist noch unterwegs.",
      "nl": "Je {{shop.name}} pakket kan een beetje vertraagd zijn",
      "pl": "Dostawa Twojej przesy\u0142ki {{shop.name}} nieco si\u0119 op\xF3\u017Ani",
      "da": "Din {{shop.name}} pakke kan potentielt blive en smule forsinket",
      "pt": "O seu pacote {{shop.name}} poder\xE1 estar ligeiramente atrasado",
      "sv": "Ditt paket fr\xE5n {{shop.name}} kan vara n\xE5got f\xF6rsenat!",
      "fi": "{{shop.name}} -pakettisi saattaa my\xF6h\xE4sty\xE4 hieman",
      "no": "{{shop.name}}-pakken din kan v\xE6re litt forsinket!",
      "bg": "\u0412\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u0435 {{shop.name}} \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 \u043C\u0430\u043B\u043A\u043E \u0434\u0430 \u0441\u0435 \u0437\u0430\u0431\u0430\u0432\u0438",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} m\u016F\u017Ee m\xEDt m\xEDrn\xE9 zpo\u017Ed\u011Bn\xED",
      "hu": "El\u0151fordulhat, hogy az \xD6n {{shop.name}} csomagja kicsit k\xE9sik",
      "sk": "V\xE1\u0161 {{shop.name}} bal\xEDk sa m\xF4\u017Ee mierne oneskori\u0165",
      "zh": "\u60A8\u7684{{shop.name}}\u5305\u88F9\u53EF\u80FD\u4F1A\u7A0D\u6709\u5EF6\u8FDF",
      "ja": "{{shop.name}}\u306E\u8377\u7269\u304C\u5C11\u3057\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059"
    },
    "content": {
      "fr": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS POURRAIT AVOIR UN PETIT RETARD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span></span><span style="font-size: 12px;"> nous informe que votre colis </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">pourrait subir un l\xE9ger retard.&nbsp;Votre commande est toujours en route et vous sera livr\xE9e tr\xE8s prochainement.</span></p>'
      },
      "en": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>YOUR PACKAGE IS ON ITS WAY!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Your package is on its way but could be a bit delayed due to <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. You'll have your order very soon. </p>`
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>PUEDE QUE TU PAQUETE TENGA UN PEQUE\xD1O RETRASO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> nos ha informado que es posible que tu paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> lleve un poco de retraso. \xA1Pero no te preocupes <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span> ! A\xFAn est\xE1 en camino y te llegar\xE1 muy pronto.</p>'
      },
      "it": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>IL TUO ORDINE POTREBBE ESSERE UN PO' IN RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> ci ha indicato che il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> potrebbe essere in ritardo. Non ti preoccupare <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>! L'ordine \xE8 ancora in transito ma verr\xE0 consegnato a breve.</p>`
      },
      "de": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>Ihr <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> Paket ist noch unterwegs.</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hat uns \xFCber ein Problem bei der Zustellung Ihres <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> Pakets informiert. Es wird mit etwas  Versp\xE4tung bei Ihnen eintreffen. Sie erhalten weitere Informationen zu der Zustellung, indem Sie auf 'Meine Lieferung verfolgen' klicken.</p>`
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>JE PAKKET IS ONDERWEG!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Je pakket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is onderweg, maar kan een beetje vertraagd zijn. Geen zorgen, het zal zo snel mogelijk bezorgd worden!</p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>TWOJA PACZKA JEST JU\u017B W DRODZE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Twoja przesy\u0142ka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> jest w drodze, ale dostawa realizowana przez <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> mo\u017Ce si\u0119 nieco op\xF3\u017Ani\u0107. Nie martw si\u0119, <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>! Przesy\u0142ka dotrze do Ciebie ju\u017C nied\u0142ugo!</p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>DIN PAKKE ER P\xC5 VEJ!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> pakke er p\xE5 vej til dig - den kan potentielt v\xE6re en smule forsinket af <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Bare rolig <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>! Du vil have din pakke i h\xE6nde meget snart!</p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>O SEU PACOTE EST\xC1 A CAMINHO!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">O seu pacote est\xE1 a caminho, mas pode sofrer um ligeiro atraso devido \xE0 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Ter\xE1 a sua encomenda em breve. </p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>DITT PAKET \xC4R P\xC5 V\xC4G!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Ditt paket \xE4r p\xE5 v\xE4g men kan vara lite f\xF6rsenat p\xE5 grund av <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Du f\xE5r din best\xE4llning mycket snart. </p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>PAKETTISI ON MATKALLA!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Pakettisi on matkalla luoksesi, mutta se voi olla hieman my\xF6h\xE4ss\xE4 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> -kuriirista johtuvista syist\xE4. Saat tilauspakettisi pian. </p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>PAKKEN DIN ER P\xC5 VEI!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Pakken din er p\xE5 vei, men kan v\xE6re litt forsinket p\xE5 grunn av <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Du f\xE5r bestillingen din snart. </p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u041D\u0410 \u041F\u042A\u0422!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 \u0435 \u043D\u0430 \u043F\u044A\u0442, \u043D\u043E \u0435 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043B\u0435\u043A\u043E \u0434\u0430 \u0441\u0435 \u0437\u0430\u0431\u0430\u0432\u0438 \u043F\u043E\u0440\u0430\u0434\u0438 <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. \u0429\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u0441\u0438 \u0441\u044A\u0432\u0441\u0435\u043C \u0441\u043A\u043E\u0440\u043E. </p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>BAL\xCDK JE NA CEST\u011A!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Bal\xEDk je na cest\u011B, ale m\u016F\u017Ee se trochu zpozdit z d\u016Fvodu: <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Objedn\xE1vku obdr\u017E\xEDte u\u017E brzy. </p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>A CSOMAGJA M\xC1R \xDATON VAN!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">Az \xD6n csomagja \xFAton van, de a(z) <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> t\xE9ved\xE9se miatt egy kicsit k\xE9shet. Hamarosan megkapja a rendel\xE9s\xE9t. </p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>V\xC1\u0160 BAL\xCDK JE NA CESTE!</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">V\xE1\u0161 bal\xEDk je na ceste, ale m\xF4\u017Ee sa trochu oneskori\u0165 kv\xF4li <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. Objedn\xE1vku dostanete u\u017E \u010Doskoro. </p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>\u60A8\u7684\u5305\u88F9\u53EF\u80FD\u4F1A\u7A0D\u6709\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u60A8\u7684\u5305\u88F9\u6B63\u5728\u8FD0\u9001\u4E2D\uFF0C\u4F46\u7531\u4E8E <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u7684\u539F\u56E0\u53EF\u80FD\u4F1A\u7A0D\u6709\u5EF6\u8FDF\u3002\u60A8\u5F88\u5FEB\u5C31\u4F1A\u6536\u5230\u60A8\u7684\u8BA2\u5355\u3002</p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 18px;"><strong>\u8377\u7269\u304C\u5C11\u3057\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;">\u8377\u7269\u306F\u914D\u9001\u4E2D\u3067\u3059\u304C\u3001<span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u306E\u90FD\u5408\u306B\u3088\u308A\u5C11\u3057\u9045\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u307E\u3082\u306A\u304F\u304A\u5C4A\u3051\u3044\u305F\u3057\u307E\u3059\u3002</p>'
      }
    }
  },
  "RETURNED_TO_SENDER": {
    "category": "incident",
    "subject": {
      "fr": "Votre colis n\u2019a pas pu \xEAtre livr\xE9 et / ou r\xE9cup\xE9r\xE9 et retourne d\xE9sormais chez {{shop.name}}.",
      "en": "Your {{shop.name}} order is being returned to sender.",
      "es": "Su pedido de {{shop.name}} est\xE1 siendo devuelto al remitente.",
      "it": "Il tuo ordine {{shop.name}} viene restituito al mittente.",
      "de": "Ihre {{shop.name}}-Bestellung wird an den Absender zur\xFCckgesendet.",
      "nl": "Uw {{shop.name}}-bestelling wordt teruggestuurd naar de afzender.",
      "pl": "Twoje zam\xF3wienie {{shop.name}} jest zwracane do nadawcy.",
      "da": "Din {{shop.name}}-ordre returneres til afsenderen.",
      "pt": "O seu pedido {{shop.name}} est\xE1 a ser devolvido ao remetente.",
      "sv": "Din {{shop.name}}-best\xE4llning returneras till avs\xE4ndaren.",
      "fi": "Tilauksesi {{shop.name}} palautetaan l\xE4hett\xE4j\xE4lle.",
      "no": "Din {{shop.name}}-bestilling returneres til avsenderen.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "Va\u0161e objedn\xE1vka {{shop.name}} se vrac\xED odes\xEDlateli.",
      "hu": "A(z) {{shop.name}} rendel\xE9se visszak\xFCld\xE9sre ker\xFCl a felad\xF3nak.",
      "sk": "Va\u0161a objedn\xE1vka {{shop.name}} sa vracia odosielate\u013Eovi.",
      "zh": "\u60A8\u7684 {{shop.name}} \u8BA2\u5355\u6B63\u5728\u9000\u56DE\u53D1\u4EF6\u4EBA\u3002",
      "ja": "{{shop.name}} \u306E\u3054\u6CE8\u6587\u306F\u767A\u9001\u5143\u306B\u8FD4\u9001\u4E2D\u3067\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE REPART CHEZ L'EXP\xC9DITEUR</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, vous n'avez pas pu prendre possession de votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> et nous le regrettons.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Le colis fait le chemin inverse et sera bient\xF4t dans les mains de nos \xE9quipes.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER IS BEING RETURNED TO THE SENDER</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you were unable to receive your {{shop.name}} order and we regret this. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package is on its way back and will soon be in the hands of our team. </span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO EST\xC1 SIENDO DEVUELTO AL REMITENTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, no pudo recibir su pedido de {{shop.name}} y lo lamentamos. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">El paquete est\xE1 de regreso y pronto estar\xE1 en manos de nuestro equipo. </span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE VIENE RESTITUITO AL MITTENTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, non sei riuscito a ricevere il tuo ordine {{shop.name}} e ce ne dispiace. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Il pacco \xE8 in viaggio di ritorno e presto sar\xE0 nelle mani del nostro team. </span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG WIRD AN DEN ABSENDER ZUR\xDCCKGESENDET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Sie konnten Ihre {{shop.name}}-Bestellung nicht entgegennehmen und wir bedauern dies. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Das Paket ist auf dem R\xFCckweg und wird bald in den H\xE4nden unseres Teams sein. </span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW BESTELLING WORDT TERUGGESTUURD NAAR DE AFZENDER</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, u kon uw {{shop.name}}-bestelling niet ontvangen en dat betreuren wij. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Het pakket is onderweg terug en zal binnenkort in handen zijn van ons team. </span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJE ZAM\xD3WIENIE JEST ZWRACANE DO NADAWCY</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, nie uda\u0142o Ci si\u0119 odebra\u0107 zam\xF3wienia {{shop.name}} i jest nam przykro. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Paczka jest w drodze powrotnej i wkr\xF3tce b\u0119dzie w r\u0119kach naszego zespo\u0142u. </span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN BESTILLING RETURNERES TIL AFSENDEREN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, du kunne ikke modtage din {{shop.name}}-bestilling, og vi beklager dette. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pakken er p\xE5 vej tilbage og vil snart v\xE6re i h\xE6nderne p\xE5 vores team. </span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO EST\xC1 A SER DEVOLVIDO AO REMETENTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, n\xE3o conseguiu receber o seu pedido {{shop.name}} e lamentamos isso. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">O pacote est\xE1 a caminho de volta e em breve estar\xE1 nas m\xE3os da nossa equipa. </span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN BEST\xC4LLNING RETURNERAS TILL AVS\xC4NDAREN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, du kunde inte ta emot din {{shop.name}}-best\xE4llning och vi beklagar detta. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Paketet \xE4r p\xE5 v\xE4g tillbaka och kommer snart att vara i v\xE5rt teams h\xE4nder. </span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TILAUKSESI PALAUTETAAN L\xC4HETT\xC4J\xC4LLE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, et voinut vastaanottaa {{shop.name}}-tilaustasi ja pahoittelemme t\xE4t\xE4. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Paketti on matkalla takaisin ja on pian tiimimme k\xE4siss\xE4. </span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN BESTILLING RETURNERES TIL AVSENDEREN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, du kunne ikke motta din {{shop.name}}-bestilling, og vi beklager dette. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pakken er p\xE5 vei tilbake og vil snart v\xE6re i hendene p\xE5 v\xE5rt team. </span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160E OBJEDN\xC1VKA SE VRAC\xCD ODES\xCDLATELI</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, nepoda\u0159ilo se v\xE1m p\u0159evz\xEDt objedn\xE1vku {{shop.name}} a je n\xE1m to l\xEDto. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Bal\xED\u010Dek je na cest\u011B zp\u011Bt a brzy bude v rukou na\u0161eho t\xFDmu. </span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>RENDEL\xC9SE VISSZAK\xDCLD\xC9SRE KER\xDCL A FELAD\xD3NAK</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, nem tudta \xE1tvenni a(z) {{shop.name}} rendel\xE9s\xE9t, \xE9s ezt sajn\xE1ljuk. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">A csomag vissza\xFAton van, \xE9s hamarosan a csapatunk kez\xE9ben lesz. </span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VA\u0160A OBJEDN\xC1VKA SA VRACIA ODOSIELATE\u013DOVI</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, nepodarilo sa v\xE1m prevzia\u0165 objedn\xE1vku {{shop.name}} a je n\xE1m to \u013E\xFAto. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Bal\xEDk je na ceste sp\xE4\u0165 a \u010Doskoro bude v ruk\xE1ch n\xE1\u0161ho t\xEDmu. </span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u6B63\u5728\u9000\u56DE\u53D1\u4EF6\u4EBA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you were unable to receive your {{shop.name}} order and we regret this. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package is on its way back and will soon be in the hands of our team. </span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u306F\u767A\u9001\u5143\u306B\u8FD4\u9001\u3055\u308C\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, you were unable to receive your {{shop.name}} order and we regret this. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">The package is on its way back and will soon be in the hands of our team. </span></p>'
      }
    }
  },
  "WAITING_AT_PICKUP_POINT": {
    "category": "incident",
    "subject": {
      "fr": "Rappel : votre colis {{shop.name}} est en point de retrait depuis plusieurs jours.",
      "en": "Reminder: your {{shop.name}} package has been at the pickup point for several days.",
      "es": "Recordatorio: su paquete {{shop.name}} ha estado en el punto de recogida durante varios d\xEDas.",
      "it": "Promemoria: il tuo pacco {{shop.name}} \xE8 al punto di ritiro da diversi giorni.",
      "de": "Erinnerung: Ihr {{shop.name}} Paket befindet sich seit mehreren Tagen am Abholpunkt.",
      "nl": "Herinnering: je {{shop.name}} pakket ligt al enkele dagen op het afhaalpunt.",
      "pl": "Przypomnienie: Twoja paczka {{shop.name}} jest w punkcie odbioru od kilku dni.",
      "da": "P\xE5mindelse: din {{shop.name}} pakke har v\xE6ret p\xE5 afhentningsstedet i flere dage.",
      "pt": "Lembrete: seu pacote {{shop.name}} est\xE1 no ponto de retirada h\xE1 v\xE1rios dias.",
      "sv": "P\xE5minnelse: ditt {{shop.name}} paket har varit vid upph\xE4mtningsplatsen i flera dagar.",
      "fi": "Muistutus: {{shop.name}}-pakettisi on ollut noutopisteess\xE4 useita p\xE4ivi\xE4.",
      "no": "P\xE5minnelse: din {{shop.name}}-pakke har v\xE6rt p\xE5 hentepunktet i flere dager.",
      "bg": "\u041D\u0430\u043F\u043E\u043C\u043D\u044F\u043D\u0435: \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0435 \u043D\u0430 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u043E\u0442 \u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0434\u043D\u0438.",
      "cs": "P\u0159ipom\xEDnka: v\xE1\u0161 bal\xED\u010Dek {{shop.name}} je ji\u017E n\u011Bkolik dn\xED na v\xFDdejn\xEDm m\xEDst\u011B.",
      "hu": "Eml\xE9keztet\u0151: a(z) {{shop.name}} csomagod m\xE1r t\xF6bb napja az \xE1tv\xE9teli ponton van.",
      "sk": "Pripomienka: v\xE1\u0161 bal\xEDk {{shop.name}} je u\u017E nieko\u013Eko dn\xED na odbernom mieste.",
      "zh": "\u63D0\u9192\uFF1A\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5DF2\u5728\u81EA\u63D0\u70B9\u5B58\u653E\u591A\u65E5\u3002",
      "ja": "\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\uFF1A{{shop.name}} \u306E\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u5C4A\u3044\u3066\u304B\u3089\u6570\u65E5\u304C\u7D4C\u904E\u3057\u3066\u3044\u307E\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS VOUS ATTEND AU POINT DE RETRAIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est encore disponible quelques jours au point de retrait.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE9sentez-vous <u>rapidement</u> avec votre num\xE9ro de colis</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">et votre pi\xE8ce d\u2019identit\xE9 pour le r\xE9cup\xE9rer.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Retrouvez votre point de retrait via le bouton \xAB Suivre mon colis \xBB.&nbsp;</span></p>'
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS WAITING FOR YOU AT THE PICKUP POINT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your package <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is still available for a few days at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>quickly</u> with your package number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "Track my package" button.&nbsp;</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE LE ESPERA EN EL PUNTO DE RECOGIDA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 disponible por unos d\xEDas m\xE1s en el punto de recogida.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pres\xE9ntese <u>r\xE1pidamente</u> con su n\xFAmero de paquete</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">y su identificaci\xF3n para recogerlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encuentre su punto de recogida a trav\xE9s del bot\xF3n "Seguir mi paquete".&nbsp;</span></p>'
      },
      "it": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO TI ASPETTA AL PUNTO DI RITIRO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE8 ancora disponibile per alcuni giorni al punto di ritiro.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Presentati <u>rapidamente</u> con il tuo numero di pacco</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e il tuo documento d'identit\xE0 per ritirarlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Trova il tuo punto di ritiro tramite il pulsante "Traccia il mio pacco".&nbsp;</span></p>`
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DEIN PAKET WARTET AM ABHOLPUNKT AUF DICH</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, dein Paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ist noch einige Tage am Abholpunkt verf\xFCgbar.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Bitte erscheine <u>schnell</u> mit deiner Paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">und deinem Ausweis, um es abzuholen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finde deinen Abholpunkt \xFCber den Button "Mein Paket verfolgen".&nbsp;</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WACHT OP JE BIJ HET AFHAALPUNT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, je pakket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is nog enkele dagen beschikbaar bij het afhaalpunt.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Meld je <u>snel</u> met je pakketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">en je ID om het op te halen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vind je afhaalpunt via de knop "Mijn pakket volgen".&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA CZEKA NA CIEBIE W PUNKCIE ODBIORU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Drogi/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, twoja paczka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">jest nadal dost\u0119pna przez kilka dni w punkcie odbioru.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Prosz\u0119 zg\u0142o\u015B si\u0119 <u>szybko</u> z numerem paczki</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">i dowodem to\u017Csamo\u015Bci, aby j\u0105 odebra\u0107.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Znajd\u017A sw\xF3j punkt odbioru za pomoc\u0105 przycisku "\u015Aled\u017A moj\u0105 paczk\u0119".&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE VENTER P\xC5 DIG VED AFHENTNINGSPUNKTET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din pakke <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">er stadig tilg\xE6ngelig i et par dage ved afhentningspunktet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE6senter dig <u>hurtigt</u> med dit pakkenummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for at hente det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find dit afhentningspunkt via knappen "Spor min pakke".&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 \xC0 SUA ESPERA NO PONTO DE RETIRADA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ainda est\xE1 dispon\xEDvel por alguns dias no ponto de retirada.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Apresente-se <u>rapidamente</u> com o seu n\xFAmero de pacote</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e a sua identifica\xE7\xE3o para o recolher.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encontre o seu ponto de retirada atrav\xE9s do bot\xE3o "Rastrear meu pacote".&nbsp;</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET V\xC4NTAR P\xC5 DIG VID UPPH\xC4MTNINGSPUNKTEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, ditt paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE4r fortfarande tillg\xE4ngligt i n\xE5gra dagar vid upph\xE4mtningspunkten.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE4nligen presentera dig <u>snabbt</u> med ditt paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">och din ID f\xF6r att h\xE4mta det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hitta din upph\xE4mtningspunkt via knappen "Sp\xE5ra mitt paket".&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ODOTTAA SINUA NOUTOPISTEESS\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakettisi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">on edelleen saatavilla muutaman p\xE4iv\xE4n ajan noutopisteess\xE4.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Esit\xE4 itsesi <u>nopeasti</u> pakettinumerosi kanssa</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ja henkil\xF6todistuksesi saadaksesi sen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">L\xF6yd\xE4 noutopisteesi "Seuraa pakettiani"-painikkeen kautta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN VENTER P\xC5 DEG VED HENTEPUNKTET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakken din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">er fortsatt tilgjengelig i noen dager ved hentepunktet.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vennligst presenter deg <u>raskt</u> med pakkenummeret ditt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for \xE5 hente den.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finn hentepunktet ditt via knappen "Spor pakken min".&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0418 \u041E\u0427\u0410\u041A\u0412\u0410 \u041D\u0410 \u041C\u042F\u0421\u0422\u041E\u0422\u041E \u0417\u0410 \u041F\u041E\u041B\u0423\u0427\u0410\u0412\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0435 \u0432\u0441\u0435 \u043E\u0449\u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0437\u0430 \u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0434\u043D\u0438 \u043D\u0430 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041C\u043E\u043B\u044F, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u0441\u0435 <u>\u0431\u044A\u0440\u0437\u043E</u> \u0441 \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0430 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0438</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0438 \u0432\u0430\u0448\u0430\u0442\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430, \u0437\u0430 \u0434\u0430 \u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041D\u0430\u043C\u0435\u0440\u0435\u0442\u0435 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0441\u0438 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0447\u0440\u0435\u0437 \u0431\u0443\u0442\u043E\u043D\u0430 "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430".&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK NA V\xC1S \u010CEK\xC1 NA V\xDDDEJN\xCDM M\xCDST\u011A</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xED\u010Dek <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je st\xE1le k dispozici n\u011Bkolik dn\xED na v\xFDdejn\xEDm m\xEDst\u011B.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pros\xEDm, dostavte se <u>rychle</u> s \u010D\xEDslem bal\xEDku</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a va\u0161\xEDm dokladem toto\u017Enosti, abyste jej vyzvedli.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Najd\u011Bte sv\xE9 v\xFDdejn\xED m\xEDsto pomoc\xED tla\u010D\xEDtka "Sledovat m\u016Fj bal\xEDk".&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>A CSOMAGJA V\xC1RJA \xD6NT AZ \xC1TV\xC9TELI PONTON</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kedves</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a csomagja <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">m\xE9g n\xE9h\xE1ny napig el\xE9rhet\u0151 az \xE1tv\xE9teli ponton.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE9rj\xFCk, jelentkezzen <u>gyorsan</u> a csomagsz\xE1m\xE1val</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE9s azonos\xEDt\xF3j\xE1val, hogy \xE1tvegye.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Keresse meg az \xE1tv\xE9teli pontj\xE1t a "Csomagom k\xF6vet\xE9se" gomb seg\xEDts\xE9g\xE9vel.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK V\xC1S \u010CAK\xC1 NA ODBERNOM MIESTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xEDk <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je e\u0161te nieko\u013Eko dn\xED dostupn\xFD na odbernom mieste.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pros\xEDm, dostavte sa <u>r\xFDchlo</u> s \u010D\xEDslom bal\xEDka</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a va\u0161\xEDm dokladom toto\u017Enosti, aby ste ho vyzdvihli.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">N\xE1jdite svoje odbern\xE9 miesto pomocou tla\u010Didla "Sledova\u0165 m\xF4j bal\xEDk".&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u6B63\u5728\u81EA\u63D0\u70B9\u7B49\u60A8</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u5305\u88F9 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is still available for a few days at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>quickly</u> with \u60A8\u7684\u5305\u88F9 number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9" button.&nbsp;</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u304C\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u3067\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u8377\u7269 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is still available for a few days at the pickup point.&nbsp;</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>quickly</u> with \u8377\u7269 number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B" button.&nbsp;</span></p>'
      }
    }
  },
  "WAITING_AT_PICKUP_POINT_SEVERE": {
    "category": "incident",
    "subject": {
      "fr": "Dernier rappel : la p\xE9riode de disponibilit\xE9 en point de retrait indiqu\xE9e par {{carrier.name}} touche bient\xF4t \xE0 sa fin.",
      "en": "Last reminder: the availability period at the pickup point indicated by {{carrier.name}} is coming to an end soon.",
      "es": "\xDAltimo recordatorio: el per\xEDodo de disponibilidad en el punto de recogida indicado por {{carrier.name}} est\xE1 llegando a su fin.",
      "it": "Ultimo promemoria: il periodo di disponibilit\xE0 presso il punto di ritiro indicato da {{carrier.name}} sta per terminare.",
      "de": "Letzte Erinnerung: Die Verf\xFCgbarkeitsdauer am Abholpunkt, angegeben von {{carrier.name}}, endet bald.",
      "nl": "Laatste herinnering: de beschikbaarheidsperiode bij het afhaalpunt aangegeven door {{carrier.name}} loopt binnenkort af.",
      "pl": "Ostatnie przypomnienie: okres dost\u0119pno\u015Bci w punkcie odbioru wskazanym przez {{carrier.name}} dobiega ko\u0144ca.",
      "da": "Sidste p\xE5mindelse: tilg\xE6ngelighedsperioden ved afhentningsstedet angivet af {{carrier.name}} n\xE6rmer sig sin afslutning.",
      "pt": "\xDAltimo lembrete: o per\xEDodo de disponibilidade no ponto de recolha indicado por {{carrier.name}} est\xE1 a chegar ao fim.",
      "sv": "Sista p\xE5minnelsen: tillg\xE4nglighetsperioden vid upph\xE4mtningsplatsen angiven av {{carrier.name}} n\xE4rmar sig sitt slut.",
      "fi": "Viimeinen muistutus: {{carrier.name}}-ilmoittama noutopisteen saatavuusaika on p\xE4\xE4ttym\xE4ss\xE4.",
      "no": "Siste p\xE5minnelse: tilgjengelighetsperioden ved hentepunktet angitt av {{carrier.name}} n\xE6rmer seg slutten.",
      "bg": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u043D\u0430\u043F\u043E\u043C\u043D\u044F\u043D\u0435: \u043F\u0435\u0440\u0438\u043E\u0434\u044A\u0442 \u043D\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0441\u0442 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435, \u043F\u043E\u0441\u043E\u0447\u0435\u043D \u043E\u0442 {{carrier.name}}, \u0441\u043A\u043E\u0440\u043E \u0449\u0435 \u043F\u0440\u0438\u043A\u043B\u044E\u0447\u0438.",
      "cs": "Posledn\xED p\u0159ipom\xEDnka: obdob\xED dostupnosti na v\xFDdejn\xEDm m\xEDst\u011B uveden\xE9m {{carrier.name}} se bl\xED\u017E\xED ke konci.",
      "hu": "Utols\xF3 eml\xE9keztet\u0151: a {{carrier.name}} \xE1ltal megadott \xE1tv\xE9teli pont el\xE9rhet\u0151s\xE9gi id\u0151szaka hamarosan v\xE9get \xE9r.",
      "sk": "Posledn\xE1 pripomienka: obdobie dostupnosti na odbernom mieste uvedenom {{carrier.name}} sa bl\xED\u017Ei ku koncu.",
      "zh": "\u6700\u540E\u63D0\u9192\uFF1A{{carrier.name}} \u6307\u5B9A\u7684\u81EA\u63D0\u70B9\u4FDD\u7BA1\u671F\u9650\u5373\u5C06\u5C4A\u6EE1\u3002",
      "ja": "\u6700\u7D42\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\uFF1A{{carrier.name}} \u306E\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u3067\u306E\u4FDD\u7BA1\u671F\u9650\u304C\u9593\u3082\u306A\u304F\u7D42\u4E86\u3057\u307E\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATTENTION, VOTRE COLIS DOIT \xCATRE R\xC9CUP\xC9R\xC9 D\xC8S QUE POSSIBLE AU POINT DE RETRAIT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> est toujours au point de retrait et ne sera bient\xF4t plus disponible.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pr\xE9sentez-vous <u>d\xE8s que possible</u> avec votre num\xE9ro de colis</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Num\xE9ro de suivi" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Num\xE9ro de suivi</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">et votre pi\xE8ce d\u2019identit\xE9 pour le r\xE9cup\xE9rer.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Retrouvez votre point de retrait via le bouton \xAB Suivre mon colis \xBB.&nbsp;</span></p>'
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATTENTION, YOUR PACKAGE MUST BE PICKED UP AS SOON AS POSSIBLE AT THE PICKUP POINT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your package <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is still at the pickup point and will soon no longer be available.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>as soon as possible</u> with your package number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Tracking number" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Tracking number</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "Track my package" button.&nbsp;</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATENCI\xD3N, SU PAQUETE DEBE SER RECOGIDO LO ANTES POSIBLE EN EL PUNTO DE RECOGIDA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> todav\xEDa est\xE1 en el punto de recogida y pronto ya no estar\xE1 disponible.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pres\xE9ntese <u>lo antes posible</u> con su n\xFAmero de paquete</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="N\xFAmero de seguimiento" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@N\xFAmero de seguimiento</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">y su identificaci\xF3n para recuperarlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encuentre su punto de recogida a trav\xE9s del bot\xF3n "Seguir mi paquete".&nbsp;</span></p>'
      },
      "it": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATTENZIONE, IL TUO PACCO DEVE ESSERE RITIRATO IL PRIMA POSSIBILE AL PUNTO DI RITIRO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE8 ancora al punto di ritiro e presto non sar\xE0 pi\xF9 disponibile.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Presentati <u>il prima possibile</u> con il tuo numero di pacco</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Numero di tracciamento" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Numero di tracciamento</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e il tuo documento d'identit\xE0 per ritirarlo.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Trova il tuo punto di ritiro tramite il pulsante "Traccia il mio pacco".&nbsp;</span></p>`
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ACHTUNG, IHR PAKET MUSS SO SCHNELL WIE M\xD6GLICH AM ABHOLPUNKT ABGEHOLT WERDEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihr Paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> befindet sich noch am Abholpunkt und wird bald nicht mehr verf\xFCgbar sein.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Bitte erscheinen Sie <u>so schnell wie m\xF6glich</u> mit Ihrer Paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sendungsnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sendungsnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">und Ihrem Ausweis, um es abzuholen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finden Sie Ihren Abholpunkt \xFCber den Button "Mein Paket verfolgen".&nbsp;</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>LET OP, JE PAKKET MOET ZO SNEL MOGELIJK BIJ HET AFHAALPUNT WORDEN OPGEHAALD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, je pakket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is nog steeds bij het afhaalpunt en zal binnenkort niet meer beschikbaar zijn.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Meld je <u>zo snel mogelijk</u> met je pakketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Volgnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Volgnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">en je ID om het op te halen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vind je afhaalpunt via de knop "Mijn pakket volgen".&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UWAGA, TWOJA PACZKA MUSI ZOSTA\u0106 ODEBRANA JAK NAJSZYBCIEJ W PUNKCIE ODBIORU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, twoja paczka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> nadal znajduje si\u0119 w punkcie odbioru i wkr\xF3tce nie b\u0119dzie ju\u017C dost\u0119pna.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Prosz\u0119 zg\u0142osi\u0107 si\u0119 <u>jak najszybciej</u> z numerem paczki</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Numer \u015Bledzenia" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Numer \u015Bledzenia</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">i dowodem to\u017Csamo\u015Bci, aby j\u0105 odebra\u0107.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Znajd\u017A sw\xF3j punkt odbioru za pomoc\u0105 przycisku "\u015Aled\u017A moj\u0105 paczk\u0119".&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>OPM\xC6RKSOMHED, DIN PAKKE SKAL HENTES S\xC5 SNART SOM MULIGT VED AFHENTNINGSSTEDET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din pakke <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er stadig ved afhentningsstedet og vil snart ikke l\xE6ngere v\xE6re tilg\xE6ngelig.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Venligst pr\xE6senter dig <u>s\xE5 snart som muligt</u> med dit pakkenummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sporingsnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sporingsnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for at hente det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find dit afhentningssted via knappen "Spor min pakke".&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>ATEN\xC7\xC3O, O SEU PACOTE DEVE SER RECOLHIDO O MAIS R\xC1PIDO POSS\xCDVEL NO PONTO DE RECOLHA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ainda est\xE1 no ponto de recolha e em breve n\xE3o estar\xE1 mais dispon\xEDvel.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Apresente-se <u>o mais r\xE1pido poss\xEDvel</u> com o seu n\xFAmero de pacote</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="N\xFAmero de rastreamento" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@N\xFAmero de rastreamento</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">e o seu documento de identidade para o recolher.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Encontre o seu ponto de recolha atrav\xE9s do bot\xE3o "Rastrear o meu pacote".&nbsp;</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VARNING, DITT PAKET M\xC5STE H\xC4MTAS S\xC5 SNART SOM M\xD6JLIGT VID UPPH\xC4MTNINGSPLATSEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, ditt paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \xE4r fortfarande vid upph\xE4mtningsplatsen och kommer snart inte l\xE4ngre vara tillg\xE4ngligt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE4nligen presentera dig <u>s\xE5 snart som m\xF6jligt</u> med ditt paketnummer</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sp\xE5rningsnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sp\xE5rningsnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">och din ID f\xF6r att h\xE4mta det.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hitta din upph\xE4mtningsplats via knappen "Sp\xE5ra mitt paket".&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>HUOMIO, PAKETTISI ON NOUDETTAVA MAHDOLLISIMMAN PIAN NOUTOPISTEEST\xC4</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakettisi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> on edelleen noutopisteess\xE4 ja pian se ei en\xE4\xE4 ole saatavilla.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Esit\xE4 itsesi <u>mahdollisimman pian</u> pakettinumerosi kanssa</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Seurantanumero" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Seurantanumero</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ja henkil\xF6todistuksesi saadaksesi sen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">L\xF6yd\xE4 noutopisteesi "Seuraa pakettiani" -painikkeen kautta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>OBS, PAKKEN DIN M\xC5 HENTES S\xC5 SNART SOM MULIG P\xC5 HENTEPUNKTET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, pakken din <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> er fortsatt p\xE5 hentepunktet og vil snart ikke lenger v\xE6re tilgjengelig.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vennligst presenter deg <u>s\xE5 snart som mulig</u> med pakkenummeret ditt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sporingsnummer" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sporingsnummer</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">og din ID for \xE5 hente den.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Finn hentepunktet ditt via knappen "Spor pakken min".&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u041D\u0418\u041C\u0410\u041D\u0418\u0415, \u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0422\u0420\u042F\u0411\u0412\u0410 \u0414\u0410 \u0411\u042A\u0414\u0415 \u0412\u0417\u0415\u0422\u0410 \u0412\u042A\u0417\u041C\u041E\u0416\u041D\u041E \u041D\u0410\u0419-\u0421\u041A\u041E\u0420\u041E \u041E\u0422 \u041F\u0423\u041D\u041A\u0422\u0410 \u0417\u0410 \u041F\u041E\u041B\u0423\u0427\u0410\u0412\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0435 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0438 \u0441\u043A\u043E\u0440\u043E \u043D\u044F\u043C\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041C\u043E\u043B\u044F, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u0441\u0435 <u>\u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0441\u043A\u043E\u0440\u043E</u> \u0441 \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="\u041D\u043E\u043C\u0435\u0440 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@\u041D\u043E\u043C\u0435\u0440 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0438 \u0432\u0430\u0448\u0430\u0442\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430, \u0437\u0430 \u0434\u0430 \u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u041D\u0430\u043C\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u0447\u0440\u0435\u0437 \u0431\u0443\u0442\u043E\u043D\u0430 "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u043E\u044F\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430".&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>POZOR, V\xC1\u0160 BAL\xCDK MUS\xCD B\xDDT CO NEJD\u0158\xCDVE VYZVEDNUT NA V\xDDDEJN\xCDM M\xCDST\u011A</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xED\u010Dek <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je st\xE1le na v\xFDdejn\xEDm m\xEDst\u011B a brzy ji\u017E nebude k dispozici.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pros\xEDm, dostavte se <u>co nejd\u0159\xEDve</u> s \u010D\xEDslem va\u0161eho bal\xED\u010Dku</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sledovac\xED \u010D\xEDslo" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sledovac\xED \u010D\xEDslo</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a va\u0161\xEDm pr\u016Fkazem toto\u017Enosti, abyste jej vyzvedli.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Najd\u011Bte sv\xE9 v\xFDdejn\xED m\xEDsto pomoc\xED tla\u010D\xEDtka "Sledovat m\u016Fj bal\xED\u010Dek".&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>FIGYELEM, A CSOMAGOT A LEHET\u0150 LEGHAMARABB FEL KELL VENNI AZ \xC1TV\xC9TELI PONTON</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a(z) <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> csomagja m\xE9g mindig az \xE1tv\xE9teli ponton van, \xE9s hamarosan m\xE1r nem lesz el\xE9rhet\u0151.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE9rj\xFCk, jelenjen meg <u>a lehet\u0151 leghamarabb</u> a csomagsz\xE1m\xE1val</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Nyomk\xF6vet\xE9si sz\xE1m" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nyomk\xF6vet\xE9si sz\xE1m</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE9s azonos\xEDt\xF3j\xE1val, hogy \xE1tvegye.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Keresse meg az \xE1tv\xE9teli pontj\xE1t a "Csomagom nyomon k\xF6vet\xE9se" gomb seg\xEDts\xE9g\xE9vel.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>POZOR, V\xC1\u0160 BAL\xCDK MUS\xCD BY\u0164 \u010CO NAJSK\xD4R VYZDVIHNUT\xDD NA ODBERNOM MIESTE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, v\xE1\u0161 bal\xEDk <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> je st\xE1le na odbernom mieste a \u010Doskoro u\u017E nebude k dispoz\xEDcii.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pros\xEDm, dostavte sa <u>\u010Do najsk\xF4r</u> s \u010D\xEDslom v\xE1\u0161ho bal\xEDka</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Sledovacie \u010D\xEDslo" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Sledovacie \u010D\xEDslo</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a va\u0161\xEDm preukazom toto\u017Enosti, aby ste ho vyzdvihli.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">N\xE1jdite svoje odbern\xE9 miesto pomocou tla\u010Didla "Sledova\u0165 m\xF4j bal\xEDk".&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u6CE8\u610F\uFF0C\u60A8\u7684\u5305\u88F9\u5FC5\u987B\u5C3D\u5FEB\u5728\u81EA\u63D0\u70B9\u9886\u53D6</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u5305\u88F9 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is still at the pickup point and will soon no longer be available.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>as soon as possible</u> with \u60A8\u7684\u5305\u88F9 number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Tracking number" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Tracking number</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8FFD\u8E2A\u6211\u7684\u5305\u88F9" button.&nbsp;</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u610F\uFF1A\u8377\u7269\u306F\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u3067\u53D7\u3051\u53D6\u3063\u3066\u304F\u3060\u3055\u3044</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u8377\u7269 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> is still at the pickup point and will soon no longer be available.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Please present yourself <u>as soon as possible</u> with \u8377\u7269 number</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="parcel.trackingId" data-label="Tracking number" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Tracking number</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">and your ID to retrieve it.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Find your pickup point via the "\u8377\u7269\u3092\u8FFD\u8DE1\u3059\u308B" button.&nbsp;</span></p>'
      }
    }
  },
  "WAITING_INFORMATION_FROM_ADDRESS": {
    "category": "incident",
    "subject": {
      "fr": "{{carrier.name}} n\xE9cessite des informations compl\xE9mentaires pour finaliser la livraison. ",
      "en": "Your {{shop.name}} package is still being prepared.",
      "es": "Su paquete {{shop.name}} todav\xEDa est\xE1 en preparaci\xF3n.",
      "it": "Il tuo pacco {{shop.name}} \xE8 ancora in fase di preparazione.",
      "de": "Dein {{shop.name}} Paket wird noch vorbereitet.",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "O seu pacote {{shop.name}} ainda est\xE1 a ser preparado.",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "\u60A8\u7684 {{shop.name}} \u5305\u88F9\u4ECD\u5728\u51C6\u5907\u4E2D\u3002",
      "ja": "{{shop.name}} \u306E\u8377\u7269\u306F\u307E\u3060\u6E96\u5099\u4E2D\u3067\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><strong>BESOIN D'INFORMATIONS SUPPLEMENTAIRES POUR VOTRE LIVRAISON</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Code transporteur</span> nous informe qu'il a besoin d'informations compl\xE9mentaires pour vous livrer votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Nom du shop" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du shop</span>.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Code transporteur</span> va revenir vers vous rapidement pour les compl\xE9ter.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS STILL BEING PREPARED AND MAY EXPERIENCE A SLIGHT DELAY</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, your </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> package is still being prepared. We will keep you updated on its progress and delivery.&nbsp;</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE TODAV\xCDA EST\xC1 EN PREPARACI\xD3N Y PODR\xCDA SUFRIR UN LIGERO RETRASO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, su paquete </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> todav\xEDa est\xE1 en preparaci\xF3n. Le mantendremos informado sobre su progreso y entrega.&nbsp;</span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 ANCORA IN PREPARAZIONE E POTREBBE SUBIRE UN LEGGERO RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, il tuo pacco </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \xE8 ancora in preparazione. Ti terremo informato sui suoi progressi e sulla consegna.&nbsp;</span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DEIN PAKET WIRD NOCH VORBEREITET UND K\xD6NNTE SICH LEICHT VERZ\xD6GERN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, dein </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> Paket wird noch vorbereitet. Wir halten dich \xFCber den Fortschritt und die Lieferung auf dem Laufenden.&nbsp;</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE AINDA EST\xC1 A SER PREPARADO E PODE SOFRER UM LIGEIRO ATRASO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, o seu pacote </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> ainda est\xE1 a ser preparado. Iremos mant\xEA-lo informado sobre o progresso e a entrega.&nbsp;</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u4ECD\u5728\u51C6\u5907\u4E2D\uFF0C\u53EF\u80FD\u4F1A\u6709\u4E9B\u8BB8\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, your </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> package is still being prepared. \u6211\u4EEC\u5C06\u968F\u65F6\u544A\u77E5\u60A8\u8FDB\u5C55\u548C\u9001\u8FBE\u60C5\u51B5\u3002&nbsp;</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306F\u307E\u3060\u6E96\u5099\u4E2D\u3067\u3001\u82E5\u5E72\u9045\u5EF6\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, your </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> package is still being prepared. \u9032\u6357\u3068\u914D\u9001\u306B\u3064\u3044\u3066\u968F\u6642\u304A\u77E5\u3089\u305B\u3044\u305F\u3057\u307E\u3059\u3002&nbsp;</span></p>'
      }
    }
  },
  "DISPATCHED_TO_OTHER_PICKUP_POINT": {
    "category": "incident",
    "subject": {
      "fr": "Votre colis {{shop.name}} a \xE9t\xE9 redirig\xE9 vers un autre point de retrait par {{carrier.name}}.",
      "en": "Your {{shop.name}} package will be delivered to a different pickup point.",
      "es": "Su paquete {{shop.name}} ser\xE1 entregado en un punto de recogida diferente.",
      "it": "Il tuo pacco {{shop.name}} sar\xE0 consegnato a un punto di ritiro diverso.",
      "de": "Ihr {{shop.name}} Paket wird an einen anderen Abholpunkt geliefert.",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "O seu pacote {{shop.name}} ser\xE1 entregue em um ponto de retirada diferente.",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "\u60A8\u7684 {{shop.name}} \u5305\u88F9\u5C06\u88AB\u6D3E\u9001\u81F3\u53E6\u4E00\u4E2A\u81EA\u63D0\u70B9\u3002",
      "ja": "{{shop.name}} \u306E\u8377\u7269\u306F\u5225\u306E\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u5C4A\u3051\u3089\u308C\u307E\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST ACHEMIN\xC9 VERS UN AUTRE POINT DE RETRAIT QUE CELUI S\xC9LECTIONN\xC9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre colis <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">a \xE9t\xE9 achemin\xE9 vers un autre point de retrait que celui initialement s\xE9lectionn\xE9.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Les informations \xE0 jour vous seront communiqu\xE9es tr\xE8s prochainement.</span></p>'
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS BEING SENT TO A DIFFERENT PICKUP POINT THAN SELECTED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your package <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">has been sent to a different pickup point than initially selected.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Updated information will be communicated to you shortly.</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE SE EST\xC1 ENVIANDO A UN PUNTO DE RECOGIDA DIFERENTE AL SELECCIONADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su paquete <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">ha sido enviado a un punto de recogida diferente al seleccionado inicialmente.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">La informaci\xF3n actualizada se le comunicar\xE1 en breve.</span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 STATO INVIATO A UN PUNTO DI RITIRO DIVERSO DA QUELLO SELEZIONATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo pacco <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE8 stato inviato a un punto di ritiro diverso da quello selezionato inizialmente.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Le informazioni aggiornate ti saranno comunicate a breve.</span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHR PAKET WIRD AN EINEN ANDEREN ABHOLPUNKT GESENDET ALS AUSGEW\xC4HLT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihr Paket <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">wurde an einen anderen Abholpunkt gesendet als urspr\xFCnglich ausgew\xE4hlt.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Aktualisierte Informationen werden Ihnen in K\xFCrze mitgeteilt.</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 A SER ENVIADO PARA UM PONTO DE RETIRADA DIFERENTE DO SELECIONADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pacote <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">foi enviado para um ponto de retirada diferente do inicialmente selecionado.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">As informa\xE7\xF5es atualizadas ser\xE3o comunicadas em breve.</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u5DF2\u88AB\u53D1\u9001\u81F3\u4E0E\u6240\u9009\u4E0D\u540C\u7684\u81EA\u63D0\u70B9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u5305\u88F9 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">has been sent to a different pickup point than initially selected.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Updated information will be communicated to you shortly.</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306F\u9078\u629E\u3055\u308C\u305F\u5834\u6240\u3068\u306F\u7570\u306A\u308B\u53D7\u53D6\u30DD\u30A4\u30F3\u30C8\u306B\u9001\u3089\u308C\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u8377\u7269 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> </span><span style="color: rgb(0, 0, 0); font-size: 12px;">has been sent to a different pickup point than initially selected.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Updated information will be communicated to you shortly.</span></p>'
      }
    }
  },
  "REDIRECT_TO_PICKUP": {
    "category": "incident",
    "subject": {
      "fr": "N'ayant pas pu vous \xEAtre livr\xE9 directement, votre colis {{shop.name}} vous attend d\xE9sormais en point de retrait.",
      "en": "Your order could not be delivered by {{carrier.name}}",
      "es": "Su pedido no pudo ser entregado por {{carrier.name}}",
      "it": "Il tuo ordine non \xE8 stato consegnato da {{carrier.name}}",
      "de": "Ihre Bestellung konnte nicht von {{carrier.name}} geliefert werden",
      "nl": "Uw {{shop.name}} pakket kon niet worden bezorgd en is doorgestuurd naar een afhaalpunt.",
      "pl": "Twoja paczka {{shop.name}} nie mog\u0142a zosta\u0107 dostarczona i zosta\u0142a przekierowana do punktu odbioru.",
      "da": "Din {{shop.name}} pakke kunne ikke leveres og er blevet omdirigeret til et afhentningssted.",
      "pt": "O seu pedido n\xE3o p\xF4de ser entregue por {{carrier.name}}",
      "sv": "Ditt {{shop.name}}-paket kunde inte levereras och har omdirigerats till ett utl\xE4mningsst\xE4lle.",
      "fi": "{{shop.name}}-pakettiasi ei voitu toimittaa ja se on ohjattu noutopisteeseen.",
      "no": "{{shop.name}}-pakken din kunne ikke leveres og er omdirigert til et hentested.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u043D\u0435 \u043C\u043E\u0436\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u0438 \u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0430 \u043A\u044A\u043C \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} nemohl b\xFDt doru\u010Den a byl p\u0159esm\u011Brov\xE1n na v\xFDdejn\xED m\xEDsto.",
      "hu": "A {{shop.name}} csomagod nem volt k\xE9zbes\xEDthet\u0151, ez\xE9rt egy \xE1tv\xE9teli pontra ir\xE1ny\xEDtottuk.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} nemohol by\u0165 doru\u010Den\xFD a bol presmerovan\xFD na v\xFDdajn\xE9 miesto.",
      "zh": "{{carrier.name}} \u672A\u80FD\u6210\u529F\u914D\u9001\u60A8\u7684\u8BA2\u5355",
      "ja": "{{carrier.name}} \u306B\u3088\u308B\u3054\u6CE8\u6587\u306E\u914D\u9054\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE N'A PAS PU \xCATRE LIVR\xC9E CHEZ VOUS.</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nous informe que votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n'a pas pu \xEAtre livr\xE9e chez vous.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Vous serez inform\xE9(e) rapidement de sa mise \xE0 disposition dans un point de retrait \xE0 proximit\xE9 de votre domicile par <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span>.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER COULD NOT BE DELIVERED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> could not be delivered by </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> today. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Rest assured, instructions are on the way to help you arrange the redelivery of your package. </span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO NO PUDO SER ENTREGADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> no pudo ser entregado por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoy. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">No se preocupe, las instrucciones est\xE1n en camino para ayudarle a organizar la reentrega de su paquete. </span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE NON HA POTUTO ESSERE CONSEGNATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> non ha potuto essere consegnato da </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> oggi. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stai tranquillo, le istruzioni stanno arrivando per aiutarti a organizzare la riconsegna del tuo pacco. </span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG KONNTE NICHT GELIEFERT WERDEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> konnte nicht von </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> heute geliefert werden. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Seien Sie versichert, Anweisungen sind unterwegs, um Ihnen bei der Organisation der erneuten Lieferung Ihres Pakets zu helfen. </span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>UW PAKKET KON NIET WORDEN BEZORGD EN IS DOORGESTUURD NAAR EEN AFHAALPUNT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, uw bestelling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> kon niet worden bezorgd door </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Uw pakket is doorgestuurd naar een afhaalpunt. U wordt op de hoogte gesteld zodra het beschikbaar is voor afhaling. </span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA NIE MOG\u0141A ZOSTA\u0106 DOSTARCZONA I ZOSTA\u0141A PRZEKIEROWANA DO PUNKTU ODBIORU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Twoje zam\xF3wienie <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> nie mog\u0142o zosta\u0107 dostarczone przez </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Twoja paczka zosta\u0142a przekierowana do punktu odbioru. Powiadomimy Ci\u0119, gdy b\u0119dzie gotowa do odbioru. </span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE KUNNE IKKE LEVERES OG ER OMDIRIGERET TIL ET AFHENTNINGSSTED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din ordre <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> kunne ikke leveres af </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Din pakke er blevet omdirigeret til et afhentningssted. Du f\xE5r besked, s\xE5 snart den er klar til afhentning. </span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO N\xC3O P\xD4DE SER ENTREGUE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n\xE3o p\xF4de ser entregue por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoje. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Fique tranquilo, as instru\xE7\xF5es est\xE3o a caminho para ajud\xE1-lo a organizar a reentrega do seu pacote. </span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET KUNDE INTE LEVERERAS OCH HAR OMDIRIGERATS TILL ETT UTL\xC4MNINGSST\xC4LLE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din best\xE4llning <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> kunde inte levereras av </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Ditt paket har omdirigerats till ett utl\xE4mningsst\xE4lle. Du meddelas s\xE5 snart det \xE4r tillg\xE4ngligt f\xF6r avh\xE4mtning. </span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTIASI EI VOITU TOIMITTAA JA SE ON OHJATTU NOUTOPISTEESEEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, tilaustasi <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> ei voitu toimittaa kuljetusyhti\xF6n <span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> toimesta. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pakettisi on ohjattu noutopisteeseen. Saat ilmoituksen, kun se on noudettavissa. </span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN KUNNE IKKE LEVERES OG ER OMDIRIGERT TIL ET HENTESTED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, din bestilling <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> kunne ikke leveres av </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Pakken din er omdirigert til et hentested. Du vil bli varslet s\xE5 snart den er klar for henting. </span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u041D\u0415 \u041C\u041E\u0416\u0410 \u0414\u0410 \u0411\u042A\u0414\u0415 \u0414\u041E\u0421\u0422\u0410\u0412\u0415\u041D\u0410 \u0418 \u0415 \u041F\u0420\u0415\u041D\u0410\u0421\u041E\u0427\u0415\u041D\u0410 \u041A\u042A\u041C \u041F\u0423\u041D\u041A\u0422 \u0417\u0410 \u041F\u041E\u041B\u0423\u0427\u0410\u0412\u0410\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u043D\u0435 \u043C\u043E\u0436\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u043E\u0442 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 \u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0430 \u043A\u044A\u043C \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435. \u0429\u0435 \u0431\u044A\u0434\u0435\u0442\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u0435\u043D\u0438 \u0432\u0435\u0434\u043D\u0430\u0433\u0430 \u0449\u043E\u043C \u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435. </span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK NEMOHL B\xDDT DORU\u010CEN A BYL P\u0158ESM\u011AROV\xC1N NA V\xDDDEJN\xCD M\xCDSTO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161e objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> nemohla b\xFDt doru\u010Dena p\u0159epravcem </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">V\xE1\u0161 bal\xEDk byl p\u0159esm\u011Brov\xE1n na v\xFDdejn\xED m\xEDsto. Budete informov\xE1ni, jakmile bude p\u0159ipraven k vyzvednut\xED. </span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJ\xC1T NEM SIKER\xDCLT K\xC9ZBES\xCDTENI \xC9S EGY \xC1TV\xC9TELI PONTRA IR\xC1NY\xCDTOTTUK</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, a(z) <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> rendel\xE9s\xE9t nem tudta k\xE9zbes\xEDteni a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Csomagj\xE1t egy \xE1tv\xE9teli pontra ir\xE1ny\xEDtottuk. \xC9rtes\xEDtj\xFCk, amint \xE1tvehet\u0151 lesz. </span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK NEMOHOL BY\u0164 DORU\u010CEN\xDD A BOL PRESMEROVAN\xDD NA V\xDDDAJN\xC9 MIESTO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, va\u0161a objedn\xE1vka <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> nemohla by\u0165 doru\u010Den\xE1 prepravcom </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span>. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">V\xE1\u0161 bal\xEDk bol presmerovan\xFD na v\xFDdajn\xE9 miesto. Budete informovan\xED, akon\xE1hle bude pripraven\xFD na vyzdvihnutie. </span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u672A\u80FD\u9001\u8FBE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u672A\u80FD\u9001\u8FBE\uFF0C\u627F\u8FD0\u5546\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u4ECA\u5929\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u8BF7\u653E\u5FC3\uFF0C\u5173\u4E8E\u91CD\u65B0\u914D\u9001\u7684\u8BF4\u660E\u5373\u5C06\u53D1\u9001\u7ED9\u60A8\uFF1A \u60A8\u7684\u5305\u88F9. </span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u3092\u304A\u5C4A\u3051\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306B\u3088\u308B\u914D\u9001\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u672C\u65E5\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u5B89\u5FC3\u304F\u3060\u3055\u3044\u3002\u518D\u914D\u9054\u306E\u624B\u914D\u65B9\u6CD5\u306B\u3064\u3044\u3066\u6848\u5185\u3092\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\uFF1A \u8377\u7269. </span></p>'
      }
    }
  },
  "CUSTOMS_CLEARANCE_START": {
    "category": "incident",
    "subject": {
      "fr": "{{carrier.name}} signale une difficult\xE9 douani\xE8re ; {{shop.name}} suit le dossier et vous accompagnera jusqu\u2019\xE0 r\xE9solution.",
      "en": "{{carrier.name}} reports a customs issue; {{shop.name}} is monitoring the case and will assist you until resolution.",
      "es": "{{carrier.name}} informa de un problema aduanero; {{shop.name}} est\xE1 monitoreando el caso y le asistir\xE1 hasta la resoluci\xF3n.",
      "it": "{{carrier.name}} segnala un problema doganale; {{shop.name}} sta monitorando il caso e ti assister\xE0 fino alla risoluzione.",
      "de": "{{carrier.name}} meldet ein Zollproblem; {{shop.name}} \xFCberwacht den Fall und wird Sie bis zur L\xF6sung unterst\xFCtzen.",
      "nl": "{{carrier.name}} meldt een douaneprobleem; {{shop.name}} volgt de zaak en zal u bijstaan tot de oplossing.",
      "pl": "{{carrier.name}} zg\u0142asza problem celny; {{shop.name}} monitoruje spraw\u0119 i b\u0119dzie Ci\u0119 wspiera\u0107 a\u017C do rozwi\u0105zania.",
      "da": "{{carrier.name}} rapporterer et toldproblem; {{shop.name}} overv\xE5ger sagen og vil hj\xE6lpe dig indtil l\xF8sningen.",
      "pt": "{{carrier.name}} relata um problema aduaneiro; {{shop.name}} est\xE1 monitorando o caso e ir\xE1 assisti-lo at\xE9 a resolu\xE7\xE3o.",
      "sv": "{{carrier.name}} rapporterar ett tullproblem; {{shop.name}} \xF6vervakar \xE4rendet och kommer att hj\xE4lpa dig tills det \xE4r l\xF6st.",
      "fi": "{{carrier.name}} ilmoittaa tulliongelmasta; {{shop.name}} seuraa tapausta ja auttaa sinua ratkaisuun asti.",
      "no": "{{carrier.name}} rapporterer et tollproblem; {{shop.name}} overv\xE5ker saken og vil hjelpe deg til den er l\xF8st.",
      "bg": "{{carrier.name}} \u0441\u044A\u043E\u0431\u0449\u0430\u0432\u0430 \u0437\u0430 \u043C\u0438\u0442\u043D\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C; {{shop.name}} \u0441\u043B\u0435\u0434\u0438 \u0441\u043B\u0443\u0447\u0430\u044F \u0438 \u0449\u0435 \u0432\u0438 \u043F\u043E\u043C\u043E\u0433\u043D\u0435 \u0434\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u043C\u0443.",
      "cs": "{{carrier.name}} hl\xE1s\xED celn\xED probl\xE9m; {{shop.name}} sleduje p\u0159\xEDpad a bude v\xE1s podporovat a\u017E do vy\u0159e\u0161en\xED.",
      "hu": "{{carrier.name}} v\xE1m jelent egy v\xE1mprobl\xE9m\xE1t; {{shop.name}} figyelemmel k\xEDs\xE9ri az \xFCgyet, \xE9s seg\xEDt a megold\xE1sig.",
      "sk": "{{carrier.name}} hl\xE1si coln\xFD probl\xE9m; {{shop.name}} sleduje pr\xEDpad a bude v\xE1s podporova\u0165 a\u017E do vyrie\u0161enia.",
      "zh": "{{carrier.name}} \u62A5\u544A\u4E86\u6D77\u5173\u95EE\u9898\uFF1B{{shop.name}} \u6B63\u5728\u8DDF\u8FDB\u6B64\u6848\u4EF6\uFF0C\u5C06\u534F\u52A9\u60A8\u76F4\u81F3\u89E3\u51B3\u3002",
      "ja": "{{carrier.name}} \u3088\u308A\u901A\u95A2\u306B\u95A2\u3059\u308B\u554F\u984C\u304C\u5831\u544A\u3055\u308C\u307E\u3057\u305F\u3002{{shop.name}} \u304C\u89E3\u6C7A\u307E\u3067\u30B5\u30DD\u30FC\u30C8\u3044\u305F\u3057\u307E\u3059\u3002"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COLIS EST RETARD\xC9</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nous informe que votre commande </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est actuellement retenue en douane.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cette proc\xE9dure est al\xE9atoire et retarde n\xE9cessairement l'acheminement de votre commande.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Nous vous tiendrons inform\xE9 de son \xE9volution et vous remercions pour votre patience.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR PACKAGE IS DELAYED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that your order </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is currently held at customs.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">This procedure is random and necessarily delays the delivery of your order.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">We will keep you informed of its progress and thank you for your patience.</span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PAQUETE EST\xC1 RETRASADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos informa que su pedido </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 actualmente retenido en aduanas.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Este procedimiento es aleatorio y necesariamente retrasa la entrega de su pedido.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Le mantendremos informado de su progreso y le agradecemos su paciencia.</span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO PACCO \xC8 IN RITARDO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ci informa che il tuo ordine </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\xE8 attualmente trattenuto in dogana.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Questa procedura \xE8 casuale e ritarda necessariamente la consegna del tuo ordine.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Ti terremo informato sui suoi progressi e ti ringraziamo per la tua pazienza.</span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DEIN PAKET IST VERZ\xD6GERT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Liebe/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informiert uns, dass Ihre Bestellung </span><span style="color: rgb(0, 0, 0); font-size: 12px;">derzeit beim Zoll festgehalten wird.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dieses Verfahren ist zuf\xE4llig und verz\xF6gert notwendigerweise die Lieferung Ihrer Bestellung.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Wir werden Sie \xFCber den Fortschritt informieren und danken Ihnen f\xFCr Ihre Geduld.</span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET IS VERTRAAGD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informeert ons dat uw bestelling </span><span style="color: rgb(0, 0, 0); font-size: 12px;">momenteel bij de douane wordt vastgehouden.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Deze procedure is willekeurig en vertraagt noodzakelijkerwijs de levering van uw bestelling.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">We zullen u op de hoogte houden van de voortgang en danken u voor uw geduld.</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST OP\xD3\u0179NIONA</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informuje nas, \u017Ce Twoje zam\xF3wienie </span><span style="color: rgb(0, 0, 0); font-size: 12px;">jest obecnie zatrzymane w urz\u0119dzie celnym.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Ta procedura jest losowa i koniecznie op\xF3\u017Ania dostaw\u0119 Twojego zam\xF3wienia.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">B\u0119dziemy Ci\u0119 informowa\u0107 o jego post\u0119pach i dzi\u0119kujemy za cierpliwo\u015B\u0107.</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerer os om, at din ordre </span><span style="color: rgb(0, 0, 0); font-size: 12px;">i \xF8jeblikket holdes i tolden.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Denne procedure er tilf\xE6ldig og forsinker n\xF8dvendigvis leveringen af din ordre.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vi vil holde dig informeret om dens fremskridt og takker for din t\xE5lmodighed.</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PACOTE EST\xC1 ATRASADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> nos informa que o seu pedido </span><span style="color: rgb(0, 0, 0); font-size: 12px;">est\xE1 atualmente retido na alf\xE2ndega.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Este procedimento \xE9 aleat\xF3rio e atrasa necessariamente a entrega do seu pedido.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Manteremos voc\xEA informado sobre o progresso e agradecemos pela sua paci\xEAncia.</span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET \xC4R F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerar oss om att din best\xE4llning </span><span style="color: rgb(0, 0, 0); font-size: 12px;">f\xF6r n\xE4rvarande h\xE5lls i tullen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Denna procedur \xE4r slumpm\xE4ssig och f\xF6rsenar n\xF6dv\xE4ndigtvis leveransen av din best\xE4llning.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vi kommer att h\xE5lla dig informerad om dess framsteg och tackar f\xF6r ditt t\xE5lamod.</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON VIIV\xC4STYNYT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ilmoittaa, ett\xE4 tilauksesi </span><span style="color: rgb(0, 0, 0); font-size: 12px;">on t\xE4ll\xE4 hetkell\xE4 tullissa.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">T\xE4m\xE4 menettely on satunnainen ja viiv\xE4stytt\xE4\xE4 v\xE4ist\xE4m\xE4tt\xE4 tilauksesi toimitusta.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja kiit\xE4mme k\xE4rsiv\xE4llisyydest\xE4si.</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informerer oss om at bestillingen din </span><span style="color: rgb(0, 0, 0); font-size: 12px;">for tiden holdes i tollen.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Denne prosedyren er tilfeldig og forsinker n\xF8dvendigvis leveringen av bestillingen din.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Vi vil holde deg informert om fremdriften og takker for din t\xE5lmodighet.</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0415 \u0417\u0410\u0411\u0410\u0412\u0415\u041D\u0410</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> \u043D\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430, \u0447\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430 </span><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0432 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0435 \u0437\u0430\u0434\u044A\u0440\u0436\u0430\u043D\u0430 \u043D\u0430 \u043C\u0438\u0442\u043D\u0438\u0446\u0430\u0442\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0422\u0430\u0437\u0438 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430 \u0435 \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u0430 \u0438 \u043D\u0435\u0438\u0437\u0431\u0435\u0436\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0435\u0439\u043D\u0438\u044F \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A \u0438 \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u0432\u0430\u0448\u0435\u0442\u043E \u0442\u044A\u0440\u043F\u0435\u043D\u0438\u0435.</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ZPO\u017DD\u011AN\xDD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informuje, \u017Ee va\u0161e objedn\xE1vka </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je moment\xE1ln\u011B zadr\u017Eena na celnici.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tento postup je n\xE1hodn\xFD a nutn\u011B zpo\u017E\u010Fuje doru\u010Den\xED va\u0161\xED objedn\xE1vky.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Budeme v\xE1s informovat o jeho postupu a d\u011Bkujeme za va\u0161i trp\u011Blivost.</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA K\xC9S\xC9SBEN VAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> t\xE1j\xE9koztatott minket, hogy rendel\xE9se </span><span style="color: rgb(0, 0, 0); font-size: 12px;">jelenleg v\xE1mkezel\xE9s alatt \xE1ll.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Ez az elj\xE1r\xE1s v\xE9letlenszer\u0171, \xE9s sz\xFCks\xE9gszer\u0171en k\xE9slelteti a rendel\xE9s k\xE9zbes\xEDt\xE9s\xE9t.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l, \xE9s k\xF6sz\xF6nj\xFCk t\xFCrelm\xE9t.</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ONESKOREN\xDD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> n\xE1s informuje, \u017Ee va\u0161a objedn\xE1vka </span><span style="color: rgb(0, 0, 0); font-size: 12px;">je moment\xE1lne zadr\u017Ean\xE1 na colnici.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tento postup je n\xE1hodn\xFD a nevyhnutne oneskoruje doru\u010Denie va\u0161ej objedn\xE1vky.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Budeme v\xE1s informova\u0165 o jeho priebehu a \u010Fakujeme za va\u0161u trpezlivos\u0165.</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u5305\u88F9\u5DF2\u5EF6\u8FDF</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that \u60A8\u7684\u8BA2\u5355 </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is currently held at customs.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">This procedure is random and necessarily delays the delivery of \u60A8\u7684\u8BA2\u5355.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">We will keep you informed of its progress and thank you for your patience.</span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u8377\u7269\u306E\u914D\u9054\u304C\u9045\u308C\u3066\u3044\u307E\u3059</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> informs us that \u3054\u6CE8\u6587 </span><span style="color: rgb(0, 0, 0); font-size: 12px;">is currently held at customs.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">This procedure is random and necessarily delays the delivery of \u3054\u6CE8\u6587.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">We will keep you informed of its progress and thank you for your patience.</span></p>'
      }
    }
  },
  "DELIVERY_ATTEMPTED": {
    "category": "incident",
    "subject": {
      "fr": "La tentative de livraison par {{carrier.name}} n\u2019a pas pu aboutir ; une nouvelle remise est d\xE9j\xE0 programm\xE9e.",
      "en": "Your order could not be delivered by {{carrier.name}}",
      "es": "Su pedido no pudo ser entregado por {{carrier.name}}",
      "it": "Il tuo ordine non \xE8 stato consegnato da {{carrier.name}}",
      "de": "Ihre Bestellung konnte nicht von {{carrier.name}} geliefert werden",
      "nl": "Je {{shop.name}} pakket wordt nog klaargemaakt.",
      "pl": "Twoja paczka {{shop.name}} jest nadal przygotowywana.",
      "da": "Din {{shop.name}} pakke er stadig under forberedelse.",
      "pt": "O seu pedido n\xE3o p\xF4de ser entregue por {{carrier.name}}",
      "sv": "Ditt paket fr\xE5n {{shop.name}} h\xE5ller fortfarande p\xE5 att f\xF6rberedas.",
      "fi": "{{shop.name}}-pakettisi on edelleen valmistelussa.",
      "no": "{{shop.name}}-pakken din er fortsatt under forberedelse.",
      "bg": "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 {{shop.name}} \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F.",
      "cs": "V\xE1\u0161 bal\xEDk {{shop.name}} se st\xE1le p\u0159ipravuje.",
      "hu": "A {{shop.name}} csomagod m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll.",
      "sk": "V\xE1\u0161 bal\xEDk {{shop.name}} je st\xE1le v pr\xEDprave.",
      "zh": "{{carrier.name}} \u672A\u80FD\u6210\u529F\u914D\u9001\u60A8\u7684\u8BA2\u5355",
      "ja": "{{carrier.name}} \u306B\u3088\u308B\u3054\u6CE8\u6587\u306E\u914D\u9054\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F"
    },
    "content": {
      "fr": {
        "html": `<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>VOTRE COMMANDE N'A PAS PU \xCATRE LIVR\xC9E</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Cher(e)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, votre commande <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n'a pas pu \xEAtre livr\xE9e par <span data-type="mention" class="mention" data-id="carrier.name" data-label="Nom du transporteur" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Nom du transporteur</span> ce jour.</span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Soyez rassur\xE9(e), des instructions arrivent afin de vous permettre d'organiser la relivraison de votre colis rapidement.</span></p>`
      },
      "en": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>YOUR ORDER COULD NOT BE DELIVERED</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Dear</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, your order <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> could not be delivered by </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> today. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Rest assured, instructions are on the way to help you arrange the redelivery of your package. </span></p>'
      },
      "es": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>SU PEDIDO NO PUDO SER ENTREGADO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Estimado/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, su pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> no pudo ser entregado por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoy. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">No se preocupe, las instrucciones est\xE1n en camino para ayudarle a organizar la reentrega de su paquete. </span></p>'
      },
      "it": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IL TUO ORDINE NON HA POTUTO ESSERE CONSEGNATO</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro/a</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, il tuo ordine <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> non ha potuto essere consegnato da </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> oggi. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Stai tranquillo, le istruzioni stanno arrivando per aiutarti a organizzare la riconsegna del tuo pacco. </span></p>'
      },
      "de": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>IHRE BESTELLUNG KONNTE NICHT GELIEFERT WERDEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Sehr geehrte/r</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, Ihre Bestellung <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> konnte nicht von </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> heute geliefert werden. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Seien Sie versichert, Anweisungen sind unterwegs, um Ihnen bei der Organisation der erneuten Lieferung Ihres Pakets zu helfen. </span></p>'
      },
      "nl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>JE PAKKET WORDT NOG VOORBEREID EN KAN EEN KLEINE VERTRAGING HEBBEN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Beste</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, je </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakket is nog in voorbereiding. We houden je op de hoogte van de voortgang en levering.&nbsp;</span></p>'
      },
      "pl": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>TWOJA PACZKA JEST NADAL PRZYGOTOWYWANA I MO\u017BE NAST\u0104PI\u0106 NIEWIELKIE OP\xD3\u0179NIENIE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Szanowny/a</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, Twoja paczka </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> jest nadal przygotowywana. B\u0119dziemy Ci\u0119 informowa\u0107 o post\u0119pach i dostawie.&nbsp;</span></p>'
      },
      "da": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DIN PAKKE ER STADIG UNDER FORBEREDELSE OG KAN BLIVE EN SMULE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, din </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> pakke er stadig under forberedelse. Vi holder dig opdateret om fremskridt og levering.&nbsp;</span></p>'
      },
      "pt": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>O SEU PEDIDO N\xC3O P\xD4DE SER ENTREGUE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Caro(a)</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, o seu pedido <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> n\xE3o p\xF4de ser entregue por </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> hoje. </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">Fique tranquilo, as instru\xE7\xF5es est\xE3o a caminho para ajud\xE1-lo a organizar a reentrega do seu pacote. </span></p>'
      },
      "sv": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>DITT PAKET H\xC5LLER FORTFARANDE P\xC5 ATT F\xD6RBEREDAS OCH KAN BLI N\xC5GOT F\xD6RSENAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">K\xE4ra</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, ditt paket fr\xE5n </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> h\xE5ller fortfarande p\xE5 att f\xF6rberedas. Vi h\xE5ller dig uppdaterad om dess status och leverans.&nbsp;</span></p>'
      },
      "fi": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKETTISI ON EDELLEEN VALMISTELUSSA JA SAATTAA VIIV\xC4STY\xC4 HIEMAN</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Hyv\xE4</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakettisi on edelleen valmistelussa. Pid\xE4mme sinut ajan tasalla sen etenemisest\xE4 ja toimituksesta.&nbsp;</span></p>'
      },
      "no": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>PAKKEN DIN ER FORTSATT UNDER FORBEREDELSE OG KAN BLI NOE FORSINKET</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Kj\xE6re</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, {{</span><span style="font-size: 12px;">shop.name</span><span style="font-size: 12px;">}}-pakken din er fortsatt under forberedelse. Vi holder deg oppdatert om fremdrift og levering.&nbsp;</span></p>'
      },
      "bg": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u0412\u0410\u0428\u0410\u0422\u0410 \u041F\u0420\u0410\u0422\u041A\u0410 \u0412\u0421\u0415 \u041E\u0429\u0415 \u0421\u0415 \u041F\u041E\u0414\u0413\u041E\u0422\u0412\u042F \u0418 \u041C\u041E\u0416\u0415 \u0414\u0410 \u041D\u0410\u0421\u0422\u042A\u041F\u0418 \u041B\u0415\u041A\u041E \u0417\u0410\u0411\u0410\u0412\u042F\u041D\u0415</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u0438/\u0430</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0430\u0442\u043A\u0430 </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> \u0432\u0441\u0435 \u043E\u0449\u0435 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F. \u0429\u0435 \u0432\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043C\u0435 \u0437\u0430 \u043D\u0430\u043F\u0440\u0435\u0434\u044A\u043A\u0430 \u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430.&nbsp;</span></p>'
      },
      "cs": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK SE ST\xC1LE P\u0158IPRAVUJE A M\u016E\u017DE DOJ\xCDT K MEN\u0160\xCDMU ZPO\u017DD\u011AN\xCD</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xED\u010Dek </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> se st\xE1le p\u0159ipravuje. Budeme v\xE1s informovat o jeho postupu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "hu": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>CSOMAGJA M\xC9G EL\u0150K\xC9SZ\xCDT\xC9S ALATT \xC1LL, \xC9S KISEBB K\xC9S\xC9S EL\u0150FORDULHAT</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">Tisztelt</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, a(z) </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> csomagja m\xE9g el\u0151k\xE9sz\xEDt\xE9s alatt \xE1ll. T\xE1j\xE9koztatni fogjuk a folyamat el\u0151rehalad\xE1s\xE1r\xF3l \xE9s a k\xE9zbes\xEDt\xE9sr\u0151l.&nbsp;</span></p>'
      },
      "sk": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>V\xC1\u0160 BAL\xCDK JE ST\xC1LE V PR\xCDPRAVE A M\xD4\u017DE D\xD4JS\u0164 K MIERNEMU ME\u0160KANIU</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">V\xE1\u017Een\xFD/\xE1</span><span style="font-size: 12px;"> </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span></span><span style="font-size: 12px;">, v\xE1\u0161 bal\xEDk </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span></span><span style="font-size: 12px;"> je st\xE1le v pr\xEDprave. Budeme v\xE1s informova\u0165 o priebehu a doru\u010Den\xED.&nbsp;</span></p>'
      },
      "zh": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u60A8\u7684\u8BA2\u5355\u672A\u80FD\u9001\u8FBE</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u5C0A\u656C\u7684</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u60A8\u7684\u8BA2\u5355 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u672A\u80FD\u9001\u8FBE\uFF0C\u627F\u8FD0\u5546\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u4ECA\u5929\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u8BF7\u653E\u5FC3\uFF0C\u5173\u4E8E\u91CD\u65B0\u914D\u9001\u7684\u8BF4\u660E\u5373\u5C06\u53D1\u9001\u7ED9\u60A8\uFF1A \u60A8\u7684\u5305\u88F9. </span></p>'
      },
      "ja": {
        "html": '<p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 14px;"><strong>\u3054\u6CE8\u6587\u3092\u304A\u5C4A\u3051\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F</strong></span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="color: rgb(0, 0, 0); font-size: 12px;">\u89AA\u611B\u306A\u308B</span><span style="font-size: 12px;"> <span data-type="mention" class="mention" data-id="order.firstName" data-label="Customer first name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Customer first name</span>, \u3054\u6CE8\u6587 <span data-type="mention" class="mention" data-id="shop.name" data-label="Shop name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Shop name</span> \u306B\u3088\u308B\u914D\u9001\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A </span><span style="font-size: 12px;"><span data-type="mention" class="mention" data-id="carrier.name" data-label="Carrier name" data-mention-suggestion-char="@" style="background: rgba(0, 0, 0, 0.05); padding: 0px 2px; border-radius: 3px;">@Carrier name</span> \u672C\u65E5\u3002 </span></p><p style="font-size: 16px; font-weight: normal; margin: 0px; padding: 0px;"><span style="font-size: 12px;">\u3054\u5B89\u5FC3\u304F\u3060\u3055\u3044\u3002\u518D\u914D\u9054\u306E\u624B\u914D\u65B9\u6CD5\u306B\u3064\u3044\u3066\u6848\u5185\u3092\u304A\u9001\u308A\u3044\u305F\u3057\u307E\u3059\uFF1A \u8377\u7269. </span></p>'
      }
    }
  }
};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils/mergeClasses.js:
lucide-react/dist/esm/shared/src/utils/toKebabCase.js:
lucide-react/dist/esm/shared/src/utils/toCamelCase.js:
lucide-react/dist/esm/shared/src/utils/toPascalCase.js:
lucide-react/dist/esm/defaultAttributes.js:
lucide-react/dist/esm/shared/src/utils/hasA11yProp.js:
lucide-react/dist/esm/Icon.js:
lucide-react/dist/esm/createLucideIcon.js:
lucide-react/dist/esm/icons/activity.js:
lucide-react/dist/esm/icons/align-center-vertical.js:
lucide-react/dist/esm/icons/align-end-vertical.js:
lucide-react/dist/esm/icons/align-start-vertical.js:
lucide-react/dist/esm/icons/align-vertical-justify-center.js:
lucide-react/dist/esm/icons/align-vertical-justify-end.js:
lucide-react/dist/esm/icons/align-vertical-justify-start.js:
lucide-react/dist/esm/icons/arrow-big-right.js:
lucide-react/dist/esm/icons/bold.js:
lucide-react/dist/esm/icons/building.js:
lucide-react/dist/esm/icons/calendar-clock.js:
lucide-react/dist/esm/icons/calendar.js:
lucide-react/dist/esm/icons/check.js:
lucide-react/dist/esm/icons/chevron-down.js:
lucide-react/dist/esm/icons/circle-minus.js:
lucide-react/dist/esm/icons/cloud-upload.js:
lucide-react/dist/esm/icons/columns-2.js:
lucide-react/dist/esm/icons/download.js:
lucide-react/dist/esm/icons/eye-off.js:
lucide-react/dist/esm/icons/heading.js:
lucide-react/dist/esm/icons/hourglass.js:
lucide-react/dist/esm/icons/image.js:
lucide-react/dist/esm/icons/italic.js:
lucide-react/dist/esm/icons/languages.js:
lucide-react/dist/esm/icons/link-2.js:
lucide-react/dist/esm/icons/list-ordered.js:
lucide-react/dist/esm/icons/loader.js:
lucide-react/dist/esm/icons/map-pin-house.js:
lucide-react/dist/esm/icons/map-pin.js:
lucide-react/dist/esm/icons/minus.js:
lucide-react/dist/esm/icons/mouse.js:
lucide-react/dist/esm/icons/package.js:
lucide-react/dist/esm/icons/palette.js:
lucide-react/dist/esm/icons/refresh-cw.js:
lucide-react/dist/esm/icons/rotate-ccw.js:
lucide-react/dist/esm/icons/share-2.js:
lucide-react/dist/esm/icons/shopping-bag.js:
lucide-react/dist/esm/icons/smartphone.js:
lucide-react/dist/esm/icons/star.js:
lucide-react/dist/esm/icons/text-align-start.js:
lucide-react/dist/esm/icons/text-wrap.js:
lucide-react/dist/esm/icons/ticket-percent.js:
lucide-react/dist/esm/icons/trash-2.js:
lucide-react/dist/esm/icons/triangle-alert.js:
lucide-react/dist/esm/icons/truck.js:
lucide-react/dist/esm/icons/underline.js:
lucide-react/dist/esm/icons/undo-2.js:
lucide-react/dist/esm/icons/wallet-minimal.js:
lucide-react/dist/esm/icons/x.js:
lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.564.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/

export { blocksEmail, blocksReturnEmail, return_exports as return, tracking_exports as tracking };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map